/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			var _m = moreModules[moduleId];
/******/
/******/ 			// Check if module is deduplicated
/******/ 			switch(typeof _m) {
/******/ 			case "object":
/******/ 				// Module can be created from a template
/******/ 				modules[moduleId] = (function(_m) {
/******/ 					var args = _m.slice(1), templateId = _m[0];
/******/ 					return function (a,b,c) {
/******/ 						modules[templateId].apply(this, [a,b,c].concat(args));
/******/ 					};
/******/ 				}(_m));
/******/ 				break;
/******/ 			case "function":
/******/ 				// Normal module
/******/ 				modules[moduleId] = _m;
/******/ 				break;
/******/ 			default:
/******/ 				// Module is a copy of another module
/******/ 				modules[moduleId] = modules[_m];
/******/ 				break;
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		4:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + {"0":"23523cf76eaa5799dec0","1":"368548a53fce23458fa8","2":"315e75de169d05807c1d","3":"ae84e56982fa19ab9e9c"}[chunkId] + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */,
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(2);
	
	// Left here in case we need this again. For now we handle any asynchronous polyfills
	// before our app starts at all, using https://polyfill.io/
	// Asynchronous polyfills
	exports.default = Promise.resolve(); /*  weak */
	// ES5+ polyfills
	// These consist of all the polyfills required by Babel.

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(3);
	
	__webpack_require__(294);
	
	__webpack_require__(296);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(4);
	__webpack_require__(53);
	__webpack_require__(54);
	__webpack_require__(55);
	__webpack_require__(56);
	__webpack_require__(58);
	__webpack_require__(61);
	__webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(67);
	__webpack_require__(68);
	__webpack_require__(69);
	__webpack_require__(71);
	__webpack_require__(73);
	__webpack_require__(75);
	__webpack_require__(77);
	__webpack_require__(80);
	__webpack_require__(81);
	__webpack_require__(82);
	__webpack_require__(86);
	__webpack_require__(88);
	__webpack_require__(90);
	__webpack_require__(93);
	__webpack_require__(94);
	__webpack_require__(95);
	__webpack_require__(96);
	__webpack_require__(98);
	__webpack_require__(99);
	__webpack_require__(100);
	__webpack_require__(101);
	__webpack_require__(102);
	__webpack_require__(103);
	__webpack_require__(104);
	__webpack_require__(106);
	__webpack_require__(107);
	__webpack_require__(108);
	__webpack_require__(110);
	__webpack_require__(111);
	__webpack_require__(112);
	__webpack_require__(114);
	__webpack_require__(115);
	__webpack_require__(116);
	__webpack_require__(117);
	__webpack_require__(118);
	__webpack_require__(119);
	__webpack_require__(120);
	__webpack_require__(121);
	__webpack_require__(122);
	__webpack_require__(123);
	__webpack_require__(124);
	__webpack_require__(125);
	__webpack_require__(126);
	__webpack_require__(127);
	__webpack_require__(132);
	__webpack_require__(133);
	__webpack_require__(137);
	__webpack_require__(138);
	__webpack_require__(139);
	__webpack_require__(140);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	__webpack_require__(151);
	__webpack_require__(152);
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(155);
	__webpack_require__(156);
	__webpack_require__(157);
	__webpack_require__(158);
	__webpack_require__(160);
	__webpack_require__(161);
	__webpack_require__(167);
	__webpack_require__(168);
	__webpack_require__(170);
	__webpack_require__(171);
	__webpack_require__(172);
	__webpack_require__(176);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(182);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(185);
	__webpack_require__(188);
	__webpack_require__(190);
	__webpack_require__(191);
	__webpack_require__(192);
	__webpack_require__(194);
	__webpack_require__(196);
	__webpack_require__(198);
	__webpack_require__(199);
	__webpack_require__(200);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(204);
	__webpack_require__(205);
	__webpack_require__(212);
	__webpack_require__(215);
	__webpack_require__(216);
	__webpack_require__(218);
	__webpack_require__(219);
	__webpack_require__(222);
	__webpack_require__(223);
	__webpack_require__(225);
	__webpack_require__(226);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(230);
	__webpack_require__(231);
	__webpack_require__(232);
	__webpack_require__(233);
	__webpack_require__(234);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(237);
	__webpack_require__(238);
	__webpack_require__(239);
	__webpack_require__(240);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(243);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(250);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(254);
	__webpack_require__(255);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(261);
	__webpack_require__(262);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(267);
	__webpack_require__(270);
	__webpack_require__(271);
	__webpack_require__(272);
	__webpack_require__(273);
	__webpack_require__(274);
	__webpack_require__(275);
	__webpack_require__(276);
	__webpack_require__(277);
	__webpack_require__(279);
	__webpack_require__(280);
	__webpack_require__(281);
	__webpack_require__(282);
	__webpack_require__(283);
	__webpack_require__(284);
	__webpack_require__(285);
	__webpack_require__(286);
	__webpack_require__(287);
	__webpack_require__(288);
	__webpack_require__(289);
	__webpack_require__(292);
	__webpack_require__(293);
	module.exports = __webpack_require__(10);

/***/ },
/* 4 */
[4431, 5, 6, 7, 9, 19, 23, 8, 24, 25, 20, 26, 27, 28, 30, 43, 46, 13, 33, 17, 18, 47, 50, 52, 12, 31, 51, 45, 44, 29, 11],
/* 5 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 6 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 7 */
[4432, 8],
/* 8 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(5)
	  , core      = __webpack_require__(10)
	  , hide      = __webpack_require__(11)
	  , redefine  = __webpack_require__(19)
	  , ctx       = __webpack_require__(21)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 10 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 11 */
[4433, 12, 18, 7],
/* 12 */
[4434, 13, 15, 17, 7],
/* 13 */
[4435, 14],
/* 14 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 15 */
[4436, 7, 8, 16],
/* 16 */
[4437, 14, 5],
/* 17 */
[4438, 14],
/* 18 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(5)
	  , hide      = __webpack_require__(11)
	  , has       = __webpack_require__(6)
	  , SRC       = __webpack_require__(20)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(10).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 20 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 21 */
[4439, 22],
/* 22 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 23 */
[4440, 20, 14, 6, 12, 8],
/* 24 */
[4441, 5],
/* 25 */
[4442, 12, 6, 26],
/* 26 */
[4443, 24, 20, 5],
/* 27 */
[4444, 26],
/* 28 */
[4445, 5, 10, 29, 27, 12],
/* 29 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 30 */
[4446, 31, 33],
/* 31 */
[4447, 32, 42],
/* 32 */
[4448, 6, 33, 37, 41],
/* 33 */
[4449, 34, 36],
/* 34 */
[4450, 35],
/* 35 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 36 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 37 */
[4451, 33, 38, 40],
/* 38 */
[4452, 39],
/* 39 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 40 */
[4453, 39],
/* 41 */
[4454, 24, 20],
/* 42 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 43 */
[4455, 31, 44, 45],
/* 44 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 45 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 46 */
[4456, 35],
/* 47 */
[4457, 13, 48, 42, 41, 16, 49],
/* 48 */
[4458, 12, 13, 31, 7],
/* 49 */
[4459, 5],
/* 50 */
[4460, 33, 51],
/* 51 */
[4461, 32, 42],
/* 52 */
[4462, 45, 18, 33, 17, 6, 15, 7],
/* 53 */
[4463, 9, 47],
/* 54 */
[4464, 9, 7, 12],
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(7), 'Object', {defineProperties: __webpack_require__(48)});

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(33)
	  , $getOwnPropertyDescriptor = __webpack_require__(52).f;
	
	__webpack_require__(57)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(9)
	  , core    = __webpack_require__(10)
	  , fails   = __webpack_require__(8);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(59)
	  , $getPrototypeOf = __webpack_require__(60);
	
	__webpack_require__(57)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 59 */
[4465, 36],
/* 60 */
[4466, 6, 59, 41],
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(59)
	  , $keys    = __webpack_require__(31);
	
	__webpack_require__(57)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(57)('getOwnPropertyNames', function(){
	  return __webpack_require__(50).f;
	});

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(14)
	  , meta     = __webpack_require__(23).onFreeze;
	
	__webpack_require__(57)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(14)
	  , meta     = __webpack_require__(23).onFreeze;
	
	__webpack_require__(57)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(14)
	  , meta     = __webpack_require__(23).onFreeze;
	
	__webpack_require__(57)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(57)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(57)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(57)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 69 */
[4467, 9, 70],
/* 70 */
[4468, 31, 44, 45, 59, 34, 8],
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(9);
	$export($export.S, 'Object', {is: __webpack_require__(72)});

/***/ },
/* 72 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(9);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(74).set});

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(14)
	  , anObject = __webpack_require__(13);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(21)(Function.call, __webpack_require__(52).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(76)
	  , test    = {};
	test[__webpack_require__(26)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(19)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 76 */
[4469, 35, 26],
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(9);
	
	$export($export.P, 'Function', {bind: __webpack_require__(78)});

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(22)
	  , isObject   = __webpack_require__(14)
	  , invoke     = __webpack_require__(79)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ },
/* 79 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(12).f
	  , createDesc = __webpack_require__(18)
	  , has        = __webpack_require__(6)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(7) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(14)
	  , getPrototypeOf = __webpack_require__(60)
	  , HAS_INSTANCE   = __webpack_require__(26)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(12).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(9)
	  , $parseInt = __webpack_require__(83);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(5).parseInt
	  , $trim     = __webpack_require__(84).trim
	  , ws        = __webpack_require__(85)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9)
	  , defined = __webpack_require__(36)
	  , fails   = __webpack_require__(8)
	  , spaces  = __webpack_require__(85)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(9)
	  , $parseFloat = __webpack_require__(87);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(5).parseFloat
	  , $trim       = __webpack_require__(84).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(85) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(5)
	  , has               = __webpack_require__(6)
	  , cof               = __webpack_require__(35)
	  , inheritIfRequired = __webpack_require__(89)
	  , toPrimitive       = __webpack_require__(17)
	  , fails             = __webpack_require__(8)
	  , gOPN              = __webpack_require__(51).f
	  , gOPD              = __webpack_require__(52).f
	  , dP                = __webpack_require__(12).f
	  , $trim             = __webpack_require__(84).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(47)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(7) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(19)(global, NUMBER, $Number);
	}

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(14)
	  , setPrototypeOf = __webpack_require__(74).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(9)
	  , toInteger    = __webpack_require__(39)
	  , aNumberValue = __webpack_require__(91)
	  , repeat       = __webpack_require__(92)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(8)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(35);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(39)
	  , defined   = __webpack_require__(36);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(9)
	  , $fails       = __webpack_require__(8)
	  , aNumberValue = __webpack_require__(91)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(9)
	  , _isFinite = __webpack_require__(5).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(97)});

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(14)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(9)
	  , isInteger = __webpack_require__(97)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(9)
	  , $parseFloat = __webpack_require__(87);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(9)
	  , $parseInt = __webpack_require__(83);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(9)
	  , log1p   = __webpack_require__(105)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 105 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(9)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(9)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(9)
	  , sign    = __webpack_require__(109);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 109 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(9)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(9)
	  , $expm1  = __webpack_require__(113);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 113 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(9)
	  , sign      = __webpack_require__(109)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(9)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(9)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(105)});

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {sign: __webpack_require__(109)});

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(9)
	  , expm1   = __webpack_require__(113)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(9)
	  , expm1   = __webpack_require__(113)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(9)
	  , toIndex        = __webpack_require__(40)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(9)
	  , toIObject = __webpack_require__(33)
	  , toLength  = __webpack_require__(38);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(84)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 127 */
[4470, 128, 129],
/* 128 */
[4471, 39, 36],
/* 129 */
[4472, 29, 9, 19, 11, 6, 130, 131, 25, 60, 26],
/* 130 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 131 */
[4473, 47, 18, 25, 11, 26],
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $at     = __webpack_require__(128)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(9)
	  , toLength  = __webpack_require__(38)
	  , context   = __webpack_require__(134)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(135)
	  , defined  = __webpack_require__(36);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(14)
	  , cof      = __webpack_require__(35)
	  , MATCH    = __webpack_require__(26)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(26)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(9)
	  , context  = __webpack_require__(134)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(136)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(92)
	});

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(9)
	  , toLength    = __webpack_require__(38)
	  , context     = __webpack_require__(134)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(141)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9)
	  , fails   = __webpack_require__(8)
	  , defined = __webpack_require__(36)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(141)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(141)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(141)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(141)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(141)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(141)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(141)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(141)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(141)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(141)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(141)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(141)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(9)
	  , toObject    = __webpack_require__(59)
	  , toPrimitive = __webpack_require__(17);
	
	$export($export.P + $export.F * __webpack_require__(8)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(9)
	  , fails   = __webpack_require__(8)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(19)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(26)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(11)(proto, TO_PRIMITIVE, __webpack_require__(159));

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(13)
	  , toPrimitive = __webpack_require__(17)
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(46)});

/***/ },
/* 161 */
[4474, 21, 9, 59, 162, 163, 38, 164, 165, 166],
/* 162 */
[4475, 13],
/* 163 */
[4476, 130, 26],
/* 164 */
[4477, 12, 18],
/* 165 */
[4478, 76, 26, 130, 10],
/* 166 */
[4479, 26],
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(9)
	  , createProperty = __webpack_require__(164);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(9)
	  , toIObject = __webpack_require__(33)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(34) != Object || !__webpack_require__(169)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(8);
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(9)
	  , html       = __webpack_require__(49)
	  , cof        = __webpack_require__(35)
	  , toIndex    = __webpack_require__(40)
	  , toLength   = __webpack_require__(38)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(8)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(9)
	  , aFunction = __webpack_require__(22)
	  , toObject  = __webpack_require__(59)
	  , fails     = __webpack_require__(8)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(169)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(9)
	  , $forEach = __webpack_require__(173)(0)
	  , STRICT   = __webpack_require__(169)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 173 */
[4480, 21, 34, 59, 38, 174],
/* 174 */
[4481, 175],
/* 175 */
[4482, 14, 46, 26],
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $map    = __webpack_require__(173)(1);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $filter = __webpack_require__(173)(2);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $some   = __webpack_require__(173)(3);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $every  = __webpack_require__(173)(4);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $reduce = __webpack_require__(181);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(22)
	  , toObject  = __webpack_require__(59)
	  , IObject   = __webpack_require__(34)
	  , toLength  = __webpack_require__(38);
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $reduce = __webpack_require__(181);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(9)
	  , $indexOf      = __webpack_require__(37)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(169)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(9)
	  , toIObject     = __webpack_require__(33)
	  , toInteger     = __webpack_require__(39)
	  , toLength      = __webpack_require__(38)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(169)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(9);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(186)});
	
	__webpack_require__(187)('copyWithin');

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(59)
	  , toIndex  = __webpack_require__(40)
	  , toLength = __webpack_require__(38);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(26)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(11)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(9);
	
	$export($export.P, 'Array', {fill: __webpack_require__(189)});
	
	__webpack_require__(187)('fill');

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(59)
	  , toIndex  = __webpack_require__(40)
	  , toLength = __webpack_require__(38);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(9)
	  , $find   = __webpack_require__(173)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(187)(KEY);

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(9)
	  , $find   = __webpack_require__(173)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(187)(KEY);

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(193)('Array');

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(5)
	  , dP          = __webpack_require__(12)
	  , DESCRIPTORS = __webpack_require__(7)
	  , SPECIES     = __webpack_require__(26)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 194 */
[4483, 187, 195, 130, 33, 129],
/* 195 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(5)
	  , inheritIfRequired = __webpack_require__(89)
	  , dP                = __webpack_require__(12).f
	  , gOPN              = __webpack_require__(51).f
	  , isRegExp          = __webpack_require__(135)
	  , $flags            = __webpack_require__(197)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(7) && (!CORRECT_NEW || __webpack_require__(8)(function(){
	  re2[__webpack_require__(26)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(19)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(193)('RegExp');

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(13);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(199);
	var anObject    = __webpack_require__(13)
	  , $flags      = __webpack_require__(197)
	  , DESCRIPTORS = __webpack_require__(7)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(19)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(8)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(7) && /./g.flags != 'g')__webpack_require__(12).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(197)
	});

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(201)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(11)
	  , redefine = __webpack_require__(19)
	  , fails    = __webpack_require__(8)
	  , defined  = __webpack_require__(36)
	  , wks      = __webpack_require__(26);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(201)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(201)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(201)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(135)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(29)
	  , global             = __webpack_require__(5)
	  , ctx                = __webpack_require__(21)
	  , classof            = __webpack_require__(76)
	  , $export            = __webpack_require__(9)
	  , isObject           = __webpack_require__(14)
	  , aFunction          = __webpack_require__(22)
	  , anInstance         = __webpack_require__(206)
	  , forOf              = __webpack_require__(207)
	  , speciesConstructor = __webpack_require__(208)
	  , task               = __webpack_require__(209).set
	  , microtask          = __webpack_require__(210)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(26)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(211)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(25)($Promise, PROMISE);
	__webpack_require__(193)(PROMISE);
	Wrapper = __webpack_require__(10)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(166)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 206 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ },
/* 207 */
[4484, 21, 162, 163, 13, 38, 165],
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(13)
	  , aFunction = __webpack_require__(22)
	  , SPECIES   = __webpack_require__(26)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(21)
	  , invoke             = __webpack_require__(79)
	  , html               = __webpack_require__(49)
	  , cel                = __webpack_require__(16)
	  , global             = __webpack_require__(5)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(35)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(5)
	  , macrotask = __webpack_require__(209).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(35)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(19);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ },
/* 212 */
[4485, 213, 214],
/* 213 */
[4486, 12, 47, 211, 21, 206, 36, 207, 129, 195, 193, 7, 23],
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(5)
	  , $export           = __webpack_require__(9)
	  , redefine          = __webpack_require__(19)
	  , redefineAll       = __webpack_require__(211)
	  , meta              = __webpack_require__(23)
	  , forOf             = __webpack_require__(207)
	  , anInstance        = __webpack_require__(206)
	  , isObject          = __webpack_require__(14)
	  , fails             = __webpack_require__(8)
	  , $iterDetect       = __webpack_require__(166)
	  , setToStringTag    = __webpack_require__(25)
	  , inheritIfRequired = __webpack_require__(89);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 215 */
[4487, 213, 214],
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(173)(0)
	  , redefine     = __webpack_require__(19)
	  , meta         = __webpack_require__(23)
	  , assign       = __webpack_require__(70)
	  , weak         = __webpack_require__(217)
	  , isObject     = __webpack_require__(14)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(214)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(211)
	  , getWeak           = __webpack_require__(23).getWeak
	  , anObject          = __webpack_require__(13)
	  , isObject          = __webpack_require__(14)
	  , anInstance        = __webpack_require__(206)
	  , forOf             = __webpack_require__(207)
	  , createArrayMethod = __webpack_require__(173)
	  , $has              = __webpack_require__(6)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(217);
	
	// 23.4 WeakSet Objects
	__webpack_require__(214)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(9)
	  , $typed       = __webpack_require__(220)
	  , buffer       = __webpack_require__(221)
	  , anObject     = __webpack_require__(13)
	  , toIndex      = __webpack_require__(40)
	  , toLength     = __webpack_require__(38)
	  , isObject     = __webpack_require__(14)
	  , ArrayBuffer  = __webpack_require__(5).ArrayBuffer
	  , speciesConstructor = __webpack_require__(208)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(8)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(193)(ARRAY_BUFFER);

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5)
	  , hide   = __webpack_require__(11)
	  , uid    = __webpack_require__(20)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(5)
	  , DESCRIPTORS    = __webpack_require__(7)
	  , LIBRARY        = __webpack_require__(29)
	  , $typed         = __webpack_require__(220)
	  , hide           = __webpack_require__(11)
	  , redefineAll    = __webpack_require__(211)
	  , fails          = __webpack_require__(8)
	  , anInstance     = __webpack_require__(206)
	  , toInteger      = __webpack_require__(39)
	  , toLength       = __webpack_require__(38)
	  , gOPN           = __webpack_require__(51).f
	  , dP             = __webpack_require__(12).f
	  , arrayFill      = __webpack_require__(189)
	  , setToStringTag = __webpack_require__(25)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	$export($export.G + $export.W + $export.F * !__webpack_require__(220).ABV, {
	  DataView: __webpack_require__(221).DataView
	});

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(7)){
	  var LIBRARY             = __webpack_require__(29)
	    , global              = __webpack_require__(5)
	    , fails               = __webpack_require__(8)
	    , $export             = __webpack_require__(9)
	    , $typed              = __webpack_require__(220)
	    , $buffer             = __webpack_require__(221)
	    , ctx                 = __webpack_require__(21)
	    , anInstance          = __webpack_require__(206)
	    , propertyDesc        = __webpack_require__(18)
	    , hide                = __webpack_require__(11)
	    , redefineAll         = __webpack_require__(211)
	    , toInteger           = __webpack_require__(39)
	    , toLength            = __webpack_require__(38)
	    , toIndex             = __webpack_require__(40)
	    , toPrimitive         = __webpack_require__(17)
	    , has                 = __webpack_require__(6)
	    , same                = __webpack_require__(72)
	    , classof             = __webpack_require__(76)
	    , isObject            = __webpack_require__(14)
	    , toObject            = __webpack_require__(59)
	    , isArrayIter         = __webpack_require__(163)
	    , create              = __webpack_require__(47)
	    , getPrototypeOf      = __webpack_require__(60)
	    , gOPN                = __webpack_require__(51).f
	    , getIterFn           = __webpack_require__(165)
	    , uid                 = __webpack_require__(20)
	    , wks                 = __webpack_require__(26)
	    , createArrayMethod   = __webpack_require__(173)
	    , createArrayIncludes = __webpack_require__(37)
	    , speciesConstructor  = __webpack_require__(208)
	    , ArrayIterators      = __webpack_require__(194)
	    , Iterators           = __webpack_require__(130)
	    , $iterDetect         = __webpack_require__(166)
	    , setSpecies          = __webpack_require__(193)
	    , arrayFill           = __webpack_require__(189)
	    , arrayCopyWithin     = __webpack_require__(186)
	    , $DP                 = __webpack_require__(12)
	    , $GOPD               = __webpack_require__(52)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(9)
	  , aFunction = __webpack_require__(22)
	  , anObject  = __webpack_require__(13)
	  , rApply    = (__webpack_require__(5).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(8)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(9)
	  , create     = __webpack_require__(47)
	  , aFunction  = __webpack_require__(22)
	  , anObject   = __webpack_require__(13)
	  , isObject   = __webpack_require__(14)
	  , fails      = __webpack_require__(8)
	  , bind       = __webpack_require__(78)
	  , rConstruct = (__webpack_require__(5).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(12)
	  , $export     = __webpack_require__(9)
	  , anObject    = __webpack_require__(13)
	  , toPrimitive = __webpack_require__(17);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(9)
	  , gOPD     = __webpack_require__(52).f
	  , anObject = __webpack_require__(13);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(9)
	  , anObject = __webpack_require__(13);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(131)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(52)
	  , getPrototypeOf = __webpack_require__(60)
	  , has            = __webpack_require__(6)
	  , $export        = __webpack_require__(9)
	  , isObject       = __webpack_require__(14)
	  , anObject       = __webpack_require__(13);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(52)
	  , $export  = __webpack_require__(9)
	  , anObject = __webpack_require__(13);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(9)
	  , getProto = __webpack_require__(60)
	  , anObject = __webpack_require__(13);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(9)
	  , anObject      = __webpack_require__(13)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(244)});

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(51)
	  , gOPS     = __webpack_require__(44)
	  , anObject = __webpack_require__(13)
	  , Reflect  = __webpack_require__(5).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(9)
	  , anObject           = __webpack_require__(13)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(12)
	  , gOPD           = __webpack_require__(52)
	  , getPrototypeOf = __webpack_require__(60)
	  , has            = __webpack_require__(6)
	  , $export        = __webpack_require__(9)
	  , createDesc     = __webpack_require__(18)
	  , anObject       = __webpack_require__(13)
	  , isObject       = __webpack_require__(14);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(9)
	  , setProto = __webpack_require__(74);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(9)
	  , $includes = __webpack_require__(37)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(187)('includes');

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(9)
	  , $at     = __webpack_require__(128)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(9)
	  , $pad    = __webpack_require__(251);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(38)
	  , repeat   = __webpack_require__(92)
	  , defined  = __webpack_require__(36);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(9)
	  , $pad    = __webpack_require__(251);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(84)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(84)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(9)
	  , defined     = __webpack_require__(36)
	  , toLength    = __webpack_require__(38)
	  , isRegExp    = __webpack_require__(135)
	  , getFlags    = __webpack_require__(197)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(131)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ },
/* 256 */
[4488, 28],
/* 257 */
[4489, 28],
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(9)
	  , ownKeys        = __webpack_require__(244)
	  , toIObject      = __webpack_require__(33)
	  , gOPD           = __webpack_require__(52)
	  , createProperty = __webpack_require__(164);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(9)
	  , $values = __webpack_require__(260)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(31)
	  , toIObject = __webpack_require__(33)
	  , isEnum    = __webpack_require__(45).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(9)
	  , $entries = __webpack_require__(260)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(9)
	  , toObject        = __webpack_require__(59)
	  , aFunction       = __webpack_require__(22)
	  , $defineProperty = __webpack_require__(12);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(7) && $export($export.P + __webpack_require__(263), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(29)|| !__webpack_require__(8)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(5)[K];
	});

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(9)
	  , toObject        = __webpack_require__(59)
	  , aFunction       = __webpack_require__(22)
	  , $defineProperty = __webpack_require__(12);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(7) && $export($export.P + __webpack_require__(263), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(9)
	  , toObject                 = __webpack_require__(59)
	  , toPrimitive              = __webpack_require__(17)
	  , getPrototypeOf           = __webpack_require__(60)
	  , getOwnPropertyDescriptor = __webpack_require__(52).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(7) && $export($export.P + __webpack_require__(263), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(9)
	  , toObject                 = __webpack_require__(59)
	  , toPrimitive              = __webpack_require__(17)
	  , getPrototypeOf           = __webpack_require__(60)
	  , getOwnPropertyDescriptor = __webpack_require__(52).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(7) && $export($export.P + __webpack_require__(263), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 267 */
[4490, 9, 268],
/* 268 */
[4491, 76, 269],
/* 269 */
[4492, 207],
/* 270 */
[4493, 9, 268],
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(9);
	
	$export($export.S, 'System', {global: __webpack_require__(5)});

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(9)
	  , cof     = __webpack_require__(35);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(278)
	  , anObject                  = __webpack_require__(13)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(212)
	  , $export = __webpack_require__(9)
	  , shared  = __webpack_require__(24)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(216)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(278)
	  , anObject               = __webpack_require__(13)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(278)
	  , anObject               = __webpack_require__(13)
	  , getPrototypeOf         = __webpack_require__(60)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(215)
	  , from                    = __webpack_require__(269)
	  , metadata                = __webpack_require__(278)
	  , anObject                = __webpack_require__(13)
	  , getPrototypeOf          = __webpack_require__(60)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(278)
	  , anObject               = __webpack_require__(13)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(278)
	  , anObject                = __webpack_require__(13)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(278)
	  , anObject               = __webpack_require__(13)
	  , getPrototypeOf         = __webpack_require__(60)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(278)
	  , anObject               = __webpack_require__(13)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(278)
	  , anObject                  = __webpack_require__(13)
	  , aFunction                 = __webpack_require__(22)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(9)
	  , microtask = __webpack_require__(210)()
	  , process   = __webpack_require__(5).process
	  , isNode    = __webpack_require__(35)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(9)
	  , global      = __webpack_require__(5)
	  , core        = __webpack_require__(10)
	  , microtask   = __webpack_require__(210)()
	  , OBSERVABLE  = __webpack_require__(26)('observable')
	  , aFunction   = __webpack_require__(22)
	  , anObject    = __webpack_require__(13)
	  , anInstance  = __webpack_require__(206)
	  , redefineAll = __webpack_require__(211)
	  , hide        = __webpack_require__(11)
	  , forOf       = __webpack_require__(207)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(193)('Observable');

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(5)
	  , $export    = __webpack_require__(9)
	  , invoke     = __webpack_require__(79)
	  , partial    = __webpack_require__(290)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(291)
	  , invoke    = __webpack_require__(79)
	  , aFunction = __webpack_require__(22);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(5);

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9)
	  , $task   = __webpack_require__(209);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(194)
	  , redefine      = __webpack_require__(19)
	  , global        = __webpack_require__(5)
	  , hide          = __webpack_require__(11)
	  , Iterators     = __webpack_require__(130)
	  , wks           = __webpack_require__(26)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(295)))

/***/ },
/* 295 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(297);
	module.exports = __webpack_require__(10).RegExp.escape;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(9)
	  , $re     = __webpack_require__(298)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 298 */
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(300);


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	var ReactChildren = __webpack_require__(302);
	var ReactComponent = __webpack_require__(315);
	var ReactPureComponent = __webpack_require__(318);
	var ReactClass = __webpack_require__(319);
	var ReactDOMFactories = __webpack_require__(321);
	var ReactElement = __webpack_require__(306);
	var ReactPropTypes = __webpack_require__(322);
	var ReactVersion = __webpack_require__(324);
	
	var onlyChild = __webpack_require__(325);
	var warning = __webpack_require__(308);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 301 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(303);
	var ReactElement = __webpack_require__(306);
	
	var emptyFunction = __webpack_require__(309);
	var traverseAllChildren = __webpack_require__(312);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 303 */
[4494, 304, 305],
/* 304 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	var ReactCurrentOwner = __webpack_require__(307);
	
	var warning = __webpack_require__(308);
	var canDefineProperty = __webpack_require__(310);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(311);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 307 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 308 */
[4495, 309],
/* 309 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 311 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(304);
	
	var ReactCurrentOwner = __webpack_require__(307);
	var REACT_ELEMENT_TYPE = __webpack_require__(311);
	
	var getIteratorFn = __webpack_require__(313);
	var invariant = __webpack_require__(305);
	var KeyEscapeUtils = __webpack_require__(314);
	var warning = __webpack_require__(308);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 313 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 314 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(304);
	
	var ReactNoopUpdateQueue = __webpack_require__(316);
	
	var canDefineProperty = __webpack_require__(310);
	var emptyObject = __webpack_require__(317);
	var invariant = __webpack_require__(305);
	var warning = __webpack_require__(308);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(308);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	var ReactComponent = __webpack_require__(315);
	var ReactNoopUpdateQueue = __webpack_require__(316);
	
	var emptyObject = __webpack_require__(317);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(304),
	    _assign = __webpack_require__(301);
	
	var ReactComponent = __webpack_require__(315);
	var ReactElement = __webpack_require__(306);
	var ReactPropTypeLocationNames = __webpack_require__(320);
	var ReactNoopUpdateQueue = __webpack_require__(316);
	
	var emptyObject = __webpack_require__(317);
	var invariant = __webpack_require__(305);
	var warning = __webpack_require__(308);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(306);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(306);
	var ReactPropTypeLocationNames = __webpack_require__(320);
	var ReactPropTypesSecret = __webpack_require__(323);
	
	var emptyFunction = __webpack_require__(309);
	var getIteratorFn = __webpack_require__(313);
	var warning = __webpack_require__(308);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        if (props[propName] === null) {
	          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	        }
	        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 323 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 324 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.4.1';

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(304);
	
	var ReactElement = __webpack_require__(306);
	
	var invariant = __webpack_require__(305);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(327);


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(328);
	var ReactDefaultInjection = __webpack_require__(333);
	var ReactMount = __webpack_require__(458);
	var ReactReconciler = __webpack_require__(356);
	var ReactUpdates = __webpack_require__(353);
	var ReactVersion = __webpack_require__(463);
	
	var findDOMNode = __webpack_require__(464);
	var getHostComponentFromComposite = __webpack_require__(465);
	var renderSubtreeIntoContainer = __webpack_require__(466);
	var warning = __webpack_require__(341);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var DOMProperty = __webpack_require__(330);
	var ReactDOMComponentFlags = __webpack_require__(332);
	
	var invariant = __webpack_require__(331);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 329 */
304,
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var invariant = __webpack_require__(331);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 331 */
305,
/* 332 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(334);
	var BeforeInputEventPlugin = __webpack_require__(335);
	var ChangeEventPlugin = __webpack_require__(352);
	var DefaultEventPluginOrder = __webpack_require__(364);
	var EnterLeaveEventPlugin = __webpack_require__(365);
	var HTMLDOMPropertyConfig = __webpack_require__(370);
	var ReactComponentBrowserEnvironment = __webpack_require__(371);
	var ReactDOMComponent = __webpack_require__(384);
	var ReactDOMComponentTree = __webpack_require__(328);
	var ReactDOMEmptyComponent = __webpack_require__(429);
	var ReactDOMTreeTraversal = __webpack_require__(430);
	var ReactDOMTextComponent = __webpack_require__(431);
	var ReactDefaultBatchingStrategy = __webpack_require__(432);
	var ReactEventListener = __webpack_require__(433);
	var ReactInjection = __webpack_require__(436);
	var ReactReconcileTransaction = __webpack_require__(437);
	var SVGDOMPropertyConfig = __webpack_require__(445);
	var SelectEventPlugin = __webpack_require__(446);
	var SimpleEventPlugin = __webpack_require__(447);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 334 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(336);
	var ExecutionEnvironment = __webpack_require__(345);
	var FallbackCompositionState = __webpack_require__(346);
	var SyntheticCompositionEvent = __webpack_require__(349);
	var SyntheticInputEvent = __webpack_require__(351);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(337);
	var EventPluginUtils = __webpack_require__(339);
	
	var accumulateInto = __webpack_require__(343);
	var forEachAccumulated = __webpack_require__(344);
	var warning = __webpack_require__(341);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var EventPluginRegistry = __webpack_require__(338);
	var EventPluginUtils = __webpack_require__(339);
	var ReactErrorUtils = __webpack_require__(340);
	
	var accumulateInto = __webpack_require__(343);
	var forEachAccumulated = __webpack_require__(344);
	var invariant = __webpack_require__(331);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var invariant = __webpack_require__(331);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var ReactErrorUtils = __webpack_require__(340);
	
	var invariant = __webpack_require__(331);
	var warning = __webpack_require__(341);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      // $FlowFixMe https://github.com/facebook/flow/issues/2336
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 341 */
[4495, 342],
/* 342 */
309,
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var invariant = __webpack_require__(331);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 344 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 345 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	var PooledClass = __webpack_require__(347);
	
	var getTextContentAccessor = __webpack_require__(348);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 347 */
[4494, 329, 331],
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(345);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(350);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	var PooledClass = __webpack_require__(347);
	
	var emptyFunction = __webpack_require__(342);
	var warning = __webpack_require__(341);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(350);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(337);
	var EventPropagators = __webpack_require__(336);
	var ExecutionEnvironment = __webpack_require__(345);
	var ReactDOMComponentTree = __webpack_require__(328);
	var ReactUpdates = __webpack_require__(353);
	var SyntheticEvent = __webpack_require__(350);
	
	var getEventTarget = __webpack_require__(361);
	var isEventSupported = __webpack_require__(362);
	var isTextInputElement = __webpack_require__(363);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329),
	    _assign = __webpack_require__(301);
	
	var CallbackQueue = __webpack_require__(354);
	var PooledClass = __webpack_require__(347);
	var ReactFeatureFlags = __webpack_require__(355);
	var ReactReconciler = __webpack_require__(356);
	var Transaction = __webpack_require__(360);
	
	var invariant = __webpack_require__(331);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(347);
	
	var invariant = __webpack_require__(331);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 355 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(357);
	var ReactInstrumentation = __webpack_require__(359);
	
	var warning = __webpack_require__(341);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(358);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var invariant = __webpack_require__(331);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var invariant = __webpack_require__(331);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 361 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(345);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 363 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 364 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(336);
	var ReactDOMComponentTree = __webpack_require__(328);
	var SyntheticMouseEvent = __webpack_require__(366);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(367);
	var ViewportMetrics = __webpack_require__(368);
	
	var getEventModifierState = __webpack_require__(369);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(350);
	
	var getEventTarget = __webpack_require__(361);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 368 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 369 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(330);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(372);
	var ReactDOMIDOperations = __webpack_require__(383);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(373);
	var Danger = __webpack_require__(379);
	var ReactDOMComponentTree = __webpack_require__(328);
	var ReactInstrumentation = __webpack_require__(359);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(376);
	var setInnerHTML = __webpack_require__(375);
	var setTextContent = __webpack_require__(377);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(374);
	var setInnerHTML = __webpack_require__(375);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(376);
	var setTextContent = __webpack_require__(377);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 374 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(345);
	var DOMNamespaces = __webpack_require__(374);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(376);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 376 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(345);
	var escapeTextContentForBrowser = __webpack_require__(378);
	var setInnerHTML = __webpack_require__(375);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 378 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var DOMLazyTree = __webpack_require__(373);
	var ExecutionEnvironment = __webpack_require__(345);
	
	var createNodesFromMarkup = __webpack_require__(380);
	var emptyFunction = __webpack_require__(342);
	var invariant = __webpack_require__(331);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(345);
	
	var createArrayFromMixed = __webpack_require__(381);
	var getMarkupWrap = __webpack_require__(382);
	var invariant = __webpack_require__(331);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(331);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(345);
	
	var invariant = __webpack_require__(331);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(372);
	var ReactDOMComponentTree = __webpack_require__(328);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329),
	    _assign = __webpack_require__(301);
	
	var AutoFocusUtils = __webpack_require__(385);
	var CSSPropertyOperations = __webpack_require__(387);
	var DOMLazyTree = __webpack_require__(373);
	var DOMNamespaces = __webpack_require__(374);
	var DOMProperty = __webpack_require__(330);
	var DOMPropertyOperations = __webpack_require__(395);
	var EventPluginHub = __webpack_require__(337);
	var EventPluginRegistry = __webpack_require__(338);
	var ReactBrowserEventEmitter = __webpack_require__(397);
	var ReactDOMComponentFlags = __webpack_require__(332);
	var ReactDOMComponentTree = __webpack_require__(328);
	var ReactDOMInput = __webpack_require__(400);
	var ReactDOMOption = __webpack_require__(403);
	var ReactDOMSelect = __webpack_require__(404);
	var ReactDOMTextarea = __webpack_require__(405);
	var ReactInstrumentation = __webpack_require__(359);
	var ReactMultiChild = __webpack_require__(406);
	var ReactServerRenderingTransaction = __webpack_require__(425);
	
	var emptyFunction = __webpack_require__(342);
	var escapeTextContentForBrowser = __webpack_require__(378);
	var invariant = __webpack_require__(331);
	var isEventSupported = __webpack_require__(362);
	var shallowEqual = __webpack_require__(414);
	var validateDOMNesting = __webpack_require__(428);
	var warning = __webpack_require__(341);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(328);
	
	var focusNode = __webpack_require__(386);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 386 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(388);
	var ExecutionEnvironment = __webpack_require__(345);
	var ReactInstrumentation = __webpack_require__(359);
	
	var camelizeStyleName = __webpack_require__(389);
	var dangerousStyleValue = __webpack_require__(391);
	var hyphenateStyleName = __webpack_require__(392);
	var memoizeStringOnly = __webpack_require__(394);
	var warning = __webpack_require__(341);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 388 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(390);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 390 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(388);
	var warning = __webpack_require__(341);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(393);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 393 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 394 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(330);
	var ReactDOMComponentTree = __webpack_require__(328);
	var ReactInstrumentation = __webpack_require__(359);
	
	var quoteAttributeValueForBrowser = __webpack_require__(396);
	var warning = __webpack_require__(341);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(378);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	var EventPluginRegistry = __webpack_require__(338);
	var ReactEventEmitterMixin = __webpack_require__(398);
	var ViewportMetrics = __webpack_require__(368);
	
	var getVendorPrefixedEventName = __webpack_require__(399);
	var isEventSupported = __webpack_require__(362);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(337);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(345);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329),
	    _assign = __webpack_require__(301);
	
	var DOMPropertyOperations = __webpack_require__(395);
	var LinkedValueUtils = __webpack_require__(401);
	var ReactDOMComponentTree = __webpack_require__(328);
	var ReactUpdates = __webpack_require__(353);
	
	var invariant = __webpack_require__(331);
	var warning = __webpack_require__(341);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var React = __webpack_require__(300);
	var ReactPropTypesSecret = __webpack_require__(402);
	
	var invariant = __webpack_require__(331);
	var warning = __webpack_require__(341);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: React.PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 402 */
323,
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	var React = __webpack_require__(300);
	var ReactDOMComponentTree = __webpack_require__(328);
	var ReactDOMSelect = __webpack_require__(404);
	
	var warning = __webpack_require__(341);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	var LinkedValueUtils = __webpack_require__(401);
	var ReactDOMComponentTree = __webpack_require__(328);
	var ReactUpdates = __webpack_require__(353);
	
	var warning = __webpack_require__(341);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329),
	    _assign = __webpack_require__(301);
	
	var LinkedValueUtils = __webpack_require__(401);
	var ReactDOMComponentTree = __webpack_require__(328);
	var ReactUpdates = __webpack_require__(353);
	
	var invariant = __webpack_require__(331);
	var warning = __webpack_require__(341);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var ReactComponentEnvironment = __webpack_require__(407);
	var ReactInstanceMap = __webpack_require__(408);
	var ReactInstrumentation = __webpack_require__(359);
	
	var ReactCurrentOwner = __webpack_require__(307);
	var ReactReconciler = __webpack_require__(356);
	var ReactChildReconciler = __webpack_require__(409);
	
	var emptyFunction = __webpack_require__(342);
	var flattenChildren = __webpack_require__(424);
	var invariant = __webpack_require__(331);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var invariant = __webpack_require__(331);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 408 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(356);
	
	var instantiateReactComponent = __webpack_require__(410);
	var KeyEscapeUtils = __webpack_require__(419);
	var shouldUpdateReactComponent = __webpack_require__(415);
	var traverseAllChildren = __webpack_require__(420);
	var warning = __webpack_require__(341);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(423);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329),
	    _assign = __webpack_require__(301);
	
	var ReactCompositeComponent = __webpack_require__(411);
	var ReactEmptyComponent = __webpack_require__(416);
	var ReactHostComponent = __webpack_require__(417);
	
	var getNextDebugID = __webpack_require__(418);
	var invariant = __webpack_require__(331);
	var warning = __webpack_require__(341);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329),
	    _assign = __webpack_require__(301);
	
	var React = __webpack_require__(300);
	var ReactComponentEnvironment = __webpack_require__(407);
	var ReactCurrentOwner = __webpack_require__(307);
	var ReactErrorUtils = __webpack_require__(340);
	var ReactInstanceMap = __webpack_require__(408);
	var ReactInstrumentation = __webpack_require__(359);
	var ReactNodeTypes = __webpack_require__(412);
	var ReactReconciler = __webpack_require__(356);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(413);
	var invariant = __webpack_require__(331);
	var shallowEqual = __webpack_require__(414);
	var shouldUpdateReactComponent = __webpack_require__(415);
	var warning = __webpack_require__(341);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var React = __webpack_require__(300);
	
	var invariant = __webpack_require__(331);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 413 */
317,
/* 414 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 415 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 416 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329),
	    _assign = __webpack_require__(301);
	
	var invariant = __webpack_require__(331);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 418 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 419 */
314,
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var ReactCurrentOwner = __webpack_require__(307);
	var REACT_ELEMENT_TYPE = __webpack_require__(421);
	
	var getIteratorFn = __webpack_require__(422);
	var invariant = __webpack_require__(331);
	var KeyEscapeUtils = __webpack_require__(419);
	var warning = __webpack_require__(341);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 421 */
311,
/* 422 */
313,
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(304);
	
	var ReactCurrentOwner = __webpack_require__(307);
	
	var invariant = __webpack_require__(305);
	var warning = __webpack_require__(308);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(419);
	var traverseAllChildren = __webpack_require__(420);
	var warning = __webpack_require__(341);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(423);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	var PooledClass = __webpack_require__(347);
	var Transaction = __webpack_require__(360);
	var ReactInstrumentation = __webpack_require__(359);
	var ReactServerUpdateQueue = __webpack_require__(426);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(427);
	
	var warning = __webpack_require__(341);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var ReactCurrentOwner = __webpack_require__(307);
	var ReactInstanceMap = __webpack_require__(408);
	var ReactInstrumentation = __webpack_require__(359);
	var ReactUpdates = __webpack_require__(353);
	
	var invariant = __webpack_require__(331);
	var warning = __webpack_require__(341);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	var emptyFunction = __webpack_require__(342);
	var warning = __webpack_require__(341);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	var DOMLazyTree = __webpack_require__(373);
	var ReactDOMComponentTree = __webpack_require__(328);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var invariant = __webpack_require__(331);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329),
	    _assign = __webpack_require__(301);
	
	var DOMChildrenOperations = __webpack_require__(372);
	var DOMLazyTree = __webpack_require__(373);
	var ReactDOMComponentTree = __webpack_require__(328);
	
	var escapeTextContentForBrowser = __webpack_require__(378);
	var invariant = __webpack_require__(331);
	var validateDOMNesting = __webpack_require__(428);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	var ReactUpdates = __webpack_require__(353);
	var Transaction = __webpack_require__(360);
	
	var emptyFunction = __webpack_require__(342);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	var EventListener = __webpack_require__(434);
	var ExecutionEnvironment = __webpack_require__(345);
	var PooledClass = __webpack_require__(347);
	var ReactDOMComponentTree = __webpack_require__(328);
	var ReactUpdates = __webpack_require__(353);
	
	var getEventTarget = __webpack_require__(361);
	var getUnboundedScrollPosition = __webpack_require__(435);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(342);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 435 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(330);
	var EventPluginHub = __webpack_require__(337);
	var EventPluginUtils = __webpack_require__(339);
	var ReactComponentEnvironment = __webpack_require__(407);
	var ReactEmptyComponent = __webpack_require__(416);
	var ReactBrowserEventEmitter = __webpack_require__(397);
	var ReactHostComponent = __webpack_require__(417);
	var ReactUpdates = __webpack_require__(353);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	var CallbackQueue = __webpack_require__(354);
	var PooledClass = __webpack_require__(347);
	var ReactBrowserEventEmitter = __webpack_require__(397);
	var ReactInputSelection = __webpack_require__(438);
	var ReactInstrumentation = __webpack_require__(359);
	var Transaction = __webpack_require__(360);
	var ReactUpdateQueue = __webpack_require__(427);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(439);
	
	var containsNode = __webpack_require__(441);
	var focusNode = __webpack_require__(386);
	var getActiveElement = __webpack_require__(444);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(345);
	
	var getNodeForCharacterOffset = __webpack_require__(440);
	var getTextContentAccessor = __webpack_require__(348);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 440 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(442);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(443);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 443 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 444 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 445 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(336);
	var ExecutionEnvironment = __webpack_require__(345);
	var ReactDOMComponentTree = __webpack_require__(328);
	var ReactInputSelection = __webpack_require__(438);
	var SyntheticEvent = __webpack_require__(350);
	
	var getActiveElement = __webpack_require__(444);
	var isTextInputElement = __webpack_require__(363);
	var shallowEqual = __webpack_require__(414);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var EventListener = __webpack_require__(434);
	var EventPropagators = __webpack_require__(336);
	var ReactDOMComponentTree = __webpack_require__(328);
	var SyntheticAnimationEvent = __webpack_require__(448);
	var SyntheticClipboardEvent = __webpack_require__(449);
	var SyntheticEvent = __webpack_require__(350);
	var SyntheticFocusEvent = __webpack_require__(450);
	var SyntheticKeyboardEvent = __webpack_require__(451);
	var SyntheticMouseEvent = __webpack_require__(366);
	var SyntheticDragEvent = __webpack_require__(454);
	var SyntheticTouchEvent = __webpack_require__(455);
	var SyntheticTransitionEvent = __webpack_require__(456);
	var SyntheticUIEvent = __webpack_require__(367);
	var SyntheticWheelEvent = __webpack_require__(457);
	
	var emptyFunction = __webpack_require__(342);
	var getEventCharCode = __webpack_require__(452);
	var invariant = __webpack_require__(331);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(350);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(350);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(367);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(367);
	
	var getEventCharCode = __webpack_require__(452);
	var getEventKey = __webpack_require__(453);
	var getEventModifierState = __webpack_require__(369);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 452 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(452);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(366);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(367);
	
	var getEventModifierState = __webpack_require__(369);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(350);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(366);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var DOMLazyTree = __webpack_require__(373);
	var DOMProperty = __webpack_require__(330);
	var React = __webpack_require__(300);
	var ReactBrowserEventEmitter = __webpack_require__(397);
	var ReactCurrentOwner = __webpack_require__(307);
	var ReactDOMComponentTree = __webpack_require__(328);
	var ReactDOMContainerInfo = __webpack_require__(459);
	var ReactDOMFeatureFlags = __webpack_require__(460);
	var ReactFeatureFlags = __webpack_require__(355);
	var ReactInstanceMap = __webpack_require__(408);
	var ReactInstrumentation = __webpack_require__(359);
	var ReactMarkupChecksum = __webpack_require__(461);
	var ReactReconciler = __webpack_require__(356);
	var ReactUpdateQueue = __webpack_require__(427);
	var ReactUpdates = __webpack_require__(353);
	
	var emptyObject = __webpack_require__(413);
	var instantiateReactComponent = __webpack_require__(410);
	var invariant = __webpack_require__(331);
	var setInnerHTML = __webpack_require__(375);
	var shouldUpdateReactComponent = __webpack_require__(415);
	var warning = __webpack_require__(341);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(428);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 460 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(462);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 462 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 463 */
324,
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(329);
	
	var ReactCurrentOwner = __webpack_require__(307);
	var ReactDOMComponentTree = __webpack_require__(328);
	var ReactInstanceMap = __webpack_require__(408);
	
	var getHostComponentFromComposite = __webpack_require__(465);
	var invariant = __webpack_require__(331);
	var warning = __webpack_require__(341);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(412);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(458);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 467 */,
/* 468 */,
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 475 */,
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(477);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(492);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(494);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(495);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(496);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(493);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(478);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(488);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(479),
	    getPrototype = __webpack_require__(485),
	    isObjectLike = __webpack_require__(487);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(480),
	    getRawTag = __webpack_require__(483),
	    objectToString = __webpack_require__(484);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(481);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(482);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 482 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(480);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 484 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(486);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 486 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 487 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(489);


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(491);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(490)(module)))

/***/ },
/* 490 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 491 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(477);
	
	var _isPlainObject = __webpack_require__(478);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(493);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  if (false) {
	    var unexpectedKeyCache = {};
	  }
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 493 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 494 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(496);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 496 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  var rest = funcs.slice(0, -1);
	  return function () {
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(498);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(499);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(500);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(501);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(517);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(518);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(519);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(520);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(522);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(521);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(523);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(513);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(524);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(538);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(539);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(540);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(548);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(526);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(299);
	
	var func = _react.PropTypes.func,
	    object = _react.PropTypes.object,
	    shape = _react.PropTypes.shape,
	    string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager2 = __webpack_require__(502);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(512);
	
	var _RouterContext = __webpack_require__(513);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(498);
	
	var _RouterUtils = __webpack_require__(516);
	
	var _routerWarning = __webpack_require__(503);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    func = _React$PropTypes.func,
	    object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v2.x or ' + 'earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please upgrade to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(503);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(505);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(506);
	
	var _isActive2 = __webpack_require__(508);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(509);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(511);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(504);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(500);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(507);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	var enterHooks = new PendingHooks();
	var changeHooks = new PendingHooks();
	
	function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	  var isSync = hook.length < asyncArity;
	
	  var transitionHook = function transitionHook() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (isSync) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	
	  pendingHooks.add(transitionHook);
	
	  return transitionHook;
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location) {
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  enterHooks.clear();
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    var wrappedNext = function wrappedNext() {
	      if (enterHooks.has(hooks[index])) {
	        next();
	        enterHooks.remove(hooks[index]);
	      }
	    };
	    hooks[index](nextState, replace, wrappedNext);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  changeHooks.clear();
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    var wrappedNext = function wrappedNext() {
	      if (changeHooks.has(hooks[index])) {
	        next();
	        changeHooks.remove(hooks[index]);
	      }
	    };
	    hooks[index](state, nextState, replace, wrappedNext);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 507 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(500);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(507);
	
	var _PromiseUtils = __webpack_require__(510);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 510 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(507);
	
	var _PromiseUtils = __webpack_require__(510);
	
	var _PatternUtils = __webpack_require__(500);
	
	var _routerWarning = __webpack_require__(503);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(299);
	
	var func = _react.PropTypes.func,
	    object = _react.PropTypes.object,
	    arrayOf = _react.PropTypes.arrayOf,
	    oneOfType = _react.PropTypes.oneOfType,
	    element = _react.PropTypes.element,
	    shape = _react.PropTypes.shape,
	    string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getRouteParams = __webpack_require__(514);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(515);
	
	var _RouteUtils = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    array = _React$PropTypes.array,
	    func = _React$PropTypes.func,
	    object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(500);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(299);
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  eventIndex: _react.PropTypes.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ },
/* 516 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(499);
	
	var _ContextUtils = __webpack_require__(515);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    bool = _React$PropTypes.bool,
	    object = _React$PropTypes.object,
	    string = _React$PropTypes.string,
	    func = _React$PropTypes.func,
	    oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object, func]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(517);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(474);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(515);
	
	var _PropTypes = __webpack_require__(499);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(503);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(521);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(512);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(498);
	
	var _PatternUtils = __webpack_require__(500);
	
	var _InternalPropTypes = __webpack_require__(512);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(503);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(498);
	
	var _InternalPropTypes = __webpack_require__(512);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(498);
	
	var _InternalPropTypes = __webpack_require__(512);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(525);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(526);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(502);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(498);
	
	var _RouterUtils = __webpack_require__(516);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 525 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(527);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(534);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(535);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(528);
	
	var _runTransitionHook = __webpack_require__(530);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(532);
	
	var _PathUtils = __webpack_require__(533);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(529);
	var objectAssign = __webpack_require__(301);
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (ret[key] === undefined) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
		});
	
		return ret;
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true
		};
	
		opts = objectAssign(defaults, opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					if (val2 === null) {
						result.push(encode(key, opts));
					} else {
						result.push(encode(key, opts) + '=' + encode(val2, opts));
					}
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 529 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(531);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 531 */
504,
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(531);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(533);
	
	var _Actions = __webpack_require__(525);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(531);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path);
	
	  var pathname = _parsePath.pathname;
	  var search = _parsePath.search;
	  var hash = _parsePath.hash;
	
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path);
	
	  var pathname = _parsePath2.pathname;
	  var search = _parsePath2.search;
	  var hash = _parsePath2.hash;
	
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path);
	
	  var search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename;
	  var pathname = location.pathname;
	  var search = location.search;
	  var hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(530);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(533);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(531);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(532);
	
	var _PathUtils = __webpack_require__(533);
	
	var _createHistory = __webpack_require__(536);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(525);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(537);
	
	var _PathUtils = __webpack_require__(533);
	
	var _runTransitionHook = __webpack_require__(530);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(525);
	
	var _LocationUtils = __webpack_require__(532);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var getUserConfirmation = options.getUserConfirmation;
	  var pushLocation = options.pushLocation;
	  var replaceLocation = options.replaceLocation;
	  var go = options.go;
	  var keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 537 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(527);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(534);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(513);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(503);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(541);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(547);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(542);
	
	var _BrowserProtocol = __webpack_require__(543);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(546);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(544);
	
	var _createHistory = __webpack_require__(536);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation;
	  var getCurrentLocation = Protocol.getCurrentLocation;
	  var pushLocation = Protocol.pushLocation;
	  var replaceLocation = Protocol.replaceLocation;
	  var go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 542 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(532);
	
	var _DOMUtils = __webpack_require__(544);
	
	var _DOMStateStorage = __webpack_require__(545);
	
	var _PathUtils = __webpack_require__(533);
	
	var _ExecutionEnvironment = __webpack_require__(542);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if (event.state !== undefined) // Ignore extraneous popstate events in WebKit
	      listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state;
	  var key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 544 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(531);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(543);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(532);
	
	var _PathUtils = __webpack_require__(533);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(538);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(549);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(547);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(531);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(542);
	
	var _DOMUtils = __webpack_require__(544);
	
	var _HashProtocol = __webpack_require__(550);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(536);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey;
	  var hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(543);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(531);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(532);
	
	var _DOMUtils = __webpack_require__(544);
	
	var _DOMStateStorage = __webpack_require__(545);
	
	var _PathUtils = __webpack_require__(533);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state;
	  var key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 551 */
/***/ function(module, exports) {

	module.exports = CONFIG;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routeRenderer = routeRenderer;
	exports.getWindowUser = getWindowUser;
	
	var _asyncProps = __webpack_require__(553);
	
	var _asyncProps2 = _interopRequireDefault(_asyncProps);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _reactTunnel = __webpack_require__(1050);
	
	var _reactIntl = __webpack_require__(1058);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleAsyncPropsError(err) {
	  console.error('loadProps failed client side. It should have run only in SSR and been caught earlier.', err);
	  debugger; // eslint-disable-line
	}
	
	/* eslint-disable react/prop-types */
	function routeRenderer(props) {
	  // TODO reconcile with CurrentUser
	  var init = window.initialAppData;
	  var provided = {
	    // cookies: try to make an object to read these
	    userAgentStr: window.navigator.userAgent,
	    userId: init && init.userData && init.userData.id
	  };
	
	  var router = props.router;
	
	  return _react2.default.createElement(
	    _reactIntl.IntlProvider,
	    { locale: 'en' },
	    _react2.default.createElement(
	      _reactTunnel.Provider,
	      { provide: provided },
	      function () {
	        return _react2.default.createElement(_asyncProps2.default, _extends({}, props, {
	          onError: handleAsyncPropsError,
	          loadContext: { router: router },
	          renderLoading: function renderLoading() {
	            return _react2.default.createElement(
	              'h1',
	              null,
	              'Loading\u2026'
	            );
	          }
	        }));
	      }
	    )
	  );
	}
	
	function getWindowUser() {
	  var _window = window,
	      init = _window.initialAppData;
	  // read on app init, so clear it away to prevent re-reading it when it's stale
	
	  delete window.initialAppData;
	
	  var userData = init && init.authenticated && init.userData;
	  if (userData) {
	    return _User2.default.fromJSON(userData);
	  } else {
	    return null;
	  }
	}

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; }; /*global __ASYNC_PROPS__*/
	
	
	exports.loadPropsOnServer = loadPropsOnServer;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(513);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _computeChangedRoutes2 = __webpack_require__(505);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	
	function eachComponents(components, iterator) {
	  for (var i = 0, l = components.length; i < l; i++) {
	    if (_typeof(components[i]) === 'object') {
	      for (var key in components[i]) {
	        iterator(components[i][key], i, key);
	      }
	    } else {
	      iterator(components[i], i);
	    }
	  }
	}
	
	function filterAndFlattenComponents(components) {
	  var flattened = [];
	  eachComponents(components, function (Component) {
	    if (Component && Component.loadProps) flattened.push(Component);
	  });
	  return flattened;
	}
	
	function _loadAsyncProps(_ref, cb) {
	  var components = _ref.components;
	  var params = _ref.params;
	  var loadContext = _ref.loadContext;
	
	  var componentsArray = [];
	  var propsArray = [];
	  var needToLoadCounter = components.length;
	  var hasCalledBack = [];
	
	  var maybeFinish = function maybeFinish(err) {
	    if (err) cb(err);else if (needToLoadCounter === 0) cb(null, { propsArray: propsArray, componentsArray: componentsArray });
	  };
	
	  // If there are no components we should resolve directly
	  if (needToLoadCounter === 0) {
	    maybeFinish();
	  } else {
	    components.forEach(function (Component, index) {
	      Component.loadProps({ params: params, loadContext: loadContext }, function (error, props) {
	        var isDeferredCallback = hasCalledBack[index];
	        if (isDeferredCallback && needToLoadCounter === 0) {
	          cb(error, {
	            propsArray: [props],
	            componentsArray: [Component]
	          });
	        } else {
	          if (!hasCalledBack[index]) needToLoadCounter--;
	          propsArray[index] = props;
	          componentsArray[index] = Component;
	          hasCalledBack[index] = true;
	          maybeFinish(error);
	        }
	      });
	    });
	  }
	}
	
	function lookupPropsForComponent(Component, propsAndComponents) {
	  var componentsArray = propsAndComponents.componentsArray;
	  var propsArray = propsAndComponents.propsArray;
	
	  var index = componentsArray.indexOf(Component);
	  return propsArray[index];
	}
	
	function mergePropsAndComponents(current, changes) {
	  for (var i = 0, l = changes.propsArray.length; i < l; i++) {
	    var Component = changes.componentsArray[i];
	    var position = current.componentsArray.indexOf(Component);
	    var isNew = position === -1;
	
	    if (isNew) {
	      current.propsArray.push(changes.propsArray[i]);
	      current.componentsArray.push(changes.componentsArray[i]);
	    } else {
	      current.propsArray[position] = changes.propsArray[i];
	    }
	  }
	  return current;
	}
	
	function createElement(Component, props) {
	  if (Component.loadProps) return _react2.default.createElement(AsyncPropsContainer, { Component: Component, routerProps: props });else return _react2.default.createElement(Component, props);
	}
	
	function loadPropsOnServer(_ref2, loadContext, cb) {
	  var components = _ref2.components;
	  var params = _ref2.params;
	
	  _loadAsyncProps({
	    components: filterAndFlattenComponents(components),
	    params: params,
	    loadContext: loadContext
	  }, function (err, propsAndComponents) {
	    if (err) {
	      cb(err);
	    } else {
	      var json = JSON.stringify(propsAndComponents.propsArray, null, 2);
	      var scriptString = '<script>__ASYNC_PROPS__ = ' + json + '</script>';
	      cb(null, propsAndComponents, scriptString);
	    }
	  });
	}
	
	function hydrate(props) {
	  if (typeof __ASYNC_PROPS__ !== 'undefined') return {
	    propsArray: __ASYNC_PROPS__,
	    componentsArray: filterAndFlattenComponents(props.components)
	  };else return null;
	}
	
	var AsyncPropsContainer = _react2.default.createClass({
	  displayName: 'AsyncPropsContainer',
	
	
	  propTypes: {
	    Component: func.isRequired,
	    routerProps: object.isRequired
	  },
	
	  contextTypes: {
	    asyncProps: object.isRequired
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var Component = _props.Component;
	    var routerProps = _props.routerProps;
	
	    var props = _objectWithoutProperties(_props, ['Component', 'routerProps']);
	
	    var _context$asyncProps = this.context.asyncProps;
	    var propsAndComponents = _context$asyncProps.propsAndComponents;
	    var loading = _context$asyncProps.loading;
	    var reloadComponent = _context$asyncProps.reloadComponent;
	
	    var asyncProps = lookupPropsForComponent(Component, propsAndComponents);
	    var reload = function reload() {
	      return reloadComponent(Component);
	    };
	    return _react2.default.createElement(Component, _extends({}, props, routerProps, asyncProps, {
	      reloadAsyncProps: reload,
	      loading: loading
	    }));
	  }
	});
	
	var AsyncProps = _react2.default.createClass({
	  displayName: 'AsyncProps',
	
	
	  childContextTypes: {
	    asyncProps: object
	  },
	
	  propTypes: {
	    loadContext: object,
	    components: array.isRequired,
	    params: object.isRequired,
	    location: object.isRequired,
	    onError: func.isRequired,
	    renderLoading: func.isRequired,
	
	    // server rendering
	    propsArray: array,
	    componentsArray: array
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onError: function onError(err) {
	        throw err;
	      },
	      renderLoading: function renderLoading() {
	        return null;
	      },
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, _extends({}, props, { createElement: createElement }));
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    var _props2 = this.props;
	    var propsArray = _props2.propsArray;
	    var componentsArray = _props2.componentsArray;
	
	    var isServerRender = propsArray && componentsArray;
	    return {
	      loading: false,
	      prevProps: null,
	      propsAndComponents: isServerRender ? { propsArray: propsArray, componentsArray: componentsArray } : hydrate(this.props)
	    };
	  },
	  getChildContext: function getChildContext() {
	    var _this = this;
	
	    var _state = this.state;
	    var loading = _state.loading;
	    var propsAndComponents = _state.propsAndComponents;
	
	    return {
	      asyncProps: {
	        loading: loading,
	        propsAndComponents: propsAndComponents,
	        reloadComponent: function reloadComponent(Component) {
	          _this.reloadComponent(Component);
	        }
	      }
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var wasHydrated = this.state.propsAndComponents !== null;
	    if (!wasHydrated) {
	      var _props3 = this.props;
	      var components = _props3.components;
	      var params = _props3.params;
	      var location = _props3.location;
	
	      this.loadAsyncProps(components, params, location);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.location === this.props.location) return;
	
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)({ routes: this.props.routes, params: this.props.params }, { routes: nextProps.routes, params: nextProps.params });
	
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    var indexDiff = nextProps.components.length - enterRoutes.length;
	    var components = [];
	    for (var i = 0, l = enterRoutes.length; i < l; i++) {
	      components.push(nextProps.components[indexDiff + i]);
	    }this.loadAsyncProps(filterAndFlattenComponents(components), nextProps.params, nextProps.location);
	  },
	  handleError: function handleError(cb) {
	    var _this2 = this;
	
	    return function (err) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      if (err && _this2.props.onError) _this2.props.onError(err);else cb.apply(undefined, [null].concat(args));
	    };
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unmounted = true;
	  },
	  loadAsyncProps: function loadAsyncProps(components, params, location, options) {
	    var _this3 = this;
	
	    var loadContext = this.props.loadContext;
	
	    this.setState({
	      loading: true,
	      prevProps: this.props
	    }, function () {
	      _loadAsyncProps({
	        components: filterAndFlattenComponents(components),
	        params: params,
	        loadContext: loadContext
	      }, _this3.handleError(function (err, propsAndComponents) {
	        var reloading = options && options.reload;
	        var didNotChangeRoutes = _this3.props.location === location;
	        // FIXME: next line has potential (rare) race conditions I think. If
	        // somebody calls reloadAsyncProps, changes location, then changes
	        // location again before its done and state gets out of whack (Rx folks
	        // are like "LOL FLAT MAP LATEST NEWB"). Will revisit later.
	        if ((reloading || didNotChangeRoutes) && !_this3._unmounted) {
	          if (_this3.state.propsAndComponents) {
	            propsAndComponents = mergePropsAndComponents(_this3.state.propsAndComponents, propsAndComponents);
	          }
	          _this3.setState({
	            loading: false,
	            propsAndComponents: propsAndComponents,
	            prevProps: null
	          });
	        }
	      }));
	    });
	  },
	  reloadComponent: function reloadComponent(Component) {
	    var params = this.props.params;
	
	    this.loadAsyncProps([Component], params, null, { reload: true });
	  },
	  render: function render() {
	    var propsAndComponents = this.state.propsAndComponents;
	
	    if (!propsAndComponents) {
	      return this.props.renderLoading();
	    } else {
	      var props = this.state.loading ? this.state.prevProps : this.props;
	      return this.props.render(props);
	    }
	  }
	});
	
	exports.default = AsyncProps;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Collection = __webpack_require__(599);
	
	var _Collection2 = _interopRequireDefault(_Collection);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	var _OfficeHours = __webpack_require__(922);
	
	var _OfficeHours2 = _interopRequireDefault(_OfficeHours);
	
	var _Prompt = __webpack_require__(1049);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _QuickPromotion = __webpack_require__(1042);
	
	var _QuickPromotion2 = _interopRequireDefault(_QuickPromotion);
	
	var _UserConstants = __webpack_require__(1015);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var User = function (_Entity) {
	  _inherits(User, _Entity);
	
	  function User() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, User);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = User.__proto__ || Object.getPrototypeOf(User)).call.apply(_ref, [this].concat(args))), _this), _this.getExperimentVariant = _lodash2.default.memoize(function (experiment) {
	      var variant = _this.get('experiments')[experiment];
	      if (variant) {
	        var experimentsTrackable = _this.get('experiments_trackable');
	        if (experimentsTrackable.find(function (e) {
	          return e === experiment;
	        })) {
	          _this.trackExperimentExposure(experiment, variant);
	        }
	        return variant;
	      } else {
	        return 'control';
	      }
	    }), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(User, [{
	    key: 'parse',
	    value: function parse(response) {
	      var user = _lodash2.default.cloneDeep(response);
	      if (user['birthdate']) {
	        user['birthdate'] = new Date(user['birthdate']);
	      }
	      if (user['recent_prompts']) {
	        user['recent_prompts'] = new _Collection2.default(user['recent_prompts'].map(function (prompt) {
	          return _Prompt2.default.fromJSON(prompt);
	        }));
	      }
	      if (user['prompts_inventory']) {
	        user['prompts_inventory'] = new _Collection2.default(user['prompts_inventory'].map(function (prompt) {
	          return _Prompt2.default.fromJSON(prompt);
	        }));
	      } else {
	        user['prompts_inventory'] = new _Collection2.default();
	      }
	      if (user['quick_promotions']) {
	        user['quick_promotions'] = new _Collection2.default(user['quick_promotions'].map(function (prompt) {
	          return _QuickPromotion2.default.fromJSON(prompt);
	        }));
	      } else {
	        user['quick_promotions'] = new _Collection2.default();
	      }
	      if (user['office_hours']) {
	        user['office_hours'] = _OfficeHours2.default.fromJSON(user['office_hours']);
	      }
	      if (user['needs']) {
	        // UNTIL https://github.com/remind101/r101-api/pull/8023/
	        delete user['needs']['chat_promotion'];
	      }
	      if (user['created_at']) {
	        user['created_at'] = new Date(user['created_at']);
	      }
	      if (user['muted_until']) {
	        user['muted_until'] = new Date(user['muted_until']);
	      }
	      return user;
	    }
	  }, {
	    key: 'urlRoot',
	    value: function urlRoot() {
	      return '/user';
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        experiments: {}
	      };
	    }
	  }, {
	    key: 'getUuid',
	    value: function getUuid() {
	      return this.get('uuid');
	    }
	  }, {
	    key: 'getPrefix',
	    value: function getPrefix() {
	      return this.get('prefix');
	    }
	  }, {
	    key: 'getFirstName',
	    value: function getFirstName() {
	      return this.get('first_name') || '';
	    }
	  }, {
	    key: 'getCountryCode',
	    value: function getCountryCode() {
	      return this.get('country_code');
	    }
	  }, {
	    key: 'getCreatedAt',
	    value: function getCreatedAt() {
	      return this.get('created_at');
	    }
	  }, {
	    key: 'hasManualInviteSupported',
	    value: function hasManualInviteSupported() {
	      return this.get('manual_invite_supported');
	    }
	  }, {
	    key: 'hasEmail',
	    value: function hasEmail() {
	      return !!this.getEmail();
	    }
	  }, {
	    key: 'getInitials',
	    value: function getInitials() {
	      return this.get('initials');
	    }
	  }, {
	    key: 'getGradeLevel',
	    value: function getGradeLevel() {
	      return this.get('grade_level');
	    }
	  }, {
	    key: 'hasSmsSupported',
	    value: function hasSmsSupported() {
	      return this.get('sms_supported');
	    }
	  }, {
	    key: 'getLastName',
	    value: function getLastName() {
	      return this.get('last_name') || '';
	    }
	  }, {
	    key: 'getUnconfirmedEmail',
	    value: function getUnconfirmedEmail() {
	      return this.get('unconfirmed_email');
	    }
	  }, {
	    key: 'getReferralUrl',
	    value: function getReferralUrl() {
	      return this.get('referral_url');
	    }
	  }, {
	    key: 'getOrganizationId',
	    value: function getOrganizationId() {
	      return this.get('organization_id');
	    }
	
	    // There is an issue adding organization_ids as an empty array to the user factory for tests:
	    // https://github.com/Coffa/factory_girl/issues/20
	
	  }, {
	    key: 'getOrganizationIds',
	    value: function getOrganizationIds() {
	      return this.get('organization_ids') || [];
	    }
	  }, {
	    key: 'getEmail',
	    value: function getEmail() {
	      return this.get('email');
	    }
	  }, {
	    key: 'getDisplayName',
	    value: function getDisplayName() {
	      return this.get('display_name');
	    }
	  }, {
	    key: 'getFullName',
	    value: function getFullName() {
	      return this.getFirstName() + ' ' + this.getLastName();
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return this.get('name') || this.getFullName();
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      return this.get('color');
	    }
	  }, {
	    key: 'getBirthdate',
	    value: function getBirthdate() {
	      return this.get('birthdate');
	    }
	  }, {
	    key: 'getIsChild',
	    value: function getIsChild() {
	      return this.get('is_child');
	    }
	  }, {
	    key: 'getRole',
	    value: function getRole() {
	      return this.get('role');
	    }
	  }, {
	    key: 'getUserSelectedRole',
	    value: function getUserSelectedRole() {
	      return this.get('user_selected_role');
	    }
	  }, {
	    key: 'getLocale',
	    value: function getLocale() {
	      return this.get('locale') || 'en-US';
	    }
	  }, {
	    key: 'getISO639Locale',
	    value: function getISO639Locale() {
	      return this.getLocale().split('-')[0];
	    }
	  }, {
	    key: 'getSignature',
	    value: function getSignature() {
	      return this.get('signature');
	    }
	  }, {
	    key: 'hasPassword',
	    value: function hasPassword() {
	      return this.get('has_password');
	    }
	  }, {
	    key: 'getPusherChannel',
	    value: function getPusherChannel() {
	      return this.get('pusher_channel');
	    }
	  }, {
	    key: 'getAge',
	    value: function getAge() {
	      var birthdate = this.getBirthdate();
	      if (!birthdate) {
	        return null;
	      }
	
	      var today = new Date();
	      var age = today.getFullYear() - birthdate.getFullYear();
	      var m = today.getMonth() - birthdate.getMonth();
	      return m < 0 || m === 0 && today.getDate() < birthdate.getDate() ? age - 1 : age;
	    }
	  }, {
	    key: 'isUnderage',
	    value: function isUnderage() {
	      var age = this.getAge();
	      return typeof age === 'number' && age < 13;
	    }
	  }, {
	    key: 'getParentEmail',
	    value: function getParentEmail() {
	      return this.get('parent_email');
	    }
	
	    /**
	     * Memoize so that only first exposure logs (subsequent are redundant).
	     *
	     * Note that our experiment reporting framework requires than an impression
	     * is logged at least once per day. We rely on the refreshAppIfOld() in src/app
	     * to ensure that the app is reloaded every 24hrs.
	     */
	
	  }, {
	    key: 'trackExperimentExposure',
	
	
	    // TODO type these against our experiment definition
	    value: function trackExperimentExposure(experiment, variant) {
	      _EventTracking2.default.experimentExposure(experiment, variant);
	    }
	  }, {
	    key: 'getFeatures',
	    value: function getFeatures() {
	      return this.get('features');
	    }
	  }, {
	    key: 'hasFeature',
	    value: function hasFeature(name) {
	      return !!this.get('features')[name];
	    }
	  }, {
	    key: 'getReachability',
	    value: function getReachability() {
	      return this.get('reachability');
	    }
	  }, {
	    key: 'getReachabilityState',
	    value: function getReachabilityState() {
	      return this.get('reachability_state');
	    }
	
	    /**
	     * @deprecated in favor of prompts_inventory
	     * @see https://github.com/remind101/r101-frontend/pull/2607#issuecomment-212069295
	     */
	
	  }, {
	    key: 'getRecentPrompts',
	    value: function getRecentPrompts() {
	      return this.get('recent_prompts');
	    }
	
	    /**
	     * Inventory of prompts we would like to show the user
	     * @return {[Prompt]}
	     */
	
	  }, {
	    key: 'getPromptsInventory',
	    value: function getPromptsInventory() {
	      // TODO figure out why this is undefined sometimes
	      return this.get('prompts_inventory') || new _Collection2.default();
	    }
	  }, {
	    key: 'getQuickPromotions',
	    value: function getQuickPromotions() {
	      return this.get('quick_promotions');
	    }
	  }, {
	    key: 'removeQuickPromotion',
	    value: function removeQuickPromotion(promotion) {
	      this.get('quick_promotions').remove(promotion);
	    }
	  }, {
	    key: 'hasItemInPromptsInventory',
	    value: function hasItemInPromptsInventory(name) {
	      return !!this.getPromptsInventory().find(function (item) {
	        return item.get('action') === name;
	      });
	    }
	  }, {
	    key: 'findPrompt',
	    value: function findPrompt(name) {
	      return this.getPromptsInventory().find(function (item) {
	        return item.get('action') === name;
	      });
	    }
	  }, {
	    key: 'getOfficeHours',
	    value: function getOfficeHours() {
	      return this.get('office_hours');
	    }
	  }, {
	    key: 'getNeeds',
	    value: function getNeeds() {
	      return this.get('needs');
	    }
	  }, {
	    key: 'completedSetup',
	    value: function completedSetup() {
	      return !_lodash2.default.some(this.getNeeds());
	    }
	  }, {
	    key: 'getTrackingSegment',
	    value: function getTrackingSegment() {
	      var email = this.getEmail();
	      if (email && email.endsWith('remind101.com')) {
	        return 'remind';
	      } else if (this.get('is_admin')) {
	        return 'admin';
	      } else if (this.get('is_child')) {
	        return 'child';
	      } else {
	        return this.getRole();
	      }
	    }
	  }, {
	    key: 'isAdmin',
	    value: function isAdmin() {
	      return !!this.get('is_admin');
	    }
	
	    // $FlowFixMe
	
	  }, {
	    key: 'setOfficeHours',
	    value: function setOfficeHours(hours) {
	      return this.set({ office_hours: hours });
	    }
	  }, {
	    key: 'getGroupChatMemberLimit',
	    value: function getGroupChatMemberLimit() {
	      return this.get('settings')['chats']['members']['limit'];
	    }
	  }, {
	    key: 'getAnnouncementCharactersLimit',
	    value: function getAnnouncementCharactersLimit() {
	      return this.get('settings')['messages']['characters']['limit'];
	    }
	  }, {
	    key: 'getAnnouncementCharactersLimitWithFiles',
	    value: function getAnnouncementCharactersLimitWithFiles() {
	      return this.get('settings')['messages']['characters']['limit_with_files'];
	    }
	  }, {
	    key: 'needsGroups',
	    value: function needsGroups() {
	      return this.getNeeds()['groups'];
	    }
	  }, {
	    key: 'getSignInCount',
	    value: function getSignInCount() {
	      return this.get('sign_in_count');
	    }
	  }, {
	    key: 'isOrganizationPickerEligible',
	    value: function isOrganizationPickerEligible() {
	      return this.get('organization_picker_eligible');
	    }
	  }, {
	    key: 'getPreferences',
	    value: function getPreferences() {
	      return this.get('preferences');
	    }
	  }, {
	    key: 'getPreference',
	    value: function getPreference(name) {
	      return this.get('preferences')[name];
	    }
	
	    // $FlowFixMe
	
	  }, {
	    key: 'setPreferences',
	    value: function setPreferences(preferences) {
	      return this.set({ preferences: preferences });
	    }
	  }, {
	    key: 'worksAtASchool',
	    value: function worksAtASchool() {
	      return this.getPreferences()['works_at_a_school'];
	    }
	  }, {
	    key: 'hasTwoWayMessaging',
	    value: function hasTwoWayMessaging() {
	      return this.getPreference('two_way_messaging');
	    }
	  }, {
	    key: 'isRCE',
	    value: function isRCE() {
	      return !!this.get('is_rce');
	    }
	  }, {
	    key: 'isTeacher',
	    value: function isTeacher() {
	      return this.getRole() === _UserConstants.Roles.teacher;
	    }
	  }, {
	    key: 'isStudent',
	    value: function isStudent() {
	      return this.getRole() === _UserConstants.Roles.student;
	    }
	  }, {
	    key: 'isBlocked',
	    value: function isBlocked() {
	      return this.get('blocked');
	    }
	  }, {
	    key: 'getPermissions',
	    value: function getPermissions() {
	      return this.get('permissions') || {};
	    }
	  }, {
	    key: 'canChat',
	    value: function canChat() {
	      return !!this.getPermissions()['can_chat'];
	    }
	  }, {
	    key: 'canCollectMoney',
	    value: function canCollectMoney() {
	      return !!this.getPermissions()['can_collect_money'];
	    }
	  }, {
	    key: 'canSendMoney',
	    value: function canSendMoney() {
	      return !!this.getPermissions()['can_send_money'];
	    }
	  }, {
	    key: 'canComposeAnnouncements',
	    value: function canComposeAnnouncements() {
	      return !!this.getPermissions()['can_compose_announcements'];
	    }
	  }, {
	    key: 'canComposeGroupChat',
	    value: function canComposeGroupChat() {
	      return !!this.getPermissions()['can_compose_group_chat'];
	    }
	  }, {
	    key: 'canCreateActivity',
	    value: function canCreateActivity() {
	      return !!this.getPermissions()['can_create_activity'];
	    }
	  }, {
	    key: 'canComposeIndividualChat',
	    value: function canComposeIndividualChat() {
	      return true;
	    }
	  }, {
	    key: 'canCreateGroups',
	    value: function canCreateGroups() {
	      return !!this.getPermissions()['can_create_group'];
	    }
	  }, {
	    key: 'canOwnGroups',
	    value: function canOwnGroups() {
	      return !!this.getPermissions()['can_own_groups'];
	    }
	  }, {
	    key: 'getMutedUntil',
	    value: function getMutedUntil() {
	      return this.get('muted_until');
	    }
	  }, {
	    key: 'isMuted',
	    value: function isMuted() {
	      var mutedUntil = this.getMutedUntil();
	      return !!mutedUntil && mutedUntil >= new Date();
	    }
	
	    // $FlowFixMe
	
	  }, {
	    key: 'savePreference',
	    value: function savePreference(name, value) {
	      var _this2 = this;
	
	      return (0, _apiRequest2.default)('/users/' + this.id + '/prefs', 'PATCH', {
	        preferences: _defineProperty({}, name, value)
	      }).then(function (_ref2) {
	        var preferences = _ref2.preferences;
	
	        _this2.set({ preferences: preferences });
	        return preferences;
	      });
	    }
	  }], [{
	    key: 'setRole',
	    value: function setRole(role) {
	      return (0, _apiRequest2.default)('/user', 'PATCH', { user: { role: role } }).then(function (user) {
	        return User.fromJSON(user);
	      });
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword(password, token) {
	      var params = {
	        password: password,
	        password_confirmation: password,
	        token: token
	      };
	
	      return (0, _apiRequest2.default)('/password', 'PUT', params).then(function (user) {
	        return User.fromJSON(user);
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(token) {
	      // TODO does this require a token or not?
	      var params = token ? { token: token } : {};
	      return (0, _apiRequest2.default)('/user', 'DELETE', params);
	    }
	  }, {
	    key: 'verifyDeleteToken',
	    value: function verifyDeleteToken(token) {
	      return (0, _apiRequest2.default)('/account_deletion', 'GET', { token: token });
	    }
	
	    /* Api send 202 even when error happens
	     * we need a custom promise the handle this.
	     */
	
	  }, {
	    key: 'create',
	    value: function create(attr) {
	      return new Promise(function (resolve, reject) {
	        var onSuccess = function onSuccess(result) {
	          // if there an id it's probably a user.
	          if (result.id) {
	            resolve(User.fromJSON(result));
	          }
	
	          // otherwise it's an error
	          reject(result);
	        };
	
	        (0, _apiRequest2.default)('/users', 'POST', { user: attr }).then(onSuccess, function (error) {
	          return reject(error);
	        });
	      });
	    }
	  }, {
	    key: 'update',
	    value: function update(attr) {
	      return (0, _apiRequest2.default)('/user', 'PATCH', { user: attr }).then(function (response) {
	        return User.fromJSON(response);
	      });
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm(confirmationToken, source) {
	      return (0, _apiRequest2.default)('/users/confirm', 'POST', {
	        confirmation_token: confirmationToken,
	        source: source
	      }).then(function (user) {
	        return User.fromJSON(user);
	      });
	    }
	  }, {
	    key: 'requestConfirmation',
	    value: function requestConfirmation() {
	      return (0, _apiRequest2.default)('/users/confirm/request', 'POST');
	    }
	  }, {
	    key: 'setBirthdate',
	    value: function setBirthdate(birthdate) {
	      var dateString = birthdate.getFullYear() + '-' + ('0' + (birthdate.getMonth() + 1)).slice(-2) + '-' + ('0' + birthdate.getDate()).slice(-2);
	      return (0, _apiRequest2.default)('/user', 'PATCH', { user: { birthdate: dateString } }).then(function (user) {
	        return User.fromJSON(user);
	      });
	    }
	  }, {
	    key: 'setParentEmail',
	    value: function setParentEmail(parentEmail) {
	      return (0, _apiRequest2.default)('/user', 'PATCH', { user: { parent_email: parentEmail } }).then(function (user) {
	        return User.fromJSON(user);
	      });
	    }
	  }, {
	    key: 'requestForPublicGroups',
	    value: function requestForPublicGroups(teacherId) {
	      return (0, _apiRequest2.default)('/users/' + teacherId + '/request_for_public_groups', 'POST');
	    }
	  }, {
	    key: 'loadProfile',
	    value: function loadProfile(opts) {
	      return (0, _apiRequest2.default)('/profiles', 'GET', opts);
	    }
	  }, {
	    key: 'reportUser',
	    value: function reportUser(userId, reason, notes) {
	      var reasonAndNotes = notes ? reason + ' - ' + notes : reason;
	      return (0, _apiRequest2.default)('/users/' + userId + '/report', 'POST', {
	        reason: reasonAndNotes
	      });
	    }
	  }, {
	    key: 'addParent',
	    value: function addParent(name, address) {
	      return (0, _apiRequest2.default)('/users/parents', 'POST', {
	        address: address,
	        name: name
	      }).then(function (response) {
	        return User.fromJSON(response.child);
	      });
	    }
	  }]);
	
	  return User;
	}(_Entity3.default);
	
	User.displayName = 'User';
	exports.default = User;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(490)(module)))

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.remindXHR = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getAPIURL = getAPIURL;
	exports.default = apiRequest;
	
	var _Config = __webpack_require__(551);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _qs = __webpack_require__(557);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _xhr = __webpack_require__(562);
	
	var _xhr2 = _interopRequireDefault(_xhr);
	
	var _requestHeaders = __webpack_require__(569);
	
	var _xhrInterceptors = __webpack_require__(575);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var remindXHR = exports.remindXHR = { xhr: _xhr2.default };
	
	var API_HOST = _Config2.default.Environment.R101_API_URL;
	var PATH_PREFIX = '/v2';
	
	function encodeData(data) {
	  return _qs2.default.stringify(data, {
	    arrayFormat: 'brackets'
	  });
	}
	
	function getAPIURL(endpoint) {
	  return API_HOST + PATH_PREFIX + endpoint;
	}
	
	function apiRequest(endpoint) {
	  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
	  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var isJSON = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  return new Promise(function (resolve, reject) {
	    var options = {
	      url: getAPIURL(endpoint),
	      method: method,
	      headers: _extends({}, (0, _requestHeaders.getCommonHeaders)(), {
	        'Content-Type': isJSON ? 'application/json; charset=utf-8' : 'application/x-www-form-urlencoded; charset=utf-8',
	        'X-Requested-With': 'XMLHttpRequest'
	      }),
	      timeout: 30 * 1000
	    };
	
	    // Limit API requests to GET and POST requests only. We use the `X-HTTP-Method-Override` to
	    // alter the HTTP method when proxying to API.
	    if (method !== 'GET' && method !== 'POST') {
	      options.method = 'POST';
	      options.headers['X-HTTP-Method-Override'] = method;
	    }
	
	    // XXX remove stores from API lib
	    var CurrentUser = __webpack_require__(576).default;
	    if (CurrentUser.getToken()) {
	      data['token'] = CurrentUser.getToken();
	    }
	
	    // always omit undefined
	    // XXX We allow explicitly setting null to accomodate de-linking a class from an org. 💩
	    // This behavior is otherwise deprecated and should not be relied on.
	    for (var key in data) {
	      if (data[key] === undefined || method === 'GET' && data[key] === null) {
	        delete data[key];
	      }
	    }
	
	    if (method === 'GET') {
	      if (data) {
	        options.url += '?' + encodeData(data);
	        data = {}; // eslint-disable-line no-param-reassign
	      }
	    }
	
	    if (isJSON) {
	      options.json = data;
	    } else {
	      options.body = encodeData(data);
	    }
	
	    remindXHR.xhr(options, function (err, response, body) {
	      // A status code of `0` typically means that the xhr request was cancelled.
	      // Don't handle these as they'll typically result in errors being produced.
	      if (response.statusCode === 0) {
	        return;
	      }
	
	      if (!isJSON) {
	        try {
	          body = JSON.parse(body); // eslint-disable-line no-param-reassign
	        } catch (e) {
	          // Do nothing.
	        }
	      }
	
	      var intercepted = (0, _xhrInterceptors.checkInterception)(response);
	      if (!intercepted) {
	        if (err || response.statusCode >= 400) {
	          // TODO: Wrap the error response into something easier to use.
	          if (body && (typeof body === 'undefined' ? 'undefined' : _typeof(body)) === 'object') {
	            body.statusCode = response.statusCode;
	          }
	          reject(err || body);
	        } else {
	          resolve(body);
	        }
	      }
	    });
	  });
	}

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(558);


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Stringify = __webpack_require__(559);
	var Parse = __webpack_require__(561);
	
	
	// Declare internals
	
	var internals = {};
	
	
	module.exports = {
	    stringify: Stringify,
	    parse: Parse
	};


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(560);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    arrayPrefixGenerators: {
	        brackets: function (prefix, key) {
	
	            return prefix + '[]';
	        },
	        indices: function (prefix, key) {
	
	            return prefix + '[' + key + ']';
	        },
	        repeat: function (prefix, key) {
	
	            return prefix;
	        }
	    },
	    strictNullHandling: false
	};
	
	
	internals.stringify = function (obj, prefix, generateArrayPrefix, strictNullHandling, filter) {
	
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    }
	    else if (Utils.isBuffer(obj)) {
	        obj = obj.toString();
	    }
	    else if (obj instanceof Date) {
	        obj = obj.toISOString();
	    }
	    else if (obj === null) {
	        if (strictNullHandling) {
	            return Utils.encode(prefix);
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' ||
	        typeof obj === 'number' ||
	        typeof obj === 'boolean') {
	
	        return [Utils.encode(prefix) + '=' + Utils.encode(obj)];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys = Array.isArray(filter) ? filter : Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	
	        if (Array.isArray(obj)) {
	            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, filter));
	        }
	        else {
	            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix, strictNullHandling, filter));
	        }
	    }
	
	    return values;
	};
	
	
	module.exports = function (obj, options) {
	
	    options = options || {};
	    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
	    var objKeys;
	    var filter;
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    }
	    else if (Array.isArray(options.filter)) {
	        objKeys = filter = options.filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in internals.arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    }
	    else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    }
	    else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix, strictNullHandling, filter));
	    }
	
	    return keys.join(delimiter);
	};


/***/ },
/* 560 */
/***/ function(module, exports) {

	// Load modules
	
	
	// Declare internals
	
	var internals = {};
	internals.hexTable = new Array(256);
	for (var i = 0; i < 256; ++i) {
	    internals.hexTable[i] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
	}
	
	
	exports.arrayToObject = function (source) {
	
	    var obj = Object.create(null);
	    for (var i = 0, il = source.length; i < il; ++i) {
	        if (typeof source[i] !== 'undefined') {
	
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	
	exports.merge = function (target, source) {
	
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        }
	        else if (typeof target === 'object') {
	            target[source] = true;
	        }
	        else {
	            target = [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        target = [target].concat(source);
	        return target;
	    }
	
	    if (Array.isArray(target) &&
	        !Array.isArray(source)) {
	
	        target = exports.arrayToObject(target);
	    }
	
	    var keys = Object.keys(source);
	    for (var k = 0, kl = keys.length; k < kl; ++k) {
	        var key = keys[k];
	        var value = source[key];
	
	        if (!target[key]) {
	            target[key] = value;
	        }
	        else {
	            target[key] = exports.merge(target[key], value);
	        }
	    }
	
	    return target;
	};
	
	
	exports.decode = function (str) {
	
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	exports.encode = function (str) {
	
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    if (typeof str !== 'string') {
	        str = '' + str;
	    }
	
	    var out = '';
	    for (var i = 0, il = str.length; i < il; ++i) {
	        var c = str.charCodeAt(i);
	
	        if (c === 0x2D || // -
	            c === 0x2E || // .
	            c === 0x5F || // _
	            c === 0x7E || // ~
	            (c >= 0x30 && c <= 0x39) || // 0-9
	            (c >= 0x41 && c <= 0x5A) || // a-z
	            (c >= 0x61 && c <= 0x7A)) { // A-Z
	
	            out += str[i];
	            continue;
	        }
	
	        if (c < 0x80) {
	            out += internals.hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out += internals.hexTable[0xC0 | (c >> 6)] + internals.hexTable[0x80 | (c & 0x3F)];
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out += internals.hexTable[0xE0 | (c >> 12)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
	            continue;
	        }
	
	        ++i;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (str.charCodeAt(i) & 0x3FF));
	        out += internals.hexTable[0xF0 | (c >> 18)] + internals.hexTable[0x80 | ((c >> 12) & 0x3F)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	exports.compact = function (obj, refs) {
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return obj;
	    }
	
	    refs = refs || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0, il = obj.length; i < il; ++i) {
	            if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    for (i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        obj[key] = exports.compact(obj[key], refs);
	    }
	
	    return obj;
	};
	
	
	exports.isRegExp = function (obj) {
	
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	
	exports.isBuffer = function (obj) {
	
	    if (obj === null ||
	        typeof obj === 'undefined') {
	
	        return false;
	    }
	
	    return !!(obj.constructor &&
	              obj.constructor.isBuffer &&
	              obj.constructor.isBuffer(obj));
	};


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(560);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    depth: 5,
	    arrayLimit: 20,
	    parameterLimit: 1000,
	    strictNullHandling: false
	};
	
	
	internals.parseValues = function (str, options) {
	
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0, il = parts.length; i < il; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        if (pos === -1) {
	            obj[Utils.decode(part)] = '';
	
	            if (options.strictNullHandling) {
	                obj[Utils.decode(part)] = null;
	            }
	        }
	        else {
	            var key = Utils.decode(part.slice(0, pos));
	            var val = Utils.decode(part.slice(pos + 1));
	
	            if (!Object.prototype.hasOwnProperty.call(obj, key)) {
	                obj[key] = val;
	            }
	            else {
	                obj[key] = [].concat(obj[key]).concat(val);
	            }
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseObject = function (chain, val, options) {
	
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj;
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(internals.parseObject(chain, val, options));
	    }
	    else {
	        obj = Object.create(null);
	        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
	        var index = parseInt(cleanRoot, 10);
	        var indexString = '' + index;
	        if (!isNaN(index) &&
	            root !== cleanRoot &&
	            indexString === cleanRoot &&
	            index >= 0 &&
	            (options.parseArrays &&
	             index <= options.arrayLimit)) {
	
	            obj = [];
	            obj[index] = internals.parseObject(chain, val, options);
	        }
	        else {
	            obj[cleanRoot] = internals.parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseKeys = function (key, val, options) {
	
	    if (!key) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	
	    if (options.allowDots) {
	        key = key.replace(/\.([^\.\[]+)/g, '[$1]');
	    }
	
	    // The regex chunks
	
	    var parent = /^([^\[\]]*)/;
	    var child = /(\[[^\[\]]*\])/g;
	
	    // Get the parent
	
	    var segment = parent.exec(key);
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (segment[1]) {
	        keys.push(segment[1]);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	
	        ++i;
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return internals.parseObject(keys, val, options);
	};
	
	
	module.exports = function (str, options) {
	
	    if (str === '' ||
	        str === null ||
	        typeof str === 'undefined') {
	
	        return Object.create(null);
	    }
	
	    options = options || {};
	    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.allowDots = options.allowDots !== false;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
	
	
	    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
	    var obj = Object.create(null);
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        var newObj = internals.parseKeys(key, tempObj[key], options);
	        obj = Utils.merge(obj, newObj);
	    }
	
	    return Utils.compact(obj);
	};


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var window = __webpack_require__(563)
	var isFunction = __webpack_require__(564)
	var parseHeaders = __webpack_require__(565)
	var xtend = __webpack_require__(568)
	
	module.exports = createXHR
	createXHR.XMLHttpRequest = window.XMLHttpRequest || noop
	createXHR.XDomainRequest = "withCredentials" in (new createXHR.XMLHttpRequest()) ? createXHR.XMLHttpRequest : window.XDomainRequest
	
	forEachArray(["get", "put", "post", "patch", "head", "delete"], function(method) {
	    createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
	        options = initParams(uri, options, callback)
	        options.method = method.toUpperCase()
	        return _createXHR(options)
	    }
	})
	
	function forEachArray(array, iterator) {
	    for (var i = 0; i < array.length; i++) {
	        iterator(array[i])
	    }
	}
	
	function isEmpty(obj){
	    for(var i in obj){
	        if(obj.hasOwnProperty(i)) return false
	    }
	    return true
	}
	
	function initParams(uri, options, callback) {
	    var params = uri
	
	    if (isFunction(options)) {
	        callback = options
	        if (typeof uri === "string") {
	            params = {uri:uri}
	        }
	    } else {
	        params = xtend(options, {uri: uri})
	    }
	
	    params.callback = callback
	    return params
	}
	
	function createXHR(uri, options, callback) {
	    options = initParams(uri, options, callback)
	    return _createXHR(options)
	}
	
	function _createXHR(options) {
	    if(typeof options.callback === "undefined"){
	        throw new Error("callback argument missing")
	    }
	
	    var called = false
	    var callback = function cbOnce(err, response, body){
	        if(!called){
	            called = true
	            options.callback(err, response, body)
	        }
	    }
	
	    function readystatechange() {
	        if (xhr.readyState === 4) {
	            loadFunc()
	        }
	    }
	
	    function getBody() {
	        // Chrome with requestType=blob throws errors arround when even testing access to responseText
	        var body = undefined
	
	        if (xhr.response) {
	            body = xhr.response
	        } else {
	            body = xhr.responseText || getXml(xhr)
	        }
	
	        if (isJson) {
	            try {
	                body = JSON.parse(body)
	            } catch (e) {}
	        }
	
	        return body
	    }
	
	    function errorFunc(evt) {
	        clearTimeout(timeoutTimer)
	        if(!(evt instanceof Error)){
	            evt = new Error("" + (evt || "Unknown XMLHttpRequest Error") )
	        }
	        evt.statusCode = 0
	        return callback(evt, failureResponse)
	    }
	
	    // will load the data & process the response in a special response object
	    function loadFunc() {
	        if (aborted) return
	        var status
	        clearTimeout(timeoutTimer)
	        if(options.useXDR && xhr.status===undefined) {
	            //IE8 CORS GET successful response doesn't have a status field, but body is fine
	            status = 200
	        } else {
	            status = (xhr.status === 1223 ? 204 : xhr.status)
	        }
	        var response = failureResponse
	        var err = null
	
	        if (status !== 0){
	            response = {
	                body: getBody(),
	                statusCode: status,
	                method: method,
	                headers: {},
	                url: uri,
	                rawRequest: xhr
	            }
	            if(xhr.getAllResponseHeaders){ //remember xhr can in fact be XDR for CORS in IE
	                response.headers = parseHeaders(xhr.getAllResponseHeaders())
	            }
	        } else {
	            err = new Error("Internal XMLHttpRequest Error")
	        }
	        return callback(err, response, response.body)
	    }
	
	    var xhr = options.xhr || null
	
	    if (!xhr) {
	        if (options.cors || options.useXDR) {
	            xhr = new createXHR.XDomainRequest()
	        }else{
	            xhr = new createXHR.XMLHttpRequest()
	        }
	    }
	
	    var key
	    var aborted
	    var uri = xhr.url = options.uri || options.url
	    var method = xhr.method = options.method || "GET"
	    var body = options.body || options.data
	    var headers = xhr.headers = options.headers || {}
	    var sync = !!options.sync
	    var isJson = false
	    var timeoutTimer
	    var failureResponse = {
	        body: undefined,
	        headers: {},
	        statusCode: 0,
	        method: method,
	        url: uri,
	        rawRequest: xhr
	    }
	
	    if ("json" in options && options.json !== false) {
	        isJson = true
	        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json") //Don't override existing accept header declared by user
	        if (method !== "GET" && method !== "HEAD") {
	            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json") //Don't override existing accept header declared by user
	            body = JSON.stringify(options.json === true ? body : options.json)
	        }
	    }
	
	    xhr.onreadystatechange = readystatechange
	    xhr.onload = loadFunc
	    xhr.onerror = errorFunc
	    // IE9 must have onprogress be set to a unique function.
	    xhr.onprogress = function () {
	        // IE must die
	    }
	    xhr.onabort = function(){
	        aborted = true;
	    }
	    xhr.ontimeout = errorFunc
	    xhr.open(method, uri, !sync, options.username, options.password)
	    //has to be after open
	    if(!sync) {
	        xhr.withCredentials = !!options.withCredentials
	    }
	    // Cannot set timeout with sync request
	    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
	    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
	    if (!sync && options.timeout > 0 ) {
	        timeoutTimer = setTimeout(function(){
	            if (aborted) return
	            aborted = true//IE9 may still call readystatechange
	            xhr.abort("timeout")
	            var e = new Error("XMLHttpRequest timeout")
	            e.code = "ETIMEDOUT"
	            errorFunc(e)
	        }, options.timeout )
	    }
	
	    if (xhr.setRequestHeader) {
	        for(key in headers){
	            if(headers.hasOwnProperty(key)){
	                xhr.setRequestHeader(key, headers[key])
	            }
	        }
	    } else if (options.headers && !isEmpty(options.headers)) {
	        throw new Error("Headers cannot be set on an XDomainRequest object")
	    }
	
	    if ("responseType" in options) {
	        xhr.responseType = options.responseType
	    }
	
	    if ("beforeSend" in options &&
	        typeof options.beforeSend === "function"
	    ) {
	        options.beforeSend(xhr)
	    }
	
	    // Microsoft Edge browser sends "undefined" when send is called with undefined value.
	    // XMLHttpRequest spec says to pass null as body to indicate no body
	    // See https://github.com/naugtur/xhr/issues/100.
	    xhr.send(body || null)
	
	    return xhr
	
	
	}
	
	function getXml(xhr) {
	    if (xhr.responseType === "document") {
	        return xhr.responseXML
	    }
	    var firefoxBugTakenEffect = xhr.status === 204 && xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror"
	    if (xhr.responseType === "" && !firefoxBugTakenEffect) {
	        return xhr.responseXML
	    }
	
	    return null
	}
	
	function noop() {}


/***/ },
/* 563 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {if (typeof window !== "undefined") {
	    module.exports = window;
	} else if (typeof global !== "undefined") {
	    module.exports = global;
	} else if (typeof self !== "undefined"){
	    module.exports = self;
	} else {
	    module.exports = {};
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 564 */
/***/ function(module, exports) {

	module.exports = isFunction
	
	var toString = Object.prototype.toString
	
	function isFunction (fn) {
	  var string = toString.call(fn)
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	};


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(566)
	  , forEach = __webpack_require__(567)
	  , isArray = function(arg) {
	      return Object.prototype.toString.call(arg) === '[object Array]';
	    }
	
	module.exports = function (headers) {
	  if (!headers)
	    return {}
	
	  var result = {}
	
	  forEach(
	      trim(headers).split('\n')
	    , function (row) {
	        var index = row.indexOf(':')
	          , key = trim(row.slice(0, index)).toLowerCase()
	          , value = trim(row.slice(index + 1))
	
	        if (typeof(result[key]) === 'undefined') {
	          result[key] = value
	        } else if (isArray(result[key])) {
	          result[key].push(value)
	        } else {
	          result[key] = [ result[key], value ]
	        }
	      }
	  )
	
	  return result
	}

/***/ },
/* 566 */
/***/ function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(564)
	
	module.exports = forEach
	
	var toString = Object.prototype.toString
	var hasOwnProperty = Object.prototype.hasOwnProperty
	
	function forEach(list, iterator, context) {
	    if (!isFunction(iterator)) {
	        throw new TypeError('iterator must be a function')
	    }
	
	    if (arguments.length < 3) {
	        context = this
	    }
	    
	    if (toString.call(list) === '[object Array]')
	        forEachArray(list, iterator, context)
	    else if (typeof list === 'string')
	        forEachString(list, iterator, context)
	    else
	        forEachObject(list, iterator, context)
	}
	
	function forEachArray(array, iterator, context) {
	    for (var i = 0, len = array.length; i < len; i++) {
	        if (hasOwnProperty.call(array, i)) {
	            iterator.call(context, array[i], i, array)
	        }
	    }
	}
	
	function forEachString(string, iterator, context) {
	    for (var i = 0, len = string.length; i < len; i++) {
	        // no such thing as a sparse string.
	        iterator.call(context, string.charAt(i), i, string)
	    }
	}
	
	function forEachObject(object, iterator, context) {
	    for (var k in object) {
	        if (hasOwnProperty.call(object, k)) {
	            iterator.call(context, object[k], k, object)
	        }
	    }
	}


/***/ },
/* 568 */
/***/ function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCommonHeaders = exports.staticHeaders = undefined;
	
	var _Config = __webpack_require__(551);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _jstimezonedetect = __webpack_require__(570);
	
	var _jstimezonedetect2 = _interopRequireDefault(_jstimezonedetect);
	
	var _Cookies = __webpack_require__(573);
	
	var _Cookies2 = _interopRequireDefault(_Cookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timezone = _jstimezonedetect2.default.determine().name();
	
	var offset = new Date().getTimezoneOffset() * 60; // in seconds.
	
	var staticHeaders = exports.staticHeaders = {
	  // TODO(turadg) improve these headers to use Empire more
	  'Remind101-Client-Type': 'Web',
	  'Remind101-Client-Name': 'Dashboard',
	  // must be a version number (e.g. 5.3 or v1700) or 'dev'. Else API will 500.
	  'Remind101-Client-Version': _Config2.default.Environment.EMPIRE_RELEASE,
	  'Remind101-Timezone-Id': timezone,
	  'Remind101-Timezone-Offset': offset
	};
	
	var getCommonHeaders = exports.getCommonHeaders = function getCommonHeaders() {
	  // TODO we'll have to provide the CSRF token for /graphql queries to work server-side
	  var csrfToken = _Cookies2.default.isEnabled() ? _Cookies2.default.get('csrf_token') : null;
	  var csrfHeader = csrfToken ? { 'X-CSRF-Token': csrfToken } : {};
	
	  return Object.assign({}, staticHeaders, csrfHeader);
	};

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root) {/*global exports, Intl*/
	/**
	 * This script gives you the zone info key representing your device's time zone setting.
	 *
	 * @name jsTimezoneDetect
	 * @version 1.0.6
	 * @author Jon Nylander
	 * @license MIT License - https://bitbucket.org/pellepim/jstimezonedetect/src/default/LICENCE.txt
	 *
	 * For usage and examples, visit:
	 * http://pellepim.bitbucket.org/jstz/
	 *
	 * Copyright (c) Jon Nylander
	 */
	
	
	/**
	 * Namespace to hold all the code for timezone detection.
	 */
	var jstz = (function () {
	    'use strict';
	    var HEMISPHERE_SOUTH = 's',
	
	        consts = {
	            DAY: 86400000,
	            HOUR: 3600000,
	            MINUTE: 60000,
	            SECOND: 1000,
	            BASELINE_YEAR: 2014,
	            MAX_SCORE: 864000000, // 10 days
	            AMBIGUITIES: {
	                'America/Denver':       ['America/Mazatlan'],
	                'Europe/London':        ['Africa/Casablanca'],
	                'America/Chicago':      ['America/Mexico_City'],
	                'America/Asuncion':     ['America/Campo_Grande', 'America/Santiago'],
	                'America/Montevideo':   ['America/Sao_Paulo', 'America/Santiago'],
	                // Europe/Minsk should not be in this list... but Windows.
	                'Asia/Beirut':          ['Asia/Amman', 'Asia/Jerusalem', 'Europe/Helsinki', 'Asia/Damascus', 'Africa/Cairo', 'Asia/Gaza', 'Europe/Minsk'],
	                'Pacific/Auckland':     ['Pacific/Fiji'],
	                'America/Los_Angeles':  ['America/Santa_Isabel'],
	                'America/New_York':     ['America/Havana'],
	                'America/Halifax':      ['America/Goose_Bay'],
	                'America/Godthab':      ['America/Miquelon'],
	                'Asia/Dubai':           ['Asia/Yerevan'],
	                'Asia/Jakarta':         ['Asia/Krasnoyarsk'],
	                'Asia/Shanghai':        ['Asia/Irkutsk', 'Australia/Perth'],
	                'Australia/Sydney':     ['Australia/Lord_Howe'],
	                'Asia/Tokyo':           ['Asia/Yakutsk'],
	                'Asia/Dhaka':           ['Asia/Omsk'],
	                // In the real world Yerevan is not ambigous for Baku... but Windows.
	                'Asia/Baku':            ['Asia/Yerevan'],
	                'Australia/Brisbane':   ['Asia/Vladivostok'],
	                'Pacific/Noumea':       ['Asia/Vladivostok'],
	                'Pacific/Majuro':       ['Asia/Kamchatka', 'Pacific/Fiji'],
	                'Pacific/Tongatapu':    ['Pacific/Apia'],
	                'Asia/Baghdad':         ['Europe/Minsk', 'Europe/Moscow'],
	                'Asia/Karachi':         ['Asia/Yekaterinburg'],
	                'Africa/Johannesburg':  ['Asia/Gaza', 'Africa/Cairo']
	            }
	        },
	
	        /**
	         * Gets the offset in minutes from UTC for a certain date.
	         * @param {Date} date
	         * @returns {Number}
	         */
	        get_date_offset = function get_date_offset(date) {
	            var offset = -date.getTimezoneOffset();
	            return (offset !== null ? offset : 0);
	        },
	
	        /**
	         * This function does some basic calculations to create information about
	         * the user's timezone. It uses REFERENCE_YEAR as a solid year for which
	         * the script has been tested rather than depend on the year set by the
	         * client device.
	         *
	         * Returns a key that can be used to do lookups in jstz.olson.timezones.
	         * eg: "720,1,2".
	         *
	         * @returns {String}
	         */
	        lookup_key = function lookup_key() {
	            var january_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 0, 2)),
	                june_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 5, 2)),
	                diff = january_offset - june_offset;
	
	            if (diff < 0) {
	                return january_offset + ",1";
	            } else if (diff > 0) {
	                return june_offset + ",1," + HEMISPHERE_SOUTH;
	            }
	
	            return january_offset + ",0";
	        },
	
	
	        /**
	         * Tries to get the time zone key directly from the operating system for those
	         * environments that support the ECMAScript Internationalization API.
	         */
	        get_from_internationalization_api = function get_from_internationalization_api() {
	            var format, timezone;
	            if (typeof Intl === "undefined" || typeof Intl.DateTimeFormat === "undefined") {
	                return;
	            }
	
	            format = Intl.DateTimeFormat();
	
	            if (typeof format === "undefined" || typeof format.resolvedOptions === "undefined") {
	                return;
	            }
	
	            timezone = format.resolvedOptions().timeZone;
	
	            if (timezone && (timezone.indexOf("/") > -1 || timezone === 'UTC')) {
	                return timezone;
	            }
	
	        },
	
	        /**
	         * Starting point for getting all the DST rules for a specific year
	         * for the current timezone (as described by the client system).
	         *
	         * Returns an object with start and end attributes, or false if no
	         * DST rules were found for the year.
	         *
	         * @param year
	         * @returns {Object} || {Boolean}
	         */
	        dst_dates = function dst_dates(year) {
	            var yearstart = new Date(year, 0, 1, 0, 0, 1, 0).getTime();
	            var yearend = new Date(year, 12, 31, 23, 59, 59).getTime();
	            var current = yearstart;
	            var offset = (new Date(current)).getTimezoneOffset();
	            var dst_start = null;
	            var dst_end = null;
	
	            while (current < yearend - 86400000) {
	                var dateToCheck = new Date(current);
	                var dateToCheckOffset = dateToCheck.getTimezoneOffset();
	
	                if (dateToCheckOffset !== offset) {
	                    if (dateToCheckOffset < offset) {
	                        dst_start = dateToCheck;
	                    }
	                    if (dateToCheckOffset > offset) {
	                        dst_end = dateToCheck;
	                    }
	                    offset = dateToCheckOffset;
	                }
	
	                current += 86400000;
	            }
	
	            if (dst_start && dst_end) {
	                return {
	                    s: find_dst_fold(dst_start).getTime(),
	                    e: find_dst_fold(dst_end).getTime()
	                };
	            }
	
	            return false;
	        },
	
	        /**
	         * Probably completely unnecessary function that recursively finds the
	         * exact (to the second) time when a DST rule was changed.
	         *
	         * @param a_date - The candidate Date.
	         * @param padding - integer specifying the padding to allow around the candidate
	         *                  date for finding the fold.
	         * @param iterator - integer specifying how many milliseconds to iterate while
	         *                   searching for the fold.
	         *
	         * @returns {Date}
	         */
	        find_dst_fold = function find_dst_fold(a_date, padding, iterator) {
	            if (typeof padding === 'undefined') {
	                padding = consts.DAY;
	                iterator = consts.HOUR;
	            }
	
	            var date_start = new Date(a_date.getTime() - padding).getTime();
	            var date_end = a_date.getTime() + padding;
	            var offset = new Date(date_start).getTimezoneOffset();
	
	            var current = date_start;
	
	            var dst_change = null;
	            while (current < date_end - iterator) {
	                var dateToCheck = new Date(current);
	                var dateToCheckOffset = dateToCheck.getTimezoneOffset();
	
	                if (dateToCheckOffset !== offset) {
	                    dst_change = dateToCheck;
	                    break;
	                }
	                current += iterator;
	            }
	
	            if (padding === consts.DAY) {
	                return find_dst_fold(dst_change, consts.HOUR, consts.MINUTE);
	            }
	
	            if (padding === consts.HOUR) {
	                return find_dst_fold(dst_change, consts.MINUTE, consts.SECOND);
	            }
	
	            return dst_change;
	        },
	
	        windows7_adaptations = function windows7_adaptions(rule_list, preliminary_timezone, score, sample) {
	            if (score !== 'N/A') {
	                return score;
	            }
	            if (preliminary_timezone === 'Asia/Beirut') {
	                if (sample.name === 'Africa/Cairo') {
	                    if (rule_list[6].s === 1398376800000 && rule_list[6].e === 1411678800000) {
	                        return 0;
	                    }
	                }
	                if (sample.name === 'Asia/Jerusalem') {
	                    if (rule_list[6].s === 1395964800000 && rule_list[6].e === 1411858800000) {
	                        return 0;
	                }
	            }
	            } else if (preliminary_timezone === 'America/Santiago') {
	                if (sample.name === 'America/Asuncion') {
	                    if (rule_list[6].s === 1412481600000 && rule_list[6].e === 1397358000000) {
	                        return 0;
	                    }
	                }
	                if (sample.name === 'America/Campo_Grande') {
	                    if (rule_list[6].s === 1413691200000 && rule_list[6].e === 1392519600000) {
	                        return 0;
	                    }
	                }
	            } else if (preliminary_timezone === 'America/Montevideo') {
	                if (sample.name === 'America/Sao_Paulo') {
	                    if (rule_list[6].s === 1413687600000 && rule_list[6].e === 1392516000000) {
	                        return 0;
	                    }
	                }
	            } else if (preliminary_timezone === 'Pacific/Auckland') {
	                if (sample.name === 'Pacific/Fiji') {
	                    if (rule_list[6].s === 1414245600000 && rule_list[6].e === 1396101600000) {
	                        return 0;
	                    }
	                }
	            }
	
	            return score;
	        },
	
	        /**
	         * Takes the DST rules for the current timezone, and proceeds to find matches
	         * in the jstz.olson.dst_rules.zones array.
	         *
	         * Compares samples to the current timezone on a scoring basis.
	         *
	         * Candidates are ruled immediately if either the candidate or the current zone
	         * has a DST rule where the other does not.
	         *
	         * Candidates are ruled out immediately if the current zone has a rule that is
	         * outside the DST scope of the candidate.
	         *
	         * Candidates are included for scoring if the current zones rules fall within the
	         * span of the samples rules.
	         *
	         * Low score is best, the score is calculated by summing up the differences in DST
	         * rules and if the consts.MAX_SCORE is overreached the candidate is ruled out.
	         *
	         * Yah follow? :)
	         *
	         * @param rule_list
	         * @param preliminary_timezone
	         * @returns {*}
	         */
	        best_dst_match = function best_dst_match(rule_list, preliminary_timezone) {
	            var score_sample = function score_sample(sample) {
	                var score = 0;
	
	                for (var j = 0; j < rule_list.length; j++) {
	
	                    // Both sample and current time zone report DST during the year.
	                    if (!!sample.rules[j] && !!rule_list[j]) {
	
	                        // The current time zone's DST rules are inside the sample's. Include.
	                        if (rule_list[j].s >= sample.rules[j].s && rule_list[j].e <= sample.rules[j].e) {
	                            score = 0;
	                            score += Math.abs(rule_list[j].s - sample.rules[j].s);
	                            score += Math.abs(sample.rules[j].e - rule_list[j].e);
	
	                        // The current time zone's DST rules are outside the sample's. Discard.
	                        } else {
	                            score = 'N/A';
	                            break;
	                        }
	
	                        // The max score has been reached. Discard.
	                        if (score > consts.MAX_SCORE) {
	                            score = 'N/A';
	                            break;
	                        }
	                    }
	                }
	
	                score = windows7_adaptations(rule_list, preliminary_timezone, score, sample);
	
	                return score;
	            };
	            var scoreboard = {};
	            var dst_zones = jstz.olson.dst_rules.zones;
	            var dst_zones_length = dst_zones.length;
	            var ambiguities = consts.AMBIGUITIES[preliminary_timezone];
	
	            for (var i = 0; i < dst_zones_length; i++) {
	                var sample = dst_zones[i];
	                var score = score_sample(dst_zones[i]);
	
	                if (score !== 'N/A') {
	                    scoreboard[sample.name] = score;
	                }
	            }
	
	            for (var tz in scoreboard) {
	                if (scoreboard.hasOwnProperty(tz)) {
	                    for (var j = 0; j < ambiguities.length; j++) {
	                        if (ambiguities[j] === tz) {
	                            return tz;
	                        }
	                    }
	                }
	            }
	
	            return preliminary_timezone;
	        },
	
	        /**
	         * Takes the preliminary_timezone as detected by lookup_key().
	         *
	         * Builds up the current timezones DST rules for the years defined
	         * in the jstz.olson.dst_rules.years array.
	         *
	         * If there are no DST occurences for those years, immediately returns
	         * the preliminary timezone. Otherwise proceeds and tries to solve
	         * ambiguities.
	         *
	         * @param preliminary_timezone
	         * @returns {String} timezone_name
	         */
	        get_by_dst = function get_by_dst(preliminary_timezone) {
	            var get_rules = function get_rules() {
	                var rule_list = [];
	                for (var i = 0; i < jstz.olson.dst_rules.years.length; i++) {
	                    var year_rules = dst_dates(jstz.olson.dst_rules.years[i]);
	                    rule_list.push(year_rules);
	                }
	                return rule_list;
	            };
	            var check_has_dst = function check_has_dst(rules) {
	                for (var i = 0; i < rules.length; i++) {
	                    if (rules[i] !== false) {
	                        return true;
	                    }
	                }
	                return false;
	            };
	            var rules = get_rules();
	            var has_dst = check_has_dst(rules);
	
	            if (has_dst) {
	                return best_dst_match(rules, preliminary_timezone);
	            }
	
	            return preliminary_timezone;
	        },
	
	        /**
	         * Uses get_timezone_info() to formulate a key to use in the olson.timezones dictionary.
	         *
	         * Returns an object with one function ".name()"
	         *
	         * @returns Object
	         */
	        determine = function determine() {
	            var preliminary_tz = get_from_internationalization_api();
	
	            if (!preliminary_tz) {
	                preliminary_tz = jstz.olson.timezones[lookup_key()];
	
	                if (typeof consts.AMBIGUITIES[preliminary_tz] !== 'undefined') {
	                    preliminary_tz = get_by_dst(preliminary_tz);
	                }
	            }
	
	            return {
	                name: function () {
	                    return preliminary_tz;
	                }
	            };
	        };
	
	    return {
	        determine: determine
	    };
	}());
	
	
	jstz.olson = jstz.olson || {};
	
	/**
	 * The keys in this dictionary are comma separated as such:
	 *
	 * First the offset compared to UTC time in minutes.
	 *
	 * Then a flag which is 0 if the timezone does not take daylight savings into account and 1 if it
	 * does.
	 *
	 * Thirdly an optional 's' signifies that the timezone is in the southern hemisphere,
	 * only interesting for timezones with DST.
	 *
	 * The mapped arrays is used for constructing the jstz.TimeZone object from within
	 * jstz.determine();
	 */
	jstz.olson.timezones = {
	    '-720,0': 'Etc/GMT+12',
	    '-660,0': 'Pacific/Pago_Pago',
	    '-660,1,s': 'Pacific/Apia', // Why? Because windows... cry!
	    '-600,1': 'America/Adak',
	    '-600,0': 'Pacific/Honolulu',
	    '-570,0': 'Pacific/Marquesas',
	    '-540,0': 'Pacific/Gambier',
	    '-540,1': 'America/Anchorage',
	    '-480,1': 'America/Los_Angeles',
	    '-480,0': 'Pacific/Pitcairn',
	    '-420,0': 'America/Phoenix',
	    '-420,1': 'America/Denver',
	    '-360,0': 'America/Guatemala',
	    '-360,1': 'America/Chicago',
	    '-360,1,s': 'Pacific/Easter',
	    '-300,0': 'America/Bogota',
	    '-300,1': 'America/New_York',
	    '-270,0': 'America/Caracas',
	    '-240,1': 'America/Halifax',
	    '-240,0': 'America/Santo_Domingo',
	    '-240,1,s': 'America/Asuncion',
	    '-210,1': 'America/St_Johns',
	    '-180,1': 'America/Godthab',
	    '-180,0': 'America/Argentina/Buenos_Aires',
	    '-180,1,s': 'America/Montevideo',
	    '-120,0': 'America/Noronha',
	    '-120,1': 'America/Noronha',
	    '-60,1': 'Atlantic/Azores',
	    '-60,0': 'Atlantic/Cape_Verde',
	    '0,0': 'UTC',
	    '0,1': 'Europe/London',
	    '60,1': 'Europe/Berlin',
	    '60,0': 'Africa/Lagos',
	    '60,1,s': 'Africa/Windhoek',
	    '120,1': 'Asia/Beirut',
	    '120,0': 'Africa/Johannesburg',
	    '180,0': 'Asia/Baghdad',
	    '180,1': 'Europe/Moscow',
	    '210,1': 'Asia/Tehran',
	    '240,0': 'Asia/Dubai',
	    '240,1': 'Asia/Baku',
	    '270,0': 'Asia/Kabul',
	    '300,1': 'Asia/Yekaterinburg',
	    '300,0': 'Asia/Karachi',
	    '330,0': 'Asia/Kolkata',
	    '345,0': 'Asia/Kathmandu',
	    '360,0': 'Asia/Dhaka',
	    '360,1': 'Asia/Omsk',
	    '390,0': 'Asia/Rangoon',
	    '420,1': 'Asia/Krasnoyarsk',
	    '420,0': 'Asia/Jakarta',
	    '480,0': 'Asia/Shanghai',
	    '480,1': 'Asia/Irkutsk',
	    '525,0': 'Australia/Eucla',
	    '525,1,s': 'Australia/Eucla',
	    '540,1': 'Asia/Yakutsk',
	    '540,0': 'Asia/Tokyo',
	    '570,0': 'Australia/Darwin',
	    '570,1,s': 'Australia/Adelaide',
	    '600,0': 'Australia/Brisbane',
	    '600,1': 'Asia/Vladivostok',
	    '600,1,s': 'Australia/Sydney',
	    '630,1,s': 'Australia/Lord_Howe',
	    '660,1': 'Asia/Kamchatka',
	    '660,0': 'Pacific/Noumea',
	    '690,0': 'Pacific/Norfolk',
	    '720,1,s': 'Pacific/Auckland',
	    '720,0': 'Pacific/Majuro',
	    '765,1,s': 'Pacific/Chatham',
	    '780,0': 'Pacific/Tongatapu',
	    '780,1,s': 'Pacific/Apia',
	    '840,0': 'Pacific/Kiritimati'
	};
	
	/* Build time: 2015-11-02 13:01:00Z Build by invoking python utilities/dst.py generate */
	jstz.olson.dst_rules = {
	    "years": [
	        2008,
	        2009,
	        2010,
	        2011,
	        2012,
	        2013,
	        2014
	    ],
	    "zones": [
	        {
	            "name": "Africa/Cairo",
	            "rules": [
	                {
	                    "e": 1219957200000,
	                    "s": 1209074400000
	                },
	                {
	                    "e": 1250802000000,
	                    "s": 1240524000000
	                },
	                {
	                    "e": 1285880400000,
	                    "s": 1284069600000
	                },
	                false,
	                false,
	                false,
	                {
	                    "e": 1411678800000,
	                    "s": 1406844000000
	                }
	            ]
	        },
	        {
	            "name": "Africa/Casablanca",
	            "rules": [
	                {
	                    "e": 1220223600000,
	                    "s": 1212278400000
	                },
	                {
	                    "e": 1250809200000,
	                    "s": 1243814400000
	                },
	                {
	                    "e": 1281222000000,
	                    "s": 1272758400000
	                },
	                {
	                    "e": 1312066800000,
	                    "s": 1301788800000
	                },
	                {
	                    "e": 1348970400000,
	                    "s": 1345428000000
	                },
	                {
	                    "e": 1382839200000,
	                    "s": 1376100000000
	                },
	                {
	                    "e": 1414288800000,
	                    "s": 1406944800000
	                }
	            ]
	        },
	        {
	            "name": "America/Asuncion",
	            "rules": [
	                {
	                    "e": 1205031600000,
	                    "s": 1224388800000
	                },
	                {
	                    "e": 1236481200000,
	                    "s": 1255838400000
	                },
	                {
	                    "e": 1270954800000,
	                    "s": 1286078400000
	                },
	                {
	                    "e": 1302404400000,
	                    "s": 1317528000000
	                },
	                {
	                    "e": 1333854000000,
	                    "s": 1349582400000
	                },
	                {
	                    "e": 1364094000000,
	                    "s": 1381032000000
	                },
	                {
	                    "e": 1395543600000,
	                    "s": 1412481600000
	                }
	            ]
	        },
	        {
	            "name": "America/Campo_Grande",
	            "rules": [
	                {
	                    "e": 1203217200000,
	                    "s": 1224388800000
	                },
	                {
	                    "e": 1234666800000,
	                    "s": 1255838400000
	                },
	                {
	                    "e": 1266721200000,
	                    "s": 1287288000000
	                },
	                {
	                    "e": 1298170800000,
	                    "s": 1318737600000
	                },
	                {
	                    "e": 1330225200000,
	                    "s": 1350792000000
	                },
	                {
	                    "e": 1361070000000,
	                    "s": 1382241600000
	                },
	                {
	                    "e": 1392519600000,
	                    "s": 1413691200000
	                }
	            ]
	        },
	        {
	            "name": "America/Goose_Bay",
	            "rules": [
	                {
	                    "e": 1225594860000,
	                    "s": 1205035260000
	                },
	                {
	                    "e": 1257044460000,
	                    "s": 1236484860000
	                },
	                {
	                    "e": 1289098860000,
	                    "s": 1268539260000
	                },
	                {
	                    "e": 1320555600000,
	                    "s": 1299988860000
	                },
	                {
	                    "e": 1352005200000,
	                    "s": 1331445600000
	                },
	                {
	                    "e": 1383454800000,
	                    "s": 1362895200000
	                },
	                {
	                    "e": 1414904400000,
	                    "s": 1394344800000
	                }
	            ]
	        },
	        {
	            "name": "America/Havana",
	            "rules": [
	                {
	                    "e": 1224997200000,
	                    "s": 1205643600000
	                },
	                {
	                    "e": 1256446800000,
	                    "s": 1236488400000
	                },
	                {
	                    "e": 1288501200000,
	                    "s": 1268542800000
	                },
	                {
	                    "e": 1321160400000,
	                    "s": 1300597200000
	                },
	                {
	                    "e": 1352005200000,
	                    "s": 1333256400000
	                },
	                {
	                    "e": 1383454800000,
	                    "s": 1362891600000
	                },
	                {
	                    "e": 1414904400000,
	                    "s": 1394341200000
	                }
	            ]
	        },
	        {
	            "name": "America/Mazatlan",
	            "rules": [
	                {
	                    "e": 1225008000000,
	                    "s": 1207472400000
	                },
	                {
	                    "e": 1256457600000,
	                    "s": 1238922000000
	                },
	                {
	                    "e": 1288512000000,
	                    "s": 1270371600000
	                },
	                {
	                    "e": 1319961600000,
	                    "s": 1301821200000
	                },
	                {
	                    "e": 1351411200000,
	                    "s": 1333270800000
	                },
	                {
	                    "e": 1382860800000,
	                    "s": 1365325200000
	                },
	                {
	                    "e": 1414310400000,
	                    "s": 1396774800000
	                }
	            ]
	        },
	        {
	            "name": "America/Mexico_City",
	            "rules": [
	                {
	                    "e": 1225004400000,
	                    "s": 1207468800000
	                },
	                {
	                    "e": 1256454000000,
	                    "s": 1238918400000
	                },
	                {
	                    "e": 1288508400000,
	                    "s": 1270368000000
	                },
	                {
	                    "e": 1319958000000,
	                    "s": 1301817600000
	                },
	                {
	                    "e": 1351407600000,
	                    "s": 1333267200000
	                },
	                {
	                    "e": 1382857200000,
	                    "s": 1365321600000
	                },
	                {
	                    "e": 1414306800000,
	                    "s": 1396771200000
	                }
	            ]
	        },
	        {
	            "name": "America/Miquelon",
	            "rules": [
	                {
	                    "e": 1225598400000,
	                    "s": 1205038800000
	                },
	                {
	                    "e": 1257048000000,
	                    "s": 1236488400000
	                },
	                {
	                    "e": 1289102400000,
	                    "s": 1268542800000
	                },
	                {
	                    "e": 1320552000000,
	                    "s": 1299992400000
	                },
	                {
	                    "e": 1352001600000,
	                    "s": 1331442000000
	                },
	                {
	                    "e": 1383451200000,
	                    "s": 1362891600000
	                },
	                {
	                    "e": 1414900800000,
	                    "s": 1394341200000
	                }
	            ]
	        },
	        {
	            "name": "America/Santa_Isabel",
	            "rules": [
	                {
	                    "e": 1225011600000,
	                    "s": 1207476000000
	                },
	                {
	                    "e": 1256461200000,
	                    "s": 1238925600000
	                },
	                {
	                    "e": 1288515600000,
	                    "s": 1270375200000
	                },
	                {
	                    "e": 1319965200000,
	                    "s": 1301824800000
	                },
	                {
	                    "e": 1351414800000,
	                    "s": 1333274400000
	                },
	                {
	                    "e": 1382864400000,
	                    "s": 1365328800000
	                },
	                {
	                    "e": 1414314000000,
	                    "s": 1396778400000
	                }
	            ]
	        },
	        {
	            "name": "America/Santiago",
	            "rules": [
	                {
	                    "e": 1206846000000,
	                    "s": 1223784000000
	                },
	                {
	                    "e": 1237086000000,
	                    "s": 1255233600000
	                },
	                {
	                    "e": 1270350000000,
	                    "s": 1286683200000
	                },
	                {
	                    "e": 1304823600000,
	                    "s": 1313899200000
	                },
	                {
	                    "e": 1335668400000,
	                    "s": 1346558400000
	                },
	                {
	                    "e": 1367118000000,
	                    "s": 1378612800000
	                },
	                {
	                    "e": 1398567600000,
	                    "s": 1410062400000
	                }
	            ]
	        },
	        {
	            "name": "America/Sao_Paulo",
	            "rules": [
	                {
	                    "e": 1203213600000,
	                    "s": 1224385200000
	                },
	                {
	                    "e": 1234663200000,
	                    "s": 1255834800000
	                },
	                {
	                    "e": 1266717600000,
	                    "s": 1287284400000
	                },
	                {
	                    "e": 1298167200000,
	                    "s": 1318734000000
	                },
	                {
	                    "e": 1330221600000,
	                    "s": 1350788400000
	                },
	                {
	                    "e": 1361066400000,
	                    "s": 1382238000000
	                },
	                {
	                    "e": 1392516000000,
	                    "s": 1413687600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Amman",
	            "rules": [
	                {
	                    "e": 1225404000000,
	                    "s": 1206655200000
	                },
	                {
	                    "e": 1256853600000,
	                    "s": 1238104800000
	                },
	                {
	                    "e": 1288303200000,
	                    "s": 1269554400000
	                },
	                {
	                    "e": 1319752800000,
	                    "s": 1301608800000
	                },
	                false,
	                false,
	                {
	                    "e": 1414706400000,
	                    "s": 1395957600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Damascus",
	            "rules": [
	                {
	                    "e": 1225486800000,
	                    "s": 1207260000000
	                },
	                {
	                    "e": 1256850000000,
	                    "s": 1238104800000
	                },
	                {
	                    "e": 1288299600000,
	                    "s": 1270159200000
	                },
	                {
	                    "e": 1319749200000,
	                    "s": 1301608800000
	                },
	                {
	                    "e": 1351198800000,
	                    "s": 1333058400000
	                },
	                {
	                    "e": 1382648400000,
	                    "s": 1364508000000
	                },
	                {
	                    "e": 1414702800000,
	                    "s": 1395957600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Dubai",
	            "rules": [
	                false,
	                false,
	                false,
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Gaza",
	            "rules": [
	                {
	                    "e": 1219957200000,
	                    "s": 1206655200000
	                },
	                {
	                    "e": 1252015200000,
	                    "s": 1238104800000
	                },
	                {
	                    "e": 1281474000000,
	                    "s": 1269640860000
	                },
	                {
	                    "e": 1312146000000,
	                    "s": 1301608860000
	                },
	                {
	                    "e": 1348178400000,
	                    "s": 1333058400000
	                },
	                {
	                    "e": 1380229200000,
	                    "s": 1364508000000
	                },
	                {
	                    "e": 1414098000000,
	                    "s": 1395957600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Irkutsk",
	            "rules": [
	                {
	                    "e": 1224957600000,
	                    "s": 1206813600000
	                },
	                {
	                    "e": 1256407200000,
	                    "s": 1238263200000
	                },
	                {
	                    "e": 1288461600000,
	                    "s": 1269712800000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Jerusalem",
	            "rules": [
	                {
	                    "e": 1223161200000,
	                    "s": 1206662400000
	                },
	                {
	                    "e": 1254006000000,
	                    "s": 1238112000000
	                },
	                {
	                    "e": 1284246000000,
	                    "s": 1269561600000
	                },
	                {
	                    "e": 1317510000000,
	                    "s": 1301616000000
	                },
	                {
	                    "e": 1348354800000,
	                    "s": 1333065600000
	                },
	                {
	                    "e": 1382828400000,
	                    "s": 1364515200000
	                },
	                {
	                    "e": 1414278000000,
	                    "s": 1395964800000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Kamchatka",
	            "rules": [
	                {
	                    "e": 1224943200000,
	                    "s": 1206799200000
	                },
	                {
	                    "e": 1256392800000,
	                    "s": 1238248800000
	                },
	                {
	                    "e": 1288450800000,
	                    "s": 1269698400000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Krasnoyarsk",
	            "rules": [
	                {
	                    "e": 1224961200000,
	                    "s": 1206817200000
	                },
	                {
	                    "e": 1256410800000,
	                    "s": 1238266800000
	                },
	                {
	                    "e": 1288465200000,
	                    "s": 1269716400000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Omsk",
	            "rules": [
	                {
	                    "e": 1224964800000,
	                    "s": 1206820800000
	                },
	                {
	                    "e": 1256414400000,
	                    "s": 1238270400000
	                },
	                {
	                    "e": 1288468800000,
	                    "s": 1269720000000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Vladivostok",
	            "rules": [
	                {
	                    "e": 1224950400000,
	                    "s": 1206806400000
	                },
	                {
	                    "e": 1256400000000,
	                    "s": 1238256000000
	                },
	                {
	                    "e": 1288454400000,
	                    "s": 1269705600000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Yakutsk",
	            "rules": [
	                {
	                    "e": 1224954000000,
	                    "s": 1206810000000
	                },
	                {
	                    "e": 1256403600000,
	                    "s": 1238259600000
	                },
	                {
	                    "e": 1288458000000,
	                    "s": 1269709200000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Yekaterinburg",
	            "rules": [
	                {
	                    "e": 1224968400000,
	                    "s": 1206824400000
	                },
	                {
	                    "e": 1256418000000,
	                    "s": 1238274000000
	                },
	                {
	                    "e": 1288472400000,
	                    "s": 1269723600000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Yerevan",
	            "rules": [
	                {
	                    "e": 1224972000000,
	                    "s": 1206828000000
	                },
	                {
	                    "e": 1256421600000,
	                    "s": 1238277600000
	                },
	                {
	                    "e": 1288476000000,
	                    "s": 1269727200000
	                },
	                {
	                    "e": 1319925600000,
	                    "s": 1301176800000
	                },
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Australia/Lord_Howe",
	            "rules": [
	                {
	                    "e": 1207407600000,
	                    "s": 1223134200000
	                },
	                {
	                    "e": 1238857200000,
	                    "s": 1254583800000
	                },
	                {
	                    "e": 1270306800000,
	                    "s": 1286033400000
	                },
	                {
	                    "e": 1301756400000,
	                    "s": 1317483000000
	                },
	                {
	                    "e": 1333206000000,
	                    "s": 1349537400000
	                },
	                {
	                    "e": 1365260400000,
	                    "s": 1380987000000
	                },
	                {
	                    "e": 1396710000000,
	                    "s": 1412436600000
	                }
	            ]
	        },
	        {
	            "name": "Australia/Perth",
	            "rules": [
	                {
	                    "e": 1206813600000,
	                    "s": 1224957600000
	                },
	                false,
	                false,
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Europe/Helsinki",
	            "rules": [
	                {
	                    "e": 1224982800000,
	                    "s": 1206838800000
	                },
	                {
	                    "e": 1256432400000,
	                    "s": 1238288400000
	                },
	                {
	                    "e": 1288486800000,
	                    "s": 1269738000000
	                },
	                {
	                    "e": 1319936400000,
	                    "s": 1301187600000
	                },
	                {
	                    "e": 1351386000000,
	                    "s": 1332637200000
	                },
	                {
	                    "e": 1382835600000,
	                    "s": 1364691600000
	                },
	                {
	                    "e": 1414285200000,
	                    "s": 1396141200000
	                }
	            ]
	        },
	        {
	            "name": "Europe/Minsk",
	            "rules": [
	                {
	                    "e": 1224979200000,
	                    "s": 1206835200000
	                },
	                {
	                    "e": 1256428800000,
	                    "s": 1238284800000
	                },
	                {
	                    "e": 1288483200000,
	                    "s": 1269734400000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Europe/Moscow",
	            "rules": [
	                {
	                    "e": 1224975600000,
	                    "s": 1206831600000
	                },
	                {
	                    "e": 1256425200000,
	                    "s": 1238281200000
	                },
	                {
	                    "e": 1288479600000,
	                    "s": 1269730800000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Pacific/Apia",
	            "rules": [
	                false,
	                false,
	                false,
	                {
	                    "e": 1301752800000,
	                    "s": 1316872800000
	                },
	                {
	                    "e": 1333202400000,
	                    "s": 1348927200000
	                },
	                {
	                    "e": 1365256800000,
	                    "s": 1380376800000
	                },
	                {
	                    "e": 1396706400000,
	                    "s": 1411826400000
	                }
	            ]
	        },
	        {
	            "name": "Pacific/Fiji",
	            "rules": [
	                false,
	                false,
	                {
	                    "e": 1269698400000,
	                    "s": 1287842400000
	                },
	                {
	                    "e": 1327154400000,
	                    "s": 1319292000000
	                },
	                {
	                    "e": 1358604000000,
	                    "s": 1350741600000
	                },
	                {
	                    "e": 1390050000000,
	                    "s": 1382796000000
	                },
	                {
	                    "e": 1421503200000,
	                    "s": 1414850400000
	                }
	            ]
	        },
	        {
	            "name": "Europe/London",
	            "rules": [
	                {
	                    "e": 1224982800000,
	                    "s": 1206838800000
	                },
	                {
	                    "e": 1256432400000,
	                    "s": 1238288400000
	                },
	                {
	                    "e": 1288486800000,
	                    "s": 1269738000000
	                },
	                {
	                    "e": 1319936400000,
	                    "s": 1301187600000
	                },
	                {
	                    "e": 1351386000000,
	                    "s": 1332637200000
	                },
	                {
	                    "e": 1382835600000,
	                    "s": 1364691600000
	                },
	                {
	                    "e": 1414285200000,
	                    "s": 1396141200000
	                }
	            ]
	        }
	    ]
	};
	if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
	    module.exports = jstz;
	} else if (("function" !== 'undefined' && __webpack_require__(571) !== null) && (__webpack_require__(572) != null)) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return jstz;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
	    if (typeof root === 'undefined') {
	        window.jstz = jstz;
	    } else {
	        root.jstz = jstz;
	    }
	}
	}());


/***/ },
/* 571 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 572 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cookiesJs = __webpack_require__(574);
	
	function isEnabled() {
	  if (typeof document === 'undefined') {
	    // running in server context
	    return false;
	  }
	
	  // In IE, cookies can be enabled by default but disabled for this particular site. So, rather than
	  // checking `window.navigator.cookieEnabled`, we do this instead...
	  return 'cookie' in document && (document.cookie.length > 0 || (document.cookie = 'test').indexOf.call(document.cookie, 'test') >= 0);
	}
	exports.default = {
	  isEnabled: isEnabled,
	  /* eslint-disable object-shorthand */ // Flow complains
	  get: _cookiesJs.get,
	  set: _cookiesJs.set,
	  expire: _cookiesJs.expire
	};

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Cookies.js - 1.2.3
	 * https://github.com/ScottHamper/Cookies
	 *
	 * This is free and unencumbered software released into the public domain.
	 */
	(function (global, undefined) {
	    'use strict';
	
	    var factory = function (window) {
	        if (typeof window.document !== 'object') {
	            throw new Error('Cookies.js requires a `window` with a `document` object');
	        }
	
	        var Cookies = function (key, value, options) {
	            return arguments.length === 1 ?
	                Cookies.get(key) : Cookies.set(key, value, options);
	        };
	
	        // Allows for setter injection in unit tests
	        Cookies._document = window.document;
	
	        // Used to ensure cookie keys do not collide with
	        // built-in `Object` properties
	        Cookies._cacheKeyPrefix = 'cookey.'; // Hurr hurr, :)
	        
	        Cookies._maxExpireDate = new Date('Fri, 31 Dec 9999 23:59:59 UTC');
	
	        Cookies.defaults = {
	            path: '/',
	            secure: false
	        };
	
	        Cookies.get = function (key) {
	            if (Cookies._cachedDocumentCookie !== Cookies._document.cookie) {
	                Cookies._renewCache();
	            }
	            
	            var value = Cookies._cache[Cookies._cacheKeyPrefix + key];
	
	            return value === undefined ? undefined : decodeURIComponent(value);
	        };
	
	        Cookies.set = function (key, value, options) {
	            options = Cookies._getExtendedOptions(options);
	            options.expires = Cookies._getExpiresDate(value === undefined ? -1 : options.expires);
	
	            Cookies._document.cookie = Cookies._generateCookieString(key, value, options);
	
	            return Cookies;
	        };
	
	        Cookies.expire = function (key, options) {
	            return Cookies.set(key, undefined, options);
	        };
	
	        Cookies._getExtendedOptions = function (options) {
	            return {
	                path: options && options.path || Cookies.defaults.path,
	                domain: options && options.domain || Cookies.defaults.domain,
	                expires: options && options.expires || Cookies.defaults.expires,
	                secure: options && options.secure !== undefined ?  options.secure : Cookies.defaults.secure
	            };
	        };
	
	        Cookies._isValidDate = function (date) {
	            return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
	        };
	
	        Cookies._getExpiresDate = function (expires, now) {
	            now = now || new Date();
	
	            if (typeof expires === 'number') {
	                expires = expires === Infinity ?
	                    Cookies._maxExpireDate : new Date(now.getTime() + expires * 1000);
	            } else if (typeof expires === 'string') {
	                expires = new Date(expires);
	            }
	
	            if (expires && !Cookies._isValidDate(expires)) {
	                throw new Error('`expires` parameter cannot be converted to a valid Date instance');
	            }
	
	            return expires;
	        };
	
	        Cookies._generateCookieString = function (key, value, options) {
	            key = key.replace(/[^#$&+\^`|]/g, encodeURIComponent);
	            key = key.replace(/\(/g, '%28').replace(/\)/g, '%29');
	            value = (value + '').replace(/[^!#$&-+\--:<-\[\]-~]/g, encodeURIComponent);
	            options = options || {};
	
	            var cookieString = key + '=' + value;
	            cookieString += options.path ? ';path=' + options.path : '';
	            cookieString += options.domain ? ';domain=' + options.domain : '';
	            cookieString += options.expires ? ';expires=' + options.expires.toUTCString() : '';
	            cookieString += options.secure ? ';secure' : '';
	
	            return cookieString;
	        };
	
	        Cookies._getCacheFromString = function (documentCookie) {
	            var cookieCache = {};
	            var cookiesArray = documentCookie ? documentCookie.split('; ') : [];
	
	            for (var i = 0; i < cookiesArray.length; i++) {
	                var cookieKvp = Cookies._getKeyValuePairFromCookieString(cookiesArray[i]);
	
	                if (cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] === undefined) {
	                    cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] = cookieKvp.value;
	                }
	            }
	
	            return cookieCache;
	        };
	
	        Cookies._getKeyValuePairFromCookieString = function (cookieString) {
	            // "=" is a valid character in a cookie value according to RFC6265, so cannot `split('=')`
	            var separatorIndex = cookieString.indexOf('=');
	
	            // IE omits the "=" when the cookie value is an empty string
	            separatorIndex = separatorIndex < 0 ? cookieString.length : separatorIndex;
	
	            var key = cookieString.substr(0, separatorIndex);
	            var decodedKey;
	            try {
	                decodedKey = decodeURIComponent(key);
	            } catch (e) {
	                if (console && typeof console.error === 'function') {
	                    console.error('Could not decode cookie with key "' + key + '"', e);
	                }
	            }
	            
	            return {
	                key: decodedKey,
	                value: cookieString.substr(separatorIndex + 1) // Defer decoding value until accessed
	            };
	        };
	
	        Cookies._renewCache = function () {
	            Cookies._cache = Cookies._getCacheFromString(Cookies._document.cookie);
	            Cookies._cachedDocumentCookie = Cookies._document.cookie;
	        };
	
	        Cookies._areEnabled = function () {
	            var testKey = 'cookies.js';
	            var areEnabled = Cookies.set(testKey, 1).get(testKey) === '1';
	            Cookies.expire(testKey);
	            return areEnabled;
	        };
	
	        Cookies.enabled = Cookies._areEnabled();
	
	        return Cookies;
	    };
	    var cookiesExport = (global && typeof global.document === 'object') ? factory(global) : factory;
	
	    // AMD support
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return cookiesExport; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    // CommonJS/Node.js support
	    } else if (typeof exports === 'object') {
	        // Support Node.js specific `module.exports` (which can be a function)
	        if (typeof module === 'object' && typeof module.exports === 'object') {
	            exports = module.exports = cookiesExport;
	        }
	        // But always support CommonJS module 1.1.1 spec (`exports` cannot be a function)
	        exports.Cookies = cookiesExport;
	    } else {
	        global.Cookies = cookiesExport;
	    }
	})(typeof window === 'undefined' ? this : window);

/***/ },
/* 575 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerInterceptor = registerInterceptor;
	exports.unregisterInterceptor = unregisterInterceptor;
	
	
	var registeredInterceptors = new Map();
	
	function registerInterceptor(name, interceptor) {
	  if (registeredInterceptors.has(name)) {
	    throw new Error('interceptor name already registered', name);
	  }
	  registeredInterceptors.set(name, interceptor);
	}
	
	function unregisterInterceptor(name) {
	  registeredInterceptors.delete(name);
	}
	
	var checkInterception = exports.checkInterception = function checkInterception(response) {
	  var interceptors = Array.from(registeredInterceptors.values());
	  return interceptors.some(function (interceptor) {
	    return interceptor(response);
	  });
	};

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	var _FeatureStore = __webpack_require__(588);
	
	var _FeatureStore2 = _interopRequireDefault(_FeatureStore);
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _QuickPromotion = __webpack_require__(1042);
	
	var _QuickPromotion2 = _interopRequireDefault(_QuickPromotion);
	
	var _QuickPromotionConstants = __webpack_require__(1043);
	
	var _AuthConstants = __webpack_require__(1034);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _ChatSettingsConstants = __webpack_require__(923);
	
	var _SetupConstants = __webpack_require__(1046);
	
	var _PusherConstants = __webpack_require__(954);
	
	var _UserConstants = __webpack_require__(1015);
	
	var _Experimentation = __webpack_require__(1047);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = function (_Store) {
	  _inherits(CurrentUser, _Store);
	
	  function CurrentUser() {
	    _classCallCheck(this, CurrentUser);
	
	    return _possibleConstructorReturn(this, (CurrentUser.__proto__ || Object.getPrototypeOf(CurrentUser)).apply(this, arguments));
	  }
	
	  _createClass(CurrentUser, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        user: null,
	        token: null,
	        setupJoinedClassThisSession: false };
	    }
	  }, {
	    key: 'addSignInListener',
	    value: function addSignInListener(callback) {
	      this.on('sign-in', callback);
	    }
	  }, {
	    key: 'removeSignInListener',
	    value: function removeSignInListener(callback) {
	      this.removeListener('sign-in', callback);
	    }
	  }, {
	    key: 'addSignInNoRoleListener',
	    value: function addSignInNoRoleListener(callback) {
	      this.on('sign-in-no-role', callback);
	    }
	  }, {
	    key: 'removeSignInNoRoleListener',
	    value: function removeSignInNoRoleListener(callback) {
	      this.removeListener('sign-in-no-role', callback);
	    }
	  }, {
	    key: 'hasEmail',
	    value: function hasEmail() {
	      return this.state.user && this.state.user.hasEmail();
	    }
	  }, {
	    key: 'getUser',
	    value: function getUser() {
	      (0, _invariant2.default)(this.isSignedIn(), 'getUser() when not signed in');
	
	      return this.state.user;
	    }
	  }, {
	    key: 'getCreatedAt',
	    value: function getCreatedAt() {
	      return this.state.user ? this.state.user.getCreatedAt() : null;
	    }
	  }, {
	    key: 'getUserUuid',
	    value: function getUserUuid() {
	      var user = this.getUser();
	      (0, _invariant2.default)(typeof user.getUuid() === 'string', 'getUserUuId() when user object missing uuid');
	      return user.getUuid();
	    }
	  }, {
	    key: 'getUserId',
	    value: function getUserId() {
	      var user = this.getUser();
	      (0, _invariant2.default)(typeof user.id === 'number', 'getUserId() when user object missing id');
	      return user.id;
	    }
	  }, {
	    key: 'getToken',
	    value: function getToken() {
	      return this.state.token;
	    }
	  }, {
	    key: 'isSignedIn',
	    value: function isSignedIn() {
	      return !!this.state.user;
	    }
	  }, {
	    key: 'getQuickPromotionsForTrigger',
	    value: function getQuickPromotionsForTrigger(trigger) {
	      var user = this.state.user;
	
	      if (user) {
	        return user.getQuickPromotions().where({ trigger: trigger });
	      } else {
	        return [];
	      }
	    }
	  }, {
	    key: 'handleUserLoad',
	    value: function handleUserLoad(user) {
	      this.waitFor([_FeatureStore2.default]);
	      this.state.user = user;
	      _EventTracking2.default.setUserInfo(this.getUserId(), this.getUser().getUuid());
	    }
	
	    /**
	     * If checkVariant is omitted, check for a default variant named the same as
	     * the web key, but lower case.
	     */
	
	  }, {
	    key: 'inExpVariant',
	    value: function inExpVariant(webKey, checkVariant) {
	      if (this.isSignedIn()) {
	        return (0, _Experimentation.userInExperimentVariant)(this.getUser(), webKey, checkVariant);
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'didSetupAndJoinClassThisSession',
	    value: function didSetupAndJoinClassThisSession() {
	      return this.state.setupJoinedClassThisSession;
	    }
	  }, {
	    key: 'emitSigninEvent',
	    value: function emitSigninEvent() {
	      var _this2 = this;
	
	      var emitEvent = function emitEvent(name) {
	        setTimeout(function () {
	          return _this2.emit(name);
	        }, 0);
	      };
	
	      switch (this.state.user.getRole()) {
	        case _UserConstants.Roles.parent:
	        case _UserConstants.Roles.teacher:
	        case _UserConstants.Roles.student:
	          emitEvent('sign-in');
	          break;
	        default:
	          emitEvent('sign-in-no-role');
	      }
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      switch (action.type) {
	        case _AuthConstants.ActionTypes.TOKEN_ENTRY:
	          (0, _invariant2.default)(action.token, 'missing action.token');
	          this.state.token = action.token;
	          this.emitChange();
	          break;
	        case _AuthConstants.ActionTypes.AUTH_SUCCESS:
	          (0, _invariant2.default)(action.user, 'missing action.user');
	          this.handleUserLoad(action.user);
	          this.emitSigninEvent();
	          this.emitChange();
	          break;
	        case _UserConstants.ActionTypes.LOAD_USER:
	          (0, _invariant2.default)(action.user, 'missing action.user');
	          this.handleUserLoad(action.user);
	          this.emitChange();
	          break;
	        case _PusherConstants.PushEvents.USER:
	          (0, _invariant2.default)(action.eventData && action.model, 'missing action.eventData');
	          (0, _invariant2.default)(_typeof(action.eventData) === 'object', 'invalid action.eventData');
	          if (action.eventData.action === 'update') {
	            this.state.user = action.model;
	            this.emitChange();
	          }
	          break;
	        case _UserConstants.ActionTypes.USER_DELETED:
	          /*
	            This case will not call 'this.emitChange()' in order to prevent the
	            view from updating with a null (deleted) user. After account deletion,
	            The user should be redirected to the sign out page, which does not
	            require user information.
	          */
	          this.state.user = null;
	          break;
	        case _UserConstants.ActionTypes.USER_UPDATED:
	          if (this.state.user && action.user && this.state.user.id === action.user.id) {
	            this.state.user = action.user;
	            this.emitChange();
	          }
	          break;
	        case _UserConstants.ActionTypes.PREFERENCES_UPDATED:
	          (0, _invariant2.default)(action.preferences, 'missing action.preferences');
	          this.state.user.setPreferences(action.preferences);
	          this.emitChange();
	          break;
	        case _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_LOADED:
	        case _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_ENABLED:
	        case _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_DISABLED:
	        case _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_UPDATED:
	          (0, _invariant2.default)(action.hours, 'missing action.hours');
	          this.state.user.setOfficeHours(action.hours);
	          this.emitChange();
	          break;
	        // Gets called after a prompts inventory prompt is dismissed
	        // Prompts inventory prompts are stored in the User object
	        case _PromptConstants.ActionTypes.USER_PROMPT_DISMISSED:
	          this.emitChange();
	          break;
	        case _PusherConstants.PushEvents.CHANGESET_UPDATE_USER:
	          _UserActions2.default.loadCurrentUser();
	          break;
	        case _QuickPromotionConstants.ActionTypes.PROMOTION_DISMISSED:
	          (0, _invariant2.default)(action.promotion, 'missing action.promotion');
	          this.state.user.removeQuickPromotion(action.promotion);
	          this.emitChange();
	          break;
	        case _SetupConstants.ActionTypes.JOIN_CLASS_FOR_SETUP_SESSION:
	          this.state.setupJoinedClassThisSession = true;
	          break;
	        case _SetupConstants.ActionTypes.REMOVE_FLAGS_FOR_SETUP_SESSION:
	          this.state.setupJoinedClassThisSession = false;
	          break;
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return CurrentUser;
	}(_Store3.default);
	
	CurrentUser.displayName = 'CurrentUser';
	exports.default = new CurrentUser();

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getEventProperties = exports.getEventContextName = exports.getEventElementName = exports.getEventScreenName = exports.EventTracking = exports.ref = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _xhr = __webpack_require__(562);
	
	var _xhr2 = _interopRequireDefault(_xhr);
	
	var _Config = __webpack_require__(551);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _retry = __webpack_require__(578);
	
	var _retry2 = _interopRequireDefault(_retry);
	
	var _fastSafeStringify = __webpack_require__(581);
	
	var _fastSafeStringify2 = _interopRequireDefault(_fastSafeStringify);
	
	var _Cookies = __webpack_require__(573);
	
	var _Cookies2 = _interopRequireDefault(_Cookies);
	
	var _uuid = __webpack_require__(582);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ENABLED = _Config2.default.Environment.R101_EVENTS_ENABLED;
	var INTERVAL = _Config2.default.Environment.R101_EVENTS_INTERVAL;
	var URL = _Config2.default.Environment.R101_EVENTS_URL;
	
	function decamelizeProperties(properties) {
	  var props = {};
	  for (var key in properties) {
	    props[key.replace(/([a-z\d])([A-Z])/g, '$1_$2').toLowerCase()] = properties[key];
	  }
	  return props;
	}
	
	var windowDefined = typeof window !== 'undefined';
	
	var ref = exports.ref = { xhr: _xhr2.default }; // tests :(
	
	function dispatchBuffer(events, properties, onError) {
	  var data = (0, _fastSafeStringify2.default)({
	    batch: events,
	    properties: properties
	  });
	
	  var operation = _retry2.default.operation({
	    retries: 5,
	    factor: 2, // exponential rollback
	    minTimeout: 500,
	    maxTimeout: 1000 * 60
	  });
	
	  operation.attempt(function () {
	    ref.xhr({
	      url: URL + '/v1/import',
	      method: 'POST',
	      useXDR: true,
	      data: data
	    }, function (err, res) {
	      if (!res || res.statusCode >= 500) {
	        var outOfRetries = !operation.retry(err);
	        if (outOfRetries && err) {
	          onError(events);
	          console.warn('eventTracking failed to flush', operation.mainError(), res);
	        }
	      }
	    });
	  });
	
	  // XXX (rgoldfinger) temporary while trying to find a circular reference
	  var tempData = {
	    batch: events,
	    properties: properties
	  };
	  try {
	    JSON.stringify(tempData);
	  } catch (e) {
	    console.error('Failed to serialize event data: ', (0, _fastSafeStringify2.default)(tempData));
	    throw new Error(e);
	  }
	}
	
	var EventTracking = exports.EventTracking = function () {
	  function EventTracking(doPush) {
	    _classCallCheck(this, EventTracking);
	
	    this.doPush = doPush;
	    this.buffer = [];
	    this.timeout = null;
	    this.userId = null;
	    this.userUuid = null;
	    if (doPush && windowDefined) {
	      window.addEventListener('unload', this.flushBuffer.bind(this), false);
	    }
	  }
	
	  _createClass(EventTracking, [{
	    key: 'setUserInfo',
	    value: function setUserInfo(userId, userUuid) {
	      this.userId = userId;
	      this.userUuid = userUuid;
	    }
	  }, {
	    key: 'getProperties',
	    value: function getProperties() {
	      if (!windowDefined) {
	        // TODO handle this more smartly in SSR
	        return {};
	      }
	
	      return {
	        client_type: 'Web',
	        client_uuid: this.getClientId(),
	        foreign_service: 'r101-web-client',
	        request_url: window.location.href,
	        screen_width: window.screen.width,
	        screen_height: window.screen.height,
	        session_uuid: this.getSessionId()
	      };
	    }
	
	    /**
	     * SessionId uniquely identifies a session. A session is
	     * begins when a user hits remind.com, and terminates when
	     * the broswer closes or the user logs out.
	     */
	
	  }, {
	    key: 'getSessionId',
	    value: function getSessionId() {
	      var sessionId = _Cookies2.default.get('session_uuid');
	      if (!sessionId) {
	        _Cookies2.default.set('session_uuid', sessionId = (0, _uuid2.default)());
	      }
	      return sessionId;
	    }
	  }, {
	    key: 'getClientId',
	    value: function getClientId() {
	      var clientId = _Cookies2.default.get('client_uuid');
	      if (!clientId) {
	        _Cookies2.default.set('client_uuid', clientId = (0, _uuid2.default)());
	      }
	      return clientId;
	    }
	  }, {
	    key: 'track',
	    value: function track(name) {
	      var _this = this;
	
	      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      properties['user_id'] = this.userId;
	      properties['user_uuid'] = this.userUuid;
	
	      if (!this.doPush) {
	        if (false) {
	          console.debug('track', name, properties);
	        }
	        return;
	      }
	
	      this.buffer.push({
	        event: name,
	        properties: properties,
	        timestamp: new Date().toISOString()
	      });
	
	      if (this.timeout === null) {
	        this.timeout = setTimeout(function () {
	          _this.flushBuffer();
	          _this.timeout = null;
	        }, INTERVAL);
	      }
	    }
	
	    // FIXME contextName should be string but bad args are coming in
	
	  }, {
	    key: 'tap',
	    value: function tap(screenName, elementName) {
	      var contextName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	      var properties = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	      this.track('ui.tapped', Object.assign({
	        screen_name: screenName,
	        ui_element_name: elementName,
	        ui_context: contextName
	      }, decamelizeProperties(properties)));
	    }
	  }, {
	    key: 'view',
	    value: function view(screenName) {
	      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (screenName) {
	        this.track('ui.viewed', Object.assign({
	          screen_name: screenName
	        }, decamelizeProperties(properties)));
	      }
	    }
	  }, {
	    key: 'experimentExposure',
	    value: function experimentExposure(experiment, variant) {
	      var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      this.track('experiment.exposure', Object.assign({
	        experiment: experiment,
	        alternative: variant
	      }, decamelizeProperties(properties)));
	    }
	  }, {
	    key: 'flushBuffer',
	    value: function flushBuffer() {
	      var _this2 = this;
	
	      if (this.buffer.length === 0) {
	        return;
	      }
	
	      var onError = function onError(unsentEvents) {
	        _this2.buffer = _this2.buffer.concat(unsentEvents);
	      };
	
	      // shallow copy so that events added to the buffer during dispatch aren't sent twice
	      var bufferCopy = [].concat(_toConsumableArray(this.buffer));
	      this.buffer = [];
	      try {
	        dispatchBuffer(bufferCopy, this.getProperties(), onError);
	      } catch (err) {
	        onError(bufferCopy);
	        console.error('Failed to flushBuffer', err);
	        // XXX (rgoldfinger) temporary to debug circular structures in events
	        throw new Error(err);
	      }
	    }
	  }]);
	
	  return EventTracking;
	}();
	
	EventTracking.displayName = 'EventTracking';
	exports.default = new EventTracking(ENABLED === 'true');
	
	
	var stripHOCNames = function stripHOCNames(name) {
	  var thingsToRemove = ['Apollo', 'FluxContainer', 'Connect', 'WaitForPromises', 'TrackView', /[()-]/g];
	  return thingsToRemove.reduce(function (res, thing) {
	    return res.replace(thing, '');
	  }, name);
	};
	
	var getEventScreenName = exports.getEventScreenName = function getEventScreenName(props, router) {
	  if (props && props.screenName) {
	    return props.screenName;
	  }
	  if (router) {
	    var innermostRouteHandlerName = router.routes.reduce(function (prevName, route) {
	      if (route.component) {
	        var _route$component = route.component,
	            name = _route$component.name,
	            displayName = _route$component.displayName;
	
	        return displayName || name || prevName;
	      } else {
	        return prevName;
	      }
	    }, '');
	
	    if (innermostRouteHandlerName) {
	      return stripHOCNames(innermostRouteHandlerName);
	    }
	  }
	  return null;
	};
	
	var getEventElementName = exports.getEventElementName = function getEventElementName(props) {
	  return props.eventElementName || null;
	};
	
	var getEventContextName = exports.getEventContextName = function getEventContextName(props, context) {
	  if (props.eventContextName) {
	    return props.eventContextName;
	  }
	
	  if (context.eventContextName) {
	    return context.eventContextName;
	  }
	
	  return null;
	};
	
	var getEventProperties = exports.getEventProperties = function getEventProperties(eventProperties, context) {
	  return Object.assign(context.eventProperties || {}, eventProperties || {});
	};

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(579);

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	var RetryOperation = __webpack_require__(580);
	
	exports.operation = function(options) {
	  var timeouts = exports.timeouts(options);
	  return new RetryOperation(timeouts, {
	      forever: options && options.forever,
	      unref: options && options.unref
	  });
	};
	
	exports.timeouts = function(options) {
	  if (options instanceof Array) {
	    return [].concat(options);
	  }
	
	  var opts = {
	    retries: 10,
	    factor: 2,
	    minTimeout: 1 * 1000,
	    maxTimeout: Infinity,
	    randomize: false
	  };
	  for (var key in options) {
	    opts[key] = options[key];
	  }
	
	  if (opts.minTimeout > opts.maxTimeout) {
	    throw new Error('minTimeout is greater than maxTimeout');
	  }
	
	  var timeouts = [];
	  for (var i = 0; i < opts.retries; i++) {
	    timeouts.push(this.createTimeout(i, opts));
	  }
	
	  if (options && options.forever && !timeouts.length) {
	    timeouts.push(this.createTimeout(i, opts));
	  }
	
	  // sort the array numerically ascending
	  timeouts.sort(function(a,b) {
	    return a - b;
	  });
	
	  return timeouts;
	};
	
	exports.createTimeout = function(attempt, opts) {
	  var random = (opts.randomize)
	    ? (Math.random() + 1)
	    : 1;
	
	  var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
	  timeout = Math.min(timeout, opts.maxTimeout);
	
	  return timeout;
	};
	
	exports.wrap = function(obj, options, methods) {
	  if (options instanceof Array) {
	    methods = options;
	    options = null;
	  }
	
	  if (!methods) {
	    methods = [];
	    for (var key in obj) {
	      if (typeof obj[key] === 'function') {
	        methods.push(key);
	      }
	    }
	  }
	
	  for (var i = 0; i < methods.length; i++) {
	    var method   = methods[i];
	    var original = obj[method];
	
	    obj[method] = function retryWrapper() {
	      var op       = exports.operation(options);
	      var args     = Array.prototype.slice.call(arguments);
	      var callback = args.pop();
	
	      args.push(function(err) {
	        if (op.retry(err)) {
	          return;
	        }
	        if (err) {
	          arguments[0] = op.mainError();
	        }
	        callback.apply(this, arguments);
	      });
	
	      op.attempt(function() {
	        original.apply(obj, args);
	      });
	    };
	    obj[method].options = options;
	  }
	};


/***/ },
/* 580 */
/***/ function(module, exports) {

	function RetryOperation(timeouts, options) {
	  // Compatibility for the old (timeouts, retryForever) signature
	  if (typeof options === 'boolean') {
	    options = { forever: options };
	  }
	
	  this._timeouts = timeouts;
	  this._options = options || {};
	  this._fn = null;
	  this._errors = [];
	  this._attempts = 1;
	  this._operationTimeout = null;
	  this._operationTimeoutCb = null;
	  this._timeout = null;
	
	  if (this._options.forever) {
	    this._cachedTimeouts = this._timeouts.slice(0);
	  }
	}
	module.exports = RetryOperation;
	
	RetryOperation.prototype.stop = function() {
	  if (this._timeout) {
	    clearTimeout(this._timeout);
	  }
	
	  this._timeouts       = [];
	  this._cachedTimeouts = null;
	};
	
	RetryOperation.prototype.retry = function(err) {
	  if (this._timeout) {
	    clearTimeout(this._timeout);
	  }
	
	  if (!err) {
	    return false;
	  }
	
	  this._errors.push(err);
	
	  var timeout = this._timeouts.shift();
	  if (timeout === undefined) {
	    if (this._cachedTimeouts) {
	      // retry forever, only keep last error
	      this._errors.splice(this._errors.length - 1, this._errors.length);
	      this._timeouts = this._cachedTimeouts.slice(0);
	      timeout = this._timeouts.shift();
	    } else {
	      return false;
	    }
	  }
	
	  var self = this;
	  var timer = setTimeout(function() {
	    self._attempts++;
	
	    if (self._operationTimeoutCb) {
	      self._timeout = setTimeout(function() {
	        self._operationTimeoutCb(self._attempts);
	      }, self._operationTimeout);
	
	      if (this._options.unref) {
	          self._timeout.unref();
	      }
	    }
	
	    self._fn(self._attempts);
	  }, timeout);
	
	  if (this._options.unref) {
	      timer.unref();
	  }
	
	  return true;
	};
	
	RetryOperation.prototype.attempt = function(fn, timeoutOps) {
	  this._fn = fn;
	
	  if (timeoutOps) {
	    if (timeoutOps.timeout) {
	      this._operationTimeout = timeoutOps.timeout;
	    }
	    if (timeoutOps.cb) {
	      this._operationTimeoutCb = timeoutOps.cb;
	    }
	  }
	
	  var self = this;
	  if (this._operationTimeoutCb) {
	    this._timeout = setTimeout(function() {
	      self._operationTimeoutCb();
	    }, self._operationTimeout);
	  }
	
	  this._fn(this._attempts);
	};
	
	RetryOperation.prototype.try = function(fn) {
	  console.log('Using RetryOperation.try() is deprecated');
	  this.attempt(fn);
	};
	
	RetryOperation.prototype.start = function(fn) {
	  console.log('Using RetryOperation.start() is deprecated');
	  this.attempt(fn);
	};
	
	RetryOperation.prototype.start = RetryOperation.prototype.try;
	
	RetryOperation.prototype.errors = function() {
	  return this._errors;
	};
	
	RetryOperation.prototype.attempts = function() {
	  return this._attempts;
	};
	
	RetryOperation.prototype.mainError = function() {
	  if (this._errors.length === 0) {
	    return null;
	  }
	
	  var counts = {};
	  var mainError = null;
	  var mainErrorCount = 0;
	
	  for (var i = 0; i < this._errors.length; i++) {
	    var error = this._errors[i];
	    var message = error.message;
	    var count = (counts[message] || 0) + 1;
	
	    counts[message] = count;
	
	    if (count >= mainErrorCount) {
	      mainError = error;
	      mainErrorCount = count;
	    }
	  }
	
	  return mainError;
	};


/***/ },
/* 581 */
/***/ function(module, exports) {

	module.exports = stringify
	
	function stringify (obj) {
	  decirc(obj, '', [], null)
	  return JSON.stringify(obj)
	}
	function Circle (val, k, parent) {
	  this.val = val
	  this.k = k
	  this.parent = parent
	  this.count = 1
	}
	Circle.prototype.toJSON = function toJSON () {
	  if (--this.count === 0) {
	    this.parent[this.k] = this.val
	  }
	  return '[Circular]'
	}
	function decirc (val, k, stack, parent) {
	  var keys, len, i
	  if (typeof val !== 'object' || val === null) {
	    // not an object, nothing to do
	    return
	  } else if (val instanceof Circle) {
	    val.count++
	    return
	  } else if (parent) {
	    if (~stack.indexOf(val)) {
	      parent[k] = new Circle(val, k, parent)
	      return
	    }
	  }
	  stack.push(val)
	  keys = Object.keys(val)
	  len = keys.length
	  i = 0
	  for (; i < len; i++) {
	    k = keys[i]
	    decirc(val[k], k, stack, val)
	  }
	  stack.pop()
	}


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _uuid = __webpack_require__(583);
	
	// TODO get rid of this unproductive abstraction
	exports.default = _uuid.v4;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(584);
	var v4 = __webpack_require__(587);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	// Unique ID creation requires a high quality random # generator.  We feature
	// detect to determine the best RNG source, normalizing to a function that
	// returns 128-bits of randomness, since that's what's usually required
	var rng = __webpack_require__(585);
	var bytesToUuid = __webpack_require__(586);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	// random #'s we need to init node and clockseq
	var _seedBytes = rng();
	
	// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	var _nodeId = [
	  _seedBytes[0] | 0x01,
	  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
	];
	
	// Per 4.2.2, randomize (14 bit) clockseq
	var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
	// Previous uuid creation time
	var _lastMSecs = 0, _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  var node = options.node || _nodeId;
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ },
/* 585 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	var rng;
	
	var crypto = global.crypto || global.msCrypto; // for IE 11
	if (crypto && crypto.getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16);
	  rng = function whatwgRNG() {
	    crypto.getRandomValues(rnds8);
	    return rnds8;
	  };
	}
	
	if (!rng) {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var  rnds = new Array(16);
	  rng = function() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}
	
	module.exports = rng;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 586 */
/***/ function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  return  bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	module.exports = bytesToUuid;


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(585);
	var bytesToUuid = __webpack_require__(586);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options == 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _UserConstants = __webpack_require__(1015);
	
	var _AuthConstants = __webpack_require__(1034);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeatureStore = function (_Store) {
	  _inherits(FeatureStore, _Store);
	
	  function FeatureStore() {
	    _classCallCheck(this, FeatureStore);
	
	    return _possibleConstructorReturn(this, (FeatureStore.__proto__ || Object.getPrototypeOf(FeatureStore)).apply(this, arguments));
	  }
	
	  _createClass(FeatureStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        features: {}
	      };
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      switch (action.type) {
	        case _AuthConstants.ActionTypes.AUTH_SUCCESS:
	        case _UserConstants.ActionTypes.LOAD_USER:
	          {
	            var user = action.user;
	            (0, _lodash.assign)(this.state.features, user.getFeatures());
	            this.emitChange();
	            break;
	          }
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'hasFeature',
	    value: function hasFeature(feature) {
	      return !!this.state.features[feature];
	    }
	  }]);
	
	  return FeatureStore;
	}(_Store3.default);
	
	FeatureStore.displayName = 'FeatureStore';
	exports.default = new FeatureStore();

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Dispatcher = __webpack_require__(590);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	var _events = __webpack_require__(1036);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _fbemitter = __webpack_require__(963);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// $FlowIssue
	_events2.default.defaultMaxListeners = Number.MAX_VALUE;
	
	var Store = function (_EventEmitter) {
	  _inherits(Store, _EventEmitter);
	
	  function Store() {
	    _classCallCheck(this, Store);
	
	    var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this));
	
	    _this.__changeEvent = 'change';
	    _this.__fbemitter = new _fbemitter.EventEmitter();
	    _this.__dispatcher = _Dispatcher.dispatcher;
	
	    _this._dispatchToken = _Dispatcher.dispatcher.register(_this.getDispatchHandler());
	    _this.state = _this.getInitialState();
	
	    if (false) {
	      window.stores = window.stores || {};
	      window.stores[_this.constructor.name] = _this;
	    }
	    return _this;
	  }
	
	  _createClass(Store, [{
	    key: 'setState',
	    value: function setState(state) {
	      this.state = state;
	      this.emitChange();
	    }
	  }, {
	    key: 'resetState',
	    value: function resetState() {
	      this.setState(this.getInitialState());
	    }
	  }, {
	    key: 'getDispatchHandler',
	    value: function getDispatchHandler() {
	      return this.handleDispatch.bind(this);
	    }
	
	    /* This should be overridden in subclasses */
	
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(_action) {
	      return undefined;
	    }
	
	    /* This should be overridden in subclasses */
	
	  }, {
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {};
	    }
	  }, {
	    key: 'emitChange',
	    value: function emitChange() {
	      this.emit(this.__changeEvent);
	      this.__fbemitter.emit(this.__changeEvent);
	    }
	
	    /**
	     * @deprecated older Node-style event emitter
	     * @param {Function} callback [description]
	     */
	
	  }, {
	    key: 'addChangeListener',
	    value: function addChangeListener(callback) {
	      this.on(this.__changeEvent, callback);
	    }
	  }, {
	    key: 'waitFor',
	    value: function waitFor(stores) {
	      return this.__dispatcher.waitFor(stores.map(function (store) {
	        return store._dispatchToken;
	      }));
	    }
	
	    //
	    // interfaces for FluxUtils
	    //
	
	    /**
	     * @public
	     * @param {function} callback
	     * @return {object} EmitterSubscription that can be used with
	     *   SubscriptionsHandler or directly used to release the subscription.
	     */
	    // XXX this signature doesn't match EventEmitter parent
	    // $FlowFixMe https://github.com/remind101/r101-frontend/pull/4065
	
	  }, {
	    key: 'addListener',
	    value: function addListener(callback) {
	      return this.__fbemitter.addListener(this.__changeEvent, callback);
	    }
	
	    /**
	     * @public
	     * @return {Dispatcher} The dispatcher that this store is registered with.
	     */
	
	  }, {
	    key: 'getDispatcher',
	    value: function getDispatcher() {
	      return this.__dispatcher;
	    }
	
	    /**
	     * @public
	     * @return {string} A string the dispatcher uses to identify each store's
	     *   registered callback. This is used with the dispatcher's waitFor method
	     *   to declaratively depend on other stores updating themselves first.
	     */
	
	  }, {
	    key: 'getDispatchToken',
	    value: function getDispatchToken() {
	      return this._dispatchToken;
	    }
	  }]);
	
	  return Store;
	}(_events2.default);
	
	Store.displayName = 'Store';
	exports.default = Store;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reduxDispatcher = exports.dispatcher = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _flux = __webpack_require__(591);
	
	var _flux2 = _interopRequireDefault(_flux);
	
	var _PusherEventParser = __webpack_require__(594);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dispatcher = function (_Flux$Dispatcher) {
	  _inherits(Dispatcher, _Flux$Dispatcher);
	
	  function Dispatcher() {
	    _classCallCheck(this, Dispatcher);
	
	    return _possibleConstructorReturn(this, (Dispatcher.__proto__ || Object.getPrototypeOf(Dispatcher)).apply(this, arguments));
	  }
	
	  _createClass(Dispatcher, [{
	    key: 'handlePusherEvent',
	    value: function handlePusherEvent(pusherEvent) {
	      var _this2 = this;
	
	      if (false) {
	        console.log('Pusher Event', pusherEvent);
	      }
	
	      var actions = (0, _PusherEventParser.getActions)(pusherEvent);
	      actions.forEach(function (action) {
	        return _this2.dispatch(action);
	      });
	    }
	  }]);
	
	  return Dispatcher;
	}(_flux2.default.Dispatcher);
	
	/* This is a class helping use transition
	 * from Flux to Redux, you should never use this class
	 * from within a React Component (use react-redux connect HOC)
	 * This class is only usefull if you want to dispatch redux action
	 * from flux actions.
	 *
	 * For example if you have a redux store that need to listen to CurrentUser
	 * store. Because CurrentUser is a Flux store it doesn't emit redux action.
	 * You could use this class to dispatch redux actions from withing the flux action.
	 */
	
	
	Dispatcher.displayName = 'Dispatcher';
	
	var ReduxDispatcher = function () {
	  function ReduxDispatcher() {
	    _classCallCheck(this, ReduxDispatcher);
	
	    this.dispatch = function () {
	      if (true) {
	        console.error('Redux dispatcher called before being set');
	      }
	    };
	  }
	
	  _createClass(ReduxDispatcher, [{
	    key: 'setDispatch',
	    value: function setDispatch(dispatch) {
	      this.dispatch = dispatch;
	    }
	  }]);
	
	  return ReduxDispatcher;
	}();
	
	// We have a single dispatcher because our app is pretty small. This is in the
	// Dispatcher module as a convenient refactoring from a module export.
	
	
	ReduxDispatcher.displayName = 'ReduxDispatcher';
	var dispatcher = exports.dispatcher = new Dispatcher();
	var reduxDispatcher = exports.reduxDispatcher = new ReduxDispatcher();
	exports.default = Dispatcher;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	module.exports.Dispatcher = __webpack_require__(592);


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Dispatcher
	 * 
	 * @preventMunge
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(593);
	
	var _prefix = 'ID_';
	
	/**
	 * Dispatcher is used to broadcast payloads to registered callbacks. This is
	 * different from generic pub-sub systems in two ways:
	 *
	 *   1) Callbacks are not subscribed to particular events. Every payload is
	 *      dispatched to every registered callback.
	 *   2) Callbacks can be deferred in whole or part until other callbacks have
	 *      been executed.
	 *
	 * For example, consider this hypothetical flight destination form, which
	 * selects a default city when a country is selected:
	 *
	 *   var flightDispatcher = new Dispatcher();
	 *
	 *   // Keeps track of which country is selected
	 *   var CountryStore = {country: null};
	 *
	 *   // Keeps track of which city is selected
	 *   var CityStore = {city: null};
	 *
	 *   // Keeps track of the base flight price of the selected city
	 *   var FlightPriceStore = {price: null}
	 *
	 * When a user changes the selected city, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'city-update',
	 *     selectedCity: 'paris'
	 *   });
	 *
	 * This payload is digested by `CityStore`:
	 *
	 *   flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'city-update') {
	 *       CityStore.city = payload.selectedCity;
	 *     }
	 *   });
	 *
	 * When the user selects a country, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'country-update',
	 *     selectedCountry: 'australia'
	 *   });
	 *
	 * This payload is digested by both stores:
	 *
	 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       CountryStore.country = payload.selectedCountry;
	 *     }
	 *   });
	 *
	 * When the callback to update `CountryStore` is registered, we save a reference
	 * to the returned token. Using this token with `waitFor()`, we can guarantee
	 * that `CountryStore` is updated before the callback that updates `CityStore`
	 * needs to query its data.
	 *
	 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       // `CountryStore.country` may not be updated.
	 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
	 *       // `CountryStore.country` is now guaranteed to be updated.
	 *
	 *       // Select the default city for the new country
	 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
	 *     }
	 *   });
	 *
	 * The usage of `waitFor()` can be chained, for example:
	 *
	 *   FlightPriceStore.dispatchToken =
	 *     flightDispatcher.register(function(payload) {
	 *       switch (payload.actionType) {
	 *         case 'country-update':
	 *         case 'city-update':
	 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
	 *           FlightPriceStore.price =
	 *             getFlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *     }
	 *   });
	 *
	 * The `country-update` payload will be guaranteed to invoke the stores'
	 * registered callbacks in order: `CountryStore`, `CityStore`, then
	 * `FlightPriceStore`.
	 */
	
	var Dispatcher = (function () {
	  function Dispatcher() {
	    _classCallCheck(this, Dispatcher);
	
	    this._callbacks = {};
	    this._isDispatching = false;
	    this._isHandled = {};
	    this._isPending = {};
	    this._lastID = 1;
	  }
	
	  /**
	   * Registers a callback to be invoked with every dispatched payload. Returns
	   * a token that can be used with `waitFor()`.
	   */
	
	  Dispatcher.prototype.register = function register(callback) {
	    var id = _prefix + this._lastID++;
	    this._callbacks[id] = callback;
	    return id;
	  };
	
	  /**
	   * Removes a callback based on its token.
	   */
	
	  Dispatcher.prototype.unregister = function unregister(id) {
	    !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.unregister(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	    delete this._callbacks[id];
	  };
	
	  /**
	   * Waits for the callbacks specified to be invoked before continuing execution
	   * of the current callback. This method should only be used by a callback in
	   * response to a dispatched payload.
	   */
	
	  Dispatcher.prototype.waitFor = function waitFor(ids) {
	    !this._isDispatching ?  false ? invariant(false, 'Dispatcher.waitFor(...): Must be invoked while dispatching.') : invariant(false) : undefined;
	    for (var ii = 0; ii < ids.length; ii++) {
	      var id = ids[ii];
	      if (this._isPending[id]) {
	        !this._isHandled[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): Circular dependency detected while ' + 'waiting for `%s`.', id) : invariant(false) : undefined;
	        continue;
	      }
	      !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	      this._invokeCallback(id);
	    }
	  };
	
	  /**
	   * Dispatches a payload to all registered callbacks.
	   */
	
	  Dispatcher.prototype.dispatch = function dispatch(payload) {
	    !!this._isDispatching ?  false ? invariant(false, 'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.') : invariant(false) : undefined;
	    this._startDispatching(payload);
	    try {
	      for (var id in this._callbacks) {
	        if (this._isPending[id]) {
	          continue;
	        }
	        this._invokeCallback(id);
	      }
	    } finally {
	      this._stopDispatching();
	    }
	  };
	
	  /**
	   * Is this Dispatcher currently dispatching.
	   */
	
	  Dispatcher.prototype.isDispatching = function isDispatching() {
	    return this._isDispatching;
	  };
	
	  /**
	   * Call the callback stored with the given id. Also do some internal
	   * bookkeeping.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
	    this._isPending[id] = true;
	    this._callbacks[id](this._pendingPayload);
	    this._isHandled[id] = true;
	  };
	
	  /**
	   * Set up bookkeeping needed when dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
	    for (var id in this._callbacks) {
	      this._isPending[id] = false;
	      this._isHandled[id] = false;
	    }
	    this._pendingPayload = payload;
	    this._isDispatching = true;
	  };
	
	  /**
	   * Clear bookkeeping used for dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._stopDispatching = function _stopDispatching() {
	    delete this._pendingPayload;
	    this._isDispatching = false;
	  };
	
	  return Dispatcher;
	})();
	
	module.exports = Dispatcher;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function (condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getActions = getActions;
	
	var _Entity = __webpack_require__(595);
	
	var _Entity2 = _interopRequireDefault(_Entity);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _PusherConstants = __webpack_require__(954);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// typecheck: ignore file
	var CHANGESET_EVENT_TYPE = 'v3.changeset';
	var CONTENT_EVENT_TYPE = 'v3.content';
	
	function getModelFromType(actionType) {
	  switch (actionType) {
	    case _PusherConstants.PushEvents.CLASS_MEMBERSHIP:
	      return _GroupMembership2.default;
	    case _PusherConstants.PushEvents.USER:
	      return _User2.default;
	    default:
	      return null;
	  }
	}
	
	/*
	 * Tries to match the push event data with a model
	 * This is how we get entities & collection in v2 push event
	 * or v3 content push event
	 */
	function parseModel(type, data) {
	  var model = getModelFromType(type);
	
	  if (model) {
	    return model.fromJSON(data);
	  }
	
	  return undefined;
	}
	
	function isV2(event) {
	  return !!(event && event.eventData && event.eventData.data && event.eventData.data.v2);
	}
	
	function isV3Changeset(event) {
	  return event && event.type === CHANGESET_EVENT_TYPE;
	}
	
	function isV3Content(event) {
	  return event && event.type === CONTENT_EVENT_TYPE;
	}
	
	function aggregateChanges(changes) {
	  var isContentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  return changes.reduce(function (result, change) {
	    var key = isContentType ? 'content-' + change.action + '-' + change.type : 'changeset-' + change.action + '-' + change.type;
	
	    if (!result[key]) {
	      result[key] = [];
	    }
	
	    // We delete those keys because they are redundant informations
	    // We don't need the action & type in the changeset now that
	    // we agregated the changes by type & action.
	    //
	    // {
	    //   type: 'changeset-update-group',
	    //   eventData: {
	    //     changes: [
	    //       {uuid: '123-1'},
	    //       {uuid: '123-2'},
	    //     ]
	    //   }
	    // }
	
	    delete change.action;
	    delete change.type;
	
	    result[key].push(change);
	    return result;
	  }, {});
	}
	
	/*
	 * V2 push:
	 *   - always return a single action (array of 1).
	 *   - parse the data & add a model object to the action.
	 *
	 * V3 changeset push:
	 *   - return an array of actions aggregated the model & type.
	 *     eg: all the changeset that concerns destroying chat will
	 *     be in a { type: changeset-destroy-chat, ... } action.
	 *
	 * V3 content push
	 *   - return an array of actions aggregated the model & type
	 *     that includes the content of the model being updated
	 */
	function getActions(event) {
	  if (isV2(event)) {
	    event.model = parseModel(event.type, event.eventData.data.v2);
	    return [event];
	  }
	
	  var actionsToDispatch = [];
	
	  if (isV3Changeset(event)) {
	    var changes = aggregateChanges(event.eventData.changes);
	    for (var key in changes) {
	      actionsToDispatch.push({
	        type: key,
	        changes: changes[key]
	      });
	    }
	  } else if (isV3Content(event)) {
	    var _changes = aggregateChanges(event.eventData.changes, true);
	    for (var _key in _changes) {
	      actionsToDispatch.push({
	        type: _key,
	        changes: _changes[_key]
	      });
	    }
	  }
	
	  return actionsToDispatch;
	}

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _backboneModel = __webpack_require__(596);
	
	var _backboneModel2 = _interopRequireDefault(_backboneModel);
	
	var _Collection = __webpack_require__(599);
	
	var _Collection2 = _interopRequireDefault(_Collection);
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _BackboneSync = __webpack_require__(603);
	
	var _BackboneSync2 = _interopRequireDefault(_BackboneSync);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Entity = function (_Backbone$Model) {
	  _inherits(Entity, _Backbone$Model);
	
	  function Entity() {
	    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Entity);
	
	    var _this = _possibleConstructorReturn(this, (Entity.__proto__ || Object.getPrototypeOf(Entity)).call(this));
	
	    _this.cid = _lodash2.default.uniqueId('c');
	    _this.attributes = {};
	    if (options.collection) {
	      _this.collection = options.collection;
	    }
	    var possiblyParsedAttrs = attrs;
	    if (options.parse) {
	      possiblyParsedAttrs = _this.parse(attrs, options) || {};
	    }
	    var defaultedAttrs = _lodash2.default.defaults({}, possiblyParsedAttrs, _lodash2.default.result(_this, 'defaults'));
	    _this.initialize.call(_this, defaultedAttrs, options);
	    _this.set(defaultedAttrs, options);
	    _this.changed = {};
	    return _this;
	  }
	
	  _createClass(Entity, [{
	    key: 'fetch',
	    value: function fetch() {
	      var _this2 = this;
	
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return new Promise(function (resolve, reject) {
	        options.success = resolve;
	        options.error = function (model, response) {
	          reject(response);
	        };
	        _get(Entity.prototype.__proto__ || Object.getPrototypeOf(Entity.prototype), 'fetch', _this2).call(_this2, options);
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save(attributes) {
	      var _this3 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return new Promise(function (resolve, reject) {
	        options.success = resolve;
	        options.error = function (model, response) {
	          reject(response);
	        };
	        _get(Entity.prototype.__proto__ || Object.getPrototypeOf(Entity.prototype), 'save', _this3).call(_this3, attributes, options);
	      });
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      var _this4 = this;
	
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return new Promise(function (resolve, reject) {
	        options.success = resolve;
	        options.error = reject;
	        _get(Entity.prototype.__proto__ || Object.getPrototypeOf(Entity.prototype), 'destroy', _this4).call(_this4, options);
	      });
	    }
	  }, {
	    key: 'sync',
	    value: function sync() {
	      return _BackboneSync2.default.apply(this, arguments);
	    }
	  }, {
	    key: 'jasmineToString',
	    value: function jasmineToString() {
	      return this.constructor.name + ' ' + JSON.stringify(this.attributes, null, 2);
	    }
	
	    // TODO make this safe to override toJSON
	    // https://github.com/remind101/r101-frontend/pull/3877#issuecomment-239017223
	
	  }, {
	    key: 'recursivelyToJSON',
	    value: function recursivelyToJSON() {
	      var json = _get(Entity.prototype.__proto__ || Object.getPrototypeOf(Entity.prototype), 'toJSON', this).call(this);
	
	      var attrKeys = Object.keys(this.attributes);
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = attrKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	          var val = this.get(key);
	
	          if (val) {
	            var jsonVal = Array.isArray(val) ? val.map(function (item) {
	              return serialize(item);
	            }) : serialize(val);
	            json[key] = jsonVal;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return json;
	    }
	  }], [{
	    key: 'fetch',
	    value: function fetch() {
	      var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return new this(attributes).fetch(options);
	    }
	  }, {
	    key: 'fromJSON',
	    value: function fromJSON() {
	      var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return new this(attributes, { parse: true });
	    }
	  }]);
	
	  return Entity;
	}(_backboneModel2.default.Model);
	
	Entity.displayName = 'Entity';
	exports.default = Entity;
	
	
	function serialize(val) {
	  if (val instanceof Entity || val instanceof _Collection2.default) {
	    return val.toJSON();
	  } else {
	    return val;
	  }
	}

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	//     Backbone.js 1.0.0
	
	//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
	//     Backbone may be freely distributed under the MIT license.
	//     For all details and documentation:
	//     http://backbonejs.org
	
	  // Backbone.Model
	  // --------------
	
	  // Backbone **Models** are the basic data object in the framework --
	  // frequently representing a row in a table in a database on your server.
	  // A discrete chunk of data and a bunch of useful, related methods for
	  // performing computations and transformations on that data.
	
	  // Create a new model with the specified attributes. A client id (`cid`)
	  // is automatically generated and assigned for you.
	
	var _ = __webpack_require__(555);
	var Events = __webpack_require__(597).Events;
	
	var urlError = __webpack_require__(598).urlError;
	var wrapError = __webpack_require__(598).wrapError;
	
	var array = [];
	var push = array.push;
	var slice = array.slice;
	var splice = array.splice;
	
	var Model = module.exports.Model = function(attributes, options) {
	  var attrs = attributes || {};
	    options || (options = {});
	    this.cid = _.uniqueId('c');
	    this.attributes = {};
	    if (options.collection) this.collection = options.collection;
	    if (options.parse) attrs = this.parse(attrs, options) || {};
	    attrs = _.defaults({}, attrs, _.result(this, 'defaults'));
	    this.set(attrs, options);
	    this.changed = {};
	    this.initialize.apply(this, arguments);
	  };
	
	  // Attach all inheritable methods to the Model prototype.
	  _.extend(Model.prototype, Events, {
	
	    // A hash of attributes whose current and previous value differ.
	    changed: null,
	
	    // The value returned during the last failed validation.
	    validationError: null,
	
	    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
	    // CouchDB users may want to set this to `"_id"`.
	    idAttribute: 'id',
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Return a copy of the model's `attributes` object.
	    toJSON: function(options) {
	      return _.clone(this.attributes);
	    },
	
	    sync : function(){
	
	      throw new Error("Sync component not used");
	
	    },
	    // Get the value of an attribute.
	    get: function(attr) {
	      return this.attributes[attr];
	    },
	
	    // Get the HTML-escaped value of an attribute.
	    escape: function(attr) {
	      return _.escape(this.get(attr));
	    },
	
	    // Returns `true` if the attribute contains a value that is not null
	    // or undefined.
	    has: function(attr) {
	      return this.get(attr) != null;
	    },
	
	    // Set a hash of model attributes on the object, firing `"change"`. This is
	    // the core primitive operation of a model, updating the data and notifying
	    // anyone who needs to know about the change in state. The heart of the beast.
	    set: function(key, val, options) {
	      var attr, attrs, unset, changes, silent, changing, prev, current;
	      if (key == null) return this;
	
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      if (typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options || (options = {});
	
	      // Run validation.
	      if (!this._validate(attrs, options)) return false;
	
	      // Extract attributes and options.
	      unset           = options.unset;
	      silent          = options.silent;
	      changes         = [];
	      changing        = this._changing;
	      this._changing  = true;
	
	      if (!changing) {
	        this._previousAttributes = _.clone(this.attributes);
	        this.changed = {};
	      }
	      current = this.attributes, prev = this._previousAttributes;
	
	      // Check for changes of `id`.
	      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];
	
	      // For each `set` attribute, update or delete the current value.
	      for (attr in attrs) {
	        val = attrs[attr];
	        if (!_.isEqual(current[attr], val)) changes.push(attr);
	        if (!_.isEqual(prev[attr], val)) {
	          this.changed[attr] = val;
	        } else {
	          delete this.changed[attr];
	        }
	        unset ? delete current[attr] : current[attr] = val;
	      }
	
	      // Trigger all relevant attribute changes.
	      if (!silent) {
	        if (changes.length) this._pending = true;
	        for (var i = 0, l = changes.length; i < l; i++) {
	          this.trigger('change:' + changes[i], this, current[changes[i]], options);
	        }
	      }
	
	      // You might be wondering why there's a `while` loop here. Changes can
	      // be recursively nested within `"change"` events.
	      if (changing) return this;
	      if (!silent) {
	        while (this._pending) {
	          this._pending = false;
	          this.trigger('change', this, options);
	        }
	      }
	      this._pending = false;
	      this._changing = false;
	      return this;
	    },
	
	    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
	    // if the attribute doesn't exist.
	    unset: function(attr, options) {
	      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
	    },
	
	    // Clear all attributes on the model, firing `"change"`.
	    clear: function(options) {
	      var attrs = {};
	      for (var key in this.attributes) attrs[key] = void 0;
	      return this.set(attrs, _.extend({}, options, {unset: true}));
	    },
	
	    // Determine if the model has changed since the last `"change"` event.
	    // If you specify an attribute name, determine if that attribute has changed.
	    hasChanged: function(attr) {
	      if (attr == null) return !_.isEmpty(this.changed);
	      return _.has(this.changed, attr);
	    },
	
	    // Return an object containing all the attributes that have changed, or
	    // false if there are no changed attributes. Useful for determining what
	    // parts of a view need to be updated and/or what attributes need to be
	    // persisted to the server. Unset attributes will be set to undefined.
	    // You can also pass an attributes object to diff against the model,
	    // determining if there *would be* a change.
	    changedAttributes: function(diff) {
	      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
	      var val, changed = false;
	      var old = this._changing ? this._previousAttributes : this.attributes;
	      for (var attr in diff) {
	        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
	        (changed || (changed = {}))[attr] = val;
	      }
	      return changed;
	    },
	
	    // Get the previous value of an attribute, recorded at the time the last
	    // `"change"` event was fired.
	    previous: function(attr) {
	      if (attr == null || !this._previousAttributes) return null;
	      return this._previousAttributes[attr];
	    },
	
	    // Get all of the attributes of the model at the time of the previous
	    // `"change"` event.
	    previousAttributes: function() {
	      return _.clone(this._previousAttributes);
	    },
	
	    // Fetch the model from the server. If the server's representation of the
	    // model differs from its current attributes, they will be overridden,
	    // triggering a `"change"` event.
	    fetch: function(options) {
	      options = options ? _.clone(options) : {};
	      if (options.parse === void 0) options.parse = true;
	      var model = this;
	      var success = options.success;
	      options.success = function(resp) {
	        if (!model.set(model.parse(resp, options), options)) return false;
	        if (success) success(model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Set a hash of model attributes, and sync the model to the server.
	    // If the server returns an attributes hash that differs, the model's
	    // state will be `set` again.
	    save: function(key, val, options) {
	      var attrs, method, xhr, attributes = this.attributes;
	
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      if (key == null || typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options = _.extend({validate: true}, options);
	
	      // If we're not waiting and attributes exist, save acts as
	      // `set(attr).save(null, opts)` with validation. Otherwise, check if
	      // the model will be valid when the attributes, if any, are set.
	      if (attrs && !options.wait) {
	        if (!this.set(attrs, options)) return false;
	      } else {
	        if (!this._validate(attrs, options)) return false;
	      }
	
	      // Set temporary attributes if `{wait: true}`.
	      if (attrs && options.wait) {
	        this.attributes = _.extend({}, attributes, attrs);
	      }
	
	      // After a successful server-side save, the client is (optionally)
	      // updated with the server-side state.
	      if (options.parse === void 0) options.parse = true;
	      var model = this;
	      var success = options.success;
	      options.success = function(resp) {
	        // Ensure attributes are restored during synchronous saves.
	        model.attributes = attributes;
	        var serverAttrs = model.parse(resp, options);
	        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
	        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
	          return false;
	        }
	        if (success) success(model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	
	      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
	      if (method === 'patch') options.attrs = attrs;
	      xhr = this.sync(method, this, options);
	
	      // Restore attributes.
	      if (attrs && options.wait) this.attributes = attributes;
	
	      return xhr;
	    },
	
	    // Destroy this model on the server if it was already persisted.
	    // Optimistically removes the model from its collection, if it has one.
	    // If `wait: true` is passed, waits for the server to respond before removal.
	    destroy: function(options) {
	      options = options ? _.clone(options) : {};
	      var model = this;
	      var success = options.success;
	
	      var destroy = function() {
	        model.trigger('destroy', model, model.collection, options);
	      };
	
	      options.success = function(resp) {
	        if (options.wait || model.isNew()) destroy();
	        if (success) success(model, resp, options);
	        if (!model.isNew()) model.trigger('sync', model, resp, options);
	      };
	
	      if (this.isNew()) {
	        options.success();
	        return false;
	      }
	      wrapError(this, options);
	
	      var xhr = this.sync('delete', this, options);
	      if (!options.wait) destroy();
	      return xhr;
	    },
	
	    // Default URL for the model's representation on the server -- if you're
	    // using Backbone's restful methods, override this to change the endpoint
	    // that will be called.
	    url: function() {
	      var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
	      if (this.isNew()) return base;
	      return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id);
	    },
	
	    // **parse** converts a response into the hash of attributes to be `set` on
	    // the model. The default implementation is just to pass the response along.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new model with identical attributes to this one.
	    clone: function() {
	      return new this.constructor(this.attributes);
	    },
	
	    // A model is new if it has never been saved to the server, and lacks an id.
	    isNew: function() {
	      return this.id == null;
	    },
	
	    // Check if the model is currently in a valid state.
	    isValid: function(options) {
	      return this._validate({}, _.extend(options || {}, { validate: true }));
	    },
	
	    // Run validation against the next complete set of model attributes,
	    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
	    _validate: function(attrs, options) {
	      if (!options.validate || !this.validate) return true;
	      attrs = _.extend({}, this.attributes, attrs);
	      var error = this.validationError = this.validate(attrs, options) || null;
	      if (!error) return true;
	      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
	      return false;
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Model.
	  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];
	
	  // Mix in each Underscore method as a proxy to `Model#attributes`.
	  _.each(modelMethods, function(method) {
	    Model.prototype[method] = function() {
	      var args = slice.call(arguments);
	      args.unshift(this.attributes);
	      return _[method].apply(_, args);
	    };
	  });
	
	Model.extend = __webpack_require__(598).extend;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	//     Backbone.js 1.0.0
	
	//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
	//     Backbone may be freely distributed under the MIT license.
	//     For all details and documentation:
	//     http://backbonejs.org
	
	// Backbone.Events
	// ---------------
	
	// A module that can be mixed in to *any object* in order to provide it with
	// custom events. You may bind with `on` or remove with `off` callback
	// functions to an event; `trigger`-ing an event fires all callbacks in
	// succession.
	//
	//     var object = {};
	//     _.extend(object, Backbone.Events);
	//     object.on('expand', function(){ alert('expanded'); });
	//     object.trigger('expand');
	//
	
	var array = [];
	var push = array.push;
	var slice = array.slice;
	var splice = array.splice;
	
	var _ = __webpack_require__(555);
	
	var Events = module.exports.Events = {
	
	    // Bind an event to a `callback` function. Passing `"all"` will bind
	    // the callback to all events fired.
	    on: function(name, callback, context) {
	      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
	      this._events || (this._events = {});
	      var events = this._events[name] || (this._events[name] = []);
	      events.push({callback: callback, context: context, ctx: context || this});
	      return this;
	    },
	
	    // Bind an event to only be triggered a single time. After the first time
	    // the callback is invoked, it will be removed.
	    once: function(name, callback, context) {
	      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
	      var self = this;
	      var once = _.once(function() {
	        self.off(name, once);
	        callback.apply(this, arguments);
	      });
	      once._callback = callback;
	      return this.on(name, once, context);
	    },
	
	    // Remove one or many callbacks. If `context` is null, removes all
	    // callbacks with that function. If `callback` is null, removes all
	    // callbacks for the event. If `name` is null, removes all bound
	    // callbacks for all events.
	    off: function(name, callback, context) {
	      var retain, ev, events, names, i, l, j, k;
	      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
	      if (!name && !callback && !context) {
	        this._events = {};
	        return this;
	      }
	      names = name ? [name] : _.keys(this._events);
	      for (i = 0, l = names.length; i < l; i++) {
	        name = names[i];
	        if (events = this._events[name]) {
	          this._events[name] = retain = [];
	          if (callback || context) {
	            for (j = 0, k = events.length; j < k; j++) {
	              ev = events[j];
	              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
	                  (context && context !== ev.context)) {
	                retain.push(ev);
	              }
	            }
	          }
	          if (!retain.length) delete this._events[name];
	        }
	      }
	
	      return this;
	    },
	
	    // Trigger one or many events, firing all bound callbacks. Callbacks are
	    // passed the same arguments as `trigger` is, apart from the event name
	    // (unless you're listening on `"all"`, which will cause your callback to
	    // receive the true name of the event as the first argument).
	    trigger: function(name) {
	      if (!this._events) return this;
	      var args = slice.call(arguments, 1);
	      if (!eventsApi(this, 'trigger', name, args)) return this;
	      var events = this._events[name];
	      var allEvents = this._events.all;
	      if (events) triggerEvents(events, args);
	      if (allEvents) triggerEvents(allEvents, arguments);
	      return this;
	    },
	
	    // Tell this object to stop listening to either specific events ... or
	    // to every object it's currently listening to.
	    stopListening: function(obj, name, callback) {
	      var listeningTo = this._listeningTo;
	      if (!listeningTo) return this;
	      var remove = !name && !callback;
	      if (!callback && typeof name === 'object') callback = this;
	      if (obj) (listeningTo = {})[obj._listenId] = obj;
	      for (var id in listeningTo) {
	        obj = listeningTo[id];
	        obj.off(name, callback, this);
	        if (remove || _.isEmpty(obj._events)) delete this._listeningTo[id];
	      }
	      return this;
	    }
	
	  };
	
	  // Regular expression used to split event strings.
	  var eventSplitter = /\s+/;
	
	  // Implement fancy features of the Events API such as multiple event
	  // names `"change blur"` and jQuery-style event maps `{change: action}`
	  // in terms of the existing API.
	  var eventsApi = function(obj, action, name, rest) {
	    if (!name) return true;
	
	    // Handle event maps.
	    if (typeof name === 'object') {
	      for (var key in name) {
	        obj[action].apply(obj, [key, name[key]].concat(rest));
	      }
	      return false;
	    }
	
	    // Handle space separated event names.
	    if (eventSplitter.test(name)) {
	      var names = name.split(eventSplitter);
	      for (var i = 0, l = names.length; i < l; i++) {
	        obj[action].apply(obj, [names[i]].concat(rest));
	      }
	      return false;
	    }
	
	    return true;
	  };
	
	  // A difficult-to-believe, but optimized internal dispatch function for
	  // triggering events. Tries to keep the usual cases speedy (most internal
	  // Backbone events have 3 arguments).
	  var triggerEvents = function(events, args) {
	    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
	    switch (args.length) {
	      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
	      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
	      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
	      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
	      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
	    }
	  };
	
	  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};
	
	  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
	  // listen to an event in another object ... keeping track of what it's
	  // listening to.
	  _.each(listenMethods, function(implementation, method) {
	    Events[method] = function(obj, name, callback) {
	      var listeningTo = this._listeningTo || (this._listeningTo = {});
	      var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
	      listeningTo[id] = obj;
	      if (!callback && typeof name === 'object') callback = this;
	      obj[implementation](name, callback, this);
	      return this;
	    };
	  });
	
	  // Aliases for backwards compatibility.
	  Events.bind   = Events.on;
	  Events.unbind = Events.off;
	
	//Events.extend = require('backbone-helpers').extend;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	//     Backbone.js 1.0.0
	
	//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
	//     Backbone may be freely distributed under the MIT license.
	//     For all details and documentation:
	//     http://backbonejs.org 
	
	var _ = __webpack_require__(555);
	
	// Helpers
	// -------
	
	// Helper function to correctly set up the prototype chain, for subclasses.
	// Similar to `goog.inherits`, but uses a hash of prototype properties and
	// class properties to be extended.
	var extend = module.exports.extend = function(protoProps, staticProps) {
	
	  var parent = this;
	  var child;
	
	  // The constructor function for the new subclass is either defined by you
	  // (the "constructor" property in your `extend` definition), or defaulted
	  // by us to simply call the parent's constructor.
	  if (protoProps && _.has(protoProps, 'constructor')) {
	    child = protoProps.constructor;
	  } else {
	    child = function(){ return parent.apply(this, arguments); };
	  }
	
	  // Add static properties to the constructor function, if supplied.
	  _.extend(child, parent, staticProps);
	
	  // Set the prototype chain to inherit from `parent`, without calling
	  // `parent`'s constructor function.
	  var Surrogate = function(){ this.constructor = child; };
	  Surrogate.prototype = parent.prototype;
	  child.prototype = new Surrogate();
	
	  // Add prototype properties (instance properties) to the subclass,
	  // if supplied.
	  if (protoProps) _.extend(child.prototype, protoProps);
	
	  // Set a convenience property in case the parent's prototype is needed
	  // later.
	  child.__super__ = parent.prototype;
	
	  return child;
	
	};
	
	var urlError = module.exports.urlError = function() {
	  throw new Error('A "url" property or function must be specified');
	};
	
	// Wrap an optional error callback with a fallback error event.
	var wrapError = module.exports.wrapError = function (model, options) {
	  var error = options.error;
	  options.error = function(resp) {
	    if (error) error(model, resp, options);
	    model.trigger('error', model, resp, options);
	  };
	};

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _backboneCollection = __webpack_require__(600);
	
	var _backboneCollection2 = _interopRequireDefault(_backboneCollection);
	
	var _BackboneSync = __webpack_require__(603);
	
	var _BackboneSync2 = _interopRequireDefault(_BackboneSync);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Collection = function (_Backbone$Collection) {
	  _inherits(Collection, _Backbone$Collection);
	
	  function Collection() {
	    _classCallCheck(this, Collection);
	
	    return _possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).apply(this, arguments));
	  }
	
	  _createClass(Collection, [{
	    key: 'add',
	    value: function add(models) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      // Make add() use `merge` by default
	      return _get(Collection.prototype.__proto__ || Object.getPrototypeOf(Collection.prototype), 'add', this).call(this, models, Object.assign({ merge: true }, options));
	    }
	  }, {
	    key: 'fetch',
	    value: function fetch() {
	      var _this2 = this;
	
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return new Promise(function (resolve, reject) {
	        options.success = resolve;
	        options.error = function (model, response) {
	          reject(response);
	        };
	        _get(Collection.prototype.__proto__ || Object.getPrototypeOf(Collection.prototype), 'fetch', _this2).call(_this2, options);
	      });
	    }
	  }, {
	    key: 'sync',
	    value: function sync() {
	      return _BackboneSync2.default.apply(this, arguments);
	    }
	  }, {
	    key: 'jasmineToString',
	    value: function jasmineToString() {
	      return '[' + this.length + ' ' + this.model.name + 's]';
	    }
	  }], [{
	    key: 'fetch',
	    value: function fetch() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return new this().fetch(options);
	    }
	  }, {
	    key: 'fromJSON',
	    value: function fromJSON() {
	      var models = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      return new this(models, { parse: true });
	    }
	  }]);
	
	  return Collection;
	}(_backboneCollection2.default.Collection);
	
	Collection.displayName = 'Collection';
	exports.default = Collection;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	//     Backbone.js 1.0.0
	
	//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
	//     Backbone may be freely distributed under the MIT license.
	//     For all details and documentation:
	//     http://backbonejs.org
	
	var _ = __webpack_require__(555);
	var Model = __webpack_require__(596).Model;
	var Events = __webpack_require__(601).Events;
	
	var array = [];
	var push = array.push;
	var slice = array.slice;
	var splice = array.splice;
	
	var wrapError = __webpack_require__(602).wrapError;
	
	var instanceOfModel = function (obj) {
	  return !!obj.cid;
	}
	
	// Backbone.Collection
	// -------------------
	
	// If models tend to represent a single row of data, a Backbone Collection is
	// more analagous to a table full of data ... or a small slice or page of that
	// table, or a collection of rows that belong together for a particular reason
	// -- all of the messages in this particular folder, all of the documents
	// belonging to this particular author, and so on. Collections maintain
	// indexes of their models, both in order, and for lookup by `id`.
	
	// Create a new **Collection**, perhaps to contain a specific type of `model`.
	// If a `comparator` is specified, the Collection will maintain
	// its models in sort order, as they're added and removed.
	
	
	  var Collection = module.exports.Collection = function(models, options) {
	    options || (options = {});
	    if (options.model) this.model = options.model;
	    if (options.comparator !== void 0) this.comparator = options.comparator;
	    this._reset();
	    this.initialize.apply(this, arguments);
	    if (models) this.reset(models, _.extend({silent: true}, options));
	  };
	
	  // Default options for `Collection#set`.
	  var setOptions = {add: true, remove: true, merge: true};
	  var addOptions = {add: true, remove: false};
	
	  // Define the Collection's inheritable methods.
	  _.extend(Collection.prototype, Events, {
	
	    // The default model for a collection is just a **Backbone.Model**.
	    // This should be overridden in most cases.
	    model: Model,
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // The JSON representation of a Collection is an array of the
	    // models' attributes.
	    toJSON: function(options) {
	      return this.map(function(model){ return model.toJSON(options); });
	    },
	
	    // Proxy `Backbone.sync` by default.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Add a model, or list of models to the set.
	    add: function(models, options) {
	      return this.set(models, _.extend({merge: false}, options, addOptions));
	    },
	
	    // Remove a model, or a list of models from the set.
	    remove: function(models, options) {
	      var singular = !_.isArray(models);
	      models = singular ? [models] : _.clone(models);
	      options || (options = {});
	      var i, l, index, model;
	      for (i = 0, l = models.length; i < l; i++) {
	        model = models[i] = this.get(models[i]);
	        if (!model) continue;
	        delete this._byId[model.id];
	        delete this._byId[model.cid];
	        index = this.indexOf(model);
	        this.models.splice(index, 1);
	        this.length--;
	        if (!options.silent) {
	          options.index = index;
	          model.trigger('remove', model, this, options);
	        }
	        this._removeReference(model);
	      }
	      return singular ? models[0] : models;
	    },
	
	    // Update a collection by `set`-ing a new list of models, adding new ones,
	    // removing models that are no longer present, and merging models that
	    // already exist in the collection, as necessary. Similar to **Model#set**,
	    // the core operation for updating the data contained by the collection.
	    set: function(models, options) {
	      options = _.defaults({}, options, setOptions);
	      if (options.parse) models = this.parse(models, options);
	      var singular = !_.isArray(models);
	      models = singular ? (models ? [models] : []) : _.clone(models);
	      var i, l, id, model, attrs, existing, sort;
	      var at = options.at;
	      var targetModel = this.model;
	      var sortable = this.comparator && (at == null) && options.sort !== false;
	      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
	      var toAdd = [], toRemove = [], modelMap = {};
	      var add = options.add, merge = options.merge, remove = options.remove;
	      var order = !sortable && add && remove ? [] : false;
	
	      // Turn bare objects into model references, and prevent invalid models
	      // from being added.
	      for (i = 0, l = models.length; i < l; i++) {
	        attrs = models[i];
	        if (instanceOfModel(attrs)) {
	          id = model = attrs;
	        } else {
	          id = attrs[targetModel.prototype.idAttribute];
	        }
	
	        // If a duplicate is found, prevent it from being added and
	        // optionally merge it into the existing model.
	        if (existing = this.get(id)) {
	          if (remove) modelMap[existing.cid] = true;
	          if (merge) {
	            attrs = attrs === model ? model.attributes : attrs;
	            if (options.parse) attrs = existing.parse(attrs, options);
	            existing.set(attrs, options);
	            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
	          }
	          models[i] = existing;
	
	        // If this is a new, valid model, push it to the `toAdd` list.
	        } else if (add) {
	          model = models[i] = this._prepareModel(attrs, options);
	          if (!model) continue;
	          toAdd.push(model);
	
	          // Listen to added models' events, and index models for lookup by
	          // `id` and by `cid`.
	          model.on('all', this._onModelEvent, this);
	          this._byId[model.cid] = model;
	          if (model.id != null) this._byId[model.id] = model;
	        }
	        if (order) order.push(existing || model);
	      }
	
	      // Remove nonexistent models if appropriate.
	      if (remove) {
	        for (i = 0, l = this.length; i < l; ++i) {
	          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
	        }
	        if (toRemove.length) this.remove(toRemove, options);
	      }
	
	      // See if sorting is needed, update `length` and splice in new models.
	      if (toAdd.length || (order && order.length)) {
	        if (sortable) sort = true;
	        this.length += toAdd.length;
	        if (at != null) {
	          for (i = 0, l = toAdd.length; i < l; i++) {
	            this.models.splice(at + i, 0, toAdd[i]);
	          }
	        } else {
	          if (order) this.models.length = 0;
	          var orderedModels = order || toAdd;
	          for (i = 0, l = orderedModels.length; i < l; i++) {
	            this.models.push(orderedModels[i]);
	          }
	        }
	      }
	
	      // Silently sort the collection if appropriate.
	      if (sort) this.sort({silent: true});
	
	      // Unless silenced, it's time to fire all appropriate add/sort events.
	      if (!options.silent) {
	        for (i = 0, l = toAdd.length; i < l; i++) {
	          (model = toAdd[i]).trigger('add', model, this, options);
	        }
	        if (sort || (order && order.length)) this.trigger('sort', this, options);
	      }
	      
	      // Return the added (or merged) model (or models).
	      return singular ? models[0] : models;
	    },
	
	    // When you have more items than you want to add or remove individually,
	    // you can reset the entire set with a new list of models, without firing
	    // any granular `add` or `remove` events. Fires `reset` when finished.
	    // Useful for bulk operations and optimizations.
	    reset: function(models, options) {
	      options || (options = {});
	      for (var i = 0, l = this.models.length; i < l; i++) {
	        this._removeReference(this.models[i]);
	      }
	      options.previousModels = this.models;
	      this._reset();
	      models = this.add(models, _.extend({silent: true}, options));
	      if (!options.silent) this.trigger('reset', this, options);
	      return models;
	    },
	
	    // Add a model to the end of the collection.
	    push: function(model, options) {
	      return this.add(model, _.extend({at: this.length}, options));
	    },
	
	    // Remove a model from the end of the collection.
	    pop: function(options) {
	      var model = this.at(this.length - 1);
	      this.remove(model, options);
	      return model;
	    },
	
	    // Add a model to the beginning of the collection.
	    unshift: function(model, options) {
	      return this.add(model, _.extend({at: 0}, options));
	    },
	
	    // Remove a model from the beginning of the collection.
	    shift: function(options) {
	      var model = this.at(0);
	      this.remove(model, options);
	      return model;
	    },
	
	    // Slice out a sub-array of models from the collection.
	    slice: function() {
	      return slice.apply(this.models, arguments);
	    },
	
	    // Get a model from the set by id.
	    get: function(obj) {
	      if (obj == null) return void 0;
	      return this._byId[obj.id] || this._byId[obj.cid] || this._byId[obj];
	    },
	
	    // Get the model at the given index.
	    at: function(index) {
	      return this.models[index];
	    },
	
	    // Return models with matching attributes. Useful for simple cases of
	    // `filter`.
	    where: function(attrs, first) {
	      if (_.isEmpty(attrs)) return first ? void 0 : [];
	      return this[first ? 'find' : 'filter'](function(model) {
	        for (var key in attrs) {
	          if (attrs[key] !== model.get(key)) return false;
	        }
	        return true;
	      });
	    },
	
	    // Return the first model with matching attributes. Useful for simple cases
	    // of `find`.
	    findWhere: function(attrs) {
	      return this.where(attrs, true);
	    },
	
	    // Force the collection to re-sort itself. You don't need to call this under
	    // normal circumstances, as the set will maintain sort order as each item
	    // is added.
	    sort: function(options) {
	      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
	      options || (options = {});
	
	      // Run sort based on type of `comparator`.
	      if (_.isString(this.comparator) || this.comparator.length === 1) {
	        this.models = this.sortBy(this.comparator, this);
	      } else {
	        this.models.sort(_.bind(this.comparator, this));
	      }
	
	      if (!options.silent) this.trigger('sort', this, options);
	      return this;
	    },
	
	    // Pluck an attribute from each model in the collection.
	    pluck: function(attr) {
	      return _.invoke(this.models, 'get', attr);
	    },
	
	    // Fetch the default set of models for this collection, resetting the
	    // collection when they arrive. If `reset: true` is passed, the response
	    // data will be passed through the `reset` method instead of `set`.
	    fetch: function(options) {
	      options = options ? _.clone(options) : {};
	      if (options.parse === void 0) options.parse = true;
	      var success = options.success;
	      var collection = this;
	      options.success = function(resp) {
	        var method = options.reset ? 'reset' : 'set';
	        collection[method](resp, options);
	        if (success) success(collection, resp, options);
	        collection.trigger('sync', collection, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Create a new instance of a model in this collection. Add the model to the
	    // collection immediately, unless `wait: true` is passed, in which case we
	    // wait for the server to agree.
	    create: function(model, options) {
	      options = options ? _.clone(options) : {};
	      if (!(model = this._prepareModel(model, options))) return false;
	      if (!options.wait) this.add(model, options);
	      var collection = this;
	      var success = options.success;
	      options.success = function(model, resp, options) {
	        if (options.wait) collection.add(model, options);
	        if (success) success(model, resp, options);
	      };
	      model.save(null, options);
	      return model;
	    },
	
	    // **parse** converts a response into a list of models to be added to the
	    // collection. The default implementation is just to pass it through.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new collection with an identical list of models as this one.
	    clone: function() {
	      return new this.constructor(this.models);
	    },
	
	    // Private method to reset all internal state. Called when the collection
	    // is first initialized or reset.
	    _reset: function() {
	      this.length = 0;
	      this.models = [];
	      this._byId  = {};
	    },
	
	    // Prepare a hash of attributes (or other model) to be added to this
	    // collection.
	    _prepareModel: function(attrs, options) {
	      if (instanceOfModel(attrs)) {
	        if (!attrs.collection) attrs.collection = this;
	        return attrs;
	      }
	      options = options ? _.clone(options) : {};
	      options.collection = this;
	      var model = new this.model(attrs, options);
	      if (!model.validationError) return model;
	      this.trigger('invalid', this, model.validationError, options);
	      return false;
	    },
	
	    // Internal method to sever a model's ties to a collection.
	    _removeReference: function(model) {
	      if (this === model.collection) delete model.collection;
	      model.off('all', this._onModelEvent, this);
	    },
	
	    // Internal method called every time a model in the set fires an event.
	    // Sets need to update their indexes when models change ids. All other
	    // events simply proxy through. "add" and "remove" events that originate
	    // in other collections are ignored.
	    _onModelEvent: function(event, model, collection, options) {
	      if ((event === 'add' || event === 'remove') && collection !== this) return;
	      if (event === 'destroy') this.remove(model, options);
	      if (model && event === 'change:' + model.idAttribute) {
	        delete this._byId[model.previous(model.idAttribute)];
	        if (model.id != null) this._byId[model.id] = model;
	      }
	      this.trigger.apply(this, arguments);
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Collection.
	  // 90% of the core usefulness of Backbone Collections is actually implemented
	  // right here:
	  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
	    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
	    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
	    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
	    'tail', 'drop', 'last', 'without', 'difference', 'indexOf', 'shuffle',
	    'lastIndexOf', 'isEmpty', 'chain'];
	
	  // Mix in each Underscore method as a proxy to `Collection#models`.
	  _.each(methods, function(method) {
	    Collection.prototype[method] = function() {
	      var args = slice.call(arguments);
	      args.unshift(this.models);
	      return _[method].apply(_, args);
	    };
	  });
	
	  // Underscore methods that take a property name as an argument.
	  var attributeMethods = ['groupBy', 'countBy', 'sortBy'];
	
	  // Use attributes instead of properties.
	  _.each(attributeMethods, function(method) {
	    Collection.prototype[method] = function(value, context) {
	      var iterator = _.isFunction(value) ? value : function(model) {
	        return model.get(value);
	      };
	      return _[method](this.models, iterator, context);
	    };
	  });
	
	Collection.extend = __webpack_require__(602).extend;


/***/ },
/* 601 */
597,
/* 602 */
598,
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sync;
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _lodash = __webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Our drop-in for Backbone.sync used in both Entity and Collection
	 * The parameters are defined by Backbone. We should never call this directly.
	 */
	var methodMap = {
	  create: 'POST',
	  read: 'GET',
	  update: 'PUT',
	  patch: 'PATCH',
	  delete: 'DELETE'
	};
	
	/**
	 * options.method overrides the defaultMethod arg
	*/
	/*  weak */
	function sync(defaultMethod, model, options) {
	  var url = options.url;
	  if (!url) {
	    url = (0, _lodash.result)(model, 'url');
	  }
	
	  (0, _invariant2.default)(url, 'A "url" property or function must be specified');
	
	  var method = 'method' in options ? options.method : defaultMethod;
	  var data = options.data;
	
	  if (!data && model && (method === 'create' || method === 'update' || method === 'patch')) {
	    data = options.attrs || model.toJSON(options);
	  }
	
	  return (0, _apiRequest2.default)(url, methodMap[method] || method, data).then(options.success, options.error);
	}

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// The relationship between a user and a group
	var GroupMembership = function (_Entity) {
	  _inherits(GroupMembership, _Entity);
	
	  function GroupMembership() {
	    _classCallCheck(this, GroupMembership);
	
	    return _possibleConstructorReturn(this, (GroupMembership.__proto__ || Object.getPrototypeOf(GroupMembership)).apply(this, arguments));
	  }
	
	  _createClass(GroupMembership, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.urlRoot = '/members';
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var membership = _lodash2.default.clone(response);
	      membership['created_at'] = new Date(membership['created_at']);
	      membership['user'] = _Subscriber2.default.fromJSON(membership['user']);
	      return membership;
	    }
	
	    /**
	     * TODO change uses of this to getSubscriber
	     * @return {Subscriber} 'user' attribute as Subscriber model
	     */
	
	  }, {
	    key: 'getUser',
	    value: function getUser() {
	      return this.get('user');
	    }
	  }, {
	    key: 'getSubscriber',
	    value: function getSubscriber() {
	      return this.get('user');
	    }
	  }, {
	    key: 'getUserId',
	    value: function getUserId() {
	      return this.get('user').id;
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return this.get('user').getName();
	    }
	  }, {
	    key: 'getCanBecomeOwner',
	    value: function getCanBecomeOwner() {
	      return this.get('can_become_owner');
	    }
	  }, {
	    key: 'getCreatedAt',
	    value: function getCreatedAt() {
	      return this.get('created_at');
	    }
	  }, {
	    key: 'getRole',
	    value: function getRole() {
	      return this.get('role');
	    }
	  }, {
	    key: 'isBlocked',
	    value: function isBlocked() {
	      return this.get('user').get('blocked');
	    }
	  }, {
	    key: 'isOwner',
	    value: function isOwner() {
	      return this.getRole() === 'owner';
	    }
	  }, {
	    key: 'getQueryKey',
	    value: function getQueryKey() {
	      return this.get('query_key');
	    }
	  }, {
	    key: 'getTag',
	    value: function getTag() {
	      return this.get('tag');
	    }
	  }, {
	    key: 'getGroupId',
	    value: function getGroupId() {
	      return this.get('group_id');
	    }
	  }, {
	    key: 'getCanUnsubscribe',
	    value: function getCanUnsubscribe() {
	      return this.get('can_unsubscribe');
	    }
	  }, {
	    key: 'getCanChat',
	    value: function getCanChat() {
	      return this.get('can_chat');
	    }
	  }, {
	    key: 'getChatEligibilityState',
	    value: function getChatEligibilityState() {
	      return this.get('chat_eligibility_state');
	    }
	  }, {
	    key: 'getOrgAffiliationView',
	    value: function getOrgAffiliationView() {
	      return this.get('org_affiliation_view');
	    }
	  }, {
	    key: 'hasPermission',
	    value: function hasPermission(permission) {
	      var permissions = this.get('permissions');
	      if (permissions) {
	        return !!permissions[permission];
	      }
	      return false;
	    }
	  }]);
	
	  return GroupMembership;
	}(_Entity3.default);
	
	GroupMembership.displayName = 'GroupMembership';
	exports.default = GroupMembership;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _OfficeHours = __webpack_require__(922);
	
	var _OfficeHours2 = _interopRequireDefault(_OfficeHours);
	
	var _PublicDevice = __webpack_require__(1035);
	
	var _PublicDevice2 = _interopRequireDefault(_PublicDevice);
	
	var _Subscription = __webpack_require__(1008);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _Subscriptions = __webpack_require__(1009);
	
	var _Subscriptions2 = _interopRequireDefault(_Subscriptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// The user in a GroupMembership (Group <-> User relationship)
	// This is the same as User, and has the same id, but only a subset of the properties of a User
	var Subscriber = function (_Entity) {
	  _inherits(Subscriber, _Entity);
	
	  function Subscriber() {
	    _classCallCheck(this, Subscriber);
	
	    return _possibleConstructorReturn(this, (Subscriber.__proto__ || Object.getPrototypeOf(Subscriber)).apply(this, arguments));
	  }
	
	  _createClass(Subscriber, [{
	    key: 'urlRoot',
	    value: function urlRoot() {
	      return '/subscribers';
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var subscriber = _lodash2.default.clone(response);
	      if (subscriber['devices']) {
	        subscriber['devices'] = subscriber['devices'].map(function (device) {
	          return _PublicDevice2.default.fromJSON(device);
	        });
	      }
	      if (subscriber['subscriptions']) {
	        subscriber['subscriptions'] = _Subscriptions2.default.fromJSON(subscriber['subscriptions']);
	      }
	      if (subscriber['subscribed_at']) {
	        subscriber['subscribed_at'] = new Date(subscriber['subscribed_at']);
	      }
	      if (subscriber['office_hours']) {
	        subscriber['office_hours'] = _OfficeHours2.default.fromJSON(subscriber['office_hours']);
	      }
	      return subscriber;
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }, {
	    key: 'getNote',
	    value: function getNote() {
	      return this.get('note');
	    }
	  }, {
	    key: 'getRole',
	    value: function getRole() {
	      return this.get('role');
	    }
	  }, {
	    key: 'getFirstName',
	    value: function getFirstName() {
	      return this.get('first_name') || '';
	    }
	  }, {
	    key: 'getLastName',
	    value: function getLastName() {
	      return this.get('last_name') || '';
	    }
	  }, {
	    key: 'getFullName',
	    value: function getFullName() {
	      return this.getFirstName() + ' ' + this.getLastName();
	    }
	  }, {
	    key: 'getSignature',
	    value: function getSignature() {
	      return this.get('signature');
	    }
	  }, {
	    key: 'getOfficeHours',
	    value: function getOfficeHours() {
	      return this.get('office_hours');
	    }
	  }, {
	    key: 'getSubscribedAt',
	    value: function getSubscribedAt() {
	      return this.get('subscribed_at');
	    }
	  }, {
	    key: 'getMediums',
	    value: function getMediums() {
	      return this.get('mediums');
	    }
	  }, {
	    key: 'getDevices',
	    value: function getDevices() {
	      return this.get('devices');
	    }
	  }, {
	    key: 'isNotable',
	    value: function isNotable() {
	      return this.get('notable');
	    }
	  }, {
	    key: 'isBlocked',
	    value: function isBlocked() {
	      return this.get('blocked');
	    }
	  }, {
	    key: 'getUntrustedName',
	    value: function getUntrustedName() {
	      return this.get('untrusted_name');
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      return this.get('color');
	    }
	  }, {
	    key: 'getInitials',
	    value: function getInitials() {
	      return this.get('initials');
	    }
	  }, {
	    key: 'isCurrentUser',
	    value: function isCurrentUser() {
	      // XXX remove CurrentUser from entities
	      var CurrentUser = __webpack_require__(576).default;
	      return this.id === CurrentUser.getUser().id;
	    }
	  }, {
	    key: 'setNote',
	    value: function setNote(note) {
	      return this.set({ note: note });
	    }
	  }, {
	    key: 'setFirstName',
	    value: function setFirstName(firstName) {
	      return this.set({ first_name: firstName });
	    }
	  }, {
	    key: 'setLastName',
	    value: function setLastName(lastName) {
	      return this.set({ last_name: lastName });
	    }
	  }, {
	    key: 'getSubscriptions',
	    value: function getSubscriptions() {
	      return this.get('subscriptions');
	    }
	  }, {
	    key: 'getCanBeCopiedToClass',
	    value: function getCanBeCopiedToClass() {
	      return this.get('can_be_copied_to_class');
	    }
	  }, {
	    key: 'subscribe',
	    value: function subscribe(subscription) {
	      this.get('subscriptions').add(subscription);
	    }
	  }, {
	    key: 'unsubscribeFromGroup',
	    value: function unsubscribeFromGroup(group) {
	      var subscriptions = this.getSubscriptions();
	      subscriptions.filter(function (s) {
	        return s.getGroupId() === group.id;
	      }).forEach(function (sub) {
	        subscriptions.remove(sub.id);
	      });
	    }
	  }, {
	    key: 'confirmUntrustedName',
	    value: function confirmUntrustedName() {
	      return this.set({ untrusted_name: false });
	    }
	  }, {
	    key: 'toJSON',
	    value: function toJSON() {
	      var json = _get(Subscriber.prototype.__proto__ || Object.getPrototypeOf(Subscriber.prototype), 'toJSON', this).call(this);
	      if (json['subscriptions']) {
	        json['subscriptions'] = this.get('subscriptions').toJSON();
	      }
	      return json;
	    }
	  }]);
	
	  return Subscriber;
	}(_Entity3.default);
	
	Subscriber.displayName = 'Subscriber';
	exports.default = Subscriber;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_COLOR = exports.GROUP_MEMBER_PAGE_SIZE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _urijs = __webpack_require__(607);
	
	var _urijs2 = _interopRequireDefault(_urijs);
	
	var _Avatars = __webpack_require__(611);
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	var _Avatar = __webpack_require__(933);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _GroupMemberships = __webpack_require__(996);
	
	var _GroupMemberships2 = _interopRequireDefault(_GroupMemberships);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _UserConstants = __webpack_require__(1015);
	
	var _Message = __webpack_require__(930);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GROUP_MEMBER_PAGE_SIZE = exports.GROUP_MEMBER_PAGE_SIZE = 200;
	var DEFAULT_COLOR = exports.DEFAULT_COLOR = '#2f75c1';
	
	// https://github.com/remind101/r101-api/blob/master/app/api/v2/entities/medium.rb
	
	
	// https://github.com/remind101/r101-api/blob/426f7353ce7d9e8834e5792c5372ab6af3f573d9/app/api/v2/entities/group.rb#L73-L86
	
	var Group = function (_Entity) {
	  _inherits(Group, _Entity);
	
	  function Group() {
	    _classCallCheck(this, Group);
	
	    return _possibleConstructorReturn(this, (Group.__proto__ || Object.getPrototypeOf(Group)).apply(this, arguments));
	  }
	
	  _createClass(Group, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.urlRoot = '/classes';
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        class_name: '',
	        group_avatar: null,
	        has_children: false,
	        memberships_count: 1,
	        messages_count: 0,
	        name: null,
	        possessive_name: '',
	        subscriber_initiated_chats: true,
	        searchable: true,
	        type: '',
	        owners: [],
	        organization: null,
	        roles: []
	      };
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var parsed = Object.assign({}, response);
	
	      if (response['group_avatar']) {
	        parsed['group_avatar'] = _Avatar2.default.fromJSON(response['group_avatar']);
	      }
	
	      if (response['created_at']) {
	        parsed['created_at'] = new Date(response['created_at']);
	      }
	
	      if (response['owners']) {
	        parsed['owners'] = _GroupMemberships2.default.fromJSON(response['owners']);
	      }
	
	      if (response['organization']) {
	        parsed['organization'] = _Organization2.default.fromJSON(response['organization']);
	      }
	
	      if (response['archived_at']) {
	        parsed['archived_at'] = new Date(response['archived_at']);
	      }
	
	      return parsed;
	    }
	  }, {
	    key: 'url',
	    value: function url() {
	      if (!this.id) {
	        var code = this.getCode();
	        if (code) {
	          return this.urlRoot + '/@' + code;
	        }
	      }
	      return _get(Group.prototype.__proto__ || Object.getPrototypeOf(Group.prototype), 'url', this).call(this);
	    }
	  }, {
	    key: 'webUrl',
	    value: function webUrl() {
	      var code = this.getCode();
	      if (code) {
	        return '/classes/' + code;
	      }
	      return null;
	    }
	  }, {
	    key: 'isRoot',
	    value: function isRoot() {
	      return false;
	    }
	  }, {
	    key: 'getUuid',
	    value: function getUuid() {
	      return this.get('uuid');
	    }
	  }, {
	    key: 'getCreatedAt',
	    value: function getCreatedAt() {
	      return this.get('created_at');
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return this.get('class_name');
	    }
	  }, {
	    key: 'getOwners',
	    value: function getOwners() {
	      return this.get('owners');
	    }
	
	    // XXX should be immutable once created
	    // TODO move into new Group arguments at caller
	
	  }, {
	    key: 'setName',
	    value: function setName(name) {
	      this.set('class_name', name);
	    }
	  }, {
	    key: 'getCode',
	    value: function getCode() {
	      return this.get('name');
	    }
	  }, {
	    key: 'getPdfUrl',
	    value: function getPdfUrl(locale) {
	      if (locale) {
	        return new _urijs2.default(this.get('pdf_url')).addQuery('locale', locale).toString();
	      } else {
	        return this.get('pdf_url');
	      }
	    }
	  }, {
	    key: 'getJoinUrl',
	    value: function getJoinUrl() {
	      return this.get('join_url');
	    }
	  }, {
	    key: 'hasChildren',
	    value: function hasChildren() {
	      // Property is nullable on server-side, so ensure this is boolean
	      return !!this.get('has_children');
	    }
	  }, {
	    key: 'setHasChildren',
	    value: function setHasChildren(hasChildren) {
	      this.set('has_children', hasChildren);
	    }
	  }, {
	    key: 'hasStudentOrParentOwner',
	    value: function hasStudentOrParentOwner() {
	      return !!this.getOwners().some(function (p) {
	        var role = p.getUser() ? p.getUser().getRole() : '';
	        return role === _UserConstants.Roles.parent || role === _UserConstants.Roles.student;
	      });
	    }
	  }, {
	    key: 'getMembershipsCount',
	    value: function getMembershipsCount() {
	      return this.get('memberships_count');
	    }
	  }, {
	    key: 'getMembershipCountText',
	    value: function getMembershipCountText() {
	      var memberCount = this.getMembershipsCount();
	      return memberCount === 1 ? '1 person' : memberCount + ' people';
	    }
	  }, {
	    key: 'getSubscriptionInfo',
	    value: function getSubscriptionInfo() {
	      return this.get('subscribe');
	    }
	
	    // This group may support short codes, but not if the current user is in Canada
	    // $FlowFixMe
	
	  }, {
	    key: 'useShortCodeForUser',
	    value: function useShortCodeForUser(user) {
	      return this.getSubscriptionInfo().sms && user.getCountryCode() === 'US' && this.hasShortCode();
	    }
	
	    // This group may support SMS subscription, but not if the current user is in Afghanistan
	    // $FlowFixMe
	
	  }, {
	    key: 'smsEnabledForUser',
	    value: function smsEnabledForUser(user) {
	      return this.getSubscriptionInfo().sms && ['US', 'CA'].includes(user.getCountryCode());
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.get('type');
	    }
	  }, {
	    key: 'isStaffClass',
	    value: function isStaffClass() {
	      return this.getType() === 'organization';
	    }
	  }, {
	    key: 'getStaffClassOrgId',
	    value: function getStaffClassOrgId() {
	      return this.get('staff_class_org_id');
	    }
	  }, {
	    key: 'getOrganization',
	    value: function getOrganization() {
	      return this.get('organization');
	    }
	  }, {
	    key: 'setOrganization',
	    value: function setOrganization(o) {
	      this.set('organization', o);
	    }
	  }, {
	    key: 'getMessagesCount',
	    value: function getMessagesCount() {
	      return this.get('messages_count');
	    }
	  }, {
	    key: 'isMessageHistoryEnabled',
	    value: function isMessageHistoryEnabled() {
	      return this.get('message_history_enabled');
	    }
	  }, {
	    key: 'getLastReadSeq',
	    value: function getLastReadSeq() {
	      return this.get('last_read_seq');
	    }
	  }, {
	    key: 'canSubscribersInitiateChats',
	    value: function canSubscribersInitiateChats() {
	      return this.get('subscriber_initiated_chats');
	    }
	  }, {
	    key: 'setCanSubscribersInititateChats',
	    value: function setCanSubscribersInititateChats(canSubscribersInitiateChats) {
	      this.set('subscriber_initiated_chats', canSubscribersInitiateChats);
	    }
	  }, {
	    key: 'hasJoinCode',
	    value: function hasJoinCode() {
	      return !this.isStaffClass() && this.getType() !== 'root';
	    }
	  }, {
	    key: 'getPermissions',
	    value: function getPermissions() {
	      return this.get('permissions');
	    }
	  }, {
	    key: 'canJoin',
	    value: function canJoin() {
	      if (this.getPermissions()) {
	        return this.getPermissions()['can_join'];
	      }
	      return true;
	    }
	  }, {
	    key: 'isOwnedByUser',
	    value: function isOwnedByUser(userId) {
	      return this.getOwners().map(function (o) {
	        return o.getUserId();
	      }).includes(userId);
	    }
	  }, {
	    key: 'canEdit',
	    value: function canEdit() {
	      return this.getPermissions()['can_edit'];
	    }
	  }, {
	    key: 'canLeave',
	    value: function canLeave() {
	      return !this.getPermissions() || this.getPermissions()['can_leave'];
	    }
	  }, {
	    key: 'canAddOwner',
	    value: function canAddOwner() {
	      return this.canEdit() && !this.isStaffClass();
	    }
	
	    /**
	     * @deprecated use postable roles instead
	     */
	
	  }, {
	    key: 'canPost',
	    value: function canPost() {
	      return this.getPermissions()['can_post'];
	    }
	  }, {
	    key: 'canDelete',
	    value: function canDelete() {
	      return this.get('permissions')['can_delete'];
	    }
	  }, {
	    key: 'canAddPeople',
	    value: function canAddPeople() {
	      return this.getPermissions()['can_add_people'];
	    }
	  }, {
	    key: 'getPostableRoles',
	    value: function getPostableRoles() {
	      return this.getPermissions().postable_roles || [];
	    }
	  }, {
	    key: 'isSMSEnabled',
	    value: function isSMSEnabled() {
	      // while debugging https://my.trackjs.com/messages/filtered?hash=1eb254c56674faa5
	      // https://my.trackjs.com/messages/filtered?hash=43b3602fb3e91315
	      // https://github.com/remind101/r101-frontend/commit/60715a0698224de39a5000dcd2b550e5e835ea74
	      // Attributes are Group defaults, possibly because the Group entity is being accessed
	      // before the group is loaded https://my.trackjs.com/shared/NzE3ZTI4NGY1NmJmNGQ1Y2E3OTA1ODNjNGVhNjAwZmQ
	      // We recover with the catch, but what else is missing from the UI that we're not detecting?
	      try {
	        var _getSubscriptionInfo = this.getSubscriptionInfo(),
	            _sms = _getSubscriptionInfo.sms;
	
	        return !!_sms;
	      } catch (e) {
	        console.error('Group.isSMSEnabled() failed', this.attributes);
	        return false;
	      }
	    }
	  }, {
	    key: 'hasShortCode',
	    value: function hasShortCode() {
	      var _getSubscriptionInfo2 = this.getSubscriptionInfo(),
	          sms = _getSubscriptionInfo2.sms;
	
	      return sms && sms['raw'].length === 5;
	    }
	  }, {
	    key: 'getPossessiveName',
	    value: function getPossessiveName() {
	      return this.get('possessive_name');
	    }
	
	    // @return string like "B. McGriff, B. McGriff, L. Feringa, and Mr Wu's "
	
	  }, {
	    key: 'getPossessiveSignature',
	    value: function getPossessiveSignature() {
	      // TODO XXX have API send this
	      // For now, infer it from possessive_name that API does send like this:
	      // https://github.com/remind101/r101-api/blob/426f7353ce7d9e8834e5792c5372ab6af3f573d9/app/decorators/group_decorator.rb#L18-L21
	      var sigPlusName = this.getPossessiveName();
	      var startOfName = sigPlusName.indexOf(this.getName());
	      return sigPlusName.substr(0, startOfName - 1); // minus one for the space
	    }
	  }, {
	    key: 'getSMSNumber',
	    value: function getSMSNumber() {
	      var _getSubscriptionInfo3 = this.getSubscriptionInfo(),
	          sms = _getSubscriptionInfo3.sms;
	
	      if (sms) {
	        return sms.pretty;
	      }
	      return null;
	    }
	  }, {
	    key: 'getSMSAlternateNumber',
	    value: function getSMSAlternateNumber() {
	      var _getSubscriptionInfo4 = this.getSubscriptionInfo(),
	          smsAlt = _getSubscriptionInfo4.sms_alternate;
	
	      if (smsAlt) {
	        return smsAlt.pretty;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getEmail',
	    value: function getEmail() {
	      return this.getSubscriptionInfo()['email']['pretty'];
	    }
	  }, {
	    key: 'isSearchable',
	    value: function isSearchable() {
	      return this.get('searchable');
	    }
	  }, {
	    key: 'setSearchable',
	    value: function setSearchable(value) {
	      return this.set('searchable', value);
	    }
	  }, {
	    key: 'getAvatarId',
	    value: function getAvatarId() {
	      var avatar = this.get('group_avatar');
	      return avatar ? avatar.id : null;
	    }
	  }, {
	    key: 'getAvatar',
	    value: function getAvatar() {
	      return this.get('group_avatar');
	    }
	  }, {
	    key: 'getAvatarUrl',
	    value: function getAvatarUrl() {
	      var avatar = this.getAvatar();
	      return avatar ? avatar.getUrl() : (0, _Avatars.getAvatarUrlFromKey)(this.id);
	    }
	  }, {
	    key: 'getAccentColor',
	    value: function getAccentColor() {
	      var avatar = this.getAvatar();
	
	      if (avatar && avatar.getColor()) {
	        return '#' + avatar.getColor();
	      }
	
	      return DEFAULT_COLOR;
	    }
	  }, {
	    key: 'setAvatar',
	    value: function setAvatar(avatar) {
	      this.set('group_avatar', avatar);
	    }
	  }, {
	    key: 'setLastReadSeq',
	    value: function setLastReadSeq(seq) {
	      return this.set('last_read_seq', seq);
	    }
	  }, {
	    key: 'getRoles',
	    value: function getRoles() {
	      return this.get('roles');
	    }
	
	    // XXX .state is only set client side, should be in store instead of entity
	
	  }, {
	    key: 'getState',
	    value: function getState() {
	      return this.get('state');
	    }
	  }, {
	    key: 'setState',
	    value: function setState(state) {
	      return this.set({ state: state });
	    }
	  }, {
	    key: 'isAvailable',
	    value: function isAvailable() {
	      return this.getState() === 'available';
	    }
	  }, {
	    key: 'isSubscribed',
	    value: function isSubscribed() {
	      return this.getState() === 'subscribed';
	    }
	  }, {
	    key: 'setThreadPreview',
	    value: function setThreadPreview(role, preview, sentAt) {
	      var thread = this.get('threads').find(function (t) {
	        return t.role === role;
	      });
	      thread.preview = {
	        preview: preview,
	        sent_at: sentAt
	      };
	    }
	  }, {
	    key: 'getThreads',
	    value: function getThreads() {
	      var result = [];
	      var targets = this.get('threads');
	      if (targets) {
	        result = targets.map(function (t) {
	          return _extends({ type: _Message.TARGET_TYPES.GROUP_TARGET }, t);
	        });
	      }
	      return result;
	    }
	  }, {
	    key: 'getPostableThreads',
	    value: function getPostableThreads() {
	      var postableRoles = this.getPostableRoles();
	      return this.getThreads().filter(function (t) {
	        return !!postableRoles.includes(t.role);
	      });
	    }
	  }, {
	    key: 'getThread',
	    value: function getThread(role) {
	      return this.getThreads().find(function (t) {
	        return t.role === role;
	      });
	    }
	  }, {
	    key: 'loadPotentialOwners',
	    value: function loadPotentialOwners() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GROUP_MEMBER_PAGE_SIZE;
	      var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	      return _RemindAPI2.default.request(this.url() + '/potential_owners', 'GET', {
	        page: page,
	        per_page: perPage,
	        q: query
	      }).then(function (response) {
	        return _GroupMemberships2.default.fromJSON(response.potential_owners);
	      });
	    }
	  }, {
	    key: 'loadGroupMemberships',
	    value: function loadGroupMemberships(params) {
	      var parameters = _extends({
	        page: 1,
	        perPage: GROUP_MEMBER_PAGE_SIZE
	      }, params);
	
	      var options = {
	        per_page: parameters.perPage,
	        user_ids: parameters.userIds,
	        role: parameters.role,
	        page: parameters.page,
	        q: parameters.query
	      };
	
	      var resourceId = this.id || this.getUuid();
	      return _RemindAPI2.default.request('/classes/' + resourceId + '/members', 'GET', options).then(function (response) {
	        return _GroupMemberships2.default.fromJSON(response.members);
	      });
	    }
	  }, {
	    key: 'promoteGroupMemberships',
	    value: function promoteGroupMemberships(memberIds) {
	      return _RemindAPI2.default.request(this.url() + '/members', 'PATCH', {
	        members: memberIds.map(function (id) {
	          return {
	            id: id,
	            role: 'owner'
	          };
	        })
	      }).then(function (response) {
	        return _GroupMemberships2.default.fromJSON(response.members);
	      });
	    }
	  }, {
	    key: 'resignOwnership',
	    value: function resignOwnership() {
	      return _RemindAPI2.default.request('/classes/' + this.id, 'PATCH', {
	        type: 'subscribed'
	      }).then(function (group) {
	        return Group.fromJSON(group);
	      });
	    }
	
	    // $FlowFixMe
	
	  }, {
	    key: 'removeMember',
	    value: function removeMember(relatedUser) {
	      return _RemindAPI2.default.request('/classes/' + this.id + '/members/' + relatedUser.id, 'DELETE', {});
	    }
	  }, {
	    key: 'create',
	    value: function create() {
	      return _RemindAPI2.default.request('/classes', 'POST', {
	        group: {
	          has_children: this.hasChildren(),
	          class_name: this.getName(),
	          name: this.getCode(),
	          subscriber_initiated_chats: this.canSubscribersInitiateChats(),
	          group_avatar_id: this.getAvatarId(),
	          searchable: this.isSearchable(),
	          organization_id: this.getOrganization() ? this.getOrganization().id : null
	        }
	      }).then(function (group) {
	        return Group.fromJSON(group);
	      });
	    }
	  }, {
	    key: 'patch',
	    value: function patch(attributes) {
	      return this.save({}, {
	        data: attributes,
	        patch: true
	      });
	    }
	
	    // $FlowFixMe
	
	  }, {
	    key: 'addSubscribers',
	    value: function addSubscribers(subscribers) {
	      return _RemindAPI2.default.request('/classes/' + this.id + '/members', 'POST', {
	        members: subscribers.map(function (subscriber) {
	          return {
	            id: subscriber.id
	          };
	        })
	      }).then(function (response) {
	        return _GroupMemberships2.default.fromJSON(response.members);
	      });
	    }
	
	    /**
	     * Subscribes the current user to the group
	     */
	
	  }, {
	    key: 'subscribe',
	    value: function subscribe() {
	      return _RemindAPI2.default.request(this.url() + '/subscription', 'POST').then(function (group) {
	        return Group.fromJSON(group);
	      });
	    }
	
	    /**
	     * Unsubscribes the current user from the group
	     */
	
	  }, {
	    key: 'unsubscribe',
	    value: function unsubscribe() {
	      return _RemindAPI2.default.request(this.url() + '/subscription', 'DELETE');
	    }
	  }, {
	    key: 'toJSON',
	    value: function toJSON() {
	      return this.recursivelyToJSON();
	    }
	  }, {
	    key: 'archive',
	    value: function archive() {
	      return _RemindAPI2.default.request('/classes/' + this.id + '/archive', 'POST').then(function (group) {
	        return Group.fromJSON(group);
	      });
	    }
	  }, {
	    key: 'reuse',
	    value: function reuse(organizationId, groupCode) {
	      return _RemindAPI2.default.request('/classes/' + this.id + '/reuse', 'POST', {
	        organization_id: organizationId,
	        name: groupCode || null
	      }).then(function (group) {
	        return Group.fromJSON(group);
	      });
	    }
	  }, {
	    key: 'unarchive',
	    value: function unarchive(organizationId, groupCode) {
	      return _RemindAPI2.default.request('/classes/' + this.id + '/unarchive', 'POST', {
	        organization_id: organizationId,
	        name: groupCode || null
	      }).then(function (group) {
	        return Group.fromJSON(group);
	      });
	    }
	  }, {
	    key: 'isArchived',
	    value: function isArchived() {
	      return !!this.get('archived_at');
	    }
	  }, {
	    key: 'getArchivedDate',
	    value: function getArchivedDate() {
	      return this.get('archived_at');
	    }
	  }, {
	    key: 'getOriginalOrganizationId',
	    value: function getOriginalOrganizationId() {
	      return this.get('original_organization_id');
	    }
	  }], [{
	    key: 'parseAcceptableGroupCode',
	    value: function parseAcceptableGroupCode(code) {
	      var matches = code.match(/[a-zA-Z0-9-]+/);
	      return matches && matches.length === 1 ? matches[0] : null;
	    }
	  }, {
	    key: 'createGroupFromCode',
	    value: function createGroupFromCode(code) {
	      return new Group({ name: code });
	    }
	  }, {
	    key: 'fetchByCode',
	    value: function fetchByCode(groupCode) {
	      // TODO: This should be replaced by /v2/classes/:code. We currently depend on /v2/groups/:code
	      // to validate whether a group can be joined.
	      return _RemindAPI2.default.request('/groups/@' + groupCode, 'GET', {}).then(function (group) {
	        return Group.fromJSON(group);
	      });
	    }
	  }, {
	    key: 'fetchById',
	    value: function fetchById(groupId) {
	      return _RemindAPI2.default.request('/classes/' + groupId, 'GET', {}).then(function (group) {
	        return Group.fromJSON(group);
	      });
	    }
	  }, {
	    key: 'suggestCode',
	    value: function suggestCode(groupName) {
	      return _RemindAPI2.default.request('/groups/suggested_codes', 'GET', {
	        'group[class_name]': groupName
	      });
	    }
	  }, {
	    key: 'validateCodeUniqueness',
	    value: function validateCodeUniqueness(groupCode) {
	      return _RemindAPI2.default.request('/groups/valid_code', 'GET', {
	        'group[name]': groupCode
	      }).then(function (response) {
	        if (response.success) {
	          return Promise.resolve(null);
	        } else {
	          return Promise.resolve(response);
	        }
	      });
	    }
	  }]);
	
	  return Group;
	}(_Entity3.default);
	
	// Manually export this for ES5 compatibility
	
	
	Group.displayName = 'Group';
	exports.default = Group;
	Group.GROUP_MEMBER_PAGE_SIZE = GROUP_MEMBER_PAGE_SIZE;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * URI.js - Mutating URLs
	 *
	 * Version: 1.18.4
	 *
	 * Author: Rodney Rehm
	 * Web: http://medialize.github.io/URI.js/
	 *
	 * Licensed under
	 *   MIT License http://www.opensource.org/licenses/mit-license
	 *
	 */
	(function (root, factory) {
	  'use strict';
	  // https://github.com/umdjs/umd/blob/master/returnExports.js
	  if (typeof module === 'object' && module.exports) {
	    // Node
	    module.exports = factory(__webpack_require__(608), __webpack_require__(609), __webpack_require__(610));
	  } else if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(608), __webpack_require__(609), __webpack_require__(610)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Browser globals (root is window)
	    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
	  }
	}(this, function (punycode, IPv6, SLD, root) {
	  'use strict';
	  /*global location, escape, unescape */
	  // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
	  /*jshint camelcase: false */
	
	  // save current URI variable, if any
	  var _URI = root && root.URI;
	
	  function URI(url, base) {
	    var _urlSupplied = arguments.length >= 1;
	    var _baseSupplied = arguments.length >= 2;
	
	    // Allow instantiation without the 'new' keyword
	    if (!(this instanceof URI)) {
	      if (_urlSupplied) {
	        if (_baseSupplied) {
	          return new URI(url, base);
	        }
	
	        return new URI(url);
	      }
	
	      return new URI();
	    }
	
	    if (url === undefined) {
	      if (_urlSupplied) {
	        throw new TypeError('undefined is not a valid argument for URI');
	      }
	
	      if (typeof location !== 'undefined') {
	        url = location.href + '';
	      } else {
	        url = '';
	      }
	    }
	
	    this.href(url);
	
	    // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
	    if (base !== undefined) {
	      return this.absoluteTo(base);
	    }
	
	    return this;
	  }
	
	  URI.version = '1.18.4';
	
	  var p = URI.prototype;
	  var hasOwn = Object.prototype.hasOwnProperty;
	
	  function escapeRegEx(string) {
	    // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
	    return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
	  }
	
	  function getType(value) {
	    // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
	    if (value === undefined) {
	      return 'Undefined';
	    }
	
	    return String(Object.prototype.toString.call(value)).slice(8, -1);
	  }
	
	  function isArray(obj) {
	    return getType(obj) === 'Array';
	  }
	
	  function filterArrayValues(data, value) {
	    var lookup = {};
	    var i, length;
	
	    if (getType(value) === 'RegExp') {
	      lookup = null;
	    } else if (isArray(value)) {
	      for (i = 0, length = value.length; i < length; i++) {
	        lookup[value[i]] = true;
	      }
	    } else {
	      lookup[value] = true;
	    }
	
	    for (i = 0, length = data.length; i < length; i++) {
	      /*jshint laxbreak: true */
	      var _match = lookup && lookup[data[i]] !== undefined
	        || !lookup && value.test(data[i]);
	      /*jshint laxbreak: false */
	      if (_match) {
	        data.splice(i, 1);
	        length--;
	        i--;
	      }
	    }
	
	    return data;
	  }
	
	  function arrayContains(list, value) {
	    var i, length;
	
	    // value may be string, number, array, regexp
	    if (isArray(value)) {
	      // Note: this can be optimized to O(n) (instead of current O(m * n))
	      for (i = 0, length = value.length; i < length; i++) {
	        if (!arrayContains(list, value[i])) {
	          return false;
	        }
	      }
	
	      return true;
	    }
	
	    var _type = getType(value);
	    for (i = 0, length = list.length; i < length; i++) {
	      if (_type === 'RegExp') {
	        if (typeof list[i] === 'string' && list[i].match(value)) {
	          return true;
	        }
	      } else if (list[i] === value) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function arraysEqual(one, two) {
	    if (!isArray(one) || !isArray(two)) {
	      return false;
	    }
	
	    // arrays can't be equal if they have different amount of content
	    if (one.length !== two.length) {
	      return false;
	    }
	
	    one.sort();
	    two.sort();
	
	    for (var i = 0, l = one.length; i < l; i++) {
	      if (one[i] !== two[i]) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  function trimSlashes(text) {
	    var trim_expression = /^\/+|\/+$/g;
	    return text.replace(trim_expression, '');
	  }
	
	  URI._parts = function() {
	    return {
	      protocol: null,
	      username: null,
	      password: null,
	      hostname: null,
	      urn: null,
	      port: null,
	      path: null,
	      query: null,
	      fragment: null,
	      // state
	      duplicateQueryParameters: URI.duplicateQueryParameters,
	      escapeQuerySpace: URI.escapeQuerySpace
	    };
	  };
	  // state: allow duplicate query parameters (a=1&a=1)
	  URI.duplicateQueryParameters = false;
	  // state: replaces + with %20 (space in query strings)
	  URI.escapeQuerySpace = true;
	  // static properties
	  URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
	  URI.idn_expression = /[^a-z0-9\.-]/i;
	  URI.punycode_expression = /(xn--)/i;
	  // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
	  URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
	  // credits to Rich Brown
	  // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
	  // specification: http://www.ietf.org/rfc/rfc4291.txt
	  URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
	  // expression used is "gruber revised" (@gruber v2) determined to be the
	  // best solution in a regex-golf we did a couple of ages ago at
	  // * http://mathiasbynens.be/demo/url-regex
	  // * http://rodneyrehm.de/t/url-regex.html
	  URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
	  URI.findUri = {
	    // valid "scheme://" or "www."
	    start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
	    // everything up to the next whitespace
	    end: /[\s\r\n]|$/,
	    // trim trailing punctuation captured by end RegExp
	    trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
	    // balanced parens inclusion (), [], {}, <>
	    parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g,
	  };
	  // http://www.iana.org/assignments/uri-schemes.html
	  // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
	  URI.defaultPorts = {
	    http: '80',
	    https: '443',
	    ftp: '21',
	    gopher: '70',
	    ws: '80',
	    wss: '443'
	  };
	  // allowed hostname characters according to RFC 3986
	  // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
	  // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . -
	  URI.invalid_hostname_characters = /[^a-zA-Z0-9\.-]/;
	  // map DOM Elements to their URI attribute
	  URI.domAttributes = {
	    'a': 'href',
	    'blockquote': 'cite',
	    'link': 'href',
	    'base': 'href',
	    'script': 'src',
	    'form': 'action',
	    'img': 'src',
	    'area': 'href',
	    'iframe': 'src',
	    'embed': 'src',
	    'source': 'src',
	    'track': 'src',
	    'input': 'src', // but only if type="image"
	    'audio': 'src',
	    'video': 'src'
	  };
	  URI.getDomAttribute = function(node) {
	    if (!node || !node.nodeName) {
	      return undefined;
	    }
	
	    var nodeName = node.nodeName.toLowerCase();
	    // <input> should only expose src for type="image"
	    if (nodeName === 'input' && node.type !== 'image') {
	      return undefined;
	    }
	
	    return URI.domAttributes[nodeName];
	  };
	
	  function escapeForDumbFirefox36(value) {
	    // https://github.com/medialize/URI.js/issues/91
	    return escape(value);
	  }
	
	  // encoding / decoding according to RFC3986
	  function strictEncodeURIComponent(string) {
	    // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
	    return encodeURIComponent(string)
	      .replace(/[!'()*]/g, escapeForDumbFirefox36)
	      .replace(/\*/g, '%2A');
	  }
	  URI.encode = strictEncodeURIComponent;
	  URI.decode = decodeURIComponent;
	  URI.iso8859 = function() {
	    URI.encode = escape;
	    URI.decode = unescape;
	  };
	  URI.unicode = function() {
	    URI.encode = strictEncodeURIComponent;
	    URI.decode = decodeURIComponent;
	  };
	  URI.characters = {
	    pathname: {
	      encode: {
	        // RFC3986 2.1: For consistency, URI producers and normalizers should
	        // use uppercase hexadecimal digits for all percent-encodings.
	        expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
	        map: {
	          // -._~!'()*
	          '%24': '$',
	          '%26': '&',
	          '%2B': '+',
	          '%2C': ',',
	          '%3B': ';',
	          '%3D': '=',
	          '%3A': ':',
	          '%40': '@'
	        }
	      },
	      decode: {
	        expression: /[\/\?#]/g,
	        map: {
	          '/': '%2F',
	          '?': '%3F',
	          '#': '%23'
	        }
	      }
	    },
	    reserved: {
	      encode: {
	        // RFC3986 2.1: For consistency, URI producers and normalizers should
	        // use uppercase hexadecimal digits for all percent-encodings.
	        expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
	        map: {
	          // gen-delims
	          '%3A': ':',
	          '%2F': '/',
	          '%3F': '?',
	          '%23': '#',
	          '%5B': '[',
	          '%5D': ']',
	          '%40': '@',
	          // sub-delims
	          '%21': '!',
	          '%24': '$',
	          '%26': '&',
	          '%27': '\'',
	          '%28': '(',
	          '%29': ')',
	          '%2A': '*',
	          '%2B': '+',
	          '%2C': ',',
	          '%3B': ';',
	          '%3D': '='
	        }
	      }
	    },
	    urnpath: {
	      // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
	      // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
	      // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
	      // note that the colon character is not featured in the encoding map; this is because URI.js
	      // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
	      // should not appear unencoded in a segment itself.
	      // See also the note above about RFC3986 and capitalalized hex digits.
	      encode: {
	        expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
	        map: {
	          '%21': '!',
	          '%24': '$',
	          '%27': '\'',
	          '%28': '(',
	          '%29': ')',
	          '%2A': '*',
	          '%2B': '+',
	          '%2C': ',',
	          '%3B': ';',
	          '%3D': '=',
	          '%40': '@'
	        }
	      },
	      // These characters are the characters called out by RFC2141 as "reserved" characters that
	      // should never appear in a URN, plus the colon character (see note above).
	      decode: {
	        expression: /[\/\?#:]/g,
	        map: {
	          '/': '%2F',
	          '?': '%3F',
	          '#': '%23',
	          ':': '%3A'
	        }
	      }
	    }
	  };
	  URI.encodeQuery = function(string, escapeQuerySpace) {
	    var escaped = URI.encode(string + '');
	    if (escapeQuerySpace === undefined) {
	      escapeQuerySpace = URI.escapeQuerySpace;
	    }
	
	    return escapeQuerySpace ? escaped.replace(/%20/g, '+') : escaped;
	  };
	  URI.decodeQuery = function(string, escapeQuerySpace) {
	    string += '';
	    if (escapeQuerySpace === undefined) {
	      escapeQuerySpace = URI.escapeQuerySpace;
	    }
	
	    try {
	      return URI.decode(escapeQuerySpace ? string.replace(/\+/g, '%20') : string);
	    } catch(e) {
	      // we're not going to mess with weird encodings,
	      // give up and return the undecoded original string
	      // see https://github.com/medialize/URI.js/issues/87
	      // see https://github.com/medialize/URI.js/issues/92
	      return string;
	    }
	  };
	  // generate encode/decode path functions
	  var _parts = {'encode':'encode', 'decode':'decode'};
	  var _part;
	  var generateAccessor = function(_group, _part) {
	    return function(string) {
	      try {
	        return URI[_part](string + '').replace(URI.characters[_group][_part].expression, function(c) {
	          return URI.characters[_group][_part].map[c];
	        });
	      } catch (e) {
	        // we're not going to mess with weird encodings,
	        // give up and return the undecoded original string
	        // see https://github.com/medialize/URI.js/issues/87
	        // see https://github.com/medialize/URI.js/issues/92
	        return string;
	      }
	    };
	  };
	
	  for (_part in _parts) {
	    URI[_part + 'PathSegment'] = generateAccessor('pathname', _parts[_part]);
	    URI[_part + 'UrnPathSegment'] = generateAccessor('urnpath', _parts[_part]);
	  }
	
	  var generateSegmentedPathFunction = function(_sep, _codingFuncName, _innerCodingFuncName) {
	    return function(string) {
	      // Why pass in names of functions, rather than the function objects themselves? The
	      // definitions of some functions (but in particular, URI.decode) will occasionally change due
	      // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
	      // that the functions we use here are "fresh".
	      var actualCodingFunc;
	      if (!_innerCodingFuncName) {
	        actualCodingFunc = URI[_codingFuncName];
	      } else {
	        actualCodingFunc = function(string) {
	          return URI[_codingFuncName](URI[_innerCodingFuncName](string));
	        };
	      }
	
	      var segments = (string + '').split(_sep);
	
	      for (var i = 0, length = segments.length; i < length; i++) {
	        segments[i] = actualCodingFunc(segments[i]);
	      }
	
	      return segments.join(_sep);
	    };
	  };
	
	  // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
	  URI.decodePath = generateSegmentedPathFunction('/', 'decodePathSegment');
	  URI.decodeUrnPath = generateSegmentedPathFunction(':', 'decodeUrnPathSegment');
	  URI.recodePath = generateSegmentedPathFunction('/', 'encodePathSegment', 'decode');
	  URI.recodeUrnPath = generateSegmentedPathFunction(':', 'encodeUrnPathSegment', 'decode');
	
	  URI.encodeReserved = generateAccessor('reserved', 'encode');
	
	  URI.parse = function(string, parts) {
	    var pos;
	    if (!parts) {
	      parts = {};
	    }
	    // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]
	
	    // extract fragment
	    pos = string.indexOf('#');
	    if (pos > -1) {
	      // escaping?
	      parts.fragment = string.substring(pos + 1) || null;
	      string = string.substring(0, pos);
	    }
	
	    // extract query
	    pos = string.indexOf('?');
	    if (pos > -1) {
	      // escaping?
	      parts.query = string.substring(pos + 1) || null;
	      string = string.substring(0, pos);
	    }
	
	    // extract protocol
	    if (string.substring(0, 2) === '//') {
	      // relative-scheme
	      parts.protocol = null;
	      string = string.substring(2);
	      // extract "user:pass@host:port"
	      string = URI.parseAuthority(string, parts);
	    } else {
	      pos = string.indexOf(':');
	      if (pos > -1) {
	        parts.protocol = string.substring(0, pos) || null;
	        if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) {
	          // : may be within the path
	          parts.protocol = undefined;
	        } else if (string.substring(pos + 1, pos + 3) === '//') {
	          string = string.substring(pos + 3);
	
	          // extract "user:pass@host:port"
	          string = URI.parseAuthority(string, parts);
	        } else {
	          string = string.substring(pos + 1);
	          parts.urn = true;
	        }
	      }
	    }
	
	    // what's left must be the path
	    parts.path = string;
	
	    // and we're done
	    return parts;
	  };
	  URI.parseHost = function(string, parts) {
	    // Copy chrome, IE, opera backslash-handling behavior.
	    // Back slashes before the query string get converted to forward slashes
	    // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
	    // See: https://code.google.com/p/chromium/issues/detail?id=25916
	    // https://github.com/medialize/URI.js/pull/233
	    string = string.replace(/\\/g, '/');
	
	    // extract host:port
	    var pos = string.indexOf('/');
	    var bracketPos;
	    var t;
	
	    if (pos === -1) {
	      pos = string.length;
	    }
	
	    if (string.charAt(0) === '[') {
	      // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
	      // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
	      // IPv6+port in the format [2001:db8::1]:80 (for the time being)
	      bracketPos = string.indexOf(']');
	      parts.hostname = string.substring(1, bracketPos) || null;
	      parts.port = string.substring(bracketPos + 2, pos) || null;
	      if (parts.port === '/') {
	        parts.port = null;
	      }
	    } else {
	      var firstColon = string.indexOf(':');
	      var firstSlash = string.indexOf('/');
	      var nextColon = string.indexOf(':', firstColon + 1);
	      if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
	        // IPv6 host contains multiple colons - but no port
	        // this notation is actually not allowed by RFC 3986, but we're a liberal parser
	        parts.hostname = string.substring(0, pos) || null;
	        parts.port = null;
	      } else {
	        t = string.substring(0, pos).split(':');
	        parts.hostname = t[0] || null;
	        parts.port = t[1] || null;
	      }
	    }
	
	    if (parts.hostname && string.substring(pos).charAt(0) !== '/') {
	      pos++;
	      string = '/' + string;
	    }
	
	    return string.substring(pos) || '/';
	  };
	  URI.parseAuthority = function(string, parts) {
	    string = URI.parseUserinfo(string, parts);
	    return URI.parseHost(string, parts);
	  };
	  URI.parseUserinfo = function(string, parts) {
	    // extract username:password
	    var firstSlash = string.indexOf('/');
	    var pos = string.lastIndexOf('@', firstSlash > -1 ? firstSlash : string.length - 1);
	    var t;
	
	    // authority@ must come before /path
	    if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
	      t = string.substring(0, pos).split(':');
	      parts.username = t[0] ? URI.decode(t[0]) : null;
	      t.shift();
	      parts.password = t[0] ? URI.decode(t.join(':')) : null;
	      string = string.substring(pos + 1);
	    } else {
	      parts.username = null;
	      parts.password = null;
	    }
	
	    return string;
	  };
	  URI.parseQuery = function(string, escapeQuerySpace) {
	    if (!string) {
	      return {};
	    }
	
	    // throw out the funky business - "?"[name"="value"&"]+
	    string = string.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');
	
	    if (!string) {
	      return {};
	    }
	
	    var items = {};
	    var splits = string.split('&');
	    var length = splits.length;
	    var v, name, value;
	
	    for (var i = 0; i < length; i++) {
	      v = splits[i].split('=');
	      name = URI.decodeQuery(v.shift(), escapeQuerySpace);
	      // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
	      value = v.length ? URI.decodeQuery(v.join('='), escapeQuerySpace) : null;
	
	      if (hasOwn.call(items, name)) {
	        if (typeof items[name] === 'string' || items[name] === null) {
	          items[name] = [items[name]];
	        }
	
	        items[name].push(value);
	      } else {
	        items[name] = value;
	      }
	    }
	
	    return items;
	  };
	
	  URI.build = function(parts) {
	    var t = '';
	
	    if (parts.protocol) {
	      t += parts.protocol + ':';
	    }
	
	    if (!parts.urn && (t || parts.hostname)) {
	      t += '//';
	    }
	
	    t += (URI.buildAuthority(parts) || '');
	
	    if (typeof parts.path === 'string') {
	      if (parts.path.charAt(0) !== '/' && typeof parts.hostname === 'string') {
	        t += '/';
	      }
	
	      t += parts.path;
	    }
	
	    if (typeof parts.query === 'string' && parts.query) {
	      t += '?' + parts.query;
	    }
	
	    if (typeof parts.fragment === 'string' && parts.fragment) {
	      t += '#' + parts.fragment;
	    }
	    return t;
	  };
	  URI.buildHost = function(parts) {
	    var t = '';
	
	    if (!parts.hostname) {
	      return '';
	    } else if (URI.ip6_expression.test(parts.hostname)) {
	      t += '[' + parts.hostname + ']';
	    } else {
	      t += parts.hostname;
	    }
	
	    if (parts.port) {
	      t += ':' + parts.port;
	    }
	
	    return t;
	  };
	  URI.buildAuthority = function(parts) {
	    return URI.buildUserinfo(parts) + URI.buildHost(parts);
	  };
	  URI.buildUserinfo = function(parts) {
	    var t = '';
	
	    if (parts.username) {
	      t += URI.encode(parts.username);
	    }
	
	    if (parts.password) {
	      t += ':' + URI.encode(parts.password);
	    }
	
	    if (t) {
	      t += '@';
	    }
	
	    return t;
	  };
	  URI.buildQuery = function(data, duplicateQueryParameters, escapeQuerySpace) {
	    // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
	    // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
	    // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
	    // URI.js treats the query string as being application/x-www-form-urlencoded
	    // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type
	
	    var t = '';
	    var unique, key, i, length;
	    for (key in data) {
	      if (hasOwn.call(data, key) && key) {
	        if (isArray(data[key])) {
	          unique = {};
	          for (i = 0, length = data[key].length; i < length; i++) {
	            if (data[key][i] !== undefined && unique[data[key][i] + ''] === undefined) {
	              t += '&' + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
	              if (duplicateQueryParameters !== true) {
	                unique[data[key][i] + ''] = true;
	              }
	            }
	          }
	        } else if (data[key] !== undefined) {
	          t += '&' + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
	        }
	      }
	    }
	
	    return t.substring(1);
	  };
	  URI.buildQueryParameter = function(name, value, escapeQuerySpace) {
	    // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
	    // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
	    return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? '=' + URI.encodeQuery(value, escapeQuerySpace) : '');
	  };
	
	  URI.addQuery = function(data, name, value) {
	    if (typeof name === 'object') {
	      for (var key in name) {
	        if (hasOwn.call(name, key)) {
	          URI.addQuery(data, key, name[key]);
	        }
	      }
	    } else if (typeof name === 'string') {
	      if (data[name] === undefined) {
	        data[name] = value;
	        return;
	      } else if (typeof data[name] === 'string') {
	        data[name] = [data[name]];
	      }
	
	      if (!isArray(value)) {
	        value = [value];
	      }
	
	      data[name] = (data[name] || []).concat(value);
	    } else {
	      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
	    }
	  };
	  URI.removeQuery = function(data, name, value) {
	    var i, length, key;
	
	    if (isArray(name)) {
	      for (i = 0, length = name.length; i < length; i++) {
	        data[name[i]] = undefined;
	      }
	    } else if (getType(name) === 'RegExp') {
	      for (key in data) {
	        if (name.test(key)) {
	          data[key] = undefined;
	        }
	      }
	    } else if (typeof name === 'object') {
	      for (key in name) {
	        if (hasOwn.call(name, key)) {
	          URI.removeQuery(data, key, name[key]);
	        }
	      }
	    } else if (typeof name === 'string') {
	      if (value !== undefined) {
	        if (getType(value) === 'RegExp') {
	          if (!isArray(data[name]) && value.test(data[name])) {
	            data[name] = undefined;
	          } else {
	            data[name] = filterArrayValues(data[name], value);
	          }
	        } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) {
	          data[name] = undefined;
	        } else if (isArray(data[name])) {
	          data[name] = filterArrayValues(data[name], value);
	        }
	      } else {
	        data[name] = undefined;
	      }
	    } else {
	      throw new TypeError('URI.removeQuery() accepts an object, string, RegExp as the first parameter');
	    }
	  };
	  URI.hasQuery = function(data, name, value, withinArray) {
	    switch (getType(name)) {
	      case 'String':
	        // Nothing to do here
	        break;
	
	      case 'RegExp':
	        for (var key in data) {
	          if (hasOwn.call(data, key)) {
	            if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) {
	              return true;
	            }
	          }
	        }
	
	        return false;
	
	      case 'Object':
	        for (var _key in name) {
	          if (hasOwn.call(name, _key)) {
	            if (!URI.hasQuery(data, _key, name[_key])) {
	              return false;
	            }
	          }
	        }
	
	        return true;
	
	      default:
	        throw new TypeError('URI.hasQuery() accepts a string, regular expression or object as the name parameter');
	    }
	
	    switch (getType(value)) {
	      case 'Undefined':
	        // true if exists (but may be empty)
	        return name in data; // data[name] !== undefined;
	
	      case 'Boolean':
	        // true if exists and non-empty
	        var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
	        return value === _booly;
	
	      case 'Function':
	        // allow complex comparison
	        return !!value(data[name], name, data);
	
	      case 'Array':
	        if (!isArray(data[name])) {
	          return false;
	        }
	
	        var op = withinArray ? arrayContains : arraysEqual;
	        return op(data[name], value);
	
	      case 'RegExp':
	        if (!isArray(data[name])) {
	          return Boolean(data[name] && data[name].match(value));
	        }
	
	        if (!withinArray) {
	          return false;
	        }
	
	        return arrayContains(data[name], value);
	
	      case 'Number':
	        value = String(value);
	        /* falls through */
	      case 'String':
	        if (!isArray(data[name])) {
	          return data[name] === value;
	        }
	
	        if (!withinArray) {
	          return false;
	        }
	
	        return arrayContains(data[name], value);
	
	      default:
	        throw new TypeError('URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter');
	    }
	  };
	
	
	  URI.joinPaths = function() {
	    var input = [];
	    var segments = [];
	    var nonEmptySegments = 0;
	
	    for (var i = 0; i < arguments.length; i++) {
	      var url = new URI(arguments[i]);
	      input.push(url);
	      var _segments = url.segment();
	      for (var s = 0; s < _segments.length; s++) {
	        if (typeof _segments[s] === 'string') {
	          segments.push(_segments[s]);
	        }
	
	        if (_segments[s]) {
	          nonEmptySegments++;
	        }
	      }
	    }
	
	    if (!segments.length || !nonEmptySegments) {
	      return new URI('');
	    }
	
	    var uri = new URI('').segment(segments);
	
	    if (input[0].path() === '' || input[0].path().slice(0, 1) === '/') {
	      uri.path('/' + uri.path());
	    }
	
	    return uri.normalize();
	  };
	
	  URI.commonPath = function(one, two) {
	    var length = Math.min(one.length, two.length);
	    var pos;
	
	    // find first non-matching character
	    for (pos = 0; pos < length; pos++) {
	      if (one.charAt(pos) !== two.charAt(pos)) {
	        pos--;
	        break;
	      }
	    }
	
	    if (pos < 1) {
	      return one.charAt(0) === two.charAt(0) && one.charAt(0) === '/' ? '/' : '';
	    }
	
	    // revert to last /
	    if (one.charAt(pos) !== '/' || two.charAt(pos) !== '/') {
	      pos = one.substring(0, pos).lastIndexOf('/');
	    }
	
	    return one.substring(0, pos + 1);
	  };
	
	  URI.withinString = function(string, callback, options) {
	    options || (options = {});
	    var _start = options.start || URI.findUri.start;
	    var _end = options.end || URI.findUri.end;
	    var _trim = options.trim || URI.findUri.trim;
	    var _parens = options.parens || URI.findUri.parens;
	    var _attributeOpen = /[a-z0-9-]=["']?$/i;
	
	    _start.lastIndex = 0;
	    while (true) {
	      var match = _start.exec(string);
	      if (!match) {
	        break;
	      }
	
	      var start = match.index;
	      if (options.ignoreHtml) {
	        // attribut(e=["']?$)
	        var attributeOpen = string.slice(Math.max(start - 3, 0), start);
	        if (attributeOpen && _attributeOpen.test(attributeOpen)) {
	          continue;
	        }
	      }
	
	      var end = start + string.slice(start).search(_end);
	      var slice = string.slice(start, end);
	      // make sure we include well balanced parens
	      var parensEnd = -1;
	      while (true) {
	        var parensMatch = _parens.exec(slice);
	        if (!parensMatch) {
	          break;
	        }
	
	        var parensMatchEnd = parensMatch.index + parensMatch[0].length;
	        parensEnd = Math.max(parensEnd, parensMatchEnd);
	      }
	
	      if (parensEnd > -1) {
	        slice = slice.slice(0, parensEnd) + slice.slice(parensEnd + 1).replace(_trim, '');
	      } else {
	        slice = slice.replace(_trim, '');
	      }
	
	      if (options.ignore && options.ignore.test(slice)) {
	        continue;
	      }
	
	      end = start + slice.length;
	      var result = callback(slice, start, end, string);
	      if (result === undefined) {
	        _start.lastIndex = end;
	        continue;
	      }
	
	      result = String(result);
	      string = string.slice(0, start) + result + string.slice(end);
	      _start.lastIndex = start + result.length;
	    }
	
	    _start.lastIndex = 0;
	    return string;
	  };
	
	  URI.ensureValidHostname = function(v) {
	    // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
	    // they are not part of DNS and therefore ignored by URI.js
	
	    if (v.match(URI.invalid_hostname_characters)) {
	      // test punycode
	      if (!punycode) {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-] and Punycode.js is not available');
	      }
	
	      if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
	      }
	    }
	  };
	
	  // noConflict
	  URI.noConflict = function(removeAll) {
	    if (removeAll) {
	      var unconflicted = {
	        URI: this.noConflict()
	      };
	
	      if (root.URITemplate && typeof root.URITemplate.noConflict === 'function') {
	        unconflicted.URITemplate = root.URITemplate.noConflict();
	      }
	
	      if (root.IPv6 && typeof root.IPv6.noConflict === 'function') {
	        unconflicted.IPv6 = root.IPv6.noConflict();
	      }
	
	      if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === 'function') {
	        unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
	      }
	
	      return unconflicted;
	    } else if (root.URI === this) {
	      root.URI = _URI;
	    }
	
	    return this;
	  };
	
	  p.build = function(deferBuild) {
	    if (deferBuild === true) {
	      this._deferred_build = true;
	    } else if (deferBuild === undefined || this._deferred_build) {
	      this._string = URI.build(this._parts);
	      this._deferred_build = false;
	    }
	
	    return this;
	  };
	
	  p.clone = function() {
	    return new URI(this);
	  };
	
	  p.valueOf = p.toString = function() {
	    return this.build(false)._string;
	  };
	
	
	  function generateSimpleAccessor(_part){
	    return function(v, build) {
	      if (v === undefined) {
	        return this._parts[_part] || '';
	      } else {
	        this._parts[_part] = v || null;
	        this.build(!build);
	        return this;
	      }
	    };
	  }
	
	  function generatePrefixAccessor(_part, _key){
	    return function(v, build) {
	      if (v === undefined) {
	        return this._parts[_part] || '';
	      } else {
	        if (v !== null) {
	          v = v + '';
	          if (v.charAt(0) === _key) {
	            v = v.substring(1);
	          }
	        }
	
	        this._parts[_part] = v;
	        this.build(!build);
	        return this;
	      }
	    };
	  }
	
	  p.protocol = generateSimpleAccessor('protocol');
	  p.username = generateSimpleAccessor('username');
	  p.password = generateSimpleAccessor('password');
	  p.hostname = generateSimpleAccessor('hostname');
	  p.port = generateSimpleAccessor('port');
	  p.query = generatePrefixAccessor('query', '?');
	  p.fragment = generatePrefixAccessor('fragment', '#');
	
	  p.search = function(v, build) {
	    var t = this.query(v, build);
	    return typeof t === 'string' && t.length ? ('?' + t) : t;
	  };
	  p.hash = function(v, build) {
	    var t = this.fragment(v, build);
	    return typeof t === 'string' && t.length ? ('#' + t) : t;
	  };
	
	  p.pathname = function(v, build) {
	    if (v === undefined || v === true) {
	      var res = this._parts.path || (this._parts.hostname ? '/' : '');
	      return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
	    } else {
	      if (this._parts.urn) {
	        this._parts.path = v ? URI.recodeUrnPath(v) : '';
	      } else {
	        this._parts.path = v ? URI.recodePath(v) : '/';
	      }
	      this.build(!build);
	      return this;
	    }
	  };
	  p.path = p.pathname;
	  p.href = function(href, build) {
	    var key;
	
	    if (href === undefined) {
	      return this.toString();
	    }
	
	    this._string = '';
	    this._parts = URI._parts();
	
	    var _URI = href instanceof URI;
	    var _object = typeof href === 'object' && (href.hostname || href.path || href.pathname);
	    if (href.nodeName) {
	      var attribute = URI.getDomAttribute(href);
	      href = href[attribute] || '';
	      _object = false;
	    }
	
	    // window.location is reported to be an object, but it's not the sort
	    // of object we're looking for:
	    // * location.protocol ends with a colon
	    // * location.query != object.search
	    // * location.hash != object.fragment
	    // simply serializing the unknown object should do the trick
	    // (for location, not for everything...)
	    if (!_URI && _object && href.pathname !== undefined) {
	      href = href.toString();
	    }
	
	    if (typeof href === 'string' || href instanceof String) {
	      this._parts = URI.parse(String(href), this._parts);
	    } else if (_URI || _object) {
	      var src = _URI ? href._parts : href;
	      for (key in src) {
	        if (hasOwn.call(this._parts, key)) {
	          this._parts[key] = src[key];
	        }
	      }
	    } else {
	      throw new TypeError('invalid input');
	    }
	
	    this.build(!build);
	    return this;
	  };
	
	  // identification accessors
	  p.is = function(what) {
	    var ip = false;
	    var ip4 = false;
	    var ip6 = false;
	    var name = false;
	    var sld = false;
	    var idn = false;
	    var punycode = false;
	    var relative = !this._parts.urn;
	
	    if (this._parts.hostname) {
	      relative = false;
	      ip4 = URI.ip4_expression.test(this._parts.hostname);
	      ip6 = URI.ip6_expression.test(this._parts.hostname);
	      ip = ip4 || ip6;
	      name = !ip;
	      sld = name && SLD && SLD.has(this._parts.hostname);
	      idn = name && URI.idn_expression.test(this._parts.hostname);
	      punycode = name && URI.punycode_expression.test(this._parts.hostname);
	    }
	
	    switch (what.toLowerCase()) {
	      case 'relative':
	        return relative;
	
	      case 'absolute':
	        return !relative;
	
	      // hostname identification
	      case 'domain':
	      case 'name':
	        return name;
	
	      case 'sld':
	        return sld;
	
	      case 'ip':
	        return ip;
	
	      case 'ip4':
	      case 'ipv4':
	      case 'inet4':
	        return ip4;
	
	      case 'ip6':
	      case 'ipv6':
	      case 'inet6':
	        return ip6;
	
	      case 'idn':
	        return idn;
	
	      case 'url':
	        return !this._parts.urn;
	
	      case 'urn':
	        return !!this._parts.urn;
	
	      case 'punycode':
	        return punycode;
	    }
	
	    return null;
	  };
	
	  // component specific input validation
	  var _protocol = p.protocol;
	  var _port = p.port;
	  var _hostname = p.hostname;
	
	  p.protocol = function(v, build) {
	    if (v !== undefined) {
	      if (v) {
	        // accept trailing ://
	        v = v.replace(/:(\/\/)?$/, '');
	
	        if (!v.match(URI.protocol_expression)) {
	          throw new TypeError('Protocol "' + v + '" contains characters other than [A-Z0-9.+-] or doesn\'t start with [A-Z]');
	        }
	      }
	    }
	    return _protocol.call(this, v, build);
	  };
	  p.scheme = p.protocol;
	  p.port = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v !== undefined) {
	      if (v === 0) {
	        v = null;
	      }
	
	      if (v) {
	        v += '';
	        if (v.charAt(0) === ':') {
	          v = v.substring(1);
	        }
	
	        if (v.match(/[^0-9]/)) {
	          throw new TypeError('Port "' + v + '" contains characters other than [0-9]');
	        }
	      }
	    }
	    return _port.call(this, v, build);
	  };
	  p.hostname = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v !== undefined) {
	      var x = {};
	      var res = URI.parseHost(v, x);
	      if (res !== '/') {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
	      }
	
	      v = x.hostname;
	    }
	    return _hostname.call(this, v, build);
	  };
	
	  // compound accessors
	  p.origin = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined) {
	      var protocol = this.protocol();
	      var authority = this.authority();
	      if (!authority) {
	        return '';
	      }
	
	      return (protocol ? protocol + '://' : '') + this.authority();
	    } else {
	      var origin = URI(v);
	      this
	        .protocol(origin.protocol())
	        .authority(origin.authority())
	        .build(!build);
	      return this;
	    }
	  };
	  p.host = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined) {
	      return this._parts.hostname ? URI.buildHost(this._parts) : '';
	    } else {
	      var res = URI.parseHost(v, this._parts);
	      if (res !== '/') {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.authority = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined) {
	      return this._parts.hostname ? URI.buildAuthority(this._parts) : '';
	    } else {
	      var res = URI.parseAuthority(v, this._parts);
	      if (res !== '/') {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.userinfo = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined) {
	      var t = URI.buildUserinfo(this._parts);
	      return t ? t.substring(0, t.length -1) : t;
	    } else {
	      if (v[v.length-1] !== '@') {
	        v += '@';
	      }
	
	      URI.parseUserinfo(v, this._parts);
	      this.build(!build);
	      return this;
	    }
	  };
	  p.resource = function(v, build) {
	    var parts;
	
	    if (v === undefined) {
	      return this.path() + this.search() + this.hash();
	    }
	
	    parts = URI.parse(v);
	    this._parts.path = parts.path;
	    this._parts.query = parts.query;
	    this._parts.fragment = parts.fragment;
	    this.build(!build);
	    return this;
	  };
	
	  // fraction accessors
	  p.subdomain = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    // convenience, return "www" from "www.example.org"
	    if (v === undefined) {
	      if (!this._parts.hostname || this.is('IP')) {
	        return '';
	      }
	
	      // grab domain and add another segment
	      var end = this._parts.hostname.length - this.domain().length - 1;
	      return this._parts.hostname.substring(0, end) || '';
	    } else {
	      var e = this._parts.hostname.length - this.domain().length;
	      var sub = this._parts.hostname.substring(0, e);
	      var replace = new RegExp('^' + escapeRegEx(sub));
	
	      if (v && v.charAt(v.length - 1) !== '.') {
	        v += '.';
	      }
	
	      if (v) {
	        URI.ensureValidHostname(v);
	      }
	
	      this._parts.hostname = this._parts.hostname.replace(replace, v);
	      this.build(!build);
	      return this;
	    }
	  };
	  p.domain = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (typeof v === 'boolean') {
	      build = v;
	      v = undefined;
	    }
	
	    // convenience, return "example.org" from "www.example.org"
	    if (v === undefined) {
	      if (!this._parts.hostname || this.is('IP')) {
	        return '';
	      }
	
	      // if hostname consists of 1 or 2 segments, it must be the domain
	      var t = this._parts.hostname.match(/\./g);
	      if (t && t.length < 2) {
	        return this._parts.hostname;
	      }
	
	      // grab tld and add another segment
	      var end = this._parts.hostname.length - this.tld(build).length - 1;
	      end = this._parts.hostname.lastIndexOf('.', end -1) + 1;
	      return this._parts.hostname.substring(end) || '';
	    } else {
	      if (!v) {
	        throw new TypeError('cannot set domain empty');
	      }
	
	      URI.ensureValidHostname(v);
	
	      if (!this._parts.hostname || this.is('IP')) {
	        this._parts.hostname = v;
	      } else {
	        var replace = new RegExp(escapeRegEx(this.domain()) + '$');
	        this._parts.hostname = this._parts.hostname.replace(replace, v);
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.tld = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (typeof v === 'boolean') {
	      build = v;
	      v = undefined;
	    }
	
	    // return "org" from "www.example.org"
	    if (v === undefined) {
	      if (!this._parts.hostname || this.is('IP')) {
	        return '';
	      }
	
	      var pos = this._parts.hostname.lastIndexOf('.');
	      var tld = this._parts.hostname.substring(pos + 1);
	
	      if (build !== true && SLD && SLD.list[tld.toLowerCase()]) {
	        return SLD.get(this._parts.hostname) || tld;
	      }
	
	      return tld;
	    } else {
	      var replace;
	
	      if (!v) {
	        throw new TypeError('cannot set TLD empty');
	      } else if (v.match(/[^a-zA-Z0-9-]/)) {
	        if (SLD && SLD.is(v)) {
	          replace = new RegExp(escapeRegEx(this.tld()) + '$');
	          this._parts.hostname = this._parts.hostname.replace(replace, v);
	        } else {
	          throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
	        }
	      } else if (!this._parts.hostname || this.is('IP')) {
	        throw new ReferenceError('cannot set TLD on non-domain host');
	      } else {
	        replace = new RegExp(escapeRegEx(this.tld()) + '$');
	        this._parts.hostname = this._parts.hostname.replace(replace, v);
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.directory = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined || v === true) {
	      if (!this._parts.path && !this._parts.hostname) {
	        return '';
	      }
	
	      if (this._parts.path === '/') {
	        return '/';
	      }
	
	      var end = this._parts.path.length - this.filename().length - 1;
	      var res = this._parts.path.substring(0, end) || (this._parts.hostname ? '/' : '');
	
	      return v ? URI.decodePath(res) : res;
	
	    } else {
	      var e = this._parts.path.length - this.filename().length;
	      var directory = this._parts.path.substring(0, e);
	      var replace = new RegExp('^' + escapeRegEx(directory));
	
	      // fully qualifier directories begin with a slash
	      if (!this.is('relative')) {
	        if (!v) {
	          v = '/';
	        }
	
	        if (v.charAt(0) !== '/') {
	          v = '/' + v;
	        }
	      }
	
	      // directories always end with a slash
	      if (v && v.charAt(v.length - 1) !== '/') {
	        v += '/';
	      }
	
	      v = URI.recodePath(v);
	      this._parts.path = this._parts.path.replace(replace, v);
	      this.build(!build);
	      return this;
	    }
	  };
	  p.filename = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined || v === true) {
	      if (!this._parts.path || this._parts.path === '/') {
	        return '';
	      }
	
	      var pos = this._parts.path.lastIndexOf('/');
	      var res = this._parts.path.substring(pos+1);
	
	      return v ? URI.decodePathSegment(res) : res;
	    } else {
	      var mutatedDirectory = false;
	
	      if (v.charAt(0) === '/') {
	        v = v.substring(1);
	      }
	
	      if (v.match(/\.?\//)) {
	        mutatedDirectory = true;
	      }
	
	      var replace = new RegExp(escapeRegEx(this.filename()) + '$');
	      v = URI.recodePath(v);
	      this._parts.path = this._parts.path.replace(replace, v);
	
	      if (mutatedDirectory) {
	        this.normalizePath(build);
	      } else {
	        this.build(!build);
	      }
	
	      return this;
	    }
	  };
	  p.suffix = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined || v === true) {
	      if (!this._parts.path || this._parts.path === '/') {
	        return '';
	      }
	
	      var filename = this.filename();
	      var pos = filename.lastIndexOf('.');
	      var s, res;
	
	      if (pos === -1) {
	        return '';
	      }
	
	      // suffix may only contain alnum characters (yup, I made this up.)
	      s = filename.substring(pos+1);
	      res = (/^[a-z0-9%]+$/i).test(s) ? s : '';
	      return v ? URI.decodePathSegment(res) : res;
	    } else {
	      if (v.charAt(0) === '.') {
	        v = v.substring(1);
	      }
	
	      var suffix = this.suffix();
	      var replace;
	
	      if (!suffix) {
	        if (!v) {
	          return this;
	        }
	
	        this._parts.path += '.' + URI.recodePath(v);
	      } else if (!v) {
	        replace = new RegExp(escapeRegEx('.' + suffix) + '$');
	      } else {
	        replace = new RegExp(escapeRegEx(suffix) + '$');
	      }
	
	      if (replace) {
	        v = URI.recodePath(v);
	        this._parts.path = this._parts.path.replace(replace, v);
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.segment = function(segment, v, build) {
	    var separator = this._parts.urn ? ':' : '/';
	    var path = this.path();
	    var absolute = path.substring(0, 1) === '/';
	    var segments = path.split(separator);
	
	    if (segment !== undefined && typeof segment !== 'number') {
	      build = v;
	      v = segment;
	      segment = undefined;
	    }
	
	    if (segment !== undefined && typeof segment !== 'number') {
	      throw new Error('Bad segment "' + segment + '", must be 0-based integer');
	    }
	
	    if (absolute) {
	      segments.shift();
	    }
	
	    if (segment < 0) {
	      // allow negative indexes to address from the end
	      segment = Math.max(segments.length + segment, 0);
	    }
	
	    if (v === undefined) {
	      /*jshint laxbreak: true */
	      return segment === undefined
	        ? segments
	        : segments[segment];
	      /*jshint laxbreak: false */
	    } else if (segment === null || segments[segment] === undefined) {
	      if (isArray(v)) {
	        segments = [];
	        // collapse empty elements within array
	        for (var i=0, l=v.length; i < l; i++) {
	          if (!v[i].length && (!segments.length || !segments[segments.length -1].length)) {
	            continue;
	          }
	
	          if (segments.length && !segments[segments.length -1].length) {
	            segments.pop();
	          }
	
	          segments.push(trimSlashes(v[i]));
	        }
	      } else if (v || typeof v === 'string') {
	        v = trimSlashes(v);
	        if (segments[segments.length -1] === '') {
	          // empty trailing elements have to be overwritten
	          // to prevent results such as /foo//bar
	          segments[segments.length -1] = v;
	        } else {
	          segments.push(v);
	        }
	      }
	    } else {
	      if (v) {
	        segments[segment] = trimSlashes(v);
	      } else {
	        segments.splice(segment, 1);
	      }
	    }
	
	    if (absolute) {
	      segments.unshift('');
	    }
	
	    return this.path(segments.join(separator), build);
	  };
	  p.segmentCoded = function(segment, v, build) {
	    var segments, i, l;
	
	    if (typeof segment !== 'number') {
	      build = v;
	      v = segment;
	      segment = undefined;
	    }
	
	    if (v === undefined) {
	      segments = this.segment(segment, v, build);
	      if (!isArray(segments)) {
	        segments = segments !== undefined ? URI.decode(segments) : undefined;
	      } else {
	        for (i = 0, l = segments.length; i < l; i++) {
	          segments[i] = URI.decode(segments[i]);
	        }
	      }
	
	      return segments;
	    }
	
	    if (!isArray(v)) {
	      v = (typeof v === 'string' || v instanceof String) ? URI.encode(v) : v;
	    } else {
	      for (i = 0, l = v.length; i < l; i++) {
	        v[i] = URI.encode(v[i]);
	      }
	    }
	
	    return this.segment(segment, v, build);
	  };
	
	  // mutating query string
	  var q = p.query;
	  p.query = function(v, build) {
	    if (v === true) {
	      return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    } else if (typeof v === 'function') {
	      var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	      var result = v.call(this, data);
	      this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	      this.build(!build);
	      return this;
	    } else if (v !== undefined && typeof v !== 'string') {
	      this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	      this.build(!build);
	      return this;
	    } else {
	      return q.call(this, v, build);
	    }
	  };
	  p.setQuery = function(name, value, build) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	
	    if (typeof name === 'string' || name instanceof String) {
	      data[name] = value !== undefined ? value : null;
	    } else if (typeof name === 'object') {
	      for (var key in name) {
	        if (hasOwn.call(name, key)) {
	          data[key] = name[key];
	        }
	      }
	    } else {
	      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
	    }
	
	    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	    if (typeof name !== 'string') {
	      build = value;
	    }
	
	    this.build(!build);
	    return this;
	  };
	  p.addQuery = function(name, value, build) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    URI.addQuery(data, name, value === undefined ? null : value);
	    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	    if (typeof name !== 'string') {
	      build = value;
	    }
	
	    this.build(!build);
	    return this;
	  };
	  p.removeQuery = function(name, value, build) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    URI.removeQuery(data, name, value);
	    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	    if (typeof name !== 'string') {
	      build = value;
	    }
	
	    this.build(!build);
	    return this;
	  };
	  p.hasQuery = function(name, value, withinArray) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    return URI.hasQuery(data, name, value, withinArray);
	  };
	  p.setSearch = p.setQuery;
	  p.addSearch = p.addQuery;
	  p.removeSearch = p.removeQuery;
	  p.hasSearch = p.hasQuery;
	
	  // sanitizing URLs
	  p.normalize = function() {
	    if (this._parts.urn) {
	      return this
	        .normalizeProtocol(false)
	        .normalizePath(false)
	        .normalizeQuery(false)
	        .normalizeFragment(false)
	        .build();
	    }
	
	    return this
	      .normalizeProtocol(false)
	      .normalizeHostname(false)
	      .normalizePort(false)
	      .normalizePath(false)
	      .normalizeQuery(false)
	      .normalizeFragment(false)
	      .build();
	  };
	  p.normalizeProtocol = function(build) {
	    if (typeof this._parts.protocol === 'string') {
	      this._parts.protocol = this._parts.protocol.toLowerCase();
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizeHostname = function(build) {
	    if (this._parts.hostname) {
	      if (this.is('IDN') && punycode) {
	        this._parts.hostname = punycode.toASCII(this._parts.hostname);
	      } else if (this.is('IPv6') && IPv6) {
	        this._parts.hostname = IPv6.best(this._parts.hostname);
	      }
	
	      this._parts.hostname = this._parts.hostname.toLowerCase();
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizePort = function(build) {
	    // remove port of it's the protocol's default
	    if (typeof this._parts.protocol === 'string' && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
	      this._parts.port = null;
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizePath = function(build) {
	    var _path = this._parts.path;
	    if (!_path) {
	      return this;
	    }
	
	    if (this._parts.urn) {
	      this._parts.path = URI.recodeUrnPath(this._parts.path);
	      this.build(!build);
	      return this;
	    }
	
	    if (this._parts.path === '/') {
	      return this;
	    }
	
	    _path = URI.recodePath(_path);
	
	    var _was_relative;
	    var _leadingParents = '';
	    var _parent, _pos;
	
	    // handle relative paths
	    if (_path.charAt(0) !== '/') {
	      _was_relative = true;
	      _path = '/' + _path;
	    }
	
	    // handle relative files (as opposed to directories)
	    if (_path.slice(-3) === '/..' || _path.slice(-2) === '/.') {
	      _path += '/';
	    }
	
	    // resolve simples
	    _path = _path
	      .replace(/(\/(\.\/)+)|(\/\.$)/g, '/')
	      .replace(/\/{2,}/g, '/');
	
	    // remember leading parents
	    if (_was_relative) {
	      _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || '';
	      if (_leadingParents) {
	        _leadingParents = _leadingParents[0];
	      }
	    }
	
	    // resolve parents
	    while (true) {
	      _parent = _path.search(/\/\.\.(\/|$)/);
	      if (_parent === -1) {
	        // no more ../ to resolve
	        break;
	      } else if (_parent === 0) {
	        // top level cannot be relative, skip it
	        _path = _path.substring(3);
	        continue;
	      }
	
	      _pos = _path.substring(0, _parent).lastIndexOf('/');
	      if (_pos === -1) {
	        _pos = _parent;
	      }
	      _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
	    }
	
	    // revert to relative
	    if (_was_relative && this.is('relative')) {
	      _path = _leadingParents + _path.substring(1);
	    }
	
	    this._parts.path = _path;
	    this.build(!build);
	    return this;
	  };
	  p.normalizePathname = p.normalizePath;
	  p.normalizeQuery = function(build) {
	    if (typeof this._parts.query === 'string') {
	      if (!this._parts.query.length) {
	        this._parts.query = null;
	      } else {
	        this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
	      }
	
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizeFragment = function(build) {
	    if (!this._parts.fragment) {
	      this._parts.fragment = null;
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizeSearch = p.normalizeQuery;
	  p.normalizeHash = p.normalizeFragment;
	
	  p.iso8859 = function() {
	    // expect unicode input, iso8859 output
	    var e = URI.encode;
	    var d = URI.decode;
	
	    URI.encode = escape;
	    URI.decode = decodeURIComponent;
	    try {
	      this.normalize();
	    } finally {
	      URI.encode = e;
	      URI.decode = d;
	    }
	    return this;
	  };
	
	  p.unicode = function() {
	    // expect iso8859 input, unicode output
	    var e = URI.encode;
	    var d = URI.decode;
	
	    URI.encode = strictEncodeURIComponent;
	    URI.decode = unescape;
	    try {
	      this.normalize();
	    } finally {
	      URI.encode = e;
	      URI.decode = d;
	    }
	    return this;
	  };
	
	  p.readable = function() {
	    var uri = this.clone();
	    // removing username, password, because they shouldn't be displayed according to RFC 3986
	    uri.username('').password('').normalize();
	    var t = '';
	    if (uri._parts.protocol) {
	      t += uri._parts.protocol + '://';
	    }
	
	    if (uri._parts.hostname) {
	      if (uri.is('punycode') && punycode) {
	        t += punycode.toUnicode(uri._parts.hostname);
	        if (uri._parts.port) {
	          t += ':' + uri._parts.port;
	        }
	      } else {
	        t += uri.host();
	      }
	    }
	
	    if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== '/') {
	      t += '/';
	    }
	
	    t += uri.path(true);
	    if (uri._parts.query) {
	      var q = '';
	      for (var i = 0, qp = uri._parts.query.split('&'), l = qp.length; i < l; i++) {
	        var kv = (qp[i] || '').split('=');
	        q += '&' + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace)
	          .replace(/&/g, '%26');
	
	        if (kv[1] !== undefined) {
	          q += '=' + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace)
	            .replace(/&/g, '%26');
	        }
	      }
	      t += '?' + q.substring(1);
	    }
	
	    t += URI.decodeQuery(uri.hash(), true);
	    return t;
	  };
	
	  // resolving relative and absolute URLs
	  p.absoluteTo = function(base) {
	    var resolved = this.clone();
	    var properties = ['protocol', 'username', 'password', 'hostname', 'port'];
	    var basedir, i, p;
	
	    if (this._parts.urn) {
	      throw new Error('URNs do not have any generally defined hierarchical components');
	    }
	
	    if (!(base instanceof URI)) {
	      base = new URI(base);
	    }
	
	    if (!resolved._parts.protocol) {
	      resolved._parts.protocol = base._parts.protocol;
	    }
	
	    if (this._parts.hostname) {
	      return resolved;
	    }
	
	    for (i = 0; (p = properties[i]); i++) {
	      resolved._parts[p] = base._parts[p];
	    }
	
	    if (!resolved._parts.path) {
	      resolved._parts.path = base._parts.path;
	      if (!resolved._parts.query) {
	        resolved._parts.query = base._parts.query;
	      }
	    } else {
	      if (resolved._parts.path.substring(-2) === '..') {
	        resolved._parts.path += '/';
	      }
	
	      if (resolved.path().charAt(0) !== '/') {
	        basedir = base.directory();
	        basedir = basedir ? basedir : base.path().indexOf('/') === 0 ? '/' : '';
	        resolved._parts.path = (basedir ? (basedir + '/') : '') + resolved._parts.path;
	        resolved.normalizePath();
	      }
	    }
	
	    resolved.build();
	    return resolved;
	  };
	  p.relativeTo = function(base) {
	    var relative = this.clone().normalize();
	    var relativeParts, baseParts, common, relativePath, basePath;
	
	    if (relative._parts.urn) {
	      throw new Error('URNs do not have any generally defined hierarchical components');
	    }
	
	    base = new URI(base).normalize();
	    relativeParts = relative._parts;
	    baseParts = base._parts;
	    relativePath = relative.path();
	    basePath = base.path();
	
	    if (relativePath.charAt(0) !== '/') {
	      throw new Error('URI is already relative');
	    }
	
	    if (basePath.charAt(0) !== '/') {
	      throw new Error('Cannot calculate a URI relative to another relative URI');
	    }
	
	    if (relativeParts.protocol === baseParts.protocol) {
	      relativeParts.protocol = null;
	    }
	
	    if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) {
	      return relative.build();
	    }
	
	    if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) {
	      return relative.build();
	    }
	
	    if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
	      relativeParts.hostname = null;
	      relativeParts.port = null;
	    } else {
	      return relative.build();
	    }
	
	    if (relativePath === basePath) {
	      relativeParts.path = '';
	      return relative.build();
	    }
	
	    // determine common sub path
	    common = URI.commonPath(relativePath, basePath);
	
	    // If the paths have nothing in common, return a relative URL with the absolute path.
	    if (!common) {
	      return relative.build();
	    }
	
	    var parents = baseParts.path
	      .substring(common.length)
	      .replace(/[^\/]*$/, '')
	      .replace(/.*?\//g, '../');
	
	    relativeParts.path = (parents + relativeParts.path.substring(common.length)) || './';
	
	    return relative.build();
	  };
	
	  // comparing URIs
	  p.equals = function(uri) {
	    var one = this.clone();
	    var two = new URI(uri);
	    var one_map = {};
	    var two_map = {};
	    var checked = {};
	    var one_query, two_query, key;
	
	    one.normalize();
	    two.normalize();
	
	    // exact match
	    if (one.toString() === two.toString()) {
	      return true;
	    }
	
	    // extract query string
	    one_query = one.query();
	    two_query = two.query();
	    one.query('');
	    two.query('');
	
	    // definitely not equal if not even non-query parts match
	    if (one.toString() !== two.toString()) {
	      return false;
	    }
	
	    // query parameters have the same length, even if they're permuted
	    if (one_query.length !== two_query.length) {
	      return false;
	    }
	
	    one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
	    two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);
	
	    for (key in one_map) {
	      if (hasOwn.call(one_map, key)) {
	        if (!isArray(one_map[key])) {
	          if (one_map[key] !== two_map[key]) {
	            return false;
	          }
	        } else if (!arraysEqual(one_map[key], two_map[key])) {
	          return false;
	        }
	
	        checked[key] = true;
	      }
	    }
	
	    for (key in two_map) {
	      if (hasOwn.call(two_map, key)) {
	        if (!checked[key]) {
	          // two contains a parameter not present in one
	          return false;
	        }
	      }
	    }
	
	    return true;
	  };
	
	  // state
	  p.duplicateQueryParameters = function(v) {
	    this._parts.duplicateQueryParameters = !!v;
	    return this;
	  };
	
	  p.escapeQuerySpace = function(v) {
	    this._parts.escapeQuerySpace = !!v;
	    return this;
	  };
	
	  return URI;
	}));


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.4.0 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw new RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * https://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) {
				// in Node.js, io.js, or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else {
				// in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else {
			// in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(490)(module), (function() { return this; }())))

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * URI.js - Mutating URLs
	 * IPv6 Support
	 *
	 * Version: 1.18.4
	 *
	 * Author: Rodney Rehm
	 * Web: http://medialize.github.io/URI.js/
	 *
	 * Licensed under
	 *   MIT License http://www.opensource.org/licenses/mit-license
	 *
	 */
	
	(function (root, factory) {
	  'use strict';
	  // https://github.com/umdjs/umd/blob/master/returnExports.js
	  if (typeof module === 'object' && module.exports) {
	    // Node
	    module.exports = factory();
	  } else if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Browser globals (root is window)
	    root.IPv6 = factory(root);
	  }
	}(this, function (root) {
	  'use strict';
	
	  /*
	  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
	  var _out = IPv6.best(_in);
	  var _expected = "fe80::204:61ff:fe9d:f156";
	
	  console.log(_in, _out, _expected, _out === _expected);
	  */
	
	  // save current IPv6 variable, if any
	  var _IPv6 = root && root.IPv6;
	
	  function bestPresentation(address) {
	    // based on:
	    // Javascript to test an IPv6 address for proper format, and to
	    // present the "best text representation" according to IETF Draft RFC at
	    // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
	    // 8 Feb 2010 Rich Brown, Dartware, LLC
	    // Please feel free to use this code as long as you provide a link to
	    // http://www.intermapper.com
	    // http://intermapper.com/support/tools/IPV6-Validator.aspx
	    // http://download.dartware.com/thirdparty/ipv6validator.js
	
	    var _address = address.toLowerCase();
	    var segments = _address.split(':');
	    var length = segments.length;
	    var total = 8;
	
	    // trim colons (:: or ::a:b:c… or …a:b:c::)
	    if (segments[0] === '' && segments[1] === '' && segments[2] === '') {
	      // must have been ::
	      // remove first two items
	      segments.shift();
	      segments.shift();
	    } else if (segments[0] === '' && segments[1] === '') {
	      // must have been ::xxxx
	      // remove the first item
	      segments.shift();
	    } else if (segments[length - 1] === '' && segments[length - 2] === '') {
	      // must have been xxxx::
	      segments.pop();
	    }
	
	    length = segments.length;
	
	    // adjust total segments for IPv4 trailer
	    if (segments[length - 1].indexOf('.') !== -1) {
	      // found a "." which means IPv4
	      total = 7;
	    }
	
	    // fill empty segments them with "0000"
	    var pos;
	    for (pos = 0; pos < length; pos++) {
	      if (segments[pos] === '') {
	        break;
	      }
	    }
	
	    if (pos < total) {
	      segments.splice(pos, 1, '0000');
	      while (segments.length < total) {
	        segments.splice(pos, 0, '0000');
	      }
	    }
	
	    // strip leading zeros
	    var _segments;
	    for (var i = 0; i < total; i++) {
	      _segments = segments[i].split('');
	      for (var j = 0; j < 3 ; j++) {
	        if (_segments[0] === '0' && _segments.length > 1) {
	          _segments.splice(0,1);
	        } else {
	          break;
	        }
	      }
	
	      segments[i] = _segments.join('');
	    }
	
	    // find longest sequence of zeroes and coalesce them into one segment
	    var best = -1;
	    var _best = 0;
	    var _current = 0;
	    var current = -1;
	    var inzeroes = false;
	    // i; already declared
	
	    for (i = 0; i < total; i++) {
	      if (inzeroes) {
	        if (segments[i] === '0') {
	          _current += 1;
	        } else {
	          inzeroes = false;
	          if (_current > _best) {
	            best = current;
	            _best = _current;
	          }
	        }
	      } else {
	        if (segments[i] === '0') {
	          inzeroes = true;
	          current = i;
	          _current = 1;
	        }
	      }
	    }
	
	    if (_current > _best) {
	      best = current;
	      _best = _current;
	    }
	
	    if (_best > 1) {
	      segments.splice(best, _best, '');
	    }
	
	    length = segments.length;
	
	    // assemble remaining segments
	    var result = '';
	    if (segments[0] === '')  {
	      result = ':';
	    }
	
	    for (i = 0; i < length; i++) {
	      result += segments[i];
	      if (i === length - 1) {
	        break;
	      }
	
	      result += ':';
	    }
	
	    if (segments[length - 1] === '') {
	      result += ':';
	    }
	
	    return result;
	  }
	
	  function noConflict() {
	    /*jshint validthis: true */
	    if (root.IPv6 === this) {
	      root.IPv6 = _IPv6;
	    }
	  
	    return this;
	  }
	
	  return {
	    best: bestPresentation,
	    noConflict: noConflict
	  };
	}));


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * URI.js - Mutating URLs
	 * Second Level Domain (SLD) Support
	 *
	 * Version: 1.18.4
	 *
	 * Author: Rodney Rehm
	 * Web: http://medialize.github.io/URI.js/
	 *
	 * Licensed under
	 *   MIT License http://www.opensource.org/licenses/mit-license
	 *
	 */
	
	(function (root, factory) {
	  'use strict';
	  // https://github.com/umdjs/umd/blob/master/returnExports.js
	  if (typeof module === 'object' && module.exports) {
	    // Node
	    module.exports = factory();
	  } else if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Browser globals (root is window)
	    root.SecondLevelDomains = factory(root);
	  }
	}(this, function (root) {
	  'use strict';
	
	  // save current SecondLevelDomains variable, if any
	  var _SecondLevelDomains = root && root.SecondLevelDomains;
	
	  var SLD = {
	    // list of known Second Level Domains
	    // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
	    // ----
	    // publicsuffix.org is more current and actually used by a couple of browsers internally.
	    // downside is it also contains domains like "dyndns.org" - which is fine for the security
	    // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
	    // ----
	    list: {
	      'ac':' com gov mil net org ',
	      'ae':' ac co gov mil name net org pro sch ',
	      'af':' com edu gov net org ',
	      'al':' com edu gov mil net org ',
	      'ao':' co ed gv it og pb ',
	      'ar':' com edu gob gov int mil net org tur ',
	      'at':' ac co gv or ',
	      'au':' asn com csiro edu gov id net org ',
	      'ba':' co com edu gov mil net org rs unbi unmo unsa untz unze ',
	      'bb':' biz co com edu gov info net org store tv ',
	      'bh':' biz cc com edu gov info net org ',
	      'bn':' com edu gov net org ',
	      'bo':' com edu gob gov int mil net org tv ',
	      'br':' adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ',
	      'bs':' com edu gov net org ',
	      'bz':' du et om ov rg ',
	      'ca':' ab bc mb nb nf nl ns nt nu on pe qc sk yk ',
	      'ck':' biz co edu gen gov info net org ',
	      'cn':' ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ',
	      'co':' com edu gov mil net nom org ',
	      'cr':' ac c co ed fi go or sa ',
	      'cy':' ac biz com ekloges gov ltd name net org parliament press pro tm ',
	      'do':' art com edu gob gov mil net org sld web ',
	      'dz':' art asso com edu gov net org pol ',
	      'ec':' com edu fin gov info med mil net org pro ',
	      'eg':' com edu eun gov mil name net org sci ',
	      'er':' com edu gov ind mil net org rochest w ',
	      'es':' com edu gob nom org ',
	      'et':' biz com edu gov info name net org ',
	      'fj':' ac biz com info mil name net org pro ',
	      'fk':' ac co gov net nom org ',
	      'fr':' asso com f gouv nom prd presse tm ',
	      'gg':' co net org ',
	      'gh':' com edu gov mil org ',
	      'gn':' ac com gov net org ',
	      'gr':' com edu gov mil net org ',
	      'gt':' com edu gob ind mil net org ',
	      'gu':' com edu gov net org ',
	      'hk':' com edu gov idv net org ',
	      'hu':' 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ',
	      'id':' ac co go mil net or sch web ',
	      'il':' ac co gov idf k12 muni net org ',
	      'in':' ac co edu ernet firm gen gov i ind mil net nic org res ',
	      'iq':' com edu gov i mil net org ',
	      'ir':' ac co dnssec gov i id net org sch ',
	      'it':' edu gov ',
	      'je':' co net org ',
	      'jo':' com edu gov mil name net org sch ',
	      'jp':' ac ad co ed go gr lg ne or ',
	      'ke':' ac co go info me mobi ne or sc ',
	      'kh':' com edu gov mil net org per ',
	      'ki':' biz com de edu gov info mob net org tel ',
	      'km':' asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ',
	      'kn':' edu gov net org ',
	      'kr':' ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ',
	      'kw':' com edu gov net org ',
	      'ky':' com edu gov net org ',
	      'kz':' com edu gov mil net org ',
	      'lb':' com edu gov net org ',
	      'lk':' assn com edu gov grp hotel int ltd net ngo org sch soc web ',
	      'lr':' com edu gov net org ',
	      'lv':' asn com conf edu gov id mil net org ',
	      'ly':' com edu gov id med net org plc sch ',
	      'ma':' ac co gov m net org press ',
	      'mc':' asso tm ',
	      'me':' ac co edu gov its net org priv ',
	      'mg':' com edu gov mil nom org prd tm ',
	      'mk':' com edu gov inf name net org pro ',
	      'ml':' com edu gov net org presse ',
	      'mn':' edu gov org ',
	      'mo':' com edu gov net org ',
	      'mt':' com edu gov net org ',
	      'mv':' aero biz com coop edu gov info int mil museum name net org pro ',
	      'mw':' ac co com coop edu gov int museum net org ',
	      'mx':' com edu gob net org ',
	      'my':' com edu gov mil name net org sch ',
	      'nf':' arts com firm info net other per rec store web ',
	      'ng':' biz com edu gov mil mobi name net org sch ',
	      'ni':' ac co com edu gob mil net nom org ',
	      'np':' com edu gov mil net org ',
	      'nr':' biz com edu gov info net org ',
	      'om':' ac biz co com edu gov med mil museum net org pro sch ',
	      'pe':' com edu gob mil net nom org sld ',
	      'ph':' com edu gov i mil net ngo org ',
	      'pk':' biz com edu fam gob gok gon gop gos gov net org web ',
	      'pl':' art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ',
	      'pr':' ac biz com edu est gov info isla name net org pro prof ',
	      'ps':' com edu gov net org plo sec ',
	      'pw':' belau co ed go ne or ',
	      'ro':' arts com firm info nom nt org rec store tm www ',
	      'rs':' ac co edu gov in org ',
	      'sb':' com edu gov net org ',
	      'sc':' com edu gov net org ',
	      'sh':' co com edu gov net nom org ',
	      'sl':' com edu gov net org ',
	      'st':' co com consulado edu embaixada gov mil net org principe saotome store ',
	      'sv':' com edu gob org red ',
	      'sz':' ac co org ',
	      'tr':' av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ',
	      'tt':' aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ',
	      'tw':' club com ebiz edu game gov idv mil net org ',
	      'mu':' ac co com gov net or org ',
	      'mz':' ac co edu gov org ',
	      'na':' co com ',
	      'nz':' ac co cri geek gen govt health iwi maori mil net org parliament school ',
	      'pa':' abo ac com edu gob ing med net nom org sld ',
	      'pt':' com edu gov int net nome org publ ',
	      'py':' com edu gov mil net org ',
	      'qa':' com edu gov mil net org ',
	      're':' asso com nom ',
	      'ru':' ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ',
	      'rw':' ac co com edu gouv gov int mil net ',
	      'sa':' com edu gov med net org pub sch ',
	      'sd':' com edu gov info med net org tv ',
	      'se':' a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ',
	      'sg':' com edu gov idn net org per ',
	      'sn':' art com edu gouv org perso univ ',
	      'sy':' com edu gov mil net news org ',
	      'th':' ac co go in mi net or ',
	      'tj':' ac biz co com edu go gov info int mil name net nic org test web ',
	      'tn':' agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ',
	      'tz':' ac co go ne or ',
	      'ua':' biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ',
	      'ug':' ac co go ne or org sc ',
	      'uk':' ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ',
	      'us':' dni fed isa kids nsn ',
	      'uy':' com edu gub mil net org ',
	      've':' co com edu gob info mil net org web ',
	      'vi':' co com k12 net org ',
	      'vn':' ac biz com edu gov health info int name net org pro ',
	      'ye':' co com gov ltd me net org plc ',
	      'yu':' ac co edu gov org ',
	      'za':' ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ',
	      'zm':' ac co com edu gov net org sch '
	    },
	    // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
	    // in both performance and memory footprint. No initialization required.
	    // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
	    // Following methods use lastIndexOf() rather than array.split() in order
	    // to avoid any memory allocations.
	    has: function(domain) {
	      var tldOffset = domain.lastIndexOf('.');
	      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
	        return false;
	      }
	      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
	      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
	        return false;
	      }
	      var sldList = SLD.list[domain.slice(tldOffset+1)];
	      if (!sldList) {
	        return false;
	      }
	      return sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') >= 0;
	    },
	    is: function(domain) {
	      var tldOffset = domain.lastIndexOf('.');
	      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
	        return false;
	      }
	      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
	      if (sldOffset >= 0) {
	        return false;
	      }
	      var sldList = SLD.list[domain.slice(tldOffset+1)];
	      if (!sldList) {
	        return false;
	      }
	      return sldList.indexOf(' ' + domain.slice(0, tldOffset) + ' ') >= 0;
	    },
	    get: function(domain) {
	      var tldOffset = domain.lastIndexOf('.');
	      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
	        return null;
	      }
	      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
	      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
	        return null;
	      }
	      var sldList = SLD.list[domain.slice(tldOffset+1)];
	      if (!sldList) {
	        return null;
	      }
	      if (sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') < 0) {
	        return null;
	      }
	      return domain.slice(sldOffset+1);
	    },
	    noConflict: function(){
	      if (root.SecondLevelDomains === this) {
	        root.SecondLevelDomains = _SecondLevelDomains;
	      }
	      return this;
	    }
	  };
	
	  return SLD;
	}));


/***/ },
/* 611 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAvatarUrlFromKey = getAvatarUrlFromKey;
	var Avatars = {
	  americanhistory: 'https://remind.imgix.net/3c0c0765-8575-4962-9fc2-c0c17b5c4a1b/americanhistory.svg',
	  apple: 'https://remind.imgix.net/09be2cf3-2b09-4d0f-9616-938d73435a5a/apple.svg',
	  art: 'https://remind.imgix.net/00b2b954-ad35-4705-b453-85f3befb5ba0/art.svg',
	  baseball: 'https://remind.imgix.net/d38195f5-bcc9-4d16-899b-40a9a29d8c4e/baseball.svg',
	  basketball: 'https://remind.imgix.net/dcd770e7-ea3a-40fc-b1c0-cb3843c6869c/basketball.svg',
	  chemistry: 'https://remind.imgix.net/75abca9b-cdda-4224-9862-b80e55a2d45f/chemistry.svg',
	  chorus: 'https://remind.imgix.net/0a157e1c-2ff9-4f1c-9b12-2199d656892e/chorus.svg',
	  dinosaur: 'https://remind.imgix.net/64b37f6c-5322-4560-b3a3-f147e4b5aea2/dinosaur.svg',
	  earthscience: 'https://remind.imgix.net/5b25e78f-eb0d-4aa4-a25b-6c6f053a18eb/earthscience.svg',
	  football: 'https://remind.imgix.net/1948465c-6dbe-4492-9868-0de3794a7c9c/football.svg',
	  geography: 'https://remind.imgix.net/8fe6e8a7-59bd-48fc-b69f-601cc5e03be8/geography.svg',
	  geometry: 'https://remind.imgix.net/8f36940a-de83-4099-984e-e1a1b5d8264d/geometry.svg',
	  home_economics: 'https://remind.imgix.net/32ae1920-907d-42a4-b33f-91ea2f9dc43d/home_economics.svg',
	  language: 'https://remind.imgix.net/bd9cab09-3210-4fed-b8d6-69ecdf3951d7/language.svg',
	  literature: 'https://remind.imgix.net/f6c0a316-a0f6-494e-8fd3-891733348c52/literature.svg',
	  math: 'https://remind.imgix.net/c05e0419-6d7e-4213-b330-e6ca692f099c/math.svg',
	  music: 'https://remind.imgix.net/3b260bde-e512-4921-9fb1-1650b13ee5e2/music.svg',
	  physics: 'https://remind.imgix.net/f497cb2a-4bc9-48d7-bd31-e6da0c1817e2/physics.svg',
	  politics: 'https://remind.imgix.net/8ca96e64-8b7d-42ca-8d17-315f8fd686bf/politics.svg',
	  reading: 'https://remind.imgix.net/07477444-667f-449d-a54f-c40b8d3f9915/reading.svg',
	  rocket: 'https://remind.imgix.net/e3421d23-5dca-4952-a86e-3dc7c11c2593/rocket.svg',
	  science: 'https://remind.imgix.net/7d78cc30-0722-4753-9668-346a60b3527b/science.svg',
	  school: 'https://remind.imgix.net/a3ec6345-0f21-4bd8-97e7-7d8dd0f6da91/school.svg',
	  soccer: 'https://remind.imgix.net/17bcc4a0-5e4a-43c3-a75e-ea30c45a1d01/soccer.svg',
	  sports: 'https://remind.imgix.net/e3c35aa0-c9f4-4f59-920c-9cbd7c8a873a/sports.svg',
	  stats: 'https://remind.imgix.net/75536adb-251f-411d-9902-d821cf3df31c/stats.svg',
	  tech: 'https://remind.imgix.net/96379c73-6531-43f1-96ff-0182e9f6a0d2/tech.svg',
	  theater: 'https://remind.imgix.net/922a1638-891c-4107-bf74-9e814d3d9ef0/theater.svg',
	  track: 'https://remind.imgix.net/673af6cf-6c6f-4912-afd5-f13b7ffc2fef/track.svg',
	  writing: 'https://remind.imgix.net/b809898f-2903-4217-8954-569f958c194f/writing.svg'
	};
	
	var keys = Object.keys(Avatars);
	
	function getAvatarUrlFromKey(key) {
	  var stringKey = '' + key;
	  var index = 0;
	  for (var i = 0, l = stringKey.length; i < l; i++) {
	    index = (index + stringKey.charCodeAt(i)) % keys.length;
	  }
	  return Avatars[keys[index]];
	}
	
	exports.default = Avatars;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ERRORS = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _graphql = __webpack_require__(615);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RemindAPI = function () {
	  function RemindAPI() {
	    _classCallCheck(this, RemindAPI);
	  }
	
	  _createClass(RemindAPI, null, [{
	    key: 'request',
	    value: function request(endpoint) {
	      var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
	      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var isJSON = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	      return (0, _apiRequest2.default)(endpoint, method, data, isJSON);
	    }
	  }, {
	    key: 'execute',
	    value: function execute(query) {
	      var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var options = { query: query, variables: variables };
	      return _graphql.apolloClient.query(options).then(function (_ref) {
	        var data = _ref.data;
	        return data;
	      });
	    }
	  }]);
	
	  return RemindAPI;
	}();
	
	RemindAPI.displayName = 'RemindAPI';
	exports.default = RemindAPI;
	var ERRORS = exports.ERRORS = {
	  birthdate_required: 'birthdate_required',
	  not_found: 'not_found',
	  cannot_respond_to_closed_event: 'cannot_respond_to_closed_event'
	};
	
	if (false) {
	  window.apolloClient = _graphql.apolloClient;
	  window.gql = _graphqlTag2.default;
	  window.RemindAPI = RemindAPI;
	}

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(614).parse;
	
	// Strip insignificant whitespace
	// Note that this could do a lot more, such as reorder fields etc.
	function normalize(string) {
	  return string.replace(/[\s,]+/g, ' ').trim();
	}
	
	// A map docString -> graphql document
	var docCache = {};
	
	// A map fragmentName -> [normalized source]
	var fragmentSourceMap = {};
	
	function cacheKeyFromLoc(loc) {
	  return normalize(loc.source.body.substring(loc.start, loc.end));
	}
	
	// For testing.
	function resetCaches() {
	  docCache = {};
	  fragmentSourceMap = {};
	}
	
	// Take a unstripped parsed document (query/mutation or even fragment), and
	// check all fragment definitions, checking for name->source uniqueness
	var printFragmentWarnings = true;
	function checkFragments(ast) {
	  for (var i = 0; i < ast.definitions.length; i++) {
	    var fragmentDefinition = ast.definitions[i];
	    if (fragmentDefinition.kind === 'FragmentDefinition') {
	      var fragmentName = fragmentDefinition.name.value;
	      var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
	
	      // We know something about this fragment
	      if (fragmentSourceMap.hasOwnProperty(fragmentName) &&
	            !fragmentSourceMap[fragmentName][sourceKey]) {
	
	        // this is a problem because the app developer is trying to register another fragment with
	        // the same name as one previously registered. So, we tell them about it.
	        if (printFragmentWarnings) {
	          console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
	            + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
	            + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
	        }
	
	        fragmentSourceMap[fragmentName][sourceKey] = true;
	
	      } else if (!fragmentSourceMap.hasOwnProperty(fragmentName)) {
	        fragmentSourceMap[fragmentName] = {};
	        fragmentSourceMap[fragmentName][sourceKey] = true;
	      }
	    }
	  }
	}
	
	function disableFragmentWarnings() {
	  printFragmentWarnings = false;
	}
	
	function stripLoc (doc, removeLocAtThisLevel) {
	  var docType = Object.prototype.toString.call(doc);
	
	  if (docType === '[object Array]') {
	    return doc.map(function(d) { return stripLoc(d, removeLocAtThisLevel); });
	  }
	
	  if (docType !== '[object Object]') {
	    throw new Error('Unexpected input.');
	  }
	
	  // We don't want to remove the root loc field so we can use it
	  // for fragment substitution (see below)
	  if (removeLocAtThisLevel && doc.loc) {
	    delete doc.loc;
	  }
	
	  var keys = Object.keys(doc);
	  var key;
	  var value;
	  var valueType;
	
	  for (key in keys) {
	    if (keys.hasOwnProperty(key)) {
	      value = doc[keys[key]];
	      valueType = Object.prototype.toString.call(value);
	
	      if (valueType === '[object Object]' || valueType === '[object Array]') {
	        doc[keys[key]] = stripLoc(value, true);
	      }
	    }
	  }
	
	  return doc;
	}
	
	function parseDocument(doc) {
	  var cacheKey = normalize(doc);
	
	  if (docCache[cacheKey]) {
	    return docCache[cacheKey];
	  }
	
	  var parsed = parse(doc);
	  if (!parsed || parsed.kind !== 'Document') {
	    throw new Error('Not a valid GraphQL document.');
	  }
	
	  // check that all "new" fragments inside the documents are consistent with
	  // existing fragments of the same name
	  checkFragments(parsed);
	  parsed = stripLoc(parsed, false);
	  docCache[cacheKey] = parsed;
	
	  return parsed;
	}
	
	// XXX This should eventually disallow arbitrary string interpolation, like Relay does
	function gql(/* arguments */) {
	  var args = Array.prototype.slice.call(arguments);
	
	  var literals = args[0];
	
	  // We always get literals[0] and then matching post literals for each arg given
	  var result = literals[0];
	
	  for (var i = 1; i < args.length; i++) {
	      if (args[i] && args[i].kind && args[i].kind === 'Document') {
	        result += args[i].loc.source.body;
	      } else {
	        result += args[i];
	      }
	
	      result += literals[i];
	  }
	
	  return parseDocument(result);
	}
	
	// Support typescript, which isn't as nice as Babel about default exports
	gql.default = gql;
	gql.resetCaches = resetCaches;
	gql.disableFragmentWarnings = disableFragmentWarnings;
	
	module.exports = gql;


/***/ },
/* 614 */
/***/ function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1);
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.parse = parse;
		exports.parseValue = parseValue;
		exports.parseConstValue = parseConstValue;
		exports.parseType = parseType;
		exports.parseNamedType = parseNamedType;
	
		var _source = __webpack_require__(2);
	
		var _error = __webpack_require__(3);
	
		var _lexer = __webpack_require__(7);
	
		var _kinds = __webpack_require__(10);
	
		/**
		 * Given a GraphQL source, parses it into a Document.
		 * Throws GraphQLError if a syntax error is encountered.
		 */
	
	
		/**
		 * Configuration options to control parser behavior
		 */
	
		/**
		 *  Copyright (c) 2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		function parse(source, options) {
		  var sourceObj = source instanceof _source.Source ? source : new _source.Source(source);
		  var parser = makeParser(sourceObj, options || {});
		  return parseDocument(parser);
		}
	
		/**
		 * Given a string containing a GraphQL value, parse the AST for that value.
		 * Throws GraphQLError if a syntax error is encountered.
		 *
		 * This is useful within tools that operate upon GraphQL Values directly and
		 * in isolation of complete GraphQL documents.
		 */
		function parseValue(source, options) {
		  var sourceObj = source instanceof _source.Source ? source : new _source.Source(source);
		  var parser = makeParser(sourceObj, options || {});
		  return parseValueLiteral(parser, false);
		}
	
		/**
		 * Converts a name lex token into a name parse node.
		 */
		function parseName(parser) {
		  var token = expect(parser, _lexer.TokenKind.NAME);
		  return {
		    kind: _kinds.NAME,
		    value: token.value,
		    loc: loc(parser, token.start)
		  };
		}
	
		// Implements the parsing rules in the Document section.
	
		/**
		 * Document : Definition+
		 */
		function parseDocument(parser) {
		  var start = parser.token.start;
	
		  var definitions = [];
		  do {
		    definitions.push(parseDefinition(parser));
		  } while (!skip(parser, _lexer.TokenKind.EOF));
	
		  return {
		    kind: _kinds.DOCUMENT,
		    definitions: definitions,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * Definition :
		 *   - OperationDefinition
		 *   - FragmentDefinition
		 *   - TypeSystemDefinition
		 */
		function parseDefinition(parser) {
		  if (peek(parser, _lexer.TokenKind.BRACE_L)) {
		    return parseOperationDefinition(parser);
		  }
	
		  if (peek(parser, _lexer.TokenKind.NAME)) {
		    switch (parser.token.value) {
		      // Note: subscription is an experimental non-spec addition.
		      case 'query':
		      case 'mutation':
		      case 'subscription':
		        return parseOperationDefinition(parser);
	
		      case 'fragment':
		        return parseFragmentDefinition(parser);
	
		      // Note: the Type System IDL is an experimental non-spec addition.
		      case 'schema':
		      case 'scalar':
		      case 'type':
		      case 'interface':
		      case 'union':
		      case 'enum':
		      case 'input':
		      case 'extend':
		      case 'directive':
		        return parseTypeSystemDefinition(parser);
		    }
		  }
	
		  throw unexpected(parser);
		}
	
		// Implements the parsing rules in the Operations section.
	
		/**
		 * OperationDefinition :
		 *  - SelectionSet
		 *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
		 */
		function parseOperationDefinition(parser) {
		  var start = parser.token.start;
		  if (peek(parser, _lexer.TokenKind.BRACE_L)) {
		    return {
		      kind: _kinds.OPERATION_DEFINITION,
		      operation: 'query',
		      name: null,
		      variableDefinitions: null,
		      directives: [],
		      selectionSet: parseSelectionSet(parser),
		      loc: loc(parser, start)
		    };
		  }
		  var operation = parseOperationType(parser);
		  var name = void 0;
		  if (peek(parser, _lexer.TokenKind.NAME)) {
		    name = parseName(parser);
		  }
		  return {
		    kind: _kinds.OPERATION_DEFINITION,
		    operation: operation,
		    name: name,
		    variableDefinitions: parseVariableDefinitions(parser),
		    directives: parseDirectives(parser),
		    selectionSet: parseSelectionSet(parser),
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * OperationType : one of query mutation subscription
		 */
		function parseOperationType(parser) {
		  var operationToken = expect(parser, _lexer.TokenKind.NAME);
		  switch (operationToken.value) {
		    case 'query':
		      return 'query';
		    case 'mutation':
		      return 'mutation';
		    // Note: subscription is an experimental non-spec addition.
		    case 'subscription':
		      return 'subscription';
		  }
	
		  throw unexpected(parser, operationToken);
		}
	
		/**
		 * VariableDefinitions : ( VariableDefinition+ )
		 */
		function parseVariableDefinitions(parser) {
		  return peek(parser, _lexer.TokenKind.PAREN_L) ? many(parser, _lexer.TokenKind.PAREN_L, parseVariableDefinition, _lexer.TokenKind.PAREN_R) : [];
		}
	
		/**
		 * VariableDefinition : Variable : Type DefaultValue?
		 */
		function parseVariableDefinition(parser) {
		  var start = parser.token.start;
		  return {
		    kind: _kinds.VARIABLE_DEFINITION,
		    variable: parseVariable(parser),
		    type: (expect(parser, _lexer.TokenKind.COLON), parseType(parser)),
		    defaultValue: skip(parser, _lexer.TokenKind.EQUALS) ? parseValueLiteral(parser, true) : null,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * Variable : $ Name
		 */
		function parseVariable(parser) {
		  var start = parser.token.start;
		  expect(parser, _lexer.TokenKind.DOLLAR);
		  return {
		    kind: _kinds.VARIABLE,
		    name: parseName(parser),
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * SelectionSet : { Selection+ }
		 */
		function parseSelectionSet(parser) {
		  var start = parser.token.start;
		  return {
		    kind: _kinds.SELECTION_SET,
		    selections: many(parser, _lexer.TokenKind.BRACE_L, parseSelection, _lexer.TokenKind.BRACE_R),
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * Selection :
		 *   - Field
		 *   - FragmentSpread
		 *   - InlineFragment
		 */
		function parseSelection(parser) {
		  return peek(parser, _lexer.TokenKind.SPREAD) ? parseFragment(parser) : parseField(parser);
		}
	
		/**
		 * Field : Alias? Name Arguments? Directives? SelectionSet?
		 *
		 * Alias : Name :
		 */
		function parseField(parser) {
		  var start = parser.token.start;
	
		  var nameOrAlias = parseName(parser);
		  var alias = void 0;
		  var name = void 0;
		  if (skip(parser, _lexer.TokenKind.COLON)) {
		    alias = nameOrAlias;
		    name = parseName(parser);
		  } else {
		    alias = null;
		    name = nameOrAlias;
		  }
	
		  return {
		    kind: _kinds.FIELD,
		    alias: alias,
		    name: name,
		    arguments: parseArguments(parser),
		    directives: parseDirectives(parser),
		    selectionSet: peek(parser, _lexer.TokenKind.BRACE_L) ? parseSelectionSet(parser) : null,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * Arguments : ( Argument+ )
		 */
		function parseArguments(parser) {
		  return peek(parser, _lexer.TokenKind.PAREN_L) ? many(parser, _lexer.TokenKind.PAREN_L, parseArgument, _lexer.TokenKind.PAREN_R) : [];
		}
	
		/**
		 * Argument : Name : Value
		 */
		function parseArgument(parser) {
		  var start = parser.token.start;
		  return {
		    kind: _kinds.ARGUMENT,
		    name: parseName(parser),
		    value: (expect(parser, _lexer.TokenKind.COLON), parseValueLiteral(parser, false)),
		    loc: loc(parser, start)
		  };
		}
	
		// Implements the parsing rules in the Fragments section.
	
		/**
		 * Corresponds to both FragmentSpread and InlineFragment in the spec.
		 *
		 * FragmentSpread : ... FragmentName Directives?
		 *
		 * InlineFragment : ... TypeCondition? Directives? SelectionSet
		 */
		function parseFragment(parser) {
		  var start = parser.token.start;
		  expect(parser, _lexer.TokenKind.SPREAD);
		  if (peek(parser, _lexer.TokenKind.NAME) && parser.token.value !== 'on') {
		    return {
		      kind: _kinds.FRAGMENT_SPREAD,
		      name: parseFragmentName(parser),
		      directives: parseDirectives(parser),
		      loc: loc(parser, start)
		    };
		  }
		  var typeCondition = null;
		  if (parser.token.value === 'on') {
		    advance(parser);
		    typeCondition = parseNamedType(parser);
		  }
		  return {
		    kind: _kinds.INLINE_FRAGMENT,
		    typeCondition: typeCondition,
		    directives: parseDirectives(parser),
		    selectionSet: parseSelectionSet(parser),
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * FragmentDefinition :
		 *   - fragment FragmentName on TypeCondition Directives? SelectionSet
		 *
		 * TypeCondition : NamedType
		 */
		function parseFragmentDefinition(parser) {
		  var start = parser.token.start;
		  expectKeyword(parser, 'fragment');
		  return {
		    kind: _kinds.FRAGMENT_DEFINITION,
		    name: parseFragmentName(parser),
		    typeCondition: (expectKeyword(parser, 'on'), parseNamedType(parser)),
		    directives: parseDirectives(parser),
		    selectionSet: parseSelectionSet(parser),
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * FragmentName : Name but not `on`
		 */
		function parseFragmentName(parser) {
		  if (parser.token.value === 'on') {
		    throw unexpected(parser);
		  }
		  return parseName(parser);
		}
	
		// Implements the parsing rules in the Values section.
	
		/**
		 * Value[Const] :
		 *   - [~Const] Variable
		 *   - IntValue
		 *   - FloatValue
		 *   - StringValue
		 *   - BooleanValue
		 *   - EnumValue
		 *   - ListValue[?Const]
		 *   - ObjectValue[?Const]
		 *
		 * BooleanValue : one of `true` `false`
		 *
		 * EnumValue : Name but not `true`, `false` or `null`
		 */
		function parseValueLiteral(parser, isConst) {
		  var token = parser.token;
		  switch (token.kind) {
		    case _lexer.TokenKind.BRACKET_L:
		      return parseList(parser, isConst);
		    case _lexer.TokenKind.BRACE_L:
		      return parseObject(parser, isConst);
		    case _lexer.TokenKind.INT:
		      advance(parser);
		      return {
		        kind: _kinds.INT,
		        value: token.value,
		        loc: loc(parser, token.start)
		      };
		    case _lexer.TokenKind.FLOAT:
		      advance(parser);
		      return {
		        kind: _kinds.FLOAT,
		        value: token.value,
		        loc: loc(parser, token.start)
		      };
		    case _lexer.TokenKind.STRING:
		      advance(parser);
		      return {
		        kind: _kinds.STRING,
		        value: token.value,
		        loc: loc(parser, token.start)
		      };
		    case _lexer.TokenKind.NAME:
		      if (token.value === 'true' || token.value === 'false') {
		        advance(parser);
		        return {
		          kind: _kinds.BOOLEAN,
		          value: token.value === 'true',
		          loc: loc(parser, token.start)
		        };
		      } else if (token.value !== 'null') {
		        advance(parser);
		        return {
		          kind: _kinds.ENUM,
		          value: token.value,
		          loc: loc(parser, token.start)
		        };
		      }
		      break;
		    case _lexer.TokenKind.DOLLAR:
		      if (!isConst) {
		        return parseVariable(parser);
		      }
		      break;
		  }
		  throw unexpected(parser);
		}
	
		function parseConstValue(parser) {
		  return parseValueLiteral(parser, true);
		}
	
		function parseValueValue(parser) {
		  return parseValueLiteral(parser, false);
		}
	
		/**
		 * ListValue[Const] :
		 *   - [ ]
		 *   - [ Value[?Const]+ ]
		 */
		function parseList(parser, isConst) {
		  var start = parser.token.start;
		  var item = isConst ? parseConstValue : parseValueValue;
		  return {
		    kind: _kinds.LIST,
		    values: any(parser, _lexer.TokenKind.BRACKET_L, item, _lexer.TokenKind.BRACKET_R),
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * ObjectValue[Const] :
		 *   - { }
		 *   - { ObjectField[?Const]+ }
		 */
		function parseObject(parser, isConst) {
		  var start = parser.token.start;
		  expect(parser, _lexer.TokenKind.BRACE_L);
		  var fields = [];
		  while (!skip(parser, _lexer.TokenKind.BRACE_R)) {
		    fields.push(parseObjectField(parser, isConst));
		  }
		  return {
		    kind: _kinds.OBJECT,
		    fields: fields,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * ObjectField[Const] : Name : Value[?Const]
		 */
		function parseObjectField(parser, isConst) {
		  var start = parser.token.start;
		  return {
		    kind: _kinds.OBJECT_FIELD,
		    name: parseName(parser),
		    value: (expect(parser, _lexer.TokenKind.COLON), parseValueLiteral(parser, isConst)),
		    loc: loc(parser, start)
		  };
		}
	
		// Implements the parsing rules in the Directives section.
	
		/**
		 * Directives : Directive+
		 */
		function parseDirectives(parser) {
		  var directives = [];
		  while (peek(parser, _lexer.TokenKind.AT)) {
		    directives.push(parseDirective(parser));
		  }
		  return directives;
		}
	
		/**
		 * Directive : @ Name Arguments?
		 */
		function parseDirective(parser) {
		  var start = parser.token.start;
		  expect(parser, _lexer.TokenKind.AT);
		  return {
		    kind: _kinds.DIRECTIVE,
		    name: parseName(parser),
		    arguments: parseArguments(parser),
		    loc: loc(parser, start)
		  };
		}
	
		// Implements the parsing rules in the Types section.
	
		/**
		 * Type :
		 *   - NamedType
		 *   - ListType
		 *   - NonNullType
		 */
		function parseType(parser) {
		  var start = parser.token.start;
		  var type = void 0;
		  if (skip(parser, _lexer.TokenKind.BRACKET_L)) {
		    type = parseType(parser);
		    expect(parser, _lexer.TokenKind.BRACKET_R);
		    type = {
		      kind: _kinds.LIST_TYPE,
		      type: type,
		      loc: loc(parser, start)
		    };
		  } else {
		    type = parseNamedType(parser);
		  }
		  if (skip(parser, _lexer.TokenKind.BANG)) {
		    return {
		      kind: _kinds.NON_NULL_TYPE,
		      type: type,
		      loc: loc(parser, start)
		    };
		  }
		  return type;
		}
	
		/**
		 * NamedType : Name
		 */
		function parseNamedType(parser) {
		  var start = parser.token.start;
		  return {
		    kind: _kinds.NAMED_TYPE,
		    name: parseName(parser),
		    loc: loc(parser, start)
		  };
		}
	
		// Implements the parsing rules in the Type Definition section.
	
		/**
		 * TypeSystemDefinition :
		 *   - SchemaDefinition
		 *   - TypeDefinition
		 *   - TypeExtensionDefinition
		 *   - DirectiveDefinition
		 *
		 * TypeDefinition :
		 *   - ScalarTypeDefinition
		 *   - ObjectTypeDefinition
		 *   - InterfaceTypeDefinition
		 *   - UnionTypeDefinition
		 *   - EnumTypeDefinition
		 *   - InputObjectTypeDefinition
		 */
		function parseTypeSystemDefinition(parser) {
		  if (peek(parser, _lexer.TokenKind.NAME)) {
		    switch (parser.token.value) {
		      case 'schema':
		        return parseSchemaDefinition(parser);
		      case 'scalar':
		        return parseScalarTypeDefinition(parser);
		      case 'type':
		        return parseObjectTypeDefinition(parser);
		      case 'interface':
		        return parseInterfaceTypeDefinition(parser);
		      case 'union':
		        return parseUnionTypeDefinition(parser);
		      case 'enum':
		        return parseEnumTypeDefinition(parser);
		      case 'input':
		        return parseInputObjectTypeDefinition(parser);
		      case 'extend':
		        return parseTypeExtensionDefinition(parser);
		      case 'directive':
		        return parseDirectiveDefinition(parser);
		    }
		  }
	
		  throw unexpected(parser);
		}
	
		/**
		 * SchemaDefinition : schema Directives? { OperationTypeDefinition+ }
		 *
		 * OperationTypeDefinition : OperationType : NamedType
		 */
		function parseSchemaDefinition(parser) {
		  var start = parser.token.start;
		  expectKeyword(parser, 'schema');
		  var directives = parseDirectives(parser);
		  var operationTypes = many(parser, _lexer.TokenKind.BRACE_L, parseOperationTypeDefinition, _lexer.TokenKind.BRACE_R);
		  return {
		    kind: _kinds.SCHEMA_DEFINITION,
		    directives: directives,
		    operationTypes: operationTypes,
		    loc: loc(parser, start)
		  };
		}
	
		function parseOperationTypeDefinition(parser) {
		  var start = parser.token.start;
		  var operation = parseOperationType(parser);
		  expect(parser, _lexer.TokenKind.COLON);
		  var type = parseNamedType(parser);
		  return {
		    kind: _kinds.OPERATION_TYPE_DEFINITION,
		    operation: operation,
		    type: type,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * ScalarTypeDefinition : scalar Name Directives?
		 */
		function parseScalarTypeDefinition(parser) {
		  var start = parser.token.start;
		  expectKeyword(parser, 'scalar');
		  var name = parseName(parser);
		  var directives = parseDirectives(parser);
		  return {
		    kind: _kinds.SCALAR_TYPE_DEFINITION,
		    name: name,
		    directives: directives,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * ObjectTypeDefinition :
		 *   - type Name ImplementsInterfaces? Directives? { FieldDefinition+ }
		 */
		function parseObjectTypeDefinition(parser) {
		  var start = parser.token.start;
		  expectKeyword(parser, 'type');
		  var name = parseName(parser);
		  var interfaces = parseImplementsInterfaces(parser);
		  var directives = parseDirectives(parser);
		  var fields = any(parser, _lexer.TokenKind.BRACE_L, parseFieldDefinition, _lexer.TokenKind.BRACE_R);
		  return {
		    kind: _kinds.OBJECT_TYPE_DEFINITION,
		    name: name,
		    interfaces: interfaces,
		    directives: directives,
		    fields: fields,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * ImplementsInterfaces : implements NamedType+
		 */
		function parseImplementsInterfaces(parser) {
		  var types = [];
		  if (parser.token.value === 'implements') {
		    advance(parser);
		    do {
		      types.push(parseNamedType(parser));
		    } while (peek(parser, _lexer.TokenKind.NAME));
		  }
		  return types;
		}
	
		/**
		 * FieldDefinition : Name ArgumentsDefinition? : Type Directives?
		 */
		function parseFieldDefinition(parser) {
		  var start = parser.token.start;
		  var name = parseName(parser);
		  var args = parseArgumentDefs(parser);
		  expect(parser, _lexer.TokenKind.COLON);
		  var type = parseType(parser);
		  var directives = parseDirectives(parser);
		  return {
		    kind: _kinds.FIELD_DEFINITION,
		    name: name,
		    arguments: args,
		    type: type,
		    directives: directives,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * ArgumentsDefinition : ( InputValueDefinition+ )
		 */
		function parseArgumentDefs(parser) {
		  if (!peek(parser, _lexer.TokenKind.PAREN_L)) {
		    return [];
		  }
		  return many(parser, _lexer.TokenKind.PAREN_L, parseInputValueDef, _lexer.TokenKind.PAREN_R);
		}
	
		/**
		 * InputValueDefinition : Name : Type DefaultValue? Directives?
		 */
		function parseInputValueDef(parser) {
		  var start = parser.token.start;
		  var name = parseName(parser);
		  expect(parser, _lexer.TokenKind.COLON);
		  var type = parseType(parser);
		  var defaultValue = null;
		  if (skip(parser, _lexer.TokenKind.EQUALS)) {
		    defaultValue = parseConstValue(parser);
		  }
		  var directives = parseDirectives(parser);
		  return {
		    kind: _kinds.INPUT_VALUE_DEFINITION,
		    name: name,
		    type: type,
		    defaultValue: defaultValue,
		    directives: directives,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * InterfaceTypeDefinition : interface Name Directives? { FieldDefinition+ }
		 */
		function parseInterfaceTypeDefinition(parser) {
		  var start = parser.token.start;
		  expectKeyword(parser, 'interface');
		  var name = parseName(parser);
		  var directives = parseDirectives(parser);
		  var fields = any(parser, _lexer.TokenKind.BRACE_L, parseFieldDefinition, _lexer.TokenKind.BRACE_R);
		  return {
		    kind: _kinds.INTERFACE_TYPE_DEFINITION,
		    name: name,
		    directives: directives,
		    fields: fields,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * UnionTypeDefinition : union Name Directives? = UnionMembers
		 */
		function parseUnionTypeDefinition(parser) {
		  var start = parser.token.start;
		  expectKeyword(parser, 'union');
		  var name = parseName(parser);
		  var directives = parseDirectives(parser);
		  expect(parser, _lexer.TokenKind.EQUALS);
		  var types = parseUnionMembers(parser);
		  return {
		    kind: _kinds.UNION_TYPE_DEFINITION,
		    name: name,
		    directives: directives,
		    types: types,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * UnionMembers :
		 *   - NamedType
		 *   - UnionMembers | NamedType
		 */
		function parseUnionMembers(parser) {
		  var members = [];
		  do {
		    members.push(parseNamedType(parser));
		  } while (skip(parser, _lexer.TokenKind.PIPE));
		  return members;
		}
	
		/**
		 * EnumTypeDefinition : enum Name Directives? { EnumValueDefinition+ }
		 */
		function parseEnumTypeDefinition(parser) {
		  var start = parser.token.start;
		  expectKeyword(parser, 'enum');
		  var name = parseName(parser);
		  var directives = parseDirectives(parser);
		  var values = many(parser, _lexer.TokenKind.BRACE_L, parseEnumValueDefinition, _lexer.TokenKind.BRACE_R);
		  return {
		    kind: _kinds.ENUM_TYPE_DEFINITION,
		    name: name,
		    directives: directives,
		    values: values,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * EnumValueDefinition : EnumValue Directives?
		 *
		 * EnumValue : Name
		 */
		function parseEnumValueDefinition(parser) {
		  var start = parser.token.start;
		  var name = parseName(parser);
		  var directives = parseDirectives(parser);
		  return {
		    kind: _kinds.ENUM_VALUE_DEFINITION,
		    name: name,
		    directives: directives,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * InputObjectTypeDefinition : input Name Directives? { InputValueDefinition+ }
		 */
		function parseInputObjectTypeDefinition(parser) {
		  var start = parser.token.start;
		  expectKeyword(parser, 'input');
		  var name = parseName(parser);
		  var directives = parseDirectives(parser);
		  var fields = any(parser, _lexer.TokenKind.BRACE_L, parseInputValueDef, _lexer.TokenKind.BRACE_R);
		  return {
		    kind: _kinds.INPUT_OBJECT_TYPE_DEFINITION,
		    name: name,
		    directives: directives,
		    fields: fields,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * TypeExtensionDefinition : extend ObjectTypeDefinition
		 */
		function parseTypeExtensionDefinition(parser) {
		  var start = parser.token.start;
		  expectKeyword(parser, 'extend');
		  var definition = parseObjectTypeDefinition(parser);
		  return {
		    kind: _kinds.TYPE_EXTENSION_DEFINITION,
		    definition: definition,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * DirectiveDefinition :
		 *   - directive @ Name ArgumentsDefinition? on DirectiveLocations
		 */
		function parseDirectiveDefinition(parser) {
		  var start = parser.token.start;
		  expectKeyword(parser, 'directive');
		  expect(parser, _lexer.TokenKind.AT);
		  var name = parseName(parser);
		  var args = parseArgumentDefs(parser);
		  expectKeyword(parser, 'on');
		  var locations = parseDirectiveLocations(parser);
		  return {
		    kind: _kinds.DIRECTIVE_DEFINITION,
		    name: name,
		    arguments: args,
		    locations: locations,
		    loc: loc(parser, start)
		  };
		}
	
		/**
		 * DirectiveLocations :
		 *   - Name
		 *   - DirectiveLocations | Name
		 */
		function parseDirectiveLocations(parser) {
		  var locations = [];
		  do {
		    locations.push(parseName(parser));
		  } while (skip(parser, _lexer.TokenKind.PIPE));
		  return locations;
		}
	
		// Core parsing utility functions
	
		/**
		 * Returns the parser object that is used to store state throughout the
		 * process of parsing.
		 */
		function makeParser(source, options) {
		  var _lexToken = (0, _lexer.lex)(source);
		  return {
		    _lexToken: _lexToken,
		    source: source,
		    options: options,
		    prevEnd: 0,
		    token: _lexToken()
		  };
		}
	
		/**
		 * Returns a location object, used to identify the place in
		 * the source that created a given parsed object.
		 */
		function loc(parser, start) {
		  if (parser.options.noLocation) {
		    return null;
		  }
		  if (parser.options.noSource) {
		    return { start: start, end: parser.prevEnd };
		  }
		  return { start: start, end: parser.prevEnd, source: parser.source };
		}
	
		/**
		 * Moves the internal parser object to the next lexed token.
		 */
		function advance(parser) {
		  var prevEnd = parser.token.end;
		  parser.prevEnd = prevEnd;
		  parser.token = parser._lexToken(prevEnd);
		}
	
		/**
		 * Determines if the next token is of a given kind
		 */
		function peek(parser, kind) {
		  return parser.token.kind === kind;
		}
	
		/**
		 * If the next token is of the given kind, return true after advancing
		 * the parser. Otherwise, do not change the parser state and return false.
		 */
		function skip(parser, kind) {
		  var match = parser.token.kind === kind;
		  if (match) {
		    advance(parser);
		  }
		  return match;
		}
	
		/**
		 * If the next token is of the given kind, return that token after advancing
		 * the parser. Otherwise, do not change the parser state and throw an error.
		 */
		function expect(parser, kind) {
		  var token = parser.token;
		  if (token.kind === kind) {
		    advance(parser);
		    return token;
		  }
		  throw (0, _error.syntaxError)(parser.source, token.start, 'Expected ' + (0, _lexer.getTokenKindDesc)(kind) + ', found ' + (0, _lexer.getTokenDesc)(token));
		}
	
		/**
		 * If the next token is a keyword with the given value, return that token after
		 * advancing the parser. Otherwise, do not change the parser state and return
		 * false.
		 */
		function expectKeyword(parser, value) {
		  var token = parser.token;
		  if (token.kind === _lexer.TokenKind.NAME && token.value === value) {
		    advance(parser);
		    return token;
		  }
		  throw (0, _error.syntaxError)(parser.source, token.start, 'Expected "' + value + '", found ' + (0, _lexer.getTokenDesc)(token));
		}
	
		/**
		 * Helper function for creating an error when an unexpected lexed token
		 * is encountered.
		 */
		function unexpected(parser, atToken) {
		  var token = atToken || parser.token;
		  return (0, _error.syntaxError)(parser.source, token.start, 'Unexpected ' + (0, _lexer.getTokenDesc)(token));
		}
	
		/**
		 * Returns a possibly empty list of parse nodes, determined by
		 * the parseFn. This list begins with a lex token of openKind
		 * and ends with a lex token of closeKind. Advances the parser
		 * to the next lex token after the closing token.
		 */
		function any(parser, openKind, parseFn, closeKind) {
		  expect(parser, openKind);
		  var nodes = [];
		  while (!skip(parser, closeKind)) {
		    nodes.push(parseFn(parser));
		  }
		  return nodes;
		}
	
		/**
		 * Returns a non-empty list of parse nodes, determined by
		 * the parseFn. This list begins with a lex token of openKind
		 * and ends with a lex token of closeKind. Advances the parser
		 * to the next lex token after the closing token.
		 */
		function many(parser, openKind, parseFn, closeKind) {
		  expect(parser, openKind);
		  var nodes = [parseFn(parser)];
		  while (!skip(parser, closeKind)) {
		    nodes.push(parseFn(parser));
		  }
		  return nodes;
		}
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		/**
		 *  Copyright (c) 2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		/**
		 * A representation of source input to GraphQL. The name is optional,
		 * but is mostly useful for clients who store GraphQL documents in
		 * source files; for example, if the GraphQL input is in a file Foo.graphql,
		 * it might be useful for name to be "Foo.graphql".
		 */
		var Source = exports.Source = function Source(body, name) {
		  _classCallCheck(this, Source);
	
		  this.body = body;
		  this.name = name || 'GraphQL';
		};
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _GraphQLError = __webpack_require__(4);
	
		Object.defineProperty(exports, 'GraphQLError', {
		  enumerable: true,
		  get: function get() {
		    return _GraphQLError.GraphQLError;
		  }
		});
	
		var _syntaxError = __webpack_require__(11);
	
		Object.defineProperty(exports, 'syntaxError', {
		  enumerable: true,
		  get: function get() {
		    return _syntaxError.syntaxError;
		  }
		});
	
		var _locatedError = __webpack_require__(12);
	
		Object.defineProperty(exports, 'locatedError', {
		  enumerable: true,
		  get: function get() {
		    return _locatedError.locatedError;
		  }
		});
	
		var _formatError = __webpack_require__(13);
	
		Object.defineProperty(exports, 'formatError', {
		  enumerable: true,
		  get: function get() {
		    return _formatError.formatError;
		  }
		});
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.GraphQLError = undefined;
	
		var _language = __webpack_require__(5);
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		/**
		 *  Copyright (c) 2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		var GraphQLError = exports.GraphQLError = function (_Error) {
		  _inherits(GraphQLError, _Error);
	
		  function GraphQLError(message,
		  // A flow bug keeps us from declaring nodes as an array of Node
		  nodes, stack, source, positions, path, originalError) {
		    _classCallCheck(this, GraphQLError);
	
		    var _this = _possibleConstructorReturn(this, _Error.call(this, message));
	
		    Object.defineProperty(_this, 'message', {
		      value: message,
		      // By being enumerable, JSON.stringify will include `message` in the
		      // resulting output. This ensures that the simplist possible GraphQL
		      // service adheres to the spec.
		      enumerable: true,
		      // Note: you really shouldn't overwrite message, but it enables
		      // Error brand-checking.
		      writable: true
		    });
	
		    Object.defineProperty(_this, 'stack', {
		      value: stack || message,
		      // Note: stack should not really be writable, but some libraries (such
		      // as bluebird) use Error brand-checking which specifically looks to see
		      // if stack is a writable property.
		      writable: true
		    });
	
		    Object.defineProperty(_this, 'nodes', { value: nodes });
	
		    // Note: flow does not yet know about Object.defineProperty with `get`.
		    Object.defineProperty(_this, 'source', {
		      get: function get() {
		        if (source) {
		          return source;
		        }
		        if (nodes && nodes.length > 0) {
		          var node = nodes[0];
		          return node && node.loc && node.loc.source;
		        }
		      }
		    });
	
		    Object.defineProperty(_this, 'positions', {
		      get: function get() {
		        if (positions) {
		          return positions;
		        }
		        if (nodes) {
		          var nodePositions = nodes.map(function (node) {
		            return node.loc && node.loc.start;
		          });
		          if (nodePositions.some(function (p) {
		            return p;
		          })) {
		            return nodePositions;
		          }
		        }
		      }
		    });
	
		    Object.defineProperty(_this, 'locations', {
		      get: function get() {
		        var _positions = this.positions;
		        var _source = this.source;
		        if (_positions && _positions.length > 0 && _source) {
		          return _positions.map(function (pos) {
		            return (0, _language.getLocation)(_source, pos);
		          });
		        }
		      },
	
		      // By being enumerable, JSON.stringify will include `locations` in the
		      // resulting output. This ensures that the simplist possible GraphQL
		      // service adheres to the spec.
		      enumerable: true
		    });
	
		    Object.defineProperty(_this, 'path', {
		      value: path,
		      // By being enumerable, JSON.stringify will include `path` in the
		      // resulting output. This ensures that the simplist possible GraphQL
		      // service adheres to the spec.
		      enumerable: true
		    });
	
		    Object.defineProperty(_this, 'originalError', {
		      value: originalError
		    });
		    return _this;
		  }
	
		  return GraphQLError;
		}(Error);
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.BREAK = exports.visitWithTypeInfo = exports.visitInParallel = exports.visit = exports.Source = exports.print = exports.parseValue = exports.parse = exports.lex = exports.Kind = exports.getLocation = undefined;
	
		var _location = __webpack_require__(6);
	
		Object.defineProperty(exports, 'getLocation', {
		  enumerable: true,
		  get: function get() {
		    return _location.getLocation;
		  }
		});
	
		var _lexer = __webpack_require__(7);
	
		Object.defineProperty(exports, 'lex', {
		  enumerable: true,
		  get: function get() {
		    return _lexer.lex;
		  }
		});
	
		var _parser = __webpack_require__(1);
	
		Object.defineProperty(exports, 'parse', {
		  enumerable: true,
		  get: function get() {
		    return _parser.parse;
		  }
		});
		Object.defineProperty(exports, 'parseValue', {
		  enumerable: true,
		  get: function get() {
		    return _parser.parseValue;
		  }
		});
	
		var _printer = __webpack_require__(8);
	
		Object.defineProperty(exports, 'print', {
		  enumerable: true,
		  get: function get() {
		    return _printer.print;
		  }
		});
	
		var _source = __webpack_require__(2);
	
		Object.defineProperty(exports, 'Source', {
		  enumerable: true,
		  get: function get() {
		    return _source.Source;
		  }
		});
	
		var _visitor = __webpack_require__(9);
	
		Object.defineProperty(exports, 'visit', {
		  enumerable: true,
		  get: function get() {
		    return _visitor.visit;
		  }
		});
		Object.defineProperty(exports, 'visitInParallel', {
		  enumerable: true,
		  get: function get() {
		    return _visitor.visitInParallel;
		  }
		});
		Object.defineProperty(exports, 'visitWithTypeInfo', {
		  enumerable: true,
		  get: function get() {
		    return _visitor.visitWithTypeInfo;
		  }
		});
		Object.defineProperty(exports, 'BREAK', {
		  enumerable: true,
		  get: function get() {
		    return _visitor.BREAK;
		  }
		});
	
		var _kinds = __webpack_require__(10);
	
		var Kind = _interopRequireWildcard(_kinds);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		exports.Kind = Kind;
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.getLocation = getLocation;
	
	
		/**
		 * Takes a Source and a UTF-8 character offset, and returns the corresponding
		 * line and column as a SourceLocation.
		 */
	
		/**
		 *  Copyright (c) 2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		function getLocation(source, position) {
		  var lineRegexp = /\r\n|[\n\r]/g;
		  var line = 1;
		  var column = position + 1;
		  var match = void 0;
		  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
		    line += 1;
		    column = position + 1 - (match.index + match[0].length);
		  }
		  return { line: line, column: column };
		}
	
		/**
		 * Represents a location in a Source.
		 */
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.TokenKind = undefined;
		exports.lex = lex;
		exports.getTokenDesc = getTokenDesc;
		exports.getTokenKindDesc = getTokenKindDesc;
	
		var _error = __webpack_require__(3);
	
		/**
		 * Given a Source object, this returns a Lexer for that source.
		 * A Lexer is a function that acts like a generator in that every time
		 * it is called, it returns the next token in the Source. Assuming the
		 * source lexes, the final Token emitted by the lexer will be of kind
		 * EOF, after which the lexer will repeatedly return EOF tokens whenever
		 * called.
		 *
		 * The argument to the lexer function is optional, and can be used to
		 * rewind or fast forward the lexer to a new position in the source.
		 */
	
	
		/**
		 * A representation of a lexed Token. Value only appears for non-punctuation
		 * tokens: NAME, INT, FLOAT, and STRING.
		 */
		/*  /
		/**
		 *  Copyright (c) 2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		function lex(source) {
		  var prevPosition = 0;
		  return function nextToken(resetPosition) {
		    var token = readToken(source, resetPosition === undefined ? prevPosition : resetPosition);
		    prevPosition = token.end;
		    return token;
		  };
		}
	
		/**
		 * An enum describing the different kinds of tokens that the lexer emits.
		 */
		var TokenKind = exports.TokenKind = {
		  EOF: 1,
		  BANG: 2,
		  DOLLAR: 3,
		  PAREN_L: 4,
		  PAREN_R: 5,
		  SPREAD: 6,
		  COLON: 7,
		  EQUALS: 8,
		  AT: 9,
		  BRACKET_L: 10,
		  BRACKET_R: 11,
		  BRACE_L: 12,
		  PIPE: 13,
		  BRACE_R: 14,
		  NAME: 15,
		  INT: 16,
		  FLOAT: 17,
		  STRING: 18
		};
	
		/**
		 * A helper function to describe a token as a string for debugging
		 */
		function getTokenDesc(token) {
		  var value = token.value;
		  return value ? getTokenKindDesc(token.kind) + ' "' + value + '"' : getTokenKindDesc(token.kind);
		}
	
		/**
		 * A helper function to describe a token kind as a string for debugging
		 */
		function getTokenKindDesc(kind) {
		  return tokenDescription[kind];
		}
	
		var tokenDescription = {};
		tokenDescription[TokenKind.EOF] = 'EOF';
		tokenDescription[TokenKind.BANG] = '!';
		tokenDescription[TokenKind.DOLLAR] = '$';
		tokenDescription[TokenKind.PAREN_L] = '(';
		tokenDescription[TokenKind.PAREN_R] = ')';
		tokenDescription[TokenKind.SPREAD] = '...';
		tokenDescription[TokenKind.COLON] = ':';
		tokenDescription[TokenKind.EQUALS] = '=';
		tokenDescription[TokenKind.AT] = '@';
		tokenDescription[TokenKind.BRACKET_L] = '[';
		tokenDescription[TokenKind.BRACKET_R] = ']';
		tokenDescription[TokenKind.BRACE_L] = '{';
		tokenDescription[TokenKind.PIPE] = '|';
		tokenDescription[TokenKind.BRACE_R] = '}';
		tokenDescription[TokenKind.NAME] = 'Name';
		tokenDescription[TokenKind.INT] = 'Int';
		tokenDescription[TokenKind.FLOAT] = 'Float';
		tokenDescription[TokenKind.STRING] = 'String';
	
		var charCodeAt = String.prototype.charCodeAt;
		var slice = String.prototype.slice;
	
		/**
		 * Helper function for constructing the Token object.
		 */
		function makeToken(kind, start, end, value) {
		  return { kind: kind, start: start, end: end, value: value };
		}
	
		function printCharCode(code) {
		  return (
		    // NaN/undefined represents access beyond the end of the file.
		    isNaN(code) ? '<EOF>' :
		    // Trust JSON for ASCII.
		    code < 0x007F ? JSON.stringify(String.fromCharCode(code)) :
		    // Otherwise print the escaped form.
		    '"\\u' + ('00' + code.toString(16).toUpperCase()).slice(-4) + '"'
		  );
		}
	
		/**
		 * Gets the next token from the source starting at the given position.
		 *
		 * This skips over whitespace and comments until it finds the next lexable
		 * token, then lexes punctuators immediately or calls the appropriate helper
		 * function for more complicated tokens.
		 */
		function readToken(source, fromPosition) {
		  var body = source.body;
		  var bodyLength = body.length;
	
		  var position = positionAfterWhitespace(body, fromPosition);
	
		  if (position >= bodyLength) {
		    return makeToken(TokenKind.EOF, position, position);
		  }
	
		  var code = charCodeAt.call(body, position);
	
		  // SourceCharacter
		  if (code < 0x0020 && code !== 0x0009 && code !== 0x000A && code !== 0x000D) {
		    throw (0, _error.syntaxError)(source, position, 'Invalid character ' + printCharCode(code) + '.');
		  }
	
		  switch (code) {
		    // !
		    case 33:
		      return makeToken(TokenKind.BANG, position, position + 1);
		    // $
		    case 36:
		      return makeToken(TokenKind.DOLLAR, position, position + 1);
		    // (
		    case 40:
		      return makeToken(TokenKind.PAREN_L, position, position + 1);
		    // )
		    case 41:
		      return makeToken(TokenKind.PAREN_R, position, position + 1);
		    // .
		    case 46:
		      if (charCodeAt.call(body, position + 1) === 46 && charCodeAt.call(body, position + 2) === 46) {
		        return makeToken(TokenKind.SPREAD, position, position + 3);
		      }
		      break;
		    // :
		    case 58:
		      return makeToken(TokenKind.COLON, position, position + 1);
		    // =
		    case 61:
		      return makeToken(TokenKind.EQUALS, position, position + 1);
		    // @
		    case 64:
		      return makeToken(TokenKind.AT, position, position + 1);
		    // [
		    case 91:
		      return makeToken(TokenKind.BRACKET_L, position, position + 1);
		    // ]
		    case 93:
		      return makeToken(TokenKind.BRACKET_R, position, position + 1);
		    // {
		    case 123:
		      return makeToken(TokenKind.BRACE_L, position, position + 1);
		    // |
		    case 124:
		      return makeToken(TokenKind.PIPE, position, position + 1);
		    // }
		    case 125:
		      return makeToken(TokenKind.BRACE_R, position, position + 1);
		    // A-Z _ a-z
		    case 65:case 66:case 67:case 68:case 69:case 70:case 71:case 72:
		    case 73:case 74:case 75:case 76:case 77:case 78:case 79:case 80:
		    case 81:case 82:case 83:case 84:case 85:case 86:case 87:case 88:
		    case 89:case 90:
		    case 95:
		    case 97:case 98:case 99:case 100:case 101:case 102:case 103:case 104:
		    case 105:case 106:case 107:case 108:case 109:case 110:case 111:
		    case 112:case 113:case 114:case 115:case 116:case 117:case 118:
		    case 119:case 120:case 121:case 122:
		      return readName(source, position);
		    // - 0-9
		    case 45:
		    case 48:case 49:case 50:case 51:case 52:
		    case 53:case 54:case 55:case 56:case 57:
		      return readNumber(source, position, code);
		    // "
		    case 34:
		      return readString(source, position);
		  }
	
		  throw (0, _error.syntaxError)(source, position, 'Unexpected character ' + printCharCode(code) + '.');
		}
	
		/**
		 * Reads from body starting at startPosition until it finds a non-whitespace
		 * or commented character, then returns the position of that character for
		 * lexing.
		 */
		function positionAfterWhitespace(body, startPosition) {
		  var bodyLength = body.length;
		  var position = startPosition;
		  while (position < bodyLength) {
		    var code = charCodeAt.call(body, position);
		    // Skip Ignored
		    if (
		    // BOM
		    code === 0xFEFF ||
		    // White Space
		    code === 0x0009 || // tab
		    code === 0x0020 || // space
		    // Line Terminator
		    code === 0x000A || // new line
		    code === 0x000D || // carriage return
		    // Comma
		    code === 0x002C) {
		      ++position;
		      // Skip comments
		    } else if (code === 35) {
		      // #
		      ++position;
		      while (position < bodyLength && (code = charCodeAt.call(body, position)) !== null && (
		      // SourceCharacter but not LineTerminator
		      code > 0x001F || code === 0x0009) && code !== 0x000A && code !== 0x000D) {
		        ++position;
		      }
		    } else {
		      break;
		    }
		  }
		  return position;
		}
	
		/**
		 * Reads a number token from the source file, either a float
		 * or an int depending on whether a decimal point appears.
		 *
		 * Int:   -?(0|[1-9][0-9]*)
		 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
		 */
		function readNumber(source, start, firstCode) {
		  var body = source.body;
		  var code = firstCode;
		  var position = start;
		  var isFloat = false;
	
		  if (code === 45) {
		    // -
		    code = charCodeAt.call(body, ++position);
		  }
	
		  if (code === 48) {
		    // 0
		    code = charCodeAt.call(body, ++position);
		    if (code >= 48 && code <= 57) {
		      throw (0, _error.syntaxError)(source, position, 'Invalid number, unexpected digit after 0: ' + printCharCode(code) + '.');
		    }
		  } else {
		    position = readDigits(source, position, code);
		    code = charCodeAt.call(body, position);
		  }
	
		  if (code === 46) {
		    // .
		    isFloat = true;
	
		    code = charCodeAt.call(body, ++position);
		    position = readDigits(source, position, code);
		    code = charCodeAt.call(body, position);
		  }
	
		  if (code === 69 || code === 101) {
		    // E e
		    isFloat = true;
	
		    code = charCodeAt.call(body, ++position);
		    if (code === 43 || code === 45) {
		      // + -
		      code = charCodeAt.call(body, ++position);
		    }
		    position = readDigits(source, position, code);
		  }
	
		  return makeToken(isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, slice.call(body, start, position));
		}
	
		/**
		 * Returns the new position in the source after reading digits.
		 */
		function readDigits(source, start, firstCode) {
		  var body = source.body;
		  var position = start;
		  var code = firstCode;
		  if (code >= 48 && code <= 57) {
		    // 0 - 9
		    do {
		      code = charCodeAt.call(body, ++position);
		    } while (code >= 48 && code <= 57); // 0 - 9
		    return position;
		  }
		  throw (0, _error.syntaxError)(source, position, 'Invalid number, expected digit but got: ' + printCharCode(code) + '.');
		}
	
		/**
		 * Reads a string token from the source file.
		 *
		 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
		 */
		function readString(source, start) {
		  var body = source.body;
		  var position = start + 1;
		  var chunkStart = position;
		  var code = 0;
		  var value = '';
	
		  while (position < body.length && (code = charCodeAt.call(body, position)) !== null &&
		  // not LineTerminator
		  code !== 0x000A && code !== 0x000D &&
		  // not Quote (")
		  code !== 34) {
		    // SourceCharacter
		    if (code < 0x0020 && code !== 0x0009) {
		      throw (0, _error.syntaxError)(source, position, 'Invalid character within String: ' + printCharCode(code) + '.');
		    }
	
		    ++position;
		    if (code === 92) {
		      // \
		      value += slice.call(body, chunkStart, position - 1);
		      code = charCodeAt.call(body, position);
		      switch (code) {
		        case 34:
		          value += '"';break;
		        case 47:
		          value += '\/';break;
		        case 92:
		          value += '\\';break;
		        case 98:
		          value += '\b';break;
		        case 102:
		          value += '\f';break;
		        case 110:
		          value += '\n';break;
		        case 114:
		          value += '\r';break;
		        case 116:
		          value += '\t';break;
		        case 117:
		          // u
		          var charCode = uniCharCode(charCodeAt.call(body, position + 1), charCodeAt.call(body, position + 2), charCodeAt.call(body, position + 3), charCodeAt.call(body, position + 4));
		          if (charCode < 0) {
		            throw (0, _error.syntaxError)(source, position, 'Invalid character escape sequence: ' + ('\\u' + body.slice(position + 1, position + 5) + '.'));
		          }
		          value += String.fromCharCode(charCode);
		          position += 4;
		          break;
		        default:
		          throw (0, _error.syntaxError)(source, position, 'Invalid character escape sequence: \\' + String.fromCharCode(code) + '.');
		      }
		      ++position;
		      chunkStart = position;
		    }
		  }
	
		  if (code !== 34) {
		    // quote (")
		    throw (0, _error.syntaxError)(source, position, 'Unterminated string.');
		  }
	
		  value += slice.call(body, chunkStart, position);
		  return makeToken(TokenKind.STRING, start, position + 1, value);
		}
	
		/**
		 * Converts four hexidecimal chars to the integer that the
		 * string represents. For example, uniCharCode('0','0','0','f')
		 * will return 15, and uniCharCode('0','0','f','f') returns 255.
		 *
		 * Returns a negative number on error, if a char was invalid.
		 *
		 * This is implemented by noting that char2hex() returns -1 on error,
		 * which means the result of ORing the char2hex() will also be negative.
		 */
		function uniCharCode(a, b, c, d) {
		  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
		}
	
		/**
		 * Converts a hex character to its integer value.
		 * '0' becomes 0, '9' becomes 9
		 * 'A' becomes 10, 'F' becomes 15
		 * 'a' becomes 10, 'f' becomes 15
		 *
		 * Returns -1 on error.
		 */
		function char2hex(a) {
		  return a >= 48 && a <= 57 ? a - 48 : // 0-9
		  a >= 65 && a <= 70 ? a - 55 : // A-F
		  a >= 97 && a <= 102 ? a - 87 : // a-f
		  -1;
		}
	
		/**
		 * Reads an alphanumeric + underscore name from the source.
		 *
		 * [_A-Za-z][_0-9A-Za-z]*
		 */
		function readName(source, position) {
		  var body = source.body;
		  var bodyLength = body.length;
		  var end = position + 1;
		  var code = 0;
		  while (end !== bodyLength && (code = charCodeAt.call(body, end)) !== null && (code === 95 || // _
		  code >= 48 && code <= 57 || // 0-9
		  code >= 65 && code <= 90 || // A-Z
		  code >= 97 && code <= 122 // a-z
		  )) {
		    ++end;
		  }
		  return makeToken(TokenKind.NAME, position, end, slice.call(body, position, end));
		}
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.print = print;
	
		var _visitor = __webpack_require__(9);
	
		/**
		 * Converts an AST into a string, using one set of reasonable
		 * formatting rules.
		 */
		function print(ast) {
		  return (0, _visitor.visit)(ast, { leave: printDocASTReducer });
		} /**
		   *  Copyright (c) 2015, Facebook, Inc.
		   *  All rights reserved.
		   *
		   *  This source code is licensed under the BSD-style license found in the
		   *  LICENSE file in the root directory of this source tree. An additional grant
		   *  of patent rights can be found in the PATENTS file in the same directory.
		   */
	
		var printDocASTReducer = {
		  Name: function Name(node) {
		    return node.value;
		  },
		  Variable: function Variable(node) {
		    return '$' + node.name;
		  },
	
		  // Document
	
		  Document: function Document(node) {
		    return join(node.definitions, '\n\n') + '\n';
		  },
	
		  OperationDefinition: function OperationDefinition(node) {
		    var op = node.operation;
		    var name = node.name;
		    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
		    var directives = join(node.directives, ' ');
		    var selectionSet = node.selectionSet;
		    // Anonymous queries with no directives or variable definitions can use
		    // the query short form.
		    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
		  },
	
	
		  VariableDefinition: function VariableDefinition(_ref) {
		    var variable = _ref.variable;
		    var type = _ref.type;
		    var defaultValue = _ref.defaultValue;
		    return variable + ': ' + type + wrap(' = ', defaultValue);
		  },
	
		  SelectionSet: function SelectionSet(_ref2) {
		    var selections = _ref2.selections;
		    return block(selections);
		  },
	
		  Field: function Field(_ref3) {
		    var alias = _ref3.alias;
		    var name = _ref3.name;
		    var args = _ref3.arguments;
		    var directives = _ref3.directives;
		    var selectionSet = _ref3.selectionSet;
		    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
		  },
	
		  Argument: function Argument(_ref4) {
		    var name = _ref4.name;
		    var value = _ref4.value;
		    return name + ': ' + value;
		  },
	
		  // Fragments
	
		  FragmentSpread: function FragmentSpread(_ref5) {
		    var name = _ref5.name;
		    var directives = _ref5.directives;
		    return '...' + name + wrap(' ', join(directives, ' '));
		  },
	
		  InlineFragment: function InlineFragment(_ref6) {
		    var typeCondition = _ref6.typeCondition;
		    var directives = _ref6.directives;
		    var selectionSet = _ref6.selectionSet;
		    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
		  },
	
		  FragmentDefinition: function FragmentDefinition(_ref7) {
		    var name = _ref7.name;
		    var typeCondition = _ref7.typeCondition;
		    var directives = _ref7.directives;
		    var selectionSet = _ref7.selectionSet;
		    return 'fragment ' + name + ' on ' + typeCondition + ' ' + wrap('', join(directives, ' '), ' ') + selectionSet;
		  },
	
		  // Value
	
		  IntValue: function IntValue(_ref8) {
		    var value = _ref8.value;
		    return value;
		  },
		  FloatValue: function FloatValue(_ref9) {
		    var value = _ref9.value;
		    return value;
		  },
		  StringValue: function StringValue(_ref10) {
		    var value = _ref10.value;
		    return JSON.stringify(value);
		  },
		  BooleanValue: function BooleanValue(_ref11) {
		    var value = _ref11.value;
		    return JSON.stringify(value);
		  },
		  EnumValue: function EnumValue(_ref12) {
		    var value = _ref12.value;
		    return value;
		  },
		  ListValue: function ListValue(_ref13) {
		    var values = _ref13.values;
		    return '[' + join(values, ', ') + ']';
		  },
		  ObjectValue: function ObjectValue(_ref14) {
		    var fields = _ref14.fields;
		    return '{' + join(fields, ', ') + '}';
		  },
		  ObjectField: function ObjectField(_ref15) {
		    var name = _ref15.name;
		    var value = _ref15.value;
		    return name + ': ' + value;
		  },
	
		  // Directive
	
		  Directive: function Directive(_ref16) {
		    var name = _ref16.name;
		    var args = _ref16.arguments;
		    return '@' + name + wrap('(', join(args, ', '), ')');
		  },
	
		  // Type
	
		  NamedType: function NamedType(_ref17) {
		    var name = _ref17.name;
		    return name;
		  },
		  ListType: function ListType(_ref18) {
		    var type = _ref18.type;
		    return '[' + type + ']';
		  },
		  NonNullType: function NonNullType(_ref19) {
		    var type = _ref19.type;
		    return type + '!';
		  },
	
		  // Type System Definitions
	
		  SchemaDefinition: function SchemaDefinition(_ref20) {
		    var directives = _ref20.directives;
		    var operationTypes = _ref20.operationTypes;
		    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
		  },
	
		  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
		    var operation = _ref21.operation;
		    var type = _ref21.type;
		    return operation + ': ' + type;
		  },
	
		  ScalarTypeDefinition: function ScalarTypeDefinition(_ref22) {
		    var name = _ref22.name;
		    var directives = _ref22.directives;
		    return join(['scalar', name, join(directives, ' ')], ' ');
		  },
	
		  ObjectTypeDefinition: function ObjectTypeDefinition(_ref23) {
		    var name = _ref23.name;
		    var interfaces = _ref23.interfaces;
		    var directives = _ref23.directives;
		    var fields = _ref23.fields;
		    return join(['type', name, wrap('implements ', join(interfaces, ', ')), join(directives, ' '), block(fields)], ' ');
		  },
	
		  FieldDefinition: function FieldDefinition(_ref24) {
		    var name = _ref24.name;
		    var args = _ref24.arguments;
		    var type = _ref24.type;
		    var directives = _ref24.directives;
		    return name + wrap('(', join(args, ', '), ')') + ': ' + type + wrap(' ', join(directives, ' '));
		  },
	
		  InputValueDefinition: function InputValueDefinition(_ref25) {
		    var name = _ref25.name;
		    var type = _ref25.type;
		    var defaultValue = _ref25.defaultValue;
		    var directives = _ref25.directives;
		    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
		  },
	
		  InterfaceTypeDefinition: function InterfaceTypeDefinition(_ref26) {
		    var name = _ref26.name;
		    var directives = _ref26.directives;
		    var fields = _ref26.fields;
		    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
		  },
	
		  UnionTypeDefinition: function UnionTypeDefinition(_ref27) {
		    var name = _ref27.name;
		    var directives = _ref27.directives;
		    var types = _ref27.types;
		    return join(['union', name, join(directives, ' '), '= ' + join(types, ' | ')], ' ');
		  },
	
		  EnumTypeDefinition: function EnumTypeDefinition(_ref28) {
		    var name = _ref28.name;
		    var directives = _ref28.directives;
		    var values = _ref28.values;
		    return join(['enum', name, join(directives, ' '), block(values)], ' ');
		  },
	
		  EnumValueDefinition: function EnumValueDefinition(_ref29) {
		    var name = _ref29.name;
		    var directives = _ref29.directives;
		    return join([name, join(directives, ' ')], ' ');
		  },
	
		  InputObjectTypeDefinition: function InputObjectTypeDefinition(_ref30) {
		    var name = _ref30.name;
		    var directives = _ref30.directives;
		    var fields = _ref30.fields;
		    return join(['input', name, join(directives, ' '), block(fields)], ' ');
		  },
	
		  TypeExtensionDefinition: function TypeExtensionDefinition(_ref31) {
		    var definition = _ref31.definition;
		    return 'extend ' + definition;
		  },
	
		  DirectiveDefinition: function DirectiveDefinition(_ref32) {
		    var name = _ref32.name;
		    var args = _ref32.arguments;
		    var locations = _ref32.locations;
		    return 'directive @' + name + wrap('(', join(args, ', '), ')') + ' on ' + join(locations, ' | ');
		  }
		};
	
		/**
		 * Given maybeArray, print an empty string if it is null or empty, otherwise
		 * print all items together separated by separator if provided
		 */
		function join(maybeArray, separator) {
		  return maybeArray ? maybeArray.filter(function (x) {
		    return x;
		  }).join(separator || '') : '';
		}
	
		/**
		 * Given array, print each item on its own line, wrapped in an
		 * indented "{ }" block.
		 */
		function block(array) {
		  return array && array.length !== 0 ? indent('{\n' + join(array, '\n')) + '\n}' : '{}';
		}
	
		/**
		 * If maybeString is not null or empty, then wrap with start and end, otherwise
		 * print an empty string.
		 */
		function wrap(start, maybeString, end) {
		  return maybeString ? start + maybeString + (end || '') : '';
		}
	
		function indent(maybeString) {
		  return maybeString && maybeString.replace(/\n/g, '\n  ');
		}
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.visit = visit;
		exports.visitInParallel = visitInParallel;
		exports.visitWithTypeInfo = visitWithTypeInfo;
		/**
		 *  Copyright (c) 2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		var QueryDocumentKeys = exports.QueryDocumentKeys = {
		  Name: [],
	
		  Document: ['definitions'],
		  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
		  VariableDefinition: ['variable', 'type', 'defaultValue'],
		  Variable: ['name'],
		  SelectionSet: ['selections'],
		  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
		  Argument: ['name', 'value'],
	
		  FragmentSpread: ['name', 'directives'],
		  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
		  FragmentDefinition: ['name', 'typeCondition', 'directives', 'selectionSet'],
	
		  IntValue: [],
		  FloatValue: [],
		  StringValue: [],
		  BooleanValue: [],
		  EnumValue: [],
		  ListValue: ['values'],
		  ObjectValue: ['fields'],
		  ObjectField: ['name', 'value'],
	
		  Directive: ['name', 'arguments'],
	
		  NamedType: ['name'],
		  ListType: ['type'],
		  NonNullType: ['type'],
	
		  SchemaDefinition: ['directives', 'operationTypes'],
		  OperationTypeDefinition: ['type'],
	
		  ScalarTypeDefinition: ['name', 'directives'],
		  ObjectTypeDefinition: ['name', 'interfaces', 'directives', 'fields'],
		  FieldDefinition: ['name', 'arguments', 'type', 'directives'],
		  InputValueDefinition: ['name', 'type', 'defaultValue', 'directives'],
		  InterfaceTypeDefinition: ['name', 'directives', 'fields'],
		  UnionTypeDefinition: ['name', 'directives', 'types'],
		  EnumTypeDefinition: ['name', 'directives', 'values'],
		  EnumValueDefinition: ['name', 'directives'],
		  InputObjectTypeDefinition: ['name', 'directives', 'fields'],
	
		  TypeExtensionDefinition: ['definition'],
	
		  DirectiveDefinition: ['name', 'arguments', 'locations']
		};
	
		var BREAK = exports.BREAK = {};
	
		/**
		 * visit() will walk through an AST using a depth first traversal, calling
		 * the visitor's enter function at each node in the traversal, and calling the
		 * leave function after visiting that node and all of its child nodes.
		 *
		 * By returning different values from the enter and leave functions, the
		 * behavior of the visitor can be altered, including skipping over a sub-tree of
		 * the AST (by returning false), editing the AST by returning a value or null
		 * to remove the value, or to stop the whole traversal by returning BREAK.
		 *
		 * When using visit() to edit an AST, the original AST will not be modified, and
		 * a new version of the AST with the changes applied will be returned from the
		 * visit function.
		 *
		 *     const editedAST = visit(ast, {
		 *       enter(node, key, parent, path, ancestors) {
		 *         // @return
		 *         //   undefined: no action
		 *         //   false: skip visiting this node
		 *         //   visitor.BREAK: stop visiting altogether
		 *         //   null: delete this node
		 *         //   any value: replace this node with the returned value
		 *       },
		 *       leave(node, key, parent, path, ancestors) {
		 *         // @return
		 *         //   undefined: no action
		 *         //   false: no action
		 *         //   visitor.BREAK: stop visiting altogether
		 *         //   null: delete this node
		 *         //   any value: replace this node with the returned value
		 *       }
		 *     });
		 *
		 * Alternatively to providing enter() and leave() functions, a visitor can
		 * instead provide functions named the same as the kinds of AST nodes, or
		 * enter/leave visitors at a named key, leading to four permutations of
		 * visitor API:
		 *
		 * 1) Named visitors triggered when entering a node a specific kind.
		 *
		 *     visit(ast, {
		 *       Kind(node) {
		 *         // enter the "Kind" node
		 *       }
		 *     })
		 *
		 * 2) Named visitors that trigger upon entering and leaving a node of
		 *    a specific kind.
		 *
		 *     visit(ast, {
		 *       Kind: {
		 *         enter(node) {
		 *           // enter the "Kind" node
		 *         }
		 *         leave(node) {
		 *           // leave the "Kind" node
		 *         }
		 *       }
		 *     })
		 *
		 * 3) Generic visitors that trigger upon entering and leaving any node.
		 *
		 *     visit(ast, {
		 *       enter(node) {
		 *         // enter any node
		 *       },
		 *       leave(node) {
		 *         // leave any node
		 *       }
		 *     })
		 *
		 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
		 *
		 *     visit(ast, {
		 *       enter: {
		 *         Kind(node) {
		 *           // enter the "Kind" node
		 *         }
		 *       },
		 *       leave: {
		 *         Kind(node) {
		 *           // leave the "Kind" node
		 *         }
		 *       }
		 *     })
		 */
		function visit(root, visitor, keyMap) {
		  var visitorKeys = keyMap || QueryDocumentKeys;
	
		  var stack = void 0;
		  var inArray = Array.isArray(root);
		  var keys = [root];
		  var index = -1;
		  var edits = [];
		  var parent = void 0;
		  var path = [];
		  var ancestors = [];
		  var newRoot = root;
	
		  do {
		    index++;
		    var isLeaving = index === keys.length;
		    var key = void 0;
		    var node = void 0;
		    var isEdited = isLeaving && edits.length !== 0;
		    if (isLeaving) {
		      key = ancestors.length === 0 ? undefined : path.pop();
		      node = parent;
		      parent = ancestors.pop();
		      if (isEdited) {
		        if (inArray) {
		          node = node.slice();
		        } else {
		          var clone = {};
		          for (var k in node) {
		            if (node.hasOwnProperty(k)) {
		              clone[k] = node[k];
		            }
		          }
		          node = clone;
		        }
		        var editOffset = 0;
		        for (var ii = 0; ii < edits.length; ii++) {
		          var editKey = edits[ii][0];
		          var editValue = edits[ii][1];
		          if (inArray) {
		            editKey -= editOffset;
		          }
		          if (inArray && editValue === null) {
		            node.splice(editKey, 1);
		            editOffset++;
		          } else {
		            node[editKey] = editValue;
		          }
		        }
		      }
		      index = stack.index;
		      keys = stack.keys;
		      edits = stack.edits;
		      inArray = stack.inArray;
		      stack = stack.prev;
		    } else {
		      key = parent ? inArray ? index : keys[index] : undefined;
		      node = parent ? parent[key] : newRoot;
		      if (node === null || node === undefined) {
		        continue;
		      }
		      if (parent) {
		        path.push(key);
		      }
		    }
	
		    var result = void 0;
		    if (!Array.isArray(node)) {
		      if (!isNode(node)) {
		        throw new Error('Invalid AST Node: ' + JSON.stringify(node));
		      }
		      var visitFn = getVisitFn(visitor, node.kind, isLeaving);
		      if (visitFn) {
		        result = visitFn.call(visitor, node, key, parent, path, ancestors);
	
		        if (result === BREAK) {
		          break;
		        }
	
		        if (result === false) {
		          if (!isLeaving) {
		            path.pop();
		            continue;
		          }
		        } else if (result !== undefined) {
		          edits.push([key, result]);
		          if (!isLeaving) {
		            if (isNode(result)) {
		              node = result;
		            } else {
		              path.pop();
		              continue;
		            }
		          }
		        }
		      }
		    }
	
		    if (result === undefined && isEdited) {
		      edits.push([key, node]);
		    }
	
		    if (!isLeaving) {
		      stack = { inArray: inArray, index: index, keys: keys, edits: edits, prev: stack };
		      inArray = Array.isArray(node);
		      keys = inArray ? node : visitorKeys[node.kind] || [];
		      index = -1;
		      edits = [];
		      if (parent) {
		        ancestors.push(parent);
		      }
		      parent = node;
		    }
		  } while (stack !== undefined);
	
		  if (edits.length !== 0) {
		    newRoot = edits[edits.length - 1][1];
		  }
	
		  return newRoot;
		}
	
		function isNode(maybeNode) {
		  return maybeNode && typeof maybeNode.kind === 'string';
		}
	
		/**
		 * Creates a new visitor instance which delegates to many visitors to run in
		 * parallel. Each visitor will be visited for each node before moving on.
		 *
		 * If a prior visitor edits a node, no following visitors will see that node.
		 */
		function visitInParallel(visitors) {
		  var skipping = new Array(visitors.length);
	
		  return {
		    enter: function enter(node) {
		      for (var i = 0; i < visitors.length; i++) {
		        if (!skipping[i]) {
		          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */false);
		          if (fn) {
		            var result = fn.apply(visitors[i], arguments);
		            if (result === false) {
		              skipping[i] = node;
		            } else if (result === BREAK) {
		              skipping[i] = BREAK;
		            } else if (result !== undefined) {
		              return result;
		            }
		          }
		        }
		      }
		    },
		    leave: function leave(node) {
		      for (var i = 0; i < visitors.length; i++) {
		        if (!skipping[i]) {
		          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */true);
		          if (fn) {
		            var result = fn.apply(visitors[i], arguments);
		            if (result === BREAK) {
		              skipping[i] = BREAK;
		            } else if (result !== undefined && result !== false) {
		              return result;
		            }
		          }
		        } else if (skipping[i] === node) {
		          skipping[i] = null;
		        }
		      }
		    }
		  };
		}
	
		/**
		 * Creates a new visitor instance which maintains a provided TypeInfo instance
		 * along with visiting visitor.
		 */
		function visitWithTypeInfo(typeInfo, visitor) {
		  return {
		    enter: function enter(node) {
		      typeInfo.enter(node);
		      var fn = getVisitFn(visitor, node.kind, /* isLeaving */false);
		      if (fn) {
		        var result = fn.apply(visitor, arguments);
		        if (result !== undefined) {
		          typeInfo.leave(node);
		          if (isNode(result)) {
		            typeInfo.enter(result);
		          }
		        }
		        return result;
		      }
		    },
		    leave: function leave(node) {
		      var fn = getVisitFn(visitor, node.kind, /* isLeaving */true);
		      var result = void 0;
		      if (fn) {
		        result = fn.apply(visitor, arguments);
		      }
		      typeInfo.leave(node);
		      return result;
		    }
		  };
		}
	
		/**
		 * Given a visitor instance, if it is leaving or not, and a node kind, return
		 * the function the visitor runtime should call.
		 */
		function getVisitFn(visitor, kind, isLeaving) {
		  var kindVisitor = visitor[kind];
		  if (kindVisitor) {
		    if (!isLeaving && typeof kindVisitor === 'function') {
		      // { Kind() {} }
		      return kindVisitor;
		    }
		    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
		    if (typeof kindSpecificVisitor === 'function') {
		      // { Kind: { enter() {}, leave() {} } }
		      return kindSpecificVisitor;
		    }
		  } else {
		    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
		    if (specificVisitor) {
		      if (typeof specificVisitor === 'function') {
		        // { enter() {}, leave() {} }
		        return specificVisitor;
		      }
		      var specificKindVisitor = specificVisitor[kind];
		      if (typeof specificKindVisitor === 'function') {
		        // { enter: { Kind() {} }, leave: { Kind() {} } }
		        return specificKindVisitor;
		      }
		    }
		  }
		}
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		/**
		 *  Copyright (c) 2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		// Name
	
		var NAME = exports.NAME = 'Name';
	
		// Document
	
		var DOCUMENT = exports.DOCUMENT = 'Document';
		var OPERATION_DEFINITION = exports.OPERATION_DEFINITION = 'OperationDefinition';
		var VARIABLE_DEFINITION = exports.VARIABLE_DEFINITION = 'VariableDefinition';
		var VARIABLE = exports.VARIABLE = 'Variable';
		var SELECTION_SET = exports.SELECTION_SET = 'SelectionSet';
		var FIELD = exports.FIELD = 'Field';
		var ARGUMENT = exports.ARGUMENT = 'Argument';
	
		// Fragments
	
		var FRAGMENT_SPREAD = exports.FRAGMENT_SPREAD = 'FragmentSpread';
		var INLINE_FRAGMENT = exports.INLINE_FRAGMENT = 'InlineFragment';
		var FRAGMENT_DEFINITION = exports.FRAGMENT_DEFINITION = 'FragmentDefinition';
	
		// Values
	
		var INT = exports.INT = 'IntValue';
		var FLOAT = exports.FLOAT = 'FloatValue';
		var STRING = exports.STRING = 'StringValue';
		var BOOLEAN = exports.BOOLEAN = 'BooleanValue';
		var ENUM = exports.ENUM = 'EnumValue';
		var LIST = exports.LIST = 'ListValue';
		var OBJECT = exports.OBJECT = 'ObjectValue';
		var OBJECT_FIELD = exports.OBJECT_FIELD = 'ObjectField';
	
		// Directives
	
		var DIRECTIVE = exports.DIRECTIVE = 'Directive';
	
		// Types
	
		var NAMED_TYPE = exports.NAMED_TYPE = 'NamedType';
		var LIST_TYPE = exports.LIST_TYPE = 'ListType';
		var NON_NULL_TYPE = exports.NON_NULL_TYPE = 'NonNullType';
	
		// Type System Definitions
	
		var SCHEMA_DEFINITION = exports.SCHEMA_DEFINITION = 'SchemaDefinition';
		var OPERATION_TYPE_DEFINITION = exports.OPERATION_TYPE_DEFINITION = 'OperationTypeDefinition';
	
		// Type Definitions
	
		var SCALAR_TYPE_DEFINITION = exports.SCALAR_TYPE_DEFINITION = 'ScalarTypeDefinition';
		var OBJECT_TYPE_DEFINITION = exports.OBJECT_TYPE_DEFINITION = 'ObjectTypeDefinition';
		var FIELD_DEFINITION = exports.FIELD_DEFINITION = 'FieldDefinition';
		var INPUT_VALUE_DEFINITION = exports.INPUT_VALUE_DEFINITION = 'InputValueDefinition';
		var INTERFACE_TYPE_DEFINITION = exports.INTERFACE_TYPE_DEFINITION = 'InterfaceTypeDefinition';
		var UNION_TYPE_DEFINITION = exports.UNION_TYPE_DEFINITION = 'UnionTypeDefinition';
		var ENUM_TYPE_DEFINITION = exports.ENUM_TYPE_DEFINITION = 'EnumTypeDefinition';
		var ENUM_VALUE_DEFINITION = exports.ENUM_VALUE_DEFINITION = 'EnumValueDefinition';
		var INPUT_OBJECT_TYPE_DEFINITION = exports.INPUT_OBJECT_TYPE_DEFINITION = 'InputObjectTypeDefinition';
	
		// Type Extensions
	
		var TYPE_EXTENSION_DEFINITION = exports.TYPE_EXTENSION_DEFINITION = 'TypeExtensionDefinition';
	
		// Directive Definitions
	
		var DIRECTIVE_DEFINITION = exports.DIRECTIVE_DEFINITION = 'DirectiveDefinition';
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.syntaxError = syntaxError;
	
		var _location = __webpack_require__(6);
	
		var _GraphQLError = __webpack_require__(4);
	
		/**
		 * Produces a GraphQLError representing a syntax error, containing useful
		 * descriptive information about the syntax error's position in the source.
		 */
	
		/**
		 *  Copyright (c) 2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		function syntaxError(source, position, description) {
		  var location = (0, _location.getLocation)(source, position);
		  var error = new _GraphQLError.GraphQLError('Syntax Error ' + source.name + ' (' + location.line + ':' + location.column + ') ' + description + '\n\n' + highlightSourceAtLocation(source, location), undefined, undefined, source, [position]);
		  return error;
		}
	
		/**
		 * Render a helpful description of the location of the error in the GraphQL
		 * Source document.
		 */
		function highlightSourceAtLocation(source, location) {
		  var line = location.line;
		  var prevLineNum = (line - 1).toString();
		  var lineNum = line.toString();
		  var nextLineNum = (line + 1).toString();
		  var padLen = nextLineNum.length;
		  var lines = source.body.split(/\r\n|[\n\r]/g);
		  return (line >= 2 ? lpad(padLen, prevLineNum) + ': ' + lines[line - 2] + '\n' : '') + lpad(padLen, lineNum) + ': ' + lines[line - 1] + '\n' + Array(2 + padLen + location.column).join(' ') + '^\n' + (line < lines.length ? lpad(padLen, nextLineNum) + ': ' + lines[line] + '\n' : '');
		}
	
		function lpad(len, str) {
		  return Array(len - str.length + 1).join(' ') + str;
		}
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.locatedError = locatedError;
	
		var _GraphQLError = __webpack_require__(4);
	
		/**
		 * Given an arbitrary Error, presumably thrown while attempting to execute a
		 * GraphQL operation, produce a new GraphQLError aware of the location in the
		 * document responsible for the original Error.
		 */
		function locatedError(originalError, nodes, path) {
		  // Note: this uses a brand-check to support GraphQL errors originating from
		  // other contexts.
		  if (originalError && originalError.hasOwnProperty('locations')) {
		    return originalError;
		  }
	
		  var message = originalError ? originalError.message || String(originalError) : 'An unknown error occurred.';
		  var stack = originalError ? originalError.stack : null;
		  return new _GraphQLError.GraphQLError(message, nodes, stack, null, null, path, originalError);
		}
		/**
		 *  Copyright (c) 2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.formatError = formatError;
	
		var _invariant = __webpack_require__(14);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/**
		 * Given a GraphQLError, format it according to the rules described by the
		 * Response Format, Errors section of the GraphQL Specification.
		 */
		function formatError(error) {
		  (0, _invariant2.default)(error, 'Received null or undefined error.');
		  return {
		    message: error.message,
		    locations: error.locations
		  };
		}
		/**
		 *  Copyright (c) 2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
	/***/ },
	/* 14 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = invariant;
	
		/**
		 *  Copyright (c) 2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		function invariant(condition, message) {
		  if (!condition) {
		    throw new Error(message);
		  }
		}
	
	/***/ }
	/******/ ]);

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.apolloClient = undefined;
	
	var _apolloClient = __webpack_require__(616);
	
	var _apolloClient2 = _interopRequireDefault(_apolloClient);
	
	var _Config = __webpack_require__(551);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _requestHeaders = __webpack_require__(569);
	
	var _afterware = __webpack_require__(836);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO import from `graphql` package; types don't get included in build
	var API_HOST = _Config2.default.Environment.R101_API_URL;
	
	// batching borks our mock matching in functional tests
	var createInterface = _Config2.default.Environment.NODE_ENV === 'functional' ? _apolloClient.createNetworkInterface : _apolloClient.createBatchingNetworkInterface;
	
	var networkInterface = createInterface({
	  uri: API_HOST + '/graphql',
	  batchInterval: 10
	});
	
	networkInterface.use([{
	  applyMiddleware: function applyMiddleware(req, next) {
	    req.options.credentials = 'same-origin';
	
	    if (!req.options.headers) {
	      req.options.headers = {}; // Create the header object if needed.
	    }
	
	    Object.assign(req.options.headers, (0, _requestHeaders.getCommonHeaders)());
	    next();
	  }
	}]);
	
	networkInterface.useAfter([_afterware.detect401, _afterware.detect503, _afterware.logNetworkErrors]);
	
	var apolloClient = exports.apolloClient = new _apolloClient2.default({
	  networkInterface: networkInterface,
	  dataIdFromObject: function dataIdFromObject(result) {
	    if (result.id && result.__typename) {
	      return result.__typename + result.id;
	    }
	    return null;
	  }
	});

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var networkInterface_1 = __webpack_require__(617);
	exports.createNetworkInterface = networkInterface_1.createNetworkInterface;
	exports.HTTPFetchNetworkInterface = networkInterface_1.HTTPFetchNetworkInterface;
	var batchedNetworkInterface_1 = __webpack_require__(745);
	exports.createBatchingNetworkInterface = batchedNetworkInterface_1.createBatchingNetworkInterface;
	var printer_1 = __webpack_require__(744);
	exports.printAST = printer_1.print;
	var store_1 = __webpack_require__(748);
	exports.createApolloStore = store_1.createApolloStore;
	exports.createApolloReducer = store_1.createApolloReducer;
	var ObservableQuery_1 = __webpack_require__(816);
	exports.ObservableQuery = ObservableQuery_1.ObservableQuery;
	var readFromStore_1 = __webpack_require__(825);
	exports.readQueryFromStore = readFromStore_1.readQueryFromStore;
	var writeToStore_1 = __webpack_require__(751);
	exports.writeQueryToStore = writeToStore_1.writeQueryToStore;
	var getFromAST_1 = __webpack_require__(754);
	exports.getQueryDefinition = getFromAST_1.getQueryDefinition;
	exports.getFragmentDefinitions = getFromAST_1.getFragmentDefinitions;
	exports.createFragmentMap = getFromAST_1.createFragmentMap;
	var store_2 = __webpack_require__(804);
	exports.NetworkStatus = store_2.NetworkStatus;
	var ApolloError_1 = __webpack_require__(818);
	exports.ApolloError = ApolloError_1.ApolloError;
	var ApolloClient_1 = __webpack_require__(833);
	exports.ApolloClient = ApolloClient_1.default;
	var fragments_1 = __webpack_require__(834);
	exports.createFragment = fragments_1.createFragment;
	exports.clearFragmentDefinitions = fragments_1.clearFragmentDefinitions;
	exports.disableFragmentWarnings = fragments_1.disableFragmentWarnings;
	exports.enableFragmentWarnings = fragments_1.enableFragmentWarnings;
	var storeUtils_1 = __webpack_require__(771);
	exports.toIdValue = storeUtils_1.toIdValue;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ApolloClient_1.default;
	//# sourceMappingURL=index.js.map

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var isString = __webpack_require__(618);
	var assign = __webpack_require__(620);
	var mapValues = __webpack_require__(661);
	__webpack_require__(743);
	var printer_1 = __webpack_require__(744);
	function printRequest(request) {
	    return mapValues(request, function (val, key) {
	        return key === 'query' ? printer_1.print(val) : val;
	    });
	}
	exports.printRequest = printRequest;
	var HTTPFetchNetworkInterface = (function () {
	    function HTTPFetchNetworkInterface(uri, opts) {
	        if (opts === void 0) { opts = {}; }
	        if (!uri) {
	            throw new Error('A remote enpdoint is required for a network layer');
	        }
	        if (!isString(uri)) {
	            throw new Error('Remote endpoint must be a string');
	        }
	        this._uri = uri;
	        this._opts = assign({}, opts);
	        this._middlewares = [];
	        this._afterwares = [];
	    }
	    HTTPFetchNetworkInterface.prototype.applyMiddlewares = function (_a) {
	        var _this = this;
	        var request = _a.request, options = _a.options;
	        return new Promise(function (resolve, reject) {
	            var queue = function (funcs, scope) {
	                var next = function () {
	                    if (funcs.length > 0) {
	                        var f = funcs.shift();
	                        f.applyMiddleware.apply(scope, [{ request: request, options: options }, next]);
	                    }
	                    else {
	                        resolve({
	                            request: request,
	                            options: options,
	                        });
	                    }
	                };
	                next();
	            };
	            queue(_this._middlewares.slice(), _this);
	        });
	    };
	    HTTPFetchNetworkInterface.prototype.applyAfterwares = function (_a) {
	        var _this = this;
	        var response = _a.response, options = _a.options;
	        return new Promise(function (resolve, reject) {
	            var queue = function (funcs, scope) {
	                var next = function () {
	                    if (funcs.length > 0) {
	                        var f = funcs.shift();
	                        f.applyAfterware.apply(scope, [{ response: response, options: options }, next]);
	                    }
	                    else {
	                        resolve({
	                            response: response,
	                            options: options,
	                        });
	                    }
	                };
	                next();
	            };
	            queue(_this._afterwares.slice(), _this);
	        });
	    };
	    HTTPFetchNetworkInterface.prototype.fetchFromRemoteEndpoint = function (_a) {
	        var request = _a.request, options = _a.options;
	        return fetch(this._uri, assign({}, this._opts, {
	            body: JSON.stringify(printRequest(request)),
	            method: 'POST',
	        }, options, {
	            headers: assign({}, {
	                Accept: '*/*',
	                'Content-Type': 'application/json',
	            }, options.headers),
	        }));
	    };
	    ;
	    HTTPFetchNetworkInterface.prototype.query = function (request) {
	        var _this = this;
	        var options = assign({}, this._opts);
	        return this.applyMiddlewares({
	            request: request,
	            options: options,
	        }).then(function (rao) { return _this.fetchFromRemoteEndpoint.call(_this, rao); })
	            .then(function (response) { return _this.applyAfterwares({
	            response: response,
	            options: options,
	        }); })
	            .then(function (_a) {
	            var response = _a.response;
	            return response.json();
	        })
	            .then(function (payload) {
	            if (!payload.hasOwnProperty('data') && !payload.hasOwnProperty('errors')) {
	                throw new Error("Server response was missing for query '" + request.debugName + "'.");
	            }
	            else {
	                return payload;
	            }
	        });
	    };
	    ;
	    HTTPFetchNetworkInterface.prototype.use = function (middlewares) {
	        var _this = this;
	        middlewares.map(function (middleware) {
	            if (typeof middleware.applyMiddleware === 'function') {
	                _this._middlewares.push(middleware);
	            }
	            else {
	                throw new Error('Middleware must implement the applyMiddleware function');
	            }
	        });
	        return this;
	    };
	    HTTPFetchNetworkInterface.prototype.useAfter = function (afterwares) {
	        var _this = this;
	        afterwares.map(function (afterware) {
	            if (typeof afterware.applyAfterware === 'function') {
	                _this._afterwares.push(afterware);
	            }
	            else {
	                throw new Error('Afterware must implement the applyAfterware function');
	            }
	        });
	        return this;
	    };
	    return HTTPFetchNetworkInterface;
	}());
	exports.HTTPFetchNetworkInterface = HTTPFetchNetworkInterface;
	function createNetworkInterface(uriOrInterfaceOpts, secondArgOpts) {
	    if (secondArgOpts === void 0) { secondArgOpts = {}; }
	    if (!uriOrInterfaceOpts) {
	        throw new Error('You must pass an options argument to createNetworkInterface.');
	    }
	    var uri;
	    var opts;
	    if (isString(uriOrInterfaceOpts)) {
	        console.warn("Passing the URI as the first argument to createNetworkInterface is deprecated as of Apollo Client 0.5. Please pass it as the \"uri\" property of the network interface options.");
	        opts = secondArgOpts;
	        uri = uriOrInterfaceOpts;
	    }
	    else {
	        opts = uriOrInterfaceOpts.opts;
	        uri = uriOrInterfaceOpts.uri;
	    }
	    return new HTTPFetchNetworkInterface(uri, opts);
	}
	exports.createNetworkInterface = createNetworkInterface;
	//# sourceMappingURL=networkInterface.js.map

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(479),
	    isArray = __webpack_require__(619),
	    isObjectLike = __webpack_require__(487);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 619 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(621),
	    copyObject = __webpack_require__(633),
	    createAssigner = __webpack_require__(634),
	    isArrayLike = __webpack_require__(644),
	    isPrototype = __webpack_require__(647),
	    keys = __webpack_require__(648);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(622),
	    eq = __webpack_require__(632);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(623);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(624);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(625),
	    getValue = __webpack_require__(631);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(626),
	    isMasked = __webpack_require__(628),
	    isObject = __webpack_require__(627),
	    toSource = __webpack_require__(630);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(479),
	    isObject = __webpack_require__(627);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 627 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(629);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(481);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 630 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 631 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 632 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(621),
	    baseAssignValue = __webpack_require__(622);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(635),
	    isIterateeCall = __webpack_require__(643);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(636),
	    overRest = __webpack_require__(637),
	    setToString = __webpack_require__(639);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 636 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(638);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 638 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(640),
	    shortOut = __webpack_require__(642);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(641),
	    defineProperty = __webpack_require__(623),
	    identity = __webpack_require__(636);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 641 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 642 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(632),
	    isArrayLike = __webpack_require__(644),
	    isIndex = __webpack_require__(646),
	    isObject = __webpack_require__(627);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(626),
	    isLength = __webpack_require__(645);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 645 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 646 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 647 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(649),
	    baseKeys = __webpack_require__(659),
	    isArrayLike = __webpack_require__(644);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(650),
	    isArguments = __webpack_require__(651),
	    isArray = __webpack_require__(619),
	    isBuffer = __webpack_require__(653),
	    isIndex = __webpack_require__(646),
	    isTypedArray = __webpack_require__(655);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 650 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(652),
	    isObjectLike = __webpack_require__(487);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(479),
	    isObjectLike = __webpack_require__(487);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(481),
	    stubFalse = __webpack_require__(654);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(490)(module)))

/***/ },
/* 654 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(656),
	    baseUnary = __webpack_require__(657),
	    nodeUtil = __webpack_require__(658);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(479),
	    isLength = __webpack_require__(645),
	    isObjectLike = __webpack_require__(487);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 657 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(482);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(490)(module)))

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(647),
	    nativeKeys = __webpack_require__(660);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(486);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(622),
	    baseForOwn = __webpack_require__(662),
	    baseIteratee = __webpack_require__(665);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(663),
	    keys = __webpack_require__(648);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(664);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 664 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(666),
	    baseMatchesProperty = __webpack_require__(724),
	    identity = __webpack_require__(636),
	    isArray = __webpack_require__(619),
	    property = __webpack_require__(740);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(667),
	    getMatchData = __webpack_require__(721),
	    matchesStrictComparable = __webpack_require__(723);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(668),
	    baseIsEqual = __webpack_require__(697);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(669),
	    stackClear = __webpack_require__(676),
	    stackDelete = __webpack_require__(677),
	    stackGet = __webpack_require__(678),
	    stackHas = __webpack_require__(679),
	    stackSet = __webpack_require__(680);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(670),
	    listCacheDelete = __webpack_require__(671),
	    listCacheGet = __webpack_require__(673),
	    listCacheHas = __webpack_require__(674),
	    listCacheSet = __webpack_require__(675);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 670 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(672);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(632);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(672);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(672);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(672);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(669);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 677 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 678 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 679 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(669),
	    Map = __webpack_require__(681),
	    MapCache = __webpack_require__(682);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(624),
	    root = __webpack_require__(481);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(683),
	    mapCacheDelete = __webpack_require__(691),
	    mapCacheGet = __webpack_require__(694),
	    mapCacheHas = __webpack_require__(695),
	    mapCacheSet = __webpack_require__(696);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(684),
	    ListCache = __webpack_require__(669),
	    Map = __webpack_require__(681);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(685),
	    hashDelete = __webpack_require__(687),
	    hashGet = __webpack_require__(688),
	    hashHas = __webpack_require__(689),
	    hashSet = __webpack_require__(690);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(686);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(624);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 687 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(686);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(686);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(686);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(692);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(693);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 693 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(692);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(692);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(692);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(698),
	    isObjectLike = __webpack_require__(487);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(668),
	    equalArrays = __webpack_require__(699),
	    equalByTag = __webpack_require__(705),
	    equalObjects = __webpack_require__(709),
	    getTag = __webpack_require__(716),
	    isArray = __webpack_require__(619),
	    isBuffer = __webpack_require__(653),
	    isTypedArray = __webpack_require__(655);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(700),
	    arraySome = __webpack_require__(703),
	    cacheHas = __webpack_require__(704);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(682),
	    setCacheAdd = __webpack_require__(701),
	    setCacheHas = __webpack_require__(702);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 701 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 702 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 703 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 704 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(480),
	    Uint8Array = __webpack_require__(706),
	    eq = __webpack_require__(632),
	    equalArrays = __webpack_require__(699),
	    mapToArray = __webpack_require__(707),
	    setToArray = __webpack_require__(708);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(481);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 707 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 708 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(710);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(711),
	    getSymbols = __webpack_require__(713),
	    keys = __webpack_require__(648);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(712),
	    isArray = __webpack_require__(619);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 712 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(714),
	    stubArray = __webpack_require__(715);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 714 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 715 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(717),
	    Map = __webpack_require__(681),
	    Promise = __webpack_require__(718),
	    Set = __webpack_require__(719),
	    WeakMap = __webpack_require__(720),
	    baseGetTag = __webpack_require__(479),
	    toSource = __webpack_require__(630);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(624),
	    root = __webpack_require__(481);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(624),
	    root = __webpack_require__(481);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(624),
	    root = __webpack_require__(481);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(624),
	    root = __webpack_require__(481);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(722),
	    keys = __webpack_require__(648);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(627);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 723 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(697),
	    get = __webpack_require__(725),
	    hasIn = __webpack_require__(737),
	    isKey = __webpack_require__(728),
	    isStrictComparable = __webpack_require__(722),
	    matchesStrictComparable = __webpack_require__(723),
	    toKey = __webpack_require__(736);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(726);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(727),
	    toKey = __webpack_require__(736);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(619),
	    isKey = __webpack_require__(728),
	    stringToPath = __webpack_require__(730),
	    toString = __webpack_require__(733);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(619),
	    isSymbol = __webpack_require__(729);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(479),
	    isObjectLike = __webpack_require__(487);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(731);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(732);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(682);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(734);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(480),
	    arrayMap = __webpack_require__(735),
	    isArray = __webpack_require__(619),
	    isSymbol = __webpack_require__(729);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 735 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(729);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(738),
	    hasPath = __webpack_require__(739);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 738 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(727),
	    isArguments = __webpack_require__(651),
	    isArray = __webpack_require__(619),
	    isIndex = __webpack_require__(646),
	    isLength = __webpack_require__(645),
	    toKey = __webpack_require__(736);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(741),
	    basePropertyDeep = __webpack_require__(742),
	    isKey = __webpack_require__(728),
	    toKey = __webpack_require__(736);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 741 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(726);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 743 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (typeof input === 'string') {
	      this.url = input
	    } else {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split('\r\n').forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 744 */
/***/ function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1);
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.print = print;
	
		var _visitor = __webpack_require__(2);
	
		/**
		 * Converts an AST into a string, using one set of reasonable
		 * formatting rules.
		 */
		function print(ast) {
		  return (0, _visitor.visit)(ast, { leave: printDocASTReducer });
		} /**
		   *  Copyright (c) 2015, Facebook, Inc.
		   *  All rights reserved.
		   *
		   *  This source code is licensed under the BSD-style license found in the
		   *  LICENSE file in the root directory of this source tree. An additional grant
		   *  of patent rights can be found in the PATENTS file in the same directory.
		   */
	
		var printDocASTReducer = {
		  Name: function Name(node) {
		    return node.value;
		  },
		  Variable: function Variable(node) {
		    return '$' + node.name;
		  },
	
		  // Document
	
		  Document: function Document(node) {
		    return join(node.definitions, '\n\n') + '\n';
		  },
	
		  OperationDefinition: function OperationDefinition(node) {
		    var op = node.operation;
		    var name = node.name;
		    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
		    var directives = join(node.directives, ' ');
		    var selectionSet = node.selectionSet;
		    // Anonymous queries with no directives or variable definitions can use
		    // the query short form.
		    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
		  },
	
	
		  VariableDefinition: function VariableDefinition(_ref) {
		    var variable = _ref.variable;
		    var type = _ref.type;
		    var defaultValue = _ref.defaultValue;
		    return variable + ': ' + type + wrap(' = ', defaultValue);
		  },
	
		  SelectionSet: function SelectionSet(_ref2) {
		    var selections = _ref2.selections;
		    return block(selections);
		  },
	
		  Field: function Field(_ref3) {
		    var alias = _ref3.alias;
		    var name = _ref3.name;
		    var args = _ref3.arguments;
		    var directives = _ref3.directives;
		    var selectionSet = _ref3.selectionSet;
		    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
		  },
	
		  Argument: function Argument(_ref4) {
		    var name = _ref4.name;
		    var value = _ref4.value;
		    return name + ': ' + value;
		  },
	
		  // Fragments
	
		  FragmentSpread: function FragmentSpread(_ref5) {
		    var name = _ref5.name;
		    var directives = _ref5.directives;
		    return '...' + name + wrap(' ', join(directives, ' '));
		  },
	
		  InlineFragment: function InlineFragment(_ref6) {
		    var typeCondition = _ref6.typeCondition;
		    var directives = _ref6.directives;
		    var selectionSet = _ref6.selectionSet;
		    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
		  },
	
		  FragmentDefinition: function FragmentDefinition(_ref7) {
		    var name = _ref7.name;
		    var typeCondition = _ref7.typeCondition;
		    var directives = _ref7.directives;
		    var selectionSet = _ref7.selectionSet;
		    return 'fragment ' + name + ' on ' + typeCondition + ' ' + wrap('', join(directives, ' '), ' ') + selectionSet;
		  },
	
		  // Value
	
		  IntValue: function IntValue(_ref8) {
		    var value = _ref8.value;
		    return value;
		  },
		  FloatValue: function FloatValue(_ref9) {
		    var value = _ref9.value;
		    return value;
		  },
		  StringValue: function StringValue(_ref10) {
		    var value = _ref10.value;
		    return JSON.stringify(value);
		  },
		  BooleanValue: function BooleanValue(_ref11) {
		    var value = _ref11.value;
		    return JSON.stringify(value);
		  },
		  EnumValue: function EnumValue(_ref12) {
		    var value = _ref12.value;
		    return value;
		  },
		  ListValue: function ListValue(_ref13) {
		    var values = _ref13.values;
		    return '[' + join(values, ', ') + ']';
		  },
		  ObjectValue: function ObjectValue(_ref14) {
		    var fields = _ref14.fields;
		    return '{' + join(fields, ', ') + '}';
		  },
		  ObjectField: function ObjectField(_ref15) {
		    var name = _ref15.name;
		    var value = _ref15.value;
		    return name + ': ' + value;
		  },
	
		  // Directive
	
		  Directive: function Directive(_ref16) {
		    var name = _ref16.name;
		    var args = _ref16.arguments;
		    return '@' + name + wrap('(', join(args, ', '), ')');
		  },
	
		  // Type
	
		  NamedType: function NamedType(_ref17) {
		    var name = _ref17.name;
		    return name;
		  },
		  ListType: function ListType(_ref18) {
		    var type = _ref18.type;
		    return '[' + type + ']';
		  },
		  NonNullType: function NonNullType(_ref19) {
		    var type = _ref19.type;
		    return type + '!';
		  },
	
		  // Type System Definitions
	
		  SchemaDefinition: function SchemaDefinition(_ref20) {
		    var directives = _ref20.directives;
		    var operationTypes = _ref20.operationTypes;
		    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
		  },
	
		  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
		    var operation = _ref21.operation;
		    var type = _ref21.type;
		    return operation + ': ' + type;
		  },
	
		  ScalarTypeDefinition: function ScalarTypeDefinition(_ref22) {
		    var name = _ref22.name;
		    var directives = _ref22.directives;
		    return join(['scalar', name, join(directives, ' ')], ' ');
		  },
	
		  ObjectTypeDefinition: function ObjectTypeDefinition(_ref23) {
		    var name = _ref23.name;
		    var interfaces = _ref23.interfaces;
		    var directives = _ref23.directives;
		    var fields = _ref23.fields;
		    return join(['type', name, wrap('implements ', join(interfaces, ', ')), join(directives, ' '), block(fields)], ' ');
		  },
	
		  FieldDefinition: function FieldDefinition(_ref24) {
		    var name = _ref24.name;
		    var args = _ref24.arguments;
		    var type = _ref24.type;
		    var directives = _ref24.directives;
		    return name + wrap('(', join(args, ', '), ')') + ': ' + type + wrap(' ', join(directives, ' '));
		  },
	
		  InputValueDefinition: function InputValueDefinition(_ref25) {
		    var name = _ref25.name;
		    var type = _ref25.type;
		    var defaultValue = _ref25.defaultValue;
		    var directives = _ref25.directives;
		    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
		  },
	
		  InterfaceTypeDefinition: function InterfaceTypeDefinition(_ref26) {
		    var name = _ref26.name;
		    var directives = _ref26.directives;
		    var fields = _ref26.fields;
		    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
		  },
	
		  UnionTypeDefinition: function UnionTypeDefinition(_ref27) {
		    var name = _ref27.name;
		    var directives = _ref27.directives;
		    var types = _ref27.types;
		    return join(['union', name, join(directives, ' '), '= ' + join(types, ' | ')], ' ');
		  },
	
		  EnumTypeDefinition: function EnumTypeDefinition(_ref28) {
		    var name = _ref28.name;
		    var directives = _ref28.directives;
		    var values = _ref28.values;
		    return join(['enum', name, join(directives, ' '), block(values)], ' ');
		  },
	
		  EnumValueDefinition: function EnumValueDefinition(_ref29) {
		    var name = _ref29.name;
		    var directives = _ref29.directives;
		    return join([name, join(directives, ' ')], ' ');
		  },
	
		  InputObjectTypeDefinition: function InputObjectTypeDefinition(_ref30) {
		    var name = _ref30.name;
		    var directives = _ref30.directives;
		    var fields = _ref30.fields;
		    return join(['input', name, join(directives, ' '), block(fields)], ' ');
		  },
	
		  TypeExtensionDefinition: function TypeExtensionDefinition(_ref31) {
		    var definition = _ref31.definition;
		    return 'extend ' + definition;
		  },
	
		  DirectiveDefinition: function DirectiveDefinition(_ref32) {
		    var name = _ref32.name;
		    var args = _ref32.arguments;
		    var locations = _ref32.locations;
		    return 'directive @' + name + wrap('(', join(args, ', '), ')') + ' on ' + join(locations, ' | ');
		  }
		};
	
		/**
		 * Given maybeArray, print an empty string if it is null or empty, otherwise
		 * print all items together separated by separator if provided
		 */
		function join(maybeArray, separator) {
		  return maybeArray ? maybeArray.filter(function (x) {
		    return x;
		  }).join(separator || '') : '';
		}
	
		/**
		 * Given array, print each item on its own line, wrapped in an
		 * indented "{ }" block.
		 */
		function block(array) {
		  return array && array.length !== 0 ? indent('{\n' + join(array, '\n')) + '\n}' : '{}';
		}
	
		/**
		 * If maybeString is not null or empty, then wrap with start and end, otherwise
		 * print an empty string.
		 */
		function wrap(start, maybeString, end) {
		  return maybeString ? start + maybeString + (end || '') : '';
		}
	
		function indent(maybeString) {
		  return maybeString && maybeString.replace(/\n/g, '\n  ');
		}
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.visit = visit;
		exports.visitInParallel = visitInParallel;
		exports.visitWithTypeInfo = visitWithTypeInfo;
		/**
		 *  Copyright (c) 2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		var QueryDocumentKeys = exports.QueryDocumentKeys = {
		  Name: [],
	
		  Document: ['definitions'],
		  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
		  VariableDefinition: ['variable', 'type', 'defaultValue'],
		  Variable: ['name'],
		  SelectionSet: ['selections'],
		  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
		  Argument: ['name', 'value'],
	
		  FragmentSpread: ['name', 'directives'],
		  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
		  FragmentDefinition: ['name', 'typeCondition', 'directives', 'selectionSet'],
	
		  IntValue: [],
		  FloatValue: [],
		  StringValue: [],
		  BooleanValue: [],
		  EnumValue: [],
		  ListValue: ['values'],
		  ObjectValue: ['fields'],
		  ObjectField: ['name', 'value'],
	
		  Directive: ['name', 'arguments'],
	
		  NamedType: ['name'],
		  ListType: ['type'],
		  NonNullType: ['type'],
	
		  SchemaDefinition: ['directives', 'operationTypes'],
		  OperationTypeDefinition: ['type'],
	
		  ScalarTypeDefinition: ['name', 'directives'],
		  ObjectTypeDefinition: ['name', 'interfaces', 'directives', 'fields'],
		  FieldDefinition: ['name', 'arguments', 'type', 'directives'],
		  InputValueDefinition: ['name', 'type', 'defaultValue', 'directives'],
		  InterfaceTypeDefinition: ['name', 'directives', 'fields'],
		  UnionTypeDefinition: ['name', 'directives', 'types'],
		  EnumTypeDefinition: ['name', 'directives', 'values'],
		  EnumValueDefinition: ['name', 'directives'],
		  InputObjectTypeDefinition: ['name', 'directives', 'fields'],
	
		  TypeExtensionDefinition: ['definition'],
	
		  DirectiveDefinition: ['name', 'arguments', 'locations']
		};
	
		var BREAK = exports.BREAK = {};
	
		/**
		 * visit() will walk through an AST using a depth first traversal, calling
		 * the visitor's enter function at each node in the traversal, and calling the
		 * leave function after visiting that node and all of its child nodes.
		 *
		 * By returning different values from the enter and leave functions, the
		 * behavior of the visitor can be altered, including skipping over a sub-tree of
		 * the AST (by returning false), editing the AST by returning a value or null
		 * to remove the value, or to stop the whole traversal by returning BREAK.
		 *
		 * When using visit() to edit an AST, the original AST will not be modified, and
		 * a new version of the AST with the changes applied will be returned from the
		 * visit function.
		 *
		 *     const editedAST = visit(ast, {
		 *       enter(node, key, parent, path, ancestors) {
		 *         // @return
		 *         //   undefined: no action
		 *         //   false: skip visiting this node
		 *         //   visitor.BREAK: stop visiting altogether
		 *         //   null: delete this node
		 *         //   any value: replace this node with the returned value
		 *       },
		 *       leave(node, key, parent, path, ancestors) {
		 *         // @return
		 *         //   undefined: no action
		 *         //   false: no action
		 *         //   visitor.BREAK: stop visiting altogether
		 *         //   null: delete this node
		 *         //   any value: replace this node with the returned value
		 *       }
		 *     });
		 *
		 * Alternatively to providing enter() and leave() functions, a visitor can
		 * instead provide functions named the same as the kinds of AST nodes, or
		 * enter/leave visitors at a named key, leading to four permutations of
		 * visitor API:
		 *
		 * 1) Named visitors triggered when entering a node a specific kind.
		 *
		 *     visit(ast, {
		 *       Kind(node) {
		 *         // enter the "Kind" node
		 *       }
		 *     })
		 *
		 * 2) Named visitors that trigger upon entering and leaving a node of
		 *    a specific kind.
		 *
		 *     visit(ast, {
		 *       Kind: {
		 *         enter(node) {
		 *           // enter the "Kind" node
		 *         }
		 *         leave(node) {
		 *           // leave the "Kind" node
		 *         }
		 *       }
		 *     })
		 *
		 * 3) Generic visitors that trigger upon entering and leaving any node.
		 *
		 *     visit(ast, {
		 *       enter(node) {
		 *         // enter any node
		 *       },
		 *       leave(node) {
		 *         // leave any node
		 *       }
		 *     })
		 *
		 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
		 *
		 *     visit(ast, {
		 *       enter: {
		 *         Kind(node) {
		 *           // enter the "Kind" node
		 *         }
		 *       },
		 *       leave: {
		 *         Kind(node) {
		 *           // leave the "Kind" node
		 *         }
		 *       }
		 *     })
		 */
		function visit(root, visitor, keyMap) {
		  var visitorKeys = keyMap || QueryDocumentKeys;
	
		  var stack = void 0;
		  var inArray = Array.isArray(root);
		  var keys = [root];
		  var index = -1;
		  var edits = [];
		  var parent = void 0;
		  var path = [];
		  var ancestors = [];
		  var newRoot = root;
	
		  do {
		    index++;
		    var isLeaving = index === keys.length;
		    var key = void 0;
		    var node = void 0;
		    var isEdited = isLeaving && edits.length !== 0;
		    if (isLeaving) {
		      key = ancestors.length === 0 ? undefined : path.pop();
		      node = parent;
		      parent = ancestors.pop();
		      if (isEdited) {
		        if (inArray) {
		          node = node.slice();
		        } else {
		          var clone = {};
		          for (var k in node) {
		            if (node.hasOwnProperty(k)) {
		              clone[k] = node[k];
		            }
		          }
		          node = clone;
		        }
		        var editOffset = 0;
		        for (var ii = 0; ii < edits.length; ii++) {
		          var editKey = edits[ii][0];
		          var editValue = edits[ii][1];
		          if (inArray) {
		            editKey -= editOffset;
		          }
		          if (inArray && editValue === null) {
		            node.splice(editKey, 1);
		            editOffset++;
		          } else {
		            node[editKey] = editValue;
		          }
		        }
		      }
		      index = stack.index;
		      keys = stack.keys;
		      edits = stack.edits;
		      inArray = stack.inArray;
		      stack = stack.prev;
		    } else {
		      key = parent ? inArray ? index : keys[index] : undefined;
		      node = parent ? parent[key] : newRoot;
		      if (node === null || node === undefined) {
		        continue;
		      }
		      if (parent) {
		        path.push(key);
		      }
		    }
	
		    var result = void 0;
		    if (!Array.isArray(node)) {
		      if (!isNode(node)) {
		        throw new Error('Invalid AST Node: ' + JSON.stringify(node));
		      }
		      var visitFn = getVisitFn(visitor, node.kind, isLeaving);
		      if (visitFn) {
		        result = visitFn.call(visitor, node, key, parent, path, ancestors);
	
		        if (result === BREAK) {
		          break;
		        }
	
		        if (result === false) {
		          if (!isLeaving) {
		            path.pop();
		            continue;
		          }
		        } else if (result !== undefined) {
		          edits.push([key, result]);
		          if (!isLeaving) {
		            if (isNode(result)) {
		              node = result;
		            } else {
		              path.pop();
		              continue;
		            }
		          }
		        }
		      }
		    }
	
		    if (result === undefined && isEdited) {
		      edits.push([key, node]);
		    }
	
		    if (!isLeaving) {
		      stack = { inArray: inArray, index: index, keys: keys, edits: edits, prev: stack };
		      inArray = Array.isArray(node);
		      keys = inArray ? node : visitorKeys[node.kind] || [];
		      index = -1;
		      edits = [];
		      if (parent) {
		        ancestors.push(parent);
		      }
		      parent = node;
		    }
		  } while (stack !== undefined);
	
		  if (edits.length !== 0) {
		    newRoot = edits[edits.length - 1][1];
		  }
	
		  return newRoot;
		}
	
		function isNode(maybeNode) {
		  return maybeNode && typeof maybeNode.kind === 'string';
		}
	
		/**
		 * Creates a new visitor instance which delegates to many visitors to run in
		 * parallel. Each visitor will be visited for each node before moving on.
		 *
		 * If a prior visitor edits a node, no following visitors will see that node.
		 */
		function visitInParallel(visitors) {
		  var skipping = new Array(visitors.length);
	
		  return {
		    enter: function enter(node) {
		      for (var i = 0; i < visitors.length; i++) {
		        if (!skipping[i]) {
		          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */false);
		          if (fn) {
		            var result = fn.apply(visitors[i], arguments);
		            if (result === false) {
		              skipping[i] = node;
		            } else if (result === BREAK) {
		              skipping[i] = BREAK;
		            } else if (result !== undefined) {
		              return result;
		            }
		          }
		        }
		      }
		    },
		    leave: function leave(node) {
		      for (var i = 0; i < visitors.length; i++) {
		        if (!skipping[i]) {
		          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */true);
		          if (fn) {
		            var result = fn.apply(visitors[i], arguments);
		            if (result === BREAK) {
		              skipping[i] = BREAK;
		            } else if (result !== undefined && result !== false) {
		              return result;
		            }
		          }
		        } else if (skipping[i] === node) {
		          skipping[i] = null;
		        }
		      }
		    }
		  };
		}
	
		/**
		 * Creates a new visitor instance which maintains a provided TypeInfo instance
		 * along with visiting visitor.
		 */
		function visitWithTypeInfo(typeInfo, visitor) {
		  return {
		    enter: function enter(node) {
		      typeInfo.enter(node);
		      var fn = getVisitFn(visitor, node.kind, /* isLeaving */false);
		      if (fn) {
		        var result = fn.apply(visitor, arguments);
		        if (result !== undefined) {
		          typeInfo.leave(node);
		          if (isNode(result)) {
		            typeInfo.enter(result);
		          }
		        }
		        return result;
		      }
		    },
		    leave: function leave(node) {
		      var fn = getVisitFn(visitor, node.kind, /* isLeaving */true);
		      var result = void 0;
		      if (fn) {
		        result = fn.apply(visitor, arguments);
		      }
		      typeInfo.leave(node);
		      return result;
		    }
		  };
		}
	
		/**
		 * Given a visitor instance, if it is leaving or not, and a node kind, return
		 * the function the visitor runtime should call.
		 */
		function getVisitFn(visitor, kind, isLeaving) {
		  var kindVisitor = visitor[kind];
		  if (kindVisitor) {
		    if (!isLeaving && typeof kindVisitor === 'function') {
		      // { Kind() {} }
		      return kindVisitor;
		    }
		    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
		    if (typeof kindSpecificVisitor === 'function') {
		      // { Kind: { enter() {}, leave() {} } }
		      return kindSpecificVisitor;
		    }
		  } else {
		    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
		    if (specificVisitor) {
		      if (typeof specificVisitor === 'function') {
		        // { enter() {}, leave() {} }
		        return specificVisitor;
		      }
		      var specificKindVisitor = specificVisitor[kind];
		      if (typeof specificKindVisitor === 'function') {
		        // { enter: { Kind() {} }, leave: { Kind() {} } }
		        return specificKindVisitor;
		      }
		    }
		  }
		}
	
	/***/ }
	/******/ ]);

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	__webpack_require__(743);
	var assign = __webpack_require__(620);
	var isNumber = __webpack_require__(746);
	var networkInterface_1 = __webpack_require__(617);
	var batching_1 = __webpack_require__(747);
	var HTTPBatchedNetworkInterface = (function (_super) {
	    __extends(HTTPBatchedNetworkInterface, _super);
	    function HTTPBatchedNetworkInterface(uri, pollInterval, fetchOpts) {
	        var _this = _super.call(this, uri, fetchOpts) || this;
	        if (!isNumber(pollInterval)) {
	            throw new Error("pollInterval must be a number, got " + pollInterval);
	        }
	        _this.pollInterval = pollInterval;
	        _this.batcher = new batching_1.QueryBatcher({
	            batchFetchFunction: _this.batchQuery.bind(_this),
	        });
	        _this.batcher.start(_this.pollInterval);
	        return _this;
	    }
	    ;
	    HTTPBatchedNetworkInterface.prototype.query = function (request) {
	        return this.batcher.enqueueRequest(request);
	    };
	    HTTPBatchedNetworkInterface.prototype.batchQuery = function (requests) {
	        var _this = this;
	        var options = assign({}, this._opts);
	        var middlewarePromises = [];
	        requests.forEach(function (request) {
	            middlewarePromises.push(_this.applyMiddlewares({
	                request: request,
	                options: options,
	            }));
	        });
	        return new Promise(function (resolve, reject) {
	            Promise.all(middlewarePromises).then(function (requestsAndOptions) {
	                return _this.batchedFetchFromRemoteEndpoint(requestsAndOptions)
	                    .then(function (result) {
	                    return result.json();
	                })
	                    .then(function (responses) {
	                    if (typeof responses.map !== 'function') {
	                        throw new Error('BatchingNetworkInterface: server response is not an array');
	                    }
	                    var afterwaresPromises = responses.map(function (response, index) {
	                        return _this.applyAfterwares({
	                            response: response,
	                            options: requestsAndOptions[index].options,
	                        });
	                    });
	                    Promise.all(afterwaresPromises).then(function (responsesAndOptions) {
	                        var results = [];
	                        responsesAndOptions.forEach(function (result) {
	                            results.push(result.response);
	                        });
	                        resolve(results);
	                    }).catch(function (error) {
	                        reject(error);
	                    });
	                });
	            }).catch(function (error) {
	                reject(error);
	            });
	        });
	    };
	    HTTPBatchedNetworkInterface.prototype.batchedFetchFromRemoteEndpoint = function (requestsAndOptions) {
	        var options = {};
	        requestsAndOptions.forEach(function (requestAndOptions) {
	            assign(options, requestAndOptions.options);
	        });
	        var printedRequests = requestsAndOptions.map(function (_a) {
	            var request = _a.request;
	            return networkInterface_1.printRequest(request);
	        });
	        return fetch(this._uri, assign({}, this._opts, {
	            body: JSON.stringify(printedRequests),
	            method: 'POST',
	        }, options, {
	            headers: assign({}, {
	                Accept: '*/*',
	                'Content-Type': 'application/json',
	            }, options.headers),
	        }));
	    };
	    ;
	    return HTTPBatchedNetworkInterface;
	}(networkInterface_1.HTTPFetchNetworkInterface));
	exports.HTTPBatchedNetworkInterface = HTTPBatchedNetworkInterface;
	function createBatchingNetworkInterface(options) {
	    if (!options) {
	        throw new Error('You must pass an options argument to createNetworkInterface.');
	    }
	    return new HTTPBatchedNetworkInterface(options.uri, options.batchInterval, options.opts);
	}
	exports.createBatchingNetworkInterface = createBatchingNetworkInterface;
	//# sourceMappingURL=batchedNetworkInterface.js.map

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(479),
	    isObjectLike = __webpack_require__(487);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 747 */
/***/ function(module, exports) {

	"use strict";
	;
	var QueryBatcher = (function () {
	    function QueryBatcher(_a) {
	        var batchFetchFunction = _a.batchFetchFunction;
	        this.queuedRequests = [];
	        this.queuedRequests = [];
	        this.batchFetchFunction = batchFetchFunction;
	    }
	    QueryBatcher.prototype.enqueueRequest = function (request) {
	        var fetchRequest = {
	            request: request,
	        };
	        this.queuedRequests.push(fetchRequest);
	        fetchRequest.promise = new Promise(function (resolve, reject) {
	            fetchRequest.resolve = resolve;
	            fetchRequest.reject = reject;
	        });
	        return fetchRequest.promise;
	    };
	    QueryBatcher.prototype.consumeQueue = function () {
	        if (this.queuedRequests.length < 1) {
	            return undefined;
	        }
	        var requests = this.queuedRequests.map(function (queuedRequest) {
	            return {
	                query: queuedRequest.request.query,
	                variables: queuedRequest.request.variables,
	                operationName: queuedRequest.request.operationName,
	            };
	        });
	        var promises = [];
	        var resolvers = [];
	        var rejecters = [];
	        this.queuedRequests.forEach(function (fetchRequest, index) {
	            promises.push(fetchRequest.promise);
	            resolvers.push(fetchRequest.resolve);
	            rejecters.push(fetchRequest.reject);
	        });
	        this.queuedRequests = [];
	        var batchedPromise = this.batchFetchFunction(requests);
	        batchedPromise.then(function (results) {
	            results.forEach(function (result, index) {
	                resolvers[index](result);
	            });
	        }).catch(function (error) {
	            rejecters.forEach(function (rejecter, index) {
	                rejecters[index](error);
	            });
	        });
	        return promises;
	    };
	    QueryBatcher.prototype.start = function (pollInterval) {
	        var _this = this;
	        if (this.pollTimer) {
	            clearInterval(this.pollTimer);
	        }
	        this.pollInterval = pollInterval;
	        this.pollTimer = setInterval(function () {
	            _this.consumeQueue();
	        }, this.pollInterval);
	    };
	    QueryBatcher.prototype.stop = function () {
	        if (this.pollTimer) {
	            clearInterval(this.pollTimer);
	        }
	    };
	    return QueryBatcher;
	}());
	exports.QueryBatcher = QueryBatcher;
	//# sourceMappingURL=batching.js.map

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var redux_1 = __webpack_require__(476);
	var store_1 = __webpack_require__(749);
	var store_2 = __webpack_require__(804);
	var store_3 = __webpack_require__(806);
	var store_4 = __webpack_require__(807);
	var assign = __webpack_require__(620);
	var crashReporter = function (store) { return function (next) { return function (action) {
	    try {
	        return next(action);
	    }
	    catch (err) {
	        console.error('Caught an exception!', err);
	        console.error(err.stack);
	        throw err;
	    }
	}; }; };
	function createApolloReducer(config) {
	    return function apolloReducer(state, action) {
	        if (state === void 0) { state = {}; }
	        try {
	            var newState = {
	                queries: store_2.queries(state.queries, action),
	                mutations: store_3.mutations(state.mutations, action),
	                data: store_1.data(state.data, action, state.queries, state.mutations, config),
	                optimistic: [],
	                reducerError: null,
	            };
	            newState.optimistic = store_4.optimistic(state.optimistic, action, newState, config);
	            return newState;
	        }
	        catch (reducerError) {
	            return __assign({}, state, { reducerError: reducerError });
	        }
	    };
	}
	exports.createApolloReducer = createApolloReducer;
	function createApolloStore(_a) {
	    var _b = _a === void 0 ? {} : _a, _c = _b.reduxRootKey, reduxRootKey = _c === void 0 ? 'apollo' : _c, initialState = _b.initialState, _d = _b.config, config = _d === void 0 ? {} : _d, _e = _b.reportCrashes, reportCrashes = _e === void 0 ? true : _e, logger = _b.logger;
	    var enhancers = [];
	    var middlewares = [];
	    if (reportCrashes) {
	        middlewares.push(crashReporter);
	    }
	    if (logger) {
	        middlewares.push(logger);
	    }
	    if (middlewares.length > 0) {
	        enhancers.push(redux_1.applyMiddleware.apply(void 0, middlewares));
	    }
	    if (typeof window !== 'undefined') {
	        var anyWindow = window;
	        if (anyWindow.devToolsExtension) {
	            enhancers.push(anyWindow.devToolsExtension());
	        }
	    }
	    var compose = redux_1.compose;
	    if (initialState && initialState[reduxRootKey] && initialState[reduxRootKey]['queries']) {
	        throw new Error('Apollo initial state may not contain queries, only data');
	    }
	    if (initialState && initialState[reduxRootKey] && initialState[reduxRootKey]['mutations']) {
	        throw new Error('Apollo initial state may not contain mutations, only data');
	    }
	    return redux_1.createStore(redux_1.combineReducers((_f = {}, _f[reduxRootKey] = createApolloReducer(config), _f)), initialState, compose.apply(void 0, enhancers));
	    var _f;
	}
	exports.createApolloStore = createApolloStore;
	function getDataWithOptimisticResults(store) {
	    if (store.optimistic.length === 0) {
	        return store.data;
	    }
	    var patches = store.optimistic.map(function (opt) { return opt.data; });
	    return assign.apply(void 0, [{}, store.data].concat(patches));
	}
	exports.getDataWithOptimisticResults = getDataWithOptimisticResults;
	//# sourceMappingURL=store.js.map

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var actions_1 = __webpack_require__(750);
	var writeToStore_1 = __webpack_require__(751);
	var storeUtils_1 = __webpack_require__(771);
	var mutationResults_1 = __webpack_require__(773);
	var replaceQueryResults_1 = __webpack_require__(802);
	function data(previousState, action, queries, mutations, config) {
	    if (previousState === void 0) { previousState = {}; }
	    var constAction = action;
	    if (actions_1.isQueryResultAction(action)) {
	        if (!queries[action.queryId]) {
	            return previousState;
	        }
	        if (action.requestId < queries[action.queryId].lastRequestId) {
	            return previousState;
	        }
	        if (!storeUtils_1.graphQLResultHasError(action.result)) {
	            var queryStoreValue = queries[action.queryId];
	            var clonedState = __assign({}, previousState);
	            var newState_1 = writeToStore_1.writeResultToStore({
	                result: action.result.data,
	                dataId: 'ROOT_QUERY',
	                document: action.document,
	                variables: queryStoreValue.variables,
	                store: clonedState,
	                dataIdFromObject: config.dataIdFromObject,
	            });
	            if (action.extraReducers) {
	                action.extraReducers.forEach(function (reducer) {
	                    newState_1 = reducer(newState_1, constAction);
	                });
	            }
	            return newState_1;
	        }
	    }
	    else if (actions_1.isSubscriptionResultAction(action)) {
	        if (!storeUtils_1.graphQLResultHasError(action.result)) {
	            var clonedState = __assign({}, previousState);
	            var newState_2 = writeToStore_1.writeResultToStore({
	                result: action.result.data,
	                dataId: 'ROOT_QUERY',
	                document: action.document,
	                variables: action.variables,
	                store: clonedState,
	                dataIdFromObject: config.dataIdFromObject,
	            });
	            if (action.extraReducers) {
	                action.extraReducers.forEach(function (reducer) {
	                    newState_2 = reducer(newState_2, constAction);
	                });
	            }
	            return newState_2;
	        }
	    }
	    else if (actions_1.isMutationResultAction(constAction)) {
	        if (!constAction.result.errors) {
	            var queryStoreValue_1 = mutations[constAction.mutationId];
	            var clonedState = __assign({}, previousState);
	            var newState_3 = writeToStore_1.writeResultToStore({
	                result: constAction.result.data,
	                dataId: 'ROOT_MUTATION',
	                document: constAction.document,
	                variables: queryStoreValue_1.variables,
	                store: clonedState,
	                dataIdFromObject: config.dataIdFromObject,
	            });
	            if (constAction.resultBehaviors) {
	                constAction.resultBehaviors.forEach(function (behavior) {
	                    var args = {
	                        behavior: behavior,
	                        result: constAction.result,
	                        variables: queryStoreValue_1.variables,
	                        document: constAction.document,
	                        config: config,
	                    };
	                    if (mutationResults_1.defaultMutationBehaviorReducers[behavior.type]) {
	                        newState_3 = mutationResults_1.defaultMutationBehaviorReducers[behavior.type](newState_3, args);
	                    }
	                    else if (config.mutationBehaviorReducers[behavior.type]) {
	                        newState_3 = config.mutationBehaviorReducers[behavior.type](newState_3, args);
	                    }
	                    else {
	                        throw new Error("No mutation result reducer defined for type " + behavior.type);
	                    }
	                });
	            }
	            if (constAction.extraReducers) {
	                constAction.extraReducers.forEach(function (reducer) {
	                    newState_3 = reducer(newState_3, constAction);
	                });
	            }
	            return newState_3;
	        }
	    }
	    else if (actions_1.isUpdateQueryResultAction(constAction)) {
	        return replaceQueryResults_1.replaceQueryResults(previousState, constAction, config);
	    }
	    else if (actions_1.isStoreResetAction(action)) {
	        return {};
	    }
	    return previousState;
	}
	exports.data = data;
	//# sourceMappingURL=store.js.map

/***/ },
/* 750 */
/***/ function(module, exports) {

	"use strict";
	function isQueryResultAction(action) {
	    return action.type === 'APOLLO_QUERY_RESULT';
	}
	exports.isQueryResultAction = isQueryResultAction;
	function isQueryErrorAction(action) {
	    return action.type === 'APOLLO_QUERY_ERROR';
	}
	exports.isQueryErrorAction = isQueryErrorAction;
	function isQueryInitAction(action) {
	    return action.type === 'APOLLO_QUERY_INIT';
	}
	exports.isQueryInitAction = isQueryInitAction;
	function isQueryResultClientAction(action) {
	    return action.type === 'APOLLO_QUERY_RESULT_CLIENT';
	}
	exports.isQueryResultClientAction = isQueryResultClientAction;
	function isQueryStopAction(action) {
	    return action.type === 'APOLLO_QUERY_STOP';
	}
	exports.isQueryStopAction = isQueryStopAction;
	function isMutationInitAction(action) {
	    return action.type === 'APOLLO_MUTATION_INIT';
	}
	exports.isMutationInitAction = isMutationInitAction;
	function isMutationResultAction(action) {
	    return action.type === 'APOLLO_MUTATION_RESULT';
	}
	exports.isMutationResultAction = isMutationResultAction;
	;
	function isMutationErrorAction(action) {
	    return action.type === 'APOLLO_MUTATION_ERROR';
	}
	exports.isMutationErrorAction = isMutationErrorAction;
	function isUpdateQueryResultAction(action) {
	    return action.type === 'APOLLO_UPDATE_QUERY_RESULT';
	}
	exports.isUpdateQueryResultAction = isUpdateQueryResultAction;
	function isStoreResetAction(action) {
	    return action.type === 'APOLLO_STORE_RESET';
	}
	exports.isStoreResetAction = isStoreResetAction;
	function isSubscriptionResultAction(action) {
	    return action.type === 'APOLLO_SUBSCRIPTION_RESULT';
	}
	exports.isSubscriptionResultAction = isSubscriptionResultAction;
	//# sourceMappingURL=actions.js.map

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var isNull = __webpack_require__(752);
	var isUndefined = __webpack_require__(753);
	var isObject = __webpack_require__(627);
	var getFromAST_1 = __webpack_require__(754);
	var storeUtils_1 = __webpack_require__(771);
	var storeUtils_2 = __webpack_require__(771);
	var directives_1 = __webpack_require__(772);
	function writeQueryToStore(_a) {
	    var result = _a.result, query = _a.query, _b = _a.store, store = _b === void 0 ? {} : _b, variables = _a.variables, _c = _a.dataIdFromObject, dataIdFromObject = _c === void 0 ? null : _c, _d = _a.fragmentMap, fragmentMap = _d === void 0 ? {} : _d;
	    var queryDefinition = getFromAST_1.getQueryDefinition(query);
	    return writeSelectionSetToStore({
	        dataId: 'ROOT_QUERY',
	        result: result,
	        selectionSet: queryDefinition.selectionSet,
	        context: {
	            store: store,
	            variables: variables,
	            dataIdFromObject: dataIdFromObject,
	            fragmentMap: fragmentMap,
	        },
	    });
	}
	exports.writeQueryToStore = writeQueryToStore;
	function writeResultToStore(_a) {
	    var result = _a.result, dataId = _a.dataId, document = _a.document, _b = _a.store, store = _b === void 0 ? {} : _b, variables = _a.variables, _c = _a.dataIdFromObject, dataIdFromObject = _c === void 0 ? null : _c;
	    var selectionSet = getFromAST_1.getOperationDefinition(document).selectionSet;
	    var fragmentMap = getFromAST_1.createFragmentMap(getFromAST_1.getFragmentDefinitions(document));
	    return writeSelectionSetToStore({
	        result: result,
	        dataId: dataId,
	        selectionSet: selectionSet,
	        context: {
	            store: store,
	            variables: variables,
	            dataIdFromObject: dataIdFromObject,
	            fragmentMap: fragmentMap,
	        },
	    });
	}
	exports.writeResultToStore = writeResultToStore;
	function writeSelectionSetToStore(_a) {
	    var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
	    var variables = context.variables, store = context.store, dataIdFromObject = context.dataIdFromObject, fragmentMap = context.fragmentMap;
	    selectionSet.selections.forEach(function (selection) {
	        var included = directives_1.shouldInclude(selection, variables);
	        if (storeUtils_1.isField(selection)) {
	            var resultFieldKey = storeUtils_1.resultKeyNameFromField(selection);
	            var value = result[resultFieldKey];
	            if (!isUndefined(value)) {
	                writeFieldToStore({
	                    dataId: dataId,
	                    value: value,
	                    field: selection,
	                    context: context,
	                });
	            }
	        }
	        else if (storeUtils_1.isInlineFragment(selection)) {
	            if (included) {
	                writeSelectionSetToStore({
	                    result: result,
	                    selectionSet: selection.selectionSet,
	                    dataId: dataId,
	                    context: context,
	                });
	            }
	        }
	        else {
	            var fragment = void 0;
	            if (storeUtils_1.isInlineFragment(selection)) {
	                fragment = selection;
	            }
	            else {
	                fragment = fragmentMap[selection.name.value];
	                if (!fragment) {
	                    throw new Error("No fragment named " + selection.name.value + ".");
	                }
	            }
	            if (included) {
	                writeSelectionSetToStore({
	                    result: result,
	                    selectionSet: fragment.selectionSet,
	                    dataId: dataId,
	                    context: context,
	                });
	            }
	        }
	    });
	    return store;
	}
	exports.writeSelectionSetToStore = writeSelectionSetToStore;
	function isGeneratedId(id) {
	    return (id[0] === '$');
	}
	function mergeWithGenerated(generatedKey, realKey, cache) {
	    var generated = cache[generatedKey];
	    var real = cache[realKey];
	    Object.keys(generated).forEach(function (key) {
	        var value = generated[key];
	        var realValue = real[key];
	        if (storeUtils_2.isIdValue(value)
	            && isGeneratedId(value.id)
	            && storeUtils_2.isIdValue(realValue)) {
	            mergeWithGenerated(value.id, realValue.id, cache);
	        }
	        delete cache[generatedKey];
	        cache[realKey] = __assign({}, generated, real);
	    });
	}
	function writeFieldToStore(_a) {
	    var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
	    var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store, fragmentMap = context.fragmentMap;
	    var storeValue;
	    var storeFieldName = storeUtils_1.storeKeyNameFromField(field, variables);
	    var shouldMerge = false;
	    var generatedKey;
	    if ((!field.selectionSet || isNull(value)) && !isObject(value)) {
	        storeValue = value;
	    }
	    else if ((!field.selectionSet || isNull(value)) && isObject(value)) {
	        storeValue = {
	            type: 'json',
	            json: value,
	        };
	    }
	    else if (Array.isArray(value)) {
	        var generatedId = dataId + "." + storeFieldName;
	        storeValue = processArrayValue(value, generatedId, field.selectionSet, context);
	    }
	    else {
	        var valueDataId = dataId + "." + storeFieldName;
	        var generated = true;
	        if (!isGeneratedId(valueDataId)) {
	            valueDataId = '$' + valueDataId;
	        }
	        if (dataIdFromObject) {
	            var semanticId = dataIdFromObject(value);
	            if (semanticId && isGeneratedId(semanticId)) {
	                throw new Error('IDs returned by dataIdFromObject cannot begin with the "$" character.');
	            }
	            if (semanticId) {
	                valueDataId = semanticId;
	                generated = false;
	            }
	        }
	        writeSelectionSetToStore({
	            dataId: valueDataId,
	            result: value,
	            selectionSet: field.selectionSet,
	            context: context,
	        });
	        storeValue = {
	            type: 'id',
	            id: valueDataId,
	            generated: generated,
	        };
	        if (store[dataId] && store[dataId][storeFieldName] !== storeValue) {
	            var escapedId = store[dataId][storeFieldName];
	            if (storeUtils_2.isIdValue(storeValue) && storeValue.generated
	                && storeUtils_2.isIdValue(escapedId) && !escapedId.generated) {
	                throw new Error("Store error: the application attempted to write an object with no provided id" +
	                    (" but the store already contains an id of " + escapedId.id + " for this object."));
	            }
	            if (storeUtils_2.isIdValue(escapedId) && escapedId.generated) {
	                generatedKey = escapedId.id;
	                shouldMerge = true;
	            }
	        }
	    }
	    var newStoreObj = __assign({}, store[dataId], (_b = {}, _b[storeFieldName] = storeValue, _b));
	    if (shouldMerge) {
	        mergeWithGenerated(generatedKey, storeValue.id, store);
	    }
	    if (!store[dataId] || storeValue !== store[dataId][storeFieldName]) {
	        store[dataId] = newStoreObj;
	    }
	    var _b;
	}
	function processArrayValue(value, generatedId, selectionSet, context) {
	    return value.map(function (item, index) {
	        if (isNull(item)) {
	            return null;
	        }
	        var itemDataId = generatedId + "." + index;
	        if (Array.isArray(item)) {
	            return processArrayValue(item, itemDataId, selectionSet, context);
	        }
	        var generated = true;
	        if (context.dataIdFromObject) {
	            var semanticId = context.dataIdFromObject(item);
	            if (semanticId) {
	                itemDataId = semanticId;
	                generated = false;
	            }
	        }
	        writeSelectionSetToStore({
	            dataId: itemDataId,
	            result: item,
	            selectionSet: selectionSet,
	            context: context,
	        });
	        var idStoreValue = {
	            type: 'id',
	            id: itemDataId,
	            generated: generated,
	        };
	        return idStoreValue;
	    });
	}
	//# sourceMappingURL=writeToStore.js.map

/***/ },
/* 752 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	 * @example
	 *
	 * _.isNull(null);
	 * // => true
	 *
	 * _.isNull(void 0);
	 * // => false
	 */
	function isNull(value) {
	  return value === null;
	}
	
	module.exports = isNull;


/***/ },
/* 753 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var countBy = __webpack_require__(755);
	var identity = __webpack_require__(636);
	var uniq = __webpack_require__(761);
	function getMutationDefinition(doc) {
	    checkDocument(doc);
	    var mutationDef = null;
	    doc.definitions.forEach(function (definition) {
	        if (definition.kind === 'OperationDefinition'
	            && definition.operation === 'mutation') {
	            mutationDef = definition;
	        }
	    });
	    if (!mutationDef) {
	        throw new Error('Must contain a mutation definition.');
	    }
	    return mutationDef;
	}
	exports.getMutationDefinition = getMutationDefinition;
	function checkDocument(doc) {
	    if (doc.kind !== 'Document') {
	        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
	    }
	    var definitionTypes = doc.definitions.map(function (definition) {
	        if (definition.kind !== 'OperationDefinition' && definition.kind !== 'FragmentDefinition') {
	            throw new Error("Schema type definitions not allowed in queries. Found: \"" + definition.kind + "\"");
	        }
	        return definition.kind;
	    });
	    var typeCounts = countBy(definitionTypes, identity);
	    if (typeCounts['OperationDefinition'] > 1) {
	        throw new Error('Queries must have exactly one operation definition.');
	    }
	}
	exports.checkDocument = checkDocument;
	function getOperationName(doc) {
	    var res = '';
	    doc.definitions.forEach(function (definition) {
	        if (definition.kind === 'OperationDefinition'
	            && definition.name) {
	            res = definition.name.value;
	        }
	    });
	    return res;
	}
	exports.getOperationName = getOperationName;
	function getFragmentDefinitions(doc) {
	    var fragmentDefinitions = doc.definitions.filter(function (definition) {
	        if (definition.kind === 'FragmentDefinition') {
	            return true;
	        }
	        else {
	            return false;
	        }
	    });
	    return fragmentDefinitions;
	}
	exports.getFragmentDefinitions = getFragmentDefinitions;
	function getQueryDefinition(doc) {
	    checkDocument(doc);
	    var queryDef = null;
	    doc.definitions.map(function (definition) {
	        if (definition.kind === 'OperationDefinition'
	            && definition.operation === 'query') {
	            queryDef = definition;
	        }
	    });
	    if (!queryDef) {
	        throw new Error('Must contain a query definition.');
	    }
	    return queryDef;
	}
	exports.getQueryDefinition = getQueryDefinition;
	function getOperationDefinition(doc) {
	    checkDocument(doc);
	    var opDef = null;
	    doc.definitions.map(function (definition) {
	        if (definition.kind === 'OperationDefinition') {
	            opDef = definition;
	        }
	    });
	    if (!opDef) {
	        throw new Error('Must contain a query definition.');
	    }
	    return opDef;
	}
	exports.getOperationDefinition = getOperationDefinition;
	function getFragmentDefinition(doc) {
	    if (doc.kind !== 'Document') {
	        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
	    }
	    if (doc.definitions.length > 1) {
	        throw new Error('Fragment must have exactly one definition.');
	    }
	    var fragmentDef = doc.definitions[0];
	    if (fragmentDef.kind !== 'FragmentDefinition') {
	        throw new Error('Must be a fragment definition.');
	    }
	    return fragmentDef;
	}
	exports.getFragmentDefinition = getFragmentDefinition;
	function createFragmentMap(fragments) {
	    if (fragments === void 0) { fragments = []; }
	    var symTable = {};
	    fragments.forEach(function (fragment) {
	        symTable[fragment.name.value] = fragment;
	    });
	    return symTable;
	}
	exports.createFragmentMap = createFragmentMap;
	function addFragmentsToDocument(queryDoc, fragments) {
	    if (!fragments) {
	        return queryDoc;
	    }
	    checkDocument(queryDoc);
	    return (__assign({}, queryDoc, { definitions: uniq(queryDoc.definitions.concat(fragments)) }));
	}
	exports.addFragmentsToDocument = addFragmentsToDocument;
	//# sourceMappingURL=getFromAST.js.map

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(622),
	    createAggregator = __webpack_require__(756);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The corresponding value of
	 * each key is the number of times the key was returned by `iteratee`. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.countBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': 1, '6': 2 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.countBy(['one', 'two', 'three'], 'length');
	 * // => { '3': 2, '5': 1 }
	 */
	var countBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    ++result[key];
	  } else {
	    baseAssignValue(result, key, 1);
	  }
	});
	
	module.exports = countBy;


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__(757),
	    baseAggregator = __webpack_require__(758),
	    baseIteratee = __webpack_require__(665),
	    isArray = __webpack_require__(619);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 757 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(759);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(662),
	    createBaseEach = __webpack_require__(760);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(644);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(762);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each element
	 * is kept. The order of result values is determined by the order they occur
	 * in the array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length) ? baseUniq(array) : [];
	}
	
	module.exports = uniq;


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(700),
	    arrayIncludes = __webpack_require__(763),
	    arrayIncludesWith = __webpack_require__(768),
	    cacheHas = __webpack_require__(704),
	    createSet = __webpack_require__(769),
	    setToArray = __webpack_require__(708);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(764);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(765),
	    baseIsNaN = __webpack_require__(766),
	    strictIndexOf = __webpack_require__(767);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 765 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 766 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 767 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 768 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(719),
	    noop = __webpack_require__(770),
	    setToArray = __webpack_require__(708);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 770 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var isObject = __webpack_require__(627);
	function isStringValue(value) {
	    return value.kind === 'StringValue';
	}
	function isBooleanValue(value) {
	    return value.kind === 'BooleanValue';
	}
	function isIntValue(value) {
	    return value.kind === 'IntValue';
	}
	function isFloatValue(value) {
	    return value.kind === 'FloatValue';
	}
	function isVariable(value) {
	    return value.kind === 'Variable';
	}
	function isObjectValue(value) {
	    return value.kind === 'ObjectValue';
	}
	function isListValue(value) {
	    return value.kind === 'ListValue';
	}
	function isEnumValue(value) {
	    return value.kind === 'EnumValue';
	}
	function valueToObjectRepresentation(argObj, name, value, variables) {
	    if (isIntValue(value) || isFloatValue(value)) {
	        argObj[name.value] = Number(value.value);
	    }
	    else if (isBooleanValue(value) || isStringValue(value)) {
	        argObj[name.value] = value.value;
	    }
	    else if (isObjectValue(value)) {
	        var nestedArgObj_1 = {};
	        value.fields.map(function (obj) { return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables); });
	        argObj[name.value] = nestedArgObj_1;
	    }
	    else if (isVariable(value)) {
	        if (!variables || !(value.name.value in variables)) {
	            throw new Error("The inline argument \"" + value.name.value + "\" is expected as a variable but was not provided.");
	        }
	        var variableValue = variables[value.name.value];
	        argObj[name.value] = variableValue;
	    }
	    else if (isListValue(value)) {
	        argObj[name.value] = value.values.map(function (listValue) {
	            var nestedArgArrayObj = {};
	            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
	            return nestedArgArrayObj[name.value];
	        });
	    }
	    else if (isEnumValue(value)) {
	        argObj[name.value] = value.value;
	    }
	    else {
	        throw new Error("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\" is not supported.\n                    Use variables instead of inline arguments to overcome this limitation.");
	    }
	}
	function storeKeyNameFromField(field, variables) {
	    if (field.arguments && field.arguments.length) {
	        var argObj_1 = {};
	        field.arguments.forEach(function (_a) {
	            var name = _a.name, value = _a.value;
	            return valueToObjectRepresentation(argObj_1, name, value, variables);
	        });
	        return storeKeyNameFromFieldNameAndArgs(field.name.value, argObj_1);
	    }
	    return field.name.value;
	}
	exports.storeKeyNameFromField = storeKeyNameFromField;
	function storeKeyNameFromFieldNameAndArgs(fieldName, args) {
	    if (args) {
	        var stringifiedArgs = JSON.stringify(args);
	        return fieldName + "(" + stringifiedArgs + ")";
	    }
	    return fieldName;
	}
	exports.storeKeyNameFromFieldNameAndArgs = storeKeyNameFromFieldNameAndArgs;
	function resultKeyNameFromField(field) {
	    return field.alias ?
	        field.alias.value :
	        field.name.value;
	}
	exports.resultKeyNameFromField = resultKeyNameFromField;
	function isField(selection) {
	    return selection.kind === 'Field';
	}
	exports.isField = isField;
	function isInlineFragment(selection) {
	    return selection.kind === 'InlineFragment';
	}
	exports.isInlineFragment = isInlineFragment;
	function graphQLResultHasError(result) {
	    return result.errors && result.errors.length;
	}
	exports.graphQLResultHasError = graphQLResultHasError;
	function isIdValue(idObject) {
	    return (isObject(idObject) && idObject.type === 'id');
	}
	exports.isIdValue = isIdValue;
	function toIdValue(id, generated) {
	    if (generated === void 0) { generated = false; }
	    return {
	        type: 'id',
	        id: id,
	        generated: generated,
	    };
	}
	exports.toIdValue = toIdValue;
	function isJsonValue(jsonObject) {
	    return (isObject(jsonObject) && jsonObject.type === 'json');
	}
	exports.isJsonValue = isJsonValue;
	//# sourceMappingURL=storeUtils.js.map

/***/ },
/* 772 */
/***/ function(module, exports) {

	"use strict";
	function shouldInclude(selection, variables) {
	    if (!variables) {
	        variables = {};
	    }
	    if (!selection.directives) {
	        return true;
	    }
	    var res = true;
	    selection.directives.forEach(function (directive) {
	        if (directive.name.value !== 'skip' && directive.name.value !== 'include') {
	            return;
	        }
	        var directiveArguments = directive.arguments;
	        var directiveName = directive.name.value;
	        if (directiveArguments.length !== 1) {
	            throw new Error("Incorrect number of arguments for the @" + directiveName + " directive.");
	        }
	        var ifArgument = directive.arguments[0];
	        if (!ifArgument.name || ifArgument.name.value !== 'if') {
	            throw new Error("Invalid argument for the @" + directiveName + " directive.");
	        }
	        var ifValue = directive.arguments[0].value;
	        var evaledValue = false;
	        if (!ifValue || ifValue.kind !== 'BooleanValue') {
	            if (ifValue.kind !== 'Variable') {
	                throw new Error("Argument for the @" + directiveName + " directive must be a variable or a bool ean value.");
	            }
	            else {
	                evaledValue = variables[ifValue.name.value];
	                if (evaledValue === undefined) {
	                    throw new Error("Invalid variable referenced in @" + directiveName + " directive.");
	                }
	            }
	        }
	        else {
	            evaledValue = ifValue.value;
	        }
	        if (directiveName === 'skip') {
	            evaledValue = !evaledValue;
	        }
	        if (!evaledValue) {
	            res = false;
	        }
	    });
	    return res;
	}
	exports.shouldInclude = shouldInclude;
	//# sourceMappingURL=directives.js.map

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var mapValues = __webpack_require__(661);
	var cloneDeep = __webpack_require__(774);
	var replaceQueryResults_1 = __webpack_require__(802);
	var writeToStore_1 = __webpack_require__(751);
	var getFromAST_1 = __webpack_require__(754);
	var scopeQuery_1 = __webpack_require__(803);
	function mutationResultArrayInsertReducer(state, _a) {
	    var behavior = _a.behavior, result = _a.result, variables = _a.variables, document = _a.document, config = _a.config;
	    var _b = behavior, resultPath = _b.resultPath, storePath = _b.storePath, where = _b.where;
	    var selectionSet = getFromAST_1.getOperationDefinition(document).selectionSet;
	    var fragmentMap = getFromAST_1.createFragmentMap(getFromAST_1.getFragmentDefinitions(document));
	    var scopedSelectionSet = scopeQuery_1.scopeSelectionSetToResultPath({
	        selectionSet: selectionSet,
	        fragmentMap: fragmentMap,
	        path: resultPath,
	    });
	    var scopedResult = scopeQuery_1.scopeJSONToResultPath({
	        json: result.data,
	        path: resultPath,
	    });
	    var dataId = config.dataIdFromObject(scopedResult) || generateMutationResultDataId();
	    state = writeToStore_1.writeSelectionSetToStore({
	        result: scopedResult,
	        dataId: dataId,
	        selectionSet: scopedSelectionSet,
	        context: {
	            store: state,
	            variables: variables,
	            dataIdFromObject: config.dataIdFromObject,
	            fragmentMap: fragmentMap,
	        },
	    });
	    var dataIdOfObj = storePath[0], restStorePath = storePath.slice(1);
	    var clonedObj = cloneDeep(state[dataIdOfObj]);
	    var array = scopeQuery_1.scopeJSONToResultPath({
	        json: clonedObj,
	        path: restStorePath,
	    });
	    var idValue = { type: 'id', generated: false, id: dataId };
	    if (where === 'PREPEND') {
	        array.unshift(idValue);
	    }
	    else if (where === 'APPEND') {
	        array.push(idValue);
	    }
	    else {
	        throw new Error('Unsupported "where" option to ARRAY_INSERT.');
	    }
	    return __assign({}, state, (_c = {}, _c[dataIdOfObj] = clonedObj, _c));
	    var _c;
	}
	var currId = 0;
	function generateMutationResultDataId() {
	    currId++;
	    return "ARRAY_INSERT-gen-id-" + currId;
	}
	function mutationResultDeleteReducer(state, _a) {
	    var behavior = _a.behavior;
	    var dataId = behavior.dataId;
	    delete state[dataId];
	    var newState = mapValues(state, function (storeObj) {
	        return removeRefsFromStoreObj(storeObj, dataId);
	    });
	    return newState;
	}
	function removeRefsFromStoreObj(storeObj, dataId) {
	    var affected = false;
	    var cleanedObj = mapValues(storeObj, function (value) {
	        if (value && value.id === dataId) {
	            affected = true;
	            return null;
	        }
	        if (Array.isArray(value)) {
	            var filteredArray = cleanArray(value, dataId);
	            if (filteredArray !== value) {
	                affected = true;
	                return filteredArray;
	            }
	        }
	        return value;
	    });
	    if (affected) {
	        return cleanedObj;
	    }
	    else {
	        return storeObj;
	    }
	}
	function cleanArray(originalArray, dataId) {
	    if (originalArray.length && Array.isArray(originalArray[0])) {
	        var modified_1 = false;
	        var filteredArray = originalArray.map(function (nestedArray) {
	            var nestedFilteredArray = cleanArray(nestedArray, dataId);
	            if (nestedFilteredArray !== nestedArray) {
	                modified_1 = true;
	                return nestedFilteredArray;
	            }
	            return nestedArray;
	        });
	        if (!modified_1) {
	            return originalArray;
	        }
	        return filteredArray;
	    }
	    else {
	        var filteredArray = originalArray.filter(function (item) { return item.id !== dataId; });
	        if (filteredArray.length === originalArray.length) {
	            return originalArray;
	        }
	        return filteredArray;
	    }
	}
	exports.cleanArray = cleanArray;
	function mutationResultArrayDeleteReducer(state, _a) {
	    var behavior = _a.behavior;
	    var _b = behavior, dataId = _b.dataId, storePath = _b.storePath;
	    var dataIdOfObj = storePath[0], restStorePath = storePath.slice(1);
	    var clonedObj = cloneDeep(state[dataIdOfObj]);
	    var array = scopeQuery_1.scopeJSONToResultPath({
	        json: clonedObj,
	        path: restStorePath,
	    });
	    var index = -1;
	    array.some(function (item, i) {
	        if (item && item.id === dataId) {
	            index = i;
	            return true;
	        }
	        return false;
	    });
	    if (index === -1) {
	        return state;
	    }
	    array.splice(index, 1);
	    return __assign({}, state, (_c = {}, _c[dataIdOfObj] = clonedObj, _c));
	    var _c;
	}
	function mutationResultQueryResultReducer(state, _a) {
	    var behavior = _a.behavior, config = _a.config;
	    return replaceQueryResults_1.replaceQueryResults(state, behavior, config);
	}
	exports.mutationResultQueryResultReducer = mutationResultQueryResultReducer;
	exports.defaultMutationBehaviorReducers = {
	    'ARRAY_INSERT': mutationResultArrayInsertReducer,
	    'DELETE': mutationResultDeleteReducer,
	    'ARRAY_DELETE': mutationResultArrayDeleteReducer,
	    'QUERY_RESULT': mutationResultQueryResultReducer,
	};
	//# sourceMappingURL=mutationResults.js.map

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(775);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(668),
	    arrayEach = __webpack_require__(776),
	    assignValue = __webpack_require__(621),
	    baseAssign = __webpack_require__(777),
	    baseAssignIn = __webpack_require__(778),
	    cloneBuffer = __webpack_require__(782),
	    copyArray = __webpack_require__(783),
	    copySymbols = __webpack_require__(784),
	    copySymbolsIn = __webpack_require__(785),
	    getAllKeys = __webpack_require__(710),
	    getAllKeysIn = __webpack_require__(787),
	    getTag = __webpack_require__(716),
	    initCloneArray = __webpack_require__(788),
	    initCloneByTag = __webpack_require__(789),
	    initCloneObject = __webpack_require__(800),
	    isArray = __webpack_require__(619),
	    isBuffer = __webpack_require__(653),
	    isObject = __webpack_require__(627),
	    keys = __webpack_require__(648);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 776 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(633),
	    keys = __webpack_require__(648);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(633),
	    keysIn = __webpack_require__(779);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(649),
	    baseKeysIn = __webpack_require__(780),
	    isArrayLike = __webpack_require__(644);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(627),
	    isPrototype = __webpack_require__(647),
	    nativeKeysIn = __webpack_require__(781);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 781 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(481);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(490)(module)))

/***/ },
/* 783 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(633),
	    getSymbols = __webpack_require__(713);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(633),
	    getSymbolsIn = __webpack_require__(786);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(712),
	    getPrototype = __webpack_require__(485),
	    getSymbols = __webpack_require__(713),
	    stubArray = __webpack_require__(715);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(711),
	    getSymbolsIn = __webpack_require__(786),
	    keysIn = __webpack_require__(779);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 788 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(790),
	    cloneDataView = __webpack_require__(791),
	    cloneMap = __webpack_require__(792),
	    cloneRegExp = __webpack_require__(795),
	    cloneSet = __webpack_require__(796),
	    cloneSymbol = __webpack_require__(798),
	    cloneTypedArray = __webpack_require__(799);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(706);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(790);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(793),
	    arrayReduce = __webpack_require__(794),
	    mapToArray = __webpack_require__(707);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 793 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 794 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 795 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(797),
	    arrayReduce = __webpack_require__(794),
	    setToArray = __webpack_require__(708);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 797 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(480);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(790);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(801),
	    getPrototype = __webpack_require__(485),
	    isPrototype = __webpack_require__(647);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(627);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var writeToStore_1 = __webpack_require__(751);
	function replaceQueryResults(state, _a, config) {
	    var variables = _a.variables, document = _a.document, newResult = _a.newResult;
	    var clonedState = __assign({}, state);
	    return writeToStore_1.writeResultToStore({
	        result: newResult,
	        dataId: 'ROOT_QUERY',
	        variables: variables,
	        document: document,
	        store: clonedState,
	        dataIdFromObject: config.dataIdFromObject,
	    });
	}
	exports.replaceQueryResults = replaceQueryResults;
	//# sourceMappingURL=replaceQueryResults.js.map

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var storeUtils_1 = __webpack_require__(771);
	var isNumber = __webpack_require__(746);
	function scopeJSONToResultPath(_a) {
	    var json = _a.json, path = _a.path;
	    var current = json;
	    path.forEach(function (pathSegment) {
	        current = current[pathSegment];
	    });
	    return current;
	}
	exports.scopeJSONToResultPath = scopeJSONToResultPath;
	function scopeSelectionSetToResultPath(_a) {
	    var selectionSet = _a.selectionSet, fragmentMap = _a.fragmentMap, path = _a.path;
	    var currSelSet = selectionSet;
	    path
	        .filter(function (pathSegment) { return !isNumber(pathSegment); })
	        .forEach(function (pathSegment) {
	        currSelSet = followOnePathSegment(currSelSet, pathSegment, fragmentMap);
	    });
	    return currSelSet;
	}
	exports.scopeSelectionSetToResultPath = scopeSelectionSetToResultPath;
	function followOnePathSegment(currSelSet, pathSegment, fragmentMap) {
	    var matchingFields = getMatchingFields(currSelSet, pathSegment, fragmentMap);
	    if (matchingFields.length < 1) {
	        throw new Error("No matching field found in query for path segment: " + pathSegment);
	    }
	    if (matchingFields.length > 1) {
	        throw new Error("Multiple fields found in query for path segment \"" + pathSegment + "\". Please file an issue on Apollo Client if you run into this situation.");
	    }
	    return matchingFields[0].selectionSet;
	}
	function getMatchingFields(currSelSet, pathSegment, fragmentMap) {
	    var matching = [];
	    currSelSet.selections.forEach(function (selection) {
	        if (storeUtils_1.isField(selection)) {
	            if (storeUtils_1.resultKeyNameFromField(selection) === pathSegment) {
	                matching.push(selection);
	            }
	        }
	        else if (storeUtils_1.isInlineFragment(selection)) {
	            matching = matching.concat(getMatchingFields(selection.selectionSet, pathSegment, fragmentMap));
	        }
	        else {
	            var fragment = fragmentMap[selection.name.value];
	            matching = matching.concat(getMatchingFields(fragment.selectionSet, pathSegment, fragmentMap));
	        }
	    });
	    return matching;
	}
	//# sourceMappingURL=scopeQuery.js.map

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var actions_1 = __webpack_require__(750);
	var storeUtils_1 = __webpack_require__(771);
	var isEqual = __webpack_require__(805);
	var NetworkStatus;
	(function (NetworkStatus) {
	    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
	    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
	    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
	    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
	    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
	    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
	    NetworkStatus[NetworkStatus["error"] = 8] = "error";
	})(NetworkStatus = exports.NetworkStatus || (exports.NetworkStatus = {}));
	function queries(previousState, action) {
	    if (previousState === void 0) { previousState = {}; }
	    if (actions_1.isQueryInitAction(action)) {
	        var newState = __assign({}, previousState);
	        var previousQuery = previousState[action.queryId];
	        if (previousQuery && previousQuery.queryString !== action.queryString) {
	            throw new Error('Internal Error: may not update existing query string in store');
	        }
	        var isSetVariables = false;
	        var previousVariables = void 0;
	        if (action.storePreviousVariables &&
	            previousQuery &&
	            previousQuery.networkStatus !== NetworkStatus.loading) {
	            if (!isEqual(previousQuery.variables, action.variables)) {
	                isSetVariables = true;
	                previousVariables = previousQuery.variables;
	            }
	        }
	        var newNetworkStatus = NetworkStatus.loading;
	        if (isSetVariables) {
	            newNetworkStatus = NetworkStatus.setVariables;
	        }
	        else if (action.isPoll) {
	            newNetworkStatus = NetworkStatus.poll;
	        }
	        else if (action.isRefetch) {
	            newNetworkStatus = NetworkStatus.refetch;
	        }
	        else if (action.isPoll) {
	            newNetworkStatus = NetworkStatus.poll;
	        }
	        newState[action.queryId] = {
	            queryString: action.queryString,
	            variables: action.variables,
	            previousVariables: previousVariables,
	            loading: true,
	            networkError: null,
	            graphQLErrors: null,
	            networkStatus: newNetworkStatus,
	            forceFetch: action.forceFetch,
	            returnPartialData: action.returnPartialData,
	            lastRequestId: action.requestId,
	            metadata: action.metadata,
	        };
	        return newState;
	    }
	    else if (actions_1.isQueryResultAction(action)) {
	        if (!previousState[action.queryId]) {
	            return previousState;
	        }
	        if (action.requestId < previousState[action.queryId].lastRequestId) {
	            return previousState;
	        }
	        var newState = __assign({}, previousState);
	        var resultHasGraphQLErrors = storeUtils_1.graphQLResultHasError(action.result);
	        newState[action.queryId] = __assign({}, previousState[action.queryId], { loading: false, networkError: null, graphQLErrors: resultHasGraphQLErrors ? action.result.errors : null, previousVariables: null, networkStatus: NetworkStatus.ready });
	        return newState;
	    }
	    else if (actions_1.isQueryErrorAction(action)) {
	        if (!previousState[action.queryId]) {
	            return previousState;
	        }
	        if (action.requestId < previousState[action.queryId].lastRequestId) {
	            return previousState;
	        }
	        var newState = __assign({}, previousState);
	        newState[action.queryId] = __assign({}, previousState[action.queryId], { loading: false, networkError: action.error, networkStatus: NetworkStatus.error });
	        return newState;
	    }
	    else if (actions_1.isQueryResultClientAction(action)) {
	        if (!previousState[action.queryId]) {
	            return previousState;
	        }
	        var newState = __assign({}, previousState);
	        newState[action.queryId] = __assign({}, previousState[action.queryId], { loading: !action.complete, networkError: null, previousVariables: null, networkStatus: action.complete ? NetworkStatus.ready : NetworkStatus.loading });
	        return newState;
	    }
	    else if (actions_1.isQueryStopAction(action)) {
	        var newState = __assign({}, previousState);
	        delete newState[action.queryId];
	        return newState;
	    }
	    else if (actions_1.isStoreResetAction(action)) {
	        return resetQueryState(previousState, action);
	    }
	    return previousState;
	}
	exports.queries = queries;
	function resetQueryState(state, action) {
	    var observableQueryIds = action.observableQueryIds;
	    var newQueries = Object.keys(state).filter(function (queryId) {
	        return (observableQueryIds.indexOf(queryId) > -1);
	    }).reduce(function (res, key) {
	        res[key] = __assign({}, state[key], { loading: true, networkStatus: NetworkStatus.loading });
	        return res;
	    }, {});
	    return newQueries;
	}
	//# sourceMappingURL=store.js.map

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(697);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var actions_1 = __webpack_require__(750);
	function mutations(previousState, action) {
	    if (previousState === void 0) { previousState = {}; }
	    if (actions_1.isMutationInitAction(action)) {
	        var newState = __assign({}, previousState);
	        newState[action.mutationId] = {
	            mutationString: action.mutationString,
	            variables: action.variables,
	            loading: true,
	            error: null,
	        };
	        return newState;
	    }
	    else if (actions_1.isMutationResultAction(action)) {
	        var newState = __assign({}, previousState);
	        newState[action.mutationId] = __assign({}, previousState[action.mutationId], { loading: false, error: null });
	        return newState;
	    }
	    else if (actions_1.isMutationErrorAction(action)) {
	        var newState = __assign({}, previousState);
	        newState[action.mutationId] = __assign({}, previousState[action.mutationId], { loading: false, error: action.error });
	    }
	    else if (actions_1.isStoreResetAction(action)) {
	        return {};
	    }
	    return previousState;
	}
	exports.mutations = mutations;
	//# sourceMappingURL=store.js.map

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var actions_1 = __webpack_require__(750);
	var store_1 = __webpack_require__(749);
	var store_2 = __webpack_require__(748);
	var pick = __webpack_require__(808);
	var optimisticDefaultState = [];
	function optimistic(previousState, action, store, config) {
	    if (previousState === void 0) { previousState = optimisticDefaultState; }
	    if (actions_1.isMutationInitAction(action) && action.optimisticResponse) {
	        var fakeMutationResultAction = {
	            type: 'APOLLO_MUTATION_RESULT',
	            result: { data: action.optimisticResponse },
	            document: action.mutation,
	            operationName: action.operationName,
	            variables: action.variables,
	            mutationId: action.mutationId,
	            resultBehaviors: action.resultBehaviors,
	            extraReducers: action.extraReducers,
	        };
	        var fakeStore = __assign({}, store, { optimistic: previousState });
	        var optimisticData_1 = store_2.getDataWithOptimisticResults(fakeStore);
	        var fakeDataResultState_1 = store_1.data(optimisticData_1, fakeMutationResultAction, store.queries, store.mutations, config);
	        var changedKeys = Object.keys(fakeDataResultState_1).filter(function (key) { return optimisticData_1[key] !== fakeDataResultState_1[key]; });
	        var patch = pick(fakeDataResultState_1, changedKeys);
	        var optimisticState = {
	            data: patch,
	            mutationId: action.mutationId,
	        };
	        var newState = previousState.concat([optimisticState]);
	        return newState;
	    }
	    else if ((actions_1.isMutationErrorAction(action) || actions_1.isMutationResultAction(action))
	        && previousState.some(function (change) { return change.mutationId === action.mutationId; })) {
	        var newState = previousState.filter(function (change) { return change.mutationId !== action.mutationId; });
	        return newState;
	    }
	    return previousState;
	}
	exports.optimistic = optimistic;
	//# sourceMappingURL=store.js.map

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(809),
	    flatRest = __webpack_require__(812);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(810),
	    hasIn = __webpack_require__(737);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(726),
	    baseSet = __webpack_require__(811),
	    castPath = __webpack_require__(727);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(621),
	    castPath = __webpack_require__(727),
	    isIndex = __webpack_require__(646),
	    isObject = __webpack_require__(627),
	    toKey = __webpack_require__(736);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(813),
	    overRest = __webpack_require__(637),
	    setToString = __webpack_require__(639);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(814);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(712),
	    isFlattenable = __webpack_require__(815);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(480),
	    isArguments = __webpack_require__(651),
	    isArray = __webpack_require__(619);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var Observable_1 = __webpack_require__(817);
	var ApolloError_1 = __webpack_require__(818);
	var QueryManager_1 = __webpack_require__(819);
	var errorHandling_1 = __webpack_require__(832);
	var store_1 = __webpack_require__(804);
	var getFromAST_1 = __webpack_require__(754);
	var isEqual = __webpack_require__(805);
	var ObservableQuery = (function (_super) {
	    __extends(ObservableQuery, _super);
	    function ObservableQuery(_a) {
	        var scheduler = _a.scheduler, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
	        var _this;
	        var queryManager = scheduler.queryManager;
	        var queryId = queryManager.generateQueryId();
	        var subscriberFunction = function (observer) {
	            return _this.onSubscribe(observer);
	        };
	        _this = _super.call(this, subscriberFunction) || this;
	        _this.isCurrentlyPolling = false;
	        _this.options = options;
	        _this.variables = _this.options.variables || {};
	        _this.scheduler = scheduler;
	        _this.queryManager = queryManager;
	        _this.queryId = queryId;
	        _this.shouldSubscribe = shouldSubscribe;
	        _this.observers = [];
	        _this.subscriptionHandles = [];
	        return _this;
	    }
	    ObservableQuery.prototype.result = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            var subscription = _this.subscribe({
	                next: function (result) {
	                    resolve(result);
	                    setTimeout(function () {
	                        subscription.unsubscribe();
	                    }, 0);
	                },
	                error: function (error) {
	                    reject(error);
	                },
	            });
	        });
	    };
	    ObservableQuery.prototype.currentResult = function () {
	        var _a = this.queryManager.getCurrentQueryResult(this, true), data = _a.data, partial = _a.partial;
	        var queryStoreValue = this.queryManager.getApolloState().queries[this.queryId];
	        if (queryStoreValue && (queryStoreValue.graphQLErrors || queryStoreValue.networkError)) {
	            var error = new ApolloError_1.ApolloError({
	                graphQLErrors: queryStoreValue.graphQLErrors,
	                networkError: queryStoreValue.networkError,
	            });
	            return { data: {}, loading: false, networkStatus: queryStoreValue.networkStatus, error: error };
	        }
	        var queryLoading = !queryStoreValue || queryStoreValue.loading;
	        var loading = (this.options.forceFetch && queryLoading)
	            || (partial && !this.options.noFetch);
	        var networkStatus;
	        if (queryStoreValue) {
	            networkStatus = queryStoreValue.networkStatus;
	        }
	        else {
	            networkStatus = loading ? store_1.NetworkStatus.loading : store_1.NetworkStatus.ready;
	        }
	        return { data: data, loading: loading, networkStatus: networkStatus };
	    };
	    ObservableQuery.prototype.refetch = function (variables) {
	        var _this = this;
	        this.variables = __assign({}, this.variables, variables);
	        if (this.options.noFetch) {
	            throw new Error('noFetch option should not use query refetch.');
	        }
	        this.options.variables = __assign({}, this.options.variables, this.variables);
	        var combinedOptions = __assign({}, this.options, { forceFetch: true });
	        return this.queryManager.fetchQuery(this.queryId, combinedOptions, QueryManager_1.FetchType.refetch)
	            .then(function (result) { return _this.queryManager.transformResult(result); });
	    };
	    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
	        var _this = this;
	        return Promise.resolve()
	            .then(function () {
	            var qid = _this.queryManager.generateQueryId();
	            var combinedOptions = null;
	            if (fetchMoreOptions.query) {
	                combinedOptions = fetchMoreOptions;
	            }
	            else {
	                var variables = __assign({}, _this.variables, fetchMoreOptions.variables);
	                combinedOptions = __assign({}, _this.options, fetchMoreOptions, { variables: variables });
	            }
	            var fullQuery = getFromAST_1.addFragmentsToDocument(combinedOptions.query, combinedOptions.fragments);
	            combinedOptions = __assign({}, combinedOptions, { query: fullQuery, forceFetch: true });
	            return _this.queryManager.fetchQuery(qid, combinedOptions);
	        })
	            .then(function (fetchMoreResult) {
	            var reducer = fetchMoreOptions.updateQuery;
	            var mapFn = function (previousResult, _a) {
	                var variables = _a.variables;
	                var queryVariables = variables;
	                return reducer(previousResult, {
	                    fetchMoreResult: fetchMoreResult,
	                    queryVariables: queryVariables,
	                });
	            };
	            _this.updateQuery(mapFn);
	            return fetchMoreResult;
	        });
	    };
	    ObservableQuery.prototype.subscribeToMore = function (options) {
	        var _this = this;
	        var observable = this.queryManager.startGraphQLSubscription({
	            document: options.document,
	            variables: options.variables,
	        });
	        var reducer = options.updateQuery;
	        var subscription = observable.subscribe({
	            next: function (data) {
	                var mapFn = function (previousResult, _a) {
	                    var variables = _a.variables;
	                    return reducer(previousResult, {
	                        subscriptionData: { data: data },
	                        variables: variables,
	                    });
	                };
	                _this.updateQuery(mapFn);
	            },
	            error: function (err) {
	                if (options.onError) {
	                    options.onError(err);
	                }
	                else {
	                    console.error('Unhandled GraphQL subscription errror', err);
	                }
	            },
	        });
	        this.subscriptionHandles.push(subscription);
	        return function () {
	            var i = _this.subscriptionHandles.indexOf(subscription);
	            if (i >= 0) {
	                _this.subscriptionHandles.splice(i, 1);
	                subscription.unsubscribe();
	            }
	        };
	    };
	    ObservableQuery.prototype.setOptions = function (opts) {
	        var _this = this;
	        var oldOptions = this.options;
	        this.options = __assign({}, this.options, opts);
	        if (opts.pollInterval) {
	            this.startPolling(opts.pollInterval);
	        }
	        else if (opts.pollInterval === 0) {
	            this.stopPolling();
	        }
	        if ((!oldOptions.forceFetch && opts.forceFetch) || (oldOptions.noFetch && !opts.noFetch)) {
	            return this.queryManager.fetchQuery(this.queryId, this.options)
	                .then(function (result) { return _this.queryManager.transformResult(result); });
	        }
	        return this.setVariables(this.options.variables);
	    };
	    ObservableQuery.prototype.setVariables = function (variables) {
	        var _this = this;
	        var newVariables = __assign({}, this.variables, variables);
	        if (isEqual(newVariables, this.variables)) {
	            return this.result();
	        }
	        else {
	            this.variables = newVariables;
	            return this.queryManager.fetchQuery(this.queryId, __assign({}, this.options, { variables: this.variables }))
	                .then(function (result) { return _this.queryManager.transformResult(result); });
	        }
	    };
	    ObservableQuery.prototype.updateQuery = function (mapFn) {
	        var _a = this.queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
	        var newResult = errorHandling_1.tryFunctionOrLogError(function () { return mapFn(previousResult, { variables: variables }); });
	        if (newResult) {
	            this.queryManager.store.dispatch({
	                type: 'APOLLO_UPDATE_QUERY_RESULT',
	                newResult: newResult,
	                variables: variables,
	                document: document,
	            });
	        }
	    };
	    ObservableQuery.prototype.stopPolling = function () {
	        if (this.isCurrentlyPolling) {
	            this.scheduler.stopPollingQuery(this.queryId);
	            this.isCurrentlyPolling = false;
	        }
	    };
	    ObservableQuery.prototype.startPolling = function (pollInterval) {
	        if (this.options.noFetch) {
	            throw new Error('noFetch option should not use query polling.');
	        }
	        if (this.isCurrentlyPolling) {
	            this.scheduler.stopPollingQuery(this.queryId);
	            this.isCurrentlyPolling = false;
	        }
	        this.options.pollInterval = pollInterval;
	        this.isCurrentlyPolling = true;
	        this.scheduler.startPollingQuery(this.options, this.queryId);
	    };
	    ObservableQuery.prototype.onSubscribe = function (observer) {
	        var _this = this;
	        this.observers.push(observer);
	        if (observer.next && this.lastResult) {
	            observer.next(this.lastResult);
	        }
	        if (observer.error && this.lastError) {
	            observer.error(this.lastError);
	        }
	        if (this.observers.length === 1) {
	            this.setUpQuery();
	        }
	        var retQuerySubscription = {
	            unsubscribe: function () {
	                if (_this.observers.findIndex(function (el) { return el === observer; }) < 0) {
	                    return;
	                }
	                _this.observers = _this.observers.filter(function (obs) { return obs !== observer; });
	                if (_this.observers.length === 0) {
	                    _this.tearDownQuery();
	                }
	            },
	        };
	        return retQuerySubscription;
	    };
	    ObservableQuery.prototype.setUpQuery = function () {
	        var _this = this;
	        if (this.shouldSubscribe) {
	            this.queryManager.addObservableQuery(this.queryId, this);
	        }
	        if (!!this.options.pollInterval) {
	            if (this.options.noFetch) {
	                throw new Error('noFetch option should not use query polling.');
	            }
	            this.isCurrentlyPolling = true;
	            this.scheduler.startPollingQuery(this.options, this.queryId);
	        }
	        var observer = {
	            next: function (result) {
	                _this.observers.forEach(function (obs) {
	                    if (obs.next) {
	                        obs.next(result);
	                    }
	                });
	                _this.lastResult = result;
	            },
	            error: function (error) {
	                _this.observers.forEach(function (obs) {
	                    if (obs.error) {
	                        obs.error(error);
	                    }
	                    else {
	                        console.error('Unhandled error', error.message, error.stack);
	                    }
	                });
	                _this.lastError = error;
	            },
	        };
	        this.queryManager.startQuery(this.queryId, this.options, this.queryManager.queryListenerForObserver(this.queryId, this.options, observer));
	    };
	    ObservableQuery.prototype.tearDownQuery = function () {
	        if (this.isCurrentlyPolling) {
	            this.scheduler.stopPollingQuery(this.queryId);
	            this.isCurrentlyPolling = false;
	        }
	        this.subscriptionHandles.forEach(function (sub) { return sub.unsubscribe(); });
	        this.subscriptionHandles = [];
	        this.queryManager.stopQuery(this.queryId);
	        if (this.shouldSubscribe) {
	            this.queryManager.removeObservableQuery(this.queryId);
	        }
	        this.observers = [];
	    };
	    return ObservableQuery;
	}(Observable_1.Observable));
	exports.ObservableQuery = ObservableQuery;
	//# sourceMappingURL=ObservableQuery.js.map

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var symbol_observable_1 = __webpack_require__(488);
	function isSubscription(subscription) {
	    return subscription.unsubscribe !== undefined;
	}
	var Observable = (function () {
	    function Observable(subscriberFunction) {
	        this.subscriberFunction = subscriberFunction;
	    }
	    Observable.prototype[symbol_observable_1.default] = function () {
	        return this;
	    };
	    Observable.prototype.subscribe = function (observer) {
	        var subscriptionOrCleanupFunction = this.subscriberFunction(observer);
	        if (isSubscription(subscriptionOrCleanupFunction)) {
	            return subscriptionOrCleanupFunction;
	        }
	        else {
	            return {
	                unsubscribe: subscriptionOrCleanupFunction,
	            };
	        }
	    };
	    return Observable;
	}());
	exports.Observable = Observable;
	//# sourceMappingURL=Observable.js.map

/***/ },
/* 818 */
/***/ function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	function isApolloError(err) {
	    return err.hasOwnProperty('graphQLErrors');
	}
	exports.isApolloError = isApolloError;
	var generateErrorMessage = function (err) {
	    var message = '';
	    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) {
	        err.graphQLErrors.forEach(function (graphQLError) {
	            message += 'GraphQL error: ' + graphQLError.message + '\n';
	        });
	    }
	    if (err.networkError) {
	        message += 'Network error: ' + err.networkError.message + '\n';
	    }
	    message = message.replace(/\n$/, '');
	    return message;
	};
	var ApolloError = (function (_super) {
	    __extends(ApolloError, _super);
	    function ApolloError(_a) {
	        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
	        var _this = _super.call(this, errorMessage) || this;
	        _this.graphQLErrors = graphQLErrors;
	        _this.networkError = networkError;
	        _this.stack = new Error().stack;
	        if (!errorMessage) {
	            _this.message = generateErrorMessage(_this);
	        }
	        else {
	            _this.message = errorMessage;
	        }
	        _this.extraInfo = extraInfo;
	        return _this;
	    }
	    return ApolloError;
	}(Error));
	exports.ApolloError = ApolloError;
	//# sourceMappingURL=ApolloError.js.map

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var Deduplicator_1 = __webpack_require__(820);
	var forOwn = __webpack_require__(821);
	var isEqual = __webpack_require__(805);
	var store_1 = __webpack_require__(748);
	var getFromAST_1 = __webpack_require__(754);
	var queryTransform_1 = __webpack_require__(823);
	var resultReducers_1 = __webpack_require__(824);
	var printer_1 = __webpack_require__(744);
	var readFromStore_1 = __webpack_require__(825);
	var readFromStore_2 = __webpack_require__(825);
	var scheduler_1 = __webpack_require__(831);
	var Observable_1 = __webpack_require__(817);
	var store_2 = __webpack_require__(804);
	var errorHandling_1 = __webpack_require__(832);
	var ApolloError_1 = __webpack_require__(818);
	var ObservableQuery_1 = __webpack_require__(816);
	;
	var FetchType;
	(function (FetchType) {
	    FetchType[FetchType["normal"] = 1] = "normal";
	    FetchType[FetchType["refetch"] = 2] = "refetch";
	    FetchType[FetchType["poll"] = 3] = "poll";
	})(FetchType = exports.FetchType || (exports.FetchType = {}));
	var QueryManager = (function () {
	    function QueryManager(_a) {
	        var networkInterface = _a.networkInterface, store = _a.store, reduxRootSelector = _a.reduxRootSelector, _b = _a.reducerConfig, reducerConfig = _b === void 0 ? { mutationBehaviorReducers: {} } : _b, resultTransformer = _a.resultTransformer, resultComparator = _a.resultComparator, _c = _a.addTypename, addTypename = _c === void 0 ? true : _c, _d = _a.queryDeduplication, queryDeduplication = _d === void 0 ? false : _d;
	        var _this = this;
	        this.idCounter = 1;
	        this.networkInterface = networkInterface;
	        this.deduplicator = new Deduplicator_1.Deduplicator(networkInterface);
	        this.store = store;
	        this.reduxRootSelector = reduxRootSelector;
	        this.reducerConfig = reducerConfig;
	        this.resultTransformer = resultTransformer;
	        this.resultComparator = resultComparator;
	        this.pollingTimers = {};
	        this.queryListeners = {};
	        this.queryDocuments = {};
	        this.addTypename = addTypename;
	        this.queryDeduplication = queryDeduplication;
	        this.scheduler = new scheduler_1.QueryScheduler({
	            queryManager: this,
	        });
	        this.fetchQueryPromises = {};
	        this.observableQueries = {};
	        this.queryIdsByName = {};
	        if (this.store['subscribe']) {
	            var currentStoreData_1;
	            this.store['subscribe'](function () {
	                var previousStoreData = currentStoreData_1 || {};
	                var previousStoreHasData = Object.keys(previousStoreData).length;
	                currentStoreData_1 = _this.getApolloState();
	                if (isEqual(previousStoreData, currentStoreData_1) && previousStoreHasData) {
	                    return;
	                }
	                _this.broadcastQueries();
	            });
	        }
	    }
	    QueryManager.prototype.broadcastNewStore = function (store) {
	        this.broadcastQueries();
	    };
	    QueryManager.prototype.mutate = function (_a) {
	        var _this = this;
	        var mutation = _a.mutation, variables = _a.variables, _b = _a.resultBehaviors, resultBehaviors = _b === void 0 ? [] : _b, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _c = _a.refetchQueries, refetchQueries = _c === void 0 ? [] : _c;
	        var mutationId = this.generateQueryId();
	        if (this.addTypename) {
	            mutation = queryTransform_1.addTypenameToDocument(mutation);
	        }
	        getFromAST_1.checkDocument(mutation);
	        var mutationString = printer_1.print(mutation);
	        var request = {
	            query: mutation,
	            variables: variables,
	            operationName: getFromAST_1.getOperationName(mutation),
	        };
	        var updateQueriesResultBehaviors = !optimisticResponse ? [] :
	            this.collectResultBehaviorsFromUpdateQueries(updateQueries, { data: optimisticResponse }, true);
	        this.queryDocuments[mutationId] = mutation;
	        this.store.dispatch({
	            type: 'APOLLO_MUTATION_INIT',
	            mutationString: mutationString,
	            mutation: mutation,
	            variables: variables,
	            operationName: getFromAST_1.getOperationName(mutation),
	            mutationId: mutationId,
	            optimisticResponse: optimisticResponse,
	            resultBehaviors: resultBehaviors.concat(updateQueriesResultBehaviors),
	            extraReducers: this.getExtraReducers(),
	        });
	        return new Promise(function (resolve, reject) {
	            _this.networkInterface.query(request)
	                .then(function (result) {
	                if (result.errors) {
	                    reject(new ApolloError_1.ApolloError({
	                        graphQLErrors: result.errors,
	                    }));
	                }
	                _this.store.dispatch({
	                    type: 'APOLLO_MUTATION_RESULT',
	                    result: result,
	                    mutationId: mutationId,
	                    document: mutation,
	                    operationName: getFromAST_1.getOperationName(mutation),
	                    variables: variables,
	                    resultBehaviors: resultBehaviors.concat(_this.collectResultBehaviorsFromUpdateQueries(updateQueries, result)),
	                    extraReducers: _this.getExtraReducers(),
	                });
	                refetchQueries.forEach(function (name) { _this.refetchQueryByName(name); });
	                delete _this.queryDocuments[mutationId];
	                resolve(_this.transformResult(result));
	            })
	                .catch(function (err) {
	                _this.store.dispatch({
	                    type: 'APOLLO_MUTATION_ERROR',
	                    error: err,
	                    mutationId: mutationId,
	                });
	                delete _this.queryDocuments[mutationId];
	                reject(new ApolloError_1.ApolloError({
	                    networkError: err,
	                }));
	            });
	        });
	    };
	    QueryManager.prototype.queryListenerForObserver = function (queryId, options, observer) {
	        var _this = this;
	        var lastResult;
	        return function (queryStoreValue) {
	            if (!queryStoreValue) {
	                return;
	            }
	            var noFetch = _this.observableQueries[queryId] ? _this.observableQueries[queryId].observableQuery.options.noFetch : options.noFetch;
	            var shouldNotifyIfLoading = queryStoreValue.returnPartialData
	                || queryStoreValue.previousVariables || noFetch;
	            var networkStatusChanged = lastResult && queryStoreValue.networkStatus !== lastResult.networkStatus;
	            if (!queryStoreValue.loading ||
	                (networkStatusChanged && options.notifyOnNetworkStatusChange) ||
	                shouldNotifyIfLoading) {
	                if (queryStoreValue.graphQLErrors || queryStoreValue.networkError) {
	                    var apolloError = new ApolloError_1.ApolloError({
	                        graphQLErrors: queryStoreValue.graphQLErrors,
	                        networkError: queryStoreValue.networkError,
	                    });
	                    if (observer.error) {
	                        try {
	                            observer.error(apolloError);
	                        }
	                        catch (e) {
	                            console.error("Error in observer.error \n" + e.stack);
	                        }
	                    }
	                    else {
	                        console.error('Unhandled error', apolloError, apolloError.stack);
	                        if (false) {
	                            console.info('An unhandled error was thrown because no error handler is registered ' +
	                                'for the query ' + options.query.loc.source);
	                        }
	                    }
	                }
	                else {
	                    try {
	                        var resultFromStore = {
	                            data: readFromStore_1.readQueryFromStore({
	                                store: _this.getDataWithOptimisticResults(),
	                                query: _this.queryDocuments[queryId],
	                                variables: queryStoreValue.previousVariables || queryStoreValue.variables,
	                                returnPartialData: options.returnPartialData || noFetch,
	                                config: _this.reducerConfig,
	                            }),
	                            loading: queryStoreValue.loading,
	                            networkStatus: queryStoreValue.networkStatus,
	                        };
	                        if (observer.next) {
	                            if (_this.isDifferentResult(lastResult, resultFromStore)) {
	                                lastResult = resultFromStore;
	                                try {
	                                    observer.next(_this.transformResult(resultFromStore));
	                                }
	                                catch (e) {
	                                    console.error("Error in observer.next \n" + e.stack);
	                                }
	                            }
	                        }
	                    }
	                    catch (error) {
	                        if (observer.error) {
	                            observer.error(new ApolloError_1.ApolloError({
	                                networkError: error,
	                            }));
	                        }
	                        return;
	                    }
	                }
	            }
	        };
	    };
	    QueryManager.prototype.watchQuery = function (options, shouldSubscribe) {
	        if (shouldSubscribe === void 0) { shouldSubscribe = true; }
	        getFromAST_1.getQueryDefinition(options.query);
	        var transformedOptions = __assign({}, options);
	        if (this.addTypename) {
	            transformedOptions.query = queryTransform_1.addTypenameToDocument(transformedOptions.query);
	        }
	        var observableQuery = new ObservableQuery_1.ObservableQuery({
	            scheduler: this.scheduler,
	            options: transformedOptions,
	            shouldSubscribe: shouldSubscribe,
	        });
	        return observableQuery;
	    };
	    QueryManager.prototype.query = function (options) {
	        var _this = this;
	        if (options.returnPartialData) {
	            throw new Error('returnPartialData option only supported on watchQuery.');
	        }
	        if (options.query.kind !== 'Document') {
	            throw new Error('You must wrap the query string in a "gql" tag.');
	        }
	        var requestId = this.idCounter;
	        var resPromise = new Promise(function (resolve, reject) {
	            _this.addFetchQueryPromise(requestId, resPromise, resolve, reject);
	            return _this.watchQuery(options, false).result().then(function (result) {
	                _this.removeFetchQueryPromise(requestId);
	                resolve(result);
	            }).catch(function (error) {
	                _this.removeFetchQueryPromise(requestId);
	                reject(error);
	            });
	        });
	        return resPromise;
	    };
	    QueryManager.prototype.fetchQuery = function (queryId, options, fetchType) {
	        var _a = options.variables, variables = _a === void 0 ? {} : _a, _b = options.forceFetch, forceFetch = _b === void 0 ? false : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.noFetch, noFetch = _d === void 0 ? false : _d, _e = options.metadata, metadata = _e === void 0 ? null : _e;
	        var queryDoc = this.transformQueryDocument(options).queryDoc;
	        var queryString = printer_1.print(queryDoc);
	        var storeResult;
	        var needToFetch = forceFetch;
	        if (!forceFetch) {
	            var _f = readFromStore_2.diffQueryAgainstStore({
	                query: queryDoc,
	                store: this.reduxRootSelector(this.store.getState()).data,
	                returnPartialData: true,
	                variables: variables,
	                config: this.reducerConfig,
	            }), isMissing = _f.isMissing, result = _f.result;
	            needToFetch = isMissing;
	            storeResult = result;
	        }
	        var requestId = this.generateRequestId();
	        var shouldFetch = needToFetch && !noFetch;
	        this.queryDocuments[queryId] = queryDoc;
	        this.store.dispatch({
	            type: 'APOLLO_QUERY_INIT',
	            queryString: queryString,
	            document: queryDoc,
	            variables: variables,
	            forceFetch: forceFetch,
	            returnPartialData: returnPartialData || noFetch,
	            queryId: queryId,
	            requestId: requestId,
	            storePreviousVariables: shouldFetch,
	            isPoll: fetchType === FetchType.poll,
	            isRefetch: fetchType === FetchType.refetch,
	            metadata: metadata,
	        });
	        if (!shouldFetch || returnPartialData) {
	            this.store.dispatch({
	                type: 'APOLLO_QUERY_RESULT_CLIENT',
	                result: { data: storeResult },
	                variables: variables,
	                document: queryDoc,
	                complete: !shouldFetch,
	                queryId: queryId,
	                requestId: requestId,
	            });
	        }
	        if (shouldFetch) {
	            return this.fetchRequest({
	                requestId: requestId,
	                queryId: queryId,
	                document: queryDoc,
	                options: options,
	            });
	        }
	        return Promise.resolve({ data: storeResult });
	    };
	    QueryManager.prototype.generateQueryId = function () {
	        var queryId = this.idCounter.toString();
	        this.idCounter++;
	        return queryId;
	    };
	    QueryManager.prototype.stopQueryInStore = function (queryId) {
	        this.store.dispatch({
	            type: 'APOLLO_QUERY_STOP',
	            queryId: queryId,
	        });
	    };
	    ;
	    QueryManager.prototype.getApolloState = function () {
	        return this.reduxRootSelector(this.store.getState());
	    };
	    QueryManager.prototype.getInitialState = function () {
	        return { data: this.getApolloState().data };
	    };
	    QueryManager.prototype.getDataWithOptimisticResults = function () {
	        return store_1.getDataWithOptimisticResults(this.getApolloState());
	    };
	    QueryManager.prototype.addQueryListener = function (queryId, listener) {
	        this.queryListeners[queryId] = this.queryListeners[queryId] || [];
	        this.queryListeners[queryId].push(listener);
	    };
	    QueryManager.prototype.addFetchQueryPromise = function (requestId, promise, resolve, reject) {
	        this.fetchQueryPromises[requestId.toString()] = { promise: promise, resolve: resolve, reject: reject };
	    };
	    QueryManager.prototype.removeFetchQueryPromise = function (requestId) {
	        delete this.fetchQueryPromises[requestId.toString()];
	    };
	    QueryManager.prototype.addObservableQuery = function (queryId, observableQuery) {
	        this.observableQueries[queryId] = { observableQuery: observableQuery };
	        var queryDef = getFromAST_1.getQueryDefinition(observableQuery.options.query);
	        if (queryDef.name && queryDef.name.value) {
	            var queryName = queryDef.name.value;
	            this.queryIdsByName[queryName] = this.queryIdsByName[queryName] || [];
	            this.queryIdsByName[queryName].push(observableQuery.queryId);
	        }
	    };
	    QueryManager.prototype.removeObservableQuery = function (queryId) {
	        var observableQuery = this.observableQueries[queryId].observableQuery;
	        var definition = getFromAST_1.getQueryDefinition(observableQuery.options.query);
	        var queryName = definition.name ? definition.name.value : null;
	        delete this.observableQueries[queryId];
	        if (queryName) {
	            this.queryIdsByName[queryName] = this.queryIdsByName[queryName].filter(function (val) {
	                return !(observableQuery.queryId === val);
	            });
	        }
	    };
	    QueryManager.prototype.resetStore = function () {
	        var _this = this;
	        Object.keys(this.fetchQueryPromises).forEach(function (key) {
	            var reject = _this.fetchQueryPromises[key].reject;
	            reject(new Error('Store reset while query was in flight.'));
	        });
	        this.store.dispatch({
	            type: 'APOLLO_STORE_RESET',
	            observableQueryIds: Object.keys(this.observableQueries),
	        });
	        Object.keys(this.observableQueries).forEach(function (queryId) {
	            var storeQuery = _this.reduxRootSelector(_this.store.getState()).queries[queryId];
	            if (!_this.observableQueries[queryId].observableQuery.options.noFetch) {
	                _this.observableQueries[queryId].observableQuery.refetch();
	            }
	        });
	    };
	    QueryManager.prototype.startQuery = function (queryId, options, listener) {
	        this.addQueryListener(queryId, listener);
	        this.fetchQuery(queryId, options)
	            .catch(function (error) { return undefined; });
	        return queryId;
	    };
	    QueryManager.prototype.startGraphQLSubscription = function (options) {
	        var _this = this;
	        var document = options.document, variables = options.variables;
	        var transformedDoc = document;
	        if (this.addTypename) {
	            transformedDoc = queryTransform_1.addTypenameToDocument(transformedDoc);
	        }
	        var request = {
	            query: transformedDoc,
	            variables: variables,
	            operationName: getFromAST_1.getOperationName(transformedDoc),
	        };
	        var subId;
	        var observers = [];
	        return new Observable_1.Observable(function (observer) {
	            observers.push(observer);
	            if (observers.length === 1) {
	                var handler = function (error, result) {
	                    if (error) {
	                        observers.forEach(function (obs) {
	                            obs.error(error);
	                        });
	                    }
	                    else {
	                        _this.store.dispatch({
	                            type: 'APOLLO_SUBSCRIPTION_RESULT',
	                            document: transformedDoc,
	                            operationName: getFromAST_1.getOperationName(transformedDoc),
	                            result: { data: result },
	                            variables: variables,
	                            subscriptionId: subId,
	                            extraReducers: _this.getExtraReducers(),
	                        });
	                        observers.forEach(function (obs) {
	                            obs.next(result);
	                        });
	                    }
	                };
	                subId = _this.networkInterface.subscribe(request, handler);
	            }
	            return {
	                unsubscribe: function () {
	                    observers = observers.filter(function (obs) { return obs !== observer; });
	                    if (observers.length === 0) {
	                        _this.networkInterface.unsubscribe(subId);
	                    }
	                },
	                _networkSubscriptionId: subId,
	            };
	        });
	    };
	    ;
	    QueryManager.prototype.stopQuery = function (queryId) {
	        delete this.queryListeners[queryId];
	        delete this.queryDocuments[queryId];
	        this.stopQueryInStore(queryId);
	    };
	    QueryManager.prototype.getCurrentQueryResult = function (observableQuery, isOptimistic) {
	        if (isOptimistic === void 0) { isOptimistic = false; }
	        var _a = this.getQueryParts(observableQuery), variables = _a.variables, document = _a.document;
	        var queryOptions = observableQuery.options;
	        var readOptions = {
	            store: isOptimistic ? this.getDataWithOptimisticResults() : this.getApolloState().data,
	            query: document,
	            variables: variables,
	            returnPartialData: false,
	            config: this.reducerConfig,
	        };
	        try {
	            var data = readFromStore_1.readQueryFromStore(readOptions);
	            return { data: data, partial: false };
	        }
	        catch (e) {
	            if (queryOptions.returnPartialData || queryOptions.noFetch) {
	                try {
	                    readOptions.returnPartialData = true;
	                    var data = readFromStore_1.readQueryFromStore(readOptions);
	                    return { data: data, partial: true };
	                }
	                catch (e) {
	                }
	            }
	            return { data: {}, partial: true };
	        }
	    };
	    QueryManager.prototype.getQueryWithPreviousResult = function (queryIdOrObservable, isOptimistic) {
	        if (isOptimistic === void 0) { isOptimistic = false; }
	        var observableQuery;
	        if (typeof queryIdOrObservable === 'string') {
	            if (!this.observableQueries[queryIdOrObservable]) {
	                throw new Error("ObservableQuery with this id doesn't exist: " + queryIdOrObservable);
	            }
	            observableQuery = this.observableQueries[queryIdOrObservable].observableQuery;
	        }
	        else {
	            observableQuery = queryIdOrObservable;
	        }
	        var _a = this.getQueryParts(observableQuery), variables = _a.variables, document = _a.document;
	        var data = this.getCurrentQueryResult(observableQuery, isOptimistic).data;
	        return {
	            previousResult: data,
	            variables: variables,
	            document: document,
	        };
	    };
	    QueryManager.prototype.transformResult = function (result) {
	        if (!this.resultTransformer) {
	            return result;
	        }
	        else {
	            return this.resultTransformer(result);
	        }
	    };
	    QueryManager.prototype.getQueryParts = function (observableQuery) {
	        var queryOptions = observableQuery.options;
	        var transformedDoc = observableQuery.options.query;
	        if (this.addTypename) {
	            transformedDoc = queryTransform_1.addTypenameToDocument(transformedDoc);
	        }
	        return {
	            variables: queryOptions.variables,
	            document: transformedDoc,
	        };
	    };
	    QueryManager.prototype.collectResultBehaviorsFromUpdateQueries = function (updateQueries, mutationResult, isOptimistic) {
	        var _this = this;
	        if (isOptimistic === void 0) { isOptimistic = false; }
	        if (!updateQueries) {
	            return [];
	        }
	        var resultBehaviors = [];
	        Object.keys(updateQueries).forEach(function (queryName) {
	            var reducer = updateQueries[queryName];
	            var queryIds = _this.queryIdsByName[queryName];
	            if (!queryIds) {
	                return;
	            }
	            queryIds.forEach(function (queryId) {
	                var _a = _this.getQueryWithPreviousResult(queryId, isOptimistic), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
	                var newResult = errorHandling_1.tryFunctionOrLogError(function () { return reducer(previousResult, {
	                    mutationResult: mutationResult,
	                    queryName: queryName,
	                    queryVariables: variables,
	                }); });
	                if (newResult) {
	                    resultBehaviors.push({
	                        type: 'QUERY_RESULT',
	                        newResult: newResult,
	                        variables: variables,
	                        document: document,
	                    });
	                }
	            });
	        });
	        return resultBehaviors;
	    };
	    QueryManager.prototype.transformQueryDocument = function (options) {
	        var queryDoc = options.query;
	        if (this.addTypename) {
	            queryDoc = queryTransform_1.addTypenameToDocument(queryDoc);
	        }
	        return {
	            queryDoc: queryDoc,
	        };
	    };
	    QueryManager.prototype.getExtraReducers = function () {
	        var _this = this;
	        return Object.keys(this.observableQueries).map(function (obsQueryId) {
	            var queryOptions = _this.observableQueries[obsQueryId].observableQuery.options;
	            if (queryOptions.reducer) {
	                return resultReducers_1.createStoreReducer(queryOptions.reducer, queryOptions.query, queryOptions.variables, _this.reducerConfig);
	            }
	            return null;
	        }).filter(function (reducer) { return reducer !== null; });
	    };
	    QueryManager.prototype.fetchRequest = function (_a) {
	        var _this = this;
	        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options;
	        var variables = options.variables, noFetch = options.noFetch, returnPartialData = options.returnPartialData;
	        var request = {
	            query: document,
	            variables: variables,
	            operationName: getFromAST_1.getOperationName(document),
	        };
	        var retPromise = new Promise(function (resolve, reject) {
	            _this.addFetchQueryPromise(requestId, retPromise, resolve, reject);
	            _this.deduplicator.query(request, _this.queryDeduplication)
	                .then(function (result) {
	                var extraReducers = _this.getExtraReducers();
	                _this.store.dispatch({
	                    type: 'APOLLO_QUERY_RESULT',
	                    document: document,
	                    operationName: getFromAST_1.getOperationName(document),
	                    result: result,
	                    queryId: queryId,
	                    requestId: requestId,
	                    extraReducers: extraReducers,
	                });
	                _this.removeFetchQueryPromise(requestId);
	                if (result.errors) {
	                    throw new ApolloError_1.ApolloError({
	                        graphQLErrors: result.errors,
	                    });
	                }
	                return result;
	            }).then(function () {
	                var resultFromStore;
	                try {
	                    resultFromStore = readFromStore_1.readQueryFromStore({
	                        store: _this.getApolloState().data,
	                        variables: variables,
	                        returnPartialData: returnPartialData || noFetch,
	                        query: document,
	                        config: _this.reducerConfig,
	                    });
	                }
	                catch (e) { }
	                var reducerError = _this.getApolloState().reducerError;
	                if (!resultFromStore && reducerError) {
	                    return Promise.reject(reducerError);
	                }
	                _this.removeFetchQueryPromise(requestId);
	                resolve({ data: resultFromStore, loading: false, networkStatus: store_2.NetworkStatus.ready });
	                return null;
	            }).catch(function (error) {
	                if (ApolloError_1.isApolloError(error)) {
	                    reject(error);
	                }
	                else {
	                    _this.store.dispatch({
	                        type: 'APOLLO_QUERY_ERROR',
	                        error: error,
	                        queryId: queryId,
	                        requestId: requestId,
	                    });
	                    _this.removeFetchQueryPromise(requestId);
	                    reject(new ApolloError_1.ApolloError({
	                        networkError: error,
	                    }));
	                }
	            });
	        });
	        return retPromise;
	    };
	    QueryManager.prototype.refetchQueryByName = function (queryName) {
	        var _this = this;
	        var refetchedQueries = this.queryIdsByName[queryName];
	        if (refetchedQueries === undefined) {
	            console.warn("Warning: unknown query with name " + queryName + " asked to refetch");
	        }
	        else {
	            refetchedQueries.forEach(function (queryId) {
	                _this.observableQueries[queryId].observableQuery.refetch();
	            });
	        }
	    };
	    QueryManager.prototype.isDifferentResult = function (lastResult, newResult) {
	        var comparator = this.resultComparator || isEqual;
	        return !comparator(lastResult, newResult);
	    };
	    QueryManager.prototype.broadcastQueries = function () {
	        var queries = this.getApolloState().queries;
	        forOwn(this.queryListeners, function (listeners, queryId) {
	            if (listeners) {
	                listeners.forEach(function (listener) {
	                    if (listener) {
	                        var queryStoreValue = queries[queryId];
	                        listener(queryStoreValue);
	                    }
	                });
	            }
	        });
	    };
	    QueryManager.prototype.generateRequestId = function () {
	        var requestId = this.idCounter;
	        this.idCounter++;
	        return requestId;
	    };
	    return QueryManager;
	}());
	exports.QueryManager = QueryManager;
	//# sourceMappingURL=QueryManager.js.map

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var printer_1 = __webpack_require__(744);
	var Deduplicator = (function () {
	    function Deduplicator(networkInterface) {
	        this.networkInterface = networkInterface;
	        this.inFlightRequestPromises = {};
	    }
	    Deduplicator.prototype.query = function (request, deduplicate) {
	        var _this = this;
	        if (deduplicate === void 0) { deduplicate = true; }
	        if (!deduplicate) {
	            return this.networkInterface.query(request);
	        }
	        var key = this.getKey(request);
	        if (!this.inFlightRequestPromises[key]) {
	            this.inFlightRequestPromises[key] = this.networkInterface.query(request);
	        }
	        return this.inFlightRequestPromises[key]
	            .then(function (res) {
	            delete _this.inFlightRequestPromises[key];
	            return res;
	        });
	    };
	    Deduplicator.prototype.getKey = function (request) {
	        return printer_1.print(request.query) + "|" + JSON.stringify(request.variables) + "|" + request.operationName;
	    };
	    return Deduplicator;
	}());
	exports.Deduplicator = Deduplicator;
	//# sourceMappingURL=Deduplicator.js.map

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(662),
	    castFunction = __webpack_require__(822);
	
	/**
	 * Iterates over own enumerable string keyed properties of an object and
	 * invokes `iteratee` for each property. The iteratee is invoked with three
	 * arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwnRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, castFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(636);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var getFromAST_1 = __webpack_require__(754);
	var cloneDeep = __webpack_require__(774);
	var TYPENAME_FIELD = {
	    kind: 'Field',
	    alias: null,
	    name: {
	        kind: 'Name',
	        value: '__typename',
	    },
	};
	function addTypenameToSelectionSet(selectionSet, isRoot) {
	    if (isRoot === void 0) { isRoot = false; }
	    if (selectionSet && selectionSet.selections) {
	        if (!isRoot) {
	            var alreadyHasThisField = selectionSet.selections.some(function (selection) {
	                return selection.kind === 'Field' && selection.name.value === '__typename';
	            });
	            if (!alreadyHasThisField) {
	                selectionSet.selections.push(TYPENAME_FIELD);
	            }
	        }
	        selectionSet.selections.forEach(function (selection) {
	            if (selection.kind === 'Field' || selection.kind === 'InlineFragment') {
	                addTypenameToSelectionSet(selection.selectionSet);
	            }
	        });
	    }
	}
	function addTypenameToDocument(doc) {
	    getFromAST_1.checkDocument(doc);
	    var docClone = cloneDeep(doc);
	    docClone.definitions.forEach(function (definition) {
	        var isRoot = definition.kind === 'OperationDefinition';
	        addTypenameToSelectionSet(definition.selectionSet, isRoot);
	    });
	    return docClone;
	}
	exports.addTypenameToDocument = addTypenameToDocument;
	//# sourceMappingURL=queryTransform.js.map

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var readFromStore_1 = __webpack_require__(825);
	var writeToStore_1 = __webpack_require__(751);
	function createStoreReducer(resultReducer, document, variables, config) {
	    return function (store, action) {
	        var currentResult = readFromStore_1.readQueryFromStore({
	            store: store,
	            query: document,
	            variables: variables,
	            returnPartialData: true,
	            config: config,
	        });
	        var nextResult = resultReducer(currentResult, action, variables);
	        if (currentResult !== nextResult) {
	            return writeToStore_1.writeResultToStore({
	                dataId: 'ROOT_QUERY',
	                result: nextResult,
	                store: store,
	                document: document,
	                variables: variables,
	                dataIdFromObject: config.dataIdFromObject,
	            });
	        }
	        return store;
	    };
	}
	exports.createStoreReducer = createStoreReducer;
	//# sourceMappingURL=resultReducers.js.map

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var graphql_anywhere_1 = __webpack_require__(826);
	var storeUtils_1 = __webpack_require__(771);
	var storeUtils_2 = __webpack_require__(771);
	var getFromAST_1 = __webpack_require__(754);
	function readQueryFromStore(_a) {
	    var store = _a.store, query = _a.query, variables = _a.variables, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? false : _b, config = _a.config;
	    var result = diffQueryAgainstStore({
	        query: query,
	        store: store,
	        returnPartialData: returnPartialData,
	        variables: variables,
	        config: config,
	    }).result;
	    return result;
	}
	exports.readQueryFromStore = readQueryFromStore;
	var haveWarned = false;
	var fragmentMatcher = function (idValue, typeCondition, context) {
	    assertIdValue(idValue);
	    var obj = context.store[idValue.id];
	    if (!obj) {
	        return false;
	    }
	    if (!obj.__typename) {
	        if (!haveWarned) {
	            console.warn("You're using fragments in your queries, but don't have the addTypename:\ntrue option set in Apollo Client. Please turn on that option so that we can accurately\nmatch fragments.");
	            if (true) {
	                haveWarned = true;
	            }
	        }
	        context.returnPartialData = true;
	        return true;
	    }
	    if (obj.__typename === typeCondition) {
	        return true;
	    }
	    context.returnPartialData = true;
	    return true;
	};
	var readStoreResolver = function (fieldName, idValue, args, context) {
	    assertIdValue(idValue);
	    var objId = idValue.id;
	    var obj = context.store[objId];
	    var storeKeyName = storeUtils_2.storeKeyNameFromFieldNameAndArgs(fieldName, args);
	    var fieldValue = (obj || {})[storeKeyName];
	    if (typeof fieldValue === 'undefined') {
	        if (context.customResolvers && obj && (obj.__typename || objId === 'ROOT_QUERY')) {
	            var typename = obj.__typename || 'Query';
	            var type = context.customResolvers[typename];
	            if (type) {
	                var resolver = type[fieldName];
	                if (resolver) {
	                    return resolver(obj, args);
	                }
	            }
	        }
	        if (!context.returnPartialData) {
	            throw new Error("Can't find field " + storeKeyName + " on object (" + objId + ") " + JSON.stringify(obj, null, 2) + ".\nPerhaps you want to use the `returnPartialData` option?");
	        }
	        context.hasMissingField = true;
	        return fieldValue;
	    }
	    if (storeUtils_1.isJsonValue(fieldValue)) {
	        return fieldValue.json;
	    }
	    return fieldValue;
	};
	function diffQueryAgainstStore(_a) {
	    var store = _a.store, query = _a.query, variables = _a.variables, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, config = _a.config;
	    getFromAST_1.getQueryDefinition(query);
	    var context = {
	        store: store,
	        returnPartialData: returnPartialData,
	        customResolvers: config && config.customResolvers,
	        hasMissingField: false,
	    };
	    var rootIdValue = {
	        type: 'id',
	        id: 'ROOT_QUERY',
	    };
	    var result = graphql_anywhere_1.default(readStoreResolver, query, rootIdValue, context, variables, {
	        fragmentMatcher: fragmentMatcher,
	    });
	    return {
	        result: result,
	        isMissing: context.hasMissingField,
	    };
	}
	exports.diffQueryAgainstStore = diffQueryAgainstStore;
	function assertIdValue(idValue) {
	    if (!storeUtils_1.isIdValue(idValue)) {
	        throw new Error("Encountered a sub-selection on the query, but the store doesn't have an object reference. This should never happen during normal use unless you have custom code that is directly manipulating the store; please file an issue.");
	    }
	}
	//# sourceMappingURL=readFromStore.js.map

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var getFromAST_1 = __webpack_require__(827);
	var directives_1 = __webpack_require__(828);
	var storeUtils_1 = __webpack_require__(829);
	var utilities_1 = __webpack_require__(830);
	exports.filter = utilities_1.filter;
	exports.check = utilities_1.check;
	exports.propType = utilities_1.propType;
	function graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
	    if (execOptions === void 0) { execOptions = {}; }
	    var mainDefinition = getFromAST_1.getMainDefinition(document);
	    var fragments = getFromAST_1.getFragmentDefinitions(document);
	    var fragmentMap = getFromAST_1.createFragmentMap(fragments) || {};
	    var resultMapper = execOptions.resultMapper;
	    var fragmentMatcher = execOptions.fragmentMatcher || (function () { return true; });
	    var execContext = {
	        fragmentMap: fragmentMap,
	        contextValue: contextValue,
	        variableValues: variableValues,
	        resultMapper: resultMapper,
	        resolver: resolver,
	        fragmentMatcher: fragmentMatcher,
	    };
	    return executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = graphql;
	function executeSelectionSet(selectionSet, rootValue, execContext) {
	    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
	    var result = {};
	    selectionSet.selections.forEach(function (selection) {
	        if (!directives_1.shouldInclude(selection, variables)) {
	            return;
	        }
	        if (storeUtils_1.isField(selection)) {
	            var fieldResult = executeField(selection, rootValue, execContext);
	            var resultFieldKey = storeUtils_1.resultKeyNameFromField(selection);
	            if (fieldResult !== undefined) {
	                result[resultFieldKey] = fieldResult;
	            }
	        }
	        else {
	            var fragment = void 0;
	            if (storeUtils_1.isInlineFragment(selection)) {
	                fragment = selection;
	            }
	            else {
	                fragment = fragmentMap[selection.name.value];
	                if (!fragment) {
	                    throw new Error("No fragment named " + selection.name.value);
	                }
	            }
	            var typeCondition = fragment.typeCondition.name.value;
	            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
	                var fragmentResult = executeSelectionSet(fragment.selectionSet, rootValue, execContext);
	                merge(result, fragmentResult);
	            }
	        }
	    });
	    if (execContext.resultMapper) {
	        return execContext.resultMapper(result, rootValue);
	    }
	    return result;
	}
	function executeField(field, rootValue, execContext) {
	    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
	    var fieldName = field.name.value;
	    var args = storeUtils_1.argumentsObjectFromField(field, variables);
	    var info = {
	        isLeaf: !field.selectionSet,
	        resultKey: storeUtils_1.resultKeyNameFromField(field),
	    };
	    var result = resolver(fieldName, rootValue, args, contextValue, info);
	    if (!field.selectionSet) {
	        return result;
	    }
	    if (result === null || typeof result === 'undefined') {
	        return result;
	    }
	    if (Array.isArray(result)) {
	        return executeSubSelectedArray(field, result, execContext);
	    }
	    return executeSelectionSet(field.selectionSet, result, execContext);
	}
	function executeSubSelectedArray(field, result, execContext) {
	    return result.map(function (item) {
	        if (item === null) {
	            return null;
	        }
	        if (Array.isArray(item)) {
	            return executeSubSelectedArray(field, item, execContext);
	        }
	        return executeSelectionSet(field.selectionSet, item, execContext);
	    });
	}
	function merge(dest, src) {
	    if (src === null ||
	        typeof src === 'undefined' ||
	        typeof src === 'string' ||
	        typeof src === 'number' ||
	        typeof src === 'boolean' ||
	        Array.isArray(src)) {
	        return src;
	    }
	    Object.keys(dest).forEach(function (destKey) {
	        if (src.hasOwnProperty(destKey)) {
	            merge(dest[destKey], src[destKey]);
	        }
	    });
	    Object.keys(src).forEach(function (srcKey) {
	        if (!dest.hasOwnProperty(srcKey)) {
	            dest[srcKey] = src[srcKey];
	        }
	    });
	}
	//# sourceMappingURL=index.js.map

/***/ },
/* 827 */
/***/ function(module, exports) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	function getMutationDefinition(doc) {
	    checkDocument(doc);
	    var mutationDef = null;
	    doc.definitions.forEach(function (definition) {
	        if (definition.kind === 'OperationDefinition'
	            && definition.operation === 'mutation') {
	            mutationDef = definition;
	        }
	    });
	    if (!mutationDef) {
	        throw new Error('Must contain a mutation definition.');
	    }
	    return mutationDef;
	}
	exports.getMutationDefinition = getMutationDefinition;
	function checkDocument(doc) {
	    if (doc.kind !== 'Document') {
	        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
	    }
	    var numOpDefinitions = doc.definitions.filter(function (definition) {
	        return definition.kind === 'OperationDefinition';
	    }).length;
	    if (numOpDefinitions > 1) {
	        throw new Error('Queries must have exactly one operation definition.');
	    }
	}
	exports.checkDocument = checkDocument;
	function getOperationName(doc) {
	    var res = '';
	    doc.definitions.forEach(function (definition) {
	        if (definition.kind === 'OperationDefinition'
	            && definition.name) {
	            res = definition.name.value;
	        }
	    });
	    return res;
	}
	exports.getOperationName = getOperationName;
	function getFragmentDefinitions(doc) {
	    var fragmentDefinitions = doc.definitions.filter(function (definition) {
	        if (definition.kind === 'FragmentDefinition') {
	            return true;
	        }
	        else {
	            return false;
	        }
	    });
	    return fragmentDefinitions;
	}
	exports.getFragmentDefinitions = getFragmentDefinitions;
	function getQueryDefinition(doc) {
	    checkDocument(doc);
	    var queryDef = null;
	    doc.definitions.map(function (definition) {
	        if (definition.kind === 'OperationDefinition'
	            && definition.operation === 'query') {
	            queryDef = definition;
	        }
	    });
	    if (!queryDef) {
	        throw new Error('Must contain a query definition.');
	    }
	    return queryDef;
	}
	exports.getQueryDefinition = getQueryDefinition;
	function getFragmentDefinition(doc) {
	    if (doc.kind !== 'Document') {
	        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
	    }
	    if (doc.definitions.length > 1) {
	        throw new Error('Fragment must have exactly one definition.');
	    }
	    var fragmentDef = doc.definitions[0];
	    if (fragmentDef.kind !== 'FragmentDefinition') {
	        throw new Error('Must be a fragment definition.');
	    }
	    return fragmentDef;
	}
	exports.getFragmentDefinition = getFragmentDefinition;
	function createFragmentMap(fragments) {
	    if (fragments === void 0) { fragments = []; }
	    var symTable = {};
	    fragments.forEach(function (fragment) {
	        symTable[fragment.name.value] = fragment;
	    });
	    return symTable;
	}
	exports.createFragmentMap = createFragmentMap;
	function addFragmentsToDocument(queryDoc, fragments) {
	    checkDocument(queryDoc);
	    return __assign({}, queryDoc, { definitions: queryDoc.definitions.concat(fragments) });
	}
	exports.addFragmentsToDocument = addFragmentsToDocument;
	function getMainDefinition(queryDoc) {
	    checkDocument(queryDoc);
	    try {
	        return getQueryDefinition(queryDoc);
	    }
	    catch (e) {
	        try {
	            var fragments = getFragmentDefinitions(queryDoc);
	            return fragments[0];
	        }
	        catch (e) {
	            throw new Error("Expected a parsed GraphQL query with a query or a fragment.");
	        }
	    }
	}
	exports.getMainDefinition = getMainDefinition;
	//# sourceMappingURL=getFromAST.js.map

/***/ },
/* 828 */
772,
/* 829 */
/***/ function(module, exports) {

	"use strict";
	function isScalarValue(value) {
	    var SCALAR_TYPES = {
	        StringValue: 1,
	        BooleanValue: 1,
	        EnumValue: 1,
	    };
	    return !!SCALAR_TYPES[value.kind];
	}
	function isNumberValue(value) {
	    var NUMBER_TYPES = {
	        IntValue: 1,
	        FloatValue: 1,
	    };
	    return NUMBER_TYPES[value.kind];
	}
	function isVariable(value) {
	    return value.kind === 'Variable';
	}
	function isObject(value) {
	    return value.kind === 'ObjectValue';
	}
	function isList(value) {
	    return value.kind === 'ListValue';
	}
	function valueToObjectRepresentation(argObj, name, value, variables) {
	    if (isNumberValue(value)) {
	        argObj[name.value] = Number(value.value);
	    }
	    else if (isScalarValue(value)) {
	        argObj[name.value] = value.value;
	    }
	    else if (isObject(value)) {
	        var nestedArgObj_1 = {};
	        value.fields.map(function (obj) { return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables); });
	        argObj[name.value] = nestedArgObj_1;
	    }
	    else if (isVariable(value)) {
	        if (!variables || !(value.name.value in variables)) {
	            throw new Error("The inline argument \"" + value.name.value + "\" is expected as a variable but was not provided.");
	        }
	        var variableValue = variables[value.name.value];
	        argObj[name.value] = variableValue;
	    }
	    else if (isList(value)) {
	        argObj[name.value] = value.values.map(function (listValue) {
	            var nestedArgArrayObj = {};
	            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
	            return nestedArgArrayObj[name.value];
	        });
	    }
	    else {
	        throw new Error("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\" is not supported. Use variables instead of inline arguments to overcome this limitation.");
	    }
	}
	function argumentsObjectFromField(field, variables) {
	    if (field.arguments && field.arguments.length) {
	        var argObj_1 = {};
	        field.arguments.forEach(function (_a) {
	            var name = _a.name, value = _a.value;
	            return valueToObjectRepresentation(argObj_1, name, value, variables);
	        });
	        return argObj_1;
	    }
	    return null;
	}
	exports.argumentsObjectFromField = argumentsObjectFromField;
	function resultKeyNameFromField(field) {
	    return field.alias ?
	        field.alias.value :
	        field.name.value;
	}
	exports.resultKeyNameFromField = resultKeyNameFromField;
	function isField(selection) {
	    return selection.kind === 'Field';
	}
	exports.isField = isField;
	function isInlineFragment(selection) {
	    return selection.kind === 'InlineFragment';
	}
	exports.isInlineFragment = isInlineFragment;
	function graphQLResultHasError(result) {
	    return result.errors && result.errors.length;
	}
	exports.graphQLResultHasError = graphQLResultHasError;
	//# sourceMappingURL=storeUtils.js.map

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var index_1 = __webpack_require__(826);
	function filter(doc, data) {
	    var resolver = function (fieldName, root, args, context, info) {
	        return root[info.resultKey];
	    };
	    return index_1.default(resolver, doc, data);
	}
	exports.filter = filter;
	function check(doc, data) {
	    var resolver = function (fieldName, root, args, context, info) {
	        if (!{}.hasOwnProperty.call(root, info.resultKey)) {
	            throw new Error(info.resultKey + " missing on " + root);
	        }
	        return root[info.resultKey];
	    };
	    index_1.default(resolver, doc, data, {}, {}, {
	        fragmentMatcher: function () { return false; },
	    });
	}
	exports.check = check;
	var ANONYMOUS = '<<anonymous>>';
	function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	}
	PropTypeError.prototype = Error.prototype;
	var reactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context',
	};
	function createChainableTypeChecker(validate) {
	    function checkType(isRequired, props, propName, componentName, location, propFullName) {
	        componentName = componentName || ANONYMOUS;
	        propFullName = propFullName || propName;
	        if (props[propName] == null) {
	            var locationName = reactPropTypeLocationNames[location];
	            if (isRequired) {
	                if (props[propName] === null) {
	                    return new PropTypeError("The " + locationName + " `" + propFullName + "` is marked as required " +
	                        ("in `" + componentName + "`, but its value is `null`."));
	                }
	                return new PropTypeError("The " + locationName + " `" + propFullName + "` is marked as required in " +
	                    ("`" + componentName + "`, but its value is `undefined`."));
	            }
	            return null;
	        }
	        else {
	            return validate(props, propName, componentName, location, propFullName);
	        }
	    }
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	    return chainedCheckType;
	}
	function propType(doc) {
	    return createChainableTypeChecker(function (props, propName) {
	        var prop = props[propName];
	        try {
	            check(doc, prop);
	            return null;
	        }
	        catch (e) {
	            return e;
	        }
	    });
	}
	exports.propType = propType;
	//# sourceMappingURL=utilities.js.map

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var QueryManager_1 = __webpack_require__(819);
	var ObservableQuery_1 = __webpack_require__(816);
	var store_1 = __webpack_require__(804);
	var QueryScheduler = (function () {
	    function QueryScheduler(_a) {
	        var queryManager = _a.queryManager;
	        this.queryManager = queryManager;
	        this.pollingTimers = {};
	        this.inFlightQueries = {};
	        this.registeredQueries = {};
	        this.intervalQueries = {};
	    }
	    QueryScheduler.prototype.checkInFlight = function (queryId) {
	        var queries = this.queryManager.getApolloState().queries;
	        return queries[queryId] && queries[queryId].networkStatus !== store_1.NetworkStatus.ready;
	    };
	    QueryScheduler.prototype.fetchQuery = function (queryId, options, fetchType) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            _this.queryManager.fetchQuery(queryId, options, fetchType).then(function (result) {
	                resolve(result);
	            }).catch(function (error) {
	                reject(error);
	            });
	        });
	    };
	    QueryScheduler.prototype.startPollingQuery = function (options, queryId, listener) {
	        if (!options.pollInterval) {
	            throw new Error('Attempted to start a polling query without a polling interval.');
	        }
	        this.registeredQueries[queryId] = options;
	        if (listener) {
	            this.queryManager.addQueryListener(queryId, listener);
	        }
	        this.addQueryOnInterval(queryId, options);
	        return queryId;
	    };
	    QueryScheduler.prototype.stopPollingQuery = function (queryId) {
	        delete this.registeredQueries[queryId];
	    };
	    QueryScheduler.prototype.fetchQueriesOnInterval = function (interval) {
	        var _this = this;
	        this.intervalQueries[interval] = this.intervalQueries[interval].filter(function (queryId) {
	            if (!_this.registeredQueries.hasOwnProperty(queryId)) {
	                return false;
	            }
	            if (_this.checkInFlight(queryId)) {
	                return true;
	            }
	            var queryOptions = _this.registeredQueries[queryId];
	            var pollingOptions = __assign({}, queryOptions);
	            pollingOptions.forceFetch = true;
	            _this.fetchQuery(queryId, pollingOptions, QueryManager_1.FetchType.poll);
	            return true;
	        });
	        if (this.intervalQueries[interval].length === 0) {
	            clearInterval(this.pollingTimers[interval]);
	            delete this.intervalQueries[interval];
	        }
	    };
	    QueryScheduler.prototype.addQueryOnInterval = function (queryId, queryOptions) {
	        var _this = this;
	        var interval = queryOptions.pollInterval;
	        if (this.intervalQueries.hasOwnProperty(interval.toString()) && this.intervalQueries[interval].length > 0) {
	            this.intervalQueries[interval].push(queryId);
	        }
	        else {
	            this.intervalQueries[interval] = [queryId];
	            this.pollingTimers[interval] = setInterval(function () {
	                _this.fetchQueriesOnInterval(interval);
	            }, interval);
	        }
	    };
	    QueryScheduler.prototype.registerPollingQuery = function (queryOptions) {
	        if (!queryOptions.pollInterval) {
	            throw new Error('Attempted to register a non-polling query with the scheduler.');
	        }
	        return new ObservableQuery_1.ObservableQuery({
	            scheduler: this,
	            options: queryOptions,
	        });
	    };
	    return QueryScheduler;
	}());
	exports.QueryScheduler = QueryScheduler;
	//# sourceMappingURL=scheduler.js.map

/***/ },
/* 832 */
/***/ function(module, exports) {

	"use strict";
	function tryFunctionOrLogError(f) {
	    try {
	        return f();
	    }
	    catch (e) {
	        if (console.error) {
	            console.error(e);
	        }
	    }
	}
	exports.tryFunctionOrLogError = tryFunctionOrLogError;
	//# sourceMappingURL=errorHandling.js.map

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var networkInterface_1 = __webpack_require__(617);
	var isUndefined = __webpack_require__(753);
	var isString = __webpack_require__(618);
	var store_1 = __webpack_require__(748);
	var QueryManager_1 = __webpack_require__(819);
	var storeUtils_1 = __webpack_require__(771);
	var fragments_1 = __webpack_require__(834);
	var getFromAST_1 = __webpack_require__(754);
	var version_1 = __webpack_require__(835);
	var DEFAULT_REDUX_ROOT_KEY = 'apollo';
	function defaultReduxRootSelector(state) {
	    return state[DEFAULT_REDUX_ROOT_KEY];
	}
	var haveWarnedQuery = false;
	var haveWarnedWatchQuery = false;
	var haveWarnedMutation = false;
	var haveWarnedSubscription = false;
	var ApolloClient = (function () {
	    function ApolloClient(_a) {
	        var _b = _a === void 0 ? {} : _a, networkInterface = _b.networkInterface, reduxRootKey = _b.reduxRootKey, reduxRootSelector = _b.reduxRootSelector, initialState = _b.initialState, dataIdFromObject = _b.dataIdFromObject, resultComparator = _b.resultComparator, _c = _b.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _b.ssrForceFetchDelay, ssrForceFetchDelay = _d === void 0 ? 0 : _d, _e = _b.mutationBehaviorReducers, mutationBehaviorReducers = _e === void 0 ? {} : _e, _f = _b.addTypename, addTypename = _f === void 0 ? true : _f, resultTransformer = _b.resultTransformer, customResolvers = _b.customResolvers, connectToDevTools = _b.connectToDevTools, _g = _b.queryDeduplication, queryDeduplication = _g === void 0 ? false : _g;
	        var _this = this;
	        this.middleware = function () {
	            return function (store) {
	                _this.setStore(store);
	                return function (next) { return function (action) {
	                    var returnValue = next(action);
	                    _this.queryManager.broadcastNewStore(store.getState());
	                    if (_this.devToolsHookCb) {
	                        _this.devToolsHookCb({
	                            action: action,
	                            state: _this.queryManager.getApolloState(),
	                            dataWithOptimisticResults: _this.queryManager.getDataWithOptimisticResults(),
	                        });
	                    }
	                    return returnValue;
	                }; };
	            };
	        };
	        if (reduxRootKey && reduxRootSelector) {
	            throw new Error('Both "reduxRootKey" and "reduxRootSelector" are configured, but only one of two is allowed.');
	        }
	        if (reduxRootKey) {
	            console.warn('"reduxRootKey" option is deprecated and might be removed in the upcoming versions, ' +
	                'please use the "reduxRootSelector" instead.');
	            this.reduxRootKey = reduxRootKey;
	        }
	        if (!reduxRootSelector && reduxRootKey) {
	            this.reduxRootSelector = function (state) { return state[reduxRootKey]; };
	        }
	        else if (isString(reduxRootSelector)) {
	            this.reduxRootKey = reduxRootSelector;
	            this.reduxRootSelector = function (state) { return state[reduxRootSelector]; };
	        }
	        else if (typeof reduxRootSelector === 'function') {
	            this.reduxRootSelector = reduxRootSelector;
	        }
	        else {
	            this.reduxRootSelector = null;
	        }
	        this.initialState = initialState ? initialState : {};
	        this.networkInterface = networkInterface ? networkInterface :
	            networkInterface_1.createNetworkInterface({ uri: '/graphql' });
	        this.addTypename = addTypename;
	        this.resultTransformer = resultTransformer;
	        this.resultComparator = resultComparator;
	        this.shouldForceFetch = !(ssrMode || ssrForceFetchDelay > 0);
	        this.dataId = dataIdFromObject;
	        this.fieldWithArgs = storeUtils_1.storeKeyNameFromFieldNameAndArgs;
	        this.queryDeduplication = queryDeduplication;
	        if (ssrForceFetchDelay) {
	            setTimeout(function () { return _this.shouldForceFetch = true; }, ssrForceFetchDelay);
	        }
	        this.reducerConfig = {
	            dataIdFromObject: dataIdFromObject,
	            mutationBehaviorReducers: mutationBehaviorReducers,
	            customResolvers: customResolvers,
	        };
	        this.watchQuery = this.watchQuery.bind(this);
	        this.query = this.query.bind(this);
	        this.mutate = this.mutate.bind(this);
	        this.setStore = this.setStore.bind(this);
	        this.resetStore = this.resetStore.bind(this);
	        var defaultConnectToDevTools = typeof process === 'undefined' || (({"NODE_ENV":"production"}) && ("production") !== 'production') &&
	            typeof window !== 'undefined' && (!window.__APOLLO_CLIENT__);
	        if (typeof connectToDevTools === 'undefined') {
	            connectToDevTools = defaultConnectToDevTools;
	        }
	        if (connectToDevTools) {
	            window.__APOLLO_CLIENT__ = this;
	        }
	        this.version = version_1.version;
	    }
	    ApolloClient.prototype.watchQuery = function (options) {
	        this.initStore();
	        if (!this.shouldForceFetch && options.forceFetch) {
	            options = __assign({}, options, { forceFetch: false });
	        }
	        if (options.fragments && !haveWarnedWatchQuery && ("production") !== 'production') {
	            console.warn('"fragments" option is deprecated and will be removed in the upcoming versions, ' +
	                'please refer to the documentation for how to define fragments: ' +
	                'http://dev.apollodata.com/react/fragments.html.');
	            if (true) {
	                haveWarnedWatchQuery = true;
	            }
	        }
	        fragments_1.createFragment(options.query, undefined, true);
	        var fullDocument = getFromAST_1.addFragmentsToDocument(options.query, options.fragments);
	        var realOptions = __assign({}, options, { query: fullDocument });
	        delete realOptions.fragments;
	        return this.queryManager.watchQuery(realOptions);
	    };
	    ;
	    ApolloClient.prototype.query = function (options) {
	        this.initStore();
	        if (!this.shouldForceFetch && options.forceFetch) {
	            options = __assign({}, options, { forceFetch: false });
	        }
	        if (options.fragments && !haveWarnedQuery && ("production") !== 'production') {
	            console.warn('"fragments" option is deprecated and will be removed in the upcoming versions, ' +
	                'please refer to the documentation for how to define fragments: ' +
	                'http://dev.apollodata.com/react/fragments.html.');
	            if (true) {
	                haveWarnedQuery = true;
	            }
	        }
	        fragments_1.createFragment(options.query, undefined, true);
	        var fullDocument = getFromAST_1.addFragmentsToDocument(options.query, options.fragments);
	        var realOptions = __assign({}, options, { query: fullDocument });
	        delete realOptions.fragments;
	        return this.queryManager.query(realOptions);
	    };
	    ;
	    ApolloClient.prototype.mutate = function (options) {
	        this.initStore();
	        if (options.fragments && !haveWarnedMutation && ("production") !== 'production') {
	            console.warn('"fragments" option is deprecated and will be removed in the upcoming versions, ' +
	                'please refer to the documentation for how to define fragments: ' +
	                'http://dev.apollodata.com/react/fragments.html.');
	            if (true) {
	                haveWarnedMutation = true;
	            }
	        }
	        var fullDocument = getFromAST_1.addFragmentsToDocument(options.mutation, options.fragments);
	        var realOptions = __assign({}, options, { mutation: fullDocument });
	        delete realOptions.fragments;
	        return this.queryManager.mutate(realOptions);
	    };
	    ;
	    ApolloClient.prototype.subscribe = function (options) {
	        this.initStore();
	        if (options.fragments && !haveWarnedSubscription && ("production") !== 'production') {
	            console.warn('"fragments" option is deprecated and will be removed in the upcoming versions, ' +
	                'please refer to the documentation for how to define fragments: ' +
	                'http://dev.apollodata.com/react/fragments.html.');
	            if (true) {
	                haveWarnedSubscription = true;
	            }
	        }
	        var fullDocument = getFromAST_1.addFragmentsToDocument(options.query, options.fragments);
	        var realOptions = __assign({}, options, { document: fullDocument });
	        delete realOptions.fragments;
	        delete realOptions.query;
	        return this.queryManager.startGraphQLSubscription(realOptions);
	    };
	    ApolloClient.prototype.reducer = function () {
	        return store_1.createApolloReducer(this.reducerConfig);
	    };
	    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
	        this.devToolsHookCb = cb;
	    };
	    ApolloClient.prototype.initStore = function () {
	        var _this = this;
	        if (this.store) {
	            return;
	        }
	        if (this.reduxRootSelector) {
	            throw new Error('Cannot initialize the store because "reduxRootSelector" or "reduxRootKey" is provided. ' +
	                'They should only be used when the store is created outside of the client. ' +
	                'This may lead to unexpected results when querying the store internally. ' +
	                "Please remove that option from ApolloClient constructor.");
	        }
	        this.setStore(store_1.createApolloStore({
	            reduxRootKey: DEFAULT_REDUX_ROOT_KEY,
	            initialState: this.initialState,
	            config: this.reducerConfig,
	            logger: function (store) { return function (next) { return function (action) {
	                var result = next(action);
	                if (_this.devToolsHookCb) {
	                    _this.devToolsHookCb({
	                        action: action,
	                        state: _this.queryManager.getApolloState(),
	                        dataWithOptimisticResults: _this.queryManager.getDataWithOptimisticResults(),
	                    });
	                }
	                return result;
	            }; }; },
	        }));
	        this.reduxRootKey = DEFAULT_REDUX_ROOT_KEY;
	    };
	    ;
	    ApolloClient.prototype.resetStore = function () {
	        this.queryManager.resetStore();
	    };
	    ;
	    ApolloClient.prototype.getInitialState = function () {
	        return this.queryManager.getInitialState();
	    };
	    ApolloClient.prototype.setStore = function (store) {
	        var reduxRootSelector;
	        if (this.reduxRootSelector) {
	            reduxRootSelector = this.reduxRootSelector;
	        }
	        else {
	            reduxRootSelector = defaultReduxRootSelector;
	            this.reduxRootKey = DEFAULT_REDUX_ROOT_KEY;
	        }
	        if (isUndefined(reduxRootSelector(store.getState()))) {
	            throw new Error('Existing store does not use apolloReducer. Please make sure the store ' +
	                'is properly configured and "reduxRootSelector" is correctly specified.');
	        }
	        this.store = store;
	        this.queryManager = new QueryManager_1.QueryManager({
	            networkInterface: this.networkInterface,
	            reduxRootSelector: reduxRootSelector,
	            store: store,
	            addTypename: this.addTypename,
	            resultTransformer: this.resultTransformer,
	            resultComparator: this.resultComparator,
	            reducerConfig: this.reducerConfig,
	            queryDeduplication: this.queryDeduplication,
	        });
	    };
	    ;
	    return ApolloClient;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ApolloClient;
	//# sourceMappingURL=ApolloClient.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var flatten = __webpack_require__(813);
	var getFromAST_1 = __webpack_require__(754);
	exports.fragmentDefinitionsMap = {};
	var printFragmentWarnings = true;
	var haveWarned = false;
	function createFragment(doc, fragments, internalUse) {
	    if (fragments === void 0) { fragments = []; }
	    if (internalUse === void 0) { internalUse = false; }
	    if (!internalUse) {
	        if (!haveWarned) {
	            if (false) {
	                console.warn('"createFragment" is deprecated and will be removed in version 0.6, ' +
	                    'please refer to the documentation for how to define fragments: ' +
	                    'http://dev.apollodata.com/react/fragments.html.');
	            }
	            if (true) {
	                haveWarned = true;
	            }
	        }
	    }
	    fragments = flatten(fragments);
	    var fragmentDefinitions = getFromAST_1.getFragmentDefinitions(doc);
	    fragmentDefinitions.forEach(function (fragmentDefinition) {
	        var fragmentName = fragmentDefinition.name.value;
	        if (exports.fragmentDefinitionsMap.hasOwnProperty(fragmentName) &&
	            exports.fragmentDefinitionsMap[fragmentName].indexOf(fragmentDefinition) === -1) {
	            if (printFragmentWarnings) {
	                console.warn("Warning: fragment with name " + fragmentDefinition.name.value + " already exists.\nApollo Client enforces all fragment names across your application to be unique; read more about\nthis in the docs: http://docs.apollostack.com/");
	            }
	            exports.fragmentDefinitionsMap[fragmentName].push(fragmentDefinition);
	        }
	        else if (!exports.fragmentDefinitionsMap.hasOwnProperty(fragmentName)) {
	            exports.fragmentDefinitionsMap[fragmentName] = [fragmentDefinition];
	        }
	    });
	    return fragments.concat(fragmentDefinitions);
	}
	exports.createFragment = createFragment;
	function disableFragmentWarnings() {
	    printFragmentWarnings = false;
	}
	exports.disableFragmentWarnings = disableFragmentWarnings;
	function enableFragmentWarnings() {
	    printFragmentWarnings = true;
	}
	exports.enableFragmentWarnings = enableFragmentWarnings;
	function clearFragmentDefinitions() {
	    exports.fragmentDefinitionsMap = {};
	}
	exports.clearFragmentDefinitions = clearFragmentDefinitions;
	//# sourceMappingURL=fragments.js.map

/***/ },
/* 835 */
/***/ function(module, exports) {

	exports.version = "0.6.0"

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	/*
	  Afterware for Apollo client
	  http://dev.apollodata.com/core/network.html#networkInterfaceAfterware
	
	  This thread was helpful:
	  https://github.com/apollostack/apollo-client/issues/657#issuecomment-258440056
	 */
	
	// NOTE imports are dynamic to prevent cyclic dependencies
	// import AuthActions from 'auth/AuthActions';
	
	// message we're getting:
	// 401 - {"error":"Unauthorized","code":"unauthenticated","message":"Unauthorized"}
	var has401 = function has401(errors) {
	  return errors.some(function (err) {
	    return err.message.startsWith('401 ');
	  });
	};
	
	var detect401 = exports.detect401 = {
	  applyAfterware: function applyAfterware(_ref, next) {
	    var response = _ref.response;
	
	    if (response.ok) {
	      return response.clone().json().then(function (_ref2) {
	        var errors = _ref2.errors;
	
	        if (errors && has401(errors)) {
	          console.warn('Received a 401 in GraphQL response. Expiring user session.');
	          var AuthActions = __webpack_require__(837).default;
	          AuthActions.expireSession();
	        } else {
	          next();
	        }
	      });
	    }
	
	    next();
	    return Promise.resolve();
	  }
	};
	
	var logNetworkErrors = exports.logNetworkErrors = {
	  applyAfterware: function applyAfterware(_ref3, next) {
	    var response = _ref3.response;
	
	    // TODO improve apollo-client so batching doesn't change the afterware
	    // contract so much. Batched network requests pass in just {data} here,
	    // while singular network requests each have HTTP info like `ok`.
	    if (response.data || response.ok) {
	      next();
	    } else if (response.clone) {
	      response.clone().text().then(function (bodyText) {
	        console.error('Network Error: ' + response.status + ' (' + response.statusText + ') - ' + bodyText);
	        next();
	      }).catch(function () {
	        return console.error('response clone failed');
	      });
	    } else {
	      console.warn('GraphQL response missing data', response);
	      next();
	    }
	  }
	};
	
	var detect503 = exports.detect503 = {
	  applyAfterware: function applyAfterware(_ref4, next) {
	    var response = _ref4.response;
	
	    if (response.status === 503) {
	      var ToastActions = __webpack_require__(947).default;
	      ToastActions.showErrorToast('We are currently experiencing some technical issues. Try again later.');
	      return;
	    }
	    next();
	  }
	};

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.onSessionCreated = onSessionCreated;
	
	var _Config = __webpack_require__(551);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Cookies = __webpack_require__(573);
	
	var _Cookies2 = _interopRequireDefault(_Cookies);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _GoogleAPI = __webpack_require__(950);
	
	var _GoogleAPI2 = _interopRequireDefault(_GoogleAPI);
	
	var _PusherClient = __webpack_require__(952);
	
	var _PusherClient2 = _interopRequireDefault(_PusherClient);
	
	var _Session = __webpack_require__(1032);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _Startup = __webpack_require__(552);
	
	var _userBootData = __webpack_require__(975);
	
	var _RouteLogic = __webpack_require__(1033);
	
	var _AuthConstants = __webpack_require__(1034);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SEC_IN_DAY = 60 * 60 * 24;
	
	var AUTH_TOKEN = 'auth_token';
	var REMEMBER_USER_TOKEN = 'remember_user_token';
	var SESSION_UUID = 'session_uuid';
	
	function clearNonStoreAuthState() {
	  // XXX until we get our Flux in order
	  _ChatActions2.default.resetPromiseMemoization();
	  _Cookies2.default.expire(AUTH_TOKEN, { domain: _Config2.default.Environment.API_PROXY_COOKIE_DOMAIN });
	  _Cookies2.default.expire(REMEMBER_USER_TOKEN, { domain: _Config2.default.Environment.API_PROXY_COOKIE_DOMAIN });
	  _Cookies2.default.expire(SESSION_UUID, { domain: _Config2.default.Environment.API_PROXY_COOKIE_DOMAIN });
	  _PusherClient2.default.disconnectAndCleanUp();
	}
	
	function onSessionCreated(user) {
	  // Configure the userId in TrackJS
	  var trackJs = window.trackJs;
	  if (trackJs) {
	    trackJs.configure({ userId: String(user.id) });
	    // TJS should let us filter on application version, but it doesn't yet, so
	    // they've advised using their generic filtering function
	    trackJs.addMetadata('buildVersion', window._trackJs.version);
	    // sent the whole thing as one value so we can filter by vectors of permissions
	    trackJs.addMetadata('userPermissions', user.getPermissions());
	    // like user.role but infers additional segments like "child"
	    trackJs.addMetadata('userSegment', user.getTrackingSegment());
	  }
	
	  // Load user initial data before we dispatch AUTH_SUCCESS
	  return (0, _userBootData.promiseAppData)(user).then(function () {
	    _Dispatcher.dispatcher.dispatch({
	      type: _AuthConstants.ActionTypes.AUTH_SUCCESS,
	      user: user
	    });
	
	    return user;
	  });
	}
	
	var AuthActions = {
	  signIn: function signIn(email, password) {
	    var persist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var valid = email && email.length > 0 && password && password.length > 0;
	    if (!valid) {
	      return Promise.reject({ statusCode: 400 });
	    }
	
	    return _Session2.default.create(email, password, persist).then(onSessionCreated, function (error) {
	      if (error && error.code === 'unauthenticated') {
	        console.warn('Session.create error', error);
	      } else {
	        console.error('Session.create error', error);
	      }
	
	      _Dispatcher.dispatcher.dispatch({
	        type: _AuthConstants.ActionTypes.AUTH_FAILURE,
	        error: error
	      });
	
	      return Promise.reject(error);
	    });
	  },
	
	
	  // TODO make Promise<void> or void
	  accessTokenSignIn: function accessTokenSignIn(token) {
	    if (!(token.length > 0)) {
	      console.error('accessTokenSignIn received bad token', token);
	    }
	    return _Session2.default.createWithToken(token).then(onSessionCreated, function (error) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _AuthConstants.ActionTypes.AUTH_FAILURE,
	        error: error
	      });
	
	      return Promise.reject(error);
	    });
	  },
	  expireSession: function expireSession() {
	    AuthActions.signOut('/session/expired');
	  },
	  signOut: function signOut() {
	    var redirectTo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/send_the_app';
	
	    return Promise.all([_Session2.default.destroy(), _GoogleAPI2.default.signOut()]).then(function () {
	      clearNonStoreAuthState();
	      (0, _RouteLogic.hardRedirectTo)(redirectTo);
	    }).catch(function (e) {
	      console.warn(e);
	      console.error('signOut failed');
	      _ToastActions2.default.showErrorToast('There was a problem logging out');
	    });
	  },
	  requestPasswordReset: function requestPasswordReset(uid) {
	    return (0, _apiRequest2.default)('/password', 'POST', {
	      user_identifier: uid
	    });
	  },
	  checkLoggedIn: function checkLoggedIn() {
	    var user = (0, _Startup.getWindowUser)();
	    var userPromise = user ? Promise.resolve(user) : _User2.default.fetch();
	    return userPromise.then(onSessionCreated);
	  },
	  jwtTokenSignIn: function jwtTokenSignIn(token) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _AuthConstants.ActionTypes.TOKEN_ENTRY,
	      token: token
	    });
	  },
	  googleSignIn: function googleSignIn(code) {
	    return _Session2.default.createWithGoogleAuthorizationCode(code).then(onSessionCreated);
	  },
	
	
	  /**
	   * Fetches and sets the token for autologin to native apps
	   */
	  setAuthTokenCookie: function setAuthTokenCookie() {
	    (0, _apiRequest2.default)('/access_tokens', 'POST').then(function (response) {
	      _Cookies2.default.set(AUTH_TOKEN, response.token, { domain: _Config2.default.Environment.API_PROXY_COOKIE_DOMAIN, expires: 30 * SEC_IN_DAY });
	    }, function () {});
	  },
	  getAuthTokenFromCookies: function getAuthTokenFromCookies() {
	    return _Cookies2.default.get(AUTH_TOKEN);
	  }
	};
	
	exports.default = AuthActions;

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _memoizee = __webpack_require__(839);
	
	var _memoizee2 = _interopRequireDefault(_memoizee);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _Chats = __webpack_require__(942);
	
	var _Chats2 = _interopRequireDefault(_Chats);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _ChatMembership = __webpack_require__(920);
	
	var _ChatMembership2 = _interopRequireDefault(_ChatMembership);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _PotentialChatMember = __webpack_require__(945);
	
	var _PotentialChatMember2 = _interopRequireDefault(_PotentialChatMember);
	
	var _PotentialChatMembers = __webpack_require__(946);
	
	var _PotentialChatMembers2 = _interopRequireDefault(_PotentialChatMembers);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _ChatConstants = __webpack_require__(941);
	
	var _RootGroup = __webpack_require__(943);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loadedChatRangeMap = {
	  map: {},
	  getLoadedChatRangeForGroup: function getLoadedChatRangeForGroup(groupId) {
	    // eslint-disable-line
	    if (!this.map[groupId]) {
	      this.map[groupId] = {
	        oldestUpdate: null,
	        newestUpdate: null
	      };
	    }
	
	    return this.map[groupId];
	  },
	  setLoadedChatRangeForGroup: function setLoadedChatRangeForGroup(groupId, chats) {
	    // eslint-disable-line
	    if (chats.isEmpty()) {
	      return;
	    }
	
	    var existing = this.getLoadedChatRangeForGroup(groupId);
	
	    var oldestUpdate = chats.getOldestUpdatedAt();
	    if (oldestUpdate && (!existing.oldestUpdate || oldestUpdate < existing.oldestUpdate)) {
	      existing.oldestUpdate = oldestUpdate;
	    }
	
	    var newestUpdate = chats.getNewestUpdatedAt();
	    if (newestUpdate && (!existing.newestUpdate || newestUpdate > existing.newestUpdate)) {
	      existing.newestUpdate = newestUpdate;
	    }
	  }
	};
	
	var ChatActions = {
	  createChat: function createChat(chatToInitiate, message) {
	    return chatToInitiate.initiate(message).then(function (chat) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.CREATE_CHAT,
	        chat: chat
	      });
	
	      // set the chat id on the message.
	      // this is necessary because the created chat may
	      // not have the same uuid as the chat given in the parameters
	      // if there was a preexisting one to one chat.
	      message.setChatId(chat.id);
	
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.SENT_MESSAGE,
	        message: message
	      });
	      return chat;
	    });
	  },
	  resetStore: function resetStore() {
	    _Dispatcher.dispatcher.dispatch({
	      type: _ChatConstants.ActionTypes.RESET_STORE
	    });
	  },
	  changeMemberStatus: function changeMemberStatus(chat, membersId, state) {
	    return chat.changeMemberStatus(membersId, state).then(function (membership) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.EDIT_MEMBER_FROM_CHAT,
	        membership: membership,
	        chat: chat
	      });
	
	      return membership;
	    });
	  },
	  addMembersToChat: function addMembersToChat(chat, membersIds) {
	    return chat.addMembers(membersIds).then(function (memberships) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.ADD_MEMBERS_TO_CHAT,
	        memberships: memberships,
	        chat: chat
	      });
	
	      return memberships;
	    });
	  },
	
	
	  loadChats: function loadChats(group) {
	    // This promise is memoized so that this method doesn't hit the network
	    // too frequently.
	    ChatActions.promiseLoadChats(group);
	  },
	
	  promiseLoadChats: (0, _memoizee2.default)(function (group) {
	    var groupId = group.id;
	    return _Chats2.default.loadForGroup(groupId).then(function (chats) {
	      loadedChatRangeMap.setLoadedChatRangeForGroup(groupId, chats);
	
	      _Dispatcher.reduxDispatcher.dispatch({
	        type: 'chats/LIST_CHATS',
	        chats: chats
	      });
	
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.LIST_CHATS,
	        groupId: groupId,
	        chats: chats
	      });
	      return chats;
	    }).catch(function (err) {
	      _ToastActions2.default.showErrorToast('Messages could not be loaded. Please wait and try again later.');
	      console.warn(err);
	    });
	  }, {
	    promise: true,
	    maxAge: _ChatConstants.DATA_RELOAD_TIMEOUT_MS
	  }),
	
	  loadMoreChats: function loadMoreChats(group) {
	    var _loadedChatRangeMap$g = loadedChatRangeMap.getLoadedChatRangeForGroup(group.id),
	        oldestUpdate = _loadedChatRangeMap$g.oldestUpdate,
	        newestUpdate = _loadedChatRangeMap$g.newestUpdate;
	
	    ChatActions.loadChatPage(group.id, oldestUpdate ? oldestUpdate.toISOString() : null, newestUpdate ? newestUpdate.toISOString() : null);
	  },
	
	
	  loadChatPage: (0, _memoizee2.default)(function (groupId, updatedBefore, lastUpdated) {
	    var data = {};
	    if (updatedBefore) {
	      data['max_ts'] = updatedBefore;
	    }
	    if (lastUpdated) {
	      data['last_updated_ts'] = lastUpdated;
	    }
	    if (groupId !== _RootGroup.rootGroup.id) {
	      data['group_id'] = groupId;
	    }
	    data.limit = _ChatConstants.CHATS_PAGE_SIZE;
	    // postpone loading this until a specific chat view is requesting it
	    data.include_memberships = false;
	
	    var params = {
	      data: data
	    };
	
	    _Chats2.default.fetch(params).then(function (chats) {
	      loadedChatRangeMap.setLoadedChatRangeForGroup(groupId, chats);
	      _Dispatcher.reduxDispatcher.dispatch({
	        type: 'chats/APPEND_CHATS',
	        chats: chats
	      });
	      _Dispatcher.dispatcher.dispatch(_extends({
	        groupId: groupId,
	        type: _ChatConstants.ActionTypes.APPEND_CHATS,
	        chats: chats
	      }, params));
	    });
	  }, {
	    maxAge: _ChatConstants.DATA_RELOAD_TIMEOUT_MS
	  }),
	
	  searchChats: _lodash2.default.debounce((0, _memoizee2.default)(function (query) {
	    _Chats2.default.search(query).then(function (chats) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.SEARCH_CHATS,
	        chats: chats
	      });
	    });
	  }, {
	    maxAge: _ChatConstants.DATA_RELOAD_TIMEOUT_MS
	  }), _ChatConstants.SEARCH_NETWORK_LIMIT_MS),
	
	  resetSelection: function resetSelection() {
	    _Dispatcher.dispatcher.dispatch({
	      type: _ChatConstants.ActionTypes.RESET_SELECTION
	    });
	  },
	  selectChat: function selectChat(chatId) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _ChatConstants.ActionTypes.SELECT_CHAT,
	      chatId: chatId
	    });
	  },
	  loadLocal: function loadLocal(members, title) {
	    var originIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    _Dispatcher.dispatcher.dispatch({
	      type: _ChatConstants.ActionTypes.LOAD_LOCAL_CHAT,
	      members: members,
	      title: title,
	      originIds: originIds
	    });
	  },
	  updateLocal: function updateLocal() {
	    _Dispatcher.dispatcher.dispatch({
	      type: _ChatConstants.ActionTypes.UPDATE_LOCAL_CHAT
	    });
	  },
	  destroyLocal: function destroyLocal() {
	    _Dispatcher.dispatcher.dispatch({
	      type: _ChatConstants.ActionTypes.DESTROY_LOCAL_CHAT
	    });
	  },
	  loadChat: function loadChat(chatId) {
	    return _Chat2.default.fetch({ uuid: chatId }).then(function (chat) {
	      _Dispatcher.reduxDispatcher.dispatch({
	        type: 'chats/LOAD_CHAT',
	        chat: chat
	      });
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.LOAD_CHAT,
	        chat: chat
	      });
	    });
	  },
	  markRead: function markRead(chatId) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _ChatConstants.ActionTypes.MARK_READ,
	      chatId: chatId
	    });
	  },
	  markReadUpto: function markReadUpto(chatId, seqId) {
	    ChatActions.markRead(chatId);
	    _Chat2.default.markReadUpto(chatId, seqId).then(function () {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.READ_MESSAGE,
	        chatId: chatId
	      });
	    });
	  },
	  disableReplies: function disableReplies(chatToDisable) {
	    chatToDisable.disableReplies().then(function (chat) {
	      _ToastActions2.default.showSuccessToast('Replies are turned off');
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.UPDATE_CHAT,
	        chat: chat
	      });
	    });
	  },
	  enableReplies: function enableReplies(chatToEnable) {
	    chatToEnable.enableReplies().then(function (chat) {
	      _ToastActions2.default.showSuccessToast('Replies are turned on');
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.UPDATE_CHAT,
	        chat: chat
	      });
	    });
	  },
	  leaveChat: function leaveChat(chat) {
	    chat.leave().then(function () {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.UPDATE_CHAT,
	        chat: chat
	      });
	    });
	  },
	  updateChatTitle: function updateChatTitle(chat, title) {
	    chat.updateTitle(title).then(function () {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.UPDATE_CHAT,
	        chat: chat
	      });
	    });
	  },
	
	
	  // TODO remove because each PCM query is unique. It's not just loading data
	  // into a store, the order of the results is significant.
	  loadPotentialChatMembers: _lodash2.default.debounce(function (query) {
	    ChatActions.promisePotentialChatMembers(query);
	  }, _ChatConstants.SEARCH_NETWORK_LIMIT_MS),
	
	  promisePotentialChatMembers: (0, _memoizee2.default)(function (query) {
	    return _PotentialChatMembers2.default.fetch({
	      data: {
	        q: query
	      }
	    }).then(function (members) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.LOAD_MEMBERS,
	        members: members,
	        query: query
	      });
	      return members;
	    });
	  }, {
	    maxAge: _ChatConstants.DATA_RELOAD_TIMEOUT_MS
	  }),
	
	  emailTranscript: function emailTranscript(chatId) {
	    _Chat2.default.emailTranscript(chatId).then(function () {
	      _ToastActions2.default.showSuccessToast('We’ve sent the message history for this conversation.');
	    }).catch(function (error) {
	      _ToastActions2.default.showAPIError(error);
	      throw error;
	    });
	  },
	  reportChat: function reportChat(chatId, uuid, reason, notes) {
	    _Chat2.default.reportChat(chatId, uuid, reason, notes).then(function () {
	      _ToastActions2.default.showSuccessToast('Report submitted');
	    });
	  },
	  requestMemberAge: function requestMemberAge(memberToRequest) {
	    memberToRequest.requestAge().then(function (member) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.UPDATE_MEMBER,
	        member: member
	      });
	    });
	  },
	  setFocusView: function setFocusView(focus) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _ChatConstants.ActionTypes.SET_FOCUS_VIEW,
	      focus: focus
	    });
	  },
	  enableRepliesForAllChats: function enableRepliesForAllChats() {
	    return _Chats2.default.enableRepliesForAllChats();
	  },
	  disableRepliesForAllChats: function disableRepliesForAllChats() {
	    return _Chats2.default.disableRepliesForAllChats();
	  },
	  resetPromiseMemoization: function resetPromiseMemoization() {
	    ChatActions.promiseLoadChats.clear();
	    ChatActions.promisePotentialChatMembers.clear();
	    loadedChatRangeMap.map = {};
	  }
	};
	
	exports.default = ChatActions;

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var normalizeOpts = __webpack_require__(840)
	  , resolveLength = __webpack_require__(841)
	  , plain         = __webpack_require__(847);
	
	module.exports = function (fn/*, options*/) {
		var options = normalizeOpts(arguments[1]), length;
	
		if (!options.normalizer) {
			length = options.length = resolveLength(options.length, fn.length, options.async);
			if (length !== 0) {
				if (options.primitive) {
					if (length === false) {
						options.normalizer = __webpack_require__(886);
					} else if (length > 1) {
						options.normalizer = __webpack_require__(887)(length);
					}
				} else {
					if (length === false) options.normalizer = __webpack_require__(888)();
					else if (length === 1) options.normalizer = __webpack_require__(890)();
					else options.normalizer = __webpack_require__(891)(length);
				}
			}
		}
	
		// Assure extensions
		if (options.async) __webpack_require__(892);
		if (options.promise) __webpack_require__(897);
		if (options.dispose) __webpack_require__(899);
		if (options.maxAge) __webpack_require__(900);
		if (options.max) __webpack_require__(903);
		if (options.refCounter) __webpack_require__(905);
	
		return plain(fn, options);
	};


/***/ },
/* 840 */
/***/ function(module, exports) {

	'use strict';
	
	var forEach = Array.prototype.forEach, create = Object.create;
	
	var process = function (src, obj) {
		var key;
		for (key in src) obj[key] = src[key];
	};
	
	module.exports = function (options/*, …options*/) {
		var result = create(null);
		forEach.call(arguments, function (options) {
			if (options == null) return;
			process(Object(options), result);
		});
		return result;
	};


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toPosInt = __webpack_require__(842);
	
	module.exports = function (optsLength, fnLength, isAsync) {
		var length;
		if (isNaN(optsLength)) {
			length = fnLength;
			if (!(length >= 0)) return 1;
			if (isAsync && length) return length - 1;
			return length;
		}
		if (optsLength === false) return false;
		return toPosInt(optsLength);
	};


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toInteger = __webpack_require__(843)
	
	  , max = Math.max;
	
	module.exports = function (value) { return max(0, toInteger(value)); };


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var sign = __webpack_require__(844)
	
	  , abs = Math.abs, floor = Math.floor;
	
	module.exports = function (value) {
		if (isNaN(value)) return 0;
		value = Number(value);
		if ((value === 0) || !isFinite(value)) return value;
		return sign(value) * floor(abs(value));
	};


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(845)()
		? Math.sign
		: __webpack_require__(846);


/***/ },
/* 845 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
		var sign = Math.sign;
		if (typeof sign !== 'function') return false;
		return ((sign(10) === 1) && (sign(-20) === -1));
	};


/***/ },
/* 846 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (value) {
		value = Number(value);
		if (isNaN(value) || (value === 0)) return value;
		return (value > 0) ? 1 : -1;
	};


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callable      = __webpack_require__(848)
	  , forEach       = __webpack_require__(849)
	  , extensions    = __webpack_require__(852)
	  , configure     = __webpack_require__(853)
	  , resolveLength = __webpack_require__(841)
	
	  , hasOwnProperty = Object.prototype.hasOwnProperty;
	
	module.exports = function self(fn/*, options */) {
		var options, length, conf;
	
		callable(fn);
		options = Object(arguments[1]);
	
		if (options.async && options.promise) {
			throw new Error("Options 'async' and 'promise' cannot be used together");
		}
	
		// Do not memoize already memoized function
		if (hasOwnProperty.call(fn, '__memoized__') && !options.force) return fn;
	
		// Resolve length;
		length = resolveLength(options.length, fn.length, options.async && extensions.async);
	
		// Configure cache map
		conf = configure(fn, length, options);
	
		// Bind eventual extensions
		forEach(extensions, function (fn, name) {
			if (options[name]) fn(options[name], conf, options);
		});
	
		if (self.__profiler__) self.__profiler__(conf);
	
		conf.updateEnv();
		return conf.memoized;
	};


/***/ },
/* 848 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (fn) {
		if (typeof fn !== 'function') throw new TypeError(fn + " is not a function");
		return fn;
	};


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(850)('forEach');


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	// Internal method, used by iteration functions.
	// Calls a function for each key-value pair found in object
	// Optionally takes compareFn to iterate object in specific order
	
	'use strict';
	
	var callable = __webpack_require__(848)
	  , value    = __webpack_require__(851)
	
	  , bind = Function.prototype.bind, call = Function.prototype.call, keys = Object.keys
	  , propertyIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	module.exports = function (method, defVal) {
		return function (obj, cb/*, thisArg, compareFn*/) {
			var list, thisArg = arguments[2], compareFn = arguments[3];
			obj = Object(value(obj));
			callable(cb);
	
			list = keys(obj);
			if (compareFn) {
				list.sort((typeof compareFn === 'function') ? bind.call(compareFn, obj) : undefined);
			}
			if (typeof method !== 'function') method = list[method];
			return call.call(method, list, function (key, index) {
				if (!propertyIsEnumerable.call(obj, key)) return defVal;
				return call.call(cb, thisArg, obj[key], key, obj, index);
			});
		};
	};


/***/ },
/* 851 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (value) {
		if (value == null) throw new TypeError("Cannot use null or undefined");
		return value;
	};


/***/ },
/* 852 */
/***/ function(module, exports) {

	'use strict';


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var customError      = __webpack_require__(854)
	  , defineLength     = __webpack_require__(861)
	  , d                = __webpack_require__(863)
	  , ee               = __webpack_require__(868).methods
	  , resolveResolve   = __webpack_require__(870)
	  , resolveNormalize = __webpack_require__(885)
	
	  , apply = Function.prototype.apply, call = Function.prototype.call
	  , create = Object.create, hasOwnProperty = Object.prototype.hasOwnProperty
	  , defineProperties = Object.defineProperties
	  , on = ee.on, emit = ee.emit;
	
	module.exports = function (original, length, options) {
		var cache = create(null), conf, memLength, get, set, del, clear, extDel, normalizer
		  , getListeners, setListeners, deleteListeners, memoized, resolve;
		if (length !== false) memLength = length;
		else if (isNaN(original.length)) memLength = 1;
		else memLength = original.length;
	
		if (options.normalizer) {
			normalizer = resolveNormalize(options.normalizer);
			get = normalizer.get;
			set = normalizer.set;
			del = normalizer.delete;
			clear = normalizer.clear;
		}
		if (options.resolvers != null) resolve = resolveResolve(options.resolvers);
	
		if (get) {
			memoized = defineLength(function (arg) {
				var id, result, args = arguments;
				if (resolve) args = resolve(args);
				id = get(args);
				if (id !== null) {
					if (hasOwnProperty.call(cache, id)) {
						if (getListeners) conf.emit('get', id, args, this);
						return cache[id];
					}
				}
				if (args.length === 1) result = call.call(original, this, args[0]);
				else result = apply.call(original, this, args);
				if (id === null) {
					id = get(args);
					if (id !== null) throw customError("Circular invocation", 'CIRCULAR_INVOCATION');
					id = set(args);
				} else if (hasOwnProperty.call(cache, id)) {
					throw customError("Circular invocation", 'CIRCULAR_INVOCATION');
				}
				cache[id] = result;
				if (setListeners) conf.emit('set', id, null, result);
				return result;
			}, memLength);
		} else if (length === 0) {
			memoized = function () {
				var result;
				if (hasOwnProperty.call(cache, 'data')) {
					if (getListeners) conf.emit('get', 'data', arguments, this);
					return cache.data;
				}
				if (!arguments.length) result = call.call(original, this);
				else result = apply.call(original, this, arguments);
				if (hasOwnProperty.call(cache, 'data')) {
					throw customError("Circular invocation", 'CIRCULAR_INVOCATION');
				}
				cache.data = result;
				if (setListeners) conf.emit('set', 'data', null, result);
				return result;
			};
		} else {
			memoized = function (arg) {
				var result, args = arguments, id;
				if (resolve) args = resolve(arguments);
				id = String(args[0]);
				if (hasOwnProperty.call(cache, id)) {
					if (getListeners) conf.emit('get', id, args, this);
					return cache[id];
				}
				if (args.length === 1) result = call.call(original, this, args[0]);
				else result = apply.call(original, this, args);
				if (hasOwnProperty.call(cache, id)) {
					throw customError("Circular invocation", 'CIRCULAR_INVOCATION');
				}
				cache[id] = result;
				if (setListeners) conf.emit('set', id, null, result);
				return result;
			};
		}
		conf = {
			original: original,
			memoized: memoized,
			get: function (args) {
				if (resolve) args = resolve(args);
				if (get) return get(args);
				return String(args[0]);
			},
			has: function (id) { return hasOwnProperty.call(cache, id); },
			delete: function (id) {
				var result;
				if (!hasOwnProperty.call(cache, id)) return;
				if (del) del(id);
				result = cache[id];
				delete cache[id];
				if (deleteListeners) conf.emit('delete', id, result);
			},
			clear: function () {
				var oldCache = cache;
				if (clear) clear();
				cache = create(null);
				conf.emit('clear', oldCache);
			},
			on: function (type, listener) {
				if (type === 'get') getListeners = true;
				else if (type === 'set') setListeners = true;
				else if (type === 'delete') deleteListeners = true;
				return on.call(this, type, listener);
			},
			emit: emit,
			updateEnv: function () { original = conf.original; }
		};
		if (get) {
			extDel = defineLength(function (arg) {
				var id, args = arguments;
				if (resolve) args = resolve(args);
				id = get(args);
				if (id === null) return;
				conf.delete(id);
			}, memLength);
		} else if (length === 0) {
			extDel = function () { return conf.delete('data'); };
		} else {
			extDel = function (arg) {
				if (resolve) arg = resolve(arguments)[0];
				return conf.delete(arg);
			};
		}
		defineProperties(memoized, {
			__memoized__: d(true),
			delete: d(extDel),
			clear: d(conf.clear)
		});
		return conf;
	};


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign = __webpack_require__(855)
	
	  , captureStackTrace = Error.captureStackTrace;
	
	exports = module.exports = function (message/*, code, ext*/) {
		var err = new Error(), code = arguments[1], ext = arguments[2];
		if (ext == null) {
			if (code && (typeof code === 'object')) {
				ext = code;
				code = null;
			}
		}
		if (ext != null) assign(err, ext);
		err.message = String(message);
		if (code != null) err.code = String(code);
		if (captureStackTrace) captureStackTrace(err, exports);
		return err;
	};


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(856)()
		? Object.assign
		: __webpack_require__(857);


/***/ },
/* 856 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
		var assign = Object.assign, obj;
		if (typeof assign !== 'function') return false;
		obj = { foo: 'raz' };
		assign(obj, { bar: 'dwa' }, { trzy: 'trzy' });
		return (obj.foo + obj.bar + obj.trzy) === 'razdwatrzy';
	};


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys  = __webpack_require__(858)
	  , value = __webpack_require__(851)
	
	  , max = Math.max;
	
	module.exports = function (dest, src/*, …srcn*/) {
		var error, i, l = max(arguments.length, 2), assign;
		dest = Object(value(dest));
		assign = function (key) {
			try { dest[key] = src[key]; } catch (e) {
				if (!error) error = e;
			}
		};
		for (i = 1; i < l; ++i) {
			src = arguments[i];
			keys(src).forEach(assign);
		}
		if (error !== undefined) throw error;
		return dest;
	};


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(859)()
		? Object.keys
		: __webpack_require__(860);


/***/ },
/* 859 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
		try {
			Object.keys('primitive');
			return true;
		} catch (e) { return false; }
	};


/***/ },
/* 860 */
/***/ function(module, exports) {

	'use strict';
	
	var keys = Object.keys;
	
	module.exports = function (object) {
		return keys(object == null ? object : Object(object));
	};


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toPosInt = __webpack_require__(842)
	
	  , test = function (a, b) {}, desc, defineProperty
	  , generate, mixin;
	
	try {
		Object.defineProperty(test, 'length', { configurable: true, writable: false,
			enumerable: false, value: 1 });
	} catch (ignore) {}
	
	if (test.length === 1) {
		// ES6
		desc = { configurable: true, writable: false, enumerable: false };
		defineProperty = Object.defineProperty;
		module.exports = function (fn, length) {
			length = toPosInt(length);
			if (fn.length === length) return fn;
			desc.value = length;
			return defineProperty(fn, 'length', desc);
		};
	} else {
		mixin = __webpack_require__(862);
		generate = (function () {
			var cache = [];
			return function (l) {
				var args, i = 0;
				if (cache[l]) return cache[l];
				args = [];
				while (l--) args.push('a' + (++i).toString(36));
				return new Function('fn', 'return function (' + args.join(', ') +
					') { return fn.apply(this, arguments); };');
			};
		}());
		module.exports = function (src, length) {
			var target;
			length = toPosInt(length);
			if (src.length === length) return src;
			target = generate(length)(src);
			try { mixin(target, src); } catch (ignore) {}
			return target;
		};
	}


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var value = __webpack_require__(851)
	
	  , defineProperty = Object.defineProperty
	  , getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor
	  , getOwnPropertyNames = Object.getOwnPropertyNames
	  , getOwnPropertySymbols = Object.getOwnPropertySymbols;
	
	module.exports = function (target, source) {
		var error, sourceObject = Object(value(source));
		target = Object(value(target));
		getOwnPropertyNames(sourceObject).forEach(function (name) {
			try {
				defineProperty(target, name, getOwnPropertyDescriptor(source, name));
			} catch (e) { error = e; }
		});
		if (typeof getOwnPropertySymbols === 'function') {
			getOwnPropertySymbols(sourceObject).forEach(function (symbol) {
				try {
					defineProperty(target, symbol, getOwnPropertyDescriptor(source, symbol));
				} catch (e) { error = e; }
			});
		}
		if (error !== undefined) throw error;
		return target;
	};


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign        = __webpack_require__(855)
	  , normalizeOpts = __webpack_require__(840)
	  , isCallable    = __webpack_require__(864)
	  , contains      = __webpack_require__(865)
	
	  , d;
	
	d = module.exports = function (dscr, value/*, options*/) {
		var c, e, w, options, desc;
		if ((arguments.length < 2) || (typeof dscr !== 'string')) {
			options = value;
			value = dscr;
			dscr = null;
		} else {
			options = arguments[2];
		}
		if (dscr == null) {
			c = w = true;
			e = false;
		} else {
			c = contains.call(dscr, 'c');
			e = contains.call(dscr, 'e');
			w = contains.call(dscr, 'w');
		}
	
		desc = { value: value, configurable: c, enumerable: e, writable: w };
		return !options ? desc : assign(normalizeOpts(options), desc);
	};
	
	d.gs = function (dscr, get, set/*, options*/) {
		var c, e, options, desc;
		if (typeof dscr !== 'string') {
			options = set;
			set = get;
			get = dscr;
			dscr = null;
		} else {
			options = arguments[3];
		}
		if (get == null) {
			get = undefined;
		} else if (!isCallable(get)) {
			options = get;
			get = set = undefined;
		} else if (set == null) {
			set = undefined;
		} else if (!isCallable(set)) {
			options = set;
			set = undefined;
		}
		if (dscr == null) {
			c = true;
			e = false;
		} else {
			c = contains.call(dscr, 'c');
			e = contains.call(dscr, 'e');
		}
	
		desc = { get: get, set: set, configurable: c, enumerable: e };
		return !options ? desc : assign(normalizeOpts(options), desc);
	};


/***/ },
/* 864 */
/***/ function(module, exports) {

	// Deprecated
	
	'use strict';
	
	module.exports = function (obj) { return typeof obj === 'function'; };


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(866)()
		? String.prototype.contains
		: __webpack_require__(867);


/***/ },
/* 866 */
/***/ function(module, exports) {

	'use strict';
	
	var str = 'razdwatrzy';
	
	module.exports = function () {
		if (typeof str.contains !== 'function') return false;
		return ((str.contains('dwa') === true) && (str.contains('foo') === false));
	};


/***/ },
/* 867 */
/***/ function(module, exports) {

	'use strict';
	
	var indexOf = String.prototype.indexOf;
	
	module.exports = function (searchString/*, position*/) {
		return indexOf.call(this, searchString, arguments[1]) > -1;
	};


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var d        = __webpack_require__(869)
	  , callable = __webpack_require__(848)
	
	  , apply = Function.prototype.apply, call = Function.prototype.call
	  , create = Object.create, defineProperty = Object.defineProperty
	  , defineProperties = Object.defineProperties
	  , hasOwnProperty = Object.prototype.hasOwnProperty
	  , descriptor = { configurable: true, enumerable: false, writable: true }
	
	  , on, once, off, emit, methods, descriptors, base;
	
	on = function (type, listener) {
		var data;
	
		callable(listener);
	
		if (!hasOwnProperty.call(this, '__ee__')) {
			data = descriptor.value = create(null);
			defineProperty(this, '__ee__', descriptor);
			descriptor.value = null;
		} else {
			data = this.__ee__;
		}
		if (!data[type]) data[type] = listener;
		else if (typeof data[type] === 'object') data[type].push(listener);
		else data[type] = [data[type], listener];
	
		return this;
	};
	
	once = function (type, listener) {
		var once, self;
	
		callable(listener);
		self = this;
		on.call(this, type, once = function () {
			off.call(self, type, once);
			apply.call(listener, this, arguments);
		});
	
		once.__eeOnceListener__ = listener;
		return this;
	};
	
	off = function (type, listener) {
		var data, listeners, candidate, i;
	
		callable(listener);
	
		if (!hasOwnProperty.call(this, '__ee__')) return this;
		data = this.__ee__;
		if (!data[type]) return this;
		listeners = data[type];
	
		if (typeof listeners === 'object') {
			for (i = 0; (candidate = listeners[i]); ++i) {
				if ((candidate === listener) ||
						(candidate.__eeOnceListener__ === listener)) {
					if (listeners.length === 2) data[type] = listeners[i ? 0 : 1];
					else listeners.splice(i, 1);
				}
			}
		} else {
			if ((listeners === listener) ||
					(listeners.__eeOnceListener__ === listener)) {
				delete data[type];
			}
		}
	
		return this;
	};
	
	emit = function (type) {
		var i, l, listener, listeners, args;
	
		if (!hasOwnProperty.call(this, '__ee__')) return;
		listeners = this.__ee__[type];
		if (!listeners) return;
	
		if (typeof listeners === 'object') {
			l = arguments.length;
			args = new Array(l - 1);
			for (i = 1; i < l; ++i) args[i - 1] = arguments[i];
	
			listeners = listeners.slice();
			for (i = 0; (listener = listeners[i]); ++i) {
				apply.call(listener, this, args);
			}
		} else {
			switch (arguments.length) {
			case 1:
				call.call(listeners, this);
				break;
			case 2:
				call.call(listeners, this, arguments[1]);
				break;
			case 3:
				call.call(listeners, this, arguments[1], arguments[2]);
				break;
			default:
				l = arguments.length;
				args = new Array(l - 1);
				for (i = 1; i < l; ++i) {
					args[i - 1] = arguments[i];
				}
				apply.call(listeners, this, args);
			}
		}
	};
	
	methods = {
		on: on,
		once: once,
		off: off,
		emit: emit
	};
	
	descriptors = {
		on: d(on),
		once: d(once),
		off: d(off),
		emit: d(emit)
	};
	
	base = defineProperties({}, descriptors);
	
	module.exports = exports = function (o) {
		return (o == null) ? create(base) : defineProperties(Object(o), descriptors);
	};
	exports.methods = methods;


/***/ },
/* 869 */
863,
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toArray  = __webpack_require__(871)
	  , callable = __webpack_require__(848)
	
	  , slice = Array.prototype.slice
	  , resolveArgs;
	
	resolveArgs = function (args) {
		return this.map(function (r, i) {
			return r ? r(args[i]) : args[i];
		}).concat(slice.call(args, this.length));
	};
	
	module.exports = function (resolvers) {
		resolvers = toArray(resolvers);
		resolvers.forEach(function (r) {
			if (r != null) callable(r);
		});
		return resolveArgs.bind(resolvers);
	};


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var from = __webpack_require__(872)
	
	  , isArray = Array.isArray;
	
	module.exports = function (arrayLike) {
		return isArray(arrayLike) ? arrayLike : from(arrayLike);
	};


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(873)()
		? Array.from
		: __webpack_require__(874);


/***/ },
/* 873 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
		var from = Array.from, arr, result;
		if (typeof from !== 'function') return false;
		arr = ['raz', 'dwa'];
		result = from(arr);
		return Boolean(result && (result !== arr) && (result[1] === 'dwa'));
	};


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var iteratorSymbol = __webpack_require__(875).iterator
	  , isArguments    = __webpack_require__(881)
	  , isFunction     = __webpack_require__(882)
	  , toPosInt       = __webpack_require__(842)
	  , callable       = __webpack_require__(848)
	  , validValue     = __webpack_require__(851)
	  , isString       = __webpack_require__(884)
	
	  , isArray = Array.isArray, call = Function.prototype.call
	  , desc = { configurable: true, enumerable: true, writable: true, value: null }
	  , defineProperty = Object.defineProperty;
	
	module.exports = function (arrayLike/*, mapFn, thisArg*/) {
		var mapFn = arguments[1], thisArg = arguments[2], Constructor, i, j, arr, l, code, iterator
		  , result, getIterator, value;
	
		arrayLike = Object(validValue(arrayLike));
	
		if (mapFn != null) callable(mapFn);
		if (!this || (this === Array) || !isFunction(this)) {
			// Result: Plain array
			if (!mapFn) {
				if (isArguments(arrayLike)) {
					// Source: Arguments
					l = arrayLike.length;
					if (l !== 1) return Array.apply(null, arrayLike);
					arr = new Array(1);
					arr[0] = arrayLike[0];
					return arr;
				}
				if (isArray(arrayLike)) {
					// Source: Array
					arr = new Array(l = arrayLike.length);
					for (i = 0; i < l; ++i) arr[i] = arrayLike[i];
					return arr;
				}
			}
			arr = [];
		} else {
			// Result: Non plain array
			Constructor = this;
		}
	
		if (!isArray(arrayLike)) {
			if ((getIterator = arrayLike[iteratorSymbol]) !== undefined) {
				// Source: Iterator
				iterator = callable(getIterator).call(arrayLike);
				if (Constructor) arr = new Constructor();
				result = iterator.next();
				i = 0;
				while (!result.done) {
					value = mapFn ? call.call(mapFn, thisArg, result.value, i) : result.value;
					if (!Constructor) {
						arr[i] = value;
					} else {
						desc.value = value;
						defineProperty(arr, i, desc);
					}
					result = iterator.next();
					++i;
				}
				l = i;
			} else if (isString(arrayLike)) {
				// Source: String
				l = arrayLike.length;
				if (Constructor) arr = new Constructor();
				for (i = 0, j = 0; i < l; ++i) {
					value = arrayLike[i];
					if ((i + 1) < l) {
						code = value.charCodeAt(0);
						if ((code >= 0xD800) && (code <= 0xDBFF)) value += arrayLike[++i];
					}
					value = mapFn ? call.call(mapFn, thisArg, value, j) : value;
					if (!Constructor) {
						arr[j] = value;
					} else {
						desc.value = value;
						defineProperty(arr, j, desc);
					}
					++j;
				}
				l = j;
			}
		}
		if (l === undefined) {
			// Source: array or array-like
			l = toPosInt(arrayLike.length);
			if (Constructor) arr = new Constructor(l);
			for (i = 0; i < l; ++i) {
				value = mapFn ? call.call(mapFn, thisArg, arrayLike[i], i) : arrayLike[i];
				if (!Constructor) {
					arr[i] = value;
				} else {
					desc.value = value;
					defineProperty(arr, i, desc);
				}
			}
		}
		if (Constructor) {
			desc.value = null;
			arr.length = l;
		}
		return arr;
	};


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(876)() ? Symbol : __webpack_require__(877);


/***/ },
/* 876 */
/***/ function(module, exports) {

	'use strict';
	
	var validTypes = { object: true, symbol: true };
	
	module.exports = function () {
		var symbol;
		if (typeof Symbol !== 'function') return false;
		symbol = Symbol('test symbol');
		try { String(symbol); } catch (e) { return false; }
	
		// Return 'true' also for polyfills
		if (!validTypes[typeof Symbol.iterator]) return false;
		if (!validTypes[typeof Symbol.toPrimitive]) return false;
		if (!validTypes[typeof Symbol.toStringTag]) return false;
	
		return true;
	};


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	// ES2015 Symbol polyfill for environments that do not support it (or partially support it)
	
	'use strict';
	
	var d              = __webpack_require__(878)
	  , validateSymbol = __webpack_require__(879)
	
	  , create = Object.create, defineProperties = Object.defineProperties
	  , defineProperty = Object.defineProperty, objPrototype = Object.prototype
	  , NativeSymbol, SymbolPolyfill, HiddenSymbol, globalSymbols = create(null)
	  , isNativeSafe;
	
	if (typeof Symbol === 'function') {
		NativeSymbol = Symbol;
		try {
			String(NativeSymbol());
			isNativeSafe = true;
		} catch (ignore) {}
	}
	
	var generateName = (function () {
		var created = create(null);
		return function (desc) {
			var postfix = 0, name, ie11BugWorkaround;
			while (created[desc + (postfix || '')]) ++postfix;
			desc += (postfix || '');
			created[desc] = true;
			name = '@@' + desc;
			defineProperty(objPrototype, name, d.gs(null, function (value) {
				// For IE11 issue see:
				// https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
				//    ie11-broken-getters-on-dom-objects
				// https://github.com/medikoo/es6-symbol/issues/12
				if (ie11BugWorkaround) return;
				ie11BugWorkaround = true;
				defineProperty(this, name, d(value));
				ie11BugWorkaround = false;
			}));
			return name;
		};
	}());
	
	// Internal constructor (not one exposed) for creating Symbol instances.
	// This one is used to ensure that `someSymbol instanceof Symbol` always return false
	HiddenSymbol = function Symbol(description) {
		if (this instanceof HiddenSymbol) throw new TypeError('TypeError: Symbol is not a constructor');
		return SymbolPolyfill(description);
	};
	
	// Exposed `Symbol` constructor
	// (returns instances of HiddenSymbol)
	module.exports = SymbolPolyfill = function Symbol(description) {
		var symbol;
		if (this instanceof Symbol) throw new TypeError('TypeError: Symbol is not a constructor');
		if (isNativeSafe) return NativeSymbol(description);
		symbol = create(HiddenSymbol.prototype);
		description = (description === undefined ? '' : String(description));
		return defineProperties(symbol, {
			__description__: d('', description),
			__name__: d('', generateName(description))
		});
	};
	defineProperties(SymbolPolyfill, {
		for: d(function (key) {
			if (globalSymbols[key]) return globalSymbols[key];
			return (globalSymbols[key] = SymbolPolyfill(String(key)));
		}),
		keyFor: d(function (s) {
			var key;
			validateSymbol(s);
			for (key in globalSymbols) if (globalSymbols[key] === s) return key;
		}),
	
		// If there's native implementation of given symbol, let's fallback to it
		// to ensure proper interoperability with other native functions e.g. Array.from
		hasInstance: d('', (NativeSymbol && NativeSymbol.hasInstance) || SymbolPolyfill('hasInstance')),
		isConcatSpreadable: d('', (NativeSymbol && NativeSymbol.isConcatSpreadable) ||
			SymbolPolyfill('isConcatSpreadable')),
		iterator: d('', (NativeSymbol && NativeSymbol.iterator) || SymbolPolyfill('iterator')),
		match: d('', (NativeSymbol && NativeSymbol.match) || SymbolPolyfill('match')),
		replace: d('', (NativeSymbol && NativeSymbol.replace) || SymbolPolyfill('replace')),
		search: d('', (NativeSymbol && NativeSymbol.search) || SymbolPolyfill('search')),
		species: d('', (NativeSymbol && NativeSymbol.species) || SymbolPolyfill('species')),
		split: d('', (NativeSymbol && NativeSymbol.split) || SymbolPolyfill('split')),
		toPrimitive: d('', (NativeSymbol && NativeSymbol.toPrimitive) || SymbolPolyfill('toPrimitive')),
		toStringTag: d('', (NativeSymbol && NativeSymbol.toStringTag) || SymbolPolyfill('toStringTag')),
		unscopables: d('', (NativeSymbol && NativeSymbol.unscopables) || SymbolPolyfill('unscopables'))
	});
	
	// Internal tweaks for real symbol producer
	defineProperties(HiddenSymbol.prototype, {
		constructor: d(SymbolPolyfill),
		toString: d('', function () { return this.__name__; })
	});
	
	// Proper implementation of methods exposed on Symbol.prototype
	// They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
	defineProperties(SymbolPolyfill.prototype, {
		toString: d(function () { return 'Symbol (' + validateSymbol(this).__description__ + ')'; }),
		valueOf: d(function () { return validateSymbol(this); })
	});
	defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toPrimitive, d('', function () {
		var symbol = validateSymbol(this);
		if (typeof symbol === 'symbol') return symbol;
		return symbol.toString();
	}));
	defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d('c', 'Symbol'));
	
	// Proper implementaton of toPrimitive and toStringTag for returned symbol instances
	defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toStringTag,
		d('c', SymbolPolyfill.prototype[SymbolPolyfill.toStringTag]));
	
	// Note: It's important to define `toPrimitive` as last one, as some implementations
	// implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
	// And that may invoke error in definition flow:
	// See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
	defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toPrimitive,
		d('c', SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive]));


/***/ },
/* 878 */
863,
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isSymbol = __webpack_require__(880);
	
	module.exports = function (value) {
		if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
		return value;
	};


/***/ },
/* 880 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (x) {
		if (!x) return false;
		if (typeof x === 'symbol') return true;
		if (!x.constructor) return false;
		if (x.constructor.name !== 'Symbol') return false;
		return (x[x.constructor.toStringTag] === 'Symbol');
	};


/***/ },
/* 881 */
/***/ function(module, exports) {

	'use strict';
	
	var toString = Object.prototype.toString
	
	  , id = toString.call((function () { return arguments; }()));
	
	module.exports = function (x) { return (toString.call(x) === id); };


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toString = Object.prototype.toString
	
	  , id = toString.call(__webpack_require__(883));
	
	module.exports = function (f) {
		return (typeof f === "function") && (toString.call(f) === id);
	};


/***/ },
/* 883 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {};


/***/ },
/* 884 */
/***/ function(module, exports) {

	'use strict';
	
	var toString = Object.prototype.toString
	
	  , id = toString.call('');
	
	module.exports = function (x) {
		return (typeof x === 'string') || (x && (typeof x === 'object') &&
			((x instanceof String) || (toString.call(x) === id))) || false;
	};


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callable = __webpack_require__(848);
	
	module.exports = function (userNormalizer) {
		var normalizer;
		if (typeof userNormalizer === 'function') return { set: userNormalizer, get: userNormalizer };
		normalizer = { get: callable(userNormalizer.get) };
		if (userNormalizer.set !== undefined) {
			normalizer.set = callable(userNormalizer.set);
			normalizer.delete = callable(userNormalizer.delete);
			normalizer.clear = callable(userNormalizer.clear);
			return normalizer;
		}
		normalizer.set = normalizer.get;
		return normalizer;
	};


/***/ },
/* 886 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (args) {
		var id, i, length = args.length;
		if (!length) return '\u0002';
		id = String(args[i = 0]);
		while (--length) id += '\u0001' + args[++i];
		return id;
	};


/***/ },
/* 887 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (length) {
		if (!length) {
			return function () { return ''; };
		}
		return function (args) {
			var id = String(args[0]), i = 0, l = length;
			while (--l) { id += '\u0001' + args[++i]; }
			return id;
		};
	};


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var indexOf = __webpack_require__(889)
	  , create = Object.create;
	
	module.exports = function () {
		var lastId = 0, map = [], cache = create(null);
		return {
			get: function (args) {
				var index = 0, set = map, i, length = args.length;
				if (length === 0) return set[length] || null;
				if ((set = set[length])) {
					while (index < (length - 1)) {
						i = indexOf.call(set[0], args[index]);
						if (i === -1) return null;
						set = set[1][i];
						++index;
					}
					i = indexOf.call(set[0], args[index]);
					if (i === -1) return null;
					return set[1][i] || null;
				}
				return null;
			},
			set: function (args) {
				var index = 0, set = map, i, length = args.length;
				if (length === 0) {
					set[length] = ++lastId;
				} else {
					if (!set[length]) {
						set[length] = [[], []];
					}
					set = set[length];
					while (index < (length - 1)) {
						i = indexOf.call(set[0], args[index]);
						if (i === -1) {
							i = set[0].push(args[index]) - 1;
							set[1].push([[], []]);
						}
						set = set[1][i];
						++index;
					}
					i = indexOf.call(set[0], args[index]);
					if (i === -1) {
						i = set[0].push(args[index]) - 1;
					}
					set[1][i] = ++lastId;
				}
				cache[lastId] = args;
				return lastId;
			},
			delete: function (id) {
				var index = 0, set = map, i, args = cache[id], length = args.length
				  , path = [];
				if (length === 0) {
					delete set[length];
				} else if ((set = set[length])) {
					while (index < (length - 1)) {
						i = indexOf.call(set[0], args[index]);
						if (i === -1) {
							return;
						}
						path.push(set, i);
						set = set[1][i];
						++index;
					}
					i = indexOf.call(set[0], args[index]);
					if (i === -1) {
						return;
					}
					id = set[1][i];
					set[0].splice(i, 1);
					set[1].splice(i, 1);
					while (!set[0].length && path.length) {
						i = path.pop();
						set = path.pop();
						set[0].splice(i, 1);
						set[1].splice(i, 1);
					}
				}
				delete cache[id];
			},
			clear: function () {
				map = [];
				cache = create(null);
			}
		};
	};


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toPosInt = __webpack_require__(842)
	  , value    = __webpack_require__(851)
	
	  , indexOf = Array.prototype.indexOf
	  , hasOwnProperty = Object.prototype.hasOwnProperty
	  , abs = Math.abs, floor = Math.floor;
	
	module.exports = function (searchElement/*, fromIndex*/) {
		var i, l, fromIndex, val;
		if (searchElement === searchElement) { //jslint: ignore
			return indexOf.apply(this, arguments);
		}
	
		l = toPosInt(value(this).length);
		fromIndex = arguments[1];
		if (isNaN(fromIndex)) fromIndex = 0;
		else if (fromIndex >= 0) fromIndex = floor(fromIndex);
		else fromIndex = toPosInt(this.length) - floor(abs(fromIndex));
	
		for (i = fromIndex; i < l; ++i) {
			if (hasOwnProperty.call(this, i)) {
				val = this[i];
				if (val !== val) return i; //jslint: ignore
			}
		}
		return -1;
	};


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var indexOf = __webpack_require__(889);
	
	module.exports = function () {
		var lastId = 0, argsMap = [], cache = [];
		return {
			get: function (args) {
				var index = indexOf.call(argsMap, args[0]);
				return (index === -1) ? null : cache[index];
			},
			set: function (args) {
				argsMap.push(args[0]);
				cache.push(++lastId);
				return lastId;
			},
			delete: function (id) {
				var index = indexOf.call(cache, id);
				if (index !== -1) {
					argsMap.splice(index, 1);
					cache.splice(index, 1);
				}
			},
			clear: function () {
				argsMap = [];
				cache = [];
			}
		};
	};


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var indexOf = __webpack_require__(889)
	  , create = Object.create;
	
	module.exports = function (length) {
		var lastId = 0, map = [[], []], cache = create(null);
		return {
			get: function (args) {
				var index = 0, set = map, i;
				while (index < (length - 1)) {
					i = indexOf.call(set[0], args[index]);
					if (i === -1) return null;
					set = set[1][i];
					++index;
				}
				i = indexOf.call(set[0], args[index]);
				if (i === -1) return null;
				return set[1][i] || null;
			},
			set: function (args) {
				var index = 0, set = map, i;
				while (index < (length - 1)) {
					i = indexOf.call(set[0], args[index]);
					if (i === -1) {
						i = set[0].push(args[index]) - 1;
						set[1].push([[], []]);
					}
					set = set[1][i];
					++index;
				}
				i = indexOf.call(set[0], args[index]);
				if (i === -1) {
					i = set[0].push(args[index]) - 1;
				}
				set[1][i] = ++lastId;
				cache[lastId] = args;
				return lastId;
			},
			delete: function (id) {
				var index = 0, set = map, i, path = [], args = cache[id];
				while (index < (length - 1)) {
					i = indexOf.call(set[0], args[index]);
					if (i === -1) {
						return;
					}
					path.push(set, i);
					set = set[1][i];
					++index;
				}
				i = indexOf.call(set[0], args[index]);
				if (i === -1) {
					return;
				}
				id = set[1][i];
				set[0].splice(i, 1);
				set[1].splice(i, 1);
				while (!set[0].length && path.length) {
					i = path.pop();
					set = path.pop();
					set[0].splice(i, 1);
					set[1].splice(i, 1);
				}
				delete cache[id];
			},
			clear: function () {
				map = [[], []];
				cache = create(null);
			}
		};
	};


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	// Support for asynchronous functions
	
	'use strict';
	
	var aFrom        = __webpack_require__(872)
	  , objectMap    = __webpack_require__(893)
	  , mixin        = __webpack_require__(862)
	  , defineLength = __webpack_require__(861)
	  , nextTick     = __webpack_require__(894)
	
	  , slice = Array.prototype.slice
	  , apply = Function.prototype.apply, create = Object.create
	  , hasOwnProperty = Object.prototype.hasOwnProperty;
	
	__webpack_require__(852).async = function (tbi, conf) {
		var waiting = create(null), cache = create(null)
		  , base = conf.memoized, original = conf.original
		  , currentCallback, currentContext, currentArgs;
	
		// Initial
		conf.memoized = defineLength(function (arg) {
			var args = arguments, last = args[args.length - 1];
			if (typeof last === 'function') {
				currentCallback = last;
				args = slice.call(args, 0, -1);
			}
			return base.apply(currentContext = this, currentArgs = args);
		}, base);
		try { mixin(conf.memoized, base); } catch (ignore) {}
	
		// From cache (sync)
		conf.on('get', function (id) {
			var cb, context, args;
			if (!currentCallback) return;
	
			// Unresolved
			if (waiting[id]) {
				if (typeof waiting[id] === 'function') waiting[id] = [waiting[id], currentCallback];
				else waiting[id].push(currentCallback);
				currentCallback = null;
				return;
			}
	
			// Resolved, assure next tick invocation
			cb = currentCallback;
			context = currentContext;
			args = currentArgs;
			currentCallback = currentContext = currentArgs = null;
			nextTick(function () {
				var data;
				if (hasOwnProperty.call(cache, id)) {
					data = cache[id];
					conf.emit('getasync', id, args, context);
					apply.call(cb, data.context, data.args);
				} else {
					// Purged in a meantime, we shouldn't rely on cached value, recall
					currentCallback = cb;
					currentContext = context;
					currentArgs = args;
					base.apply(context, args);
				}
			});
		});
	
		// Not from cache
		conf.original = function () {
			var args, cb, origCb, result;
			if (!currentCallback) return apply.call(original, this, arguments);
			args = aFrom(arguments);
			cb = function self(err) {
				var cb, args, id = self.id;
				if (id == null) {
					// Shouldn't happen, means async callback was called sync way
					nextTick(apply.bind(self, this, arguments));
					return;
				}
				delete self.id;
				cb = waiting[id];
				delete waiting[id];
				if (!cb) {
					// Already processed,
					// outcome of race condition: asyncFn(1, cb), asyncFn.clear(), asyncFn(1, cb)
					return;
				}
				args = aFrom(arguments);
				if (conf.has(id)) {
					if (err) {
						conf.delete(id);
					} else {
						cache[id] = { context: this, args: args };
						conf.emit('setasync', id, (typeof cb === 'function') ? 1 : cb.length);
					}
				}
				if (typeof cb === 'function') {
					result = apply.call(cb, this, args);
				} else {
					cb.forEach(function (cb) { result = apply.call(cb, this, args); }, this);
				}
				return result;
			};
			origCb = currentCallback;
			currentCallback = currentContext = currentArgs = null;
			args.push(cb);
			result = apply.call(original, this, args);
			cb.cb = origCb;
			currentCallback = cb;
			return result;
		};
	
		// After not from cache call
		conf.on('set', function (id) {
			if (!currentCallback) {
				conf.delete(id);
				return;
			}
			if (waiting[id]) {
				// Race condition: asyncFn(1, cb), asyncFn.clear(), asyncFn(1, cb)
				if (typeof waiting[id] === 'function') waiting[id] = [waiting[id], currentCallback.cb];
				else waiting[id].push(currentCallback.cb);
			} else {
				waiting[id] = currentCallback.cb;
			}
			delete currentCallback.cb;
			currentCallback.id = id;
			currentCallback = null;
		});
	
		// On delete
		conf.on('delete', function (id) {
			var result;
			// If false, we don't have value yet, so we assume that intention is not
			// to memoize this call. After value is obtained we don't cache it but
			// gracefully pass to callback
			if (hasOwnProperty.call(waiting, id)) return;
			if (!cache[id]) return;
			result = cache[id];
			delete cache[id];
			conf.emit('deleteasync', id, slice.call(result.args, 1));
		});
	
		// On clear
		conf.on('clear', function () {
			var oldCache = cache;
			cache = create(null);
			conf.emit('clearasync', objectMap(oldCache, function (data) {
				return slice.call(data.args, 1);
			}));
		});
	};


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callable = __webpack_require__(848)
	  , forEach  = __webpack_require__(849)
	
	  , call = Function.prototype.call;
	
	module.exports = function (obj, cb/*, thisArg*/) {
		var o = {}, thisArg = arguments[2];
		callable(cb);
		forEach(obj, function (value, key, obj, index) {
			o[key] = call.call(cb, thisArg, value, key, obj, index);
		});
		return o;
	};


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {'use strict';
	
	var callable, byObserver;
	
	callable = function (fn) {
		if (typeof fn !== 'function') throw new TypeError(fn + " is not a function");
		return fn;
	};
	
	byObserver = function (Observer) {
		var node = document.createTextNode(''), queue, currentQueue, i = 0;
		new Observer(function () {
			var callback;
			if (!queue) {
				if (!currentQueue) return;
				queue = currentQueue;
			} else if (currentQueue) {
				queue = currentQueue.concat(queue);
			}
			currentQueue = queue;
			queue = null;
			if (typeof currentQueue === 'function') {
				callback = currentQueue;
				currentQueue = null;
				callback();
				return;
			}
			node.data = (i = ++i % 2); // Invoke other batch, to handle leftover callbacks in case of crash
			while (currentQueue) {
				callback = currentQueue.shift();
				if (!currentQueue.length) currentQueue = null;
				callback();
			}
		}).observe(node, { characterData: true });
		return function (fn) {
			callable(fn);
			if (queue) {
				if (typeof queue === 'function') queue = [queue, fn];
				else queue.push(fn);
				return;
			}
			queue = fn;
			node.data = (i = ++i % 2);
		};
	};
	
	module.exports = (function () {
		// Node.js
		if ((typeof process === 'object') && process && (typeof process.nextTick === 'function')) {
			return process.nextTick;
		}
	
		// MutationObserver
		if ((typeof document === 'object') && document) {
			if (typeof MutationObserver === 'function') return byObserver(MutationObserver);
			if (typeof WebKitMutationObserver === 'function') return byObserver(WebKitMutationObserver);
		}
	
		// W3C Draft
		// http://dvcs.w3.org/hg/webperf/raw-file/tip/specs/setImmediate/Overview.html
		if (typeof setImmediate === 'function') {
			return function (cb) { setImmediate(callable(cb)); };
		}
	
		// Wide available standard
		if ((typeof setTimeout === 'function') || (typeof setTimeout === 'object')) {
			return function (cb) { setTimeout(callable(cb), 0); };
		}
	
		return null;
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295), __webpack_require__(895).setImmediate))

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(896);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(295)))

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	// Support for functions returning promise
	
	'use strict';
	
	var objectMap = __webpack_require__(893)
	  , isPromise = __webpack_require__(898)
	  , nextTick  = __webpack_require__(894)
	
	  , create = Object.create, hasOwnProperty = Object.prototype.hasOwnProperty;
	
	__webpack_require__(852).promise = function (mode, conf) {
		var waiting = create(null), cache = create(null), promises = create(null);
	
		// After not from cache call
		conf.on('set', function (id, ignore, promise) {
			if (!isPromise(promise)) {
				// Non promise result
				cache[id] = promise;
				conf.emit('setasync', id, 1);
				return;
			}
			waiting[id] = 1;
			promises[id] = promise;
			var onSuccess = function (result) {
				var count = waiting[id];
				if (!count) return; // deleted from cache before resolved
				delete waiting[id];
				cache[id] = result;
				conf.emit('setasync', id, count);
			};
			var onFailure = function () {
				if (!waiting[id]) return; // deleted from cache (or succeed in case of finally)
				delete waiting[id];
				delete promises[id];
				conf.delete(id);
			};
	
			if ((mode !== 'then') && (typeof promise.done === 'function')) {
				// Optimal promise resolution
				if ((mode !== 'done') && (typeof promise.finally === 'function')) {
					// Use 'finally' to not register error handling (still proper behavior is subject to
					// used implementation, if library throws unconditionally even on handled errors
					// switch to 'then' mode)
					promise.done(onSuccess);
					promise.finally(onFailure);
				} else {
					// With no `finally` side effect is that it mutes any eventual
					// "Unhandled error" events on returned promise
					promise.done(onSuccess, onFailure);
				}
			} else {
				// With no `done` it's best we can do.
				// Side effect is that it mutes any eventual "Unhandled error" events on returned promise
				promise.then(function (result) {
					nextTick(onSuccess.bind(this, result));
				}, function () {
					nextTick(onFailure);
				});
			}
		});
	
		// From cache (sync)
		conf.on('get', function (id, args, context) {
			var promise;
			if (waiting[id]) {
				++waiting[id]; // Still waiting
				return;
			}
			promise = promises[id];
			var emit = function () { conf.emit('getasync', id, args, context); };
			if (isPromise(promise)) {
				if (typeof promise.done === 'function') promise.done(emit);
				else promise.then(function () { nextTick(emit); });
			} else {
				emit();
			}
		});
	
		// On delete
		conf.on('delete', function (id) {
			delete promises[id];
			if (waiting[id]) {
				delete waiting[id];
				return; // Not yet resolved
			}
			if (!hasOwnProperty.call(cache, id)) return;
			var result = cache[id];
			delete cache[id];
			conf.emit('deleteasync', id, [result]);
		});
	
		// On clear
		conf.on('clear', function () {
			var oldCache = cache;
			cache = create(null);
			waiting = create(null);
			promises = create(null);
			conf.emit('clearasync', objectMap(oldCache, function (data) { return [data]; }));
		});
	};


/***/ },
/* 898 */
/***/ function(module, exports) {

	module.exports = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	// Call dispose callback on each cache purge
	
	'use strict';
	
	var callable   = __webpack_require__(848)
	  , forEach    = __webpack_require__(849)
	  , extensions = __webpack_require__(852)
	
	  , apply = Function.prototype.apply;
	
	extensions.dispose = function (dispose, conf, options) {
		var del;
		callable(dispose);
		if ((options.async && extensions.async) || (options.promise && extensions.promise)) {
			conf.on('deleteasync', del = function (id, resultArray) {
				apply.call(dispose, null, resultArray);
			});
			conf.on('clearasync', function (cache) {
				forEach(cache, function (result, id) { del(id, result); });
			});
			return;
		}
		conf.on('delete', del = function (id, result) { dispose(result); });
		conf.on('clear', function (cache) {
			forEach(cache, function (result, id) { del(id, result); });
		});
	};


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	// Timeout cached values
	
	'use strict';
	
	var aFrom      = __webpack_require__(872)
	  , forEach    = __webpack_require__(849)
	  , nextTick   = __webpack_require__(894)
	  , isPromise  = __webpack_require__(898)
	  , timeout    = __webpack_require__(901)
	  , extensions = __webpack_require__(852)
	
	  , noop = Function.prototype
	  , max = Math.max, min = Math.min, create = Object.create;
	
	extensions.maxAge = function (maxAge, conf, options) {
		var timeouts, postfix, preFetchAge, preFetchTimeouts;
	
		maxAge = timeout(maxAge);
		if (!maxAge) return;
	
		timeouts = create(null);
		postfix = ((options.async && extensions.async) || (options.promise && extensions.promise))
			? 'async' : '';
		conf.on('set' + postfix, function (id) {
			timeouts[id] = setTimeout(function () { conf.delete(id); }, maxAge);
			if (!preFetchTimeouts) return;
			if (preFetchTimeouts[id]) {
				if (preFetchTimeouts[id] !== 'nextTick') clearTimeout(preFetchTimeouts[id]);
			}
			preFetchTimeouts[id] = setTimeout(function () {
				delete preFetchTimeouts[id];
			}, preFetchAge);
		});
		conf.on('delete' + postfix, function (id) {
			clearTimeout(timeouts[id]);
			delete timeouts[id];
			if (!preFetchTimeouts) return;
			if (preFetchTimeouts[id] !== 'nextTick') clearTimeout(preFetchTimeouts[id]);
			delete preFetchTimeouts[id];
		});
	
		if (options.preFetch) {
			if ((options.preFetch === true) || isNaN(options.preFetch)) {
				preFetchAge = 0.333;
			} else {
				preFetchAge = max(min(Number(options.preFetch), 1), 0);
			}
			if (preFetchAge) {
				preFetchTimeouts = {};
				preFetchAge = (1 - preFetchAge) * maxAge;
				conf.on('get' + postfix, function (id, args, context) {
					if (!preFetchTimeouts[id]) {
						preFetchTimeouts[id] = 'nextTick';
						nextTick(function () {
							var result;
							if (preFetchTimeouts[id] !== 'nextTick') return;
							delete preFetchTimeouts[id];
							conf.delete(id);
							if (options.async) {
								args = aFrom(args);
								args.push(noop);
							}
							result = conf.memoized.apply(context, args);
							if (options.promise) {
								// Supress eventual error warnings
								if (isPromise(result)) {
									if (typeof result.done === 'function') result.done(noop, noop);
									else result.then(noop, noop);
								}
							}
						});
					}
				});
			}
		}
	
		conf.on('clear' + postfix, function () {
			forEach(timeouts, function (id) { clearTimeout(id); });
			timeouts = {};
			if (preFetchTimeouts) {
				forEach(preFetchTimeouts, function (id) {
					if (id !== 'nextTick') clearTimeout(id);
				});
				preFetchTimeouts = {};
			}
		});
	};


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toPosInt   = __webpack_require__(842)
	  , maxTimeout = __webpack_require__(902);
	
	module.exports = function (value) {
		value = toPosInt(value);
		if (value > maxTimeout) throw new TypeError(value + " exceeds maximum possible timeout");
		return value;
	};


/***/ },
/* 902 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = 2147483647;


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	// Limit cache size, LRU (least recently used) algorithm.
	
	'use strict';
	
	var toPosInteger = __webpack_require__(842)
	  , lruQueue     = __webpack_require__(904)
	  , extensions   = __webpack_require__(852);
	
	extensions.max = function (max, conf, options) {
		var postfix, queue, hit;
	
		max = toPosInteger(max);
		if (!max) return;
	
		queue = lruQueue(max);
		postfix = ((options.async && extensions.async) || (options.promise && extensions.promise))
			? 'async' : '';
	
		conf.on('set' + postfix, hit = function (id) {
			id = queue.hit(id);
			if (id === undefined) return;
			conf.delete(id);
		});
		conf.on('get' + postfix, hit);
		conf.on('delete' + postfix, queue.delete);
		conf.on('clear' + postfix, queue.clear);
	};


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toPosInt = __webpack_require__(842)
	
	  , create = Object.create, hasOwnProperty = Object.prototype.hasOwnProperty;
	
	module.exports = function (limit) {
		var size = 0, base = 1, queue = create(null), map = create(null), index = 0, del;
		limit = toPosInt(limit);
		return {
			hit: function (id) {
				var oldIndex = map[id], nuIndex = ++index;
				queue[nuIndex] = id;
				map[id] = nuIndex;
				if (!oldIndex) {
					++size;
					if (size <= limit) return;
					id = queue[base];
					del(id);
					return id;
				}
				delete queue[oldIndex];
				if (base !== oldIndex) return;
				while (!hasOwnProperty.call(queue, ++base)) continue; //jslint: skip
			},
			delete: del = function (id) {
				var oldIndex = map[id];
				if (!oldIndex) return;
				delete queue[oldIndex];
				delete map[id];
				--size;
				if (base !== oldIndex) return;
				if (!size) {
					index = 0;
					base = 1;
					return;
				}
				while (!hasOwnProperty.call(queue, ++base)) continue; //jslint: skip
			},
			clear: function () {
				size = 0;
				base = 1;
				queue = create(null);
				map = create(null);
				index = 0;
			}
		};
	};


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	// Reference counter, useful for garbage collector like functionality
	
	'use strict';
	
	var d          = __webpack_require__(863)
	  , extensions = __webpack_require__(852)
	
	  , create = Object.create, defineProperties = Object.defineProperties;
	
	extensions.refCounter = function (ignore, conf, options) {
		var cache, postfix;
	
		cache = create(null);
		postfix = ((options.async && extensions.async) || (options.promise && extensions.promise))
			? 'async' : '';
	
		conf.on('set' + postfix, function (id, length) { cache[id] = length || 1; });
		conf.on('get' + postfix, function (id) { ++cache[id]; });
		conf.on('delete' + postfix, function (id) { delete cache[id]; });
		conf.on('clear' + postfix, function () { cache = {}; });
	
		defineProperties(conf.memoized, {
			deleteRef: d(function () {
				var id = conf.get(arguments);
				if (id === null) return null;
				if (!cache[id]) return null;
				if (!--cache[id]) {
					conf.delete(id);
					return true;
				}
				return false;
			}),
			getRefCount: d(function () {
				var id = conf.get(arguments);
				if (id === null) return 0;
				if (!cache[id]) return 0;
				return cache[id];
			})
		});
	};


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MAX_PARTICIPANTS_REPLIES_ENABLE = exports.TYPES = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _ChatMembership = __webpack_require__(920);
	
	var _ChatMembership2 = _interopRequireDefault(_ChatMembership);
	
	var _ChatMemberships = __webpack_require__(926);
	
	var _ChatMemberships2 = _interopRequireDefault(_ChatMemberships);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TYPES = exports.TYPES = {
	  ACTIVITY: 'activity',
	  GROUP: 'group',
	  INDIVIDUAL: 'individual',
	  ASSISTANT: 'assistant'
	};
	
	var MAX_PARTICIPANTS_REPLIES_ENABLE = exports.MAX_PARTICIPANTS_REPLIES_ENABLE = 200;
	
	var Chat = function (_Entity) {
	  _inherits(Chat, _Entity);
	
	  function Chat() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Chat);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Chat.__proto__ || Object.getPrototypeOf(Chat)).call.apply(_ref, [this].concat(args))), _this), _this.getDisplayNames = _lodash2.default.memoize(function () {
	      var present = _this.getOtherChatMembershipsWithState('present');
	      var names = present.map(function (membership) {
	        return membership.getMember().getName();
	      });
	
	      if (names.length === 0) {
	        var ownerMembership = _this.getOwnerChatMembership();
	        if (ownerMembership) {
	          names = [ownerMembership.getMember().getName()];
	        }
	      }
	
	      return names;
	    }), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Chat, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.idAttribute = 'uuid';
	      this.urlRoot = '/chats';
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      // typecheck: ignore statement
	      return {
	        active: true,
	        can_close: true,
	        can_open: false,
	        group_summaries: [],
	        memberships: [],
	        last_read_seq: null,
	        present: true,
	        state: 'open',
	        can_send: true,
	        updated_at: new Date()
	      };
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var chat = (0, _lodash.cloneDeep)(response);
	
	      if (chat['last_message']) {
	        chat['last_message'] = _ChatMessage2.default.fromJSON(chat['last_message']);
	      }
	
	      if (chat['activity']) {
	        chat['activity'] = _Activity2.default.fromJSON(chat['activity']);
	      }
	
	      chat['memberships'] = _ChatMemberships2.default.fromJSON(chat['memberships']);
	      chat['updated_at'] = new Date(chat['updated_at']);
	      return chat;
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive() {
	      return !!this.get('active');
	    }
	  }, {
	    key: 'hasTitle',
	    value: function hasTitle() {
	      return this.get('title').length > 0;
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      return this.get('title');
	    }
	  }, {
	    key: 'getQueryKey',
	    value: function getQueryKey() {
	      return this.get('query_key');
	    }
	  }, {
	    key: 'canAdd',
	    value: function canAdd() {
	      return !!this.get('can_add');
	    }
	  }, {
	    key: 'canManageReplies',
	    value: function canManageReplies() {
	      return !!this.get('can_manage_replies');
	    }
	  }, {
	    key: 'canOpen',
	    value: function canOpen() {
	      return !!this.get('can_open');
	    }
	  }, {
	    key: 'canLeave',
	    value: function canLeave() {
	      return !!this.get('can_leave');
	    }
	  }, {
	    key: 'canSend',
	    value: function canSend() {
	      return !!this.get('can_send');
	    }
	  }, {
	    key: 'hasRepliesDisabled',
	    value: function hasRepliesDisabled() {
	      return this.getState() === 'replies_disabled';
	    }
	  }, {
	    key: 'isInGroup',
	    value: function isInGroup(groupId) {
	      return !!this.get('group_summaries').find(function (group) {
	        return group.id === groupId;
	      });
	    }
	  }, {
	    key: 'isRemoved',
	    value: function isRemoved() {
	      return this.getState() === 'removed';
	    }
	  }, {
	    key: 'isDead',
	    value: function isDead() {
	      return this.getState() === 'dead';
	    }
	  }, {
	    key: 'hasLeft',
	    value: function hasLeft() {
	      return this.getState() === 'left';
	    }
	  }, {
	    key: 'isOpen',
	    value: function isOpen() {
	      return this.getState() === 'open';
	    }
	  }, {
	    key: 'getMaximumMembers',
	    value: function getMaximumMembers() {
	      return this.get('maximum_members');
	    }
	  }, {
	    key: 'hasReachedParticipantNumberLimit',
	    value: function hasReachedParticipantNumberLimit() {
	      return this.getPresentMemberships().length >= this.getMaximumMembers();
	    }
	
	    // NOTE: Not to be confused with the !this.isActive()
	
	  }, {
	    key: 'isInactive',
	    value: function isInactive() {
	      return this.hasLeft() || this.isRemoved() || this.isDead();
	    }
	  }, {
	    key: 'getCreatorId',
	    value: function getCreatorId() {
	      return this.get('creator_id');
	    }
	  }, {
	    key: 'getActivity',
	    value: function getActivity() {
	      return this.get('activity');
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.get('type');
	    }
	  }, {
	    key: 'isActivityType',
	    value: function isActivityType() {
	      return this.getType() === TYPES.ACTIVITY;
	    }
	  }, {
	    key: 'isAssistantType',
	    value: function isAssistantType() {
	      return this.getType() === TYPES.ASSISTANT;
	    }
	  }, {
	    key: 'isGroupType',
	    value: function isGroupType() {
	      return this.getType() === TYPES.GROUP;
	    }
	  }, {
	    key: 'isIndividualType',
	    value: function isIndividualType() {
	      return this.getType() === TYPES.INDIVIDUAL;
	    }
	  }, {
	    key: 'getLastMessage',
	    value: function getLastMessage() {
	      return this.get('last_message');
	    }
	
	    // TODO: Get rid of this (immutable data)
	
	  }, {
	    key: 'setLastMessage',
	    value: function setLastMessage(message) {
	      return this.set({ last_message: message });
	    }
	
	    // legacy state
	
	  }, {
	    key: 'isPaused',
	    value: function isPaused() {
	      return this.getState() === 'paused';
	    }
	
	    // legacy state
	
	  }, {
	    key: 'isClosed',
	    value: function isClosed() {
	      return this.getState() === 'closed';
	    }
	
	    // We still received pusher update on groups
	    // with the old states, this helper handles it.
	
	  }, {
	    key: 'isDisabled',
	    value: function isDisabled() {
	      return this.isPaused() || this.hasRepliesDisabled() || this.isClosed();
	    }
	  }, {
	    key: 'hasMutedMembers',
	    value: function hasMutedMembers() {
	      return !!this.get('has_muted_members');
	    }
	  }, {
	    key: 'getGroupSummaries',
	    value: function getGroupSummaries() {
	      return this.get('group_summaries');
	    }
	  }, {
	    key: 'getAssociatedGroupUuids',
	    value: function getAssociatedGroupUuids() {
	      return this.getGroupSummaries().map(function (summary) {
	        return summary.uuid;
	      });
	    }
	
	    // HACK param because of circular dependencies
	
	  }, {
	    key: 'markAsReadForAssociatedGroups',
	    value: function markAsReadForAssociatedGroups(unreadStore) {
	      var unreadCount = this.getUnreadMessages();
	      if (!unreadCount) {
	        return;
	      }
	
	      var groupUuids = this.getAssociatedGroupUuids();
	      groupUuids.forEach(function (uuid) {
	        return unreadStore.decrementUnreads(uuid, unreadCount);
	      });
	    }
	  }, {
	    key: 'getLastReadSeq',
	    value: function getLastReadSeq() {
	      return this.get('last_read_seq');
	    }
	
	    // Note: may not be loaded if the chat is loaded by v2/chats
	    // This should return ChatMemberships but with ChatMembershipsMock it returns ChatMembership[]
	
	  }, {
	    key: 'getMemberships',
	    value: function getMemberships() {
	      return this.get('memberships');
	    }
	
	    // Note: may not be loaded if the chat is loaded by v2/chats
	
	  }, {
	    key: 'getMemberIds',
	    value: function getMemberIds() {
	      return this.getMemberships().map(function (membership) {
	        return membership.getMember().id;
	      });
	    }
	
	    // Chats now have origin_ids which are the groups the chat should be attached to
	    // (For example, what group was the user in when they created the chat?)
	
	  }, {
	    key: 'getOriginIds',
	    value: function getOriginIds() {
	      return this.get('origin_ids');
	    }
	  }, {
	    key: 'isPresent',
	    value: function isPresent() {
	      return this.get('present');
	    }
	  }, {
	    key: 'getLeftMemberships',
	    value: function getLeftMemberships() {
	      return this.getMemberships().filter(function (membership) {
	        return membership.getState() === 'left';
	      });
	    }
	  }, {
	    key: 'getPresentMemberships',
	    value: function getPresentMemberships() {
	      return this.getMemberships().filter(function (membership) {
	        return membership.getState() === 'present';
	      });
	    }
	  }, {
	    key: 'getOtherPresentMemberships',
	    value: function getOtherPresentMemberships(currentUserId) {
	      return this.getMemberships().filter(function (membership) {
	        return membership.getState() === 'present' && membership.getMember().id !== currentUserId;
	      });
	    }
	  }, {
	    key: 'getOtherChatMemberships',
	    value: function getOtherChatMemberships() {
	      var allowEmpty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      // XXX remove CurrentUser from entities
	      var CurrentUser = __webpack_require__(576).default;
	      var currentUserId = CurrentUser.getUserId();
	      var memberships = new _ChatMemberships2.default(this.getMemberships().filter(function (membership) {
	        return membership.getMember().id !== currentUserId;
	      }));
	
	      // Note: this is a temporary fix until the backend fixes issues with deleted chat memberships
	      return memberships.length > 0 || allowEmpty ? memberships : this.getMemberships();
	    }
	  }, {
	    key: 'getOtherChatMembers',
	    value: function getOtherChatMembers() {
	      var allowEmpty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      return this.getOtherChatMemberships(allowEmpty).map(function (membership) {
	        return membership.getMember();
	      });
	    }
	  }, {
	    key: 'getOwnerChatMembership',
	    value: function getOwnerChatMembership() {
	      var _this2 = this;
	
	      return this.getMemberships().filter(function (membership) {
	        return membership.getMember().id === _this2.getCreatorId();
	      })[0];
	    }
	  }, {
	    key: 'getOtherChatMembershipsWithState',
	    value: function getOtherChatMembershipsWithState(state) {
	      return this.getOtherChatMemberships().reduce(function (results, membership) {
	        if (!state || membership.getState() === state) {
	          results.push(membership);
	        }
	        return results;
	      }, []);
	    }
	  }, {
	    key: 'getMembership',
	    value: function getMembership(member) {
	      var memberships = this.getMemberships().filter(function (membership) {
	        return membership.getMember().id === member.id;
	      });
	
	      return memberships[0];
	    }
	  }, {
	    key: 'isPresentMember',
	    value: function isPresentMember(member) {
	      var membership = this.getMembership(member);
	      return !!membership && membership.isPresent();
	    }
	  }, {
	    key: 'createNewMembership',
	    value: function createNewMembership(member) {
	      this.getMemberships().add(_ChatMembership2.default.create(member));
	    }
	  }, {
	    key: 'addToMemberships',
	    value: function addToMemberships(membership) {
	      this.getMemberships().add(membership);
	    }
	  }, {
	    key: 'removeFromMemberships',
	    value: function removeFromMemberships(membership) {
	      this.getMemberships().remove(membership);
	    }
	
	    /* DEPRECATED, use isGroupType */
	
	  }, {
	    key: 'isGroupChat',
	    value: function isGroupChat() {
	      return this.getMemberships().length > 2;
	    }
	  }, {
	    key: 'getState',
	    value: function getState() {
	      return this.get('state');
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      return this.get('color');
	    }
	  }, {
	    key: 'getUnreadMessages',
	    value: function getUnreadMessages() {
	      return this.get('unread_messages');
	    }
	  }, {
	    key: 'getUpdatedAt',
	    value: function getUpdatedAt() {
	      return this.get('updated_at');
	    }
	
	    // TODO: Get rid of this (immutable data)
	
	  }, {
	    key: 'setUpdatedAt',
	    value: function setUpdatedAt(date) {
	      this.set({ updated_at: date });
	    }
	  }, {
	    key: 'isUnsubscribed',
	    value: function isUnsubscribed() {
	      return this.get('state') === 'dead';
	    }
	
	    // TODO: Get rid of this? (immutable data)
	
	  }, {
	    key: 'markAsRead',
	    value: function markAsRead() {
	      this.set({ unread_messages: 0 });
	      var lastMessage = this.getLastMessage();
	      if (lastMessage) {
	        this.set({ last_read_seq: lastMessage.getSeq() });
	      }
	    }
	  }, {
	    key: 'deactivate',
	    value: function deactivate() {
	      this.set({ active: false });
	    }
	  }, {
	    key: 'leave',
	    value: function leave() {
	      return this.save({
	        active: this.getMemberships().where({ state: 'present' }).length - 1 > 1,
	        can_open: true,
	        present: false
	      }, {
	        data: { chat: { present: false } },
	        patch: true
	      });
	    }
	  }, {
	    key: 'initiate',
	    value: function initiate(message) {
	      return (0, _apiRequest2.default)('/chats', 'POST', {
	        chat: {
	          origin_ids: this.getOriginIds(),
	          member_ids: this.getMemberIds(),
	          message: {
	            body: message.getBody(),
	            file: message.getFile(),
	            uuid: message.getUuid()
	          }
	        }
	      }).then(function (chat) {
	        return Chat.fromJSON(chat);
	      });
	    }
	  }, {
	    key: 'isOutsideOfOtherOfficeHours',
	    value: function isOutsideOfOtherOfficeHours() {
	      return this.getOtherChatMembers().some(function (member) {
	        var officeHours = member.getOfficeHours();
	        if (officeHours && !officeHours.isAvailableNow()) {
	          return true;
	        }
	        return false;
	      });
	    }
	  }, {
	    key: 'getOtherMember',
	    value: function getOtherMember() {
	      return this.get('other_member');
	    }
	  }, {
	    key: 'getSortKey',
	    value: function getSortKey() {
	      return this.get('sort_key');
	    }
	
	    // Extract the timestamp from sort_key. If it fails, fall back to updated_at
	
	  }, {
	    key: 'getSortKeyTimestamp',
	    value: function getSortKeyTimestamp() {
	      try {
	        var parsedDate = new Date(this.getSortKey().split('UTC')[0] + 'UTC');
	        if (isNaN(parsedDate.getTime())) {
	          // Detect 'Invalid Date'
	          return this.getUpdatedAt();
	        }
	        return parsedDate;
	      } catch (e) {} // eslint-disable-line
	      return this.getUpdatedAt();
	    }
	  }, {
	    key: 'addMembers',
	    value: function addMembers(membersIds) {
	      return (0, _apiRequest2.default)('/chats/' + this.id + '/members', 'POST', {
	        member_ids: membersIds
	      }).then(function (memberships) {
	        return memberships.map(function (m) {
	          return _ChatMembership2.default.fromJSON(m);
	        });
	      });
	    }
	  }, {
	    key: 'changeMemberStatus',
	    value: function changeMemberStatus(membersId, state) {
	      return (0, _apiRequest2.default)('/chats/' + this.id + '/members/' + membersId, 'PATCH', {
	        member: { state: state }
	      }).then(function (membership) {
	        return _ChatMembership2.default.fromJSON(membership);
	      });
	    }
	  }, {
	    key: 'disableReplies',
	    value: function disableReplies() {
	      return (0, _apiRequest2.default)('/chats/' + this.id, 'PATCH', {
	        chat: { state: 'replies_disabled' }
	      }).then(function (chat) {
	        return Chat.fromJSON(chat);
	      });
	    }
	  }, {
	    key: 'enableReplies',
	    value: function enableReplies() {
	      return (0, _apiRequest2.default)('/chats/' + this.id, 'PATCH', {
	        chat: { state: 'open' }
	      }).then(function (chat) {
	        return Chat.fromJSON(chat);
	      });
	    }
	  }, {
	    key: 'updateTitle',
	    value: function updateTitle(title) {
	      return this.save({
	        chat: { title: title }
	      }, {
	        patch: true
	      });
	    }
	
	    // memoize so this calculation doesn't create a new object
	    // and bust the shallow compare.
	
	  }], [{
	    key: 'createLocal',
	    value: function createLocal(members, title) {
	      var originIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	      var memberships = new _ChatMemberships2.default(members.map(function (member) {
	        return _ChatMembership2.default.create(member);
	      }));
	      var otherChatMember = memberships.first().getMember();
	
	      return new Chat({
	        memberships: memberships,
	        other_member: {
	          color: otherChatMember.getColor() || '',
	          id: -1,
	          initials: otherChatMember.getInitials() || '',
	          name: ''
	        },
	        origin_ids: originIds,
	        title: title,
	        type: members.length === 2 ? TYPES.INDIVIDUAL : TYPES.GROUP
	      });
	    }
	  }, {
	    key: 'markReadUpto',
	    value: function markReadUpto(chatId, seq) {
	      return (0, _apiRequest2.default)('/chats/' + chatId, 'PATCH', {
	        chat: {
	          last_read_seq: seq
	        }
	      });
	    }
	  }, {
	    key: 'emailTranscript',
	    value: function emailTranscript(chatId) {
	      return (0, _apiRequest2.default)('/chats/' + chatId + '/email_transcript', 'POST', {});
	    }
	  }, {
	    key: 'reportChat',
	    value: function reportChat(chatId, uuid, reason, notes) {
	      var reasonAndNotes = notes ? reason + ' - ' + notes : reason;
	      return (0, _apiRequest2.default)('/chats/' + chatId + '/report', 'POST', {
	        uuid: chatId,
	        chat: {
	          reason: reasonAndNotes,
	          reported_user_uuid: uuid
	        }
	      });
	    }
	  }]);
	
	  return Chat;
	}(_Entity3.default);
	
	Chat.displayName = 'Chat';
	exports.default = Chat;

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ACTIVITY_PRINTED_MSG = exports.TYPES = exports.SHARE_MODAL = exports.ATTENDANCE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _ActivityRecipients = __webpack_require__(910);
	
	var _ActivityRecipients2 = _interopRequireDefault(_ActivityRecipients);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _RecipientSummary = __webpack_require__(911);
	
	var _RecipientSummary2 = _interopRequireDefault(_RecipientSummary);
	
	var _RelatedUserSummary = __webpack_require__(909);
	
	var _RelatedUserSummary2 = _interopRequireDefault(_RelatedUserSummary);
	
	var _jstimezonedetect = __webpack_require__(570);
	
	var _jstimezonedetect2 = _interopRequireDefault(_jstimezonedetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ATTENDANCE = exports.ATTENDANCE = {
	  YES: 'yes',
	  NO: 'no',
	  MAYBE: 'maybe',
	  PENDING: 'pending'
	};
	
	var SHARE_MODAL = exports.SHARE_MODAL = 'share_modal';
	
	var TYPES = exports.TYPES = {
	  FIELD_TRIP: 'field_trip',
	  ORDER: 'order',
	  EVENT: 'event',
	  FUNDRAISER: 'fundraiser'
	};
	
	var ACTIVITY_PRINTED_MSG = exports.ACTIVITY_PRINTED_MSG = 'We’ve emailed you the Activity record you’ve requested. You should receive it within 10 minutes.';
	
	var ActivityCover = function ActivityCover(image, color) {
	  _classCallCheck(this, ActivityCover);
	
	  this.image = image;
	  this.color = color;
	};
	
	ActivityCover.displayName = 'ActivityCover';
	
	
	var COVERS = {
	  field_trip: new ActivityCover(__webpack_require__(912), '#F4FBFF'),
	  order: new ActivityCover(__webpack_require__(913), '#F8F8F8'),
	  event: new ActivityCover(__webpack_require__(914), '#EFF9F8'),
	  fundraiser: new ActivityCover(__webpack_require__(915), '#E9FBF7')
	};
	
	var THUMBNAILS = {
	  field_trip: new ActivityCover(__webpack_require__(916), '#F4FBFF'),
	  order: new ActivityCover(__webpack_require__(917), '#F8F8F8'),
	  event: new ActivityCover(__webpack_require__(918), '#EFF9F8'),
	  fundraiser: new ActivityCover(__webpack_require__(919), '#E9FBF7')
	};
	
	var DEFAULT_COVER = COVERS['fundraiser'];
	var DEFAULT_THUMBNAIL = THUMBNAILS['fundraiser'];
	
	var Activity = function (_Entity) {
	  _inherits(Activity, _Entity);
	
	  function Activity() {
	    _classCallCheck(this, Activity);
	
	    return _possibleConstructorReturn(this, (Activity.__proto__ || Object.getPrototypeOf(Activity)).apply(this, arguments));
	  }
	
	  _createClass(Activity, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.idAttribute = 'uuid';
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        amount_per_person: 0,
	        is_sender: false,
	        requester: new _RelatedUserSummary2.default(),
	        title: '',
	        transactions_count: 0,
	        group_summaries: []
	      };
	    }
	  }, {
	    key: 'getPayUrl',
	    value: function getPayUrl() {
	      return this.get('pay_url');
	    }
	  }, {
	    key: 'getGroupSummaries',
	    value: function getGroupSummaries() {
	      return this.get('group_summaries');
	    }
	  }, {
	    key: 'getRequester',
	    value: function getRequester() {
	      return this.get('requester');
	    }
	  }, {
	    key: 'getEventType',
	    value: function getEventType() {
	      return this.get('event_type');
	    }
	  }, {
	    key: 'getCover',
	    value: function getCover() {
	      var eventType = this.getEventType();
	      return COVERS[eventType] || DEFAULT_COVER;
	    }
	  }, {
	    key: 'getThumbnail',
	    value: function getThumbnail() {
	      var eventType = this.getEventType();
	      return THUMBNAILS[eventType] || DEFAULT_THUMBNAIL;
	    }
	  }, {
	    key: 'getAmountPerPerson',
	    value: function getAmountPerPerson() {
	      return this.get('amount_per_person');
	    }
	  }, {
	    key: 'hasChildren',
	    value: function hasChildren() {
	      return !!this.get('has_children');
	    }
	  }, {
	    key: 'hasDisableReplies',
	    value: function hasDisableReplies() {
	      return !!this.get('disable_replies');
	    }
	  }, {
	    key: 'isOrHasCollectedMoneyOnline',
	    value: function isOrHasCollectedMoneyOnline() {
	      return this.isCollectingMoneyOnline() || this.getTransactionsCount() > 0;
	    }
	  }, {
	    key: 'isCollectingMoneyOnline',
	    value: function isCollectingMoneyOnline() {
	      return !this.isFree() && this.get('collect_online');
	    }
	  }, {
	    key: 'isInGroup',
	    value: function isInGroup(group) {
	      return group.isRoot() || !!this.get('group_summaries').find(function (gs) {
	        return gs.name === group.getCode();
	      });
	    }
	  }, {
	    key: 'isFree',
	    value: function isFree() {
	      return !this.getAmountPerPerson();
	    }
	  }, {
	    key: 'getTotalCollected',
	    value: function getTotalCollected() {
	      return this.get('total_collected');
	    }
	  }, {
	    key: 'getTotalDeposited',
	    value: function getTotalDeposited() {
	      return this.get('total_deposited');
	    }
	  }, {
	    key: 'getCurrentBalance',
	    value: function getCurrentBalance() {
	      return this.get('current_balance');
	    }
	  }, {
	    key: 'getTransactionsCount',
	    value: function getTransactionsCount() {
	      return this.get('transactions_count');
	    }
	  }, {
	    key: 'getRespondedUsersSample',
	    value: function getRespondedUsersSample() {
	      return this.get('responded_users_sample') || [];
	    }
	  }, {
	    key: 'isSender',
	    value: function isSender() {
	      return this.get('is_sender');
	    }
	  }, {
	    key: 'isClosed',
	    value: function isClosed() {
	      return this.get('state') === 'closed';
	    }
	  }, {
	    key: 'isBlocked',
	    value: function isBlocked() {
	      return this.get('state') === 'blocked';
	    }
	  }, {
	    key: 'hasPaid',
	    value: function hasPaid() {
	      return this.get('has_paid');
	    }
	  }, {
	    key: 'hasResponded',
	    value: function hasResponded() {
	      return this.get('has_responded');
	    }
	  }, {
	    key: 'getViewingUserResponse',
	    value: function getViewingUserResponse() {
	      console.error('undefined getViewingUserResponse, listen to activityRecipients instead');
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      return this.get('title');
	    }
	  }, {
	    key: 'getWelcomeMsgBody',
	    value: function getWelcomeMsgBody() {
	      return this.get('welcome_msg_body');
	    }
	  }, {
	    key: 'getLocation',
	    value: function getLocation() {
	      return this.get('location');
	    }
	  }, {
	    key: 'getCreatedAt',
	    value: function getCreatedAt() {
	      return this.get('created_at');
	    }
	  }, {
	    key: 'getStartAt',
	    value: function getStartAt() {
	      return this.get('start_at');
	    }
	  }, {
	    key: 'getEndAt',
	    value: function getEndAt() {
	      return this.get('end_at');
	    }
	  }, {
	    key: 'getFee',
	    value: function getFee() {
	      return this.get('fee');
	    }
	  }, {
	    key: 'getRecipientSummary',
	    value: function getRecipientSummary() {
	      return this.get('recipient_summary');
	    }
	  }, {
	    key: 'getChatUuid',
	    value: function getChatUuid() {
	      var uuid = null;
	      if (this.get('chat')) {
	        uuid = this.get('chat').uuid;
	      }
	      return uuid;
	    }
	
	    // typecheck: ignore statement
	
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var request = (0, _lodash.cloneDeep)(response);
	
	      if ('created_at' in request && request['created_at'] !== null) {
	        request['created_at'] = new Date(request['created_at']);
	      }
	
	      if ('start_at' in request && request['start_at'] !== null) {
	        request['start_at'] = new Date(request['start_at']);
	      }
	
	      if ('end_at' in request && request['end_at'] !== null) {
	        request['end_at'] = new Date(request['end_at']);
	      }
	
	      if ('requester' in request) {
	        request['requester'] = _RelatedUserSummary2.default.fromJSON(request['requester']);
	      }
	
	      if ('viewing_user_response' in request) {
	        request['viewing_user_response'] = _ActivityRecipient2.default.fromJSON(request['viewing_user_response']);
	      }
	
	      if ('recipient_summary' in request) {
	        request['recipient_summary'] = _RecipientSummary2.default.fromJSON(request['recipient_summary']);
	      }
	
	      return request;
	    }
	
	    // typecheck: ignore statement
	
	  }, {
	    key: 'close',
	    value: function close() {
	      return (0, _apiRequest2.default)('/activities/' + this.id, 'PATCH', {
	        activity: { state: 'closed' }
	      }).then(function (response) {
	        return Activity.fromJSON(response);
	      });
	    }
	  }, {
	    key: 'createRSVP',
	    value: function createRSVP(opts) {
	      return (0, _apiRequest2.default)('/activities/' + this.id + '/recipient_response', 'POST', opts).then(function (response) {
	        return _ActivityRecipient2.default.fromJSON(response);
	      });
	    }
	  }], [{
	    key: 'create',
	    value: function create(params) {
	      return (0, _apiRequest2.default)('/activities', 'POST', {
	        activity: {
	          title: params.title,
	          amount_per_person: params.amountPerPerson,
	          location: params.location,
	          has_children: params.hasChildren,
	          start_at: params.date,
	          end_at: params.endDate,
	          group_ids: params.groupIds,
	          collect_online: params.collectOnline,
	          recipient_ids: params.individualIds,
	          disable_replies: params.disableReplies,
	          welcome_msg_body: params.welcomeMsgBody,
	          event_type: params.type,
	          targets: params.targets
	        }
	      }).then(function (request) {
	        return Activity.fromJSON(request);
	      });
	    }
	  }, {
	    key: 'edit',
	    value: function edit(params) {
	      return (0, _apiRequest2.default)('/activities/' + params.activity.id, 'PATCH', {
	        activity: {
	          amount_per_person: params.amountPerPerson,
	          welcome_msg_body: params.welcomeMsgBody,
	          collect_online: params.collectOnline,
	          has_children: params.hasChildren,
	          location: params.location,
	          end_at: params.endDate,
	          start_at: params.date,
	          title: params.title
	        }
	      }).then(function (response) {
	        return Activity.fromJSON(response);
	      });
	    }
	  }, {
	    key: 'getCurrentUserRecipientResponse',
	    value: function getCurrentUserRecipientResponse(activityUuid) {
	      return (0, _apiRequest2.default)('/activities/' + activityUuid + '/recipient_response', 'GET').then(function (response) {
	        return _ActivityRecipient2.default.fromJSON(response);
	      });
	    }
	  }, {
	    key: 'getRecipients',
	    value: function getRecipients(activityId) {
	      return (0, _apiRequest2.default)('/activities/' + activityId + '/recipients', 'GET').then(function (response) {
	        return _ActivityRecipients2.default.fromJSON(response.recipients ? response.recipients : response);
	      });
	    }
	  }, {
	    key: 'export',
	    value: function _export(activityId) {
	      var tz = _jstimezonedetect2.default.determine();
	      var timezone = tz.name();
	      return (0, _apiRequest2.default)('/activities/' + activityId + '/export', 'POST', {
	        time_zone: timezone
	      });
	    }
	  }, {
	    key: 'findByUuid',
	    value: function findByUuid(requestUuid) {
	      return (0, _apiRequest2.default)('/activities/' + requestUuid, 'GET').then(function (response) {
	        return Activity.fromJSON(response);
	      });
	    }
	  }]);
	
	  return Activity;
	}(_Entity3.default);
	
	Activity.displayName = 'Activity';
	exports.default = Activity;

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RECIPIENT_DECLINED = exports.RECIPIENT_MAYBE = exports.RECIPIENT_ATTENDING = exports.RECIPIENT_PENDING = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _RelatedUserSummary = __webpack_require__(909);
	
	var _RelatedUserSummary2 = _interopRequireDefault(_RelatedUserSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RECIPIENT_PENDING = exports.RECIPIENT_PENDING = 'pending';
	var RECIPIENT_ATTENDING = exports.RECIPIENT_ATTENDING = 'yes';
	var RECIPIENT_MAYBE = exports.RECIPIENT_MAYBE = 'maybe';
	var RECIPIENT_DECLINED = exports.RECIPIENT_DECLINED = 'no';
	
	var ActivityRecipient = function (_Entity) {
	  _inherits(ActivityRecipient, _Entity);
	
	  function ActivityRecipient() {
	    _classCallCheck(this, ActivityRecipient);
	
	    return _possibleConstructorReturn(this, (ActivityRecipient.__proto__ || Object.getPrototypeOf(ActivityRecipient)).apply(this, arguments));
	  }
	
	  _createClass(ActivityRecipient, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.idAttribute = 'uuid';
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var recipient = (0, _lodash.cloneDeep)(response);
	
	      if ('created_at' in recipient) {
	        recipient['created_at'] = new Date(recipient['created_at']);
	      }
	
	      if ('user' in recipient) {
	        recipient['user'] = new _RelatedUserSummary2.default(recipient['user']);
	      }
	
	      return recipient;
	    }
	  }, {
	    key: 'getActivityUuid',
	    value: function getActivityUuid() {
	      return this.get('activity_uuid');
	    }
	  }, {
	    key: 'getUserUuid',
	    value: function getUserUuid() {
	      return this.get('user_uuid');
	    }
	  }, {
	    key: 'getCreatedAt',
	    value: function getCreatedAt() {
	      return this.get('created_at');
	    }
	  }, {
	    key: 'getAttendance',
	    value: function getAttendance() {
	      return this.get('attendance');
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress() {
	      return this.get('address');
	    }
	  }, {
	    key: 'hasPaid',
	    value: function hasPaid() {
	      return this.get('paid');
	    }
	  }, {
	    key: 'getUser',
	    value: function getUser() {
	      return this.get('user');
	    }
	  }, {
	    key: 'getNote',
	    value: function getNote() {
	      return this.get('note');
	    }
	  }, {
	    key: 'claim',
	    value: function claim() {
	      return (0, _apiRequest2.default)('/payments/recipients/' + this.id + '/claim', 'POST').then(function (recipient) {
	        return ActivityRecipient.fromJSON(recipient);
	      });
	    }
	  }], [{
	    key: 'patch',
	    value: function patch(activityId, recipientId, data) {
	      return (0, _apiRequest2.default)('/activities/' + activityId + '/recipient_response/' + recipientId, 'PATCH', data).then(function (response) {
	        return ActivityRecipient.fromJSON(response);
	      });
	    }
	  }]);
	
	  return ActivityRecipient;
	}(_Entity3.default);
	
	ActivityRecipient.displayName = 'ActivityRecipient';
	exports.default = ActivityRecipient;

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RelatedUserSummary = function (_Entity) {
	  _inherits(RelatedUserSummary, _Entity);
	
	  function RelatedUserSummary() {
	    _classCallCheck(this, RelatedUserSummary);
	
	    return _possibleConstructorReturn(this, (RelatedUserSummary.__proto__ || Object.getPrototypeOf(RelatedUserSummary)).apply(this, arguments));
	  }
	
	  _createClass(RelatedUserSummary, [{
	    key: 'getUuid',
	    value: function getUuid() {
	      return this.get('uuid');
	    }
	  }, {
	    key: 'getFirstName',
	    value: function getFirstName() {
	      return this.get('first_name');
	    }
	  }, {
	    key: 'getLastName',
	    value: function getLastName() {
	      return this.get('last_name');
	    }
	  }, {
	    key: 'getDisplayName',
	    value: function getDisplayName() {
	      return this.get('display_name');
	    }
	  }, {
	    key: 'getInitials',
	    value: function getInitials() {
	      return this.get('initials');
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      return this.get('color');
	    }
	  }]);
	
	  return RelatedUserSummary;
	}(_Entity3.default);
	
	RelatedUserSummary.displayName = 'RelatedUserSummary';
	exports.default = RelatedUserSummary;

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityRecipients = function (_Collection) {
	  _inherits(ActivityRecipients, _Collection);
	
	  function ActivityRecipients() {
	    _classCallCheck(this, ActivityRecipients);
	
	    return _possibleConstructorReturn(this, (ActivityRecipients.__proto__ || Object.getPrototypeOf(ActivityRecipients)).apply(this, arguments));
	  }
	
	  _createClass(ActivityRecipients, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _ActivityRecipient2.default;
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      return response.map(function (recipient) {
	        return _ActivityRecipient2.default.fromJSON(recipient);
	      });
	    }
	  }]);
	
	  return ActivityRecipients;
	}(_Collection3.default);
	
	ActivityRecipients.displayName = 'ActivityRecipients';
	exports.default = ActivityRecipients;

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecipientSummary = function (_Entity) {
	  _inherits(RecipientSummary, _Entity);
	
	  function RecipientSummary() {
	    _classCallCheck(this, RecipientSummary);
	
	    return _possibleConstructorReturn(this, (RecipientSummary.__proto__ || Object.getPrototypeOf(RecipientSummary)).apply(this, arguments));
	  }
	
	  _createClass(RecipientSummary, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.idAttribute = 'uuid';
	    }
	  }, {
	    key: 'getNotAttendingCount',
	    value: function getNotAttendingCount() {
	      return this.get('not_attending_count');
	    }
	  }, {
	    key: 'getAttendingCount',
	    value: function getAttendingCount() {
	      return this.get('attending_count');
	    }
	  }, {
	    key: 'getNotRespondingCount',
	    value: function getNotRespondingCount() {
	      return this.get('not_responded_count');
	    }
	  }, {
	    key: 'getPaidCount',
	    value: function getPaidCount() {
	      return this.get('paid_count');
	    }
	  }, {
	    key: 'getInvitedCount',
	    value: function getInvitedCount() {
	      return this.get('invited_count');
	    }
	  }, {
	    key: 'getMaybeCount',
	    value: function getMaybeCount() {
	      return this.get('maybe_count');
	    }
	  }, {
	    key: 'getResponsesCount',
	    value: function getResponsesCount() {
	      return this.getAttendingCount() + this.getNotAttendingCount() + this.getMaybeCount();
	    }
	  }]);
	
	  return RecipientSummary;
	}(_Entity3.default);
	
	RecipientSummary.displayName = 'RecipientSummary';
	exports.default = RecipientSummary;

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "239559f6c37a7bd0a0f9ae0cb7f2d991.png";

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dbcc900049b5a2f079906ae1fd34c1b5.png";

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a9f0a13274546baf2a414bf0e1d0d0c6.png";

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "42ab61fa478611e961f3bfb9b60ae3b9.png";

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "56687648a7fa8dbe9b6d78318cba1d70.png";

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8d2b75c73cd345d68d4f0dffa68f4d3b.png";

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ee47852b2c759e774a503954262966bc.png";

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "078d726be93fcacb9c3786550b108a15.png";

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatMember = __webpack_require__(921);
	
	var _ChatMember2 = _interopRequireDefault(_ChatMember);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// eslint-disable-line
	
	var ChatMembership = function (_Entity) {
	  _inherits(ChatMembership, _Entity);
	
	  function ChatMembership() {
	    _classCallCheck(this, ChatMembership);
	
	    return _possibleConstructorReturn(this, (ChatMembership.__proto__ || Object.getPrototypeOf(ChatMembership)).apply(this, arguments));
	  }
	
	  _createClass(ChatMembership, [{
	    key: 'parse',
	    value: function parse(response) {
	      var membership = (0, _lodash.cloneDeep)(response);
	      membership['user'] = _ChatMember2.default.fromJSON(membership['user']);
	      if (membership['left_at']) {
	        membership['left_at'] = new Date(membership['left_at']);
	      }
	      if (membership['unsubscribed_at']) {
	        membership['unsubscribed_at'] = new Date(membership['unsubscribed_at']);
	      }
	      return membership;
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        state: 'present'
	      };
	    }
	  }, {
	    key: 'getMember',
	    value: function getMember() {
	      return this.get('user');
	    }
	  }, {
	    key: 'setMember',
	    value: function setMember(member) {
	      return this.set({ user: member });
	    }
	  }, {
	    key: 'canRemove',
	    value: function canRemove() {
	      return !!this.get('can_remove');
	    }
	  }, {
	    key: 'getState',
	    value: function getState() {
	      return this.get('state');
	    }
	  }, {
	    key: 'isPresent',
	    value: function isPresent() {
	      return this.getState() === 'present';
	    }
	  }, {
	    key: 'isCreator',
	    value: function isCreator(chat) {
	      return chat.getCreatorId() === this.getMember().id;
	    }
	  }, {
	    key: 'hasLeft',
	    value: function hasLeft() {
	      return this.getState() === 'left';
	    }
	  }, {
	    key: 'hasBeenRemoved',
	    value: function hasBeenRemoved() {
	      return this.getState() === 'removed';
	    }
	  }, {
	    key: 'leaveChat',
	    value: function leaveChat() {
	      return this.set({ state: 'left', left_at: new Date() });
	    }
	  }, {
	    key: 'getLeftAt',
	    value: function getLeftAt() {
	      return this.get('left_at');
	    }
	  }, {
	    key: 'getUnsubscribedAt',
	    value: function getUnsubscribedAt() {
	      return this.get('unsubscribed_at');
	    }
	  }], [{
	    key: 'create',
	    value: function create(member) {
	      return new ChatMembership({
	        user: new _ChatMember2.default(member.attributes)
	      });
	    }
	  }]);
	
	  return ChatMembership;
	}(_Entity3.default);
	
	ChatMembership.displayName = 'ChatMembership';
	exports.default = ChatMembership;

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _OfficeHours = __webpack_require__(922);
	
	var _OfficeHours2 = _interopRequireDefault(_OfficeHours);
	
	var _lodash = __webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatMember = function (_Entity) {
	  _inherits(ChatMember, _Entity);
	
	  function ChatMember() {
	    _classCallCheck(this, ChatMember);
	
	    return _possibleConstructorReturn(this, (ChatMember.__proto__ || Object.getPrototypeOf(ChatMember)).apply(this, arguments));
	  }
	
	  _createClass(ChatMember, [{
	    key: 'parse',
	    value: function parse(response) {
	      var member = (0, _lodash.cloneDeep)(response);
	      member['office_hours'] = _OfficeHours2.default.fromJSON(member['office_hours']);
	      return member;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      return this.get('color');
	    }
	  }, {
	    key: 'getFirstName',
	    value: function getFirstName() {
	      return this.get('first_name');
	    }
	  }, {
	    key: 'getLastName',
	    value: function getLastName() {
	      return this.get('last_name');
	    }
	  }, {
	    key: 'getUserId',
	    value: function getUserId() {
	      return this.get('id');
	    }
	  }, {
	    key: 'getUuid',
	    value: function getUuid() {
	      return this.get('uuid');
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }, {
	    key: 'getInitials',
	    value: function getInitials() {
	      return this.get('initials');
	    }
	  }, {
	    key: 'getSignature',
	    value: function getSignature() {
	      return this.get('signature');
	    }
	  }, {
	    key: 'setName',
	    value: function setName(name) {
	      return this.set({ name: name });
	    }
	  }, {
	    key: 'getRole',
	    value: function getRole() {
	      return this.get('role');
	    }
	  }, {
	    key: 'getOfficeHours',
	    value: function getOfficeHours() {
	      return this.get('office_hours');
	    }
	  }, {
	    key: 'isBlocked',
	    value: function isBlocked() {
	      return this.get('blocked');
	    }
	  }, {
	    key: 'setOfficeHours',
	    value: function setOfficeHours(hours) {
	      return this.set({ office_hours: hours });
	    }
	  }, {
	    key: 'getChatEligibilityState',
	    value: function getChatEligibilityState() {
	      return this.get('chat_eligibility_state');
	    }
	  }, {
	    key: 'isEligibleForChat',
	    value: function isEligibleForChat() {
	      return this.getChatEligibilityState() === 'eligible';
	    }
	  }]);
	
	  return ChatMember;
	}(_Entity3.default);
	
	ChatMember.displayName = 'ChatMember';
	exports.default = ChatMember;

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ChatSettingsConstants = __webpack_require__(923);
	
	var _ChatSettingsConstants2 = _interopRequireDefault(_ChatSettingsConstants);
	
	var _OfficeHoursDay = __webpack_require__(925);
	
	var _OfficeHoursDay2 = _interopRequireDefault(_OfficeHoursDay);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Returns the local machine's timezone offset, converted for server-side use
	 * Note: This WILL lead to issues with DST and changes in location, which isn't a concern right now.
	 */
	function getTimezoneOffset() {
	  return new Date().getTimezoneOffset() * 60 * -1;
	}
	
	var OfficeHours = function (_Entity) {
	  _inherits(OfficeHours, _Entity);
	
	  function OfficeHours() {
	    _classCallCheck(this, OfficeHours);
	
	    return _possibleConstructorReturn(this, (OfficeHours.__proto__ || Object.getPrototypeOf(OfficeHours)).apply(this, arguments));
	  }
	
	  _createClass(OfficeHours, [{
	    key: 'isNew',
	
	    // TODO: Figure out what to do about this with similar models. Basically, the server doesn't treat
	    // this as a record that is created on the client. It initializes it (without an ID) on the server
	    value: function isNew() {
	      return false;
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var hours = _lodash2.default.cloneDeep(response);
	      if (hours['available']) {
	        hours['available'] = hours['available'].map(function (day) {
	          return _OfficeHoursDay2.default.fromJSON(day);
	        });
	      }
	      return hours;
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        available: _ChatSettingsConstants2.default.OfficeHours.DAYS_DEFAULT.map(function (day) {
	          return _OfficeHoursDay2.default.create(day);
	        }),
	        timezone: getTimezoneOffset()
	      };
	    }
	  }, {
	    key: 'getAvailability',
	    value: function getAvailability() {
	      return this.get('available');
	    }
	  }, {
	    key: 'getLabel',
	    value: function getLabel() {
	      return this.get('office_hours_label');
	    }
	  }, {
	    key: 'getAvailabilityForToday',
	    value: function getAvailabilityForToday() {
	      var todayDayNumber = new Date().getDay();
	      return this.getAvailability().find(function (officeHoursDay) {
	        return officeHoursDay.getDay() === todayDayNumber;
	      });
	    }
	  }, {
	    key: 'getNextAvailability',
	    value: function getNextAvailability() {
	      if (this.isAvailableNow()) {
	        return this.getAvailableForToday();
	      }
	
	      var availabilities = this.getAvailability().reduce(function (map, availability) {
	        map[availability.getDay()] = availability;
	        return map;
	      }, {});
	
	      var start = new Date().getDay() + 1;
	      for (var i = 0, l = 7, day = start; i < l; day = (start + ++i) % 7) {
	        if (day in availabilities) {
	          return availabilities[day];
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'hasAvailability',
	    value: function hasAvailability() {
	      var availability = this.getAvailability();
	      return availability.length > 0;
	    }
	  }, {
	    key: 'isAvailableNow',
	    value: function isAvailableNow() {
	      if (!this.hasAvailability()) {
	        return true;
	      }
	
	      var availability = this.getAvailabilityForToday();
	      if (availability) {
	        var now = new Date();
	        var currentTime = now.getHours() * 60 * 60 + now.getMinutes() * 60 + now.getSeconds();
	        // TODO: Account for timezone?
	        return currentTime > availability.getStartTime() && currentTime < availability.getEndTime();
	      }
	      return false;
	    }
	  }, {
	    key: 'getTimezone',
	    value: function getTimezone() {
	      return this.get('timezone');
	    }
	  }], [{
	    key: 'yieldForCurrentUser',
	    value: function yieldForCurrentUser() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      // XXX remove CurrentUser from entities
	      var CurrentUser = __webpack_require__(576).default;
	      var userId = CurrentUser.getUserId();
	      if (!userId) {
	        return Promise.reject(new Error('Undefined userId in setForCurrentUser'));
	      }
	
	      var hours = new OfficeHours();
	      hours.url = '/users/' + userId + '/office_hours';
	      return hours.fetch(options);
	    }
	  }, {
	    key: 'setForCurrentUser',
	    value: function setForCurrentUser(available) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      // XXX remove CurrentUser from entities
	      var CurrentUser = __webpack_require__(576).default;
	      var userId = CurrentUser.getUserId();
	      if (!userId) {
	        return Promise.reject(new Error('Undefined userId in setForCurrentUser'));
	      }
	
	      var hours = new OfficeHours();
	      hours.url = '/users/' + userId + '/office_hours';
	      return hours.save({}, Object.assign(options, {
	        data: {
	          available: available.map(function (day) {
	            return day.toJSON();
	          }),
	          timezone: getTimezoneOffset()
	        },
	        patch: true
	      }));
	    }
	  }]);
	
	  return OfficeHours;
	}(_Entity3.default);
	
	OfficeHours.displayName = 'OfficeHours';
	exports.default = OfficeHours;

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OfficeHours = exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['OFFICE_HOURS_LOADED', 'OFFICE_HOURS_ENABLED', 'OFFICE_HOURS_UPDATED', 'OFFICE_HOURS_DISABLED']); /*  weak */
	var OfficeHours = exports.OfficeHours = {
	  START_TIME_DEFAULT: 7 * 60 * 60,
	  END_TIME_DEFAULT: 19 * 60 * 60,
	  DAYS_DEFAULT: [1, 2, 3, 4, 5]
	};
	
	exports.default = {
	  ActionTypes: ActionTypes,
	  OfficeHours: OfficeHours
	};

/***/ },
/* 924 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = enumerate;
	var nextValue = 0;
	
	function enumerate(keys) {
	  var obj = {};
	
	  keys.forEach(function (key) {
	    obj[key] = nextValue;
	    nextValue++;
	  });
	
	  Object.freeze(obj);
	  return obj;
	}

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ChatSettingsConstants = __webpack_require__(923);
	
	var _ChatSettingsConstants2 = _interopRequireDefault(_ChatSettingsConstants);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OfficeHoursDay = function (_Entity) {
	  _inherits(OfficeHoursDay, _Entity);
	
	  function OfficeHoursDay() {
	    _classCallCheck(this, OfficeHoursDay);
	
	    return _possibleConstructorReturn(this, (OfficeHoursDay.__proto__ || Object.getPrototypeOf(OfficeHoursDay)).apply(this, arguments));
	  }
	
	  _createClass(OfficeHoursDay, [{
	    key: 'getDay',
	    value: function getDay() {
	      return this.get('day');
	    }
	  }, {
	    key: 'getStartTime',
	    value: function getStartTime() {
	      return this.get('start_time');
	    }
	  }, {
	    key: 'getEndTime',
	    value: function getEndTime() {
	      return this.get('end_time');
	    }
	  }], [{
	    key: 'create',
	    value: function create(day, startTime, endTime) {
	      return new OfficeHoursDay({
	        day: day,
	        start_time: startTime || _ChatSettingsConstants2.default.OfficeHours.START_TIME_DEFAULT,
	        end_time: endTime || _ChatSettingsConstants2.default.OfficeHours.END_TIME_DEFAULT
	      });
	    }
	  }]);
	
	  return OfficeHoursDay;
	}(_Entity3.default);
	
	OfficeHoursDay.displayName = 'OfficeHoursDay';
	exports.default = OfficeHoursDay;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ChatMembership = __webpack_require__(920);
	
	var _ChatMembership2 = _interopRequireDefault(_ChatMembership);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatMemberships = function (_Collection) {
	  _inherits(ChatMemberships, _Collection);
	
	  function ChatMemberships() {
	    _classCallCheck(this, ChatMemberships);
	
	    return _possibleConstructorReturn(this, (ChatMemberships.__proto__ || Object.getPrototypeOf(ChatMemberships)).apply(this, arguments));
	  }
	
	  _createClass(ChatMemberships, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _ChatMembership2.default;
	    }
	  }]);
	
	  return ChatMemberships;
	}(_Collection3.default);
	
	ChatMemberships.displayName = 'ChatMemberships';
	exports.default = ChatMemberships;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.chatMessageTypes = exports.ChatGapMessage = exports.ChatSystemMessage = exports.ChatMessage = exports.ChatBaseMessage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.chatMessageFactory = chatMessageFactory;
	exports.shouldListenToPushEventFrom = shouldListenToPushEventFrom;
	
	var _lodash = __webpack_require__(555);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ChatSender = __webpack_require__(928);
	
	var _ChatSender2 = _interopRequireDefault(_ChatSender);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _File = __webpack_require__(929);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _MessageSender = __webpack_require__(934);
	
	var _MessageSender2 = _interopRequireDefault(_MessageSender);
	
	var _ReactionSummary = __webpack_require__(936);
	
	var _ReactionSummary2 = _interopRequireDefault(_ReactionSummary);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _uuid = __webpack_require__(582);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _ChatMessageActions = __webpack_require__(939);
	
	var _ChatMessageActions2 = _interopRequireDefault(_ChatMessageActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatBaseMessage = exports.ChatBaseMessage = function (_Entity) {
	  _inherits(ChatBaseMessage, _Entity);
	
	  function ChatBaseMessage() {
	    _classCallCheck(this, ChatBaseMessage);
	
	    return _possibleConstructorReturn(this, (ChatBaseMessage.__proto__ || Object.getPrototypeOf(ChatBaseMessage)).apply(this, arguments));
	  }
	
	  _createClass(ChatBaseMessage, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.idAttribute = 'uuid';
	    }
	  }, {
	    key: 'getSeq',
	    value: function getSeq() {
	      return this.get('seq');
	    }
	  }, {
	    key: 'setChatId',
	    value: function setChatId(id) {
	      var chat = this.get('chat');
	      chat.uuid = id;
	      this.set('chat', chat);
	    }
	  }, {
	    key: 'getChatId',
	    value: function getChatId() {
	      return this.get('chat').uuid;
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.get('type');
	    }
	  }]);
	
	  return ChatBaseMessage;
	}(_Entity3.default);
	
	ChatBaseMessage.displayName = 'ChatBaseMessage';
	
	var ChatMessage = exports.ChatMessage = function (_ChatBaseMessage) {
	  _inherits(ChatMessage, _ChatBaseMessage);
	
	  function ChatMessage() {
	    _classCallCheck(this, ChatMessage);
	
	    return _possibleConstructorReturn(this, (ChatMessage.__proto__ || Object.getPrototypeOf(ChatMessage)).apply(this, arguments));
	  }
	
	  _createClass(ChatMessage, [{
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        body: '',
	        preview: '',
	        created_at: new Date(),
	        type: 'text'
	      };
	    }
	  }, {
	    key: 'urlRoot',
	    value: function urlRoot() {
	      return '/chats/' + this.getChatId() + '/messages';
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var message = (0, _lodash.cloneDeep)(response);
	      if ('created_at' in message) {
	        message['created_at'] = new Date(message['created_at']);
	      }
	      message['sender'] = _ChatSender2.default.fromJSON(message['sender']);
	
	      if ('message' in message) {
	        message['message'] = _Message2.default.fromJSON(message['message']);
	      }
	
	      if (message['file']) {
	        message['file'] = _File2.default.fromJSON(message['file']);
	      }
	
	      if (message['group_summary']) {
	        message['group_summary'] = _Group2.default.fromJSON(message['group_summary']);
	      }
	
	      if (message['payment_req']) {
	        message['payment_req'] = _Activity2.default.fromJSON(message['payment_req']);
	      }
	
	      if (message['reaction_summary']) {
	        message['reaction_summary'] = _ReactionSummary2.default.fromJSON(message['reaction_summary']);
	      }
	
	      return message;
	    }
	  }, {
	    key: 'setReactionSummary',
	    value: function setReactionSummary(reactionSummary) {
	      // Only update if reaction summary is newer than current
	      if (reactionSummary.getVersion() > this.getReactionSummary().getVersion()) {
	        this.set('reaction_summary', reactionSummary);
	      }
	    }
	  }, {
	    key: 'getReactionSummary',
	    value: function getReactionSummary() {
	      return this.get('reaction_summary') || new _ReactionSummary2.default();
	    }
	  }, {
	    key: 'hasReactions',
	    value: function hasReactions() {
	      return !!this.getReactionSummary().getReactions().length;
	    }
	  }, {
	    key: 'addReaction',
	    value: function addReaction(reactionName) {
	      _ChatMessageActions2.default.addReaction(this, reactionName);
	    }
	  }, {
	    key: 'removeReaction',
	    value: function removeReaction(reactionName) {
	      _ChatMessageActions2.default.removeReaction(this, reactionName);
	    }
	  }, {
	    key: 'getActivity',
	    value: function getActivity() {
	      return this.get('payment_req');
	    }
	  }, {
	    key: 'getSender',
	    value: function getSender() {
	      return this.get('sender');
	    }
	  }, {
	    key: 'getGroupSummary',
	    value: function getGroupSummary() {
	      return this.get('group_summary');
	    }
	  }, {
	    key: 'getGroupIds',
	    value: function getGroupIds() {
	      return this.getGroupSummary() ? [this.getGroupSummary().id] : [];
	    }
	  }, {
	    key: 'getBody',
	    value: function getBody() {
	      return this.get('body');
	    }
	  }, {
	    key: 'setPreview',
	    value: function setPreview(body) {
	      return this.set({ preview: body });
	    }
	  }, {
	    key: 'getPreview',
	    value: function getPreview() {
	      return this.get('preview') || this._generatePreview();
	    }
	  }, {
	    key: '_generatePreview',
	    value: function _generatePreview() {
	      var preview = this.getBody() || this.getFile() && '1 Attachment 📚' || '<error>';
	
	      if (this.getType() === 'text') {
	        return 'You: ' + preview;
	      } else if (this.getType() === 'broadcast') {
	        return 'Announcement: ' + preview;
	      }
	      return preview;
	    }
	  }, {
	    key: 'getISO639Locale',
	    value: function getISO639Locale() {
	      var locale = this.get('locale');
	
	      if (locale) {
	        locale = locale.split('-')[0];
	      }
	
	      return locale;
	    }
	  }, {
	    key: 'getFile',
	    value: function getFile() {
	      return this.get('file');
	    }
	  }, {
	    key: 'getMessage',
	    value: function getMessage() {
	      return this.get('message');
	    }
	  }, {
	    key: 'getCreatedAt',
	    value: function getCreatedAt() {
	      return this.get('created_at');
	    }
	  }, {
	    key: 'getSentAt',
	    value: function getSentAt() {
	      return this.getCreatedAt();
	    }
	  }, {
	    key: 'getReadSummary',
	    value: function getReadSummary() {
	      return this.get('read_summary');
	    }
	  }, {
	    key: 'getUuid',
	    value: function getUuid() {
	      return this.get('uuid');
	    }
	  }, {
	    key: 'getOriginGroupId',
	    value: function getOriginGroupId() {
	      return this.get('origin_group_id');
	    }
	  }, {
	    key: 'send',
	    value: function send() {
	      return this.save({}, {
	        url: this.urlRoot(),
	        method: 'create',
	        data: {
	          message: {
	            body: this.getBody(),
	            uuid: this.id,
	            file: this.getFile(),
	            origin_group_id: this.getOriginGroupId()
	          }
	        }
	      });
	    }
	  }], [{
	    key: 'findByUuid',
	    value: function findByUuid(chatThreadUuid, chatMessageUuid, trackingParameter) {
	      return (0, _apiRequest2.default)('/chats/' + chatThreadUuid + '/messages/' + chatMessageUuid, 'GET', { _t: trackingParameter }).then(function (chatMessageJSON) {
	        return ChatMessage.fromJSON(chatMessageJSON);
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create(text, files, chat, sender, seq) {
	      var type = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'text';
	      var groupSummary = arguments[6];
	      var originGroupId = arguments[7];
	
	      return new ChatMessage({
	        uuid: (0, _uuid2.default)(),
	        sender: sender,
	        chat: { uuid: chat.id },
	        body: text,
	        failed: false,
	        seq: seq,
	        file: files[0],
	        type: type,
	        group_summary: groupSummary,
	        origin_group_id: originGroupId
	      });
	    }
	  }]);
	
	  return ChatMessage;
	}(ChatBaseMessage);
	
	ChatMessage.displayName = 'ChatMessage';
	
	var ChatSystemMessage = exports.ChatSystemMessage = function (_ChatMessage) {
	  _inherits(ChatSystemMessage, _ChatMessage);
	
	  function ChatSystemMessage() {
	    _classCallCheck(this, ChatSystemMessage);
	
	    return _possibleConstructorReturn(this, (ChatSystemMessage.__proto__ || Object.getPrototypeOf(ChatSystemMessage)).apply(this, arguments));
	  }
	
	  _createClass(ChatSystemMessage, [{
	    key: 'getBodyAttributes',
	    value: function getBodyAttributes() {
	      return this.get('body_attributes');
	    }
	  }]);
	
	  return ChatSystemMessage;
	}(ChatMessage);
	
	ChatSystemMessage.displayName = 'ChatSystemMessage';
	
	var ChatGapMessage = exports.ChatGapMessage = function (_ChatBaseMessage2) {
	  _inherits(ChatGapMessage, _ChatBaseMessage2);
	
	  function ChatGapMessage() {
	    _classCallCheck(this, ChatGapMessage);
	
	    return _possibleConstructorReturn(this, (ChatGapMessage.__proto__ || Object.getPrototypeOf(ChatGapMessage)).apply(this, arguments));
	  }
	
	  _createClass(ChatGapMessage, [{
	    key: 'getParams',
	    value: function getParams() {
	      return this.get('params');
	    }
	  }, {
	    key: 'getUuid',
	    value: function getUuid() {
	      return 'gap-uuid';
	    }
	  }]);
	
	  return ChatGapMessage;
	}(ChatBaseMessage);
	
	ChatGapMessage.displayName = 'ChatGapMessage';
	function chatMessageFactory(data) {
	  if (data.type === 'system') {
	    return ChatSystemMessage.fromJSON(data);
	  } else {
	    return ChatMessage.fromJSON(data);
	  }
	}
	
	function shouldListenToPushEventFrom(message) {
	  return ['text', 'broadcast', 'system'].includes(message.getType()) && !!message.get('chat');
	}
	
	var chatMessageTypes = exports.chatMessageTypes = {
	  gap: ChatGapMessage,
	  system: ChatSystemMessage,
	  attachment: ChatMessage,
	  text: ChatMessage,
	  broadcast: ChatMessage
	};
	
	exports.default = ChatMessage;

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatSender = function (_Entity) {
	  _inherits(ChatSender, _Entity);
	
	  function ChatSender() {
	    _classCallCheck(this, ChatSender);
	
	    return _possibleConstructorReturn(this, (ChatSender.__proto__ || Object.getPrototypeOf(ChatSender)).apply(this, arguments));
	  }
	
	  _createClass(ChatSender, [{
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      return this.get('color');
	    }
	  }, {
	    key: 'getInitials',
	    value: function getInitials() {
	      return this.get('initials');
	    }
	  }, {
	    key: 'isCurrentUser',
	    value: function isCurrentUser() {
	      // XXX remove CurrentUser from entities
	      var CurrentUser = __webpack_require__(576).default;
	
	      if (!CurrentUser.isSignedIn()) {
	        return false;
	      }
	
	      return this.id === CurrentUser.getUserId();
	    }
	  }]);
	
	  return ChatSender;
	}(_Entity3.default);
	
	ChatSender.displayName = 'ChatSender';
	exports.default = ChatSender;

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MAX_IMAGE_PREVIEW_HEIGHT = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _lodash = __webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ERROR_URL = 'https://www.remind.com/error';
	var ERROR_URLS = {
	  cdn: ERROR_URL,
	  raw: ERROR_URL,
	  download: ERROR_URL
	};
	
	// This is half of the max image size set in r101-files.
	// https://github.com/remind101/r101-files-go/blob/523fcdf56e30e8b97606b7d99941c8c07be50b04/file_urls.go#L11-L12
	var MAX_IMAGE_PREVIEW_HEIGHT = exports.MAX_IMAGE_PREVIEW_HEIGHT = 300;
	
	var File = function (_Entity) {
	  _inherits(File, _Entity);
	
	  function File() {
	    _classCallCheck(this, File);
	
	    return _possibleConstructorReturn(this, (File.__proto__ || Object.getPrototypeOf(File)).apply(this, arguments));
	  }
	
	  _createClass(File, [{
	    key: 'urlRoot',
	    value: function urlRoot() {
	      return '/files';
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var file = (0, _lodash.cloneDeep)(response);
	
	      if (file['urls'] && file['urls']['cdn']) {
	        file['urls']['raw'] = file['urls']['cdn'].split('?')[0];
	        file['urls']['download'] = file['urls']['raw'] + '?dl';
	      }
	
	      if (file['type']) {
	        file['content_type'] = file['type'];
	      }
	
	      return file;
	    }
	  }, {
	    key: 'getContentType',
	    value: function getContentType() {
	      return this.get('content_type');
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }, {
	    key: 'getSize',
	    value: function getSize() {
	      return this.get('size');
	    }
	  }, {
	    key: 'hasUrls',
	    value: function hasUrls() {
	      return !!this.get('urls');
	    }
	  }, {
	    key: 'getUrls',
	    value: function getUrls() {
	      var urls = this.get('urls');
	      if (!urls) {
	        console.error('File getUrls() called without URLs. Recovering with ERROR_URLS.');
	        return ERROR_URLS;
	      }
	      return urls;
	    }
	  }, {
	    key: 'getPreviewDimensions',
	    value: function getPreviewDimensions(maxDimension) {
	      var height = Math.min(this.get('preview_height'), maxDimension);
	      var width = Math.min(this.get('preview_width'), maxDimension);
	      if (height && width) {
	        return { height: height, width: width };
	      } else {
	        return {};
	      }
	    }
	  }, {
	    key: 'getTrackedUrl',
	    value: function getTrackedUrl(trackingUuid) {
	      var trackedUrl = this.getUrls().tracked;
	
	      if (!trackedUrl) {
	        console.error('File getTrackedUrl() called without trackedUrl. Recovering with ERROR_URL');
	        return ERROR_URL;
	      }
	
	      if (trackedUrl.indexOf('_t=') > 0) {
	        return trackedUrl;
	      }
	
	      return '' + trackedUrl + (trackedUrl.indexOf('?') === -1 ? '?' : '&') + '_t=' + trackingUuid;
	    }
	  }, {
	    key: 'getViewers',
	    value: function getViewers() {
	      return this.get('viewers') || [];
	    }
	  }]);
	
	  return File;
	}(_Entity3.default);
	
	File.displayName = 'File';
	exports.default = File;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GapMessage = exports.Message = exports.TARGET_TYPES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _File = __webpack_require__(929);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _MessageRecipients = __webpack_require__(931);
	
	var _MessageRecipients2 = _interopRequireDefault(_MessageRecipients);
	
	var _MessageSender = __webpack_require__(934);
	
	var _MessageSender2 = _interopRequireDefault(_MessageSender);
	
	var _prefillMessageWithGroupName = __webpack_require__(935);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ReactionSummary = __webpack_require__(936);
	
	var _ReactionSummary2 = _interopRequireDefault(_ReactionSummary);
	
	var _uuid = __webpack_require__(582);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TARGET_TYPES = exports.TARGET_TYPES = {
	  GROUP_TARGET: 'group_target',
	  INDIVIDUAL_TARGET: 'individual_target'
	};
	
	/**
	 * Announcement, really. (This was named before we had chat.)
	 */
	var Message = exports.Message = function (_Entity) {
	  _inherits(Message, _Entity);
	
	  function Message() {
	    _classCallCheck(this, Message);
	
	    return _possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).apply(this, arguments));
	  }
	
	  _createClass(Message, [{
	    key: 'urlRoot',
	    value: function urlRoot() {
	      return '/messages';
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        attachmentId: null,
	        body: '',
	        created_at: new Date(),
	        files: [],
	        group_ids: null,
	        params: {},
	        payment_req: null,
	        received_count: null,
	        recipients: [],
	        send_at: null,
	        sent_at: null,
	        status: null,
	        uuid: (0, _uuid2.default)(),
	        is_client_created: false
	      };
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var data = Object.assign({}, response);
	
	      if (data['created_at']) {
	        data['created_at'] = new Date(data['created_at']);
	      }
	
	      if (data['send_at']) {
	        data['send_at'] = new Date(data['send_at']);
	      }
	
	      if (data['sent_at']) {
	        data['sent_at'] = new Date(data['sent_at']);
	      }
	
	      if (data['sender']) {
	        data['sender'] = new _MessageSender2.default(data['sender']);
	      }
	
	      if (data['files']) {
	        data['files'] = data['files'].map(function (file) {
	          return _File2.default.fromJSON(file);
	        });
	      }
	
	      if (data['recipients']) {
	        data['recipients'] = _MessageRecipients2.default.fromJSON(data['recipients']);
	      }
	
	      if (data['payment_req']) {
	        data['payment_req'] = _Activity2.default.fromJSON(data['payment_req']);
	      }
	
	      if (data['reaction_summary']) {
	        data['reaction_summary'] = _ReactionSummary2.default.fromJSON(data['reaction_summary']);
	      }
	
	      return data;
	    }
	  }, {
	    key: 'setReactionSummary',
	    value: function setReactionSummary(reactionSummary) {
	      this.set('reaction_summary', reactionSummary);
	    }
	  }, {
	    key: 'getReactionSummary',
	    value: function getReactionSummary() {
	      return this.get('reaction_summary') || new _ReactionSummary2.default();
	    }
	  }, {
	    key: 'getSeq',
	    value: function getSeq() {
	      return this.get('seq');
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.get('type');
	    }
	  }, {
	    key: 'getAttachmentId',
	    value: function getAttachmentId() {
	      return this.get('attachmentId');
	    }
	  }, {
	    key: 'getISO639Locale',
	    value: function getISO639Locale() {
	      var locale = this.get('locale');
	
	      if (locale) {
	        locale = locale.split('-')[0];
	      }
	
	      return locale;
	    }
	  }, {
	    key: 'getBody',
	    value: function getBody() {
	      return this.get('body');
	    }
	  }, {
	    key: 'getSender',
	    value: function getSender() {
	      return this.get('sender');
	    }
	  }, {
	    key: 'getCreatedAt',
	    value: function getCreatedAt() {
	      return this.get('created_at');
	    }
	  }, {
	    key: 'getSendAt',
	    value: function getSendAt() {
	      return this.get('send_at');
	    }
	  }, {
	    key: 'getSentTo',
	    value: function getSentTo() {
	      return this.get('sent_to');
	    }
	  }, {
	    key: 'getSentAt',
	    value: function getSentAt() {
	      return this.getStatus() === 'pending' ? this.getSendAt() : this.get('sent_at');
	    }
	  }, {
	    key: 'getStatus',
	    value: function getStatus() {
	      return this.get('status');
	    }
	
	    // $FlowFixMe
	
	  }, {
	    key: 'setStatus',
	    value: function setStatus(status) {
	      return this.set({ status: status });
	    }
	  }, {
	    key: 'getRecipients',
	    value: function getRecipients() {
	      return this.get('recipients');
	    }
	  }, {
	    key: 'getGroupIds',
	    value: function getGroupIds() {
	      return this.get('group_ids') || this.getGroupIdsFromRecipients();
	    }
	  }, {
	    key: 'getGroupIdsFromRecipients',
	    value: function getGroupIdsFromRecipients() {
	      return this.getRecipients().filter(function (recipient) {
	        return recipient.isGroup();
	      }).map(function (recipient) {
	        return recipient.id;
	      });
	    }
	  }, {
	    key: 'getReceivedCount',
	    value: function getReceivedCount() {
	      return this.get('received_count');
	    }
	  }, {
	    key: 'getFiles',
	    value: function getFiles() {
	      return this.get('files');
	    }
	  }, {
	    key: 'getFile',
	    value: function getFile() {
	      var files = this.getFiles();
	      return files.length > 0 ? files[0] : null;
	    }
	  }, {
	    key: 'getGapParams',
	    value: function getGapParams() {
	      return this.get('params');
	    }
	  }, {
	    key: 'getActivity',
	    value: function getActivity() {
	      return this.get('payment_req');
	    }
	  }, {
	    key: 'getPreview',
	    value: function getPreview() {
	      var preview = this.getBody() || this.getFile() && '1 Attachment 📚' || '<error>';
	      return 'Announcement: ' + preview;
	    }
	  }, {
	    key: 'isWorthSaving',
	    value: function isWorthSaving(groupName) {
	      return (this.hasBody() || this.getFiles().length > 0) && this.getBody() !== (0, _prefillMessageWithGroupName.prefillMessageWithGroupName)(groupName);
	    }
	  }, {
	    key: 'hasBody',
	    value: function hasBody() {
	      var body = this.getBody();
	      if (body == null) {
	        return false;
	      }
	      return body.trim().length > 0;
	    }
	  }, {
	    key: 'getThreads',
	    value: function getThreads() {
	      var result = [];
	      var threads = this.get('threads');
	      if (threads) {
	        result = threads.map(function (t) {
	          var type = (0, _lodash.has)(t, 'group_id') ? TARGET_TYPES.GROUP_TARGET : TARGET_TYPES.INDIVIDUAL_TARGET;
	          return _extends({ type: type }, t);
	        });
	      }
	      return result;
	    }
	  }, {
	    key: 'getUuid',
	    value: function getUuid() {
	      return this.get('uuid');
	    }
	  }, {
	    key: 'getReadSummary',
	    value: function getReadSummary() {
	      return this.get('read_summary');
	    }
	  }, {
	    key: 'getTargets',
	    value: function getTargets() {
	      var result = [];
	      var targets = this.get('targets');
	      if (targets) {
	        result = targets.map(function (t) {
	          var type = (0, _lodash.has)(t, 'group_id') ? TARGET_TYPES.GROUP_TARGET : TARGET_TYPES.INDIVIDUAL_TARGET;
	          return _extends({ type: type }, t);
	        });
	      }
	      return result;
	    }
	  }, {
	    key: 'getRoles',
	    value: function getRoles() {
	      // $FlowFixMe
	      var targets = this.getTargets().filter(function (t) {
	        return t.role;
	      }).map(function (t) {
	        return t.role;
	      });
	      return targets.length > 0 ? targets :
	      // $FlowFixMe
	      this.getThreads().filter(function (t) {
	        return t.role;
	      }).map(function (t) {
	        return t.role;
	      });
	    }
	  }, {
	    key: 'getIsClientCreated',
	    value: function getIsClientCreated() {
	      return this.get('is_client_created');
	    }
	  }, {
	    key: 'sentByCurrentUser',
	    value: function sentByCurrentUser() {
	      // XXX remove CurrentUser from entities
	      var CurrentUser = __webpack_require__(576).default;
	      var sender = this.getSender();
	      return sender && sender.id === CurrentUser.getUserId();
	    }
	
	    // Used when adding file by file ID
	
	  }, {
	    key: 'setOnlyFile',
	    value: function setOnlyFile(file) {
	      return this.set('files', [file]);
	    }
	  }, {
	    key: 'send',
	    value: function send() {
	      var _this2 = this;
	
	      if (!this.isNew()) {
	        // The message has already been sent.
	        return new Promise(function (resolve) {
	          return resolve(_this2);
	        });
	      }
	      var targets = this.getTargets();
	      var message = {
	        body: this.getBody(),
	        group_ids: targets.length ? null : this.getGroupIds(),
	        send_at: this.getSendAt(),
	        files: this.getFiles(),
	        uuid: this.getUuid(),
	        payment_req_uuid: this.get('payment_req_uuid'),
	        is_client_created: true,
	        targets: targets
	      };
	
	      // remove any undefined or null options
	      message = (0, _lodash.pickBy)(message, function (v) {
	        return typeof v !== 'undefined' && v !== null;
	      });
	
	      return this.save({ sent_at: new Date() }, {
	        data: {
	          message: message
	        }
	      });
	    }
	  }, {
	    key: 'reuse',
	
	
	    /**
	     * @return {Message} a version of this message suitable to send again
	     */
	    value: function reuse() {
	      var sendable = this.clone();
	      sendable.set({
	        status: null,
	        send_at: null,
	        sent_at: null,
	        uuid: (0, _uuid2.default)()
	      });
	      return sendable;
	    }
	
	    // This should not update 'files' because the urls
	    // aren't ready until returned by the server in patch
	    // $FlowFixMe
	
	  }, {
	    key: 'update',
	    value: function update(body, targets, sendAt) {
	      this.set({
	        body: body,
	        targets: targets,
	        send_at: sendAt
	      });
	
	      var changes = this.changedAttributes() || {};
	
	      // The message was changed to unscheduled.
	      // Placed below changes because it's only
	      // meant for view purposes
	      if (!sendAt) {
	        this.set({
	          status: null,
	          sent_at: new Date()
	        });
	      }
	
	      return changes;
	    }
	
	    // $FlowFixMe
	
	  }, {
	    key: 'patch',
	    value: function patch(changes, files) {
	      var message = Object.assign(changes, { files: files });
	
	      return this.save({ message: message }, { patch: true });
	    }
	  }, {
	    key: 'toJSON',
	    value: function toJSON() {
	      return this.recursivelyToJSON();
	    }
	  }], [{
	    key: 'findByUuid',
	    value: function findByUuid(messageUuid) {
	      return (0, _apiRequest2.default)('/messages/' + messageUuid, 'GET').then(function (messageJSON) {
	        return Message.fromJSON(messageJSON);
	      });
	    }
	  }, {
	    key: 'createMessage',
	    value: function createMessage(groups, text, sendAt, files, sender, sentAt, targets) {
	      // XXX remove CurrentUser from entities
	      var CurrentUser = __webpack_require__(576).default;
	      var user = CurrentUser.isSignedIn() ? CurrentUser.getUser() : {};
	
	      var filesAreEntities = !!(files && files.length && files[0].attributes);
	
	      var options = {
	        group_ids: groups ? groups.map(function (group) {
	          return group.id;
	        }) : null,
	        recipients: groups ? groups.map(function (group) {
	          return {
	            id: group.id,
	            name: group.getName(),
	            type: 'group'
	          };
	        }) : null,
	        send_at: sendAt,
	        sent_at: sentAt,
	        body: text,
	        sender: sender || { id: user.id, name: user.getSignature() },
	        files: filesAreEntities ? files.map(function (f) {
	          return f.toJSON();
	        }) : files,
	        targets: targets
	      };
	
	      // remove any undefined or null options
	      options = (0, _lodash.pickBy)(options, function (v) {
	        return typeof v !== 'undefined' && v !== null;
	      });
	      return Message.fromJSON(options);
	    }
	  }]);
	
	  return Message;
	}(_Entity3.default);
	
	Message.displayName = 'Message';
	
	var GapMessage = exports.GapMessage = function (_Message) {
	  _inherits(GapMessage, _Message);
	
	  function GapMessage() {
	    _classCallCheck(this, GapMessage);
	
	    return _possibleConstructorReturn(this, (GapMessage.__proto__ || Object.getPrototypeOf(GapMessage)).apply(this, arguments));
	  }
	
	  _createClass(GapMessage, [{
	    key: 'getType',
	    value: function getType() {
	      return 'gap';
	    }
	  }, {
	    key: 'getUuid',
	    value: function getUuid() {
	      return 'gap-uuid';
	    }
	  }]);
	
	  return GapMessage;
	}(Message);
	
	GapMessage.displayName = 'GapMessage';
	exports.default = Message;

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _MessageRecipient = __webpack_require__(932);
	
	var _MessageRecipient2 = _interopRequireDefault(_MessageRecipient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageRecipients = function (_Collection) {
	  _inherits(MessageRecipients, _Collection);
	
	  function MessageRecipients() {
	    _classCallCheck(this, MessageRecipients);
	
	    return _possibleConstructorReturn(this, (MessageRecipients.__proto__ || Object.getPrototypeOf(MessageRecipients)).apply(this, arguments));
	  }
	
	  _createClass(MessageRecipients, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _MessageRecipient2.default;
	    }
	  }, {
	    key: 'comparator',
	    value: function comparator(a, b) {
	      if (a.isGroup() && b.isSubscriber()) {
	        return -1;
	      }
	      if (a.isSubscriber() && b.isGroup()) {
	        return 1;
	      }
	
	      if (!a.isDeleted() && b.isDeleted()) {
	        return -1;
	      }
	      if (a.isDeleted() && !b.isDeleted()) {
	        return 1;
	      }
	
	      return a.getName().localeCompare(b.getName());
	    }
	  }, {
	    key: 'getCounts',
	    value: function getCounts() {
	      return {
	        group: this.getGroupCount(),
	        subscriber: this.getSubscriberCount()
	      };
	    }
	  }, {
	    key: 'getGroupCount',
	    value: function getGroupCount() {
	      // This where() is provided by backbone-collection, NOT proxied to lodash
	      // which is nice because where() has been removed in lodash 4
	      return this.where({ type: 'group' }).length;
	    }
	  }, {
	    key: 'getSubscriberCount',
	    value: function getSubscriberCount() {
	      return this.where({ type: 'subscriber' }).length;
	    }
	  }]);
	
	  return MessageRecipients;
	}(_Collection3.default);
	
	MessageRecipients.displayName = 'MessageRecipients';
	exports.default = MessageRecipients;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _Avatar = __webpack_require__(933);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageRecipient = function (_Entity) {
	  _inherits(MessageRecipient, _Entity);
	
	  function MessageRecipient() {
	    _classCallCheck(this, MessageRecipient);
	
	    return _possibleConstructorReturn(this, (MessageRecipient.__proto__ || Object.getPrototypeOf(MessageRecipient)).apply(this, arguments));
	  }
	
	  _createClass(MessageRecipient, [{
	    key: 'parse',
	    value: function parse(response) {
	      if (response['group_avatar']) {
	        response['group_avatar'] = _Avatar2.default.fromJSON(response['group_avatar']);
	      }
	
	      return response;
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        deleted: false
	      };
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }, {
	    key: 'getGroupAvatar',
	    value: function getGroupAvatar() {
	      return this.get('group_avatar');
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.get('type');
	    }
	  }, {
	    key: 'isDeleted',
	    value: function isDeleted() {
	      return this.get('deleted');
	    }
	  }, {
	    key: 'isGroup',
	    value: function isGroup() {
	      return this.getType() === 'group';
	    }
	  }, {
	    key: 'isSubscriber',
	    value: function isSubscriber() {
	      return this.getType() === 'subscriber';
	    }
	  }]);
	
	  return MessageRecipient;
	}(_Entity3.default);
	
	MessageRecipient.displayName = 'MessageRecipient';
	exports.default = MessageRecipient;

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Avatar = function (_Entity) {
	  _inherits(Avatar, _Entity);
	
	  function Avatar() {
	    _classCallCheck(this, Avatar);
	
	    return _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).apply(this, arguments));
	  }
	
	  _createClass(Avatar, [{
	    key: 'getColor',
	    value: function getColor() {
	      return this.get('color');
	    }
	  }, {
	    key: 'getUrl',
	    value: function getUrl() {
	      // file_url is a PNG version which we don't use on web anymore.
	      return this.get('svg_url');
	    }
	  }]);
	
	  return Avatar;
	}(_Entity3.default);
	
	Avatar.displayName = 'Avatar';
	exports.default = Avatar;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageSender = function (_Entity) {
	  _inherits(MessageSender, _Entity);
	
	  function MessageSender() {
	    _classCallCheck(this, MessageSender);
	
	    return _possibleConstructorReturn(this, (MessageSender.__proto__ || Object.getPrototypeOf(MessageSender)).apply(this, arguments));
	  }
	
	  _createClass(MessageSender, [{
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	
	    // TODO does API actually return null or are our test fixtures off?
	
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      return this.get('color');
	    }
	
	    // TODO does API actually return null or are our test fixtures off?
	
	  }, {
	    key: 'getInitials',
	    value: function getInitials() {
	      return this.get('initials');
	    }
	  }]);
	
	  return MessageSender;
	}(_Entity3.default);
	
	MessageSender.displayName = 'MessageSender';
	exports.default = MessageSender;

/***/ },
/* 935 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var prefillMessageWithGroupName = exports.prefillMessageWithGroupName = function prefillMessageWithGroupName(groupName) {
	  return 'Welcome to ' + groupName + '! I’m looking forward to using ' + 'Remind to share updates, notes, and more. Thanks for joining!';
	};

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	var _lodash = __webpack_require__(555);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _Reactions = __webpack_require__(937);
	
	var _Reactions2 = _interopRequireDefault(_Reactions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactionSummary = function (_Entity) {
	  _inherits(ReactionSummary, _Entity);
	
	  function ReactionSummary() {
	    _classCallCheck(this, ReactionSummary);
	
	    return _possibleConstructorReturn(this, (ReactionSummary.__proto__ || Object.getPrototypeOf(ReactionSummary)).apply(this, arguments));
	  }
	
	  _createClass(ReactionSummary, [{
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        version: 0,
	        reactions: new _Reactions2.default()
	      };
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var reactionSummary = (0, _lodash.cloneDeep)(response);
	
	      reactionSummary['reactions'] = _Reactions2.default.fromJSON(reactionSummary['reactions']);
	
	      return reactionSummary;
	    }
	  }, {
	    key: 'getReactions',
	    value: function getReactions() {
	      return this.get('reactions');
	    }
	  }, {
	    key: 'getVersion',
	    value: function getVersion() {
	      return this.get('version');
	    }
	  }, {
	    key: 'getMessageUuid',
	    value: function getMessageUuid() {
	      return this.get('message_uuid');
	    }
	
	    /* Reactions in a Chat context */
	
	  }], [{
	    key: 'createReaction',
	    value: function createReaction(name, chatUuid, messageUuid) {
	      return _RemindAPI2.default.request('/chats/' + chatUuid + '/messages/' + messageUuid + '/reactions', 'POST', {
	        add: [name],
	        remove: []
	      }).then(function (reactionSummary) {
	        return ReactionSummary.fromJSON(reactionSummary);
	      });
	    }
	  }, {
	    key: 'deleteReaction',
	    value: function deleteReaction(name, chatUuid, messageUuid) {
	      return _RemindAPI2.default.request('/chats/' + chatUuid + '/messages/' + messageUuid + '/reactions', 'POST', {
	        add: [],
	        remove: [name]
	      }).then(function (reactionSummary) {
	        return ReactionSummary.fromJSON(reactionSummary);
	      });
	    }
	  }]);
	
	  return ReactionSummary;
	}(_Entity3.default);
	
	ReactionSummary.displayName = 'ReactionSummary';
	exports.default = ReactionSummary;

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Reaction = __webpack_require__(938);
	
	var _Reaction2 = _interopRequireDefault(_Reaction);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Reactions = function (_Collection) {
	  _inherits(Reactions, _Collection);
	
	  function Reactions() {
	    _classCallCheck(this, Reactions);
	
	    return _possibleConstructorReturn(this, (Reactions.__proto__ || Object.getPrototypeOf(Reactions)).apply(this, arguments));
	  }
	
	  _createClass(Reactions, [{
	    key: 'parse',
	    value: function parse(response) {
	      return response.map(function (reaction) {
	        return _Reaction2.default.fromJSON(reaction);
	      });
	    }
	  }]);
	
	  return Reactions;
	}(_Collection3.default);
	
	Reactions.displayName = 'Reactions';
	exports.default = Reactions;

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Reaction = function (_Entity) {
	  _inherits(Reaction, _Entity);
	
	  function Reaction() {
	    _classCallCheck(this, Reaction);
	
	    return _possibleConstructorReturn(this, (Reaction.__proto__ || Object.getPrototypeOf(Reaction)).apply(this, arguments));
	  }
	
	  _createClass(Reaction, [{
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }, {
	    key: 'getEmojiCode',
	    value: function getEmojiCode() {
	      return ':' + this.get('name') + ':'; // API returns Emoji shortcodes with no colons
	    }
	  }, {
	    key: 'getUsers',
	    value: function getUsers() {
	      return this.get('users');
	    }
	  }, {
	    key: 'getUserNames',
	    value: function getUserNames() {
	      return this.get('users').map(function (user) {
	        return user['name'];
	      });
	    }
	  }, {
	    key: 'getUserUuids',
	    value: function getUserUuids() {
	      return this.get('users').map(function (user) {
	        return user['uuid'];
	      });
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount() {
	      return this.get('count');
	    }
	  }]);
	
	  return Reaction;
	}(_Entity3.default);
	
	Reaction.displayName = 'Reaction';
	exports.default = Reaction;

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _memoizee = __webpack_require__(839);
	
	var _memoizee2 = _interopRequireDefault(_memoizee);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _ChatMessages = __webpack_require__(940);
	
	var _ChatMessages2 = _interopRequireDefault(_ChatMessages);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatConstants = __webpack_require__(941);
	
	var _ReactionSummary = __webpack_require__(936);
	
	var _ReactionSummary2 = _interopRequireDefault(_ReactionSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChatMessageActions = {
	  sendMessage: function sendMessage(message) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _ChatConstants.ActionTypes.SEND_MESSAGE,
	      chatId: message.getChatId(),
	      message: message
	    });
	
	    var onSuccess = function onSuccess() {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.SENT_MESSAGE,
	        message: message
	      });
	    };
	
	    var onError = function onError() {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.MESSAGE_FAILED,
	        message: message
	      });
	    };
	
	    return message.send().then(onSuccess, onError);
	  },
	  removeMessage: function removeMessage(message) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _ChatConstants.ActionTypes.REMOVE_MESSAGE,
	      message: message
	    });
	  },
	  addReaction: function addReaction(message, reactionName) {
	    _ReactionSummary2.default.createReaction(reactionName, message.getChatId(), message.getUuid()).then(function (reactionSummary) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.ADD_CHAT_MESSAGE_REACTION,
	        message: message,
	        reactionSummary: reactionSummary
	      });
	    });
	  },
	  removeReaction: function removeReaction(message, reactionName) {
	    _ReactionSummary2.default.deleteReaction(reactionName, message.getChatId(), message.getUuid()).then(function (reactionSummary) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.REMOVE_CHAT_MESSAGE_REACTION,
	        message: message,
	        reactionSummary: reactionSummary
	      });
	    });
	  },
	  loadMissingChatMessages: function loadMissingChatMessages(chatId) {
	    var sinceSeq = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    var maxSeq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	    var data = {};
	    if (sinceSeq) {
	      data.since_seq = sinceSeq;
	    }
	    if (maxSeq) {
	      data.max_seq = maxSeq;
	    }
	
	    return _ChatMessages2.default.yieldMessagesForChatId(chatId, { data: data }).then(function (messages) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.LOAD_MISSING_CHAT_MESSAGES,
	        chatId: chatId,
	        messages: messages
	      });
	    });
	  },
	  loadChatMessages: function loadChatMessages(chatId) {
	    _ChatMessages2.default.yieldMessagesForChatId(chatId).then(function (messages) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.LOAD_CHAT_MESSAGES,
	        chatId: chatId,
	        messages: messages
	      });
	    });
	  },
	  updateChatsMessages: function updateChatsMessages(chatsMessages) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _ChatConstants.ActionTypes.UPDATE_CHATS_MESSAGES,
	      chatsMessages: chatsMessages
	    });
	  },
	
	
	  fillGap: (0, _memoizee2.default)(function (gap) {
	    _ChatMessages2.default.yieldMessagesForGap(gap).then(function (messages) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatConstants.ActionTypes.LOAD_GAP_MESSAGE,
	        chatId: gap.getChatId(),
	        gapId: gap.id,
	        messages: messages
	      });
	    });
	  }, {
	    maxAge: _ChatConstants.DATA_RELOAD_TIMEOUT_MS
	  })
	};
	
	exports.default = ChatMessageActions;

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ChatMessage = __webpack_require__(927);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatMessages = function (_Collection) {
	  _inherits(ChatMessages, _Collection);
	
	  function ChatMessages() {
	    _classCallCheck(this, ChatMessages);
	
	    return _possibleConstructorReturn(this, (ChatMessages.__proto__ || Object.getPrototypeOf(ChatMessages)).apply(this, arguments));
	  }
	
	  _createClass(ChatMessages, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = function (attrs, options) {
	        var ChatMessageType = _ChatMessage.chatMessageTypes[attrs.type] || _ChatMessage.ChatMessage;
	        return new ChatMessageType(attrs, options);
	      };
	      this.comparator = 'seq';
	    }
	  }], [{
	    key: 'yieldMessagesForGap',
	    value: function yieldMessagesForGap(gap) {
	      var chatId = gap.getChatId();
	      return ChatMessages.yieldMessagesForChatId(chatId, { data: gap.getParams() });
	    }
	  }, {
	    key: 'yieldMessagesForChatId',
	    value: function yieldMessagesForChatId(chatId) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var messages = new ChatMessages();
	      messages.url = '/chats/' + chatId + '/messages';
	      return messages.fetch(options);
	    }
	  }]);
	
	  return ChatMessages;
	}(_Collection3.default);
	
	ChatMessages.displayName = 'ChatMessages';
	exports.default = ChatMessages;

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CHATS_PAGE_SIZE = exports.SEARCH_NETWORK_LIMIT_MS = exports.SEARCH_UI_LIMIT_MS = exports.DATA_RELOAD_TIMEOUT_MS = exports.FocusableViews = exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['APPEND_MEMBERS', 'CREATE_CHAT', 'DEACTIVATE', 'DESTROY_LOCAL_CHAT', 'FILTER_BY_GROUP', 'JOIN_CHAT', 'LEAVE_CHAT', 'LIST_CHATS', 'LOAD_CHAT', 'UPDATE_CHATS_MESSAGES', 'LOAD_CHAT_MESSAGES', 'LOAD_GAP_MESSAGE', 'LOAD_LOCAL_CHAT', 'UPDATE_LOCAL_CHAT', 'LOAD_MEMBERS', 'MARK_READ', 'MESSAGE_FAILED', 'REMOVE_MEMBERS_FROM_CHAT', 'READ_MESSAGE', 'REMOVE_GROUPS', 'REMOVE_MESSAGE', 'RESET_STORE', 'ADD_MEMBERS_TO_CHAT', 'ENABLE_REPLIES_CHAT', 'EDIT_MEMBER_FROM_CHAT', 'DISABLE_REPLIES_CHAT', 'SELECT_CHAT', 'RESET_SELECTION', 'SEND_MESSAGE', 'SENT_MESSAGE', 'UPDATE_CHAT', 'UPDATE_MEMBER', 'APPEND_CHATS', 'SET_FOCUS_VIEW', 'SEARCH_CHATS', 'ADD_CHAT_MESSAGE_REACTION', 'REMOVE_CHAT_MESSAGE_REACTION']);
	var FocusableViews = exports.FocusableViews = (0, _enumerate2.default)(['NONE', 'COMPOSER', 'HEADER']);
	
	var DATA_RELOAD_TIMEOUT_MS = exports.DATA_RELOAD_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes
	
	var SEARCH_UI_LIMIT_MS = exports.SEARCH_UI_LIMIT_MS = 150;
	
	/**
	 * Limit network request frequency so that serial requests (e.g. q=t, q=tu, q=tur)
	 * don't waste bandwidth and CPU
	 */
	var SEARCH_NETWORK_LIMIT_MS = exports.SEARCH_NETWORK_LIMIT_MS = 300;
	
	exports.default = {
	  ActionTypes: ActionTypes,
	  FocusableViews: FocusableViews,
	  DATA_RELOAD_TIMEOUT_MS: DATA_RELOAD_TIMEOUT_MS,
	  SEARCH_UI_LIMIT_MS: SEARCH_UI_LIMIT_MS,
	  SEARCH_NETWORK_LIMIT_MS: SEARCH_NETWORK_LIMIT_MS
	};
	var CHATS_PAGE_SIZE = exports.CHATS_PAGE_SIZE = 8;

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatMessageActions = __webpack_require__(939);
	
	var _ChatMessageActions2 = _interopRequireDefault(_ChatMessageActions);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _ChatMessages = __webpack_require__(940);
	
	var _ChatMessages2 = _interopRequireDefault(_ChatMessages);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _ChatConstants = __webpack_require__(941);
	
	var _RootGroup = __webpack_require__(943);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Chats = function (_Collection) {
	  _inherits(Chats, _Collection);
	
	  function Chats(models) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Chats);
	
	    var _this = _possibleConstructorReturn(this, (Chats.__proto__ || Object.getPrototypeOf(Chats)).call(this, models, options));
	
	    _this.sort();
	    return _this;
	  }
	
	  _createClass(Chats, [{
	    key: 'comparator',
	    value: function comparator(a, b) {
	      if (a.isNew()) {
	        return -1;
	      }
	      if (b.isNew()) {
	        return 1;
	      }
	      return b.getSortKey() > a.getSortKey() ? 1 : -1;
	    }
	  }, {
	    key: 'initialize',
	    value: function initialize() {
	      this.url = '/chats';
	      this.model = _Chat2.default;
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(chat, position) {
	      this.remove(chat);
	      this.add(chat, { at: position });
	    }
	  }, {
	    key: 'getNewestUpdatedAt',
	    value: function getNewestUpdatedAt() {
	      var newestChat = _lodash2.default.maxBy(this.models, function (chat) {
	        return chat.getUpdatedAt();
	      });
	      return newestChat ? newestChat.getUpdatedAt() : null;
	    }
	  }, {
	    key: 'getOldestUpdatedAt',
	    value: function getOldestUpdatedAt() {
	      var oldestChat = _lodash2.default.minBy(this.models, function (chat) {
	        return chat.getUpdatedAt();
	      });
	      return oldestChat ? oldestChat.getUpdatedAt() : null;
	    }
	  }, {
	    key: 'getLastMessage',
	    value: function getLastMessage() {
	      return this.isEmpty() ? null : this.first().getLastMessage();
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      // HACK to get v2/chats messages in this response
	      if (response.messages) {
	        var chatsMessages = {};
	
	        var _loop = function _loop(chatId) {
	          // Protect ourselves from a backend bug that includes messages from other threads
	          // in the pre-loaded message collection
	          // TODO: Remove .filter when https://app.asana.com/0/32507888495125/158289850714897 is fixed
	          var messagesData = response.messages[chatId].filter(function (m) {
	            return m.chat.uuid === chatId;
	          });
	          var messagesCollection = _ChatMessages2.default.fromJSON(messagesData);
	          chatsMessages[chatId] = messagesCollection;
	        };
	
	        for (var chatId in response.messages) {
	          _loop(chatId);
	        }
	        _ChatMessageActions2.default.updateChatsMessages(chatsMessages);
	      }
	
	      return response.chats;
	    }
	  }, {
	    key: 'selectChatsInGroup',
	    value: function selectChatsInGroup(group) {
	      if (group.isRoot()) {
	        return this;
	      }
	      // new chats aren't associated with any group, they just show up in whatever group
	      // you were viewing at time of creation and are deleted if you switch groups
	      return new Chats(this.filter(function (chat) {
	        return chat.isInGroup(group.id) || chat.isNew();
	      }));
	    }
	  }], [{
	    key: 'setStateForAllChats',
	    value: function setStateForAllChats(state) {
	      return _RemindAPI2.default.request('/chats', 'PATCH', {
	        chats: { state: state }
	      });
	    }
	  }, {
	    key: 'enableRepliesForAllChats',
	    value: function enableRepliesForAllChats() {
	      return this.setStateForAllChats('open');
	    }
	  }, {
	    key: 'disableRepliesForAllChats',
	    value: function disableRepliesForAllChats() {
	      return this.setStateForAllChats('replies_disabled');
	    }
	  }, {
	    key: 'loadForGroup',
	    value: function loadForGroup(groupId) {
	      return Chats.request(null, groupId, false);
	    }
	  }, {
	    key: 'search',
	    value: function search(query) {
	      // Include memberships so matching matching against memberships works in chat list
	      return Chats.request(query);
	    }
	  }, {
	    key: 'request',
	    value: function request(query) {
	      var groupId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _RootGroup.rootGroup.id;
	      var includeMemberships = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      var params = {
	        limit: _ChatConstants.CHATS_PAGE_SIZE,
	        // null query sent as empty
	        q: query,
	        group_id: groupId,
	        // We load the root group messages at start so no need to get messages for each group.
	        // When we do include messages, only get the unreads, assuming that's all people really care about.
	        include_messages: groupId === _RootGroup.rootGroup.id ? 'unreads' : false,
	        include_memberships: includeMemberships
	      };
	      // web's root group means no group to the backend
	      if (groupId === _RootGroup.rootGroup.id) {
	        delete params['group_id'];
	      }
	      return _RemindAPI2.default.request('/chats', 'GET', params).then(function (response) {
	        return Chats.fromJSON(response);
	      });
	    }
	  }]);
	
	  return Chats;
	}(_Collection3.default);
	
	Chats.displayName = 'Chats';
	exports.default = Chats;

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rootGroup = exports.rootGroupCode = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Group2 = __webpack_require__(606);
	
	var _Group3 = _interopRequireDefault(_Group2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// virtual id, not in the database
	var rootGroupId = -1;
	
	var rootGroupCode = exports.rootGroupCode = 'r';
	
	var RootGroup = function (_Group) {
	  _inherits(RootGroup, _Group);
	
	  function RootGroup() {
	    _classCallCheck(this, RootGroup);
	
	    return _possibleConstructorReturn(this, (RootGroup.__proto__ || Object.getPrototypeOf(RootGroup)).apply(this, arguments));
	  }
	
	  _createClass(RootGroup, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.id = rootGroupId;
	    }
	  }, {
	    key: 'isRoot',
	    value: function isRoot() {
	      return true;
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      // not concerned yet with localization
	      return 'All classes';
	    }
	  }, {
	    key: 'getCode',
	    value: function getCode() {
	      return rootGroupCode;
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return 'root';
	    }
	  }, {
	    key: 'isStaffClass',
	    value: function isStaffClass() {
	      return false;
	    }
	  }, {
	    key: 'canAddPeople',
	    value: function canAddPeople() {
	      return false;
	    }
	  }, {
	    key: 'canJoin',
	    value: function canJoin() {
	      return false;
	    }
	  }, {
	    key: 'canEdit',
	    value: function canEdit() {
	      return false;
	    }
	  }, {
	    key: 'canLeave',
	    value: function canLeave() {
	      return false;
	    }
	
	    /**
	     * @deprecated. Use postable roles instead.
	     */
	
	  }, {
	    key: 'canPost',
	    value: function canPost() {
	      return true;
	    }
	  }, {
	    key: 'getPostableRoles',
	    value: function getPostableRoles() {
	      return [];
	    }
	  }, {
	    key: 'canDelete',
	    value: function canDelete() {
	      return false;
	    }
	  }, {
	    key: 'isSMSEnabled',
	    value: function isSMSEnabled() {
	      return false;
	    }
	  }, {
	    key: 'hasShortCode',
	    value: function hasShortCode() {
	      return false;
	    }
	  }, {
	    key: 'isAvailable',
	    value: function isAvailable() {
	      return false;
	    }
	  }, {
	    key: 'isSubscribed',
	    value: function isSubscribed() {
	      return false;
	    }
	  }, {
	    key: 'isOwnedByUser',
	    value: function isOwnedByUser() {
	      return false;
	    }
	  }, {
	    key: 'getPermissions',
	    value: function getPermissions() {
	      return {};
	    }
	  }, {
	    key: 'getAvatarUrl',
	    value: function getAvatarUrl() {
	      return __webpack_require__(944);
	    }
	  }, {
	    key: 'getAccentColor',
	    value: function getAccentColor() {
	      return '#2f75c1';
	    }
	  }, {
	    key: 'getOwners',
	    value: function getOwners() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'setName',
	    value: function setName() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'getPdfUrl',
	    value: function getPdfUrl() {
	      return ''; // TODO: Where is this invoked?
	    }
	  }, {
	    key: 'getJoinUrl',
	    value: function getJoinUrl() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'hasChildren',
	    value: function hasChildren() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'setHasChildren',
	    value: function setHasChildren() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'getMembershipsCount',
	    value: function getMembershipsCount() {
	      return 0; // TODO: Where is this invoked?
	    }
	  }, {
	    key: 'getSubscriptionInfo',
	    value: function getSubscriptionInfo() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'useShortCodeForUser',
	    value: function useShortCodeForUser() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'smsEnabledForUser',
	    value: function smsEnabledForUser() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'getStaffClassOrgId',
	    value: function getStaffClassOrgId() {
	      return null;
	    }
	  }, {
	    key: 'getOrganization',
	    value: function getOrganization() {
	      return null;
	    }
	  }, {
	    key: 'setOrganization',
	    value: function setOrganization() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'getMessagesCount',
	    value: function getMessagesCount() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'isMessageHistoryEnabled',
	    value: function isMessageHistoryEnabled() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'getLastReadSeq',
	    value: function getLastReadSeq() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'canSubscribersInitiateChats',
	    value: function canSubscribersInitiateChats() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'setCanSubscribersInititateChats',
	    value: function setCanSubscribersInititateChats() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'getPossessiveName',
	    value: function getPossessiveName() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'getSMSNumber',
	    value: function getSMSNumber() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'getSMSAlternateNumber',
	    value: function getSMSAlternateNumber() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'getEmail',
	    value: function getEmail() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'isSearchable',
	    value: function isSearchable() {
	      return true;
	    }
	  }, {
	    key: 'setSearchable',
	    value: function setSearchable() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'getAvatar',
	    value: function getAvatar() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'getAvatarId',
	    value: function getAvatarId() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'setAvatar',
	    value: function setAvatar() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'setLastReadSeq',
	    value: function setLastReadSeq() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'getUserId',
	    value: function getUserId() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'getUserSignature',
	    value: function getUserSignature() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'getState',
	    value: function getState() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'setState',
	    value: function setState() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'loadPotentialOwners',
	    value: function loadPotentialOwners() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'loadGroupMemberships',
	    value: function loadGroupMemberships() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'promoteGroupMemberships',
	    value: function promoteGroupMemberships() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'resignOwnership',
	    value: function resignOwnership() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'removeMember',
	    value: function removeMember() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'removeAllMembers',
	    value: function removeAllMembers() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'addSubscribers',
	    value: function addSubscribers() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'subscribe',
	    value: function subscribe() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }, {
	    key: 'unsubscribe',
	    value: function unsubscribe() {
	      throw new Error('unsupported operation for RootGroup');
	    }
	  }]);
	
	  return RootGroup;
	}(_Group3.default);
	
	RootGroup.displayName = 'RootGroup';
	exports.default = RootGroup;
	var rootGroup = exports.rootGroup = new RootGroup();

/***/ },
/* 944 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ChatMember = __webpack_require__(921);
	
	var _ChatMember2 = _interopRequireDefault(_ChatMember);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _OfficeHours = __webpack_require__(922);
	
	var _OfficeHours2 = _interopRequireDefault(_OfficeHours);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PotentialChatMember = function (_Entity) {
	  _inherits(PotentialChatMember, _Entity);
	
	  function PotentialChatMember() {
	    _classCallCheck(this, PotentialChatMember);
	
	    return _possibleConstructorReturn(this, (PotentialChatMember.__proto__ || Object.getPrototypeOf(PotentialChatMember)).apply(this, arguments));
	  }
	
	  _createClass(PotentialChatMember, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.urlRoot = '/chats/members';
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        sort_key: 'name',
	        group_ids: [],
	        group_names: [],
	        school_names: [],
	        note: ''
	      };
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var member = _lodash2.default.cloneDeep(response);
	      member['office_hours'] = member['office_hours'] ? _OfficeHours2.default.fromJSON(member['office_hours']) : null;
	      member['user'] = _User2.default.fromJSON(member['user']);
	
	      return member;
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }, {
	    key: 'isMemberOfGroup',
	    value: function isMemberOfGroup(groupId) {
	      return this.get('group_ids').includes(groupId);
	    }
	  }, {
	    key: 'isTeacherLead',
	    value: function isTeacherLead() {
	      return this.get('record_type') === 'teacher_lead';
	    }
	  }, {
	    key: 'isRecommended',
	    value: function isRecommended() {
	      return !!this.get('recommended');
	    }
	  }, {
	    key: 'isInvited',
	    value: function isInvited() {
	      return this.getState() === 'invited';
	    }
	  }, {
	    key: 'isInvitable',
	    value: function isInvitable() {
	      return this.getState() === 'invitable';
	    }
	  }, {
	    key: 'getConnectionDescription',
	    value: function getConnectionDescription() {
	      return this.get('connection_description');
	    }
	  }, {
	    key: 'getFirstName',
	    value: function getFirstName() {
	      return this.get('first_name');
	    }
	  }, {
	    key: 'getLastName',
	    value: function getLastName() {
	      return this.get('last_name');
	    }
	  }, {
	    key: 'getSortKey',
	    value: function getSortKey() {
	      return this.get('sort_key');
	    }
	  }, {
	    key: 'getQueryKey',
	    value: function getQueryKey() {
	      return this.get('query_key');
	    }
	  }, {
	    key: 'setName',
	    value: function setName(name) {
	      return this.set({ name: name });
	    }
	  }, {
	    key: 'getRole',
	    value: function getRole() {
	      return this.get('role');
	    }
	  }, {
	    key: 'getState',
	    value: function getState() {
	      return this.get('state');
	    }
	  }, {
	    key: 'setState',
	    value: function setState(state) {
	      return this.set('state', state);
	    }
	  }, {
	    key: 'getGroupNames',
	    value: function getGroupNames() {
	      return this.get('group_names');
	    }
	  }, {
	    key: 'getSchoolNames',
	    value: function getSchoolNames() {
	      return this.get('school_names');
	    }
	  }, {
	    key: 'getNote',
	    value: function getNote() {
	      return this.get('note');
	    }
	  }, {
	    key: 'getOfficeHours',
	    value: function getOfficeHours() {
	      return this.get('office_hours');
	    }
	  }, {
	    key: 'getUser',
	    value: function getUser() {
	      return this.get('user');
	    }
	  }, {
	    key: 'isEligible',
	    value: function isEligible() {
	      return this.getState() === 'eligible';
	    }
	  }, {
	    key: 'isPending',
	    value: function isPending() {
	      return this.getState() === 'pending';
	    }
	  }, {
	    key: 'isUnder13',
	    value: function isUnder13() {
	      return this.getState() === 'under_13';
	    }
	  }, {
	    key: 'isUnavailable',
	    value: function isUnavailable() {
	      return this.getState() === 'unavailable';
	    }
	  }, {
	    key: 'isAgeUnknown',
	    value: function isAgeUnknown() {
	      return this.getState() === 'unknown';
	    }
	  }, {
	    key: 'requestAge',
	    value: function requestAge() {
	      (0, _invariant2.default)(this.isAgeUnknown(), 'Age can only be requested for PotentialChatMember with unknown age.');
	
	      return this.save({
	        state: 'pending'
	      }, {
	        data: { member: { state: 'pending' } },
	        patch: true
	      });
	    }
	  }], [{
	    key: 'getChatMember',
	    value: function getChatMember(user) {
	      return new PotentialChatMember({
	        id: user.id,
	        name: user.getName(),
	        role: user.getRole(),
	        office_hours: user.getOfficeHours()
	      });
	    }
	  }]);
	
	  return PotentialChatMember;
	}(_Entity3.default);
	
	PotentialChatMember.displayName = 'PotentialChatMember';
	exports.default = PotentialChatMember;

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _PotentialChatMember = __webpack_require__(945);
	
	var _PotentialChatMember2 = _interopRequireDefault(_PotentialChatMember);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PotentialChatMembers = function (_Collection) {
	  _inherits(PotentialChatMembers, _Collection);
	
	  function PotentialChatMembers() {
	    _classCallCheck(this, PotentialChatMembers);
	
	    return _possibleConstructorReturn(this, (PotentialChatMembers.__proto__ || Object.getPrototypeOf(PotentialChatMembers)).apply(this, arguments));
	  }
	
	  _createClass(PotentialChatMembers, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.url = '/chats/members/search/';
	      this.model = _PotentialChatMember2.default;
	    }
	  }, {
	    key: 'getAvailableMembers',
	    value: function getAvailableMembers() {
	      return new PotentialChatMembers(this.filter(function (member) {
	        return !member.isUnavailable();
	      }));
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      return response.potential_chat_members;
	    }
	  }]);
	
	  return PotentialChatMembers;
	}(_Collection3.default);
	
	PotentialChatMembers.displayName = 'PotentialChatMembers';
	exports.default = PotentialChatMembers;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dispatcher = __webpack_require__(590);
	
	var _toasts = __webpack_require__(948);
	
	// If you can, use the toasts redux actions:
	//
	// import {showToast} from 'reducers/toasts';
	// import {bindActionCreators} from 'redux';
	// import {connect} from 'react-redux';
	//
	// const SomeComponent = (props) => {
	//   return (
	//     <span onClick={() => props.showToast('hello', 'success')}>
	//       click me
	//     </span>
	//   );
	// }
	//
	// function mapDispatchToProps(dispatch: Function) {
	//   return bindActionCreators({showToast}, dispatch);
	// }
	//
	// export default connect(undefined, mapDispatchToProps)(SomeComponent)
	
	// TODO - rm this file!
	var ToastActions = {
	  showSuccessToast: function showSuccessToast(message) {
	    _Dispatcher.reduxDispatcher.dispatch((0, _toasts.showToast)(message, 'success'));
	  },
	  showErrorToast: function showErrorToast(message) {
	    _Dispatcher.reduxDispatcher.dispatch((0, _toasts.showToast)(message, 'error'));
	  },
	  showAPIError: function showAPIError(error) {
	    _Dispatcher.reduxDispatcher.dispatch((0, _toasts.showAPIErrorToast)(error));
	  },
	  showDefaultErrorToast: function showDefaultErrorToast() {
	    _Dispatcher.reduxDispatcher.dispatch((0, _toasts.showToast)('An error occurred.', 'error'));
	  }
	};
	
	exports.default = ToastActions;

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = reducer;
	exports.add = add;
	exports.remove = remove;
	exports.showToast = showToast;
	exports.showAPIErrorToast = showAPIErrorToast;
	
	var _immutable = __webpack_require__(949);
	
	var _uuid = __webpack_require__(582);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = new _immutable.List();
	
	// typecheck: ignore statement
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'toasts/ADD':
	      return state.push(action.toast);
	    case 'toasts/REMOVE':
	      return state.remove(state.indexOf(action.toast));
	    default:
	      return state;
	  }
	}
	
	function add(toast) {
	  return {
	    type: 'toasts/ADD',
	    toast: toast
	  };
	}
	
	function remove(toast) {
	  return {
	    type: 'toasts/REMOVE',
	    toast: toast
	  };
	}
	
	// helper for the add action, to create new toast.
	function showToast(text, kind) {
	  return add({ uuid: (0, _uuid2.default)(), text: text, kind: kind });
	}
	
	// helper for the add action, to create toast from API response.
	function showAPIErrorToast(error) {
	  var text = void 0;
	
	  if (error.code === 'validation_error') {
	    text = error.field_errors.map(function (err) {
	      return err.messages.join(', ');
	    }).join(', ');
	  } else if (error.message) {
	    text = error.message;
	  } else {
	    text = 'An error occurred.';
	  }
	
	  return add({ uuid: (0, _uuid2.default)(), text: text, kind: 'error' });
	}

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GOOGLE_PLATFORM_JS = 'https://apis.google.com/js/client:platform.js'; /*  weak */
	
	var GOOGLE_CLIENT_ID = '648260376696-s7opre8oqbblsj80ght3tf86kvjifq98.apps.googleusercontent.com';
	
	var loadId = null;
	
	function load(callback) {
	  if (window.gapi) {
	    callback(window.gapi);
	    return;
	  }
	
	  var $script = __webpack_require__(951);
	
	  if (!loadId) {
	    $script(GOOGLE_PLATFORM_JS, loadId = _lodash2.default.uniqueId('gapi'));
	  }
	
	  $script.ready(loadId, function () {
	    callback(window.gapi);
	  });
	}
	
	/**
	 * Initializes the Google API with an auth2 instance.
	 * For more information, see: https://developers.google.com/identity/sign-in/web/reference
	 */
	function initWithAuthInstance() {
	  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
	
	  load(function (gapi) {
	    gapi.load('auth2', function () {
	      var auth2 = gapi.auth2.getAuthInstance();
	      if (!auth2) {
	        auth2 = gapi.auth2.init({
	          client_id: GOOGLE_CLIENT_ID,
	          scope: 'https://www.googleapis.com/auth/plus.login',
	          cookiepolicy: 'single_host_origin'
	        });
	      }
	      callback(gapi);
	    });
	  });
	}
	
	/**
	 * Fetches an authorization code for server-side authentication.
	 * See https://developers.google.com/identity/sign-in/web/server-side-flow
	 * @returns {Promise} that resolves with an authorization code
	 */
	function fetchAuthorizationCode() {
	  return new Promise(function (resolve, reject) {
	    var handleAuthResult = function handleAuthResult(authResult) {
	      var code = authResult.code;
	      if (code) {
	        resolve(code);
	      } else {
	        reject(new Error('GoogleAPI auth fetchAuthorizationCode failed'));
	      }
	    };
	
	    initWithAuthInstance(function (gapi) {
	      var auth2 = gapi.auth2.getAuthInstance();
	      auth2.grantOfflineAccess({ redirect_uri: 'postmessage' }).then(handleAuthResult).catch(function (e) {
	        return console.error('GoogleAPI fetchAuthorizationCode failed', e);
	      });
	    });
	  });
	}
	
	/**
	 * Signs out of the Google API auth2 instance
	 */
	function signOut() {
	  initWithAuthInstance(function (gapi) {
	    var auth2 = gapi.auth2.getAuthInstance();
	    if (auth2.isSignedIn.get()) {
	      auth2.signOut();
	    }
	  });
	}
	
	exports.default = {
	  initWithAuthInstance: initWithAuthInstance,
	  fetchAuthorizationCode: fetchAuthorizationCode,
	  signOut: signOut
	};

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * $script.js JS loader & dependency manager
	  * https://github.com/ded/script.js
	  * (c) Dustin Diaz 2014 | License MIT
	  */
	
	(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('$script', function () {
	  var doc = document
	    , head = doc.getElementsByTagName('head')[0]
	    , s = 'string'
	    , f = false
	    , push = 'push'
	    , readyState = 'readyState'
	    , onreadystatechange = 'onreadystatechange'
	    , list = {}
	    , ids = {}
	    , delay = {}
	    , scripts = {}
	    , scriptpath
	    , urlArgs
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	    return 1
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      return !fn(el)
	    })
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths]
	    var idOrDoneIsDone = idOrDone && idOrDone.call
	      , done = idOrDoneIsDone ? idOrDone : optDone
	      , id = idOrDoneIsDone ? paths.join('') : idOrDone
	      , queue = paths.length
	    function loopFn(item) {
	      return item.call ? item() : list[item]
	    }
	    function callback() {
	      if (!--queue) {
	        list[id] = 1
	        done && done()
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback()
	        
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
	        }
	        
	        if (scripts[path]) {
	          if (id) ids[id] = 1
	          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
	        }
	
	        scripts[path] = 1
	        if (id) ids[id] = 1
	        create(path, callback)
	      })
	    }, 0)
	    return $script
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'), loaded
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
	      el.onload = el[onreadystatechange] = null
	      loaded = 1
	      scripts[path] = 2
	      fn()
	    }
	    el.async = 1
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild)
	  }
	
	  $script.get = create
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift()
	      !scripts.length ? $script(s, id, done) : $script(s, callback)
	    }())
	  }
	
	  $script.path = function (p) {
	    scriptpath = p
	  }
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  }
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps]
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {return list[dep]}) ?
	      ready() : !function (key) {
	      delay[key] = delay[key] || []
	      delay[key][push](ready)
	      req && req(missing)
	    }(deps.join('|'))
	    return $script
	  }
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone)
	  }
	
	  return $script
	});


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _PusherActions = __webpack_require__(953);
	
	var _PusherActions2 = _interopRequireDefault(_PusherActions);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _PusherConnection = __webpack_require__(973);
	
	var _userBootData = __webpack_require__(975);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PusherClient = function () {
	  function PusherClient() {
	    _classCallCheck(this, PusherClient);
	
	    this._subscribed = {};
	  }
	
	  _createClass(PusherClient, [{
	    key: '_getKey',
	    value: function _getKey() {
	      return (0, _userBootData.promiseSettings)().then(function () {
	        return _SettingsStore2.default.getPusherKey();
	      });
	    }
	
	    /**
	     * @return {Promise} for a Pusher connection using the key in SettingsStore
	     */
	
	  }, {
	    key: '_getOpenConnection',
	    value: function _getOpenConnection() {
	      return this._getKey().then(_PusherConnection.openConnection);
	    }
	
	    /**
	     * @return {Promise} for a Pusher channel
	     */
	
	  }, {
	    key: 'subscribe',
	    value: function subscribe(channelName) {
	      this._subscribed[channelName] = true;
	      return this._getOpenConnection().then(function (conn) {
	        return conn.subscribe(channelName);
	      });
	    }
	  }, {
	    key: 'unsubscribe',
	    value: function unsubscribe(channelName) {
	      if (this.isSubscribedTo(channelName)) {
	        delete this._subscribed[channelName];
	        this._getOpenConnection().then(function (conn) {
	          return conn.unsubscribe(channelName);
	        }).catch(function (e) {
	          return console.error('PusherClient unsubscribe failed', e);
	        });
	      }
	    }
	  }, {
	    key: 'unsubscribeAll',
	    value: function unsubscribeAll() {
	      for (var channel in this._subscribed) {
	        this.unsubscribe(channel);
	      }
	    }
	  }, {
	    key: 'disconnectAndCleanUp',
	    value: function disconnectAndCleanUp() {
	      (0, _PusherConnection.closeConnection)();
	
	      _PusherActions2.default.resetStore();
	    }
	  }, {
	    key: 'isSubscribedTo',
	    value: function isSubscribedTo(channelName) {
	      return channelName in this._subscribed;
	    }
	  }, {
	    key: 'bind',
	    value: function bind(state, callback) {
	      this._getOpenConnection().then(function (conn) {
	        return conn.bind(state, callback);
	      }).catch(function (e) {
	        return console.error('PusherClient bind failed', e);
	      });
	    }
	  }, {
	    key: 'retry',
	    value: function retry() {
	      (0, _PusherConnection.resetConnection)();
	    }
	  }]);
	
	  return PusherClient;
	}();
	
	PusherClient.displayName = 'PusherClient';
	exports.default = new PusherClient();

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dispatcher = __webpack_require__(590);
	
	var _PusherConstants = __webpack_require__(954);
	
	var _PusherClient = __webpack_require__(952);
	
	var _PusherClient2 = _interopRequireDefault(_PusherClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PusherActions = {
	  subscribeToChannel: function subscribeToChannel(channelName) {
	    if (_PusherClient2.default.isSubscribedTo(channelName)) {
	      return;
	    }
	
	    // Have all pusher event go through the dispatcher
	    _PusherClient2.default.subscribe(channelName).then(function (channel) {
	      channel.bind_all(function (event, data) {
	        _Dispatcher.dispatcher.handlePusherEvent({
	          type: event,
	          eventData: data
	        });
	      });
	    }).catch(function (e) {
	      return console.error('PusherActions subscribeToChannel failed', e);
	    });
	
	    _PusherClient2.default.bind('state_change', this.updateConnectionState);
	  },
	  unsubscribeToChannel: function unsubscribeToChannel(channelName) {
	    _PusherClient2.default.unsubscribe(channelName);
	  },
	  updateConnectionState: function updateConnectionState(states) {
	    _Dispatcher.dispatcher.handlePusherEvent({
	      type: _PusherConstants.PushEvents.CONNECTION_STATE_CHANGED,
	      previous: states.previous,
	      current: states.current
	    });
	  },
	  retryConnection: function retryConnection() {
	    _PusherClient2.default.retry();
	    _Dispatcher.dispatcher.handlePusherEvent({
	      type: _PusherConstants.PushEvents.RETRY_CONNECTION
	    });
	  },
	  resetStore: function resetStore() {
	    _Dispatcher.dispatcher.handlePusherEvent({
	      type: _PusherConstants.PushEvents.RESET_STORE
	    });
	  }
	};
	exports.default = PusherActions;

/***/ },
/* 954 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PushEvents = exports.PushEvents = {
	  CLASS_MEMBERSHIP: 'classmembership',
	  CONNECTION_STATE_CHANGED: 'state_change',
	  USER: 'user',
	  RETRY_CONNECTION: 'retry_connection',
	  RESET_STORE: 'reset_store',
	  MARKER_UPDATE: 'marker_updates',
	  TEST_MESSAGE: 'test_message',
	
	  // delivery updates
	  CHANGESET_UPDATE_DELIVERY_UPDATES: 'changeset-update-delivery_updates',
	
	  // chat message
	  CHANGESET_CREATE_CHAT_MESSAGE: 'changeset-create-chat_message',
	
	  // group
	  CHANGESET_UPDATE_GROUP: 'changeset-update-group',
	  CHANGESET_CREATE_GROUP: 'changeset-create-group',
	  CHANGESET_DESTROY_GROUP: 'changeset-destroy-group',
	
	  // unread
	  CHANGESET_UPDATE_UNREADS: 'changeset-update-unreads',
	
	  // chat
	  CHANGESET_UPDATE_CHAT: 'changeset-update-chat',
	  CHANGESET_UPDATE_CHATS: 'changeset-update-chats',
	
	  // class memberships
	  CHANGESET_CREATE_CLASSMEMBERSHIP: 'changeset-create-classmembership',
	  CHANGESET_DESTROY_CLASSMEMBERSHIP: 'changeset-destroy-classmembership',
	
	  // devices
	  CHANGESET_DESTROY_DEVICE: 'changeset-destroy-device',
	  CHANGESET_UPDATE_DEVICE: 'changeset-update-device',
	  CHANGESET_CREATE_DEVICE: 'changeset-create-device',
	
	  // desktop notification
	  CHANGESET_CREATE_DESKTOP_NOTIFICATION: 'changeset-create-desktop_notification',
	
	  // user
	  CHANGESET_UPDATE_USER: 'changeset-update-user',
	
	  // reactions
	  CONTENT_UPDATE_CHAT_MESSAGE_REACTION: 'content-update-chat_message_reaction',
	  CONTENT_UPDATE_CHAT_BROADCAST_REACTION: 'content-update-chat_broadcast_reaction'
	};

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _SettingConstants = __webpack_require__(972);
	
	var _Dispatcher = __webpack_require__(590);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsStore = function (_ReduceStore) {
	  _inherits(SettingsStore, _ReduceStore);
	
	  function SettingsStore() {
	    _classCallCheck(this, SettingsStore);
	
	    return _possibleConstructorReturn(this, (SettingsStore.__proto__ || Object.getPrototypeOf(SettingsStore)).apply(this, arguments));
	  }
	
	  _createClass(SettingsStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        settings: null
	      };
	    }
	  }, {
	    key: 'isLoaded',
	    value: function isLoaded() {
	      return this.getState().settings !== null;
	    }
	  }, {
	    key: 'getSetting',
	    value: function getSetting() {
	      if (!this.isLoaded()) {
	        return null;
	      }
	
	      var setting = this.getSettings();
	
	      for (var _len = arguments.length, names = Array(_len), _key = 0; _key < _len; _key++) {
	        names[_key] = arguments[_key];
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var name = _step.value;
	
	          if (name in setting) {
	            setting = setting[name];
	          } else {
	            break;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return setting;
	    }
	  }, {
	    key: 'getSettings',
	    value: function getSettings() {
	      return this.getState().settings;
	    }
	  }, {
	    key: 'getLanguages',
	    value: function getLanguages() {
	      return this.getSetting('languages');
	    }
	  }, {
	    key: 'getPrimaryLanguages',
	    value: function getPrimaryLanguages() {
	      return this.getSetting('languages', 'primary');
	    }
	  }, {
	    key: 'getPusherKey',
	    value: function getPusherKey() {
	      return this.getSetting('pusher', 'key');
	    }
	  }, {
	    key: 'getMinClassNameLength',
	    value: function getMinClassNameLength() {
	      return this.getSetting('group', 'class_name', 'length', 'min');
	    }
	  }, {
	    key: 'getComposerActivityRegex',
	    value: function getComposerActivityRegex() {
	      return this.getSetting('composer', 'activity_regex');
	    }
	  }, {
	    key: 'getMinPaymentPerPerson',
	    value: function getMinPaymentPerPerson() {
	      return this.getSetting('payment', 'amount_per_person', 'min');
	    }
	  }, {
	    key: 'getMaxPaymentPerPerson',
	    value: function getMaxPaymentPerPerson() {
	      return this.getSetting('payment', 'amount_per_person', 'max');
	    }
	  }, {
	    key: 'getChatMembersLimit',
	    value: function getChatMembersLimit() {
	      return this.getSetting('chats', 'members', 'limit');
	    }
	  }, {
	    key: 'getMaxClassNameLength',
	    value: function getMaxClassNameLength() {
	      return this.getSetting('group', 'class_name', 'length', 'max');
	    }
	  }, {
	    key: 'getMinClassCodeLength',
	    value: function getMinClassCodeLength() {
	      return this.getSetting('group', 'name', 'length', 'min');
	    }
	  }, {
	    key: 'getMaxClassCodeLength',
	    value: function getMaxClassCodeLength() {
	      return this.getSetting('group', 'name', 'length', 'max');
	    }
	  }, {
	    key: 'getMessagesTiming',
	    value: function getMessagesTiming() {
	      return this.getSetting('messages', 'timing');
	    }
	  }, {
	    key: 'getMinimumOrgQueryLength',
	    value: function getMinimumOrgQueryLength() {
	      return this.getSetting('organizations', 'minimum_name_query_length');
	    }
	  }, {
	    key: 'getStripeKey',
	    value: function getStripeKey() {
	      return this.getSetting('payment', 'stripe', 'publishable_key');
	    }
	  }, {
	    key: 'reduce',
	    value: function reduce(state, action) {
	      switch (action.type) {
	        case _SettingConstants.ActionTypes.LOAD_SETTINGS:
	          return { settings: action.settings };
	        default:
	          return state;
	      }
	    }
	  }]);
	
	  return SettingsStore;
	}(_utils.ReduceStore);
	
	SettingsStore.displayName = 'SettingsStore';
	exports.default = new SettingsStore(_Dispatcher.dispatcher);

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	module.exports.Container = __webpack_require__(957);
	module.exports.MapStore = __webpack_require__(960);
	module.exports.Mixin = __webpack_require__(971);
	module.exports.ReduceStore = __webpack_require__(961);
	module.exports.Store = __webpack_require__(962);


/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxContainer
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FluxStoreGroup = __webpack_require__(958);
	
	var invariant = __webpack_require__(593);
	var shallowEqual = __webpack_require__(959);
	
	var DEFAULT_OPTIONS = {
	  pure: true,
	  withProps: false
	};
	
	/**
	 * A FluxContainer is used to subscribe a react component to multiple stores.
	 * The stores that are used must be returned from a static `getStores()` method.
	 *
	 * The component receives information from the stores via state. The state
	 * is generated using a static `calculateState()` method that each container
	 * must implement. A simple container may look like:
	 */
	function create(Base, options) {
	  enforceInterface(Base);
	
	  // Construct the options using default, override with user values as necessary
	  var realOptions = _extends({}, DEFAULT_OPTIONS, options || {});
	
	  var FluxContainerClass = (function (_Base) {
	    _inherits(FluxContainerClass, _Base);
	
	    function FluxContainerClass(props) {
	      _classCallCheck(this, FluxContainerClass);
	
	      _Base.call(this, props);
	      this.state = realOptions.withProps ? Base.calculateState(null, props) : Base.calculateState(null, undefined);
	    }
	
	    // Make sure we override shouldComponentUpdate only if the pure option is
	    // specified. We can't override this above because we don't want to override
	    // the default behavior on accident. Super works weird with react ES6 classes
	    // right now
	
	    FluxContainerClass.prototype.componentDidMount = function componentDidMount() {
	      var _this = this;
	
	      if (_Base.prototype.componentDidMount) {
	        _Base.prototype.componentDidMount.call(this);
	      }
	
	      var stores = Base.getStores();
	
	      // This tracks when any store has changed and we may need to update.
	      var changed = false;
	      var setChanged = function () {
	        changed = true;
	      };
	
	      // This adds subscriptions to stores. When a store changes all we do is
	      // set changed to true.
	      this._fluxContainerSubscriptions = stores.map(function (store) {
	        return store.addListener(setChanged);
	      });
	
	      // This callback is called after the dispatch of the relevant stores. If
	      // any have reported a change we update the state, then reset changed.
	      var callback = function () {
	        if (changed) {
	          _this.setState(function (prevState) {
	            return realOptions.withProps ? Base.calculateState(prevState, _this.props) : Base.calculateState(prevState, undefined);
	          });
	        }
	        changed = false;
	      };
	      this._fluxContainerStoreGroup = new FluxStoreGroup(stores, callback);
	    };
	
	    FluxContainerClass.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	      if (_Base.prototype.componentWillReceiveProps) {
	        _Base.prototype.componentWillReceiveProps.call(this, nextProps, nextContext);
	      }
	
	      // Don't do anything else if the container is not configured to use props
	      if (!realOptions.withProps) {
	        return;
	      }
	
	      // If it's pure we can potentially optimize out the calculate state
	      if (realOptions.pure && shallowEqual(this.props, nextProps)) {
	        return;
	      }
	
	      // Finally update the state using the new props
	      this.setState(function (prevState) {
	        return Base.calculateState(prevState, nextProps);
	      });
	    };
	
	    FluxContainerClass.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (_Base.prototype.componentWillUnmount) {
	        _Base.prototype.componentWillUnmount.call(this);
	      }
	
	      this._fluxContainerStoreGroup.release();
	      for (var _iterator = this._fluxContainerSubscriptions, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var subscription = _ref;
	
	        subscription.remove();
	      }
	      this._fluxContainerSubscriptions = [];
	    };
	
	    return FluxContainerClass;
	  })(Base);
	
	  var container = realOptions.pure ? createPureContainer(FluxContainerClass) : FluxContainerClass;
	
	  // Update the name of the container before returning
	  var componentName = Base.displayName || Base.name;
	  container.displayName = 'FluxContainer(' + componentName + ')';
	
	  return container;
	}
	
	// TODO: typecheck this better
	function createPureContainer(FluxContainerBase) {
	  var PureFluxContainerClass = (function (_FluxContainerBase) {
	    _inherits(PureFluxContainerClass, _FluxContainerBase);
	
	    function PureFluxContainerClass() {
	      _classCallCheck(this, PureFluxContainerClass);
	
	      _FluxContainerBase.apply(this, arguments);
	    }
	
	    PureFluxContainerClass.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	      return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
	    };
	
	    return PureFluxContainerClass;
	  })(FluxContainerBase);
	
	  return PureFluxContainerClass;
	}
	
	function enforceInterface(o) {
	  !o.getStores ?  false ? invariant(false, 'Components that use FluxContainer must implement `static getStores()`') : invariant(false) : undefined;
	  !o.calculateState ?  false ? invariant(false, 'Components that use FluxContainer must implement `static calculateState()`') : invariant(false) : undefined;
	}
	
	module.exports = { create: create };

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxStoreGroup
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(593);
	
	/**
	 * FluxStoreGroup allows you to execute a callback on every dispatch after
	 * waiting for each of the given stores.
	 */
	
	var FluxStoreGroup = (function () {
	  function FluxStoreGroup(stores, callback) {
	    var _this = this;
	
	    _classCallCheck(this, FluxStoreGroup);
	
	    this._dispatcher = _getUniformDispatcher(stores);
	
	    // precompute store tokens
	    var storeTokens = stores.map(function (store) {
	      return store.getDispatchToken();
	    });
	
	    // register with the dispatcher
	    this._dispatchToken = this._dispatcher.register(function (payload) {
	      _this._dispatcher.waitFor(storeTokens);
	      callback();
	    });
	  }
	
	  FluxStoreGroup.prototype.release = function release() {
	    this._dispatcher.unregister(this._dispatchToken);
	  };
	
	  return FluxStoreGroup;
	})();
	
	function _getUniformDispatcher(stores) {
	  !(stores && stores.length) ?  false ? invariant(false, 'Must provide at least one store to FluxStoreGroup') : invariant(false) : undefined;
	  var dispatcher = stores[0].getDispatcher();
	  if (false) {
	    for (var _iterator = stores, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var store = _ref;
	
	      !(store.getDispatcher() === dispatcher) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'All stores in a FluxStoreGroup must use the same dispatcher') : invariant(false) : undefined;
	    }
	  }
	  return dispatcher;
	}
	
	module.exports = FluxStoreGroup;

/***/ },
/* 959 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxMapStore
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FluxReduceStore = __webpack_require__(961);
	var Immutable = __webpack_require__(949);
	
	var invariant = __webpack_require__(593);
	
	/**
	 * This is a simple store. It allows caching key value pairs. An implementation
	 * of a store using this might look like:
	 *
	 *   class FooStore extends FluxMapStore {
	 *     reduce(state, action) {
	 *       switch (action.type) {
	 *         case 'foo':
	 *           return state.set(action.id, action.foo);
	 *         case 'bar':
	 *           return state.delete(action.id);
	 *         default:
	 *           return state;
	 *       }
	 *     }
	 *   }
	 *
	 */
	
	var FluxMapStore = (function (_FluxReduceStore) {
	  _inherits(FluxMapStore, _FluxReduceStore);
	
	  function FluxMapStore() {
	    _classCallCheck(this, FluxMapStore);
	
	    _FluxReduceStore.apply(this, arguments);
	  }
	
	  FluxMapStore.prototype.getInitialState = function getInitialState() {
	    return Immutable.Map();
	  };
	
	  /**
	   * Access the value at the given key. throws an error if the key does not
	   * exist in the cache.
	   */
	
	  FluxMapStore.prototype.at = function at(key) {
	    !this.has(key) ?  false ? invariant(false, 'Expected store to have key %s', key) : invariant(false) : undefined;
	    return this.get(key);
	  };
	
	  /**
	   * Check if the cache has a particular key
	   */
	
	  FluxMapStore.prototype.has = function has(key) {
	    return this.getState().has(key);
	  };
	
	  /**
	   * Get the value of a particular key. Returns undefined if the key does not
	   * exist in the cache.
	   */
	
	  FluxMapStore.prototype.get = function get(key) {
	    return this.getState().get(key);
	  };
	
	  /**
	   * Gets an array of keys and puts the values in a map if they exist, it allows
	   * providing a previous result to update instead of generating a new map.
	   *
	   * Providing a previous result allows the possibility of keeping the same
	   * reference if the keys did not change.
	   */
	
	  FluxMapStore.prototype.getAll = function getAll(keys, prev) {
	    var _this = this;
	
	    var newKeys = Immutable.Set(keys);
	    var start = prev || Immutable.Map();
	    return start.withMutations(function (map) {
	      // remove any old keys that are not in new keys or are no longer in
	      // the cache
	      for (var _iterator = start, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var entry = _ref;
	        var oldKey = entry[0];
	
	        if (!newKeys.has(oldKey) || !_this.has(oldKey)) {
	          map['delete'](oldKey);
	        }
	      }
	
	      // then add all of the new keys that exist in the cache
	      for (var _iterator2 = newKeys, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var key = _ref2;
	
	        if (_this.has(key)) {
	          map.set(key, _this.at(key));
	        }
	      }
	    });
	  };
	
	  return FluxMapStore;
	})(FluxReduceStore);
	
	module.exports = FluxMapStore;

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxReduceStore
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FluxStore = __webpack_require__(962);
	
	var abstractMethod = __webpack_require__(970);
	var invariant = __webpack_require__(593);
	
	var FluxReduceStore = (function (_FluxStore) {
	  _inherits(FluxReduceStore, _FluxStore);
	
	  function FluxReduceStore(dispatcher) {
	    _classCallCheck(this, FluxReduceStore);
	
	    _FluxStore.call(this, dispatcher);
	    this._state = this.getInitialState();
	  }
	
	  /**
	   * Getter that exposes the entire state of this store. If your state is not
	   * immutable you should override this and not expose _state directly.
	   */
	
	  FluxReduceStore.prototype.getState = function getState() {
	    return this._state;
	  };
	
	  /**
	   * Constructs the initial state for this store. This is called once during
	   * construction of the store.
	   */
	
	  FluxReduceStore.prototype.getInitialState = function getInitialState() {
	    return abstractMethod('FluxReduceStore', 'getInitialState');
	  };
	
	  /**
	   * Used to reduce a stream of actions coming from the dispatcher into a
	   * single state object
	   */
	
	  FluxReduceStore.prototype.reduce = function reduce(state, action) {
	    return abstractMethod('FluxReduceStore', 'reduce');
	  };
	
	  /**
	   * Checks if two versions of state are the same. You do not need to override
	   * this if your state is immutable.
	   */
	
	  FluxReduceStore.prototype.areEqual = function areEqual(one, two) {
	    return one === two;
	  };
	
	  /**
	   * Use reduce and track _state instead of using __onDispatch
	   */
	
	  FluxReduceStore.prototype.__invokeOnDispatch = function __invokeOnDispatch(action) {
	    this.__changed = false;
	
	    // reduce the stream of incoming actions to state, update when necessary
	    var startingState = this._state;
	    var endingState = this.reduce(startingState, action);
	
	    // This means your ending state should never be undefined
	    !(endingState !== undefined) ?  false ? invariant(false, '%s returned undefined from reduce(...), did you forget to return ' + 'state in the default case? (use null if this was intentional)', this.constructor.name) : invariant(false) : undefined;
	
	    if (!this.areEqual(startingState, endingState)) {
	      this._state = endingState;
	
	      // `__emitChange()` sets `this.__changed` to true and then the actual
	      // change will be fired from the emitter at the end of the dispatch, this
	      // is required in order to support methods like `hasChanged()`
	      this.__emitChange();
	    }
	
	    if (this.__changed) {
	      this.__emitter.emit(this.__changeEvent);
	    }
	  };
	
	  return FluxReduceStore;
	})(FluxStore);
	
	module.exports = FluxReduceStore;

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxStore
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _require = __webpack_require__(963);
	
	var EventEmitter = _require.EventEmitter;
	
	var invariant = __webpack_require__(593);
	
	/**
	 * This class should be extended by the stores in your application, like so:
	 *
	 * var FluxStore = require('FluxStore');
	 * var MyDispatcher = require('MyDispatcher');
	 *
	 * var _foo;
	 *
	 * class MyStore extends FluxStore {
	 *
	 *   getFoo() {
	 *     return _foo;
	 *   }
	 *
	 *   __onDispatch = function(action) {
	 *     switch(action.type) {
	 *
	 *       case 'an-action':
	 *         changeState(action.someData);
	 *         this.__emitChange();
	 *         break;
	 *
	 *       case 'another-action':
	 *         changeStateAnotherWay(action.otherData);
	 *         this.__emitChange();
	 *         break;
	 *
	 *       default:
	 *         // no op
	 *     }
	 *   }
	 *
	 * }
	 *
	 * module.exports = new MyStore(MyDispatcher);
	 */
	
	var FluxStore = (function () {
	
	  /**
	   * @public
	   * @param {Dispatcher} dispatcher
	   */
	
	  function FluxStore(dispatcher) {
	    var _this = this;
	
	    _classCallCheck(this, FluxStore);
	
	    this.__className = this.constructor.name;
	
	    this.__changed = false;
	    this.__changeEvent = 'change';
	    this.__dispatcher = dispatcher;
	    this.__emitter = new EventEmitter();
	    this._dispatchToken = dispatcher.register(function (payload) {
	      _this.__invokeOnDispatch(payload);
	    });
	  }
	
	  /**
	   * @public
	   * @param {function} callback
	   * @return {object} EmitterSubscription that can be used with
	   *   SubscriptionsHandler or directly used to release the subscription.
	   */
	
	  FluxStore.prototype.addListener = function addListener(callback) {
	    return this.__emitter.addListener(this.__changeEvent, callback);
	  };
	
	  /**
	   * @public
	   * @return {Dispatcher} The dispatcher that this store is registered with.
	   */
	
	  FluxStore.prototype.getDispatcher = function getDispatcher() {
	    return this.__dispatcher;
	  };
	
	  /**
	   * @public
	   * @return {string} A string the dispatcher uses to identify each store's
	   *   registered callback. This is used with the dispatcher's waitFor method
	   *   to declaratively depend on other stores updating themselves first.
	   */
	
	  FluxStore.prototype.getDispatchToken = function getDispatchToken() {
	    return this._dispatchToken;
	  };
	
	  /**
	   * @public
	   * @return {boolean} Whether the store has changed during the most recent
	   *   dispatch.
	   */
	
	  FluxStore.prototype.hasChanged = function hasChanged() {
	    !this.__dispatcher.isDispatching() ?  false ? invariant(false, '%s.hasChanged(): Must be invoked while dispatching.', this.__className) : invariant(false) : undefined;
	    return this.__changed;
	  };
	
	  /**
	   * @protected
	   * Emit an event notifying listeners that the state of the store has changed.
	   */
	
	  FluxStore.prototype.__emitChange = function __emitChange() {
	    !this.__dispatcher.isDispatching() ?  false ? invariant(false, '%s.__emitChange(): Must be invoked while dispatching.', this.__className) : invariant(false) : undefined;
	    this.__changed = true;
	  };
	
	  /**
	   * This method encapsulates all logic for invoking __onDispatch. It should
	   * be used for things like catching changes and emitting them after the
	   * subclass has handled a payload.
	   *
	   * @protected
	   * @param {object} payload The data dispatched by the dispatcher, describing
	   *   something that has happened in the real world: the user clicked, the
	   *   server responded, time passed, etc.
	   */
	
	  FluxStore.prototype.__invokeOnDispatch = function __invokeOnDispatch(payload) {
	    this.__changed = false;
	    this.__onDispatch(payload);
	    if (this.__changed) {
	      this.__emitter.emit(this.__changeEvent);
	    }
	  };
	
	  /**
	   * The callback that will be registered with the dispatcher during
	   * instantiation. Subclasses must override this method. This callback is the
	   * only way the store receives new data.
	   *
	   * @protected
	   * @override
	   * @param {object} payload The data dispatched by the dispatcher, describing
	   *   something that has happened in the real world: the user clicked, the
	   *   server responded, time passed, etc.
	   */
	
	  FluxStore.prototype.__onDispatch = function __onDispatch(payload) {
	     true ?  false ? invariant(false, '%s has not overridden FluxStore.__onDispatch(), which is required', this.__className) : invariant(false) : undefined;
	  };
	
	  return FluxStore;
	})();
	
	module.exports = FluxStore;
	
	// private
	
	// protected, available to subclasses

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	var fbemitter = {
	  EventEmitter: __webpack_require__(964),
	  EmitterSubscription : __webpack_require__(965)
	};
	
	module.exports = fbemitter;


/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BaseEventEmitter
	 * @typechecks
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var EmitterSubscription = __webpack_require__(965);
	var EventSubscriptionVendor = __webpack_require__(967);
	
	var emptyFunction = __webpack_require__(969);
	var invariant = __webpack_require__(968);
	
	/**
	 * @class BaseEventEmitter
	 * @description
	 * An EventEmitter is responsible for managing a set of listeners and publishing
	 * events to them when it is told that such events happened. In addition to the
	 * data for the given event it also sends a event control object which allows
	 * the listeners/handlers to prevent the default behavior of the given event.
	 *
	 * The emitter is designed to be generic enough to support all the different
	 * contexts in which one might want to emit events. It is a simple multicast
	 * mechanism on top of which extra functionality can be composed. For example, a
	 * more advanced emitter may use an EventHolder and EventFactory.
	 */
	
	var BaseEventEmitter = (function () {
	  /**
	   * @constructor
	   */
	
	  function BaseEventEmitter() {
	    _classCallCheck(this, BaseEventEmitter);
	
	    this._subscriber = new EventSubscriptionVendor();
	    this._currentSubscription = null;
	  }
	
	  /**
	   * Adds a listener to be invoked when events of the specified type are
	   * emitted. An optional calling context may be provided. The data arguments
	   * emitted will be passed to the listener function.
	   *
	   * TODO: Annotate the listener arg's type. This is tricky because listeners
	   *       can be invoked with varargs.
	   *
	   * @param {string} eventType - Name of the event to listen to
	   * @param {function} listener - Function to invoke when the specified event is
	   *   emitted
	   * @param {*} context - Optional context object to use when invoking the
	   *   listener
	   */
	
	  BaseEventEmitter.prototype.addListener = function addListener(eventType, listener, context) {
	    return this._subscriber.addSubscription(eventType, new EmitterSubscription(this._subscriber, listener, context));
	  };
	
	  /**
	   * Similar to addListener, except that the listener is removed after it is
	   * invoked once.
	   *
	   * @param {string} eventType - Name of the event to listen to
	   * @param {function} listener - Function to invoke only once when the
	   *   specified event is emitted
	   * @param {*} context - Optional context object to use when invoking the
	   *   listener
	   */
	
	  BaseEventEmitter.prototype.once = function once(eventType, listener, context) {
	    var emitter = this;
	    return this.addListener(eventType, function () {
	      emitter.removeCurrentListener();
	      listener.apply(context, arguments);
	    });
	  };
	
	  /**
	   * Removes all of the registered listeners, including those registered as
	   * listener maps.
	   *
	   * @param {?string} eventType - Optional name of the event whose registered
	   *   listeners to remove
	   */
	
	  BaseEventEmitter.prototype.removeAllListeners = function removeAllListeners(eventType) {
	    this._subscriber.removeAllSubscriptions(eventType);
	  };
	
	  /**
	   * Provides an API that can be called during an eventing cycle to remove the
	   * last listener that was invoked. This allows a developer to provide an event
	   * object that can remove the listener (or listener map) during the
	   * invocation.
	   *
	   * If it is called when not inside of an emitting cycle it will throw.
	   *
	   * @throws {Error} When called not during an eventing cycle
	   *
	   * @example
	   *   var subscription = emitter.addListenerMap({
	   *     someEvent: function(data, event) {
	   *       console.log(data);
	   *       emitter.removeCurrentListener();
	   *     }
	   *   });
	   *
	   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
	   *   emitter.emit('someEvent', 'def'); // does not log anything
	   */
	
	  BaseEventEmitter.prototype.removeCurrentListener = function removeCurrentListener() {
	    !!!this._currentSubscription ?  false ? invariant(false, 'Not in an emitting cycle; there is no current subscription') : invariant(false) : undefined;
	    this._subscriber.removeSubscription(this._currentSubscription);
	  };
	
	  /**
	   * Returns an array of listeners that are currently registered for the given
	   * event.
	   *
	   * @param {string} eventType - Name of the event to query
	   * @return {array}
	   */
	
	  BaseEventEmitter.prototype.listeners = function listeners(eventType) /* TODO: Array<EventSubscription> */{
	    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
	    return subscriptions ? subscriptions.filter(emptyFunction.thatReturnsTrue).map(function (subscription) {
	      return subscription.listener;
	    }) : [];
	  };
	
	  /**
	   * Emits an event of the given type with the given data. All handlers of that
	   * particular type will be notified.
	   *
	   * @param {string} eventType - Name of the event to emit
	   * @param {*} Arbitrary arguments to be passed to each registered listener
	   *
	   * @example
	   *   emitter.addListener('someEvent', function(message) {
	   *     console.log(message);
	   *   });
	   *
	   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
	   */
	
	  BaseEventEmitter.prototype.emit = function emit(eventType) {
	    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
	    if (subscriptions) {
	      var keys = Object.keys(subscriptions);
	      for (var ii = 0; ii < keys.length; ii++) {
	        var key = keys[ii];
	        var subscription = subscriptions[key];
	        // The subscription may have been removed during this event loop.
	        if (subscription) {
	          this._currentSubscription = subscription;
	          this.__emitToSubscription.apply(this, [subscription].concat(Array.prototype.slice.call(arguments)));
	        }
	      }
	      this._currentSubscription = null;
	    }
	  };
	
	  /**
	   * Provides a hook to override how the emitter emits an event to a specific
	   * subscription. This allows you to set up logging and error boundaries
	   * specific to your environment.
	   *
	   * @param {EmitterSubscription} subscription
	   * @param {string} eventType
	   * @param {*} Arbitrary arguments to be passed to each registered listener
	   */
	
	  BaseEventEmitter.prototype.__emitToSubscription = function __emitToSubscription(subscription, eventType) {
	    var args = Array.prototype.slice.call(arguments, 2);
	    subscription.listener.apply(subscription.context, args);
	  };
	
	  return BaseEventEmitter;
	})();
	
	module.exports = BaseEventEmitter;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 * 
	 * @providesModule EmitterSubscription
	 * @typechecks
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventSubscription = __webpack_require__(966);
	
	/**
	 * EmitterSubscription represents a subscription with listener and context data.
	 */
	
	var EmitterSubscription = (function (_EventSubscription) {
	  _inherits(EmitterSubscription, _EventSubscription);
	
	  /**
	   * @param {EventSubscriptionVendor} subscriber - The subscriber that controls
	   *   this subscription
	   * @param {function} listener - Function to invoke when the specified event is
	   *   emitted
	   * @param {*} context - Optional context object to use when invoking the
	   *   listener
	   */
	
	  function EmitterSubscription(subscriber, listener, context) {
	    _classCallCheck(this, EmitterSubscription);
	
	    _EventSubscription.call(this, subscriber);
	    this.listener = listener;
	    this.context = context;
	  }
	
	  return EmitterSubscription;
	})(EventSubscription);
	
	module.exports = EmitterSubscription;

/***/ },
/* 966 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventSubscription
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * EventSubscription represents a subscription to a particular event. It can
	 * remove its own subscription.
	 */
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var EventSubscription = (function () {
	
	  /**
	   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
	   *   this subscription.
	   */
	
	  function EventSubscription(subscriber) {
	    _classCallCheck(this, EventSubscription);
	
	    this.subscriber = subscriber;
	  }
	
	  /**
	   * Removes this subscription from the subscriber that controls it.
	   */
	
	  EventSubscription.prototype.remove = function remove() {
	    if (this.subscriber) {
	      this.subscriber.removeSubscription(this);
	      this.subscriber = null;
	    }
	  };
	
	  return EventSubscription;
	})();
	
	module.exports = EventSubscription;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 * 
	 * @providesModule EventSubscriptionVendor
	 * @typechecks
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(968);
	
	/**
	 * EventSubscriptionVendor stores a set of EventSubscriptions that are
	 * subscribed to a particular event type.
	 */
	
	var EventSubscriptionVendor = (function () {
	  function EventSubscriptionVendor() {
	    _classCallCheck(this, EventSubscriptionVendor);
	
	    this._subscriptionsForType = {};
	    this._currentSubscription = null;
	  }
	
	  /**
	   * Adds a subscription keyed by an event type.
	   *
	   * @param {string} eventType
	   * @param {EventSubscription} subscription
	   */
	
	  EventSubscriptionVendor.prototype.addSubscription = function addSubscription(eventType, subscription) {
	    !(subscription.subscriber === this) ?  false ? invariant(false, 'The subscriber of the subscription is incorrectly set.') : invariant(false) : undefined;
	    if (!this._subscriptionsForType[eventType]) {
	      this._subscriptionsForType[eventType] = [];
	    }
	    var key = this._subscriptionsForType[eventType].length;
	    this._subscriptionsForType[eventType].push(subscription);
	    subscription.eventType = eventType;
	    subscription.key = key;
	    return subscription;
	  };
	
	  /**
	   * Removes a bulk set of the subscriptions.
	   *
	   * @param {?string} eventType - Optional name of the event type whose
	   *   registered supscriptions to remove, if null remove all subscriptions.
	   */
	
	  EventSubscriptionVendor.prototype.removeAllSubscriptions = function removeAllSubscriptions(eventType) {
	    if (eventType === undefined) {
	      this._subscriptionsForType = {};
	    } else {
	      delete this._subscriptionsForType[eventType];
	    }
	  };
	
	  /**
	   * Removes a specific subscription. Instead of calling this function, call
	   * `subscription.remove()` directly.
	   *
	   * @param {object} subscription
	   */
	
	  EventSubscriptionVendor.prototype.removeSubscription = function removeSubscription(subscription) {
	    var eventType = subscription.eventType;
	    var key = subscription.key;
	
	    var subscriptionsForType = this._subscriptionsForType[eventType];
	    if (subscriptionsForType) {
	      delete subscriptionsForType[key];
	    }
	  };
	
	  /**
	   * Returns the array of subscriptions that are currently registered for the
	   * given event type.
	   *
	   * Note: This array can be potentially sparse as subscriptions are deleted
	   * from it when they are removed.
	   *
	   * TODO: This returns a nullable array. wat?
	   *
	   * @param {string} eventType
	   * @return {?array}
	   */
	
	  EventSubscriptionVendor.prototype.getSubscriptionsForType = function getSubscriptionsForType(eventType) {
	    return this._subscriptionsForType[eventType];
	  };
	
	  return EventSubscriptionVendor;
	})();
	
	module.exports = EventSubscriptionVendor;

/***/ },
/* 968 */
305,
/* 969 */
309,
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule abstractMethod
	 * 
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(593);
	
	function abstractMethod(className, methodName) {
	   true ?  false ? invariant(false, 'Subclasses of %s must override %s() with their own implementation.', className, methodName) : invariant(false) : undefined;
	}
	
	module.exports = abstractMethod;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxMixinLegacy
	 * 
	 */
	
	'use strict';
	
	var FluxStoreGroup = __webpack_require__(958);
	
	var invariant = __webpack_require__(593);
	
	/**
	 * `FluxContainer` should be preferred over this mixin, but it requires using
	 * react with classes. So this mixin is provided where it is not yet possible
	 * to convert a container to be a class.
	 *
	 * This mixin should be used for React components that have state based purely
	 * on stores. `this.props` will not be available inside of `calculateState()`.
	 *
	 * This mixin will only `setState` not replace it, so you should always return
	 * every key in your state unless you know what you are doing. Consider this:
	 *
	 *   var Foo = React.createClass({
	 *     mixins: [
	 *       FluxMixinLegacy([FooStore])
	 *     ],
	 *
	 *     statics: {
	 *       calculateState(prevState) {
	 *         if (!prevState) {
	 *           return {
	 *             foo: FooStore.getFoo(),
	 *           };
	 *         }
	 *
	 *         return {
	 *           bar: FooStore.getBar(),
	 *         };
	 *       }
	 *     },
	 *   });
	 *
	 * On the second calculateState when prevState is not null, the state will be
	 * updated to contain the previous foo AND the bar that was just returned. Only
	 * returning bar will not delete foo.
	 *
	 */
	function FluxMixinLegacy(stores) {
	  return {
	    getInitialState: function () {
	      enforceInterface(this);
	      return this.constructor.calculateState(null);
	    },
	
	    componentDidMount: function () {
	      var _this = this;
	
	      // This tracks when any store has changed and we may need to update.
	      var changed = false;
	      var setChanged = function () {
	        changed = true;
	      };
	
	      // This adds subscriptions to stores. When a store changes all we do is
	      // set changed to true.
	      this._fluxMixinSubscriptions = stores.map(function (store) {
	        return store.addListener(setChanged);
	      });
	
	      // This callback is called after the dispatch of the relevant stores. If
	      // any have reported a change we update the state, then reset changed.
	      var callback = function () {
	        if (changed) {
	          _this.setState(function (prevState) {
	            return _this.constructor.calculateState(_this.state);
	          });
	        }
	        changed = false;
	      };
	      this._fluxMixinStoreGroup = new FluxStoreGroup(stores, callback);
	    },
	
	    componentWillUnmount: function () {
	      this._fluxMixinStoreGroup.release();
	      for (var _iterator = this._fluxMixinSubscriptions, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var subscription = _ref;
	
	        subscription.remove();
	      }
	      this._fluxMixinSubscriptions = [];
	    }
	  };
	}
	
	function enforceInterface(o) {
	  !o.constructor.calculateState ?  false ? invariant(false, 'Components that use FluxMixinLegacy must implement ' + '`calculateState()` on the statics object') : invariant(false) : undefined;
	}
	
	module.exports = FluxMixinLegacy;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['LOAD_SETTINGS']); /*  weak */

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.openConnection = openConnection;
	exports.closeConnection = closeConnection;
	exports.resetConnection = resetConnection;
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function remindApiAuthorizer(Runtime, socketId, callback) {
	  // to match https://github.com/pusher/pusher-js/blob/master/src/runtimes/isomorphic/auth/xhr_auth.ts
	  (0, _apiRequest2.default)('/pusher/auth', 'POST', {
	    socket_id: socketId,
	    channel_name: this.channel.name
	  }).then(function (data) {
	    return callback(false, data);
	  }).catch(function (err) {
	    console.error('DEBUG remindApiAuthorizer failure', err);
	    callback(true, err.message);
	  });
	}
	
	
	var singleton = null;
	
	function ensureSingleton(key) {
	  if (singleton) {
	    return;
	  }
	
	  // Postpone module load until there's a connection to be opened so that this
	  // PusherConnection module can load in Node.
	  var Pusher = __webpack_require__(974);
	
	  var supportedAuthorizers = Pusher.Runtime.getAuthorizers();
	  Pusher.Runtime.getAuthorizers = function () {
	    supportedAuthorizers.remindApi = remindApiAuthorizer;
	    return supportedAuthorizers;
	  };
	
	  singleton = new Pusher(key, {
	    authTransport: 'remindApi',
	    encrypted: true
	  });
	
	  // https://pusher.com/docs/client_api_guide/client_connect#available-states
	  singleton.connection.bind('state_change', function (_ref) {
	    var previous = _ref.previous,
	        current = _ref.current;
	
	    _EventTracking2.default.track('pusher.state_change.' + previous + '.to.' + current);
	  });
	
	  window.addEventListener('beforeunload', function () {
	    closeConnection();
	  });
	}
	
	/**
	 * @param  {[String]} key required to open a connection
	 * @return {[Pusher]} connection singleton
	 */
	function openConnection(key) {
	  (0, _invariant2.default)(key, 'Missing Pusher key.');
	
	  ensureSingleton(key);
	  (0, _invariant2.default)(singleton, 'Connection not available to open');
	
	  singleton.connect(); // idempotent
	
	  return singleton;
	}
	
	function closeConnection() {
	  if (singleton) {
	    singleton.disconnect();
	    // leave the singleton object to reconnect if needed
	  }
	}
	
	function resetConnection() {
	  (0, _invariant2.default)(singleton, 'Connection not available to reset');
	  singleton.disconnect();
	  singleton.connect();
	}

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Pusher JavaScript Library v3.2.0
	 * http://pusher.com/
	 *
	 * Copyright 2016, Pusher
	 * Released under the MIT licence.
	 */
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Pusher"] = factory();
		else
			root["Pusher"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var pusher_1 = __webpack_require__(1);
		module.exports = pusher_1["default"];
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var runtime_1 = __webpack_require__(2);
		var Collections = __webpack_require__(9);
		var dispatcher_1 = __webpack_require__(23);
		var timeline_1 = __webpack_require__(38);
		var level_1 = __webpack_require__(39);
		var StrategyBuilder = __webpack_require__(40);
		var timers_1 = __webpack_require__(12);
		var defaults_1 = __webpack_require__(5);
		var DefaultConfig = __webpack_require__(62);
		var logger_1 = __webpack_require__(8);
		var factory_1 = __webpack_require__(42);
		var Pusher = (function () {
		    function Pusher(app_key, options) {
		        var _this = this;
		        checkAppKey(app_key);
		        options = options || {};
		        this.key = app_key;
		        this.config = Collections.extend(DefaultConfig.getGlobalConfig(), options.cluster ? DefaultConfig.getClusterConfig(options.cluster) : {}, options);
		        this.channels = factory_1["default"].createChannels();
		        this.global_emitter = new dispatcher_1["default"]();
		        this.sessionID = Math.floor(Math.random() * 1000000000);
		        this.timeline = new timeline_1["default"](this.key, this.sessionID, {
		            cluster: this.config.cluster,
		            features: Pusher.getClientFeatures(),
		            params: this.config.timelineParams || {},
		            limit: 50,
		            level: level_1["default"].INFO,
		            version: defaults_1["default"].VERSION
		        });
		        if (!this.config.disableStats) {
		            this.timelineSender = factory_1["default"].createTimelineSender(this.timeline, {
		                host: this.config.statsHost,
		                path: "/timeline/v2/" + runtime_1["default"].TimelineTransport.name
		            });
		        }
		        var getStrategy = function (options) {
		            var config = Collections.extend({}, _this.config, options);
		            return StrategyBuilder.build(runtime_1["default"].getDefaultStrategy(config), config);
		        };
		        this.connection = factory_1["default"].createConnectionManager(this.key, Collections.extend({ getStrategy: getStrategy,
		            timeline: this.timeline,
		            activityTimeout: this.config.activity_timeout,
		            pongTimeout: this.config.pong_timeout,
		            unavailableTimeout: this.config.unavailable_timeout
		        }, this.config, { encrypted: this.isEncrypted() }));
		        this.connection.bind('connected', function () {
		            _this.subscribeAll();
		            if (_this.timelineSender) {
		                _this.timelineSender.send(_this.connection.isEncrypted());
		            }
		        });
		        this.connection.bind('message', function (params) {
		            var internal = (params.event.indexOf('pusher_internal:') === 0);
		            if (params.channel) {
		                var channel = _this.channel(params.channel);
		                if (channel) {
		                    channel.handleEvent(params.event, params.data);
		                }
		            }
		            if (!internal) {
		                _this.global_emitter.emit(params.event, params.data);
		            }
		        });
		        this.connection.bind('disconnected', function () {
		            _this.channels.disconnect();
		        });
		        this.connection.bind('error', function (err) {
		            logger_1["default"].warn('Error', err);
		        });
		        Pusher.instances.push(this);
		        this.timeline.info({ instances: Pusher.instances.length });
		        if (Pusher.isReady) {
		            this.connect();
		        }
		    }
		    Pusher.ready = function () {
		        Pusher.isReady = true;
		        for (var i = 0, l = Pusher.instances.length; i < l; i++) {
		            Pusher.instances[i].connect();
		        }
		    };
		    Pusher.log = function (message) {
		        if (Pusher.logToConsole && (window).console && (window).console.log) {
		            (window).console.log(message);
		        }
		    };
		    Pusher.getClientFeatures = function () {
		        return Collections.keys(Collections.filterObject({ "ws": runtime_1["default"].Transports.ws }, function (t) { return t.isSupported({}); }));
		    };
		    Pusher.prototype.channel = function (name) {
		        return this.channels.find(name);
		    };
		    Pusher.prototype.allChannels = function () {
		        return this.channels.all();
		    };
		    Pusher.prototype.connect = function () {
		        this.connection.connect();
		        if (this.timelineSender) {
		            if (!this.timelineSenderTimer) {
		                var encrypted = this.connection.isEncrypted();
		                var timelineSender = this.timelineSender;
		                this.timelineSenderTimer = new timers_1.PeriodicTimer(60000, function () {
		                    timelineSender.send(encrypted);
		                });
		            }
		        }
		    };
		    Pusher.prototype.disconnect = function () {
		        this.connection.disconnect();
		        if (this.timelineSenderTimer) {
		            this.timelineSenderTimer.ensureAborted();
		            this.timelineSenderTimer = null;
		        }
		    };
		    Pusher.prototype.bind = function (event_name, callback) {
		        this.global_emitter.bind(event_name, callback);
		        return this;
		    };
		    Pusher.prototype.unbind = function (event_name, callback) {
		        this.global_emitter.unbind(event_name, callback);
		        return this;
		    };
		    Pusher.prototype.bind_all = function (callback) {
		        this.global_emitter.bind_all(callback);
		        return this;
		    };
		    Pusher.prototype.subscribeAll = function () {
		        var channelName;
		        for (channelName in this.channels.channels) {
		            if (this.channels.channels.hasOwnProperty(channelName)) {
		                this.subscribe(channelName);
		            }
		        }
		    };
		    Pusher.prototype.subscribe = function (channel_name) {
		        var channel = this.channels.add(channel_name, this);
		        if (this.connection.state === "connected") {
		            channel.subscribe();
		        }
		        return channel;
		    };
		    Pusher.prototype.unsubscribe = function (channel_name) {
		        var channel = this.channels.remove(channel_name);
		        if (channel && this.connection.state === "connected") {
		            channel.unsubscribe();
		        }
		    };
		    Pusher.prototype.send_event = function (event_name, data, channel) {
		        return this.connection.send_event(event_name, data, channel);
		    };
		    Pusher.prototype.isEncrypted = function () {
		        if (runtime_1["default"].getProtocol() === "https:") {
		            return true;
		        }
		        else {
		            return Boolean(this.config.encrypted);
		        }
		    };
		    Pusher.instances = [];
		    Pusher.isReady = false;
		    Pusher.logToConsole = false;
		    Pusher.Runtime = runtime_1["default"];
		    Pusher.ScriptReceivers = runtime_1["default"].ScriptReceivers;
		    Pusher.DependenciesReceivers = runtime_1["default"].DependenciesReceivers;
		    Pusher.auth_callbacks = runtime_1["default"].auth_callbacks;
		    return Pusher;
		}());
		exports.__esModule = true;
		exports["default"] = Pusher;
		function checkAppKey(key) {
		    if (key === null || key === undefined) {
		        throw "You must pass your app key when you instantiate Pusher.";
		    }
		}
		runtime_1["default"].setup(Pusher);
	
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var dependencies_1 = __webpack_require__(3);
		var xhr_auth_1 = __webpack_require__(7);
		var jsonp_auth_1 = __webpack_require__(14);
		var script_request_1 = __webpack_require__(15);
		var jsonp_request_1 = __webpack_require__(16);
		var script_receiver_factory_1 = __webpack_require__(4);
		var jsonp_timeline_1 = __webpack_require__(17);
		var transports_1 = __webpack_require__(18);
		var net_info_1 = __webpack_require__(25);
		var default_strategy_1 = __webpack_require__(26);
		var transport_connection_initializer_1 = __webpack_require__(27);
		var http_1 = __webpack_require__(28);
		var Runtime = {
		    nextAuthCallbackID: 1,
		    auth_callbacks: {},
		    ScriptReceivers: script_receiver_factory_1.ScriptReceivers,
		    DependenciesReceivers: dependencies_1.DependenciesReceivers,
		    getDefaultStrategy: default_strategy_1["default"],
		    Transports: transports_1["default"],
		    transportConnectionInitializer: transport_connection_initializer_1["default"],
		    HTTPFactory: http_1["default"],
		    TimelineTransport: jsonp_timeline_1["default"],
		    getXHRAPI: function () {
		        return window.XMLHttpRequest;
		    },
		    getWebSocketAPI: function () {
		        return window.WebSocket || window.MozWebSocket;
		    },
		    setup: function (PusherClass) {
		        var _this = this;
		        window.Pusher = PusherClass;
		        var initializeOnDocumentBody = function () {
		            _this.onDocumentBody(PusherClass.ready);
		        };
		        if (!window.JSON) {
		            dependencies_1.Dependencies.load("json2", {}, initializeOnDocumentBody);
		        }
		        else {
		            initializeOnDocumentBody();
		        }
		    },
		    getDocument: function () {
		        return document;
		    },
		    getProtocol: function () {
		        return this.getDocument().location.protocol;
		    },
		    getAuthorizers: function () {
		        return { ajax: xhr_auth_1["default"], jsonp: jsonp_auth_1["default"] };
		    },
		    onDocumentBody: function (callback) {
		        var _this = this;
		        if (document.body) {
		            callback();
		        }
		        else {
		            setTimeout(function () {
		                _this.onDocumentBody(callback);
		            }, 0);
		        }
		    },
		    createJSONPRequest: function (url, data) {
		        return new jsonp_request_1["default"](url, data);
		    },
		    createScriptRequest: function (src) {
		        return new script_request_1["default"](src);
		    },
		    getLocalStorage: function () {
		        try {
		            return window.localStorage;
		        }
		        catch (e) {
		            return undefined;
		        }
		    },
		    createXHR: function () {
		        if (this.getXHRAPI()) {
		            return this.createXMLHttpRequest();
		        }
		        else {
		            return this.createMicrosoftXHR();
		        }
		    },
		    createXMLHttpRequest: function () {
		        var Constructor = this.getXHRAPI();
		        return new Constructor();
		    },
		    createMicrosoftXHR: function () {
		        return new ActiveXObject("Microsoft.XMLHTTP");
		    },
		    getNetwork: function () {
		        return net_info_1.Network;
		    },
		    createWebSocket: function (url) {
		        var Constructor = this.getWebSocketAPI();
		        return new Constructor(url);
		    },
		    createSocketRequest: function (method, url) {
		        if (this.isXHRSupported()) {
		            return this.HTTPFactory.createXHR(method, url);
		        }
		        else if (this.isXDRSupported(url.indexOf("https:") === 0)) {
		            return this.HTTPFactory.createXDR(method, url);
		        }
		        else {
		            throw "Cross-origin HTTP requests are not supported";
		        }
		    },
		    isXHRSupported: function () {
		        var Constructor = this.getXHRAPI();
		        return Boolean(Constructor) && (new Constructor()).withCredentials !== undefined;
		    },
		    isXDRSupported: function (encrypted) {
		        var protocol = encrypted ? "https:" : "http:";
		        var documentProtocol = this.getProtocol();
		        return Boolean((window['XDomainRequest'])) && documentProtocol === protocol;
		    },
		    addUnloadListener: function (listener) {
		        if (window.addEventListener !== undefined) {
		            window.addEventListener("unload", listener, false);
		        }
		        else if (window.attachEvent !== undefined) {
		            window.attachEvent("onunload", listener);
		        }
		    },
		    removeUnloadListener: function (listener) {
		        if (window.addEventListener !== undefined) {
		            window.removeEventListener("unload", listener, false);
		        }
		        else if (window.detachEvent !== undefined) {
		            window.detachEvent("onunload", listener);
		        }
		    }
		};
		exports.__esModule = true;
		exports["default"] = Runtime;
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var script_receiver_factory_1 = __webpack_require__(4);
		var defaults_1 = __webpack_require__(5);
		var dependency_loader_1 = __webpack_require__(6);
		exports.DependenciesReceivers = new script_receiver_factory_1.ScriptReceiverFactory("_pusher_dependencies", "Pusher.DependenciesReceivers");
		exports.Dependencies = new dependency_loader_1["default"]({
		    cdn_http: defaults_1["default"].cdn_http,
		    cdn_https: defaults_1["default"].cdn_https,
		    version: defaults_1["default"].VERSION,
		    suffix: defaults_1["default"].dependency_suffix,
		    receivers: exports.DependenciesReceivers
		});
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		"use strict";
		var ScriptReceiverFactory = (function () {
		    function ScriptReceiverFactory(prefix, name) {
		        this.lastId = 0;
		        this.prefix = prefix;
		        this.name = name;
		    }
		    ScriptReceiverFactory.prototype.create = function (callback) {
		        this.lastId++;
		        var number = this.lastId;
		        var id = this.prefix + number;
		        var name = this.name + "[" + number + "]";
		        var called = false;
		        var callbackWrapper = function () {
		            if (!called) {
		                callback.apply(null, arguments);
		                called = true;
		            }
		        };
		        this[number] = callbackWrapper;
		        return { number: number, id: id, name: name, callback: callbackWrapper };
		    };
		    ScriptReceiverFactory.prototype.remove = function (receiver) {
		        delete this[receiver.number];
		    };
		    return ScriptReceiverFactory;
		}());
		exports.ScriptReceiverFactory = ScriptReceiverFactory;
		exports.ScriptReceivers = new ScriptReceiverFactory("_pusher_script_", "Pusher.ScriptReceivers");
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		"use strict";
		var Defaults = {
		    VERSION: "3.2.0",
		    PROTOCOL: 7,
		    host: 'ws.pusherapp.com',
		    ws_port: 80,
		    wss_port: 443,
		    sockjs_host: 'sockjs.pusher.com',
		    sockjs_http_port: 80,
		    sockjs_https_port: 443,
		    sockjs_path: "/pusher",
		    stats_host: 'stats.pusher.com',
		    channel_auth_endpoint: '/pusher/auth',
		    channel_auth_transport: 'ajax',
		    activity_timeout: 120000,
		    pong_timeout: 30000,
		    unavailable_timeout: 10000,
		    cdn_http: 'http://js.pusher.com',
		    cdn_https: 'https://js.pusher.com',
		    dependency_suffix: ''
		};
		exports.__esModule = true;
		exports["default"] = Defaults;
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var script_receiver_factory_1 = __webpack_require__(4);
		var runtime_1 = __webpack_require__(2);
		var DependencyLoader = (function () {
		    function DependencyLoader(options) {
		        this.options = options;
		        this.receivers = options.receivers || script_receiver_factory_1.ScriptReceivers;
		        this.loading = {};
		    }
		    DependencyLoader.prototype.load = function (name, options, callback) {
		        var self = this;
		        if (self.loading[name] && self.loading[name].length > 0) {
		            self.loading[name].push(callback);
		        }
		        else {
		            self.loading[name] = [callback];
		            var request = runtime_1["default"].createScriptRequest(self.getPath(name, options));
		            var receiver = self.receivers.create(function (error) {
		                self.receivers.remove(receiver);
		                if (self.loading[name]) {
		                    var callbacks = self.loading[name];
		                    delete self.loading[name];
		                    var successCallback = function (wasSuccessful) {
		                        if (!wasSuccessful) {
		                            request.cleanup();
		                        }
		                    };
		                    for (var i = 0; i < callbacks.length; i++) {
		                        callbacks[i](error, successCallback);
		                    }
		                }
		            });
		            request.send(receiver);
		        }
		    };
		    DependencyLoader.prototype.getRoot = function (options) {
		        var cdn;
		        var protocol = runtime_1["default"].getDocument().location.protocol;
		        if ((options && options.encrypted) || protocol === "https:") {
		            cdn = this.options.cdn_https;
		        }
		        else {
		            cdn = this.options.cdn_http;
		        }
		        return cdn.replace(/\/*$/, "") + "/" + this.options.version;
		    };
		    DependencyLoader.prototype.getPath = function (name, options) {
		        return this.getRoot(options) + '/' + name + this.options.suffix + '.js';
		    };
		    ;
		    return DependencyLoader;
		}());
		exports.__esModule = true;
		exports["default"] = DependencyLoader;
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var logger_1 = __webpack_require__(8);
		var runtime_1 = __webpack_require__(2);
		var ajax = function (context, socketId, callback) {
		    var self = this, xhr;
		    xhr = runtime_1["default"].createXHR();
		    xhr.open("POST", self.options.authEndpoint, true);
		    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
		    for (var headerName in this.authOptions.headers) {
		        xhr.setRequestHeader(headerName, this.authOptions.headers[headerName]);
		    }
		    xhr.onreadystatechange = function () {
		        if (xhr.readyState === 4) {
		            if (xhr.status === 200) {
		                var data, parsed = false;
		                try {
		                    data = JSON.parse(xhr.responseText);
		                    parsed = true;
		                }
		                catch (e) {
		                    callback(true, 'JSON returned from webapp was invalid, yet status code was 200. Data was: ' + xhr.responseText);
		                }
		                if (parsed) {
		                    callback(false, data);
		                }
		            }
		            else {
		                logger_1["default"].warn("Couldn't get auth info from your webapp", xhr.status);
		                callback(true, xhr.status);
		            }
		        }
		    };
		    xhr.send(this.composeQuery(socketId));
		    return xhr;
		};
		exports.__esModule = true;
		exports["default"] = ajax;
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var collections_1 = __webpack_require__(9);
		var pusher_1 = __webpack_require__(1);
		var Logger = {
		    debug: function () {
		        var args = [];
		        for (var _i = 0; _i < arguments.length; _i++) {
		            args[_i - 0] = arguments[_i];
		        }
		        if (!pusher_1["default"].log) {
		            return;
		        }
		        pusher_1["default"].log(collections_1.stringify.apply(this, arguments));
		    },
		    warn: function () {
		        var args = [];
		        for (var _i = 0; _i < arguments.length; _i++) {
		            args[_i - 0] = arguments[_i];
		        }
		        var message = collections_1.stringify.apply(this, arguments);
		        if ((window).console) {
		            if ((window).console.warn) {
		                (window).console.warn(message);
		            }
		            else if ((window).console.log) {
		                (window).console.log(message);
		            }
		        }
		        if (pusher_1["default"].log) {
		            pusher_1["default"].log(message);
		        }
		    }
		};
		exports.__esModule = true;
		exports["default"] = Logger;
	
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var base64_1 = __webpack_require__(10);
		var util_1 = __webpack_require__(11);
		function extend(target) {
		    var sources = [];
		    for (var _i = 1; _i < arguments.length; _i++) {
		        sources[_i - 1] = arguments[_i];
		    }
		    for (var i = 0; i < sources.length; i++) {
		        var extensions = sources[i];
		        for (var property in extensions) {
		            if (extensions[property] && extensions[property].constructor &&
		                extensions[property].constructor === Object) {
		                target[property] = extend(target[property] || {}, extensions[property]);
		            }
		            else {
		                target[property] = extensions[property];
		            }
		        }
		    }
		    return target;
		}
		exports.extend = extend;
		function stringify() {
		    var m = ["Pusher"];
		    for (var i = 0; i < arguments.length; i++) {
		        if (typeof arguments[i] === "string") {
		            m.push(arguments[i]);
		        }
		        else {
		            m.push(safeJSONStringify(arguments[i]));
		        }
		    }
		    return m.join(" : ");
		}
		exports.stringify = stringify;
		function arrayIndexOf(array, item) {
		    var nativeIndexOf = Array.prototype.indexOf;
		    if (array === null) {
		        return -1;
		    }
		    if (nativeIndexOf && array.indexOf === nativeIndexOf) {
		        return array.indexOf(item);
		    }
		    for (var i = 0, l = array.length; i < l; i++) {
		        if (array[i] === item) {
		            return i;
		        }
		    }
		    return -1;
		}
		exports.arrayIndexOf = arrayIndexOf;
		function objectApply(object, f) {
		    for (var key in object) {
		        if (Object.prototype.hasOwnProperty.call(object, key)) {
		            f(object[key], key, object);
		        }
		    }
		}
		exports.objectApply = objectApply;
		function keys(object) {
		    var keys = [];
		    objectApply(object, function (_, key) {
		        keys.push(key);
		    });
		    return keys;
		}
		exports.keys = keys;
		function values(object) {
		    var values = [];
		    objectApply(object, function (value) {
		        values.push(value);
		    });
		    return values;
		}
		exports.values = values;
		function apply(array, f, context) {
		    for (var i = 0; i < array.length; i++) {
		        f.call(context || (window), array[i], i, array);
		    }
		}
		exports.apply = apply;
		function map(array, f) {
		    var result = [];
		    for (var i = 0; i < array.length; i++) {
		        result.push(f(array[i], i, array, result));
		    }
		    return result;
		}
		exports.map = map;
		function mapObject(object, f) {
		    var result = {};
		    objectApply(object, function (value, key) {
		        result[key] = f(value);
		    });
		    return result;
		}
		exports.mapObject = mapObject;
		function filter(array, test) {
		    test = test || function (value) { return !!value; };
		    var result = [];
		    for (var i = 0; i < array.length; i++) {
		        if (test(array[i], i, array, result)) {
		            result.push(array[i]);
		        }
		    }
		    return result;
		}
		exports.filter = filter;
		function filterObject(object, test) {
		    var result = {};
		    objectApply(object, function (value, key) {
		        if ((test && test(value, key, object, result)) || Boolean(value)) {
		            result[key] = value;
		        }
		    });
		    return result;
		}
		exports.filterObject = filterObject;
		function flatten(object) {
		    var result = [];
		    objectApply(object, function (value, key) {
		        result.push([key, value]);
		    });
		    return result;
		}
		exports.flatten = flatten;
		function any(array, test) {
		    for (var i = 0; i < array.length; i++) {
		        if (test(array[i], i, array)) {
		            return true;
		        }
		    }
		    return false;
		}
		exports.any = any;
		function all(array, test) {
		    for (var i = 0; i < array.length; i++) {
		        if (!test(array[i], i, array)) {
		            return false;
		        }
		    }
		    return true;
		}
		exports.all = all;
		function encodeParamsObject(data) {
		    return mapObject(data, function (value) {
		        if (typeof value === "object") {
		            value = safeJSONStringify(value);
		        }
		        return encodeURIComponent(base64_1["default"](value.toString()));
		    });
		}
		exports.encodeParamsObject = encodeParamsObject;
		function buildQueryString(data) {
		    var params = filterObject(data, function (value) {
		        return value !== undefined;
		    });
		    var query = map(flatten(encodeParamsObject(params)), util_1["default"].method("join", "=")).join("&");
		    return query;
		}
		exports.buildQueryString = buildQueryString;
		function decycleObject(object) {
		    var objects = [], paths = [];
		    return (function derez(value, path) {
		        var i, name, nu;
		        switch (typeof value) {
		            case 'object':
		                if (!value) {
		                    return null;
		                }
		                for (i = 0; i < objects.length; i += 1) {
		                    if (objects[i] === value) {
		                        return { $ref: paths[i] };
		                    }
		                }
		                objects.push(value);
		                paths.push(path);
		                if (Object.prototype.toString.apply(value) === '[object Array]') {
		                    nu = [];
		                    for (i = 0; i < value.length; i += 1) {
		                        nu[i] = derez(value[i], path + '[' + i + ']');
		                    }
		                }
		                else {
		                    nu = {};
		                    for (name in value) {
		                        if (Object.prototype.hasOwnProperty.call(value, name)) {
		                            nu[name] = derez(value[name], path + '[' + JSON.stringify(name) + ']');
		                        }
		                    }
		                }
		                return nu;
		            case 'number':
		            case 'string':
		            case 'boolean':
		                return value;
		        }
		    }(object, '$'));
		}
		exports.decycleObject = decycleObject;
		function safeJSONStringify(source) {
		    try {
		        return JSON.stringify(source);
		    }
		    catch (e) {
		        return JSON.stringify(decycleObject(source));
		    }
		}
		exports.safeJSONStringify = safeJSONStringify;
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		function encode(s) {
		    return btoa(utob(s));
		}
		exports.__esModule = true;
		exports["default"] = encode;
		var fromCharCode = String.fromCharCode;
		var b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
		var b64tab = {};
		for (var i = 0, l = b64chars.length; i < l; i++) {
		    b64tab[b64chars.charAt(i)] = i;
		}
		var cb_utob = function (c) {
		    var cc = c.charCodeAt(0);
		    return cc < 0x80 ? c
		        : cc < 0x800 ? fromCharCode(0xc0 | (cc >>> 6)) +
		            fromCharCode(0x80 | (cc & 0x3f))
		            : fromCharCode(0xe0 | ((cc >>> 12) & 0x0f)) +
		                fromCharCode(0x80 | ((cc >>> 6) & 0x3f)) +
		                fromCharCode(0x80 | (cc & 0x3f));
		};
		var utob = function (u) {
		    return u.replace(/[^\x00-\x7F]/g, cb_utob);
		};
		var cb_encode = function (ccc) {
		    var padlen = [0, 2, 1][ccc.length % 3];
		    var ord = ccc.charCodeAt(0) << 16
		        | ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8)
		        | ((ccc.length > 2 ? ccc.charCodeAt(2) : 0));
		    var chars = [
		        b64chars.charAt(ord >>> 18),
		        b64chars.charAt((ord >>> 12) & 63),
		        padlen >= 2 ? '=' : b64chars.charAt((ord >>> 6) & 63),
		        padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
		    ];
		    return chars.join('');
		};
		var btoa = (window).btoa || function (b) {
		    return b.replace(/[\s\S]{1,3}/g, cb_encode);
		};
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var timers_1 = __webpack_require__(12);
		var Util = {
		    now: function () {
		        if (Date.now) {
		            return Date.now();
		        }
		        else {
		            return new Date().valueOf();
		        }
		    },
		    defer: function (callback) {
		        return new timers_1.OneOffTimer(0, callback);
		    },
		    method: function (name) {
		        var args = [];
		        for (var _i = 1; _i < arguments.length; _i++) {
		            args[_i - 1] = arguments[_i];
		        }
		        var boundArguments = Array.prototype.slice.call(arguments, 1);
		        return function (object) {
		            return object[name].apply(object, boundArguments.concat(arguments));
		        };
		    }
		};
		exports.__esModule = true;
		exports["default"] = Util;
	
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var abstract_timer_1 = __webpack_require__(13);
		function clearTimeout(timer) {
		    (window).clearTimeout(timer);
		}
		function clearInterval(timer) {
		    (window).clearInterval(timer);
		}
		var OneOffTimer = (function (_super) {
		    __extends(OneOffTimer, _super);
		    function OneOffTimer(delay, callback) {
		        _super.call(this, setTimeout, clearTimeout, delay, function (timer) {
		            callback();
		            return null;
		        });
		    }
		    return OneOffTimer;
		}(abstract_timer_1["default"]));
		exports.OneOffTimer = OneOffTimer;
		var PeriodicTimer = (function (_super) {
		    __extends(PeriodicTimer, _super);
		    function PeriodicTimer(delay, callback) {
		        _super.call(this, setInterval, clearInterval, delay, function (timer) {
		            callback();
		            return timer;
		        });
		    }
		    return PeriodicTimer;
		}(abstract_timer_1["default"]));
		exports.PeriodicTimer = PeriodicTimer;
	
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
		"use strict";
		var Timer = (function () {
		    function Timer(set, clear, delay, callback) {
		        var _this = this;
		        this.clear = clear;
		        this.timer = set(function () {
		            if (_this.timer) {
		                _this.timer = callback(_this.timer);
		            }
		        }, delay);
		    }
		    Timer.prototype.isRunning = function () {
		        return this.timer !== null;
		    };
		    Timer.prototype.ensureAborted = function () {
		        if (this.timer) {
		            this.clear(this.timer);
		            this.timer = null;
		        }
		    };
		    return Timer;
		}());
		exports.__esModule = true;
		exports["default"] = Timer;
	
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var logger_1 = __webpack_require__(8);
		var jsonp = function (context, socketId, callback) {
		    if (this.authOptions.headers !== undefined) {
		        logger_1["default"].warn("Warn", "To send headers with the auth request, you must use AJAX, rather than JSONP.");
		    }
		    var callbackName = context.nextAuthCallbackID.toString();
		    context.nextAuthCallbackID++;
		    var document = context.getDocument();
		    var script = document.createElement("script");
		    context.auth_callbacks[callbackName] = function (data) {
		        callback(false, data);
		    };
		    var callback_name = "Pusher.auth_callbacks['" + callbackName + "']";
		    script.src = this.options.authEndpoint +
		        '?callback=' +
		        encodeURIComponent(callback_name) +
		        '&' +
		        this.composeQuery(socketId);
		    var head = document.getElementsByTagName("head")[0] || document.documentElement;
		    head.insertBefore(script, head.firstChild);
		};
		exports.__esModule = true;
		exports["default"] = jsonp;
	
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		"use strict";
		var ScriptRequest = (function () {
		    function ScriptRequest(src) {
		        this.src = src;
		    }
		    ScriptRequest.prototype.send = function (receiver) {
		        var self = this;
		        var errorString = "Error loading " + self.src;
		        self.script = document.createElement("script");
		        self.script.id = receiver.id;
		        self.script.src = self.src;
		        self.script.type = "text/javascript";
		        self.script.charset = "UTF-8";
		        if (self.script.addEventListener) {
		            self.script.onerror = function () {
		                receiver.callback(errorString);
		            };
		            self.script.onload = function () {
		                receiver.callback(null);
		            };
		        }
		        else {
		            self.script.onreadystatechange = function () {
		                if (self.script.readyState === 'loaded' ||
		                    self.script.readyState === 'complete') {
		                    receiver.callback(null);
		                }
		            };
		        }
		        if (self.script.async === undefined && document.attachEvent &&
		            /opera/i.test(navigator.userAgent)) {
		            self.errorScript = document.createElement("script");
		            self.errorScript.id = receiver.id + "_error";
		            self.errorScript.text = receiver.name + "('" + errorString + "');";
		            self.script.async = self.errorScript.async = false;
		        }
		        else {
		            self.script.async = true;
		        }
		        var head = document.getElementsByTagName('head')[0];
		        head.insertBefore(self.script, head.firstChild);
		        if (self.errorScript) {
		            head.insertBefore(self.errorScript, self.script.nextSibling);
		        }
		    };
		    ScriptRequest.prototype.cleanup = function () {
		        if (this.script) {
		            this.script.onload = this.script.onerror = null;
		            this.script.onreadystatechange = null;
		        }
		        if (this.script && this.script.parentNode) {
		            this.script.parentNode.removeChild(this.script);
		        }
		        if (this.errorScript && this.errorScript.parentNode) {
		            this.errorScript.parentNode.removeChild(this.errorScript);
		        }
		        this.script = null;
		        this.errorScript = null;
		    };
		    return ScriptRequest;
		}());
		exports.__esModule = true;
		exports["default"] = ScriptRequest;
	
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var Collections = __webpack_require__(9);
		var runtime_1 = __webpack_require__(2);
		var JSONPRequest = (function () {
		    function JSONPRequest(url, data) {
		        this.url = url;
		        this.data = data;
		    }
		    JSONPRequest.prototype.send = function (receiver) {
		        if (this.request) {
		            return;
		        }
		        var query = Collections.buildQueryString(this.data);
		        var url = this.url + "/" + receiver.number + "?" + query;
		        this.request = runtime_1["default"].createScriptRequest(url);
		        this.request.send(receiver);
		    };
		    JSONPRequest.prototype.cleanup = function () {
		        if (this.request) {
		            this.request.cleanup();
		        }
		    };
		    return JSONPRequest;
		}());
		exports.__esModule = true;
		exports["default"] = JSONPRequest;
	
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var runtime_1 = __webpack_require__(2);
		var script_receiver_factory_1 = __webpack_require__(4);
		var getAgent = function (sender, encrypted) {
		    return function (data, callback) {
		        var scheme = "http" + (encrypted ? "s" : "") + "://";
		        var url = scheme + (sender.host || sender.options.host) + sender.options.path;
		        var request = runtime_1["default"].createJSONPRequest(url, data);
		        var receiver = runtime_1["default"].ScriptReceivers.create(function (error, result) {
		            script_receiver_factory_1.ScriptReceivers.remove(receiver);
		            request.cleanup();
		            if (result && result.host) {
		                sender.host = result.host;
		            }
		            if (callback) {
		                callback(error, result);
		            }
		        });
		        request.send(receiver);
		    };
		};
		var jsonp = {
		    name: 'jsonp',
		    getAgent: getAgent
		};
		exports.__esModule = true;
		exports["default"] = jsonp;
	
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var transports_1 = __webpack_require__(19);
		var transport_1 = __webpack_require__(21);
		var URLSchemes = __webpack_require__(20);
		var runtime_1 = __webpack_require__(2);
		var dependencies_1 = __webpack_require__(3);
		var Collections = __webpack_require__(9);
		var SockJSTransport = new transport_1["default"]({
		    file: "sockjs",
		    urls: URLSchemes.sockjs,
		    handlesActivityChecks: true,
		    supportsPing: false,
		    isSupported: function () {
		        return true;
		    },
		    isInitialized: function () {
		        return window.SockJS !== undefined;
		    },
		    getSocket: function (url, options) {
		        return new window.SockJS(url, null, {
		            js_path: dependencies_1.Dependencies.getPath("sockjs", {
		                encrypted: options.encrypted
		            }),
		            ignore_null_origin: options.ignoreNullOrigin
		        });
		    },
		    beforeOpen: function (socket, path) {
		        socket.send(JSON.stringify({
		            path: path
		        }));
		    }
		});
		var xdrConfiguration = {
		    isSupported: function (environment) {
		        var yes = runtime_1["default"].isXDRSupported(environment.encrypted);
		        return yes;
		    }
		};
		var XDRStreamingTransport = new transport_1["default"](Collections.extend({}, transports_1.streamingConfiguration, xdrConfiguration));
		var XDRPollingTransport = new transport_1["default"](Collections.extend({}, transports_1.pollingConfiguration, xdrConfiguration));
		transports_1["default"].xdr_streaming = XDRStreamingTransport;
		transports_1["default"].xdr_polling = XDRPollingTransport;
		transports_1["default"].sockjs = SockJSTransport;
		exports.__esModule = true;
		exports["default"] = transports_1["default"];
	
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var URLSchemes = __webpack_require__(20);
		var transport_1 = __webpack_require__(21);
		var Collections = __webpack_require__(9);
		var runtime_1 = __webpack_require__(2);
		var WSTransport = new transport_1["default"]({
		    urls: URLSchemes.ws,
		    handlesActivityChecks: false,
		    supportsPing: false,
		    isInitialized: function () {
		        return Boolean(runtime_1["default"].getWebSocketAPI());
		    },
		    isSupported: function () {
		        return Boolean(runtime_1["default"].getWebSocketAPI());
		    },
		    getSocket: function (url) {
		        return runtime_1["default"].createWebSocket(url);
		    }
		});
		var httpConfiguration = {
		    urls: URLSchemes.http,
		    handlesActivityChecks: false,
		    supportsPing: true,
		    isInitialized: function () {
		        return true;
		    }
		};
		exports.streamingConfiguration = Collections.extend({ getSocket: function (url) {
		        return runtime_1["default"].HTTPFactory.createStreamingSocket(url);
		    }
		}, httpConfiguration);
		exports.pollingConfiguration = Collections.extend({ getSocket: function (url) {
		        return runtime_1["default"].HTTPFactory.createPollingSocket(url);
		    }
		}, httpConfiguration);
		var xhrConfiguration = {
		    isSupported: function () {
		        return runtime_1["default"].isXHRSupported();
		    }
		};
		var XHRStreamingTransport = new transport_1["default"](Collections.extend({}, exports.streamingConfiguration, xhrConfiguration));
		var XHRPollingTransport = new transport_1["default"](Collections.extend({}, exports.pollingConfiguration, xhrConfiguration));
		var Transports = {
		    ws: WSTransport,
		    xhr_streaming: XHRStreamingTransport,
		    xhr_polling: XHRPollingTransport
		};
		exports.__esModule = true;
		exports["default"] = Transports;
	
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var defaults_1 = __webpack_require__(5);
		function getGenericURL(baseScheme, params, path) {
		    var scheme = baseScheme + (params.encrypted ? "s" : "");
		    var host = params.encrypted ? params.hostEncrypted : params.hostUnencrypted;
		    return scheme + "://" + host + path;
		}
		function getGenericPath(key, queryString) {
		    var path = "/app/" + key;
		    var query = "?protocol=" + defaults_1["default"].PROTOCOL +
		        "&client=js" +
		        "&version=" + defaults_1["default"].VERSION +
		        (queryString ? ("&" + queryString) : "");
		    return path + query;
		}
		exports.ws = {
		    getInitial: function (key, params) {
		        return getGenericURL("ws", params, getGenericPath(key, "flash=false"));
		    }
		};
		exports.http = {
		    getInitial: function (key, params) {
		        var path = (params.httpPath || "/pusher") + getGenericPath(key);
		        return getGenericURL("http", params, path);
		    }
		};
		exports.sockjs = {
		    getInitial: function (key, params) {
		        return getGenericURL("http", params, params.httpPath || "/pusher");
		    },
		    getPath: function (key, params) {
		        return getGenericPath(key);
		    }
		};
	
	
	/***/ },
	/* 21 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var transport_connection_1 = __webpack_require__(22);
		var Transport = (function () {
		    function Transport(hooks) {
		        this.hooks = hooks;
		    }
		    Transport.prototype.isSupported = function (environment) {
		        return this.hooks.isSupported(environment);
		    };
		    Transport.prototype.createConnection = function (name, priority, key, options) {
		        return new transport_connection_1["default"](this.hooks, name, priority, key, options);
		    };
		    return Transport;
		}());
		exports.__esModule = true;
		exports["default"] = Transport;
	
	
	/***/ },
	/* 22 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var util_1 = __webpack_require__(11);
		var Collections = __webpack_require__(9);
		var dispatcher_1 = __webpack_require__(23);
		var logger_1 = __webpack_require__(8);
		var runtime_1 = __webpack_require__(2);
		var TransportConnection = (function (_super) {
		    __extends(TransportConnection, _super);
		    function TransportConnection(hooks, name, priority, key, options) {
		        _super.call(this);
		        this.initialize = runtime_1["default"].transportConnectionInitializer;
		        this.hooks = hooks;
		        this.name = name;
		        this.priority = priority;
		        this.key = key;
		        this.options = options;
		        this.state = "new";
		        this.timeline = options.timeline;
		        this.activityTimeout = options.activityTimeout;
		        this.id = this.timeline.generateUniqueID();
		    }
		    TransportConnection.prototype.handlesActivityChecks = function () {
		        return Boolean(this.hooks.handlesActivityChecks);
		    };
		    TransportConnection.prototype.supportsPing = function () {
		        return Boolean(this.hooks.supportsPing);
		    };
		    TransportConnection.prototype.connect = function () {
		        var _this = this;
		        if (this.socket || this.state !== "initialized") {
		            return false;
		        }
		        var url = this.hooks.urls.getInitial(this.key, this.options);
		        try {
		            this.socket = this.hooks.getSocket(url, this.options);
		        }
		        catch (e) {
		            util_1["default"].defer(function () {
		                _this.onError(e);
		                _this.changeState("closed");
		            });
		            return false;
		        }
		        this.bindListeners();
		        logger_1["default"].debug("Connecting", { transport: this.name, url: url });
		        this.changeState("connecting");
		        return true;
		    };
		    TransportConnection.prototype.close = function () {
		        if (this.socket) {
		            this.socket.close();
		            return true;
		        }
		        else {
		            return false;
		        }
		    };
		    TransportConnection.prototype.send = function (data) {
		        var _this = this;
		        if (this.state === "open") {
		            util_1["default"].defer(function () {
		                if (_this.socket) {
		                    _this.socket.send(data);
		                }
		            });
		            return true;
		        }
		        else {
		            return false;
		        }
		    };
		    TransportConnection.prototype.ping = function () {
		        if (this.state === "open" && this.supportsPing()) {
		            this.socket.ping();
		        }
		    };
		    TransportConnection.prototype.onOpen = function () {
		        if (this.hooks.beforeOpen) {
		            this.hooks.beforeOpen(this.socket, this.hooks.urls.getPath(this.key, this.options));
		        }
		        this.changeState("open");
		        this.socket.onopen = undefined;
		    };
		    TransportConnection.prototype.onError = function (error) {
		        this.emit("error", { type: 'WebSocketError', error: error });
		        this.timeline.error(this.buildTimelineMessage({ error: error.toString() }));
		    };
		    TransportConnection.prototype.onClose = function (closeEvent) {
		        if (closeEvent) {
		            this.changeState("closed", {
		                code: closeEvent.code,
		                reason: closeEvent.reason,
		                wasClean: closeEvent.wasClean
		            });
		        }
		        else {
		            this.changeState("closed");
		        }
		        this.unbindListeners();
		        this.socket = undefined;
		    };
		    TransportConnection.prototype.onMessage = function (message) {
		        this.emit("message", message);
		    };
		    TransportConnection.prototype.onActivity = function () {
		        this.emit("activity");
		    };
		    TransportConnection.prototype.bindListeners = function () {
		        var _this = this;
		        this.socket.onopen = function () {
		            _this.onOpen();
		        };
		        this.socket.onerror = function (error) {
		            _this.onError(error);
		        };
		        this.socket.onclose = function (closeEvent) {
		            _this.onClose(closeEvent);
		        };
		        this.socket.onmessage = function (message) {
		            _this.onMessage(message);
		        };
		        if (this.supportsPing()) {
		            this.socket.onactivity = function () { _this.onActivity(); };
		        }
		    };
		    TransportConnection.prototype.unbindListeners = function () {
		        if (this.socket) {
		            this.socket.onopen = undefined;
		            this.socket.onerror = undefined;
		            this.socket.onclose = undefined;
		            this.socket.onmessage = undefined;
		            if (this.supportsPing()) {
		                this.socket.onactivity = undefined;
		            }
		        }
		    };
		    TransportConnection.prototype.changeState = function (state, params) {
		        this.state = state;
		        this.timeline.info(this.buildTimelineMessage({
		            state: state,
		            params: params
		        }));
		        this.emit(state, params);
		    };
		    TransportConnection.prototype.buildTimelineMessage = function (message) {
		        return Collections.extend({ cid: this.id }, message);
		    };
		    return TransportConnection;
		}(dispatcher_1["default"]));
		exports.__esModule = true;
		exports["default"] = TransportConnection;
	
	
	/***/ },
	/* 23 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var callback_registry_1 = __webpack_require__(24);
		var Dispatcher = (function () {
		    function Dispatcher(failThrough) {
		        this.callbacks = new callback_registry_1["default"]();
		        this.global_callbacks = [];
		        this.failThrough = failThrough;
		    }
		    Dispatcher.prototype.bind = function (eventName, callback, context) {
		        this.callbacks.add(eventName, callback, context);
		        return this;
		    };
		    Dispatcher.prototype.bind_all = function (callback) {
		        this.global_callbacks.push(callback);
		        return this;
		    };
		    Dispatcher.prototype.unbind = function (eventName, callback, context) {
		        this.callbacks.remove(eventName, callback, context);
		        return this;
		    };
		    Dispatcher.prototype.unbind_all = function (eventName, callback) {
		        this.callbacks.remove(eventName, callback);
		        return this;
		    };
		    Dispatcher.prototype.emit = function (eventName, data) {
		        var i;
		        for (i = 0; i < this.global_callbacks.length; i++) {
		            this.global_callbacks[i](eventName, data);
		        }
		        var callbacks = this.callbacks.get(eventName);
		        if (callbacks && callbacks.length > 0) {
		            for (i = 0; i < callbacks.length; i++) {
		                callbacks[i].fn.call(callbacks[i].context || (window), data);
		            }
		        }
		        else if (this.failThrough) {
		            this.failThrough(eventName, data);
		        }
		        return this;
		    };
		    return Dispatcher;
		}());
		exports.__esModule = true;
		exports["default"] = Dispatcher;
	
	
	/***/ },
	/* 24 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var Collections = __webpack_require__(9);
		var CallbackRegistry = (function () {
		    function CallbackRegistry() {
		        this._callbacks = {};
		    }
		    CallbackRegistry.prototype.get = function (name) {
		        return this._callbacks[prefix(name)];
		    };
		    CallbackRegistry.prototype.add = function (name, callback, context) {
		        var prefixedEventName = prefix(name);
		        this._callbacks[prefixedEventName] = this._callbacks[prefixedEventName] || [];
		        this._callbacks[prefixedEventName].push({
		            fn: callback,
		            context: context
		        });
		    };
		    CallbackRegistry.prototype.remove = function (name, callback, context) {
		        if (!name && !callback && !context) {
		            this._callbacks = {};
		            return;
		        }
		        var names = name ? [prefix(name)] : Collections.keys(this._callbacks);
		        if (callback || context) {
		            this.removeCallback(names, callback, context);
		        }
		        else {
		            this.removeAllCallbacks(names);
		        }
		    };
		    CallbackRegistry.prototype.removeCallback = function (names, callback, context) {
		        Collections.apply(names, function (name) {
		            this._callbacks[name] = Collections.filter(this._callbacks[name] || [], function (binding) {
		                return (callback && callback !== binding.fn) ||
		                    (context && context !== binding.context);
		            });
		            if (this._callbacks[name].length === 0) {
		                delete this._callbacks[name];
		            }
		        }, this);
		    };
		    CallbackRegistry.prototype.removeAllCallbacks = function (names) {
		        Collections.apply(names, function (name) {
		            delete this._callbacks[name];
		        }, this);
		    };
		    return CallbackRegistry;
		}());
		exports.__esModule = true;
		exports["default"] = CallbackRegistry;
		function prefix(name) {
		    return "_" + name;
		}
	
	
	/***/ },
	/* 25 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var dispatcher_1 = __webpack_require__(23);
		var NetInfo = (function (_super) {
		    __extends(NetInfo, _super);
		    function NetInfo() {
		        _super.call(this);
		        var self = this;
		        if (window.addEventListener !== undefined) {
		            window.addEventListener("online", function () {
		                self.emit('online');
		            }, false);
		            window.addEventListener("offline", function () {
		                self.emit('offline');
		            }, false);
		        }
		    }
		    NetInfo.prototype.isOnline = function () {
		        if (window.navigator.onLine === undefined) {
		            return true;
		        }
		        else {
		            return window.navigator.onLine;
		        }
		    };
		    return NetInfo;
		}(dispatcher_1["default"]));
		exports.NetInfo = NetInfo;
		exports.Network = new NetInfo();
	
	
	/***/ },
	/* 26 */
	/***/ function(module, exports) {
	
		"use strict";
		var getDefaultStrategy = function (config) {
		    var wsStrategy;
		    if (config.encrypted) {
		        wsStrategy = [
		            ":best_connected_ever",
		            ":ws_loop",
		            [":delayed", 2000, [":http_fallback_loop"]]
		        ];
		    }
		    else {
		        wsStrategy = [
		            ":best_connected_ever",
		            ":ws_loop",
		            [":delayed", 2000, [":wss_loop"]],
		            [":delayed", 5000, [":http_fallback_loop"]]
		        ];
		    }
		    return [
		        [":def", "ws_options", {
		                hostUnencrypted: config.wsHost + ":" + config.wsPort,
		                hostEncrypted: config.wsHost + ":" + config.wssPort
		            }],
		        [":def", "wss_options", [":extend", ":ws_options", {
		                    encrypted: true
		                }]],
		        [":def", "sockjs_options", {
		                hostUnencrypted: config.httpHost + ":" + config.httpPort,
		                hostEncrypted: config.httpHost + ":" + config.httpsPort,
		                httpPath: config.httpPath
		            }],
		        [":def", "timeouts", {
		                loop: true,
		                timeout: 15000,
		                timeoutLimit: 60000
		            }],
		        [":def", "ws_manager", [":transport_manager", {
		                    lives: 2,
		                    minPingDelay: 10000,
		                    maxPingDelay: config.activity_timeout
		                }]],
		        [":def", "streaming_manager", [":transport_manager", {
		                    lives: 2,
		                    minPingDelay: 10000,
		                    maxPingDelay: config.activity_timeout
		                }]],
		        [":def_transport", "ws", "ws", 3, ":ws_options", ":ws_manager"],
		        [":def_transport", "wss", "ws", 3, ":wss_options", ":ws_manager"],
		        [":def_transport", "sockjs", "sockjs", 1, ":sockjs_options"],
		        [":def_transport", "xhr_streaming", "xhr_streaming", 1, ":sockjs_options", ":streaming_manager"],
		        [":def_transport", "xdr_streaming", "xdr_streaming", 1, ":sockjs_options", ":streaming_manager"],
		        [":def_transport", "xhr_polling", "xhr_polling", 1, ":sockjs_options"],
		        [":def_transport", "xdr_polling", "xdr_polling", 1, ":sockjs_options"],
		        [":def", "ws_loop", [":sequential", ":timeouts", ":ws"]],
		        [":def", "wss_loop", [":sequential", ":timeouts", ":wss"]],
		        [":def", "sockjs_loop", [":sequential", ":timeouts", ":sockjs"]],
		        [":def", "streaming_loop", [":sequential", ":timeouts",
		                [":if", [":is_supported", ":xhr_streaming"],
		                    ":xhr_streaming",
		                    ":xdr_streaming"
		                ]
		            ]],
		        [":def", "polling_loop", [":sequential", ":timeouts",
		                [":if", [":is_supported", ":xhr_polling"],
		                    ":xhr_polling",
		                    ":xdr_polling"
		                ]
		            ]],
		        [":def", "http_loop", [":if", [":is_supported", ":streaming_loop"], [
		                    ":best_connected_ever",
		                    ":streaming_loop",
		                    [":delayed", 4000, [":polling_loop"]]
		                ], [
		                    ":polling_loop"
		                ]]],
		        [":def", "http_fallback_loop",
		            [":if", [":is_supported", ":http_loop"], [
		                    ":http_loop"
		                ], [
		                    ":sockjs_loop"
		                ]]
		        ],
		        [":def", "strategy",
		            [":cached", 1800000,
		                [":first_connected",
		                    [":if", [":is_supported", ":ws"],
		                        wsStrategy,
		                        ":http_fallback_loop"
		                    ]
		                ]
		            ]
		        ]
		    ];
		};
		exports.__esModule = true;
		exports["default"] = getDefaultStrategy;
	
	
	/***/ },
	/* 27 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var dependencies_1 = __webpack_require__(3);
		function default_1() {
		    var self = this;
		    self.timeline.info(self.buildTimelineMessage({
		        transport: self.name + (self.options.encrypted ? "s" : "")
		    }));
		    if (self.hooks.isInitialized()) {
		        self.changeState("initialized");
		    }
		    else if (self.hooks.file) {
		        self.changeState("initializing");
		        dependencies_1.Dependencies.load(self.hooks.file, { encrypted: self.options.encrypted }, function (error, callback) {
		            if (self.hooks.isInitialized()) {
		                self.changeState("initialized");
		                callback(true);
		            }
		            else {
		                if (error) {
		                    self.onError(error);
		                }
		                self.onClose();
		                callback(false);
		            }
		        });
		    }
		    else {
		        self.onClose();
		    }
		}
		exports.__esModule = true;
		exports["default"] = default_1;
	
	
	/***/ },
	/* 28 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var http_xdomain_request_1 = __webpack_require__(29);
		var http_1 = __webpack_require__(31);
		http_1["default"].createXDR = function (method, url) {
		    return this.createRequest(http_xdomain_request_1["default"], method, url);
		};
		exports.__esModule = true;
		exports["default"] = http_1["default"];
	
	
	/***/ },
	/* 29 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var Errors = __webpack_require__(30);
		var hooks = {
		    getRequest: function (socket) {
		        var xdr = new window.XDomainRequest();
		        xdr.ontimeout = function () {
		            socket.emit("error", new Errors.RequestTimedOut());
		            socket.close();
		        };
		        xdr.onerror = function (e) {
		            socket.emit("error", e);
		            socket.close();
		        };
		        xdr.onprogress = function () {
		            if (xdr.responseText && xdr.responseText.length > 0) {
		                socket.onChunk(200, xdr.responseText);
		            }
		        };
		        xdr.onload = function () {
		            if (xdr.responseText && xdr.responseText.length > 0) {
		                socket.onChunk(200, xdr.responseText);
		            }
		            socket.emit("finished", 200);
		            socket.close();
		        };
		        return xdr;
		    },
		    abortRequest: function (xdr) {
		        xdr.ontimeout = xdr.onerror = xdr.onprogress = xdr.onload = null;
		        xdr.abort();
		    }
		};
		exports.__esModule = true;
		exports["default"] = hooks;
	
	
	/***/ },
	/* 30 */
	/***/ function(module, exports) {
	
		"use strict";
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var BadEventName = (function (_super) {
		    __extends(BadEventName, _super);
		    function BadEventName() {
		        _super.apply(this, arguments);
		    }
		    return BadEventName;
		}(Error));
		exports.BadEventName = BadEventName;
		var RequestTimedOut = (function (_super) {
		    __extends(RequestTimedOut, _super);
		    function RequestTimedOut() {
		        _super.apply(this, arguments);
		    }
		    return RequestTimedOut;
		}(Error));
		exports.RequestTimedOut = RequestTimedOut;
		var TransportPriorityTooLow = (function (_super) {
		    __extends(TransportPriorityTooLow, _super);
		    function TransportPriorityTooLow() {
		        _super.apply(this, arguments);
		    }
		    return TransportPriorityTooLow;
		}(Error));
		exports.TransportPriorityTooLow = TransportPriorityTooLow;
		var TransportClosed = (function (_super) {
		    __extends(TransportClosed, _super);
		    function TransportClosed() {
		        _super.apply(this, arguments);
		    }
		    return TransportClosed;
		}(Error));
		exports.TransportClosed = TransportClosed;
		var UnsupportedTransport = (function (_super) {
		    __extends(UnsupportedTransport, _super);
		    function UnsupportedTransport() {
		        _super.apply(this, arguments);
		    }
		    return UnsupportedTransport;
		}(Error));
		exports.UnsupportedTransport = UnsupportedTransport;
		var UnsupportedStrategy = (function (_super) {
		    __extends(UnsupportedStrategy, _super);
		    function UnsupportedStrategy() {
		        _super.apply(this, arguments);
		    }
		    return UnsupportedStrategy;
		}(Error));
		exports.UnsupportedStrategy = UnsupportedStrategy;
	
	
	/***/ },
	/* 31 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var http_request_1 = __webpack_require__(32);
		var http_socket_1 = __webpack_require__(33);
		var http_streaming_socket_1 = __webpack_require__(35);
		var http_polling_socket_1 = __webpack_require__(36);
		var http_xhr_request_1 = __webpack_require__(37);
		var HTTP = {
		    createStreamingSocket: function (url) {
		        return this.createSocket(http_streaming_socket_1["default"], url);
		    },
		    createPollingSocket: function (url) {
		        return this.createSocket(http_polling_socket_1["default"], url);
		    },
		    createSocket: function (hooks, url) {
		        return new http_socket_1["default"](hooks, url);
		    },
		    createXHR: function (method, url) {
		        return this.createRequest(http_xhr_request_1["default"], method, url);
		    },
		    createRequest: function (hooks, method, url) {
		        return new http_request_1["default"](hooks, method, url);
		    }
		};
		exports.__esModule = true;
		exports["default"] = HTTP;
	
	
	/***/ },
	/* 32 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var runtime_1 = __webpack_require__(2);
		var dispatcher_1 = __webpack_require__(23);
		var MAX_BUFFER_LENGTH = 256 * 1024;
		var HTTPRequest = (function (_super) {
		    __extends(HTTPRequest, _super);
		    function HTTPRequest(hooks, method, url) {
		        _super.call(this);
		        this.hooks = hooks;
		        this.method = method;
		        this.url = url;
		    }
		    HTTPRequest.prototype.start = function (payload) {
		        var _this = this;
		        this.position = 0;
		        this.xhr = this.hooks.getRequest(this);
		        this.unloader = function () {
		            _this.close();
		        };
		        runtime_1["default"].addUnloadListener(this.unloader);
		        this.xhr.open(this.method, this.url, true);
		        if (this.xhr.setRequestHeader) {
		            this.xhr.setRequestHeader("Content-Type", "application/json");
		        }
		        this.xhr.send(payload);
		    };
		    HTTPRequest.prototype.close = function () {
		        if (this.unloader) {
		            runtime_1["default"].removeUnloadListener(this.unloader);
		            this.unloader = null;
		        }
		        if (this.xhr) {
		            this.hooks.abortRequest(this.xhr);
		            this.xhr = null;
		        }
		    };
		    HTTPRequest.prototype.onChunk = function (status, data) {
		        while (true) {
		            var chunk = this.advanceBuffer(data);
		            if (chunk) {
		                this.emit("chunk", { status: status, data: chunk });
		            }
		            else {
		                break;
		            }
		        }
		        if (this.isBufferTooLong(data)) {
		            this.emit("buffer_too_long");
		        }
		    };
		    HTTPRequest.prototype.advanceBuffer = function (buffer) {
		        var unreadData = buffer.slice(this.position);
		        var endOfLinePosition = unreadData.indexOf("\n");
		        if (endOfLinePosition !== -1) {
		            this.position += endOfLinePosition + 1;
		            return unreadData.slice(0, endOfLinePosition);
		        }
		        else {
		            return null;
		        }
		    };
		    HTTPRequest.prototype.isBufferTooLong = function (buffer) {
		        return this.position === buffer.length && buffer.length > MAX_BUFFER_LENGTH;
		    };
		    return HTTPRequest;
		}(dispatcher_1["default"]));
		exports.__esModule = true;
		exports["default"] = HTTPRequest;
	
	
	/***/ },
	/* 33 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var state_1 = __webpack_require__(34);
		var util_1 = __webpack_require__(11);
		var runtime_1 = __webpack_require__(2);
		var autoIncrement = 1;
		var HTTPSocket = (function () {
		    function HTTPSocket(hooks, url) {
		        this.hooks = hooks;
		        this.session = randomNumber(1000) + "/" + randomString(8);
		        this.location = getLocation(url);
		        this.readyState = state_1["default"].CONNECTING;
		        this.openStream();
		    }
		    HTTPSocket.prototype.send = function (payload) {
		        return this.sendRaw(JSON.stringify([payload]));
		    };
		    HTTPSocket.prototype.ping = function () {
		        this.hooks.sendHeartbeat(this);
		    };
		    HTTPSocket.prototype.close = function (code, reason) {
		        this.onClose(code, reason, true);
		    };
		    HTTPSocket.prototype.sendRaw = function (payload) {
		        if (this.readyState === state_1["default"].OPEN) {
		            try {
		                runtime_1["default"].createSocketRequest("POST", getUniqueURL(getSendURL(this.location, this.session))).start(payload);
		                return true;
		            }
		            catch (e) {
		                return false;
		            }
		        }
		        else {
		            return false;
		        }
		    };
		    HTTPSocket.prototype.reconnect = function () {
		        this.closeStream();
		        this.openStream();
		    };
		    ;
		    HTTPSocket.prototype.onClose = function (code, reason, wasClean) {
		        this.closeStream();
		        this.readyState = state_1["default"].CLOSED;
		        if (this.onclose) {
		            this.onclose({
		                code: code,
		                reason: reason,
		                wasClean: wasClean
		            });
		        }
		    };
		    HTTPSocket.prototype.onChunk = function (chunk) {
		        if (chunk.status !== 200) {
		            return;
		        }
		        if (this.readyState === state_1["default"].OPEN) {
		            this.onActivity();
		        }
		        var payload;
		        var type = chunk.data.slice(0, 1);
		        switch (type) {
		            case 'o':
		                payload = JSON.parse(chunk.data.slice(1) || '{}');
		                this.onOpen(payload);
		                break;
		            case 'a':
		                payload = JSON.parse(chunk.data.slice(1) || '[]');
		                for (var i = 0; i < payload.length; i++) {
		                    this.onEvent(payload[i]);
		                }
		                break;
		            case 'm':
		                payload = JSON.parse(chunk.data.slice(1) || 'null');
		                this.onEvent(payload);
		                break;
		            case 'h':
		                this.hooks.onHeartbeat(this);
		                break;
		            case 'c':
		                payload = JSON.parse(chunk.data.slice(1) || '[]');
		                this.onClose(payload[0], payload[1], true);
		                break;
		        }
		    };
		    HTTPSocket.prototype.onOpen = function (options) {
		        if (this.readyState === state_1["default"].CONNECTING) {
		            if (options && options.hostname) {
		                this.location.base = replaceHost(this.location.base, options.hostname);
		            }
		            this.readyState = state_1["default"].OPEN;
		            if (this.onopen) {
		                this.onopen();
		            }
		        }
		        else {
		            this.onClose(1006, "Server lost session", true);
		        }
		    };
		    HTTPSocket.prototype.onEvent = function (event) {
		        if (this.readyState === state_1["default"].OPEN && this.onmessage) {
		            this.onmessage({ data: event });
		        }
		    };
		    HTTPSocket.prototype.onActivity = function () {
		        if (this.onactivity) {
		            this.onactivity();
		        }
		    };
		    HTTPSocket.prototype.onError = function (error) {
		        if (this.onerror) {
		            this.onerror(error);
		        }
		    };
		    HTTPSocket.prototype.openStream = function () {
		        var _this = this;
		        this.stream = runtime_1["default"].createSocketRequest("POST", getUniqueURL(this.hooks.getReceiveURL(this.location, this.session)));
		        this.stream.bind("chunk", function (chunk) {
		            _this.onChunk(chunk);
		        });
		        this.stream.bind("finished", function (status) {
		            _this.hooks.onFinished(_this, status);
		        });
		        this.stream.bind("buffer_too_long", function () {
		            _this.reconnect();
		        });
		        try {
		            this.stream.start();
		        }
		        catch (error) {
		            util_1["default"].defer(function () {
		                _this.onError(error);
		                _this.onClose(1006, "Could not start streaming", false);
		            });
		        }
		    };
		    HTTPSocket.prototype.closeStream = function () {
		        if (this.stream) {
		            this.stream.unbind_all();
		            this.stream.close();
		            this.stream = null;
		        }
		    };
		    return HTTPSocket;
		}());
		function getLocation(url) {
		    var parts = /([^\?]*)\/*(\??.*)/.exec(url);
		    return {
		        base: parts[1],
		        queryString: parts[2]
		    };
		}
		function getSendURL(url, session) {
		    return url.base + "/" + session + "/xhr_send";
		}
		function getUniqueURL(url) {
		    var separator = (url.indexOf('?') === -1) ? "?" : "&";
		    return url + separator + "t=" + (+new Date()) + "&n=" + autoIncrement++;
		}
		function replaceHost(url, hostname) {
		    var urlParts = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(url);
		    return urlParts[1] + hostname + urlParts[3];
		}
		function randomNumber(max) {
		    return Math.floor(Math.random() * max);
		}
		function randomString(length) {
		    var result = [];
		    for (var i = 0; i < length; i++) {
		        result.push(randomNumber(32).toString(32));
		    }
		    return result.join('');
		}
		exports.__esModule = true;
		exports["default"] = HTTPSocket;
	
	
	/***/ },
	/* 34 */
	/***/ function(module, exports) {
	
		"use strict";
		var State;
		(function (State) {
		    State[State["CONNECTING"] = 0] = "CONNECTING";
		    State[State["OPEN"] = 1] = "OPEN";
		    State[State["CLOSED"] = 3] = "CLOSED";
		})(State || (State = {}));
		exports.__esModule = true;
		exports["default"] = State;
	
	
	/***/ },
	/* 35 */
	/***/ function(module, exports) {
	
		"use strict";
		var hooks = {
		    getReceiveURL: function (url, session) {
		        return url.base + "/" + session + "/xhr_streaming" + url.queryString;
		    },
		    onHeartbeat: function (socket) {
		        socket.sendRaw("[]");
		    },
		    sendHeartbeat: function (socket) {
		        socket.sendRaw("[]");
		    },
		    onFinished: function (socket, status) {
		        socket.onClose(1006, "Connection interrupted (" + status + ")", false);
		    }
		};
		exports.__esModule = true;
		exports["default"] = hooks;
	
	
	/***/ },
	/* 36 */
	/***/ function(module, exports) {
	
		"use strict";
		var hooks = {
		    getReceiveURL: function (url, session) {
		        return url.base + "/" + session + "/xhr" + url.queryString;
		    },
		    onHeartbeat: function () {
		    },
		    sendHeartbeat: function (socket) {
		        socket.sendRaw("[]");
		    },
		    onFinished: function (socket, status) {
		        if (status === 200) {
		            socket.reconnect();
		        }
		        else {
		            socket.onClose(1006, "Connection interrupted (" + status + ")", false);
		        }
		    }
		};
		exports.__esModule = true;
		exports["default"] = hooks;
	
	
	/***/ },
	/* 37 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var runtime_1 = __webpack_require__(2);
		var hooks = {
		    getRequest: function (socket) {
		        var Constructor = runtime_1["default"].getXHRAPI();
		        var xhr = new Constructor();
		        xhr.onreadystatechange = xhr.onprogress = function () {
		            switch (xhr.readyState) {
		                case 3:
		                    if (xhr.responseText && xhr.responseText.length > 0) {
		                        socket.onChunk(xhr.status, xhr.responseText);
		                    }
		                    break;
		                case 4:
		                    if (xhr.responseText && xhr.responseText.length > 0) {
		                        socket.onChunk(xhr.status, xhr.responseText);
		                    }
		                    socket.emit("finished", xhr.status);
		                    socket.close();
		                    break;
		            }
		        };
		        return xhr;
		    },
		    abortRequest: function (xhr) {
		        xhr.onreadystatechange = null;
		        xhr.abort();
		    }
		};
		exports.__esModule = true;
		exports["default"] = hooks;
	
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var Collections = __webpack_require__(9);
		var util_1 = __webpack_require__(11);
		var level_1 = __webpack_require__(39);
		var Timeline = (function () {
		    function Timeline(key, session, options) {
		        this.key = key;
		        this.session = session;
		        this.events = [];
		        this.options = options || {};
		        this.sent = 0;
		        this.uniqueID = 0;
		    }
		    Timeline.prototype.log = function (level, event) {
		        if (level <= this.options.level) {
		            this.events.push(Collections.extend({}, event, { timestamp: util_1["default"].now() }));
		            if (this.options.limit && this.events.length > this.options.limit) {
		                this.events.shift();
		            }
		        }
		    };
		    Timeline.prototype.error = function (event) {
		        this.log(level_1["default"].ERROR, event);
		    };
		    Timeline.prototype.info = function (event) {
		        this.log(level_1["default"].INFO, event);
		    };
		    Timeline.prototype.debug = function (event) {
		        this.log(level_1["default"].DEBUG, event);
		    };
		    Timeline.prototype.isEmpty = function () {
		        return this.events.length === 0;
		    };
		    Timeline.prototype.send = function (sendfn, callback) {
		        var _this = this;
		        var data = Collections.extend({
		            session: this.session,
		            bundle: this.sent + 1,
		            key: this.key,
		            lib: "js",
		            version: this.options.version,
		            cluster: this.options.cluster,
		            features: this.options.features,
		            timeline: this.events
		        }, this.options.params);
		        this.events = [];
		        sendfn(data, function (error, result) {
		            if (!error) {
		                _this.sent++;
		            }
		            if (callback) {
		                callback(error, result);
		            }
		        });
		        return true;
		    };
		    Timeline.prototype.generateUniqueID = function () {
		        this.uniqueID++;
		        return this.uniqueID;
		    };
		    return Timeline;
		}());
		exports.__esModule = true;
		exports["default"] = Timeline;
	
	
	/***/ },
	/* 39 */
	/***/ function(module, exports) {
	
		"use strict";
		var TimelineLevel;
		(function (TimelineLevel) {
		    TimelineLevel[TimelineLevel["ERROR"] = 3] = "ERROR";
		    TimelineLevel[TimelineLevel["INFO"] = 6] = "INFO";
		    TimelineLevel[TimelineLevel["DEBUG"] = 7] = "DEBUG";
		})(TimelineLevel || (TimelineLevel = {}));
		exports.__esModule = true;
		exports["default"] = TimelineLevel;
	
	
	/***/ },
	/* 40 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var Collections = __webpack_require__(9);
		var util_1 = __webpack_require__(11);
		var transport_manager_1 = __webpack_require__(41);
		var Errors = __webpack_require__(30);
		var transport_strategy_1 = __webpack_require__(55);
		var sequential_strategy_1 = __webpack_require__(56);
		var best_connected_ever_strategy_1 = __webpack_require__(57);
		var cached_strategy_1 = __webpack_require__(58);
		var delayed_strategy_1 = __webpack_require__(59);
		var if_strategy_1 = __webpack_require__(60);
		var first_connected_strategy_1 = __webpack_require__(61);
		var runtime_1 = __webpack_require__(2);
		var Transports = runtime_1["default"].Transports;
		exports.build = function (scheme, options) {
		    var context = Collections.extend({}, globalContext, options);
		    return evaluate(scheme, context)[1].strategy;
		};
		var UnsupportedStrategy = {
		    isSupported: function () {
		        return false;
		    },
		    connect: function (_, callback) {
		        var deferred = util_1["default"].defer(function () {
		            callback(new Errors.UnsupportedStrategy());
		        });
		        return {
		            abort: function () {
		                deferred.ensureAborted();
		            },
		            forceMinPriority: function () { }
		        };
		    }
		};
		function returnWithOriginalContext(f) {
		    return function (context) {
		        return [f.apply(this, arguments), context];
		    };
		}
		var globalContext = {
		    extend: function (context, first, second) {
		        return [Collections.extend({}, first, second), context];
		    },
		    def: function (context, name, value) {
		        if (context[name] !== undefined) {
		            throw "Redefining symbol " + name;
		        }
		        context[name] = value;
		        return [undefined, context];
		    },
		    def_transport: function (context, name, type, priority, options, manager) {
		        var transportClass = Transports[type];
		        if (!transportClass) {
		            throw new Errors.UnsupportedTransport(type);
		        }
		        var enabled = (!context.enabledTransports ||
		            Collections.arrayIndexOf(context.enabledTransports, name) !== -1) &&
		            (!context.disabledTransports ||
		                Collections.arrayIndexOf(context.disabledTransports, name) === -1);
		        var transport;
		        if (enabled) {
		            transport = new transport_strategy_1["default"](name, priority, manager ? manager.getAssistant(transportClass) : transportClass, Collections.extend({
		                key: context.key,
		                encrypted: context.encrypted,
		                timeline: context.timeline,
		                ignoreNullOrigin: context.ignoreNullOrigin
		            }, options));
		        }
		        else {
		            transport = UnsupportedStrategy;
		        }
		        var newContext = context.def(context, name, transport)[1];
		        newContext.Transports = context.Transports || {};
		        newContext.Transports[name] = transport;
		        return [undefined, newContext];
		    },
		    transport_manager: returnWithOriginalContext(function (_, options) {
		        return new transport_manager_1["default"](options);
		    }),
		    sequential: returnWithOriginalContext(function (_, options) {
		        var strategies = Array.prototype.slice.call(arguments, 2);
		        return new sequential_strategy_1["default"](strategies, options);
		    }),
		    cached: returnWithOriginalContext(function (context, ttl, strategy) {
		        return new cached_strategy_1["default"](strategy, context.Transports, {
		            ttl: ttl,
		            timeline: context.timeline,
		            encrypted: context.encrypted
		        });
		    }),
		    first_connected: returnWithOriginalContext(function (_, strategy) {
		        return new first_connected_strategy_1["default"](strategy);
		    }),
		    best_connected_ever: returnWithOriginalContext(function () {
		        var strategies = Array.prototype.slice.call(arguments, 1);
		        return new best_connected_ever_strategy_1["default"](strategies);
		    }),
		    delayed: returnWithOriginalContext(function (_, delay, strategy) {
		        return new delayed_strategy_1["default"](strategy, { delay: delay });
		    }),
		    "if": returnWithOriginalContext(function (_, test, trueBranch, falseBranch) {
		        return new if_strategy_1["default"](test, trueBranch, falseBranch);
		    }),
		    is_supported: returnWithOriginalContext(function (_, strategy) {
		        return function () {
		            return strategy.isSupported();
		        };
		    })
		};
		function isSymbol(expression) {
		    return (typeof expression === "string") && expression.charAt(0) === ":";
		}
		function getSymbolValue(expression, context) {
		    return context[expression.slice(1)];
		}
		function evaluateListOfExpressions(expressions, context) {
		    if (expressions.length === 0) {
		        return [[], context];
		    }
		    var head = evaluate(expressions[0], context);
		    var tail = evaluateListOfExpressions(expressions.slice(1), head[1]);
		    return [[head[0]].concat(tail[0]), tail[1]];
		}
		function evaluateString(expression, context) {
		    if (!isSymbol(expression)) {
		        return [expression, context];
		    }
		    var value = getSymbolValue(expression, context);
		    if (value === undefined) {
		        throw "Undefined symbol " + expression;
		    }
		    return [value, context];
		}
		function evaluateArray(expression, context) {
		    if (isSymbol(expression[0])) {
		        var f = getSymbolValue(expression[0], context);
		        if (expression.length > 1) {
		            if (typeof f !== "function") {
		                throw "Calling non-function " + expression[0];
		            }
		            var args = [Collections.extend({}, context)].concat(Collections.map(expression.slice(1), function (arg) {
		                return evaluate(arg, Collections.extend({}, context))[0];
		            }));
		            return f.apply(this, args);
		        }
		        else {
		            return [f, context];
		        }
		    }
		    else {
		        return evaluateListOfExpressions(expression, context);
		    }
		}
		function evaluate(expression, context) {
		    if (typeof expression === "string") {
		        return evaluateString(expression, context);
		    }
		    else if (typeof expression === "object") {
		        if (expression instanceof Array && expression.length > 0) {
		            return evaluateArray(expression, context);
		        }
		    }
		    return [expression, context];
		}
	
	
	/***/ },
	/* 41 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var factory_1 = __webpack_require__(42);
		var TransportManager = (function () {
		    function TransportManager(options) {
		        this.options = options || {};
		        this.livesLeft = this.options.lives || Infinity;
		    }
		    TransportManager.prototype.getAssistant = function (transport) {
		        return factory_1["default"].createAssistantToTheTransportManager(this, transport, {
		            minPingDelay: this.options.minPingDelay,
		            maxPingDelay: this.options.maxPingDelay
		        });
		    };
		    TransportManager.prototype.isAlive = function () {
		        return this.livesLeft > 0;
		    };
		    TransportManager.prototype.reportDeath = function () {
		        this.livesLeft -= 1;
		    };
		    return TransportManager;
		}());
		exports.__esModule = true;
		exports["default"] = TransportManager;
	
	
	/***/ },
	/* 42 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var assistant_to_the_transport_manager_1 = __webpack_require__(43);
		var handshake_1 = __webpack_require__(44);
		var pusher_authorizer_1 = __webpack_require__(47);
		var timeline_sender_1 = __webpack_require__(48);
		var presence_channel_1 = __webpack_require__(49);
		var private_channel_1 = __webpack_require__(50);
		var channel_1 = __webpack_require__(51);
		var connection_manager_1 = __webpack_require__(53);
		var channels_1 = __webpack_require__(54);
		var Factory = {
		    createChannels: function () {
		        return new channels_1["default"]();
		    },
		    createConnectionManager: function (key, options) {
		        return new connection_manager_1["default"](key, options);
		    },
		    createChannel: function (name, pusher) {
		        return new channel_1["default"](name, pusher);
		    },
		    createPrivateChannel: function (name, pusher) {
		        return new private_channel_1["default"](name, pusher);
		    },
		    createPresenceChannel: function (name, pusher) {
		        return new presence_channel_1["default"](name, pusher);
		    },
		    createTimelineSender: function (timeline, options) {
		        return new timeline_sender_1["default"](timeline, options);
		    },
		    createAuthorizer: function (channel, options) {
		        return new pusher_authorizer_1["default"](channel, options);
		    },
		    createHandshake: function (transport, callback) {
		        return new handshake_1["default"](transport, callback);
		    },
		    createAssistantToTheTransportManager: function (manager, transport, options) {
		        return new assistant_to_the_transport_manager_1["default"](manager, transport, options);
		    }
		};
		exports.__esModule = true;
		exports["default"] = Factory;
	
	
	/***/ },
	/* 43 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var util_1 = __webpack_require__(11);
		var Collections = __webpack_require__(9);
		var AssistantToTheTransportManager = (function () {
		    function AssistantToTheTransportManager(manager, transport, options) {
		        this.manager = manager;
		        this.transport = transport;
		        this.minPingDelay = options.minPingDelay;
		        this.maxPingDelay = options.maxPingDelay;
		        this.pingDelay = undefined;
		    }
		    AssistantToTheTransportManager.prototype.createConnection = function (name, priority, key, options) {
		        var _this = this;
		        options = Collections.extend({}, options, {
		            activityTimeout: this.pingDelay
		        });
		        var connection = this.transport.createConnection(name, priority, key, options);
		        var openTimestamp = null;
		        var onOpen = function () {
		            connection.unbind("open", onOpen);
		            connection.bind("closed", onClosed);
		            openTimestamp = util_1["default"].now();
		        };
		        var onClosed = function (closeEvent) {
		            connection.unbind("closed", onClosed);
		            if (closeEvent.code === 1002 || closeEvent.code === 1003) {
		                _this.manager.reportDeath();
		            }
		            else if (!closeEvent.wasClean && openTimestamp) {
		                var lifespan = util_1["default"].now() - openTimestamp;
		                if (lifespan < 2 * _this.maxPingDelay) {
		                    _this.manager.reportDeath();
		                    _this.pingDelay = Math.max(lifespan / 2, _this.minPingDelay);
		                }
		            }
		        };
		        connection.bind("open", onOpen);
		        return connection;
		    };
		    AssistantToTheTransportManager.prototype.isSupported = function (environment) {
		        return this.manager.isAlive() && this.transport.isSupported(environment);
		    };
		    return AssistantToTheTransportManager;
		}());
		exports.__esModule = true;
		exports["default"] = AssistantToTheTransportManager;
	
	
	/***/ },
	/* 44 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var Collections = __webpack_require__(9);
		var Protocol = __webpack_require__(45);
		var connection_1 = __webpack_require__(46);
		var Handshake = (function () {
		    function Handshake(transport, callback) {
		        this.transport = transport;
		        this.callback = callback;
		        this.bindListeners();
		    }
		    Handshake.prototype.close = function () {
		        this.unbindListeners();
		        this.transport.close();
		    };
		    Handshake.prototype.bindListeners = function () {
		        var _this = this;
		        this.onMessage = function (m) {
		            _this.unbindListeners();
		            var result;
		            try {
		                result = Protocol.processHandshake(m);
		            }
		            catch (e) {
		                _this.finish("error", { error: e });
		                _this.transport.close();
		                return;
		            }
		            if (result.action === "connected") {
		                _this.finish("connected", {
		                    connection: new connection_1["default"](result.id, _this.transport),
		                    activityTimeout: result.activityTimeout
		                });
		            }
		            else {
		                _this.finish(result.action, { error: result.error });
		                _this.transport.close();
		            }
		        };
		        this.onClosed = function (closeEvent) {
		            _this.unbindListeners();
		            var action = Protocol.getCloseAction(closeEvent) || "backoff";
		            var error = Protocol.getCloseError(closeEvent);
		            _this.finish(action, { error: error });
		        };
		        this.transport.bind("message", this.onMessage);
		        this.transport.bind("closed", this.onClosed);
		    };
		    Handshake.prototype.unbindListeners = function () {
		        this.transport.unbind("message", this.onMessage);
		        this.transport.unbind("closed", this.onClosed);
		    };
		    Handshake.prototype.finish = function (action, params) {
		        this.callback(Collections.extend({ transport: this.transport, action: action }, params));
		    };
		    return Handshake;
		}());
		exports.__esModule = true;
		exports["default"] = Handshake;
	
	
	/***/ },
	/* 45 */
	/***/ function(module, exports) {
	
		"use strict";
		exports.decodeMessage = function (message) {
		    try {
		        var params = JSON.parse(message.data);
		        if (typeof params.data === 'string') {
		            try {
		                params.data = JSON.parse(params.data);
		            }
		            catch (e) {
		                if (!(e instanceof SyntaxError)) {
		                    throw e;
		                }
		            }
		        }
		        return params;
		    }
		    catch (e) {
		        throw { type: 'MessageParseError', error: e, data: message.data };
		    }
		};
		exports.encodeMessage = function (message) {
		    return JSON.stringify(message);
		};
		exports.processHandshake = function (message) {
		    message = exports.decodeMessage(message);
		    if (message.event === "pusher:connection_established") {
		        if (!message.data.activity_timeout) {
		            throw "No activity timeout specified in handshake";
		        }
		        return {
		            action: "connected",
		            id: message.data.socket_id,
		            activityTimeout: message.data.activity_timeout * 1000
		        };
		    }
		    else if (message.event === "pusher:error") {
		        return {
		            action: this.getCloseAction(message.data),
		            error: this.getCloseError(message.data)
		        };
		    }
		    else {
		        throw "Invalid handshake";
		    }
		};
		exports.getCloseAction = function (closeEvent) {
		    if (closeEvent.code < 4000) {
		        if (closeEvent.code >= 1002 && closeEvent.code <= 1004) {
		            return "backoff";
		        }
		        else {
		            return null;
		        }
		    }
		    else if (closeEvent.code === 4000) {
		        return "ssl_only";
		    }
		    else if (closeEvent.code < 4100) {
		        return "refused";
		    }
		    else if (closeEvent.code < 4200) {
		        return "backoff";
		    }
		    else if (closeEvent.code < 4300) {
		        return "retry";
		    }
		    else {
		        return "refused";
		    }
		};
		exports.getCloseError = function (closeEvent) {
		    if (closeEvent.code !== 1000 && closeEvent.code !== 1001) {
		        return {
		            type: 'PusherError',
		            data: {
		                code: closeEvent.code,
		                message: closeEvent.reason || closeEvent.message
		            }
		        };
		    }
		    else {
		        return null;
		    }
		};
	
	
	/***/ },
	/* 46 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var Collections = __webpack_require__(9);
		var dispatcher_1 = __webpack_require__(23);
		var Protocol = __webpack_require__(45);
		var logger_1 = __webpack_require__(8);
		var Connection = (function (_super) {
		    __extends(Connection, _super);
		    function Connection(id, transport) {
		        _super.call(this);
		        this.id = id;
		        this.transport = transport;
		        this.activityTimeout = transport.activityTimeout;
		        this.bindListeners();
		    }
		    Connection.prototype.handlesActivityChecks = function () {
		        return this.transport.handlesActivityChecks();
		    };
		    Connection.prototype.send = function (data) {
		        return this.transport.send(data);
		    };
		    Connection.prototype.send_event = function (name, data, channel) {
		        var message = { event: name, data: data };
		        if (channel) {
		            message.channel = channel;
		        }
		        logger_1["default"].debug('Event sent', message);
		        return this.send(Protocol.encodeMessage(message));
		    };
		    Connection.prototype.ping = function () {
		        if (this.transport.supportsPing()) {
		            this.transport.ping();
		        }
		        else {
		            this.send_event('pusher:ping', {});
		        }
		    };
		    Connection.prototype.close = function () {
		        this.transport.close();
		    };
		    Connection.prototype.bindListeners = function () {
		        var _this = this;
		        var listeners = {
		            message: function (m) {
		                var message;
		                try {
		                    message = Protocol.decodeMessage(m);
		                }
		                catch (e) {
		                    _this.emit('error', {
		                        type: 'MessageParseError',
		                        error: e,
		                        data: m.data
		                    });
		                }
		                if (message !== undefined) {
		                    logger_1["default"].debug('Event recd', message);
		                    switch (message.event) {
		                        case 'pusher:error':
		                            _this.emit('error', { type: 'PusherError', data: message.data });
		                            break;
		                        case 'pusher:ping':
		                            _this.emit("ping");
		                            break;
		                        case 'pusher:pong':
		                            _this.emit("pong");
		                            break;
		                    }
		                    _this.emit('message', message);
		                }
		            },
		            activity: function () {
		                _this.emit("activity");
		            },
		            error: function (error) {
		                _this.emit("error", { type: "WebSocketError", error: error });
		            },
		            closed: function (closeEvent) {
		                unbindListeners();
		                if (closeEvent && closeEvent.code) {
		                    _this.handleCloseEvent(closeEvent);
		                }
		                _this.transport = null;
		                _this.emit("closed");
		            }
		        };
		        var unbindListeners = function () {
		            Collections.objectApply(listeners, function (listener, event) {
		                _this.transport.unbind(event, listener);
		            });
		        };
		        Collections.objectApply(listeners, function (listener, event) {
		            _this.transport.bind(event, listener);
		        });
		    };
		    Connection.prototype.handleCloseEvent = function (closeEvent) {
		        var action = Protocol.getCloseAction(closeEvent);
		        var error = Protocol.getCloseError(closeEvent);
		        if (error) {
		            this.emit('error', error);
		        }
		        if (action) {
		            this.emit(action);
		        }
		    };
		    return Connection;
		}(dispatcher_1["default"]));
		exports.__esModule = true;
		exports["default"] = Connection;
	
	
	/***/ },
	/* 47 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var runtime_1 = __webpack_require__(2);
		var Authorizer = (function () {
		    function Authorizer(channel, options) {
		        this.channel = channel;
		        var authTransport = options.authTransport;
		        if (typeof runtime_1["default"].getAuthorizers()[authTransport] === "undefined") {
		            throw "'" + authTransport + "' is not a recognized auth transport";
		        }
		        this.type = authTransport;
		        this.options = options;
		        this.authOptions = (options || {}).auth || {};
		    }
		    Authorizer.prototype.composeQuery = function (socketId) {
		        var query = 'socket_id=' + encodeURIComponent(socketId) +
		            '&channel_name=' + encodeURIComponent(this.channel.name);
		        for (var i in this.authOptions.params) {
		            query += "&" + encodeURIComponent(i) + "=" + encodeURIComponent(this.authOptions.params[i]);
		        }
		        return query;
		    };
		    Authorizer.prototype.authorize = function (socketId, callback) {
		        Authorizer.authorizers = Authorizer.authorizers || runtime_1["default"].getAuthorizers();
		        return Authorizer.authorizers[this.type].call(this, runtime_1["default"], socketId, callback);
		    };
		    return Authorizer;
		}());
		exports.__esModule = true;
		exports["default"] = Authorizer;
	
	
	/***/ },
	/* 48 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var runtime_1 = __webpack_require__(2);
		var TimelineSender = (function () {
		    function TimelineSender(timeline, options) {
		        this.timeline = timeline;
		        this.options = options || {};
		    }
		    TimelineSender.prototype.send = function (encrypted, callback) {
		        if (this.timeline.isEmpty()) {
		            return;
		        }
		        this.timeline.send(runtime_1["default"].TimelineTransport.getAgent(this, encrypted), callback);
		    };
		    return TimelineSender;
		}());
		exports.__esModule = true;
		exports["default"] = TimelineSender;
	
	
	/***/ },
	/* 49 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var private_channel_1 = __webpack_require__(50);
		var logger_1 = __webpack_require__(8);
		var members_1 = __webpack_require__(52);
		var PresenceChannel = (function (_super) {
		    __extends(PresenceChannel, _super);
		    function PresenceChannel(name, pusher) {
		        _super.call(this, name, pusher);
		        this.members = new members_1["default"]();
		    }
		    PresenceChannel.prototype.authorize = function (socketId, callback) {
		        var _this = this;
		        _super.prototype.authorize.call(this, socketId, function (error, authData) {
		            if (!error) {
		                if (authData.channel_data === undefined) {
		                    logger_1["default"].warn("Invalid auth response for channel '" +
		                        _this.name +
		                        "', expected 'channel_data' field");
		                    callback("Invalid auth response");
		                    return;
		                }
		                var channelData = JSON.parse(authData.channel_data);
		                _this.members.setMyID(channelData.user_id);
		            }
		            callback(error, authData);
		        });
		    };
		    PresenceChannel.prototype.handleEvent = function (event, data) {
		        switch (event) {
		            case "pusher_internal:subscription_succeeded":
		                this.members.onSubscription(data);
		                this.subscribed = true;
		                this.emit("pusher:subscription_succeeded", this.members);
		                break;
		            case "pusher_internal:member_added":
		                var addedMember = this.members.addMember(data);
		                this.emit('pusher:member_added', addedMember);
		                break;
		            case "pusher_internal:member_removed":
		                var removedMember = this.members.removeMember(data);
		                if (removedMember) {
		                    this.emit('pusher:member_removed', removedMember);
		                }
		                break;
		            default:
		                private_channel_1["default"].prototype.handleEvent.call(this, event, data);
		        }
		    };
		    PresenceChannel.prototype.disconnect = function () {
		        this.members.reset();
		        _super.prototype.disconnect.call(this);
		    };
		    return PresenceChannel;
		}(private_channel_1["default"]));
		exports.__esModule = true;
		exports["default"] = PresenceChannel;
	
	
	/***/ },
	/* 50 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var factory_1 = __webpack_require__(42);
		var channel_1 = __webpack_require__(51);
		var PrivateChannel = (function (_super) {
		    __extends(PrivateChannel, _super);
		    function PrivateChannel() {
		        _super.apply(this, arguments);
		    }
		    PrivateChannel.prototype.authorize = function (socketId, callback) {
		        var authorizer = factory_1["default"].createAuthorizer(this, this.pusher.config);
		        return authorizer.authorize(socketId, callback);
		    };
		    return PrivateChannel;
		}(channel_1["default"]));
		exports.__esModule = true;
		exports["default"] = PrivateChannel;
	
	
	/***/ },
	/* 51 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var dispatcher_1 = __webpack_require__(23);
		var Errors = __webpack_require__(30);
		var logger_1 = __webpack_require__(8);
		var Channel = (function (_super) {
		    __extends(Channel, _super);
		    function Channel(name, pusher) {
		        _super.call(this, function (event, data) {
		            logger_1["default"].debug('No callbacks on ' + name + ' for ' + event);
		        });
		        this.name = name;
		        this.pusher = pusher;
		        this.subscribed = false;
		    }
		    Channel.prototype.authorize = function (socketId, callback) {
		        return callback(false, {});
		    };
		    Channel.prototype.trigger = function (event, data) {
		        if (event.indexOf("client-") !== 0) {
		            throw new Errors.BadEventName("Event '" + event + "' does not start with 'client-'");
		        }
		        return this.pusher.send_event(event, data, this.name);
		    };
		    Channel.prototype.disconnect = function () {
		        this.subscribed = false;
		    };
		    Channel.prototype.handleEvent = function (event, data) {
		        if (event.indexOf("pusher_internal:") === 0) {
		            if (event === "pusher_internal:subscription_succeeded") {
		                this.subscribed = true;
		                this.emit("pusher:subscription_succeeded", data);
		            }
		        }
		        else {
		            this.emit(event, data);
		        }
		    };
		    Channel.prototype.subscribe = function () {
		        var _this = this;
		        this.authorize(this.pusher.connection.socket_id, function (error, data) {
		            if (error) {
		                _this.handleEvent('pusher:subscription_error', data);
		            }
		            else {
		                _this.pusher.send_event('pusher:subscribe', {
		                    auth: data.auth,
		                    channel_data: data.channel_data,
		                    channel: _this.name
		                });
		            }
		        });
		    };
		    Channel.prototype.unsubscribe = function () {
		        this.pusher.send_event('pusher:unsubscribe', {
		            channel: this.name
		        });
		    };
		    return Channel;
		}(dispatcher_1["default"]));
		exports.__esModule = true;
		exports["default"] = Channel;
	
	
	/***/ },
	/* 52 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var Collections = __webpack_require__(9);
		var Members = (function () {
		    function Members() {
		        this.reset();
		    }
		    Members.prototype.get = function (id) {
		        if (Object.prototype.hasOwnProperty.call(this.members, id)) {
		            return {
		                id: id,
		                info: this.members[id]
		            };
		        }
		        else {
		            return null;
		        }
		    };
		    Members.prototype.each = function (callback) {
		        var _this = this;
		        Collections.objectApply(this.members, function (member, id) {
		            callback(_this.get(id));
		        });
		    };
		    Members.prototype.setMyID = function (id) {
		        this.myID = id;
		    };
		    Members.prototype.onSubscription = function (subscriptionData) {
		        this.members = subscriptionData.presence.hash;
		        this.count = subscriptionData.presence.count;
		        this.me = this.get(this.myID);
		    };
		    Members.prototype.addMember = function (memberData) {
		        if (this.get(memberData.user_id) === null) {
		            this.count++;
		        }
		        this.members[memberData.user_id] = memberData.user_info;
		        return this.get(memberData.user_id);
		    };
		    Members.prototype.removeMember = function (memberData) {
		        var member = this.get(memberData.user_id);
		        if (member) {
		            delete this.members[memberData.user_id];
		            this.count--;
		        }
		        return member;
		    };
		    Members.prototype.reset = function () {
		        this.members = {};
		        this.count = 0;
		        this.myID = null;
		        this.me = null;
		    };
		    return Members;
		}());
		exports.__esModule = true;
		exports["default"] = Members;
	
	
	/***/ },
	/* 53 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var dispatcher_1 = __webpack_require__(23);
		var timers_1 = __webpack_require__(12);
		var logger_1 = __webpack_require__(8);
		var Collections = __webpack_require__(9);
		var runtime_1 = __webpack_require__(2);
		var ConnectionManager = (function (_super) {
		    __extends(ConnectionManager, _super);
		    function ConnectionManager(key, options) {
		        var _this = this;
		        _super.call(this);
		        this.key = key;
		        this.options = options || {};
		        this.state = "initialized";
		        this.connection = null;
		        this.encrypted = !!options.encrypted;
		        this.timeline = this.options.timeline;
		        this.connectionCallbacks = this.buildConnectionCallbacks();
		        this.errorCallbacks = this.buildErrorCallbacks();
		        this.handshakeCallbacks = this.buildHandshakeCallbacks(this.errorCallbacks);
		        var Network = runtime_1["default"].getNetwork();
		        Network.bind("online", function () {
		            _this.timeline.info({ netinfo: "online" });
		            if (_this.state === "connecting" || _this.state === "unavailable") {
		                _this.retryIn(0);
		            }
		        });
		        Network.bind("offline", function () {
		            _this.timeline.info({ netinfo: "offline" });
		            if (_this.connection) {
		                _this.sendActivityCheck();
		            }
		        });
		        this.updateStrategy();
		    }
		    ConnectionManager.prototype.connect = function () {
		        if (this.connection || this.runner) {
		            return;
		        }
		        if (!this.strategy.isSupported()) {
		            this.updateState("failed");
		            return;
		        }
		        this.updateState("connecting");
		        this.startConnecting();
		        this.setUnavailableTimer();
		    };
		    ;
		    ConnectionManager.prototype.send = function (data) {
		        if (this.connection) {
		            return this.connection.send(data);
		        }
		        else {
		            return false;
		        }
		    };
		    ;
		    ConnectionManager.prototype.send_event = function (name, data, channel) {
		        if (this.connection) {
		            return this.connection.send_event(name, data, channel);
		        }
		        else {
		            return false;
		        }
		    };
		    ;
		    ConnectionManager.prototype.disconnect = function () {
		        this.disconnectInternally();
		        this.updateState("disconnected");
		    };
		    ;
		    ConnectionManager.prototype.isEncrypted = function () {
		        return this.encrypted;
		    };
		    ;
		    ConnectionManager.prototype.startConnecting = function () {
		        var _this = this;
		        var callback = function (error, handshake) {
		            if (error) {
		                _this.runner = _this.strategy.connect(0, callback);
		            }
		            else {
		                if (handshake.action === "error") {
		                    _this.emit("error", { type: "HandshakeError", error: handshake.error });
		                    _this.timeline.error({ handshakeError: handshake.error });
		                }
		                else {
		                    _this.abortConnecting();
		                    _this.handshakeCallbacks[handshake.action](handshake);
		                }
		            }
		        };
		        this.runner = this.strategy.connect(0, callback);
		    };
		    ;
		    ConnectionManager.prototype.abortConnecting = function () {
		        if (this.runner) {
		            this.runner.abort();
		            this.runner = null;
		        }
		    };
		    ;
		    ConnectionManager.prototype.disconnectInternally = function () {
		        this.abortConnecting();
		        this.clearRetryTimer();
		        this.clearUnavailableTimer();
		        if (this.connection) {
		            var connection = this.abandonConnection();
		            connection.close();
		        }
		    };
		    ;
		    ConnectionManager.prototype.updateStrategy = function () {
		        this.strategy = this.options.getStrategy({
		            key: this.key,
		            timeline: this.timeline,
		            encrypted: this.encrypted
		        });
		    };
		    ;
		    ConnectionManager.prototype.retryIn = function (delay) {
		        var _this = this;
		        this.timeline.info({ action: "retry", delay: delay });
		        if (delay > 0) {
		            this.emit("connecting_in", Math.round(delay / 1000));
		        }
		        this.retryTimer = new timers_1.OneOffTimer(delay || 0, function () {
		            _this.disconnectInternally();
		            _this.connect();
		        });
		    };
		    ;
		    ConnectionManager.prototype.clearRetryTimer = function () {
		        if (this.retryTimer) {
		            this.retryTimer.ensureAborted();
		            this.retryTimer = null;
		        }
		    };
		    ;
		    ConnectionManager.prototype.setUnavailableTimer = function () {
		        var _this = this;
		        this.unavailableTimer = new timers_1.OneOffTimer(this.options.unavailableTimeout, function () {
		            _this.updateState("unavailable");
		        });
		    };
		    ;
		    ConnectionManager.prototype.clearUnavailableTimer = function () {
		        if (this.unavailableTimer) {
		            this.unavailableTimer.ensureAborted();
		        }
		    };
		    ;
		    ConnectionManager.prototype.sendActivityCheck = function () {
		        var _this = this;
		        this.stopActivityCheck();
		        this.connection.ping();
		        this.activityTimer = new timers_1.OneOffTimer(this.options.pongTimeout, function () {
		            _this.timeline.error({ pong_timed_out: _this.options.pongTimeout });
		            _this.retryIn(0);
		        });
		    };
		    ;
		    ConnectionManager.prototype.resetActivityCheck = function () {
		        var _this = this;
		        this.stopActivityCheck();
		        if (!this.connection.handlesActivityChecks()) {
		            this.activityTimer = new timers_1.OneOffTimer(this.activityTimeout, function () {
		                _this.sendActivityCheck();
		            });
		        }
		    };
		    ;
		    ConnectionManager.prototype.stopActivityCheck = function () {
		        if (this.activityTimer) {
		            this.activityTimer.ensureAborted();
		        }
		    };
		    ;
		    ConnectionManager.prototype.buildConnectionCallbacks = function () {
		        var _this = this;
		        return {
		            message: function (message) {
		                _this.resetActivityCheck();
		                _this.emit('message', message);
		            },
		            ping: function () {
		                _this.send_event('pusher:pong', {});
		            },
		            activity: function () {
		                _this.resetActivityCheck();
		            },
		            error: function (error) {
		                _this.emit("error", { type: "WebSocketError", error: error });
		            },
		            closed: function () {
		                _this.abandonConnection();
		                if (_this.shouldRetry()) {
		                    _this.retryIn(1000);
		                }
		            }
		        };
		    };
		    ;
		    ConnectionManager.prototype.buildHandshakeCallbacks = function (errorCallbacks) {
		        var _this = this;
		        return Collections.extend({}, errorCallbacks, {
		            connected: function (handshake) {
		                _this.activityTimeout = Math.min(_this.options.activityTimeout, handshake.activityTimeout, handshake.connection.activityTimeout || Infinity);
		                _this.clearUnavailableTimer();
		                _this.setConnection(handshake.connection);
		                _this.socket_id = _this.connection.id;
		                _this.updateState("connected", { socket_id: _this.socket_id });
		            }
		        });
		    };
		    ;
		    ConnectionManager.prototype.buildErrorCallbacks = function () {
		        var _this = this;
		        var withErrorEmitted = function (callback) {
		            return function (result) {
		                if (result.error) {
		                    _this.emit("error", { type: "WebSocketError", error: result.error });
		                }
		                callback(result);
		            };
		        };
		        return {
		            ssl_only: withErrorEmitted(function () {
		                _this.encrypted = true;
		                _this.updateStrategy();
		                _this.retryIn(0);
		            }),
		            refused: withErrorEmitted(function () {
		                _this.disconnect();
		            }),
		            backoff: withErrorEmitted(function () {
		                _this.retryIn(1000);
		            }),
		            retry: withErrorEmitted(function () {
		                _this.retryIn(0);
		            })
		        };
		    };
		    ;
		    ConnectionManager.prototype.setConnection = function (connection) {
		        this.connection = connection;
		        for (var event in this.connectionCallbacks) {
		            this.connection.bind(event, this.connectionCallbacks[event]);
		        }
		        this.resetActivityCheck();
		    };
		    ;
		    ConnectionManager.prototype.abandonConnection = function () {
		        if (!this.connection) {
		            return;
		        }
		        this.stopActivityCheck();
		        for (var event in this.connectionCallbacks) {
		            this.connection.unbind(event, this.connectionCallbacks[event]);
		        }
		        var connection = this.connection;
		        this.connection = null;
		        return connection;
		    };
		    ConnectionManager.prototype.updateState = function (newState, data) {
		        var previousState = this.state;
		        this.state = newState;
		        if (previousState !== newState) {
		            var newStateDescription = newState;
		            if (newStateDescription === "connected") {
		                newStateDescription += " with new socket ID " + data.socket_id;
		            }
		            logger_1["default"].debug('State changed', previousState + ' -> ' + newStateDescription);
		            this.timeline.info({ state: newState, params: data });
		            this.emit('state_change', { previous: previousState, current: newState });
		            this.emit(newState, data);
		        }
		    };
		    ConnectionManager.prototype.shouldRetry = function () {
		        return this.state === "connecting" || this.state === "connected";
		    };
		    return ConnectionManager;
		}(dispatcher_1["default"]));
		exports.__esModule = true;
		exports["default"] = ConnectionManager;
	
	
	/***/ },
	/* 54 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var Collections = __webpack_require__(9);
		var factory_1 = __webpack_require__(42);
		var Channels = (function () {
		    function Channels() {
		        this.channels = {};
		    }
		    Channels.prototype.add = function (name, pusher) {
		        if (!this.channels[name]) {
		            this.channels[name] = createChannel(name, pusher);
		        }
		        return this.channels[name];
		    };
		    Channels.prototype.all = function () {
		        return Collections.values(this.channels);
		    };
		    Channels.prototype.find = function (name) {
		        return this.channels[name];
		    };
		    Channels.prototype.remove = function (name) {
		        var channel = this.channels[name];
		        delete this.channels[name];
		        return channel;
		    };
		    Channels.prototype.disconnect = function () {
		        Collections.objectApply(this.channels, function (channel) {
		            channel.disconnect();
		        });
		    };
		    return Channels;
		}());
		exports.__esModule = true;
		exports["default"] = Channels;
		function createChannel(name, pusher) {
		    if (name.indexOf('private-') === 0) {
		        return factory_1["default"].createPrivateChannel(name, pusher);
		    }
		    else if (name.indexOf('presence-') === 0) {
		        return factory_1["default"].createPresenceChannel(name, pusher);
		    }
		    else {
		        return factory_1["default"].createChannel(name, pusher);
		    }
		}
	
	
	/***/ },
	/* 55 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var factory_1 = __webpack_require__(42);
		var util_1 = __webpack_require__(11);
		var Errors = __webpack_require__(30);
		var Collections = __webpack_require__(9);
		var TransportStrategy = (function () {
		    function TransportStrategy(name, priority, transport, options) {
		        this.name = name;
		        this.priority = priority;
		        this.transport = transport;
		        this.options = options || {};
		    }
		    TransportStrategy.prototype.isSupported = function () {
		        return this.transport.isSupported({
		            encrypted: this.options.encrypted
		        });
		    };
		    TransportStrategy.prototype.connect = function (minPriority, callback) {
		        var _this = this;
		        if (!this.isSupported()) {
		            return failAttempt(new Errors.UnsupportedStrategy(), callback);
		        }
		        else if (this.priority < minPriority) {
		            return failAttempt(new Errors.TransportPriorityTooLow(), callback);
		        }
		        var connected = false;
		        var transport = this.transport.createConnection(this.name, this.priority, this.options.key, this.options);
		        var handshake = null;
		        var onInitialized = function () {
		            transport.unbind("initialized", onInitialized);
		            transport.connect();
		        };
		        var onOpen = function () {
		            handshake = factory_1["default"].createHandshake(transport, function (result) {
		                connected = true;
		                unbindListeners();
		                callback(null, result);
		            });
		        };
		        var onError = function (error) {
		            unbindListeners();
		            callback(error);
		        };
		        var onClosed = function () {
		            unbindListeners();
		            var serializedTransport;
		            serializedTransport = Collections.safeJSONStringify(transport);
		            callback(new Errors.TransportClosed(serializedTransport));
		        };
		        var unbindListeners = function () {
		            transport.unbind("initialized", onInitialized);
		            transport.unbind("open", onOpen);
		            transport.unbind("error", onError);
		            transport.unbind("closed", onClosed);
		        };
		        transport.bind("initialized", onInitialized);
		        transport.bind("open", onOpen);
		        transport.bind("error", onError);
		        transport.bind("closed", onClosed);
		        transport.initialize();
		        return {
		            abort: function () {
		                if (connected) {
		                    return;
		                }
		                unbindListeners();
		                if (handshake) {
		                    handshake.close();
		                }
		                else {
		                    transport.close();
		                }
		            },
		            forceMinPriority: function (p) {
		                if (connected) {
		                    return;
		                }
		                if (_this.priority < p) {
		                    if (handshake) {
		                        handshake.close();
		                    }
		                    else {
		                        transport.close();
		                    }
		                }
		            }
		        };
		    };
		    return TransportStrategy;
		}());
		exports.__esModule = true;
		exports["default"] = TransportStrategy;
		function failAttempt(error, callback) {
		    util_1["default"].defer(function () {
		        callback(error);
		    });
		    return {
		        abort: function () { },
		        forceMinPriority: function () { }
		    };
		}
	
	
	/***/ },
	/* 56 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var Collections = __webpack_require__(9);
		var util_1 = __webpack_require__(11);
		var timers_1 = __webpack_require__(12);
		var SequentialStrategy = (function () {
		    function SequentialStrategy(strategies, options) {
		        this.strategies = strategies;
		        this.loop = Boolean(options.loop);
		        this.failFast = Boolean(options.failFast);
		        this.timeout = options.timeout;
		        this.timeoutLimit = options.timeoutLimit;
		    }
		    SequentialStrategy.prototype.isSupported = function () {
		        return Collections.any(this.strategies, util_1["default"].method("isSupported"));
		    };
		    SequentialStrategy.prototype.connect = function (minPriority, callback) {
		        var _this = this;
		        var strategies = this.strategies;
		        var current = 0;
		        var timeout = this.timeout;
		        var runner = null;
		        var tryNextStrategy = function (error, handshake) {
		            if (handshake) {
		                callback(null, handshake);
		            }
		            else {
		                current = current + 1;
		                if (_this.loop) {
		                    current = current % strategies.length;
		                }
		                if (current < strategies.length) {
		                    if (timeout) {
		                        timeout = timeout * 2;
		                        if (_this.timeoutLimit) {
		                            timeout = Math.min(timeout, _this.timeoutLimit);
		                        }
		                    }
		                    runner = _this.tryStrategy(strategies[current], minPriority, { timeout: timeout, failFast: _this.failFast }, tryNextStrategy);
		                }
		                else {
		                    callback(true);
		                }
		            }
		        };
		        runner = this.tryStrategy(strategies[current], minPriority, { timeout: timeout, failFast: this.failFast }, tryNextStrategy);
		        return {
		            abort: function () {
		                runner.abort();
		            },
		            forceMinPriority: function (p) {
		                minPriority = p;
		                if (runner) {
		                    runner.forceMinPriority(p);
		                }
		            }
		        };
		    };
		    SequentialStrategy.prototype.tryStrategy = function (strategy, minPriority, options, callback) {
		        var timer = null;
		        var runner = null;
		        if (options.timeout > 0) {
		            timer = new timers_1.OneOffTimer(options.timeout, function () {
		                runner.abort();
		                callback(true);
		            });
		        }
		        runner = strategy.connect(minPriority, function (error, handshake) {
		            if (error && timer && timer.isRunning() && !options.failFast) {
		                return;
		            }
		            if (timer) {
		                timer.ensureAborted();
		            }
		            callback(error, handshake);
		        });
		        return {
		            abort: function () {
		                if (timer) {
		                    timer.ensureAborted();
		                }
		                runner.abort();
		            },
		            forceMinPriority: function (p) {
		                runner.forceMinPriority(p);
		            }
		        };
		    };
		    return SequentialStrategy;
		}());
		exports.__esModule = true;
		exports["default"] = SequentialStrategy;
	
	
	/***/ },
	/* 57 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var Collections = __webpack_require__(9);
		var util_1 = __webpack_require__(11);
		var BestConnectedEverStrategy = (function () {
		    function BestConnectedEverStrategy(strategies) {
		        this.strategies = strategies;
		    }
		    BestConnectedEverStrategy.prototype.isSupported = function () {
		        return Collections.any(this.strategies, util_1["default"].method("isSupported"));
		    };
		    BestConnectedEverStrategy.prototype.connect = function (minPriority, callback) {
		        return connect(this.strategies, minPriority, function (i, runners) {
		            return function (error, handshake) {
		                runners[i].error = error;
		                if (error) {
		                    if (allRunnersFailed(runners)) {
		                        callback(true);
		                    }
		                    return;
		                }
		                Collections.apply(runners, function (runner) {
		                    runner.forceMinPriority(handshake.transport.priority);
		                });
		                callback(null, handshake);
		            };
		        });
		    };
		    return BestConnectedEverStrategy;
		}());
		exports.__esModule = true;
		exports["default"] = BestConnectedEverStrategy;
		function connect(strategies, minPriority, callbackBuilder) {
		    var runners = Collections.map(strategies, function (strategy, i, _, rs) {
		        return strategy.connect(minPriority, callbackBuilder(i, rs));
		    });
		    return {
		        abort: function () {
		            Collections.apply(runners, abortRunner);
		        },
		        forceMinPriority: function (p) {
		            Collections.apply(runners, function (runner) {
		                runner.forceMinPriority(p);
		            });
		        }
		    };
		}
		function allRunnersFailed(runners) {
		    return Collections.all(runners, function (runner) {
		        return Boolean(runner.error);
		    });
		}
		function abortRunner(runner) {
		    if (!runner.error && !runner.aborted) {
		        runner.abort();
		        runner.aborted = true;
		    }
		}
	
	
	/***/ },
	/* 58 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var util_1 = __webpack_require__(11);
		var runtime_1 = __webpack_require__(2);
		var sequential_strategy_1 = __webpack_require__(56);
		var Collections = __webpack_require__(9);
		var CachedStrategy = (function () {
		    function CachedStrategy(strategy, transports, options) {
		        this.strategy = strategy;
		        this.transports = transports;
		        this.ttl = options.ttl || 1800 * 1000;
		        this.encrypted = options.encrypted;
		        this.timeline = options.timeline;
		    }
		    CachedStrategy.prototype.isSupported = function () {
		        return this.strategy.isSupported();
		    };
		    CachedStrategy.prototype.connect = function (minPriority, callback) {
		        var encrypted = this.encrypted;
		        var info = fetchTransportCache(encrypted);
		        var strategies = [this.strategy];
		        if (info && info.timestamp + this.ttl >= util_1["default"].now()) {
		            var transport = this.transports[info.transport];
		            if (transport) {
		                this.timeline.info({
		                    cached: true,
		                    transport: info.transport,
		                    latency: info.latency
		                });
		                strategies.push(new sequential_strategy_1["default"]([transport], {
		                    timeout: info.latency * 2 + 1000,
		                    failFast: true
		                }));
		            }
		        }
		        var startTimestamp = util_1["default"].now();
		        var runner = strategies.pop().connect(minPriority, function cb(error, handshake) {
		            if (error) {
		                flushTransportCache(encrypted);
		                if (strategies.length > 0) {
		                    startTimestamp = util_1["default"].now();
		                    runner = strategies.pop().connect(minPriority, cb);
		                }
		                else {
		                    callback(error);
		                }
		            }
		            else {
		                storeTransportCache(encrypted, handshake.transport.name, util_1["default"].now() - startTimestamp);
		                callback(null, handshake);
		            }
		        });
		        return {
		            abort: function () {
		                runner.abort();
		            },
		            forceMinPriority: function (p) {
		                minPriority = p;
		                if (runner) {
		                    runner.forceMinPriority(p);
		                }
		            }
		        };
		    };
		    return CachedStrategy;
		}());
		exports.__esModule = true;
		exports["default"] = CachedStrategy;
		function getTransportCacheKey(encrypted) {
		    return "pusherTransport" + (encrypted ? "Encrypted" : "Unencrypted");
		}
		function fetchTransportCache(encrypted) {
		    var storage = runtime_1["default"].getLocalStorage();
		    if (storage) {
		        try {
		            var serializedCache = storage[getTransportCacheKey(encrypted)];
		            if (serializedCache) {
		                return JSON.parse(serializedCache);
		            }
		        }
		        catch (e) {
		            flushTransportCache(encrypted);
		        }
		    }
		    return null;
		}
		function storeTransportCache(encrypted, transport, latency) {
		    var storage = runtime_1["default"].getLocalStorage();
		    if (storage) {
		        try {
		            storage[getTransportCacheKey(encrypted)] = Collections.safeJSONStringify({
		                timestamp: util_1["default"].now(),
		                transport: transport,
		                latency: latency
		            });
		        }
		        catch (e) {
		        }
		    }
		}
		function flushTransportCache(encrypted) {
		    var storage = runtime_1["default"].getLocalStorage();
		    if (storage) {
		        try {
		            delete storage[getTransportCacheKey(encrypted)];
		        }
		        catch (e) {
		        }
		    }
		}
	
	
	/***/ },
	/* 59 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var timers_1 = __webpack_require__(12);
		var DelayedStrategy = (function () {
		    function DelayedStrategy(strategy, _a) {
		        var number = _a.delay;
		        this.strategy = strategy;
		        this.options = { delay: number };
		    }
		    DelayedStrategy.prototype.isSupported = function () {
		        return this.strategy.isSupported();
		    };
		    DelayedStrategy.prototype.connect = function (minPriority, callback) {
		        var strategy = this.strategy;
		        var runner;
		        var timer = new timers_1.OneOffTimer(this.options.delay, function () {
		            runner = strategy.connect(minPriority, callback);
		        });
		        return {
		            abort: function () {
		                timer.ensureAborted();
		                if (runner) {
		                    runner.abort();
		                }
		            },
		            forceMinPriority: function (p) {
		                minPriority = p;
		                if (runner) {
		                    runner.forceMinPriority(p);
		                }
		            }
		        };
		    };
		    return DelayedStrategy;
		}());
		exports.__esModule = true;
		exports["default"] = DelayedStrategy;
	
	
	/***/ },
	/* 60 */
	/***/ function(module, exports) {
	
		"use strict";
		var IfStrategy = (function () {
		    function IfStrategy(test, trueBranch, falseBranch) {
		        this.test = test;
		        this.trueBranch = trueBranch;
		        this.falseBranch = falseBranch;
		    }
		    IfStrategy.prototype.isSupported = function () {
		        var branch = this.test() ? this.trueBranch : this.falseBranch;
		        return branch.isSupported();
		    };
		    IfStrategy.prototype.connect = function (minPriority, callback) {
		        var branch = this.test() ? this.trueBranch : this.falseBranch;
		        return branch.connect(minPriority, callback);
		    };
		    return IfStrategy;
		}());
		exports.__esModule = true;
		exports["default"] = IfStrategy;
	
	
	/***/ },
	/* 61 */
	/***/ function(module, exports) {
	
		"use strict";
		var FirstConnectedStrategy = (function () {
		    function FirstConnectedStrategy(strategy) {
		        this.strategy = strategy;
		    }
		    FirstConnectedStrategy.prototype.isSupported = function () {
		        return this.strategy.isSupported();
		    };
		    FirstConnectedStrategy.prototype.connect = function (minPriority, callback) {
		        var runner = this.strategy.connect(minPriority, function (error, handshake) {
		            if (handshake) {
		                runner.abort();
		            }
		            callback(error, handshake);
		        });
		        return runner;
		    };
		    return FirstConnectedStrategy;
		}());
		exports.__esModule = true;
		exports["default"] = FirstConnectedStrategy;
	
	
	/***/ },
	/* 62 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var defaults_1 = __webpack_require__(5);
		exports.getGlobalConfig = function () {
		    return {
		        wsHost: defaults_1["default"].host,
		        wsPort: defaults_1["default"].ws_port,
		        wssPort: defaults_1["default"].wss_port,
		        httpHost: defaults_1["default"].sockjs_host,
		        httpPort: defaults_1["default"].sockjs_http_port,
		        httpsPort: defaults_1["default"].sockjs_https_port,
		        httpPath: defaults_1["default"].sockjs_path,
		        statsHost: defaults_1["default"].stats_host,
		        authEndpoint: defaults_1["default"].channel_auth_endpoint,
		        authTransport: defaults_1["default"].channel_auth_transport,
		        activity_timeout: defaults_1["default"].activity_timeout,
		        pong_timeout: defaults_1["default"].pong_timeout,
		        unavailable_timeout: defaults_1["default"].unavailable_timeout
		    };
		};
		exports.getClusterConfig = function (clusterName) {
		    return {
		        wsHost: "ws-" + clusterName + ".pusher.com",
		        httpHost: "sockjs-" + clusterName + ".pusher.com"
		    };
		};
	
	
	/***/ }
	/******/ ])
	});
	;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.promiseSettings = promiseSettings;
	exports.promiseAppData = promiseAppData;
	exports.promiseDataIfSignedIn = promiseDataIfSignedIn;
	
	var _ActivityActions = __webpack_require__(976);
	
	var _ActivityActions2 = _interopRequireDefault(_ActivityActions);
	
	var _ActivityStore = __webpack_require__(983);
	
	var _ActivityStore2 = _interopRequireDefault(_ActivityStore);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _DeviceStore = __webpack_require__(1019);
	
	var _DeviceStore2 = _interopRequireDefault(_DeviceStore);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _LeadActions = __webpack_require__(1021);
	
	var _LeadActions2 = _interopRequireDefault(_LeadActions);
	
	var _Leads = __webpack_require__(1023);
	
	var _Leads2 = _interopRequireDefault(_Leads);
	
	var _LeadStore = __webpack_require__(1024);
	
	var _LeadStore2 = _interopRequireDefault(_LeadStore);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _SettingsActions = __webpack_require__(1025);
	
	var _SettingsActions2 = _interopRequireDefault(_SettingsActions);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _UnreadActions = __webpack_require__(1026);
	
	var _UnreadActions2 = _interopRequireDefault(_UnreadActions);
	
	var _UnreadStore = __webpack_require__(1030);
	
	var _UnreadStore2 = _interopRequireDefault(_UnreadStore);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _RootGroup = __webpack_require__(943);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function promiseGroups() {
	  if (_GroupStore2.default.isLoaded()) {
	    return Promise.resolve();
	  } else {
	    return _GroupActions2.default.loadGroups().catch(function (error) {
	      if (error && error.code === 'information_required') {
	        console.warn('promiseGroups information_required', error);
	      } else {
	        console.warn(error, error.stack);
	        console.error('promiseGroups failure');
	      }
	    });
	  }
	}
	
	
	function promiseLeads() {
	  if (_LeadStore2.default.isLoaded()) {
	    return Promise.resolve();
	  } else {
	    return _LeadActions2.default.loadLeads()
	    // could get a 404 error trying to load in a new account
	    .catch(function (error) {
	      return console.warn(error);
	    });
	  }
	}
	
	function promiseSettings() {
	  if (_SettingsStore2.default.isLoaded()) {
	    return Promise.resolve();
	  } else {
	    // then to return void
	    return _SettingsActions2.default.loadSettings().then(function () {});
	  }
	}
	
	var promiseBlockingData = function promiseBlockingData() {
	  return Promise.all([promiseGroups(), promiseLeads(), promiseSettings(), _OrganizationStore2.default.isLoaded() ? null : _OrganizationActions2.default.loadUserOrganizations(), _DeviceStore2.default.isLoaded() ? null : _DeviceActions2.default.loadDevices()]);
	};
	
	function promiseAppData(user) {
	  if (!user.completedSetup()) {
	    // most components assume this was already loaded
	    return promiseSettings();
	  }
	
	  // kick these off async since it's not strictly necessary for boot
	  if (_ChatStore2.default.getChats(_RootGroup.rootGroup).isEmpty()) {
	    _ChatActions2.default.loadChats(_RootGroup.rootGroup);
	  }
	  if (_UnreadStore2.default.getUnreads().isEmpty()) {
	    _UnreadActions2.default.loadUnreads();
	  }
	  if (_ActivityStore2.default.getActivities().isEmpty()) {
	    _ActivityActions2.default.load();
	  }
	  return promiseBlockingData().then(function () {});
	}
	
	function promiseDataIfSignedIn() {
	  if (_CurrentUser2.default.isSignedIn()) {
	    return promiseAppData(_CurrentUser2.default.getUser());
	  } else {
	    return Promise.resolve();
	  }
	}

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dispatcher = __webpack_require__(590);
	
	var _ActivityConstants = __webpack_require__(977);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _Activities = __webpack_require__(978);
	
	var actions = _interopRequireWildcard(_Activities);
	
	var _Activities2 = __webpack_require__(980);
	
	var _Activities3 = _interopRequireDefault(_Activities2);
	
	var _Transactions = __webpack_require__(981);
	
	var _Transactions2 = _interopRequireDefault(_Transactions);
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActivityActions = {
	  create: function create(params) {
	    return _Activity2.default.create(params).then(function (activity) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ActivityConstants.ActionTypes.CREATE_ACTIVITY,
	        activity: activity
	      });
	
	      return activity;
	    });
	  },
	  edit: function edit(params) {
	    return _Activity2.default.edit(params).then(function (editedActivity) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ActivityConstants.ActionTypes.EDIT_ACTIVITY,
	        activity: editedActivity
	      });
	
	      return editedActivity;
	    });
	  },
	  close: function close(activityToClose) {
	    return activityToClose.close().then(function (activity) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ActivityConstants.ActionTypes.CLOSE_ACTIVITY,
	        activity: activity
	      });
	      return activity;
	    });
	  },
	  load: function load() {
	    return _Activities3.default.load().then(function (activities) {
	      // flux
	      _Dispatcher.dispatcher.dispatch({
	        type: _ActivityConstants.ActionTypes.LOAD_ACTIVITIES,
	        activities: activities
	      });
	
	      // activity store is still flux, dispatch redux action too.
	      // activityRecipient redux store listens to this.
	      _Dispatcher.reduxDispatcher.dispatch(actions.loadActivitiesSuccess(activities));
	    });
	  },
	  loadByUuid: function loadByUuid(uuid) {
	    return _Activity2.default.findByUuid(uuid).then(function (activity) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ActivityConstants.ActionTypes.LOAD_ACTIVITY,
	        activity: activity
	      });
	      return activity;
	    });
	  },
	  getTransactions: function getTransactions(activityId) {
	    return _RemindAPI2.default.request('/activities/' + activityId + '/transactions', 'GET').then(function (response) {
	      var transactions = _Transactions2.default.fromJSON(response['transactions']);
	
	      _Dispatcher.dispatcher.dispatch({
	        type: _ActivityConstants.ActionTypes.GET_TRANSACTIONS,
	        transactions: transactions,
	        activityId: activityId
	      });
	
	      return transactions;
	    });
	  }
	};
	// typecheck: ignore file
	exports.default = ActivityActions;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['CREATE_ACTIVITY', 'EDIT_ACTIVITY', 'CLOSE_ACTIVITY', 'LOAD_ACTIVITIES', 'LOAD_ACTIVITY', 'GET_TRANSACTIONS', 'GET_RECIPIENTS', 'UPDATE_RSVP']); /*  weak */

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadActivitiesSuccess = loadActivitiesSuccess;
	exports.reducer = reducer;
	
	var _TransactionConstants = __webpack_require__(979);
	
	var _ActivityConstants = __webpack_require__(977);
	
	var _Activities = __webpack_require__(980);
	
	var _Activities2 = _interopRequireDefault(_Activities);
	
	var _Transactions = __webpack_require__(981);
	
	var _Transactions2 = _interopRequireDefault(_Transactions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  activities: new _Activities2.default(),
	  transactions: {}
	};
	
	function loadActivitiesSuccess(activities) {
	  return {
	    type: 'activities/LOAD_ACTIVITIES_SUCCESS',
	    activities: activities
	  };
	}
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var activities = void 0;
	  var transactions = void 0;
	
	  switch (action.type) {
	    case _ActivityConstants.ActionTypes.LOAD_ACTIVITIES:
	      activities = new _Activities2.default(state.activities.toJSON());
	      activities.add(action.activities.models);
	      return _extends({}, state, { activities: activities });
	
	    case _ActivityConstants.ActionTypes.CREATE_ACTIVITY:
	    case _ActivityConstants.ActionTypes.LOAD_ACTIVITY:
	    case _ActivityConstants.ActionTypes.EDIT_ACTIVITY:
	    case _ActivityConstants.ActionTypes.CLOSE_ACTIVITY:
	      activities = new _Activities2.default(state.activities.toJSON());
	      activities.add(action.activity);
	      return _extends({}, state, { activities: activities });
	
	    case _TransactionConstants.ActionTypes.CREATE_ACTIVITY_WITHDRAW_TRANSACTION:
	      {
	        var act = action.activityId;
	        transactions = state.transactions;
	
	        transactions[act] = transactions[act] ? new _Transactions2.default(transactions[act].toJSON()) : new _Transactions2.default();
	        transactions[act].add(action.transaction);
	
	        return _extends({}, state, { transactions: transactions });
	      }
	
	    case _ActivityConstants.ActionTypes.GET_TRANSACTIONS:
	      transactions = state.transactions;
	      transactions[action.activityId] = action.transactions;
	      return _extends({}, state, { transactions: transactions });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['CLAIM_TRANSACTION', 'CREATE_ACTIVITY_WITHDRAW_TRANSACTION', 'CREATE_TRANSACTION', 'LOAD_TRANSACTIONS']); /*  weak */

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Activities = function (_Collection) {
	  _inherits(Activities, _Collection);
	
	  function Activities() {
	    _classCallCheck(this, Activities);
	
	    return _possibleConstructorReturn(this, (Activities.__proto__ || Object.getPrototypeOf(Activities)).apply(this, arguments));
	  }
	
	  _createClass(Activities, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _Activity2.default;
	      this.comparator = function (a, b) {
	        return b.getCreatedAt() - a.getCreatedAt();
	      };
	    }
	  }], [{
	    key: 'loadReceived',
	    value: function loadReceived() {
	      return (0, _apiRequest2.default)('/activities/received', 'GET').then(function (activities) {
	        return Activities.fromJSON(activities);
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load() {
	      return (0, _apiRequest2.default)('/activities', 'GET').then(function (response) {
	        return Activities.fromJSON(response.activities);
	      });
	    }
	  }]);
	
	  return Activities;
	}(_Collection3.default);
	
	Activities.displayName = 'Activities';
	exports.default = Activities;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _Transaction = __webpack_require__(982);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Transactions = function (_Collection) {
	  _inherits(Transactions, _Collection);
	
	  function Transactions() {
	    _classCallCheck(this, Transactions);
	
	    return _possibleConstructorReturn(this, (Transactions.__proto__ || Object.getPrototypeOf(Transactions)).apply(this, arguments));
	  }
	
	  _createClass(Transactions, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _Transaction2.default;
	      this.comparator = function (a, b) {
	        return b.getCreatedAt() - a.getCreatedAt();
	      };
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      return response.map(function (transaction) {
	        return _Transaction2.default.fromJSON(transaction);
	      });
	    }
	  }], [{
	    key: 'loadChargeTransactions',
	    value: function loadChargeTransactions() {
	      return (0, _apiRequest2.default)('/payments/charges', 'GET').then(function (transactions) {
	        return Transactions.fromJSON(transactions);
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load() {
	      return (0, _apiRequest2.default)('/payments/transactions', 'GET').then(function (transactions) {
	        return Transactions.fromJSON(transactions);
	      });
	    }
	  }]);
	
	  return Transactions;
	}(_Collection3.default);
	
	Transactions.displayName = 'Transactions';
	exports.default = Transactions;

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.STATUS_PENDING = exports.TYPE_REFUND_SENT = exports.TYPE_PAYMENT_RECEIVED = exports.TYPE_PAYMENT_SENT = exports.TYPE_WITHDRAWAL = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _RelatedUserSummary = __webpack_require__(909);
	
	var _RelatedUserSummary2 = _interopRequireDefault(_RelatedUserSummary);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TYPE_WITHDRAWAL = exports.TYPE_WITHDRAWAL = 'withdrawal';
	var TYPE_PAYMENT_SENT = exports.TYPE_PAYMENT_SENT = 'payment_sent';
	var TYPE_PAYMENT_RECEIVED = exports.TYPE_PAYMENT_RECEIVED = 'payment_received';
	var TYPE_REFUND_SENT = exports.TYPE_REFUND_SENT = 'refund_sent';
	
	var STATUS_PENDING = exports.STATUS_PENDING = 'pending';
	
	var Transaction = function (_Entity) {
	  _inherits(Transaction, _Entity);
	
	  function Transaction() {
	    _classCallCheck(this, Transaction);
	
	    return _possibleConstructorReturn(this, (Transaction.__proto__ || Object.getPrototypeOf(Transaction)).apply(this, arguments));
	  }
	
	  _createClass(Transaction, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.idAttribute = 'uuid';
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        amount_per_person: 0,
	        application_fee: 2,
	        charge_id: '',
	        payment_made_for: '',
	        payment_req_note: '',
	        transfer_id: '',
	        type: TYPE_PAYMENT_SENT
	      };
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var transaction = (0, _lodash.cloneDeep)(response);
	
	      if ('created_at' in transaction) {
	        transaction['created_at'] = new Date(transaction['created_at']);
	      }
	
	      if ('activity' in transaction) {
	        transaction['activity'] = new _Activity2.default(transaction['activity']);
	      }
	
	      if ('paid_to' in transaction) {
	        transaction['paid_to'] = new _RelatedUserSummary2.default(transaction['paid_to']);
	      }
	
	      if ('payer' in transaction) {
	        transaction['payer'] = new _RelatedUserSummary2.default(transaction['payer']);
	      }
	
	      if ('available_at' in transaction) {
	        transaction['available_at'] = new Date(transaction['available_at']);
	      }
	
	      return transaction;
	    }
	
	    // Indicates if the transaction is made by a user with no Remind account
	
	  }, {
	    key: 'isByAnonymousUser',
	    value: function isByAnonymousUser() {
	      return !(this.get('user_uuid') || this.get('unverified_user_uuid'));
	    }
	  }, {
	    key: 'isWithdrawal',
	    value: function isWithdrawal() {
	      return this.getType() === TYPE_WITHDRAWAL;
	    }
	  }, {
	    key: 'isPaymentSent',
	    value: function isPaymentSent() {
	      return this.getType() === TYPE_PAYMENT_SENT;
	    }
	  }, {
	    key: 'isRefundSent',
	    value: function isRefundSent() {
	      return this.getType() === TYPE_REFUND_SENT;
	    }
	  }, {
	    key: 'isRefundable',
	    value: function isRefundable() {
	      return !!this.get('refundable');
	    }
	  }, {
	    key: 'isPaymentReceived',
	    value: function isPaymentReceived() {
	      return this.getType() === TYPE_PAYMENT_RECEIVED;
	    }
	  }, {
	    key: 'isPending',
	    value: function isPending() {
	      return this.getStatus() === STATUS_PENDING;
	    }
	  }, {
	    key: 'getStatus',
	    value: function getStatus() {
	      return this.get('status');
	    }
	  }, {
	    key: 'getUuid',
	    value: function getUuid() {
	      return this.get('uuid');
	    }
	  }, {
	    key: 'getAmount',
	    value: function getAmount() {
	      return this.get('amount');
	    }
	  }, {
	    key: 'getRefundedTransactionUUID',
	    value: function getRefundedTransactionUUID() {
	      return this.get('refunded_transaction_uuid');
	    }
	  }, {
	    key: 'getApplicationFee',
	    value: function getApplicationFee() {
	      return this.get('application_fee');
	    }
	  }, {
	    key: 'getChargeId',
	    value: function getChargeId() {
	      return this.get('charge_id');
	    }
	  }, {
	    key: 'getCreatedAt',
	    value: function getCreatedAt() {
	      return this.get('created_at');
	    }
	  }, {
	    key: 'getAddress',
	    value: function getAddress() {
	      return this.get('address');
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }, {
	    key: 'getPaidToUserUuid',
	    value: function getPaidToUserUuid() {
	      return this.get('paid_to_user_uuid');
	    }
	  }, {
	    key: 'getPayer',
	    value: function getPayer() {
	      return this.get('payer');
	    }
	  }, {
	    key: 'getPaymentMadeFor',
	    value: function getPaymentMadeFor() {
	      return this.get('payment_made_for');
	    }
	  }, {
	    key: 'getPaymentReqNote',
	    value: function getPaymentReqNote() {
	      return this.get('payment_req_note');
	    }
	  }, {
	    key: 'getActivity',
	    value: function getActivity() {
	      return this.get('activity');
	    }
	  }, {
	    key: 'getPaidTo',
	    value: function getPaidTo() {
	      return this.get('paid_to');
	    }
	  }, {
	    key: 'getTransferId',
	    value: function getTransferId() {
	      return this.get('transfer_id');
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.get('type');
	    }
	  }, {
	    key: 'getUserUuid',
	    value: function getUserUuid() {
	      return this.get('user_uuid');
	    }
	  }, {
	    key: 'getUnverifiedUserUuid',
	    value: function getUnverifiedUserUuid() {
	      return this.get('unverified_user_uuid');
	    }
	  }, {
	    key: 'getAvailableAt',
	    value: function getAvailableAt() {
	      return this.get('available_at');
	    }
	
	    // $FlowFixMe
	
	  }, {
	    key: 'claim',
	    value: function claim(args) {
	      return (0, _apiRequest2.default)('/payments/transactions/' + this.getUuid() + '/claim', 'POST', args).then(function (transaction) {
	        return Transaction.fromJSON(transaction);
	      });
	    }
	  }], [{
	    key: 'createWithdrawTransaction',
	    value: function createWithdrawTransaction(activityId, destination, amount) {
	      return (0, _apiRequest2.default)('/activities/' + activityId + '/withdraw', 'POST', {
	        destination: destination,
	        amount: amount
	      }).then(function (transaction) {
	        return Transaction.fromJSON(transaction);
	      });
	    }
	  }, {
	    key: 'createPayment',
	    value: function createPayment(activityUUID, paymentMadeFor, amount, token, address, name, recipientUuid) {
	      var card = token.startsWith('card_') ? { card_id: token } : { token: token };
	
	      return (0, _apiRequest2.default)('/activities/' + activityUUID + '/charges', 'POST', {
	        // $FlowFixMe
	        charge: Object.assign(card, {
	          payment_req_uuid: activityUUID,
	          payment_made_for: paymentMadeFor,
	          recipient_uuid: recipientUuid,
	          amount: amount,
	          address: address,
	          name: name
	        })
	      }).then(function (transaction) {
	        return Transaction.fromJSON(transaction);
	      });
	    }
	  }]);
	
	  return Transaction;
	}(_Entity3.default);
	
	Transaction.displayName = 'Transaction';
	exports.default = Transaction;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Dispatcher = __webpack_require__(590);
	
	var _Activities = __webpack_require__(978);
	
	var _utils = __webpack_require__(956);
	
	var _Activities2 = __webpack_require__(980);
	
	var _Activities3 = _interopRequireDefault(_Activities2);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Transactions = __webpack_require__(981);
	
	var _Transactions2 = _interopRequireDefault(_Transactions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityStore = function (_ReduceStore) {
	  _inherits(ActivityStore, _ReduceStore);
	
	  function ActivityStore() {
	    _classCallCheck(this, ActivityStore);
	
	    return _possibleConstructorReturn(this, (ActivityStore.__proto__ || Object.getPrototypeOf(ActivityStore)).apply(this, arguments));
	  }
	
	  _createClass(ActivityStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return _Activities.initialState;
	    }
	  }, {
	    key: 'getActivityById',
	    value: function getActivityById(id) {
	      return this.getState().activities.get(id);
	    }
	  }, {
	    key: 'getTransactionsForActivityUUID',
	    value: function getTransactionsForActivityUUID(activityUUID) {
	      return this.getState().transactions[activityUUID] || new _Transactions2.default();
	    }
	  }, {
	    key: 'getActivityForGroup',
	    value: function getActivityForGroup(group) {
	      return this.getActivities().filter(function (activity) {
	        return activity.isInGroup(group);
	      });
	    }
	  }, {
	    key: 'getOwnedActivities',
	    value: function getOwnedActivities() {
	      return new _Activities3.default(this.getActivities().filter(function (activity) {
	        return activity.isSender();
	      }));
	    }
	  }, {
	    key: 'getUpcomingActivityForGroup',
	    value: function getUpcomingActivityForGroup(group) {
	      var today = new Date();
	
	      return this.getActivityForGroup(group).filter(function (activity) {
	        var startAt = activity.getStartAt();
	        return startAt && startAt > today;
	      });
	    }
	  }, {
	    key: 'getActivities',
	    value: function getActivities() {
	      return this.getState().activities;
	    }
	  }, {
	    key: 'reduce',
	    value: function reduce(state, action) {
	      return (0, _Activities.reducer)(state, action);
	    }
	  }]);
	
	  return ActivityStore;
	}(_utils.ReduceStore);
	
	ActivityStore.displayName = 'ActivityStore';
	exports.default = new ActivityStore(_Dispatcher.dispatcher);

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatMemberStore = __webpack_require__(985);
	
	var _ChatMemberStore2 = _interopRequireDefault(_ChatMemberStore);
	
	var _ChatMessageStore = __webpack_require__(988);
	
	var _ChatMessageStore2 = _interopRequireDefault(_ChatMessageStore);
	
	var _Chats = __webpack_require__(942);
	
	var _Chats2 = _interopRequireDefault(_Chats);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _PotentialChatMember = __webpack_require__(945);
	
	var _PotentialChatMember2 = _interopRequireDefault(_PotentialChatMember);
	
	var _PotentialChatMembers = __webpack_require__(946);
	
	var _PotentialChatMembers2 = _interopRequireDefault(_PotentialChatMembers);
	
	var _AppConstants = __webpack_require__(989);
	
	var _GroupConstants = __webpack_require__(991);
	
	var _LeadConstants = __webpack_require__(1012);
	
	var _RelationshipConstants = __webpack_require__(986);
	
	var _ChatConstants = __webpack_require__(941);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _PusherConstants = __webpack_require__(954);
	
	var _RootGroup = __webpack_require__(943);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatStore = function (_Store) {
	  _inherits(ChatStore, _Store);
	
	  function ChatStore() {
	    _classCallCheck(this, ChatStore);
	
	    return _possibleConstructorReturn(this, (ChatStore.__proto__ || Object.getPrototypeOf(ChatStore)).apply(this, arguments));
	  }
	
	  _createClass(ChatStore, [{
	    key: 'getInitialState',
	
	    // TODO improve some of the filtering logic https://github.com/remind101/r101-frontend/pull/2327#issuecomment-200454662
	    value: function getInitialState() {
	      return {
	        chats: new _Chats2.default(),
	        currentId: null,
	        localChatInstance: null,
	        members: new _PotentialChatMembers2.default(),
	        invalidated: false,
	        allMembersLoaded: false,
	        focusView: null,
	        // Includes chat list and search results
	        chatsAndSearchedChats: new _Chats2.default(),
	        loadedGroups: {}, // whether this group was specifically fetched
	        allChatsLoadedForGroups: {}
	      };
	    }
	  }, {
	    key: 'getChat',
	    value: function getChat(chatId) {
	      return this.state.chats.get(chatId) || this.state.chatsAndSearchedChats.get(chatId);
	    }
	  }, {
	    key: 'getChats',
	    value: function getChats(group) {
	      return this.state.chats.selectChatsInGroup(group);
	    }
	  }, {
	    key: 'getChatsAndSearchedChats',
	    value: function getChatsAndSearchedChats(group) {
	      return this.state.chatsAndSearchedChats.selectChatsInGroup(group);
	    }
	  }, {
	    key: 'getCurrentChat',
	    value: function getCurrentChat() {
	      return this.state.currentId ? this.getChat(this.state.currentId) : null;
	    }
	  }, {
	    key: 'getMembers',
	    value: function getMembers() {
	      var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { id: _RootGroup.rootGroup.id };
	      var members = this.state.members;
	
	      if (group.id === _RootGroup.rootGroup.id) {
	        return this.state.members;
	      } else {
	        // TODO filter by PCMs who are in the group
	        var memberModels = members.filter(function (m) {
	          return m.isMemberOfGroup(group.id);
	        });
	        return new _PotentialChatMembers2.default(memberModels);
	      }
	    }
	  }, {
	    key: 'getEligibleMemberModels',
	    value: function getEligibleMemberModels() {
	      if (!this.state.eligibleMembers) {
	        this.state.eligibleMembers = this.state.members.filter(function (member) {
	          return member.isEligible();
	        });
	      }
	      return this.state.eligibleMembers;
	    }
	  }, {
	    key: 'getFocusView',
	    value: function getFocusView() {
	      return this.state.focusView;
	    }
	  }, {
	    key: 'areAllChatsLoaded',
	    value: function areAllChatsLoaded() {
	      return !!this.state.allChatsLoadedForGroups[_RootGroup.rootGroup.id];
	    }
	
	    // Have we processed yet a response for a request for chats of this particular group
	
	  }, {
	    key: 'haveChatsBeenLoadedForGroup',
	    value: function haveChatsBeenLoadedForGroup(group) {
	      return !!this.state.loadedGroups[group.id];
	    }
	  }, {
	    key: 'areAllChatsLoadedForGroup',
	    value: function areAllChatsLoadedForGroup(group) {
	      return this.areAllChatsLoaded() || !!this.state.allChatsLoadedForGroups[group.id];
	    }
	  }, {
	    key: 'areAllMembersLoaded',
	    value: function areAllMembersLoaded() {
	      return this.state.allMembersLoaded;
	    }
	  }, {
	    key: 'setAsRead',
	    value: function setAsRead(chatId) {
	      var chat = this.state.chats.get(chatId);
	      if (chat) {
	        chat.markAsRead();
	      }
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(chat) {
	      var position = 0;
	      var firstChat = this.state.chats.first();
	      if (!chat.isNew() && firstChat && firstChat.isNew()) {
	        position = 1;
	      }
	
	      this.state.chats.setPosition(chat, position);
	    }
	  }, {
	    key: 'setLastMessageForChat',
	    value: function setLastMessageForChat(chatId, message) {
	      var chat = this.state.chats.get(chatId);
	      if (chat) {
	        chat.setLastMessage(message);
	
	        var updatedAt = chat.getUpdatedAt();
	        if (updatedAt < message.getCreatedAt()) {
	          chat.setUpdatedAt(message.getCreatedAt());
	          this.state.chats.sort();
	        }
	      }
	    }
	  }, {
	    key: 'setFocusView',
	    value: function setFocusView(focus) {
	      this.state.focusView = focus;
	    }
	  }, {
	    key: 'deactivate',
	    value: function deactivate(chatId) {
	      var chat = this.state.chats.get(chatId);
	      if (chat) {
	        chat.deactivate();
	      }
	    }
	  }, {
	    key: 'handleIncomingChatMessage',
	    value: function handleIncomingChatMessage(message) {
	      var chatId = message.getChatId();
	
	      var chat = this.state.chats.get(chatId);
	
	      if (chat) {
	        this.setLastMessageForChat(chatId, message);
	        this.emitChange();
	      } else {
	        _ChatActions2.default.loadChat(chatId);
	      }
	    }
	  }, {
	    key: 'clearLocalChat',
	    value: function clearLocalChat() {
	      this.state.chats.remove(this.state.localChatInstance);
	      this.state.localChatInstance = null;
	    }
	  }, {
	    key: 'loadLocalChat',
	    value: function loadLocalChat(members, title, originIds) {
	      this.clearLocalChat();
	      this.state.localChatInstance = _Chat2.default.createLocal(members, title, originIds);
	      this.addNewChat(this.state.localChatInstance);
	    }
	  }, {
	    key: 'hasLocal',
	    value: function hasLocal() {
	      return !!this.state.localChatInstance;
	    }
	  }, {
	    key: 'getLocal',
	    value: function getLocal() {
	      return this.state.localChatInstance;
	    }
	  }, {
	    key: 'addNewChat',
	    value: function addNewChat(chat) {
	      if (chat.isAssistantType()) {
	        return;
	      }
	
	      // Refresh memberships from ChatMemberStore
	      chat.getMemberships().forEach(function (membership) {
	        membership.setMember(_ChatMemberStore2.default.getMember(membership.getMember().id));
	      });
	
	      this.state.chats.add(chat);
	      if (chat !== this.state.localChatInstance) {
	        this.state.chatsAndSearchedChats.add(chat);
	      }
	    }
	  }, {
	    key: 'shouldReloadChats',
	    value: function shouldReloadChats() {
	      return this.state.invalidated;
	    }
	  }, {
	    key: 'markTeacherLeadsInvited',
	    value: function markTeacherLeadsInvited(leadIds) {
	      var _this2 = this;
	
	      leadIds.forEach(function (leadId) {
	        var member = _this2.state.members.get(leadId);
	        if (member) {
	          member.setState('invited');
	        }
	      });
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      var _this3 = this;
	
	      this.waitFor([_ChatMemberStore2.default]);
	
	      var chatTarget = void 0;
	
	      switch (action.type) {
	        case _ChatConstants.ActionTypes.RESET_STORE:
	          this.resetState();
	          break;
	        case _ChatConstants.ActionTypes.LIST_CHATS:
	          this.state.loadedGroups[action.groupId] = true;
	          if (action.chats.length < _ChatConstants.CHATS_PAGE_SIZE) {
	            this.state.allChatsLoadedForGroups[action.groupId] = true;
	          }
	          action.chats.map(function (chat) {
	            return _this3.addNewChat(chat);
	          });
	          this.state.invalidated = false;
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.LOAD_CHAT:
	          this.addNewChat(action.chat);
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.APPEND_CHATS:
	          {
	            var groupId = action.groupId;
	            var loadedChatsCount = action.chats.length;
	
	            if (loadedChatsCount < _ChatConstants.CHATS_PAGE_SIZE) {
	              this.state.allChatsLoadedForGroups[groupId] = true;
	            }
	
	            action.chats.map(function (chat) {
	              return _this3.addNewChat(chat);
	            });
	            this.state.chats.sort();
	            this.emitChange();
	            break;
	          }
	        case _ChatConstants.ActionTypes.SEARCH_CHATS:
	          action.chats.forEach(function (chat) {
	            return _this3.state.chatsAndSearchedChats.add(chat);
	          });
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.CREATE_CHAT:
	          this.addNewChat(action.chat);
	          this.setPosition(action.chat);
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.LOAD_LOCAL_CHAT:
	          this.loadLocalChat(action.members, action.title, action.originIds);
	          this.setPosition(this.state.localChatInstance);
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.UPDATE_LOCAL_CHAT:
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.DESTROY_LOCAL_CHAT:
	          this.clearLocalChat();
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.MARK_READ:
	        case _ChatConstants.ActionTypes.READ_MESSAGE:
	          this.setAsRead(action.chatId);
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.SELECT_CHAT:
	          this.state.currentId = action.chatId;
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.RESET_SELECTION:
	          this.state.currentId = null;
	          this.emitChange();
	          break;
	        case _GroupConstants.ActionTypes.SEND_GROUP_MESSAGE:
	          {
	            var _ret = function () {
	              var message = action.message;
	              var groupIds = message.getGroupIds();
	              var groups = _GroupStore2.default.getGroups().filter(function (group) {
	                return groupIds.includes(group.id);
	              });
	              groups.forEach(function (group) {
	                var affectedChats = _this3.getChats(group).filter(function (chat) {
	                  return chat.isIndividualType();
	                });
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                  for (var _iterator = affectedChats[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var chat = _step.value;
	
	                    var lastMessage = _ChatMessageStore2.default.getChatMessages(chat.id).last();
	                    var seq = lastMessage ? lastMessage.getSeq() + 1 : 1;
	                    var chatMessage = _ChatMessage.ChatMessage.create(message.getBody(), message.getFiles(), chat, message.getSender(), seq, 'broadcast', group);
	                    chatMessage.set('message', message);
	                    _this3.setLastMessageForChat(chat.id, chatMessage);
	                    if (_ChatMessageStore2.default.hasLoadedAnyOf(chat.id)) {
	                      // If we hadn't loaded any messages yet then the `seq` is likely
	                      // erroneous. When user navs to the chat messages we'll have to
	                      // load from the server anyway and the store will get this
	                      // chatMessage then.
	                      _ChatMessageStore2.default.addMessage(chatMessage);
	                    }
	                  }
	                } catch (err) {
	                  _didIteratorError = true;
	                  _iteratorError = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                      _iterator.return();
	                    }
	                  } finally {
	                    if (_didIteratorError) {
	                      throw _iteratorError;
	                    }
	                  }
	                }
	              });
	              _this3.emitChange();
	              return 'break';
	            }();
	
	            if (_ret === 'break') break;
	          }
	        case _ChatConstants.ActionTypes.SEND_MESSAGE:
	          if (action.message instanceof _ChatMessage.ChatGapMessage) {
	            console.error('attempt to deliver a gap message');
	            break;
	          }
	          this.setLastMessageForChat(action.chatId, action.message);
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.EDIT_MEMBER_FROM_CHAT:
	          chatTarget = this.state.chats.get(action.chat.id);
	          chatTarget.addToMemberships(action.membership);
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.ADD_MEMBERS_TO_CHAT:
	          chatTarget = this.state.chats.get(action.chat.id);
	          action.memberships.forEach(function (membership) {
	            chatTarget.addToMemberships(membership);
	          });
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.LOAD_MEMBERS:
	          this.state.members.add(action.members.models);
	          delete this.state.eligibleMembers; // invalidate cache
	          this.state.allMembersLoaded = true;
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.UPDATE_CHAT:
	          this.state.chats.set(action.chat, { remove: false });
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.DEACTIVATE:
	          this.deactivate(action.chatId);
	          this.emitChange();
	          break;
	        case _RelationshipConstants.ActionTypes.LOAD_RELATIONSHIP:
	        case _RelationshipConstants.ActionTypes.UPDATE_RELATIONSHIP:
	          if (action.relationship.getChat()) {
	            this.addNewChat(action.relationship.getChat());
	            this.emitChange();
	          }
	          break;
	        case _PusherConstants.PushEvents.CHANGESET_CREATE_CHAT_MESSAGE:
	          action.changes.map(function (change) {
	            return (0, _ChatMessage.chatMessageFactory)(change.content);
	          }).filter(function (message) {
	            return (0, _ChatMessage.shouldListenToPushEventFrom)(message);
	          }).forEach(function (message) {
	            return _this3.handleIncomingChatMessage(message);
	          });
	          break;
	        case _PusherConstants.PushEvents.CHANGESET_UPDATE_CHAT:
	          // Refresh all our chats in case we missed a push.
	          // The action sends `last_updated_ts` so we only fetch what's new.
	          _ChatActions2.default.loadMoreChats(_RootGroup.rootGroup);
	          break;
	        case _PusherConstants.PushEvents.CHANGESET_UPDATE_CHATS:
	          _ChatActions2.default.resetPromiseMemoization();
	          this.resetState();
	          break;
	        case _AppConstants.ActionTypes.CONNECTION_STATE_CHANGED:
	        case _PusherConstants.PushEvents.CONNECTION_STATE_CHANGED:
	          if (action.current !== 'connected') {
	            this.state.invalidated = true;
	          }
	          break;
	        case _LeadConstants.ActionTypes.INVITE_LEADS:
	          this.markTeacherLeadsInvited(action.leadIds);
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.SET_FOCUS_VIEW:
	          this.setFocusView(action.focus);
	          break;
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return ChatStore;
	}(_Store3.default);
	
	ChatStore.displayName = 'ChatStore';
	exports.default = new ChatStore();

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ChatConstants = __webpack_require__(941);
	
	var _RelationshipConstants = __webpack_require__(986);
	
	var _ChatSettingsConstants = __webpack_require__(923);
	
	var _ChatMember = __webpack_require__(921);
	
	var _ChatMember2 = _interopRequireDefault(_ChatMember);
	
	var _ChatMembers = __webpack_require__(987);
	
	var _ChatMembers2 = _interopRequireDefault(_ChatMembers);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatMemberStore = function (_Store) {
	  _inherits(ChatMemberStore, _Store);
	
	  function ChatMemberStore() {
	    _classCallCheck(this, ChatMemberStore);
	
	    return _possibleConstructorReturn(this, (ChatMemberStore.__proto__ || Object.getPrototypeOf(ChatMemberStore)).apply(this, arguments));
	  }
	
	  _createClass(ChatMemberStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        chatMembers: new _ChatMembers2.default()
	      };
	    }
	  }, {
	    key: 'getMember',
	    value: function getMember(memberId) {
	      return this.state.chatMembers.get(memberId);
	    }
	  }, {
	    key: 'loadChatMembers',
	    value: function loadChatMembers(chat) {
	      var _this2 = this;
	
	      chat.getMemberships().forEach(function (membership) {
	        _this2.state.chatMembers.add(membership.getMember());
	      });
	    }
	  }, {
	    key: 'loadMembers',
	    value: function loadMembers(members) {
	      var _this3 = this;
	
	      members.forEach(function (member) {
	        // Cast PotentialChatMembers so ChatMemberStore only holds ChatMembers
	        var chatMember = member instanceof _ChatMember2.default ? member : new _ChatMember2.default(member.attributes);
	        _this3.state.chatMembers.add(chatMember);
	      });
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      var _this4 = this;
	
	      switch (action.type) {
	        case _ChatConstants.ActionTypes.LIST_CHATS:
	        case _ChatConstants.ActionTypes.APPEND_CHATS:
	          action.chats.map(function (chat) {
	            return _this4.loadChatMembers(chat);
	          });
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.LOAD_CHAT:
	        case _ChatConstants.ActionTypes.CREATE_CHAT:
	          this.loadChatMembers(action.chat);
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.LOAD_LOCAL_CHAT:
	          this.loadMembers(action.members);
	          this.emitChange();
	          break;
	        case _RelationshipConstants.ActionTypes.LOAD_RELATIONSHIP:
	        case _RelationshipConstants.ActionTypes.UPDATE_RELATIONSHIP:
	          if (action.relationship.getChat()) {
	            this.loadChatMembers(action.relationship.getChat());
	            this.emitChange();
	          }
	          break;
	        case _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_LOADED:
	        case _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_ENABLED:
	        case _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_DISABLED:
	        case _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_UPDATED:
	          {
	            var member = this.state.chatMembers.get(_CurrentUser2.default.getUser().id);
	            if (member && member.setOfficeHours) {
	              member.setOfficeHours(action.hours);
	            }
	            this.emitChange();
	            break;
	          }
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return ChatMemberStore;
	}(_Store3.default);
	
	ChatMemberStore.displayName = 'ChatMemberStore';
	exports.default = new ChatMemberStore();

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['DELETE', 'LOAD_RELATIONSHIP', 'UPDATE_RELATIONSHIP']); /*  weak */

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ChatMember = __webpack_require__(921);
	
	var _ChatMember2 = _interopRequireDefault(_ChatMember);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatMembers = function (_Collection) {
	  _inherits(ChatMembers, _Collection);
	
	  function ChatMembers() {
	    _classCallCheck(this, ChatMembers);
	
	    return _possibleConstructorReturn(this, (ChatMembers.__proto__ || Object.getPrototypeOf(ChatMembers)).apply(this, arguments));
	  }
	
	  _createClass(ChatMembers, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _ChatMember2.default;
	    }
	  }], [{
	    key: 'buildChatMember',
	    value: function buildChatMember(user) {
	      if (!(user instanceof _User2.default || user instanceof _Subscriber2.default)) {
	        console.warn('ChatMembers#buildChatMember only accepts User and Subscriber.');
	      }
	
	      return new _ChatMember2.default({
	        id: user.id,
	        name: user.getSignature() || user.getName(),
	        role: user.getRole(),
	        office_hours: user.getOfficeHours(),
	        color: user.getColor(),
	        initials: user.getInitials()
	      });
	    }
	  }]);
	
	  return ChatMembers;
	}(_Collection3.default);
	
	ChatMembers.displayName = 'ChatMembers';
	exports.default = ChatMembers;

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _AppConstants = __webpack_require__(989);
	
	var _ChatConstants = __webpack_require__(941);
	
	var _ChatMessageActions = __webpack_require__(939);
	
	var _ChatMessageActions2 = _interopRequireDefault(_ChatMessageActions);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessages = __webpack_require__(940);
	
	var _ChatMessages2 = _interopRequireDefault(_ChatMessages);
	
	var _PusherConstants = __webpack_require__(954);
	
	var _ReactionSummary = __webpack_require__(936);
	
	var _ReactionSummary2 = _interopRequireDefault(_ReactionSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var checkForMissingMessages = _lodash2.default.debounce(function (chatId, lastMessageSeq, mostRecentMessageSeq) {
	  if (mostRecentMessageSeq - lastMessageSeq > 1) {
	    _ChatMessageActions2.default.loadMissingChatMessages(chatId, lastMessageSeq, mostRecentMessageSeq);
	  }
	}, 1000);
	
	var ChatMessageStore = function (_Store) {
	  _inherits(ChatMessageStore, _Store);
	
	  function ChatMessageStore() {
	    _classCallCheck(this, ChatMessageStore);
	
	    return _possibleConstructorReturn(this, (ChatMessageStore.__proto__ || Object.getPrototypeOf(ChatMessageStore)).apply(this, arguments));
	  }
	
	  _createClass(ChatMessageStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        hasLoadedAny: {},
	        chatMessages: {},
	        failedMessages: new _ChatMessages2.default(),
	        invalidatedChats: {}
	      };
	    }
	
	    /**
	     * Must be tracked separately from chatMessages because those collections
	     * are made on the fly and if it's empty we don't know if it's because there
	     * are no messages in the chat, or they just aren't loaded.
	     */
	
	  }, {
	    key: 'hasLoadedAnyOf',
	    value: function hasLoadedAnyOf(chatId) {
	      return chatId in this.state.hasLoadedAny;
	    }
	
	    /**
	     * Creates a ChatMessages collection on the fly if we haven't loaded the chat yet.
	     * If you care, check hasLoadedAnyOf() first.
	     */
	
	  }, {
	    key: 'getChatMessages',
	    value: function getChatMessages(chatId) {
	      if (!(chatId in this.state.chatMessages)) {
	        this.state.chatMessages[chatId] = new _ChatMessages2.default();
	      }
	
	      this.validateMessages(chatId);
	      return this.state.chatMessages[chatId];
	    }
	
	    // XXX until we figure out the problem we're only seeing in prod
	    // was...
	    // https://my.trackjs.com/details/e6242d97ecd34492a61bbc630be5db60
	    // https://my.trackjs.com/messages/filtered?hash=f5f4d25e595641e8
	    // https://my.trackjs.com/messages/filtered?hash=11487e60d7084f92
	    // now...
	    // https://my.trackjs.com/messages/filtered?hash=3b3bf212b79fe089
	
	  }, {
	    key: 'validateMessages',
	    value: function validateMessages(chatId) {
	      var messages = this.state.chatMessages[chatId].models;
	
	      var withoutInlineGap = messages.filter(function (m, i) {
	        return m.getType() !== 'gap' || i === 0;
	      });
	
	      if (withoutInlineGap.length !== messages.length) {
	        // FIXME https://app.asana.com/0/136308400336656/193556816395301
	        console.warn('messages', messages.map(function (m) {
	          return { uuid: m.id, type: m.getType(), seq: m.getSeq() };
	        }));
	        console.warn('gap message found later than first message');
	        this.state.chatMessages[chatId].models = withoutInlineGap;
	      }
	    }
	  }, {
	    key: 'hasMessageFailed',
	    value: function hasMessageFailed(message) {
	      return _lodash2.default.includes(this.state.failedMessages.models, message);
	    }
	  }, {
	    key: 'shouldReloadMessages',
	    value: function shouldReloadMessages(chatId) {
	      return chatId in this.state.invalidatedChats;
	    }
	
	    // assumes that any new set of messages will include a `gap` message if
	    // there ought to be one
	
	  }, {
	    key: 'updateMessages',
	    value: function updateMessages(chatId, messages) {
	      var existingMessages = this.getChatMessages(chatId);
	
	      // We delete the gap messages because we expect to load a ChatMessage with
	      // the same id. Backbone collections merge only new models or attributes
	      // on existing models. That doesn't work for ChatGapMessage because the
	      // same id gets updated be a different JS class type.
	      existingMessages.where({ type: 'gap' }).forEach(function (message) {
	        return existingMessages.remove(message.id);
	      });
	
	      existingMessages.add(messages.models);
	    }
	  }, {
	    key: 'addMessage',
	    value: function addMessage(message) {
	      var chatId = message.getChatId();
	
	      if (!(chatId in this.state.chatMessages)) {
	        this.state.chatMessages[chatId] = new _ChatMessages2.default();
	      }
	
	      this.state.chatMessages[chatId].add(message);
	    }
	  }, {
	    key: 'removeMessage',
	    value: function removeMessage(message) {
	      var messages = this.state.chatMessages[message.getChatId()];
	      if (messages) {
	        messages.remove(message);
	        this.state.failedMessages.remove(message);
	      }
	    }
	  }, {
	    key: 'handlePushedMessage',
	    value: function handlePushedMessage(message) {
	      var chatId = message.getChatId();
	      _ChatActions2.default.loadChat(chatId);
	
	      var existingMessages = this.state.chatMessages[chatId];
	      if (existingMessages) {
	        var mostRecentMessageSeq = message.getSeq();
	        var lastMessage = existingMessages.last();
	        if (lastMessage) {
	          var lastMessageSeq = lastMessage.getSeq();
	          checkForMissingMessages(chatId, lastMessageSeq, mostRecentMessageSeq);
	        }
	        this.addMessage(message);
	      }
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      var _this2 = this;
	
	      switch (action.type) {
	        case _ChatConstants.ActionTypes.SEND_MESSAGE:
	        case _ChatConstants.ActionTypes.SENT_MESSAGE:
	          this.state.failedMessages.remove(action.message);
	          this.addMessage(action.message);
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.MESSAGE_FAILED:
	          this.state.failedMessages.add(action.message);
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.REMOVE_MESSAGE:
	          this.removeMessage(action.message);
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.REMOVE_CHAT_MESSAGE_REACTION:
	        case _ChatConstants.ActionTypes.ADD_CHAT_MESSAGE_REACTION:
	          {
	            var message = action.message;
	            message.setReactionSummary(action.reactionSummary);
	            this.emitChange();
	            break;
	          }
	        case _ChatConstants.ActionTypes.LOAD_MISSING_CHAT_MESSAGES:
	          {
	            var messages = this.state.chatMessages[action.chatId];
	            if (messages) {
	              messages.add(action.messages.toJSON());
	            }
	            this.state.hasLoadedAny[action.chatId] = true;
	            this.emitChange();
	            break;
	          }
	        case _ChatConstants.ActionTypes.LOAD_CHAT_MESSAGES:
	          this.state.chatMessages[action.chatId] = action.messages;
	          delete this.state.invalidatedChats[action.chatId];
	          this.state.hasLoadedAny[action.chatId] = true;
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.UPDATE_CHATS_MESSAGES:
	          {
	            var chatsMessages = action.chatsMessages;
	            for (var _chatId in chatsMessages) {
	              this.updateMessages(_chatId, chatsMessages[_chatId]);
	              delete this.state.invalidatedChats[_chatId];
	              this.state.hasLoadedAny[_chatId] = true;
	            }
	            this.emitChange();
	            break;
	          }
	        case _ChatConstants.ActionTypes.LOAD_GAP_MESSAGE:
	          this.updateMessages(action.chatId, action.messages);
	          this.emitChange();
	          break;
	        case _PusherConstants.PushEvents.CHANGESET_CREATE_CHAT_MESSAGE:
	          {
	            var _messages = action.changes.map(function (change) {
	              return (0, _ChatMessage.chatMessageFactory)(change.content);
	            });
	
	            if (_messages.length > 0) {
	              _messages.forEach(function (message) {
	                return _this2.handlePushedMessage(message);
	              });
	              this.emitChange();
	            }
	            break;
	          }
	        case _AppConstants.ActionTypes.CONNECTION_STATE_CHANGED:
	        case _PusherConstants.PushEvents.CONNECTION_STATE_CHANGED:
	          if (action.current !== 'connected') {
	            Object.keys(this.state.chatMessages).forEach(function (chatId) {
	              _this2.state.invalidatedChats[chatId] = true;
	            });
	          }
	          this.emitChange();
	          break;
	        case _PusherConstants.PushEvents.CONTENT_UPDATE_CHAT_BROADCAST_REACTION:
	          {
	            action.changes.forEach(function (change) {
	              var reactionSummary = _ReactionSummary2.default.fromJSON(change.content);
	
	              var messageUuid = reactionSummary.getMessageUuid();
	              Object.keys(_this2.state.chatMessages).forEach(function (chatId) {
	                var message = _this2.state.chatMessages[chatId].get(messageUuid);
	                if (message) {
	                  message.setReactionSummary(reactionSummary);
	                }
	              });
	            });
	            this.emitChange();
	            break;
	          }
	        case _PusherConstants.PushEvents.CONTENT_UPDATE_CHAT_MESSAGE_REACTION:
	          {
	            action.changes.forEach(function (change) {
	              var reactionSummary = _ReactionSummary2.default.fromJSON(change.content);
	              var chatId = change.uuid;
	              var messages = _this2.getChatMessages(chatId);
	              var message = messages.get(reactionSummary.getMessageUuid());
	              if (message) {
	                message.setReactionSummary(reactionSummary);
	              }
	            });
	            this.emitChange();
	            break;
	          }
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return ChatMessageStore;
	}(_Store3.default);
	
	ChatMessageStore.displayName = 'ChatMessageStore';
	exports.default = new ChatMessageStore();

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['CONNECTION_STATE_CHANGED']); /*  weak */

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GroupConstants = __webpack_require__(991);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _PusherConstants = __webpack_require__(954);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _RootGroup = __webpack_require__(943);
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * All the current user's groups.
	 *
	 * NOTE that groups that are loaded from the server will not necessarily be
	 * stored here until they become one of the user's groups.
	 */
	var GroupStore = function (_Store) {
	  _inherits(GroupStore, _Store);
	
	  function GroupStore() {
	    _classCallCheck(this, GroupStore);
	
	    return _possibleConstructorReturn(this, (GroupStore.__proto__ || Object.getPrototypeOf(GroupStore)).apply(this, arguments));
	  }
	
	  _createClass(GroupStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        archivedLoaded: false,
	        loaded: false,
	        groupCodeToId: {},
	        groupNameToId: {},
	        groups: new _Groups2.default(),
	        showDraft: false
	      };
	    }
	  }, {
	    key: 'setGroupCreatedDuringSetup',
	    value: function setGroupCreatedDuringSetup(group) {
	      this.state.groupCreatedDuringSetup = group;
	    }
	  }, {
	    key: 'getGroupCreatedDuringSetup',
	    value: function getGroupCreatedDuringSetup() {
	      return this.state.groupCreatedDuringSetup;
	    }
	  }, {
	    key: 'clearGroupCreatedDuringSetup',
	    value: function clearGroupCreatedDuringSetup() {
	      delete this.state.groupCreatedDuringSetup;
	    }
	
	    // TODO: Improve. This is a cheap implementation to get around some loading issues.
	    // See https://github.com/remind101/r101-frontend/issues/339
	
	  }, {
	    key: 'isLoaded',
	    value: function isLoaded() {
	      return this.state.loaded;
	    }
	  }, {
	    key: 'isArchivedLoaded',
	    value: function isArchivedLoaded() {
	      return this.state.archivedLoaded;
	    }
	  }, {
	    key: 'invalidate',
	    value: function invalidate() {
	      this.state.loaded = false;
	    }
	  }, {
	    key: 'isConnectedToGroup',
	    value: function isConnectedToGroup(group) {
	      return this.getGroup(group.id) !== undefined;
	    }
	
	    /**
	     * Filters out archived groups.
	     */
	
	  }, {
	    key: 'getGroups',
	    value: function getGroups() {
	      var unarchivedGroups = this.state.groups.filter(function (group) {
	        return !group.isArchived();
	      });
	      return new _Groups2.default(unarchivedGroups);
	    }
	  }, {
	    key: 'selectGroups',
	    value: function selectGroups(predicate) {
	      var selectedItems = this.state.groups.filter(predicate);
	      return new _Groups2.default(selectedItems);
	    }
	  }, {
	    key: 'getOwnedGroups',
	    value: function getOwnedGroups() {
	      return this.selectGroups(function (group) {
	        return group.getType() === 'owned' && !group.isArchived();
	      });
	    }
	  }, {
	    key: 'getInvitableClasses',
	    value: function getInvitableClasses() {
	      return this.selectGroups(function (group) {
	        return ['owned', 'subscribed'].includes(group.getType()) && group.canAddPeople();
	      });
	    }
	  }, {
	    key: 'getAdministratedGroups',
	    value: function getAdministratedGroups() {
	      return this.selectGroups(function (group) {
	        return group.isStaffClass() && group.getPostableRoles().includes('admin');
	      });
	    }
	  }, {
	    key: 'getAdministratedGroupByOrganizationId',
	    value: function getAdministratedGroupByOrganizationId(organizationID) {
	      return this.getAdministratedGroups().find(function (group) {
	        return group.getStaffClassOrgId() === organizationID;
	      });
	    }
	  }, {
	    key: 'getInvitableGroups',
	    value: function getInvitableGroups() {
	      return this.selectGroups(function (group) {
	        return group.canAddPeople();
	      });
	    }
	  }, {
	    key: 'hasOwnedGroups',
	    value: function hasOwnedGroups() {
	      return this.getOwnedGroups().length > 0;
	    }
	  }, {
	    key: 'getSubscribedGroups',
	    value: function getSubscribedGroups() {
	      return this.selectGroups(function (group) {
	        return group.getType() === 'subscribed';
	      });
	    }
	  }, {
	    key: 'getSchoolGroups',
	    value: function getSchoolGroups() {
	      return this.selectGroups(function (group) {
	        return group.isStaffClass();
	      });
	    }
	  }, {
	    key: 'getDistrictGroups',
	    value: function getDistrictGroups() {
	      return this.selectGroups(function (group) {
	        return group.getType() === 'district';
	      });
	    }
	  }, {
	    key: 'getGroupsAtOrganization',
	    value: function getGroupsAtOrganization(orgId) {
	      return this.selectGroups(function (g) {
	        return g.getOrganization() && g.getOrganization().id === orgId && !g.isStaffClass();
	      });
	    }
	
	    /**
	     * @deprecated use postable roles instead
	     */
	
	  }, {
	    key: 'getPostableGroups',
	    value: function getPostableGroups() {
	      return this.selectGroups(function (group) {
	        return group.canPost();
	      });
	    }
	  }, {
	    key: 'getGroup',
	    value: function getGroup(groupId) {
	      return this.state.groups.get(groupId);
	    }
	  }, {
	    key: 'getGroupForCode',
	    value: function getGroupForCode(groupCode) {
	      if (groupCode === _RootGroup.rootGroup.getCode()) {
	        return _RootGroup.rootGroup;
	      }
	
	      var id = this.state.groupCodeToId[groupCode];
	      if (id) {
	        return this.getGroup(id);
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getOwnedGroupForName',
	    value: function getOwnedGroupForName(groupName) {
	      return this.getOwnedGroups().find(function (g) {
	        return g.getName() === groupName;
	      });
	    }
	  }, {
	    key: 'getStaffClassForOrg',
	    value: function getStaffClassForOrg(orgId) {
	      return this.state.groups.find(function (g) {
	        return g.getStaffClassOrgId() === orgId;
	      });
	    }
	  }, {
	    key: 'getArchivedGroups',
	    value: function getArchivedGroups() {
	      return this.state.groups.filter(function (group) {
	        return group.isArchived();
	      });
	    }
	
	    /* This is called when group is added/updated or deleted
	     * because is the group code or group name is updated
	     * then we need to flush the old value.
	     */
	
	  }, {
	    key: 'resetMappings',
	    value: function resetMappings() {
	      var _this2 = this;
	
	      this.state.groupCodeToId = [];
	      this.state.groupNameToId = [];
	      this.state.archivedGroupCodeToId = [];
	
	      this.state.groups.forEach(function (group) {
	        _this2.state.groupCodeToId[group.getCode()] = group.id;
	        _this2.state.groupNameToId[group.getName().toLowerCase()] = group.id;
	      });
	    }
	  }, {
	    key: 'validateLastReadSeq',
	    value: function validateLastReadSeq(oldGroup, newGroup) {
	      return !oldGroup.getLastReadSeq() || !newGroup.getLastReadSeq() || newGroup.getLastReadSeq() >= oldGroup.getLastReadSeq();
	    }
	  }, {
	    key: 'addGroup',
	    value: function addGroup(group) {
	      var oldGroup = this.state.groups.get(group);
	      if (!oldGroup || this.validateLastReadSeq(oldGroup, group)) {
	        this.state.groups.add(group);
	      }
	    }
	  }, {
	    key: 'deleteGroup',
	    value: function deleteGroup(group) {
	      this.state.groups.remove(group);
	    }
	
	    // for AnnouncementComposer, within the universal composer dialog
	
	  }, {
	    key: 'setDraftAnnouncement',
	    value: function setDraftAnnouncement(message) {
	      this.state.currentComposerMessage = message;
	    }
	  }, {
	    key: 'getShowDraft',
	    value: function getShowDraft() {
	      return this.state.showDraft;
	    }
	  }, {
	    key: 'setShowDraft',
	    value: function setShowDraft(val) {
	      this.state.showDraft = val;
	    }
	  }, {
	    key: '_clearDraftAnnouncement',
	    value: function _clearDraftAnnouncement() {
	      this.state.currentComposerMessage = null;
	    }
	  }, {
	    key: 'getDraftAnnouncement',
	    value: function getDraftAnnouncement() {
	      return this.state.currentComposerMessage;
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      var _this3 = this;
	
	      switch (action.type) {
	        case _GroupConstants.ActionTypes.RESET_STORE:
	          this.resetState();
	          break;
	        case _GroupConstants.ActionTypes.UPDATE_GROUP:
	        case _GroupConstants.ActionTypes.LOAD_GROUP:
	          this.handleLoadGroups([action.group]);
	          break;
	        case _GroupConstants.ActionTypes.RESIGN_OWNERSHIP:
	          this.handleDeleteGroups([action.group]);
	          break;
	        case _GroupConstants.ActionTypes.LIST_GROUPS:
	          if (action.allMine) {
	            this.handleSetGroups(action.groups);
	          } else {
	            this.handleLoadGroups(action.groups);
	          }
	          break;
	        case _GroupConstants.ActionTypes.CREATE_GROUP:
	        case _GroupConstants.ActionTypes.GROUPS_UPDATED:
	          this.handleUpdateGroups(action.groups);
	          break;
	        case _GroupConstants.ActionTypes.LIST_ARCHIVED_GROUPS:
	          this.handleLoadGroups(action.groups);
	          this.state.archivedLoaded = true;
	          break;
	        case _GroupConstants.ActionTypes.ARCHIVE:
	          this.handleUpdateGroups([action.group]);
	          break;
	        case _GroupConstants.ActionTypes.ARCHIVE_AND_REUSE:
	          this.handleUpdateGroups([action.group, action.archivedGroup]);
	          break;
	        case _GroupConstants.ActionTypes.REUSE:
	          this.handleUpdateGroups([action.group, action.archivedGroup]);
	          break;
	        case _GroupConstants.ActionTypes.RESTORE:
	          this.handleUpdateGroups([action.group]);
	          break;
	        case _PusherConstants.PushEvents.CHANGESET_DESTROY_GROUP:
	          {
	            var _ret = function () {
	              var uuids = action.changes.map(function (change) {
	                return change.uuid;
	              });
	              _this3.state.groups = new _Groups2.default(_this3.state.groups.filter(function (group) {
	                return !uuids.includes(group.getUuid());
	              }));
	
	              _this3.resetMappings();
	              _this3.emitChange();
	              return 'break';
	            }();
	
	            if (_ret === 'break') break;
	          }
	        case _PusherConstants.PushEvents.CHANGESET_CREATE_GROUP:
	        case _PusherConstants.PushEvents.CHANGESET_UPDATE_GROUP:
	          {
	            var uuids = action.changes.map(function (change) {
	              return change.uuid;
	            });
	            _GroupActions2.default.loadGroups(uuids);
	            break;
	          }
	        case _GroupConstants.ActionTypes.SEND_AGAIN:
	          this.setDraftAnnouncement(action.message);
	          this.setShowDraft(true);
	          this.emitChange();
	          break;
	        case _GroupConstants.ActionTypes.SAVE_AND_SHOW_DRAFT_ANNOUNCEMENT:
	          this.setDraftAnnouncement(action.message);
	          this.setShowDraft(true);
	          this.emitChange();
	          break;
	        case _GroupConstants.ActionTypes.FINISH_SHOWING_DRAFT:
	          this.setShowDraft(false);
	          this.emitChange();
	          break;
	        case _GroupConstants.ActionTypes.SAVE_DRAFT_ANNOUNCEMENT:
	          this.setDraftAnnouncement(action.message);
	          this.emitChange();
	          break;
	        case _GroupConstants.ActionTypes.CLEAR_DRAFT_ANNOUNCEMENT:
	          this._clearDraftAnnouncement();
	          this.emitChange();
	          break;
	        case _GroupConstants.ActionTypes.SUBSCRIBED:
	          this.handleLoadGroups([action.group]);
	          break;
	        case _GroupConstants.ActionTypes.UNSUBSCRIBED:
	          this.handleDeleteGroups([action.group]);
	          break;
	        case _GroupConstants.ActionTypes.SEND_GROUP_MESSAGE:
	          this.handleMessageSent(action.message);
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'handleSetGroups',
	    value: function handleSetGroups(groups) {
	      var _this4 = this;
	
	      var ids = groups.map(function (group) {
	        return group.id;
	      });
	      var toRemove = this.state.groups.filter(function (group) {
	        return !ids.includes(group.id);
	      });
	
	      groups.forEach(function (group) {
	        return _this4.addGroup(group);
	      });
	      toRemove.forEach(function (group) {
	        return _this4.deleteGroup(group);
	      });
	
	      this.resetMappings();
	      this.state.loaded = true;
	      this.emitChange();
	    }
	  }, {
	    key: 'handleLoadGroups',
	    value: function handleLoadGroups(groups) {
	      var _this5 = this;
	
	      groups.forEach(function (group) {
	        return _this5.addGroup(group);
	      });
	      this.resetMappings();
	      this.emitChange();
	    }
	  }, {
	    key: 'handleDeleteGroups',
	    value: function handleDeleteGroups(groups) {
	      var _this6 = this;
	
	      groups.forEach(function (group) {
	        return _this6.deleteGroup(group);
	      });
	      this.resetMappings();
	      this.emitChange();
	    }
	  }, {
	    key: 'handleUpdateGroups',
	    value: function handleUpdateGroups(groups) {
	      var _this7 = this;
	
	      groups.forEach(function (group) {
	        return _this7.addGroup(group);
	      });
	      this.resetMappings();
	      this.emitChange();
	    }
	  }, {
	    key: 'handleMessageSent',
	    value: function handleMessageSent(message) {
	      var _this8 = this;
	
	      var threads = message.getThreads();
	      threads.forEach(function (t) {
	        var group = _this8.getGroup(t.group_id);
	        if (group) {
	          var groupThreads = group.getThreads();
	          groupThreads.forEach(function (gt) {
	            if (gt.role === t.role) {
	              group.setThreadPreview(gt.role, message.getPreview(), message.getSentAt());
	            }
	          });
	        }
	      });
	      this.emitChange();
	    }
	  }]);
	
	  return GroupStore;
	}(_Store3.default);
	
	GroupStore.displayName = 'GroupStore';
	exports.default = new GroupStore();

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoadingStates = exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['ARCHIVE', 'ARCHIVE_AND_REUSE', 'CAN_START_CHAT_CHANGED', 'CLEAR_DRAFT_ANNOUNCEMENT', 'CREATE_GROUP', 'DESTROY_GROUP_SCHEDULED_MESSAGE', 'FETCH_DELIVERY_SUMMARY_SUCCEEDED_USERS', 'GROUPS_UPDATED', 'LIST_GROUP_MESSAGES', 'LIST_GROUP_SCHEDULED_MESSAGES', 'LIST_GROUPS', 'LIST_ARCHIVED_GROUPS', 'LOAD_DELIVERY_SUMMARY', 'LOAD_GROUP', 'REMOVE_ALL_SUBSCRIBERS', 'RESET_STORE', 'RESIGN_OWNERSHIP', 'SAVE_DRAFT_ANNOUNCEMENT', 'SAVE_AND_SHOW_DRAFT_ANNOUNCEMENT', 'FINISH_SHOWING_DRAFT', 'RESTORE', 'REUSE', 'SEND_AGAIN', 'SEND_GROUP_MESSAGE_ERROR', 'SEND_GROUP_MESSAGE', 'SEND_GROUP_SCHEDULED_MESSAGE_ERROR', 'SEND_GROUP_SCHEDULED_MESSAGE', 'SUBSCRIBED', 'UNSUBSCRIBED', 'UPDATE_GROUP', 'UPDATED_GROUP_SCHEDULED_MESSAGE', 'CHANGE_ORG']); /*  weak */
	var LoadingStates = exports.LoadingStates = (0, _enumerate2.default)(['NOT_STARTED', 'LOADING', 'LOADED']);

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _javascriptNaturalSort = __webpack_require__(993);
	
	var _javascriptNaturalSort2 = _interopRequireDefault(_javascriptNaturalSort);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Groups = function (_Collection) {
	  _inherits(Groups, _Collection);
	
	  function Groups() {
	    _classCallCheck(this, Groups);
	
	    return _possibleConstructorReturn(this, (Groups.__proto__ || Object.getPrototypeOf(Groups)).apply(this, arguments));
	  }
	
	  _createClass(Groups, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.url = '/classes';
	      this.model = _Group2.default;
	    }
	  }, {
	    key: 'comparator',
	    value: function comparator(a, b) {
	      return (0, _javascriptNaturalSort2.default)(a.getName().toLowerCase(), b.getName().toLowerCase());
	    }
	  }], [{
	    key: 'fetch',
	    value: function fetch() {
	      return (0, _apiRequest2.default)('/classes', 'GET').then(function (response) {
	        return Groups.fromJSON(response['classes']);
	      });
	    }
	  }, {
	    key: 'fetchArchived',
	    value: function fetchArchived() {
	      return (0, _apiRequest2.default)('/classes/archived', 'GET').then(function (response) {
	        return Groups.fromJSON(response['classes']);
	      });
	    }
	  }, {
	    key: 'setGroupsAllowedToStartChat',
	    value: function setGroupsAllowedToStartChat(groups) {
	      return (0, _apiRequest2.default)('/classes', 'PATCH', {
	        classes: Object.keys(groups).map(function (groupId) {
	          return {
	            id: groupId,
	            subscriber_initiated_chats: groups[groupId]
	          };
	        })
	      }).then(function (response) {
	        return Groups.fromJSON(response['classes']);
	      });
	    }
	  }, {
	    key: 'bulkUpdate',
	    value: function bulkUpdate(params) {
	      return (0, _apiRequest2.default)('/classes', 'PATCH', {
	        classes: params
	      }).then(function (response) {
	        return Groups.fromJSON(response['classes']);
	      });
	    }
	  }, {
	    key: 'linkUnassignedToPrimaryOrg',
	    value: function linkUnassignedToPrimaryOrg() {
	      return (0, _apiRequest2.default)('/classes/link_unassigned_to_primary_org', 'POST');
	    }
	  }, {
	    key: 'find',
	    value: function find(teacherId) {
	      return (0, _apiRequest2.default)('/classes/find', 'GET', {
	        teacher_id: teacherId
	      }).then(function (response) {
	        return Groups.fromJSON(response);
	      });
	    }
	  }]);
	
	  return Groups;
	}(_Collection3.default);
	
	Groups.displayName = 'Groups';
	exports.default = Groups;

/***/ },
/* 993 */
/***/ function(module, exports) {

	/*
	 * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
	 * Author: Jim Palmer (based on chunking idea from Dave Koelle)
	 */
	/*jshint unused:false */
	module.exports = function naturalSort (a, b) {
		"use strict";
		var re = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi,
			sre = /(^[ ]*|[ ]*$)/g,
			dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
			hre = /^0x[0-9a-f]+$/i,
			ore = /^0/,
			i = function(s) { return naturalSort.insensitive && ('' + s).toLowerCase() || '' + s; },
			// convert all to strings strip whitespace
			x = i(a).replace(sre, '') || '',
			y = i(b).replace(sre, '') || '',
			// chunk/tokenize
			xN = x.replace(re, '\0$1\0').replace(/\0$/,'').replace(/^\0/,'').split('\0'),
			yN = y.replace(re, '\0$1\0').replace(/\0$/,'').replace(/^\0/,'').split('\0'),
			// numeric, hex or date detection
			xD = parseInt(x.match(hre), 16) || (xN.length !== 1 && x.match(dre) && Date.parse(x)),
			yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null,
			oFxNcL, oFyNcL;
		// first try and sort Hex codes or Dates
		if (yD) {
			if ( xD < yD ) { return -1; }
			else if ( xD > yD ) { return 1; }
		}
		// natural sorting through split numeric strings and default strings
		for(var cLoc=0, numS=Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
			// find floats not starting with '0', string or 0 if not defined (Clint Priest)
			oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
			oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
			// handle numeric vs string comparison - number < string - (Kyle Adams)
			if (isNaN(oFxNcL) !== isNaN(oFyNcL)) { return (isNaN(oFxNcL)) ? 1 : -1; }
			// rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
			else if (typeof oFxNcL !== typeof oFyNcL) {
				oFxNcL += '';
				oFyNcL += '';
			}
			if (oFxNcL < oFyNcL) { return -1; }
			if (oFxNcL > oFyNcL) { return 1; }
		}
		return 0;
	};


/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral(['\n        ', '\n        query {\n          me {\n            id\n            ownedClasses: classes(classType: "owned") {\n              ...classesDefaults\n            }\n            subscribedClasses: classes(classType: "subscribed") {\n              ...classesDefaults\n            }\n            organizationClasses: classes(classType: "organization") {\n              ...classesDefaults\n            }\n            districtClasses: classes(classType: "district") {\n              ...classesDefaults\n            }\n          }\n        }'], ['\n        ', '\n        query {\n          me {\n            id\n            ownedClasses: classes(classType: "owned") {\n              ...classesDefaults\n            }\n            subscribedClasses: classes(classType: "subscribed") {\n              ...classesDefaults\n            }\n            organizationClasses: classes(classType: "organization") {\n              ...classesDefaults\n            }\n            districtClasses: classes(classType: "district") {\n              ...classesDefaults\n            }\n          }\n        }']),
	    _templateObject2 = _taggedTemplateLiteral(['\n        ', '\n        query ($classUuids: [String]!) {\n          classes(uuids: $classUuids) {\n            ...classesDefaults\n          }\n        }'], ['\n        ', '\n        query ($classUuids: [String]!) {\n          classes(uuids: $classUuids) {\n            ...classesDefaults\n          }\n        }']);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	var _classesDefaultsFragment = __webpack_require__(995);
	
	var _classesDefaultsFragment2 = _interopRequireDefault(_classesDefaultsFragment);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _GroupMemberships = __webpack_require__(996);
	
	var _GroupMemberships2 = _interopRequireDefault(_GroupMemberships);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _RelationshipActions = __webpack_require__(1006);
	
	var _RelationshipActions2 = _interopRequireDefault(_RelationshipActions);
	
	var _RootGroupMemberships = __webpack_require__(1010);
	
	var _RootGroupMemberships2 = _interopRequireDefault(_RootGroupMemberships);
	
	var _RootGroup = __webpack_require__(943);
	
	var _GroupConstants = __webpack_require__(991);
	
	var _GroupMembershipConstants = __webpack_require__(1011);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var GroupActions = {
	  // TODO kill this action that's not an action (doesn't even dispatch)
	  searchGroupByCode: function searchGroupByCode(groupCode) {
	    return _Group2.default.fetchByCode(groupCode);
	  },
	  loadGroups: function loadGroups(classUuids) {
	    var _this = this;
	
	    return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	      var allMine, query, data, classes, groups;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              allMine = classUuids === undefined;
	              query = allMine ? (0, _graphqlTag2.default)(_templateObject, _classesDefaultsFragment2.default) : (0, _graphqlTag2.default)(_templateObject2, _classesDefaultsFragment2.default);
	              _context.next = 4;
	              return _RemindAPI2.default.execute(query, { classUuids: classUuids });
	
	            case 4:
	              data = _context.sent;
	              classes = allMine ? data.me.ownedClasses.concat(data.me.subscribedClasses, data.me.organizationClasses, data.me.districtClasses) : data.classes;
	              groups = classes.filter(Boolean) // GraphQL returns null for unavailable values
	              .map(function (group) {
	                return _Group2.default.fromJSON(group);
	              });
	
	
	              _Dispatcher.dispatcher.dispatch({
	                type: _GroupConstants.ActionTypes.LIST_GROUPS,
	                groups: groups,
	                allMine: allMine
	              });
	
	              return _context.abrupt('return', groups);
	
	            case 9:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  resetStore: function resetStore() {
	    _Dispatcher.dispatcher.dispatch({
	      type: _GroupConstants.ActionTypes.RESET_STORE
	    });
	  },
	  loadPotentialOwners: function loadPotentialOwners(group) {
	    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
	
	    return group.loadPotentialOwners(page, perPage).then(function (potentialOwners) {
	      /* todo dispatch event, unnecessary for now */
	      return potentialOwners;
	    });
	  },
	  loadRootGroupMemberships: function loadRootGroupMemberships() {
	    var _this2 = this;
	
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	      var data, members, groupMembers;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              data = _extends({
	                page: 1,
	                perPage: _Group.GROUP_MEMBER_PAGE_SIZE
	              }, params);
	              _context2.next = 3;
	              return _RootGroupMemberships2.default.fetch({ data: data });
	
	            case 3:
	              members = _context2.sent;
	              groupMembers = members.getGroupMemberships();
	
	
	              _Dispatcher.dispatcher.dispatch({
	                type: _GroupMembershipConstants.ActionTypes.LOAD_CLASS_MEMBERS,
	                members: groupMembers,
	                group: _RootGroup.rootGroup,
	                membersRequested: data.perPage,
	                query: data.query
	              });
	
	              return _context2.abrupt('return', groupMembers);
	
	            case 7:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }))();
	  },
	  loadGroupMemberships: function loadGroupMemberships(group) {
	    var _this3 = this;
	
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return _asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
	      var members;
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              if (!group.isRoot()) {
	                _context3.next = 2;
	                break;
	              }
	
	              return _context3.abrupt('return', _this3.loadRootGroupMemberships(params));
	
	            case 2:
	              _context3.next = 4;
	              return group.loadGroupMemberships(params);
	
	            case 4:
	              members = _context3.sent;
	
	
	              _Dispatcher.dispatcher.dispatch({
	                type: _GroupMembershipConstants.ActionTypes.LOAD_CLASS_MEMBERS,
	                membersRequested: params.perPage || _Group.GROUP_MEMBER_PAGE_SIZE,
	                query: params.query || '',
	                members: members,
	                group: group
	              });
	
	              return _context3.abrupt('return', members);
	
	            case 7:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this3);
	    }))();
	  },
	  loadArchivedGroups: function loadArchivedGroups() {
	    var _this4 = this;
	
	    return _asyncToGenerator(regeneratorRuntime.mark(function _callee4() {
	      var groups;
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _context4.next = 2;
	              return _Groups2.default.fetchArchived();
	
	            case 2:
	              groups = _context4.sent;
	
	
	              _Dispatcher.dispatcher.dispatch({
	                type: _GroupConstants.ActionTypes.LIST_ARCHIVED_GROUPS,
	                groups: groups
	              });
	
	            case 4:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this4);
	    }))();
	  },
	
	
	  // $FlowFixMe
	  addSubscribers: function addSubscribers(group, subscribers) {
	    return group.addSubscribers(subscribers).then(function (members) {
	      // TODO: This is temporary. This is needed to ensure visible views get the correct state since
	      // subscribing to a group no longer gets a Subscription object.
	      var relationshipUpdates = members.map(function (member) {
	        return _RelationshipActions2.default.updateRelationship(member.getUserId());
	      });
	      return Promise.all(relationshipUpdates);
	    });
	  },
	  promoteGroupMemberships: function promoteGroupMemberships(group, memberIds) {
	    var _this5 = this;
	
	    return _asyncToGenerator(regeneratorRuntime.mark(function _callee5() {
	      var members;
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _context5.next = 2;
	              return group.promoteGroupMemberships(memberIds);
	
	            case 2:
	              members = _context5.sent;
	
	              _Dispatcher.dispatcher.dispatch({
	                type: _GroupMembershipConstants.ActionTypes.PROMOTED_CLASS_MEMBERS,
	                members: members,
	                group: group
	              });
	              return _context5.abrupt('return', members);
	
	            case 5:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this5);
	    }))();
	  },
	  resignOwnership: function resignOwnership(group) {
	    var _this6 = this;
	
	    return _asyncToGenerator(regeneratorRuntime.mark(function _callee6() {
	      return regeneratorRuntime.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              _context6.next = 2;
	              return group.resignOwnership();
	
	            case 2:
	
	              _Dispatcher.dispatcher.dispatch({
	                type: _GroupConstants.ActionTypes.RESIGN_OWNERSHIP,
	                group: group
	              });
	
	            case 3:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this6);
	    }))();
	  },
	
	
	  // $FlowFixMe
	  removeMember: function removeMember(group, subscriber) {
	    return group.removeMember(subscriber).then(function () {
	      _Dispatcher.dispatcher.dispatch({
	        type: _GroupMembershipConstants.ActionTypes.REMOVE_SUBSCRIBER,
	        subscriber: subscriber
	      });
	
	      // TODO: This is temporary. This is needed to ensure visible views get the correct state since
	      // subscribing to a group no longer gets a Subscription object.
	      return _RelationshipActions2.default.updateRelationship(subscriber.id);
	    });
	  },
	  create: function create(groupToCreate) {
	    var _this7 = this;
	
	    return _asyncToGenerator(regeneratorRuntime.mark(function _callee7() {
	      var group;
	      return regeneratorRuntime.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              _context7.next = 2;
	              return groupToCreate.create();
	
	            case 2:
	              group = _context7.sent;
	
	
	              _Dispatcher.dispatcher.dispatch({
	                type: _GroupConstants.ActionTypes.CREATE_GROUP,
	                groups: [group]
	              });
	
	              return _context7.abrupt('return', group);
	
	            case 5:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this7);
	    }))();
	  },
	  patch: function patch(groupToPatch, attributes, toastText) {
	    var showToast = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	    return groupToPatch.patch(attributes).then(function (group) {
	      if (attributes.organization_id !== undefined) {
	        _Dispatcher.dispatcher.dispatch({
	          type: _GroupConstants.ActionTypes.CHANGE_ORG,
	          groupUuid: group.getUuid()
	        });
	      }
	
	      if (showToast) {
	        _ToastActions2.default.showSuccessToast(toastText || 'Saved');
	      }
	
	      _Dispatcher.dispatcher.dispatch({
	        type: _GroupConstants.ActionTypes.UPDATE_GROUP,
	        group: group
	      });
	
	      return group;
	    });
	  },
	
	
	  // $FlowFixMe
	  setGroupsAllowedToStartChat: function setGroupsAllowedToStartChat(groupsToAllow) {
	    return _Groups2.default.setGroupsAllowedToStartChat(groupsToAllow).then(function (groups) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _GroupConstants.ActionTypes.GROUPS_UPDATED,
	        groups: groups
	      });
	    });
	  },
	
	
	  // $FlowFixMe
	  sendAgainGroupMessage: function sendAgainGroupMessage(groupId, oldMessage) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _GroupConstants.ActionTypes.SEND_AGAIN,
	      groupId: groupId,
	      message: oldMessage.reuse()
	    });
	  },
	  subscribeToGroup: function subscribeToGroup(groupToSubscribe) {
	    return groupToSubscribe.subscribe().then(function (group) {
	      var org = group.getOrganization();
	      if (org) {
	        _OrganizationActions2.default.getOrLoadOrganization(org.id);
	      }
	
	      // TODO: This is temporary. This is needed to ensure visible views get the correct state
	      // since subscribing to a group no longer gets a Subscription object.
	      var relationshipUpdates = group.getOwners().map(function (member) {
	        return _RelationshipActions2.default.updateRelationship(member.getUserId());
	      });
	      return Promise.all(relationshipUpdates).then(function () {
	        _Dispatcher.dispatcher.dispatch({
	          type: _GroupConstants.ActionTypes.SUBSCRIBED,
	          group: group
	        });
	        return group;
	      });
	    }, function (e) {
	      if (e.code === 'duplicate_membership') {
	        console.warn(e);
	      } else {
	        throw e;
	      }
	    });
	  },
	  subscribeToGroupWithCode: function subscribeToGroupWithCode(code) {
	    return this.subscribeToGroup(_Group2.default.createGroupFromCode(code));
	  },
	  unsubscribeFromGroup: function unsubscribeFromGroup(group) {
	    return group.unsubscribe().then(function () {
	      // TODO: This is temporary. This is needed to ensure visible views get the correct state since
	      // subscribing to a group no longer gets a Subscription object.
	      var relationshipUpdates = group.getOwners().map(function (member) {
	        return _RelationshipActions2.default.updateRelationship(member.getUserId());
	      });
	      return Promise.all(relationshipUpdates).then(function () {
	        _Dispatcher.dispatcher.dispatch({
	          type: _GroupConstants.ActionTypes.UNSUBSCRIBED,
	          group: group
	        });
	        return group;
	      });
	    });
	  },
	  removeGroup: function removeGroup(group) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _GroupConstants.ActionTypes.DELETE_GROUP,
	      group: group
	    });
	  },
	  archiveGroup: function archiveGroup(groupToArchive) {
	    var _this8 = this;
	
	    return _asyncToGenerator(regeneratorRuntime.mark(function _callee8() {
	      var group;
	      return regeneratorRuntime.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              _context8.next = 2;
	              return groupToArchive.archive();
	
	            case 2:
	              group = _context8.sent;
	
	
	              _Dispatcher.dispatcher.dispatch({
	                type: _GroupConstants.ActionTypes.ARCHIVE,
	                group: group
	              });
	
	              return _context8.abrupt('return', group);
	
	            case 5:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, _this8);
	    }))();
	  },
	  reuseGroup: function reuseGroup(archivedGroup, organizationId, classCode) {
	    var _this9 = this;
	
	    return _asyncToGenerator(regeneratorRuntime.mark(function _callee9() {
	      var group;
	      return regeneratorRuntime.wrap(function _callee9$(_context9) {
	        while (1) {
	          switch (_context9.prev = _context9.next) {
	            case 0:
	              _context9.next = 2;
	              return archivedGroup.reuse(organizationId, classCode);
	
	            case 2:
	              group = _context9.sent;
	
	
	              _Dispatcher.dispatcher.dispatch({
	                type: _GroupConstants.ActionTypes.REUSE,
	                group: group,
	                archivedGroup: archivedGroup
	              });
	
	              return _context9.abrupt('return', group);
	
	            case 5:
	            case 'end':
	              return _context9.stop();
	          }
	        }
	      }, _callee9, _this9);
	    }))();
	  },
	  archiveAndReuseGroup: function archiveAndReuseGroup(groupToArchive, organizationId, classCode) {
	    var _this10 = this;
	
	    return _asyncToGenerator(regeneratorRuntime.mark(function _callee10() {
	      var archivedGroup, group;
	      return regeneratorRuntime.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              _context10.next = 2;
	              return groupToArchive.archive();
	
	            case 2:
	              archivedGroup = _context10.sent;
	              _context10.next = 5;
	              return archivedGroup.reuse(organizationId, classCode);
	
	            case 5:
	              group = _context10.sent;
	
	
	              _Dispatcher.dispatcher.dispatch({
	                type: _GroupConstants.ActionTypes.ARCHIVE_AND_REUSE,
	                group: group,
	                archivedGroup: archivedGroup
	              });
	
	              return _context10.abrupt('return', group);
	
	            case 8:
	            case 'end':
	              return _context10.stop();
	          }
	        }
	      }, _callee10, _this10);
	    }))();
	  },
	  restoreGroup: function restoreGroup(groupToRestore, organizationId, classCode) {
	    var group = groupToRestore.unarchive(organizationId, classCode);
	
	    _Dispatcher.dispatcher.dispatch({
	      type: _GroupConstants.ActionTypes.RESTORE,
	      group: group
	    });
	
	    return group;
	  },
	  enableAllGroupMessageHistory: function enableAllGroupMessageHistory() {
	    _RemindAPI2.default.request('/classes', 'PATCH', {
	      all: {
	        message_history_enabled: true
	      }
	    });
	  }
	};
	
	exports.default = GroupActions;

/***/ },
/* 995 */
/***/ function(module, exports) {

	module.exports = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"classesDefaults"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Class"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"class_name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"pdf_url"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"join_url"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"has_children"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"searchable"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"has_non_teacher_owner"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"message_history_enabled"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"subscribe"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"email"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"pretty"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"raw"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"uri"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"sms"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"pretty"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"raw"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"uri"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"sms_alternate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"pretty"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"raw"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"uri"},"arguments":[],"directives":[],"selectionSet":null}]}}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"possessive_name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"subscribers_count"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"memberships_count"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"subscriber_initiated_chats"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"staff_class_org_id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"type"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"group_avatar"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"svg_url"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"color"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"organization"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"type"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"paid"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"original_organization_id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"archived_at"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"unread_messages"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"messages_count"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"last_read_seq_str"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_relinquish_ownership"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_delete"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_edit"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_leave"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_post"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_join"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_add_people"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"postable_roles"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"owners"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"group_id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_become_owner"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_unsubscribe"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_chat"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"chat_eligibility_state"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"role"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"tag"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"query_key"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"mediums"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"devices"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"type"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"verified"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"friendly_name"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"first_name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"last_name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"short_name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"signature"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"role"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"color"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"reachability_state"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"reachability"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"state"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"medium"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"note"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"notable"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"blocked"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_be_copied_to_class"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"chat_eligibility_state"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"untrusted_name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"office_hours"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"available"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"day"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"start_time"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"end_time"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"timezone"},"arguments":[],"directives":[],"selectionSet":null}]}}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"org_affiliation_view"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"organization_id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_have_role_changed"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"possible_roles"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"potential_roles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"role"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"display_role"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"roles"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"pending_roles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"role"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"is_opted_in"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"is_email_confirmed"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"is_affirmed"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"official_email"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"is_member"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_change_role_until"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_request_message_history"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_remove_from_org"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_remove_from_group"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_change_role"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_admin"},"arguments":[],"directives":[],"selectionSet":null}]}}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"roles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"role"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"count"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"threads"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"role"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"preview"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"preview"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"sent_at"},"arguments":[],"directives":[],"selectionSet":null}]}}]}}]}}],"loc":{"start":0,"end":2190,"source":{"body":"fragment classesDefaults on Class {\n  id\n  uuid\n  class_name\n  name\n  pdf_url\n  join_url\n  has_children\n  searchable\n  has_non_teacher_owner\n  message_history_enabled\n  subscribe {\n    email {\n      pretty\n      raw\n      uri\n    }\n    sms {\n      pretty\n      raw\n      uri\n    }\n    sms_alternate {\n      pretty\n      raw\n      uri\n    }\n  }\n  possessive_name\n  subscribers_count\n  memberships_count\n  subscriber_initiated_chats\n  staff_class_org_id\n  type\n  group_avatar {\n    id\n    svg_url\n    color\n  }\n  organization {\n    id\n    name\n    type\n    paid\n  }\n  original_organization_id\n  archived_at\n  unread_messages\n  messages_count\n  last_read_seq_str\n  can_relinquish_ownership\n  permissions {\n    can_delete\n    can_edit\n    can_leave\n    can_post\n    can_join\n    can_add_people\n    postable_roles\n  }\n  owners {\n    id\n    group_id\n    can_become_owner\n    can_unsubscribe\n    can_chat\n    chat_eligibility_state\n    role\n    tag\n    query_key\n    created_at\n    user {\n      id\n      uuid\n      mediums\n      devices {\n        type\n        enabled\n        verified\n        friendly_name\n      }\n      name\n      first_name\n      last_name\n      short_name\n      signature\n      role\n      color\n      initials\n      reachability_state\n      reachability {\n        state\n        medium\n      }\n      note\n      notable\n      blocked\n      can_be_copied_to_class\n      chat_eligibility_state\n      untrusted_name\n      office_hours {\n        available {\n          day\n          start_time\n          end_time\n        }\n        timezone\n      }\n    }\n    org_affiliation_view {\n      organization_id\n      can_have_role_changed\n      possible_roles\n      potential_roles {\n        role\n        display_role\n      }\n      roles\n      pending_roles {\n        role\n        is_opted_in\n        is_email_confirmed\n        is_affirmed\n        official_email\n      }\n      is_member\n      can_change_role_until\n    }\n    permissions {\n      can_request_message_history\n      can_remove_from_org\n      can_remove_from_group\n      can_change_role\n      can_admin\n    }\n  }\n  roles {\n    role\n    count\n  }\n  threads {\n    uuid\n    role\n    preview {\n      preview\n      sent_at\n    }\n  }\n}\n","name":"GraphQL"}}};

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _Subscribers = __webpack_require__(997);
	
	var _Subscribers2 = _interopRequireDefault(_Subscribers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupMemberships = function (_Collection) {
	  _inherits(GroupMemberships, _Collection);
	
	  function GroupMemberships() {
	    _classCallCheck(this, GroupMemberships);
	
	    return _possibleConstructorReturn(this, (GroupMemberships.__proto__ || Object.getPrototypeOf(GroupMemberships)).apply(this, arguments));
	  }
	
	  _createClass(GroupMemberships, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.url = '/members';
	      this.model = _GroupMembership2.default;
	    }
	  }, {
	    key: 'comparator',
	    value: function comparator(a, b) {
	      var nameA = a.getUser().getFirstName();
	      var nameB = b.getUser().getFirstName();
	      return nameA.localeCompare(nameB);
	    }
	  }, {
	    key: 'sortByFirstName',
	    value: function sortByFirstName() {
	      return this.sortBy(function (member) {
	        var user = member.getUser();
	        return (user.getFirstName() + ' ' + user.getLastName()).toLowerCase();
	      });
	    }
	  }, {
	    key: 'sortByLastName',
	    value: function sortByLastName() {
	      return this.sortBy(function (member) {
	        var user = member.getUser();
	        return (user.getLastName() + ', ' + user.getFirstName()).toLowerCase();
	      });
	    }
	  }, {
	    key: 'sortByCreatedAt',
	    value: function sortByCreatedAt() {
	      return this.sortBy(function (member) {
	        return -member.getCreatedAt();
	      });
	    }
	  }, {
	    key: 'sortByOrganizationRole',
	    value: function sortByOrganizationRole() {
	      return this.sortBy(function (member) {
	        var orgAffView = member.getOrgAffiliationView();
	        return orgAffView ? orgAffView.roles.join(',') : '';
	      });
	    }
	  }, {
	    key: 'groupByRole',
	    value: function groupByRole() {
	      var members = this.groupBy('role');
	      return new GroupMemberships([].concat(members['owner'] || [], members['subscriber'] || []), { sort: false });
	    }
	  }, {
	    key: 'getSubscribers',
	    value: function getSubscribers() {
	      return new _Subscribers2.default(this.map(function (member) {
	        return member.getUser();
	      }));
	    }
	  }]);
	
	  return GroupMemberships;
	}(_Collection3.default);
	
	GroupMemberships.displayName = 'GroupMemberships';
	exports.default = GroupMemberships;

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Subscribers = function (_Collection) {
	  _inherits(Subscribers, _Collection);
	
	  function Subscribers() {
	    _classCallCheck(this, Subscribers);
	
	    return _possibleConstructorReturn(this, (Subscribers.__proto__ || Object.getPrototypeOf(Subscribers)).apply(this, arguments));
	  }
	
	  _createClass(Subscribers, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.url = '/subscribers';
	      this.model = _Subscriber2.default;
	    }
	  }, {
	    key: 'comparator',
	    value: function comparator(a, b) {
	      return a.getName().localeCompare(b.getName());
	    }
	  }, {
	    key: 'sortByFirstName',
	    value: function sortByFirstName() {
	      return this.sortBy(function (subscriber) {
	        return (subscriber.getFirstName() + ' ' + subscriber.getLastName()).toLowerCase();
	      });
	    }
	  }, {
	    key: 'sortByLastName',
	    value: function sortByLastName() {
	      return this.sortBy(function (subscriber) {
	        return (subscriber.getLastName() + ', ' + subscriber.getFirstName()).toLowerCase();
	      });
	    }
	  }, {
	    key: 'sortBySubscribedAt',
	    value: function sortBySubscribedAt() {
	      return this.sortBy(function (subscriber) {
	        return -subscriber.getSubscribedAt();
	      });
	    }
	  }], [{
	    key: 'export',
	    value: function _export(groupIds) {
	      return (0, _apiRequest2.default)('/subscribers/export', 'POST', {
	        group_ids: groupIds
	      });
	    }
	  }]);
	
	  return Subscribers;
	}(_Collection3.default);
	
	Subscribers.displayName = 'Subscribers';
	exports.default = Subscribers;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n      ', '\n\n      query {\n        me {\n          id\n          organizations {\n            ...organizationDefault\n          }\n        }\n      }'], ['\n      ', '\n\n      query {\n        me {\n          id\n          organizations {\n            ...organizationDefault\n          }\n        }\n      }']),
	    _templateObject2 = _taggedTemplateLiteral(['\n      ', '\n      query ($orgIds: [Int]!) {\n        organizations(ids: $orgIds) {\n           ...organizationDefault\n        }\n      }'], ['\n      ', '\n      query ($orgIds: [Int]!) {\n        organizations(ids: $orgIds) {\n           ...organizationDefault\n        }\n      }']);
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _Organizations = __webpack_require__(1002);
	
	var _Organizations2 = _interopRequireDefault(_Organizations);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _organizationDefaultFragment = __webpack_require__(1005);
	
	var _organizationDefaultFragment2 = _interopRequireDefault(_organizationDefaultFragment);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _OrganizationConstants = __webpack_require__(1004);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var OrganizationActions = {
	  /**
	   * Get the organization from the store. If isn't available then load it from
	   * the server.
	   */
	  getOrLoadOrganization: function getOrLoadOrganization(id) {
	    var preloadedOrg = _OrganizationStore2.default.getOrganization(id);
	    if (preloadedOrg) {
	      return Promise.resolve(preloadedOrg);
	    } else {
	      return this.loadOrganization(id);
	    }
	  },
	
	
	  /**
	   * Fetch all the organizations with which the current user is affiliated.
	   */
	  loadUserOrganizations: function loadUserOrganizations() {
	    var _this = this;
	
	    return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	      var query, data, organizations;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              query = (0, _graphqlTag2.default)(_templateObject, _organizationDefaultFragment2.default);
	              _context.next = 3;
	              return _RemindAPI2.default.execute(query);
	
	            case 3:
	              data = _context.sent;
	              organizations = data.me.organizations.map(function (org) {
	                return _Organization2.default.fromJSON(org);
	              });
	
	
	              _Dispatcher.dispatcher.dispatch({
	                type: _OrganizationConstants.ActionTypes.LOAD_USER_ORGANIZATIONS,
	                organizations: _Organizations2.default.fromJSON(organizations)
	              });
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	
	  /**
	   * Fetch the organization from the server.
	   */
	  loadOrganization: function loadOrganization(id) {
	    var _this2 = this;
	
	    return _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	      var query, orgIds, data, organization;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              query = (0, _graphqlTag2.default)(_templateObject2, _organizationDefaultFragment2.default);
	              orgIds = [id];
	              _context2.next = 4;
	              return _RemindAPI2.default.execute(query, { orgIds: orgIds });
	
	            case 4:
	              data = _context2.sent;
	              organization = _Organization2.default.fromJSON(data.organizations[0]);
	
	
	              _Dispatcher.dispatcher.dispatch({
	                type: _OrganizationConstants.ActionTypes.LOAD_ORGANIZATION,
	                organization: organization
	              });
	              return _context2.abrupt('return', organization);
	
	            case 8:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }))();
	  },
	  createOrganization: function createOrganization(attr) {
	    // don't hit api if user isn't logged in, since school picker is used on admin waitlist
	    // and unauthed users may want to create a school if it's not there
	    if (!_CurrentUser2.default.isSignedIn()) {
	      return Promise.resolve(new _Organization2.default(attr));
	    }
	    return new _Organization2.default(attr).create();
	  },
	  addOrganization: function addOrganization(organization) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _OrganizationConstants.ActionTypes.LOAD_ORGANIZATION,
	      organization: organization
	    });
	  },
	  removeOrganization: function removeOrganization(orgId) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _OrganizationConstants.ActionTypes.REMOVE_ORGANIZATION,
	      orgId: orgId
	    });
	  },
	
	
	  /**
	   * Adds a set of users to an organization via the admin's direct add flow
	   * @param {array} users an array of JSON objects with first_name, last_name and email
	   * @return {Promise} for a job status object that can be pinged for results
	   */
	  addUsers: function addUsers(users, role, orgId) {
	    return _RemindAPI2.default.request('/organizations/' + orgId + '/' + role, 'POST', { users: users });
	  },
	  batchRequestTranscript: function batchRequestTranscript(orgId, transcripts, note, inclChat, inclAnnouncements) {
	    return _RemindAPI2.default.request('/organizations/' + orgId + '/email_transcript/batch', 'POST', {
	      incl_announcements: inclAnnouncements,
	      incl_chat: inclChat,
	      transcripts: transcripts,
	      note: note
	    });
	  },
	  batchRemoveFromOrg: function batchRemoveFromOrg(orgId, userIds, reason) {
	    return _RemindAPI2.default.request('/organizations/' + orgId + '/users/batch', 'DELETE', { reason: reason, user_ids: userIds });
	  },
	  batchBanFromOrg: function batchBanFromOrg(orgId, userIds, reason) {
	    _ToastActions2.default.showErrorToast('Not yet implemented'); // TODO
	    return _RemindAPI2.default.request('/organizations/' + orgId + '/users/ban/batch', 'POST', { reason: reason, user_ids: userIds });
	  },
	  reportUserAsAdmin: function reportUserAsAdmin(orgId, userId, reason, notes) {
	    return _RemindAPI2.default.request('/organizations/' + orgId + '/users/' + userId + '/report', 'POST', { reason: reason, notes: notes });
	  }
	};
	
	exports.default = OrganizationActions;

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _Group = __webpack_require__(606);
	
	var _schoolCircle = __webpack_require__(1000);
	
	var _schoolCircle2 = _interopRequireDefault(_schoolCircle);
	
	var _district = __webpack_require__(1001);
	
	var _district2 = _interopRequireDefault(_district);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Organization = function (_Entity) {
	  _inherits(Organization, _Entity);
	
	  function Organization() {
	    _classCallCheck(this, Organization);
	
	    return _possibleConstructorReturn(this, (Organization.__proto__ || Object.getPrototypeOf(Organization)).apply(this, arguments));
	  }
	
	  _createClass(Organization, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.urlRoot = '/organizations';
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        admins: []
	      };
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.get('type') || 'School';
	    }
	  }, {
	    key: 'getCity',
	    value: function getCity() {
	      return this.get('city');
	    }
	  }, {
	    key: 'getState',
	    value: function getState() {
	      return this.get('state');
	    }
	  }, {
	    key: 'getFormattedAddress',
	    value: function getFormattedAddress() {
	      return [this.getCity(), this.getState()].filter(function (value) {
	        return value;
	      }).join(', ');
	    }
	  }, {
	    key: 'getMemberSampleString',
	    value: function getMemberSampleString() {
	      return this.get('members_sample_string');
	    }
	  }, {
	    key: 'getMemberCount',
	    value: function getMemberCount() {
	      return this.get('members_count');
	    }
	  }, {
	    key: 'getAdmins',
	    value: function getAdmins() {
	      return this.get('admins');
	    }
	  }, {
	    key: 'getLatitude',
	    value: function getLatitude() {
	      return this.get('latitude');
	    }
	  }, {
	    key: 'getLongitude',
	    value: function getLongitude() {
	      return this.get('longitude');
	    }
	  }, {
	    key: 'getNCESId',
	    value: function getNCESId() {
	      return this.get('nces_id');
	    }
	  }, {
	    key: 'getAccentColor',
	    value: function getAccentColor() {
	      return _Group.DEFAULT_COLOR;
	    }
	  }, {
	    key: 'getStatistics',
	    value: function getStatistics() {
	      return this.get('org_stats');
	    }
	  }, {
	    key: 'getAvatarUrl',
	    value: function getAvatarUrl() {
	      var type = this.get('type');
	
	      if (type === 'School') {
	        return _schoolCircle2.default;
	      } else if (type === 'District') {
	        return _district2.default;
	      }
	
	      throw new Error('Unsupported organization type ' + type);
	    }
	  }, {
	    key: 'hasAdmins',
	    value: function hasAdmins() {
	      return this.getAdmins().length > 0;
	    }
	  }, {
	    key: 'isAdminBy',
	    value: function isAdminBy(user) {
	      return this.getAdmins().some(function (admin) {
	        return admin.id === user.id;
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create() {
	      return (0, _apiRequest2.default)('/organizations', 'POST', {
	        organization: {
	          name: this.getName(),
	          city: this.getCity(),
	          state: this.getState(),
	          type: this.getType()
	        }
	      }).then(function (org) {
	        return Organization.fromJSON(org);
	      });
	    }
	  }]);
	
	  return Organization;
	}(_Entity3.default);
	
	Organization.displayName = 'Organization';
	exports.default = Organization;

/***/ },
/* 1000 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 1001 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Organizations = function (_Collection) {
	  _inherits(Organizations, _Collection);
	
	  function Organizations() {
	    _classCallCheck(this, Organizations);
	
	    return _possibleConstructorReturn(this, (Organizations.__proto__ || Object.getPrototypeOf(Organizations)).apply(this, arguments));
	  }
	
	  _createClass(Organizations, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _Organization2.default;
	    }
	  }], [{
	    key: 'suggest',
	    value: function suggest() {
	      return (0, _apiRequest2.default)('/organizations/suggested', 'GET').then(function (response) {
	        return Organizations.fromJSON(response);
	      });
	    }
	  }, {
	    key: 'search',
	    value: function search(queryType, query, page, perPage) {
	      var options = {
	        type: queryType.toLowerCase(),
	        query: query,
	        page: page || 1,
	        per_page: perPage || 20
	      };
	
	      return (0, _apiRequest2.default)('/organizations/find', 'GET', options).then(function (response) {
	        return Organizations.fromJSON(response);
	      });
	    }
	  }]);
	
	  return Organizations;
	}(_Collection3.default);
	
	Organizations.displayName = 'Organizations';
	exports.default = Organizations;

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _Organizations = __webpack_require__(1002);
	
	var _Organizations2 = _interopRequireDefault(_Organizations);
	
	var _OrganizationConstants = __webpack_require__(1004);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrganizationStore = function (_Store) {
	  _inherits(OrganizationStore, _Store);
	
	  function OrganizationStore() {
	    _classCallCheck(this, OrganizationStore);
	
	    return _possibleConstructorReturn(this, (OrganizationStore.__proto__ || Object.getPrototypeOf(OrganizationStore)).apply(this, arguments));
	  }
	
	  _createClass(OrganizationStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        organizations: new _Organizations2.default(),
	        userOrgsLoaded: false
	      };
	    }
	  }, {
	    key: 'isLoaded',
	    value: function isLoaded() {
	      return this.state.userOrgsLoaded;
	    }
	  }, {
	    key: 'getOrganization',
	    value: function getOrganization(id) {
	      return this.state.organizations.get(id);
	    }
	  }, {
	    key: 'addOrganization',
	    value: function addOrganization(organization) {
	      this.state.organizations.add(organization);
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      switch (action.type) {
	        case _OrganizationConstants.ActionTypes.LOAD_ORGANIZATION:
	          this.handleLoad([action.organization]);
	          break;
	        case _OrganizationConstants.ActionTypes.LOAD_USER_ORGANIZATIONS:
	          this.state.userOrgsLoaded = true;
	          this.handleLoad(action.organizations);
	          break;
	        case _OrganizationConstants.ActionTypes.REMOVE_ORGANIZATION:
	          this.state.organizations.remove(action.orgId);
	          this.emitChange();
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'handleLoad',
	    value: function handleLoad(organizations) {
	      var _this2 = this;
	
	      organizations.forEach(function (organization) {
	        return _this2.addOrganization(organization);
	      });
	      this.emitChange();
	    }
	  }]);
	
	  return OrganizationStore;
	}(_Store3.default);
	
	OrganizationStore.displayName = 'OrganizationStore';
	exports.default = new OrganizationStore();

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrganizationTypes = exports.UNAFFILIATED = exports.NO_SCHOOL = exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['LOAD_ORGANIZATION', 'LOAD_USER_ORGANIZATIONS', 'REMOVE_ORGANIZATION', 'REMOVE_ADMIN_ROLE', 'UPDATE_CURRENT_USER_ORGANIZATION_AFFILIATION', 'UPDATE_ORG_AFF_VIEW']);
	
	var NO_SCHOOL = exports.NO_SCHOOL = new _Organization2.default({ id: null, name: 'I don’t work at a school' });
	var UNAFFILIATED = exports.UNAFFILIATED = new _Organization2.default({ id: null, name: 'Not affiliated with a school' });
	
	var OrganizationTypes = exports.OrganizationTypes = {
	  DISTRICT: 'DISTRICT',
	  SCHOOL: 'SCHOOL'
	};

/***/ },
/* 1005 */
/***/ function(module, exports) {

	module.exports = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"organizationDefault"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"type"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"subtype"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"subsubtype"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"grade_level"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"grade_level_code"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"street"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"city"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"state"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"zip"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"longitude"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"nces_id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"state_id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"district_name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"nces_district_id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"members_count"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"admins"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"role"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"members_sample_string"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"parent_id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"user_affiliation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"organization_id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_have_role_changed"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"potential_roles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"role"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"display_role"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"roles"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"pending_roles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"role"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"is_affirmed"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"is_opted_in"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"is_email_confirmed"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"official_email"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"is_member"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"can_change_role_until"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"is_parent_org_admin"},"arguments":[],"directives":[],"selectionSet":null}]}}],"loc":{"start":0,"end":766,"source":{"body":"fragment organizationDefault on Organization {\n  id\n  name\n  type\n  subtype\n  subsubtype\n  grade_level\n  grade_level_code\n  street\n  city\n  state\n  zip\n  latitude\n  longitude\n  nces_id\n  state_id\n  district_name\n  nces_district_id\n  members_count\n  admins {\n    id\n    name\n    role\n  }\n  members_sample_string\n  parent_id\n  # v2 returns this but we never use it\n  # class {\n  #   ...classesDefaults\n  # }\n  user_affiliation {\n    organization_id\n    can_have_role_changed\n    # DEPRECATED\n    # possible_roles\n    potential_roles {\n      role\n      display_role\n    }\n    roles\n    pending_roles {\n      role\n      is_affirmed\n      is_opted_in\n      is_email_confirmed\n      official_email\n    }\n    is_member\n    can_change_role_until\n  }\n  is_parent_org_admin\n}\n","name":"GraphQL"}}};

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Relationship = __webpack_require__(1007);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _RelationshipConstants = __webpack_require__(986);
	
	var _Dispatcher = __webpack_require__(590);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RelationshipActions = {
	  loadRelationship: function loadRelationship(userId) {
	    return _Relationship2.default.fetch({ id: userId }).then(function (relationship) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _RelationshipConstants.ActionTypes.LOAD_RELATIONSHIP,
	        relationship: relationship
	      });
	      return relationship;
	    });
	  },
	
	
	  // Use updateRelationship instead of loadRelationship in cases where it is possible to no longer
	  // have a relationship with the user (i.e. unsubscribing & removing user from a class)
	  updateRelationship: function updateRelationship(userId) {
	    return this.loadRelationship(userId).catch(function () {
	      _Dispatcher.dispatcher.dispatch({
	        type: _RelationshipConstants.ActionTypes.DELETE,
	        userId: userId
	      });
	    });
	  },
	  updateName: function updateName(relatedUserId, firstName, lastName) {
	    return _Relationship2.default.updateName(relatedUserId, firstName, lastName).then(function (relationship) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _RelationshipConstants.ActionTypes.UPDATE_RELATIONSHIP,
	        relationship: relationship
	      });
	      return relationship;
	    });
	  },
	  updateNote: function updateNote(relatedUserId, note) {
	    return _Relationship2.default.updateNote(relatedUserId, note).then(function (relationship) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _RelationshipConstants.ActionTypes.UPDATE_RELATIONSHIP,
	        relationship: relationship
	      });
	      return relationship;
	    });
	  },
	  confirmUntrustedName: function confirmUntrustedName(relatedUserId) {
	    return _Relationship2.default.confirmUntrustedName(relatedUserId).then(function (relationship) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _RelationshipConstants.ActionTypes.UPDATE_RELATIONSHIP,
	        relationship: relationship
	      });
	      return relationship;
	    });
	  },
	  block: function block(relatedUserId, relatedUserName) {
	    var successMessage = relatedUserName + ' was successfully blocked.';
	    var errorMessage = 'Unable to block ' + relatedUserName + '.';
	    _Relationship2.default.block(relatedUserId).then(function (relationship) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _RelationshipConstants.ActionTypes.UPDATE_RELATIONSHIP,
	        relationship: relationship
	      });
	      return relationship;
	    }).then(function () {
	      return _ToastActions2.default.showSuccessToast(successMessage);
	    }).catch(function () {
	      return _ToastActions2.default.showErrorToast(errorMessage);
	    });
	  },
	  unblock: function unblock(relatedUserId, relatedUserName) {
	    var successMessage = relatedUserName + ' was successfully unblocked.';
	    var errorMessage = 'Unable to unblock ' + relatedUserName + '.';
	    _Relationship2.default.unblock(relatedUserId).then(function (relationship) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _RelationshipConstants.ActionTypes.UPDATE_RELATIONSHIP,
	        relationship: relationship
	      });
	      return relationship;
	    }).then(function () {
	      return _ToastActions2.default.showSuccessToast(successMessage);
	    }).catch(function () {
	      return _ToastActions2.default.showErrorToast(errorMessage);
	    });
	  }
	};
	
	exports.default = RelationshipActions;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _lodash = __webpack_require__(555);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Organizations = __webpack_require__(1002);
	
	var _Organizations2 = _interopRequireDefault(_Organizations);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _Subscription = __webpack_require__(1008);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _Subscriptions = __webpack_require__(1009);
	
	var _Subscriptions2 = _interopRequireDefault(_Subscriptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var groupIsNotStaffClass = function groupIsNotStaffClass(s) {
	  return !s.getGroup().isStaffClass();
	};
	
	var Relationship = function (_Entity) {
	  _inherits(Relationship, _Entity);
	
	  function Relationship() {
	    _classCallCheck(this, Relationship);
	
	    return _possibleConstructorReturn(this, (Relationship.__proto__ || Object.getPrototypeOf(Relationship)).apply(this, arguments));
	  }
	
	  _createClass(Relationship, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.urlRoot = '/relationships';
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var relationship = (0, _lodash.clone)(response);
	      relationship['subscriptions_to_me'] = _Subscriptions2.default.fromJSON(relationship['subscriptions_to_me']);
	      relationship['subscriptions_to_user'] = _Subscriptions2.default.fromJSON(relationship['subscriptions_to_user']);
	      relationship['related_user'] = _Subscriber2.default.fromJSON(relationship['related_user']);
	      if (relationship['chat']) {
	        relationship['chat'] = _Chat2.default.fromJSON(relationship['chat']);
	      }
	      relationship['id'] = relationship['related_user']['id'];
	      relationship['common_organizations_with_user'] = _Organizations2.default.fromJSON(relationship['common_organizations_with_user']);
	      return relationship;
	    }
	  }, {
	    key: 'getRelatedUser',
	    value: function getRelatedUser() {
	      return this.get('related_user');
	    }
	  }, {
	    key: 'getSubscriptionsToMe',
	    value: function getSubscriptionsToMe() {
	      return new _Subscriptions2.default(this.get('subscriptions_to_me').filter(groupIsNotStaffClass));
	    }
	  }, {
	    key: 'getSubscriptionsToUser',
	    value: function getSubscriptionsToUser() {
	      return new _Subscriptions2.default(this.get('subscriptions_to_user').filter(groupIsNotStaffClass));
	    }
	  }, {
	    key: 'getCommonOrganizationsWithUser',
	    value: function getCommonOrganizationsWithUser() {
	      return this.get('common_organizations_with_user');
	    }
	  }, {
	    key: 'getAdminAtOrgIds',
	    value: function getAdminAtOrgIds() {
	      return this.get('admin_at_org_ids') || [];
	    }
	  }, {
	    key: 'getChat',
	    value: function getChat() {
	      return this.get('chat');
	    }
	  }, {
	    key: 'unsubscribe',
	    value: function unsubscribe(subscription) {
	      [this.get('subscriptions_to_me'), this.get('subscriptions_to_user')].forEach(function (collection) {
	        collection.remove(subscription.id);
	      });
	    }
	  }, {
	    key: 'unsubscribeFromGroup',
	    value: function unsubscribeFromGroup(group) {
	      [this.get('subscriptions_to_me'), this.get('subscriptions_to_user')].forEach(function (collection) {
	        collection.removeSubscriptionForGroup(group);
	      });
	    }
	  }, {
	    key: 'hasSubscriptions',
	    value: function hasSubscriptions() {
	      return !this.getSubscriptionsToMe().isEmpty() || !this.getSubscriptionsToUser().isEmpty();
	    }
	  }, {
	    key: 'getChatEligibilityState',
	    value: function getChatEligibilityState() {
	      return this.get('chat_eligibility_state');
	    }
	  }, {
	    key: 'isEligibleForChat',
	    value: function isEligibleForChat() {
	      return this.getChatEligibilityState() === 'eligible';
	    }
	  }, {
	    key: 'isPendingForChat',
	    value: function isPendingForChat() {
	      return this.getChatEligibilityState() === 'pending';
	    }
	  }, {
	    key: 'isUnder13',
	    value: function isUnder13() {
	      return this.getChatEligibilityState() === 'under_13';
	    }
	  }, {
	    key: 'isUnavailableForChat',
	    value: function isUnavailableForChat() {
	      return this.getChatEligibilityState() === 'unavailable';
	    }
	  }, {
	    key: 'isAgeUnknown',
	    value: function isAgeUnknown() {
	      return this.getChatEligibilityState() === 'unknown';
	    }
	  }, {
	    key: 'getOrgAffiliationViews',
	    value: function getOrgAffiliationViews() {
	      return this.get('organization_affiliations');
	    }
	  }], [{
	    key: 'updateName',
	    value: function updateName(subscriberId, firstName, lastName) {
	      return (0, _apiRequest2.default)('/relationships/' + subscriberId, 'PATCH', {
	        related_user: {
	          first_name: firstName,
	          last_name: lastName
	        }
	      }).then(function (response) {
	        return Relationship.fromJSON(response);
	      });
	    }
	  }, {
	    key: 'updateNote',
	    value: function updateNote(subscriberId, note) {
	      return (0, _apiRequest2.default)('/relationships/' + subscriberId, 'PATCH', {
	        related_user: {
	          note: note
	        }
	      }).then(function (response) {
	        return Relationship.fromJSON(response);
	      });
	    }
	  }, {
	    key: 'confirmUntrustedName',
	    value: function confirmUntrustedName(subscriberId) {
	      return (0, _apiRequest2.default)('/relationships/' + subscriberId, 'PATCH', {
	        related_user: {
	          untrusted_name: false
	        }
	      }).then(function (response) {
	        return Relationship.fromJSON(response);
	      });
	    }
	  }, {
	    key: 'block',
	    value: function block(relatedUserId) {
	      return (0, _apiRequest2.default)('/relationships/' + relatedUserId, 'PATCH', {
	        related_user: {
	          blocked: true
	        }
	      }).then(function (response) {
	        return Relationship.fromJSON(response);
	      });
	    }
	  }, {
	    key: 'unblock',
	    value: function unblock(relatedUserId) {
	      return (0, _apiRequest2.default)('/relationships/' + relatedUserId, 'PATCH', {
	        related_user: {
	          blocked: false
	        }
	      }).then(function (response) {
	        return Relationship.fromJSON(response);
	      });
	    }
	  }]);
	
	  return Relationship;
	}(_Entity3.default);
	
	Relationship.displayName = 'Relationship';
	exports.default = Relationship;

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Subscription = function (_Entity) {
	  _inherits(Subscription, _Entity);
	
	  function Subscription() {
	    _classCallCheck(this, Subscription);
	
	    return _possibleConstructorReturn(this, (Subscription.__proto__ || Object.getPrototypeOf(Subscription)).apply(this, arguments));
	  }
	
	  _createClass(Subscription, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.urlRoot = '/subscriptions';
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var subscription = _lodash2.default.clone(response);
	      subscription['group'] = _Group2.default.fromJSON(subscription['group']);
	      subscription['subscribed_at'] = new Date(subscription['subscribed_at']);
	      return subscription;
	    }
	  }, {
	    key: 'getSubscriberId',
	    value: function getSubscriberId() {
	      return this.get('subscriber_id');
	    }
	
	    /**
	     * @deprecated
	     */
	
	  }, {
	    key: 'getGroup',
	    value: function getGroup() {
	      // DIRTY HACK around cyclic dependency
	      // Problem: entities calling out to stores
	      // Deeper problem: nested models
	      // Real solution: normalize models and pull by id from stores when needed
	      var GroupStore = __webpack_require__(990).default;
	      var group = GroupStore.getGroup(this.getGroupId());
	      if (group) {
	        return group;
	      } else {
	        return this.get('group');
	      }
	    }
	  }, {
	    key: 'getGroupId',
	    value: function getGroupId() {
	      return this.get('group').id;
	    }
	  }, {
	    key: 'getSubscribedAt',
	    value: function getSubscribedAt() {
	      return this.get('subscribed_at');
	    }
	  }, {
	    key: 'toJSON',
	    value: function toJSON() {
	      var json = _get(Subscription.prototype.__proto__ || Object.getPrototypeOf(Subscription.prototype), 'toJSON', this).call(this);
	      json['group'] = this.getGroup().toJSON();
	      return json;
	    }
	  }], [{
	    key: 'initiateDeviceSubscription',
	    value: function initiateDeviceSubscription(groupCode, recipient) {
	      return (0, _apiRequest2.default)('/subscribe/' + groupCode, 'POST', {
	        recipient: recipient
	      });
	    }
	  }]);
	
	  return Subscription;
	}(_Entity3.default);
	
	Subscription.displayName = 'Subscription';
	exports.default = Subscription;

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Subscription = __webpack_require__(1008);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Subscriptions = function (_Collection) {
	  _inherits(Subscriptions, _Collection);
	
	  function Subscriptions() {
	    _classCallCheck(this, Subscriptions);
	
	    return _possibleConstructorReturn(this, (Subscriptions.__proto__ || Object.getPrototypeOf(Subscriptions)).apply(this, arguments));
	  }
	
	  _createClass(Subscriptions, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.url = '/subscriptions';
	      this.model = _Subscription2.default;
	    }
	  }, {
	    key: 'comparator',
	    value: function comparator(a, b) {
	      var nameA = a.getGroup().getName();
	      var nameB = b.getGroup().getName();
	      return nameA.localeCompare(nameB);
	    }
	  }, {
	    key: 'getGroupIds',
	    value: function getGroupIds() {
	      return this.map(function (subscription) {
	        return subscription.getGroupId();
	      });
	    }
	  }, {
	    key: 'getSubscriptionForGroup',
	    value: function getSubscriptionForGroup(group) {
	      var groupId = group.id;
	      return this.find(function (subscription) {
	        return subscription.getGroupId() === groupId;
	      });
	    }
	  }, {
	    key: 'removeSubscriptionForGroup',
	    value: function removeSubscriptionForGroup(group) {
	      var subscription = this.getSubscriptionForGroup(group);
	      if (subscription) {
	        this.remove(subscription);
	      }
	    }
	  }]);
	
	  return Subscriptions;
	}(_Collection3.default);
	
	Subscriptions.displayName = 'Subscriptions';
	exports.default = Subscriptions;

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _GroupMemberships = __webpack_require__(996);
	
	var _GroupMemberships2 = _interopRequireDefault(_GroupMemberships);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _PotentialChatMember = __webpack_require__(945);
	
	var _PotentialChatMember2 = _interopRequireDefault(_PotentialChatMember);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RootGroupMemberships = function (_Collection) {
	  _inherits(RootGroupMemberships, _Collection);
	
	  // $FlowFixMe
	  function RootGroupMemberships(models, options) {
	    _classCallCheck(this, RootGroupMemberships);
	
	    var _this = _possibleConstructorReturn(this, (RootGroupMemberships.__proto__ || Object.getPrototypeOf(RootGroupMemberships)).call(this, models, options));
	
	    _this.comparator = function (a, b) {
	      return a.getSortKey().localeCompare(b.getSortKey());
	    };
	    _this.sort();
	    return _this;
	  }
	
	  _createClass(RootGroupMemberships, [{
	    key: 'initialize',
	    value: function initialize() {
	      // FIXME: Replace PCM with GCQ before release
	      this.url = '/chats/members/potential/';
	      this.model = _PotentialChatMember2.default;
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      return response;
	    }
	
	    // Convert from PotentialChatMember objects to GroupMembership objects
	
	  }, {
	    key: 'getGroupMemberships',
	    value: function getGroupMemberships() {
	      // FIXME: There is no created_at date being returned
	      // by the backend from /chats/members/(search/eligible/potential) query,
	      // so we have no date to put for each user's subscribed_at or created_at
	      // dates. Right now we are just using a placeholder value.
	      return new _GroupMemberships2.default(this.models.map(function (member) {
	        return new _GroupMembership2.default({
	          id: member.getUser().id,
	          user: new _Subscriber2.default({
	            id: member.getUser().id,
	            name: member.getName(),
	            note: member.getNote(),
	            role: member.getRole(),
	            first_name: member.getFirstName(),
	            last_name: member.getLastName(),
	            signature: member.getUser().getSignature(),
	            office_hours: member.getUser().getOfficeHours(),
	            color: member.getUser().getColor(),
	            initials: member.getUser().getInitials(),
	            blocked: member.getUser().isBlocked()
	          }),
	          created_at: new Date(0), // Use UNIX Epoch as placeholder
	          group_id: null,
	          can_become_owner: false,
	          role: member.getRole(),
	          can_unsubscribe: false,
	          can_chat: member.isEligible()
	        });
	      }));
	    }
	  }]);
	
	  return RootGroupMemberships;
	}(_Collection3.default);
	
	RootGroupMemberships.displayName = 'RootGroupMemberships';
	exports.default = RootGroupMemberships;

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['LOAD_CLASS_MEMBERS', 'PROMOTED_CLASS_MEMBERS', 'REMOVE_SUBSCRIBER']);

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['LOAD_LEAD', 'LOAD_LEADS', 'INVITE_LEADS']); /*  weak */

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DeviceConstants = __webpack_require__(1014);
	
	var _UserConstants = __webpack_require__(1015);
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	var _Device = __webpack_require__(1016);
	
	var _Device2 = _interopRequireDefault(_Device);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Dispatcher = __webpack_require__(590);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceActions = {
	  loadDevices: function loadDevices(ids) {
	    var all = ids === undefined;
	    var params = all ? undefined : { ids: ids };
	
	    return _RemindAPI2.default.request('/devices/batch', 'POST', params).then(function (result) {
	      var devices = result.devices.map(function (device) {
	        return _Device2.default.fromJSON(device);
	      });
	
	      _Dispatcher.dispatcher.dispatch({
	        type: _DeviceConstants.ActionTypes.LOAD_DEVICES,
	        devices: devices,
	        all: all
	      });
	
	      return devices;
	    });
	  },
	
	
	  /* Enables a user's main email device.
	   * It kinda like DeviceActions.enable(emailDevice)
	   * but this will create the email device if none exist.
	   */
	  enableEmailDevice: function enableEmailDevice() {
	    return _Device2.default.enableEmailDevice().then(function (device) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _DeviceConstants.ActionTypes.UPDATE_DEVICE,
	        device: device
	      });
	
	      return device;
	    });
	  },
	  newEmailDevice: function newEmailDevice(uid) {
	    return _Device2.default.createEmailDevice(uid).then(function (device) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _DeviceConstants.ActionTypes.CREATE_DEVICE,
	        device: device
	      });
	
	      return device;
	    });
	  },
	  deleteEmailDevice: function deleteEmailDevice(device) {
	    return device.delete().then(function () {
	      _Dispatcher.dispatcher.dispatch({
	        type: _DeviceConstants.ActionTypes.DELETE_DEVICE,
	        device: device
	      });
	
	      return device;
	    });
	  },
	
	
	  /*
	   * Begin a outbound sms verification process, the resolved
	   * promise will return a token. You need to pass this token
	   * and the code received by sms to the createOutboundDevice function.
	   */
	  outboundVerify: function outboundVerify(endpoint) {
	    return _Device2.default.outboundVerify(endpoint);
	  },
	
	
	  /* @param token - the token returned by outboundVerify.
	   * @param code - the 4 digit code received by SMS.
	   */
	  createOutboundDevice: function createOutboundDevice(token, code) {
	    return _Device2.default.createOutboundDevice(token, code).then(function (response) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _DeviceConstants.ActionTypes.UPDATE_DEVICE,
	        device: response.device
	      });
	
	      return response;
	    });
	  },
	  localDeleteAll: function localDeleteAll() {
	    _Dispatcher.dispatcher.dispatch({
	      type: _DeviceConstants.ActionTypes.DELETE_ALL_DEVICES
	    });
	
	    return new Promise(function (resolve) {
	      return resolve();
	    });
	  },
	
	
	  /* local delete to remove the device from the store
	   * this is because the API destroy the sms device by itself
	   * once we add a new sms device.
	   */
	  localDelete: function localDelete(device) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _DeviceConstants.ActionTypes.DELETE_DEVICE,
	      device: device
	    });
	
	    return new Promise(function (resolve) {
	      return resolve(device);
	    });
	  },
	  enable: function enable(deviceToEnable) {
	    return deviceToEnable.enable().then(function (device) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _DeviceConstants.ActionTypes.UPDATE_DEVICE,
	        device: device
	      });
	    });
	  },
	  disable: function disable(deviceToDisable) {
	    return deviceToDisable.disable().then(function (device) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _DeviceConstants.ActionTypes.UPDATE_DEVICE,
	        device: device
	      });
	    });
	  },
	  resendConfirmationEmail: function resendConfirmationEmail(uid) {
	    return _RemindAPI2.default.request('/devices/email/resend', 'POST', { uid: uid });
	  },
	  createEmailMergeRequest: function createEmailMergeRequest(endpoint) {
	    return _Device2.default.createEmailMergeRequest(endpoint);
	  },
	  emailMergeRequest: function emailMergeRequest(code, oldUserEmail) {
	    return _Device2.default.emailMergeRequest(code, oldUserEmail).then(function (user) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _UserConstants.ActionTypes.USER_UPDATED,
	        user: _User2.default.fromJSON(user)
	      });
	    });
	  }
	};
	
	exports.default = DeviceActions;

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['LOAD_DEVICES', 'UPDATE_DEVICE', 'DELETE_DEVICE', 'DELETE_ALL_DEVICES', 'CREATE_DEVICE']); /*  weak */

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Roles = exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['LOAD_USER', 'USER_UPDATED', 'USER_DELETED', 'USER_CONFIRMED', 'PREFERENCES_UPDATED']); /*  weak */
	var Roles = exports.Roles = {
	  TEACHER: 'teacher',
	  teacher: 'teacher',
	  STUDENT: 'student',
	  student: 'student',
	  PARENT: 'parent',
	  parent: 'parent',
	  ADMIN: 'admin'
	};

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _MediumConstants = __webpack_require__(1017);
	
	var _i18n = __webpack_require__(1018);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _jstimezonedetect = __webpack_require__(570);
	
	var _jstimezonedetect2 = _interopRequireDefault(_jstimezonedetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Device = function (_Entity) {
	  _inherits(Device, _Entity);
	
	  function Device() {
	    _classCallCheck(this, Device);
	
	    return _possibleConstructorReturn(this, (Device.__proto__ || Object.getPrototypeOf(Device)).apply(this, arguments));
	  }
	
	  _createClass(Device, [{
	    key: 'isEnabled',
	    value: function isEnabled() {
	      return this.get('enabled');
	    }
	  }, {
	    key: 'isVerified',
	    value: function isVerified() {
	      return this.get('verified');
	    }
	  }, {
	    key: 'isDeliverable',
	    value: function isDeliverable() {
	      return this.get('deliverable');
	    }
	  }, {
	    key: 'setEnabled',
	    value: function setEnabled(value) {
	      return this.set('enabled', value);
	    }
	  }, {
	    key: 'getLabel',
	    value: function getLabel() {
	      return this.get('label') || this.getDefaultLabel();
	    }
	  }, {
	    key: 'getEndpoint',
	    value: function getEndpoint() {
	      return this.get('endpoint');
	    }
	  }, {
	    key: 'getDefaultLabel',
	    value: function getDefaultLabel() {
	      switch (this.getType()) {
	        case 'email':
	          return _i18n2.default.getText('Email device');
	        case 'apns':
	          return _i18n2.default.getText('Apple device');
	        case 'sms':
	          return _i18n2.default.getText('Sms device');
	        case 'gcm':
	          return _i18n2.default.getText('Android device');
	        case 'adm':
	          return _i18n2.default.getText('Amazon device');
	        default:
	          return 'Device';
	      }
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.get('type');
	    }
	  }, {
	    key: 'getNotificationType',
	    value: function getNotificationType() {
	      switch (this.getType()) {
	        case 'email':
	          return 'email notifications';
	        case 'gcm':
	          return 'push notifications';
	        case 'apns':
	          return 'push notifications';
	        case 'sms':
	          return 'text notifications';
	        default:
	          return 'notifications';
	      }
	    }
	  }, {
	    key: 'getMessageType',
	    value: function getMessageType() {
	      switch (this.getType()) {
	        case 'email':
	          return 'emails';
	        case 'gcm':
	          return 'push notifications';
	        case 'apns':
	          return 'push notifications';
	        case 'sms':
	          return 'text messages';
	        default:
	          return 'notifications';
	      }
	    }
	  }, {
	    key: 'getGlyphName',
	    value: function getGlyphName() {
	      return _MediumConstants.GLYPHS[this.getType()];
	    }
	  }, {
	    key: 'cannotBeEnabled',
	    value: function cannotBeEnabled() {
	      return this.getType() === 'email' && !this.isDeliverable();
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var _this2 = this;
	
	      return (0, _apiRequest2.default)('/devices/' + this.id + '/enable', 'POST').then(function (device) {
	        return _this2.set(device);
	      });
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      var _this3 = this;
	
	      return (0, _apiRequest2.default)('/devices/' + this.id + '/disable', 'POST').then(function (device) {
	        return _this3.set(device);
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      return (0, _apiRequest2.default)('/devices/' + this.id, 'DELETE');
	    }
	  }, {
	    key: 'resendConfirmationEmail',
	    value: function resendConfirmationEmail() {
	      return (0, _apiRequest2.default)('/devices/email/resend', 'POST', { uid: this.getEndpoint() });
	    }
	  }], [{
	    key: 'confirmEmailDevice',
	    value: function confirmEmailDevice(token) {
	      return (0, _apiRequest2.default)('/devices/email/confirm', 'POST', {
	        verification_token: token
	      });
	    }
	  }, {
	    key: 'enableEmailDevice',
	    value: function enableEmailDevice() {
	      return (0, _apiRequest2.default)('/devices/email/enable', 'POST').then(function (device) {
	        return Device.fromJSON(device);
	      });
	    }
	  }, {
	    key: 'createEmailDevice',
	    value: function createEmailDevice(uid) {
	      return (0, _apiRequest2.default)('/devices/email', 'POST', {
	        uid: uid
	      }).then(function (device) {
	        return Device.fromJSON(device);
	      });
	    }
	
	    /* you give this method 'sms://+4156152427' or 'email://q@q.com' and the
	     * promise will be resolved if the user owning +4156152427 can
	     * sign into the web (has a password and email), rejected otherwise.
	     *
	     * 200 Success. this endpoint belongs to a full account user
	     * 403 The address is invalid
	     * 404 The address is uknown or belong to a not full account user.
	     */
	
	  }, {
	    key: 'belongsToFullAccount',
	    value: function belongsToFullAccount(address) {
	      return (0, _apiRequest2.default)('/devices/user', 'GET', {
	        address: address
	      });
	    }
	
	    /* Initiate an outbound verification for an sms device:
	     *
	     * 201 Success. A token has been generated for further verification.
	     * 403 The address is specified properly but can not be verified.
	     * 409 The currently authenticated user already has the device.
	     * 422 The syntax of the address is invalid.
	     */
	
	  }, {
	    key: 'outboundVerify',
	    value: function outboundVerify(endpoint) {
	      return (0, _apiRequest2.default)('/devices/sms/outbound_verification/tokens', 'POST', {
	        endpoint: endpoint
	      });
	    }
	
	    /* Create the device after having initiated a outbound verification
	     * Pass the token returned by outboundVerify and the code
	     * provided by the user (received by sms).
	     *
	     * 201  Success. The device has been added.
	     * 403  The provided token and code are invalid.
	     */
	
	  }, {
	    key: 'createOutboundDevice',
	    value: function createOutboundDevice(token, code) {
	      return (0, _apiRequest2.default)('/devices/sms/outbound_verification', 'POST', {
	        token: token,
	        code: code
	      });
	    }
	
	    /* Initiate the merge request for merging two email devices
	      * 201 Success. A token has been generated for further verification.
	     * 404 The request could not be found.
	     * 403 The address is specified properly but can not be verified.
	     * 409 The currently authenticated user already has the device.
	     * 422 The syntax of the address is invalid.
	     */
	
	  }, {
	    key: 'createEmailMergeRequest',
	    value: function createEmailMergeRequest(endpoint) {
	      return (0, _apiRequest2.default)('/devices/email/merge_confirmation', 'POST', {
	        endpoint: endpoint
	      });
	    }
	
	    /* Merge two two email accounts after having initiated a merge request
	     * Pass the token returned by createEmailRequest and the token returned
	     * by the User. Also pass the ID of the two users.
	    */
	
	  }, {
	    key: 'emailMergeRequest',
	    value: function emailMergeRequest(code, oldUserEmail) {
	      var tz = _jstimezonedetect2.default.determine();
	      var timezone = tz.name();
	      return (0, _apiRequest2.default)('/devices/email/merge_emails', 'POST', {
	        code: code,
	        email: oldUserEmail,
	        timezone: timezone
	      });
	    }
	  }]);
	
	  return Device;
	}(_Entity3.default);
	
	Device.displayName = 'Device';
	exports.default = Device;

/***/ },
/* 1017 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	var GLYPHS = exports.GLYPHS = {
	  adm: 'amazon',
	  android: 'android',
	  apns: 'ios',
	  email: 'mail',
	  ios: 'ios',
	  gcm: 'android',
	  sms: 'message'
	};
	
	var NAMES = exports.NAMES = {
	  adm: 'Amazon',
	  android: 'Android',
	  apns: 'iOS',
	  email: 'Email',
	  gcm: 'Android',
	  ios: 'iOS',
	  sms: 'Text'
	};

/***/ },
/* 1018 */
/***/ function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ((function(modules) {
		// Check all modules for deduplicated modules
		for(var i in modules) {
			if(Object.prototype.hasOwnProperty.call(modules, i)) {
				switch(typeof modules[i]) {
				case "number":
					// Module is a copy of another module
					modules[i] = modules[modules[i]];
					break;
				case "object":
					// Module can be created from a template
					modules[i] = (function(_m) {
						var args = _m.slice(1), fn = modules[_m[0]];
						return function (a,b,c) {
							fn.apply(null, [a,b,c].concat(args));
						};
					}(modules[i]));
				}
			}
		}
		return modules;
	}([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
		
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		/* jshint esnext: true */
		
		var _IntlMessageFormat = __webpack_require__(3);
		
		var _IntlMessageFormat2 = _interopRequireWildcard(_IntlMessageFormat);
		
		var _IntlRelativeFormat = __webpack_require__(4);
		
		var _IntlRelativeFormat2 = _interopRequireWildcard(_IntlRelativeFormat);
		
		var _Dictionary = __webpack_require__(1);
		
		var _Dictionary2 = _interopRequireWildcard(_Dictionary);
		
		var _createFormatCache = __webpack_require__(5);
		
		var _createFormatCache2 = _interopRequireWildcard(_createFormatCache);
		
		var _normalize = __webpack_require__(2);
		
		var _normalize2 = _interopRequireWildcard(_normalize);
		
		var getNumberFormat = _createFormatCache2['default'](Intl.NumberFormat);
		var getDateTimeFormat = _createFormatCache2['default'](Intl.DateTimeFormat);
		var getMessageFormat = _createFormatCache2['default'](_IntlMessageFormat2['default']);
		var getRelativeFormat = _createFormatCache2['default'](_IntlRelativeFormat2['default']);
		
		var _locale = 'en-US';
		var _dictionary;
		
		exports['default'] = {
		  init: function init(locale, dictionary) {
		    _locale = locale;
		    _dictionary = dictionary;
		  },
		
		  getDate: function getDate(date, options) {
		    return getDateTimeFormat(_locale, options).format(date);
		  },
		
		  getTime: function getTime(date, options) {
		    return getDateTimeFormat(_locale, options).format(date);
		  },
		
		  getRelative: function getRelative(date, options) {
		    return getRelativeFormat(_locale, options).format(date);
		  },
		
		  getNumber: function getNumber(num, options) {
		    return getNumberFormat(_locale, options).format(num);
		  },
		
		  getText: function getText(text, values) {
		    if (_dictionary) {
		      text = _dictionary.get(_normalize2['default'](text)) || text;
		    }
		    // TEMP FIX: https://github.com/yahoo/intl-messageformat/issues/88
		    if (values) {
		      for (var key in values) {
		        if (values[key] === 0) {
		          values[key] = String(values[key]);
		        }
		      }
		    }
		    return getMessageFormat(text, _locale).format(values);
		  },
		
		  __addLocaleData: function __addLocaleData(data) {
		    _IntlMessageFormat2['default'].__addLocaleData(data);
		    _IntlRelativeFormat2['default'].__addLocaleData(data);
		  },
		
		  Dictionary: _Dictionary2['default']
		};
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		/* jshint esnext: true */
		
		function Dictionary(dictionary) {
		  this.dictionary = dictionary || {};
		}
		
		Dictionary.prototype.add = function (dictionary) {
		  for (var key in dictionary) {
		    this.dictionary[key] = dictionary[key];
		  }
		};
		
		Dictionary.prototype.get = function (key) {
		  return this.dictionary[key];
		};
		
		exports["default"] = Dictionary;
		module.exports = exports["default"];
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		
		/**
		 * Normalizes a translatable string to free dictionary of extraneous/useless characters.
		 * @param {String} text original string
		 * @returns {String} normalized string
		 */
		exports['default'] = normalize;
		/* jshint esnext: true */
		
		var escapedHtml = /&(?:nbsp|amp|lt|gt|quot|#39|#96);/g;
		var escapedHtmlMap = {
		  '&nbsp;': ' ',
		  '&amp;': '&',
		  '&lt;': '<',
		  '&gt;': '>',
		  '&quot;': '"',
		  '&#39;': '\'',
		  '&#96;': '`'
		};
		
		function unescapeHtmlChar(chr) {
		  return escapedHtmlMap[chr];
		}
		function normalize(text) {
		  return text.replace(escapedHtml, unescapeHtmlChar).replace(/\s+/g, ' ');
		}
		
		module.exports = exports['default'];
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* jshint node:true */
		
		'use strict';
		
		var IntlMessageFormat = __webpack_require__(9)['default'];
		
		// Add all locale data to `IntlMessageFormat`. This module will be ignored when
		// bundling for the browser with Browserify/Webpack.
		__webpack_require__(8);
		
		// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
		// locale data registered, and with English set as the default locale. Define
		// the `default` prop for use with other compiled ES6 Modules.
		exports = module.exports = IntlMessageFormat;
		exports['default'] = exports;
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* jshint node:true */
		
		'use strict';
		
		var IntlRelativeFormat = __webpack_require__(7)['default'];
		
		// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
		// bundling for the browser with Browserify/Webpack.
		__webpack_require__(6);
		
		// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
		// locale data registered, and with English set as the default locale. Define
		// the `default` prop for use with other compiled ES6 Modules.
		exports = module.exports = IntlRelativeFormat;
		exports['default'] = exports;
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		exports = module.exports = __webpack_require__(10)['default'];
		exports['default'] = exports;
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* (ignored) */
	
	/***/ },
	/* 7 */
	[23, 11, 12],
	/* 8 */
	6,
	/* 9 */
	[23, 13, 14],
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var src$es5$$ = __webpack_require__(15);
		exports["default"] = createFormatCache;
		
		// -----------------------------------------------------------------------------
		
		function createFormatCache(FormatConstructor) {
		    var cache = src$es5$$.objCreate(null);
		
		    return function () {
		        var args    = Array.prototype.slice.call(arguments);
		        var cacheId = getCacheId(args);
		        var format  = cacheId && cache[cacheId];
		
		        if (!format) {
		            format = src$es5$$.objCreate(FormatConstructor.prototype);
		            FormatConstructor.apply(format, args);
		
		            if (cacheId) {
		                cache[cacheId] = format;
		            }
		        }
		
		        return format;
		    };
		}
		
		// -- Utilities ----------------------------------------------------------------
		
		function getCacheId(inputs) {
		    // When JSON is not available in the runtime, we will not create a cache id.
		    if (typeof JSON === 'undefined') { return; }
		
		    var cacheId = [];
		
		    var i, len, input;
		
		    for (i = 0, len = inputs.length; i < len; i += 1) {
		        input = inputs[i];
		
		        if (input && typeof input === 'object') {
		            cacheId.push(orderedProps(input));
		        } else {
		            cacheId.push(input);
		        }
		    }
		
		    return JSON.stringify(cacheId);
		}
		
		function orderedProps(obj) {
		    var props = [],
		        keys  = [];
		
		    var key, i, len, prop;
		
		    for (key in obj) {
		        if (obj.hasOwnProperty(key)) {
		            keys.push(key);
		        }
		    }
		
		    var orderedKeys = keys.sort();
		
		    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
		        key  = orderedKeys[i];
		        prop = {};
		
		        prop[key] = obj[key];
		        props[i]  = prop;
		    }
		
		    return props;
		}
		
		//# sourceMappingURL=memoizer.js.map
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		/*
		Copyright (c) 2014, Yahoo! Inc. All rights reserved.
		Copyrights licensed under the New BSD License.
		See the accompanying LICENSE file for terms.
		*/
		
		/* jslint esnext: true */
		
		"use strict";
		var intl$messageformat$$ = __webpack_require__(3), src$diff$$ = __webpack_require__(16), src$es5$$ = __webpack_require__(17);
		exports["default"] = RelativeFormat;
		
		// -----------------------------------------------------------------------------
		
		var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
		var STYLES = ['best fit', 'numeric'];
		
		// -- RelativeFormat -----------------------------------------------------------
		
		function RelativeFormat(locales, options) {
		    options = options || {};
		
		    // Make a copy of `locales` if it's an array, so that it doesn't change
		    // since it's used lazily.
		    if (src$es5$$.isArray(locales)) {
		        locales = locales.concat();
		    }
		
		    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
		    src$es5$$.defineProperty(this, '_options', {value: {
		        style: this._resolveStyle(options.style),
		        units: this._isValidUnits(options.units) && options.units
		    }});
		
		    src$es5$$.defineProperty(this, '_locales', {value: locales});
		    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
		    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});
		
		    // "Bind" `format()` method to `this` so it can be passed by reference like
		    // the other `Intl` APIs.
		    var relativeFormat = this;
		    this.format = function format(date, options) {
		        return relativeFormat._format(date, options);
		    };
		}
		
		// Define internal private properties for dealing with locale data.
		src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
		src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
		    if (!(data && data.locale)) {
		        throw new Error(
		            'Locale data provided to IntlRelativeFormat is missing a ' +
		            '`locale` property value'
		        );
		    }
		
		    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;
		
		    // Add data to IntlMessageFormat.
		    intl$messageformat$$["default"].__addLocaleData(data);
		}});
		
		// Define public `defaultLocale` property which can be set by the developer, or
		// it will be set when the first RelativeFormat instance is created by
		// leveraging the resolved locale from `Intl`.
		src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
		    enumerable: true,
		    writable  : true,
		    value     : undefined
		});
		
		// Define public `thresholds` property which can be set by the developer, and
		// defaults to relative time thresholds from moment.js.
		src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
		    enumerable: true,
		
		    value: {
		        second: 45,  // seconds to minute
		        minute: 45,  // minutes to hour
		        hour  : 22,  // hours to day
		        day   : 26,  // days to month
		        month : 11   // months to year
		    }
		});
		
		RelativeFormat.prototype.resolvedOptions = function () {
		    return {
		        locale: this._locale,
		        style : this._options.style,
		        units : this._options.units
		    };
		};
		
		RelativeFormat.prototype._compileMessage = function (units) {
		    // `this._locales` is the original set of locales the user specified to the
		    // constructor, while `this._locale` is the resolved root locale.
		    var locales        = this._locales;
		    var resolvedLocale = this._locale;
		
		    var field        = this._fields[units];
		    var relativeTime = field.relativeTime;
		    var future       = '';
		    var past         = '';
		    var i;
		
		    for (i in relativeTime.future) {
		        if (relativeTime.future.hasOwnProperty(i)) {
		            future += ' ' + i + ' {' +
		                relativeTime.future[i].replace('{0}', '#') + '}';
		        }
		    }
		
		    for (i in relativeTime.past) {
		        if (relativeTime.past.hasOwnProperty(i)) {
		            past += ' ' + i + ' {' +
		                relativeTime.past[i].replace('{0}', '#') + '}';
		        }
		    }
		
		    var message = '{when, select, future {{0, plural, ' + future + '}}' +
		                                 'past {{0, plural, ' + past + '}}}';
		
		    // Create the synthetic IntlMessageFormat instance using the original
		    // locales value specified by the user when constructing the the parent
		    // IntlRelativeFormat instance.
		    return new intl$messageformat$$["default"](message, locales);
		};
		
		RelativeFormat.prototype._getMessage = function (units) {
		    var messages = this._messages;
		
		    // Create a new synthetic message based on the locale data from CLDR.
		    if (!messages[units]) {
		        messages[units] = this._compileMessage(units);
		    }
		
		    return messages[units];
		};
		
		RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
		    var field = this._fields[units];
		
		    if (field.relative) {
		        return field.relative[diff];
		    }
		};
		
		RelativeFormat.prototype._findFields = function (locale) {
		    var localeData = RelativeFormat.__localeData__;
		    var data       = localeData[locale.toLowerCase()];
		
		    // The locale data is de-duplicated, so we have to traverse the locale's
		    // hierarchy until we find `fields` to return.
		    while (data) {
		        if (data.fields) {
		            return data.fields;
		        }
		
		        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
		    }
		
		    throw new Error(
		        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
		        locale
		    );
		};
		
		RelativeFormat.prototype._format = function (date, options) {
		    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();
		
		    if (date === undefined) {
		        date = now;
		    }
		
		    // Determine if the `date` and optional `now` values are valid, and throw a
		    // similar error to what `Intl.DateTimeFormat#format()` would throw.
		    if (!isFinite(now)) {
		        throw new RangeError(
		            'The `now` option provided to IntlRelativeFormat#format() is not ' +
		            'in valid range.'
		        );
		    }
		
		    if (!isFinite(date)) {
		        throw new RangeError(
		            'The date value provided to IntlRelativeFormat#format() is not ' +
		            'in valid range.'
		        );
		    }
		
		    var diffReport  = src$diff$$["default"](now, date);
		    var units       = this._options.units || this._selectUnits(diffReport);
		    var diffInUnits = diffReport[units];
		
		    if (this._options.style !== 'numeric') {
		        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
		        if (relativeUnits) {
		            return relativeUnits;
		        }
		    }
		
		    return this._getMessage(units).format({
		        '0' : Math.abs(diffInUnits),
		        when: diffInUnits < 0 ? 'past' : 'future'
		    });
		};
		
		RelativeFormat.prototype._isValidUnits = function (units) {
		    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
		        return true;
		    }
		
		    if (typeof units === 'string') {
		        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
		        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
		            throw new Error(
		                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
		                'value, did you mean: ' + suggestion
		            );
		        }
		    }
		
		    throw new Error(
		        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
		        'must be one of: "' + FIELDS.join('", "') + '"'
		    );
		};
		
		RelativeFormat.prototype._resolveLocale = function (locales) {
		    if (typeof locales === 'string') {
		        locales = [locales];
		    }
		
		    // Create a copy of the array so we can push on the default locale.
		    locales = (locales || []).concat(RelativeFormat.defaultLocale);
		
		    var localeData = RelativeFormat.__localeData__;
		    var i, len, localeParts, data;
		
		    // Using the set of locales + the default locale, we look for the first one
		    // which that has been registered. When data does not exist for a locale, we
		    // traverse its ancestors to find something that's been registered within
		    // its hierarchy of locales. Since we lack the proper `parentLocale` data
		    // here, we must take a naive approach to traversal.
		    for (i = 0, len = locales.length; i < len; i += 1) {
		        localeParts = locales[i].toLowerCase().split('-');
		
		        while (localeParts.length) {
		            data = localeData[localeParts.join('-')];
		            if (data) {
		                // Return the normalized locale string; e.g., we return "en-US",
		                // instead of "en-us".
		                return data.locale;
		            }
		
		            localeParts.pop();
		        }
		    }
		
		    var defaultLocale = locales.pop();
		    throw new Error(
		        'No locale data has been added to IntlRelativeFormat for: ' +
		        locales.join(', ') + ', or the default locale: ' + defaultLocale
		    );
		};
		
		RelativeFormat.prototype._resolveStyle = function (style) {
		    // Default to "best fit" style.
		    if (!style) {
		        return STYLES[0];
		    }
		
		    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
		        return style;
		    }
		
		    throw new Error(
		        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
		        'must be one of: "' + STYLES.join('", "') + '"'
		    );
		};
		
		RelativeFormat.prototype._selectUnits = function (diffReport) {
		    var i, l, units;
		
		    for (i = 0, l = FIELDS.length; i < l; i += 1) {
		        units = FIELDS[i];
		
		        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
		            break;
		        }
		    }
		
		    return units;
		};
		
		//# sourceMappingURL=core.js.map
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		// GENERATED FILE
		"use strict";
		exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"Year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"Month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"Day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"Hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"Minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"Second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};
		
		//# sourceMappingURL=en.js.map
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		/*
		Copyright (c) 2014, Yahoo! Inc. All rights reserved.
		Copyrights licensed under the New BSD License.
		See the accompanying LICENSE file for terms.
		*/
		
		/* jslint esnext: true */
		
		"use strict";
		var src$utils$$ = __webpack_require__(18), src$es5$$ = __webpack_require__(19), src$compiler$$ = __webpack_require__(20), intl$messageformat$parser$$ = __webpack_require__(21);
		exports["default"] = MessageFormat;
		
		// -- MessageFormat --------------------------------------------------------
		
		function MessageFormat(message, locales, formats) {
		    // Parse string messages into an AST.
		    var ast = typeof message === 'string' ?
		            MessageFormat.__parse(message) : message;
		
		    if (!(ast && ast.type === 'messageFormatPattern')) {
		        throw new TypeError('A message must be provided as a String or AST.');
		    }
		
		    // Creates a new object with the specified `formats` merged with the default
		    // formats.
		    formats = this._mergeFormats(MessageFormat.formats, formats);
		
		    // Defined first because it's used to build the format pattern.
		    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
		
		    // Compile the `ast` to a pattern that is highly optimized for repeated
		    // `format()` invocations. **Note:** This passes the `locales` set provided
		    // to the constructor instead of just the resolved locale.
		    var pluralFn = this._findPluralRuleFunction(this._locale);
		    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
		
		    // "Bind" `format()` method to `this` so it can be passed by reference like
		    // the other `Intl` APIs.
		    var messageFormat = this;
		    this.format = function (values) {
		        return messageFormat._format(pattern, values);
		    };
		}
		
		// Default format options used as the prototype of the `formats` provided to the
		// constructor. These are used when constructing the internal Intl.NumberFormat
		// and Intl.DateTimeFormat instances.
		src$es5$$.defineProperty(MessageFormat, 'formats', {
		    enumerable: true,
		
		    value: {
		        number: {
		            'currency': {
		                style: 'currency'
		            },
		
		            'percent': {
		                style: 'percent'
		            }
		        },
		
		        date: {
		            'short': {
		                month: 'numeric',
		                day  : 'numeric',
		                year : '2-digit'
		            },
		
		            'medium': {
		                month: 'short',
		                day  : 'numeric',
		                year : 'numeric'
		            },
		
		            'long': {
		                month: 'long',
		                day  : 'numeric',
		                year : 'numeric'
		            },
		
		            'full': {
		                weekday: 'long',
		                month  : 'long',
		                day    : 'numeric',
		                year   : 'numeric'
		            }
		        },
		
		        time: {
		            'short': {
		                hour  : 'numeric',
		                minute: 'numeric'
		            },
		
		            'medium':  {
		                hour  : 'numeric',
		                minute: 'numeric',
		                second: 'numeric'
		            },
		
		            'long': {
		                hour        : 'numeric',
		                minute      : 'numeric',
		                second      : 'numeric',
		                timeZoneName: 'short'
		            },
		
		            'full': {
		                hour        : 'numeric',
		                minute      : 'numeric',
		                second      : 'numeric',
		                timeZoneName: 'short'
		            }
		        }
		    }
		});
		
		// Define internal private properties for dealing with locale data.
		src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
		src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
		    if (!(data && data.locale)) {
		        throw new Error(
		            'Locale data provided to IntlMessageFormat is missing a ' +
		            '`locale` property'
		        );
		    }
		
		    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
		}});
		
		// Defines `__parse()` static method as an exposed private.
		src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
		
		// Define public `defaultLocale` property which defaults to English, but can be
		// set by the developer.
		src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
		    enumerable: true,
		    writable  : true,
		    value     : undefined
		});
		
		MessageFormat.prototype.resolvedOptions = function () {
		    // TODO: Provide anything else?
		    return {
		        locale: this._locale
		    };
		};
		
		MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
		    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
		    return compiler.compile(ast);
		};
		
		MessageFormat.prototype._findPluralRuleFunction = function (locale) {
		    var localeData = MessageFormat.__localeData__;
		    var data       = localeData[locale.toLowerCase()];
		
		    // The locale data is de-duplicated, so we have to traverse the locale's
		    // hierarchy until we find a `pluralRuleFunction` to return.
		    while (data) {
		        if (data.pluralRuleFunction) {
		            return data.pluralRuleFunction;
		        }
		
		        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
		    }
		
		    throw new Error(
		        'Locale data added to IntlMessageFormat is missing a ' +
		        '`pluralRuleFunction` for :' + locale
		    );
		};
		
		MessageFormat.prototype._format = function (pattern, values) {
		    var result = '',
		        i, len, part, id, value;
		
		    for (i = 0, len = pattern.length; i < len; i += 1) {
		        part = pattern[i];
		
		        // Exist early for string parts.
		        if (typeof part === 'string') {
		            result += part;
		            continue;
		        }
		
		        id = part.id;
		
		        // Enforce that all required values are provided by the caller.
		        if (!(values && src$utils$$.hop.call(values, id))) {
		            throw new Error('A value must be provided for: ' + id);
		        }
		
		        value = values[id];
		
		        // Recursively format plural and select parts' option — which can be a
		        // nested pattern structure. The choosing of the option to use is
		        // abstracted-by and delegated-to the part helper object.
		        if (part.options) {
		            result += this._format(part.getOption(value), values);
		        } else {
		            result += part.format(value);
		        }
		    }
		
		    return result;
		};
		
		MessageFormat.prototype._mergeFormats = function (defaults, formats) {
		    var mergedFormats = {},
		        type, mergedType;
		
		    for (type in defaults) {
		        if (!src$utils$$.hop.call(defaults, type)) { continue; }
		
		        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
		
		        if (formats && src$utils$$.hop.call(formats, type)) {
		            src$utils$$.extend(mergedType, formats[type]);
		        }
		    }
		
		    return mergedFormats;
		};
		
		MessageFormat.prototype._resolveLocale = function (locales) {
		    if (typeof locales === 'string') {
		        locales = [locales];
		    }
		
		    // Create a copy of the array so we can push on the default locale.
		    locales = (locales || []).concat(MessageFormat.defaultLocale);
		
		    var localeData = MessageFormat.__localeData__;
		    var i, len, localeParts, data;
		
		    // Using the set of locales + the default locale, we look for the first one
		    // which that has been registered. When data does not exist for a locale, we
		    // traverse its ancestors to find something that's been registered within
		    // its hierarchy of locales. Since we lack the proper `parentLocale` data
		    // here, we must take a naive approach to traversal.
		    for (i = 0, len = locales.length; i < len; i += 1) {
		        localeParts = locales[i].toLowerCase().split('-');
		
		        while (localeParts.length) {
		            data = localeData[localeParts.join('-')];
		            if (data) {
		                // Return the normalized locale string; e.g., we return "en-US",
		                // instead of "en-us".
		                return data.locale;
		            }
		
		            localeParts.pop();
		        }
		    }
		
		    var defaultLocale = locales.pop();
		    throw new Error(
		        'No locale data has been added to IntlMessageFormat for: ' +
		        locales.join(', ') + ', or the default locale: ' + defaultLocale
		    );
		};
		
		//# sourceMappingURL=core.js.map
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		// GENERATED FILE
		"use strict";
		exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
		
		//# sourceMappingURL=en.js.map
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		
		// Purposely using the same implementation as the Intl.js `Intl` polyfill.
		// Copyright 2013 Andy Earnshaw, MIT License
		
		var hop = Object.prototype.hasOwnProperty;
		
		var realDefineProp = (function () {
		    try { return !!Object.defineProperty({}, 'a', {}); }
		    catch (e) { return false; }
		})();
		
		var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
		
		var defineProperty = realDefineProp ? Object.defineProperty :
		        function (obj, name, desc) {
		
		    if ('get' in desc && obj.__defineGetter__) {
		        obj.__defineGetter__(name, desc.get);
		    } else if (!hop.call(obj, name) || 'value' in desc) {
		        obj[name] = desc.value;
		    }
		};
		
		var objCreate = Object.create || function (proto, props) {
		    var obj, k;
		
		    function F() {}
		    F.prototype = proto;
		    obj = new F();
		
		    for (k in props) {
		        if (hop.call(props, k)) {
		            defineProperty(obj, k, props[k]);
		        }
		    }
		
		    return obj;
		};
		exports.defineProperty = defineProperty, exports.objCreate = objCreate;
		
		//# sourceMappingURL=es5.js.map
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		/*
		Copyright (c) 2014, Yahoo! Inc. All rights reserved.
		Copyrights licensed under the New BSD License.
		See the accompanying LICENSE file for terms.
		*/
		
		/* jslint esnext: true */
		
		"use strict";
		
		var round = Math.round;
		
		function daysToYears(days) {
		    // 400 years have 146097 days (taking into account leap year rules)
		    return days * 400 / 146097;
		}
		
		exports["default"] = function (from, to) {
		    // Convert to ms timestamps.
		    from = +from;
		    to   = +to;
		
		    var millisecond = round(to - from),
		        second      = round(millisecond / 1000),
		        minute      = round(second / 60),
		        hour        = round(minute / 60),
		        day         = round(hour / 24),
		        week        = round(day / 7);
		
		    var rawYears = daysToYears(day),
		        month    = round(rawYears * 12),
		        year     = round(rawYears);
		
		    return {
		        millisecond: millisecond,
		        second     : second,
		        minute     : minute,
		        hour       : hour,
		        day        : day,
		        week       : week,
		        month      : month,
		        year       : year
		    };
		};
		
		//# sourceMappingURL=diff.js.map
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		/*
		Copyright (c) 2014, Yahoo! Inc. All rights reserved.
		Copyrights licensed under the New BSD License.
		See the accompanying LICENSE file for terms.
		*/
		
		/* jslint esnext: true */
		
		"use strict";
		
		// Purposely using the same implementation as the Intl.js `Intl` polyfill.
		// Copyright 2013 Andy Earnshaw, MIT License
		
		var hop = Object.prototype.hasOwnProperty;
		var toString = Object.prototype.toString;
		
		var realDefineProp = (function () {
		    try { return !!Object.defineProperty({}, 'a', {}); }
		    catch (e) { return false; }
		})();
		
		var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
		
		var defineProperty = realDefineProp ? Object.defineProperty :
		        function (obj, name, desc) {
		
		    if ('get' in desc && obj.__defineGetter__) {
		        obj.__defineGetter__(name, desc.get);
		    } else if (!hop.call(obj, name) || 'value' in desc) {
		        obj[name] = desc.value;
		    }
		};
		
		var objCreate = Object.create || function (proto, props) {
		    var obj, k;
		
		    function F() {}
		    F.prototype = proto;
		    obj = new F();
		
		    for (k in props) {
		        if (hop.call(props, k)) {
		            defineProperty(obj, k, props[k]);
		        }
		    }
		
		    return obj;
		};
		
		var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
		    /*jshint validthis:true */
		    var arr = this;
		    if (!arr.length) {
		        return -1;
		    }
		
		    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
		        if (arr[i] === search) {
		            return i;
		        }
		    }
		
		    return -1;
		};
		
		var isArray = Array.isArray || function (obj) {
		    return toString.call(obj) === '[object Array]';
		};
		
		var dateNow = Date.now || function () {
		    return new Date().getTime();
		};
		exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;
		
		//# sourceMappingURL=es5.js.map
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		/*
		Copyright (c) 2014, Yahoo! Inc. All rights reserved.
		Copyrights licensed under the New BSD License.
		See the accompanying LICENSE file for terms.
		*/
		
		/* jslint esnext: true */
		
		"use strict";
		exports.extend = extend;
		var hop = Object.prototype.hasOwnProperty;
		
		function extend(obj) {
		    var sources = Array.prototype.slice.call(arguments, 1),
		        i, len, source, key;
		
		    for (i = 0, len = sources.length; i < len; i += 1) {
		        source = sources[i];
		        if (!source) { continue; }
		
		        for (key in source) {
		            if (hop.call(source, key)) {
		                obj[key] = source[key];
		            }
		        }
		    }
		
		    return obj;
		}
		exports.hop = hop;
		
		//# sourceMappingURL=utils.js.map
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		/*
		Copyright (c) 2014, Yahoo! Inc. All rights reserved.
		Copyrights licensed under the New BSD License.
		See the accompanying LICENSE file for terms.
		*/
		
		/* jslint esnext: true */
		
		"use strict";
		var src$utils$$ = __webpack_require__(18);
		
		// Purposely using the same implementation as the Intl.js `Intl` polyfill.
		// Copyright 2013 Andy Earnshaw, MIT License
		
		var realDefineProp = (function () {
		    try { return !!Object.defineProperty({}, 'a', {}); }
		    catch (e) { return false; }
		})();
		
		var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
		
		var defineProperty = realDefineProp ? Object.defineProperty :
		        function (obj, name, desc) {
		
		    if ('get' in desc && obj.__defineGetter__) {
		        obj.__defineGetter__(name, desc.get);
		    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
		        obj[name] = desc.value;
		    }
		};
		
		var objCreate = Object.create || function (proto, props) {
		    var obj, k;
		
		    function F() {}
		    F.prototype = proto;
		    obj = new F();
		
		    for (k in props) {
		        if (src$utils$$.hop.call(props, k)) {
		            defineProperty(obj, k, props[k]);
		        }
		    }
		
		    return obj;
		};
		exports.defineProperty = defineProperty, exports.objCreate = objCreate;
		
		//# sourceMappingURL=es5.js.map
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		/*
		Copyright (c) 2014, Yahoo! Inc. All rights reserved.
		Copyrights licensed under the New BSD License.
		See the accompanying LICENSE file for terms.
		*/
		
		/* jslint esnext: true */
		
		"use strict";
		exports["default"] = Compiler;
		
		function Compiler(locales, formats, pluralFn) {
		    this.locales  = locales;
		    this.formats  = formats;
		    this.pluralFn = pluralFn;
		}
		
		Compiler.prototype.compile = function (ast) {
		    this.pluralStack        = [];
		    this.currentPlural      = null;
		    this.pluralNumberFormat = null;
		
		    return this.compileMessage(ast);
		};
		
		Compiler.prototype.compileMessage = function (ast) {
		    if (!(ast && ast.type === 'messageFormatPattern')) {
		        throw new Error('Message AST is not of type: "messageFormatPattern"');
		    }
		
		    var elements = ast.elements,
		        pattern  = [];
		
		    var i, len, element;
		
		    for (i = 0, len = elements.length; i < len; i += 1) {
		        element = elements[i];
		
		        switch (element.type) {
		            case 'messageTextElement':
		                pattern.push(this.compileMessageText(element));
		                break;
		
		            case 'argumentElement':
		                pattern.push(this.compileArgument(element));
		                break;
		
		            default:
		                throw new Error('Message element does not have a valid type');
		        }
		    }
		
		    return pattern;
		};
		
		Compiler.prototype.compileMessageText = function (element) {
		    // When this `element` is part of plural sub-pattern and its value contains
		    // an unescaped '#', use a `PluralOffsetString` helper to properly output
		    // the number with the correct offset in the string.
		    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
		        // Create a cache a NumberFormat instance that can be reused for any
		        // PluralOffsetString instance in this message.
		        if (!this.pluralNumberFormat) {
		            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
		        }
		
		        return new PluralOffsetString(
		                this.currentPlural.id,
		                this.currentPlural.format.offset,
		                this.pluralNumberFormat,
		                element.value);
		    }
		
		    // Unescape the escaped '#'s in the message text.
		    return element.value.replace(/\\#/g, '#');
		};
		
		Compiler.prototype.compileArgument = function (element) {
		    var format = element.format;
		
		    if (!format) {
		        return new StringFormat(element.id);
		    }
		
		    var formats  = this.formats,
		        locales  = this.locales,
		        pluralFn = this.pluralFn,
		        options;
		
		    switch (format.type) {
		        case 'numberFormat':
		            options = formats.number[format.style];
		            return {
		                id    : element.id,
		                format: new Intl.NumberFormat(locales, options).format
		            };
		
		        case 'dateFormat':
		            options = formats.date[format.style];
		            return {
		                id    : element.id,
		                format: new Intl.DateTimeFormat(locales, options).format
		            };
		
		        case 'timeFormat':
		            options = formats.time[format.style];
		            return {
		                id    : element.id,
		                format: new Intl.DateTimeFormat(locales, options).format
		            };
		
		        case 'pluralFormat':
		            options = this.compileOptions(element);
		            return new PluralFormat(
		                element.id, format.ordinal, format.offset, options, pluralFn
		            );
		
		        case 'selectFormat':
		            options = this.compileOptions(element);
		            return new SelectFormat(element.id, options);
		
		        default:
		            throw new Error('Message element does not have a valid format type');
		    }
		};
		
		Compiler.prototype.compileOptions = function (element) {
		    var format      = element.format,
		        options     = format.options,
		        optionsHash = {};
		
		    // Save the current plural element, if any, then set it to a new value when
		    // compiling the options sub-patterns. This conforms the spec's algorithm
		    // for handling `"#"` syntax in message text.
		    this.pluralStack.push(this.currentPlural);
		    this.currentPlural = format.type === 'pluralFormat' ? element : null;
		
		    var i, len, option;
		
		    for (i = 0, len = options.length; i < len; i += 1) {
		        option = options[i];
		
		        // Compile the sub-pattern and save it under the options's selector.
		        optionsHash[option.selector] = this.compileMessage(option.value);
		    }
		
		    // Pop the plural stack to put back the original current plural value.
		    this.currentPlural = this.pluralStack.pop();
		
		    return optionsHash;
		};
		
		// -- Compiler Helper Classes --------------------------------------------------
		
		function StringFormat(id) {
		    this.id = id;
		}
		
		StringFormat.prototype.format = function (value) {
		    if (!value) {
		        return '';
		    }
		
		    return typeof value === 'string' ? value : String(value);
		};
		
		function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
		    this.id         = id;
		    this.useOrdinal = useOrdinal;
		    this.offset     = offset;
		    this.options    = options;
		    this.pluralFn   = pluralFn;
		}
		
		PluralFormat.prototype.getOption = function (value) {
		    var options = this.options;
		
		    var option = options['=' + value] ||
		            options[this.pluralFn(value - this.offset, this.useOrdinal)];
		
		    return option || options.other;
		};
		
		function PluralOffsetString(id, offset, numberFormat, string) {
		    this.id           = id;
		    this.offset       = offset;
		    this.numberFormat = numberFormat;
		    this.string       = string;
		}
		
		PluralOffsetString.prototype.format = function (value) {
		    var number = this.numberFormat.format(value - this.offset);
		
		    return this.string
		            .replace(/(^|[^\\])#/g, '$1' + number)
		            .replace(/\\#/g, '#');
		};
		
		function SelectFormat(id, options) {
		    this.id      = id;
		    this.options = options;
		}
		
		SelectFormat.prototype.getOption = function (value) {
		    var options = this.options;
		    return options[value] || options.other;
		};
		
		//# sourceMappingURL=compiler.js.map
	
	/***/ },
	/* 21 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		exports = module.exports = __webpack_require__(22)['default'];
		exports['default'] = exports;
	
	
	/***/ },
	/* 22 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		
		exports["default"] = (function() {
		  /*
		   * Generated by PEG.js 0.8.0.
		   *
		   * http://pegjs.majda.cz/
		   */
		
		  function peg$subclass(child, parent) {
		    function ctor() { this.constructor = child; }
		    ctor.prototype = parent.prototype;
		    child.prototype = new ctor();
		  }
		
		  function SyntaxError(message, expected, found, offset, line, column) {
		    this.message  = message;
		    this.expected = expected;
		    this.found    = found;
		    this.offset   = offset;
		    this.line     = line;
		    this.column   = column;
		
		    this.name     = "SyntaxError";
		  }
		
		  peg$subclass(SyntaxError, Error);
		
		  function parse(input) {
		    var options = arguments.length > 1 ? arguments[1] : {},
		
		        peg$FAILED = {},
		
		        peg$startRuleFunctions = { start: peg$parsestart },
		        peg$startRuleFunction  = peg$parsestart,
		
		        peg$c0 = [],
		        peg$c1 = function(elements) {
		                return {
		                    type    : 'messageFormatPattern',
		                    elements: elements
		                };
		            },
		        peg$c2 = peg$FAILED,
		        peg$c3 = function(text) {
		                var string = '',
		                    i, j, outerLen, inner, innerLen;
		
		                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
		                    inner = text[i];
		
		                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
		                        string += inner[j];
		                    }
		                }
		
		                return string;
		            },
		        peg$c4 = function(messageText) {
		                return {
		                    type : 'messageTextElement',
		                    value: messageText
		                };
		            },
		        peg$c5 = /^[^ \t\n\r,.+={}#]/,
		        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
		        peg$c7 = "{",
		        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
		        peg$c9 = null,
		        peg$c10 = ",",
		        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
		        peg$c12 = "}",
		        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
		        peg$c14 = function(id, format) {
		                return {
		                    type  : 'argumentElement',
		                    id    : id,
		                    format: format && format[2]
		                };
		            },
		        peg$c15 = "number",
		        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
		        peg$c17 = "date",
		        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
		        peg$c19 = "time",
		        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
		        peg$c21 = function(type, style) {
		                return {
		                    type : type + 'Format',
		                    style: style && style[2]
		                };
		            },
		        peg$c22 = "plural",
		        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
		        peg$c24 = function(pluralStyle) {
		                return {
		                    type   : pluralStyle.type,
		                    ordinal: false,
		                    offset : pluralStyle.offset || 0,
		                    options: pluralStyle.options
		                };
		            },
		        peg$c25 = "selectordinal",
		        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
		        peg$c27 = function(pluralStyle) {
		                return {
		                    type   : pluralStyle.type,
		                    ordinal: true,
		                    offset : pluralStyle.offset || 0,
		                    options: pluralStyle.options
		                }
		            },
		        peg$c28 = "select",
		        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
		        peg$c30 = function(options) {
		                return {
		                    type   : 'selectFormat',
		                    options: options
		                };
		            },
		        peg$c31 = "=",
		        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
		        peg$c33 = function(selector, pattern) {
		                return {
		                    type    : 'optionalFormatPattern',
		                    selector: selector,
		                    value   : pattern
		                };
		            },
		        peg$c34 = "offset:",
		        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
		        peg$c36 = function(number) {
		                return number;
		            },
		        peg$c37 = function(offset, options) {
		                return {
		                    type   : 'pluralFormat',
		                    offset : offset,
		                    options: options
		                };
		            },
		        peg$c38 = { type: "other", description: "whitespace" },
		        peg$c39 = /^[ \t\n\r]/,
		        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
		        peg$c41 = { type: "other", description: "optionalWhitespace" },
		        peg$c42 = /^[0-9]/,
		        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
		        peg$c44 = /^[0-9a-f]/i,
		        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
		        peg$c46 = "0",
		        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
		        peg$c48 = /^[1-9]/,
		        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
		        peg$c50 = function(digits) {
		            return parseInt(digits, 10);
		        },
		        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
		        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
		        peg$c53 = "\\#",
		        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
		        peg$c55 = function() { return '\\#'; },
		        peg$c56 = "\\{",
		        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
		        peg$c58 = function() { return '\u007B'; },
		        peg$c59 = "\\}",
		        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
		        peg$c61 = function() { return '\u007D'; },
		        peg$c62 = "\\u",
		        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
		        peg$c64 = function(digits) {
		                return String.fromCharCode(parseInt(digits, 16));
		            },
		        peg$c65 = function(chars) { return chars.join(''); },
		
		        peg$currPos          = 0,
		        peg$reportedPos      = 0,
		        peg$cachedPos        = 0,
		        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
		        peg$maxFailPos       = 0,
		        peg$maxFailExpected  = [],
		        peg$silentFails      = 0,
		
		        peg$result;
		
		    if ("startRule" in options) {
		      if (!(options.startRule in peg$startRuleFunctions)) {
		        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
		      }
		
		      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
		    }
		
		    function text() {
		      return input.substring(peg$reportedPos, peg$currPos);
		    }
		
		    function offset() {
		      return peg$reportedPos;
		    }
		
		    function line() {
		      return peg$computePosDetails(peg$reportedPos).line;
		    }
		
		    function column() {
		      return peg$computePosDetails(peg$reportedPos).column;
		    }
		
		    function expected(description) {
		      throw peg$buildException(
		        null,
		        [{ type: "other", description: description }],
		        peg$reportedPos
		      );
		    }
		
		    function error(message) {
		      throw peg$buildException(message, null, peg$reportedPos);
		    }
		
		    function peg$computePosDetails(pos) {
		      function advance(details, startPos, endPos) {
		        var p, ch;
		
		        for (p = startPos; p < endPos; p++) {
		          ch = input.charAt(p);
		          if (ch === "\n") {
		            if (!details.seenCR) { details.line++; }
		            details.column = 1;
		            details.seenCR = false;
		          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
		            details.line++;
		            details.column = 1;
		            details.seenCR = true;
		          } else {
		            details.column++;
		            details.seenCR = false;
		          }
		        }
		      }
		
		      if (peg$cachedPos !== pos) {
		        if (peg$cachedPos > pos) {
		          peg$cachedPos = 0;
		          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
		        }
		        advance(peg$cachedPosDetails, peg$cachedPos, pos);
		        peg$cachedPos = pos;
		      }
		
		      return peg$cachedPosDetails;
		    }
		
		    function peg$fail(expected) {
		      if (peg$currPos < peg$maxFailPos) { return; }
		
		      if (peg$currPos > peg$maxFailPos) {
		        peg$maxFailPos = peg$currPos;
		        peg$maxFailExpected = [];
		      }
		
		      peg$maxFailExpected.push(expected);
		    }
		
		    function peg$buildException(message, expected, pos) {
		      function cleanupExpected(expected) {
		        var i = 1;
		
		        expected.sort(function(a, b) {
		          if (a.description < b.description) {
		            return -1;
		          } else if (a.description > b.description) {
		            return 1;
		          } else {
		            return 0;
		          }
		        });
		
		        while (i < expected.length) {
		          if (expected[i - 1] === expected[i]) {
		            expected.splice(i, 1);
		          } else {
		            i++;
		          }
		        }
		      }
		
		      function buildMessage(expected, found) {
		        function stringEscape(s) {
		          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
		
		          return s
		            .replace(/\\/g,   '\\\\')
		            .replace(/"/g,    '\\"')
		            .replace(/\x08/g, '\\b')
		            .replace(/\t/g,   '\\t')
		            .replace(/\n/g,   '\\n')
		            .replace(/\f/g,   '\\f')
		            .replace(/\r/g,   '\\r')
		            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
		            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
		            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
		            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
		        }
		
		        var expectedDescs = new Array(expected.length),
		            expectedDesc, foundDesc, i;
		
		        for (i = 0; i < expected.length; i++) {
		          expectedDescs[i] = expected[i].description;
		        }
		
		        expectedDesc = expected.length > 1
		          ? expectedDescs.slice(0, -1).join(", ")
		              + " or "
		              + expectedDescs[expected.length - 1]
		          : expectedDescs[0];
		
		        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
		
		        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
		      }
		
		      var posDetails = peg$computePosDetails(pos),
		          found      = pos < input.length ? input.charAt(pos) : null;
		
		      if (expected !== null) {
		        cleanupExpected(expected);
		      }
		
		      return new SyntaxError(
		        message !== null ? message : buildMessage(expected, found),
		        expected,
		        found,
		        pos,
		        posDetails.line,
		        posDetails.column
		      );
		    }
		
		    function peg$parsestart() {
		      var s0;
		
		      s0 = peg$parsemessageFormatPattern();
		
		      return s0;
		    }
		
		    function peg$parsemessageFormatPattern() {
		      var s0, s1, s2;
		
		      s0 = peg$currPos;
		      s1 = [];
		      s2 = peg$parsemessageFormatElement();
		      while (s2 !== peg$FAILED) {
		        s1.push(s2);
		        s2 = peg$parsemessageFormatElement();
		      }
		      if (s1 !== peg$FAILED) {
		        peg$reportedPos = s0;
		        s1 = peg$c1(s1);
		      }
		      s0 = s1;
		
		      return s0;
		    }
		
		    function peg$parsemessageFormatElement() {
		      var s0;
		
		      s0 = peg$parsemessageTextElement();
		      if (s0 === peg$FAILED) {
		        s0 = peg$parseargumentElement();
		      }
		
		      return s0;
		    }
		
		    function peg$parsemessageText() {
		      var s0, s1, s2, s3, s4, s5;
		
		      s0 = peg$currPos;
		      s1 = [];
		      s2 = peg$currPos;
		      s3 = peg$parse_();
		      if (s3 !== peg$FAILED) {
		        s4 = peg$parsechars();
		        if (s4 !== peg$FAILED) {
		          s5 = peg$parse_();
		          if (s5 !== peg$FAILED) {
		            s3 = [s3, s4, s5];
		            s2 = s3;
		          } else {
		            peg$currPos = s2;
		            s2 = peg$c2;
		          }
		        } else {
		          peg$currPos = s2;
		          s2 = peg$c2;
		        }
		      } else {
		        peg$currPos = s2;
		        s2 = peg$c2;
		      }
		      if (s2 !== peg$FAILED) {
		        while (s2 !== peg$FAILED) {
		          s1.push(s2);
		          s2 = peg$currPos;
		          s3 = peg$parse_();
		          if (s3 !== peg$FAILED) {
		            s4 = peg$parsechars();
		            if (s4 !== peg$FAILED) {
		              s5 = peg$parse_();
		              if (s5 !== peg$FAILED) {
		                s3 = [s3, s4, s5];
		                s2 = s3;
		              } else {
		                peg$currPos = s2;
		                s2 = peg$c2;
		              }
		            } else {
		              peg$currPos = s2;
		              s2 = peg$c2;
		            }
		          } else {
		            peg$currPos = s2;
		            s2 = peg$c2;
		          }
		        }
		      } else {
		        s1 = peg$c2;
		      }
		      if (s1 !== peg$FAILED) {
		        peg$reportedPos = s0;
		        s1 = peg$c3(s1);
		      }
		      s0 = s1;
		      if (s0 === peg$FAILED) {
		        s0 = peg$currPos;
		        s1 = peg$parsews();
		        if (s1 !== peg$FAILED) {
		          s1 = input.substring(s0, peg$currPos);
		        }
		        s0 = s1;
		      }
		
		      return s0;
		    }
		
		    function peg$parsemessageTextElement() {
		      var s0, s1;
		
		      s0 = peg$currPos;
		      s1 = peg$parsemessageText();
		      if (s1 !== peg$FAILED) {
		        peg$reportedPos = s0;
		        s1 = peg$c4(s1);
		      }
		      s0 = s1;
		
		      return s0;
		    }
		
		    function peg$parseargument() {
		      var s0, s1, s2;
		
		      s0 = peg$parsenumber();
		      if (s0 === peg$FAILED) {
		        s0 = peg$currPos;
		        s1 = [];
		        if (peg$c5.test(input.charAt(peg$currPos))) {
		          s2 = input.charAt(peg$currPos);
		          peg$currPos++;
		        } else {
		          s2 = peg$FAILED;
		          if (peg$silentFails === 0) { peg$fail(peg$c6); }
		        }
		        if (s2 !== peg$FAILED) {
		          while (s2 !== peg$FAILED) {
		            s1.push(s2);
		            if (peg$c5.test(input.charAt(peg$currPos))) {
		              s2 = input.charAt(peg$currPos);
		              peg$currPos++;
		            } else {
		              s2 = peg$FAILED;
		              if (peg$silentFails === 0) { peg$fail(peg$c6); }
		            }
		          }
		        } else {
		          s1 = peg$c2;
		        }
		        if (s1 !== peg$FAILED) {
		          s1 = input.substring(s0, peg$currPos);
		        }
		        s0 = s1;
		      }
		
		      return s0;
		    }
		
		    function peg$parseargumentElement() {
		      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
		
		      s0 = peg$currPos;
		      if (input.charCodeAt(peg$currPos) === 123) {
		        s1 = peg$c7;
		        peg$currPos++;
		      } else {
		        s1 = peg$FAILED;
		        if (peg$silentFails === 0) { peg$fail(peg$c8); }
		      }
		      if (s1 !== peg$FAILED) {
		        s2 = peg$parse_();
		        if (s2 !== peg$FAILED) {
		          s3 = peg$parseargument();
		          if (s3 !== peg$FAILED) {
		            s4 = peg$parse_();
		            if (s4 !== peg$FAILED) {
		              s5 = peg$currPos;
		              if (input.charCodeAt(peg$currPos) === 44) {
		                s6 = peg$c10;
		                peg$currPos++;
		              } else {
		                s6 = peg$FAILED;
		                if (peg$silentFails === 0) { peg$fail(peg$c11); }
		              }
		              if (s6 !== peg$FAILED) {
		                s7 = peg$parse_();
		                if (s7 !== peg$FAILED) {
		                  s8 = peg$parseelementFormat();
		                  if (s8 !== peg$FAILED) {
		                    s6 = [s6, s7, s8];
		                    s5 = s6;
		                  } else {
		                    peg$currPos = s5;
		                    s5 = peg$c2;
		                  }
		                } else {
		                  peg$currPos = s5;
		                  s5 = peg$c2;
		                }
		              } else {
		                peg$currPos = s5;
		                s5 = peg$c2;
		              }
		              if (s5 === peg$FAILED) {
		                s5 = peg$c9;
		              }
		              if (s5 !== peg$FAILED) {
		                s6 = peg$parse_();
		                if (s6 !== peg$FAILED) {
		                  if (input.charCodeAt(peg$currPos) === 125) {
		                    s7 = peg$c12;
		                    peg$currPos++;
		                  } else {
		                    s7 = peg$FAILED;
		                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
		                  }
		                  if (s7 !== peg$FAILED) {
		                    peg$reportedPos = s0;
		                    s1 = peg$c14(s3, s5);
		                    s0 = s1;
		                  } else {
		                    peg$currPos = s0;
		                    s0 = peg$c2;
		                  }
		                } else {
		                  peg$currPos = s0;
		                  s0 = peg$c2;
		                }
		              } else {
		                peg$currPos = s0;
		                s0 = peg$c2;
		              }
		            } else {
		              peg$currPos = s0;
		              s0 = peg$c2;
		            }
		          } else {
		            peg$currPos = s0;
		            s0 = peg$c2;
		          }
		        } else {
		          peg$currPos = s0;
		          s0 = peg$c2;
		        }
		      } else {
		        peg$currPos = s0;
		        s0 = peg$c2;
		      }
		
		      return s0;
		    }
		
		    function peg$parseelementFormat() {
		      var s0;
		
		      s0 = peg$parsesimpleFormat();
		      if (s0 === peg$FAILED) {
		        s0 = peg$parsepluralFormat();
		        if (s0 === peg$FAILED) {
		          s0 = peg$parseselectOrdinalFormat();
		          if (s0 === peg$FAILED) {
		            s0 = peg$parseselectFormat();
		          }
		        }
		      }
		
		      return s0;
		    }
		
		    function peg$parsesimpleFormat() {
		      var s0, s1, s2, s3, s4, s5, s6;
		
		      s0 = peg$currPos;
		      if (input.substr(peg$currPos, 6) === peg$c15) {
		        s1 = peg$c15;
		        peg$currPos += 6;
		      } else {
		        s1 = peg$FAILED;
		        if (peg$silentFails === 0) { peg$fail(peg$c16); }
		      }
		      if (s1 === peg$FAILED) {
		        if (input.substr(peg$currPos, 4) === peg$c17) {
		          s1 = peg$c17;
		          peg$currPos += 4;
		        } else {
		          s1 = peg$FAILED;
		          if (peg$silentFails === 0) { peg$fail(peg$c18); }
		        }
		        if (s1 === peg$FAILED) {
		          if (input.substr(peg$currPos, 4) === peg$c19) {
		            s1 = peg$c19;
		            peg$currPos += 4;
		          } else {
		            s1 = peg$FAILED;
		            if (peg$silentFails === 0) { peg$fail(peg$c20); }
		          }
		        }
		      }
		      if (s1 !== peg$FAILED) {
		        s2 = peg$parse_();
		        if (s2 !== peg$FAILED) {
		          s3 = peg$currPos;
		          if (input.charCodeAt(peg$currPos) === 44) {
		            s4 = peg$c10;
		            peg$currPos++;
		          } else {
		            s4 = peg$FAILED;
		            if (peg$silentFails === 0) { peg$fail(peg$c11); }
		          }
		          if (s4 !== peg$FAILED) {
		            s5 = peg$parse_();
		            if (s5 !== peg$FAILED) {
		              s6 = peg$parsechars();
		              if (s6 !== peg$FAILED) {
		                s4 = [s4, s5, s6];
		                s3 = s4;
		              } else {
		                peg$currPos = s3;
		                s3 = peg$c2;
		              }
		            } else {
		              peg$currPos = s3;
		              s3 = peg$c2;
		            }
		          } else {
		            peg$currPos = s3;
		            s3 = peg$c2;
		          }
		          if (s3 === peg$FAILED) {
		            s3 = peg$c9;
		          }
		          if (s3 !== peg$FAILED) {
		            peg$reportedPos = s0;
		            s1 = peg$c21(s1, s3);
		            s0 = s1;
		          } else {
		            peg$currPos = s0;
		            s0 = peg$c2;
		          }
		        } else {
		          peg$currPos = s0;
		          s0 = peg$c2;
		        }
		      } else {
		        peg$currPos = s0;
		        s0 = peg$c2;
		      }
		
		      return s0;
		    }
		
		    function peg$parsepluralFormat() {
		      var s0, s1, s2, s3, s4, s5;
		
		      s0 = peg$currPos;
		      if (input.substr(peg$currPos, 6) === peg$c22) {
		        s1 = peg$c22;
		        peg$currPos += 6;
		      } else {
		        s1 = peg$FAILED;
		        if (peg$silentFails === 0) { peg$fail(peg$c23); }
		      }
		      if (s1 !== peg$FAILED) {
		        s2 = peg$parse_();
		        if (s2 !== peg$FAILED) {
		          if (input.charCodeAt(peg$currPos) === 44) {
		            s3 = peg$c10;
		            peg$currPos++;
		          } else {
		            s3 = peg$FAILED;
		            if (peg$silentFails === 0) { peg$fail(peg$c11); }
		          }
		          if (s3 !== peg$FAILED) {
		            s4 = peg$parse_();
		            if (s4 !== peg$FAILED) {
		              s5 = peg$parsepluralStyle();
		              if (s5 !== peg$FAILED) {
		                peg$reportedPos = s0;
		                s1 = peg$c24(s5);
		                s0 = s1;
		              } else {
		                peg$currPos = s0;
		                s0 = peg$c2;
		              }
		            } else {
		              peg$currPos = s0;
		              s0 = peg$c2;
		            }
		          } else {
		            peg$currPos = s0;
		            s0 = peg$c2;
		          }
		        } else {
		          peg$currPos = s0;
		          s0 = peg$c2;
		        }
		      } else {
		        peg$currPos = s0;
		        s0 = peg$c2;
		      }
		
		      return s0;
		    }
		
		    function peg$parseselectOrdinalFormat() {
		      var s0, s1, s2, s3, s4, s5;
		
		      s0 = peg$currPos;
		      if (input.substr(peg$currPos, 13) === peg$c25) {
		        s1 = peg$c25;
		        peg$currPos += 13;
		      } else {
		        s1 = peg$FAILED;
		        if (peg$silentFails === 0) { peg$fail(peg$c26); }
		      }
		      if (s1 !== peg$FAILED) {
		        s2 = peg$parse_();
		        if (s2 !== peg$FAILED) {
		          if (input.charCodeAt(peg$currPos) === 44) {
		            s3 = peg$c10;
		            peg$currPos++;
		          } else {
		            s3 = peg$FAILED;
		            if (peg$silentFails === 0) { peg$fail(peg$c11); }
		          }
		          if (s3 !== peg$FAILED) {
		            s4 = peg$parse_();
		            if (s4 !== peg$FAILED) {
		              s5 = peg$parsepluralStyle();
		              if (s5 !== peg$FAILED) {
		                peg$reportedPos = s0;
		                s1 = peg$c27(s5);
		                s0 = s1;
		              } else {
		                peg$currPos = s0;
		                s0 = peg$c2;
		              }
		            } else {
		              peg$currPos = s0;
		              s0 = peg$c2;
		            }
		          } else {
		            peg$currPos = s0;
		            s0 = peg$c2;
		          }
		        } else {
		          peg$currPos = s0;
		          s0 = peg$c2;
		        }
		      } else {
		        peg$currPos = s0;
		        s0 = peg$c2;
		      }
		
		      return s0;
		    }
		
		    function peg$parseselectFormat() {
		      var s0, s1, s2, s3, s4, s5, s6;
		
		      s0 = peg$currPos;
		      if (input.substr(peg$currPos, 6) === peg$c28) {
		        s1 = peg$c28;
		        peg$currPos += 6;
		      } else {
		        s1 = peg$FAILED;
		        if (peg$silentFails === 0) { peg$fail(peg$c29); }
		      }
		      if (s1 !== peg$FAILED) {
		        s2 = peg$parse_();
		        if (s2 !== peg$FAILED) {
		          if (input.charCodeAt(peg$currPos) === 44) {
		            s3 = peg$c10;
		            peg$currPos++;
		          } else {
		            s3 = peg$FAILED;
		            if (peg$silentFails === 0) { peg$fail(peg$c11); }
		          }
		          if (s3 !== peg$FAILED) {
		            s4 = peg$parse_();
		            if (s4 !== peg$FAILED) {
		              s5 = [];
		              s6 = peg$parseoptionalFormatPattern();
		              if (s6 !== peg$FAILED) {
		                while (s6 !== peg$FAILED) {
		                  s5.push(s6);
		                  s6 = peg$parseoptionalFormatPattern();
		                }
		              } else {
		                s5 = peg$c2;
		              }
		              if (s5 !== peg$FAILED) {
		                peg$reportedPos = s0;
		                s1 = peg$c30(s5);
		                s0 = s1;
		              } else {
		                peg$currPos = s0;
		                s0 = peg$c2;
		              }
		            } else {
		              peg$currPos = s0;
		              s0 = peg$c2;
		            }
		          } else {
		            peg$currPos = s0;
		            s0 = peg$c2;
		          }
		        } else {
		          peg$currPos = s0;
		          s0 = peg$c2;
		        }
		      } else {
		        peg$currPos = s0;
		        s0 = peg$c2;
		      }
		
		      return s0;
		    }
		
		    function peg$parseselector() {
		      var s0, s1, s2, s3;
		
		      s0 = peg$currPos;
		      s1 = peg$currPos;
		      if (input.charCodeAt(peg$currPos) === 61) {
		        s2 = peg$c31;
		        peg$currPos++;
		      } else {
		        s2 = peg$FAILED;
		        if (peg$silentFails === 0) { peg$fail(peg$c32); }
		      }
		      if (s2 !== peg$FAILED) {
		        s3 = peg$parsenumber();
		        if (s3 !== peg$FAILED) {
		          s2 = [s2, s3];
		          s1 = s2;
		        } else {
		          peg$currPos = s1;
		          s1 = peg$c2;
		        }
		      } else {
		        peg$currPos = s1;
		        s1 = peg$c2;
		      }
		      if (s1 !== peg$FAILED) {
		        s1 = input.substring(s0, peg$currPos);
		      }
		      s0 = s1;
		      if (s0 === peg$FAILED) {
		        s0 = peg$parsechars();
		      }
		
		      return s0;
		    }
		
		    function peg$parseoptionalFormatPattern() {
		      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
		
		      s0 = peg$currPos;
		      s1 = peg$parse_();
		      if (s1 !== peg$FAILED) {
		        s2 = peg$parseselector();
		        if (s2 !== peg$FAILED) {
		          s3 = peg$parse_();
		          if (s3 !== peg$FAILED) {
		            if (input.charCodeAt(peg$currPos) === 123) {
		              s4 = peg$c7;
		              peg$currPos++;
		            } else {
		              s4 = peg$FAILED;
		              if (peg$silentFails === 0) { peg$fail(peg$c8); }
		            }
		            if (s4 !== peg$FAILED) {
		              s5 = peg$parse_();
		              if (s5 !== peg$FAILED) {
		                s6 = peg$parsemessageFormatPattern();
		                if (s6 !== peg$FAILED) {
		                  s7 = peg$parse_();
		                  if (s7 !== peg$FAILED) {
		                    if (input.charCodeAt(peg$currPos) === 125) {
		                      s8 = peg$c12;
		                      peg$currPos++;
		                    } else {
		                      s8 = peg$FAILED;
		                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
		                    }
		                    if (s8 !== peg$FAILED) {
		                      peg$reportedPos = s0;
		                      s1 = peg$c33(s2, s6);
		                      s0 = s1;
		                    } else {
		                      peg$currPos = s0;
		                      s0 = peg$c2;
		                    }
		                  } else {
		                    peg$currPos = s0;
		                    s0 = peg$c2;
		                  }
		                } else {
		                  peg$currPos = s0;
		                  s0 = peg$c2;
		                }
		              } else {
		                peg$currPos = s0;
		                s0 = peg$c2;
		              }
		            } else {
		              peg$currPos = s0;
		              s0 = peg$c2;
		            }
		          } else {
		            peg$currPos = s0;
		            s0 = peg$c2;
		          }
		        } else {
		          peg$currPos = s0;
		          s0 = peg$c2;
		        }
		      } else {
		        peg$currPos = s0;
		        s0 = peg$c2;
		      }
		
		      return s0;
		    }
		
		    function peg$parseoffset() {
		      var s0, s1, s2, s3;
		
		      s0 = peg$currPos;
		      if (input.substr(peg$currPos, 7) === peg$c34) {
		        s1 = peg$c34;
		        peg$currPos += 7;
		      } else {
		        s1 = peg$FAILED;
		        if (peg$silentFails === 0) { peg$fail(peg$c35); }
		      }
		      if (s1 !== peg$FAILED) {
		        s2 = peg$parse_();
		        if (s2 !== peg$FAILED) {
		          s3 = peg$parsenumber();
		          if (s3 !== peg$FAILED) {
		            peg$reportedPos = s0;
		            s1 = peg$c36(s3);
		            s0 = s1;
		          } else {
		            peg$currPos = s0;
		            s0 = peg$c2;
		          }
		        } else {
		          peg$currPos = s0;
		          s0 = peg$c2;
		        }
		      } else {
		        peg$currPos = s0;
		        s0 = peg$c2;
		      }
		
		      return s0;
		    }
		
		    function peg$parsepluralStyle() {
		      var s0, s1, s2, s3, s4;
		
		      s0 = peg$currPos;
		      s1 = peg$parseoffset();
		      if (s1 === peg$FAILED) {
		        s1 = peg$c9;
		      }
		      if (s1 !== peg$FAILED) {
		        s2 = peg$parse_();
		        if (s2 !== peg$FAILED) {
		          s3 = [];
		          s4 = peg$parseoptionalFormatPattern();
		          if (s4 !== peg$FAILED) {
		            while (s4 !== peg$FAILED) {
		              s3.push(s4);
		              s4 = peg$parseoptionalFormatPattern();
		            }
		          } else {
		            s3 = peg$c2;
		          }
		          if (s3 !== peg$FAILED) {
		            peg$reportedPos = s0;
		            s1 = peg$c37(s1, s3);
		            s0 = s1;
		          } else {
		            peg$currPos = s0;
		            s0 = peg$c2;
		          }
		        } else {
		          peg$currPos = s0;
		          s0 = peg$c2;
		        }
		      } else {
		        peg$currPos = s0;
		        s0 = peg$c2;
		      }
		
		      return s0;
		    }
		
		    function peg$parsews() {
		      var s0, s1;
		
		      peg$silentFails++;
		      s0 = [];
		      if (peg$c39.test(input.charAt(peg$currPos))) {
		        s1 = input.charAt(peg$currPos);
		        peg$currPos++;
		      } else {
		        s1 = peg$FAILED;
		        if (peg$silentFails === 0) { peg$fail(peg$c40); }
		      }
		      if (s1 !== peg$FAILED) {
		        while (s1 !== peg$FAILED) {
		          s0.push(s1);
		          if (peg$c39.test(input.charAt(peg$currPos))) {
		            s1 = input.charAt(peg$currPos);
		            peg$currPos++;
		          } else {
		            s1 = peg$FAILED;
		            if (peg$silentFails === 0) { peg$fail(peg$c40); }
		          }
		        }
		      } else {
		        s0 = peg$c2;
		      }
		      peg$silentFails--;
		      if (s0 === peg$FAILED) {
		        s1 = peg$FAILED;
		        if (peg$silentFails === 0) { peg$fail(peg$c38); }
		      }
		
		      return s0;
		    }
		
		    function peg$parse_() {
		      var s0, s1, s2;
		
		      peg$silentFails++;
		      s0 = peg$currPos;
		      s1 = [];
		      s2 = peg$parsews();
		      while (s2 !== peg$FAILED) {
		        s1.push(s2);
		        s2 = peg$parsews();
		      }
		      if (s1 !== peg$FAILED) {
		        s1 = input.substring(s0, peg$currPos);
		      }
		      s0 = s1;
		      peg$silentFails--;
		      if (s0 === peg$FAILED) {
		        s1 = peg$FAILED;
		        if (peg$silentFails === 0) { peg$fail(peg$c41); }
		      }
		
		      return s0;
		    }
		
		    function peg$parsedigit() {
		      var s0;
		
		      if (peg$c42.test(input.charAt(peg$currPos))) {
		        s0 = input.charAt(peg$currPos);
		        peg$currPos++;
		      } else {
		        s0 = peg$FAILED;
		        if (peg$silentFails === 0) { peg$fail(peg$c43); }
		      }
		
		      return s0;
		    }
		
		    function peg$parsehexDigit() {
		      var s0;
		
		      if (peg$c44.test(input.charAt(peg$currPos))) {
		        s0 = input.charAt(peg$currPos);
		        peg$currPos++;
		      } else {
		        s0 = peg$FAILED;
		        if (peg$silentFails === 0) { peg$fail(peg$c45); }
		      }
		
		      return s0;
		    }
		
		    function peg$parsenumber() {
		      var s0, s1, s2, s3, s4, s5;
		
		      s0 = peg$currPos;
		      if (input.charCodeAt(peg$currPos) === 48) {
		        s1 = peg$c46;
		        peg$currPos++;
		      } else {
		        s1 = peg$FAILED;
		        if (peg$silentFails === 0) { peg$fail(peg$c47); }
		      }
		      if (s1 === peg$FAILED) {
		        s1 = peg$currPos;
		        s2 = peg$currPos;
		        if (peg$c48.test(input.charAt(peg$currPos))) {
		          s3 = input.charAt(peg$currPos);
		          peg$currPos++;
		        } else {
		          s3 = peg$FAILED;
		          if (peg$silentFails === 0) { peg$fail(peg$c49); }
		        }
		        if (s3 !== peg$FAILED) {
		          s4 = [];
		          s5 = peg$parsedigit();
		          while (s5 !== peg$FAILED) {
		            s4.push(s5);
		            s5 = peg$parsedigit();
		          }
		          if (s4 !== peg$FAILED) {
		            s3 = [s3, s4];
		            s2 = s3;
		          } else {
		            peg$currPos = s2;
		            s2 = peg$c2;
		          }
		        } else {
		          peg$currPos = s2;
		          s2 = peg$c2;
		        }
		        if (s2 !== peg$FAILED) {
		          s2 = input.substring(s1, peg$currPos);
		        }
		        s1 = s2;
		      }
		      if (s1 !== peg$FAILED) {
		        peg$reportedPos = s0;
		        s1 = peg$c50(s1);
		      }
		      s0 = s1;
		
		      return s0;
		    }
		
		    function peg$parsechar() {
		      var s0, s1, s2, s3, s4, s5, s6, s7;
		
		      if (peg$c51.test(input.charAt(peg$currPos))) {
		        s0 = input.charAt(peg$currPos);
		        peg$currPos++;
		      } else {
		        s0 = peg$FAILED;
		        if (peg$silentFails === 0) { peg$fail(peg$c52); }
		      }
		      if (s0 === peg$FAILED) {
		        s0 = peg$currPos;
		        if (input.substr(peg$currPos, 2) === peg$c53) {
		          s1 = peg$c53;
		          peg$currPos += 2;
		        } else {
		          s1 = peg$FAILED;
		          if (peg$silentFails === 0) { peg$fail(peg$c54); }
		        }
		        if (s1 !== peg$FAILED) {
		          peg$reportedPos = s0;
		          s1 = peg$c55();
		        }
		        s0 = s1;
		        if (s0 === peg$FAILED) {
		          s0 = peg$currPos;
		          if (input.substr(peg$currPos, 2) === peg$c56) {
		            s1 = peg$c56;
		            peg$currPos += 2;
		          } else {
		            s1 = peg$FAILED;
		            if (peg$silentFails === 0) { peg$fail(peg$c57); }
		          }
		          if (s1 !== peg$FAILED) {
		            peg$reportedPos = s0;
		            s1 = peg$c58();
		          }
		          s0 = s1;
		          if (s0 === peg$FAILED) {
		            s0 = peg$currPos;
		            if (input.substr(peg$currPos, 2) === peg$c59) {
		              s1 = peg$c59;
		              peg$currPos += 2;
		            } else {
		              s1 = peg$FAILED;
		              if (peg$silentFails === 0) { peg$fail(peg$c60); }
		            }
		            if (s1 !== peg$FAILED) {
		              peg$reportedPos = s0;
		              s1 = peg$c61();
		            }
		            s0 = s1;
		            if (s0 === peg$FAILED) {
		              s0 = peg$currPos;
		              if (input.substr(peg$currPos, 2) === peg$c62) {
		                s1 = peg$c62;
		                peg$currPos += 2;
		              } else {
		                s1 = peg$FAILED;
		                if (peg$silentFails === 0) { peg$fail(peg$c63); }
		              }
		              if (s1 !== peg$FAILED) {
		                s2 = peg$currPos;
		                s3 = peg$currPos;
		                s4 = peg$parsehexDigit();
		                if (s4 !== peg$FAILED) {
		                  s5 = peg$parsehexDigit();
		                  if (s5 !== peg$FAILED) {
		                    s6 = peg$parsehexDigit();
		                    if (s6 !== peg$FAILED) {
		                      s7 = peg$parsehexDigit();
		                      if (s7 !== peg$FAILED) {
		                        s4 = [s4, s5, s6, s7];
		                        s3 = s4;
		                      } else {
		                        peg$currPos = s3;
		                        s3 = peg$c2;
		                      }
		                    } else {
		                      peg$currPos = s3;
		                      s3 = peg$c2;
		                    }
		                  } else {
		                    peg$currPos = s3;
		                    s3 = peg$c2;
		                  }
		                } else {
		                  peg$currPos = s3;
		                  s3 = peg$c2;
		                }
		                if (s3 !== peg$FAILED) {
		                  s3 = input.substring(s2, peg$currPos);
		                }
		                s2 = s3;
		                if (s2 !== peg$FAILED) {
		                  peg$reportedPos = s0;
		                  s1 = peg$c64(s2);
		                  s0 = s1;
		                } else {
		                  peg$currPos = s0;
		                  s0 = peg$c2;
		                }
		              } else {
		                peg$currPos = s0;
		                s0 = peg$c2;
		              }
		            }
		          }
		        }
		      }
		
		      return s0;
		    }
		
		    function peg$parsechars() {
		      var s0, s1, s2;
		
		      s0 = peg$currPos;
		      s1 = [];
		      s2 = peg$parsechar();
		      if (s2 !== peg$FAILED) {
		        while (s2 !== peg$FAILED) {
		          s1.push(s2);
		          s2 = peg$parsechar();
		        }
		      } else {
		        s1 = peg$c2;
		      }
		      if (s1 !== peg$FAILED) {
		        peg$reportedPos = s0;
		        s1 = peg$c65(s1);
		      }
		      s0 = s1;
		
		      return s0;
		    }
		
		    peg$result = peg$startRuleFunction();
		
		    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
		      return peg$result;
		    } else {
		      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
		        peg$fail({ type: "end", description: "end of input" });
		      }
		
		      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
		    }
		  }
		
		  return {
		    SyntaxError: SyntaxError,
		    parse:       parse
		  };
		})();
		
		//# sourceMappingURL=parser.js.map
	
	/***/ },
	/* 23 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		/* jslint esnext: true */
		
		"use strict";
		var src$core$$ = __webpack_require__(__webpack_module_template_argument_0__), src$en$$ = __webpack_require__(__webpack_module_template_argument_1__);
		
		src$core$$["default"].__addLocaleData(src$en$$["default"]);
		src$core$$["default"].defaultLocale = 'en';
		
		exports["default"] = src$core$$["default"];
		
		//# sourceMappingURL=main.js.map
	
	/***/ }
	/******/ ])));
	//# sourceMappingURL=i18n.js.map

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _DeviceConstants = __webpack_require__(1014);
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _Devices = __webpack_require__(1020);
	
	var _Devices2 = _interopRequireDefault(_Devices);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _PusherConstants = __webpack_require__(954);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeviceStore = function (_Store) {
	  _inherits(DeviceStore, _Store);
	
	  function DeviceStore() {
	    _classCallCheck(this, DeviceStore);
	
	    return _possibleConstructorReturn(this, (DeviceStore.__proto__ || Object.getPrototypeOf(DeviceStore)).apply(this, arguments));
	  }
	
	  _createClass(DeviceStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        loaded: false,
	        devices: new _Devices2.default()
	      };
	    }
	  }, {
	    key: 'isLoaded',
	    value: function isLoaded() {
	      return this.state.loaded;
	    }
	  }, {
	    key: 'getDevices',
	    value: function getDevices() {
	      return this.state.devices;
	    }
	  }, {
	    key: 'getDevice',
	    value: function getDevice(deviceId) {
	      return this.state.devices.get(deviceId);
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      switch (action.type) {
	        case _PusherConstants.PushEvents.CHANGESET_UPDATE_DEVICE:
	        case _PusherConstants.PushEvents.CHANGESET_CREATE_DEVICE:
	          {
	            var ids = action.changes.map(function (change) {
	              return change.id;
	            });
	            _DeviceActions2.default.loadDevices(ids);
	            break;
	          }
	        case _PusherConstants.PushEvents.CHANGESET_DESTROY_DEVICE:
	          {
	            var _ids = action.changes.map(function (change) {
	              return change.id;
	            });
	            this.state.devices.remove(_ids);
	            this.emitChange();
	            break;
	          }
	        case _DeviceConstants.ActionTypes.LOAD_DEVICES:
	          this.state.devices.add(action.devices);
	          this.state.loaded = action.all;
	          this.emitChange();
	          break;
	        case _DeviceConstants.ActionTypes.UPDATE_DEVICE:
	          this.state.devices.set([action.device], { remove: false });
	          this.emitChange();
	          break;
	        case _DeviceConstants.ActionTypes.DELETE_ALL_DEVICES:
	          this.resetState();
	          this.emitChange();
	          break;
	        case _DeviceConstants.ActionTypes.DELETE_DEVICE:
	          this.state.devices.remove(action.device.id);
	          this.emitChange();
	          break;
	        case _DeviceConstants.ActionTypes.CREATE_DEVICE:
	          this.state.devices.push(action.device);
	          this.emitChange();
	          break;
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return DeviceStore;
	}(_Store3.default);
	
	DeviceStore.displayName = 'DeviceStore';
	exports.default = new DeviceStore();

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _Device = __webpack_require__(1016);
	
	var _Device2 = _interopRequireDefault(_Device);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Devices = function (_Collection) {
	  _inherits(Devices, _Collection);
	
	  function Devices() {
	    _classCallCheck(this, Devices);
	
	    return _possibleConstructorReturn(this, (Devices.__proto__ || Object.getPrototypeOf(Devices)).apply(this, arguments));
	  }
	
	  _createClass(Devices, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.url = '/devices';
	      this.model = _Device2.default;
	    }
	
	    // $FlowFixMe
	
	  }, {
	    key: 'type',
	    value: function type(_type) {
	      return this.models.filter(function (model) {
	        return model.getType() === _type;
	      });
	    }
	  }, {
	    key: 'enabled',
	    value: function enabled() {
	      return this.models.filter(function (model) {
	        return model.isEnabled();
	      });
	    }
	  }]);
	
	  return Devices;
	}(_Collection3.default);
	
	Devices.displayName = 'Devices';
	exports.default = Devices;

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Lead = __webpack_require__(1022);
	
	var _Lead2 = _interopRequireDefault(_Lead);
	
	var _Leads = __webpack_require__(1023);
	
	var _Leads2 = _interopRequireDefault(_Leads);
	
	var _LeadStore = __webpack_require__(1024);
	
	var _LeadStore2 = _interopRequireDefault(_LeadStore);
	
	var _LeadConstants = __webpack_require__(1012);
	
	var _Dispatcher = __webpack_require__(590);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeadActions = {
	  loadLead: function loadLead(userId) {
	    return _Lead2.default.fetch().then(function (lead) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _LeadConstants.ActionTypes.LOAD_LEAD,
	        lead: lead,
	        userId: userId
	      });
	    });
	  },
	  deleteLead: function deleteLead() {
	    return _Lead2.default.delete();
	  },
	  loadLeads: function loadLeads() {
	    var forceLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    if (!forceLoad && _LeadStore2.default.isLoaded()) {
	      return Promise.resolve();
	    }
	    return _Leads2.default.fetch().then(function (leads) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _LeadConstants.ActionTypes.LOAD_LEADS,
	        leads: leads
	      });
	      return leads;
	    });
	  },
	  sendInvitations: function sendInvitations(leadIds, context) {
	    return _Leads2.default.sendInvitations(leadIds, context).then(function () {
	      _Dispatcher.dispatcher.dispatch({
	        type: _LeadConstants.ActionTypes.INVITE_LEADS,
	        leadIds: leadIds
	      });
	      LeadActions.loadLeads(true);
	    });
	  }
	};
	exports.default = LeadActions;

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Lead = function (_Entity) {
	  _inherits(Lead, _Entity);
	
	  function Lead() {
	    _classCallCheck(this, Lead);
	
	    return _possibleConstructorReturn(this, (Lead.__proto__ || Object.getPrototypeOf(Lead)).apply(this, arguments));
	  }
	
	  _createClass(Lead, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.url = '/lead';
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        first_name: '',
	        last_name: ''
	      };
	    }
	  }, {
	    key: 'getFirstName',
	    value: function getFirstName() {
	      return this.get('first_name');
	    }
	  }, {
	    key: 'getLastName',
	    value: function getLastName() {
	      return this.get('last_name');
	    }
	  }, {
	    key: 'getOrganizationId',
	    value: function getOrganizationId() {
	      return this.get('organization_id');
	    }
	  }, {
	    key: 'getDisplayName',
	    value: function getDisplayName() {
	      return this.get('display_name');
	    }
	  }, {
	    key: 'getInitials',
	    value: function getInitials() {
	      return this.get('initials');
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      return this.get('color');
	    }
	  }, {
	    key: 'hasBeenInvited',
	    value: function hasBeenInvited() {
	      return this.get('invited');
	    }
	  }], [{
	    key: 'delete',
	    value: function _delete() {
	      return (0, _apiRequest2.default)('/lead', 'DELETE');
	    }
	  }]);
	
	  return Lead;
	}(_Entity3.default);
	
	Lead.displayName = 'Lead';
	exports.default = Lead;

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Lead = __webpack_require__(1022);
	
	var _Lead2 = _interopRequireDefault(_Lead);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Leads = function (_Collection) {
	  _inherits(Leads, _Collection);
	
	  function Leads() {
	    _classCallCheck(this, Leads);
	
	    return _possibleConstructorReturn(this, (Leads.__proto__ || Object.getPrototypeOf(Leads)).apply(this, arguments));
	  }
	
	  _createClass(Leads, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.url = '/leads';
	      this.model = _Lead2.default;
	    }
	  }, {
	    key: 'hasInvitedAnyLeads',
	    value: function hasInvitedAnyLeads() {
	      return this.some(function (lead) {
	        return lead.hasBeenInvited();
	      });
	    }
	  }, {
	    key: 'getNamed',
	    value: function getNamed() {
	      return this.filter(function (lead) {
	        return lead.getFirstName() || lead.getLastName();
	      });
	    }
	  }], [{
	    key: 'sendInvitations',
	    value: function sendInvitations(ids, context) {
	      var data = { ids: ids };
	      if (context) {
	        // $FlowFixMe
	        data.context = context;
	      }
	      return (0, _apiRequest2.default)('/leads/invite', 'POST', data);
	    }
	  }]);
	
	  return Leads;
	}(_Collection3.default);
	
	Leads.displayName = 'Leads';
	exports.default = Leads;

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _Leads = __webpack_require__(1023);
	
	var _Leads2 = _interopRequireDefault(_Leads);
	
	var _LeadConstants = __webpack_require__(1012);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeadStore = function (_Store) {
	  _inherits(LeadStore, _Store);
	
	  function LeadStore() {
	    _classCallCheck(this, LeadStore);
	
	    return _possibleConstructorReturn(this, (LeadStore.__proto__ || Object.getPrototypeOf(LeadStore)).apply(this, arguments));
	  }
	
	  _createClass(LeadStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        leads: new _Leads2.default(),
	        userIdToLead: {},
	        loaded: false
	      };
	    }
	  }, {
	    key: 'getLeads',
	    value: function getLeads() {
	      return this.state.leads;
	    }
	  }, {
	    key: 'getLeadsForOrganization',
	    value: function getLeadsForOrganization(id) {
	      return new _Leads2.default(this.state.leads.filter(function (lead) {
	        return lead.getOrganizationId() === id;
	      }));
	    }
	  }, {
	    key: 'getLeadForUser',
	    value: function getLeadForUser(userId) {
	      return this.state.userIdToLead[userId];
	    }
	  }, {
	    key: 'addLead',
	    value: function addLead(lead) {
	      var userId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.state.leads.add(lead);
	
	      if (userId) {
	        this.state.userIdToLead[userId] = lead;
	      }
	    }
	  }, {
	    key: 'handleLoad',
	    value: function handleLoad(leads) {
	      this.state.leads = leads;
	      this.state.loaded = true;
	      this.emitChange();
	    }
	  }, {
	    key: 'isLoaded',
	    value: function isLoaded() {
	      return this.state.loaded;
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      switch (action.type) {
	        case _LeadConstants.ActionTypes.LOAD_LEAD:
	          this.addLead(action.lead, action.userId);
	          this.emitChange();
	          break;
	        case _LeadConstants.ActionTypes.LOAD_LEADS:
	          this.handleLoad(action.leads);
	          break;
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return LeadStore;
	}(_Store3.default);
	
	LeadStore.displayName = 'LeadStore';
	exports.default = new LeadStore();

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SettingConstants = __webpack_require__(972);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Dispatcher = __webpack_require__(590);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingsActions = {
	  // TODO make void
	  loadSettings: function loadSettings() {
	    return (0, _apiRequest2.default)('/settings', 'GET', {}).then(function (settings) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _SettingConstants.ActionTypes.LOAD_SETTINGS,
	        settings: settings
	      });
	
	      return settings;
	    });
	  },
	  getGeo: function getGeo() {
	    return (0, _apiRequest2.default)('/settings/geo', 'GET', {});
	  }
	};
	exports.default = SettingsActions;

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Unreads = __webpack_require__(1027);
	
	var _Unreads2 = _interopRequireDefault(_Unreads);
	
	var _UnreadConstants = __webpack_require__(1029);
	
	var _Dispatcher = __webpack_require__(590);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnreadActions = {
	  loadUnreads: function loadUnreads() {
	    return _Unreads2.default.fetch().then(function (unreads) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _UnreadConstants.ActionTypes.LIST_UNREADS,
	        unreads: unreads
	      });
	    });
	  }
	};
	exports.default = UnreadActions;

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Unread = __webpack_require__(1028);
	
	var _Unread2 = _interopRequireDefault(_Unread);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Unreads = function (_Collection) {
	  _inherits(Unreads, _Collection);
	
	  function Unreads() {
	    _classCallCheck(this, Unreads);
	
	    return _possibleConstructorReturn(this, (Unreads.__proto__ || Object.getPrototypeOf(Unreads)).apply(this, arguments));
	  }
	
	  _createClass(Unreads, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.url = '/notifications/unread';
	      this.model = _Unread2.default;
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      if (response.unreads) {
	        return response.unreads.concat(response['group_unreads'] || []);
	      }
	      return [];
	    }
	  }]);
	
	  return Unreads;
	}(_Collection3.default);
	
	Unreads.displayName = 'Unreads';
	exports.default = Unreads;

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Unread = function (_Entity) {
	  _inherits(Unread, _Entity);
	
	  function Unread() {
	    _classCallCheck(this, Unread);
	
	    return _possibleConstructorReturn(this, (Unread.__proto__ || Object.getPrototypeOf(Unread)).apply(this, arguments));
	  }
	
	  _createClass(Unread, [{
	    key: 'getUnreadCount',
	    value: function getUnreadCount() {
	      return this.get('unread_count');
	    }
	  }, {
	    key: 'getParentId',
	    value: function getParentId() {
	      return this.get('parent');
	    }
	  }, {
	    key: 'incrementUnreadCount',
	    value: function incrementUnreadCount() {
	      return this.set({ unread_count: this.get('unread_count') + 1 });
	    }
	  }, {
	    key: 'decrementUnreadCountBy',
	    value: function decrementUnreadCountBy(amount) {
	      return this.set({ unread_count: Math.max(this.get('unread_count') - amount, 0) });
	    }
	  }, {
	    key: 'hasParent',
	    value: function hasParent() {
	      return this.get('parent') !== '';
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        parent: '',
	        unread_count: 0,
	        timestamp: 0
	      };
	    }
	  }]);
	
	  return Unread;
	}(_Entity3.default);
	
	Unread.displayName = 'Unread';
	exports.default = Unread;

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['LIST_UNREADS']); /*  weak */

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Favicon = __webpack_require__(1031);
	
	var _Favicon2 = _interopRequireDefault(_Favicon);
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _Unread = __webpack_require__(1028);
	
	var _Unread2 = _interopRequireDefault(_Unread);
	
	var _UnreadActions = __webpack_require__(1026);
	
	var _UnreadActions2 = _interopRequireDefault(_UnreadActions);
	
	var _Unreads = __webpack_require__(1027);
	
	var _Unreads2 = _interopRequireDefault(_Unreads);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatConstants = __webpack_require__(941);
	
	var _UnreadConstants = __webpack_require__(1029);
	
	var _PusherConstants = __webpack_require__(954);
	
	var _ChatMessage = __webpack_require__(927);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnreadStore = function (_Store) {
	  _inherits(UnreadStore, _Store);
	
	  function UnreadStore() {
	    _classCallCheck(this, UnreadStore);
	
	    return _possibleConstructorReturn(this, (UnreadStore.__proto__ || Object.getPrototypeOf(UnreadStore)).apply(this, arguments));
	  }
	
	  _createClass(UnreadStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        unreads: new _Unreads2.default()
	      };
	    }
	  }, {
	    key: 'getUnreads',
	    value: function getUnreads() {
	      return this.state.unreads || new _Unreads2.default();
	    }
	  }, {
	    key: 'getTotalUnread',
	    value: function getTotalUnread() {
	      return this.getUnreadCount('chats');
	    }
	  }, {
	    key: 'getUnreadCount',
	    value: function getUnreadCount(id) {
	      var unread = this.state.unreads.get(id);
	      if (unread) {
	        // If a parent unread has been set as 0, then all the children count as 0 implicitly
	        var iter = unread;
	        while (iter.hasParent()) {
	          iter = this.state.unreads.get(iter.getParentId());
	          if (!iter || iter.getUnreadCount() === 0) {
	            return 0;
	          }
	        }
	        return unread.getUnreadCount();
	      } else {
	        return 0;
	      }
	    }
	  }, {
	    key: 'incrementUnreads',
	    value: function incrementUnreads(id, parent) {
	      var unread = this.state.unreads.get(id);
	      if (!unread) {
	        this.addNewUnread(new _Unread2.default({ id: id, parent: parent }));
	        unread = this.state.unreads.get(id);
	      }
	      var iter = unread;
	      while (iter) {
	        iter.incrementUnreadCount();
	        iter = this.state.unreads.get(iter.getParentId());
	      }
	    }
	  }, {
	    key: 'decrementUnreads',
	    value: function decrementUnreads(id, count) {
	      var iter = this.state.unreads.get(id);
	      while (iter) {
	        iter.decrementUnreadCountBy(count);
	        iter = this.state.unreads.get(iter.getParentId());
	      }
	    }
	  }, {
	    key: 'setAsRead',
	    value: function setAsRead(id) {
	      var unread = this.state.unreads.get(id);
	      if (unread) {
	        var numUnread = unread.getUnreadCount();
	        var iter = unread;
	        while (iter) {
	          iter.decrementUnreadCountBy(numUnread);
	          iter = this.state.unreads.get(iter.getParentId());
	        }
	      }
	    }
	  }, {
	    key: 'addNewUnread',
	    value: function addNewUnread(unread) {
	      this.state.unreads.add(unread);
	    }
	  }, {
	    key: 'messageIsForCurrentChatThread',
	    value: function messageIsForCurrentChatThread(chatId) {
	      return window.location.pathname.replace(/\/+$/, '').endsWith(chatId);
	    }
	  }, {
	    key: 'refreshFavicon',
	    value: function refreshFavicon() {
	      _Favicon2.default.showNumber(this.getTotalUnread());
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      var _this2 = this;
	
	      switch (action.type) {
	        case _ChatConstants.ActionTypes.LIST_CHATS:
	          action.chats.forEach(function (chat) {
	            return _this2.addNewUnread({
	              id: chat.id,
	              parent: 'chats',
	              unreadCount: chat.getUnreadMessages()
	            });
	          });
	          this.refreshFavicon();
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.MARK_READ:
	        case _ChatConstants.ActionTypes.READ_MESSAGE:
	          this.setAsRead(action.chatId);
	          this.refreshFavicon();
	          this.emitChange();
	          break;
	        case _UnreadConstants.ActionTypes.LIST_UNREADS:
	          // action.unreads contains a complete description of all unreads, so we reset the state
	          this.state = this.getInitialState();
	
	          // NOTE: Temp fix because backend isn't providing this in the initial request
	          if (!this.state.unreads.get('chats')) {
	            this.addNewUnread(new _Unread2.default({ id: 'chats', parent: 'user', unreadCount: 0 }));
	          }
	
	          action.unreads.forEach(function (unread) {
	            return _this2.addNewUnread(unread);
	          });
	          this.refreshFavicon();
	          this.emitChange();
	          break;
	        case _PusherConstants.PushEvents.CHANGESET_CREATE_CHAT_MESSAGE:
	          {
	            var _ret = function () {
	              var messages = action.changes.map(function (change) {
	                return (0, _ChatMessage.chatMessageFactory)(change.content);
	              });
	
	              // Structures to avoid useless update & duplicate
	              // (eg only mark "read up to" for the last message per chat).
	              var chatToMarkReadUpTo = new Map();
	              var chatToIncrementUnread = new Set();
	
	              /* For each received message:
	               * If the message is in the current thread, mark it a read.
	               * Otherwise load & increment the unread for the chat.
	               */
	              messages.forEach(function (message) {
	                var chatId = message.getChatId();
	
	                if (!(0, _ChatMessage.shouldListenToPushEventFrom)(message) || message.getSender().isCurrentUser()) {
	                  return;
	                }
	
	                if (_this2.messageIsForCurrentChatThread(chatId)) {
	                  var seq = chatToMarkReadUpTo.get(chatId);
	                  if (!seq || message.getSeq() > seq) {
	                    chatToMarkReadUpTo.set(chatId, message.getSeq());
	                  }
	                } else {
	                  chatToIncrementUnread.add(chatId);
	                }
	              });
	
	              chatToMarkReadUpTo.forEach(function (seqNumber, chatId) {
	                setTimeout(function () {
	                  return _ChatActions2.default.markReadUpto(chatId, seqNumber);
	                }, 0);
	              });
	
	              chatToIncrementUnread.forEach(function (chatId) {
	                _this2.incrementUnreads(chatId, 'chats');
	              });
	
	              if (chatToIncrementUnread.size > 0) {
	                _UnreadActions2.default.loadUnreads();
	                _this2.refreshFavicon();
	                _this2.emitChange();
	              }
	
	              return 'break';
	            }();
	
	            if (_ret === 'break') break;
	          }
	        case _PusherConstants.PushEvents.CHANGESET_UPDATE_GROUP:
	        case _PusherConstants.PushEvents.CHANGESET_UPDATE_UNREADS:
	          _UnreadActions2.default.loadUnreads();
	          break;
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return UnreadStore;
	}(_Store3.default);
	
	UnreadStore.displayName = 'UnreadStore';
	exports.default = new UnreadStore();

/***/ },
/* 1031 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FAVICON_COLOR_BACKGROUND = '#2F75C1';
	var FAVICON_COLOR_FOREGROUND = '#FFFFFF';
	
	var Favicon = function () {
	  function Favicon() {
	    _classCallCheck(this, Favicon);
	  }
	
	  _createClass(Favicon, [{
	    key: '_getDataURLForNumber',
	    value: function _getDataURLForNumber(num) {
	      var canvas = document.createElement('canvas');
	
	      canvas.width = 32;
	      canvas.height = 32;
	
	      var context = canvas.getContext('2d');
	
	      if (!context) {
	        throw new Error('null context from canvas');
	      }
	
	      context.fillStyle = FAVICON_COLOR_BACKGROUND;
	      this._roundRect(context, 0, 0, 32, 32, 6);
	
	      context.fillStyle = FAVICON_COLOR_FOREGROUND;
	      context.textAlign = 'center';
	      context.textBaseline = 'top';
	
	      if (num < 99) {
	        context.font = 'bold 22px arial';
	        context.fillText(String(num), 16, 5);
	      } else {
	        context.font = 'bold 18px arial';
	        context.fillText(String(num), 16, 7);
	      }
	
	      return context.canvas.toDataURL();
	    }
	  }, {
	    key: '_roundRect',
	    value: function _roundRect(ctx, x, y, width, height, radius) {
	      ctx.beginPath();
	      ctx.moveTo(x + radius, y);
	      ctx.lineTo(x + width - radius, y);
	      ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
	      ctx.lineTo(x + width, y + height - radius);
	      ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
	      ctx.lineTo(x + radius, y + height);
	      ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
	      ctx.lineTo(x, y + radius);
	      ctx.quadraticCurveTo(x, y, x + radius, y);
	      ctx.closePath();
	      ctx.fill();
	    }
	  }, {
	    key: '_clearFavicon',
	    value: function _clearFavicon() {
	      // remove existing favicons
	      var head = document.getElementsByTagName('head')[0];
	      var links = head.getElementsByTagName('link');
	
	      for (var i = links.length - 1; i >= 0; i--) {
	        if (links[i].getAttribute('rel') === 'shortcut icon') {
	          head.removeChild(links[i]);
	        }
	      }
	    }
	  }, {
	    key: '_newFavicon',
	    value: function _newFavicon(href) {
	      var favicon = document.createElement('link');
	      favicon.type = 'image/x-icon';
	      favicon.rel = 'shortcut icon';
	      favicon.href = href;
	      return favicon;
	    }
	  }, {
	    key: 'showDefault',
	    value: function showDefault() {
	      this._clearFavicon();
	      var favicon = this._newFavicon('/assets/favicon.ico');
	      document.getElementsByTagName('head')[0].appendChild(favicon);
	    }
	  }, {
	    key: 'showNumber',
	    value: function showNumber(num) {
	      if (num > 0) {
	        this._clearFavicon();
	        var favicon = this._newFavicon(this._getDataURLForNumber(num));
	        document.getElementsByTagName('head')[0].appendChild(favicon);
	      } else {
	        this.showDefault();
	      }
	    }
	  }]);
	
	  return Favicon;
	}();
	
	Favicon.displayName = 'Favicon';
	exports.default = new Favicon();

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Session = function (_Entity) {
	  _inherits(Session, _Entity);
	
	  function Session() {
	    _classCallCheck(this, Session);
	
	    return _possibleConstructorReturn(this, (Session.__proto__ || Object.getPrototypeOf(Session)).apply(this, arguments));
	  }
	
	  _createClass(Session, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.url = '/sessions';
	    }
	  }, {
	    key: 'isNew',
	    value: function isNew() {
	      return false;
	    }
	  }], [{
	    key: 'create',
	    value: function create(email, password) {
	      var persist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      return (0, _apiRequest2.default)('/sessions', 'POST', {
	        user: {
	          email: email,
	          password: password
	        },
	        persist: persist
	      }).then(function (user) {
	        return _User2.default.fromJSON(user);
	      });
	    }
	  }, {
	    key: 'createWithToken',
	    value: function createWithToken(token) {
	      return (0, _apiRequest2.default)('/sessions', 'POST', {
	        auth_token: token
	      }).then(function (user) {
	        return _User2.default.fromJSON(user);
	      });
	    }
	  }, {
	    key: 'createWithGoogleAuthorizationCode',
	    value: function createWithGoogleAuthorizationCode(code) {
	      return (0, _apiRequest2.default)('/users/auth/google_plus/callback', 'POST', {
	        code: code
	      }, false).then(function (response) {
	        return _User2.default.fromJSON(response.user);
	      });
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      return new Session().destroy();
	    }
	  }]);
	
	  return Session;
	}(_Entity3.default);
	
	Session.displayName = 'Session';
	exports.default = Session;

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.promiseUser = promiseUser;
	exports.goLandingIfAuthed = goLandingIfAuthed;
	exports.goFromLanding = goFromLanding;
	exports.goToClassCode = goToClassCode;
	exports.goToClassCodeIfAuthed = goToClassCodeIfAuthed;
	exports.hardRedirectTo = hardRedirectTo;
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO move resolveDeepLinkRedirects into here
	
	// TODO simplify our user state
	function promiseUser() {
	  if (_CurrentUser2.default.isSignedIn()) {
	    return Promise.resolve(_CurrentUser2.default.getUser());
	  } else {
	    return _AuthActions2.default.checkLoggedIn();
	  }
	}
	/**
	 * For non-declarative behavior of routes
	 */
	function goLandingIfAuthed(nextState, replaceWith) {
	  if (_CurrentUser2.default.isSignedIn()) {
	    replaceWith('/landing');
	  }
	}
	
	function goFromLanding(nextState, replaceWith, callback) {
	  var loggedIn = function loggedIn(user) {
	    if (user.getRole()) {
	      if (user.isAdmin() && user.hasFeature('web_admin_console')) {
	        replaceWith('/admin/landing');
	      } else {
	        replaceWith('/classes');
	      }
	    } else {
	      replaceWith('/join/role_picker');
	    }
	    callback();
	  };
	  var notLoggedIn = function notLoggedIn() {
	    replaceWith('/log_in');
	    callback();
	  };
	
	  promiseUser().then(loggedIn, notLoggedIn);
	}
	
	function goToClassCode(nextState, replaceWith) {
	  replaceWith('/classes/' + nextState.params.groupCode);
	}
	
	// @deprecated using in onEnter makes first CSR blank, breaking clean rehydration with SSR
	function goToClassCodeIfAuthed(nextState, replaceWith, callback) {
	  promiseUser().then(function () {
	    goToClassCode(nextState, replaceWith);
	    callback();
	  }, function () {
	    return callback();
	  });
	}
	
	// This is just to make testing easier
	function hardRedirectTo(redirectTo) {
	  window.location.href = redirectTo;
	}

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['AUTH_SUCCESS', 'AUTH_FAILURE', 'TOKEN_ENTRY']); /*  weak */

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PublicDevice = function (_Entity) {
	  _inherits(PublicDevice, _Entity);
	
	  function PublicDevice() {
	    _classCallCheck(this, PublicDevice);
	
	    return _possibleConstructorReturn(this, (PublicDevice.__proto__ || Object.getPrototypeOf(PublicDevice)).apply(this, arguments));
	  }
	
	  _createClass(PublicDevice, [{
	    key: 'getMedium',
	    value: function getMedium() {
	      return this.get('type');
	    }
	  }, {
	    key: 'isEnabled',
	    value: function isEnabled() {
	      return this.get('enabled');
	    }
	  }, {
	    key: 'isVerified',
	    value: function isVerified() {
	      return this.get('verified');
	    }
	  }, {
	    key: 'getFriendlyName',
	    value: function getFriendlyName() {
	      return this.get('friendly_name');
	    }
	  }]);
	
	  return PublicDevice;
	}(_Entity3.default);
	
	PublicDevice.displayName = 'PublicDevice';
	exports.default = PublicDevice;

/***/ },
/* 1036 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _AffiliationStore = __webpack_require__(1038);
	
	var _AffiliationStore2 = _interopRequireDefault(_AffiliationStore);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _AuthConstants = __webpack_require__(1040);
	
	var _Cookies = __webpack_require__(573);
	
	var _Cookies2 = _interopRequireDefault(_Cookies);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DeviceStore = __webpack_require__(1019);
	
	var _DeviceStore2 = _interopRequireDefault(_DeviceStore);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _promise = __webpack_require__(1041);
	
	var _UserConstants = __webpack_require__(1015);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var editPassword = function editPassword(values) {
	  var password = values.password;
	
	
	  var signInWithDevice = function signInWithDevice() {
	    var devices = _DeviceStore2.default.getDevices();
	    var emailOrPhoneDevice = devices.find(function (d) {
	      return d.getType() === 'sms' || d.getType() === 'email';
	    });
	    return _AuthActions2.default.signIn(emailOrPhoneDevice.getEndpoint(), password, false).then(function (user) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _UserConstants.ActionTypes.USER_UPDATED,
	        user: user
	      });
	    });
	  };
	
	  var updatePassword = function updatePassword() {
	    return _User2.default.update(values).then(signInWithDevice);
	  };
	
	  return _DeviceActions2.default.loadDevices().then(updatePassword);
	};
	
	var UserActions = {
	  // TODO does this require a token or not?
	  loadCurrentUser: function loadCurrentUser(token) {
	    return _User2.default.fetch({ token: token }).then(function (user) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _UserConstants.ActionTypes.LOAD_USER,
	        user: user
	      });
	
	      return user;
	    });
	  },
	  update: function update(attrs) {
	    return _User2.default.update(attrs).then(function (user) {
	      if (_CurrentUser2.default.isSignedIn() && !_lodash2.default.isEqual(_CurrentUser2.default.getUser().getOrganizationIds(), user.getOrganizationIds())) {
	        _GroupActions2.default.loadGroups();
	      }
	
	      _Dispatcher.dispatcher.dispatch({
	        type: _UserConstants.ActionTypes.USER_UPDATED,
	        user: user
	      });
	
	      return user;
	    });
	  },
	  updateLocal: function updateLocal(attrs) {
	    var user = _CurrentUser2.default.getUser();
	
	    user.set(attrs);
	
	    _Dispatcher.dispatcher.dispatch({
	      type: _UserConstants.ActionTypes.USER_UPDATED,
	      user: user
	    });
	  },
	  createPassword: function createPassword(password) {
	    return editPassword({ password: password });
	  },
	  changePassword: function changePassword(currentPassword, newPassword) {
	    var values = { password: newPassword };
	    if (currentPassword) {
	      Object.assign(values, { current_password: currentPassword });
	    }
	    return editPassword(values);
	  },
	  create: function create(attrs) {
	    return _User2.default.create(attrs).then(_AuthActions.onSessionCreated);
	  },
	  delete: function _delete(token) {
	    return _User2.default.delete(token).then(function () {
	      _Dispatcher.dispatcher.dispatch({
	        type: _UserConstants.ActionTypes.USER_DELETED
	      });
	    });
	  },
	  verifyDeleteToken: function verifyDeleteToken() {
	    return _User2.default.verifyDeleteToken.apply(_User2.default, arguments);
	  },
	  confirm: function confirm() {
	    return _User2.default.confirm.apply(_User2.default, arguments);
	  },
	  requestConfirmation: function requestConfirmation() {
	    return _User2.default.requestConfirmation();
	  },
	  savePreference: function savePreference() {
	    var currentUser = _CurrentUser2.default.getUser();
	
	    return currentUser.savePreference.apply(currentUser, arguments).then(function (preferences) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _UserConstants.ActionTypes.PREFERENCES_UPDATED,
	        preferences: preferences
	      });
	
	      return preferences;
	    });
	  },
	  setRole: function setRole(role) {
	    _User2.default.setRole(role).then(function (user) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _UserConstants.ActionTypes.USER_UPDATED,
	        user: user
	      });
	    }).catch(_promise.genericCatch);
	  },
	  resetPassword: function resetPassword(password) {
	    var token = _Cookies2.default.isEnabled() ? _Cookies2.default.get(_AuthConstants.RESET_PASSWORD_TOKEN_COOKIE) : null;
	    _Cookies2.default.expire(_AuthConstants.RESET_PASSWORD_TOKEN_COOKIE);
	    return _User2.default.resetPassword(password, token);
	  },
	  setBirthdate: function setBirthdate(birthdate) {
	    return _User2.default.setBirthdate(birthdate).then(function (user) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _UserConstants.ActionTypes.USER_UPDATED,
	        user: user
	      });
	    });
	  },
	  setParentEmail: function setParentEmail(parentEmail) {
	    // TODO: Add error handling here
	    return _User2.default.setParentEmail(parentEmail).then(function (user) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _UserConstants.ActionTypes.USER_UPDATED,
	        user: user
	      });
	    });
	  },
	  requestForPublicGroups: function requestForPublicGroups(teacherId) {
	    return _User2.default.requestForPublicGroups(teacherId).then(function () {
	      _ToastActions2.default.showSuccessToast('Invite sent');
	    }).catch(_promise.genericCatch);
	  },
	  reportUser: function reportUser(userId, reason, notes) {
	    _User2.default.reportUser(userId, reason, notes).then(function () {
	      _ToastActions2.default.showSuccessToast('Report submitted');
	    }).catch(_promise.genericCatch);
	  },
	  leaveOrg: function leaveOrg(removingId) {
	    var schools = _AffiliationStore2.default.getMemberOrganizations();
	    var onRemoveSuccess = function onRemoveSuccess() {
	      var oldSchool = schools.filter(function (s) {
	        return s.id === removingId;
	      })[0];
	      _ToastActions2.default.showSuccessToast('You left ' + oldSchool.getName());
	      _OrganizationActions2.default.removeOrganization(removingId);
	      var oldStaffClass = _GroupStore2.default.getStaffClassForOrg(removingId);
	      if (oldStaffClass) {
	        _GroupActions2.default.removeGroup(oldStaffClass);
	      }
	    };
	
	    var schoolIds = schools.map(function (s) {
	      return s.id;
	    }).filter(function (id) {
	      return id !== removingId;
	    });
	
	    return UserActions.update({ organization_ids: schoolIds }).then(onRemoveSuccess, _ToastActions2.default.showDefaultErrorToast);
	  },
	  addParent: function addParent(name, email) {
	    return _User2.default.addParent(name, email).then(function (user) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _UserConstants.ActionTypes.USER_UPDATED,
	        user: user
	      });
	      return user;
	    });
	  }
	};
	
	exports.default = UserActions;

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _Organizations = __webpack_require__(1002);
	
	var _Organizations2 = _interopRequireDefault(_Organizations);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _Affiliation = __webpack_require__(1039);
	
	var _OrganizationConstants = __webpack_require__(1004);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// This is the current user organization affiliations store.
	var AffiliationStore = function (_Store) {
	  _inherits(AffiliationStore, _Store);
	
	  function AffiliationStore() {
	    _classCallCheck(this, AffiliationStore);
	
	    return _possibleConstructorReturn(this, (AffiliationStore.__proto__ || Object.getPrototypeOf(AffiliationStore)).apply(this, arguments));
	  }
	
	  _createClass(AffiliationStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        // Store orgIds in a separate array to preserve ordering
	        orgIds: [],
	        affiliations: {},
	        loaded: false
	      };
	    }
	  }, {
	    key: 'isLoaded',
	    value: function isLoaded() {
	      return this.state.loaded;
	    }
	  }, {
	    key: 'getAffiliation',
	    value: function getAffiliation(organizationId) {
	      return this.state.affiliations[organizationId];
	    }
	  }, {
	    key: 'getAffiliations',
	    value: function getAffiliations() {
	      var _this2 = this;
	
	      return this.state.orgIds.map(function (id) {
	        return _this2.state.affiliations[id];
	      });
	    }
	  }, {
	    key: 'getAffiliatedOrganizationsIds',
	    value: function getAffiliatedOrganizationsIds() {
	      return Object.keys(this.state.affiliations).map(function (s) {
	        return Number(s);
	      });
	    }
	  }, {
	    key: 'getAffiliatedOrganizations',
	    value: function getAffiliatedOrganizations() {
	      return new _Organizations2.default(this.getAffiliatedOrganizationsIds().map(function (id) {
	        return _OrganizationStore2.default.getOrganization(id);
	      }).filter(function (o) {
	        return !!o;
	      }));
	    }
	  }, {
	    key: 'getMemberOrganizations',
	    value: function getMemberOrganizations() {
	      return this.getAffiliations().filter(_Affiliation.isMember).map(function (aff) {
	        return _OrganizationStore2.default.getOrganization(aff.organization_id);
	      }).filter(function (o) {
	        return !!o;
	      });
	    }
	  }, {
	    key: 'parseOrganization',
	    value: function parseOrganization(organization) {
	      var aff = organization.get('user_affiliation');
	      if (aff) {
	        aff.organization_id = organization.id;
	        if (!(0, _lodash.includes)(this.state.orgIds, organization.id)) {
	          this.state.orgIds.push(organization.id);
	        }
	        this.state.affiliations[organization.id] = aff;
	      }
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      switch (action.type) {
	        case _OrganizationConstants.ActionTypes.LOAD_USER_ORGANIZATIONS:
	          this.handleLoadAll(action.organizations);
	          break;
	        case _OrganizationConstants.ActionTypes.REMOVE_ORGANIZATION:
	          delete this.state.affiliations[action.orgId];
	          this.state.orgIds = (0, _lodash.pull)(this.state.orgIds, action.orgId);
	          this.emitChange();
	          break;
	        case _OrganizationConstants.ActionTypes.LOAD_ORGANIZATION:
	          this.parseOrganization(action.organization);
	          this.emitChange();
	          break;
	        case _OrganizationConstants.ActionTypes.REMOVE_ADMIN_ROLE:
	          {
	            var oldAff = this.state.affiliations[action.orgId];
	            this.state.affiliations[action.orgId] = (0, _Affiliation.removeRole)(oldAff, 'admin');
	            this.emitChange();
	            break;
	          }
	        case _OrganizationConstants.ActionTypes.UPDATE_CURRENT_USER_ORGANIZATION_AFFILIATION:
	          {
	            this.state.affiliations[action.organizationId] = action.affiliation;
	            this.emitChange();
	            break;
	          }
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'handleLoadAll',
	    value: function handleLoadAll(organizations) {
	      var _this3 = this;
	
	      this.state.affiliations = {};
	      this.state.orgIds = [];
	      organizations.forEach(function (organization) {
	        return _this3.parseOrganization(organization);
	      });
	      this.state.loaded = true;
	      this.emitChange();
	    }
	  }]);
	
	  return AffiliationStore;
	}(_Store3.default);
	
	AffiliationStore.displayName = 'AffiliationStore';
	exports.default = new AffiliationStore();

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeRole = exports.isMember = exports.getNeedsEmailConf = exports.needsEmailConf = exports.needsOptIn = exports.isTeacherOrAdmin = exports.isAdmin = exports.isPendingAdmin = exports.hasPendingRole = exports.PendingRoleShape = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var PendingRoleShape = exports.PendingRoleShape = _react.PropTypes.shape({
	  role: _react.PropTypes.string.isRequired,
	  is_affirmed: _react.PropTypes.bool,
	  is_opted_in: _react.PropTypes.bool,
	  is_email_confirmed: _react.PropTypes.bool.isRequired,
	  official_email: _react.PropTypes.string
	});
	
	// AffiliationShape
	exports.default = _react.PropTypes.shape({
	  organization_id: _react.PropTypes.number.isRequired,
	  roles: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
	  pending_roles: _react.PropTypes.arrayOf(PendingRoleShape).isRequired,
	  is_member: _react.PropTypes.bool.isRequired,
	  can_have_role_changed: _react.PropTypes.bool
	});
	var hasPendingRole = exports.hasPendingRole = function hasPendingRole(affiliation) {
	  return !!affiliation.pending_roles.length;
	};
	
	var isPendingAdmin = exports.isPendingAdmin = function isPendingAdmin(affiliation) {
	  return !!affiliation.pending_roles.find(function (pr) {
	    return pr.role === 'admin';
	  });
	};
	
	var isAdmin = exports.isAdmin = function isAdmin(affiliation) {
	  return affiliation.roles.includes('admin');
	};
	
	var isTeacherOrAdmin = exports.isTeacherOrAdmin = function isTeacherOrAdmin(affiliation) {
	  return affiliation.roles.includes('teacher') || affiliation.roles.includes('admin');
	};
	
	var needsOptIn = exports.needsOptIn = function needsOptIn(affiliation) {
	  var roleNeedsOptIn = function roleNeedsOptIn(role) {
	    return !role.is_opted_in;
	  };
	  return !!affiliation.pending_roles.find(roleNeedsOptIn);
	};
	
	var roleNeedsEmailConf = function roleNeedsEmailConf(role) {
	  return !role.is_email_confirmed;
	};
	
	var needsEmailConf = exports.needsEmailConf = function needsEmailConf(affiliation) {
	  return !!affiliation.pending_roles.find(roleNeedsEmailConf);
	};
	
	var getNeedsEmailConf = exports.getNeedsEmailConf = function getNeedsEmailConf(affiliation) {
	  return affiliation.pending_roles.find(roleNeedsEmailConf);
	};
	
	var isMember = exports.isMember = function isMember(aff) {
	  return !!aff.is_member;
	};
	
	var removeRole = exports.removeRole = function removeRole(aff, role) {
	  return _extends({}, aff, {
	    roles: aff.roles.filter(function (r) {
	      return r !== role;
	    })
	  });
	};

/***/ },
/* 1040 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var RESET_PASSWORD_TOKEN_COOKIE = exports.RESET_PASSWORD_TOKEN_COOKIE = 'resetPasswordToken';
	
	// exported so it can be used client-side in src/routes.js and server-side in lib/server.common.js
	var RESET_PASSWORD_PATH = exports.RESET_PASSWORD_PATH = '/reset_password';

/***/ },
/* 1041 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeCancelable = makeCancelable;
	exports.genericCatch = genericCatch;
	
	/* Make a promise cancelable.
	 * When the promise is canceled, it goes thought the reject chain passing {isCanceled: true}
	 *
	 * https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html
	 * https://github.com/facebook/react/issues/5465#issuecomment-157888325
	 *
	 * const cancelablePromise = makeCancelable(somePromise);
	 *
	 * cancelablePromise
	 *   .promise
	 *   .then(() => console.log('resolved'))
	 *   .catch((reason) => console.log('isCanceled', reason.isCanceled));
	 *
	 * cancelablePromise.cancel(); // Cancel the promise
	 */
	function makeCancelable(promise) {
	  var hasCanceled_ = false;
	
	  var wrappedPromise = new Promise(function (resolve, reject) {
	    promise.then(function (val) {
	      return hasCanceled_ ? reject({ isCanceled: true }) : resolve(val);
	    }).catch(function (error) {
	      return hasCanceled_ ? reject({ isCanceled: true }) : reject(error);
	    });
	  });
	
	  return {
	    promise: wrappedPromise,
	    cancel: function cancel() {
	      hasCanceled_ = true;
	    }
	  };
	}
	
	/**
	 * Generally should be replaced with a purposeful catch
	 */
	// $FlowFixMe
	function genericCatch() {
	  var _console;
	
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  (_console = console).warn.apply(_console, ['genericCatch'].concat(args));
	}

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _QuickPromotionConstants = __webpack_require__(1043);
	
	var _QuickPromotionAction = __webpack_require__(1044);
	
	var _QuickPromotionAction2 = _interopRequireDefault(_QuickPromotionAction);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuickPromotion = function (_Entity) {
	  _inherits(QuickPromotion, _Entity);
	
	  function QuickPromotion() {
	    _classCallCheck(this, QuickPromotion);
	
	    return _possibleConstructorReturn(this, (QuickPromotion.__proto__ || Object.getPrototypeOf(QuickPromotion)).apply(this, arguments));
	  }
	
	  _createClass(QuickPromotion, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.url = '/quick_promotions';
	    }
	  }, {
	    key: 'getPromotion',
	    value: function getPromotion() {
	      return this.get('promotion');
	    }
	  }, {
	    key: 'getSchemaVersion',
	    value: function getSchemaVersion() {
	      return this.get('schema_version');
	    }
	  }, {
	    key: 'getEndDate',
	    value: function getEndDate() {
	      return this.get('end_date');
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.get('type');
	    }
	  }, {
	    key: 'getTrigger',
	    value: function getTrigger() {
	      return this.get('trigger');
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return this.get('header');
	    }
	  }, {
	    key: 'getBody',
	    value: function getBody() {
	      return this.get('body');
	    }
	  }, {
	    key: 'getImageUrl',
	    value: function getImageUrl() {
	      return this.get('image_url');
	    }
	  }, {
	    key: 'getImageType',
	    value: function getImageType() {
	      return this.get('image_type');
	    }
	  }, {
	    key: 'getPrimaryAction',
	    value: function getPrimaryAction() {
	      return this.get('primary_action');
	    }
	  }, {
	    key: 'getSecondaryAction',
	    value: function getSecondaryAction() {
	      return this.get('secondary_action');
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var promotion = (0, _lodash.cloneDeep)(response);
	      promotion['primary_action'] = _QuickPromotionAction2.default.fromJSON(promotion['primary_action']);
	      if (promotion['secondary_action']) {
	        promotion['secondary_action'] = _QuickPromotionAction2.default.fromJSON(promotion['secondary_action']);
	      }
	      if (promotion['end_date']) {
	        promotion['end_date'] = new Date(promotion['end_date']);
	      }
	      promotion['trigger'] = _QuickPromotionConstants.TriggerTypes[promotion['trigger'].toUpperCase()] || _QuickPromotionConstants.TriggerTypes.UNKNOWN;
	      promotion['type'] = _QuickPromotionConstants.PromotionTypes[promotion['type'].toUpperCase()] || _QuickPromotionConstants.PromotionTypes.UNKNOWN;
	      promotion['image_type'] = _QuickPromotionConstants.ImageTypes[promotion['image_type'].toUpperCase()] || _QuickPromotionConstants.ImageTypes.UNKNOWN;
	      return promotion;
	    }
	
	    // Whether we understand how to show this QP
	
	  }, {
	    key: 'isShowable',
	    value: function isShowable() {
	      // If it's an old schema, don't show it
	      if (this.getSchemaVersion() > _QuickPromotionConstants.SCHEMA_VERSION_SUPPORTED) {
	        return false;
	      }
	
	      // If the QPs already expired, don't show it
	      var endDate = this.getEndDate();
	      if (endDate != null && new Date() > endDate) {
	        return false;
	      }
	
	      // If we don't know what type of QP it is, don't show it
	      if (this.getType() === _QuickPromotionConstants.PromotionTypes.UNKNOWN) {
	        return false;
	      }
	
	      // If we don't know what type of QP it is, don't show it
	      if (this.getTrigger() === _QuickPromotionConstants.TriggerTypes.UNKNOWN) {
	        return false;
	      }
	
	      // If we don't know how to display its image, don't show it
	      if (this.getImageType() === _QuickPromotionConstants.ImageTypes.UNKNOWN) {
	        return false;
	      }
	
	      // If we don't know how to handle one of the requested action types, don't show it
	      if (this.getPrimaryAction() != null && this.getPrimaryAction().getActionType() === _QuickPromotionConstants.ButtonActionTypes.UNKNOWN) {
	        return false;
	      }
	
	      var secondaryAction = this.getSecondaryAction();
	      if (secondaryAction != null && secondaryAction.getActionType() === _QuickPromotionConstants.ButtonActionTypes.UNKNOWN) {
	        return false;
	      }
	
	      // all checks passed, we should be able to show it!
	      return true;
	    }
	  }, {
	    key: 'recordDismissal',
	    value: function recordDismissal(response) {
	      return (0, _apiRequest2.default)('' + this.url, 'POST', {
	        promotion: this.getPromotion(),
	        response: response
	      });
	    }
	  }]);
	
	  return QuickPromotion;
	}(_Entity3.default);
	
	QuickPromotion.displayName = 'QuickPromotion';
	exports.default = QuickPromotion;

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = exports.TriggerTypes = exports.ButtonActionTypes = exports.ImageTypes = exports.PromotionTypes = exports.ResponseTypes = exports.SCHEMA_VERSION_SUPPORTED = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SCHEMA_VERSION_SUPPORTED = exports.SCHEMA_VERSION_SUPPORTED = 2;
	var ResponseTypes = exports.ResponseTypes = {
	  PRIMARY_ACTION: 'primary',
	  SECONDARY_ACTION: 'secondary'
	};
	
	var PromotionTypes = exports.PromotionTypes = (0, _enumerate2.default)(['MODAL', 'INLINE', 'TUTORING_SURVEY_MODAL', 'UNKNOWN']);
	
	var ImageTypes = exports.ImageTypes = (0, _enumerate2.default)(['IMAGE', 'BANNER', 'NONE', 'LEFT_ICON', 'RIGHT_ICON', 'UNKNOWN']);
	
	var ButtonActionTypes = exports.ButtonActionTypes = (0, _enumerate2.default)(['DEEPLINK', 'LINK', 'NONE', 'UNKNOWN']);
	
	var TriggerTypes = exports.TriggerTypes = (0, _enumerate2.default)(['APP_OPENED', 'CLASSES_LIST_TOP', 'REMINDBAR', 'UNKNOWN']);
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['PROMOTION_DISMISSED']);

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _lodash = __webpack_require__(555);
	
	var _QuickPromotionConstants = __webpack_require__(1043);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuickPromotionAction = function (_Entity) {
	  _inherits(QuickPromotionAction, _Entity);
	
	  function QuickPromotionAction() {
	    _classCallCheck(this, QuickPromotionAction);
	
	    return _possibleConstructorReturn(this, (QuickPromotionAction.__proto__ || Object.getPrototypeOf(QuickPromotionAction)).apply(this, arguments));
	  }
	
	  _createClass(QuickPromotionAction, [{
	    key: 'getLabel',
	    value: function getLabel() {
	      return this.get('label');
	    }
	  }, {
	    key: 'getActionType',
	    value: function getActionType() {
	      return this.get('action');
	    }
	  }, {
	    key: 'getActionData',
	    value: function getActionData() {
	      return this.get('action_data');
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var action = (0, _lodash.cloneDeep)(response);
	      action['action'] = _QuickPromotionConstants.ButtonActionTypes[action['action'].toUpperCase()] || _QuickPromotionConstants.ButtonActionTypes.UNKNOWN;
	      return action;
	    }
	  }]);
	
	  return QuickPromotionAction;
	}(_Entity3.default);
	
	QuickPromotionAction.displayName = 'QuickPromotionAction';
	exports.default = QuickPromotionAction;

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = exports.PromptNames = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PromptNames = exports.PromptNames = {
	  NUX_SETUP_CLASS: 'nux_setup_class',
	  NUX_START_NEW_CHAT_TOOLTIP: 'nux_start_new_chat_tooltip',
	  NUX_MORE_SIDEBAR_TOOLTIP: 'nux_more_sidebar_tooltip',
	  NUX_SETUP_SIGNATURE: 'nux_setup_signature',
	  NUX_SETUP_FIRST_SUBSCRIPTION: 'nux_setup_subscription',
	  NUX_SETUP_SMS_DEVICE: 'nux_setup_sms_device',
	  INVITE_DIALOG_CONFIRM_HIDE: 'invite_dialog_confirm_hide',
	  DESKTOP_NOTIFICATION_MODAL: 'desktop_notification_modal_web',
	  SAFETY_MODAL: 'safety_modal',
	  SP_CREATE_GROUP_MODAL: 'snp_create_group',
	  ADMIN_VERIFIED_MODAL: 'admin_verification_accepted_modal',
	  ADMIN_REJECTED_MODAL: 'admin_verification_rejected_modal',
	  ADMIN_PREVERIFIED_MODAL: 'admin_preverified_modal',
	  MESSAGE_HISTORY_MODAL: 'message_history',
	  ACTIVITIES_BANNER: 'june_2016_activities_banner',
	  NUX_CHAT_THREAD: '2016.aug.new_user_experience',
	  TYMK_MODAL: '6.11.tymk_modal',
	  TYMK_BADGE: '6.11.tymk_badge',
	  PDF_CALLOUT: 'pdf_callout_prompt',
	  LONG_ANNOUNCEMENTS_BANNER: 'web_show_long_announcements_banner',
	  TEACHER_INFO_COLLECTION: 'teacher_info_collection'
	};
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['PROMPT_DISMISSED', 'EXISTING_PROMPT_DISMISSED', 'USER_PROMPT_DISMISSED']);

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['JOIN_CLASS_FOR_SETUP_SESSION', 'REMOVE_FLAGS_FOR_SETUP_SESSION']);

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.userInExperimentVariant = userInExperimentVariant;
	
	var _ExperimentConstants = __webpack_require__(1048);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OVERRIDES_STORAGE_KEY = 'experimentOverrides';
	
	/**
	 * Set these values in localStorage. This Chrome extension makes it easy,
	 * https://chrome.google.com/webstore/detail/storage-area-explorer/ocfjjjjhkpapocigimmppepjgfdecjkb/related?hl=en
	 */
	function devOverride(apiKey) {
	  var str = window.localStorage.getItem(OVERRIDES_STORAGE_KEY);
	  if (str === null) {
	    // not set
	    return null;
	  }
	
	  try {
	    var experimentOverrides = JSON.parse(str);
	    var variant = experimentOverrides[apiKey];
	    return variant;
	  } catch (e) {
	    console.error('Error parsing experiment overrides from \'' + str + '\'', e);
	    return null;
	  }
	}
	
	/**
	 * If checkVariant is omitted, check for a default variant named the same as
	 * the web key, but lower case.
	 */
	function userInExperimentVariant(user, webKey) {
	  var checkVariant = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : webKey.toLowerCase();
	
	  var exp = _ExperimentConstants.Experiments[webKey];
	
	  (0, _invariant2.default)(exp, 'Unknown web experiment key \'' + webKey + '\'');
	
	  var apiKey = exp.apiKey,
	      validVariants = exp.validVariants;
	
	
	  (0, _invariant2.default)(validVariants.includes(checkVariant), 'currentUserInExperimentVariant called with invalid variant \'' + checkVariant + '\'');
	
	  if (false) {
	    var devOverrideVariant = devOverride(apiKey);
	    if (devOverrideVariant) {
	      return checkVariant === devOverrideVariant;
	    }
	  }
	
	  var apiVariant = user.getExperimentVariant(apiKey);
	
	  if (!validVariants.includes(apiVariant)) {
	    // This is a little drastic. We could fall back to control but then we'd
	    // potentially contaminate our experiments. Instead treat this as a
	    // downtime situation and fix it right quick.
	    throw new Error('Experiments API returned invalid variant \'' + apiVariant + '\'');
	  }
	
	  return checkVariant === apiVariant;
	}

/***/ },
/* 1048 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Experiments = exports.Experiments = {
	  TEST: { // needed for Experimentation-test
	    apiKey: '1080.apr.web.unit_test',
	    validVariants: ['control', 'someValid']
	  },
	  NEW_ACTIVITY_CREATION_FLOW: {
	    apiKey: '2016.aug.web.new_activity_creation_flow',
	    validVariants: ['control', 'enabled']
	  },
	  ACTIVITY_CREATION_INDIVIDUAL_COMPOSER: {
	    apiKey: '2016.aug.web.activity_creation_individual_composer',
	    validVariants: ['control', 'enabled']
	  },
	  COPPA_DIRECT_ADD: {
	    apiKey: '2016.sept.web.parent_coppa',
	    validVariants: ['control', 'parent_coppa']
	  },
	  PROMINENT_ORG: {
	    apiKey: '2016.sept.web.prominent_org',
	    validVariants: ['control', 'prominent_org']
	  },
	  QUICK_ACTIONS: {
	    apiKey: '2016.oct.web.quick_actions',
	    validVariants: ['control', 'quick_actions']
	  },
	  CLASS_BADGES: {
	    apiKey: '2016.nov.web.class_badges',
	    validVariants: ['control', 'class_badges']
	  },
	  FORCE_PHONE: {
	    apiKey: '2016.dec.web.force_phone',
	    validVariants: ['control', 'allow_skip', 'force_phone']
	  }
	};

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Prompt = function (_Entity) {
	  _inherits(Prompt, _Entity);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, (Prompt.__proto__ || Object.getPrototypeOf(Prompt)).apply(this, arguments));
	  }
	
	  _createClass(Prompt, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.url = '/prompts';
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        created_at: new Date(),
	        responded_at: new Date()
	      };
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var p = _lodash2.default.clone(response);
	      p['created_at'] = new Date(p['created_at']);
	      p['responded_at'] = new Date(p['responded_at']);
	      return p;
	    }
	  }, {
	    key: 'isNew',
	    value: function isNew() {
	      return true;
	    }
	  }, {
	    key: 'getAction',
	    value: function getAction() {
	      return this.get('action');
	    }
	  }, {
	    key: 'getCreatedAt',
	    value: function getCreatedAt() {
	      return this.get('created_at');
	    }
	  }, {
	    key: 'getRespondedAt',
	    value: function getRespondedAt() {
	      return this.get('responded_at');
	    }
	  }, {
	    key: 'getResponse',
	    value: function getResponse() {
	      return this.get('response');
	    }
	  }, {
	    key: 'getMessageId',
	    value: function getMessageId() {
	      return this.get('message_id');
	    }
	  }, {
	    key: 'isLessThanDaysOld',
	    value: function isLessThanDaysOld(days) {
	      return this.getCreatedAt() >= Date.now() - days * 24 * 60 * 60 * 1000;
	    }
	  }], [{
	    key: 'savePrompt',
	    value: function savePrompt(prompt) {
	      return prompt.save({}, {
	        data: {
	          prompt: {
	            action: prompt.getAction(),
	            response: prompt.getResponse()
	          }
	        }
	      });
	    }
	  }, {
	    key: 'markDismissed',
	    value: function markDismissed(prompt) {
	      var promptId = prompt.id;
	      if (prompt.id) {
	        // 1) Recent Prompts: Dismissed with a PATCH and prompt.id
	        return (0, _apiRequest2.default)('/prompts/' + promptId + '/', 'PATCH', {
	          response: 'dismissed'
	        });
	      } else {
	        // 2) Prompts Inventory: Dismissed with a POST, prompt.action, and response="dismissed"
	        return (0, _apiRequest2.default)('/prompts/', 'POST', {
	          prompt: {
	            action: prompt.getAction(),
	            response: 'dismissed'
	          }
	        });
	      }
	    }
	  }]);
	
	  return Prompt;
	}(_Entity3.default);
	
	Prompt.displayName = 'Prompt';
	exports.default = Prompt;

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCreateAll = __webpack_require__(1051);
	
	var _componentsCreateAll2 = _interopRequireDefault(_componentsCreateAll);
	
	var _createAll = _componentsCreateAll2['default'](_react2['default']);
	
	var Provider = _createAll.Provider;
	var inject = _createAll.inject;
	exports.Provider = Provider;
	exports.inject = inject;

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createAll;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _createProvider = __webpack_require__(1052);
	
	var _createProvider2 = _interopRequireDefault(_createProvider);
	
	var _createInject = __webpack_require__(1057);
	
	var _createInject2 = _interopRequireDefault(_createInject);
	
	function createAll(React) {
	  var Provider = _createProvider2['default'](React);
	  var inject = _createInject2['default'](React);
	
	  return { Provider: Provider, inject: inject };
	}
	
	module.exports = exports['default'];

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports['default'] = createProvider;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utilsShallowEqual = __webpack_require__(1053);
	
	var _utilsShallowEqual2 = _interopRequireDefault(_utilsShallowEqual);
	
	var _utilsIsPlainObject = __webpack_require__(1054);
	
	var _utilsIsPlainObject2 = _interopRequireDefault(_utilsIsPlainObject);
	
	var _utilsHasEmptyIntersection = __webpack_require__(1055);
	
	var _utilsHasEmptyIntersection2 = _interopRequireDefault(_utilsHasEmptyIntersection);
	
	var _utilsSharedKeys = __webpack_require__(1056);
	
	var _utilsSharedKeys2 = _interopRequireDefault(_utilsSharedKeys);
	
	function createProvider(React) {
	  var Component = React.Component;
	  var PropTypes = React.PropTypes;
	
	  return (function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      return { provided: this.state.provided };
	    };
	
	    _createClass(Provider, null, [{
	      key: 'contextTypes',
	      value: {
	        provided: PropTypes.object
	      },
	      enumerable: true
	    }, {
	      key: 'childContextTypes',
	      value: {
	        provided: PropTypes.object.isRequired
	      },
	      enumerable: true
	    }, {
	      key: 'propTypes',
	      value: {
	        children: PropTypes.func.isRequired,
	        provide: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
	      },
	      enumerable: true
	    }]);
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      _Component.call(this, props, context);
	      var provided = this.providedFromPropsAndContext(props, context);
	      this.state = { provided: provided };
	    }
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	      var provided = this.state.provided;
	
	      var nextProvided = this.providedFromPropsAndContext(nextProps, nextContext);
	      if (_utilsShallowEqual2['default'](provided, nextProvided)) {
	        return;
	      }
	      this.setState({ provided: nextProvided });
	    };
	
	    Provider.prototype.providedFromPropsAndContext = function providedFromPropsAndContext(props, context) {
	      var isNestedProvider = _utilsIsPlainObject2['default'](context.provided);
	      var parentProvided = isNestedProvider ? context.provided : {};
	
	      if (isNestedProvider) {
	        _invariant2['default'](_utilsIsPlainObject2['default'](parentProvided), 'This Provider appears to be nested inside another provider but received a parent `provided` ' + 'is not a plain Object. `provided` must be always be a plain Object. %s', parentProvided);
	      }
	
	      var provide = props.provide;
	
	      var provider = provide;
	
	      if (_utilsIsPlainObject2['default'](provide)) {
	        provider = function (parentProvided) {
	          return _extends({}, parentProvided, provide);
	        };
	      }
	
	      var provided = provider(parentProvided);
	
	      _invariant2['default'](_utilsIsPlainObject2['default'](provided), 'This Provider is attempting to provide something other than a plain Object. ' + 'the `provide` prop must either be a plain object itself or a function that returns ' + 'a plain Object. `provide` is or returned %s', provided);
	
	      return provided;
	    };
	
	    Provider.prototype.isNested = function isNested() {};
	
	    Provider.prototype.render = function render() {
	      var children = this.props.children;
	
	      return children();
	    };
	
	    return Provider;
	  })(Component);
	}
	
	module.exports = exports['default'];

/***/ },
/* 1053 */
/***/ function(module, exports) {

	/**
	 * copied from https://github.com/gaearon/react-redux/blob/master/src/utils/isPlainObject.js authored by @gaearon
	 */
	
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1054 */
/***/ function(module, exports) {

	/**
	 * copied from https://github.com/gaearon/react-redux/blob/master/src/utils/isPlainObject.js authored by @gaearon
	 */
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isPlainObject;
	var fnToString = function fnToString(fn) {
	  return Function.prototype.toString.call(fn);
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	
	function isPlainObject(obj) {
	  if (!obj || typeof obj !== 'object') {
	    return false;
	  }
	
	  var proto = typeof obj.constructor === 'function' ? Object.getPrototypeOf(obj) : Object.prototype;
	
	  if (proto === null) {
	    return true;
	  }
	
	  var constructor = proto.constructor;
	
	  return typeof constructor === 'function' && constructor instanceof constructor && fnToString(constructor) === fnToString(Object);
	}
	
	module.exports = exports['default'];

/***/ },
/* 1055 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = hasEmptyIntersection;
	
	function hasEmptyIntersection(objA, objB) {
	  if (!objA || !objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length === 0 || keysB.length === 0) {
	    return true;
	  }
	
	  if (objA === objB) {
	    return false;
	  }
	
	  var objCombined = _extends({}, objA, objB);
	  var keysCombined = Object.keys(objCombined);
	
	  if (keysA.length + keysB.length === keysCombined.length) {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1056 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = sharedKeys;
	
	function sharedKeys(objA, objB) {
	
	  if (!objA || !objB) {
	    return [];
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length === 0 || keysB.length === 0) {
	    return [];
	  }
	
	  if (objA === objB) {
	    return keysA;
	  }
	
	  var sharedKeys = [];
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var _iterator = keysA, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var keyA = _ref;
	
	    if (hasOwn.call(objB, keyA)) {
	      sharedKeys.push(keyA);
	    }
	  }
	
	  return sharedKeys;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = createInject;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utilsShallowEqual = __webpack_require__(1053);
	
	var _utilsShallowEqual2 = _interopRequireDefault(_utilsShallowEqual);
	
	var _utilsIsPlainObject = __webpack_require__(1054);
	
	var _utilsIsPlainObject2 = _interopRequireDefault(_utilsIsPlainObject);
	
	var defaultMapProvidedToProps = function defaultMapProvidedToProps(provided) {
	  return _extends({}, provided);
	};
	
	function getDisplayName(Component) {
	  return Component.displayName || Component.name || 'Component';
	}
	
	function createInject(React) {
	  var Component = React.Component;
	  var PropTypes = React.PropTypes;
	
	  //@TODO have not tested nextVersion stuff
	  var nextVersion = 0;
	  return function inject(mapProvidedToProps) {
	    var finalMapProvidedToProps = mapProvidedToProps || defaultMapProvidedToProps;
	
	    // Helps track hot reloading.
	    var version = nextVersion++;
	
	    function computeProvidedProps(provided) {
	      var providedProps = finalMapProvidedToProps(provided);
	      _invariant2['default'](_utilsIsPlainObject2['default'](providedProps), '`mapProvidedToProps` must return an object. Instead received %s.', providedProps);
	      return providedProps;
	    }
	
	    return function wrapWithInject(WrappedComponent) {
	      var Inject = (function (_Component) {
	        _inherits(Inject, _Component);
	
	        Inject.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState, nextContext) {
	          return !_utilsShallowEqual2['default'](this.state.provided, nextState.provided) || !_utilsShallowEqual2['default'](this.props, nextProps);
	        };
	
	        _createClass(Inject, null, [{
	          key: 'displayName',
	          value: 'inject(' + getDisplayName(WrappedComponent) + ')',
	          enumerable: true
	        }, {
	          key: 'WrappedComponent',
	          value: WrappedComponent,
	          enumerable: true
	        }, {
	          key: 'contextTypes',
	          value: {
	            provided: PropTypes.object
	          },
	          enumerable: true
	        }]);
	
	        function Inject(props, context) {
	          _classCallCheck(this, Inject);
	
	          _Component.call(this, props, context);
	          this.version = version;
	          this.provided = context.provided;
	
	          _invariant2['default'](this.provided, 'Could not find "provided" in context ' + ('of "' + this.constructor.displayName + '". ') + 'Wrap a higher component in a <Provider>. ');
	
	          this.state = {
	            provided: computeProvidedProps(this.provided)
	          };
	        }
	
	        Inject.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	          if (!_utilsShallowEqual2['default'](this.provided, nextContext.provided)) {
	            this.provided = nextContext.provided;
	            this.recomputeProvidedProps(nextContext);
	          }
	        };
	
	        Inject.prototype.recomputeProvidedProps = function recomputeProvidedProps() {
	          var context = arguments.length <= 0 || arguments[0] === undefined ? this.context : arguments[0];
	
	          var nextProvidedProps = computeProvidedProps(context.provided);
	          if (!_utilsShallowEqual2['default'](nextProvidedProps, this.state.provided)) {
	            this.setState({ provided: nextProvidedProps });
	          }
	        };
	
	        Inject.prototype.getWrappedInstance = function getWrappedInstance() {
	          return this.refs.wrappedInstance;
	        };
	
	        Inject.prototype.render = function render() {
	          return React.createElement(WrappedComponent, _extends({ ref: 'wrappedInstance'
	          }, this.state.provided, this.props));
	        };
	
	        return Inject;
	      })(Component);
	
	      if (
	      // Node-like CommonJS environments (Browserify, Webpack)
	      typeof process !== 'undefined' && "object" !== 'undefined' && ("production") !== 'production' ||
	      // React Native
	      "boolean" !== 'undefined' && (false) //eslint-disable-line no-undef
	      ) {
	          Inject.prototype.componentWillUpdate = function componentWillUpdate() {
	            if (this.version === version) {
	              return;
	            }
	
	            // We are hot reloading!
	            this.version = version;
	
	            // Update the state and bindings.
	            this.recomputeProvidedProps();
	          };
	        }
	
	      return Inject;
	    };
	  };
	}
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	 * Copyright 2016, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var allLocaleData = _interopDefault(__webpack_require__(1059));
	var IntlMessageFormat = _interopDefault(__webpack_require__(1060));
	var IntlRelativeFormat = _interopDefault(__webpack_require__(1070));
	var React = __webpack_require__(299);
	var React__default = _interopDefault(React);
	var invariant = _interopDefault(__webpack_require__(469));
	var memoizeIntlConstructor = _interopDefault(__webpack_require__(1077));
	
	// GENERATED FILE
	var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function addLocaleData() {
	    var data = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    var locales = Array.isArray(data) ? data : [data];
	
	    locales.forEach(function (localeData) {
	        if (localeData && localeData.locale) {
	            IntlMessageFormat.__addLocaleData(localeData);
	            IntlRelativeFormat.__addLocaleData(localeData);
	        }
	    });
	}
	
	function hasLocaleData(locale) {
	    var localeParts = (locale || '').split('-');
	
	    while (localeParts.length > 0) {
	        if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
	            return true;
	        }
	
	        localeParts.pop();
	    }
	
	    return false;
	}
	
	function hasIMFAndIRFLocaleData(locale) {
	    var normalizedLocale = locale && locale.toLowerCase();
	
	    return !!(IntlMessageFormat.__localeData__[normalizedLocale] && IntlRelativeFormat.__localeData__[normalizedLocale]);
	}
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	var jsx = function () {
	  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
	  return function createRawReactElement(type, props, key, children) {
	    var defaultProps = type && type.defaultProps;
	    var childrenLength = arguments.length - 3;
	
	    if (!props && childrenLength !== 0) {
	      props = {};
	    }
	
	    if (props && defaultProps) {
	      for (var propName in defaultProps) {
	        if (props[propName] === void 0) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    } else if (!props) {
	      props = defaultProps || {};
	    }
	
	    if (childrenLength === 1) {
	      props.children = children;
	    } else if (childrenLength > 1) {
	      var childArray = Array(childrenLength);
	
	      for (var i = 0; i < childrenLength; i++) {
	        childArray[i] = arguments[i + 3];
	      }
	
	      props.children = childArray;
	    }
	
	    return {
	      $$typeof: REACT_ELEMENT_TYPE,
	      type: type,
	      key: key === undefined ? null : '' + key,
	      ref: null,
	      props: props,
	      _owner: null
	    };
	  };
	}();
	
	var asyncToGenerator = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            return step("next", value);
	          }, function (err) {
	            return step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var defineEnumerableProperties = function (obj, descs) {
	  for (var key in descs) {
	    var desc = descs[key];
	    desc.configurable = desc.enumerable = true;
	    if ("value" in desc) desc.writable = true;
	    Object.defineProperty(obj, key, desc);
	  }
	
	  return obj;
	};
	
	var defaults = function (obj, defaults) {
	  var keys = Object.getOwnPropertyNames(defaults);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var value = Object.getOwnPropertyDescriptor(defaults, key);
	
	    if (value && value.configurable && obj[key] === undefined) {
	      Object.defineProperty(obj, key, value);
	    }
	  }
	
	  return obj;
	};
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var get = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var _instanceof = function (left, right) {
	  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
	    return right[Symbol.hasInstance](left);
	  } else {
	    return left instanceof right;
	  }
	};
	
	var interopRequireDefault = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};
	
	var interopRequireWildcard = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }
	
	    newObj.default = obj;
	    return newObj;
	  }
	};
	
	var newArrowCheck = function (innerThis, boundThis) {
	  if (innerThis !== boundThis) {
	    throw new TypeError("Cannot instantiate an arrow function");
	  }
	};
	
	var objectDestructuringEmpty = function (obj) {
	  if (obj == null) throw new TypeError("Cannot destructure undefined");
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var selfGlobal = typeof global === "undefined" ? self : global;
	
	var set = function set(object, property, value, receiver) {
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent !== null) {
	      set(parent, property, value, receiver);
	    }
	  } else if ("value" in desc && desc.writable) {
	    desc.value = value;
	  } else {
	    var setter = desc.set;
	
	    if (setter !== undefined) {
	      setter.call(receiver, value);
	    }
	  }
	
	  return value;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var slicedToArrayLoose = function (arr, i) {
	  if (Array.isArray(arr)) {
	    return arr;
	  } else if (Symbol.iterator in Object(arr)) {
	    var _arr = [];
	
	    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
	      _arr.push(_step.value);
	
	      if (i && _arr.length === i) break;
	    }
	
	    return _arr;
	  } else {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	  }
	};
	
	var taggedTemplateLiteral = function (strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, {
	    raw: {
	      value: Object.freeze(raw)
	    }
	  }));
	};
	
	var taggedTemplateLiteralLoose = function (strings, raw) {
	  strings.raw = raw;
	  return strings;
	};
	
	var temporalRef = function (val, name, undef) {
	  if (val === undef) {
	    throw new ReferenceError(name + " is not defined - temporal dead zone");
	  } else {
	    return val;
	  }
	};
	
	var temporalUndefined = {};
	
	var toArray = function (arr) {
	  return Array.isArray(arr) ? arr : Array.from(arr);
	};
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	
	
	var babelHelpers$1 = Object.freeze({
	  jsx: jsx,
	  asyncToGenerator: asyncToGenerator,
	  classCallCheck: classCallCheck,
	  createClass: createClass,
	  defineEnumerableProperties: defineEnumerableProperties,
	  defaults: defaults,
	  defineProperty: defineProperty,
	  get: get,
	  inherits: inherits,
	  interopRequireDefault: interopRequireDefault,
	  interopRequireWildcard: interopRequireWildcard,
	  newArrowCheck: newArrowCheck,
	  objectDestructuringEmpty: objectDestructuringEmpty,
	  objectWithoutProperties: objectWithoutProperties,
	  possibleConstructorReturn: possibleConstructorReturn,
	  selfGlobal: selfGlobal,
	  set: set,
	  slicedToArray: slicedToArray,
	  slicedToArrayLoose: slicedToArrayLoose,
	  taggedTemplateLiteral: taggedTemplateLiteral,
	  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
	  temporalRef: temporalRef,
	  temporalUndefined: temporalUndefined,
	  toArray: toArray,
	  toConsumableArray: toConsumableArray,
	  typeof: _typeof,
	  extends: _extends,
	  instanceof: _instanceof
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var bool = React.PropTypes.bool;
	var number = React.PropTypes.number;
	var string = React.PropTypes.string;
	var func = React.PropTypes.func;
	var object = React.PropTypes.object;
	var oneOf = React.PropTypes.oneOf;
	var shape = React.PropTypes.shape;
	
	
	var intlConfigPropTypes = {
	    locale: string,
	    formats: object,
	    messages: object,
	
	    defaultLocale: string,
	    defaultFormats: object
	};
	
	var intlFormatPropTypes = {
	    formatDate: func.isRequired,
	    formatTime: func.isRequired,
	    formatRelative: func.isRequired,
	    formatNumber: func.isRequired,
	    formatPlural: func.isRequired,
	    formatMessage: func.isRequired,
	    formatHTMLMessage: func.isRequired
	};
	
	var intlShape = shape(babelHelpers$1['extends']({}, intlConfigPropTypes, intlFormatPropTypes, {
	    formatters: object,
	    now: func.isRequired
	}));
	
	var messageDescriptorPropTypes = {
	    id: string.isRequired,
	    description: string,
	    defaultMessage: string
	};
	
	var dateTimeFormatPropTypes = {
	    localeMatcher: oneOf(['best fit', 'lookup']),
	    formatMatcher: oneOf(['basic', 'best fit']),
	
	    timeZone: string,
	    hour12: bool,
	
	    weekday: oneOf(['narrow', 'short', 'long']),
	    era: oneOf(['narrow', 'short', 'long']),
	    year: oneOf(['numeric', '2-digit']),
	    month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	    day: oneOf(['numeric', '2-digit']),
	    hour: oneOf(['numeric', '2-digit']),
	    minute: oneOf(['numeric', '2-digit']),
	    second: oneOf(['numeric', '2-digit']),
	    timeZoneName: oneOf(['short', 'long'])
	};
	
	var numberFormatPropTypes = {
	    localeMatcher: oneOf(['best fit', 'lookup']),
	
	    style: oneOf(['decimal', 'currency', 'percent']),
	    currency: string,
	    currencyDisplay: oneOf(['symbol', 'code', 'name']),
	    useGrouping: bool,
	
	    minimumIntegerDigits: number,
	    minimumFractionDigits: number,
	    maximumFractionDigits: number,
	    minimumSignificantDigits: number,
	    maximumSignificantDigits: number
	};
	
	var relativeFormatPropTypes = {
	    style: oneOf(['best fit', 'numeric']),
	    units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
	};
	
	var pluralFormatPropTypes = {
	    style: oneOf(['cardinal', 'ordinal'])
	};
	
	/*
	HTML escaping and shallow-equals implementations are the same as React's
	(on purpose.) Therefore, it has the following Copyright and Licensing:
	
	Copyright 2013-2014, Facebook, Inc.
	All rights reserved.
	
	This source code is licensed under the BSD-style license found in the LICENSE
	file in the root directory of React's source tree.
	*/
	
	var intlConfigPropNames = Object.keys(intlConfigPropTypes);
	
	var ESCAPED_CHARS = {
	    '&': '&amp;',
	    '>': '&gt;',
	    '<': '&lt;',
	    '"': '&quot;',
	    '\'': '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	function escape(str) {
	    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	        return ESCAPED_CHARS[match];
	    });
	}
	
	function filterProps(props, whitelist) {
	    var defaults = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	    return whitelist.reduce(function (filtered, name) {
	        if (props.hasOwnProperty(name)) {
	            filtered[name] = props[name];
	        } else if (defaults.hasOwnProperty(name)) {
	            filtered[name] = defaults[name];
	        }
	
	        return filtered;
	    }, {});
	}
	
	function invariantIntlContext() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var intl = _ref.intl;
	
	    invariant(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
	}
	
	function shallowEquals(objA, objB) {
	    if (objA === objB) {
	        return true;
	    }
	
	    if ((typeof objA === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](objB)) !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if (keysA.length !== keysB.length) {
	        return false;
	    }
	
	    // Test for A's keys different from B.
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	    for (var i = 0; i < keysA.length; i++) {
	        if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
	    var props = _ref2.props;
	    var state = _ref2.state;
	    var _ref2$context = _ref2.context;
	    var context = _ref2$context === undefined ? {} : _ref2$context;
	    var nextContext = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var _context$intl = context.intl;
	    var intl = _context$intl === undefined ? {} : _context$intl;
	    var _nextContext$intl = nextContext.intl;
	    var nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
	
	
	    return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// Inspired by react-redux's `connect()` HOC factory function implementation:
	// https://github.com/rackt/react-redux
	
	function getDisplayName(Component) {
	    return Component.displayName || Component.name || 'Component';
	}
	
	function injectIntl(WrappedComponent) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    var _options$intlPropName = options.intlPropName;
	    var intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName;
	    var _options$withRef = options.withRef;
	    var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	    var InjectIntl = function (_Component) {
	        inherits(InjectIntl, _Component);
	
	        function InjectIntl(props, context) {
	            classCallCheck(this, InjectIntl);
	
	            var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));
	
	            invariantIntlContext(context);
	            return _this;
	        }
	
	        createClass(InjectIntl, [{
	            key: 'getWrappedInstance',
	            value: function getWrappedInstance() {
	                invariant(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');
	
	                return this.refs.wrappedInstance;
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return React__default.createElement(WrappedComponent, babelHelpers$1['extends']({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
	                    ref: withRef ? 'wrappedInstance' : null
	                }));
	            }
	        }]);
	        return InjectIntl;
	    }(React.Component);
	
	    InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
	
	    InjectIntl.contextTypes = {
	        intl: intlShape
	    };
	
	    InjectIntl.WrappedComponent = WrappedComponent;
	
	    return InjectIntl;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function defineMessages(messageDescriptors) {
	  // This simply returns what's passed-in because it's meant to be a hook for
	  // babel-plugin-react-intl.
	  return messageDescriptors;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// This is a "hack" until a proper `intl-pluralformat` package is created.
	
	function resolveLocale(locales) {
	    // IntlMessageFormat#_resolveLocale() does not depend on `this`.
	    return IntlMessageFormat.prototype._resolveLocale(locales);
	}
	
	function findPluralFunction(locale) {
	    // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
	    return IntlMessageFormat.prototype._findPluralRuleFunction(locale);
	}
	
	var IntlPluralFormat = function IntlPluralFormat(locales) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    classCallCheck(this, IntlPluralFormat);
	
	    var useOrdinal = options.style === 'ordinal';
	    var pluralFn = findPluralFunction(resolveLocale(locales));
	
	    this.format = function (value) {
	        return pluralFn(value, useOrdinal);
	    };
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
	var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
	var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
	var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);
	
	var RELATIVE_FORMAT_THRESHOLDS = {
	    second: 60, // seconds to minute
	    minute: 60, // minutes to hour
	    hour: 24, // hours to day
	    day: 30, // days to month
	    month: 12 };
	
	function updateRelativeFormatThresholds(newThresholds) {
	    var thresholds = IntlRelativeFormat.thresholds;
	    thresholds.second = newThresholds.second;
	    thresholds.minute = newThresholds.minute;
	    thresholds.hour = newThresholds.hour;
	    thresholds.day = newThresholds.day;
	    thresholds.month = newThresholds.month;
	}
	
	function getNamedFormat(formats, type, name) {
	    var format = formats && formats[type] && formats[type][name];
	    if (format) {
	        return format;
	    }
	
	    if (false) {
	        console.error('[React Intl] No ' + type + ' format named: ' + name);
	    }
	}
	
	function formatDate(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var defaults = format && getNamedFormat(formats, 'date', format);
	    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
	
	    try {
	        return state.getDateTimeFormat(locale, filteredOptions).format(date);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting date.\n' + e);
	        }
	    }
	
	    return String(date);
	}
	
	function formatTime(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var defaults = format && getNamedFormat(formats, 'time', format);
	    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
	
	    if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
	        // Add default formatting options if hour, minute, or second isn't defined.
	        filteredOptions = babelHelpers$1['extends']({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
	    }
	
	    try {
	        return state.getDateTimeFormat(locale, filteredOptions).format(date);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting time.\n' + e);
	        }
	    }
	
	    return String(date);
	}
	
	function formatRelative(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var now = new Date(options.now);
	    var defaults = format && getNamedFormat(formats, 'relative', format);
	    var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults);
	
	    // Capture the current threshold values, then temporarily override them with
	    // specific values just for this render.
	    var oldThresholds = babelHelpers$1['extends']({}, IntlRelativeFormat.thresholds);
	    updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);
	
	    try {
	        return state.getRelativeFormat(locale, filteredOptions).format(date, {
	            now: isFinite(now) ? now : state.now()
	        });
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting relative time.\n' + e);
	        }
	    } finally {
	        updateRelativeFormatThresholds(oldThresholds);
	    }
	
	    return String(date);
	}
	
	function formatNumber(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var defaults = format && getNamedFormat(formats, 'number', format);
	    var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults);
	
	    try {
	        return state.getNumberFormat(locale, filteredOptions).format(value);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting number.\n' + e);
	        }
	    }
	
	    return String(value);
	}
	
	function formatPlural(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	
	
	    var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
	
	    try {
	        return state.getPluralFormat(locale, filteredOptions).format(value);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting plural.\n' + e);
	        }
	    }
	
	    return 'other';
	}
	
	function formatMessage(config, state) {
	    var messageDescriptor = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	    var values = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var messages = config.messages;
	    var defaultLocale = config.defaultLocale;
	    var defaultFormats = config.defaultFormats;
	    var id = messageDescriptor.id;
	    var defaultMessage = messageDescriptor.defaultMessage;
	
	    // `id` is a required field of a Message Descriptor.
	
	    invariant(id, '[React Intl] An `id` must be provided to format a message.');
	
	    var message = messages && messages[id];
	    var hasValues = Object.keys(values).length > 0;
	
	    // Avoid expensive message formatting for simple messages without values. In
	    // development messages will always be formatted in case of missing values.
	    if (!hasValues && ("production") === 'production') {
	        return message || defaultMessage || id;
	    }
	
	    var formattedMessage = void 0;
	
	    if (message) {
	        try {
	            var formatter = state.getMessageFormat(message, locale, formats);
	
	            formattedMessage = formatter.format(values);
	        } catch (e) {
	            if (false) {
	                console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
	            }
	        }
	    } else {
	        if (false) {
	            // This prevents warnings from littering the console in development
	            // when no `messages` are passed into the <IntlProvider> for the
	            // default locale, and a default message is in the source.
	            if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
	
	                console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
	            }
	        }
	    }
	
	    if (!formattedMessage && defaultMessage) {
	        try {
	            var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	
	            formattedMessage = _formatter.format(values);
	        } catch (e) {
	            if (false) {
	                console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
	            }
	        }
	    }
	
	    if (!formattedMessage) {
	        if (false) {
	            console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
	        }
	    }
	
	    return formattedMessage || message || defaultMessage || id;
	}
	
	function formatHTMLMessage(config, state, messageDescriptor) {
	    var rawValues = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	    // Process all the values before they are used when formatting the ICU
	    // Message string. Since the formatted message might be injected via
	    // `innerHTML`, all String-based values need to be HTML-escaped.
	    var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	        var value = rawValues[name];
	        escaped[name] = typeof value === 'string' ? escape(value) : value;
	        return escaped;
	    }, {});
	
	    return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	
	
	
	var format = Object.freeze({
	    formatDate: formatDate,
	    formatTime: formatTime,
	    formatRelative: formatRelative,
	    formatNumber: formatNumber,
	    formatPlural: formatPlural,
	    formatMessage: formatMessage,
	    formatHTMLMessage: formatHTMLMessage
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
	var intlFormatPropNames = Object.keys(intlFormatPropTypes);
	
	// These are not a static property on the `IntlProvider` class so the intl
	// config values can be inherited from an <IntlProvider> ancestor.
	var defaultProps = {
	    formats: {},
	    messages: {},
	
	    defaultLocale: 'en',
	    defaultFormats: {}
	};
	
	var IntlProvider = function (_Component) {
	    inherits(IntlProvider, _Component);
	
	    function IntlProvider(props, context) {
	        classCallCheck(this, IntlProvider);
	
	        var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));
	
	        invariant(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');
	
	        var intlContext = context.intl;
	
	        // Used to stabilize time when performing an initial rendering so that
	        // all relative times use the same reference "now" time.
	
	        var initialNow = void 0;
	        if (isFinite(props.initialNow)) {
	            initialNow = Number(props.initialNow);
	        } else {
	            // When an `initialNow` isn't provided via `props`, look to see an
	            // <IntlProvider> exists in the ancestry and call its `now()`
	            // function to propagate its value for "now".
	            initialNow = intlContext ? intlContext.now() : Date.now();
	        }
	
	        // Creating `Intl*` formatters is expensive. If there's a parent
	        // `<IntlProvider>`, then its formatters will be used. Otherwise, this
	        // memoize the `Intl*` constructors and cache them for the lifecycle of
	        // this IntlProvider instance.
	
	        var _ref = intlContext || {};
	
	        var _ref$formatters = _ref.formatters;
	        var formatters = _ref$formatters === undefined ? {
	            getDateTimeFormat: memoizeIntlConstructor(Intl.DateTimeFormat),
	            getNumberFormat: memoizeIntlConstructor(Intl.NumberFormat),
	            getMessageFormat: memoizeIntlConstructor(IntlMessageFormat),
	            getRelativeFormat: memoizeIntlConstructor(IntlRelativeFormat),
	            getPluralFormat: memoizeIntlConstructor(IntlPluralFormat)
	        } : _ref$formatters;
	
	
	        _this.state = babelHelpers$1['extends']({}, formatters, {
	
	            // Wrapper to provide stable "now" time for initial render.
	            now: function now() {
	                return _this._didDisplay ? Date.now() : initialNow;
	            }
	        });
	        return _this;
	    }
	
	    createClass(IntlProvider, [{
	        key: 'getConfig',
	        value: function getConfig() {
	            var intlContext = this.context.intl;
	
	            // Build a whitelisted config object from `props`, defaults, and
	            // `context.intl`, if an <IntlProvider> exists in the ancestry.
	
	            var config = filterProps(this.props, intlConfigPropNames$1, intlContext);
	
	            // Apply default props. This must be applied last after the props have
	            // been resolved and inherited from any <IntlProvider> in the ancestry.
	            // This matches how React resolves `defaultProps`.
	            for (var propName in defaultProps) {
	                if (config[propName] === undefined) {
	                    config[propName] = defaultProps[propName];
	                }
	            }
	
	            if (!hasLocaleData(config.locale)) {
	                var _config = config;
	                var locale = _config.locale;
	                var defaultLocale = _config.defaultLocale;
	                var defaultFormats = _config.defaultFormats;
	
	
	                if (false) {
	                    console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
	                }
	
	                // Since there's no registered locale data for `locale`, this will
	                // fallback to the `defaultLocale` to make sure things can render.
	                // The `messages` are overridden to the `defaultProps` empty object
	                // to maintain referential equality across re-renders. It's assumed
	                // each <FormattedMessage> contains a `defaultMessage` prop.
	                config = babelHelpers$1['extends']({}, config, {
	                    locale: defaultLocale,
	                    formats: defaultFormats,
	                    messages: defaultProps.messages
	                });
	            }
	
	            return config;
	        }
	    }, {
	        key: 'getBoundFormatFns',
	        value: function getBoundFormatFns(config, state) {
	            return intlFormatPropNames.reduce(function (boundFormatFns, name) {
	                boundFormatFns[name] = format[name].bind(null, config, state);
	                return boundFormatFns;
	            }, {});
	        }
	    }, {
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var config = this.getConfig();
	
	            // Bind intl factories and current config to the format functions.
	            var boundFormatFns = this.getBoundFormatFns(config, this.state);
	
	            var _state = this.state;
	            var now = _state.now;
	            var formatters = objectWithoutProperties(_state, ['now']);
	
	
	            return {
	                intl: babelHelpers$1['extends']({}, config, boundFormatFns, {
	                    formatters: formatters,
	                    now: now
	                })
	            };
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._didDisplay = true;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.Children.only(this.props.children);
	        }
	    }]);
	    return IntlProvider;
	}(React.Component);
	
	IntlProvider.displayName = 'IntlProvider';
	
	IntlProvider.contextTypes = {
	    intl: intlShape
	};
	
	IntlProvider.childContextTypes = {
	    intl: intlShape.isRequired
	};
	
	IntlProvider.propTypes = babelHelpers$1['extends']({}, intlConfigPropTypes, {
	    children: React.PropTypes.element.isRequired,
	    initialNow: React.PropTypes.any
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedDate = function (_Component) {
	    inherits(FormattedDate, _Component);
	
	    function FormattedDate(props, context) {
	        classCallCheck(this, FormattedDate);
	
	        var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedDate, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatDate = this.context.intl.formatDate;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedDate = formatDate(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedDate);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedDate
	            );
	        }
	    }]);
	    return FormattedDate;
	}(React.Component);
	
	FormattedDate.displayName = 'FormattedDate';
	
	FormattedDate.contextTypes = {
	    intl: intlShape
	};
	
	FormattedDate.propTypes = babelHelpers$1['extends']({}, dateTimeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedTime = function (_Component) {
	    inherits(FormattedTime, _Component);
	
	    function FormattedTime(props, context) {
	        classCallCheck(this, FormattedTime);
	
	        var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedTime, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatTime = this.context.intl.formatTime;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedTime = formatTime(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedTime);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedTime
	            );
	        }
	    }]);
	    return FormattedTime;
	}(React.Component);
	
	FormattedTime.displayName = 'FormattedTime';
	
	FormattedTime.contextTypes = {
	    intl: intlShape
	};
	
	FormattedTime.propTypes = babelHelpers$1['extends']({}, dateTimeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var SECOND = 1000;
	var MINUTE = 1000 * 60;
	var HOUR = 1000 * 60 * 60;
	var DAY = 1000 * 60 * 60 * 24;
	
	// The maximum timer delay value is a 32-bit signed integer.
	// See: https://mdn.io/setTimeout
	var MAX_TIMER_DELAY = 2147483647;
	
	function selectUnits(delta) {
	    var absDelta = Math.abs(delta);
	
	    if (absDelta < MINUTE) {
	        return 'second';
	    }
	
	    if (absDelta < HOUR) {
	        return 'minute';
	    }
	
	    if (absDelta < DAY) {
	        return 'hour';
	    }
	
	    // The maximum scheduled delay will be measured in days since the maximum
	    // timer delay is less than the number of milliseconds in 25 days.
	    return 'day';
	}
	
	function getUnitDelay(units) {
	    switch (units) {
	        case 'second':
	            return SECOND;
	        case 'minute':
	            return MINUTE;
	        case 'hour':
	            return HOUR;
	        case 'day':
	            return DAY;
	        default:
	            return MAX_TIMER_DELAY;
	    }
	}
	
	function isSameDate(a, b) {
	    if (a === b) {
	        return true;
	    }
	
	    var aTime = new Date(a).getTime();
	    var bTime = new Date(b).getTime();
	
	    return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
	}
	
	var FormattedRelative = function (_Component) {
	    inherits(FormattedRelative, _Component);
	
	    function FormattedRelative(props, context) {
	        classCallCheck(this, FormattedRelative);
	
	        var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));
	
	        invariantIntlContext(context);
	
	        var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
	
	        // `now` is stored as state so that `render()` remains a function of
	        // props + state, instead of accessing `Date.now()` inside `render()`.
	        _this.state = { now: now };
	        return _this;
	    }
	
	    createClass(FormattedRelative, [{
	        key: 'scheduleNextUpdate',
	        value: function scheduleNextUpdate(props, state) {
	            var _this2 = this;
	
	            var updateInterval = props.updateInterval;
	
	            // If the `updateInterval` is falsy, including `0`, then auto updates
	            // have been turned off, so we bail and skip scheduling an update.
	
	            if (!updateInterval) {
	                return;
	            }
	
	            var time = new Date(props.value).getTime();
	            var delta = time - state.now;
	            var units = props.units || selectUnits(delta);
	
	            var unitDelay = getUnitDelay(units);
	            var unitRemainder = Math.abs(delta % unitDelay);
	
	            // We want the largest possible timer delay which will still display
	            // accurate information while reducing unnecessary re-renders. The delay
	            // should be until the next "interesting" moment, like a tick from
	            // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
	            var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
	
	            clearTimeout(this._timer);
	
	            this._timer = setTimeout(function () {
	                _this2.setState({ now: _this2.context.intl.now() });
	            }, delay);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.scheduleNextUpdate(this.props, this.state);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var nextValue = _ref.value;
	
	            // When the `props.value` date changes, `state.now` needs to be updated,
	            // and the next update can be rescheduled.
	            if (!isSameDate(nextValue, this.props.value)) {
	                this.setState({ now: this.context.intl.now() });
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            this.scheduleNextUpdate(nextProps, nextState);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this._timer);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatRelative = this.context.intl.formatRelative;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedRelative = formatRelative(value, babelHelpers$1['extends']({}, this.props, this.state));
	
	            if (typeof children === 'function') {
	                return children(formattedRelative);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedRelative
	            );
	        }
	    }]);
	    return FormattedRelative;
	}(React.Component);
	
	FormattedRelative.displayName = 'FormattedRelative';
	
	FormattedRelative.contextTypes = {
	    intl: intlShape
	};
	
	FormattedRelative.propTypes = babelHelpers$1['extends']({}, relativeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    updateInterval: React.PropTypes.number,
	    initialNow: React.PropTypes.any,
	    children: React.PropTypes.func
	});
	
	FormattedRelative.defaultProps = {
	    updateInterval: 1000 * 10
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedNumber = function (_Component) {
	    inherits(FormattedNumber, _Component);
	
	    function FormattedNumber(props, context) {
	        classCallCheck(this, FormattedNumber);
	
	        var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedNumber, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatNumber = this.context.intl.formatNumber;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedNumber = formatNumber(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedNumber);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedNumber
	            );
	        }
	    }]);
	    return FormattedNumber;
	}(React.Component);
	
	FormattedNumber.displayName = 'FormattedNumber';
	
	FormattedNumber.contextTypes = {
	    intl: intlShape
	};
	
	FormattedNumber.propTypes = babelHelpers$1['extends']({}, numberFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedPlural = function (_Component) {
	    inherits(FormattedPlural, _Component);
	
	    function FormattedPlural(props, context) {
	        classCallCheck(this, FormattedPlural);
	
	        var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedPlural, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatPlural = this.context.intl.formatPlural;
	            var _props = this.props;
	            var value = _props.value;
	            var other = _props.other;
	            var children = _props.children;
	
	
	            var pluralCategory = formatPlural(value, this.props);
	            var formattedPlural = this.props[pluralCategory] || other;
	
	            if (typeof children === 'function') {
	                return children(formattedPlural);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedPlural
	            );
	        }
	    }]);
	    return FormattedPlural;
	}(React.Component);
	
	FormattedPlural.displayName = 'FormattedPlural';
	
	FormattedPlural.contextTypes = {
	    intl: intlShape
	};
	
	FormattedPlural.propTypes = babelHelpers$1['extends']({}, pluralFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	
	    other: React.PropTypes.node.isRequired,
	    zero: React.PropTypes.node,
	    one: React.PropTypes.node,
	    two: React.PropTypes.node,
	    few: React.PropTypes.node,
	    many: React.PropTypes.node,
	
	    children: React.PropTypes.func
	});
	
	FormattedPlural.defaultProps = {
	    style: 'cardinal'
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedMessage = function (_Component) {
	    inherits(FormattedMessage, _Component);
	
	    function FormattedMessage(props, context) {
	        classCallCheck(this, FormattedMessage);
	
	        var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedMessage, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            var values = this.props.values;
	            var nextValues = nextProps.values;
	
	
	            if (!shallowEquals(nextValues, values)) {
	                return true;
	            }
	
	            // Since `values` has already been checked, we know they're not
	            // different, so the current `values` are carried over so the shallow
	            // equals comparison on the other props isn't affected by the `values`.
	            var nextPropsToCheck = babelHelpers$1['extends']({}, nextProps, {
	                values: values
	            });
	
	            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                next[_key - 1] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.context.intl.formatMessage;
	            var _props = this.props;
	            var id = _props.id;
	            var description = _props.description;
	            var defaultMessage = _props.defaultMessage;
	            var values = _props.values;
	            var tagName = _props.tagName;
	            var children = _props.children;
	
	
	            var tokenDelimiter = void 0;
	            var tokenizedValues = void 0;
	            var elements = void 0;
	
	            var hasValues = values && Object.keys(values).length > 0;
	            if (hasValues) {
	                (function () {
	                    // Creates a token with a random UID that should not be guessable or
	                    // conflict with other parts of the `message` string.
	                    var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
	
	                    var generateToken = function () {
	                        var counter = 0;
	                        return function () {
	                            return 'ELEMENT-' + uid + '-' + (counter += 1);
	                        };
	                    }();
	
	                    // Splitting with a delimiter to support IE8. When using a regex
	                    // with a capture group IE8 does not include the capture group in
	                    // the resulting array.
	                    tokenDelimiter = '@__' + uid + '__@';
	                    tokenizedValues = {};
	                    elements = {};
	
	                    // Iterates over the `props` to keep track of any React Element
	                    // values so they can be represented by the `token` as a placeholder
	                    // when the `message` is formatted. This allows the formatted
	                    // message to then be broken-up into parts with references to the
	                    // React Elements inserted back in.
	                    Object.keys(values).forEach(function (name) {
	                        var value = values[name];
	
	                        if (React.isValidElement(value)) {
	                            var token = generateToken();
	                            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
	                            elements[token] = value;
	                        } else {
	                            tokenizedValues[name] = value;
	                        }
	                    });
	                })();
	            }
	
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedMessage = formatMessage(descriptor, tokenizedValues || values);
	
	            var nodes = void 0;
	
	            var hasElements = elements && Object.keys(elements).length > 0;
	            if (hasElements) {
	                // Split the message into parts so the React Element values captured
	                // above can be inserted back into the rendered message. This
	                // approach allows messages to render with React Elements while
	                // keeping React's virtual diffing working properly.
	                nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
	                    return !!part;
	                }).map(function (part) {
	                    return elements[part] || part;
	                });
	            } else {
	                nodes = [formattedMessage];
	            }
	
	            if (typeof children === 'function') {
	                return children.apply(undefined, toConsumableArray(nodes));
	            }
	
	            return React.createElement.apply(undefined, [tagName, null].concat(toConsumableArray(nodes)));
	        }
	    }]);
	    return FormattedMessage;
	}(React.Component);
	
	FormattedMessage.displayName = 'FormattedMessage';
	
	FormattedMessage.contextTypes = {
	    intl: intlShape
	};
	
	FormattedMessage.propTypes = babelHelpers$1['extends']({}, messageDescriptorPropTypes, {
	    values: React.PropTypes.object,
	    tagName: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	FormattedMessage.defaultProps = {
	    values: {},
	    tagName: 'span'
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedHTMLMessage = function (_Component) {
	    inherits(FormattedHTMLMessage, _Component);
	
	    function FormattedHTMLMessage(props, context) {
	        classCallCheck(this, FormattedHTMLMessage);
	
	        var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    createClass(FormattedHTMLMessage, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            var values = this.props.values;
	            var nextValues = nextProps.values;
	
	
	            if (!shallowEquals(nextValues, values)) {
	                return true;
	            }
	
	            // Since `values` has already been checked, we know they're not
	            // different, so the current `values` are carried over so the shallow
	            // equals comparison on the other props isn't affected by the `values`.
	            var nextPropsToCheck = babelHelpers$1['extends']({}, nextProps, {
	                values: values
	            });
	
	            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                next[_key - 1] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatHTMLMessage = this.context.intl.formatHTMLMessage;
	            var _props = this.props;
	            var id = _props.id;
	            var description = _props.description;
	            var defaultMessage = _props.defaultMessage;
	            var rawValues = _props.values;
	            var tagName = _props.tagName;
	            var children = _props.children;
	
	
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	
	            if (typeof children === 'function') {
	                return children(formattedHTMLMessage);
	            }
	
	            // Since the message presumably has HTML in it, we need to set
	            // `innerHTML` in order for it to be rendered and not escaped by React.
	            // To be safe, all string prop values were escaped when formatting the
	            // message. It is assumed that the message is not UGC, and came from the
	            // developer making it more like a template.
	            //
	            // Note: There's a perf impact of using this component since there's no
	            // way for React to do its virtual DOM diffing.
	            return React.createElement(tagName, {
	                dangerouslySetInnerHTML: {
	                    __html: formattedHTMLMessage
	                }
	            });
	        }
	    }]);
	    return FormattedHTMLMessage;
	}(React.Component);
	
	FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	
	FormattedHTMLMessage.contextTypes = {
	    intl: intlShape
	};
	
	FormattedHTMLMessage.propTypes = babelHelpers$1['extends']({}, messageDescriptorPropTypes, {
	    values: React.PropTypes.object,
	    tagName: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	FormattedHTMLMessage.defaultProps = {
	    values: {},
	    tagName: 'span'
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(defaultLocaleData);
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(allLocaleData);
	
	exports.addLocaleData = addLocaleData;
	exports.intlShape = intlShape;
	exports.injectIntl = injectIntl;
	exports.defineMessages = defineMessages;
	exports.IntlProvider = IntlProvider;
	exports.FormattedDate = FormattedDate;
	exports.FormattedTime = FormattedTime;
	exports.FormattedRelative = FormattedRelative;
	exports.FormattedNumber = FormattedNumber;
	exports.FormattedPlural = FormattedPlural;
	exports.FormattedMessage = FormattedMessage;
	exports.FormattedHTMLMessage = FormattedHTMLMessage;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1059 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(1061)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(1069);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlMessageFormat;
	exports['default'] = exports;


/***/ },
/* 1061 */
[4496, 1062, 1068],
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(1063), src$es5$$ = __webpack_require__(1064), src$compiler$$ = __webpack_require__(1065), intl$messageformat$parser$$ = __webpack_require__(1066);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	        return messageFormat._format(pattern, values);
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	            throw new Error('A value must be provided for: ' + id);
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 1063 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(1063);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 1065 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value) {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(1067)['default'];
	exports['default'] = exports;


/***/ },
/* 1067 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = (function() {
	  /*
	   * Generated by PEG.js 0.8.0.
	   *
	   * http://pegjs.majda.cz/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function SyntaxError(message, expected, found, offset, line, column) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.offset   = offset;
	    this.line     = line;
	    this.column   = column;
	
	    this.name     = "SyntaxError";
	  }
	
	  peg$subclass(SyntaxError, Error);
	
	  function parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = [],
	        peg$c1 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements
	                };
	            },
	        peg$c2 = peg$FAILED,
	        peg$c3 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c4 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText
	                };
	            },
	        peg$c5 = /^[^ \t\n\r,.+={}#]/,
	        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c7 = "{",
	        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c9 = null,
	        peg$c10 = ",",
	        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c12 = "}",
	        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c14 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2]
	                };
	            },
	        peg$c15 = "number",
	        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c17 = "date",
	        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c19 = "time",
	        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c21 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2]
	                };
	            },
	        peg$c22 = "plural",
	        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                };
	            },
	        peg$c25 = "selectordinal",
	        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c27 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                }
	            },
	        peg$c28 = "select",
	        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c30 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options
	                };
	            },
	        peg$c31 = "=",
	        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c33 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern
	                };
	            },
	        peg$c34 = "offset:",
	        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c36 = function(number) {
	                return number;
	            },
	        peg$c37 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options
	                };
	            },
	        peg$c38 = { type: "other", description: "whitespace" },
	        peg$c39 = /^[ \t\n\r]/,
	        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c41 = { type: "other", description: "optionalWhitespace" },
	        peg$c42 = /^[0-9]/,
	        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c44 = /^[0-9a-f]/i,
	        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c46 = "0",
	        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c48 = /^[1-9]/,
	        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c50 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
	        peg$c53 = "\\\\",
	        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c55 = function() { return '\\'; },
	        peg$c56 = "\\#",
	        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c58 = function() { return '\\#'; },
	        peg$c59 = "\\{",
	        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c61 = function() { return '\u007B'; },
	        peg$c62 = "\\}",
	        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c64 = function() { return '\u007D'; },
	        peg$c65 = "\\u",
	        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c67 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c68 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$reportedPos      = 0,
	        peg$cachedPos        = 0,
	        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$reportedPos, peg$currPos);
	    }
	
	    function offset() {
	      return peg$reportedPos;
	    }
	
	    function line() {
	      return peg$computePosDetails(peg$reportedPos).line;
	    }
	
	    function column() {
	      return peg$computePosDetails(peg$reportedPos).column;
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        peg$reportedPos
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(message, null, peg$reportedPos);
	    }
	
	    function peg$computePosDetails(pos) {
	      function advance(details, startPos, endPos) {
	        var p, ch;
	
	        for (p = startPos; p < endPos; p++) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	        }
	      }
	
	      if (peg$cachedPos !== pos) {
	        if (peg$cachedPos > pos) {
	          peg$cachedPos = 0;
	          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
	        }
	        advance(peg$cachedPosDetails, peg$cachedPos, pos);
	        peg$cachedPos = pos;
	      }
	
	      return peg$cachedPosDetails;
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, pos) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      var posDetails = peg$computePosDetails(pos),
	          found      = pos < input.length ? input.charAt(pos) : null;
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        pos,
	        posDetails.line,
	        posDetails.column
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$c2;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$c2;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$c2;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c3(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c4(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c5.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c6); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c5.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	          }
	        } else {
	          s1 = peg$c2;
	        }
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c7;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c8); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c10;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c11); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$c2;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$c2;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = peg$c9;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c12;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c14(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c15) {
	        s1 = peg$c15;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c16); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c17) {
	          s1 = peg$c17;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c18); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c19) {
	            s1 = peg$c19;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c20); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c10;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$c2;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$c2;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$c2;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = peg$c9;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c21(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c28) {
	        s1 = peg$c28;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$c2;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c30(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c31;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$c2;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c7;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c8); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c12;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$reportedPos = s0;
	                      s1 = peg$c33(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c34) {
	        s1 = peg$c34;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c36(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = peg$c9;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$c2;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c37(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c39.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c40); }
	          }
	        }
	      } else {
	        s0 = peg$c2;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c41); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c42.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c43); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c44.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c45); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c46;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c47); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c48.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c49); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	        if (s2 !== peg$FAILED) {
	          s2 = input.substring(s1, peg$currPos);
	        }
	        s1 = s2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c50(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c51.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c52); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c53) {
	          s1 = peg$c53;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c54); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$reportedPos = s0;
	          s1 = peg$c55();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c56) {
	            s1 = peg$c56;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c57); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c58();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c59) {
	              s1 = peg$c59;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c60); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$reportedPos = s0;
	              s1 = peg$c61();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c62) {
	                s1 = peg$c62;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c63); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c64();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c65) {
	                  s1 = peg$c65;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$c2;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$c2;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$c2;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s3 = input.substring(s2, peg$currPos);
	                  }
	                  s2 = s3;
	                  if (s2 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c67(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c68(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
	    }
	  }
	
	  return {
	    SyntaxError: SyntaxError,
	    parse:       parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map

/***/ },
/* 1068 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 1069 */
1059,
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(1071)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(1076);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlRelativeFormat;
	exports['default'] = exports;


/***/ },
/* 1071 */
[4496, 1072, 1075],
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var intl$messageformat$$ = __webpack_require__(1060), src$diff$$ = __webpack_require__(1073), src$es5$$ = __webpack_require__(1074);
	exports["default"] = RelativeFormat;
	
	// -----------------------------------------------------------------------------
	
	var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
	var STYLES = ['best fit', 'numeric'];
	
	// -- RelativeFormat -----------------------------------------------------------
	
	function RelativeFormat(locales, options) {
	    options = options || {};
	
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (src$es5$$.isArray(locales)) {
	        locales = locales.concat();
	    }
	
	    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
	    src$es5$$.defineProperty(this, '_options', {value: {
	        style: this._resolveStyle(options.style),
	        units: this._isValidUnits(options.units) && options.units
	    }});
	
	    src$es5$$.defineProperty(this, '_locales', {value: locales});
	    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
	    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlRelativeFormat is missing a ' +
	            '`locale` property value'
	        );
	    }
	
	    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;
	
	    // Add data to IntlMessageFormat.
	    intl$messageformat$$["default"].__addLocaleData(data);
	}});
	
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	
	    value: {
	        second: 45,  // seconds to minute
	        minute: 45,  // minutes to hour
	        hour  : 22,  // hours to day
	        day   : 26,  // days to month
	        month : 11   // months to year
	    }
	});
	
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style : this._options.style,
	        units : this._options.units
	    };
	};
	
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales        = this._locales;
	    var resolvedLocale = this._locale;
	
	    var field        = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future       = '';
	    var past         = '';
	    var i;
	
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	                                 'past {{0, plural, ' + past + '}}}';
	
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl$messageformat$$["default"](message, locales);
	};
	
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	
	    return messages[units];
	};
	
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale
	    );
	};
	
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();
	
	    if (date === undefined) {
	        date = now;
	    }
	
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError(
	            'The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    if (!isFinite(date)) {
	        throw new RangeError(
	            'The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    var diffReport  = src$diff$$["default"](now, date);
	    var units       = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	
	    return this._getMessage(units).format({
	        '0' : Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error(
	                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion
	            );
	        }
	    }
	
	    throw new Error(
	        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	
	    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	
	    throw new Error(
	        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	
	    for (i = 0, l = FIELDS.length; i < l; i += 1) {
	        units = FIELDS[i];
	
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	
	    return units;
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 1073 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	var round = Math.round;
	
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	
	exports["default"] = function (from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to   = +to;
	
	    var millisecond = round(to - from),
	        second      = round(millisecond / 1000),
	        minute      = round(second / 60),
	        hour        = round(minute / 60),
	        day         = round(hour / 24),
	        week        = round(day / 7);
	
	    var rawYears = daysToYears(day),
	        month    = round(rawYears * 12),
	        year     = round(rawYears);
	
	    return {
	        millisecond: millisecond,
	        second     : second,
	        minute     : minute,
	        hour       : hour,
	        day        : day,
	        week       : week,
	        month      : month,
	        year       : year
	    };
	};
	
	//# sourceMappingURL=diff.js.map

/***/ },
/* 1074 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 1075 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 1076 */
1059,
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(1078)['default'];
	exports['default'] = exports;


/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var src$es5$$ = __webpack_require__(1079);
	exports["default"] = createFormatCache;
	
	// -----------------------------------------------------------------------------
	
	function createFormatCache(FormatConstructor) {
	    var cache = src$es5$$.objCreate(null);
	
	    return function () {
	        var args    = Array.prototype.slice.call(arguments);
	        var cacheId = getCacheId(args);
	        var format  = cacheId && cache[cacheId];
	
	        if (!format) {
	            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();
	
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	
	        return format;
	    };
	}
	
	// -- Utilities ----------------------------------------------------------------
	
	function getCacheId(inputs) {
	    // When JSON is not available in the runtime, we will not create a cache id.
	    if (typeof JSON === 'undefined') { return; }
	
	    var cacheId = [];
	
	    var i, len, input;
	
	    for (i = 0, len = inputs.length; i < len; i += 1) {
	        input = inputs[i];
	
	        if (input && typeof input === 'object') {
	            cacheId.push(orderedProps(input));
	        } else {
	            cacheId.push(input);
	        }
	    }
	
	    return JSON.stringify(cacheId);
	}
	
	function orderedProps(obj) {
	    var props = [],
	        keys  = [];
	
	    var key, i, len, prop;
	
	    for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            keys.push(key);
	        }
	    }
	
	    var orderedKeys = keys.sort();
	
	    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
	        key  = orderedKeys[i];
	        prop = {};
	
	        prop[key] = obj[key];
	        props[i]  = prop;
	    }
	
	    return props;
	}
	
	//# sourceMappingURL=memoizer.js.map

/***/ },
/* 1079 */
/***/ function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	// Function.prototype.bind implementation from Mozilla Developer Network:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill
	
	var bind = Function.prototype.bind || function (oThis) {
	    if (typeof this !== 'function') {
	      // closest thing possible to the ECMAScript 5
	      // internal IsCallable function
	      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	    }
	
	    var aArgs   = Array.prototype.slice.call(arguments, 1),
	        fToBind = this,
	        fNOP    = function() {},
	        fBound  = function() {
	          return fToBind.apply(this instanceof fNOP
	                 ? this
	                 : oThis,
	                 aArgs.concat(Array.prototype.slice.call(arguments)));
	        };
	
	    if (this.prototype) {
	      // native functions don't have a prototype
	      fNOP.prototype = this.prototype;
	    }
	    fBound.prototype = new fNOP();
	
	    return fBound;
	};
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 1080 */,
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ZOPIM_JS = 'https://v2.zopim.com/?28wHYXfglWj5NGTN8wTxuTFkJztIk18f';
	
	var loadId = null;
	var isOnline = false;
	var isWindowOpen = false;
	
	function conditionButton() {
	  var elements = document.getElementsByClassName('zopim');
	  if (elements.length > 0) {
	    var isLoggedIn = _CurrentUser2.default.isSignedIn();
	    // The button is the first element (let's hope it stays that way...)
	    elements[0].style.display = isOnline && !isWindowOpen && !isLoggedIn ? '' : 'none';
	  }
	}
	
	var Zopim = function () {
	  function Zopim() {
	    _classCallCheck(this, Zopim);
	  }
	
	  _createClass(Zopim, null, [{
	    key: 'load',
	    value: function load() {
	      if (window.$zopim) {
	        return Promise.resolve(window.$zopim);
	      }
	
	      var $script = __webpack_require__(951);
	
	      if (!loadId) {
	        $script(ZOPIM_JS, loadId = _lodash2.default.uniqueId('zopim'), function () {
	          var zopim = window.$zopim;
	          if (!zopim) {
	            return;
	          }
	
	          var livechat = zopim.livechat;
	
	          // Update isOnline state
	          livechat.setOnStatus(function (status) {
	            isOnline = status === 'online';
	            conditionButton();
	          });
	
	          // Subscribe to user change to condition the button
	          _CurrentUser2.default.addChangeListener(conditionButton);
	
	          // Subscribe to show/hide to condition the button
	          livechat.window.onShow(function () {
	            isWindowOpen = true;
	            conditionButton();
	          });
	          livechat.window.onHide(function () {
	            isWindowOpen = false;
	            conditionButton();
	          });
	
	          isWindowOpen = !!livechat.window.getDisplay();
	          conditionButton();
	        });
	      }
	
	      return new Promise(function (resolve) {
	        $script.ready(loadId, function () {
	          if (window.$zopim) {
	            window.$zopim(function () {
	              return resolve(window.$zopim);
	            });
	          }
	        });
	      });
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      Zopim.load().then(function (zopim) {
	        zopim.livechat.window.show();
	        isWindowOpen = true;
	        conditionButton();
	      }).catch(function (e) {
	        return console.error('Zopim show failed', e);
	      });
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      Zopim.load().then(function (zopim) {
	        zopim.livechat.window.hide();
	        isWindowOpen = false;
	        conditionButton();
	      }).catch(function (e) {
	        return console.error('Zopim hide failed', e);
	      });
	    }
	  }, {
	    key: 'addStatusListener',
	    value: function addStatusListener(listener) {
	      Zopim.load().then(function (zopim) {
	        zopim.livechat.setOnStatus(listener);
	      }).catch(function (e) {
	        return console.error('Zopim addStatusListener failed', e);
	      });
	    }
	  }, {
	    key: 'getCurrentStatus',
	    value: function getCurrentStatus() {
	      return isOnline;
	    }
	  }]);
	
	  return Zopim;
	}();
	
	Zopim.displayName = 'Zopim';
	exports.default = Zopim;

/***/ },
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ImageSupport = __webpack_require__(1091);
	
	var _Image = __webpack_require__(1092);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Basic image component with a few options
	 */
	
	var Image = function (_React$Component) {
	  _inherits(Image, _React$Component);
	
	  function Image() {
	    _classCallCheck(this, Image);
	
	    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
	  }
	
	  _createClass(Image, [{
	    key: 'render',
	    value: function render() {
	      var _cx;
	
	      return _react2.default.createElement('img', {
	        onLoad: this.props.onLoad,
	        alt: this.props.alt,
	        src: this.props.src,
	        height: this.props.height,
	        width: this.props.width,
	        draggable: !this.props.disableUserInteraction,
	        style: this.props.style,
	        srcSet: this.props.srcSet,
	        className: (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _Image2.default.interactionDisabled, this.props.disableUserInteraction), _defineProperty(_cx, _Image2.default.circle, this.props.circle), _cx), this.props.className)
	        // Setting the key on images is a fix for Safari not rendering SVGs
	        // correctly when you change their src. This way is the src changes, it
	        // makes a new img element and Safari renders it correctly.
	        , key: this.props.src
	      });
	    }
	  }]);
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  circle: false,
	  alt: '',
	  onLoad: function onLoad() {},
	  draggable: true
	};
	Image.isSupportedType = _ImageSupport.isSupportedType;
	Image.displayName = 'Image';
	exports.default = Image;

/***/ },
/* 1091 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSupportedType = isSupportedType;
	/*  weak */
	/**
	 * ImageSupport is used to determine if a file's content type can be displayed
	 * as an image within a browser.
	 */
	
	var TYPES = {
	  'image/bmp': true,
	  'image/gif': true,
	  'image/jpeg': true,
	  'image/png': true
	};
	
	function isSupportedType(contentType) {
	  return contentType in TYPES ? TYPES[contentType] : false;
	}

/***/ },
/* 1092 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"circle":"Image__circle___1yacp","interactionDisabled":"Image__interactionDisabled___1IUvB"};

/***/ },
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4MDAgODAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA4MDAgODAwIj48cGF0aCBmaWxsPSIjZjJjYjI3IiBkPSJtMzE2LjMgMTA0LjRjLTgyLjkgMzMuMS0xNDEuNCAxMTQuMS0xNDEuNCAyMDguNyAwIDEzLjIgMS4yIDI2LjQgNC4yIDM5LjMgNC4yIDE4LjMgNi41IDM3LjQgNi41IDU2LjkgMCA3MS44LTMwIDEzNi42LTc4LjEgMTgyLjYtOC4zIDcuOS0yLjUgMjEuOSA4LjkgMjEuOWwyODMuNi0uMSAyODMuNi0uMWMxMS40IDAgMTcuMi0xNCA4LjktMjEuOS00OC4xLTQ2LTc4LjItMTEwLjctNzguMi0xODIuNiAwLTE5LjYgMi4yLTM4LjYgNi41LTU3IDMtMTIuOSA0LjItMjYuMSA0LjItMzkuMyAwLTEwMi4zLTY4LjQtMTg4LjUtMTYxLjktMjE1LjcuNy00LjEgMS4xLTguMiAxLjEtMTIuNCAwLTQxLjYtMzMuNy03NS4yLTc1LjMtNzUuMi00MS42IDAtNzUuMiAzMy43LTc1LjIgNzUuMyAwIDYuOS45IDEzLjQgMi42IDE5LjYiLz48ZyBmaWxsPSIjZTNiYzI0Ij48cGF0aCBkPSJtMzE2LjMgMTA0LjRjMjUuNy0xMC4zIDUzLjgtMTYgODMuMi0xNiAuMSAwIC4yIDAgLjQgMCAuMSAwIC4yIDAgLjQgMCAyMS44IDAgNDIuOSAzLjIgNjIuOCA4LjkuNy00LjEgMS4xLTguMiAxLjEtMTIuNCAwLTE2LjYtNS41LTMxLjktMTQuNi00NC40LTEzLjcgMTguNy0zNS43IDMwLjktNjAuNyAzMC45LTI0LjkgMC00Ny0xMi4yLTYwLjctMzAuOC05LjEgMTIuNC0xNC41IDI3LjctMTQuNSA0NC40IDAgNi43LjkgMTMuMiAyLjYgMTkuNCIvPjxwYXRoIGQ9Im0zODkgNDI3LjZjMCA2Ny43IDE3LjcgMTMxLjIgNDguNyAxODYuMmwyNDUuOS0uMWMxMS40IDAgMTcuMi0xNCA4LjktMjEuOS00OC4xLTQ2LTc4LjItMTEwLjctNzguMi0xODIuNiAwLTE5LjYgMi4yLTM4LjYgNi41LTU3IDMtMTIuOSA0LjItMjYuMSA0LjItMzkuMyAwLTc1LjEtMzYuOS0xNDEuNi05My42LTE4Mi40LTg2LjkgNjkuOS0xNDIuNCAxNzctMTQyLjQgMjk3LjEiLz48L2c+PGNpcmNsZSBmaWxsPSIjZWY3ODI5IiBjeD0iMjU5LjMiIGN5PSI3MTYuNiIgcj0iNzMuNyIvPjwvc3ZnPg=="

/***/ },
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Config = __webpack_require__(551);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BLOG = 'http://blog.remind.com';
	
	var MARKETING = _Config2.default.Environment.R101_MARKETING_URL;
	var ZENDESK = 'https://help.remind.com/hc/en-us';
	
	exports.default = {
	  MARKETING: MARKETING,
	  SIGN_UP: MARKETING + '/?sign-up=true',
	  ABOUT: MARKETING + '/about',
	  CAREERS: MARKETING + '/careers',
	  COMMUNITY: MARKETING + '/community',
	  COMMUNITY_GUIDELINES: MARKETING + '/community-guidelines',
	  FEATURES: MARKETING + '/features',
	  HOW_IT_WORKS_TEACHERS: MARKETING + '/how-it-works/teachers',
	  PRESS: MARKETING + '/press',
	  PRIVACY_POLICY: MARKETING + '/privacy-policy',
	  RCE: MARKETING + '/connected-educator/thank-you',
	  RESOURCES: MARKETING + '/resources',
	  SCHOOLS: MARKETING + '/schools',
	  TEACH_SMALL: MARKETING + '/teach-small',
	  TEACHER_RESOURCES: MARKETING + '/resources/teachers',
	  TERMS_OF_SERVICE: MARKETING + '/terms-of-service',
	  JOIN: MARKETING + '/join',
	
	  APP_DOWNLOAD: 'http://rmd.me/a',
	  HELP: 'https://help.remind.com',
	
	  CONTACT_EMAIL: 'contact@remindhq.com',
	  REPORT_EMAIL: 'report@remindhq.com',
	  SCHOOLS_EMAIL: 'schooladmin@remindhq.com',
	  SUPPORT_EMAIL: 'support@remindhq.com',
	
	  FACEBOOK: 'https://facebook.com/remindhq',
	  TWITTER: 'https://twitter.com/remindhq',
	  INSTAGRAM: 'https://instagram.com/remindhq',
	  PINTEREST: 'https://pinterest.com/remindhq',
	  YOUTUBE: 'https://youtube.com/remindhq',
	  YOUTUBE_TUTORIAL_VIDEOS: 'https://www.youtube.com/user/remind101/videos',
	  LINKEDIN: 'https://www.linkedin.com/company/remind101',
	  GOOGLE_PLUS: 'https://plus.google.com/+remindhq',
	  RSS: BLOG + '/feed',
	
	  APP_STORE: 'https://itunes.apple.com/us/app/remind101/id522826277',
	  GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=com.remind101&referrer=utm_source%3Dremind101%26utm_medium%3D%252Fapps%26utm_campaign%3Dget-it-on-google-play',
	  GOOGLE_PLAY_AUTOLOGIN_PARAM: '%26utm_term%3Dautologin_',
	  GOOGLE_PLAY_SHORT_LINK_REFERRER_AUTOLOGIN_PARAM: '?referrer=utm_term%3Dautologin_',
	  MAC_APP_STORE: 'https://itunes.apple.com/us/app/remind-safe-classroom-communication/id1059891751',
	  QR: 'https://qr.remind.com',
	
	  BLOG: BLOG,
	
	  ZENDESK: ZENDESK,
	  CHAT_FAQ: ZENDESK + '/sections/200876739-Chat',
	  CHAT_RESTRICTIONS: ZENDESK + '/articles/204484215-Are-there-restrictions-on-who-can-chat',
	  CSV_FAQ: ZENDESK + '/articles/208218366',
	  FORGOT_PASSWORD: ZENDESK + '/articles/202132223-I-did-not-receive-a-password-reset-link-via-email',
	  MOG_FAQ: ZENDESK + '/articles/203179827',
	  NO_DEVICES: ZENDESK + '/articles/202540978-How-do-I-change-how-I-receive-messages-email-text-push-notifications-',
	  PARENTAL_CONSENT: ZENDESK + '/articles/205762439',
	  SUPPORTED_BROWSERS: ZENDESK + '/articles/202409729-Which-browsers-does-Remind-support-',
	  SELECTING_SCHOOL: ZENDESK + '/articles/204922059-What-does-selecting-a-school-mean-',
	  USING_ACTIVITIES: ZENDESK + '/categories/201278283-Using-Activities',
	
	  CONTACT_FORM: ZENDESK + '/requests/new?ticket_form_id=75133',
	
	  DOWNLOAD_CHROME: 'https://www.google.com/chrome/browser/desktop/',
	  DOWNLOAD_FIREFOX: 'https://www.getfirefox.com/'
	};

/***/ },
/* 1103 */,
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UnreadStore = __webpack_require__(1030);
	
	var _UnreadStore2 = _interopRequireDefault(_UnreadStore);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The object for inter-process communication within Electron.
	 *
	 * `window.require` is defined by Electron when nodeIntegration: true
	 * @see https://github.com/atom/electron/blob/master/docs/api/browser-window.md
	 * @return {IPC} https://github.com/atom/electron/blob/master/docs/api/ipc-renderer.md
	 */
	/*  weak */
	function getIpc() {
	  if (isAvailable()) {
	    return window.require('electron').ipcRenderer;
	  } else {
	    throw new Error('Electron not available');
	  }
	}
	
	/**
	 * Receive each IPC message that the Electron desktop app sends.
	 *
	 * NOTE: NEVER REMOVE A BINDING DEFINED HERE. That would break installed
	 * versions of the desktop app and unlike web we can't auto-update. Instead,
	 * if a function can no longer be implemented, notify the user with an alert.
	 */
	function bindReceivers(ipc, router) {
	  ipc.on('show-classes', function () {
	    router.push('/classes');
	  });
	
	  ipc.on('show-chat', function () {
	    router.push('/inbox');
	  });
	
	  ipc.on('show-settings', function () {
	    router.push('/settings');
	  });
	
	  ipc.on('new-conversation', function () {
	    router.push('/classes/r/messages/new');
	  });
	
	  ipc.on('log-out', function () {
	    _AuthActions2.default.signOut();
	  });
	}
	
	function bindSenders(ipc) {
	  _UnreadStore2.default.addChangeListener(function () {
	    return ipc.send('set-app-unread-count', _UnreadStore2.default.getTotalUnread());
	  });
	}
	
	function bindIfAvailable(router) {
	  if (isAvailable()) {
	    var ipc = getIpc();
	    bindReceivers(ipc, router);
	    bindSenders(ipc);
	  }
	}
	
	function isAvailable() {
	  return !!(typeof window !== 'undefined' && window.require && window.require.extensions && // test for Node's require, not just any window.require
	  window.require('electron') // b/c some malware defines window.require that throws here
	  );
	}
	
	function showCurrentWindow() {
	  window.require('electron').remote.getCurrentWindow().show();
	}
	
	exports.default = {
	  bindIfAvailable: bindIfAvailable,
	  bindReceivers: bindReceivers,
	  bindSenders: bindSenders,
	  isAvailable: isAvailable,
	  showCurrentWindow: showCurrentWindow
	};

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _pickInputElementProps = __webpack_require__(1106);
	
	var _pickInputElementProps2 = _interopRequireDefault(_pickInputElementProps);
	
	var _DOM = __webpack_require__(1109);
	
	var _DOM2 = _interopRequireDefault(_DOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stack = [];
	
	var ScrollContext = function (_React$Component) {
	  _inherits(ScrollContext, _React$Component);
	
	  function ScrollContext() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScrollContext);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollContext.__proto__ || Object.getPrototypeOf(ScrollContext)).call.apply(_ref, [this].concat(args))), _this), _this._pos = null, _this.fix = function () {
	      var pos = _DOM2.default.getScrollPosition();
	
	      var node = _reactDom2.default.findDOMNode(_this);
	      node.style.cssText = 'position: fixed;' + ('left: -' + pos.left + 'px;') + ('top: -' + pos.top + 'px;');
	
	      _this._pos = pos;
	    }, _this.restore = function () {
	      var node = _reactDom2.default.findDOMNode(_this);
	      node.style.cssText = '';
	      if (_this._pos) {
	        window.scrollTo(_this._pos.left, _this._pos.top);
	        _this._pos = null;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ScrollContext, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var context = stack[stack.length - 1];
	      if (context) {
	        context.fix();
	        window.scrollTo(0, 0);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      stack.push(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var index = stack.indexOf(this);
	      if (index >= 0) {
	        stack.splice(index, 1);
	
	        var context = stack[stack.length - 1];
	        if (context) {
	          context.restore();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = (0, _pickInputElementProps2.default)(this.props);
	      return _react2.default.createElement(
	        'div',
	        props,
	        this.props.children
	      );
	    }
	  }]);
	
	  return ScrollContext;
	}(_react2.default.Component);
	
	ScrollContext.displayName = 'ScrollContext';
	
	
	var MockScrollContext = function MockScrollContext(props) {
	  return _react2.default.createElement('div', props);
	};
	
	exports.default = typeof window === 'undefined' ? MockScrollContext : ScrollContext;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _GlobalAttributes = __webpack_require__(1107);
	
	var _GlobalAttributes2 = _interopRequireDefault(_GlobalAttributes);
	
	var _SupportedEventNames = __webpack_require__(1108);
	
	var _SupportedEventNames2 = _interopRequireDefault(_SupportedEventNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INPUT_ATTRIBUTES = ['name', 'type', 'accept', 'autoComplete', 'autoFocus', 'checked', 'defaultChecked', 'disabled', 'maxLength', 'minLength', 'pattern', 'placeholder', 'readOnly', 'required', 'size', 'spellCheck', 'step', 'value']; /*  weak */
	
	
	var ALLOWED_PROPS = _lodash2.default.union(_GlobalAttributes2.default, _SupportedEventNames2.default, INPUT_ATTRIBUTES);
	
	exports.default = function (props) {
	  return _lodash2.default.pick(props, ALLOWED_PROPS);
	};

/***/ },
/* 1107 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	exports.default = [
	// These are our own, we could work harder and allow any data-* prop, but this works for now
	'data-test', 'data-test-selector',
	// The list of global HTML attributes that are also supported by React, camel-cased
	'accessKey', 'className', 'contentEditable', 'contextMenu', 'dir', 'draggable', 'hidden', 'id', 'lang', 'style', 'tabIndex', 'title'];

/***/ },
/* 1108 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	// The list of event names that are supported by React
	exports.default = ['onCopy', 'onCut', 'onPaste', 'onKeyDown', 'onKeyPress', 'onKeyUp', 'onFocus', 'onBlur', 'onChange', 'onInput', 'onSubmit', 'onClick', 'onContextMenu', 'onDoubleClick', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onSelect', 'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart', 'onScroll', 'onWheel'];

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getStyle = getStyle;
	exports.getOffset = getOffset;
	exports.getPosition = getPosition;
	exports.getOffsetParent = getOffsetParent;
	exports.getScrollPosition = getScrollPosition;
	
	var _camelCase = __webpack_require__(1110);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shortcut to compute element style
	 *
	 * @param {HTMLElement} elem
	 * @param {string} prop
	 * @returns {string}
	 */
	function getStyle(elem, prop) {
	  if (typeof window.getComputedStyle !== 'undefined') {
	    return window.getComputedStyle(elem, null).getPropertyValue(prop);
	  } else {
	    return elem.currentStyle[(0, _camelCase2.default)(prop)];
	  }
	}
	
	/**
	 * Get elements offset
	 *
	 * @param {HTMLElement} elem
	 * @returns {{top: number, left: number}}
	 */
	/*  weak */
	function getOffset(elem) {
	  var docElem = document.documentElement;
	  var box = { top: 0, left: 0 };
	
	  // If we don't have gBCR, just use 0,0 rather than error
	  // BlackBerry 5, iOS 3 (original iPhone)
	  if (typeof elem.getBoundingClientRect !== 'undefined') {
	    box = elem.getBoundingClientRect();
	  }
	
	  var scrollPosition = getScrollPosition();
	
	  return {
	    top: box.top + scrollPosition.top - docElem.clientTop,
	    left: box.left + scrollPosition.left - docElem.clientLeft
	  };
	}
	
	/**
	 * Get elements position
	 *
	 * @param {HTMLElement} elem
	 * @param {HTMLElement?} offsetParent
	 * @returns {{top: number, left: number}}
	 */
	function getPosition(elem, offsetParent) {
	  var offset = void 0;
	  var parentOffset = { top: 0, left: 0 };
	
	  // Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only
	  // offset parent
	  if (getStyle(elem, 'position') === 'fixed') {
	    // We assume that getBoundingClientRect is available when computed position is fixed
	    offset = elem.getBoundingClientRect();
	  } else {
	    if (!offsetParent) {
	      // Get *real* offsetParent
	      offsetParent = getOffsetParent(elem); // eslint-disable-line no-param-reassign
	    }
	
	    // Get correct offsets
	    offset = getOffset(elem);
	    if (offsetParent.nodeName !== 'HTML') {
	      parentOffset = getOffset(offsetParent);
	    }
	
	    // Add offsetParent borders
	    parentOffset.top += parseInt(getStyle(offsetParent, 'border-top-width'), 10);
	    parentOffset.left += parseInt(getStyle(offsetParent, 'border-left-width'), 10);
	  }
	
	  // Subtract parent offsets and element margins
	  return {
	    top: offset.top - parentOffset.top - parseInt(getStyle(elem, 'margin-top'), 10),
	    left: offset.left - parentOffset.left - parseInt(getStyle(elem, 'margin-left'), 10)
	  };
	}
	
	/**
	 * Get parent element
	 *
	 * @param {HTMLElement?} elem
	 * @returns {HTMLElement}
	 */
	function getOffsetParent(elem) {
	  var docElem = document.documentElement;
	  var offsetParent = elem.offsetParent || docElem;
	
	  while (offsetParent && offsetParent.nodeName !== 'HTML' && getStyle(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || docElem;
	}
	
	/**
	 * Get scroll position of an element (or document, if no element is provided)
	 *
	 * @param {HTMLElement?} elem
	 * @returns {{top: number, left: number}}
	 */
	function getScrollPosition(elem) {
	  var docElem = document.documentElement;
	  if (!elem || elem === document.body || elem === window) {
	    elem = docElem; // eslint-disable-line no-param-reassign
	  }
	  return {
	    left: elem === docElem ? window.pageXOffset || docElem.scrollLeft : elem.scrollLeft,
	    top: elem === docElem ? window.pageYOffset || docElem.scrollTop : elem.scrollTop
	  };
	}
	
	exports.default = {
	  getStyle: getStyle,
	  getOffset: getOffset,
	  getPosition: getPosition,
	  getOffsetParent: getOffsetParent,
	  getScrollPosition: getScrollPosition
	};

/***/ },
/* 1110 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = camelCase;
	/*  weak */
	function camelCase(str) {
	  return str.replace(/[_.-](\w|$)/g, function (_, x) {
	    return x.toUpperCase();
	  });
	}

/***/ },
/* 1111 */,
/* 1112 */,
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1114);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(1117);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(1119);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(299);
	
	var _storeShape = __webpack_require__(1115);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(1116);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports.default = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2.default.isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2.default.isRequired
	};
	Provider.displayName = 'Provider';

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(299);
	
	exports.default = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },
/* 1116 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(474);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(299);
	
	var _Subscription = __webpack_require__(1118);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _storeShape = __webpack_require__(1115);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _storeShape2.default, _contextTypes[subscriptionKey] = _react.PropTypes.instanceOf(_Subscription2.default), _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _react.PropTypes.instanceOf(_Subscription2.default), _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + WrappedComponent));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = _this.props[storeKey] || _this.context[storeKey];
	        _this.parentSub = props[subscriptionKey] || context[subscriptionKey];
	
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or ' + ('props of "' + displayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        // make sure `getState` is properly bound in order to avoid breaking
	        // custom store implementations that rely on the store's context
	        _this.getState = _this.store.getState.bind(_this.store);
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        return _ref2 = {}, _ref2[subscriptionKey] = this.subscription, _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        // these are just to guard against extra memory leakage if a parent element doesn't
	        // dereference this instance properly, such as an async callback that never finishes
	        this.subscription = null;
	        this.store = null;
	        this.parentSub = null;
	        this.selector.run = function () {};
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var dispatch = this.store.dispatch;
	        var getState = this.getState;
	
	        var sourceSelector = selectorFactory(dispatch, selectorFactoryOptions);
	
	        // wrap the selector in an object that tracks its results between runs
	        var selector = this.selector = {
	          shouldComponentUpdate: true,
	          props: sourceSelector(getState(), this.props),
	          run: function runComponentSelector(props) {
	            try {
	              var nextProps = sourceSelector(getState(), props);
	              if (selector.error || nextProps !== selector.props) {
	                selector.shouldComponentUpdate = true;
	                selector.props = nextProps;
	                selector.error = null;
	              }
	            } catch (error) {
	              selector.shouldComponentUpdate = true;
	              selector.error = error;
	            }
	          }
	        };
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        var _this2 = this;
	
	        if (shouldHandleStateChanges) {
	          (function () {
	            var subscription = _this2.subscription = new _Subscription2.default(_this2.store, _this2.parentSub);
	            var dummyState = {};
	
	            subscription.onStateChange = function onStateChange() {
	              this.selector.run(this.props);
	
	              if (!this.selector.shouldComponentUpdate) {
	                subscription.notifyNestedSubs();
	              } else {
	                this.componentDidUpdate = function componentDidUpdate() {
	                  this.componentDidUpdate = undefined;
	                  subscription.notifyNestedSubs();
	                };
	
	                this.setState(dummyState);
	              }
	            }.bind(_this2);
	          })();
	        }
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          if (this.subscription) this.subscription.tryUnsubscribe();
	          this.initSubscription();
	          if (shouldHandleStateChanges) this.subscription.trySubscribe();
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 1118 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      // this.onStateChange is set by connectAdvanced.initSubscription()
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(1117);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(1120);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(1121);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(1124);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(1125);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(1126);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 1120 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function shallowEqual(a, b) {
	  if (a === b) return true;
	
	  var countA = 0;
	  var countB = 0;
	
	  for (var key in a) {
	    if (hasOwn.call(a, key) && a[key] !== b[key]) return false;
	    countA++;
	  }
	
	  for (var _key in b) {
	    if (hasOwn.call(b, _key)) countB++;
	  }
	
	  return countA === countB;
	}

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(476);
	
	var _wrapMapToProps = __webpack_require__(1122);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(1123);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(478);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(1116);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(1122);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(1123);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(1127);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(1116);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _getPropClasses2 = _interopRequireDefault(_getPropClasses);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	__webpack_require__(2123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var propsToClasses = {
	  color: {
	    lava: 'Notice--lava',
	    pitch: 'Notice--pitch',
	    flame: 'Notice--flame',
	    shamrock: 'Notice--shamrock'
	  }
	};
	
	var Notice = function (_React$Component) {
	  _inherits(Notice, _React$Component);
	
	  function Notice() {
	    _classCallCheck(this, Notice);
	
	    return _possibleConstructorReturn(this, (Notice.__proto__ || Object.getPrototypeOf(Notice)).apply(this, arguments));
	  }
	
	  _createClass(Notice, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          color = _props.color,
	          glyph = _props.glyph;
	
	
	      (0, _invariant2.default)(children, 'Notice needs a children to render');
	      var rootClasses = (0, _classnames2.default)('Notice', (0, _getPropClasses2.default)(this.props, propsToClasses));
	
	      return _react2.default.createElement(
	        'div',
	        { className: rootClasses },
	        glyph && _react2.default.createElement(_Glyph2.default, { name: glyph, color: color, size: 'xsmall', solo: true, className: 'Notice-glyph' }),
	        _react2.default.createElement(
	          _Text2.default,
	          { color: 'white', size: 'small', weight: 'semibold', className: 'Notice-text' },
	          _react2.default.createElement(_TextWithEntities2.default, {
	            text: children,
	            entities: _TextEntities2.default.parseEmoji(children)
	          })
	        )
	      );
	    }
	  }]);
	
	  return Notice;
	}(_react2.default.Component);
	
	Notice.defaultProps = {
	  color: 'pitch'
	};
	Notice.displayName = 'Notice';
	exports.default = Notice;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _r101Glyphs = __webpack_require__(1134);
	
	var _r101Glyphs2 = _interopRequireDefault(_r101Glyphs);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _getPropClasses2 = _interopRequireDefault(_getPropClasses);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _GlobalAttributes = __webpack_require__(1107);
	
	var _GlobalAttributes2 = _interopRequireDefault(_GlobalAttributes);
	
	var _SupportedEventNames = __webpack_require__(1108);
	
	var _SupportedEventNames2 = _interopRequireDefault(_SupportedEventNames);
	
	__webpack_require__(1136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ALLOWED_PROPS = _lodash2.default.union(_GlobalAttributes2.default, _SupportedEventNames2.default);
	
	/*
	 * Glyph provides icons through a web font maintained in the r101-glyphs respository.
	 *
	 * Glyphicons use a web font and can be styled like text on a web page. You can customize the size
	 * and color by simply inheriting the font size and text color of the container the `Glyph` is used
	 * in or by specifying a size and/or color through props.
	 *
	 * _TODO: Use JavaScript to render this example._
	 *
	 * ```example
	 *  <div>
	 *    <Glyph name="facebook" color="facebook" size="xxxlarge" />
	 *    <Glyph name="twitter" color="twitter" size="xxxlarge" />
	 *    <Glyph name="youtube" color="lava" size="xxxlarge" />
	 *  </div>
	 * ```
	 */
	
	var Glyph = function (_React$Component) {
	  _inherits(Glyph, _React$Component);
	
	  function Glyph() {
	    _classCallCheck(this, Glyph);
	
	    return _possibleConstructorReturn(this, (Glyph.__proto__ || Object.getPrototypeOf(Glyph)).apply(this, arguments));
	  }
	
	  _createClass(Glyph, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          name = _props.name;
	
	      var iconProps = _lodash2.default.pick(this.props, ALLOWED_PROPS);
	
	      return _react2.default.createElement('i', _extends({}, iconProps, {
	        className: (0, _classnames2.default)('Glyph',
	        // $FlowFixMe
	        _r101Glyphs2.default[name] || 'Glyph-unknown', { 'Glyph--solo': this.props.solo }, (0, _getPropClasses2.default)(this.props, Glyph.propClasses), className)
	      }));
	    }
	  }]);
	
	  return Glyph;
	}(_react2.default.Component);
	
	Glyph.propClasses = {
	  size: {
	    xxxsmall: 'Glyph-sizeXxxSmall',
	    xxsmall: 'Glyph-sizeXxSmall',
	    xsmall: 'Glyph-sizeXSmall',
	    small: 'Glyph-sizeSmall',
	    medium: 'Glyph-sizeMedium',
	    large: 'Glyph-sizeLarge',
	    xlarge: 'Glyph-sizeXLarge',
	    xxlarge: 'Glyph-sizeXxLarge',
	    xxxlarge: 'Glyph-sizeXxxLarge'
	  },
	  color: {
	    lava: 'Glyph-color-lava',
	    flame: 'Glyph-color-flame',
	    tuscan: 'Glyph-color-tuscan',
	    sunrise: 'Glyph-color-sunrise',
	    shamrock: 'Glyph-color-shamrock',
	    jungle: 'Glyph-color-jungle',
	    brand: 'Glyph-color-brand',
	    violet: 'Glyph-color-violet',
	    thunder: 'Glyph-color-thunder',
	    midnight: 'Glyph-color-midnight',
	    eclipse: 'Glyph-color-eclipse',
	    koala: 'Glyph-color-koala',
	    pitch: 'Glyph-color-pitch',
	    white: 'Glyph-color-white',
	    facebook: 'Glyph-color-facebook',
	    pinterest: 'Glyph-color-pinterest',
	    twitter: 'Glyph-color-twitter'
	  }
	};
	Glyph.defaultProps = {
	  size: 'inherit',
	  color: 'inherit'
	};
	Glyph.displayName = 'Glyph';
	exports.default = Glyph;

/***/ },
/* 1134 */
/***/ function(module, exports) {

	module.exports = {
		"amazon": "Glyph-amazon",
		"android": "Glyph-android",
		"announcement-preview-eye-filled": "Glyph-announcement-preview-eye-filled",
		"announcement-preview-eye-outlined": "Glyph-announcement-preview-eye-outlined",
		"announcement": "Glyph-announcement",
		"apple": "Glyph-apple",
		"arrow-down": "Glyph-arrow-down",
		"arrow-left": "Glyph-arrow-left",
		"arrow-right": "Glyph-arrow-right",
		"arrow-up": "Glyph-arrow-up",
		"audio-level-1": "Glyph-audio-level-1",
		"audio-level-2": "Glyph-audio-level-2",
		"audio-level-3": "Glyph-audio-level-3",
		"audio-level-mute": "Glyph-audio-level-mute",
		"avatar-add": "Glyph-avatar-add",
		"avatar-circle": "Glyph-avatar-circle",
		"avatar-group-fill": "Glyph-avatar-group-fill",
		"avatar-group-stroke": "Glyph-avatar-group-stroke",
		"avatar-hexagon-fill": "Glyph-avatar-hexagon-fill",
		"avatar-remove": "Glyph-avatar-remove",
		"avatar": "Glyph-avatar",
		"bar-graph-fill": "Glyph-bar-graph-fill",
		"bar-graph-stroke": "Glyph-bar-graph-stroke",
		"bell-fill": "Glyph-bell-fill",
		"bell-stroke": "Glyph-bell-stroke",
		"book": "Glyph-book",
		"calendar-fill": "Glyph-calendar-fill",
		"calendar-stroke": "Glyph-calendar-stroke",
		"calendar": "Glyph-calendar",
		"camcorder": "Glyph-camcorder",
		"camera": "Glyph-camera",
		"cart": "Glyph-cart",
		"caution": "Glyph-caution",
		"chat-add-bubble-fill": "Glyph-chat-add-bubble-fill",
		"chat-add-bubble": "Glyph-chat-add-bubble",
		"chat-check-bubble-fill": "Glyph-chat-check-bubble-fill",
		"chat-check-bubble": "Glyph-chat-check-bubble",
		"chat-close-bubble-fill": "Glyph-chat-close-bubble-fill",
		"chat-close-bubble": "Glyph-chat-close-bubble",
		"chat-mute": "Glyph-chat-mute",
		"chat-stroke": "Glyph-chat-stroke",
		"chat": "Glyph-chat",
		"check": "Glyph-check",
		"chevron-down": "Glyph-chevron-down",
		"chevron-left": "Glyph-chevron-left",
		"chevron-right": "Glyph-chevron-right",
		"chevron-up": "Glyph-chevron-up",
		"class-leave-stroke": "Glyph-class-leave-stroke",
		"classes": "Glyph-classes",
		"clock-bubble": "Glyph-clock-bubble",
		"clock": "Glyph-clock",
		"close-btn": "Glyph-close-btn",
		"close-circle": "Glyph-close-circle",
		"close": "Glyph-close",
		"credit-card": "Glyph-credit-card",
		"crown-stroke": "Glyph-crown-stroke",
		"crown": "Glyph-crown",
		"disabled": "Glyph-disabled",
		"display-board": "Glyph-display-board",
		"dollar-circle": "Glyph-dollar-circle",
		"dollar": "Glyph-dollar",
		"download": "Glyph-download",
		"ellipses": "Glyph-ellipses",
		"email-transcript": "Glyph-email-transcript",
		"email": "Glyph-email",
		"excel": "Glyph-excel",
		"explanation-circle": "Glyph-explanation-circle",
		"explanation": "Glyph-explanation",
		"eye": "Glyph-eye",
		"facebook": "Glyph-facebook",
		"flag": "Glyph-flag",
		"fullscreen": "Glyph-fullscreen",
		"gear": "Glyph-gear",
		"globe": "Glyph-globe",
		"google-plus": "Glyph-google-plus",
		"google": "Glyph-google",
		"heart-bubble": "Glyph-heart-bubble",
		"heart": "Glyph-heart",
		"help": "Glyph-help",
		"home": "Glyph-home",
		"image": "Glyph-image",
		"info-fill": "Glyph-info-fill",
		"info": "Glyph-info",
		"instagram": "Glyph-instagram",
		"ios": "Glyph-ios",
		"lightbulb": "Glyph-lightbulb",
		"link": "Glyph-link",
		"linkedin": "Glyph-linkedin",
		"location-pin": "Glyph-location-pin",
		"lock-stroke": "Glyph-lock-stroke",
		"lock": "Glyph-lock",
		"mail": "Glyph-mail",
		"megaphone": "Glyph-megaphone",
		"message-activity": "Glyph-message-activity",
		"message-bubble-fill": "Glyph-message-bubble-fill",
		"message-bubble-stroke": "Glyph-message-bubble-stroke",
		"message-group": "Glyph-message-group",
		"message-individual": "Glyph-message-individual",
		"message": "Glyph-message",
		"microphone": "Glyph-microphone",
		"minimize": "Glyph-minimize",
		"mobile": "Glyph-mobile",
		"nav-event": "Glyph-nav-event",
		"note": "Glyph-note",
		"paperclip": "Glyph-paperclip",
		"pause": "Glyph-pause",
		"pdf": "Glyph-pdf",
		"pencil-compose-stroke": "Glyph-pencil-compose-stroke",
		"pencil-stroke": "Glyph-pencil-stroke",
		"pencil": "Glyph-pencil",
		"pinterest": "Glyph-pinterest",
		"play": "Glyph-play",
		"plus-circle-fill": "Glyph-plus-circle-fill",
		"plus-circle-stroke": "Glyph-plus-circle-stroke",
		"plus": "Glyph-plus",
		"powerpoint": "Glyph-powerpoint",
		"printer": "Glyph-printer",
		"remind-icon": "Glyph-remind-icon",
		"schedule": "Glyph-schedule",
		"school-stroke": "Glyph-school-stroke",
		"school": "Glyph-school",
		"search": "Glyph-search",
		"share": "Glyph-share",
		"sign-out": "Glyph-sign-out",
		"sort": "Glyph-sort",
		"spreadsheet": "Glyph-spreadsheet",
		"stamp-check": "Glyph-stamp-check",
		"stamp-close": "Glyph-stamp-close",
		"stamp-help": "Glyph-stamp-help",
		"stamp-star": "Glyph-stamp-star",
		"star": "Glyph-star",
		"success-checkmark-stroke": "Glyph-success-checkmark-stroke",
		"text": "Glyph-text",
		"thumbtack": "Glyph-thumbtack",
		"trash": "Glyph-trash",
		"twitter": "Glyph-twitter",
		"upload": "Glyph-upload",
		"video": "Glyph-video",
		"vimeo": "Glyph-vimeo",
		"widgets": "Glyph-widgets",
		"word": "Glyph-word",
		"world": "Glyph-world",
		"youtube": "Glyph-youtube"
	};

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPropClassesFromInstance = getPropClassesFromInstance;
	exports.default = getPropClasses;
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Helper function to connect props with classnames
	 *
	 * const props = {
	 *   color: 'green',
	 * }
	 *
	 * const propsToClasses = {
	 *   color: {
	 *     green: 'green-class',
	 *     red: 'red-class',
	 *   }
	 * }
	 *
	 * <div classNames={getPropClassesFromInstance(this)} />
	 */
	// typecheck: ignore statement
	function getPropClassesFromInstance(componentInstance, filteredProps) {
	  return getPropClasses(componentInstance.props,
	  // $FlowFixMe property `propClasses` of unknown type
	  componentInstance.constructor.propClasses || {}, filteredProps);
	}
	
	/* If you don't have a component instance, like in a stateless function
	 * want you can use getPropClasses directly.
	 *
	 * const props = {
	 *   color: 'green',
	 * }
	 *
	 * const propsToClasses = {
	 *   color: {
	 *     green: 'green-class',
	 *     red: 'red-class',
	 *   }
	 * }
	 *
	 * <div classNames={getPropClasses(props, propsToClasses)} />
	 */
	
	function getPropClasses(props, propsToClasses, filteredProps) {
	  var whiteListedProps = filteredProps || Object.keys(propsToClasses);
	
	  var propBasedClasses = whiteListedProps.reduce(function (classNames, prop) {
	    var propVal = props[prop];
	    if (propVal) {
	      if (propVal === true) {
	        classNames.push(propsToClasses[prop]);
	      } else if (propVal in propsToClasses[prop]) {
	        classNames.push(propsToClasses[prop][propVal]);
	      }
	    }
	
	    return classNames;
	  }, []);
	
	  // some propToClasses map to null values
	  return _lodash2.default.compact(propBasedClasses);
	}

/***/ },
/* 1136 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(555);
	
	var _TextWithEntities = __webpack_require__(1143);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	/**
	 * Adds rich-text entities to text using a serialize format.
	 *
	 * See `TextEntities` for various parsers.
	 */
	
	var TextWithEntities = function (_React$PureComponent) {
	  _inherits(TextWithEntities, _React$PureComponent);
	
	  function TextWithEntities() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TextWithEntities);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextWithEntities.__proto__ || Object.getPrototypeOf(TextWithEntities)).call.apply(_ref, [this].concat(args))), _this), _this._renderEntities = function (text, entities, offset, originalText) {
	      var output = [];
	
	      while (entities[0] && entities[0].offset - offset < text.length) {
	        var entity = entities.shift();
	
	        var index = entity.offset - offset;
	        if (index > 0) {
	          output.push(text.substr(0, index));
	        }
	
	        if (_this.props.shallow && entity.offset < offset) {
	          continue;
	        }
	
	        var rendered = _this.props.shallow ? originalText.substr(entity.offset, entity.length) : _this._renderEntities(text.substr(index, entity.length), entities, entity.offset, originalText);
	
	        var element = entity.renderer(originalText.substr(entity.offset, entity.length), rendered, entity.data);
	
	        if (_react2.default.isValidElement(element)) {
	          element = _react2.default.cloneElement(element, { key: entity.offset });
	        }
	
	        output.push(element);
	
	        text = text.substr(index + entity.length); // eslint-disable-line no-param-reassign
	        offset = entity.offset + entity.length; // eslint-disable-line no-param-reassign
	      }
	
	      if (!output.length) {
	        return text;
	      }
	
	      output.push(text);
	
	      return output;
	    }, _this.renderEntities = function (text, entities) {
	      var clonedEntities = (0, _lodash.clone)(entities);
	      clonedEntities.sort(function (a, b) {
	        return a.offset - b.offset || b.length - a.length;
	      });
	      return _this._renderEntities(text, clonedEntities, 0, text);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TextWithEntities, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        { className: _TextWithEntities2.default.this },
	        this.renderEntities(this.props.text, this.props.entities)
	      );
	    }
	  }]);
	
	  return TextWithEntities;
	}(_react2.default.PureComponent);
	
	TextWithEntities.displayName = 'TextWithEntities';
	exports.default = TextWithEntities;

/***/ },
/* 1143 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"this":"TextWithEntities__this___3dTe6"};

/***/ },
/* 1144 */,
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Emoji = __webpack_require__(1146);
	
	var _Emoji2 = _interopRequireDefault(_Emoji);
	
	var _ShortcodeEmoji = __webpack_require__(1151);
	
	var _ShortcodeEmoji2 = _interopRequireDefault(_ShortcodeEmoji);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _emojiAnnotationToUnicode = __webpack_require__(1152);
	
	var _emojiAnnotationToUnicode2 = _interopRequireDefault(_emojiAnnotationToUnicode);
	
	var _matchStrings = __webpack_require__(1185);
	
	var _matchStrings2 = _interopRequireDefault(_matchStrings);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _emoji = __webpack_require__(1147);
	
	var _linkifyIt = __webpack_require__(1221);
	
	var _linkifyIt2 = _interopRequireDefault(_linkifyIt);
	
	var _GroupMessageListModal = __webpack_require__(1227);
	
	var _GroupMessageListModal2 = _interopRequireDefault(_GroupMessageListModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var linkify = (0, _linkifyIt2.default)();
	
	function renderEmoji(char) {
	  return _react2.default.createElement(_Emoji2.default, { character: char });
	}
	
	function renderShortcodeEmoji(code) {
	  return _react2.default.createElement(_ShortcodeEmoji2.default, { text: code });
	}
	
	function renderLink(text, rendered, data) {
	  return _react2.default.createElement(
	    _Link2.default,
	    { href: data.url, target: '_blank' },
	    rendered
	  );
	}
	
	function getModalForPath(url) {
	  var urlParts = url.split('/');
	  if (urlParts[3] === 'classes' && urlParts[5] === 'history') {
	    return _react2.default.createElement(_GroupMessageListModal2.default, { groupCode: urlParts[4] });
	  }
	  return null;
	}
	
	function renderLinkTag(text, rendered, data) {
	  var url = data.url;
	
	  var link = _react2.default.createElement(
	    _Link2.default,
	    { href: url, target: '_blank' },
	    rendered
	  );
	  var modal = getModalForPath(url);
	  if (modal) {
	    return _react2.default.createElement(
	      _ModalTrigger2.default,
	      { modal: modal },
	      link
	    );
	  }
	  return link;
	}
	
	function renderNewline() {
	  return _react2.default.createElement('br', null);
	}
	
	function renderStrong(text, rendered) {
	  return _react2.default.createElement(
	    'strong',
	    null,
	    rendered
	  );
	}
	
	function renderWhitespace(text) {
	  return text.replace(/\t/g, '\xA0\xA0').replace(/ /g, '\xA0');
	}
	
	/**
	 * @param  {RegExp} regExp   without any capture groups (2nd arg of replace fn must be index)
	 * @param  {function} filterFn whether the match qualifies for an entity replacement
	 * @param  {function} renderer to render in place of the matching text
	 * @return {Entities[]}
	 */
	function createParser(regExp, filterFn, renderer) {
	  return function (text) {
	    var entities = [];
	    if (text) {
	      // $FlowFixMe
	      text.replace(regExp, function (match, index) {
	        if (!filterFn || filterFn(match)) {
	          entities.push({
	            offset: index,
	            length: match.length,
	            renderer: renderer
	          });
	        }
	      });
	    }
	    return entities;
	  };
	}
	
	function createUnicodeEmojiParser() {
	  // like createParser but use the standard emoji replacer,
	  // since we don't have access to the regexp it uses.
	  return function (text) {
	    var entities = [];
	    (0, _emoji.replace)(text, function (match, index) {
	      entities.push({
	        offset: index,
	        length: match.length,
	        renderer: renderEmoji
	      });
	    });
	    return entities;
	  };
	}
	
	function createShortcodeEmojiParser() {
	  var keys = (0, _matchStrings2.default)(Object.keys(_emojiAnnotationToUnicode2.default));
	  var regExp = new RegExp(':(?:' + keys + '):', 'g');
	  return createParser(regExp, null, renderShortcodeEmoji);
	}
	
	var parseUrls = function parseUrls(text) {
	  if (text) {
	    var matches = linkify.match(text) || [];
	    return matches.map(function (match) {
	      return {
	        offset: match.index,
	        length: match.text.length,
	        data: { url: match.url },
	        renderer: renderLink
	      };
	    });
	  }
	  return [];
	};
	
	exports.default = {
	  parseShortcodeEmoji: createShortcodeEmojiParser(),
	  parseNewlines: createParser(/\n/g, null, renderNewline),
	  parseLeadingWhitespace: createParser(/^[\t ]+/mg, null, renderWhitespace),
	  parseUrls: parseUrls,
	  parseAttributes: function parseAttributes(attributes) {
	    return attributes.reduce(function (result, item) {
	      switch (item.type) {
	        case 'link':
	          item.renderer = renderLinkTag;
	          result.push(item);
	          break;
	        default:
	          break;
	      }
	      return result;
	    }, []);
	  },
	  createTextMatchingParser: function createTextMatchingParser(text) {
	    var replacedText = text.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
	    return createParser(new RegExp(replacedText, 'ig'), null, renderStrong);
	  },
	
	  parseEmoji: createUnicodeEmojiParser()
	};

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _emoji = __webpack_require__(1147);
	
	var _Emoji = __webpack_require__(1149);
	
	var _Emoji2 = _interopRequireDefault(_Emoji);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Displays a Unicode emoji character using [twemoji](http://twitter.github.io/twemoji/).
	 *
	 * ```example
	 *  <div>
	 *    <Emoji character="\ud83c\udfc3" />
	 *    <Emoji character="\ud83d\udca8 " />
	 *    <Emoji character="\ud83d\ude93" />
	 *    <Emoji character="\ud83d\ude93" />
	 *    <Emoji character="\ud83d\ude93" />
	 *  </div>
	 * ```
	 *
	 * You will rarely use this component directly. Rather, look at `TextWithEntities` and
	 * `TextEntities` to parse and convert Emoji for cross-platform support.
	 *
	 * ```js
	 *  <TextWithEntities
	 *    text={text}
	 *    entities={
	 *      [].concat(
	 *        TextEntities.parseEmoji(text),
	 *        TextEntities.parseUrls(text)
	 *      )
	 *    }
	 *  />
	 * ```
	 *
	 */
	
	var Emoji = function Emoji(_ref) {
	  var character = _ref.character,
	      className = _ref.className;
	  return _react2.default.createElement(_Image2.default, {
	    className: (0, _classnames2.default)(_Emoji2.default.this, className),
	    disableUserInteraction: true,
	    src: (0, _emoji.imgSrcForUnicodeEmoji)(character),
	    alt: character
	  });
	};
	exports.default = Emoji;

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.replace = undefined;
	exports.imgSrcForEmojiHex = imgSrcForEmojiHex;
	exports.imgSrcForUnicodeEmoji = imgSrcForUnicodeEmoji;
	
	var _twemoji = __webpack_require__(1148);
	
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _twemoji.replace;
	  }
	});
	
	
	var size = 'svg';
	
	var ext = 'svg';
	
	// https://github.com/twitter/twemoji/blob/gh-pages/2/twemoji.js
	function imgSrcForEmojiHex(hex) {
	  // SVG: https://twemoji.maxcdn.com/2/svg/1f004.svg
	  // PNG: https://twemoji.maxcdn.com/2/72x72/1f004.png
	  return '' + _twemoji.base + size + '/' + hex + '.' + ext;
	}
	
	function imgSrcForUnicodeEmoji(char) {
	  var hex = grabTheRightIcon(char);
	  return imgSrcForEmojiHex(hex);
	}
	
	// COPIED from Twemoji to fix https://github.com/twitter/twemoji/pull/162
	var UFE0Fg = /\uFE0F/g;
	// avoid using a string literal like '\u200D' here because minifiers expand it inline
	var U200D = String.fromCharCode(0x200D);
	/**
	 * Used to both remove the possible variant
	 *  and to convert utf16 into code points.
	 *  If there is a zero-width-joiner (U+200D), leave the variants in.
	 * @param   string    the raw text of the emoji match
	 */
	function grabTheRightIcon(rawText) {
	  // if variant is present as \uFE0F
	  return _twemoji.convert.toCodePoint(rawText.indexOf(U200D) < 0 ? rawText.replace(UFE0Fg, '') : rawText);
	}

/***/ },
/* 1148 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var location = global.location || {};
	/*jslint indent: 2, browser: true, bitwise: true, plusplus: true */
	var twemoji = (function (
	  /*! Copyright Twitter Inc. and other contributors. Licensed under MIT *//*
	    https://github.com/twitter/twemoji/blob/gh-pages/LICENSE
	  */
	
	  // WARNING:   this file is generated automatically via
	  //            `node twemoji-generator.js`
	  //            please update its `createTwemoji` function
	  //            at the bottom of the same file instead.
	
	) {
	  'use strict';
	
	  /*jshint maxparams:4 */
	
	  var
	    // the exported module object
	    twemoji = {
	
	
	    /////////////////////////
	    //      properties     //
	    /////////////////////////
	
	      // default assets url, by default will be Twitter Inc. CDN
	      base: 'https://twemoji.maxcdn.com/2/',
	
	      // default assets file extensions, by default '.png'
	      ext: '.png',
	
	      // default assets/folder size, by default "72x72"
	      // available via Twitter CDN: 72
	      size: '72x72',
	
	      // default class name, by default 'emoji'
	      className: 'emoji',
	
	      // basic utilities / helpers to convert code points
	      // to JavaScript surrogates and vice versa
	      convert: {
	
	        /**
	         * Given an HEX codepoint, returns UTF16 surrogate pairs.
	         *
	         * @param   string  generic codepoint, i.e. '1F4A9'
	         * @return  string  codepoint transformed into utf16 surrogates pair,
	         *          i.e. \uD83D\uDCA9
	         *
	         * @example
	         *  twemoji.convert.fromCodePoint('1f1e8');
	         *  // "\ud83c\udde8"
	         *
	         *  '1f1e8-1f1f3'.split('-').map(twemoji.convert.fromCodePoint).join('')
	         *  // "\ud83c\udde8\ud83c\uddf3"
	         */
	        fromCodePoint: fromCodePoint,
	
	        /**
	         * Given UTF16 surrogate pairs, returns the equivalent HEX codepoint.
	         *
	         * @param   string  generic utf16 surrogates pair, i.e. \uD83D\uDCA9
	         * @param   string  optional separator for double code points, default='-'
	         * @return  string  utf16 transformed into codepoint, i.e. '1F4A9'
	         *
	         * @example
	         *  twemoji.convert.toCodePoint('\ud83c\udde8\ud83c\uddf3');
	         *  // "1f1e8-1f1f3"
	         *
	         *  twemoji.convert.toCodePoint('\ud83c\udde8\ud83c\uddf3', '~');
	         *  // "1f1e8~1f1f3"
	         */
	        toCodePoint: toCodePoint
	      },
	
	
	    /////////////////////////
	    //       methods       //
	    /////////////////////////
	
	      /**
	       * User first: used to remove missing images
	       * preserving the original text intent when
	       * a fallback for network problems is desired.
	       * Automatically added to Image nodes via DOM
	       * It could be recycled for string operations via:
	       *  $('img.emoji').on('error', twemoji.onerror)
	       */
	      onerror: function onerror() {
	        if (this.parentNode) {
	          this.parentNode.replaceChild(createText(this.alt), this);
	        }
	      },
	
	      /**
	       * Main method/logic to generate either <img> tags or HTMLImage nodes.
	       *  "emojify" a generic text or DOM Element.
	       *
	       * @overloads
	       *
	       * String replacement for `innerHTML` or server side operations
	       *  twemoji.parse(string);
	       *  twemoji.parse(string, Function);
	       *  twemoji.parse(string, Object);
	       *
	       * HTMLElement tree parsing for safer operations over existing DOM
	       *  twemoji.parse(HTMLElement);
	       *  twemoji.parse(HTMLElement, Function);
	       *  twemoji.parse(HTMLElement, Object);
	       *
	       * @param   string|HTMLElement  the source to parse and enrich with emoji.
	       *
	       *          string              replace emoji matches with <img> tags.
	       *                              Mainly used to inject emoji via `innerHTML`
	       *                              It does **not** parse the string or validate it,
	       *                              it simply replaces found emoji with a tag.
	       *                              NOTE: be sure this won't affect security.
	       *
	       *          HTMLElement         walk through the DOM tree and find emoji
	       *                              that are inside **text node only** (nodeType === 3)
	       *                              Mainly used to put emoji in already generated DOM
	       *                              without compromising surrounding nodes and
	       *                              **avoiding** the usage of `innerHTML`.
	       *                              NOTE: Using DOM elements instead of strings should
	       *                              improve security without compromising too much
	       *                              performance compared with a less safe `innerHTML`.
	       *
	       * @param   Function|Object  [optional]
	       *                              either the callback that will be invoked or an object
	       *                              with all properties to use per each found emoji.
	       *
	       *          Function            if specified, this will be invoked per each emoji
	       *                              that has been found through the RegExp except
	       *                              those follwed by the invariant \uFE0E ("as text").
	       *                              Once invoked, parameters will be:
	       *
	       *                                iconId:string     the lower case HEX code point
	       *                                                  i.e. "1f4a9"
	       *
	       *                                options:Object    all info for this parsing operation
	       *
	       *                                variant:char      the optional \uFE0F ("as image")
	       *                                                  variant, in case this info
	       *                                                  is anyhow meaningful.
	       *                                                  By default this is ignored.
	       *
	       *                              If such callback will return a falsy value instead
	       *                              of a valid `src` to use for the image, nothing will
	       *                              actually change for that specific emoji.
	       *
	       *
	       *          Object              if specified, an object containing the following properties
	       *
	       *            callback   Function  the callback to invoke per each found emoji.
	       *            base       string    the base url, by default twemoji.base
	       *            ext        string    the image extension, by default twemoji.ext
	       *            size       string    the assets size, by default twemoji.size
	       *
	       * @example
	       *
	       *  twemoji.parse("I \u2764\uFE0F emoji!");
	       *  // I <img class="emoji" draggable="false" alt="❤️" src="/assets/2764.gif"> emoji!
	       *
	       *
	       *  twemoji.parse("I \u2764\uFE0F emoji!", function(iconId, options) {
	       *    return '/assets/' + iconId + '.gif';
	       *  });
	       *  // I <img class="emoji" draggable="false" alt="❤️" src="/assets/2764.gif"> emoji!
	       *
	       *
	       * twemoji.parse("I \u2764\uFE0F emoji!", {
	       *   size: 72,
	       *   callback: function(iconId, options) {
	       *     return '/assets/' + options.size + '/' + iconId + options.ext;
	       *   }
	       * });
	       *  // I <img class="emoji" draggable="false" alt="❤️" src="/assets/72x72/2764.png"> emoji!
	       *
	       */
	      parse: parse,
	
	      /**
	       * Given a string, invokes the callback argument
	       *  per each emoji found in such string.
	       * This is the most raw version used by
	       *  the .parse(string) method itself.
	       *
	       * @param   string    generic string to parse
	       * @param   Function  a generic callback that will be
	       *                    invoked to replace the content.
	       *                    This calback wil receive standard
	       *                    String.prototype.replace(str, callback)
	       *                    arguments such:
	       *  callback(
	       *    rawText,  // the emoji match
	       *  );
	       *
	       *                    and others commonly received via replace.
	       */
	      replace: replace,
	
	      /**
	       * Simplify string tests against emoji.
	       *
	       * @param   string  some text that might contain emoji
	       * @return  boolean true if any emoji was found, false otherwise.
	       *
	       * @example
	       *
	       *  if (twemoji.test(someContent)) {
	       *    console.log("emoji All The Things!");
	       *  }
	       */
	      test: test
	    },
	
	    // used to escape HTML special chars in attributes
	    escaper = {
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      "'": '&#39;',
	      '"': '&quot;'
	    },
	
	    // RegExp based on emoji's official Unicode standards
	    // http://www.unicode.org/Public/UNIDATA/EmojiSources.txt
	    re = /\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d[\udc68\udc69]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d[\udc68\udc69]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83c\udff3\ufe0f\u200d\ud83c\udf08|\ud83c\udff4\u200d\u2620\ufe0f|\ud83d\udc41\u200d\ud83d\udde8|(?:[\u0023\u002a\u0030-\u0039])\ufe0f?\u20e3|(?:(?:\ud83c\udfcb|\ud83d[\udd75\udd90]|[\u261d\u26f9\u270c\u270d])(?:\ufe0f|(?!\ufe0e))|\ud83c[\udf85\udfc2-\udfc4\udfc7\udfca]|\ud83d[\udc42\udc43\udc46-\udc50\udc66-\udc69\udc6e\udc70-\udc78\udc7c\udc81-\udc83\udc85-\udc87\udcaa\udd7a\udd95\udd96\ude45-\ude47\ude4b-\ude4f\udea3\udeb4-\udeb6\udec0]|\ud83e[\udd18-\udd1e\udd26\udd30\udd33-\udd39\udd3c-\udd3e]|[\u270a\u270b])(?:\ud83c[\udffb-\udfff]|)|\ud83c\udde6\ud83c[\udde8-\uddec\uddee\uddf1\uddf2\uddf4\uddf6-\uddfa\uddfc\uddfd\uddff]|\ud83c\udde7\ud83c[\udde6\udde7\udde9-\uddef\uddf1-\uddf4\uddf6-\uddf9\uddfb\uddfc\uddfe\uddff]|\ud83c\udde8\ud83c[\udde6\udde8\udde9\uddeb-\uddee\uddf0-\uddf5\uddf7\uddfa-\uddff]|\ud83c\udde9\ud83c[\uddea\uddec\uddef\uddf0\uddf2\uddf4\uddff]|\ud83c\uddea\ud83c[\udde6\udde8\uddea\uddec\udded\uddf7-\uddfa]|\ud83c\uddeb\ud83c[\uddee-\uddf0\uddf2\uddf4\uddf7]|\ud83c\uddec\ud83c[\udde6\udde7\udde9-\uddee\uddf1-\uddf3\uddf5-\uddfa\uddfc\uddfe]|\ud83c\udded\ud83c[\uddf0\uddf2\uddf3\uddf7\uddf9\uddfa]|\ud83c\uddee\ud83c[\udde8-\uddea\uddf1-\uddf4\uddf6-\uddf9]|\ud83c\uddef\ud83c[\uddea\uddf2\uddf4\uddf5]|\ud83c\uddf0\ud83c[\uddea\uddec-\uddee\uddf2\uddf3\uddf5\uddf7\uddfc\uddfe\uddff]|\ud83c\uddf1\ud83c[\udde6-\udde8\uddee\uddf0\uddf7-\uddfb\uddfe]|\ud83c\uddf2\ud83c[\udde6\udde8-\udded\uddf0-\uddff]|\ud83c\uddf3\ud83c[\udde6\udde8\uddea-\uddec\uddee\uddf1\uddf4\uddf5\uddf7\uddfa\uddff]|\ud83c\uddf4\ud83c\uddf2|\ud83c\uddf5\ud83c[\udde6\uddea-\udded\uddf0-\uddf3\uddf7-\uddf9\uddfc\uddfe]|\ud83c\uddf6\ud83c\udde6|\ud83c\uddf7\ud83c[\uddea\uddf4\uddf8\uddfa\uddfc]|\ud83c\uddf8\ud83c[\udde6-\uddea\uddec-\uddf4\uddf7-\uddf9\uddfb\uddfd-\uddff]|\ud83c\uddf9\ud83c[\udde6\udde8\udde9\uddeb-\udded\uddef-\uddf4\uddf7\uddf9\uddfb\uddfc\uddff]|\ud83c\uddfa\ud83c[\udde6\uddec\uddf2\uddf8\uddfe\uddff]|\ud83c\uddfb\ud83c[\udde6\udde8\uddea\uddec\uddee\uddf3\uddfa]|\ud83c\uddfc\ud83c[\uddeb\uddf8]|\ud83c\uddfd\ud83c\uddf0|\ud83c\uddfe\ud83c[\uddea\uddf9]|\ud83c\uddff\ud83c[\udde6\uddf2\uddfc]|\ud83c[\udccf\udd8e\udd91-\udd9a\udde6-\uddff\ude01\ude32-\ude36\ude38-\ude3a\ude50\ude51\udf00-\udf20\udf2d-\udf35\udf37-\udf7c\udf7e-\udf84\udf86-\udf93\udfa0-\udfc1\udfc5\udfc6\udfc8\udfc9\udfcf-\udfd3\udfe0-\udff0\udff4\udff8-\udfff]|\ud83d[\udc00-\udc3e\udc40\udc44\udc45\udc51-\udc65\udc6a-\udc6d\udc6f\udc79-\udc7b\udc7d-\udc80\udc84\udc88-\udca9\udcab-\udcfc\udcff-\udd3d\udd4b-\udd4e\udd50-\udd67\udda4\uddfb-\ude44\ude48-\ude4a\ude80-\udea2\udea4-\udeb3\udeb7-\udebf\udec1-\udec5\udecc\uded0-\uded2\udeeb\udeec\udef4-\udef6]|\ud83e[\udd10-\udd17\udd20-\udd25\udd27\udd3a\udd40-\udd45\udd47-\udd4b\udd50-\udd5e\udd80-\udd91\uddc0]|[\u23e9-\u23ec\u23f0\u23f3\u26ce\u2705\u2728\u274c\u274e\u2753-\u2755\u2795-\u2797\u27b0\u27bf\ue50a]|(?:\ud83c[\udc04\udd70\udd71\udd7e\udd7f\ude02\ude1a\ude2f\ude37\udf21\udf24-\udf2c\udf36\udf7d\udf96\udf97\udf99-\udf9b\udf9e\udf9f\udfcc-\udfce\udfd4-\udfdf\udff3\udff5\udff7]|\ud83d[\udc3f\udc41\udcfd\udd49\udd4a\udd6f\udd70\udd73\udd74\udd76-\udd79\udd87\udd8a-\udd8d\udda5\udda8\uddb1\uddb2\uddbc\uddc2-\uddc4\uddd1-\uddd3\udddc-\uddde\udde1\udde3\udde8\uddef\uddf3\uddfa\udecb\udecd-\udecf\udee0-\udee5\udee9\udef0\udef3]|[\u00a9\u00ae\u203c\u2049\u2122\u2139\u2194-\u2199\u21a9\u21aa\u231a\u231b\u2328\u23cf\u23ed-\u23ef\u23f1\u23f2\u23f8-\u23fa\u24c2\u25aa\u25ab\u25b6\u25c0\u25fb-\u25fe\u2600-\u2604\u260e\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262a\u262e\u262f\u2638-\u263a\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267b\u267f\u2692-\u2694\u2696\u2697\u2699\u269b\u269c\u26a0\u26a1\u26aa\u26ab\u26b0\u26b1\u26bd\u26be\u26c4\u26c5\u26c8\u26cf\u26d1\u26d3\u26d4\u26e9\u26ea\u26f0-\u26f5\u26f7\u26f8\u26fa\u26fd\u2702\u2708\u2709\u270f\u2712\u2714\u2716\u271d\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u2764\u27a1\u2934\u2935\u2b05-\u2b07\u2b1b\u2b1c\u2b50\u2b55\u3030\u303d\u3297\u3299])(?:\ufe0f|(?!\ufe0e))/g,
	
	    // avoid runtime RegExp creation for not so smart,
	    // not JIT based, and old browsers / engines
	    UFE0Fg = /\uFE0F/g,
	
	    // avoid using a string literal like '\u200D' here because minifiers expand it inline
	    U200D = String.fromCharCode(0x200D),
	
	    // used to find HTML special chars in attributes
	    rescaper = /[&<>'"]/g,
	
	    // nodes with type 1 which should **not** be parsed (including lower case svg)
	    shouldntBeParsed = /IFRAME|NOFRAMES|NOSCRIPT|SCRIPT|SELECT|STYLE|TEXTAREA|[a-z]/,
	
	    // just a private shortcut
	    fromCharCode = String.fromCharCode;
	
	  return twemoji;
	
	
	  /////////////////////////
	  //  private functions  //
	  //     declaration     //
	  /////////////////////////
	
	  /**
	   * Shortcut to create text nodes
	   * @param   string  text used to create DOM text node
	   * @return  Node  a DOM node with that text
	   */
	  function createText(text) {
	    return document.createTextNode(text);
	  }
	
	  /**
	   * Utility function to escape html attribute text
	   * @param   string  text use in HTML attribute
	   * @return  string  text encoded to use in HTML attribute
	   */
	  function escapeHTML(s) {
	    return s.replace(rescaper, replacer);
	  }
	
	  /**
	   * Default callback used to generate emoji src
	   *  based on Twitter CDN
	   * @param   string    the emoji codepoint string
	   * @param   string    the default size to use, i.e. "36x36"
	   * @return  string    the image source to use
	   */
	  function defaultImageSrcGenerator(icon, options) {
	    return ''.concat(options.base, options.size, '/', icon, options.ext);
	  }
	
	  /**
	   * Given a generic DOM nodeType 1, walk through all children
	   * and store every nodeType 3 (#text) found in the tree.
	   * @param   Element a DOM Element with probably some text in it
	   * @param   Array the list of previously discovered text nodes
	   * @return  Array same list with new discovered nodes, if any
	   */
	  function grabAllTextNodes(node, allText) {
	    var
	      childNodes = node.childNodes,
	      length = childNodes.length,
	      subnode,
	      nodeType;
	    while (length--) {
	      subnode = childNodes[length];
	      nodeType = subnode.nodeType;
	      // parse emoji only in text nodes
	      if (nodeType === 3) {
	        // collect them to process emoji later
	        allText.push(subnode);
	      }
	      // ignore all nodes that are not type 1 or that
	      // should not be parsed as script, style, and others
	      else if (nodeType === 1 && !shouldntBeParsed.test(subnode.nodeName)) {
	        grabAllTextNodes(subnode, allText);
	      }
	    }
	    return allText;
	  }
	
	  /**
	   * Used to both remove the possible variant
	   *  and to convert utf16 into code points.
	   *  If there is a zero-width-joiner (U+200D), leave the variants in.
	   * @param   string    the raw text of the emoji match
	   */
	  function grabTheRightIcon(rawText) {
	    // if variant is present as \uFE0F
	    return toCodePoint(rawText.indexOf(U200D) < 0 ?
	      rawText.replace(UFE0Fg, '') :
	      rawText
	    );
	  }
	
	  /**
	   * DOM version of the same logic / parser:
	   *  emojify all found sub-text nodes placing images node instead.
	   * @param   Element   generic DOM node with some text in some child node
	   * @param   Object    options  containing info about how to parse
	    *
	    *            .callback   Function  the callback to invoke per each found emoji.
	    *            .base       string    the base url, by default twemoji.base
	    *            .ext        string    the image extension, by default twemoji.ext
	    *            .size       string    the assets size, by default twemoji.size
	    *
	   * @return  Element same generic node with emoji in place, if any.
	   */
	  function parseNode(node, options) {
	    var
	      allText = grabAllTextNodes(node, []),
	      length = allText.length,
	      attrib,
	      attrname,
	      modified,
	      fragment,
	      subnode,
	      text,
	      match,
	      i,
	      index,
	      img,
	      rawText,
	      iconId,
	      src;
	    while (length--) {
	      modified = false;
	      fragment = document.createDocumentFragment();
	      subnode = allText[length];
	      text = subnode.nodeValue;
	      i = 0;
	      while ((match = re.exec(text))) {
	        index = match.index;
	        if (index !== i) {
	          fragment.appendChild(
	            createText(text.slice(i, index))
	          );
	        }
	        rawText = match[0];
	        iconId = grabTheRightIcon(rawText);
	        i = index + rawText.length;
	        src = options.callback(iconId, options);
	        if (src) {
	          img = new Image();
	          img.onerror = options.onerror;
	          img.setAttribute('draggable', 'false');
	          attrib = options.attributes(rawText, iconId);
	          for (attrname in attrib) {
	            if (
	              attrib.hasOwnProperty(attrname) &&
	              // don't allow any handlers to be set + don't allow overrides
	              attrname.indexOf('on') !== 0 &&
	              !img.hasAttribute(attrname)
	            ) {
	              img.setAttribute(attrname, attrib[attrname]);
	            }
	          }
	          img.className = options.className;
	          img.alt = rawText;
	          img.src = src;
	          modified = true;
	          fragment.appendChild(img);
	        }
	        if (!img) fragment.appendChild(createText(rawText));
	        img = null;
	      }
	      // is there actually anything to replace in here ?
	      if (modified) {
	        // any text left to be added ?
	        if (i < text.length) {
	          fragment.appendChild(
	            createText(text.slice(i))
	          );
	        }
	        // replace the text node only, leave intact
	        // anything else surrounding such text
	        subnode.parentNode.replaceChild(fragment, subnode);
	      }
	    }
	    return node;
	  }
	
	  /**
	   * String/HTML version of the same logic / parser:
	   *  emojify a generic text placing images tags instead of surrogates pair.
	   * @param   string    generic string with possibly some emoji in it
	   * @param   Object    options  containing info about how to parse
	   *
	   *            .callback   Function  the callback to invoke per each found emoji.
	   *            .base       string    the base url, by default twemoji.base
	   *            .ext        string    the image extension, by default twemoji.ext
	   *            .size       string    the assets size, by default twemoji.size
	   *
	   * @return  the string with <img tags> replacing all found and parsed emoji
	   */
	  function parseString(str, options) {
	    return replace(str, function (rawText) {
	      var
	        ret = rawText,
	        iconId = grabTheRightIcon(rawText),
	        src = options.callback(iconId, options),
	        attrib,
	        attrname;
	      if (src) {
	        // recycle the match string replacing the emoji
	        // with its image counter part
	        ret = '<img '.concat(
	          'class="', options.className, '" ',
	          'draggable="false" ',
	          // needs to preserve user original intent
	          // when variants should be copied and pasted too
	          'alt="',
	          rawText,
	          '"',
	          ' src="',
	          src,
	          '"'
	        );
	        attrib = options.attributes(rawText, iconId);
	        for (attrname in attrib) {
	          if (
	            attrib.hasOwnProperty(attrname) &&
	            // don't allow any handlers to be set + don't allow overrides
	            attrname.indexOf('on') !== 0 &&
	            ret.indexOf(' ' + attrname + '=') === -1
	          ) {
	            ret = ret.concat(' ', attrname, '="', escapeHTML(attrib[attrname]), '"');
	          }
	        }
	        ret = ret.concat('>');
	      }
	      return ret;
	    });
	  }
	
	  /**
	   * Function used to actually replace HTML special chars
	   * @param   string  HTML special char
	   * @return  string  encoded HTML special char
	   */
	  function replacer(m) {
	    return escaper[m];
	  }
	
	  /**
	   * Default options.attribute callback
	   * @return  null
	   */
	  function returnNull() {
	    return null;
	  }
	
	  /**
	   * Given a generic value, creates its squared counterpart if it's a number.
	   *  As example, number 36 will return '36x36'.
	   * @param   any     a generic value.
	   * @return  any     a string representing asset size, i.e. "36x36"
	   *                  only in case the value was a number.
	   *                  Returns initial value otherwise.
	   */
	  function toSizeSquaredAsset(value) {
	    return typeof value === 'number' ?
	      value + 'x' + value :
	      value;
	  }
	
	
	  /////////////////////////
	  //  exported functions //
	  //     declaration     //
	  /////////////////////////
	
	  function fromCodePoint(codepoint) {
	    var code = typeof codepoint === 'string' ?
	          parseInt(codepoint, 16) : codepoint;
	    if (code < 0x10000) {
	      return fromCharCode(code);
	    }
	    code -= 0x10000;
	    return fromCharCode(
	      0xD800 + (code >> 10),
	      0xDC00 + (code & 0x3FF)
	    );
	  }
	
	  function parse(what, how) {
	    if (!how || typeof how === 'function') {
	      how = {callback: how};
	    }
	    // if first argument is string, inject html <img> tags
	    // otherwise use the DOM tree and parse text nodes only
	    return (typeof what === 'string' ? parseString : parseNode)(what, {
	      callback:   how.callback || defaultImageSrcGenerator,
	      attributes: typeof how.attributes === 'function' ? how.attributes : returnNull,
	      base:       typeof how.base === 'string' ? how.base : twemoji.base,
	      ext:        how.ext || twemoji.ext,
	      size:       how.folder || toSizeSquaredAsset(how.size || twemoji.size),
	      className:  how.className || twemoji.className,
	      onerror:    how.onerror || twemoji.onerror
	    });
	  }
	
	  function replace(text, callback) {
	    return String(text).replace(re, callback);
	  }
	
	  function test(text) {
	    // IE6 needs a reset before too
	    re.lastIndex = 0;
	    var result = re.test(text);
	    re.lastIndex = 0;
	    return result;
	  }
	
	  function toCodePoint(unicodeSurrogates, sep) {
	    var
	      r = [],
	      c = 0,
	      p = 0,
	      i = 0;
	    while (i < unicodeSurrogates.length) {
	      c = unicodeSurrogates.charCodeAt(i++);
	      if (p) {
	        r.push((0x10000 + ((p - 0xD800) << 10) + (c - 0xDC00)).toString(16));
	        p = 0;
	      } else if (0xD800 <= c && c <= 0xDBFF) {
	        p = c;
	      } else {
	        r.push(c.toString(16));
	      }
	    }
	    return r.join(sep || '-');
	  }
	
	}());
	if (!location.protocol) {
	  twemoji.base = twemoji.base.replace(/^http:/, "");
	}
	module.exports = twemoji;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1149 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"this":"Emoji__this___2hD4_"};

/***/ },
/* 1150 */,
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _emojiAnnotationToUnicode = __webpack_require__(1152);
	
	var _emojiAnnotationToUnicode2 = _interopRequireDefault(_emojiAnnotationToUnicode);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _emoji = __webpack_require__(1147);
	
	var _ShortcodeEmoji = __webpack_require__(1153);
	
	var _ShortcodeEmoji2 = _interopRequireDefault(_ShortcodeEmoji);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function styleFor(title) {
	  var hex = _emojiAnnotationToUnicode2.default[title];
	
	  var src = (0, _emoji.imgSrcForEmojiHex)(hex);
	
	  return {
	    background: 'url(' + src + ')'
	  };
	}
	
	/**
	 * Displays an emoji character for a given
	 * [annotation](http://unicode.org/emoji/charts/emoji-annotations.html). Note
	 * that annotations are a many-to-many relationship, so we use the emoji-
	 * annotation-to-unicode map generated from [Github's Emoji
	 * API](https://developer.github.com/v3/emojis/).
	 *
	 * ```example
	 *  <div>
	 *    <ShortcodeEmoji text=":mortar_board:" />
	 *  </div>
	 * ```
	 *
	 * You will rarely use this component directly. Rather, look at `TextWithEntities` and
	 * `TextEntities` to parse and convert Emoji for cross-platform support.
	 *
	 * ```js
	 *  <TextWithEntities
	 *    text={text}
	 *    entities={
	 *      [].concat(
	 *        TextEntities.parseShortcodeEmoji(text),
	 *      )
	 *    }
	 *  />
	 * ```
	 *
	 */
	// UNTIL prop-types lint can detect Flow annotation
	/* eslint-disable react/prop-types */
	function ShortcodeEmoji(_ref) {
	  var text = _ref.text;
	
	  // cut out the leading and trailing colons
	  var title = text.slice(1, -1);
	
	  try {
	    return _react2.default.createElement(
	      'span',
	      {
	        className: _ShortcodeEmoji2.default.this,
	        style: styleFor(title),
	        title: title },
	      text
	    );
	  } catch (ex) {
	    console.warn('No emoji for shortcode', text);
	    return _react2.default.createElement(
	      'span',
	      null,
	      text
	    );
	  }
	}
	
	exports.default = ShortcodeEmoji;

/***/ },
/* 1152 */
/***/ function(module, exports) {

	module.exports = {
	  "+1": "1f44d",
	  "-1": "1f44e",
	  "100": "1f4af",
	  "1234": "1f522",
	  "8ball": "1f3b1",
	  "a": "1f170",
	  "ab": "1f18e",
	  "abc": "1f524",
	  "abcd": "1f521",
	  "accept": "1f251",
	  "aerial_tramway": "1f6a1",
	  "airplane": "2708",
	  "alarm_clock": "23f0",
	  "alien": "1f47d",
	  "ambulance": "1f691",
	  "anchor": "2693",
	  "angel": "1f47c",
	  "anger": "1f4a2",
	  "angry": "1f620",
	  "anguished": "1f627",
	  "ant": "1f41c",
	  "apple": "1f34e",
	  "aquarius": "2652",
	  "aries": "2648",
	  "arrow_backward": "25c0",
	  "arrow_double_down": "23ec",
	  "arrow_double_up": "23eb",
	  "arrow_down": "2b07",
	  "arrow_down_small": "1f53d",
	  "arrow_forward": "25b6",
	  "arrow_heading_down": "2935",
	  "arrow_heading_up": "2934",
	  "arrow_left": "2b05",
	  "arrow_lower_left": "2199",
	  "arrow_lower_right": "2198",
	  "arrow_right": "27a1",
	  "arrow_right_hook": "21aa",
	  "arrow_up": "2b06",
	  "arrow_up_down": "2195",
	  "arrow_up_small": "1f53c",
	  "arrow_upper_left": "2196",
	  "arrow_upper_right": "2197",
	  "arrows_clockwise": "1f503",
	  "arrows_counterclockwise": "1f504",
	  "art": "1f3a8",
	  "articulated_lorry": "1f69b",
	  "astonished": "1f632",
	  "athletic_shoe": "1f45f",
	  "atm": "1f3e7",
	  "b": "1f171",
	  "baby": "1f476",
	  "baby_bottle": "1f37c",
	  "baby_chick": "1f424",
	  "baby_symbol": "1f6bc",
	  "back": "1f519",
	  "baggage_claim": "1f6c4",
	  "balloon": "1f388",
	  "ballot_box_with_check": "2611",
	  "bamboo": "1f38d",
	  "banana": "1f34c",
	  "bangbang": "203c",
	  "bank": "1f3e6",
	  "bar_chart": "1f4ca",
	  "barber": "1f488",
	  "baseball": "26be",
	  "basketball": "1f3c0",
	  "bath": "1f6c0",
	  "bathtub": "1f6c1",
	  "battery": "1f50b",
	  "bear": "1f43b",
	  "bee": "1f41d",
	  "beer": "1f37a",
	  "beers": "1f37b",
	  "beetle": "1f41e",
	  "beginner": "1f530",
	  "bell": "1f514",
	  "bento": "1f371",
	  "bicyclist": "1f6b4",
	  "bike": "1f6b2",
	  "bikini": "1f459",
	  "bird": "1f426",
	  "birthday": "1f382",
	  "black_circle": "26ab",
	  "black_joker": "1f0cf",
	  "black_large_square": "2b1b",
	  "black_medium_small_square": "25fe",
	  "black_medium_square": "25fc",
	  "black_nib": "2712",
	  "black_small_square": "25aa",
	  "black_square_button": "1f532",
	  "blossom": "1f33c",
	  "blowfish": "1f421",
	  "blue_book": "1f4d8",
	  "blue_car": "1f699",
	  "blue_heart": "1f499",
	  "blush": "1f60a",
	  "boar": "1f417",
	  "boat": "26f5",
	  "bomb": "1f4a3",
	  "book": "1f4d6",
	  "bookmark": "1f516",
	  "bookmark_tabs": "1f4d1",
	  "books": "1f4da",
	  "boom": "1f4a5",
	  "boot": "1f462",
	  "bouquet": "1f490",
	  "bow": "1f647",
	  "bowling": "1f3b3",
	  "bowtie": null,
	  "boy": "1f466",
	  "bread": "1f35e",
	  "bride_with_veil": "1f470",
	  "bridge_at_night": "1f309",
	  "briefcase": "1f4bc",
	  "broken_heart": "1f494",
	  "bug": "1f41b",
	  "bulb": "1f4a1",
	  "bullettrain_front": "1f685",
	  "bullettrain_side": "1f684",
	  "bus": "1f68c",
	  "busstop": "1f68f",
	  "bust_in_silhouette": "1f464",
	  "busts_in_silhouette": "1f465",
	  "cactus": "1f335",
	  "cake": "1f370",
	  "calendar": "1f4c6",
	  "calling": "1f4f2",
	  "camel": "1f42b",
	  "camera": "1f4f7",
	  "cancer": "264b",
	  "candy": "1f36c",
	  "capital_abcd": "1f520",
	  "capricorn": "2651",
	  "car": "1f697",
	  "card_index": "1f4c7",
	  "carousel_horse": "1f3a0",
	  "cat": "1f431",
	  "cat2": "1f408",
	  "cd": "1f4bf",
	  "chart": "1f4b9",
	  "chart_with_downwards_trend": "1f4c9",
	  "chart_with_upwards_trend": "1f4c8",
	  "checkered_flag": "1f3c1",
	  "cherries": "1f352",
	  "cherry_blossom": "1f338",
	  "chestnut": "1f330",
	  "chicken": "1f414",
	  "children_crossing": "1f6b8",
	  "chocolate_bar": "1f36b",
	  "christmas_tree": "1f384",
	  "church": "26ea",
	  "cinema": "1f3a6",
	  "circus_tent": "1f3aa",
	  "city_sunrise": "1f307",
	  "city_sunset": "1f306",
	  "cl": "1f191",
	  "clap": "1f44f",
	  "clapper": "1f3ac",
	  "clipboard": "1f4cb",
	  "clock1": "1f550",
	  "clock10": "1f559",
	  "clock1030": "1f565",
	  "clock11": "1f55a",
	  "clock1130": "1f566",
	  "clock12": "1f55b",
	  "clock1230": "1f567",
	  "clock130": "1f55c",
	  "clock2": "1f551",
	  "clock230": "1f55d",
	  "clock3": "1f552",
	  "clock330": "1f55e",
	  "clock4": "1f553",
	  "clock430": "1f55f",
	  "clock5": "1f554",
	  "clock530": "1f560",
	  "clock6": "1f555",
	  "clock630": "1f561",
	  "clock7": "1f556",
	  "clock730": "1f562",
	  "clock8": "1f557",
	  "clock830": "1f563",
	  "clock9": "1f558",
	  "clock930": "1f564",
	  "closed_book": "1f4d5",
	  "closed_lock_with_key": "1f510",
	  "closed_umbrella": "1f302",
	  "cloud": "2601",
	  "clubs": "2663",
	  "cn": "1f1e8-1f1f3",
	  "cocktail": "1f378",
	  "coffee": "2615",
	  "cold_sweat": "1f630",
	  "collision": "1f4a5",
	  "computer": "1f4bb",
	  "confetti_ball": "1f38a",
	  "confounded": "1f616",
	  "confused": "1f615",
	  "congratulations": "3297",
	  "construction": "1f6a7",
	  "construction_worker": "1f477",
	  "convenience_store": "1f3ea",
	  "cookie": "1f36a",
	  "cool": "1f192",
	  "cop": "1f46e",
	  "copyright": "00a9",
	  "corn": "1f33d",
	  "couple": "1f46b",
	  "couple_with_heart": "1f491",
	  "couplekiss": "1f48f",
	  "cow": "1f42e",
	  "cow2": "1f404",
	  "credit_card": "1f4b3",
	  "crescent_moon": "1f319",
	  "crocodile": "1f40a",
	  "crossed_flags": "1f38c",
	  "crown": "1f451",
	  "cry": "1f622",
	  "crying_cat_face": "1f63f",
	  "crystal_ball": "1f52e",
	  "cupid": "1f498",
	  "curly_loop": "27b0",
	  "currency_exchange": "1f4b1",
	  "curry": "1f35b",
	  "custard": "1f36e",
	  "customs": "1f6c3",
	  "cyclone": "1f300",
	  "dancer": "1f483",
	  "dancers": "1f46f",
	  "dango": "1f361",
	  "dart": "1f3af",
	  "dash": "1f4a8",
	  "date": "1f4c5",
	  "de": "1f1e9-1f1ea",
	  "deciduous_tree": "1f333",
	  "department_store": "1f3ec",
	  "diamond_shape_with_a_dot_inside": "1f4a0",
	  "diamonds": "2666",
	  "disappointed": "1f61e",
	  "disappointed_relieved": "1f625",
	  "dizzy": "1f4ab",
	  "dizzy_face": "1f635",
	  "do_not_litter": "1f6af",
	  "dog": "1f436",
	  "dog2": "1f415",
	  "dollar": "1f4b5",
	  "dolls": "1f38e",
	  "dolphin": "1f42c",
	  "door": "1f6aa",
	  "doughnut": "1f369",
	  "dragon": "1f409",
	  "dragon_face": "1f432",
	  "dress": "1f457",
	  "dromedary_camel": "1f42a",
	  "droplet": "1f4a7",
	  "dvd": "1f4c0",
	  "e-mail": "1f4e7",
	  "ear": "1f442",
	  "ear_of_rice": "1f33e",
	  "earth_africa": "1f30d",
	  "earth_americas": "1f30e",
	  "earth_asia": "1f30f",
	  "egg": "1f373",
	  "eggplant": "1f346",
	  "eight": "0038-20e3",
	  "eight_pointed_black_star": "2734",
	  "eight_spoked_asterisk": "2733",
	  "electric_plug": "1f50c",
	  "elephant": "1f418",
	  "email": "2709",
	  "end": "1f51a",
	  "envelope": "2709",
	  "envelope_with_arrow": "1f4e9",
	  "es": "1f1ea-1f1f8",
	  "euro": "1f4b6",
	  "european_castle": "1f3f0",
	  "european_post_office": "1f3e4",
	  "evergreen_tree": "1f332",
	  "exclamation": "2757",
	  "expressionless": "1f611",
	  "eyeglasses": "1f453",
	  "eyes": "1f440",
	  "facepunch": "1f44a",
	  "factory": "1f3ed",
	  "fallen_leaf": "1f342",
	  "family": "1f46a",
	  "fast_forward": "23e9",
	  "fax": "1f4e0",
	  "fearful": "1f628",
	  "feelsgood": null,
	  "feet": "1f43e",
	  "ferris_wheel": "1f3a1",
	  "file_folder": "1f4c1",
	  "finnadie": null,
	  "fire": "1f525",
	  "fire_engine": "1f692",
	  "fireworks": "1f386",
	  "first_quarter_moon": "1f313",
	  "first_quarter_moon_with_face": "1f31b",
	  "fish": "1f41f",
	  "fish_cake": "1f365",
	  "fishing_pole_and_fish": "1f3a3",
	  "fist": "270a",
	  "five": "0035-20e3",
	  "flags": "1f38f",
	  "flashlight": "1f526",
	  "flipper": "1f42c",
	  "floppy_disk": "1f4be",
	  "flower_playing_cards": "1f3b4",
	  "flushed": "1f633",
	  "foggy": "1f301",
	  "football": "1f3c8",
	  "footprints": "1f463",
	  "fork_and_knife": "1f374",
	  "fountain": "26f2",
	  "four": "0034-20e3",
	  "four_leaf_clover": "1f340",
	  "fr": "1f1eb-1f1f7",
	  "free": "1f193",
	  "fried_shrimp": "1f364",
	  "fries": "1f35f",
	  "frog": "1f438",
	  "frowning": "1f626",
	  "fu": null,
	  "fuelpump": "26fd",
	  "full_moon": "1f315",
	  "full_moon_with_face": "1f31d",
	  "game_die": "1f3b2",
	  "gb": "1f1ec-1f1e7",
	  "gem": "1f48e",
	  "gemini": "264a",
	  "ghost": "1f47b",
	  "gift": "1f381",
	  "gift_heart": "1f49d",
	  "girl": "1f467",
	  "globe_with_meridians": "1f310",
	  "goat": "1f410",
	  "goberserk": null,
	  "godmode": null,
	  "golf": "26f3",
	  "grapes": "1f347",
	  "green_apple": "1f34f",
	  "green_book": "1f4d7",
	  "green_heart": "1f49a",
	  "grey_exclamation": "2755",
	  "grey_question": "2754",
	  "grimacing": "1f62c",
	  "grin": "1f601",
	  "grinning": "1f600",
	  "guardsman": "1f482",
	  "guitar": "1f3b8",
	  "gun": "1f52b",
	  "haircut": "1f487",
	  "hamburger": "1f354",
	  "hammer": "1f528",
	  "hamster": "1f439",
	  "hand": "270b",
	  "handbag": "1f45c",
	  "hankey": "1f4a9",
	  "hash": "0023-20e3",
	  "hatched_chick": "1f425",
	  "hatching_chick": "1f423",
	  "headphones": "1f3a7",
	  "hear_no_evil": "1f649",
	  "heart": "2764",
	  "heart_decoration": "1f49f",
	  "heart_eyes": "1f60d",
	  "heart_eyes_cat": "1f63b",
	  "heartbeat": "1f493",
	  "heartpulse": "1f497",
	  "hearts": "2665",
	  "heavy_check_mark": "2714",
	  "heavy_division_sign": "2797",
	  "heavy_dollar_sign": "1f4b2",
	  "heavy_exclamation_mark": "2757",
	  "heavy_minus_sign": "2796",
	  "heavy_multiplication_x": "2716",
	  "heavy_plus_sign": "2795",
	  "helicopter": "1f681",
	  "herb": "1f33f",
	  "hibiscus": "1f33a",
	  "high_brightness": "1f506",
	  "high_heel": "1f460",
	  "hocho": "1f52a",
	  "honey_pot": "1f36f",
	  "honeybee": "1f41d",
	  "horse": "1f434",
	  "horse_racing": "1f3c7",
	  "hospital": "1f3e5",
	  "hotel": "1f3e8",
	  "hotsprings": "2668",
	  "hourglass": "231b",
	  "hourglass_flowing_sand": "23f3",
	  "house": "1f3e0",
	  "house_with_garden": "1f3e1",
	  "hurtrealbad": null,
	  "hushed": "1f62f",
	  "ice_cream": "1f368",
	  "icecream": "1f366",
	  "id": "1f194",
	  "ideograph_advantage": "1f250",
	  "imp": "1f47f",
	  "inbox_tray": "1f4e5",
	  "incoming_envelope": "1f4e8",
	  "information_desk_person": "1f481",
	  "information_source": "2139",
	  "innocent": "1f607",
	  "interrobang": "2049",
	  "iphone": "1f4f1",
	  "it": "1f1ee-1f1f9",
	  "izakaya_lantern": "1f3ee",
	  "jack_o_lantern": "1f383",
	  "japan": "1f5fe",
	  "japanese_castle": "1f3ef",
	  "japanese_goblin": "1f47a",
	  "japanese_ogre": "1f479",
	  "jeans": "1f456",
	  "joy": "1f602",
	  "joy_cat": "1f639",
	  "jp": "1f1ef-1f1f5",
	  "key": "1f511",
	  "keycap_ten": "1f51f",
	  "kimono": "1f458",
	  "kiss": "1f48b",
	  "kissing": "1f617",
	  "kissing_cat": "1f63d",
	  "kissing_closed_eyes": "1f61a",
	  "kissing_heart": "1f618",
	  "kissing_smiling_eyes": "1f619",
	  "knife": "1f52a",
	  "koala": "1f428",
	  "koko": "1f201",
	  "kr": "1f1f0-1f1f7",
	  "lantern": "1f3ee",
	  "large_blue_circle": "1f535",
	  "large_blue_diamond": "1f537",
	  "large_orange_diamond": "1f536",
	  "last_quarter_moon": "1f317",
	  "last_quarter_moon_with_face": "1f31c",
	  "laughing": "1f606",
	  "leaves": "1f343",
	  "ledger": "1f4d2",
	  "left_luggage": "1f6c5",
	  "left_right_arrow": "2194",
	  "leftwards_arrow_with_hook": "21a9",
	  "lemon": "1f34b",
	  "leo": "264c",
	  "leopard": "1f406",
	  "libra": "264e",
	  "light_rail": "1f688",
	  "link": "1f517",
	  "lips": "1f444",
	  "lipstick": "1f484",
	  "lock": "1f512",
	  "lock_with_ink_pen": "1f50f",
	  "lollipop": "1f36d",
	  "loop": "27bf",
	  "loud_sound": "1f50a",
	  "loudspeaker": "1f4e2",
	  "love_hotel": "1f3e9",
	  "love_letter": "1f48c",
	  "low_brightness": "1f505",
	  "m": "24c2",
	  "mag": "1f50d",
	  "mag_right": "1f50e",
	  "mahjong": "1f004",
	  "mailbox": "1f4eb",
	  "mailbox_closed": "1f4ea",
	  "mailbox_with_mail": "1f4ec",
	  "mailbox_with_no_mail": "1f4ed",
	  "man": "1f468",
	  "man_with_gua_pi_mao": "1f472",
	  "man_with_turban": "1f473",
	  "mans_shoe": "1f45e",
	  "maple_leaf": "1f341",
	  "mask": "1f637",
	  "massage": "1f486",
	  "meat_on_bone": "1f356",
	  "mega": "1f4e3",
	  "melon": "1f348",
	  "memo": "1f4dd",
	  "mens": "1f6b9",
	  "metal": null,
	  "metro": "1f687",
	  "microphone": "1f3a4",
	  "microscope": "1f52c",
	  "milky_way": "1f30c",
	  "minibus": "1f690",
	  "minidisc": "1f4bd",
	  "mobile_phone_off": "1f4f4",
	  "money_with_wings": "1f4b8",
	  "moneybag": "1f4b0",
	  "monkey": "1f412",
	  "monkey_face": "1f435",
	  "monorail": "1f69d",
	  "moon": "1f314",
	  "mortar_board": "1f393",
	  "mount_fuji": "1f5fb",
	  "mountain_bicyclist": "1f6b5",
	  "mountain_cableway": "1f6a0",
	  "mountain_railway": "1f69e",
	  "mouse": "1f42d",
	  "mouse2": "1f401",
	  "movie_camera": "1f3a5",
	  "moyai": "1f5ff",
	  "muscle": "1f4aa",
	  "mushroom": "1f344",
	  "musical_keyboard": "1f3b9",
	  "musical_note": "1f3b5",
	  "musical_score": "1f3bc",
	  "mute": "1f507",
	  "nail_care": "1f485",
	  "name_badge": "1f4db",
	  "neckbeard": null,
	  "necktie": "1f454",
	  "negative_squared_cross_mark": "274e",
	  "neutral_face": "1f610",
	  "new": "1f195",
	  "new_moon": "1f311",
	  "new_moon_with_face": "1f31a",
	  "newspaper": "1f4f0",
	  "ng": "1f196",
	  "night_with_stars": "1f303",
	  "nine": "0039-20e3",
	  "no_bell": "1f515",
	  "no_bicycles": "1f6b3",
	  "no_entry": "26d4",
	  "no_entry_sign": "1f6ab",
	  "no_good": "1f645",
	  "no_mobile_phones": "1f4f5",
	  "no_mouth": "1f636",
	  "no_pedestrians": "1f6b7",
	  "no_smoking": "1f6ad",
	  "non-potable_water": "1f6b1",
	  "nose": "1f443",
	  "notebook": "1f4d3",
	  "notebook_with_decorative_cover": "1f4d4",
	  "notes": "1f3b6",
	  "nut_and_bolt": "1f529",
	  "o": "2b55",
	  "o2": "1f17e",
	  "ocean": "1f30a",
	  "octocat": null,
	  "octopus": "1f419",
	  "oden": "1f362",
	  "office": "1f3e2",
	  "ok": "1f197",
	  "ok_hand": "1f44c",
	  "ok_woman": "1f646",
	  "older_man": "1f474",
	  "older_woman": "1f475",
	  "on": "1f51b",
	  "oncoming_automobile": "1f698",
	  "oncoming_bus": "1f68d",
	  "oncoming_police_car": "1f694",
	  "oncoming_taxi": "1f696",
	  "one": "0031-20e3",
	  "open_book": "1f4d6",
	  "open_file_folder": "1f4c2",
	  "open_hands": "1f450",
	  "open_mouth": "1f62e",
	  "ophiuchus": "26ce",
	  "orange_book": "1f4d9",
	  "outbox_tray": "1f4e4",
	  "ox": "1f402",
	  "package": "1f4e6",
	  "page_facing_up": "1f4c4",
	  "page_with_curl": "1f4c3",
	  "pager": "1f4df",
	  "palm_tree": "1f334",
	  "panda_face": "1f43c",
	  "paperclip": "1f4ce",
	  "parking": "1f17f",
	  "part_alternation_mark": "303d",
	  "partly_sunny": "26c5",
	  "passport_control": "1f6c2",
	  "paw_prints": "1f43e",
	  "peach": "1f351",
	  "pear": "1f350",
	  "pencil": "1f4dd",
	  "pencil2": "270f",
	  "penguin": "1f427",
	  "pensive": "1f614",
	  "performing_arts": "1f3ad",
	  "persevere": "1f623",
	  "person_frowning": "1f64d",
	  "person_with_blond_hair": "1f471",
	  "person_with_pouting_face": "1f64e",
	  "phone": "260e",
	  "pig": "1f437",
	  "pig2": "1f416",
	  "pig_nose": "1f43d",
	  "pill": "1f48a",
	  "pineapple": "1f34d",
	  "pisces": "2653",
	  "pizza": "1f355",
	  "point_down": "1f447",
	  "point_left": "1f448",
	  "point_right": "1f449",
	  "point_up": "261d",
	  "point_up_2": "1f446",
	  "police_car": "1f693",
	  "poodle": "1f429",
	  "poop": "1f4a9",
	  "post_office": "1f3e3",
	  "postal_horn": "1f4ef",
	  "postbox": "1f4ee",
	  "potable_water": "1f6b0",
	  "pouch": "1f45d",
	  "poultry_leg": "1f357",
	  "pound": "1f4b7",
	  "pouting_cat": "1f63e",
	  "pray": "1f64f",
	  "princess": "1f478",
	  "punch": "1f44a",
	  "purple_heart": "1f49c",
	  "purse": "1f45b",
	  "pushpin": "1f4cc",
	  "put_litter_in_its_place": "1f6ae",
	  "question": "2753",
	  "rabbit": "1f430",
	  "rabbit2": "1f407",
	  "racehorse": "1f40e",
	  "radio": "1f4fb",
	  "radio_button": "1f518",
	  "rage": "1f621",
	  "rage1": null,
	  "rage2": null,
	  "rage3": null,
	  "rage4": null,
	  "railway_car": "1f683",
	  "rainbow": "1f308",
	  "raised_hand": "270b",
	  "raised_hands": "1f64c",
	  "raising_hand": "1f64b",
	  "ram": "1f40f",
	  "ramen": "1f35c",
	  "rat": "1f400",
	  "recycle": "267b",
	  "red_car": "1f697",
	  "red_circle": "1f534",
	  "registered": "00ae",
	  "relaxed": "263a",
	  "relieved": "1f60c",
	  "repeat": "1f501",
	  "repeat_one": "1f502",
	  "restroom": "1f6bb",
	  "revolving_hearts": "1f49e",
	  "rewind": "23ea",
	  "ribbon": "1f380",
	  "rice": "1f35a",
	  "rice_ball": "1f359",
	  "rice_cracker": "1f358",
	  "rice_scene": "1f391",
	  "ring": "1f48d",
	  "rocket": "1f680",
	  "roller_coaster": "1f3a2",
	  "rooster": "1f413",
	  "rose": "1f339",
	  "rotating_light": "1f6a8",
	  "round_pushpin": "1f4cd",
	  "rowboat": "1f6a3",
	  "ru": "1f1f7-1f1fa",
	  "rugby_football": "1f3c9",
	  "runner": "1f3c3",
	  "running": "1f3c3",
	  "running_shirt_with_sash": "1f3bd",
	  "sa": "1f202",
	  "sagittarius": "2650",
	  "sailboat": "26f5",
	  "sake": "1f376",
	  "sandal": "1f461",
	  "santa": "1f385",
	  "satellite": "1f4e1",
	  "satisfied": "1f606",
	  "saxophone": "1f3b7",
	  "school": "1f3eb",
	  "school_satchel": "1f392",
	  "scissors": "2702",
	  "scorpius": "264f",
	  "scream": "1f631",
	  "scream_cat": "1f640",
	  "scroll": "1f4dc",
	  "seat": "1f4ba",
	  "secret": "3299",
	  "see_no_evil": "1f648",
	  "seedling": "1f331",
	  "seven": "0037-20e3",
	  "shaved_ice": "1f367",
	  "sheep": "1f411",
	  "shell": "1f41a",
	  "ship": "1f6a2",
	  "shipit": null,
	  "shirt": "1f455",
	  "shit": "1f4a9",
	  "shoe": "1f45e",
	  "shower": "1f6bf",
	  "signal_strength": "1f4f6",
	  "six": "0036-20e3",
	  "six_pointed_star": "1f52f",
	  "ski": "1f3bf",
	  "skull": "1f480",
	  "sleeping": "1f634",
	  "sleepy": "1f62a",
	  "slot_machine": "1f3b0",
	  "small_blue_diamond": "1f539",
	  "small_orange_diamond": "1f538",
	  "small_red_triangle": "1f53a",
	  "small_red_triangle_down": "1f53b",
	  "smile": "1f604",
	  "smile_cat": "1f638",
	  "smiley": "1f603",
	  "smiley_cat": "1f63a",
	  "smiling_imp": "1f608",
	  "smirk": "1f60f",
	  "smirk_cat": "1f63c",
	  "smoking": "1f6ac",
	  "snail": "1f40c",
	  "snake": "1f40d",
	  "snowboarder": "1f3c2",
	  "snowflake": "2744",
	  "snowman": "26c4",
	  "sob": "1f62d",
	  "soccer": "26bd",
	  "soon": "1f51c",
	  "sos": "1f198",
	  "sound": "1f509",
	  "space_invader": "1f47e",
	  "spades": "2660",
	  "spaghetti": "1f35d",
	  "sparkle": "2747",
	  "sparkler": "1f387",
	  "sparkles": "2728",
	  "sparkling_heart": "1f496",
	  "speak_no_evil": "1f64a",
	  "speaker": "1f508",
	  "speech_balloon": "1f4ac",
	  "speedboat": "1f6a4",
	  "squirrel": null,
	  "star": "2b50",
	  "star2": "1f31f",
	  "stars": "1f320",
	  "station": "1f689",
	  "statue_of_liberty": "1f5fd",
	  "steam_locomotive": "1f682",
	  "stew": "1f372",
	  "straight_ruler": "1f4cf",
	  "strawberry": "1f353",
	  "stuck_out_tongue": "1f61b",
	  "stuck_out_tongue_closed_eyes": "1f61d",
	  "stuck_out_tongue_winking_eye": "1f61c",
	  "sun_with_face": "1f31e",
	  "sunflower": "1f33b",
	  "sunglasses": "1f60e",
	  "sunny": "2600",
	  "sunrise": "1f305",
	  "sunrise_over_mountains": "1f304",
	  "surfer": "1f3c4",
	  "sushi": "1f363",
	  "suspect": null,
	  "suspension_railway": "1f69f",
	  "sweat": "1f613",
	  "sweat_drops": "1f4a6",
	  "sweat_smile": "1f605",
	  "sweet_potato": "1f360",
	  "swimmer": "1f3ca",
	  "symbols": "1f523",
	  "syringe": "1f489",
	  "tada": "1f389",
	  "tanabata_tree": "1f38b",
	  "tangerine": "1f34a",
	  "taurus": "2649",
	  "taxi": "1f695",
	  "tea": "1f375",
	  "telephone": "260e",
	  "telephone_receiver": "1f4de",
	  "telescope": "1f52d",
	  "tennis": "1f3be",
	  "tent": "26fa",
	  "thought_balloon": "1f4ad",
	  "three": "0033-20e3",
	  "thumbsdown": "1f44e",
	  "thumbsup": "1f44d",
	  "ticket": "1f3ab",
	  "tiger": "1f42f",
	  "tiger2": "1f405",
	  "tired_face": "1f62b",
	  "tm": "2122",
	  "toilet": "1f6bd",
	  "tokyo_tower": "1f5fc",
	  "tomato": "1f345",
	  "tongue": "1f445",
	  "top": "1f51d",
	  "tophat": "1f3a9",
	  "tractor": "1f69c",
	  "traffic_light": "1f6a5",
	  "train": "1f68b",
	  "train2": "1f686",
	  "tram": "1f68a",
	  "triangular_flag_on_post": "1f6a9",
	  "triangular_ruler": "1f4d0",
	  "trident": "1f531",
	  "triumph": "1f624",
	  "trolleybus": "1f68e",
	  "trollface": null,
	  "trophy": "1f3c6",
	  "tropical_drink": "1f379",
	  "tropical_fish": "1f420",
	  "truck": "1f69a",
	  "trumpet": "1f3ba",
	  "tshirt": "1f455",
	  "tulip": "1f337",
	  "turtle": "1f422",
	  "tv": "1f4fa",
	  "twisted_rightwards_arrows": "1f500",
	  "two": "0032-20e3",
	  "two_hearts": "1f495",
	  "two_men_holding_hands": "1f46c",
	  "two_women_holding_hands": "1f46d",
	  "u5272": "1f239",
	  "u5408": "1f234",
	  "u55b6": "1f23a",
	  "u6307": "1f22f",
	  "u6708": "1f237",
	  "u6709": "1f236",
	  "u6e80": "1f235",
	  "u7121": "1f21a",
	  "u7533": "1f238",
	  "u7981": "1f232",
	  "u7a7a": "1f233",
	  "uk": "1f1ec-1f1e7",
	  "umbrella": "2614",
	  "unamused": "1f612",
	  "underage": "1f51e",
	  "unlock": "1f513",
	  "up": "1f199",
	  "us": "1f1fa-1f1f8",
	  "v": "270c",
	  "vertical_traffic_light": "1f6a6",
	  "vhs": "1f4fc",
	  "vibration_mode": "1f4f3",
	  "video_camera": "1f4f9",
	  "video_game": "1f3ae",
	  "violin": "1f3bb",
	  "virgo": "264d",
	  "volcano": "1f30b",
	  "vs": "1f19a",
	  "walking": "1f6b6",
	  "waning_crescent_moon": "1f318",
	  "waning_gibbous_moon": "1f316",
	  "warning": "26a0",
	  "watch": "231a",
	  "water_buffalo": "1f403",
	  "watermelon": "1f349",
	  "wave": "1f44b",
	  "wavy_dash": "3030",
	  "waxing_crescent_moon": "1f312",
	  "waxing_gibbous_moon": "1f314",
	  "wc": "1f6be",
	  "weary": "1f629",
	  "wedding": "1f492",
	  "whale": "1f433",
	  "whale2": "1f40b",
	  "wheelchair": "267f",
	  "white_check_mark": "2705",
	  "white_circle": "26aa",
	  "white_flower": "1f4ae",
	  "white_large_square": "2b1c",
	  "white_medium_small_square": "25fd",
	  "white_medium_square": "25fb",
	  "white_small_square": "25ab",
	  "white_square_button": "1f533",
	  "wind_chime": "1f390",
	  "wine_glass": "1f377",
	  "wink": "1f609",
	  "wolf": "1f43a",
	  "woman": "1f469",
	  "womans_clothes": "1f45a",
	  "womans_hat": "1f452",
	  "womens": "1f6ba",
	  "worried": "1f61f",
	  "wrench": "1f527",
	  "x": "274c",
	  "yellow_heart": "1f49b",
	  "yen": "1f4b4",
	  "yum": "1f60b",
	  "zap": "26a1",
	  "zero": "0030-20e3",
	  "zzz": "1f4a4",
	  "simple_smile": "1f642"
	}

/***/ },
/* 1153 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"this":"ShortcodeEmoji__this___34WxU Emoji__this___2hD4_"};

/***/ },
/* 1154 */,
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tooltipable = __webpack_require__(1156);
	
	var _tooltipable2 = _interopRequireDefault(_tooltipable);
	
	var _ClickEventTrigger = __webpack_require__(1181);
	
	var _ClickEventTrigger2 = _interopRequireDefault(_ClickEventTrigger);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _LinkBase = __webpack_require__(1182);
	
	var _LinkBase2 = _interopRequireDefault(_LinkBase);
	
	__webpack_require__(1183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  statics: {
	    propClasses: {
	      color: {
	        lava: 'Link-lava',
	        jungle: 'Link-jungle',
	        shamrock: 'Link-shamrock',
	        brand: 'Link-brand',
	        violet: 'Link-violet',
	        pitch: 'Link-pitch',
	        eclipse: 'Link-eclipse',
	        thunder: 'Link-thunder',
	        white: 'Link-white',
	        inherit: 'Link-inherit',
	        sunrise: 'Link-sunrise'
	      },
	      noWrap: 'Link--noWrap',
	      weight: {
	        normal: 'Link--normal',
	        semibold: 'Link--semibold'
	      }
	    }
	  },
	
	  render: function render() {
	    var _props = this.props,
	        bar = _props.bar,
	        block = _props.block,
	        disabled = _props.disabled,
	        children = _props.children,
	        className = _props.className,
	        rel = _props.rel,
	        target = _props.target,
	        props = _objectWithoutProperties(_props, ['bar', 'block', 'disabled', 'children', 'className', 'rel', 'target']);
	
	    var targetBlankRel = 'noopener noreferrer';
	    var safeRel = null;
	
	    if (rel && target === '_blank') {
	      safeRel = rel + ' ' + targetBlankRel;
	    } else if (target === '_blank') {
	      safeRel = targetBlankRel;
	    }
	
	    return _react2.default.createElement(
	      _ClickEventTrigger2.default,
	      { eventElementName: this.props.eventElementName },
	      _react2.default.createElement(
	        _LinkBase2.default,
	        _extends({}, props, {
	          rel: safeRel,
	          target: target,
	          className: (0, _classnames2.default)('Link', {
	            'Link-bar': bar,
	            'Link-disabled': disabled,
	            'Link-block': block === true,
	            'Link-inlineBlock': block === 'inline'
	          }, (0, _getPropClasses.getPropClassesFromInstance)(this), className),
	          disabled: disabled }),
	        children
	      )
	    );
	  }
	});
	
	exports.default = (0, _tooltipable2.default)(Link);

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tooltipablePropTypes = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = tooltipable;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(1157);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _LayerPropTypes = __webpack_require__(1166);
	
	var _LayerPropTypes2 = _interopRequireDefault(_LayerPropTypes);
	
	var _TooltipTrigger = __webpack_require__(1171);
	
	var _TooltipTrigger2 = _interopRequireDefault(_TooltipTrigger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* ************************************** */
	/* DEPRECATED: Use TooltipTrigger instead */
	/* ************************************** */
	
	var tooltipablePropTypes = exports.tooltipablePropTypes = {
	  tooltip: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.element, _react2.default.PropTypes.instanceOf(_Tooltip2.default)]),
	  tooltipPlacement: _LayerPropTypes2.default.placement,
	  tooltipAlignment: _LayerPropTypes2.default.alignment
	};
	
	/* HOC
	 *
	 * Make any component tooltip ready
	 * this mean any parent component can add tooltip to
	 * the wrapper component by passing a tooltip prop to it.
	 */
	// typecheck: ignore statement
	function tooltipable(Component) {
	  var Wrapper = function (_React$Component) {
	    _inherits(Wrapper, _React$Component);
	
	    function Wrapper() {
	      _classCallCheck(this, Wrapper);
	
	      return _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).apply(this, arguments));
	    }
	
	    _createClass(Wrapper, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            tooltip = _props.tooltip,
	            tooltipPlacement = _props.tooltipPlacement,
	            tooltipAlignment = _props.tooltipAlignment,
	            rest = _objectWithoutProperties(_props, ['tooltip', 'tooltipPlacement', 'tooltipAlignment']);
	
	        if (!tooltip) {
	          return _react2.default.createElement(Component, this.props);
	        }
	
	        return _react2.default.createElement(
	          _TooltipTrigger2.default,
	          {
	            tooltip: tooltip,
	            placement: tooltipPlacement,
	            alignment: tooltipAlignment },
	          _react2.default.createElement(Component, rest)
	        );
	      }
	    }]);
	
	    return Wrapper;
	  }(_react2.default.Component);
	
	  Wrapper.displayName = Component.displayName || Component.name;
	  Wrapper.displayName = 'Wrapper';
	
	
	  return Wrapper;
	}

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _Layer = __webpack_require__(1158);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Tooltip used throughout the application.
	 *
	 * # Placement
	 *
	 * ```example
	 *  <div style={{padding: 100}}>
	 *    <LayerTrigger layer={<Tooltip>Remind</Tooltip>} placement="top">
	 *      <Glyph name="remind-icon" size="xlarge" />
	 *    </LayerTrigger>
	 *    <LayerTrigger layer={<Tooltip>Home</Tooltip>} placement="left">
	 *      <Glyph name="home" size="xlarge" />
	 *    </LayerTrigger>
	 *    <LayerTrigger layer={<Tooltip>Chat</Tooltip>} placement="right">
	 *      <Glyph name="chat" size="xlarge" />
	 *    </LayerTrigger>
	 *    <LayerTrigger layer={<Tooltip>Settings</Tooltip>} placement="bottom">
	 *      <Glyph name="gear" size="xlarge" />
	 *    </LayerTrigger>
	 *  </div>
	 * ```
	 *
	 * # Alignment
	 *
	 * ```example
	 *  <div style={{padding: 100}}>
	 *    <Link
	 *      tooltip="Home"
	 *      tooltipPlacement="top"
	 *      tooltipAlignment="left"
	 *      style={{display: 'inline-block'}}>
	 *      <Glyph name="home" size="xlarge" />
	 *    </Link>
	 *    <Link
	 *      tooltip="Chat"
	 *      tooltipPlacement="top"
	 *      tooltipAlignment="middle"
	 *      style={{display: 'inline-block'}}>
	 *      <Glyph name="chat" size="xlarge" />
	 *    </Link>
	 *    <Link
	 *      tooltip="Settings"
	 *      tooltipPlacement="top"
	 *      tooltipAlignment="right"
	 *      style={{display: 'inline-block'}}>
	 *      <Glyph name="gear" size="xlarge" />
	 *    </Link>
	 *    <br />
	 *    <Link
	 *      tooltip="Home"
	 *      tooltipPlacement="bottom"
	 *      tooltipAlignment="left"
	 *      style={{display: 'inline-block'}}>
	 *      <Glyph name="home" size="xlarge" />
	 *    </Link>
	 *    <Link
	 *      tooltip="Chat"
	 *      tooltipPlacement="bottom"
	 *      tooltipAlignment="middle"
	 *      style={{display: 'inline-block'}}>
	 *      <Glyph name="chat" size="xlarge" />
	 *    </Link>
	 *    <Link
	 *      tooltip="Settings"
	 *      tooltipPlacement="bottom"
	 *      tooltipAlignment="right"
	 *      style={{display: 'inline-block'}}>
	 *      <Glyph name="gear" size="xlarge" />
	 *    </Link>
	 *    <br />
	 *    <Link
	 *      tooltip={<span>Home<br/ >Home</span>}
	 *      tooltipPlacement="left"
	 *      tooltipAlignment="top"
	 *      style={{display: 'inline-block'}}>
	 *      <Glyph name="home" size="xlarge" />
	 *    </Link>
	 *    <Link
	 *      tooltip={<span>Chat<br/ >Chat</span>}
	 *      tooltipPlacement="left"
	 *      tooltipAlignment="middle"
	 *      style={{display: 'inline-block'}}>
	 *      <Glyph name="chat" size="xlarge" />
	 *    </Link>
	 *    <Link
	 *      tooltip={<span>Settings<br/ >Settings</span>}
	 *      tooltipPlacement="left"
	 *      tooltipAlignment="bottom"
	 *      style={{display: 'inline-block'}}>
	 *      <Glyph name="gear" size="xlarge" />
	 *    </Link>
	 *    <br />
	 *    <Link
	 *      tooltip={<span>Home<br/ >Home</span>}
	 *      tooltipPlacement="right"
	 *      tooltipAlignment="top"
	 *      style={{display: 'inline-block'}}>
	 *      <Glyph name="home" size="xlarge" />
	 *    </Link>
	 *    <Link
	 *      tooltip={<span>Chat<br/ >Chat</span>}
	 *      tooltipPlacement="right"
	 *      tooltipAlignment="middle"
	 *      style={{display: 'inline-block'}}>
	 *      <Glyph name="chat" size="xlarge" />
	 *    </Link>
	 *    <Link
	 *      tooltip={<span>Settings<br/ >Settings</span>}
	 *      tooltipPlacement="right"
	 *      tooltipAlignment="bottom"
	 *      style={{display: 'inline-block'}}>
	 *      <Glyph name="gear" size="xlarge" />
	 *    </Link>
	 *  </div>
	 * ```
	 */
	
	var Tooltip = function (_React$Component) {
	  _inherits(Tooltip, _React$Component);
	
	  function Tooltip() {
	    _classCallCheck(this, Tooltip);
	
	    return _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).apply(this, arguments));
	  }
	
	  _createClass(Tooltip, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Layer2.default,
	        _extends({}, this.props, {
	          className: (0, _classnames2.default)('Tooltip', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className) }),
	        this.props.header && _react2.default.createElement(
	          'div',
	          { className: 'Tooltip-header' },
	          this.props.header
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react2.default.Component);
	
	Tooltip.propClasses = {
	  color: {
	    shamrock: 'Tooltip-shamrock',
	    violet: 'Tooltip-violet',
	    lava: 'Tooltip-lava',
	    flame: 'Tooltip-flame'
	  },
	  type: {
	    nux: 'Tooltip-nux'
	  }
	};
	Tooltip.defaultProps = {
	  type: 'normal'
	};
	Tooltip.displayName = 'Tooltip';
	exports.default = Tooltip;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _LayerHideOnBlur = __webpack_require__(1159);
	
	var _LayerHideOnBlur2 = _interopRequireDefault(_LayerHideOnBlur);
	
	var _LayerHideOnEscape = __webpack_require__(1163);
	
	var _LayerHideOnEscape2 = _interopRequireDefault(_LayerHideOnEscape);
	
	var _LayerHideOnTransition = __webpack_require__(1165);
	
	var _LayerHideOnTransition2 = _interopRequireDefault(_LayerHideOnTransition);
	
	var _LayerPropTypes = __webpack_require__(1166);
	
	var _LayerPropTypes2 = _interopRequireDefault(_LayerPropTypes);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _pickInputElementProps = __webpack_require__(1106);
	
	var _pickInputElementProps2 = _interopRequireDefault(_pickInputElementProps);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A system of displaying layers or overlays on the page without manually positioning or the use of
	 * `z-index` in CSS.
	 *
	 * Layer is a system for content that is rendered "above the page". This includes common elements
	 * such as [Menu](/components/Menu) elements, [Tooltip](/components/Tooltip) elements,
	 * [Dialog](/components/Dialog), etc. The system manages the positioning of the element on the
	 * x-axis, y-axis, and its z-index. It optimizes the display of a layer by positioning it within
	 * the visible viewport. For example, if you explicitly set a tooltip to be placed on the top of an
	 * element that is at the top edge of the viewport when the page is scrolled down, the tooltip will
	 * be displayed on the bottom of the element. The z-index of a layer is managed by simply appending
	 * new layers to the end of the DOM. By simply relying on DOM ordering, only the z-index of the
	 * LayerTriggers are needed to ensure all layers and nested layers (e.g., a tooltip from a menu item
	 * inside of a dialog) stack properly.
	 *
	 * Layer itself is an unstyled component with props that are set by LayerTrigger. To create a Layer
	 * component, simply compose a Layer:
	 *
	 * ```js
	 *  import styles from './Popup.css';
	 *
	 *  const Popup = ({children, ...props}) => (
	 *    <Layer {...props}>
	 *      <div className={styles.this}>
	 *        {children}
	 *      </div>
	 *    </Layer>
	 *  );
	 * ```
	 *
	 * All Layer components are triggered with a [LayerTrigger](/components/LayerTrigger) element.
	 *
	 * ```example
	 *  <LayerTrigger
	 *    layer={
	 *      <Tooltip>
	 *        Hello World!
	 *      </Tooltip>
	 *    }
	 *    trigger="click">
	 *    <Link>Click this link to show the tooltip</Link>
	 *  </LayerTrigger>
	 * ```
	 *
	 * # Configurable behaviors
	 *
	 * You can use the `hideOnBlur`, `hideOnEscape`, and `hideOnTransition` props to disable some of the
	 * built-in behaviors of a layer.
	 *
	 * ```example
	 *  <div>
	 *    <LayerTrigger
	 *      layer={
	 *        <Tooltip>Hit Esc to hide this tooltip</Tooltip>
	 *      }>
	 *      <Link>Show the tooltip</Link>
	 *    </LayerTrigger>
	 *    {', '}
	 *    <LayerTrigger
	 *      layer={
	 *        <Tooltip hideOnEscape={false}>This tooltip won’t hide when you hit Esc.</Tooltip>
	 *      }>
	 *      <Link>Show another tooltip</Link>
	 *    </LayerTrigger>
	 *  </div>
	 * ```
	 *
	 * ## Caveats
	 *
	 * Layer was implemented with an older version of React before contexts existed. The approach that
	 * involves calling `React.render()` on a new DOM node at the end of the document. This method was
	 * considered to be creating a "portal" to a newly rendered subtree. When a version of React was
	 * released with contexts enabled, this created problems since newly rendered subtrees did not have
	 * the context (e.g., `react-router`, `react-intl`, `redux`, etc) of the main subtree. A hacky
	 * workaround was copied from `react-router` known as `createContextWrapper()`, which copied the
	 * context of `LayerTrigger` elements as well as `ModalTrigger` elements to the newly rendered
	 * subtree.
	 *
	 * createContextWrapper() caused components to be rebuilt unnecessarily on updates, so we replaced
	 * two instances of that with a different hack, `unstable_renderSubtreeIntoContainer` from ReactDOM
	 * ([ref](http://stackoverflow.com/a/35837064/46040)). In the future we may want to replace our Layer
	 * with [React Overlays](http://react-bootstrap.github.io/react-overlays/examples/#overlay)
	 * from React Bootstrap, or just [their portals](http://react-bootstrap.github.io/react-overlays/examples/#portals).
	 *
	 * It should be possible to render layers within the main subtree as long as there is a top-level
	 * component that wraps the entire app (e.g., [App](/components/App)). Layer state can be managed
	 * in a store. For example:
	 *
	 * ```js
	 *  import styles from './App.css';
	 *
	 *  export default class App extends React.Component {
	 *    renderLayers() {
	 *      return this.props.layers.map((layer, index) => {
	 *        return React.cloneElement(layer, {
	 *          key: index,
	 *        })
	 *      );
	 *    }
	 *
	 *    render() {
	 *      return (
	 *        <div className={styles.this}>
	 *          <ScrollContext>
	 *            {this.props.children}
	 *          </ScrollContext>
	 *          {this.renderLayers()}
	 *        </div>
	 *      );
	 *    }
	 *  }
	 * ```
	 */
	
	var Layer = _react2.default.createClass({
	  displayName: 'Layer',
	
	
	  mixins: [_LayerHideOnBlur2.default, _LayerHideOnEscape2.default, _LayerHideOnTransition2.default],
	
	  statics: {
	    propClasses: {
	      placement: {
	        bottom: 'Layer-placementBottom',
	        left: 'Layer-placementLeft',
	        right: 'Layer-placementRight',
	        top: 'Layer-placementTop'
	      },
	      alignment: {
	        middle: null,
	        bottom: 'Layer-alignmentBottom',
	        left: 'Layer-alignmentLeft',
	        right: 'Layer-alignmentRight',
	        top: 'Layer-alignmentTop'
	      },
	      fixed: 'Layer-fixed'
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      placement: 'right',
	      alignment: 'middle',
	      fixed: false,
	      propagateOutsideClicks: true
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    if (!this.props.propagateOutsideClicks) {
	      var layerContainerNode = _reactDom2.default.findDOMNode(this).parentNode;
	      this.layerContainerParentNode = layerContainerNode.parentNode;
	      this.clickLayer = document.createElement('div');
	      this.clickLayer.style.cssText = 'position:fixed;top:0;width:100%;height:100%;';
	      this.layerContainerParentNode.insertBefore(this.clickLayer, layerContainerNode);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (!this.props.propagateOutsideClicks) {
	      this.layerContainerParentNode.removeChild(this.clickLayer);
	    }
	  },
	  render: function render() {
	    var _props = this.props,
	        style = _props.style,
	        position = _props.position,
	        zIndex = _props.zIndex,
	        className = _props.className,
	        children = _props.children,
	        others = _objectWithoutProperties(_props, ['style', 'position', 'zIndex', 'className', 'children']);
	
	    var divStyle = Object.assign({}, style, position);
	
	    if (zIndex) {
	      divStyle.zIndex = zIndex;
	    }
	
	    var divProps = (0, _pickInputElementProps2.default)(others);
	    return _react2.default.createElement(
	      'div',
	      _extends({}, divProps, {
	        className: (0, _classnames2.default)('Layer', (0, _getPropClasses.getPropClassesFromInstance)(this), className),
	        style: divStyle,
	        tabIndex: 0 }),
	      children
	    );
	  }
	});
	
	exports.default = Layer;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _currentUserAgent = __webpack_require__(1160);
	
	var _currentUserAgent2 = _interopRequireDefault(_currentUserAgent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stack = []; /*  weak */
	
	
	function shouldHideLayerOnEvent(layer, event) {
	  if (!layer.props.hideOnBlur) {
	    return false;
	  }
	
	  var context = layer.props.context;
	  if (context && context.contains(event.target)) {
	    return false;
	  }
	
	  var node = _reactDom2.default.findDOMNode(layer);
	  return !node.contains(event.target);
	}
	
	function hideOnBlur(event) {
	  var layersToHide = [];
	  var layersToKeep = [];
	
	  // split the layers into 2 bucket.
	  var i = stack.length;
	  while (i--) {
	    var layer = stack[i];
	    if (shouldHideLayerOnEvent(layer, event)) {
	      layersToHide.push(layer);
	    } else {
	      layersToKeep.push(layer);
	    }
	  }
	
	  // If a layer has a button that open another layer
	  // then clicking inside the second layer should not close
	  // the first layer.
	  layersToHide = layersToHide.filter(function (layerToHide) {
	    var contextToHide = layerToHide.props.context;
	
	    var shouldFilterOut = layersToKeep.some(function (layerToKeep) {
	      var nodeToKeep = _reactDom2.default.findDOMNode(layerToKeep);
	      return !nodeToKeep.contains(contextToHide);
	    });
	
	    return !shouldFilterOut;
	  });
	
	  layersToHide.forEach(function (layer) {
	    // Enqueue this at the end of the event queue to allow click events to fire in I
	    setTimeout(layer.props.onRequestHide, 0);
	  });
	}
	
	var LayerHideOnBlur = {
	  propTypes: {
	    hideOnBlur: _react2.default.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      hideOnBlur: true
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    if (stack.length === 0) {
	      if (_currentUserAgent2.default.firefox()) {
	        document.addEventListener('focus', hideOnBlur, true);
	      } else {
	        document.addEventListener('focusin', hideOnBlur, false);
	      }
	      document.addEventListener('mousedown', hideOnBlur, false);
	    }
	
	    stack.push(this);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var index = stack.indexOf(this);
	    if (index >= 0) {
	      stack.splice(index, 1);
	
	      if (stack.length === 0) {
	        if (_currentUserAgent2.default.firefox()) {
	          document.removeEventListener('focus', hideOnBlur, true);
	        } else {
	          document.removeEventListener('focusin', hideOnBlur, false);
	        }
	        document.removeEventListener('mousedown', hideOnBlur, false);
	      }
	    }
	  }
	};
	
	exports.default = LayerHideOnBlur;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserAgent = __webpack_require__(1161);
	
	var _UserAgent2 = _interopRequireDefault(_UserAgent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uaStr = typeof window === 'undefined' ? '' : window.navigator.userAgent;
	exports.default = new _UserAgent2.default(uaStr);

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _uaParserJs = __webpack_require__(1162);
	
	var _uaParserJs2 = _interopRequireDefault(_uaParserJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function is(obj, nameOrNames) {
	  if (typeof obj === 'undefined') {
	    throw new Error('undefined UA obj argument');
	  }
	
	  var names = Array.isArray(nameOrNames) ? nameOrNames : [nameOrNames];
	
	  if (names.includes(obj.name)) {
	    return parseFloat(obj.version, 10) || 0.9; // a truthy value that some older code may expect, but won't pass a version test
	  } else {
	    return NaN; // fea1123 had this, apparently returning the version num
	  }
	}
	
	var UserAgent = function () {
	  function UserAgent(userAgentSpec) {
	    _classCallCheck(this, UserAgent);
	
	    this.result = (0, _uaParserJs2.default)(userAgentSpec);
	  }
	
	  // Engines
	
	
	  _createClass(UserAgent, [{
	    key: 'engine',
	    value: function engine(names) {
	      return is(this.result.engine, names);
	    }
	  }, {
	    key: 'gecko',
	    value: function gecko() {
	      return this.engine('Gecko');
	    }
	  }, {
	    key: 'trident',
	    value: function trident() {
	      return this.engine('Trident');
	    }
	  }, {
	    key: 'webkit',
	    value: function webkit() {
	      return this.engine('WebKit');
	    }
	
	    // Browsers
	
	  }, {
	    key: 'browser',
	    value: function browser(names) {
	      return is(this.result.browser, names);
	    }
	  }, {
	    key: 'chrome',
	    value: function chrome() {
	      return this.browser(['Chrome', 'Chromium']);
	    }
	  }, {
	    key: 'firefox',
	    value: function firefox() {
	      return this.browser(['Firefox', 'Mozilla', 'Camino']);
	    }
	  }, {
	    key: 'ie',
	    value: function ie() {
	      return this.browser(['IE', 'IEMobile', 'IE Mobile', 'Edge']);
	    }
	  }, {
	    key: 'safari',
	    value: function safari() {
	      return this.browser(['Safari', 'Mobile Safari']);
	    }
	
	    // OS
	
	  }, {
	    key: 'os',
	    value: function os(names) {
	      return is(this.result.os, names);
	    }
	  }, {
	    key: 'android',
	    value: function android() {
	      return this.os('Android');
	    }
	
	    /**
	     * @deprecated
	     * @returns {Boolean} whether the user probably has an iOS device
	     */
	
	  }, {
	    key: 'ios',
	    value: function ios() {
	      return this.os('iOS') || this.mac() && (this.phone() || this.tablet());
	    }
	  }, {
	    key: 'mac',
	    value: function mac() {
	      return this.os('Mac OS');
	    }
	  }, {
	    key: 'windows',
	    value: function windows() {
	      return this.os(['Windows', 'Windows Phone', 'Window Mobile']);
	    }
	
	    // Device
	
	  }, {
	    key: 'isDesktop',
	    value: function isDesktop() {
	      // according https://github.com/faisalman/ua-parser-js/, possible types are only:
	      // console, mobile, tablet, smarttv, wearable, embedded
	      // ^ all not desktop
	      return !this.result.device.type && !(this.android() || this.ios());
	    }
	  }, {
	    key: 'phone',
	    value: function phone() {
	      return (/Mobile/.test(this.result.ua) && this.result.device.type !== 'tablet'
	      );
	    }
	  }, {
	    key: 'tablet',
	    value: function tablet() {
	      // WTF why do we have a different definition of "tablet"?
	      return this.result.device.type === 'tablet' || this.android() && !/Mobile/.test(this.result.ua);
	    }
	  }, {
	    key: 'isAndroidOrAppleTablet',
	    value: function isAndroidOrAppleTablet() {
	      return this.tablet() && (this.android() || this.ios());
	    }
	  }, {
	    key: 'isAndroidOrApplePhone',
	    value: function isAndroidOrApplePhone() {
	      return this.phone() && (this.android() || this.ios());
	    }
	  }]);
	
	  return UserAgent;
	}();
	
	UserAgent.displayName = 'UserAgent';
	exports.default = UserAgent;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * UAParser.js v0.7.10
	 * Lightweight JavaScript-based User-Agent string parser
	 * https://github.com/faisalman/ua-parser-js
	 *
	 * Copyright © 2012-2015 Faisal Salman <fyzlman@gmail.com>
	 * Dual licensed under GPLv2 & MIT
	 */
	
	(function (window, undefined) {
	
	    'use strict';
	
	    //////////////
	    // Constants
	    /////////////
	
	
	    var LIBVERSION  = '0.7.10',
	        EMPTY       = '',
	        UNKNOWN     = '?',
	        FUNC_TYPE   = 'function',
	        UNDEF_TYPE  = 'undefined',
	        OBJ_TYPE    = 'object',
	        STR_TYPE    = 'string',
	        MAJOR       = 'major', // deprecated
	        MODEL       = 'model',
	        NAME        = 'name',
	        TYPE        = 'type',
	        VENDOR      = 'vendor',
	        VERSION     = 'version',
	        ARCHITECTURE= 'architecture',
	        CONSOLE     = 'console',
	        MOBILE      = 'mobile',
	        TABLET      = 'tablet',
	        SMARTTV     = 'smarttv',
	        WEARABLE    = 'wearable',
	        EMBEDDED    = 'embedded';
	
	
	    ///////////
	    // Helper
	    //////////
	
	
	    var util = {
	        extend : function (regexes, extensions) {
	            for (var i in extensions) {
	                if ("browser cpu device engine os".indexOf(i) !== -1 && extensions[i].length % 2 === 0) {
	                    regexes[i] = extensions[i].concat(regexes[i]);
	                }
	            }
	            return regexes;
	        },
	        has : function (str1, str2) {
	          if (typeof str1 === "string") {
	            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
	          } else {
	            return false;
	          }
	        },
	        lowerize : function (str) {
	            return str.toLowerCase();
	        },
	        major : function (version) {
	            return typeof(version) === STR_TYPE ? version.split(".")[0] : undefined;
	        }
	    };
	
	
	    ///////////////
	    // Map helper
	    //////////////
	
	
	    var mapper = {
	
	        rgx : function () {
	
	            var result, i = 0, j, k, p, q, matches, match, args = arguments;
	
	            // loop through all regexes maps
	            while (i < args.length && !matches) {
	
	                var regex = args[i],       // even sequence (0,2,4,..)
	                    props = args[i + 1];   // odd sequence (1,3,5,..)
	
	                // construct object barebones
	                if (typeof result === UNDEF_TYPE) {
	                    result = {};
	                    for (p in props) {
	                        if (props.hasOwnProperty(p)){
	                            q = props[p];
	                            if (typeof q === OBJ_TYPE) {
	                                result[q[0]] = undefined;
	                            } else {
	                                result[q] = undefined;
	                            }
	                        }
	                    }
	                }
	
	                // try matching uastring with regexes
	                j = k = 0;
	                while (j < regex.length && !matches) {
	                    matches = regex[j++].exec(this.getUA());
	                    if (!!matches) {
	                        for (p = 0; p < props.length; p++) {
	                            match = matches[++k];
	                            q = props[p];
	                            // check if given property is actually array
	                            if (typeof q === OBJ_TYPE && q.length > 0) {
	                                if (q.length == 2) {
	                                    if (typeof q[1] == FUNC_TYPE) {
	                                        // assign modified match
	                                        result[q[0]] = q[1].call(this, match);
	                                    } else {
	                                        // assign given value, ignore regex match
	                                        result[q[0]] = q[1];
	                                    }
	                                } else if (q.length == 3) {
	                                    // check whether function or regex
	                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                                        // call function (usually string mapper)
	                                        result[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
	                                    } else {
	                                        // sanitize match using given regex
	                                        result[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
	                                    }
	                                } else if (q.length == 4) {
	                                        result[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
	                                }
	                            } else {
	                                result[q] = match ? match : undefined;
	                            }
	                        }
	                    }
	                }
	                i += 2;
	            }
	            return result;
	        },
	
	        str : function (str, map) {
	
	            for (var i in map) {
	                // check if array
	                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	                    for (var j = 0; j < map[i].length; j++) {
	                        if (util.has(map[i][j], str)) {
	                            return (i === UNKNOWN) ? undefined : i;
	                        }
	                    }
	                } else if (util.has(map[i], str)) {
	                    return (i === UNKNOWN) ? undefined : i;
	                }
	            }
	            return str;
	        }
	    };
	
	
	    ///////////////
	    // String map
	    //////////////
	
	
	    var maps = {
	
	        browser : {
	            oldsafari : {
	                version : {
	                    '1.0'   : '/8',
	                    '1.2'   : '/1',
	                    '1.3'   : '/3',
	                    '2.0'   : '/412',
	                    '2.0.2' : '/416',
	                    '2.0.3' : '/417',
	                    '2.0.4' : '/419',
	                    '?'     : '/'
	                }
	            }
	        },
	
	        device : {
	            amazon : {
	                model : {
	                    'Fire Phone' : ['SD', 'KF']
	                }
	            },
	            sprint : {
	                model : {
	                    'Evo Shift 4G' : '7373KT'
	                },
	                vendor : {
	                    'HTC'       : 'APA',
	                    'Sprint'    : 'Sprint'
	                }
	            }
	        },
	
	        os : {
	            windows : {
	                version : {
	                    'ME'        : '4.90',
	                    'NT 3.11'   : 'NT3.51',
	                    'NT 4.0'    : 'NT4.0',
	                    '2000'      : 'NT 5.0',
	                    'XP'        : ['NT 5.1', 'NT 5.2'],
	                    'Vista'     : 'NT 6.0',
	                    '7'         : 'NT 6.1',
	                    '8'         : 'NT 6.2',
	                    '8.1'       : 'NT 6.3',
	                    '10'        : ['NT 6.4', 'NT 10.0'],
	                    'RT'        : 'ARM'
	                }
	            }
	        }
	    };
	
	
	    //////////////
	    // Regex map
	    /////////////
	
	
	    var regexes = {
	
	        browser : [[
	
	            // Presto based
	            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
	            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
	            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
	            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
	
	            ], [NAME, VERSION], [
	
	            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
	            ], [[NAME, 'Opera'], VERSION], [
	
	            // Mixed
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
	                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	
	            // Trident based
	            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
	                                                                                // Avant/IEMobile/SlimBrowser/Baidu
	            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer
	
	            // Webkit/KHTML based
	            /(rekonq)\/([\w\.]+)*/i,                                            // Rekonq
	            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs)\/([\w\.-]+)/i
	                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS
	            ], [NAME, VERSION], [
	
	            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
	            ], [[NAME, 'IE'], VERSION], [
	
	            /(edge)\/((\d+)?[\w\.]+)/i                                          // Microsoft Edge
	            ], [NAME, VERSION], [
	
	            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
	            ], [[NAME, 'Yandex'], VERSION], [
	
	            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
	            ], [[NAME, /_/g, ' '], VERSION], [
	
	            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i,
	                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
	            /(qqbrowser)[\/\s]?([\w\.]+)/i
	                                                                                // QQBrowser
	            ], [NAME, VERSION], [
	
	            /(uc\s?browser)[\/\s]?([\w\.]+)/i,
	            /ucweb.+(ucbrowser)[\/\s]?([\w\.]+)/i,
	            /JUC.+(ucweb)[\/\s]?([\w\.]+)/i
	                                                                                // UCBrowser
	            ], [[NAME, 'UCBrowser'], VERSION], [
	
	            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
	            ], [[NAME, 'Dolphin'], VERSION], [
	
	            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
	            ], [[NAME, 'Chrome'], VERSION], [
	
	            /XiaoMi\/MiuiBrowser\/([\w\.]+)/i                                   // MIUI Browser
	            ], [VERSION, [NAME, 'MIUI Browser']], [
	
	            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)/i         // Android Browser
	            ], [VERSION, [NAME, 'Android Browser']], [
	
	            /FBAV\/([\w\.]+);/i                                                 // Facebook App for iOS
	            ], [VERSION, [NAME, 'Facebook']], [
	
	            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
	            ], [VERSION, [NAME, 'Firefox']], [
	
	            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
	            ], [VERSION, [NAME, 'Mobile Safari']], [
	
	            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
	            ], [VERSION, NAME], [
	
	            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
	            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [
	
	            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
	            /(webkit|khtml)\/([\w\.]+)/i
	            ], [NAME, VERSION], [
	
	            // Gecko based
	            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
	            ], [[NAME, 'Netscape'], VERSION], [
	            /(swiftfox)/i,                                                      // Swiftfox
	            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
	                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
	            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
	                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla
	
	            // Other
	            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
	                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
	            /(links)\s\(([\w\.]+)/i,                                            // Links
	            /(gobrowser)\/?([\w\.]+)*/i,                                        // GoBrowser
	            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
	            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
	            ], [NAME, VERSION]
	
	            /* /////////////////////
	            // Media players BEGIN
	            ////////////////////////
	
	            , [
	
	            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
	            /(coremedia) v((\d+)[\w\._]+)/i
	            ], [NAME, VERSION], [
	
	            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
	            ], [NAME, VERSION], [
	
	            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
	            ], [NAME, VERSION], [
	
	            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
	                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
	                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
	            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
	            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
	            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
	            ], [NAME, VERSION], [
	            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
	            ], [NAME, VERSION], [
	
	            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
	            ], [[NAME, 'Flip Player'], VERSION], [
	
	            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
	                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
	            ], [NAME], [
	
	            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
	                                                                                // Gstreamer
	            ], [NAME, VERSION], [
	
	            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
	            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
	                                                                                // Java/urllib/requests/wget/cURL
	            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
	            ], [NAME, VERSION], [
	
	            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
	            ], [[NAME, /_/g, ' '], VERSION], [
	
	            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
	                                                                                // MPlayer SVN
	            ], [NAME, VERSION], [
	
	            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
	            ], [NAME, VERSION], [
	
	            /(mplayer)/i,                                                       // MPlayer (no other info)
	            /(yourmuze)/i,                                                      // YourMuze
	            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
	            ], [NAME], [
	
	            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
	            ], [NAME, VERSION], [
	
	            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
	            ], [NAME, VERSION], [
	
	            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
	            ], [NAME, VERSION], [
	
	            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
	            /(winamp)\s((\d+)[\w\.-]+)/i,
	            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
	            ], [NAME, VERSION], [
	
	            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
	                                                                                // inlight radio
	            ], [NAME], [
	
	            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
	                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
	                                                                                // SoundTap/Totem/Stagefright/Streamium
	            ], [NAME, VERSION], [
	
	            /(smp)((\d+)[\d\.]+)/i                                              // SMP
	            ], [NAME, VERSION], [
	
	            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
	            /(vlc)\/((\d+)[\w\.-]+)/i,
	            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
	            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
	            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
	            ], [NAME, VERSION], [
	
	            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
	            /(windows-media-player)\/((\d+)[\w\.-]+)/i
	            ], [[NAME, /-/g, ' '], VERSION], [
	
	            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
	                                                                                // Windows Media Server
	            ], [VERSION, [NAME, 'Windows']], [
	
	            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
	            ], [NAME, VERSION], [
	
	            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
	            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
	            ], [[NAME, 'rad.io'], VERSION]
	
	            //////////////////////
	            // Media players END
	            ////////////////////*/
	
	        ],
	
	        cpu : [[
	
	            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
	            ], [[ARCHITECTURE, 'amd64']], [
	
	            /(ia32(?=;))/i                                                      // IA32 (quicktime)
	            ], [[ARCHITECTURE, util.lowerize]], [
	
	            /((?:i[346]|x)86)[;\)]/i                                            // IA32
	            ], [[ARCHITECTURE, 'ia32']], [
	
	            // PocketPC mistakenly identified as PowerPC
	            /windows\s(ce|mobile);\sppc;/i
	            ], [[ARCHITECTURE, 'arm']], [
	
	            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
	            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [
	
	            /(sun4\w)[;\)]/i                                                    // SPARC
	            ], [[ARCHITECTURE, 'sparc']], [
	
	            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
	                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	            ], [[ARCHITECTURE, util.lowerize]]
	        ],
	
	        device : [[
	
	            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
	            ], [MODEL, VENDOR, [TYPE, TABLET]], [
	
	            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [
	
	            /(apple\s{0,1}tv)/i                                                 // Apple TV
	            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [
	
	            /(archos)\s(gamepad2?)/i,                                           // Archos
	            /(hp).+(touchpad)/i,                                                // HP TouchPad
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
	            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i                               // Kindle Fire HD
	            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
	            /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i                  // Fire Phone
	            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
	
	            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
	            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
	            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [
	
	            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
	            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|huawei|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
	                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Huawei/Meizu/Motorola/Polytron
	            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
	            /(asus)-?(\w+)/i                                                    // Asus
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
	            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
	                                                                                // Asus Tablets
	            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7)/i
	            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [
	
	            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
	            /(sony)?(?:sgp.+)\sbuild\//i
	            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
	            /(?:sony)?(?:(?:(?:c|d)\d{4})|(?:so[-l].+))\sbuild\//i
	            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Phone'], [TYPE, MOBILE]], [
	
	            /\s(ouya)\s/i,                                                      // Ouya
	            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
	            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
	
	            /android.+;\s(shield)\sbuild/i                                      // Nvidia
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
	
	            /(playstation\s[34portablevi]+)/i                                   // Playstation
	            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [
	
	            /(sprint\s(\w+))/i                                                  // Sprint Phones
	            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [
	
	            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
	            /(zte)-(\w+)*/i,                                                    // ZTE
	            /(alcatel|geeksphone|huawei|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
	                                                                                // Alcatel/GeeksPhone/Huawei/Lenovo/Nexian/Panasonic/Sony
	            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [
	                
	            /(nexus\s9)/i                                                       // HTC Nexus 9
	            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
	
	            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
	            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
	            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
	            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [
	
	                                                                                // Motorola
	            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
	            /mot[\s-]?(\w+)*/i,
	            /(XT\d{3,4}) build\//i,
	            /(nexus\s[6])/i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
	            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [
	
	            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n8000|sgh-t8[56]9|nexus 10))/i,
	            /((SM-T\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
	            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-n900))/i,
	            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
	            /sec-((sgh\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [
	            /(samsung);smarttv/i
	            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
	
	            /\(dtv[\);].+(aquos)/i                                              // Sharp
	            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
	            /sie-(\w+)*/i                                                       // Siemens
	            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
	
	            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
	            /(nokia)[\s_-]?([\w-]+)*/i
	            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [
	
	            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
	            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [
	
	            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
	            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
	            /(lg) netcast\.tv/i                                                 // LG SmartTV
	            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
	            /(nexus\s[45])/i,                                                   // LG
	            /lg[e;\s\/-]+(\w+)*/i
	            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [
	
	            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
	            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
	
	            /linux;.+((jolla));/i                                               // Jolla
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
	            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
	
	            /android.+;\s(glass)\s\d/i                                          // Google Glass
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [
	
	            /android.+(\w+)\s+build\/hm\1/i,                                        // Xiaomi Hongmi 'numeric' models
	            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,                   // Xiaomi Hongmi
	            /android.+(mi[\s\-_]*(?:one|one[\s_]plus)?[\s_]*(?:\d\w)?)\s+build/i    // Xiaomi Mi
	            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
	
	            /\s(tablet)[;\/\s]/i,                                               // Unidentifiable Tablet
	            /\s(mobile)[;\/\s]/i                                                // Unidentifiable Mobile
	            ], [[TYPE, util.lowerize], VENDOR, MODEL]
	
	            /*//////////////////////////
	            // TODO: move to string map
	            ////////////////////////////
	
	            /(C6603)/i                                                          // Sony Xperia Z C6603
	            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	            /(C6903)/i                                                          // Sony Xperia Z 1
	            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	
	            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
	            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
	            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
	            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
	            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
	            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
	            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
	            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	
	            /(R1001)/i                                                          // Oppo R1001
	            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [
	            /(X9006)/i                                                          // Oppo Find 7a
	            ], [[MODEL, 'Find 7a'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	            /(R2001)/i                                                          // Oppo YOYO R2001
	            ], [[MODEL, 'Yoyo R2001'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	            /(R815)/i                                                           // Oppo Clover R815
	            ], [[MODEL, 'Clover R815'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	             /(U707)/i                                                          // Oppo Find Way S
	            ], [[MODEL, 'Find Way S'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	
	            /(T3C)/i                                                            // Advan Vandroid T3C
	            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
	            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
	            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [
	
	            /(V972M)/i                                                          // ZTE V972M
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
	
	            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
	            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
	            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	            
	            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
	            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [
	
	            /////////////
	            // END TODO
	            ///////////*/
	
	        ],
	
	        engine : [[
	
	            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
	            ], [VERSION, [NAME, 'EdgeHTML']], [
	
	            /(presto)\/([\w\.]+)/i,                                             // Presto
	            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
	            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
	            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
	            ], [NAME, VERSION], [
	
	            /rv\:([\w\.]+).*(gecko)/i                                           // Gecko
	            ], [VERSION, NAME]
	        ],
	
	        os : [[
	
	            // Windows based
	            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
	            ], [NAME, VERSION], [
	            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
	            /(windows\sphone(?:\sos)*|windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
	            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
	            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
	            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [
	
	            // Mobile/Embedded OS
	            /\((bb)(10);/i                                                      // BlackBerry 10
	            ], [[NAME, 'BlackBerry'], VERSION], [
	            /(blackberry)\w*\/?([\w\.]+)*/i,                                    // Blackberry
	            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
	            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
	                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
	            /linux;.+(sailfish);/i                                              // Sailfish OS
	            ], [NAME, VERSION], [
	            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i                 // Symbian
	            ], [[NAME, 'Symbian'], VERSION], [
	            /\((series40);/i                                                    // Series 40
	            ], [NAME], [
	            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
	            ], [[NAME, 'Firefox OS'], VERSION], [
	
	            // Console
	            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation
	
	            // GNU/Linux based
	            /(mint)[\/\s\(]?(\w+)*/i,                                           // Mint
	            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
	            /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?([\w\.-]+)*/i,
	                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
	                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
	            /(hurd|linux)\s?([\w\.]+)*/i,                                       // Hurd/Linux
	            /(gnu)\s?([\w\.]+)*/i                                               // GNU
	            ], [NAME, VERSION], [
	
	            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
	            ], [[NAME, 'Chromium OS'], VERSION],[
	
	            // Solaris
	            /(sunos)\s?([\w\.]+\d)*/i                                           // Solaris
	            ], [[NAME, 'Solaris'], VERSION], [
	
	            // BSD based
	            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i                   // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
	            ], [NAME, VERSION],[
	
	            /(ip[honead]+)(?:.*os\s([\w]+)*\slike\smac|;\sopera)/i              // iOS
	            ], [[NAME, 'iOS'], [VERSION, /_/g, '.']], [
	
	            /(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
	            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
	            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [
	
	            // Other
	            /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,                            // Solaris
	            /(haiku)\s(\w+)/i,                                                  // Haiku
	            /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,                               // AIX
	            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
	                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
	            /(unix)\s?([\w\.]+)*/i                                              // UNIX
	            ], [NAME, VERSION]
	        ]
	    };
	
	
	    /////////////////
	    // Constructor
	    ////////////////
	
	
	    var UAParser = function (uastring, extensions) {
	
	        if (!(this instanceof UAParser)) {
	            return new UAParser(uastring, extensions).getResult();
	        }
	
	        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
	        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
	
	        this.getBrowser = function () {
	            var browser = mapper.rgx.apply(this, rgxmap.browser);
	            browser.major = util.major(browser.version);
	            return browser;
	        };
	        this.getCPU = function () {
	            return mapper.rgx.apply(this, rgxmap.cpu);
	        };
	        this.getDevice = function () {
	            return mapper.rgx.apply(this, rgxmap.device);
	        };
	        this.getEngine = function () {
	            return mapper.rgx.apply(this, rgxmap.engine);
	        };
	        this.getOS = function () {
	            return mapper.rgx.apply(this, rgxmap.os);
	        };
	        this.getResult = function() {
	            return {
	                ua      : this.getUA(),
	                browser : this.getBrowser(),
	                engine  : this.getEngine(),
	                os      : this.getOS(),
	                device  : this.getDevice(),
	                cpu     : this.getCPU()
	            };
	        };
	        this.getUA = function () {
	            return ua;
	        };
	        this.setUA = function (uastring) {
	            ua = uastring;
	            return this;
	        };
	        this.setUA(ua);
	        return this;
	    };
	
	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER = {
	        NAME    : NAME,
	        MAJOR   : MAJOR, // deprecated
	        VERSION : VERSION
	    };
	    UAParser.CPU = {
	        ARCHITECTURE : ARCHITECTURE
	    };
	    UAParser.DEVICE = {
	        MODEL   : MODEL,
	        VENDOR  : VENDOR,
	        TYPE    : TYPE,
	        CONSOLE : CONSOLE,
	        MOBILE  : MOBILE,
	        SMARTTV : SMARTTV,
	        TABLET  : TABLET,
	        WEARABLE: WEARABLE,
	        EMBEDDED: EMBEDDED
	    };
	    UAParser.ENGINE = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	    UAParser.OS = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	
	
	    ///////////
	    // Export
	    //////////
	
	
	    // check js environment
	    if (typeof(exports) !== UNDEF_TYPE) {
	        // nodejs env
	        if (typeof module !== UNDEF_TYPE && module.exports) {
	            exports = module.exports = UAParser;
	        }
	        exports.UAParser = UAParser;
	    } else {
	        // requirejs env (optional)
	        if ("function" === FUNC_TYPE && __webpack_require__(572)) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	                return UAParser;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else {
	            // browser env
	            window.UAParser = UAParser;
	        }
	    }
	
	    // jQuery/Zepto specific (optional)
	    // Note: 
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.
	    var $ = window.jQuery || window.Zepto;
	    if (typeof $ !== UNDEF_TYPE) {
	        var parser = new UAParser();
	        $.ua = parser.getResult();
	        $.ua.get = function() {
	            return parser.getUA();
	        };
	        $.ua.set = function (uastring) {
	            parser.setUA(uastring);
	            var result = parser.getResult();
	            for (var prop in result) {
	                $.ua[prop] = result[prop];
	            }
	        };
	    }
	
	})(typeof window === 'object' ? window : this);


/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _KeyConstants = __webpack_require__(1164);
	
	var _KeyConstants2 = _interopRequireDefault(_KeyConstants);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// typecheck: ignore file
	var stack = [];
	
	var handleDocumentKeyDown = function handleDocumentKeyDown(event) {
	  if (event.keyCode === _KeyConstants2.default.ESCAPE) {
	    var l = stack.length;
	    while (l--) {
	      var layer = stack[l];
	      if (layer && layer.props.hideOnEscape) {
	        if (!layer.props.onRequestHide) {
	          console.error('component has hideOnEscape without onRequestHide', layer.displayName);
	          continue;
	        }
	        event.preventDefault();
	        layer.props.onRequestHide();
	        break;
	      }
	    }
	  }
	};
	
	var LayerHideOnEscape = {
	  propTypes: {
	    hideOnEscape: _react2.default.PropTypes.bool,
	    onRequestHide: _react2.default.PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      hideOnEscape: true
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    if (stack.length === 0) {
	      document.addEventListener('keydown', handleDocumentKeyDown, false);
	    }
	    stack.push(this);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var index = stack.indexOf(this);
	    if (index >= 0) {
	      stack.splice(index, 1);
	
	      if (stack.length === 0) {
	        document.removeEventListener('keydown', handleDocumentKeyDown, false);
	      }
	    }
	  }
	};
	
	exports.default = LayerHideOnEscape;

/***/ },
/* 1164 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  BACKSPACE: 8,
	  DOWN: 40,
	  ENTER: 13,
	  ESCAPE: 27,
	  K: 75,
	  LEFT: 37,
	  RIGHT: 39,
	  TAB: 9,
	  DEC_0: 48,
	  DEC_9: 57,
	  UP: 38,
	  DOT: 190,
	  NUMPAD_DECIMAL: 110
	};

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(497);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stack = [];
	
	function handleTransition() {
	  var l = stack.length;
	  while (l--) {
	    var layer = stack[l];
	    if (layer && layer.props.hideOnTransition) {
	      if (layer.props.onRequestHide) {
	        layer.props.onRequestHide();
	      }
	    }
	  }
	}
	
	if (_reactRouter.browserHistory) {
	  _reactRouter.browserHistory.listen(handleTransition);
	}
	
	var LayerHideOnTransition = {
	  propTypes: {
	    hideOnTransition: _react2.default.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      hideOnTransition: true
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    stack.push(this);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var index = stack.indexOf(this);
	    if (index >= 0) {
	      stack.splice(index, 1);
	    }
	  }
	};
	
	exports.default = LayerHideOnTransition;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var LayerPropTypes = {
	  placement: _react2.default.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	  alignment: function alignment(props, propName, componentName) {
	    var alignment = props.alignment;
	    if (alignment !== 'middle') {
	      var placement = props.placement;
	      if (_lodash2.default.includes(['top', 'bottom'], placement) && !_lodash2.default.includes(['left', 'right'], alignment)) {
	        return new Error('Invalid prop `' + propName + '` of value `' + alignment + '` supplied to ' + ('`' + componentName + '`, expected one of ["left", "right"] when `placement` is ') + ('`' + placement + '`.'));
	      }
	      if (_lodash2.default.includes(['left', 'right'], placement) && !_lodash2.default.includes(['top', 'bottom'], alignment)) {
	        return new Error('Invalid prop `' + propName + '` of value `' + alignment + '` supplied to ' + ('`' + componentName + '`, expected one of ["top", "bottom"] when `placement` is ') + ('`' + placement + '`.'));
	      }
	    }
	  }
	};
	
	exports.default = LayerPropTypes;

/***/ },
/* 1167 */
1136,
/* 1168 */,
/* 1169 */
1136,
/* 1170 */,
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Tooltip = __webpack_require__(1157);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	/* Tooltip Trigger.
	 * This is a small & simple wrapper around
	 * LayerTrigger to write tooltip trigger with ease.
	 * (A Tooltip is just a Layer that show on hover with some delay)
	 *
	 * <TooltipTrigger tooltip="howdy?">
	 *   <Button>click me</Button>
	 * <TooltipTrigger/>
	 *
	 * <TooltipTrigger tooltip={<Tooltip color="brand">howdy?<Tooltip/>}>
	 *   <Button>click me</Button>
	 * <TooltipTrigger/>
	 */
	var TooltipTrigger = function (_React$Component) {
	  _inherits(TooltipTrigger, _React$Component);
	
	  function TooltipTrigger() {
	    _classCallCheck(this, TooltipTrigger);
	
	    return _possibleConstructorReturn(this, (TooltipTrigger.__proto__ || Object.getPrototypeOf(TooltipTrigger)).apply(this, arguments));
	  }
	
	  _createClass(TooltipTrigger, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tooltip = _props.tooltip,
	          children = _props.children,
	          placement = _props.placement,
	          alignment = _props.alignment;
	
	
	      var layer = function () {
	        if (typeof tooltip === 'string') {
	          return _react2.default.createElement(
	            _Tooltip2.default,
	            null,
	            tooltip
	          );
	        } else {
	          return tooltip;
	        }
	      }();
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          trigger: ['hover', 'focus'],
	          layer: layer,
	          placement: placement,
	          alignment: alignment,
	          delayShow: 400 },
	        children
	      );
	    }
	  }]);
	
	  return TooltipTrigger;
	}(_react2.default.Component);
	
	TooltipTrigger.displayName = 'TooltipTrigger';
	exports.default = TooltipTrigger;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _DOM = __webpack_require__(1109);
	
	var _DOM2 = _interopRequireDefault(_DOM);
	
	var _KeyState = __webpack_require__(1173);
	
	var _KeyState2 = _interopRequireDefault(_KeyState);
	
	var _LayerPropTypes = __webpack_require__(1166);
	
	var _LayerPropTypes2 = _interopRequireDefault(_LayerPropTypes);
	
	var _LayeredComponentMixin = __webpack_require__(1174);
	
	var _LayeredComponentMixin2 = _interopRequireDefault(_LayeredComponentMixin);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _findScrollParent = __webpack_require__(1176);
	
	var _findScrollParent2 = _interopRequireDefault(_findScrollParent);
	
	var _findZIndex = __webpack_require__(1177);
	
	var _findZIndex2 = _interopRequireDefault(_findZIndex);
	
	var _isFixed = __webpack_require__(1178);
	
	var _isFixed2 = _interopRequireDefault(_isFixed);
	
	var _lodash = __webpack_require__(555);
	
	var _LayerTrigger = __webpack_require__(1179);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var PLACEMENTS = ['right', 'left', 'bottom', 'top'];
	var HORIZONTAL_ALIGNMENTS = ['middle', 'left', 'right'];
	var VERTICAL_ALIGNMENTS = ['middle', 'top', 'bottom'];
	
	var OPPOSITES = {
	  right: 'left',
	  left: 'right',
	  bottom: 'top',
	  top: 'bottom'
	};
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	/**
	 * Used to display a [Layer](/components/Layer) when the trigger element is clicked, hovered, and/or
	 * focused.
	 *
	 * ```example
	 *  <div>
	 *    <LayerTrigger
	 *      layer={
	 *        <Menu>
	 *          <MenuItem>First item</MenuItem>
	 *          <MenuItem>Second item</MenuItem>
	 *          <MenuItem>Third item</MenuItem>
	 *        </Menu>
	 *      }
	 *      placement="bottom"
	 *      trigger="click">
	 *      <Link>Click here to open the menu</Link>
	 *    </LayerTrigger>
	 *    {' or '}
	 *    <LayerTrigger
	 *      layer={
	 *        <Hovercard>
	 *          <HovercardBody>Hello!</HovercardBody>
	 *        </Hovercard>
	 *      }
	 *      trigger="hover">
	 *      <Link>hover here to show the hovercard</Link>
	 *    </LayerTrigger>
	 *  </div>
	 * ```
	 *
	 * # Setting the preferred position of the layer
	 *
	 * Use the `placement` and `alignment` props of `LayerPropTypes` to set the preferred position of
	 * the layer element. LayerTrigger will determine itself whether or not to use another position on
	 * the screen if the layer is unable to fit within the viewport.
	 *
	 * ```example
	 *  <LeftRight pull="both">
	 *    <LayerTrigger
	 *      layer={
	 *        <Hovercard>
	 *          <HovercardBody>
	 *            This layer will be displayed on top of the trigger, most of the time.
	 *          </HovercardBody>
	 *        </Hovercard>
	 *      }
	 *      placement="top"
	 *      alignment="left"
	 *      trigger="hover">
	 *      <Link>Hover this link</Link>
	 *    </LayerTrigger>
	 *    <LayerTrigger
	 *      layer={
	 *        <Hovercard style={{width: 200}}>
	 *          <HovercardBody>
	 *            This layer will probably be displayed to the left of the trigger.
	 *          </HovercardBody>
	 *        </Hovercard>
	 *      }
	 *      trigger="hover">
	 *      <Link>Hover this link</Link>
	 *    </LayerTrigger>
	 *  </LeftRight>
	 * ```
	 *
	 * # Programmatically triggering a LayerTrigger
	 *
	 * You can manually show and hide a layer by using `trigger="manual"` on the LayerTrigger and
	 * calling `showLayer()` or `hideLayer()` on the LayerTrigger instance.
	 *
	 * ```js
	 *  handleFoo() {
	 *    this.refs.trigger.showLayer();
	 *  }
	 *
	 *  render() {
	 *    return (
	 *      <div>
	 *        <LayerTrigger ref="trigger" trigger={['click', 'manual']}>
	 *          <Link>Click here</Link>
	 *        </LayerTrigger>
	 *        <Link onClick={() => this.handleFoo()}>
	 *          Or click here!
	 *        </Link>
	 *      </div>
	 *    );
	 *  }
	 * ```
	 *
	 * # Showing a Layer when the trigger is mounted
	 *
	 * The `defaultLayerShown` prop from `LayeredComponentMixin` can be used to have a layer shown by
	 * default when the trigger is first mounted (e.g., NUX).
	 *
	 * ```example
	 *  <LayerTrigger
	 *    layer={
	 *      <Tooltip hideOnBlur={false} hideOnEscape={false}>
	 *        Hello!
	 *      </Tooltip>
	 *    }
	 *    trigger="manual"
	 *    defaultLayerShown={true}>
	 *    <Link>There is a tooltip attached to this link</Link>
	 *  </LayerTrigger>
	 * ```
	 *
	 * # Setting the width of the layer to the context element's width
	 *
	 * The `useContextWidth` prop can be used to set the width of the Layer to be the same as the
	 * context width.
	 *
	 * ```example
	 *  <LayerTrigger
	 *    layer={
	 *      <Layer style={{backgroundColor: '#eee'}}>
	 *        This layer is as wide as the button.
	 *      </Layer>
	 *    }
	 *    placement="bottom"
	 *    useContextWidth={true}
	 *    trigger="click">
	 *    <Button>Click to show menu</Button>
	 *  </LayerTrigger>
	 * ```
	 */
	
	var LayerTrigger = _react2.default.createClass({
	  displayName: 'LayerTrigger',
	
	
	  mixins: [_LayeredComponentMixin2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      placement: 'right',
	      alignment: 'middle',
	      trigger: ['hover', 'focus'],
	      useContextWidth: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      layerLeft: 0,
	      layerRight: null,
	      layerTop: -9999,
	      layerPlacement: this.props.placement,
	      layerAlignment: this.props.alignment
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.updateLayerPosition();
	    setTimeout(this.updateLayerPosition, 0);
	
	    if (this.props.hideLayerOnScroll) {
	      this._scrollParent = (0, _findScrollParent2.default)(_reactDom2.default.findDOMNode(this));
	      if (this._scrollParent) {
	        this._scrollParent.addEventListener('scroll', this.hideLayer, true);
	      }
	    }
	
	    window.addEventListener('resize', this.updateLayerPosition);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.trigger === 'manual') {
	      if (this._hoverDelay !== null) {
	        clearTimeout(this._hoverDelay);
	        this._hoverDelay = null;
	      }
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (this.state.layerShown !== prevState.layerShown) {
	      // this is put at the end of the event queue because
	      // the component need to be rendered before we can
	      // calculate it's correct size and see if it fits
	      // in the view port or not.
	      window.setTimeout(this.updateLayerPosition, 0);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this._hoverDelay);
	    window.removeEventListener('resize', this.updateLayerPosition);
	
	    if (this._scrollParent) {
	      this._scrollParent.removeEventListener('scroll', this.hideLayer, true);
	    }
	
	    if (this.props.trigger === 'manual' && this.isLayerShown()) {
	      this.hideLayer();
	    }
	  },
	  getLayerRect: function getLayerRect() {
	    var layerNode = this.getLayerDOMNode();
	    return layerNode.getBoundingClientRect();
	  },
	  getPosition: function getPosition() {
	    var node = _reactDom2.default.findDOMNode(this);
	    var container = this.getContainerDOMNode();
	
	    var offset = container.tagName === 'BODY' ? _DOM2.default.getOffset(node) : _DOM2.default.getPosition(node, container);
	
	    if ((0, _isFixed2.default)(node)) {
	      var scrollPosition = _DOM2.default.getScrollPosition();
	      offset.left -= scrollPosition.left;
	      offset.top -= scrollPosition.top;
	    }
	
	    return Object.assign({}, offset, {
	      height: node.offsetHeight,
	      width: node.offsetWidth
	    });
	  },
	
	
	  _hoverDelay: null,
	  _scrollParent: null,
	
	  calcLayerPosition: function calcLayerPosition(placement, alignment) {
	    var childOffset = this.getPosition();
	
	    var layer = this.getLayerDOMNode();
	
	    var position = {};
	
	    switch (placement) {
	      case 'right':
	        position.left = childOffset.left + childOffset.width;
	        break;
	      case 'left':
	        position.left = childOffset.left - layer.offsetWidth;
	        break;
	      case 'top':
	        position.top = childOffset.top - layer.offsetHeight;
	        break;
	      case 'bottom':
	        position.top = childOffset.top + childOffset.height;
	        break;
	      default:
	        break;
	    }
	
	    if (this.props.useContextWidth && (placement === 'top' || placement === 'bottom')) {
	      var width = document.documentElement.clientWidth;
	      position.left = childOffset.left;
	      position.right = width - (childOffset.left + childOffset.width);
	    } else {
	      switch (alignment) {
	        case 'right':
	          position.left = childOffset.left + childOffset.width - layer.offsetWidth;
	          break;
	        case 'left':
	          position.left = childOffset.left;
	          break;
	        case 'top':
	          position.top = childOffset.top;
	          break;
	        case 'bottom':
	          position.top = childOffset.top + childOffset.height - layer.offsetHeight;
	          break;
	        default:
	        case 'middle':
	          if (placement === 'left' || placement === 'right') {
	            position.top = childOffset.top + childOffset.height / 2 - layer.offsetHeight / 2;
	          } else {
	            position.left = childOffset.left + childOffset.width / 2 - layer.offsetWidth / 2;
	          }
	          break;
	      }
	    }
	
	    return position;
	  },
	  fitsWithinViewport: function fitsWithinViewport(left, top, right, bottom) {
	    var node = _reactDom2.default.findDOMNode(this);
	    var bounds = (0, _isFixed2.default)(node) ? _DOM2.default.getOffset(document.documentElement) : {
	      top: document.body.scrollTop,
	      left: document.body.scrollLeft
	    };
	    var width = document.documentElement.clientWidth;
	    var height = document.documentElement.clientHeight;
	
	    return top >= bounds.top && bottom <= bounds.top + height && left >= bounds.left && right <= bounds.left + width;
	  },
	  handleClick: function handleClick(event) {
	    event.preventDefault();
	    this.toggleLayer();
	  },
	  handleDelayedHide: function handleDelayedHide() {
	    var _this = this;
	
	    if (this._hoverDelay !== null) {
	      clearTimeout(this._hoverDelay);
	      this._hoverDelay = null;
	      return;
	    }
	
	    var delay = this.props.delayHide || this.props.delay;
	
	    if (!delay) {
	      this.hideLayer();
	      return;
	    }
	
	    this._hoverDelay = setTimeout(function () {
	      _this._hoverDelay = null;
	      _this.hideLayer();
	    }, delay);
	  },
	  handleDelayedShow: function handleDelayedShow() {
	    var _this2 = this;
	
	    if (this._hoverDelay !== null) {
	      clearTimeout(this._hoverDelay);
	      this._hoverDelay = null;
	      return;
	    }
	
	    var delay = this.props.delayShow || this.props.delay;
	
	    if (!delay) {
	      this.showLayer();
	      return;
	    }
	
	    this._hoverDelay = setTimeout(function () {
	      _this2._hoverDelay = null;
	      _this2.showLayer();
	    }, delay);
	  },
	  handleFocus: function handleFocus(event) {
	    if (!_KeyState2.default.isKeyDown()) {
	      return;
	    }
	    this.handleDelayedShow(event);
	  },
	
	
	  updateLayerPosition: (0, _lodash.throttle)(function () {
	    var _this3 = this;
	
	    if (!this.isMounted() || !this.isLayerShown()) {
	      return;
	    }
	
	    var layer = this.getLayerDOMNode();
	    var width = layer.offsetWidth;
	    var height = layer.offsetHeight;
	
	    var attempts = {};
	    var _props = this.props,
	        placement = _props.placement,
	        alignment = _props.alignment;
	
	
	    var found = [placement, OPPOSITES[placement]].concat(PLACEMENTS).some(function (pt) {
	      if (pt in attempts) {
	        return false;
	      }
	      attempts[pt] = {};
	
	      return [alignment].concat(pt === 'left' || pt === 'right' ? VERTICAL_ALIGNMENTS : HORIZONTAL_ALIGNMENTS).some(function (at) {
	        if (at in attempts[pt]) {
	          return false;
	        }
	        attempts[pt][at] = true;
	
	        var _calcLayerPosition = _this3.calcLayerPosition(pt, at),
	            left = _calcLayerPosition.left,
	            right = _calcLayerPosition.right,
	            top = _calcLayerPosition.top;
	
	        if (_this3.fitsWithinViewport(left, top, left + width, top + height)) {
	          _this3.setState({
	            layerLeft: left,
	            layerRight: right,
	            layerTop: top,
	            layerPlacement: pt,
	            layerAlignment: at
	          }, function () {
	            // NOTE: Hacky but because we don't automatically re-render after the
	            // pending state transaction is completed, and LayerWithArrow depends
	            // on LayerTrigger to position its arrow, the arrow will never be
	            // drawn properly when a Hovercard is first displayed. By rerendering
	            // here, we ensure that the child LayerWithArrow updates its arrow
	            // position correctly and redraws itself.
	            // TODO: Fix this arrow display problem in a less hacky way.
	            this.forceUpdate();
	          });
	          return true;
	        }
	
	        return false;
	      });
	    });
	
	    if (!found) {
	      var _calcLayerPosition2 = this.calcLayerPosition(placement, alignment),
	          left = _calcLayerPosition2.left,
	          right = _calcLayerPosition2.right,
	          top = _calcLayerPosition2.top;
	
	      this.setState({
	        layerLeft: left,
	        layerRight: right,
	        layerTop: top,
	        layerPlacement: placement,
	        layerAlignment: alignment
	      }, function () {
	        // See above note
	        this.forceUpdate();
	      });
	    }
	  }, 100),
	
	  renderLayer: function renderLayer() {
	    var node = _reactDom2.default.findDOMNode(this);
	    var layer = this.props.layer;
	
	
	    return _react2.default.cloneElement(layer, {
	      onRequestHide: (0, _createChainedFunction2.default)(this.hideLayer, layer.props.onRequestHide),
	      placement: this.state.layerPlacement,
	      alignment: this.state.layerAlignment,
	      position: {
	        left: this.state.layerLeft,
	        right: this.state.layerRight,
	        top: this.state.layerTop
	      },
	      context: node,
	      zIndex: this.props.zIndex || (0, _findZIndex2.default)(node),
	      fixed: (0, _isFixed2.default)(node)
	    });
	  },
	  render: function render() {
	    var props = {};
	
	    var child = _react2.default.Children.only(this.props.children);
	
	    if (isOneOf('click', this.props.trigger)) {
	      props.onClick = (0, _createChainedFunction2.default)(this.handleClick, child.props.onClick);
	    }
	
	    if (isOneOf('hover', this.props.trigger)) {
	      props.onMouseEnter = (0, _createChainedFunction2.default)(this.handleDelayedShow, child.props.onMouseEnter);
	      props.onMouseLeave = (0, _createChainedFunction2.default)(this.handleDelayedHide, child.props.onMouseLeave);
	    }
	
	    if (isOneOf('focus', this.props.trigger)) {
	      props.onFocus = (0, _createChainedFunction2.default)(this.handleFocus, child.props.onFocus);
	      props.onBlur = (0, _createChainedFunction2.default)(this.handleDelayedHide, child.props.onBlur);
	    }
	
	    return _react2.default.cloneElement(child, Object.assign({}, props, {
	      className: (0, _classnames2.default)(_LayerTrigger2.default.this, child.props.className, this.props.className, _defineProperty({}, this.props.activeClassName, this.state.layerShown && this.props.activeClassName))
	    }));
	  }
	});
	
	exports.default = LayerTrigger;

/***/ },
/* 1173 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	var keyDown = {};
	
	if (typeof document !== 'undefined') {
	  document.addEventListener('keydown', function (event) {
	    keyDown[event.keyCode] = true;
	  }, false);
	
	  document.addEventListener('keyup', function (event) {
	    delete keyDown[event.keyCode];
	  }, false);
	}
	
	exports.default = {
	  isKeyDown: function isKeyDown() {
	    var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    return code === null ? Object.keys(keyDown).length > 0 : code in keyDown;
	  }
	};

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*  weak */
	
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LayeredComponentMixin = {
	  propTypes: {
	    container: function container(props, propName, componentName) {
	      if (!(propName in props) || props[propName] === null) {
	        return;
	      }
	      if (_typeof(props[propName]) !== 'object' || typeof props[propName].render !== 'function' && props[propName].nodeType !== 1) {
	        throw new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`, expected DOM ' + 'node or an object that has a `render` method');
	      }
	    },
	
	    defaultLayerShown: _react2.default.PropTypes.bool,
	    onShow: _react2.default.PropTypes.func,
	    onHide: _react2.default.PropTypes.func
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layerShown: this.props.defaultLayerShown
	    };
	  },
	  isLayerShown: function isLayerShown() {
	    return this.state.layerShown;
	  },
	  showLayer: function showLayer() {
	    if (!this.isMounted()) {
	      console.warn('LayeredComponentMixin showLayer() while unmounted');
	      return;
	    }
	    this.setState({ layerShown: true });
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	  hideLayer: function hideLayer() {
	    if (!this.isMounted()) {
	      console.warn('LayeredComponentMixin hideLayer() while unmounted');
	      return;
	    }
	    this.setState({ layerShown: false });
	    if (this.props.onHide) {
	      this.props.onHide();
	    }
	  },
	  toggleLayer: function toggleLayer() {
	    if (this.state.layerShown) {
	      this.hideLayer();
	    } else {
	      this.showLayer();
	    }
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
	    this._shouldRenderLayer = typeof this.shouldLayeredComponentUpdate !== 'function' || this.shouldLayeredComponentUpdate(nextProps, nextState);
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (this._shouldRenderLayer) {
	      this._renderLayer();
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.state.layerShown) {
	      this._renderLayer();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderLayer();
	    this._unmountLayerTarget();
	  },
	  _mountLayerTarget: function _mountLayerTarget() {
	    if (!this._layerTarget) {
	      this._layerTarget = document.createElement('div');
	      this.getContainerDOMNode().appendChild(this._layerTarget);
	    }
	  },
	  _unmountLayerTarget: function _unmountLayerTarget() {
	    if (this._layerTarget) {
	      if (this._layerTarget.parentNode) {
	        this._layerTarget.parentNode.removeChild(this._layerTarget);
	      }
	      this._layerTarget = null;
	    }
	  },
	  _renderLayer: function _renderLayer() {
	    var layer = this.state.layerShown ? this.renderLayer() : null;
	    if (layer) {
	      this._mountLayerTarget();
	      // XXX undocumented API, though present in latest React, 0.15
	      this._layerInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, layer, this._layerTarget);
	    } else {
	      this._unrenderLayer();
	      this._unmountLayerTarget();
	    }
	  },
	  _unrenderLayer: function _unrenderLayer() {
	    if (this._layerTarget) {
	      _reactDom2.default.unmountComponentAtNode(this._layerTarget);
	      this._layerInstance = null;
	    }
	  },
	  getLayerDOMNode: function getLayerDOMNode() {
	    if (!this.isMounted()) {
	      throw new Error('getLayerDOMNode(): A component must be mounted to have a DOM node.');
	    }
	
	    if (this._layerInstance) {
	      return _reactDom2.default.findDOMNode(this._layerInstance);
	    }
	
	    return null;
	  },
	  getContainerDOMNode: function getContainerDOMNode() {
	    var container = _reactDom2.default.findDOMNode(this.props.container);
	    if (container) {
	      return container;
	    }
	
	    var element = _reactDom2.default.findDOMNode(this);
	    return (element && element.ownerDocument || document).body;
	  }
	};
	
	exports.default = LayeredComponentMixin;

/***/ },
/* 1175 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} one
	 * @param {function} two
	 * @returns {function|null}
	 */
	function createChainedFunction(one, two) {
	  var hasOne = typeof one === 'function';
	  var hasTwo = typeof two === 'function';
	
	  if (!hasOne && !hasTwo) {
	    return null;
	  }
	  if (!hasOne) {
	    return two;
	  }
	  if (!hasTwo) {
	    return one;
	  }
	
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	exports.default = createChainedFunction;

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DOM = __webpack_require__(1109);
	
	function findScrollParent(node) {
	  var tempNode = node;
	  while (tempNode.parentNode) {
	    tempNode = tempNode.parentNode;
	    if (tempNode === document.body) {
	      break;
	    }
	    var overflowY = (0, _DOM.getStyle)(tempNode, 'overflow-y') || (0, _DOM.getStyle)(tempNode, 'overflow');
	    if (overflowY === 'auto' || overflowY === 'scroll') {
	      return tempNode;
	    }
	  }
	  return window;
	} /*  weak */
	exports.default = findScrollParent;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findZIndex;
	
	var _DOM = __webpack_require__(1109);
	
	function findZIndex(node) {
	  var nodes = [];
	  while (node && node !== document.body) {
	    nodes.push(node);
	    node = node.parentNode; // eslint-disable-line no-param-reassign
	  }
	
	  var l = nodes.length;
	  while (l--) {
	    node = nodes[l]; // eslint-disable-line no-param-reassign
	    var zIndex = (0, _DOM.getStyle)(node, 'z-index');
	    if (zIndex && zIndex !== 'auto' && zIndex !== 'initial' && zIndex !== 'inherit') {
	      return parseInt(zIndex, 10);
	    }
	  }
	  return 0;
	} /*  weak */

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DOM = __webpack_require__(1109);
	
	function isFixed(node) {
	  while (node && node !== document.body) {
	    var position = (0, _DOM.getStyle)(node, 'position');
	    if (position === 'fixed') {
	      return true;
	    }
	    node = node.parentNode; // eslint-disable-line no-param-reassign
	  }
	  return false;
	} /*  weak */
	exports.default = isFixed;

/***/ },
/* 1179 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"this":"LayerTrigger__this___sYtC_"};

/***/ },
/* 1180 */,
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	// typecheck: ignore file
	
	
	var ClickEventTrigger = function (_React$Component) {
	  _inherits(ClickEventTrigger, _React$Component);
	
	  function ClickEventTrigger() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClickEventTrigger);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClickEventTrigger.__proto__ || Object.getPrototypeOf(ClickEventTrigger)).call.apply(_ref, [this].concat(args))), _this), _this.trackClick = function () {
	      var elementName = (0, _EventTracking.getEventElementName)(_this.props);
	      var screenName = (0, _EventTracking.getEventScreenName)(_this.props, _this.context.router);
	      if (elementName && screenName) {
	        _EventTracking2.default.tap(screenName, elementName, (0, _EventTracking.getEventContextName)(_this.props, _this.context), (0, _EventTracking.getEventProperties)(_this.props.eventProperties, _this.context));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ClickEventTrigger, [{
	    key: 'render',
	    value: function render() {
	      var child = _react2.default.Children.only(this.props.children);
	      return _react2.default.cloneElement(child, _extends({}, child.props, {
	        onClick: (0, _createChainedFunction2.default)(this.trackClick, child.props.onClick)
	      }));
	    }
	  }]);
	
	  return ClickEventTrigger;
	}(_react2.default.Component);
	
	ClickEventTrigger.contextTypes = {
	  eventScreenName: _react2.default.PropTypes.string,
	  eventProperties: _react2.default.PropTypes.object,
	  eventContextName: _react2.default.PropTypes.string,
	  router: _react2.default.PropTypes.object
	};
	ClickEventTrigger.displayName = 'ClickEventTrigger';
	exports.default = ClickEventTrigger;

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(497);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	/**
	 * Base link component that encapsulates logic for `react-router`
	 *
	 * This component is by [Link](/components/Link). You should almost always use Link, unless you
	 * want to style your link differently.
	 */
	
	var LinkBase = function (_React$Component) {
	  _inherits(LinkBase, _React$Component);
	
	  function LinkBase() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LinkBase);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkBase.__proto__ || Object.getPrototypeOf(LinkBase)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (!_this.props.to && !_this.props.href || _this.props.href === '#') {
	        event.preventDefault();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LinkBase, [{
	    key: 'render',
	    value: function render() {
	      var link = void 0;
	      var _props = this.props,
	          to = _props.to,
	          className = _props.className,
	          href = _props.href,
	          target = _props.target,
	          children = _props.children,
	          rel = _props.rel,
	          onClick = _props.onClick,
	          onDragEnd = _props.onDragEnd,
	          activeClassName = _props.activeClassName,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseMove = _props.onMouseMove,
	          onlyActiveOnIndex = _props.onlyActiveOnIndex,
	          download = _props.download,
	          disabled = _props.disabled;
	
	
	      if (to) {
	        link = _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            target: target,
	            disabled: disabled,
	            activeClassName: activeClassName,
	            onlyActiveOnIndex: onlyActiveOnIndex,
	            'data-test-selector': this.props['data-test-selector'],
	            to: to,
	            className: className,
	            onMouseEnter: onMouseEnter,
	            onMouseLeave: onMouseLeave,
	            onMouseMove: onMouseMove,
	            onDragEnd: onDragEnd,
	            onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick) },
	          children
	        );
	      } else {
	        link = _react2.default.createElement(
	          'a',
	          {
	            'data-test-selector': this.props['data-test-selector'],
	            className: className,
	            href: typeof href === 'undefined' ? '#' : href,
	            target: target,
	            disabled: disabled,
	            download: download,
	            rel: rel,
	            onMouseEnter: onMouseEnter,
	            onMouseLeave: onMouseLeave,
	            onMouseMove: onMouseMove,
	            onDragEnd: onDragEnd,
	            onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick) },
	          children
	        );
	      }
	
	      return link;
	    }
	  }]);
	
	  return LinkBase;
	}(_react2.default.Component);
	
	LinkBase.displayName = 'LinkBase';
	exports.default = LinkBase;

/***/ },
/* 1183 */
1136,
/* 1184 */,
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = matchStrings;
	
	var _escapeStringRegexp = __webpack_require__(1186);
	
	var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generate a RegEx that matches any of the strings in the argument array.
	 * @param  {String[]} stringList strings to match
	 * @return {RegExp}
	 */
	function matchStrings(stringList) {
	  return stringList.map(function (x) {
	    return (0, _escapeStringRegexp2.default)(x);
	  }).join('|');
	} /*  weak */

/***/ },
/* 1186 */
/***/ function(module, exports) {

	'use strict';
	
	var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
	
	module.exports = function (str) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		return str.replace(matchOperatorsRe, '\\$&');
	};


/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _modal = __webpack_require__(1188);
	
	var _ModalTrigger = __webpack_require__(1219);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ModalTrigger = function (_React$Component) {
	  _inherits(ModalTrigger, _React$Component);
	
	  function ModalTrigger() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ModalTrigger);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
	      event.preventDefault();
	
	      (0, _modal.mountModal)(_this.props.modal, _this);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ModalTrigger, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          others = _objectWithoutProperties(_props, ['children', 'className']);
	
	      var child = _react2.default.Children.only(children);
	
	      var childProps = Object.assign(_lodash2.default.omit(others, ['modal']), {
	        className: (0, _classnames2.default)(_ModalTrigger2.default.this, child.props.className, className),
	        onClick: (0, _createChainedFunction2.default)(this.handleClick, child.props.onClick)
	      });
	
	      return _react2.default.cloneElement(child, childProps);
	    }
	  }]);
	
	  return ModalTrigger;
	}(_react2.default.Component);
	
	ModalTrigger.displayName = 'ModalTrigger';
	exports.default = ModalTrigger;

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mountModal = mountModal;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ModalPrefetcher = __webpack_require__(1189);
	
	var _ModalPrefetcher2 = _interopRequireDefault(_ModalPrefetcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Note: This is used to ensure that modals are removed and displayed in the correct order. This is
	 * done at the end of event loops to prevent events (like clicks) from being triggered on elements
	 * that were already removed from the DOM.
	 */
	var _queue = []; // eslint-disable-line camelcase
	
	// typecheck: ignore file
	
	function queue(fn) {
	  _queue.push(fn);
	  if (_queue.length === 1) {
	    setTimeout(function () {
	      _queue.forEach(function (f) {
	        return f();
	      });
	      _queue.length = 0;
	    }, 0);
	  }
	}
	
	/**
	 * Mount a modal in the DOM.
	 *
	 * @param {React component} modal
	 * @param {React component} parent, the modal will inherit its context
	 * @return Function to unmount this modal
	 */
	function mountModal(modal, parent) {
	  var container = document.createElement('div');
	  document.body.appendChild(container);
	
	  var unmountNode = function unmountNode() {
	    return queue(function () {
	      return _reactDom2.default.unmountComponentAtNode(container);
	    });
	  };
	
	  (0, _reactDom.unstable_renderSubtreeIntoContainer)(parent, _react2.default.createElement(_ModalPrefetcher2.default, { onRequestHide: unmountNode, modal: modal }), container);
	
	  return unmountNode;
	}

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AlertDialog = __webpack_require__(1190);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _LoadingModal = __webpack_require__(1216);
	
	var _LoadingModal2 = _interopRequireDefault(_LoadingModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	/**
	 * Default error modal, when a modal without a defined
	 * error modal handler (prefetchErrorModal) returned an
	 * uncaught error during the prefetch promises resolution.
	 *
	 * @param {Error} a promise error
	 * @return {AlertDialog}
	 */
	var DefaultErrorDialog = function (_Component) {
	  _inherits(DefaultErrorDialog, _Component);
	
	  function DefaultErrorDialog() {
	    _classCallCheck(this, DefaultErrorDialog);
	
	    return _possibleConstructorReturn(this, (DefaultErrorDialog.__proto__ || Object.getPrototypeOf(DefaultErrorDialog)).apply(this, arguments));
	  }
	
	  _createClass(DefaultErrorDialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_AlertDialog2.default, {
	        onRequestHide: this.props.onRequestHide,
	        title: 'Oops, an error has occurred!',
	        subtext: this.props.error && this.props.error.error ? this.props.error.error : '',
	        buttonText: 'Close'
	      });
	    }
	  }]);
	
	  return DefaultErrorDialog;
	}(_react.Component);
	
	DefaultErrorDialog.displayName = 'DefaultErrorDialog';
	
	/**
	 * Modal display that prefetch data (via prefetch static prop), a loading indicator will
	 * be mounted will the promises are being resolved. If an uncaught error
	 * occurs during the promises modal.prefetchErrorModal will be mounted
	 *
	 * class SomeCoolModal extends Component {
	 *   static prefetch = [
	 *     (props) => props.fetchSomeCoolData(),
	 *     (props) => props.fetchSomeFutherCoolData(),
	 *   ]
	 *
	 *   static prefetchErrorModal = (err) => <AlertDialog title="Cannot get data" subtext={err} />
	 * }
	 *
	 */
	var ModalPrefetcher = function (_Component2) {
	  _inherits(ModalPrefetcher, _Component2);
	
	  function ModalPrefetcher() {
	    var _ref;
	
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, ModalPrefetcher);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = ModalPrefetcher.__proto__ || Object.getPrototypeOf(ModalPrefetcher)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
	      prefetched: false
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  _createClass(ModalPrefetcher, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      if (this.getPrefetchFns().length > 0) {
	        var promises = this.getPrefetchFns().map(function (prefetchFn) {
	          return prefetchFn(_this3.props.modal.props);
	        });
	
	        Promise.all(promises).then(function () {
	          return _this3.setState({ prefetched: true });
	        }, function (err) {
	          return _this3.setState({ prefetchError: err || { error: '' } });
	        });
	      }
	    }
	  }, {
	    key: 'getPrefetchFns',
	    value: function getPrefetchFns() {
	      return this.props.modal.type.prefetch || [];
	    }
	  }, {
	    key: 'getErrorDialog',
	    value: function getErrorDialog(error) {
	      return this.props.modal.type.prefetchErrorModal && this.props.modal.type.prefetchErrorModal(error);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.prefetchError != null) {
	        var errorView = this.getErrorDialog(this.state.prefetchError);
	
	        if (errorView) {
	          return (0, _react.cloneElement)(errorView, {
	            onRequestHide: (0, _createChainedFunction2.default)(errorView.props.onRequestHide, this.props.onRequestHide)
	          });
	        }
	
	        return _react2.default.createElement(DefaultErrorDialog, {
	          error: this.state.prefetchError,
	          onRequestHide: this.props.onRequestHide
	        });
	      }
	
	      if (this.getPrefetchFns().length > 0 && !this.state.prefetched) {
	        return _react2.default.createElement(_LoadingModal2.default, null);
	      }
	
	      return (0, _react.cloneElement)(this.props.modal, {
	        onRequestHide: (0, _createChainedFunction2.default)(this.props.modal.props.onRequestHide, this.props.onRequestHide)
	      });
	    }
	  }]);
	
	  return ModalPrefetcher;
	}(_react.Component);
	
	ModalPrefetcher.displayName = 'ModalPrefetcher';
	exports.default = ModalPrefetcher;

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _focusNode = __webpack_require__(1210);
	
	var _focusNode2 = _interopRequireDefault(_focusNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A simple dialog for displaying a message with a single button.
	 *
	 * # Use with [ModalTrigger](/components/ModalTrigger)
	 *
	 * ```example
	 * <ModalTrigger
	 *   modal={
	 *     <AlertDialog>
	 *       <div>
	 *         Hello World!
	 *       </div>
	 *     </AlertDialog>
	 *   }>
	 *   <Button>Show dialog</Button>
	 * </ModalTrigger>
	 * ```
	 */
	
	var AlertDialog = function (_React$Component) {
	  _inherits(AlertDialog, _React$Component);
	
	  function AlertDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AlertDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlertDialog.__proto__ || Object.getPrototypeOf(AlertDialog)).call.apply(_ref, [this].concat(args))), _this), _this.handleButtonClick = function () {
	      _this.requestHide();
	      if (_this.props.onOkay) {
	        _this.props.onOkay();
	      }
	    }, _this.requestHide = function () {
	      _this.props.onRequestHide();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AlertDialog, [{
	    key: 'render',
	    value: function render() {
	      var closeLinkText = this.props.closeLinkText;
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({}, this.props, {
	          className: (0, _classnames2.default)('AlertDialog', this.props.className),
	          size: this.props.size }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          this.props.children,
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'AlertDialog-okButton',
	              onClick: this.handleButtonClick,
	              ref: function ref(component) {
	                return (0, _focusNode2.default)(_reactDom2.default.findDOMNode(component));
	              },
	              eventElementName: 'AlertDialog-okButton' },
	            this.props.buttonText
	          ),
	          closeLinkText && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                level: 'text',
	                onClick: this.requestHide },
	              closeLinkText
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AlertDialog;
	}(_react2.default.Component);
	
	AlertDialog.defaultProps = {
	  buttonText: 'OK',
	  size: 'xsmall'
	};
	AlertDialog.displayName = 'AlertDialog';
	exports.default = AlertDialog;

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getPropClasses = __webpack_require__(1135);
	
	__webpack_require__(1192);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxBody = function (_React$Component) {
	  _inherits(BoxBody, _React$Component);
	
	  function BoxBody() {
	    _classCallCheck(this, BoxBody);
	
	    return _possibleConstructorReturn(this, (BoxBody.__proto__ || Object.getPrototypeOf(BoxBody)).apply(this, arguments));
	  }
	
	  _createClass(BoxBody, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('BoxBody', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className) },
	        this.props.children
	      );
	    }
	  }]);
	
	  return BoxBody;
	}(_react2.default.Component);
	
	BoxBody.propClasses = {
	  divided: 'BoxBody-divided',
	  size: {
	    small: 'BoxBody-small'
	  },
	  full: 'BoxBody-full'
	};
	BoxBody.defaultProps = {
	  divided: false,
	  size: 'medium',
	  full: false
	};
	BoxBody.displayName = 'BoxBody';
	exports.default = BoxBody;

/***/ },
/* 1192 */
1136,
/* 1193 */,
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ClickEventTrigger = __webpack_require__(1181);
	
	var _ClickEventTrigger2 = _interopRequireDefault(_ClickEventTrigger);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _getPropClasses2 = _interopRequireDefault(_getPropClasses);
	
	var _LinkBase = __webpack_require__(1182);
	
	var _LinkBase2 = _interopRequireDefault(_LinkBase);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _tooltipable = __webpack_require__(1156);
	
	var _tooltipable2 = _interopRequireDefault(_tooltipable);
	
	__webpack_require__(1198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propsToClasses = {
	  level: {
	    primary: 'Button--primary',
	    secondary: 'Button--secondary',
	    text: 'Button--text',
	    icon: 'Button--icon'
	  },
	  color: {
	    lava: 'Button--lava',
	    sunrise: 'Button--sunrise',
	    shamrock: 'Button--shamrock',
	    jungle: 'Button--jungle',
	    brand: 'Button--brand',
	    violet: 'Button--violet',
	    pitch: 'Button--pitch',
	    thunder: 'Button--thunder',
	    eclipse: 'Button--eclipse',
	    koala: 'Button--koala',
	    white: 'Button--white'
	  },
	  shape: {
	    circle: 'Button--circle'
	  },
	  size: {
	    small: 'Button--small',
	    xsmall: 'Button--xsmall',
	    xxsmall: 'Button--xxsmall'
	  },
	  weight: {
	    normal: 'Button--normal',
	    semibold: 'Button--semibold'
	  },
	  full: 'Button--full'
	};
	
	/*
	 * Basic Button components - used everywhere in our product.
	 */
	var Button = _react2.default.createClass({
	  displayName: 'Button',
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: false,
	      inline: false,
	      level: 'primary',
	      loading: false,
	      size: 'small'
	    };
	  },
	  isDisabled: function isDisabled() {
	    return this.props.disabled || this.props.loading;
	  },
	  renderChildren: function renderChildren() {
	    var lightBackground = this.props.color === 'white' || this.props.level === 'secondary';
	
	    if (this.props.loading) {
	      var color = lightBackground ? 'eclipse' : 'white';
	      return _react2.default.createElement(_LoadingIndicator2.default, { size: this.props.size, color: color });
	    } else {
	      return this.props.children;
	    }
	  },
	  render: function render() {
	    var hasTarget = this.props.to || this.props.href;
	    var Component = hasTarget ? _LinkBase2.default : 'button';
	    return _react2.default.createElement(
	      _ClickEventTrigger2.default,
	      { eventElementName: this.props.eventElementName },
	      _react2.default.createElement(
	        Component,
	        {
	          id: this.props.id,
	          type: this.props.type,
	          target: this.props.target,
	          href: this.props.href,
	          to: this.props.to,
	          download: this.props.download,
	          onMouseEnter: this.props.onMouseEnter,
	          onMouseLeave: this.props.onMouseLeave,
	          onMouseMove: this.props.onMouseMove,
	          'data-test-selector': this.props['data-test-selector'],
	          'data-test': this.props['data-test'],
	          onClick: this.props.onClick,
	          disabled: this.isDisabled(),
	          className: (0, _classnames2.default)('Button', this.props.className, {
	            'Button--inline': this.props.inline,
	            'Button--disabled': this.isDisabled()
	          }, (0, _getPropClasses2.default)(this.props, propsToClasses)) },
	        this.renderChildren()
	      )
	    );
	  }
	});
	
	exports.default = (0, _tooltipable2.default)(Button);

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingIndicator = function (_React$Component) {
	  _inherits(LoadingIndicator, _React$Component);
	
	  function LoadingIndicator() {
	    _classCallCheck(this, LoadingIndicator);
	
	    return _possibleConstructorReturn(this, (LoadingIndicator.__proto__ || Object.getPrototypeOf(LoadingIndicator)).apply(this, arguments));
	  }
	
	  _createClass(LoadingIndicator, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        _extends({}, this.props, {
	          height: this.props.height,
	          className: (0, _classnames2.default)('LoadingIndicator', { 'LoadingIndicator--height': this.props.height }, (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className) }),
	        _react2.default.createElement('div', { className: 'LoadingIndicator-bounce1' }),
	        _react2.default.createElement('div', { className: 'LoadingIndicator-bounce2' }),
	        _react2.default.createElement('div', { className: 'LoadingIndicator-bounce3' })
	      );
	    }
	  }]);
	
	  return LoadingIndicator;
	}(_react2.default.Component);
	
	LoadingIndicator.propClasses = {
	  align: {
	    left: 'LoadingIndicator--left',
	    center: 'LoadingIndicator--center',
	    right: 'LoadingIndicator--right'
	  },
	  size: {
	    xsmall: 'LoadingIndicator-sizexSmall',
	    small: 'LoadingIndicator-sizeSmall',
	    medium: 'LoadingIndicator-sizeMedium',
	    large: 'LoadingIndicator-sizeLarge'
	  },
	  color: {
	    eclipse: 'LoadingIndicator-eclipse',
	    white: 'LoadingIndicator-white',
	    lava: 'LoadingIndicator-lava',
	    rain: 'LoadingIndicator-rain'
	  },
	  height: {
	    /* eslint-disable quote-props */
	    '400': 'LoadingIndicator--height400'
	  }
	};
	LoadingIndicator.defaultProps = {
	  size: 'medium',
	  color: 'eclipse'
	};
	LoadingIndicator.displayName = 'LoadingIndicator';
	exports.default = LoadingIndicator;

/***/ },
/* 1196 */
1136,
/* 1197 */,
/* 1198 */
1136,
/* 1199 */,
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _Modal = __webpack_require__(1207);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1214);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Standard modal dialogs
	 *
	 * Use [ModalTrigger](/components/ModalTrigger) to display the dialog.
	 *
	 * ```example
	 *  <ModalTrigger
	 *    modal={
	 *      <Dialog
	 *        title="Hello World!"
	 *        subtext="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
	 *        glyph="pencil"
	 *        glyphColor="lava"
	 *        size="xsmall">
	 *        This is the content inside of the dialog.
	 *      </Dialog>
	 *    }>
	 *    <Button>Show dialog</Button>
	 *  </ModalTrigger>
	 * ```
	 */
	
	var Dialog = function (_React$Component) {
	  _inherits(Dialog, _React$Component);
	
	  function Dialog() {
	    _classCallCheck(this, Dialog);
	
	    return _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).apply(this, arguments));
	  }
	
	  _createClass(Dialog, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['className']);
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        _extends({}, props, { className: (0, _classnames2.default)('Dialog', className), title: null }),
	        _react2.default.createElement(_DialogContent2.default, props)
	      );
	    }
	  }]);
	
	  return Dialog;
	}(_react2.default.Component);
	
	Dialog.defaultProps = {
	  hideCloseButton: false,
	  hideOnBlur: true
	};
	Dialog.displayName = 'Dialog';
	exports.default = Dialog;

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Box = __webpack_require__(1202);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ClickEventTrigger = __webpack_require__(1181);
	
	var _ClickEventTrigger2 = _interopRequireDefault(_ClickEventTrigger);
	
	__webpack_require__(1205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogContent = function (_React$Component) {
	  _inherits(DialogContent, _React$Component);
	
	  function DialogContent() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DialogContent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DialogContent.__proto__ || Object.getPrototypeOf(DialogContent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      paddingTop: null
	    }, _this.closeDialog = function (event) {
	      var box = _reactDom2.default.findDOMNode(_this.refs.box);
	      // in IE only, box is somehow sometimes null
	      // https://my.trackjs.com/messages/filtered?hash=c677c309de472679
	      if (box && box.contains(event.target)) {
	        return;
	      }
	
	      event.stopPropagation();
	      if (_this.props.onRequestHide) {
	        _this.props.onRequestHide();
	      }
	    }, _this.handleClick = function (event) {
	      var box = _reactDom2.default.findDOMNode(_this.refs.box);
	      if (!_this.props.hideOnBlur || box.contains(event.target)) {
	        return;
	      }
	
	      if (_this.props.onMaskHide) {
	        _this.props.onMaskHide();
	      } else if (_this.props.onRequestHide) {
	        _this.props.onRequestHide();
	      }
	    }, _this.resetPosition = function () {
	      var root = _reactDom2.default.findDOMNode(_this);
	      var container = _reactDom2.default.findDOMNode(_this.refs.container);
	      var paddingTop = 0;
	
	      if (_this.props.position === 'center') {
	        paddingTop = (root.offsetHeight - container.offsetHeight) / 2;
	      }
	
	      _this.setState({ paddingTop: paddingTop });
	    }, _this.renderCloseButton = function () {
	      if (_this.props.hideCloseButton) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Link2.default,
	        {
	          className: 'DialogContent-closeButton',
	          onClick: _this.closeDialog,
	          eventElementName: 'DialogContent-closeButton' },
	        _react2.default.createElement(_Glyph2.default, { name: 'close', size: 'large', solo: true })
	      );
	    }, _this.renderGlyph = function () {
	      var glyph = _this.props.glyph;
	
	      if (!glyph) {
	        return null;
	      }
	
	      return _react2.default.createElement(_Glyph2.default, {
	        className: 'DialogContent-glyph',
	        name: glyph,
	        color: _this.props.glyphColor,
	        size: 'xxxlarge'
	      });
	    }, _this.renderHeader = function () {
	      var previousButton = _this.renderPreviousButton();
	      var glyph = _this.renderGlyph();
	      var image = _this.renderImage();
	      var title = _this.renderTitle();
	      var subtext = _this.renderSubtext();
	
	      if (!(previousButton || glyph || image || title || subtext)) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'header',
	        { className: 'DialogContent-header' },
	        previousButton,
	        glyph,
	        image,
	        title,
	        subtext
	      );
	    }, _this.renderImage = function () {
	      var _this$props = _this.props,
	          image = _this$props.image,
	          headerImageComponent = _this$props.headerImageComponent;
	
	      if (image) {
	        var className = 'DialogContent-image-' + _this.props.imageSize;
	        return _react2.default.createElement(_Image2.default, { className: className, src: image });
	      } else if (headerImageComponent) {
	        return headerImageComponent;
	      } else {
	        return null;
	      }
	    }, _this.renderPreviousButton = function () {
	      if (_this.props.hidePreviousButton) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Link2.default,
	        {
	          className: 'DialogContent-previousButton',
	          onClick: _this.props.onRequestPrevious,
	          eventElementName: 'DialogContent-previousButton' },
	        _react2.default.createElement(_Glyph2.default, { name: 'arrow-left', color: 'brand', size: 'xlarge', solo: true })
	      );
	    }, _this.renderSubtext = function () {
	      var subtext = _this.props.subtext;
	
	      if (!subtext) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'DialogContent-subtext' },
	        subtext
	      );
	    }, _this.renderTitle = function () {
	      var title = _this.props.title;
	
	      if (!title) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'h2',
	        { className: 'DialogContent-title' },
	        title
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DialogContent, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.addEventListener('resize', this.resetPosition, false);
	      // FIXME: This is to allow ScrollableArea to set a height before we try to center the dialog
	      this.timeout = setTimeout(function () {
	        return _this2.resetPosition();
	      }, 0);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.resetPosition, false);
	      window.clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('DialogContent', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className),
	          style: this.state.paddingTop ? {} : { opacity: 0.01 } },
	        _react2.default.createElement(
	          _ClickEventTrigger2.default,
	          { eventElementName: 'DialogContent-closeButton' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'DialogContent-wrap',
	              onClick: this.handleClick,
	              style: {
	                paddingTop: this.state.paddingTop
	              } },
	            _react2.default.createElement(
	              'div',
	              { ref: 'container', className: 'DialogContent-container' },
	              _react2.default.createElement(
	                _Box2.default,
	                { ref: 'box', className: 'DialogContent-box' },
	                this.renderHeader(),
	                this.props.children
	              ),
	              this.renderCloseButton()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DialogContent;
	}(_react2.default.Component);
	
	DialogContent.propClasses = {
	  size: {
	    xlarge: 'DialogContent-xlarge',
	    large: 'DialogContent-large',
	    medium: 'DialogContent-medium',
	    small: 'DialogContent-small',
	    xsmall: 'DialogContent-xsmall'
	  },
	  position: {
	    center: 'DialogContent-center',
	    right: 'DialogContent-right'
	  },
	  headerTextAlign: {
	    center: 'DialogContent-headerTextCenter',
	    left: 'DialogContent-headerTextLeft',
	    right: 'DialogContent-headerTextRight'
	  },
	  allowOverflow: 'DialogContent-overflow'
	};
	DialogContent.defaultProps = {
	  allowOverflow: false,
	  glyphColor: 'inherit',
	  imageSize: 'default',
	  size: 'medium',
	  position: 'center',
	  hideCloseButton: true,
	  hideOnBlur: false,
	  hidePreviousButton: true,
	  onRequestPrevious: function onRequestPrevious() {},
	  onMaskHide: null,
	  headerTextAlign: 'center'
	};
	DialogContent.displayName = 'DialogContent';
	exports.default = DialogContent;

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	  * This is a component that creates a Box with rounded corners.
	  * This is used with BoxHeader, BoxBody and BoxTitle and can also be used
	  * with other layouting components like Columns and Columns2.
	  */
	var Box = function (_React$Component) {
	  _inherits(Box, _React$Component);
	
	  function Box() {
	    _classCallCheck(this, Box);
	
	    return _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).apply(this, arguments));
	  }
	
	  _createClass(Box, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('Box', this.props.className) },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Box;
	}(_react2.default.Component);
	
	Box.displayName = 'Box';
	exports.default = Box;

/***/ },
/* 1203 */
1136,
/* 1204 */,
/* 1205 */
1136,
/* 1206 */,
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _EmitterMixin = __webpack_require__(1208);
	
	var _EmitterMixin2 = _interopRequireDefault(_EmitterMixin);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	var _LayerAutoFocus = __webpack_require__(1209);
	
	var _LayerAutoFocus2 = _interopRequireDefault(_LayerAutoFocus);
	
	var _LayerHideOnEscape = __webpack_require__(1163);
	
	var _LayerHideOnEscape2 = _interopRequireDefault(_LayerHideOnEscape);
	
	var _LayerHideOnTransition = __webpack_require__(1165);
	
	var _LayerHideOnTransition2 = _interopRequireDefault(_LayerHideOnTransition);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollContext = __webpack_require__(1105);
	
	var _ScrollContext2 = _interopRequireDefault(_ScrollContext);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stack = [];
	
	/**
	 * Class that encapsulates Modal behaviour.
	 * Do NOT use this class to create your own Modal, instead,
	 * use Dialog.jsx, which leverages Modal.jsx
	 */
	
	var Modal = _react2.default.createClass({
	  displayName: 'Modal',
	
	
	  contextTypes: {
	    eventProperties: _react2.default.PropTypes.object
	  },
	
	  mixins: [_LayerAutoFocus2.default, _LayerHideOnEscape2.default, _LayerHideOnTransition2.default, _EmitterMixin2.default],
	
	  statics: {
	    getCurrent: function getCurrent() {
	      return stack[stack.length - 1];
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      theme: 'default',
	      hideOnBlur: true
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    stack.push(this);
	    this.emit('show');
	
	    var _props = this.props,
	        eventScreenName = _props.eventScreenName,
	        eventProperties = _props.eventProperties;
	
	    if (eventScreenName) {
	      var computedEventProperties = (0, _EventTracking.getEventProperties)(eventProperties, this.context);
	      _EventTracking2.default.view(eventScreenName, computedEventProperties);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var index = stack.indexOf(this);
	    if (index >= 0) {
	      stack.splice(index, 1);
	    }
	    this.emit('hide');
	  },
	
	
	  // typecheck: ignore statement
	  handleClick: function handleClick(event) {
	    if (!this.props.hideOnBlur) {
	      return;
	    }
	
	    // $FlowFixMe
	    if (event.target === event.currentElement) {
	      if (this.props.onRequestHide) {
	        this.props.onRequestHide();
	      }
	    }
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _ScrollContext2.default,
	      _extends({}, this.props, {
	        className: (0, _classnames2.default)({
	          Modal: true,
	          'Modal-dark': this.props.theme === 'dark'
	        }, this.props.className),
	        onClick: (0, _createChainedFunction2.default)(this.props.onClick, this.handleClick),
	        tabIndex: 0 }),
	      this.props.children
	    );
	  }
	});
	
	exports.default = Modal;

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _events = __webpack_require__(1036);
	
	var EmitterMixin = {
	  _emitter: null,
	
	  statics: {
	    staticEmitter: new _events.EventEmitter(),
	    on: function on(event, listener) {
	      this.staticEmitter.addListener(event, listener);
	    },
	    removeListener: function removeListener(event, listener) {
	      this.staticEmitter.removeListener(event, listener);
	    }
	  },
	
	  emit: function emit() {
	    if (this._emitter) {
	      this._emitter.emit.apply(this._emitter, arguments);
	    }
	    var oldArguments = Array.from(arguments);
	    oldArguments.splice(1, 0, this);
	    var staticEmitter = this.constructor.staticEmitter;
	
	    staticEmitter.emit.apply(staticEmitter, oldArguments);
	  },
	  on: function on(event, listener) {
	    this.addListener(event, listener);
	  },
	  addListener: function addListener(event, listener) {
	    if (!this._emitter) {
	      this._emitter = new _events.EventEmitter();
	    }
	    this._emitter.addListener(event, listener);
	  },
	  removeListener: function removeListener(event, listener) {
	    if (this._emitter) {
	      this._emitter.removeListener(event, listener);
	    }
	  }
	};
	
	exports.default = EmitterMixin;

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _DOM = __webpack_require__(1109);
	
	var _DOM2 = _interopRequireDefault(_DOM);
	
	var _KeyState = __webpack_require__(1173);
	
	var _KeyState2 = _interopRequireDefault(_KeyState);
	
	var _focusNode = __webpack_require__(1210);
	
	var _focusNode2 = _interopRequireDefault(_focusNode);
	
	var _getActiveElement = __webpack_require__(1211);
	
	var _getActiveElement2 = _interopRequireDefault(_getActiveElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LayerAutoFocus = {
	  _activeElement: null,
	
	  componentWillMount: function componentWillMount() {
	    this._activeElement = (0, _getActiveElement2.default)();
	  },
	  componentDidMount: function componentDidMount() {
	    // TODO: getTabbableElements() and focus the first tabbable element, so that things like
	    // forms or buttons are automatically focused when opening dialogs
	
	    // It's possible for the active element to change because of a `focusNode` call within the
	    // rendered subtree. Check to see if the activeElement is within the modal.
	    var node = _reactDom2.default.findDOMNode(this);
	    var activeElement = (0, _getActiveElement2.default)();
	    if (!node.contains(activeElement)) {
	      if (_DOM2.default.getOffset(node).top < 0) {
	        return;
	      }
	
	      (0, _focusNode2.default)(node);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (_KeyState2.default.isKeyDown()) {
	      (0, _focusNode2.default)(this._activeElement);
	    }
	  }
	}; /*  weak */
	exports.default = LayerAutoFocus;

/***/ },
/* 1210 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = focusNode;
	/*  weak */
	function focusNode(node) {
	  // IE throws an error when trying to focus a node for various reasons.
	  // It's easier to just try/catch it and not deal with it ourselves.
	  try {
	    node.focus();
	  } catch (e) {
	    // Do nothing.
	  }
	}

/***/ },
/* 1211 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getActiveElement;
	/*  weak */
	function getActiveElement() {
	  // IE may throw an error if activeElement is document.body.
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}

/***/ },
/* 1212 */
1136,
/* 1213 */,
/* 1214 */
1136,
/* 1215 */,
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _Modal = __webpack_require__(1207);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LoadingModal = __webpack_require__(1217);
	
	var _LoadingModal2 = _interopRequireDefault(_LoadingModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /*  weak */
	
	
	var LoadingModal = function LoadingModal(_ref) {
	  var props = _objectWithoutProperties(_ref, []);
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    _extends({}, props, { className: (0, _classnames2.default)(_LoadingModal2.default.this, props.className) }),
	    _react2.default.createElement(_LoadingIndicator2.default, { className: _LoadingModal2.default.loadingIndicator })
	  );
	};
	
	exports.default = LoadingModal;

/***/ },
/* 1217 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"this":"LoadingModal__this___1lMyq","loadingIndicator":"LoadingModal__loadingIndicator___269xG"};

/***/ },
/* 1218 */,
/* 1219 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"this":"ModalTrigger__this___29l_C"};

/***/ },
/* 1220 */,
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	////////////////////////////////////////////////////////////////////////////////
	// Helpers
	
	// Merge objects
	//
	function assign(obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	
	  sources.forEach(function (source) {
	    if (!source) { return; }
	
	    Object.keys(source).forEach(function (key) {
	      obj[key] = source[key];
	    });
	  });
	
	  return obj;
	}
	
	function _class(obj) { return Object.prototype.toString.call(obj); }
	function isString(obj) { return _class(obj) === '[object String]'; }
	function isObject(obj) { return _class(obj) === '[object Object]'; }
	function isRegExp(obj) { return _class(obj) === '[object RegExp]'; }
	function isFunction(obj) { return _class(obj) === '[object Function]'; }
	
	
	function escapeRE(str) { return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&'); }
	
	////////////////////////////////////////////////////////////////////////////////
	
	
	var defaultOptions = {
	  fuzzyLink: true,
	  fuzzyEmail: true,
	  fuzzyIP: false
	};
	
	
	function isOptionsObj(obj) {
	  return Object.keys(obj || {}).reduce(function (acc, k) {
	    return acc || defaultOptions.hasOwnProperty(k);
	  }, false);
	}
	
	
	var defaultSchemas = {
	  'http:': {
	    validate: function (text, pos, self) {
	      var tail = text.slice(pos);
	
	      if (!self.re.http) {
	        // compile lazily, because "host"-containing variables can change on tlds update.
	        self.re.http =  new RegExp(
	          '^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i'
	        );
	      }
	      if (self.re.http.test(tail)) {
	        return tail.match(self.re.http)[0].length;
	      }
	      return 0;
	    }
	  },
	  'https:':  'http:',
	  'ftp:':    'http:',
	  '//':      {
	    validate: function (text, pos, self) {
	      var tail = text.slice(pos);
	
	      if (!self.re.no_http) {
	      // compile lazily, because "host"-containing variables can change on tlds update.
	        self.re.no_http =  new RegExp(
	          '^' +
	          self.re.src_auth +
	          // Don't allow single-level domains, because of false positives like '//test'
	          // with code comments
	          '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' +
	          self.re.src_port +
	          self.re.src_host_terminator +
	          self.re.src_path,
	
	          'i'
	        );
	      }
	
	      if (self.re.no_http.test(tail)) {
	        // should not be `://` & `///`, that protects from errors in protocol name
	        if (pos >= 3 && text[pos - 3] === ':') { return 0; }
	        if (pos >= 3 && text[pos - 3] === '/') { return 0; }
	        return tail.match(self.re.no_http)[0].length;
	      }
	      return 0;
	    }
	  },
	  'mailto:': {
	    validate: function (text, pos, self) {
	      var tail = text.slice(pos);
	
	      if (!self.re.mailto) {
	        self.re.mailto =  new RegExp(
	          '^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i'
	        );
	      }
	      if (self.re.mailto.test(tail)) {
	        return tail.match(self.re.mailto)[0].length;
	      }
	      return 0;
	    }
	  }
	};
	
	/*eslint-disable max-len*/
	
	// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
	var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
	
	// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
	var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');
	
	/*eslint-enable max-len*/
	
	////////////////////////////////////////////////////////////////////////////////
	
	function resetScanCache(self) {
	  self.__index__ = -1;
	  self.__text_cache__   = '';
	}
	
	function createValidator(re) {
	  return function (text, pos) {
	    var tail = text.slice(pos);
	
	    if (re.test(tail)) {
	      return tail.match(re)[0].length;
	    }
	    return 0;
	  };
	}
	
	function createNormalizer() {
	  return function (match, self) {
	    self.normalize(match);
	  };
	}
	
	// Schemas compiler. Build regexps.
	//
	function compile(self) {
	
	  // Load & clone RE patterns.
	  var re = self.re = __webpack_require__(1222)(self.__opts__);
	
	  // Define dynamic patterns
	  var tlds = self.__tlds__.slice();
	
	  self.onCompile();
	
	  if (!self.__tlds_replaced__) {
	    tlds.push(tlds_2ch_src_re);
	  }
	  tlds.push(re.src_xn);
	
	  re.src_tlds = tlds.join('|');
	
	  function untpl(tpl) { return tpl.replace('%TLDS%', re.src_tlds); }
	
	  re.email_fuzzy      = RegExp(untpl(re.tpl_email_fuzzy), 'i');
	  re.link_fuzzy       = RegExp(untpl(re.tpl_link_fuzzy), 'i');
	  re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
	  re.host_fuzzy_test  = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
	
	  //
	  // Compile each schema
	  //
	
	  var aliases = [];
	
	  self.__compiled__ = {}; // Reset compiled data
	
	  function schemaError(name, val) {
	    throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
	  }
	
	  Object.keys(self.__schemas__).forEach(function (name) {
	    var val = self.__schemas__[name];
	
	    // skip disabled methods
	    if (val === null) { return; }
	
	    var compiled = { validate: null, link: null };
	
	    self.__compiled__[name] = compiled;
	
	    if (isObject(val)) {
	      if (isRegExp(val.validate)) {
	        compiled.validate = createValidator(val.validate);
	      } else if (isFunction(val.validate)) {
	        compiled.validate = val.validate;
	      } else {
	        schemaError(name, val);
	      }
	
	      if (isFunction(val.normalize)) {
	        compiled.normalize = val.normalize;
	      } else if (!val.normalize) {
	        compiled.normalize = createNormalizer();
	      } else {
	        schemaError(name, val);
	      }
	
	      return;
	    }
	
	    if (isString(val)) {
	      aliases.push(name);
	      return;
	    }
	
	    schemaError(name, val);
	  });
	
	  //
	  // Compile postponed aliases
	  //
	
	  aliases.forEach(function (alias) {
	    if (!self.__compiled__[self.__schemas__[alias]]) {
	      // Silently fail on missed schemas to avoid errons on disable.
	      // schemaError(alias, self.__schemas__[alias]);
	      return;
	    }
	
	    self.__compiled__[alias].validate =
	      self.__compiled__[self.__schemas__[alias]].validate;
	    self.__compiled__[alias].normalize =
	      self.__compiled__[self.__schemas__[alias]].normalize;
	  });
	
	  //
	  // Fake record for guessed links
	  //
	  self.__compiled__[''] = { validate: null, normalize: createNormalizer() };
	
	  //
	  // Build schema condition
	  //
	  var slist = Object.keys(self.__compiled__)
	                      .filter(function (name) {
	                        // Filter disabled & fake schemas
	                        return name.length > 0 && self.__compiled__[name];
	                      })
	                      .map(escapeRE)
	                      .join('|');
	  // (?!_) cause 1.5x slowdown
	  self.re.schema_test   = RegExp('(^|(?!_)(?:[><]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
	  self.re.schema_search = RegExp('(^|(?!_)(?:[><]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
	
	  self.re.pretest       = RegExp(
	                            '(' + self.re.schema_test.source + ')|' +
	                            '(' + self.re.host_fuzzy_test.source + ')|' +
	                            '@',
	                            'i');
	
	  //
	  // Cleanup
	  //
	
	  resetScanCache(self);
	}
	
	/**
	 * class Match
	 *
	 * Match result. Single element of array, returned by [[LinkifyIt#match]]
	 **/
	function Match(self, shift) {
	  var start = self.__index__,
	      end   = self.__last_index__,
	      text  = self.__text_cache__.slice(start, end);
	
	  /**
	   * Match#schema -> String
	   *
	   * Prefix (protocol) for matched string.
	   **/
	  this.schema    = self.__schema__.toLowerCase();
	  /**
	   * Match#index -> Number
	   *
	   * First position of matched string.
	   **/
	  this.index     = start + shift;
	  /**
	   * Match#lastIndex -> Number
	   *
	   * Next position after matched string.
	   **/
	  this.lastIndex = end + shift;
	  /**
	   * Match#raw -> String
	   *
	   * Matched string.
	   **/
	  this.raw       = text;
	  /**
	   * Match#text -> String
	   *
	   * Notmalized text of matched string.
	   **/
	  this.text      = text;
	  /**
	   * Match#url -> String
	   *
	   * Normalized url of matched string.
	   **/
	  this.url       = text;
	}
	
	function createMatch(self, shift) {
	  var match = new Match(self, shift);
	
	  self.__compiled__[match.schema].normalize(match, self);
	
	  return match;
	}
	
	
	/**
	 * class LinkifyIt
	 **/
	
	/**
	 * new LinkifyIt(schemas, options)
	 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
	 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
	 *
	 * Creates new linkifier instance with optional additional schemas.
	 * Can be called without `new` keyword for convenience.
	 *
	 * By default understands:
	 *
	 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
	 * - "fuzzy" links and emails (example.com, foo@bar.com).
	 *
	 * `schemas` is an object, where each key/value describes protocol/rule:
	 *
	 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
	 *   for example). `linkify-it` makes shure that prefix is not preceeded with
	 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
	 * - __value__ - rule to check tail after link prefix
	 *   - _String_ - just alias to existing rule
	 *   - _Object_
	 *     - _validate_ - validator function (should return matched length on success),
	 *       or `RegExp`.
	 *     - _normalize_ - optional function to normalize text & url of matched result
	 *       (for example, for @twitter mentions).
	 *
	 * `options`:
	 *
	 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
	 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
	 *   like version numbers. Default `false`.
	 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
	 *
	 **/
	function LinkifyIt(schemas, options) {
	  if (!(this instanceof LinkifyIt)) {
	    return new LinkifyIt(schemas, options);
	  }
	
	  if (!options) {
	    if (isOptionsObj(schemas)) {
	      options = schemas;
	      schemas = {};
	    }
	  }
	
	  this.__opts__           = assign({}, defaultOptions, options);
	
	  // Cache last tested result. Used to skip repeating steps on next `match` call.
	  this.__index__          = -1;
	  this.__last_index__     = -1; // Next scan position
	  this.__schema__         = '';
	  this.__text_cache__     = '';
	
	  this.__schemas__        = assign({}, defaultSchemas, schemas);
	  this.__compiled__       = {};
	
	  this.__tlds__           = tlds_default;
	  this.__tlds_replaced__  = false;
	
	  this.re = {};
	
	  compile(this);
	}
	
	
	/** chainable
	 * LinkifyIt#add(schema, definition)
	 * - schema (String): rule name (fixed pattern prefix)
	 * - definition (String|RegExp|Object): schema definition
	 *
	 * Add new rule definition. See constructor description for details.
	 **/
	LinkifyIt.prototype.add = function add(schema, definition) {
	  this.__schemas__[schema] = definition;
	  compile(this);
	  return this;
	};
	
	
	/** chainable
	 * LinkifyIt#set(options)
	 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
	 *
	 * Set recognition options for links without schema.
	 **/
	LinkifyIt.prototype.set = function set(options) {
	  this.__opts__ = assign(this.__opts__, options);
	  return this;
	};
	
	
	/**
	 * LinkifyIt#test(text) -> Boolean
	 *
	 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
	 **/
	LinkifyIt.prototype.test = function test(text) {
	  // Reset scan cache
	  this.__text_cache__ = text;
	  this.__index__      = -1;
	
	  if (!text.length) { return false; }
	
	  var m, ml, me, len, shift, next, re, tld_pos, at_pos;
	
	  // try to scan for link with schema - that's the most simple rule
	  if (this.re.schema_test.test(text)) {
	    re = this.re.schema_search;
	    re.lastIndex = 0;
	    while ((m = re.exec(text)) !== null) {
	      len = this.testSchemaAt(text, m[2], re.lastIndex);
	      if (len) {
	        this.__schema__     = m[2];
	        this.__index__      = m.index + m[1].length;
	        this.__last_index__ = m.index + m[0].length + len;
	        break;
	      }
	    }
	  }
	
	  if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
	    // guess schemaless links
	    tld_pos = text.search(this.re.host_fuzzy_test);
	    if (tld_pos >= 0) {
	      // if tld is located after found link - no need to check fuzzy pattern
	      if (this.__index__ < 0 || tld_pos < this.__index__) {
	        if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
	
	          shift = ml.index + ml[1].length;
	
	          if (this.__index__ < 0 || shift < this.__index__) {
	            this.__schema__     = '';
	            this.__index__      = shift;
	            this.__last_index__ = ml.index + ml[0].length;
	          }
	        }
	      }
	    }
	  }
	
	  if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
	    // guess schemaless emails
	    at_pos = text.indexOf('@');
	    if (at_pos >= 0) {
	      // We can't skip this check, because this cases are possible:
	      // 192.168.1.1@gmail.com, my.in@example.com
	      if ((me = text.match(this.re.email_fuzzy)) !== null) {
	
	        shift = me.index + me[1].length;
	        next  = me.index + me[0].length;
	
	        if (this.__index__ < 0 || shift < this.__index__ ||
	            (shift === this.__index__ && next > this.__last_index__)) {
	          this.__schema__     = 'mailto:';
	          this.__index__      = shift;
	          this.__last_index__ = next;
	        }
	      }
	    }
	  }
	
	  return this.__index__ >= 0;
	};
	
	
	/**
	 * LinkifyIt#pretest(text) -> Boolean
	 *
	 * Very quick check, that can give false positives. Returns true if link MAY BE
	 * can exists. Can be used for speed optimization, when you need to check that
	 * link NOT exists.
	 **/
	LinkifyIt.prototype.pretest = function pretest(text) {
	  return this.re.pretest.test(text);
	};
	
	
	/**
	 * LinkifyIt#testSchemaAt(text, name, position) -> Number
	 * - text (String): text to scan
	 * - name (String): rule (schema) name
	 * - position (Number): text offset to check from
	 *
	 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
	 * at given position. Returns length of found pattern (0 on fail).
	 **/
	LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
	  // If not supported schema check requested - terminate
	  if (!this.__compiled__[schema.toLowerCase()]) {
	    return 0;
	  }
	  return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
	};
	
	
	/**
	 * LinkifyIt#match(text) -> Array|null
	 *
	 * Returns array of found link descriptions or `null` on fail. We strongly
	 * recommend to use [[LinkifyIt#test]] first, for best speed.
	 *
	 * ##### Result match description
	 *
	 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
	 *   protocol-neutral  links.
	 * - __index__ - offset of matched text
	 * - __lastIndex__ - index of next char after mathch end
	 * - __raw__ - matched text
	 * - __text__ - normalized text
	 * - __url__ - link, generated from matched text
	 **/
	LinkifyIt.prototype.match = function match(text) {
	  var shift = 0, result = [];
	
	  // Try to take previous element from cache, if .test() called before
	  if (this.__index__ >= 0 && this.__text_cache__ === text) {
	    result.push(createMatch(this, shift));
	    shift = this.__last_index__;
	  }
	
	  // Cut head if cache was used
	  var tail = shift ? text.slice(shift) : text;
	
	  // Scan string until end reached
	  while (this.test(tail)) {
	    result.push(createMatch(this, shift));
	
	    tail = tail.slice(this.__last_index__);
	    shift += this.__last_index__;
	  }
	
	  if (result.length) {
	    return result;
	  }
	
	  return null;
	};
	
	
	/** chainable
	 * LinkifyIt#tlds(list [, keepOld]) -> this
	 * - list (Array): list of tlds
	 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
	 *
	 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
	 * to avoid false positives. By default this algorythm used:
	 *
	 * - hostname with any 2-letter root zones are ok.
	 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
	 *   are ok.
	 * - encoded (`xn--...`) root zones are ok.
	 *
	 * If list is replaced, then exact match for 2-chars root zones will be checked.
	 **/
	LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
	  list = Array.isArray(list) ? list : [ list ];
	
	  if (!keepOld) {
	    this.__tlds__ = list.slice();
	    this.__tlds_replaced__ = true;
	    compile(this);
	    return this;
	  }
	
	  this.__tlds__ = this.__tlds__.concat(list)
	                                  .sort()
	                                  .filter(function (el, idx, arr) {
	                                    return el !== arr[idx - 1];
	                                  })
	                                  .reverse();
	
	  compile(this);
	  return this;
	};
	
	/**
	 * LinkifyIt#normalize(match)
	 *
	 * Default normalizer (if schema does not define it's own).
	 **/
	LinkifyIt.prototype.normalize = function normalize(match) {
	
	  // Do minimal possible changes by default. Need to collect feedback prior
	  // to move forward https://github.com/markdown-it/linkify-it/issues/1
	
	  if (!match.schema) { match.url = 'http://' + match.url; }
	
	  if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
	    match.url = 'mailto:' + match.url;
	  }
	};
	
	
	/**
	 * LinkifyIt#onCompile()
	 *
	 * Override to modify basic RegExp-s.
	 **/
	LinkifyIt.prototype.onCompile = function onCompile() {
	};
	
	
	module.exports = LinkifyIt;


/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	module.exports = function (opts) {
	  var re = {};
	
	  // Use direct extract instead of `regenerate` to reduse browserified size
	  re.src_Any = __webpack_require__(1223).source;
	  re.src_Cc  = __webpack_require__(1224).source;
	  re.src_Z   = __webpack_require__(1225).source;
	  re.src_P   = __webpack_require__(1226).source;
	
	  // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
	  re.src_ZPCc = [ re.src_Z, re.src_P, re.src_Cc ].join('|');
	
	  // \p{\Z\Cc} (white spaces + control)
	  re.src_ZCc = [ re.src_Z, re.src_Cc ].join('|');
	
	  // All possible word characters (everything without punctuation, spaces & controls)
	  // Defined via punctuation & spaces to save space
	  // Should be something like \p{\L\N\S\M} (\w but without `_`)
	  re.src_pseudo_letter       = '(?:(?!>|<|' + re.src_ZPCc + ')' + re.src_Any + ')';
	  // The same as abothe but without [0-9]
	  // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
	
	  ////////////////////////////////////////////////////////////////////////////////
	
	  re.src_ip4 =
	
	    '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
	
	  // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
	  re.src_auth    = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
	
	  re.src_port =
	
	    '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
	
	  re.src_host_terminator =
	
	    '(?=$|>|<|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
	
	  re.src_path =
	
	    '(?:' +
	      '[/?#]' +
	        '(?:' +
	          '(?!' + re.src_ZCc + '|[()[\\]{}.,"\'?!\\-<>]).|' +
	          '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' +
	          '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' +
	          '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' +
	          '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' +
	          "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" +
	          "\\'(?=" + re.src_pseudo_letter + '|[-]).|' +  // allow `I'm_king` if no pair found
	          '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
	                                     // - english
	                                     // - percent-encoded
	                                     // - parts of file path
	                                     // until more examples found.
	          '\\.(?!' + re.src_ZCc + '|[.]).|' +
	          (opts && opts['---'] ?
	            '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
	          :
	            '\\-+|'
	          ) +
	          '\\,(?!' + re.src_ZCc + ').|' +      // allow `,,,` in paths
	          '\\!(?!' + re.src_ZCc + '|[!]).|' +
	          '\\?(?!' + re.src_ZCc + '|[?]).' +
	        ')+' +
	      '|\\/' +
	    ')?';
	
	  re.src_email_name =
	
	    '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
	
	  re.src_xn =
	
	    'xn--[a-z0-9\\-]{1,59}';
	
	  // More to read about domain names
	  // http://serverfault.com/questions/638260/
	
	  re.src_domain_root =
	
	    // Allow letters & digits (http://test1)
	    '(?:' +
	      re.src_xn +
	      '|' +
	      re.src_pseudo_letter + '{1,63}' +
	    ')';
	
	  re.src_domain =
	
	    '(?:' +
	      re.src_xn +
	      '|' +
	      '(?:' + re.src_pseudo_letter + ')' +
	      '|' +
	      // don't allow `--` in domain names, because:
	      // - that can conflict with markdown &mdash; / &ndash;
	      // - nobody use those anyway
	      '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' +
	    ')';
	
	  re.src_host =
	
	    '(?:' +
	    // Don't need IP check, because digits are already allowed in normal domain names
	    //   src_ip4 +
	    // '|' +
	      '(?:(?:(?:' + re.src_domain + ')\\.)*' + re.src_domain/*_root*/ + ')' +
	    ')';
	
	  re.tpl_host_fuzzy =
	
	    '(?:' +
	      re.src_ip4 +
	    '|' +
	      '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' +
	    ')';
	
	  re.tpl_host_no_ip_fuzzy =
	
	    '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
	
	  re.src_host_strict =
	
	    re.src_host + re.src_host_terminator;
	
	  re.tpl_host_fuzzy_strict =
	
	    re.tpl_host_fuzzy + re.src_host_terminator;
	
	  re.src_host_port_strict =
	
	    re.src_host + re.src_port + re.src_host_terminator;
	
	  re.tpl_host_port_fuzzy_strict =
	
	    re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
	
	  re.tpl_host_port_no_ip_fuzzy_strict =
	
	    re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
	
	
	  ////////////////////////////////////////////////////////////////////////////////
	  // Main rules
	
	  // Rude test fuzzy links by host, for quick deny
	  re.tpl_host_fuzzy_test =
	
	    'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
	
	  re.tpl_email_fuzzy =
	
	      '(^|<|>|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
	
	  re.tpl_link_fuzzy =
	      // Fuzzy link can't be prepended with .:/\- and non punctuation.
	      // but can start with > (markdown blockquote)
	      '(^|(?![.:/\\-_@])(?:[$+<=>^`|]|' + re.src_ZPCc + '))' +
	      '((?![$+<=>^`|])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
	
	  re.tpl_link_no_ip_fuzzy =
	      // Fuzzy link can't be prepended with .:/\- and non punctuation.
	      // but can start with > (markdown blockquote)
	      '(^|(?![.:/\\-_@])(?:[$+<=>^`|]|' + re.src_ZPCc + '))' +
	      '((?![$+<=>^`|])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
	
	  return re;
	};


/***/ },
/* 1223 */
/***/ function(module, exports) {

	module.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/

/***/ },
/* 1224 */
/***/ function(module, exports) {

	module.exports=/[\0-\x1F\x7F-\x9F]/

/***/ },
/* 1225 */
/***/ function(module, exports) {

	module.exports=/[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/

/***/ },
/* 1226 */
/***/ function(module, exports) {

	module.exports=/[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E44\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _MessageActions = __webpack_require__(1228);
	
	var _MessageActions2 = _interopRequireDefault(_MessageActions);
	
	var _MessageStore = __webpack_require__(1232);
	
	var _MessageStore2 = _interopRequireDefault(_MessageStore);
	
	var _GroupMessageList = __webpack_require__(1233);
	
	var _GroupMessageList2 = _interopRequireDefault(_GroupMessageList);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GroupMessageListModal = __webpack_require__(2121);
	
	var _GroupMessageListModal2 = _interopRequireDefault(_GroupMessageListModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupMessageListModal = function (_Component) {
	  _inherits(GroupMessageListModal, _Component);
	
	  function GroupMessageListModal() {
	    _classCallCheck(this, GroupMessageListModal);
	
	    return _possibleConstructorReturn(this, (GroupMessageListModal.__proto__ || Object.getPrototypeOf(GroupMessageListModal)).apply(this, arguments));
	  }
	
	  _createClass(GroupMessageListModal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.group = _GroupStore2.default.getGroupForCode(this.props.groupCode);
	      var groupId = this.group.id;
	      if (!_MessageStore2.default.isDoneLoadingForGroup(groupId)) {
	        _MessageActions2.default.loadMessages(groupId);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'GroupMessageListModal'
	        }, this.props, {
	          className: _GroupMessageListModal2.default.this }),
	        _react2.default.createElement(_GroupMessageList2.default, { group: this.group, className: _GroupMessageListModal2.default.messages })
	      );
	    }
	  }]);
	
	  return GroupMessageListModal;
	}(_react.Component);
	
	GroupMessageListModal.displayName = 'GroupMessageListModal';
	exports.default = GroupMessageListModal;

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// typecheck: ignore file
	
	
	var _qs = __webpack_require__(557);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _GroupConstants = __webpack_require__(991);
	
	var _File = __webpack_require__(929);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _Messages = __webpack_require__(1229);
	
	var _Messages2 = _interopRequireDefault(_Messages);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _roleHelpers = __webpack_require__(1230);
	
	var _promise = __webpack_require__(1041);
	
	var _deliverySummariesQuery = __webpack_require__(1231);
	
	var _deliverySummariesQuery2 = _interopRequireDefault(_deliverySummariesQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MESSAGES_PAGE_SIZE = 10;
	
	var MessageActions = {
	
	  // XXX (rgoldfinger) remove when cleaning up old way of sending messages
	  loadMessages: function loadMessages(groupId) {
	    var maxSeq = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    var sinceSeq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : MESSAGES_PAGE_SIZE;
	
	    var options = {
	      max_seq: maxSeq,
	      since_seq: sinceSeq,
	      limit: limit
	    };
	
	    return _Messages2.default.yieldMessagesForGroupId(groupId, options).then(function (messages) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _GroupConstants.ActionTypes.LIST_GROUP_MESSAGES,
	        groupKey: groupId,
	        messages: messages
	      });
	    });
	  },
	  loadThreadMessages: function loadThreadMessages(groupId, threadUuid, role) {
	    var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    var options = _extends({
	      max_seq: null,
	      since_seq: 0,
	      limit: MESSAGES_PAGE_SIZE
	    }, opts);
	
	    _Messages2.default.yieldThreadMessagesForGroupId(groupId, threadUuid, options).then(function (messages) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _GroupConstants.ActionTypes.LIST_GROUP_MESSAGES,
	        groupKey: (0, _roleHelpers.getGroupKey)(groupId, role),
	        messages: messages
	      });
	    }).catch(_promise.genericCatch);
	  },
	
	
	  // XXX (rgoldfinger) remove when cleaning up old way of sending messages
	  loadScheduledMessages: function loadScheduledMessages(groupId) {
	    _Messages2.default.yieldScheduledMessagesForGroupId(groupId).then(function (messages) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _GroupConstants.ActionTypes.LIST_GROUP_SCHEDULED_MESSAGES,
	        groupKey: groupId,
	        messages: messages
	      });
	    }).catch(_promise.genericCatch);
	  },
	  loadScheduledThreadMessages: function loadScheduledThreadMessages(groupId, threadUuid, role) {
	    _Messages2.default.yieldScheduledThreadMessagesForGroupId(groupId, threadUuid).then(function (messages) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _GroupConstants.ActionTypes.LIST_GROUP_SCHEDULED_MESSAGES,
	        groupKey: (0, _roleHelpers.getGroupKey)(groupId, role),
	        messages: messages
	      });
	    }).catch(_promise.genericCatch);
	  },
	  finishShowingDraft: function finishShowingDraft() {
	    _Dispatcher.dispatcher.dispatch({
	      type: _GroupConstants.ActionTypes.FINISH_SHOWING_DRAFT
	    });
	  },
	  saveAndShowDraftAnnouncement: function saveAndShowDraftAnnouncement(message) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _GroupConstants.ActionTypes.SAVE_AND_SHOW_DRAFT_ANNOUNCEMENT,
	      message: message
	    });
	  },
	  saveDraftAnnouncement: function saveDraftAnnouncement(message) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _GroupConstants.ActionTypes.SAVE_DRAFT_ANNOUNCEMENT,
	      message: message
	    });
	  },
	  saveAndShowDraftFromQuery: function saveAndShowDraftFromQuery(actionData) {
	    var _qs$parse = _qs2.default.parse(actionData),
	        body = _qs$parse.body,
	        attachmentId = _qs$parse.attachmentId;
	
	    var message = new _Message2.default({ body: body, attachmentId: attachmentId });
	
	    _Dispatcher.dispatcher.dispatch({
	      type: _GroupConstants.ActionTypes.SAVE_AND_SHOW_DRAFT_ANNOUNCEMENT,
	      message: message
	    });
	  },
	  clearDraftAnnouncement: function clearDraftAnnouncement() {
	    _Dispatcher.dispatcher.dispatch({
	      type: _GroupConstants.ActionTypes.CLEAR_DRAFT_ANNOUNCEMENT
	    });
	  },
	  sendMessage: function sendMessage(message) {
	    var isScheduled = !!message.getSendAt();
	    var type = isScheduled ? {
	      success: _GroupConstants.ActionTypes.SEND_GROUP_SCHEDULED_MESSAGE,
	      error: _GroupConstants.ActionTypes.SEND_GROUP_SCHEDULED_MESSAGE_ERROR
	    } : {
	      success: _GroupConstants.ActionTypes.SEND_GROUP_MESSAGE,
	      error: _GroupConstants.ActionTypes.SEND_GROUP_MESSAGE_ERROR
	    };
	
	    return message.send().then(function (messageSent) {
	      if (isScheduled) {
	        _ToastActions2.default.showSuccessToast('Announcement scheduled');
	      } else {
	        var groupsCount = messageSent.getTargets().length;
	        _ToastActions2.default.showSuccessToast(groupsCount <= 1 ? 'Announcement sent' : groupsCount + ' Announcements sent');
	      }
	
	      _Dispatcher.dispatcher.dispatch({
	        type: type.success,
	        message: messageSent
	      });
	    }).catch(function (error) {
	      _ToastActions2.default.showAPIError(error);
	      _Dispatcher.dispatcher.dispatch({
	        type: type.error,
	        message: message,
	        error: error
	      });
	    });
	  },
	  export: function _export(groupIds, startDate, endDate) {
	    _Messages2.default.export(groupIds, startDate, endDate).then(function () {
	      _ToastActions2.default.showSuccessToast('We’ve emailed you the Announcement history you’ve requested. You should receive it within 10 minutes.');
	    }).catch(function (error) {
	      _ToastActions2.default.showAPIError(error);
	      throw error;
	    });
	  },
	  loadDeliverySummary: function loadDeliverySummary(message) {
	    var messageUuids = [message.getUuid()];
	    _RemindAPI2.default.execute(_deliverySummariesQuery2.default, { messageUuids: messageUuids }).then(function (_ref) {
	      var deliverySummaries = _ref.deliverySummaries;
	
	      deliverySummaries.forEach(function (summary) {
	        // elements of the response array may be null
	        // https://github.com/remind101/r101-apollo/blob/4ff2bca88dcff6b2cb639d3095fcbe2b75d7756c/src/data/schemas/Root.js#L8
	        // TODO consider setting a schema policy that response arrays are compacted
	        if (summary === null) {
	          return;
	        }
	        _Dispatcher.dispatcher.dispatch({
	          messageId: message.id,
	          type: _GroupConstants.ActionTypes.LOAD_DELIVERY_SUMMARY,
	          summary: summary
	        });
	      });
	    }).catch(_promise.genericCatch);
	  },
	  updateScheduledMessage: function updateScheduledMessage(messageToUpdate, body, targets, files, sendAt) {
	    var changes = messageToUpdate.update(body, targets, sendAt) || {};
	
	    return messageToUpdate.patch(changes, files).then(function (message) {
	      _ToastActions2.default.showSuccessToast('Announcement updated');
	      _Dispatcher.dispatcher.dispatch({
	        type: _GroupConstants.ActionTypes.UPDATED_GROUP_SCHEDULED_MESSAGE,
	        message: message
	      });
	    }).catch(function (error) {
	      _ToastActions2.default.showAPIError(error);
	      throw error;
	    });
	  },
	  destroyScheduledMessage: function destroyScheduledMessage(messageToDestroy) {
	    messageToDestroy.destroy().then(function (message) {
	      _ToastActions2.default.showSuccessToast('Announcement deleted');
	      _Dispatcher.dispatcher.dispatch({
	        type: _GroupConstants.ActionTypes.DESTROY_GROUP_SCHEDULED_MESSAGE,
	        message: message
	      });
	    }).catch(function (error) {
	      _ToastActions2.default.showAPIError(error);
	      throw error;
	    });
	  }
	};
	
	exports.default = MessageActions;

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _jstimezonedetect = __webpack_require__(570);
	
	var _jstimezonedetect2 = _interopRequireDefault(_jstimezonedetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Messages = function (_Collection) {
	  _inherits(Messages, _Collection);
	
	  function Messages() {
	    _classCallCheck(this, Messages);
	
	    return _possibleConstructorReturn(this, (Messages.__proto__ || Object.getPrototypeOf(Messages)).apply(this, arguments));
	  }
	
	  _createClass(Messages, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _Message2.default;
	    }
	  }, {
	    key: 'comparator',
	    value: function comparator(a, b) {
	      return b.getSeq() - a.getSeq();
	    }
	  }, {
	    key: 'getReverseArray',
	    value: function getReverseArray() {
	      var modelsCopy = (0, _lodash.clone)(this.models);
	      return (0, _lodash.sortBy)(modelsCopy, function (message) {
	        return message.getSeq();
	      });
	    }
	    // XXX (rgoldfinger) remove when cleaning up old way of sending messages
	
	  }], [{
	    key: 'yieldMessagesForGroupId',
	    value: function yieldMessagesForGroupId(groupId) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return (0, _apiRequest2.default)('/classes/' + groupId + '/messages', 'GET', options).then(_handleMessageResponse);
	    }
	    // XXX (rgoldfinger) remove when cleaning up old way of sending messages
	
	  }, {
	    key: 'yieldScheduledMessagesForGroupId',
	    value: function yieldScheduledMessagesForGroupId(groupId) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return (0, _apiRequest2.default)('/classes/' + groupId + '/messages/scheduled', 'GET', options).then(_handleMessageResponse);
	    }
	  }, {
	    key: 'yieldThreadMessagesForGroupId',
	    value: function yieldThreadMessagesForGroupId(groupId, threadUuid) {
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      return (0, _apiRequest2.default)('/classes/' + groupId + '/threads/' + threadUuid + '/messages', 'GET', options).then(_handleMessageResponse);
	    }
	  }, {
	    key: 'yieldScheduledThreadMessagesForGroupId',
	    value: function yieldScheduledThreadMessagesForGroupId(groupId, threadUuid) {
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      return (0, _apiRequest2.default)('/classes/' + groupId + '/threads/' + threadUuid + '/messages/scheduled', 'GET', options).then(_handleMessageResponse);
	    }
	  }, {
	    key: 'export',
	    value: function _export(groupIds, since, until) {
	      var tz = _jstimezonedetect2.default.determine();
	      var timezone = tz.name();
	
	      return (0, _apiRequest2.default)('/messages/export', 'POST', {
	        group_ids: groupIds,
	        since: since,
	        until: until,
	        time_zone: timezone
	      });
	    }
	  }]);
	
	  return Messages;
	}(_Collection3.default);
	
	Messages.displayName = 'Messages';
	
	
	function _handleMessageResponse(response) {
	  var messages = new Messages();
	  if (response.messages) {
	    response.messages.forEach(function (messageJSON) {
	      messages.add(_Message2.default.fromJSON(messageJSON));
	    });
	  }
	  return messages;
	}
	
	exports.default = Messages;

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getGroupKey = exports.getGroupDescription = exports.roleNameSingular = exports.roleName = exports.subgroupName = exports.RCE = exports.EVERYONE = exports.UNKNOWN = exports.TEACHER = exports.ADMIN = exports.PARENT = exports.STUDENT = undefined;
	
	var _subgroupName, _roleName, _roleNameSingular;
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var STUDENT = exports.STUDENT = 'student';
	var PARENT = exports.PARENT = 'parent';
	var ADMIN = exports.ADMIN = 'admin';
	var TEACHER = exports.TEACHER = 'teacher';
	var UNKNOWN = exports.UNKNOWN = 'unknown';
	var EVERYONE = exports.EVERYONE = 'everyone';
	var RCE = exports.RCE = 'rce';
	
	var subgroupName = exports.subgroupName = (_subgroupName = {}, _defineProperty(_subgroupName, STUDENT, 'Students'), _defineProperty(_subgroupName, PARENT, 'Parents'), _defineProperty(_subgroupName, ADMIN, 'Administrators'), _defineProperty(_subgroupName, TEACHER, 'Teachers'), _defineProperty(_subgroupName, EVERYONE, 'Everyone'), _subgroupName);
	
	var roleName = exports.roleName = (_roleName = {}, _defineProperty(_roleName, STUDENT, 'Students'), _defineProperty(_roleName, PARENT, 'Parents'), _defineProperty(_roleName, ADMIN, 'Administrators'), _defineProperty(_roleName, TEACHER, 'Teachers'), _defineProperty(_roleName, EVERYONE, 'Everyone'), _defineProperty(_roleName, UNKNOWN, 'No role'), _roleName);
	
	var roleNameSingular = exports.roleNameSingular = (_roleNameSingular = {}, _defineProperty(_roleNameSingular, STUDENT, 'Student'), _defineProperty(_roleNameSingular, PARENT, 'Parent'), _defineProperty(_roleNameSingular, ADMIN, 'Admin'), _defineProperty(_roleNameSingular, TEACHER, 'Teacher'), _roleNameSingular);
	
	var getGroupDescription = exports.getGroupDescription = function getGroupDescription(group, role) {
	  var name = group.getName();
	  if (!role || role === EVERYONE) {
	    return name;
	  } else {
	    return name + ' ' + (String.fromCharCode(160) + String.fromCharCode(8250) + String.fromCharCode(160)) + ' ' + subgroupName[role];
	  }
	};
	
	var getGroupKey = exports.getGroupKey = function getGroupKey(groupId) {
	  var role = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EVERYONE;
	  // eslint-disable-line
	  return '' + groupId + (role === EVERYONE ? '' : role);
	};

/***/ },
/* 1231 */
/***/ function(module, exports) {

	module.exports = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageUuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":null}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"deliverySummaries"},"name":{"kind":"Name","value":"tempDeliverySummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"messageUuids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageUuids"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"message_uuid"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"message_type"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"success_count"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"failed_count"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"state"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"stream_uuid"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"read_count"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"read_users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"color"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"success_users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"color"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"failed_users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"color"},"arguments":[],"directives":[],"selectionSet":null}]}},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"total_count"},"arguments":[],"directives":[],"selectionSet":null}]}}]}}],"loc":{"start":0,"end":555,"source":{"body":"query ($messageUuids: [String]!) {\n  deliverySummaries: tempDeliverySummaries(messageUuids: $messageUuids) {\n    message_uuid\n    message_type\n    success_count\n    failed_count\n    state\n    stream_uuid\n    read_count\n    read_users {\n      # DEPRECATED\n      # id\n\n      uuid\n      name\n      initials\n      color\n    }\n    success_users {\n      # DEPRECATED\n      # id\n\n      uuid\n      name\n      initials\n      color\n    }\n    failed_users {\n      # DEPRECATED\n      # id\n\n      uuid\n      name\n      initials\n      color\n    }\n    total_count\n  }\n}\n","name":"GraphQL"}}};

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _Messages = __webpack_require__(1229);
	
	var _Messages2 = _interopRequireDefault(_Messages);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _roleHelpers = __webpack_require__(1230);
	
	var _GroupConstants = __webpack_require__(991);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getGroupKeys = function getGroupKeys(message) {
	  var threadKeys = message.getThreads().map(function (t) {
	    return (0, _roleHelpers.getGroupKey)(t.group_id, t.role);
	  });
	  // XXX rgoldfinger why do messages in tests only have targets?
	  var targetKeys = message.getTargets().map(function (t) {
	    return (0, _roleHelpers.getGroupKey)(t.group_id, t.role);
	  });
	  return _lodash2.default.uniq([].concat(_toConsumableArray(threadKeys), _toConsumableArray(targetKeys)));
	};
	
	var MessageStore = function (_Store) {
	  _inherits(MessageStore, _Store);
	
	  function MessageStore() {
	    _classCallCheck(this, MessageStore);
	
	    return _possibleConstructorReturn(this, (MessageStore.__proto__ || Object.getPrototypeOf(MessageStore)).apply(this, arguments));
	  }
	
	  _createClass(MessageStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        messages: {},
	        messagesScheduled: {},
	        loadingState: {},
	        gaps: {}
	      };
	    }
	  }, {
	    key: 'doMessage',
	    value: function doMessage(dict, method, message) {
	      var groupKeys = getGroupKeys(message);
	      var changed = false;
	
	      groupKeys.forEach(function (groupKey) {
	        var messages = dict[groupKey];
	        if (!messages) {
	          dict[groupKey] = new _Messages2.default();
	          messages = dict[groupKey];
	        }
	        messages[method](message);
	        changed = true;
	      });
	
	      if (changed) {
	        this.emitChange();
	      }
	    }
	  }, {
	    key: 'addMessage',
	    value: function addMessage(message) {
	      // This is when a message was scheduled, then an edit
	      // was made that unscheduled it, so it should be removed
	      // from the scheduled messages list before adding
	      this.removeScheduledMessage(message);
	
	      this.doMessage(this.state.messages, 'add', message);
	    }
	  }, {
	    key: 'addScheduledMessage',
	    value: function addScheduledMessage(message) {
	      // The messages won’t reorder based on the comparator
	      // if we add (by merging) a message. Removing, then
	      // adding will trigger the collection to place it
	      // in the right spot
	      this.removeScheduledMessage(message);
	
	      this.doMessage(this.state.messagesScheduled, 'add', message);
	    }
	  }, {
	    key: 'removeMessage',
	    value: function removeMessage(message) {
	      this.doMessage(this.state.messages, 'remove', message);
	    }
	  }, {
	    key: 'removeScheduledMessage',
	    value: function removeScheduledMessage(message) {
	      this.doMessage(this.state.messagesScheduled, 'remove', message);
	    }
	  }, {
	    key: 'removeClientCreatedDuplicates',
	    value: function removeClientCreatedDuplicates(groupKey, newMessages) {
	      var _this2 = this;
	
	      var dupes = this.state.messages[groupKey].filter(function (m) {
	        return m.getIsClientCreated() === true && newMessages.some(function (n) {
	          return n.getBody() === m.getBody();
	        });
	      });
	      dupes.forEach(function (d) {
	        return _this2.state.messages[groupKey].remove(d);
	      });
	    }
	  }, {
	    key: 'getGap',
	    value: function getGap(groupKey) {
	      return this.state.gaps[groupKey];
	    }
	  }, {
	    key: 'isDoneLoadingForGroup',
	    value: function isDoneLoadingForGroup(groupKey) {
	      return this.state.loadingState[groupKey] === _GroupConstants.LoadingStates.LOADED;
	    }
	  }, {
	    key: 'getMessages',
	    value: function getMessages(groupKey) {
	      return this.state.messages[groupKey] || new _Messages2.default();
	    }
	  }, {
	    key: 'getMessagesScheduled',
	    value: function getMessagesScheduled(groupKey) {
	      var _this3 = this;
	
	      if (groupKey in this.state.messagesScheduled) {
	        this.state.messagesScheduled[groupKey].filter(function (message) {
	          return message.getSendAt() < new Date();
	        }).forEach(function (message) {
	          return _this3.removeScheduledMessage(message);
	        });
	      } else {
	        this.state.messagesScheduled[groupKey] = new _Messages2.default();
	      }
	      return this.state.messagesScheduled[groupKey];
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      var _this4 = this;
	
	      switch (action.type) {
	        case _GroupConstants.ActionTypes.RESET_STORE:
	          this.resetState();
	          break;
	        case _GroupConstants.ActionTypes.SEND_GROUP_MESSAGE:
	          this.addMessage(action.message);
	          break;
	        case _GroupConstants.ActionTypes.SEND_GROUP_MESSAGE_ERROR:
	          this.removeMessage(action.message);
	          break;
	        case _GroupConstants.ActionTypes.SEND_GROUP_SCHEDULED_MESSAGE:
	          this.addScheduledMessage(action.message);
	          break;
	        case _GroupConstants.ActionTypes.SEND_GROUP_SCHEDULED_MESSAGE_ERROR:
	          this.removeScheduledMessage(action.message);
	          break;
	        case _GroupConstants.ActionTypes.UPDATED_GROUP_SCHEDULED_MESSAGE:
	          this.addScheduledMessage(action.message);
	          break;
	        case _GroupConstants.ActionTypes.DESTROY_GROUP_SCHEDULED_MESSAGE:
	          this.removeScheduledMessage(action.message);
	          break;
	        case _GroupConstants.ActionTypes.LIST_GROUP_MESSAGES:
	          {
	            var _ret = function () {
	              var groupKey = action.groupKey,
	                  messages = action.messages;
	
	              if (!_this4.state.messages[groupKey]) {
	                _this4.state.messages[groupKey] = new _Messages2.default();
	              }
	              _this4.state.loadingState[groupKey] = _GroupConstants.LoadingStates.LOADED;
	              // assume this is the end until we see a gap
	              _this4.state.gaps[groupKey] = undefined;
	              _this4.removeClientCreatedDuplicates(groupKey, messages);
	              messages.forEach(function (message) {
	                var type = message.getType();
	                if (type === 'message' || type === 'payment_request') {
	                  _this4.state.messages[groupKey].add(message);
	                } else if (type === 'gap') {
	                  _this4.state.gaps[groupKey] = message;
	                }
	              });
	              _this4.emitChange();
	              return 'break';
	            }();
	
	            if (_ret === 'break') break;
	          }
	        case _GroupConstants.ActionTypes.LIST_GROUP_SCHEDULED_MESSAGES:
	          this.state.messagesScheduled[action.groupKey] = action.messages;
	          this.emitChange();
	          break;
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return MessageStore;
	}(_Store3.default);
	
	MessageStore.displayName = 'MessageStore';
	exports.default = new MessageStore();

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DividerText = __webpack_require__(1234);
	
	var _DividerText2 = _interopRequireDefault(_DividerText);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _MessageActions = __webpack_require__(1228);
	
	var _MessageActions2 = _interopRequireDefault(_MessageActions);
	
	var _MessageStore = __webpack_require__(1232);
	
	var _MessageStore2 = _interopRequireDefault(_MessageStore);
	
	var _UserConstants = __webpack_require__(1015);
	
	var _ScrollWatch = __webpack_require__(1238);
	
	var _ScrollWatch2 = _interopRequireDefault(_ScrollWatch);
	
	var _Timer = __webpack_require__(1239);
	
	var _Tooltip = __webpack_require__(1157);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _GroupMessage = __webpack_require__(1240);
	
	var _GroupMessage2 = _interopRequireDefault(_GroupMessage);
	
	var _GroupMessagesNull = __webpack_require__(1686);
	
	var _GroupMessagesNull2 = _interopRequireDefault(_GroupMessagesNull);
	
	var _GroupScheduledMessageList = __webpack_require__(2055);
	
	var _GroupScheduledMessageList2 = _interopRequireDefault(_GroupScheduledMessageList);
	
	__webpack_require__(2119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupMessageList = _react2.default.createClass({
	  displayName: 'GroupMessageList',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [(0, _linkStateWithStores2.default)([_MessageStore2.default])],
	
	  getInitialState: function getInitialState() {
	    var lastReadSeq = this.props.group.getLastReadSeq();
	    return Object.assign(this.getStateFromStores(), {
	      width: 0,
	      lastReadSeq: lastReadSeq,
	      initialFirstMessage: null,
	      newMessagesSeen: false,
	      visibility: null
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    window.addEventListener('resize', this.onResize, false);
	    this.onResize();
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
	    var _this = this;
	
	    var group = nextProps.group;
	
	    var messages = nextState.messages;
	    // New announcement line gets reset if the user makes an announcement
	    if (this.needsNewLineReset(messages)) {
	      this.refs.aboveTrigger.hideLayer();
	      this.refs.belowTrigger.hideLayer();
	      this.setState({ lastReadSeq: messages.first().getSeq() });
	    }
	
	    // Reset new announcement line visibility for additional incoming messages
	    if (this.state.newMessagesSeen && this.isFirstMessageNotRead(messages, group)) {
	      this.setState({ newMessagesSeen: false }, function () {
	        return _this.onVisibilityChange(_this.state.visibility);
	      });
	    }
	
	    if (this.props.group.id !== group.id) {
	      this.setState(this.getStateFromStores(group.id));
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevState.loading === true && this.state.loading === false) {
	      (0, _Timer.markChange)('class_open', 'loaded');
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('resize', this.onResize, false);
	  },
	  onResize: function onResize() {
	    var width = _reactDom2.default.findDOMNode(this.refs.groupMessageList).offsetWidth;
	
	    if (this.state.width !== width) {
	      this.setState({ width: width });
	    }
	  },
	  onVisibilityChange: function onVisibilityChange(visibility) {
	    // Keep track of visibility for when an update occurs
	    if (visibility !== this.state.visibility) {
	      this.setState({ visibility: visibility });
	    }
	
	    if (this.state.newMessagesSeen) {
	      return;
	    }
	
	    switch (visibility) {
	      case 'above':
	        this.refs.aboveTrigger.showLayer();
	        break;
	      case 'below':
	        this.refs.belowTrigger.showLayer();
	        break;
	      default:
	        this.refs.aboveTrigger.hideLayer();
	        this.refs.belowTrigger.hideLayer();
	
	        this.setState({ newMessagesSeen: true });
	        break;
	    }
	  },
	  getStateFromStores: function getStateFromStores() {
	    var groupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.group.id;
	
	    var messages = _MessageStore2.default.getMessages(groupId);
	    return {
	      gap: _MessageStore2.default.getGap(groupId),
	      loading: !_MessageStore2.default.isDoneLoadingForGroup(groupId),
	      messagesScheduled: _MessageStore2.default.getMessagesScheduled(groupId),
	      initialFirstMessage: messages.first(),
	      messages: messages
	    };
	  },
	  getChattableOwners: function getChattableOwners() {
	    var group = this.props.group;
	
	    return group.getOwners().filter(function (o) {
	      return o.getCanChat();
	    });
	  },
	  isFirstMessageNotRead: function isFirstMessageNotRead(messages, group) {
	    return messages.first() && messages.first().getSeq() > group.getLastReadSeq();
	  },
	  loadMoreMessages: function loadMoreMessages() {
	    if (this.state.gap) {
	      var gapParams = this.state.gap.getGapParams();
	      _MessageActions2.default.loadMessages(this.props.group.id, gapParams['max_seq'], gapParams['since_seq']);
	    }
	  },
	  needsAnimationFrame: function needsAnimationFrame() {
	    return true;
	  },
	  needsNewLineReset: function needsNewLineReset(messages) {
	    var initialFirstMessage = this.state.initialFirstMessage;
	
	    var currentFirstMessage = messages.first();
	    /*
	        New announcement line needs to be reset to the top if:
	          The first message in the list is by the current user
	          The first message is not the same first message as when the user initially enters the view
	          this.state.lastReadSeq has not already been set to be the newest message
	        All these cases will only be true if the new (first) message is made by the current user,
	        and is currently in the view in which the message was made in.
	    */
	    return initialFirstMessage && currentFirstMessage && currentFirstMessage.sentByCurrentUser() && initialFirstMessage.getSeq() !== currentFirstMessage.getSeq() && currentFirstMessage.getSeq() > this.state.lastReadSeq;
	  },
	  renderLoadingIndicator: function renderLoadingIndicator() {
	    if (this.state.loading || this.state.gap) {
	      return _react2.default.createElement(
	        _ScrollWatch2.default,
	        { onEnter: this.loadMoreMessages, threshold: 0.5 },
	        _react2.default.createElement(
	          'div',
	          { className: 'GroupMessageList-loading' },
	          _react2.default.createElement(_LoadingIndicator2.default, { size: 'large' })
	        )
	      );
	    } else {
	      return null;
	    }
	  },
	  renderMessage: function renderMessage(message) {
	    var group = this.props.group;
	
	    return _react2.default.createElement(_GroupMessage2.default, {
	      key: message.getUuid(),
	      message: message,
	      groupId: group.id,
	      groupIsOwnedByUser: group.isOwnedByUser(_CurrentUser2.default.getUserId())
	    });
	  },
	  renderMessages: function renderMessages() {
	    var _this2 = this;
	
	    if (this.state.messages.isEmpty()) {
	      if (!this.state.loading && this.state.messagesScheduled.isEmpty()) {
	        var group = this.props.group;
	
	        var user = _CurrentUser2.default.getUser();
	        return _react2.default.createElement(_GroupMessagesNull2.default, {
	          canChat: user.canChat() && this.getChattableOwners().length > 0,
	          canPost: group.canPost(),
	          canInviteTeachers: user.getRole() === _UserConstants.Roles.teacher,
	          messageHistoryEnabled: group.isMessageHistoryEnabled()
	        });
	      }
	      return null;
	    }
	    var messages = void 0;
	    var newMessages = [];
	    var oldMessages = [];
	    if (this.state.lastReadSeq && !this.needsNewLineReset(this.state.messages)) {
	      newMessages = this.state.messages.filter(function (message) {
	        return message.getSeq() > _this2.state.lastReadSeq;
	      }).map(this.renderMessage);
	
	      oldMessages = this.state.messages.filter(function (message) {
	        return message.getSeq() <= _this2.state.lastReadSeq;
	      }).map(this.renderMessage);
	
	      if (oldMessages.length === 0) {
	        messages = newMessages;
	      } else if (newMessages.length > 0) {
	        newMessages.push(this.renderNewMessagesDivider());
	        messages = newMessages.concat(oldMessages);
	      } else {
	        messages = oldMessages;
	      }
	    } else {
	      messages = this.state.messages.map(this.renderMessage);
	    }
	
	    return messages;
	  },
	  renderNewMessagesDivider: function renderNewMessagesDivider() {
	    return _react2.default.createElement(
	      _ScrollWatch2.default,
	      { onVisibilityChange: this.onVisibilityChange, key: this.props.group.id },
	      _react2.default.createElement(_DividerText2.default, {
	        className: 'GroupMessageList-newMessagesDivider',
	        text: 'New announcements',
	        color: 'violet',
	        weight: 'thick',
	        uppercase: false,
	        dividerPosition: 'bottom'
	      })
	    );
	  },
	  renderScheduledMessages: function renderScheduledMessages() {
	    if (this.state.messagesScheduled.isEmpty()) {
	      return null;
	    }
	
	    return _react2.default.createElement(_GroupScheduledMessageList2.default, {
	      group: this.props.group,
	      messages: this.state.messagesScheduled,
	      collapsible: true
	    });
	  },
	  renderTooltipLauncher: function renderTooltipLauncher(refName, placement) {
	    var tooltip = _react2.default.createElement(
	      _Tooltip2.default,
	      {
	        hideOnEscape: false,
	        hideOnBlur: false,
	        hideOnTransition: false },
	      'New announcements'
	    );
	
	    return _react2.default.createElement(
	      _LayerTrigger2.default,
	      {
	        ref: refName,
	        layer: tooltip,
	        trigger: 'manual',
	        placement: placement,
	        alignment: 'middle' },
	      _react2.default.createElement('div', { style: { width: this.state.width } })
	    );
	  },
	  render: function render() {
	    var above = this.renderTooltipLauncher('aboveTrigger', 'bottom');
	    var below = this.renderTooltipLauncher('belowTrigger', 'top');
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)('GroupMessageList-ClassNavExperiment', this.props.className),
	        ref: 'groupMessageList' },
	      above,
	      this.renderScheduledMessages(),
	      this.renderMessages(),
	      this.renderLoadingIndicator(),
	      below
	    );
	  }
	});
	
	exports.default = GroupMessageList;

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1235);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DividerText = function (_React$Component) {
	  _inherits(DividerText, _React$Component);
	
	  function DividerText() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DividerText);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DividerText.__proto__ || Object.getPrototypeOf(DividerText)).call.apply(_ref, [this].concat(args))), _this), _this.renderText = function () {
	      var text = _this.props.text;
	
	      if (!text) {
	        return null;
	      }
	      return _react2.default.createElement(
	        'span',
	        { className: 'DividerText-text' },
	        text
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DividerText, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('DividerText', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className) },
	        this.renderText()
	      );
	    }
	  }]);
	
	  return DividerText;
	}(_react2.default.Component);
	
	DividerText.propClasses = {
	  color: {
	    violet: 'DividerText-violet',
	    grey: 'DividerText-grey'
	  },
	  weight: {
	    thin: 'DividerText-thin',
	    thick: 'DividerText-thick'
	  },
	  uppercase: 'DividerText-uppercase',
	  dividerPosition: {
	    top: 'DividerText-top',
	    middle: 'DividerText-middle',
	    bottom: 'DividerText-bottom'
	  }
	};
	DividerText.defaultProps = {
	  color: 'grey',
	  weight: 'thin',
	  uppercase: false,
	  dividerPosition: 'middle'
	};
	DividerText.displayName = 'DividerText';
	exports.default = DividerText;

/***/ },
/* 1235 */
1136,
/* 1236 */,
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = linkStateWithStores;
	
	var _utils = __webpack_require__(956);
	
	var _Store = __webpack_require__(589);
	
	var _Store2 = _interopRequireDefault(_Store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates a mixin that links state with the given stores
	 * @param  {Array} stores list of store singletons to link to
	 * @return {React Mixin} mixin that amends component mount methods to link store states
	 */
	// typecheck: ignore statement
	function linkStateWithStores(stores) {
	  return {
	    updateStateFromStores: function updateStateFromStores() {
	      var _this = this;
	
	      var f = function f() {
	        if (_this.isMounted()) {
	          _this.setState(_this.getStateFromStores());
	        }
	      };
	      if (typeof this.needsAnimationFrame === 'function' && this.needsAnimationFrame()) {
	        window.requestAnimationFrame(f);
	      } else {
	        f();
	      }
	    },
	    componentDidMount: function componentDidMount() {
	      var _this2 = this;
	
	      this.__emitterSubscriptions = stores.map(function (s) {
	        return s.addListener(_this2.updateStateFromStores);
	      });
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      this.__emitterSubscriptions.forEach(function (subscription) {
	        return subscription.remove();
	      });
	      this.__emitterSubscriptions = [];
	    }
	  };
	}

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _findScrollParent = __webpack_require__(1176);
	
	var _findScrollParent2 = _interopRequireDefault(_findScrollParent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollWatch = function (_React$Component) {
	  _inherits(ScrollWatch, _React$Component);
	
	  function ScrollWatch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScrollWatch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollWatch.__proto__ || Object.getPrototypeOf(ScrollWatch)).call.apply(_ref, [this].concat(args))), _this), _this._scrollParent = null, _this._previousVisiblity = '', _this.getVisibility = function () {
	      var node = _reactDom2.default.findDOMNode(_this);
	      var top = _this.distanceToTopOfScrollParent(node);
	      var height = node.offsetHeight;
	
	      var parentHeight = void 0;
	      var parentScrollTop = void 0;
	
	      if (_this._scrollParent === window) {
	        parentHeight = window.innerHeight;
	        parentScrollTop = window.pageYOffset;
	      } else if (_this._scrollParent) {
	        parentHeight = _this._scrollParent.offsetHeight;
	        parentScrollTop = _this._scrollParent.scrollTop;
	      }
	
	      var threshold = (parentHeight || 0) * (_this.props.threshold || 0);
	
	      if (top + height + threshold < parentScrollTop) {
	        return 'above';
	      } else if (top - threshold > parentScrollTop + parentHeight) {
	        return 'below';
	      } else {
	        return 'visible';
	      }
	    }, _this.distanceToTopOfScrollParent = function (node) {
	      if (_this._scrollParent !== window && !node.offsetParent) {
	        throw new Error('ScrollWatch requires a scroll parent with `position: relative` in order to calculate ' + 'it’s visibility.');
	      }
	
	      if (node.offsetParent === _this._scrollParent || !node.offsetParent || !(node.offsetParent instanceof HTMLElement)) {
	        return node.offsetTop;
	      } else {
	        return node.offsetTop + _this.distanceToTopOfScrollParent(node.offsetParent);
	      }
	    }, _this.handleScroll = function () {
	      var visibility = _this.getVisibility();
	      if (_this._previousVisiblity === visibility) {
	        return;
	      }
	
	      if (visibility === 'visible') {
	        if (_this.props.onEnter) {
	          _this.props.onEnter();
	        }
	      } else {
	        if (_this.props.onLeave) {
	          _this.props.onLeave();
	        }
	      }
	
	      if (_this.props.onVisibilityChange) {
	        _this.props.onVisibilityChange(visibility, _this._previousVisiblity);
	      }
	
	      _this._previousVisiblity = visibility;
	    }, _this.isVisible = function () {
	      var visibility = _this._previousVisiblity || _this.getVisibility();
	      return visibility === 'visible';
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ScrollWatch, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._scrollParent = (0, _findScrollParent2.default)(_reactDom2.default.findDOMNode(this));
	      // TODO: Attach a single event listener for all instances?
	      this._scrollParent.addEventListener('scroll', this.handleScroll, false);
	      window.addEventListener('resize', this.handleScroll, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._scrollParent) {
	        this._scrollParent.removeEventListener('scroll', this.handleScroll, false);
	      }
	      window.removeEventListener('resize', this.handleScroll, false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.Children.only(this.props.children);
	    }
	  }]);
	
	  return ScrollWatch;
	}(_react2.default.Component);
	
	ScrollWatch.defaultProps = {
	  threshold: 0
	};
	ScrollWatch.displayName = 'ScrollWatch';
	exports.default = ScrollWatch;

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.markAppMounted = exports.markChange = exports.markNewTransition = exports.flushTime = undefined;
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _AppConstants = __webpack_require__(989);
	
	var _PusherConstants = __webpack_require__(954);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This lib is to time the duration between a user action and the UI updating to satisfy the user.
	 *
	 * 1. markNewTransition() At start of user action.
	 * 2. markChange() At each point that the UI may update to satisfy that action.
	 *
	 * We use this "flush" technique because there's no way to know the moment
	 * that the action completes. For example, on navigating to a new chat we know
	 * markNewTransition when they click to it and markChange when the new chat renders.
	 * At this point we don't know whether it's done or not because we have to
	 * wait for an async request to complete. When it does, we markChanged()
	 * again. In theory there could be more changes, so we take the latest time
	 * with and run that when a new transition starts.
	 *
	 * Note that if agent's system clock changes between start and end there will
	 * be bad data. Rare in practice, probably dominated by other noise. We could
	 * have window.performance.marks against the browser's own clock, but it's not
	 * supported in Safari and it parallel timers would still have to be added on
	 * top. Plus its microsecond resolution is overkill as yet.
	 */
	
	// If not we fall back to module load time. Not as accurate but we don't
	// officially support any agents that don't have Navigation Timing API so the
	// data points should be few.
	var hasNavigationTiming = typeof window !== 'undefined' && window.performance && window.performance.timing;
	
	var startTime = hasNavigationTiming ? window.performance.timing.navigationStart : Date.now();
	
	var lastChanges = {};
	
	var endTimes = {};
	
	var appMounted = false;
	
	function resetTimes() {
	  startTime = Date.now();
	  lastChanges = {};
	  endTimes = {};
	}
	
	var flushTime = exports.flushTime = function flushTime(transitionKey) {
	  var endTime = endTimes[transitionKey];
	
	  var duration = endTime - startTime;
	  var props = {
	    duration: duration,
	    last_change: lastChanges[transitionKey]
	  };
	
	  _EventTracking2.default.track('ui.timing.' + transitionKey, props);
	
	  // console.debug('flushTime',
	  //   Object.assign({ transitionKey, startTime, endTimes, lastChanges }, props));
	};
	
	/**
	 * Marks the start of a new transition, clearing the buffer of the previous.
	 * Ideally place in a route onEnter. If the transition doesn't have a route,
	 * it can be added elsewhere but it's probably better to make a route if this
	 * transition is key enough to track.
	 */
	var markNewTransition = exports.markNewTransition = function markNewTransition(_pathname) {
	  if (!appMounted) {
	    // ignore because it must be a redirect, not a user initiated transition
	    return;
	  }
	
	  // console.debug('markNewTransition flushing', pathname, Object.keys(endTimes));
	
	  for (var transitionKey in endTimes) {
	    flushTime(transitionKey);
	  }
	
	  resetTimes();
	};
	
	/**
	 * The view has changed. Marks a possible end of the transition. The latest
	 * change is considered the "end" of the transition for the UX.
	 */
	var markChange = exports.markChange = function markChange(transitionKey, change) {
	  // console.debug('markChange', transitionKey, change);
	  endTimes[transitionKey] = Date.now();
	  lastChanges[transitionKey] = change;
	};
	
	var markAppMounted = exports.markAppMounted = function markAppMounted() {
	  appMounted = true;
	  markChange('app_mount', 'mounted');
	  if (hasNavigationTiming) {
	    endTimes.domComplete = window.performance.timing.domComplete;
	    lastChanges.domComplete = 'domComplete';
	  }
	};
	
	function handleDispatch(action) {
	  switch (action.type) {
	    case _AppConstants.ActionTypes.CONNECTION_STATE_CHANGED:
	      if (action.current !== 'connected') {
	        resetTimes();
	      }
	      break;
	    case _PusherConstants.PushEvents.CHANGESET_CREATE_CHAT_MESSAGE:
	    case _PusherConstants.PushEvents.CLASS_MEMBERSHIP:
	      // Could trigger new data load that wasn't user initiated so if we don't
	      // reset then user wait timers would report new data arriving very much
	      // later than user action. Ideally we'd track open XHRs to know whether
	      // data is really pending. Boomerang could help us with this, but it'll
	      // be pretty complicated regardless. This works for now.
	      markNewTransition('PushEvent ' + action.type);
	      break;
	    default:
	      break;
	  }
	}
	
	// at module load
	_Dispatcher.dispatcher.register(handleDispatch);

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(1241);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _openPopup = __webpack_require__(1252);
	
	var _openPopup2 = _interopRequireDefault(_openPopup);
	
	var _GroupMessageBase = __webpack_require__(1253);
	
	var _GroupMessageBase2 = _interopRequireDefault(_GroupMessageBase);
	
	var _GroupMessageContent = __webpack_require__(1256);
	
	var _GroupMessageContent2 = _interopRequireDefault(_GroupMessageContent);
	
	var _GroupMessageHeader = __webpack_require__(1305);
	
	var _GroupMessageHeader2 = _interopRequireDefault(_GroupMessageHeader);
	
	var _GroupMessageInformation = __webpack_require__(1646);
	
	var _GroupMessageInformation2 = _interopRequireDefault(_GroupMessageInformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UI_CONTEXT = 'group_message';
	
	var GroupMessage = function (_React$Component) {
	  _inherits(GroupMessage, _React$Component);
	
	  function GroupMessage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupMessage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupMessage.__proto__ || Object.getPrototypeOf(GroupMessage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hoverAction: false
	    }, _this.sendAgain = function () {
	      window.scrollTo(0, 0);
	      _GroupActions2.default.sendAgainGroupMessage(_this.props.groupId, _this.props.message);
	    }, _this.tweet = function () {
	      var message = _this.props.message;
	
	
	      var text = message.getBody();
	      message.getFiles().forEach(function (file) {
	        var fileUrl = file.getUrls().large || file.getUrls().cdn;
	        text += ' ' + fileUrl;
	      });
	      text += ' (via remind.com)';
	
	      var encodedText = encodeURIComponent(text);
	      var url = 'https://twitter.com/intent/tweet?text=' + encodedText;
	
	      (0, _openPopup2.default)(url, 'twitter');
	    }, _this.renderHeaderActions = function () {
	      var menu = _react2.default.createElement(
	        _Menu2.default,
	        null,
	        !_CurrentUser2.default.getUser().isUnderage() && _react2.default.createElement(
	          _MenuItem2.default,
	          { onClick: function onClick() {
	              return _this.tweet();
	            } },
	          'Tweet'
	        ),
	        _react2.default.createElement(
	          _MenuItem2.default,
	          { onClick: function onClick() {
	              return _this.sendAgain();
	            } },
	          'Send again'
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'GroupMessageBase-headerActions' },
	        _react2.default.createElement(
	          _LayerTrigger2.default,
	          {
	            layer: menu,
	            trigger: 'click',
	            placement: 'bottom',
	            alignment: 'middle' },
	          _react2.default.createElement(_Glyph2.default, { color: 'koala', name: 'ellipses', size: 'large', solo: true })
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupMessage, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        eventContextName: UI_CONTEXT
	      };
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      // 'message' never changes deeply, but it may get a new object even when
	      // nothing changes. So this is safe, but not maximally performant.
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var message = this.props.message;
	
	      return _react2.default.createElement(
	        _GroupMessageBase2.default,
	        {
	          className: 'GroupMessage',
	          message: this.props.message,
	          border: this.props.border,
	          backgroundColor: this.props.backgroundColor },
	        _react2.default.createElement(
	          _GroupMessageHeader2.default,
	          {
	            ref: 'header',
	            author: message && message.getSender().getName(),
	            initials: message && message.getSender().getInitials(),
	            color: message && message.getSender().getColor(),
	            senderId: message && message.getSender().id,
	            iconUrl: this.props.iconUrl },
	          this.props.groupIsOwnedByUser && this.renderHeaderActions()
	        ),
	        _react2.default.createElement(_GroupMessageContent2.default, null),
	        _react2.default.createElement(_GroupMessageInformation2.default, { showReadReceipt: this.props.showReadReceipt })
	      );
	    }
	  }]);
	
	  return GroupMessage;
	}(_react2.default.Component);
	
	GroupMessage.childContextTypes = {
	  eventContextName: _react2.default.PropTypes.string
	};
	GroupMessage.defaultProps = {
	  border: true,
	  iconUrl: null,
	  showReadReceipt: true
	};
	GroupMessage.displayName = 'GroupMessage';
	exports.default = GroupMessage;

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1242);

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(1243);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	module.exports = shallowCompare;

/***/ },
/* 1243 */
414,
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// typecheck: ignore file
	
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LayerAutoFocus = __webpack_require__(1209);
	
	var _LayerAutoFocus2 = _interopRequireDefault(_LayerAutoFocus);
	
	var _Layer = __webpack_require__(1158);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	__webpack_require__(1245);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = _react2.default.createClass({
	  displayName: 'Menu',
	
	
	  mixins: [_LayerAutoFocus2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      selectedKey: '',
	      horizontal: false
	    };
	  },
	  handleMenuItemSelect: function handleMenuItemSelect(key) {
	    if (this.props.onSelect) {
	      this.props.onSelect(key);
	    }
	  },
	  renderMenuItem: function renderMenuItem(menuItem) {
	    if (menuItem === null) {
	      return null;
	    }
	
	    var key = menuItem.props.menuKey || menuItem.key;
	    return _react2.default.cloneElement(menuItem, {
	      ref: menuItem.ref,
	      menuKey: key,
	      onClick: (0, _createChainedFunction2.default)(menuItem.props.onClick, this.props.onRequestHide),
	      onSelect: (0, _createChainedFunction2.default)(menuItem.props.onSelect, this.handleMenuItemSelect),
	      selected: this.props.selectedKey ? this.props.selectedKey === key : null
	    });
	  },
	  renderTitle: function renderTitle() {
	    var title = this.props.title;
	
	    if (!title) {
	      return null;
	    }
	    return _react2.default.createElement(
	      'h2',
	      { className: 'Menu-title' },
	      title
	    );
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _Layer2.default,
	      _extends({
	        propagateOutsideClicks: false
	      }, this.props, {
	        className: (0, _classnames2.default)({
	          Menu: true,
	          'Menu--horizontal': this.props.horizontal
	        }, this.props.className) }),
	      _react2.default.createElement(
	        'div',
	        { className: 'Menu-dropdown' },
	        this.renderTitle(),
	        _react2.default.createElement(
	          'ul',
	          { className: 'Menu-list' },
	          _react2.default.Children.map(this.props.children, this.renderMenuItem)
	        )
	      )
	    );
	  }
	});
	
	exports.default = Menu;

/***/ },
/* 1245 */
1136,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1250);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var MenuItem = function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  function MenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.disabled) {
	        event.preventDefault();
	      }
	
	      if (_this.props.disabled) {
	        return;
	      }
	
	      if (_this.props.selected) {
	        return;
	      }
	
	      if (_this.props.onSelect) {
	        _this.props.onSelect(_this.props.menuKey);
	      }
	
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // typecheck: ignore statement
	
	
	  _createClass(MenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          others = _objectWithoutProperties(_props, ['className']);
	
	      return _react2.default.createElement(
	        'li',
	        {
	          className: (0, _classnames2.default)('MenuItem', {
	            'MenuItem--selectable': typeof this.props.selected === 'boolean',
	            'MenuItem--selected': !!this.props.selected,
	            'MenuItem--disabled': this.props.disabled
	          }, className) },
	        _react2.default.createElement(
	          _Link2.default,
	          _extends({}, others, {
	            color: !this.props.selected && 'thunder',
	            className: 'MenuItem-link',
	            eventScreenName: this.props.eventScreenName,
	            eventElementName: this.props.eventElementName,
	            eventProperties: this.props.eventProperties,
	            onClick: this.handleClick }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return MenuItem;
	}(_react2.default.Component);
	
	MenuItem.defaultProps = {
	  disabled: false,
	  value: null,
	  selected: null
	};
	MenuItem.displayName = 'MenuItem';
	exports.default = MenuItem;

/***/ },
/* 1250 */
1136,
/* 1251 */,
/* 1252 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	var defaults = {
	  width: 500,
	  height: 400,
	  menubar: 0,
	  scrollbars: 0,
	  location: 0,
	  left: function left() {
	    return window.screen.width / 2 - this.width / 2;
	  },
	  top: function top() {
	    return window.screen.height / 2 - this.height / 2;
	  }
	};
	
	function openPopup(url, name) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var buildParams = function buildParams(obj) {
	    return Object.keys(obj).map(function (key) {
	      var val = typeof obj[key] === 'function' ? obj[key].call(obj) : obj[key];
	      return key + '=' + val;
	    }).join(',');
	  };
	
	  var defaultedOptions = Object.assign({}, defaults, options);
	
	  window.open(url, name, buildParams(defaultedOptions));
	}
	
	exports.default = openPopup;

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1254);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupMessageBase = function (_React$Component) {
	  _inherits(GroupMessageBase, _React$Component);
	
	  function GroupMessageBase() {
	    _classCallCheck(this, GroupMessageBase);
	
	    return _possibleConstructorReturn(this, (GroupMessageBase.__proto__ || Object.getPrototypeOf(GroupMessageBase)).apply(this, arguments));
	  }
	
	  _createClass(GroupMessageBase, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        message: this.props.message
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {};
	      if (this.props.backgroundColor) {
	        style = Object.assign(style, {
	          backgroundColor: this.props.backgroundColor
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('GroupMessageBase', this.props.className) },
	        _react2.default.createElement(
	          'div',
	          _extends({}, this.props, {
	            style: style,
	            className: (0, _classnames2.default)({
	              'GroupMessageBase-card': true,
	              'GroupMessageBase-bordered': this.props.border,
	              'GroupMessageBase-failed': this.props.message.getStatus() === 'failed'
	            }) }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return GroupMessageBase;
	}(_react2.default.Component);
	
	GroupMessageBase.contextTypes = {
	  group: _react2.default.PropTypes.instanceOf(_Group2.default)
	};
	GroupMessageBase.childContextTypes = {
	  message: _react2.default.PropTypes.instanceOf(_Message2.default).isRequired
	};
	GroupMessageBase.displayName = 'GroupMessageBase';
	exports.default = GroupMessageBase;

/***/ },
/* 1254 */
1136,
/* 1255 */,
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FileContentPreview = __webpack_require__(1257);
	
	var _FileContentPreview2 = _interopRequireDefault(_FileContentPreview);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TranslatableText = __webpack_require__(1300);
	
	var _TranslatableText2 = _interopRequireDefault(_TranslatableText);
	
	var _TranslationCTA = __webpack_require__(1302);
	
	var _TranslationCTA2 = _interopRequireDefault(_TranslationCTA);
	
	__webpack_require__(1303);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupMessageContent = function (_React$Component) {
	  _inherits(GroupMessageContent, _React$Component);
	
	  function GroupMessageContent() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupMessageContent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupMessageContent.__proto__ || Object.getPrototypeOf(GroupMessageContent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      language: _this.context.message.getISO639Locale()
	    }, _this.isTranslatable = function () {
	      return _this.state.language && _this.context.group && _CurrentUser2.default.isSignedIn() && _this.context.message.getISO639Locale() && _CurrentUser2.default.getUser().getISO639Locale() && _CurrentUser2.default.getUser().getISO639Locale() !== _this.context.message.getISO639Locale() && !_this.context.group.isOwnedByUser(_CurrentUser2.default.getUserId());
	    }, _this.translate = function () {
	      if (_this.isTranslatable()) {
	        _this.refs.translationCTA.toggle();
	      }
	    }, _this.renderAttachments = function () {
	      var message = _this.context.message;
	
	
	      if (message.getFiles().length === 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'GroupMessageContent-attachments' },
	        message.getFiles().map(function (file) {
	          return _react2.default.createElement(_FileContentPreview2.default, { file: file, key: file.id });
	        })
	      );
	    }, _this.renderMessage = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'GroupMessageContent-body' },
	        _react2.default.createElement(
	          'div',
	          {
	            onClick: _this.translate,
	            className: (0, _classnames2.default)('GroupMessageContent-body-text', { 'GroupMessageContent-body-translatable': _this.isTranslatable() }) },
	          _react2.default.createElement(_TranslatableText2.default, {
	            language: _this.state.language,
	            text: _this.context.message.getBody(),
	            onLanguageChanged: function onLanguageChanged() {
	              return _this.refs.translationCTA.translated();
	            }
	          })
	        ),
	        _this.isTranslatable() && _react2.default.createElement(_TranslationCTA2.default, {
	          ref: 'translationCTA',
	          className: 'GroupMessageContent-translationCTA',
	          originLanguage: _this.context.message.getISO639Locale(),
	          onLanguageChange: function onLanguageChange(language) {
	            return _this.setState({ language: language });
	          }
	        })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupMessageContent, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'GroupMessageContent' },
	        this.renderMessage(),
	        this.renderAttachments()
	      );
	    }
	  }]);
	
	  return GroupMessageContent;
	}(_react2.default.Component);
	
	GroupMessageContent.contextTypes = {
	  message: _react2.default.PropTypes.instanceOf(_Message2.default).isRequired,
	  group: _react2.default.PropTypes.instanceOf(_Group2.default)
	};
	GroupMessageContent.displayName = 'GroupMessageContent';
	exports.default = GroupMessageContent;

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FileContentPreview = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Audio = __webpack_require__(1258);
	
	var _Audio2 = _interopRequireDefault(_Audio);
	
	var _FileImagePreview = __webpack_require__(1270);
	
	var _FileImagePreview2 = _interopRequireDefault(_FileImagePreview);
	
	var _FilePreview = __webpack_require__(1292);
	
	var _FilePreview2 = _interopRequireDefault(_FilePreview);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Video = __webpack_require__(1297);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FileAudioPreview = function FileAudioPreview(_ref) {
	  var file = _ref.file;
	  return (// eslint-disable-line object-curly-spacing
	    _react2.default.createElement(_Audio2.default, {
	      src: file.getUrls().cdn,
	      file: file,
	      key: file.id
	    })
	  );
	};
	
	var FileVideoPreview = function FileVideoPreview(_ref2) {
	  var file = _ref2.file;
	  return (// eslint-disable-line object-curly-spacing
	    _react2.default.createElement(_Video2.default, {
	      src: file.getUrls().cdn,
	      file: file,
	      key: file.id
	    })
	  );
	};
	
	var FileContentPreview = exports.FileContentPreview = function (_React$Component) {
	  _inherits(FileContentPreview, _React$Component);
	
	  function FileContentPreview() {
	    var _ref3;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FileContentPreview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = FileContentPreview.__proto__ || Object.getPrototypeOf(FileContentPreview)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
	      mounted: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FileContentPreview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // We want to set this state after mount so the first render matches the server's.
	      /* eslint-disable react/no-did-mount-set-state */
	      this.setState({ mounted: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var file = this.props.file;
	
	      var contentType = file.getContentType();
	
	      if (_Image2.default.isSupportedType(contentType)) {
	        return _react2.default.createElement(_FileImagePreview2.default, { file: file });
	      }
	
	      // These previews render differently in browser and Node. So React can
	      // match client to server DOMs we have to wait until mounted to change it.
	      // TODO continue refactoring to move this concern into <FileAudioPreview> and <FileVideoPreview>
	      if (this.state.mounted) {
	        if (_Audio2.default.isSupportedType(contentType)) {
	          return _react2.default.createElement(FileAudioPreview, { file: file });
	        } else if (_Video2.default.isSupportedType(contentType)) {
	          return _react2.default.createElement(FileVideoPreview, { file: file });
	        }
	      }
	
	      return _react2.default.createElement(_FilePreview2.default, { file: file, key: file.id });
	    }
	  }]);
	
	  return FileContentPreview;
	}(_react2.default.Component);
	
	FileContentPreview.displayName = 'FileContentPreview';
	exports.default = FileContentPreview;

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _File = __webpack_require__(929);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _MediaPlayer = __webpack_require__(1259);
	
	var _MediaPlayer2 = _interopRequireDefault(_MediaPlayer);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AudioSupport = __webpack_require__(1268);
	
	var _lodash = __webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Inline HTML5 audio player.
	 *
	 * Use `Audio.isSupportedType(type)` to check whether the audio file  can be played inline on the
	 * user's browser.
	 *
	 * ```example
	 * <Audio src="https://www.remind.com/assets/audio/pn.mp3" />
	 * ```
	 */
	var Audio = function (_React$Component) {
	  _inherits(Audio, _React$Component);
	
	  function Audio() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Audio);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Audio.__proto__ || Object.getPrototypeOf(Audio)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      id: (0, _lodash.uniqueId)()
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Audio, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Audio' },
	        _react2.default.createElement(
	          'audio',
	          { id: this.state.id, src: this.props.src },
	          'Your browser does not support the ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'audio'
	          ),
	          ' element.'
	        ),
	        _react2.default.createElement(_MediaPlayer2.default, {
	          playerId: this.state.id,
	          theme: 'light',
	          src: this.props.src,
	          file: this.props.file
	        })
	      );
	    }
	  }]);
	
	  return Audio;
	}(_react2.default.Component);
	
	Audio.isSupportedType = _AudioSupport.isSupportedType;
	Audio.displayName = 'Audio';
	exports.default = Audio;

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveMixin = __webpack_require__(1260);
	
	var _ResponsiveMixin2 = _interopRequireDefault(_ResponsiveMixin);
	
	var _Slider = __webpack_require__(1261);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _formatMediaTime = __webpack_require__(1265);
	
	var _formatMediaTime2 = _interopRequireDefault(_formatMediaTime);
	
	__webpack_require__(1266);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaPlayer = _react2.default.createClass({
	  displayName: 'MediaPlayer',
	
	
	  mixins: [_ResponsiveMixin2.default],
	
	  statics: {
	    propClasses: {
	      theme: {
	        light: 'MediaPlayer-light',
	        dark: 'MediaPlayer-dark'
	      },
	      fullscreen: 'MediaPlayer-fullscreenEnabled'
	    },
	    SMALL: 440
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      fullscreen: false,
	      downloadable: true
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      playing: false,
	      wasPlaying: false,
	      currentTime: 0,
	      totalTime: 0,
	      muted: false,
	      volume: 1.0
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var player = this.getPlayer();
	
	    if (player.tagName === 'VIDEO') {
	      player.addEventListener('click', this.togglePlayback, false);
	    }
	    player.addEventListener('durationchange', this.onDurationChange, false);
	    player.addEventListener('timeupdate', this.onTimeUpdate, false);
	    player.addEventListener('volumechange', this.onVolumeChange, false);
	    player.addEventListener('play', this.onPlay, false);
	    player.addEventListener('pause', this.onPause, false);
	    player.addEventListener('ended', this.onEnded, false);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var player = this.getPlayer();
	
	    if (player.tagName === 'VIDEO') {
	      player.removeEventListener('click', this.togglePlayback, false);
	    }
	    player.removeEventListener('durationchange', this.onDurationChange, false);
	    player.removeEventListener('timeupdate', this.onTimeUpdate, false);
	    player.removeEventListener('volumechange', this.onVolumeChange, false);
	    player.removeEventListener('play', this.onPlay, false);
	    player.removeEventListener('pause', this.onPause, false);
	    player.removeEventListener('ended', this.onEnded, false);
	  },
	  onAfterChangePlayback: function onAfterChangePlayback() {
	    if (this.state.wasPlaying) {
	      this.play();
	    }
	  },
	  onBeforeChangePlayback: function onBeforeChangePlayback() {
	    this.setState(function (_ref) {
	      var playing = _ref.playing;
	      return { wasPlaying: playing, playing: false };
	    });
	    this.pause();
	  },
	  onChangePlayback: function onChangePlayback(value) {
	    this.getPlayer().currentTime = value;
	  },
	  onChangeVolume: function onChangeVolume(value) {
	    this.getPlayer().volume = value;
	  },
	  onDurationChange: function onDurationChange() {
	    this.setState({ totalTime: this.getPlayer().duration });
	  },
	  onEnded: function onEnded() {
	    this.setState({ playing: false });
	  },
	  onPause: function onPause() {
	    if (this.state.playing) {
	      this.setState({ playing: false });
	    }
	  },
	  onPlay: function onPlay() {
	    this.setState({ playing: true });
	  },
	  onTimeUpdate: function onTimeUpdate() {
	    this.setState({ currentTime: this.getPlayer().currentTime });
	  },
	  onVolumeChange: function onVolumeChange(event) {
	    if (this.state.muted !== event.target.muted) {
	      // Mute was changed
	      this.setState({ muted: event.target.muted });
	    } else {
	      // Volume was changed
	      if (event.target.volume === 0.0) {
	        this.mute();
	      } else {
	        this.unmute();
	      }
	
	      this.setState({ volume: event.target.volume });
	    }
	  },
	  getButtonColor: function getButtonColor() {
	    return this.props.theme === 'dark' ? 'white' : 'brand';
	  },
	  getPlayer: function getPlayer() {
	    return document.getElementById(this.props.playerId);
	  },
	  makeFullscreen: function makeFullscreen() {
	    var player = this.getPlayer();
	
	    if (player.requestFullscreen) {
	      player.requestFullscreen();
	    } else if (player.msRequestFullscreen) {
	      player.msRequestFullscreen();
	    } else if (player.mozRequestFullScreen) {
	      player.mozRequestFullScreen();
	    } else if (player.webkitRequestFullscreen) {
	      player.webkitRequestFullscreen();
	    }
	  },
	  mute: function mute() {
	    this.getPlayer().muted = true;
	  },
	  pause: function pause() {
	    this.getPlayer().pause();
	  },
	  play: function play() {
	    this.getPlayer().play();
	  },
	  toggleMute: function toggleMute() {
	    if (this.state.muted) {
	      this.unmute();
	    } else {
	      this.mute();
	    }
	  },
	  togglePlayback: function togglePlayback() {
	    if (this.state.playing) {
	      this.pause();
	    } else {
	      this.play();
	    }
	  },
	  unmute: function unmute() {
	    this.getPlayer().muted = false;
	  },
	  renderDownload: function renderDownload() {
	    if (!this.props.downloadable) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      _Button2.default,
	      {
	        download: true,
	        href: this.props.src,
	        className: 'MediaPlayer-download',
	        level: 'icon',
	        color: this.getButtonColor(),
	        tooltip: 'Download',
	        tooltipPlacement: 'bottom',
	        eventElementName: 'MediaPlayer-download' },
	      _react2.default.createElement(_Glyph2.default, { name: 'download', size: 'medium', solo: true })
	    );
	  },
	  renderFullscreen: function renderFullscreen() {
	    if (!this.props.fullscreen) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      _Button2.default,
	      {
	        className: 'MediaPlayer-fullscreen',
	        level: 'icon',
	        color: this.getButtonColor(),
	        onClick: this.makeFullscreen,
	        tooltip: 'Fullscreen',
	        tooltipPlacement: 'bottom',
	        eventElementName: 'MediaPlayer-fullscreen' },
	      _react2.default.createElement(_Glyph2.default, { name: 'fullscreen', size: 'medium', solo: true })
	    );
	  },
	  renderPlayback: function renderPlayback() {
	    var glyphName = this.state.playing ? 'pause' : 'play';
	
	    return _react2.default.createElement(
	      _Button2.default,
	      {
	        className: 'MediaPlayer-playback',
	        level: 'icon',
	        color: this.getButtonColor(),
	        onClick: this.togglePlayback,
	        eventElementName: 'MediaPlayer-playback' },
	      _react2.default.createElement(_Glyph2.default, { name: glyphName, size: 'large', solo: true })
	    );
	  },
	  renderPlaybackSlider: function renderPlaybackSlider() {
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)({
	          'MediaPlayer-playbackSlider': true,
	          'MediaPlayer-playbackSliderSmall': this.isComponentSize(MediaPlayer.SMALL)
	        }) },
	      _react2.default.createElement(_Slider2.default, {
	        min: 0,
	        max: this.state.totalTime,
	        step: 0.1,
	        value: this.state.currentTime,
	        onBeforeChange: this.onBeforeChangePlayback,
	        onChange: this.onChangePlayback,
	        onAfterChange: this.onAfterChangePlayback,
	        theme: this.props.theme,
	        size: 'thick'
	      })
	    );
	  },
	  renderTime: function renderTime() {
	    var showHours = parseInt(this.state.totalTime / 3600, 10) > 0;
	
	    if (this.isComponentSize(MediaPlayer.SMALL)) {
	      return this.renderTimeSmall(showHours);
	    }
	
	    return this.renderTimeNormal(showHours);
	  },
	  renderTimeNormal: function renderTimeNormal(showHours) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'MediaPlayer-time' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'MediaPlayer-currentTime' },
	          (0, _formatMediaTime2.default)(this.state.currentTime, showHours)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'MediaPlayer-timeDivider' },
	          '/'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'MediaPlayer-totalTime' },
	          (0, _formatMediaTime2.default)(this.state.totalTime, showHours)
	        )
	      )
	    );
	  },
	  renderTimeSmall: function renderTimeSmall(showHours) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'MediaPlayer-time MediaPlayer-timeSmall' },
	      _react2.default.createElement(
	        'div',
	        { className: 'MediaPlayer-currentTime' },
	        (0, _formatMediaTime2.default)(this.state.currentTime, showHours)
	      )
	    );
	  },
	  renderVolume: function renderVolume() {
	    if (this.isComponentSize(MediaPlayer.SMALL)) {
	      return null;
	    }
	
	    var tooltipMessage = 'Mute';
	    var volume = void 0;
	    if (this.state.muted || this.state.volume === 0.0) {
	      tooltipMessage = 'Unmute';
	      volume = 'mute';
	    } else if (this.state.volume < 0.33) {
	      volume = '1';
	    } else if (this.state.volume < 0.67) {
	      volume = '2';
	    } else {
	      volume = '3';
	    }
	
	    return _react2.default.createElement(
	      _Button2.default,
	      {
	        className: 'MediaPlayer-volume',
	        level: 'icon',
	        color: this.getButtonColor(),
	        onClick: this.toggleMute,
	        tooltip: tooltipMessage,
	        tooltipPlacement: 'bottom',
	        eventElementName: 'MediaPlayer-volume' },
	      _react2.default.createElement(_Glyph2.default, { name: 'audio-level-' + volume, size: 'large', solo: true })
	    );
	  },
	  renderVolumeSlider: function renderVolumeSlider() {
	    if (this.isComponentSize(MediaPlayer.SMALL)) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'MediaPlayer-volumeSlider' },
	      _react2.default.createElement(_Slider2.default, {
	        min: 0.0,
	        max: 1.0,
	        step: 0.1,
	        value: this.state.muted ? 0.0 : this.state.volume,
	        onChange: this.onChangeVolume,
	        theme: this.props.theme,
	        size: 'thin'
	      })
	    );
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('MediaPlayer', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className) },
	      this.renderPlayback(),
	      this.renderPlaybackSlider(),
	      this.renderTime(),
	      this.renderVolume(),
	      this.renderVolumeSlider(),
	      this.renderDownload(),
	      this.renderFullscreen()
	    );
	  }
	}); /*  weak */
	exports.default = MediaPlayer;

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠
	// DEPRECATED USE lib/withWidth
	// ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠
	
	var stack = []; /*  weak */
	
	
	var NORMAL_SIZE = 'NORMAL_SIZE';
	
	function _getComponentSize(component) {
	  var element = _reactDom2.default.findDOMNode(component);
	
	  if (element) {
	    var ctor = component.constructor;
	    if (ctor.XXSMALL && element.offsetWidth <= ctor.XXSMALL) {
	      return ctor.XXSMALL;
	    } else if (ctor.XSMALL && element.offsetWidth <= ctor.XSMALL) {
	      return ctor.XSMALL;
	    } else if (ctor.SMALL && element.offsetWidth <= ctor.SMALL) {
	      return ctor.SMALL;
	    } else if (ctor.MEDIUM && element.offsetWidth <= ctor.MEDIUM) {
	      return ctor.MEDIUM;
	    } else if (ctor.LARGE && element.offsetWidth <= ctor.LARGE) {
	      return ctor.LARGE;
	    }
	  }
	
	  return NORMAL_SIZE;
	}
	
	function _handleResize() {
	  stack.forEach(function (component) {
	    var size = _getComponentSize(component);
	    if (component._responsiveSize === size) {
	      return;
	    }
	
	    component._responsiveSize = size;
	  });
	}
	
	/*
	  Dependencies:
	  The component should contain at least one of [SMALL, MEDIUM, LARGE] as
	  attributes in its statics object. Their values should be numbers that
	  represent the max-width of the component's size state.
	*/
	var ResponsiveMixin = {
	  componentWillMount: function componentWillMount() {
	    this._responsiveSize = NORMAL_SIZE;
	  },
	  componentDidMount: function componentDidMount() {
	    if (stack.length === 0) {
	      window.addEventListener('resize', _handleResize);
	    }
	
	    stack.push(this);
	
	    // Set the actual inital size after it has mounted
	    this._responsiveSize = _getComponentSize(this);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var index = stack.indexOf(this);
	    if (index >= 0) {
	      stack.splice(index, 1);
	
	      if (stack.length === 0) {
	        window.removeEventListener('resize', _handleResize);
	      }
	    }
	  },
	  hasResized: function hasResized() {
	    _handleResize();
	  },
	  getComponentSize: function getComponentSize() {
	    return this._responsiveSize;
	  },
	  isComponentSize: function isComponentSize(size) {
	    return this.getComponentSize() === size;
	  },
	  isComponentSizes: function isComponentSizes(sizes) {
	    return sizes.indexOf(this.getComponentSize()) > -1;
	  }
	};
	
	exports.default = ResponsiveMixin;

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlider = __webpack_require__(1262);
	
	var _reactSlider2 = _interopRequireDefault(_reactSlider);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1263);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Slider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Slider.__proto__ || Object.getPrototypeOf(Slider)).call.apply(_ref, [this].concat(args))), _this), _this._slider = null, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Slider, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this._slider && this.props.max !== prevProps.max) {
	        this._slider._handleResize();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(_reactSlider2.default, {
	        ref: function ref(c) {
	          return _this2._slider = c;
	        },
	        className: (0, _classnames2.default)('Slider', (0, _getPropClasses.getPropClassesFromInstance)(this)),
	        min: this.props.min,
	        max: this.props.max,
	        step: this.props.step,
	        value: this.props.value,
	        orientation: 'horizontal',
	        withBars: true,
	        onBeforeChange: this.props.onBeforeChange,
	        onChange: this.props.onChange,
	        onAfterChange: this.props.onAfterChange
	      });
	    }
	  }]);
	
	  return Slider;
	}(_react2.default.Component);
	
	Slider.propClasses = {
	  theme: {
	    light: 'Slider-light',
	    dark: 'Slider-dark'
	  },
	  size: {
	    thick: 'Slider-thick',
	    thin: 'Slider-thin'
	  }
	};
	Slider.defaultProps = {
	  step: 1
	};
	Slider.displayName = 'Slider';
	exports.default = Slider;

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(299)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory(require('react'));
	  } else {
	    root.ReactSlider = factory(root.React);
	  }
	}(this, function (React) {
	
	  /**
	   * To prevent text selection while dragging.
	   * http://stackoverflow.com/questions/5429827/how-can-i-prevent-text-element-selection-with-cursor-drag
	   */
	  function pauseEvent(e) {
	    if (e.stopPropagation) e.stopPropagation();
	    if (e.preventDefault) e.preventDefault();
	    return false;
	  }
	
	  function stopPropagation(e) {
	    if (e.stopPropagation) e.stopPropagation();
	  }
	
	  /**
	   * Spreads `count` values equally between `min` and `max`.
	   */
	  function linspace(min, max, count) {
	    var range = (max - min) / (count - 1);
	    var res = [];
	    for (var i = 0; i < count; i++) {
	      res.push(min + range * i);
	    }
	    return res;
	  }
	
	  function ensureArray(x) {
	    return x == null ? [] : Array.isArray(x) ? x : [x];
	  }
	
	  function undoEnsureArray(x) {
	    return x != null && x.length === 1 ? x[0] : x;
	  }
	
	  // undoEnsureArray(ensureArray(x)) === x
	
	  var ReactSlider = React.createClass({
	    displayName: 'ReactSlider',
	
	    propTypes: {
	
	      /**
	       * The minimum value of the slider.
	       */
	      min: React.PropTypes.number,
	
	      /**
	       * The maximum value of the slider.
	       */
	      max: React.PropTypes.number,
	
	      /**
	       * Value to be added or subtracted on each step the slider makes.
	       * Must be greater than zero.
	       * `max - min` should be evenly divisible by the step value.
	       */
	      step: React.PropTypes.number,
	
	      /**
	       * The minimal distance between any pair of handles.
	       * Must be positive, but zero means they can sit on top of each other.
	       */
	      minDistance: React.PropTypes.number,
	
	      /**
	       * Determines the initial positions of the handles and the number of handles if the component has no children.
	       *
	       * If a number is passed a slider with one handle will be rendered.
	       * If an array is passed each value will determine the position of one handle.
	       * The values in the array must be sorted.
	       * If the component has children, the length of the array must match the number of children.
	       */
	      defaultValue: React.PropTypes.oneOfType([
	        React.PropTypes.number,
	        React.PropTypes.arrayOf(React.PropTypes.number)
	      ]),
	
	      /**
	       * Like `defaultValue` but for [controlled components](http://facebook.github.io/react/docs/forms.html#controlled-components).
	       */
	      value: React.PropTypes.oneOfType([
	        React.PropTypes.number,
	        React.PropTypes.arrayOf(React.PropTypes.number)
	      ]),
	
	      /**
	       * Determines whether the slider moves horizontally (from left to right) or vertically (from top to bottom).
	       */
	      orientation: React.PropTypes.oneOf(['horizontal', 'vertical']),
	
	      /**
	       * The css class set on the slider node.
	       */
	      className: React.PropTypes.string,
	
	      /**
	       * The css class set on each handle node.
	       *
	       * In addition each handle will receive a numbered css class of the form `${handleClassName}-${i}`,
	       * e.g. `handle-0`, `handle-1`, ...
	       */
	      handleClassName: React.PropTypes.string,
	
	      /**
	       * The css class set on the handle that is currently being moved.
	       */
	      handleActiveClassName: React.PropTypes.string,
	
	      /**
	       * If `true` bars between the handles will be rendered.
	       */
	      withBars: React.PropTypes.bool,
	
	      /**
	       * The css class set on the bars between the handles.
	       * In addition bar fragment will receive a numbered css class of the form `${barClassName}-${i}`,
	       * e.g. `bar-0`, `bar-1`, ...
	       */
	      barClassName: React.PropTypes.string,
	
	      /**
	       * If `true` the active handle will push other handles
	       * within the constraints of `min`, `max`, `step` and `minDistance`.
	       */
	      pearling: React.PropTypes.bool,
	
	      /**
	       * If `true` the handles can't be moved.
	       */
	      disabled: React.PropTypes.bool,
	
	      /**
	       * Disables handle move when clicking the slider bar
	       */
	      snapDragDisabled: React.PropTypes.bool,
	
	      /**
	       * Inverts the slider.
	       */
	      invert: React.PropTypes.bool,
	
	      /**
	       * Callback called before starting to move a handle.
	       */
	      onBeforeChange: React.PropTypes.func,
	
	      /**
	       * Callback called on every value change.
	       */
	      onChange: React.PropTypes.func,
	
	      /**
	       * Callback called only after moving a handle has ended.
	       */
	      onAfterChange: React.PropTypes.func,
	
	      /**
	       *  Callback called when the the slider is clicked (handle or bars).
	       *  Receives the value at the clicked position as argument.
	       */
	      onSliderClick: React.PropTypes.func
	    },
	
	    getDefaultProps: function () {
	      return {
	        min: 0,
	        max: 100,
	        step: 1,
	        minDistance: 0,
	        defaultValue: 0,
	        orientation: 'horizontal',
	        className: 'slider',
	        handleClassName: 'handle',
	        handleActiveClassName: 'active',
	        barClassName: 'bar',
	        withBars: false,
	        pearling: false,
	        disabled: false,
	        snapDragDisabled: false,
	        invert: false
	      };
	    },
	
	    getInitialState: function () {
	      var value = this._or(ensureArray(this.props.value), ensureArray(this.props.defaultValue));
	
	      // reused throughout the component to store results of iterations over `value`
	      this.tempArray = value.slice();
	
	      // array for storing resize timeouts ids
	      this.pendingResizeTimeouts = [];
	
	      var zIndices = [];
	      for (var i = 0; i < value.length; i++) {
	        value[i] = this._trimAlignValue(value[i], this.props);
	        zIndices.push(i);
	      }
	
	      return {
	        index: -1,
	        upperBound: 0,
	        sliderLength: 0,
	        value: value,
	        zIndices: zIndices
	      };
	    },
	
	    // Keep the internal `value` consistent with an outside `value` if present.
	    // This basically allows the slider to be a controlled component.
	    componentWillReceiveProps: function (newProps) {
	      var value = this._or(ensureArray(newProps.value), this.state.value);
	
	      // ensure the array keeps the same size as `value`
	      this.tempArray = value.slice();
	
	      for (var i = 0; i < value.length; i++) {
	        this.state.value[i] = this._trimAlignValue(value[i], newProps);
	      }
	      if (this.state.value.length > value.length)
	        this.state.value.length = value.length;
	
	      // If an upperBound has not yet been determined (due to the component being hidden
	      // during the mount event, or during the last resize), then calculate it now
	      if (this.state.upperBound === 0) {
	        this._handleResize();
	      }
	    },
	
	    // Check if the arity of `value` or `defaultValue` matches the number of children (= number of custom handles).
	    // If no custom handles are provided, just returns `value` if present and `defaultValue` otherwise.
	    // If custom handles are present but neither `value` nor `defaultValue` are applicable the handles are spread out
	    // equally.
	    // TODO: better name? better solution?
	    _or: function (value, defaultValue) {
	      var count = React.Children.count(this.props.children);
	      switch (count) {
	        case 0:
	          return value.length > 0 ? value : defaultValue;
	        case value.length:
	          return value;
	        case defaultValue.length:
	          return defaultValue;
	        default:
	          if (value.length !== count || defaultValue.length !== count) {
	            console.warn(this.constructor.displayName + ": Number of values does not match number of children.");
	          }
	          return linspace(this.props.min, this.props.max, count);
	      }
	    },
	
	    componentDidMount: function () {
	      window.addEventListener('resize', this._handleResize);
	      this._handleResize();
	    },
	
	    componentWillUnmount: function () {
	      this._clearPendingResizeTimeouts();
	      window.removeEventListener('resize', this._handleResize);
	    },
	
	    getValue: function () {
	      return undoEnsureArray(this.state.value);
	    },
	
	    _handleResize: function () {
	      // setTimeout of 0 gives element enough time to have assumed its new size if it is being resized
	      var resizeTimeout = window.setTimeout(function() {
	        // drop this timeout from pendingResizeTimeouts to reduce memory usage
	        this.pendingResizeTimeouts.shift();
	
	        var slider = this.refs.slider;
	        var handle = this.refs.handle0;
	        var rect = slider.getBoundingClientRect();
	
	        var size = this._sizeKey();
	
	        var sliderMax = rect[this._posMaxKey()];
	        var sliderMin = rect[this._posMinKey()];
	
	        this.setState({
	          upperBound: slider[size] - handle[size],
	          sliderLength: Math.abs(sliderMax - sliderMin),
	          handleSize: handle[size],
	          sliderStart: this.props.invert ? sliderMax : sliderMin
	        });
	      }.bind(this), 0);
	
	      this.pendingResizeTimeouts.push(resizeTimeout);
	    },
	
	    // clear all pending timeouts to avoid error messages after unmounting
	    _clearPendingResizeTimeouts: function() {
	      do {
	        var nextTimeout = this.pendingResizeTimeouts.shift();
	
	        clearTimeout(nextTimeout);
	      } while (this.pendingResizeTimeouts.length);
	    },
	
	    // calculates the offset of a handle in pixels based on its value.
	    _calcOffset: function (value) {
	      var range = this.props.max - this.props.min;
	      if (range === 0) {
	        return 0;
	      }
	      var ratio = (value - this.props.min) / range;
	      return ratio * this.state.upperBound;
	    },
	
	    // calculates the value corresponding to a given pixel offset, i.e. the inverse of `_calcOffset`.
	    _calcValue: function (offset) {
	      var ratio = offset / this.state.upperBound;
	      return ratio * (this.props.max - this.props.min) + this.props.min;
	    },
	
	    _buildHandleStyle: function (offset, i) {
	      var style = {
	        position: 'absolute',
	        willChange: this.state.index >= 0 ? this._posMinKey() : '',
	        zIndex: this.state.zIndices.indexOf(i) + 1
	      };
	      style[this._posMinKey()] = offset + 'px';
	      return style;
	    },
	
	    _buildBarStyle: function (min, max) {
	      var obj = {
	        position: 'absolute',
	        willChange: this.state.index >= 0 ? this._posMinKey() + ',' + this._posMaxKey() : ''
	      };
	      obj[this._posMinKey()] = min;
	      obj[this._posMaxKey()] = max;
	      return obj;
	    },
	
	    _getClosestIndex: function (pixelOffset) {
	      var minDist = Number.MAX_VALUE;
	      var closestIndex = -1;
	
	      var value = this.state.value;
	      var l = value.length;
	
	      for (var i = 0; i < l; i++) {
	        var offset = this._calcOffset(value[i]);
	        var dist = Math.abs(pixelOffset - offset);
	        if (dist < minDist) {
	          minDist = dist;
	          closestIndex = i;
	        }
	      }
	
	      return closestIndex;
	    },
	
	    _calcOffsetFromPosition: function (position) {
	      var pixelOffset = position - this.state.sliderStart;
	      if (this.props.invert) pixelOffset = this.state.sliderLength - pixelOffset;
	      pixelOffset -= (this.state.handleSize / 2);
	      return pixelOffset;
	    },
	
	    // Snaps the nearest handle to the value corresponding to `position` and calls `callback` with that handle's index.
	    _forceValueFromPosition: function (position, callback) {
	      var pixelOffset = this._calcOffsetFromPosition(position);
	      var closestIndex = this._getClosestIndex(pixelOffset);
	      var nextValue = this._trimAlignValue(this._calcValue(pixelOffset));
	
	      var value = this.state.value.slice(); // Clone this.state.value since we'll modify it temporarily
	      value[closestIndex] = nextValue;
	
	      // Prevents the slider from shrinking below `props.minDistance`
	      for (var i = 0; i < value.length - 1; i += 1) {
	        if (value[i + 1] - value[i] < this.props.minDistance) return;
	      }
	
	      this.setState({value: value}, callback.bind(this, closestIndex));
	    },
	
	    _getMousePosition: function (e) {
	      return [
	        e['page' + this._axisKey()],
	        e['page' + this._orthogonalAxisKey()]
	      ];
	    },
	
	    _getTouchPosition: function (e) {
	      var touch = e.touches[0];
	      return [
	        touch['page' + this._axisKey()],
	        touch['page' + this._orthogonalAxisKey()]
	      ];
	    },
	
	    _getMouseEventMap: function () {
	      return {
	        'mousemove': this._onMouseMove,
	        'mouseup': this._onMouseUp
	      }
	    },
	
	    _getTouchEventMap: function () {
	      return {
	        'touchmove': this._onTouchMove,
	        'touchend': this._onTouchEnd
	      }
	    },
	
	    // create the `mousedown` handler for the i-th handle
	    _createOnMouseDown: function (i) {
	      return function (e) {
	        if (this.props.disabled) return;
	        var position = this._getMousePosition(e);
	        this._start(i, position[0]);
	        this._addHandlers(this._getMouseEventMap());
	        pauseEvent(e);
	      }.bind(this);
	    },
	
	    // create the `touchstart` handler for the i-th handle
	    _createOnTouchStart: function (i) {
	      return function (e) {
	        if (this.props.disabled || e.touches.length > 1) return;
	        var position = this._getTouchPosition(e);
	        this.startPosition = position;
	        this.isScrolling = undefined; // don't know yet if the user is trying to scroll
	        this._start(i, position[0]);
	        this._addHandlers(this._getTouchEventMap());
	        stopPropagation(e);
	      }.bind(this);
	    },
	
	    _addHandlers: function (eventMap) {
	      for (var key in eventMap) {
	        document.addEventListener(key, eventMap[key], false);
	      }
	    },
	
	    _removeHandlers: function (eventMap) {
	      for (var key in eventMap) {
	        document.removeEventListener(key, eventMap[key], false);
	      }
	    },
	
	    _start: function (i, position) {
	      // if activeElement is body window will lost focus in IE9
	      if (document.activeElement && document.activeElement != document.body) {
	        document.activeElement.blur();
	      }
	
	      this.hasMoved = false;
	
	      this._fireChangeEvent('onBeforeChange');
	
	      var zIndices = this.state.zIndices;
	      zIndices.splice(zIndices.indexOf(i), 1); // remove wherever the element is
	      zIndices.push(i); // add to end
	
	      this.setState({
	        startValue: this.state.value[i],
	        startPosition: position,
	        index: i,
	        zIndices: zIndices
	      });
	    },
	
	    _onMouseUp: function () {
	      this._onEnd(this._getMouseEventMap());
	    },
	
	    _onTouchEnd: function () {
	      this._onEnd(this._getTouchEventMap());
	    },
	
	    _onEnd: function (eventMap) {
	      this._removeHandlers(eventMap);
	      this.setState({index: -1}, this._fireChangeEvent.bind(this, 'onAfterChange'));
	    },
	
	    _onMouseMove: function (e) {
	      var position = this._getMousePosition(e);
	      this._move(position[0]);
	    },
	
	    _onTouchMove: function (e) {
	      if (e.touches.length > 1) return;
	
	      var position = this._getTouchPosition(e);
	
	      if (typeof this.isScrolling === 'undefined') {
	        var diffMainDir = position[0] - this.startPosition[0];
	        var diffScrollDir = position[1] - this.startPosition[1];
	        this.isScrolling = Math.abs(diffScrollDir) > Math.abs(diffMainDir);
	      }
	
	      if (this.isScrolling) {
	        this.setState({index: -1});
	        return;
	      }
	
	      pauseEvent(e);
	
	      this._move(position[0]);
	    },
	
	    _move: function (position) {
	      this.hasMoved = true;
	
	      var props = this.props;
	      var state = this.state;
	      var index = state.index;
	
	      var value = state.value;
	      var length = value.length;
	      var oldValue = value[index];
	
	      var diffPosition = position - state.startPosition;
	      if (props.invert) diffPosition *= -1;
	
	      var diffValue = diffPosition / (state.sliderLength - state.handleSize) * (props.max - props.min);
	      var newValue = this._trimAlignValue(state.startValue + diffValue);
	
	      var minDistance = props.minDistance;
	
	      // if "pearling" (= handles pushing each other) is disabled,
	      // prevent the handle from getting closer than `minDistance` to the previous or next handle.
	      if (!props.pearling) {
	        if (index > 0) {
	          var valueBefore = value[index - 1];
	          if (newValue < valueBefore + minDistance) {
	            newValue = valueBefore + minDistance;
	          }
	        }
	
	        if (index < length - 1) {
	          var valueAfter = value[index + 1];
	          if (newValue > valueAfter - minDistance) {
	            newValue = valueAfter - minDistance;
	          }
	        }
	      }
	
	      value[index] = newValue;
	
	      // if "pearling" is enabled, let the current handle push the pre- and succeeding handles.
	      if (props.pearling && length > 1) {
	        if (newValue > oldValue) {
	          this._pushSucceeding(value, minDistance, index);
	          this._trimSucceeding(length, value, minDistance, props.max);
	        }
	        else if (newValue < oldValue) {
	          this._pushPreceding(value, minDistance, index);
	          this._trimPreceding(length, value, minDistance, props.min);
	        }
	      }
	
	      // Normally you would use `shouldComponentUpdate`, but since the slider is a low-level component,
	      // the extra complexity might be worth the extra performance.
	      if (newValue !== oldValue) {
	        this.setState({value: value}, this._fireChangeEvent.bind(this, 'onChange'));
	      }
	    },
	
	    _pushSucceeding: function (value, minDistance, index) {
	      var i, padding;
	      for (i = index, padding = value[i] + minDistance;
	           value[i + 1] != null && padding > value[i + 1];
	           i++, padding = value[i] + minDistance) {
	        value[i + 1] = this._alignValue(padding);
	      }
	    },
	
	    _trimSucceeding: function (length, nextValue, minDistance, max) {
	      for (var i = 0; i < length; i++) {
	        var padding = max - i * minDistance;
	        if (nextValue[length - 1 - i] > padding) {
	          nextValue[length - 1 - i] = padding;
	        }
	      }
	    },
	
	    _pushPreceding: function (value, minDistance, index) {
	      var i, padding;
	      for (i = index, padding = value[i] - minDistance;
	           value[i - 1] != null && padding < value[i - 1];
	           i--, padding = value[i] - minDistance) {
	        value[i - 1] = this._alignValue(padding);
	      }
	    },
	
	    _trimPreceding: function (length, nextValue, minDistance, min) {
	      for (var i = 0; i < length; i++) {
	        var padding = min + i * minDistance;
	        if (nextValue[i] < padding) {
	          nextValue[i] = padding;
	        }
	      }
	    },
	
	    _axisKey: function () {
	      var orientation = this.props.orientation;
	      if (orientation === 'horizontal') return 'X';
	      if (orientation === 'vertical') return 'Y';
	    },
	
	    _orthogonalAxisKey: function () {
	      var orientation = this.props.orientation;
	      if (orientation === 'horizontal') return 'Y';
	      if (orientation === 'vertical') return 'X';
	    },
	
	    _posMinKey: function () {
	      var orientation = this.props.orientation;
	      if (orientation === 'horizontal') return this.props.invert ? 'right' : 'left';
	      if (orientation === 'vertical') return this.props.invert ? 'bottom' : 'top';
	    },
	
	    _posMaxKey: function () {
	      var orientation = this.props.orientation;
	      if (orientation === 'horizontal') return this.props.invert ? 'left' : 'right';
	      if (orientation === 'vertical') return this.props.invert ? 'top' : 'bottom';
	    },
	
	    _sizeKey: function () {
	      var orientation = this.props.orientation;
	      if (orientation === 'horizontal') return 'clientWidth';
	      if (orientation === 'vertical') return 'clientHeight';
	    },
	
	    _trimAlignValue: function (val, props) {
	      return this._alignValue(this._trimValue(val, props), props);
	    },
	
	    _trimValue: function (val, props) {
	      props = props || this.props;
	
	      if (val <= props.min) val = props.min;
	      if (val >= props.max) val = props.max;
	
	      return val;
	    },
	
	    _alignValue: function (val, props) {
	      props = props || this.props;
	
	      var valModStep = (val - props.min) % props.step;
	      var alignValue = val - valModStep;
	
	      if (Math.abs(valModStep) * 2 >= props.step) {
	        alignValue += (valModStep > 0) ? props.step : (-props.step);
	      }
	
	      return parseFloat(alignValue.toFixed(5));
	    },
	
	    _renderHandle: function (style, child, i) {
	      var className = this.props.handleClassName + ' ' +
	        (this.props.handleClassName + '-' + i) + ' ' +
	        (this.state.index === i ? this.props.handleActiveClassName : '');
	
	      return (
	        React.createElement('div', {
	            ref: 'handle' + i,
	            key: 'handle' + i,
	            className: className,
	            style: style,
	            onMouseDown: this._createOnMouseDown(i),
	            onTouchStart: this._createOnTouchStart(i)
	          },
	          child
	        )
	      );
	    },
	
	    _renderHandles: function (offset) {
	      var length = offset.length;
	
	      var styles = this.tempArray;
	      for (var i = 0; i < length; i++) {
	        styles[i] = this._buildHandleStyle(offset[i], i);
	      }
	
	      var res = this.tempArray;
	      var renderHandle = this._renderHandle;
	      if (React.Children.count(this.props.children) > 0) {
	        React.Children.forEach(this.props.children, function (child, i) {
	          res[i] = renderHandle(styles[i], child, i);
	        });
	      } else {
	        for (i = 0; i < length; i++) {
	          res[i] = renderHandle(styles[i], null, i);
	        }
	      }
	      return res;
	    },
	
	    _renderBar: function (i, offsetFrom, offsetTo) {
	      return (
	        React.createElement('div', {
	          key: 'bar' + i,
	          ref: 'bar' + i,
	          className: this.props.barClassName + ' ' + this.props.barClassName + '-' + i,
	          style: this._buildBarStyle(offsetFrom, this.state.upperBound - offsetTo)
	        })
	      );
	    },
	
	    _renderBars: function (offset) {
	      var bars = [];
	      var lastIndex = offset.length - 1;
	
	      bars.push(this._renderBar(0, 0, offset[0]));
	
	      for (var i = 0; i < lastIndex; i++) {
	        bars.push(this._renderBar(i + 1, offset[i], offset[i + 1]));
	      }
	
	      bars.push(this._renderBar(lastIndex + 1, offset[lastIndex], this.state.upperBound));
	
	      return bars;
	    },
	
	    _onSliderMouseDown: function (e) {
	      if (this.props.disabled) return;
	      this.hasMoved = false;
	      if (!this.props.snapDragDisabled) {
	        var position = this._getMousePosition(e);
	        this._forceValueFromPosition(position[0], function (i) {
	          this._fireChangeEvent('onChange');
	          this._start(i, position[0]);
	          this._addHandlers(this._getMouseEventMap());
	        }.bind(this));
	      }
	
	      pauseEvent(e);
	    },
	
	    _onSliderClick: function (e) {
	      if (this.props.disabled) return;
	
	      if (this.props.onSliderClick && !this.hasMoved) {
	        var position = this._getMousePosition(e);
	        var valueAtPos = this._trimAlignValue(this._calcValue(this._calcOffsetFromPosition(position[0])));
	        this.props.onSliderClick(valueAtPos);
	      }
	    },
	
	    _fireChangeEvent: function (event) {
	      if (this.props[event]) {
	        this.props[event](undoEnsureArray(this.state.value));
	      }
	    },
	
	    render: function () {
	      var state = this.state;
	      var props = this.props;
	
	      var offset = this.tempArray;
	      var value = state.value;
	      var l = value.length;
	      for (var i = 0; i < l; i++) {
	        offset[i] = this._calcOffset(value[i], i);
	      }
	
	      var bars = props.withBars ? this._renderBars(offset) : null;
	      var handles = this._renderHandles(offset);
	
	      return (
	        React.createElement('div', {
	            ref: 'slider',
	            style: {position: 'relative'},
	            className: props.className + (props.disabled ? ' disabled' : ''),
	            onMouseDown: this._onSliderMouseDown,
	            onClick: this._onSliderClick
	          },
	          bars,
	          handles
	        )
	      );
	    }
	  });
	
	  return ReactSlider;
	}));


/***/ },
/* 1263 */
1136,
/* 1264 */,
/* 1265 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatMediaTime;
	/*  weak */
	function leftpad(str, padding, length) {
	  var padded = padding.repeat(length) + str;
	
	  return padded.slice(padded.length - length);
	}
	
	function formatMediaTime(seconds, showHours) {
	  var time = '';
	
	  var hours = parseInt(seconds / 3600, 10);
	  if (showHours) {
	    time += leftpad(hours.toString(), '0', 2) + ':';
	  }
	
	  var minutes = parseInt(seconds % 3600 / 60, 10);
	  time += leftpad(minutes.toString(), '0', 2) + ':';
	
	  var secondsInt = parseInt(seconds % 60, 10);
	  time += leftpad(secondsInt.toString(), '0', 2);
	
	  return time;
	}

/***/ },
/* 1266 */
1136,
/* 1267 */,
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TYPES = undefined;
	exports.isSupportedType = isSupportedType;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _currentUserAgent = __webpack_require__(1160);
	
	var _currentUserAgent2 = _interopRequireDefault(_currentUserAgent);
	
	var _VideoSupport = __webpack_require__(1269);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = (0, _enumerate2.default)(['audio/mp4', 'audio/ogg', 'audio/wav', 'audio/webm']);
	/**
	 * AudioSupport is used to determine if a file's content type can be played with
	 * the HTML5 <audio> tag within a browser.
	 * https://developer.mozilla.org/en-US/docs/Web/HTML/Supported_media_formats#Browser_compatibility
	 */
	
	
	var TESTS = {
	  'audio/mp4': 'audio/mp4; codecs="mp4a.40.5"',
	  'audio/ogg': 'audio/ogg; codecs="vorbis"',
	  'audio/wav': 'audio/wav; codecs="1"',
	  'audio/webm': 'audio/webm; codecs="vorbis"'
	};
	
	var support = {};
	var elem = void 0;
	
	function isSupportedType(type) {
	  if (_currentUserAgent2.default.ie()) {
	    return false;
	  }
	
	  if (type in support) {
	    return support[type];
	  }
	
	  if (type in _VideoSupport.TYPES) {
	    return false;
	  }
	
	  if (!elem) {
	    // FIXME how to test this server side?
	    if (typeof document === 'undefined') {
	      return false;
	    }
	    elem = document.createElement('audio');
	  }
	
	  return support[type] = typeof elem.canPlayType === 'function' ? !!elem.canPlayType(TESTS[type] || type).replace(/^no$/, '') : false;
	}

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TYPE_ALIASES = exports.TYPES = undefined;
	exports.isSupportedType = isSupportedType;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _currentUserAgent = __webpack_require__(1160);
	
	var _currentUserAgent2 = _interopRequireDefault(_currentUserAgent);
	
	var _AudioSupport = __webpack_require__(1268);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = (0, _enumerate2.default)(['application/mp4', 'application/ogg', 'video/3gpp', 'video/mpeg', 'video/mp4', 'video/ogg', 'video/quicktime', 'video/webm', 'video/x-msvideo']);
	/**
	 * VideoSupport is used to determine if a file's content type can be played with
	 * the HTML5 <video> tag within a browser.
	 * https://developer.mozilla.org/en-US/docs/Web/HTML/Supported_media_formats#Browser_compatibility
	 */
	
	
	var TESTS = {
	  'video/mp4': 'video/mp4; codecs="avc1.42E01E"',
	  'video/ogg': 'video/ogg; codecs="theora"',
	  'video/webm': 'video/webm; codecs="vp8, vorbis"'
	};
	
	var TYPE_ALIASES = exports.TYPE_ALIASES = {
	  'application/mp4': 'video/mp4',
	  'application/ogg': 'video/ogg',
	  'video/3gpp': 'video/mp4',
	  'video/mpeg': 'video/mp4',
	  'video/quicktime': 'video/mp4'
	};
	
	var support = {};
	var elem = void 0;
	
	function isSupportedType(type) {
	  if (_currentUserAgent2.default.ie()) {
	    return false;
	  }
	
	  var resolvedType = TYPE_ALIASES[type] || type;
	  if (resolvedType in support) {
	    return support[resolvedType];
	  }
	
	  if (resolvedType in _AudioSupport.TYPES) {
	    return false;
	  }
	
	  if (!elem) {
	    // FIXME how to test this server side?
	    if (typeof document === 'undefined') {
	      return false;
	    }
	    elem = document.createElement('video');
	  }
	
	  return support[resolvedType] = typeof elem.canPlayType === 'function' ? !!elem.canPlayType(TESTS[resolvedType] || resolvedType).replace(/^no$/, '') : false;
	}

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FileImagePreview = undefined;
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ImageFilePreviewModal = __webpack_require__(1271);
	
	var _ImageFilePreviewModal2 = _interopRequireDefault(_ImageFilePreviewModal);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1290);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileImagePreview = exports.FileImagePreview = function FileImagePreview(_ref) {
	  var file = _ref.file;
	  // eslint-disable-line object-curly-spacing
	  return _react2.default.createElement(
	    _ModalTrigger2.default,
	    { modal: _react2.default.createElement(_ImageFilePreviewModal2.default, { file: file }) },
	    _react2.default.createElement(
	      _Link2.default,
	      { className: 'FileImagePreview', eventElementName: 'FileImagePreview' },
	      _react2.default.createElement(_Image2.default, { src: file.getUrls().cdn, alt: file.getName(), className: 'FileImagePreview-image' })
	    )
	  );
	};
	
	exports.default = FileImagePreview;

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _File = __webpack_require__(929);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _List = __webpack_require__(1281);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Modal = __webpack_require__(1207);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(1288);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var ImageFilePreviewModal = function (_React$Component) {
	  _inherits(ImageFilePreviewModal, _React$Component);
	
	  function ImageFilePreviewModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ImageFilePreviewModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageFilePreviewModal.__proto__ || Object.getPrototypeOf(ImageFilePreviewModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleCloseButtonClick = function () {
	      _this.props.onRequestHide();
	    }, _this.handleModalClick = function (event) {
	      var target = event.target;
	
	      var header = _reactDom2.default.findDOMNode(_this.refs.header);
	      if (header.contains(target)) {
	        return;
	      }
	
	      var image = _reactDom2.default.findDOMNode(_this.refs.image);
	      if (image.contains(target)) {
	        return;
	      }
	
	      _this.props.onRequestHide();
	    }, _this.renderBody = function () {
	      var file = _this.props.file;
	
	      var urls = file.getUrls();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ImageFilePreviewModal-wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ImageFilePreviewModal-content' },
	          _react2.default.createElement(_Image2.default, {
	            ref: 'image',
	            className: 'ImageFilePreviewModal-image',
	            src: urls.large || urls.raw
	          })
	        )
	      );
	    }, _this.renderHeader = function () {
	      var file = _this.props.file;
	
	      var urls = file.getUrls();
	
	      return _react2.default.createElement(
	        'header',
	        { ref: 'header', className: 'ImageFilePreviewModal-header' },
	        _react2.default.createElement(
	          _FlexibleBlock2.default,
	          { className: 'ImageFilePreviewModal-actions', flex: 'left' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ImageFilePreviewModal-fileInfo' },
	            _react2.default.createElement(
	              _Text2.default,
	              { truncate: true },
	              _react2.default.createElement(_Glyph2.default, { name: 'image', size: 'medium' }),
	              ' ',
	              file.getName()
	            )
	          ),
	          _react2.default.createElement(
	            _List2.default,
	            { horizontal: true },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _Link2.default,
	                { href: urls.raw, target: '_blank' },
	                _react2.default.createElement(_Glyph2.default, { name: 'fullscreen', size: 'small' }),
	                'View original'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _Link2.default,
	                { href: urls.download, download: true },
	                _react2.default.createElement(_Glyph2.default, { name: 'download', size: 'small' }),
	                'Download'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _Link2.default,
	                { onClick: _this.handleCloseButtonClick },
	                _react2.default.createElement(_Glyph2.default, { name: 'close', solo: true })
	              )
	            )
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ImageFilePreviewModal, [{
	    key: 'render',
	    value: function render() {
	      var header = this.renderHeader();
	      var body = this.renderBody();
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        _extends({}, this.props, {
	          className: (0, _classnames2.default)('ImageFilePreviewModal', this.props.className),
	          theme: 'dark',
	          onClick: this.handleModalClick }),
	        header,
	        body
	      );
	    }
	  }]);
	
	  return ImageFilePreviewModal;
	}(_react2.default.Component);
	
	ImageFilePreviewModal.displayName = 'ImageFilePreviewModal';
	exports.default = ImageFilePreviewModal;

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _LeftRight = __webpack_require__(1273);
	
	var _LeftRight2 = _interopRequireDefault(_LeftRight);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(1241);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FlexibleBlock = __webpack_require__(1279);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	/**
	 * Abstract layout element used to add left and right aligned content in fluid-width containers.
	 *
	 * `FlexibleBlock` is commonly referred to as ["Media Object"](http://www.stubbornella.org/content/2010/06/25/the-media-object-saves-hundreds-of-lines-of-code/).
	 * It is an extremely common layout that can be continuously nested. It is not as powerful as
	 * flexbox, but it is fully-supported by every browser (old and new).
	 *
	 * ```example
	 *  <div>
	 *    <FlexibleBlock flex="right" style={{marginBottom: 20}}>
	 *      <Glyph name="mobile" color="violet" size="xxxlarge" style={{marginRight: 10}} />
	 *      <div>
	 *        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras nunc lorem, ornare eu elit
	 *        eget, ultrices convallis odio. Maecenas convallis finibus ante. Donec quis turpis tellus.
	 *        Sed id ligula molestie dolor vulputate efficitur ac a enim. Aliquam sit amet convallis
	 *        urna, et viverra turpis.
	 *      </div>
	 *    </FlexibleBlock>
	 *    <FlexibleBlock flex="left">
	 *      <div>
	 *        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras nunc lorem, ornare eu elit
	 *        eget, ultrices convallis odio. Maecenas convallis finibus ante. Donec quis turpis tellus.
	 *        Sed id ligula molestie dolor vulputate efficitur ac a enim. Aliquam sit amet convallis
	 *        urna, et viverra turpis.
	 *      </div>
	 *      <Glyph name="gear" color="jungle" size="xxxlarge" style={{marginLeft: 10}} />
	 *    </FlexibleBlock>
	 *  </div>
	 * ```
	 *
	 * # Text truncation
	 *
	 * One major benefit of `FlexibleBlock` (over a `table`, for example) is that it is capable of
	 * truncating text without defining any fixed widths.
	 *
	 * ```example
	 *  <FlexibleBlock flex="left">
	 *    <Text truncate={true}>
	 *      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras nunc lorem, ornare eu elit
	 *      eget, ultrices convallis odio. Maecenas convallis finibus ante. Donec quis turpis tellus.
	 *    </Text>
	 *    <Glyph name="pencil" color="brand" size="large" style={{marginLeft: 10}} />
	 *  </FlexibleBlock>
	 *
	 * ```
	 *
	 * # Caveat: Working with absolute-positioned elements
	 *
	 * `FlexibleBlock` is not well-suited with absolute-positioned elements (e.g., `react-select`)
	 * because it built to work with [Layer](/components/Layer). It uses `overflow: hidden`, which will
	 * clip any absolutely positioned element that is positioned outside of the flexible region.
	 *
	 * The `allowOverflow` prop is a hack that works around this problem (with a few caveats with text
	 * truncation). Use `allowOverflow` if you absolutely need to. Otherwise, using flexbox may be a
	 * better long-term solution.
	 *
	 * ```example
	 *  <div>
	 *    <FlexibleBlock flex="right" style={{marginBottom: 20}}>
	 *      <Glyph name="crown" color="sunrise" size="xxxlarge" style={{marginRight: 10}} />
	 *      <div style={{paddingBottom: 30}}>
	 *        <div style={{position: 'relative'}}>
	 *          This text has an element below it that is clipped.
	 *          <div style={{position: 'absolute', top: '100%'}}>
	 *            <div style={{padding: 20, border: '1px solid #000'}}>
	 *              This is an absolute positioned element.
	 *            </div>
	 *          </div>
	 *        </div>
	 *      </div>
	 *    </FlexibleBlock>
	 *    <FlexibleBlock flex="right" allowOverflow={true} style={{marginBottom: 30}}>
	 *      <Glyph name="crown" color="sunrise" size="xxxlarge" style={{marginRight: 10}} />
	 *      <div style={{paddingBottom: 30}}>
	 *        <div style={{position: 'relative'}}>
	 *          This text has an element below it that is not clipped.
	 *          <div style={{position: 'absolute', top: '100%'}}>
	 *            <div style={{padding: 20, border: '1px solid #000'}}>
	 *              This is an absolute positioned element.
	 *            </div>
	 *          </div>
	 *        </div>
	 *      </div>
	 *    </FlexibleBlock>
	
	 *  </div>
	 *
	 * ```
	 */
	
	var FlexibleBlock = function (_React$Component) {
	  _inherits(FlexibleBlock, _React$Component);
	
	  function FlexibleBlock() {
	    _classCallCheck(this, FlexibleBlock);
	
	    return _possibleConstructorReturn(this, (FlexibleBlock.__proto__ || Object.getPrototypeOf(FlexibleBlock)).apply(this, arguments));
	  }
	
	  _createClass(FlexibleBlock, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$children = _slicedToArray(this.props.children, 2),
	          left = _props$children[0],
	          right = _props$children[1];
	
	      if (this.props.flex === 'left') {
	        left = FlexibleBlock.wrap(left);
	        left = _react2.default.cloneElement(left, {
	          className: (0, _classnames2.default)(left.props.className, this.props.allowOverflow ? _FlexibleBlock2.default.flexOverflow : _FlexibleBlock2.default.flex)
	        });
	      } else {
	        right = FlexibleBlock.wrap(right);
	        right = _react2.default.cloneElement(right, {
	          className: (0, _classnames2.default)(right.props.className, this.props.allowOverflow ? _FlexibleBlock2.default.flexOverflow : _FlexibleBlock2.default.flex)
	        });
	      }
	
	      return _react2.default.createElement(
	        _LeftRight2.default,
	        _extends({}, this.props, { pull: this.props.flex === 'left' ? 'right' : 'left' }),
	        left,
	        right
	      );
	    }
	  }], [{
	    key: 'wrap',
	    value: function wrap(node) {
	      if (_react2.default.isValidElement(node)) {
	        return node;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        node
	      );
	    }
	  }]);
	
	  return FlexibleBlock;
	}(_react2.default.Component);
	
	FlexibleBlock.defaultProps = {
	  allowOverflow: false
	};
	FlexibleBlock.displayName = 'FlexibleBlock';
	exports.default = FlexibleBlock;

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCreateFragment = __webpack_require__(1274);
	
	var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LeftRight = __webpack_require__(1276);
	
	var _LeftRight2 = _interopRequireDefault(_LeftRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	/**
	 * Layout component that encapsulates floating of elements to left, right, or both. Applies clearfix
	 * to the container.
	 *
	 * ```example
	 *  <LeftRight pull="both">
	 *    <div>Hello from the left side.</div>
	 *    <div>Hello from the right side.</div>
	 *  </LeftRight>
	 * ```
	 *
	 * ```example
	 *  <LeftRight pull="left">
	 *    <Glyph name="crown" color="sunrise" size="xxxlarge" style={{margin: 10}} />
	 *    <div>
	 *      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut eget tempus augue. Integer nec
	 *      felis sollicitudin, egestas nisi vitae, egestas ex. Nam dictum pellentesque nunc, sed
	 *      ultricies est efficitur rutrum. Mauris tempus malesuada fringilla. Sed augue nulla,
	 *      fermentum vel euismod in, condimentum a tortor. Etiam commodo fringilla est non semper.
	 *      Nullam non ornare tortor. Morbi elit leo, venenatis a vehicula non, blandit a nunc.
	 *      Curabitur diam metus, elementum eu placerat nec, varius id lorem.
	 *    </div>
	 *  </LeftRight>
	 * ```
	 */
	
	var LeftRight = function (_React$Component) {
	  _inherits(LeftRight, _React$Component);
	
	  function LeftRight() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LeftRight);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LeftRight.__proto__ || Object.getPrototypeOf(LeftRight)).call.apply(_ref, [this].concat(args))), _this), _this.clone = function (node, className) {
	      var wrappedNode = _this.wrap(node);
	      return _react2.default.cloneElement(wrappedNode, {
	        className: (0, _classnames2.default)(wrappedNode.props.className, className)
	      });
	    }, _this.wrap = function (node) {
	      if (_react2.default.isValidElement(node)) {
	        return node;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        node
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LeftRight, [{
	    key: 'render',
	    value: function render() {
	      var _props$children = _slicedToArray(this.props.children, 2),
	          left = _props$children[0],
	          right = _props$children[1];
	
	      var children = void 0;
	      var pull = this.props.pull;
	
	      if (pull === 'right') {
	        children = (0, _reactAddonsCreateFragment2.default)({
	          right: this.clone(right, _LeftRight2.default.pullRight),
	          left: this.wrap(left)
	        });
	      } else {
	        children = (0, _reactAddonsCreateFragment2.default)({
	          left: this.clone(left, _LeftRight2.default.pullLeft),
	          right: pull === 'both' ? this.clone(right, _LeftRight2.default.pullRight) : this.wrap(right)
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_LeftRight2.default.this, this.props.className) },
	        children
	      );
	    }
	  }]);
	
	  return LeftRight;
	}(_react2.default.Component);
	
	LeftRight.defaultProps = {
	  pull: 'both'
	};
	LeftRight.displayName = 'LeftRight';
	exports.default = LeftRight;

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1275).create;

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(304);
	
	var ReactChildren = __webpack_require__(302);
	var ReactElement = __webpack_require__(306);
	
	var emptyFunction = __webpack_require__(309);
	var invariant = __webpack_require__(305);
	var warning = __webpack_require__(308);
	
	/**
	 * We used to allow keyed objects to serve as a collection of ReactElements,
	 * or nested sets. This allowed us a way to explicitly key a set or fragment of
	 * components. This is now being replaced with an opaque data structure.
	 * The upgrade path is to call React.addons.createFragment({ key: value }) to
	 * create a keyed fragment. The resulting data structure is an array.
	 */
	
	var numericPropertyRegex = /^\d+$/;
	
	var warnedAboutNumeric = false;
	
	var ReactFragment = {
	  /**
	   * Wrap a keyed object in an opaque proxy that warns you if you access any
	   * of its properties.
	   * See https://facebook.github.io/react/docs/create-fragment.html
	   */
	  create: function (object) {
	    if (typeof object !== 'object' || !object || Array.isArray(object)) {
	       false ? warning(false, 'React.addons.createFragment only accepts a single object. Got: %s', object) : void 0;
	      return object;
	    }
	    if (ReactElement.isValidElement(object)) {
	       false ? warning(false, 'React.addons.createFragment does not accept a ReactElement ' + 'without a wrapper object.') : void 0;
	      return object;
	    }
	
	    !(object.nodeType !== 1) ?  false ? invariant(false, 'React.addons.createFragment(...): Encountered an invalid child; DOM elements are not valid children of React components.') : _prodInvariant('0') : void 0;
	
	    var result = [];
	
	    for (var key in object) {
	      if (false) {
	        if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React.addons.createFragment(...): Child objects should have ' + 'non-numeric keys so ordering is preserved.') : void 0;
	          warnedAboutNumeric = true;
	        }
	      }
	      ReactChildren.mapIntoWithKeyPrefixInternal(object[key], result, key, emptyFunction.thatReturnsArgument);
	    }
	
	    return result;
	  }
	};
	
	module.exports = ReactFragment;

/***/ },
/* 1276 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"this":"LeftRight__this___3L30Z common__clearfix___2PnG3","pullLeft":"LeftRight__pullLeft___3Fpsx","pullRight":"LeftRight__pullRight___3IB9S"};

/***/ },
/* 1277 */,
/* 1278 */,
/* 1279 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"FlexibleBlock__flex___1cNmk","flexOverflow":"FlexibleBlock__flexOverflow___33kIn"};

/***/ },
/* 1280 */,
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ListItem = __webpack_require__(1282);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _List = __webpack_require__(1283);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var List = function (_React$Component) {
	  _inherits(List, _React$Component);
	
	  function List() {
	    _classCallCheck(this, List);
	
	    return _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
	  }
	
	  _createClass(List, [{
	    key: 'render',
	    value: function render() {
	      var _cx;
	
	      var children = _react2.default.Children.map(this.props.children, function (child) {
	        if (child && child.type !== _ListItem2.default && child.type !== 'li') {
	          return _react2.default.createElement(
	            _ListItem2.default,
	            null,
	            child
	          );
	        }
	        return child;
	      });
	
	      return _react2.default.createElement(
	        'ul',
	        {
	          className: (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _List2.default.horizontal, this.props.horizontal), _defineProperty(_cx, _List2.default.commas, this.props.delimiter === 'comma'), _defineProperty(_cx, _List2.default.dashes, this.props.delimiter === 'dash'), _defineProperty(_cx, _List2.default.middot, this.props.delimiter === 'middot'), _defineProperty(_cx, _List2.default.small, this.props.size === 'small'), _cx), this.props.className) },
	        children
	      );
	    }
	  }]);
	
	  return List;
	}(_react2.default.Component);
	
	List.defaultProps = {
	  horizontal: false
	};
	List.displayName = 'List';
	exports.default = List;

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// $FlowFixMe destructuring. Missing annotation
	var ListItem = function ListItem(_ref) {
	  var children = _ref.children,
	      props = _objectWithoutProperties(_ref, ['children']);
	
	  return _react2.default.createElement(
	    'li',
	    props,
	    children
	  );
	};
	
	exports.default = ListItem;

/***/ },
/* 1283 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"horizontal":"List__horizontal___RS3MN","commas":"List__commas___316w9","dashes":"List__dashes___2k54N","middot":"List__middot___2YZf8","small":"List__small___Jg_FF"};

/***/ },
/* 1284 */,
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Text = function (_React$Component) {
	  _inherits(Text, _React$Component);
	
	  function Text() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Text);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Text.__proto__ || Object.getPrototypeOf(Text)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      label: ''
	    }, _this.handleMouseOver = function () {
	      if (!_this.props.truncate) {
	        return;
	      }
	      var container = _reactDom2.default.findDOMNode(_this);
	      var visibleWidth = container.getBoundingClientRect().width;
	      var textWidth = container.childNodes[0].getBoundingClientRect().width;
	      if (textWidth > visibleWidth) {
	        _this.setState({ label: container.textContent });
	      } else {
	        _this.setState({ label: '' });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Text, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          onMouseOver = _props.onMouseOver,
	          children = _props.children;
	
	      var Component = this.props.element || 'span';
	
	      return _react2.default.createElement(
	        Component,
	        {
	          'data-test-selector': this.props['data-test-selector'],
	          className: (0, _classnames2.default)('Text', (0, _getPropClasses.getPropClassesFromInstance)(this), {
	            'Text-noWrap': !this.props.wrap
	          }, className),
	          title: this.state.label,
	          onClick: this.props.onClick,
	          onMouseOver: (0, _createChainedFunction2.default)(this.handleMouseOver, onMouseOver) },
	        this.props.truncate ? _react2.default.createElement(
	          'span',
	          null,
	          children
	        ) : children
	      );
	    }
	  }]);
	
	  return Text;
	}(_react2.default.Component);
	
	Text.propClasses = {
	  align: {
	    left: 'Text--left',
	    center: 'Text--center',
	    right: 'Text--right'
	  },
	  color: {
	    pitch: 'Text-pitch',
	    thunder: 'Text-thunder',
	    eclipse: 'Text-eclipse',
	    koala: 'Text-koala',
	    sunrise: 'Text-sunrise',
	    lava: 'Text-lava',
	    white: 'Text-white',
	    midnight: 'Text-midnight',
	    wolf: 'Text-wolf',
	    violet: 'Text-violet',
	    shamrock: 'Text-shamrock',
	    jungle: 'Text-jungle',
	    flame: 'Text-flame',
	    brand: 'Text-brand'
	  },
	  lineHeight: {
	    medium: 'Text--lineHeightMedium',
	    large: 'Text--lineHeightLarge'
	  },
	  size: {
	    xxxxxsmall: 'Text-sizeXxxxxSmall',
	    xxxxsmall: 'Text-sizeXxxxSmall',
	    xxxsmall: 'Text-sizeXxxSmall',
	    xxsmall: 'Text-sizeXxSmall',
	    xsmall: 'Text-sizeXSmall',
	    small: 'Text-sizeSmall',
	    medium: 'Text-sizeMedium',
	    large: 'Text-sizeLarge',
	    xlarge: 'Text-sizeXLarge',
	    xxlarge: 'Text-sizeXxLarge',
	    xxxlarge: 'Text-sizeXxxLarge',
	    xxxxlarge: 'Text-sizeXxxxLarge'
	  },
	  weight: {
	    bold: 'Text-weightBold',
	    semibold: 'Text-weightSemibold',
	    normal: 'Text-weightNormal',
	    light: 'Text-weightLight'
	  },
	  truncate: 'Text-truncate',
	  uppercase: 'Text-uppercase',
	  capitalize: 'Text-capitalize',
	  italic: 'Text-italic'
	};
	Text.defaultProps = {
	  align: 'inherit',
	  element: 'span',
	  truncate: false,
	  uppercase: false,
	  wrap: true
	};
	Text.displayName = 'Text';
	exports.default = Text;

/***/ },
/* 1286 */
1136,
/* 1287 */,
/* 1288 */
1136,
/* 1289 */,
/* 1290 */
1136,
/* 1291 */,
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _File = __webpack_require__(929);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _FileTypes = __webpack_require__(1293);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _filesize = __webpack_require__(1294);
	
	var _filesize2 = _interopRequireDefault(_filesize);
	
	__webpack_require__(1295);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO rename to FileGenericPreview now that we have lots of File previewing components
	var FilePreview = function (_React$Component) {
	  _inherits(FilePreview, _React$Component);
	
	  function FilePreview() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FilePreview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePreview.__proto__ || Object.getPrototypeOf(FilePreview)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isHovering: false
	    }, _this.endHover = function () {
	      _this.setState({ isHovering: false });
	    }, _this.startHover = function () {
	      _this.setState({ isHovering: true });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FilePreview, [{
	    key: 'render',
	    value: function render() {
	      var file = this.props.file;
	
	
	      var size = file.getSize();
	      var displayedSize = '';
	      if (size) {
	        displayedSize = (0, _filesize2.default)(size, { round: 1, spacer: '' }).toUpperCase();
	      }
	
	      var contentType = file.getContentType();
	      var preview = _react2.default.createElement(
	        _Link2.default,
	        {
	          className: 'FilePreview',
	          href: file.getUrls().cdn,
	          target: '_blank',
	          eventElementName: 'FilePreview' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'FilePreview-preview',
	            onMouseEnter: this.startHover,
	            onMouseLeave: this.endHover },
	          _react2.default.createElement(_Glyph2.default, {
	            className: 'FilePreview-icon',
	            name: this.state.isHovering ? 'download' : (0, _FileTypes.getGlyphName)(contentType),
	            size: 'xxxlarge'
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'FilePreview-name' },
	            file.getName()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'FilePreview-size' },
	            _react2.default.createElement(
	              'em',
	              null,
	              displayedSize
	            )
	          )
	        )
	      );
	
	      return preview;
	    }
	  }]);
	
	  return FilePreview;
	}(_react2.default.Component);
	
	FilePreview.displayName = 'FilePreview';
	exports.default = FilePreview;

/***/ },
/* 1293 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GLYPH_NAME_MAP;
	
	exports.getType = getType;
	exports.getGlyphName = getGlyphName;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/*  weak */
	// File type constants
	// e.g., `FileTypes.getType(file.getContentType()) === FileTypes.AUDIO`
	var AUDIO = exports.AUDIO = 'AUDIO';
	var DEFAULT = exports.DEFAULT = 'DEFAULT';
	var IMAGE = exports.IMAGE = 'IMAGE';
	var MSEXCEL = exports.MSEXCEL = 'MSEXCEL';
	var MSPOWERPOINT = exports.MSPOWERPOINT = 'MSPOWERPOINT';
	var MSWORD = exports.MSWORD = 'MSWORD';
	var PDF = exports.PDF = 'PDF';
	var TEXT = exports.TEXT = 'TEXT';
	var VIDEO = exports.VIDEO = 'VIDEO';
	
	// Mapping from file type constant to glyph name in r101-glyphs
	var GLYPH_NAME_MAP = (_GLYPH_NAME_MAP = {}, _defineProperty(_GLYPH_NAME_MAP, AUDIO, 'microphone'), _defineProperty(_GLYPH_NAME_MAP, DEFAULT, 'paperclip'), _defineProperty(_GLYPH_NAME_MAP, IMAGE, 'image'), _defineProperty(_GLYPH_NAME_MAP, MSEXCEL, 'excel'), _defineProperty(_GLYPH_NAME_MAP, MSPOWERPOINT, 'powerpoint'), _defineProperty(_GLYPH_NAME_MAP, MSWORD, 'word'), _defineProperty(_GLYPH_NAME_MAP, PDF, 'pdf'), _defineProperty(_GLYPH_NAME_MAP, TEXT, 'text'), _defineProperty(_GLYPH_NAME_MAP, VIDEO, 'video'), _GLYPH_NAME_MAP);
	
	/**
	 * Given the content type of a file, return the file type
	 */
	function getType(contentType) {
	  // If we didn't get a string, give up and return the default
	  // This also handles cases where contentType is undefined or null
	  if (typeof contentType !== 'string') {
	    return DEFAULT;
	  }
	
	  switch (contentType) {
	    case 'application/pdf':
	      return PDF;
	    case 'application/vnd.ms-excel':
	    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
	    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
	    case 'text/csv':
	      return MSEXCEL;
	    case 'application/vnd.ms-powerpoint':
	    case 'application/vnd.openxmlformats-officedocument.presentationml.template':
	    case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
	    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
	    case 'application/vnd.openxmlformats-officedocument.presentationml.slide':
	      return MSPOWERPOINT;
	    case 'application/msword':
	    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
	    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
	      return MSWORD;
	    case 'application/mp4':
	      return VIDEO;
	    default:
	      if (contentType.startsWith('audio')) {
	        return AUDIO;
	      } else if (contentType.startsWith('image')) {
	        return IMAGE;
	      } else if (contentType.startsWith('text')) {
	        return TEXT;
	      } else if (contentType.startsWith('video')) {
	        return VIDEO;
	      }
	  }
	  return DEFAULT;
	}
	
	/**
	 * Given the content type of a file, return the glyph name
	 */
	function getGlyphName(contentType) {
	  return GLYPH_NAME_MAP[getType(contentType)];
	}

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	/**
	 * filesize
	 *
	 * @copyright 2016 Jason Mulligan <jason.mulligan@avoidwork.com>
	 * @license BSD-3-Clause
	 * @version 3.3.0
	 */
	(function (global) {
		var b = /^(b|B)$/;
		var symbol = {
			iec: {
				bits: ["b", "Kib", "Mib", "Gib", "Tib", "Pib", "Eib", "Zib", "Yib"],
				bytes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
			},
			jedec: {
				bits: ["b", "Kb", "Mb", "Gb", "Tb", "Pb", "Eb", "Zb", "Yb"],
				bytes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
			}
		};
	
		/**
	  * filesize
	  *
	  * @method filesize
	  * @param  {Mixed}   arg        String, Int or Float to transform
	  * @param  {Object}  descriptor [Optional] Flags
	  * @return {String}             Readable file size String
	  */
		function filesize(arg) {
			var descriptor = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
			var result = [],
			    val = 0,
			    e = void 0,
			    base = void 0,
			    bits = void 0,
			    ceil = void 0,
			    neg = void 0,
			    num = void 0,
			    output = void 0,
			    round = void 0,
			    unix = void 0,
			    spacer = void 0,
			    standard = void 0,
			    symbols = void 0;
	
			if (isNaN(arg)) {
				throw new Error("Invalid arguments");
			}
	
			bits = descriptor.bits === true;
			unix = descriptor.unix === true;
			base = descriptor.base || 2;
			round = descriptor.round !== undefined ? descriptor.round : unix ? 1 : 2;
			spacer = descriptor.spacer !== undefined ? descriptor.spacer : unix ? "" : " ";
			symbols = descriptor.symbols || descriptor.suffixes || {};
			standard = base === 2 ? descriptor.standard || "jedec" : "jedec";
			output = descriptor.output || "string";
			e = descriptor.exponent !== undefined ? descriptor.exponent : -1;
			num = Number(arg);
			neg = num < 0;
			ceil = base > 2 ? 1000 : 1024;
	
			// Flipping a negative number to determine the size
			if (neg) {
				num = -num;
			}
	
			// Zero is now a special case because bytes divide by 1
			if (num === 0) {
				result[0] = 0;
				result[1] = unix ? "" : !bits ? "B" : "b";
			} else {
				// Determining the exponent
				if (e === -1 || isNaN(e)) {
					e = Math.floor(Math.log(num) / Math.log(ceil));
	
					if (e < 0) {
						e = 0;
					}
				}
	
				// Exceeding supported length, time to reduce & multiply
				if (e > 8) {
					e = 8;
				}
	
				val = base === 2 ? num / Math.pow(2, e * 10) : num / Math.pow(1000, e);
	
				if (bits) {
					val = val * 8;
	
					if (val > ceil && e < 8) {
						val = val / ceil;
						e++;
					}
				}
	
				result[0] = Number(val.toFixed(e > 0 ? round : 0));
				result[1] = base === 10 && e === 1 ? bits ? "kb" : "kB" : symbol[standard][bits ? "bits" : "bytes"][e];
	
				if (unix) {
					result[1] = standard === "jedec" ? result[1].charAt(0) : e > 0 ? result[1].replace(/B$/, "") : result[1];
	
					if (b.test(result[1])) {
						result[0] = Math.floor(result[0]);
						result[1] = "";
					}
				}
			}
	
			// Decorating a 'diff'
			if (neg) {
				result[0] = -result[0];
			}
	
			// Applying custom symbol
			result[1] = symbols[result[1]] || result[1];
	
			// Returning Array, Object, or String (default)
			if (output === "array") {
				return result;
			}
	
			if (output === "exponent") {
				return e;
			}
	
			if (output === "object") {
				return { value: result[0], suffix: result[1], symbol: result[1] };
			}
	
			return result.join(spacer);
		}
	
		// CommonJS, AMD, script tag
		if (true) {
			module.exports = filesize;
		} else if (typeof define === "function" && define.amd) {
			define(function () {
				return filesize;
			});
		} else {
			global.filesize = filesize;
		}
	})(typeof window !== "undefined" ? window : global);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1295 */
1136,
/* 1296 */,
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _File = __webpack_require__(929);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _MediaPlayer = __webpack_require__(1259);
	
	var _MediaPlayer2 = _interopRequireDefault(_MediaPlayer);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VideoSupport = __webpack_require__(1269);
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1298);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Video = function (_React$Component) {
	  _inherits(Video, _React$Component);
	
	  function Video() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Video);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Video.__proto__ || Object.getPrototypeOf(Video)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      id: _lodash2.default.uniqueId(),
	      started: false,
	      showControl: false
	    }, _this.handleClick = function () {
	      if (!_this.state.started) {
	        _this.setState({ started: true });
	      }
	
	      var player = _this.refs.player;
	
	      if (player.state.playing) {
	        player.pause();
	      } else {
	        player.play();
	      }
	    }, _this.handleMouseEnter = function () {
	      _this.setState({ showControl: true });
	    }, _this.handleMouseLeave = function () {
	      var player = _this.refs.player;
	
	      if (!player.state.playing) {
	        return;
	      }
	
	      _this.setState({ showControl: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Video, [{
	    key: 'render',
	    value: function render() {
	      var play = void 0;
	      if (!this.state.started) {
	        play = _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'Video-playButton',
	            color: 'white',
	            onClick: this.handleClick,
	            eventElementName: 'Video-playButton' },
	          _react2.default.createElement(_Glyph2.default, { name: 'play', size: 'xlarge', color: 'brand', solo: true })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'Video',
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave },
	        _react2.default.createElement(
	          'video',
	          { id: this.state.id, src: this.props.src, onClick: this.handleClick },
	          'Your browser does not support the ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'video'
	          ),
	          ' element.'
	        ),
	        play,
	        _react2.default.createElement(_MediaPlayer2.default, {
	          className: (0, _classnames2.default)({
	            'Video-controls': true,
	            'Video-controlsHidden': !this.state.started || !this.state.showControl
	          }),
	          ref: 'player',
	          playerId: this.state.id,
	          theme: 'dark',
	          fullscreen: true,
	          src: this.props.src
	        })
	      );
	    }
	  }]);
	
	  return Video;
	}(_react2.default.Component);
	
	Video.isSupportedType = _VideoSupport.isSupportedType;
	Video.displayName = 'Video';
	exports.default = Video;

/***/ },
/* 1298 */
1136,
/* 1299 */,
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	var _TranslationActions = __webpack_require__(1301);
	
	var _TranslationActions2 = _interopRequireDefault(_TranslationActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	/* Component to translate text to any language
	 *
	 * getInitialState() {
	 *   return {
	 *     lang: 'en'
	 *   };
	 * },
	 *
	 * componentDidMount() {
	 *   setTimeout(() => this.setState({lang: 'es'}, 2000)); // translate to spanish
	 *   setTimeout(() => this.setState({lang: 'en'}, 4000)); // translate back to english
	 * },
	 *
	 * onLanguageChanged(lang) {
	 *   console.log('translated to ' + lang)
	 * }
	 *
	 * render() {
	 *   return (
	 *     <TranslatableText
	 *       text="hello"
	 *       lang={this.state.lang}
	 *       onLanguageChanged={this.onLanguageChanged}
	 *     />
	 *   );
	 * }
	 */
	var TranslatableText = function (_React$Component) {
	  _inherits(TranslatableText, _React$Component);
	
	  function TranslatableText() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TranslatableText);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TranslatableText.__proto__ || Object.getPrototypeOf(TranslatableText)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      text: _this.props.text,
	      cache: {}
	    }, _this.addToCache = function (locale, text) {
	      var cache = _this.state.cache;
	
	      cache[locale] = text;
	      _this.setState({ cache: cache });
	    }, _this.translateTo = function (locale) {
	      var onTranslationSuccess = function onTranslationSuccess(response) {
	        _this.setState({ text: response.translation });
	
	        if (_this.props.onLanguageChanged) {
	          _this.props.onLanguageChanged(locale);
	        }
	
	        return response;
	      };
	
	      var addToCache = function addToCache(response) {
	        _this.addToCache(locale, response.translation);
	      };
	
	      if (_this.state.cache[locale]) {
	        _this.setState({ text: _this.state.cache[locale] });
	
	        if (_this.props.onLanguageChanged) {
	          _this.props.onLanguageChanged(locale);
	        }
	      } else {
	        _TranslationActions2.default.translate(_this.props.text, locale).then(onTranslationSuccess).then(addToCache);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TranslatableText, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addToCache(this.props.language, this.props.text);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.language !== nextProps.language) {
	        this.translateTo(nextProps.language);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var entities = [].concat(_TextEntities2.default.parseEmoji(this.state.text), _TextEntities2.default.parseNewlines(this.state.text), _TextEntities2.default.parseLeadingWhitespace(this.state.text), _TextEntities2.default.parseUrls(this.state.text));
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'TranslatableText' },
	        _react2.default.createElement(_TextWithEntities2.default, { text: this.state.text, entities: entities })
	      );
	    }
	  }]);
	
	  return TranslatableText;
	}(_react2.default.Component);
	
	TranslatableText.defaultProps = {
	  language: null
	};
	TranslatableText.displayName = 'TranslatableText';
	exports.default = TranslatableText;

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TranslationActions = {
	  translate: function translate(text, locale) {
	    return (0, _apiRequest2.default)('/translations/' + locale, 'GET', {
	      q: text
	    });
	  }
	};
	exports.default = TranslationActions;

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var TranslationCTA = function (_React$Component) {
	  _inherits(TranslationCTA, _React$Component);
	
	  function TranslationCTA() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TranslationCTA);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TranslationCTA.__proto__ || Object.getPrototypeOf(TranslationCTA)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      currentLocal: _this.props.originLanguage
	    }, _this.showOriginal = function () {
	      var originLocal = _this.props.originLanguage;
	      _this.props.onLanguageChange(originLocal);
	      _this.setState({ translating: false, currentLocal: originLocal });
	    }, _this.toggle = function () {
	      return _CurrentUser2.default.getUser().getISO639Locale() === _this.state.currentLocal ? _this.showOriginal() : _this.translate();
	    }, _this.translate = function () {
	      var userLocale = _CurrentUser2.default.getUser().getISO639Locale();
	      _this.props.onLanguageChange(userLocale);
	      _this.setState({ translating: true, currentLocal: userLocale });
	    }, _this.translated = function () {
	      _this.setState({ translating: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TranslationCTA, [{
	    key: 'render',
	    value: function render() {
	      if (!_CurrentUser2.default.isSignedIn()) {
	        return null;
	      }
	
	      var userLocale = _CurrentUser2.default.getUser().getISO639Locale();
	      var originLocal = this.props.originLanguage;
	
	      if (!userLocale || !originLocal || userLocale === originLocal) {
	        return null;
	      }
	
	      if (userLocale === this.state.currentLocal && !this.state.translating) {
	        return _react2.default.createElement(
	          'span',
	          { className: this.props.className },
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              eventElementName: 'translation_show_orignal',
	              eventContextName: this.context.eventContextName,
	              onClick: this.showOriginal },
	            'Show original'
	          )
	        );
	      }
	
	      var color = this.state.translating ? 'thunder' : 'brand';
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)('GroupMessageHeader-Translate', this.props.className) },
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            onClick: this.translate,
	            eventElementName: 'translation_show_translation',
	            eventContextName: this.context.eventContextName,
	            color: color,
	            className: 'GroupMessageHeader-TranslateLink' },
	          'Show translation'
	        ),
	        this.state.translating ? _react2.default.createElement(_LoadingIndicator2.default, { size: 'xsmall' }) : null
	      );
	    }
	  }]);
	
	  return TranslationCTA;
	}(_react2.default.Component);
	
	TranslationCTA.contextTypes = {
	  eventContextName: _react2.default.PropTypes.string
	};
	TranslationCTA.displayName = 'TranslationCTA';
	exports.default = TranslationCTA;

/***/ },
/* 1303 */
1136,
/* 1304 */,
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RelationshipModal = __webpack_require__(1309);
	
	var _RelationshipModal2 = _interopRequireDefault(_RelationshipModal);
	
	var _UserLink = __webpack_require__(1640);
	
	var _UserLink2 = _interopRequireDefault(_UserLink);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _reactAddonsShallowCompare = __webpack_require__(1241);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	__webpack_require__(1644);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var SenderIcon = function SenderIcon(_ref) {
	  var color = _ref.color,
	      iconUrl = _ref.iconUrl,
	      initials = _ref.initials,
	      isSender = _ref.isSender;
	
	  if (iconUrl) {
	    return _react2.default.createElement(_Image2.default, { src: iconUrl, circle: true });
	  } else if (isSender) {
	    return _react2.default.createElement(_Avatar2.default, { size: 'small', color: 'grey', text: initials });
	  } else {
	    return _react2.default.createElement(_Avatar2.default, { size: 'small', colorHex: color, text: initials });
	  }
	};
	
	var GroupMessageHeader = function (_React$Component) {
	  _inherits(GroupMessageHeader, _React$Component);
	
	  function GroupMessageHeader() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupMessageHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = GroupMessageHeader.__proto__ || Object.getPrototypeOf(GroupMessageHeader)).call.apply(_ref2, [this].concat(args))), _this), _this.renderAuthor = function () {
	      var group = _this.context.group;
	      var _this$props = _this.props,
	          author = _this$props.author,
	          color = _this$props.color,
	          iconUrl = _this$props.iconUrl,
	          initials = _this$props.initials,
	          senderId = _this$props.senderId;
	
	
	      var isSignout = !_CurrentUser2.default.isSignedIn();
	      var isSender = !isSignout && _CurrentUser2.default.getUserId() === senderId;
	
	      var iconProps = { color: color, iconUrl: iconUrl, initials: initials, isSender: isSender };
	
	      // the group is not in the context in the message viewer
	      // even when signed in we can't show the user modal because
	      // of code splitting
	      if (!group || isSignout || isSender) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'GroupMessageHeader-author' },
	          _react2.default.createElement(SenderIcon, iconProps),
	          author
	        );
	      }
	
	      var modal = _react2.default.createElement(_RelationshipModal2.default, { userId: senderId });
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: modal },
	          _react2.default.createElement(
	            _UserLink2.default,
	            {
	              className: 'GroupMessageHeader-author',
	              userId: senderId,
	              showSubscriptions: false,
	              placement: 'right',
	              color: 'pitch',
	              alignment: 'top' },
	            _react2.default.createElement(SenderIcon, iconProps),
	            author
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupMessageHeader, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState) || !!nextContext.group !== !!this.context.group;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _FlexibleBlock2.default,
	        { className: 'GroupMessageHeader', flex: 'left' },
	        this.renderAuthor(),
	        this.props.children
	      );
	    }
	  }]);
	
	  return GroupMessageHeader;
	}(_react2.default.Component);
	
	GroupMessageHeader.contextTypes = {
	  group: _react2.default.PropTypes.instanceOf(_Group2.default)
	};
	GroupMessageHeader.displayName = 'GroupMessageHeader';
	exports.default = GroupMessageHeader;

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Avatar;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _getPropClasses2 = _interopRequireDefault(_getPropClasses);
	
	__webpack_require__(1307);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// typecheck: ignore file
	function computeColorHexStyles(colorHex) {
	  if (!colorHex) {
	    return {};
	  }
	
	  return {
	    color: '#' + colorHex,
	    borderColor: '#' + colorHex
	  };
	}
	
	var propsToClasses = {
	  color: {
	    grey: 'Avatar-grey',
	    fullGrey: 'Avatar-fullGrey',
	    brand: 'Avatar-brand'
	  },
	  size: {
	    medium: 'Avatar-medium',
	    small: 'Avatar-small',
	    xsmall: 'Avatar-xsmall'
	  }
	};
	
	// UNTIL prop-types lint can detect Flow annotation
	/* eslint-disable react/prop-types */
	function Avatar(props) {
	  if (false) {
	    console.warn('user icon text ' + props.text + ' should be 2 characters max');
	  }
	
	  var style = computeColorHexStyles(props.colorHex);
	  var text = props.text,
	      glyphName = props.glyphName,
	      image = props.image,
	      date = props.date;
	
	
	  return _react2.default.createElement(
	    'div',
	    {
	      style: style,
	      className: (0, _classnames2.default)('Avatar', (0, _getPropClasses2.default)(props, propsToClasses), props.className) },
	    _react2.default.createElement(AvatarContent, {
	      text: text,
	      glyphName: glyphName,
	      image: image,
	      date: date
	    })
	  );
	}
	
	var shortMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	
	function AvatarContent(props) {
	  if (props.glyphName) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'Avatar-glyphContainer' },
	      props.glyphName && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Glyph2.default, { name: props.glyphName, size: 'large', solo: true })
	      ),
	      props.text && _react2.default.createElement(
	        'div',
	        { className: 'Avatar-text' },
	        props.text
	      )
	    );
	  }
	
	  var date = props.date;
	  if (date) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'Avatar-dateContainer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'Avatar-dateContainer-month' },
	        shortMonthNames[date.getMonth()]
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Avatar-dateContainer-day' },
	        date.getDate()
	      )
	    );
	  }
	
	  if (props.text) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      props.text
	    );
	  }
	
	  if (props.image) {
	    return _react2.default.createElement(_Image2.default, { className: 'Avatar-image', src: props.image });
	  }
	
	  return _react2.default.createElement('span', null);
	}

/***/ },
/* 1307 */
1136,
/* 1308 */,
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AlertDialog = __webpack_require__(1190);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _RelationshipActions = __webpack_require__(1006);
	
	var _RelationshipActions2 = _interopRequireDefault(_RelationshipActions);
	
	var _RelationshipStore = __webpack_require__(1310);
	
	var _RelationshipStore2 = _interopRequireDefault(_RelationshipStore);
	
	var _RelationshipView = __webpack_require__(1311);
	
	var _RelationshipView2 = _interopRequireDefault(_RelationshipView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RelationshipModal = _react2.default.createClass({
	  displayName: 'RelationshipModal',
	
	
	  mixins: [(0, _linkStateWithStores2.default)([_RelationshipStore2.default])],
	
	  statics: {
	    prefetch: [function (props) {
	      var relatedUser = _RelationshipStore2.default.getRelationship(props.userId);
	      if (!relatedUser || !relatedUser.hasSubscriptions()) {
	        return _RelationshipActions2.default.loadRelationship(props.userId);
	      }
	      return null;
	    }],
	    prefetchErrorModal: function prefetchErrorModal() {
	      return _react2.default.createElement(_AlertDialog2.default, {
	        title: 'An error occurred.',
	        subtext: '\n            We were unable to display this profile because\n            you are no longer connected to the user.\n          ',
	        buttonText: 'Close'
	      });
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onRequestHide: function onRequestHide() {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    return this.getStateFromStores();
	  },
	  getStateFromStores: function getStateFromStores() {
	    var relationship = _RelationshipStore2.default.getRelationship(this.props.userId);
	
	    return {
	      relationship: relationship
	    };
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _Dialog2.default,
	      _extends({
	        eventScreenName: 'RelationshipModal'
	      }, this.props, {
	        className: 'RelationshipModal' }),
	      _react2.default.createElement(_RelationshipView2.default, {
	        groupToAdmin: this.props.groupToAdmin,
	        groupMember: this.props.groupMember,
	        onRequestHide: this.props.onRequestHide,
	        relationship: this.state.relationship
	      })
	    );
	  }
	});
	
	exports.default = RelationshipModal;

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _Collection = __webpack_require__(599);
	
	var _Collection2 = _interopRequireDefault(_Collection);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Relationship = __webpack_require__(1007);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _ChatConstants = __webpack_require__(941);
	
	var _RelationshipConstants = __webpack_require__(986);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Relationships = _Collection2.default.extend({ model: _Relationship2.default });
	
	var RelationshipStore = function (_Store) {
	  _inherits(RelationshipStore, _Store);
	
	  function RelationshipStore() {
	    _classCallCheck(this, RelationshipStore);
	
	    return _possibleConstructorReturn(this, (RelationshipStore.__proto__ || Object.getPrototypeOf(RelationshipStore)).apply(this, arguments));
	  }
	
	  _createClass(RelationshipStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        relationships: new Relationships()
	      };
	    }
	  }, {
	    key: 'getRelationship',
	    value: function getRelationship(relationshipId) {
	      return this.state.relationships.get(relationshipId);
	    }
	  }, {
	    key: 'addRelationship',
	    value: function addRelationship(relationship) {
	      this.state.relationships.add(relationship);
	    }
	  }, {
	    key: 'removeRelationship',
	    value: function removeRelationship(relationship) {
	      this.state.relationships.remove(relationship);
	    }
	  }, {
	    key: 'getRelationshipWithUser',
	    value: function getRelationshipWithUser(userId) {
	      return this.state.relationships.find(function (relationship) {
	        return relationship.getRelatedUser().id === userId;
	      });
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      var _this2 = this;
	
	      switch (action.type) {
	        case _RelationshipConstants.ActionTypes.LOAD_RELATIONSHIP:
	        case _RelationshipConstants.ActionTypes.UPDATE_RELATIONSHIP:
	          this.waitFor([_GroupStore2.default]);
	          this.addRelationship(action.relationship);
	          this.emitChange();
	          break;
	        case _RelationshipConstants.ActionTypes.DELETE:
	          this.waitFor([_GroupStore2.default]);
	          this.removeRelationship(this.getRelationshipWithUser(action.userId));
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.CREATE_CHAT:
	          {
	            var _ret = function () {
	              var otherUserId = action.chat.getOtherChatMembers()[0].id;
	              if (action.chat.isGroupChat()) {
	                return 'break';
	              }
	              _this2.state.relationships.forEach(function (relationship) {
	                var relatedUserId = relationship.getRelatedUser().id;
	                if (otherUserId === relatedUserId) {
	                  relationship.set('chat', action.chat);
	                }
	              });
	              _this2.emitChange();
	              return 'break';
	            }();
	
	            if (_ret === 'break') break;
	          }
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return RelationshipStore;
	}(_Store3.default);
	
	RelationshipStore.displayName = 'RelationshipStore';
	exports.default = new RelationshipStore();

/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserConstants = __webpack_require__(1015);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _CopySubscriberButton = __webpack_require__(1312);
	
	var _CopySubscriberButton2 = _interopRequireDefault(_CopySubscriberButton);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _FeatureStore = __webpack_require__(588);
	
	var _FeatureStore2 = _interopRequireDefault(_FeatureStore);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Relationship = __webpack_require__(1007);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _RelationshipViewGroupList = __webpack_require__(1425);
	
	var _RelationshipViewGroupList2 = _interopRequireDefault(_RelationshipViewGroupList);
	
	var _RelationshipViewHeader = __webpack_require__(1566);
	
	var _RelationshipViewHeader2 = _interopRequireDefault(_RelationshipViewHeader);
	
	var _RelationshipViewProfileHeader = __webpack_require__(1616);
	
	var _RelationshipViewProfileHeader2 = _interopRequireDefault(_RelationshipViewProfileHeader);
	
	var _RelationshipViewMediums = __webpack_require__(1623);
	
	var _RelationshipViewMediums2 = _interopRequireDefault(_RelationshipViewMediums);
	
	var _RelationshipViewNotes = __webpack_require__(1626);
	
	var _RelationshipViewNotes2 = _interopRequireDefault(_RelationshipViewNotes);
	
	var _RelationshipViewUntrustedName = __webpack_require__(1627);
	
	var _RelationshipViewUntrustedName2 = _interopRequireDefault(_RelationshipViewUntrustedName);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _Subscriptions = __webpack_require__(1009);
	
	var _Subscriptions2 = _interopRequireDefault(_Subscriptions);
	
	var _TeacherDetail = __webpack_require__(1632);
	
	var _TeacherDetail2 = _interopRequireDefault(_TeacherDetail);
	
	var _TeacherDetailActivitySection = __webpack_require__(1633);
	
	var _TeacherDetailActivitySection2 = _interopRequireDefault(_TeacherDetailActivitySection);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1636);
	
	__webpack_require__(1638);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapSubscriptions = function wrapSubscriptions(subscriptions) {
	  return subscriptions.map(function (subscription) {
	    return { group: subscription.getGroup(), subscription: subscription };
	  });
	};
	
	var wrapGroups = function wrapGroups(groups, subscriptions) {
	  return groups.map(function (group) {
	    return { group: group, subscription: subscriptions.find(function (sub) {
	        return group.id === sub.getGroupId();
	      }) };
	  });
	};
	
	var RelationshipView = _react2.default.createClass({
	  displayName: 'RelationshipView',
	
	
	  childContextTypes: {
	    subscriber: _react2.default.PropTypes.instanceOf(_Subscriber2.default).isRequired
	  },
	
	  mixins: [(0, _linkStateWithStores2.default)([_GroupStore2.default])],
	
	  getInitialState: function getInitialState() {
	    var relationship = this.props.relationship;
	
	
	    return Object.assign({
	      relationship: relationship
	    }, this.getStateFromStores());
	  },
	  getChildContext: function getChildContext() {
	    var relationship = this.props.relationship;
	
	    var subscriber = relationship.getRelatedUser();
	
	    return {
	      subscriber: subscriber
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.fetchTeacherDetailIfAdmin();
	    if (!_GroupStore2.default.isLoaded()) {
	      _GroupActions2.default.loadGroups();
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    this.setState(this.getSubscriptionStateFromStores(newProps.relationship));
	  },
	  getStateFromStores: function getStateFromStores() {
	    var relationship = this.props.relationship;
	
	
	    return Object.assign(this.getSubscriptionStateFromStores(relationship), {
	      groups: _GroupStore2.default.getOwnedGroups()
	    });
	  },
	  getSubscriptionStateFromStores: function getSubscriptionStateFromStores(relationship) {
	    var subscriber = relationship.getRelatedUser();
	
	    return {
	      subscriptionsToMe: relationship.getSubscriptionsToMe(),
	      subscriptionsToUser: relationship.getSubscriptionsToUser(),
	      subscriber: subscriber,
	      note: subscriber.getNote()
	    };
	  },
	  fetchTeacherDetailIfAdmin: function fetchTeacherDetailIfAdmin() {
	    var _this = this;
	
	    var orgsWhereUserAdmins = this.props.relationship.getAdminAtOrgIds();
	    var currentIsAdmin = orgsWhereUserAdmins.length > 0;
	
	    var relatedUser = this.props.relationship.getRelatedUser();
	    var relatedIsTeacher = relatedUser.getRole() === _UserConstants.Roles.teacher;
	
	    if (currentIsAdmin && relatedIsTeacher && !this.state.teacherDetail) {
	      // any org will work for
	      var orgId = orgsWhereUserAdmins[0];
	
	      var onSuccess = function onSuccess(teacherDetail) {
	        return _this.setState({ teacherDetail: teacherDetail });
	      };
	      // FIXME @team Graph shouldn't this give user feedback?
	      var onError = function onError(err) {
	        return console.warn(err);
	      };
	
	      _TeacherDetail2.default.getTeacherByOrgAndUserId(orgId, relatedUser.id).then(onSuccess, onError);
	    }
	  },
	  shouldRenderMediums: function shouldRenderMediums() {
	    // If this is a not a subscriber of one of my classes
	    // then do not display devices.
	    return this.props.relationship.getSubscriptionsToMe().length > 0;
	  },
	  renderDetails: function renderDetails() {
	    if (this.shouldRenderMediums()) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_RelationshipViewMediums2.default, { subscriber: this.state.subscriber }),
	        _react2.default.createElement(_RelationshipViewNotes2.default, { subscriber: this.state.subscriber })
	      );
	    } else {
	      return _react2.default.createElement(
	        'span',
	        null,
	        'No details about this person.'
	      );
	    }
	  },
	  renderOwnGroups: function renderOwnGroups() {
	    var groupMember = this.props.groupMember;
	    var subscriptionsToMe = this.state.subscriptionsToMe;
	
	    if (subscriptionsToMe.isEmpty()) {
	      return null;
	    } else {
	      return _react2.default.createElement(
	        _RelationshipViewGroupList2.default,
	        {
	          legend: 'Classes joined',
	          groupSubscriptions: wrapSubscriptions(subscriptionsToMe) },
	        _react2.default.createElement(
	          'footer',
	          { className: 'RelationshipView-groups-footer' },
	          groupMember && !groupMember.isOwner() && _react2.default.createElement(_CopySubscriberButton2.default, {
	            relationship: this.props.relationship,
	            groups: this.state.groups
	          })
	        )
	      );
	    }
	  },
	  renderTheirGroups: function renderTheirGroups() {
	    var _this2 = this;
	
	    var forAllGroups = function forAllGroups() {
	      var allTheirGroups = _this2.state.teacherDetail.getGroups().map(function (group) {
	        return _GroupStore2.default.getGroup(group.id) || group;
	      }).filter(function (group) {
	        return !group.isStaffClass();
	      });
	      return wrapGroups(allTheirGroups, _this2.state.subscriptionsToUser);
	    };
	
	    var forSubscribedGroups = function forSubscribedGroups() {
	      // Filter out groups that are owned by the current user from subscribed groups
	      var unowned = new _Subscriptions2.default(_this2.state.subscriptionsToUser.filter(function (subscription) {
	        var group = _GroupStore2.default.getGroup(subscription.getGroupId());
	        return !group.isOwnedByUser(_CurrentUser2.default.getUserId());
	      }));
	
	      return wrapSubscriptions(unowned);
	    };
	
	    var visibles = this.state.teacherDetail ? forAllGroups() : forSubscribedGroups();
	
	    if (visibles.length) {
	      return _react2.default.createElement(_RelationshipViewGroupList2.default, { legend: 'Classes owned', groupSubscriptions: visibles });
	    } else {
	      return null;
	    }
	  },
	  render: function render() {
	    var ProfileHeader = _FeatureStore2.default.hasFeature('web.new_relationship_view') ? _RelationshipViewProfileHeader2.default : _RelationshipViewHeader2.default;
	    return _react2.default.createElement(
	      'section',
	      { className: (0, _classnames2.default)('RelationshipView', this.props.className) },
	      _react2.default.createElement(ProfileHeader, {
	        groupToAdmin: this.props.groupToAdmin,
	        groupMember: this.props.groupMember,
	        relationship: this.props.relationship,
	        onRequestHide: this.props.onRequestHide,
	        subscriber: this.state.subscriber,
	        teacherDetail: this.state.teacherDetail
	      }),
	      _react2.default.createElement(_RelationshipViewUntrustedName2.default, { subscriber: this.state.subscriber }),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        null,
	        this.state.teacherDetail && _react2.default.createElement(_TeacherDetailActivitySection2.default, { teacherDetail: this.state.teacherDetail }),
	        _react2.default.createElement(
	          _Fieldset2.default,
	          { legend: 'Details', size: 'small' },
	          this.renderDetails()
	        ),
	        this.renderOwnGroups(),
	        this.renderTheirGroups()
	      )
	    );
	  }
	});
	
	exports.default = RelationshipView;

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _CopySubscriberDialog = __webpack_require__(1313);
	
	var _CopySubscriberDialog2 = _interopRequireDefault(_CopySubscriberDialog);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Relationship = __webpack_require__(1007);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1417);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CopySubscriberButton = function (_React$Component) {
	  _inherits(CopySubscriberButton, _React$Component);
	
	  function CopySubscriberButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CopySubscriberButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CopySubscriberButton.__proto__ || Object.getPrototypeOf(CopySubscriberButton)).call.apply(_ref, [this].concat(args))), _this), _this.getUnjoinedOwnedGroups = function () {
	      var relationship = _this.props.relationship;
	
	      var subscriptions = relationship.getSubscriptionsToMe();
	      return new _Groups2.default(_this.props.groups.filter(function (group) {
	        return !subscriptions.some(function (subscription) {
	          return subscription.getGroupId() === group.id;
	        });
	      }));
	    }, _this.renderCopySubscriberDialog = function () {
	      return _react2.default.createElement(_CopySubscriberDialog2.default, {
	        relationship: _this.props.relationship,
	        groups: _this.props.groups
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CopySubscriberButton, [{
	    key: 'render',
	    value: function render() {
	      var unjoinedGroups = this.getUnjoinedOwnedGroups();
	      var hasUnjoinedGroup = unjoinedGroups.length > 0;
	
	      var tooltip = void 0;
	      if (!hasUnjoinedGroup) {
	        var relationship = this.props.relationship;
	
	        var subscriber = relationship.getRelatedUser();
	        var name = subscriber.getName();
	        tooltip = name + ' has joined all of your classes.';
	      }
	
	      var button = _react2.default.createElement(
	        _Button2.default,
	        _extends({}, this.props, {
	          className: (0, _classnames2.default)('CopySubscriberButton', {
	            'CopySubscriberButton-small': this.props.size === 'small',
	            'CopySubscriberButton-disabled': !hasUnjoinedGroup
	          }, this.props.className),
	          color: 'brand',
	          level: 'text',
	          size: 'small',
	          tooltip: tooltip,
	          tooltipPlacement: 'bottom' }),
	        'Copy to another class'
	      );
	
	      if (hasUnjoinedGroup) {
	        button = _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: this.renderCopySubscriberDialog() },
	          button
	        );
	      }
	
	      return button;
	    }
	  }]);
	
	  return CopySubscriberButton;
	}(_react2.default.Component);
	
	CopySubscriberButton.defaultProps = {
	  size: 'normal'
	};
	CopySubscriberButton.displayName = 'CopySubscriberButton';
	exports.default = CopySubscriberButton;

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _GroupSelectionDialog = __webpack_require__(1321);
	
	var _GroupSelectionDialog2 = _interopRequireDefault(_GroupSelectionDialog);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Relationship = __webpack_require__(1007);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _Subscribers = __webpack_require__(997);
	
	var _Subscribers2 = _interopRequireDefault(_Subscribers);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _modal = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CopySubscriberDialog = function (_React$Component) {
	  _inherits(CopySubscriberDialog, _React$Component);
	
	  function CopySubscriberDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CopySubscriberDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CopySubscriberDialog.__proto__ || Object.getPrototypeOf(CopySubscriberDialog)).call.apply(_ref, [this].concat(args))), _this), _this.getGroupsCopyableTo = function () {
	      var relationship = _this.props.relationship;
	
	      var subscriptions = relationship.getSubscriptionsToMe();
	      return new _Groups2.default(_this.props.groups.filter(function (group) {
	        return !subscriptions.some(function (subscription) {
	          return subscription.getGroupId() === group.id && !group.isStaffClass();
	        });
	      }));
	    }, _this.confirmCopySubscriberToGroup = function (group) {
	      var subscriber = _this.props.relationship.getRelatedUser();
	
	      (0, _modal.mountModal)(_react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'CopySubscriberDialog',
	        title: _react2.default.createElement(
	          'span',
	          null,
	          'Are you sure you want to copy ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            subscriber.getName()
	          ),
	          ' to',
	          ' ',
	          _react2.default.createElement(_GroupName2.default, { group: group }),
	          '?'
	        ),
	        onConfirm: function onConfirm() {
	          _GroupActions2.default.addSubscribers(group, new _Subscribers2.default([subscriber])).then(function () {
	            _ToastActions2.default.showSuccessToast(subscriber.getName() + ' was copied to ' + group.getName());
	          }).catch(function (error) {
	            _ToastActions2.default.showErrorToast('Unable to copy ' + subscriber.getName() + ' to ' + group.getName());
	            console.warn(error);
	          });
	          _this.refs.copySubscriberDialog.hide();
	        },
	        actionButtonText: 'Copy',
	        cancelButtonText: 'Cancel'
	      }), _this);
	    }, _this.renderEmptyMessage = function (subscriber) {
	      if (_this.props.groups.length === 0) {
	        return 'You don\'t have any groups for ' + subscriber.getName() + ' to join yet.';
	      } else {
	        return subscriber.getName() + ' has joined all of your classes.';
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CopySubscriberDialog, [{
	    key: 'render',
	    value: function render() {
	      var subscriber = this.props.relationship.getRelatedUser();
	      var emptyMessage = this.renderEmptyMessage(subscriber);
	      return _react2.default.createElement(_GroupSelectionDialog2.default, _extends({}, this.props, {
	        ref: 'copySubscriberDialog',
	        title: 'Copy ' + subscriber.getName() + ' to another class',
	        groups: this.getGroupsCopyableTo(),
	        onSelect: this.confirmCopySubscriberToGroup,
	        emptyMessage: emptyMessage
	      }));
	    }
	  }]);
	
	  return CopySubscriberDialog;
	}(_react2.default.Component);
	
	CopySubscriberDialog.displayName = 'CopySubscriberDialog';
	exports.default = CopySubscriberDialog;

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Buttons = __webpack_require__(1315);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _focusNode = __webpack_require__(1210);
	
	var _focusNode2 = _interopRequireDefault(_focusNode);
	
	__webpack_require__(1318);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A simple dialog  for displaying a message with the option to accept or cancel.
	 *
	 * Use with [ModalTrigger](/components/ModalTrigger)
	 *
	 * ```example
	 *  <ModalTrigger
	 *    modal={
	 *      <ConfirmDialog>
	 *        Hello World!
	 *      </ConfirmDialog>
	 *    }>
	 *    <Button>Show dialog</Button>
	 *  </ModalTrigger>
	 * ```
	 */
	
	var ConfirmDialog = function (_React$Component) {
	  _inherits(ConfirmDialog, _React$Component);
	
	  function ConfirmDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConfirmDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConfirmDialog.__proto__ || Object.getPrototypeOf(ConfirmDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loading: false
	    }, _this.handleCancelButtonClick = function () {
	      _this.props.onRequestHide();
	      if (_this.props.onCancel) {
	        _this.props.onCancel();
	      }
	    }, _this.handleConfirmButtonClick = function () {
	      _this.setState({ loading: true });
	
	      if (_this.props.staticModal) {
	        _this.props.preConfirmPromise().then(_this.props.onRequestHide).then(_this.props.onConfirm);
	      } else {
	        _this.props.preConfirmPromise().then(_this.props.onConfirm);
	      }
	    }, _this.renderCancelButton = function () {
	      return !_this.props.hideCancel && _react2.default.createElement(
	        _Button2.default,
	        {
	          key: 'confirm-cancel',
	          className: 'cancel',
	          eventElementName: 'ConfirmDialog-cancelButton',
	          eventContextName: _this.props.eventContext,
	          color: 'brand',
	          level: 'text',
	          onClick: _this.handleCancelButtonClick },
	        _this.props.cancelButtonText
	      );
	    }, _this.renderActionButton = function () {
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          'data-test-selector': 'confirm_dialog_action_button',
	          key: 'confirm-action',
	          className: 'action',
	          eventElementName: 'ConfirmDialog-actionButton',
	          eventContextName: _this.props.eventContext,
	          disabled: _this.props.confirmDisabled,
	          onClick: _this.handleConfirmButtonClick,
	          color: _this.props.actionButtonColor,
	          ref: function ref(component) {
	            return (0, _focusNode2.default)(_reactDom2.default.findDOMNode(component));
	          } },
	        _this.props.actionButtonText
	      );
	    }, _this.renderBoxBody = function () {
	      if (_this.state.loading) {
	        return _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: _this.props.divided },
	          _react2.default.createElement(_LoadingIndicator2.default, null)
	        );
	      } else {
	        return _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: _this.props.divided },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)({ 'ConfirmDialog-text': !!_this.props.children }) },
	            _this.props.children
	          ),
	          _react2.default.createElement(
	            _Buttons2.default,
	            { axis: 'y' },
	            _this.renderActionButton(),
	            _this.renderCancelButton()
	          )
	        );
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ConfirmDialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({}, this.props, {
	          className: (0, _classnames2.default)('ConfirmDialog', this.props.className),
	          onRequestHide: (0, _createChainedFunction2.default)(this.props.onCancel, this.props.onRequestHide) }),
	        this.renderBoxBody()
	      );
	    }
	  }]);
	
	  return ConfirmDialog;
	}(_react2.default.Component);
	
	ConfirmDialog.defaultProps = {
	  actionButtonText: 'Yes',
	  cancelButtonText: 'No',
	  preConfirmPromise: function preConfirmPromise() {
	    return Promise.resolve();
	  },
	  onConfirm: function onConfirm() {},
	  size: 'xsmall',
	  hideCancel: false,
	  divided: false,
	  staticModal: true
	};
	ConfirmDialog.displayName = 'ConfirmDialog';
	exports.default = ConfirmDialog;

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1316);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Buttons = function (_React$Component) {
	  _inherits(Buttons, _React$Component);
	
	  function Buttons() {
	    _classCallCheck(this, Buttons);
	
	    return _possibleConstructorReturn(this, (Buttons.__proto__ || Object.getPrototypeOf(Buttons)).apply(this, arguments));
	  }
	
	  _createClass(Buttons, [{
	    key: 'render',
	    value: function render() {
	      var children = _react2.default.Children.map(this.props.children, function (child, index) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'Buttons-item', key: index },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('Buttons', {
	            'Buttons--x': this.props.axis === 'x',
	            'Buttons--y': this.props.axis === 'y',
	            'Buttons--left': this.props.align === 'left' && this.props.axis === 'x',
	            'Buttons--right': this.props.align === 'right' && this.props.axis === 'x',
	            'Buttons--full': this.props.full
	          }) },
	        children
	      );
	    }
	  }]);
	
	  return Buttons;
	}(_react2.default.Component);
	
	Buttons.defaultProps = {
	  align: 'center',
	  axis: 'x'
	};
	Buttons.displayName = 'Buttons';
	exports.default = Buttons;

/***/ },
/* 1316 */
1136,
/* 1317 */,
/* 1318 */
1136,
/* 1319 */,
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupName = function GroupName(_ref) {
	  var group = _ref.group;
	
	  var groupName = group.getName();
	  var entities = _TextEntities2.default.parseEmoji(groupName);
	  return _react2.default.createElement(_TextWithEntities2.default, { text: groupName, entities: entities });
	}; /*  weak */
	exports.default = GroupName;

/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _groupDisplay = __webpack_require__(1322);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _GroupCreateModal = __webpack_require__(1326);
	
	var _GroupCreateModal2 = _interopRequireDefault(_GroupCreateModal);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _InlineBlock = __webpack_require__(1409);
	
	var _InlineBlock2 = _interopRequireDefault(_InlineBlock);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollableArea = __webpack_require__(1412);
	
	var _ScrollableArea2 = _interopRequireDefault(_ScrollableArea);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(1415);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var GroupSelectionDialog = function (_React$Component) {
	  _inherits(GroupSelectionDialog, _React$Component);
	
	  function GroupSelectionDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupSelectionDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupSelectionDialog.__proto__ || Object.getPrototypeOf(GroupSelectionDialog)).call.apply(_ref, [this].concat(args))), _this), _this.hide = function () {
	      _this.props.onRequestHide();
	    }, _this.renderAddGroupOption = function () {
	      var dialog = _react2.default.createElement(_GroupCreateModal2.default, { onCreate: _this.props.onSelect });
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: dialog },
	        _react2.default.createElement(
	          'li',
	          { className: 'GroupSelectionDialog-addGroupItem' },
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              className: 'GroupSelectionDialog-addGroupItem-link',
	              eventElementName: 'GroupSelectionDialog-addGroupItem-link' },
	            _react2.default.createElement(
	              _Text2.default,
	              { size: 'xsmall', weight: 'semibold' },
	              'Add a new class'
	            )
	          )
	        )
	      );
	    }, _this.renderGroupOption = function (group) {
	      var subscribersCount = (0, _groupDisplay.membershipDescriptionFor)(group);
	
	      var groupCodeOpt = !group.isStaffClass() && _react2.default.createElement(
	        _Text2.default,
	        { className: 'GroupSelectionDialog-groupItem-code', color: 'thunder' },
	        '@',
	        group.getCode()
	      );
	
	      return _react2.default.createElement(
	        'li',
	        { key: group.id, className: 'GroupSelectionDialog-groupItem' },
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            className: 'GroupSelectionDialog-groupItem-link',
	            onClick: function onClick() {
	              return _this.props.onSelect(group);
	            },
	            eventElementName: 'GroupSelectionDialog-groupItem-link' },
	          _react2.default.createElement(
	            _FlexibleBlock2.default,
	            { flex: 'left' },
	            _react2.default.createElement(
	              _FlexibleBlock2.default,
	              { flex: 'right' },
	              _react2.default.createElement(_GroupAvatar2.default, {
	                className: 'GroupSelectionDialog-groupItem-avatar',
	                group: group
	              }),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _InlineBlock2.default,
	                  { alignv: 'middle', height: 40, fullWidth: true },
	                  _react2.default.createElement(
	                    _Text2.default,
	                    { className: 'GroupSelectionDialog-groupItem-name', truncate: true },
	                    _react2.default.createElement(_GroupName2.default, { group: group })
	                  ),
	                  groupCodeOpt
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _InlineBlock2.default,
	              { alignv: 'middle', height: 40 },
	              _react2.default.createElement(
	                _Text2.default,
	                {
	                  className: 'GroupSelectionDialog-groupItem-count',
	                  color: 'thunder',
	                  size: 'xxsmall' },
	                subscribersCount
	              )
	            )
	          )
	        )
	      );
	    }, _this.renderNoGroups = function () {
	      return _react2.default.createElement(
	        'li',
	        { className: 'GroupSelectionDialog-emptyMessage' },
	        _this.props.emptyMessage
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupSelectionDialog, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var groups = this.props.groups;
	
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'GroupSelectionDialog'
	        }, this.props, {
	          className: 'GroupSelectionDialog',
	          size: 'small' }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          {
	            className: 'GroupSelectionDialog-body',
	            divided: true,
	            full: true },
	          _react2.default.createElement(
	            _ScrollableArea2.default,
	            {
	              className: 'GroupSelectionDialog-scrollArea',
	              showShadows: true,
	              useBodyChildrenHeight: true },
	            _react2.default.createElement(
	              'ul',
	              { className: 'GroupSelectionDialog-list' },
	              groups.length === 0 && this.renderNoGroups(),
	              this.renderAddGroupOption(),
	              groups.map(function (group) {
	                return _this2.renderGroupOption(group);
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return GroupSelectionDialog;
	}(_react2.default.Component);
	
	GroupSelectionDialog.defaultProps = {
	  onSelect: function onSelect() /* group */{}
	};
	GroupSelectionDialog.displayName = 'GroupSelectionDialog';
	exports.default = GroupSelectionDialog;

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.titleForSection = titleForSection;
	exports.membershipDescriptionFor = membershipDescriptionFor;
	exports.memberTypeFor = memberTypeFor;
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _roleHelpers = __webpack_require__(1230);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Language strings that will be properly localized and pluralized eventually
	 */
	
	function titleForSection(sectionKey) {
	  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  switch (sectionKey) {
	    case 'districts':
	      return count > 1 ? 'Districts' : 'District';
	    case 'schools':
	      return count > 1 ? 'Schools' : 'School';
	    case 'classes-owned':
	      return 'Classes owned';
	    case 'classes-subscribed':
	      return 'Classes joined';
	    default:
	      return '???';
	  }
	}
	
	function membershipDescriptionFor(group, role) {
	  var size = void 0;
	  if (role && role !== _roleHelpers.EVERYONE) {
	    var roleObj = group.getRoles().find(function (r) {
	      return r.role === role;
	    });
	    size = roleObj ? roleObj.count : 0;
	  } else {
	    size = group.getMembershipsCount();
	  }
	  var membersDescription = 'participant';
	
	  if (group.isStaffClass()) {
	    membersDescription = 'member';
	  }
	  if (role && role !== _roleHelpers.EVERYONE) {
	    membersDescription = role;
	  }
	  if (size !== 1) {
	    membersDescription += 's';
	  }
	  return size + ' ' + membersDescription;
	}
	
	function memberTypeFor(group) {
	  if (group.isStaffClass()) {
	    return 'members';
	  } else {
	    return 'participants';
	  }
	}

/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _GroupAvatar = __webpack_require__(1324);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupAvatar = function (_React$Component) {
	  _inherits(GroupAvatar, _React$Component);
	
	  function GroupAvatar() {
	    _classCallCheck(this, GroupAvatar);
	
	    return _possibleConstructorReturn(this, (GroupAvatar.__proto__ || Object.getPrototypeOf(GroupAvatar)).apply(this, arguments));
	  }
	
	  _createClass(GroupAvatar, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_Image2.default, _extends({}, this.props, {
	        className: (0, _classnames2.default)(_GroupAvatar2.default[this.props.size], this.props.className),
	        src: this.props.group.getAvatarUrl(),
	        circle: true
	      }));
	    }
	  }]);
	
	  return GroupAvatar;
	}(_react2.default.Component);
	
	GroupAvatar.displayName = 'GroupAvatar';
	exports.default = GroupAvatar;

/***/ },
/* 1324 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"xxsmall":"GroupAvatar__xxsmall___2SP_o","xsmall":"GroupAvatar__xsmall___1t6_6","small":"GroupAvatar__small___C7ODj","medium":"GroupAvatar__medium___tv_mW","large":"GroupAvatar__large___3U2FZ"};

/***/ },
/* 1325 */,
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _lodash = __webpack_require__(555);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _DialogButton = __webpack_require__(1327);
	
	var _DialogButton2 = _interopRequireDefault(_DialogButton);
	
	var _Divider = __webpack_require__(1330);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupAvatarSelector = __webpack_require__(1333);
	
	var _GroupAvatarSelector2 = _interopRequireDefault(_GroupAvatarSelector);
	
	var _GroupForm = __webpack_require__(1343);
	
	var _GroupForm2 = _interopRequireDefault(_GroupForm);
	
	var _GroupOptionsForm = __webpack_require__(1387);
	
	var _GroupOptionsForm2 = _interopRequireDefault(_GroupOptionsForm);
	
	var _GroupSchoolSelect = __webpack_require__(1364);
	
	var _GroupSchoolSelect2 = _interopRequireDefault(_GroupSchoolSelect);
	
	var _MediaObject = __webpack_require__(1396);
	
	var _MediaObject2 = _interopRequireDefault(_MediaObject);
	
	var _MessageHistoryDialog = __webpack_require__(1399);
	
	var _MessageHistoryDialog2 = _interopRequireDefault(_MessageHistoryDialog);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SetUserEmailModal = __webpack_require__(1402);
	
	var _SetUserEmailModal2 = _interopRequireDefault(_SetUserEmailModal);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _modal = __webpack_require__(1188);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _utils = __webpack_require__(956);
	
	__webpack_require__(1407);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var makeInitialState = function makeInitialState() {
	  return {
	    hasChildren: false,
	    code: null,
	    name: null,
	    user: null,
	    avatarHandpicked: false,
	    groupCodeHandpicked: false,
	    suggestedGroupCode: false,
	    canSubmit: false,
	    prominentOrg: _CurrentUser2.default.inExpVariant('PROMINENT_ORG', 'prominent_org'),
	    initialOrganization: null
	  };
	};
	
	var GroupCreateModal = function (_Component) {
	  _inherits(GroupCreateModal, _Component);
	
	  function GroupCreateModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupCreateModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupCreateModal.__proto__ || Object.getPrototypeOf(GroupCreateModal)).call.apply(_ref, [this].concat(args))), _this), _this.suggestGroupCode = (0, _lodash.debounce)(function (name) {
	      _Group2.default.suggestCode(name).then(function (codes) {
	        if (!_this.state.code && codes && codes[0]) {
	          _this.setState({ code: codes[0] });
	          _this.refs.groupForm.changeCodeTo(codes[0]);
	        }
	        _this.setState({ suggestedGroupCode: true });
	      });
	    }, 300), _this.suggestAvatarForName = (0, _lodash.debounce)(function (name) {
	      if (!_this || !_this.refs || !_this.refs.avatarSelector) {
	        return;
	      }
	      _this.refs.avatarSelector.searchAvatarForName(name);
	    }, 300), _this.onAvatarSelected = function () {
	      _this.setState({ avatarHandpicked: true });
	    }, _this.onCodeChange = function () {
	      if (!_this.state.groupCodeHandpicked) {
	        _this.setState({ groupCodeHandpicked: true });
	      }
	    }, _this.onOptionsChange = function (name, value) {
	      _this.setState(_defineProperty({}, name, value));
	    }, _this.onSubmit = function () {
	      var orgData = {
	        organization: _this.state.prominentOrg ? _this.refs.groupForm.getOrganizationForSubmit() : _this.refs.groupSchoolMenu.getOrganizationForSubmit()
	      };
	
	      var groupToCreate = new _Group2.default(Object.assign({
	        name: _this.state.code,
	        class_name: _this.state.name,
	        group_avatar: {
	          id: _this.refs.avatarSelector.getSelectedAvatarId()
	        }
	      }, _this.refs.options.getValues(), orgData));
	
	      _GroupActions2.default.create(groupToCreate).then(function (group) {
	        _this.props.onRequestHide();
	        if (_this.shouldShowMessageHistoryPrompt()) {
	          // the setTimeout(..., 0) is necessary to avoid an infinite loop from the
	          // callback to onRequestHide caused by the route change in this.props.onCreate
	          (0, _modal.mountModal)(_react2.default.createElement(_MessageHistoryDialog2.default, {
	            onRequestHide: function onRequestHide() {
	              return setTimeout(function () {
	                return _this.props.onCreate && _this.props.onCreate(group);
	              }, 0);
	            },
	            onConfirm: function onConfirm() {
	              return _GroupActions2.default.enableAllGroupMessageHistory();
	            }
	          }), _this);
	          _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.MESSAGE_HISTORY_MODAL);
	        } else {
	          if (_this.props.onCreate) {
	            _this.props.onCreate(group);
	          }
	        }
	      }).catch(_ToastActions2.default.showAPIError);
	    }, _this.onFormInvalid = function () {
	      // Prevent excessive re-renders
	      if (_this.state.canSubmit) {
	        _this.setState({ name: null, code: null, canSubmit: false });
	      }
	    }, _this.onFormValid = function (name, code) {
	      _this.setState({ name: name, code: code, canSubmit: true });
	    }, _this.onValidNameChange = function (name) {
	      if (!_this.state.groupCodeHandpicked && !_this.state.suggestedGroupCode) {
	        _this.suggestGroupCode(name);
	      }
	
	      if (!_this.state.avatarHandpicked) {
	        _this.suggestAvatarForName(name);
	      }
	    }, _this.shouldShowMessageHistoryPrompt = function () {
	      return _CurrentUser2.default.getUser().getPromptsInventory().find(function (i) {
	        return i.get('action') === _PromptConstants.PromptNames.MESSAGE_HISTORY_MODAL;
	      }) && !_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.MESSAGE_HISTORY_MODAL);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupCreateModal, [{
	    key: 'renderSchoolMenu',
	    value: function renderSchoolMenu() {
	      return _react2.default.createElement(_GroupSchoolSelect2.default, {
	        ref: 'groupSchoolMenu',
	        hideUnaffiliated: this.state.hasChildren,
	        initialOrganizationId: _CurrentUser2.default.getUser().getOrganizationId(),
	        input: 'menu',
	        prefix: 'At '
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var user = this.state.user;
	
	      if (user && !user.hasEmail()) {
	        return _react2.default.createElement(_SetUserEmailModal2.default, _extends({}, this.props, {
	          closeOnSave: false,
	          message: 'An email address is required to create a group.'
	        }));
	      }
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'GroupCreateModal'
	        }, this.props, {
	          className: 'GroupCreateModal',
	          title: 'Create a class',
	          subtext: !this.state.prominentOrg && this.renderSchoolMenu(),
	          size: 'small' }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          _react2.default.createElement(
	            _MediaObject2.default,
	            { className: 'GroupCreateModal-top' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_GroupAvatarSelector2.default, { ref: 'avatarSelector', onSelect: this.onAvatarSelected })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_GroupForm2.default, {
	                ref: 'groupForm',
	                onFormValid: this.onFormValid,
	                onValidNameChange: this.onValidNameChange,
	                onCodeChange: this.onCodeChange,
	                onFormInvalid: this.onFormInvalid,
	                hasChildren: this.state.hasChildren,
	                showOrg: this.state.prominentOrg,
	                currentOrganization: this.state.initialOrganization
	              })
	            )
	          ),
	          _react2.default.createElement(_Divider2.default, { size: 'medium' }),
	          _react2.default.createElement(_GroupOptionsForm2.default, {
	            ref: 'options',
	            subscriberInitiatedChats: true,
	            hasChildren: this.state.hasChildren,
	            showSearchable: false,
	            userIsTeacher: _CurrentUser2.default.getUser().isTeacher(),
	            onChange: this.onOptionsChange
	          }),
	          _react2.default.createElement(
	            _DialogButton2.default,
	            {
	              className: 'GroupCreateModal-submitButton',
	              disabled: !this.state.canSubmit,
	              onClick: this.onSubmit },
	            'Create'
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default, _OrganizationStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState) {
	      var user = _CurrentUser2.default.isSignedIn() ? _CurrentUser2.default.getUser() : null;
	      var orgId = user ? user.getOrganizationId() : null;
	      return _extends({}, prevState || makeInitialState(), {
	        user: user,
	        initialOrganization: orgId ? _OrganizationStore2.default.getOrganization(orgId) : null
	      });
	    }
	  }]);
	
	  return GroupCreateModal;
	}(_react.Component);
	
	GroupCreateModal.displayName = 'GroupCreateModal';
	exports.default = _utils.Container.create(GroupCreateModal, { withProps: true });

/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1328);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogButton = function (_React$Component) {
	  _inherits(DialogButton, _React$Component);
	
	  function DialogButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DialogButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DialogButton.__proto__ || Object.getPrototypeOf(DialogButton)).call.apply(_ref, [this].concat(args))), _this), _this.renderText = function () {
	      return _this.props.text || null;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DialogButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'footer',
	        { className: 'DialogButton-wrap' },
	        _react2.default.createElement(
	          _Button2.default,
	          _extends({}, this.props, { className: (0, _classnames2.default)('DialogButton', this.props.className) }),
	          this.renderText(),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return DialogButton;
	}(_react2.default.Component);
	
	DialogButton.displayName = 'DialogButton';
	exports.default = DialogButton;

/***/ },
/* 1328 */
1136,
/* 1329 */,
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Divider = function (_React$Component) {
	  _inherits(Divider, _React$Component);
	
	  function Divider() {
	    _classCallCheck(this, Divider);
	
	    return _possibleConstructorReturn(this, (Divider.__proto__ || Object.getPrototypeOf(Divider)).apply(this, arguments));
	  }
	
	  _createClass(Divider, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('hr', { className: (0, _classnames2.default)('Divider', this.props.className, (0, _getPropClasses.getPropClassesFromInstance)(this)) });
	    }
	  }]);
	
	  return Divider;
	}(_react2.default.Component);
	
	Divider.propClasses = {
	  size: {
	    small: 'Divider--small',
	    medium: 'Divider--medium',
	    large: 'Divider--large'
	  }
	};
	Divider.defaultProps = {
	  size: 'large'
	};
	Divider.displayName = 'Divider';
	exports.default = Divider;

/***/ },
/* 1331 */
1136,
/* 1332 */,
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AvatarActions = __webpack_require__(1334);
	
	var _AvatarStore = __webpack_require__(1337);
	
	var _AvatarStore2 = _interopRequireDefault(_AvatarStore);
	
	var _GroupAvatarPicker = __webpack_require__(1338);
	
	var _GroupAvatarPicker2 = _interopRequireDefault(_GroupAvatarPicker);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1341);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MIN_HIDDEN_AVATAR_ID = 9001;
	
	var GroupAvatarSelector = _react2.default.createClass({
	  displayName: 'GroupAvatarSelector',
	
	
	  mixins: [(0, _linkStateWithStores2.default)([_AvatarStore2.default])],
	
	  getInitialState: function getInitialState() {
	    return this.getStateFromStores();
	  },
	  componentDidMount: function componentDidMount() {
	    if (!_AvatarStore2.default.areGroupAvatarsLoaded()) {
	      return (0, _AvatarActions.loadGroupAvatars)();
	    }
	  },
	  onAvatarSelected: function onAvatarSelected(avatar) {
	    this.setState({ avatar: avatar });
	    this.props.onSelect(avatar);
	  },
	  getSelectedAvatar: function getSelectedAvatar() {
	    return this.state.avatar;
	  },
	  getSelectedAvatarId: function getSelectedAvatarId() {
	    return this.state.avatar.id;
	  },
	  getStateFromStores: function getStateFromStores() {
	    var avatar = null;
	
	    if (!this.props.initialAvatar) {
	      avatar = _AvatarStore2.default.getGroupAvatars().getRandomAvatar();
	    } else {
	      avatar = _AvatarStore2.default.getGroupAvatars().get(this.props.initialAvatar.id);
	      // HACK: In order to display hidden avatars for classes that have them selected
	      if (!avatar && this.props.initialAvatar.id >= MIN_HIDDEN_AVATAR_ID) {
	        avatar = this.props.initialAvatar;
	      }
	    }
	
	    return {
	      avatar: avatar
	    };
	  },
	  searchAvatarForName: function searchAvatarForName(name) {
	    var _this = this;
	
	    (0, _AvatarActions.fetchGroupAvatar)(name).then(function (avatars) {
	      var avatar = avatars.first();
	
	      if (avatar) {
	        _this.setState({ avatar: avatar });
	      }
	    });
	  },
	  renderAvatar: function renderAvatar() {
	    return _react2.default.createElement(_Image2.default, {
	      className: 'GroupAvatarSelector-Avatar',
	      src: this.state.avatar.getUrl(),
	      circle: true
	    });
	  },
	  renderPlaceholder: function renderPlaceholder() {
	    return _react2.default.createElement('div', { className: 'GroupAvatarSelector-Placeholder' });
	  },
	  render: function render() {
	    var groupAvatarPickerModal = _react2.default.createElement(_GroupAvatarPicker2.default, {
	      onSelect: this.onAvatarSelected,
	      selectedAvatar: this.state.avatar ? this.state.avatar.id : null
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'GroupAvatarSelector' },
	      _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: groupAvatarPickerModal },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.state.avatar ? this.renderAvatar() : this.renderPlaceholder(),
	          _react2.default.createElement(
	            'div',
	            { className: 'GroupAvatarSelector-Subtext' },
	            _react2.default.createElement(
	              _Link2.default,
	              { href: '#' },
	              'Edit icon'
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = GroupAvatarSelector;

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadGroupAvatars = loadGroupAvatars;
	exports.fetchGroupAvatar = fetchGroupAvatar;
	
	var _AvatarConstants = __webpack_require__(1335);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _GroupAvatars = __webpack_require__(1336);
	
	var _GroupAvatars2 = _interopRequireDefault(_GroupAvatars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function loadGroupAvatars() {
	  return _GroupAvatars2.default.fetch().then(function (avatars) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _AvatarConstants.ActionTypes.GROUP_AVATARS_LOADED,
	      avatars: avatars
	    });
	    return avatars;
	  });
	}
	function fetchGroupAvatar(groupName) {
	  return _GroupAvatars2.default.fetch(groupName);
	}
	
	exports.default = {
	  loadGroupAvatars: loadGroupAvatars,
	  fetchGroupAvatar: fetchGroupAvatar
	};

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['GROUP_AVATARS_LOADED']); /*  weak */

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Avatar = __webpack_require__(933);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupAvatars = function (_Collection) {
	  _inherits(GroupAvatars, _Collection);
	
	  function GroupAvatars() {
	    _classCallCheck(this, GroupAvatars);
	
	    return _possibleConstructorReturn(this, (GroupAvatars.__proto__ || Object.getPrototypeOf(GroupAvatars)).apply(this, arguments));
	  }
	
	  _createClass(GroupAvatars, [{
	    key: 'parse',
	    value: function parse(response) {
	      return response.map(function (avatar) {
	        return _Avatar2.default.fromJSON(avatar);
	      });
	    }
	  }, {
	    key: 'getRandomAvatar',
	    value: function getRandomAvatar() {
	      return this.at(parseInt(Math.random() * this.length, 10));
	    }
	
	    // $FlowFixMe
	
	  }], [{
	    key: 'fetch',
	    value: function fetch() {
	      var groupName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var data = {};
	      if (groupName) {
	        data.q = groupName;
	      }
	
	      return (0, _apiRequest2.default)('/groups/avatars', 'GET', data).then(function (response) {
	        return GroupAvatars.fromJSON(response);
	      });
	    }
	  }]);
	
	  return GroupAvatars;
	}(_Collection3.default);
	
	GroupAvatars.displayName = 'GroupAvatars';
	exports.default = GroupAvatars;

/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _AvatarConstants = __webpack_require__(1335);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _GroupAvatars = __webpack_require__(1336);
	
	var _GroupAvatars2 = _interopRequireDefault(_GroupAvatars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AvatarStore = function (_ReduceStore) {
	  _inherits(AvatarStore, _ReduceStore);
	
	  function AvatarStore() {
	    _classCallCheck(this, AvatarStore);
	
	    return _possibleConstructorReturn(this, (AvatarStore.__proto__ || Object.getPrototypeOf(AvatarStore)).apply(this, arguments));
	  }
	
	  _createClass(AvatarStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        groupAvatars: {
	          loaded: false,
	          collection: new _GroupAvatars2.default()
	        }
	      };
	    }
	  }, {
	    key: 'getGroupAvatars',
	    value: function getGroupAvatars() {
	      return this.getState().groupAvatars.collection;
	    }
	  }, {
	    key: 'areGroupAvatarsLoaded',
	    value: function areGroupAvatarsLoaded() {
	      return this.getState().groupAvatars.loaded;
	    }
	  }, {
	    key: 'reduce',
	    value: function reduce(state, action) {
	      switch (action.type) {
	        case _AvatarConstants.ActionTypes.GROUP_AVATARS_LOADED:
	          return {
	            groupAvatars: {
	              loaded: true,
	              collection: action.avatars
	            }
	          };
	        default:
	          return state;
	      }
	    }
	  }]);
	
	  return AvatarStore;
	}(_utils.ReduceStore);
	
	AvatarStore.displayName = 'AvatarStore';
	exports.default = new AvatarStore(_Dispatcher.dispatcher);

/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AvatarActions = __webpack_require__(1334);
	
	var _AvatarActions2 = _interopRequireDefault(_AvatarActions);
	
	var _AvatarStore = __webpack_require__(1337);
	
	var _AvatarStore2 = _interopRequireDefault(_AvatarStore);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _List = __webpack_require__(1281);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(1282);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1339);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var GroupAvatarPicker = function (_React$Component) {
	  _inherits(GroupAvatarPicker, _React$Component);
	
	  function GroupAvatarPicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupAvatarPicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupAvatarPicker.__proto__ || Object.getPrototypeOf(GroupAvatarPicker)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelection = function (avatar) {
	      _this.props.onRequestHide();
	      if (_this.props.onSelect) {
	        _this.props.onSelect(avatar);
	      }
	    }, _this.renderAvatar = function (avatar, index) {
	      var selected = _this.props.selectedAvatar === avatar.id;
	
	      var selectedGlyph = selected ? _react2.default.createElement(
	        'div',
	        { className: 'GroupAvatarPicker-avatar-selectedCheck' },
	        _react2.default.createElement(_Glyph2.default, { name: 'check', size: 'medium' })
	      ) : null;
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        {
	          key: index,
	          className: (0, _classnames2.default)('GroupAvatarPicker-avatar', { selected: selected }),
	          onClick: function onClick() {
	            return _this.handleSelection(avatar);
	          } },
	        _react2.default.createElement(_Image2.default, { className: 'GroupAvatarPicker-avatar-image', src: avatar.getUrl() }),
	        selectedGlyph
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupAvatarPicker, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'GroupAvatarPicker'
	        }, this.props, {
	          title: 'Select a class icon' }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          _react2.default.createElement(
	            _List2.default,
	            null,
	            _AvatarStore2.default.getGroupAvatars().map(this.renderAvatar)
	          )
	        )
	      );
	    }
	  }]);
	
	  return GroupAvatarPicker;
	}(_react2.default.Component);
	
	GroupAvatarPicker.prefetch = [function () {
	  if (!_AvatarStore2.default.areGroupAvatarsLoaded()) {
	    return _AvatarActions2.default.loadGroupAvatars();
	  }
	}];
	GroupAvatarPicker.displayName = 'GroupAvatarPicker';
	exports.default = GroupAvatarPicker;

/***/ },
/* 1339 */
1136,
/* 1340 */,
/* 1341 */
1136,
/* 1342 */,
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupSchoolSelect = __webpack_require__(1364);
	
	var _GroupSchoolSelect2 = _interopRequireDefault(_GroupSchoolSelect);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _PrependedTextInput = __webpack_require__(1384);
	
	var _PrependedTextInput2 = _interopRequireDefault(_PrependedTextInput);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cfg = {};
	
	var GroupForm = function (_Component) {
	  _inherits(GroupForm, _Component);
	
	  function GroupForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupForm.__proto__ || Object.getPrototypeOf(GroupForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      classCodeError: null,
	      classNameError: null,
	      verifyingCodeUniqueness: false
	    }, _this._isMounted = false, _this.onNameChange =
	    // typecheck: ignore statement
	    function (event) {
	      // Clear previous errors
	      _this.setState({ classNameError: null });
	      // $FlowFixMe
	      var name = event.currentTarget.value;
	
	      if (_this.props.name && name === _this.props.name && _this.props.code === _this.getCurrentCodeValue()) {
	        _this.props.onFormInvalid();
	        return;
	      }
	
	      if (!_this.nameIsValid(name)) {
	        return;
	      }
	
	      if (_this.hasDuplicateGroupName(name)) {
	        _this.setState({
	          classNameError: 'You already have a class by that name. Please pick another.'
	        });
	        _this.props.onFormInvalid();
	        return;
	      }
	
	      if (_this.props.onValidNameChange) {
	        _this.props.onValidNameChange(name);
	      }
	      var code = _this.getCurrentCodeValue();
	      if (_this.nameIsValid(name) && _this.codeIsValid(code) && !_this.state.classCodeError) {
	        _this.props.onFormValid(name, code);
	      }
	    }, _this.onCodeChange =
	    // typecheck: ignore statement
	    function (event) {
	      // Notify parent that the form is invalid, so it can disable submit button
	      _this.props.onFormInvalid();
	
	      // Clear previous errors
	      _this.setState({ classCodeError: null });
	      _this.setState({ verifyingCodeUniqueness: false });
	
	      // We must trim the code here to match the behavior of Formsy's length validators
	      // $FlowFixMe
	      var code = event.currentTarget.value.trim();
	
	      if (_this.props.code && code.length === 0) {
	        _this.setState({ classCodeError: 'Class code is required.' });
	        return;
	      }
	
	      // When editing an existing class, and the code is the same as existing code
	      if (_this.props.code && code === _this.props.code) {
	        // If the name has also changed to something valid
	        if (_this.props.name !== _this.getCurrentNameValue() && _this.nameIsValid(_this.getCurrentNameValue()) && !_this.state.classNameError) {
	          _this.props.onFormValid(_this.getCurrentNameValue(), code);
	        } else {
	          _this.props.onFormInvalid();
	        }
	        return;
	      }
	
	      // If the code is empty, and the current name is valid, call the onFormValid handler
	      // and skip other checks on the code (but only if this isn't an existing class)
	      // This let's us generate a code for a new class created with a blank code.
	      if (!code && !_this.props.code && _this.nameIsValid(_this.getCurrentNameValue()) && !_this.state.classNameError) {
	        _this.props.onFormValid(_this.getCurrentNameValue(), code);
	        return;
	      }
	
	      // Otherwise, check if the code is valid with client-side checks
	      if (code && _this.codeIsValid(code)) {
	        // Turn on the class code input's loading indicator
	        _this.setState({ verifyingCodeUniqueness: true });
	
	        // Then call the server to check if the code is unique
	        _this.validateGroupCodeUniqueness(code);
	      }
	    }, _this.onSchoolChange = function (orgId) {
	      var code = _this.getCurrentCodeValue();
	      var name = _this.getCurrentNameValue();
	      if (_this.nameIsValid(name) && _this.codeIsValid(code) && !_this.state.classCodeError) {
	        _this.props.onFormValid(name, code, orgId);
	      }
	    }, _this.getCurrentNameValue = function () {
	      // This is the odd roundabout method for fetching the value of a FormInput
	      return _this.refs.name.refs.children.getValue();
	    }, _this.getCurrentCodeValue = function () {
	      return _this.refs.code.refs.children.getValue();
	    }, _this.getOrganizationForSubmit = function () {
	      return _this.refs.org.getOrganizationForSubmit();
	    }, _this.hasDuplicateGroupName = function (name) {
	      return _this.props.name ? _GroupStore2.default.getOwnedGroupForName(name) && name.toLowerCase() !== _this.props.name.toLowerCase() : !!_GroupStore2.default.getOwnedGroupForName(name);
	    }, _this.nameIsValid = function (name) {
	      return name && name.length >= cfg.GROUP_NAME_MIN_LENGTH && name.length <= cfg.GROUP_NAME_MAX_LENGTH;
	    }, _this.codeIsValid = function (code) {
	      var valid = code.length >= cfg.GROUP_CODE_MIN_LENGTH && code.length <= cfg.GROUP_CODE_MAX_LENGTH && cfg.GROUP_CODE_REGEX.test(code);
	
	      if (!_this.props.code) {
	        valid = valid || code.length === 0;
	      }
	      return valid;
	    }, _this.changeCodeTo = function (value) {
	      if (!_this.getCurrentCodeValue()) {
	        _this.refs.code.refs.children.changeValue(value);
	      }
	    }, _this.validateGroupCodeUniqueness = (0, _lodash.debounce)(function (code) {
	      if (!_this.isMounted()) {
	        return;
	      }
	
	      _this.props.onFormInvalid();
	      _Group2.default.validateCodeUniqueness(code).then(function (codes) {
	        // XXX move promise out of this view
	        if (!_this.isMounted()) {
	          return;
	        }
	
	        // Disable the class code input's loading indicator
	        _this.setState({ verifyingCodeUniqueness: false });
	
	        // If the code has changed since we dispatched this request,
	        // then result is no longer valid, so don't overwrite the error message
	        // This prevents these responses from overwriting length validation results.
	        if (code !== _this.getCurrentCodeValue()) {
	          return;
	        }
	
	        // The server returns an array of suggested code when the code passed
	        // to it was not unique (i.e. a duplicate)
	        if (codes) {
	          _this.setState({
	            classCodeError: '\n                Oops! This code is unavailable. Here are some available codes:\n                @' + codes[0] + ', @' + codes[1] + ', or @' + codes[2] + '.'
	          });
	        } else if (_this.nameIsValid(_this.getCurrentNameValue()) && !_this.state.classNameError && !_this.state.classCodeError) {
	          // If no codes are returned, the code passed in was unique
	          // So if the current name is also valid, call the onFormValid handler
	          _this.props.onFormValid(_this.getCurrentNameValue(), _this.getCurrentCodeValue());
	        }
	      });
	    }, 300), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      cfg = {
	        GROUP_CODE_MAX_LENGTH: _SettingsStore2.default.getMaxClassCodeLength(),
	        GROUP_CODE_MIN_LENGTH: _SettingsStore2.default.getMinClassCodeLength(),
	        GROUP_NAME_MAX_LENGTH: _SettingsStore2.default.getMaxClassNameLength(),
	        GROUP_NAME_MIN_LENGTH: _SettingsStore2.default.getMinClassNameLength(),
	        GROUP_CODE_REGEX: /^[a-zA-Z0-9\-]+$/
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._isMounted = true;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	    }
	  }, {
	    key: 'isMounted',
	    value: function isMounted() {
	      return this._isMounted;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Form2.default,
	          { onInvalid: this.props.onFormInvalid },
	          _react2.default.createElement(_FormInput2.default, {
	            label: 'Class name',
	            required: true,
	            autofocus: true,
	            ref: 'name',
	            name: 'class_name',
	            placeholder: 'e.g. Math 101, Soccer Team, Chess Club',
	            value: this.props.name,
	            onChange: this.onNameChange,
	            errorMessage: this.state.classNameError,
	            className: 'GroupForm-groupName',
	            validations: {
	              maxLength: cfg.GROUP_NAME_MAX_LENGTH,
	              minLength: cfg.GROUP_NAME_MIN_LENGTH
	            },
	            validationErrors: {
	              minLength: 'The name must be at least ' + cfg.GROUP_NAME_MIN_LENGTH + ' characters long.',
	              maxLength: 'The name cannot be over ' + cfg.GROUP_NAME_MAX_LENGTH + ' characters long.',
	              isDefaultRequiredValue: 'Class name is required.'
	            }
	          }),
	          _react2.default.createElement(_FormInput2.default, {
	            label: 'Class code',
	            prepend: '@',
	            name: 'name',
	            ref: 'code',
	            loading: this.state.verifyingCodeUniqueness,
	            component: _PrependedTextInput2.default,
	            value: this.props.code,
	            validationError: 'Class code is required',
	            validations: {
	              maxLength: cfg.GROUP_CODE_MAX_LENGTH,
	              minLength: cfg.GROUP_CODE_MIN_LENGTH,
	              matchRegexp: cfg.GROUP_CODE_REGEX
	            },
	            onChange: (0, _createChainedFunction2.default)(this.onCodeChange, this.props.onCodeChange),
	            errorMessage: this.state.classCodeError,
	            validationErrors: {
	              minLength: 'The code must be at least ' + cfg.GROUP_CODE_MIN_LENGTH + ' characters long.',
	              maxLength: 'Class code must be ' + cfg.GROUP_CODE_MAX_LENGTH + ' characters or less.',
	              matchRegexp: 'The code can only contain characters a-Z and -'
	            },
	            className: 'GroupForm-groupCode'
	          }),
	          this.props.showOrg && _react2.default.createElement(_GroupSchoolSelect2.default, {
	            group: this.props.group,
	            hideUnaffiliated: this.props.hasChildren,
	            initialOrganizationId: this.props.currentOrganization ? this.props.currentOrganization.id : null,
	            onSchoolChange: this.onSchoolChange,
	            input: 'select',
	            ref: 'org'
	          })
	        )
	      );
	    }
	  }]);
	
	  return GroupForm;
	}(_react.Component);
	
	GroupForm.defaultProps = {
	  name: '',
	  code: '',
	  hasChildren: false,
	  showOrg: true
	};
	GroupForm.displayName = 'GroupForm';
	exports.default = GroupForm;

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Formsy = __webpack_require__(1345);
	
	var _Formsy2 = _interopRequireDefault(_Formsy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	  * Component used to create a Form. Leverages Formsy
	  * https://github.com/christianalfoni/formsy-react
	  *
	  * ### General Form Structure
	  *
	  * This form component should be used whenever you need to **submit information**
	  * (this should be obvious)
	  * but there have been instances in our codebase in which forms have been faked.
	  *
	  * These are the general form components
	  * * FormInput
	  * * FormDatePicker
	  * * FormNote
	  * * FormSingle
	  * * FormSelect
	  * * FormMoneyInput
	  * * FormCellInput
	  * * FormCheckBox
	  *
	  * They are the Field component wrapped around a core component. (*see FormDatePicker*).
	  *
	  * ### Constructing a Form
	  *
	  * This is an example of a form. Every form has a `onValid` and `onInvalid` property
	  * that is GENERALLY used to set the state of the component to disabled: false, or disabled: true.
	  *
	  * Then, a button that will handle what happens when the form is submitted is
	  * disabled based on that
	  * property.
	  *
	  * For example
	  * ```
	  * <Form
	  *  ref="form"
	  *  className="CreateEventForm-form"
	  *  onValid={() => this.setState({disabled: false})}
	  *  onInvalid={() => this.setState({disabled: true})}
	  *  onValidSubmit={this.onSubmit}>
	  *  <Button
	  *     size="small"
	  *     disabled={this.state.disabled}>
	  *    Submit
	  *  </Button>
	  * </Form>
	  * ```
	  *
	  * The `onValidSubmit` property takes a function that generally looks like this.
	  * It should deal with the error case, generally by showing a Toast to indicate success or failure.
	  * ```
	  * onSubmit(value) {
	  *   this.setState({loading: true});
	  *   const onDone = () => {
	  *     this.setState({loading: false});
	  *   }
	  *
	  *   return SomeActions.create(
	  *      value.foo,
	  *      value.bar
	  *    ).then(() =>
	  *      () => ToastActions.showSuccessToast('Success'),
	  *      () => ToastActions.showDefaultErrorToast())
	  *    ).then(onDone);
	  *
	  * ```
	  *
	  * ### Creating your own validations
	  *
	  * A lot of times it is necessary to create your own validations, instead of
	  * using Formsy's out of the box validators.
	  *
	  * To do this go to `Formsy.js` and add your own validator like this.
	  * ```
	  * Formsy.customValidators.isRequired = function(values, value) {
	  *   return value === null || value === undefined || value === '';
	  * };
	  * Formsy.addValidationRule('isRequired', Formsy.customValidators.isRequired);
	  * ```
	  *
	  * You can then use this in your own form like this
	  *
	  * ```
	  * <FormInput validations={{isRequired: true} validationErrors={{isRequired: 'Input required'}}
	  * ```
	  *
	  *
	  * ### Creating your own Form component
	  *
	  *
	  * In most cases, it's enough to pass in your own component into `FormInput`.
	  *
	  * ```
	  * <FormInput
	  *    name="location"
	  *    component={LocationInput}
	  *  />
	  * ```
	  * However, you might need to roll out your own. In this case look  at
	  * `FormDatePicker`, `FormSelect` or `FormCheckbox`, as these are all examples
	  * of custom Form components that wrap existing components.
	  */
	
	var Form = function (_React$Component) {
	  _inherits(Form, _React$Component);
	
	  function Form() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Form);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.getCurrentValues = function () {
	      return _this.refs.formsy.getCurrentValues();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	  // public
	
	
	  _createClass(Form, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Formsy2.default.Form,
	        _extends({ ref: 'formsy' }, this.props, { method: 'post' }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Form;
	}(_react2.default.Component);
	
	Form.displayName = 'Form';
	exports.default = Form;

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _formsyReact = __webpack_require__(1346);
	
	var _formsyReact2 = _interopRequireDefault(_formsyReact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This is the place you should write custom validators
	_formsyReact2.default.addValidationRule('isNotLength', function (values, value, array) {
	  if (!value) {
	    return array[0] >= 0;
	  }
	
	  if (value.length >= array[0] && value.length <= array[1]) {
	    return false;
	  }
	
	  return true;
	});
	
	_formsyReact2.default.customValidators = {};
	
	_formsyReact2.default.customValidators.isRequired = function (values, value) {
	  return value === null || value === undefined || value === '';
	};
	
	_formsyReact2.default.customValidators.isGreaterThan = function (values, value, min) {
	  return Number(value) > min;
	};
	
	_formsyReact2.default.customValidators.isLessThan = function (values, value, max) {
	  return Number(value) < max;
	};
	
	_formsyReact2.default.customValidators.isValidEventAmount = function (values, value, min) {
	  if (Number(value) === 0 || value === undefined || value === null) {
	    return true;
	  }
	  return Number(value) > min;
	};
	
	_formsyReact2.default.customValidators.isGreaterOrEqualToDate = function (values, value, minDate) {
	  if (!(value instanceof Date)) {
	    return false;
	  }
	
	  var clonedDate = new Date(value.getTime());
	  var clonedMinDate = new Date(minDate.getTime());
	
	  return clonedDate.setHours(0, 0, 0, 0) >= clonedMinDate.setHours(0, 0, 0, 0);
	};
	
	_formsyReact2.default.customValidators.isValidAccountNumber = function (value, name, currency) {
	  if (window.Stripe) {
	    return window.Stripe.bankAccount.validateAccountNumber(value.account_number, currency);
	  }
	  return true;
	};
	
	_formsyReact2.default.customValidators.isValidRoutingNumber = function (value, name, currency) {
	  if (window.Stripe) {
	    return window.Stripe.bankAccount.validateRoutingNumber(value.routing_number, currency);
	  }
	  return true;
	};
	
	_formsyReact2.default.customValidators.isEmail = function (values, value) {
	  return (/^([\w\.%\+\-']+)@([\w\-]+\.)+([\w]{2,})$/i.test(value)
	  );
	};
	
	_formsyReact2.default.customValidators.isEmailWithSpaces = function (values, value) {
	  return _formsyReact2.default.customValidators.isEmail(values, value.trim());
	};
	
	_formsyReact2.default.customValidators.couldPlausiblyBeANorthAmericanPhoneNumber = function (values, value) {
	  return !!value && /^\+?1?[- .]?\(?\d{3}\)?[- .]?\d{3}[- .]?\d{4}$/m.test(value);
	};
	
	_formsyReact2.default.customValidators.isEmailOrPhone = function (values, value) {
	  if (!value) {
	    return 'Email address or phone number required';
	  }
	  if (value.indexOf('@') >= 0) {
	    return _formsyReact2.default.customValidators.isEmailWithSpaces(null, value) ? true : 'Invalid email address';
	  } else {
	    return _formsyReact2.default.customValidators.couldPlausiblyBeANorthAmericanPhoneNumber(null, value) ? true : 'Invalid email address or phone number';
	  }
	};
	
	_formsyReact2.default.customValidators.isEmailOrPhoneOrFormIsEmpty = function (values, value) {
	  if (values.name || value) {
	    return _formsyReact2.default.customValidators.isEmailOrPhone(values, value);
	  }
	  return true;
	};
	
	_formsyReact2.default.customValidators.isPresentIfUidIsPresent = function (values, value) {
	  if (value && value.trim().length > 0) {
	    return true;
	  }
	  return values.uid ? false : !value;
	};
	
	// We override Formsy's built-in isEmail with out own method that uses the same pattern used by API.
	_formsyReact2.default.addValidationRule('isEmail', _formsyReact2.default.customValidators.isEmail);
	_formsyReact2.default.addValidationRule('isEmailWithSpaces', _formsyReact2.default.customValidators.isEmailWithSpaces);
	_formsyReact2.default.addValidationRule('isEmailOrPhone', _formsyReact2.default.customValidators.isEmailOrPhone);
	_formsyReact2.default.addValidationRule('couldPlausiblyBeANorthAmericanPhoneNumber', _formsyReact2.default.customValidators.couldPlausiblyBeANorthAmericanPhoneNumber);
	_formsyReact2.default.addValidationRule('isValidAccountNumber', _formsyReact2.default.customValidators.isValidAccountNumber);
	_formsyReact2.default.addValidationRule('isValidRoutingNumber', _formsyReact2.default.customValidators.isValidRoutingNumber);
	_formsyReact2.default.addValidationRule('isValidEventAmount', _formsyReact2.default.customValidators.isValidEventAmount);
	_formsyReact2.default.addValidationRule('isGreaterOrEqualToDate', _formsyReact2.default.customValidators.isGreaterOrEqualToDate);
	_formsyReact2.default.addValidationRule('isRequired', _formsyReact2.default.customValidators.isRequired);
	_formsyReact2.default.addValidationRule('isGreaterThan', _formsyReact2.default.customValidators.isGreaterThan);
	_formsyReact2.default.addValidationRule('isLessThan', _formsyReact2.default.customValidators.isLessThan);
	
	exports.default = _formsyReact2.default;

/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = global.React || __webpack_require__(299);
	var Formsy = {};
	var validationRules = __webpack_require__(1347);
	var formDataToObject = __webpack_require__(1348);
	var utils = __webpack_require__(1349);
	var Mixin = __webpack_require__(1350);
	var HOC = __webpack_require__(1351);
	var Decorator = __webpack_require__(1352);
	var options = {};
	var emptyArray = [];
	
	Formsy.Mixin = Mixin;
	Formsy.HOC = HOC;
	Formsy.Decorator = Decorator;
	
	Formsy.defaults = function (passedOptions) {
	  options = passedOptions;
	};
	
	Formsy.addValidationRule = function (name, func) {
	  validationRules[name] = func;
	};
	
	Formsy.Form = React.createClass({
	  displayName: 'Formsy',
	  getInitialState: function getInitialState() {
	    return {
	      isValid: true,
	      isSubmitting: false,
	      canChange: false
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onSuccess: function onSuccess() {},
	      onError: function onError() {},
	      onSubmit: function onSubmit() {},
	      onValidSubmit: function onValidSubmit() {},
	      onInvalidSubmit: function onInvalidSubmit() {},
	      onValid: function onValid() {},
	      onInvalid: function onInvalid() {},
	      onChange: function onChange() {},
	      validationErrors: null,
	      preventExternalInvalidation: false
	    };
	  },
	
	  childContextTypes: {
	    formsy: React.PropTypes.object
	  },
	  getChildContext: function getChildContext() {
	    var _this = this;
	
	    return {
	      formsy: {
	        attachToForm: this.attachToForm,
	        detachFromForm: this.detachFromForm,
	        validate: this.validate,
	        isFormDisabled: this.isFormDisabled,
	        isValidValue: function isValidValue(component, value) {
	          return _this.runValidation(component, value).isValid;
	        }
	      }
	    };
	  },
	
	  // Add a map to store the inputs of the form, a model to store
	  // the values of the form and register child inputs
	  componentWillMount: function componentWillMount() {
	    this.inputs = [];
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.validateForm();
	  },
	
	  componentWillUpdate: function componentWillUpdate() {
	    // Keep a reference to input names before form updates,
	    // to check if inputs has changed after render
	    this.prevInputNames = this.inputs.map(function (component) {
	      return component.props.name;
	    });
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	
	    if (this.props.validationErrors && _typeof(this.props.validationErrors) === 'object' && Object.keys(this.props.validationErrors).length > 0) {
	      this.setInputValidationErrors(this.props.validationErrors);
	    }
	
	    var newInputNames = this.inputs.map(function (component) {
	      return component.props.name;
	    });
	    if (utils.arraysDiffer(this.prevInputNames, newInputNames)) {
	      this.validateForm();
	    }
	  },
	
	  // Allow resetting to specified data
	  reset: function reset(data) {
	    this.setFormPristine(true);
	    this.resetModel(data);
	  },
	
	  // Update model, submit to url prop and send the model
	  submit: function submit(event) {
	
	    event && event.preventDefault();
	
	    // Trigger form as not pristine.
	    // If any inputs have not been touched yet this will make them dirty
	    // so validation becomes visible (if based on isPristine)
	    this.setFormPristine(false);
	    var model = this.getModel();
	    this.props.onSubmit(model, this.resetModel, this.updateInputsWithError);
	    this.state.isValid ? this.props.onValidSubmit(model, this.resetModel, this.updateInputsWithError) : this.props.onInvalidSubmit(model, this.resetModel, this.updateInputsWithError);
	  },
	
	  mapModel: function mapModel(model) {
	
	    if (this.props.mapping) {
	      return this.props.mapping(model);
	    } else {
	      return formDataToObject.toObj(Object.keys(model).reduce(function (mappedModel, key) {
	
	        var keyArray = key.split('.');
	        var base = mappedModel;
	        while (keyArray.length) {
	          var currentKey = keyArray.shift();
	          base = base[currentKey] = keyArray.length ? base[currentKey] || {} : model[key];
	        }
	
	        return mappedModel;
	      }, {}));
	    }
	  },
	
	  getModel: function getModel() {
	    var currentValues = this.getCurrentValues();
	    return this.mapModel(currentValues);
	  },
	
	  // Reset each key in the model to the original / initial / specified value
	  resetModel: function resetModel(data) {
	    this.inputs.forEach(function (component) {
	      var name = component.props.name;
	      if (data && data.hasOwnProperty(name)) {
	        component.setValue(data[name]);
	      } else {
	        component.resetValue();
	      }
	    });
	    this.validateForm();
	  },
	
	  setInputValidationErrors: function setInputValidationErrors(errors) {
	    this.inputs.forEach(function (component) {
	      var name = component.props.name;
	      var args = [{
	        _isValid: !(name in errors),
	        _validationError: typeof errors[name] === 'string' ? [errors[name]] : errors[name]
	      }];
	      component.setState.apply(component, args);
	    });
	  },
	
	  // Checks if the values have changed from their initial value
	  isChanged: function isChanged() {
	    return !utils.isSame(this.getPristineValues(), this.getCurrentValues());
	  },
	
	  getPristineValues: function getPristineValues() {
	    return this.inputs.reduce(function (data, component) {
	      var name = component.props.name;
	      data[name] = component.props.value;
	      return data;
	    }, {});
	  },
	
	  // Go through errors from server and grab the components
	  // stored in the inputs map. Change their state to invalid
	  // and set the serverError message
	  updateInputsWithError: function updateInputsWithError(errors) {
	    var _this2 = this;
	
	    Object.keys(errors).forEach(function (name, index) {
	      var component = utils.find(_this2.inputs, function (component) {
	        return component.props.name === name;
	      });
	      if (!component) {
	        throw new Error('You are trying to update an input that does not exist. ' + 'Verify errors object with input names. ' + JSON.stringify(errors));
	      }
	      var args = [{
	        _isValid: _this2.props.preventExternalInvalidation || false,
	        _externalError: typeof errors[name] === 'string' ? [errors[name]] : errors[name]
	      }];
	      component.setState.apply(component, args);
	    });
	  },
	
	  isFormDisabled: function isFormDisabled() {
	    return this.props.disabled;
	  },
	
	  getCurrentValues: function getCurrentValues() {
	    return this.inputs.reduce(function (data, component) {
	      var name = component.props.name;
	      data[name] = component.state._value;
	      return data;
	    }, {});
	  },
	
	  setFormPristine: function setFormPristine(isPristine) {
	    this.setState({
	      _formSubmitted: !isPristine
	    });
	
	    // Iterate through each component and set it as pristine
	    // or "dirty".
	    this.inputs.forEach(function (component, index) {
	      component.setState({
	        _formSubmitted: !isPristine,
	        _isPristine: isPristine
	      });
	    });
	  },
	
	  // Use the binded values and the actual input value to
	  // validate the input and set its state. Then check the
	  // state of the form itself
	  validate: function validate(component) {
	
	    // Trigger onChange
	    if (this.state.canChange) {
	      this.props.onChange(this.getCurrentValues(), this.isChanged());
	    }
	
	    var validation = this.runValidation(component);
	    // Run through the validations, split them up and call
	    // the validator IF there is a value or it is required
	    component.setState({
	      _isValid: validation.isValid,
	      _isRequired: validation.isRequired,
	      _validationError: validation.error,
	      _externalError: null
	    }, this.validateForm);
	  },
	
	  // Checks validation on current value or a passed value
	  runValidation: function runValidation(component, value) {
	
	    var currentValues = this.getCurrentValues();
	    var validationErrors = component.props.validationErrors;
	    var validationError = component.props.validationError;
	    value = arguments.length === 2 ? value : component.state._value;
	
	    var validationResults = this.runRules(value, currentValues, component._validations);
	    var requiredResults = this.runRules(value, currentValues, component._requiredValidations);
	
	    // the component defines an explicit validate function
	    if (typeof component.validate === "function") {
	      validationResults.failed = component.validate() ? [] : ['failed'];
	    }
	
	    var isRequired = Object.keys(component._requiredValidations).length ? !!requiredResults.success.length : false;
	    var isValid = !validationResults.failed.length && !(this.props.validationErrors && this.props.validationErrors[component.props.name]);
	
	    return {
	      isRequired: isRequired,
	      isValid: isRequired ? false : isValid,
	      error: function () {
	
	        if (isValid && !isRequired) {
	          return emptyArray;
	        }
	
	        if (validationResults.errors.length) {
	          return validationResults.errors;
	        }
	
	        if (this.props.validationErrors && this.props.validationErrors[component.props.name]) {
	          return typeof this.props.validationErrors[component.props.name] === 'string' ? [this.props.validationErrors[component.props.name]] : this.props.validationErrors[component.props.name];
	        }
	
	        if (isRequired) {
	          var error = validationErrors[requiredResults.success[0]];
	          return error ? [error] : null;
	        }
	
	        if (validationResults.failed.length) {
	          return validationResults.failed.map(function (failed) {
	            return validationErrors[failed] ? validationErrors[failed] : validationError;
	          }).filter(function (x, pos, arr) {
	            // Remove duplicates
	            return arr.indexOf(x) === pos;
	          });
	        }
	      }.call(this)
	    };
	  },
	
	  runRules: function runRules(value, currentValues, validations) {
	
	    var results = {
	      errors: [],
	      failed: [],
	      success: []
	    };
	    if (Object.keys(validations).length) {
	      Object.keys(validations).forEach(function (validationMethod) {
	
	        if (validationRules[validationMethod] && typeof validations[validationMethod] === 'function') {
	          throw new Error('Formsy does not allow you to override default validations: ' + validationMethod);
	        }
	
	        if (!validationRules[validationMethod] && typeof validations[validationMethod] !== 'function') {
	          throw new Error('Formsy does not have the validation rule: ' + validationMethod);
	        }
	
	        if (typeof validations[validationMethod] === 'function') {
	          var validation = validations[validationMethod](currentValues, value);
	          if (typeof validation === 'string') {
	            results.errors.push(validation);
	            results.failed.push(validationMethod);
	          } else if (!validation) {
	            results.failed.push(validationMethod);
	          }
	          return;
	        } else if (typeof validations[validationMethod] !== 'function') {
	          var validation = validationRules[validationMethod](currentValues, value, validations[validationMethod]);
	          if (typeof validation === 'string') {
	            results.errors.push(validation);
	            results.failed.push(validationMethod);
	          } else if (!validation) {
	            results.failed.push(validationMethod);
	          } else {
	            results.success.push(validationMethod);
	          }
	          return;
	        }
	
	        return results.success.push(validationMethod);
	      });
	    }
	
	    return results;
	  },
	
	  // Validate the form by going through all child input components
	  // and check their state
	  validateForm: function validateForm() {
	    var _this3 = this;
	
	    // We need a callback as we are validating all inputs again. This will
	    // run when the last component has set its state
	    var onValidationComplete = function () {
	      var allIsValid = this.inputs.every(function (component) {
	        return component.state._isValid;
	      });
	
	      this.setState({
	        isValid: allIsValid
	      });
	
	      if (allIsValid) {
	        this.props.onValid();
	      } else {
	        this.props.onInvalid();
	      }
	
	      // Tell the form that it can start to trigger change events
	      this.setState({
	        canChange: true
	      });
	    }.bind(this);
	
	    // Run validation again in case affected by other inputs. The
	    // last component validated will run the onValidationComplete callback
	    this.inputs.forEach(function (component, index) {
	      var validation = _this3.runValidation(component);
	      if (validation.isValid && component.state._externalError) {
	        validation.isValid = false;
	      }
	      component.setState({
	        _isValid: validation.isValid,
	        _isRequired: validation.isRequired,
	        _validationError: validation.error,
	        _externalError: !validation.isValid && component.state._externalError ? component.state._externalError : null
	      }, index === _this3.inputs.length - 1 ? onValidationComplete : null);
	    });
	
	    // If there are no inputs, set state where form is ready to trigger
	    // change event. New inputs might be added later
	    if (!this.inputs.length && this.isMounted()) {
	      this.setState({
	        canChange: true
	      });
	    }
	  },
	
	  // Method put on each input component to register
	  // itself to the form
	  attachToForm: function attachToForm(component) {
	
	    if (this.inputs.indexOf(component) === -1) {
	      this.inputs.push(component);
	    }
	
	    this.validate(component);
	  },
	
	  // Method put on each input component to unregister
	  // itself from the form
	  detachFromForm: function detachFromForm(component) {
	    var componentPos = this.inputs.indexOf(component);
	
	    if (componentPos !== -1) {
	      this.inputs = this.inputs.slice(0, componentPos).concat(this.inputs.slice(componentPos + 1));
	    }
	
	    this.validateForm();
	  },
	  render: function render() {
	    var _props = this.props;
	    var mapping = _props.mapping;
	    var validationErrors = _props.validationErrors;
	    var onSubmit = _props.onSubmit;
	    var onValid = _props.onValid;
	    var onValidSubmit = _props.onValidSubmit;
	    var onInvalid = _props.onInvalid;
	    var onInvalidSubmit = _props.onInvalidSubmit;
	    var onChange = _props.onChange;
	    var reset = _props.reset;
	    var preventExternalInvalidation = _props.preventExternalInvalidation;
	    var onSuccess = _props.onSuccess;
	    var onError = _props.onError;
	
	    var nonFormsyProps = _objectWithoutProperties(_props, ['mapping', 'validationErrors', 'onSubmit', 'onValid', 'onValidSubmit', 'onInvalid', 'onInvalidSubmit', 'onChange', 'reset', 'preventExternalInvalidation', 'onSuccess', 'onError']);
	
	    return React.createElement(
	      'form',
	      _extends({}, nonFormsyProps, { onSubmit: this.submit }),
	      this.props.children
	    );
	  }
	});
	
	if (!global.exports && !global.module && (!global.define || !global.define.amd)) {
	  global.Formsy = Formsy;
	}
	
	module.exports = Formsy;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1347 */
/***/ function(module, exports) {

	'use strict';
	
	var _isExisty = function _isExisty(value) {
	  return value !== null && value !== undefined;
	};
	
	var isEmpty = function isEmpty(value) {
	  return value === '';
	};
	
	var validations = {
	  isDefaultRequiredValue: function isDefaultRequiredValue(values, value) {
	    return value === undefined || value === '';
	  },
	  isExisty: function isExisty(values, value) {
	    return _isExisty(value);
	  },
	  matchRegexp: function matchRegexp(values, value, regexp) {
	    return !_isExisty(value) || isEmpty(value) || regexp.test(value);
	  },
	  isUndefined: function isUndefined(values, value) {
	    return value === undefined;
	  },
	  isEmptyString: function isEmptyString(values, value) {
	    return isEmpty(value);
	  },
	  isEmail: function isEmail(values, value) {
	    return validations.matchRegexp(values, value, /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i);
	  },
	  isUrl: function isUrl(values, value) {
	    return validations.matchRegexp(values, value, /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i);
	  },
	  isTrue: function isTrue(values, value) {
	    return value === true;
	  },
	  isFalse: function isFalse(values, value) {
	    return value === false;
	  },
	  isNumeric: function isNumeric(values, value) {
	    if (typeof value === 'number') {
	      return true;
	    }
	    return validations.matchRegexp(values, value, /^[-+]?(?:\d*[.])?\d+$/);
	  },
	  isAlpha: function isAlpha(values, value) {
	    return validations.matchRegexp(values, value, /^[A-Z]+$/i);
	  },
	  isAlphanumeric: function isAlphanumeric(values, value) {
	    return validations.matchRegexp(values, value, /^[0-9A-Z]+$/i);
	  },
	  isInt: function isInt(values, value) {
	    return validations.matchRegexp(values, value, /^(?:[-+]?(?:0|[1-9]\d*))$/);
	  },
	  isFloat: function isFloat(values, value) {
	    return validations.matchRegexp(values, value, /^(?:[-+]?(?:\d+))?(?:\.\d*)?(?:[eE][\+\-]?(?:\d+))?$/);
	  },
	  isWords: function isWords(values, value) {
	    return validations.matchRegexp(values, value, /^[A-Z\s]+$/i);
	  },
	  isSpecialWords: function isSpecialWords(values, value) {
	    return validations.matchRegexp(values, value, /^[A-Z\s\u00C0-\u017F]+$/i);
	  },
	  isLength: function isLength(values, value, length) {
	    return !_isExisty(value) || isEmpty(value) || value.length === length;
	  },
	  equals: function equals(values, value, eql) {
	    return !_isExisty(value) || isEmpty(value) || value == eql;
	  },
	  equalsField: function equalsField(values, value, field) {
	    return value == values[field];
	  },
	  maxLength: function maxLength(values, value, length) {
	    return !_isExisty(value) || value.length <= length;
	  },
	  minLength: function minLength(values, value, length) {
	    return !_isExisty(value) || isEmpty(value) || value.length >= length;
	  }
	};
	
	module.exports = validations;

/***/ },
/* 1348 */
/***/ function(module, exports) {

	function toObj(source) {
	  return Object.keys(source).reduce(function (output, key) {
	    var parentKey = key.match(/[^\[]*/i);
	    var paths = key.match(/\[.*?\]/g) || [];
	    paths = [parentKey[0]].concat(paths).map(function (key) {
	      return key.replace(/\[|\]/g, '');
	    });
	    var currentPath = output;
	    while (paths.length) {
	      var pathKey = paths.shift();
	
	      if (pathKey in currentPath) {
	        currentPath = currentPath[pathKey];
	      } else {
	        currentPath[pathKey] = paths.length ? isNaN(paths[0]) ? {} : [] : source[key];
	        currentPath = currentPath[pathKey];
	      }
	    }
	
	    return output;
	  }, {});
	}
	
	function fromObj(obj) {
	  function recur(newObj, propName, currVal) {
	    if (Array.isArray(currVal) || Object.prototype.toString.call(currVal) === '[object Object]') {
	      Object.keys(currVal).forEach(function(v) {
	        recur(newObj, propName + "[" + v + "]", currVal[v]);
	      });
	      return newObj;
	    }
	
	    newObj[propName] = currVal;
	    return newObj;
	  }
	
	  var keys = Object.keys(obj);
	  return keys.reduce(function(newObj, propName) {
	    return recur(newObj, propName, obj[propName]);
	  }, {});
	}
	
	module.exports = {
	  fromObj: fromObj,
	  toObj: toObj
	}

/***/ },
/* 1349 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	module.exports = {
	  arraysDiffer: function arraysDiffer(a, b) {
	    var isDifferent = false;
	    if (a.length !== b.length) {
	      isDifferent = true;
	    } else {
	      a.forEach(function (item, index) {
	        if (!this.isSame(item, b[index])) {
	          isDifferent = true;
	        }
	      }, this);
	    }
	    return isDifferent;
	  },
	
	  objectsDiffer: function objectsDiffer(a, b) {
	    var isDifferent = false;
	    if (Object.keys(a).length !== Object.keys(b).length) {
	      isDifferent = true;
	    } else {
	      Object.keys(a).forEach(function (key) {
	        if (!this.isSame(a[key], b[key])) {
	          isDifferent = true;
	        }
	      }, this);
	    }
	    return isDifferent;
	  },
	
	  isSame: function isSame(a, b) {
	    if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== (typeof b === 'undefined' ? 'undefined' : _typeof(b))) {
	      return false;
	    } else if (Array.isArray(a)) {
	      return !this.arraysDiffer(a, b);
	    } else if (typeof a === 'function') {
	      return a.toString() === b.toString();
	    } else if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object' && a !== null && b !== null) {
	      return !this.objectsDiffer(a, b);
	    }
	
	    return a === b;
	  },
	
	  find: function find(collection, fn) {
	    for (var i = 0, l = collection.length; i < l; i++) {
	      var item = collection[i];
	      if (fn(item)) {
	        return item;
	      }
	    }
	    return null;
	  }
	};

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var utils = __webpack_require__(1349);
	var React = global.React || __webpack_require__(299);
	
	var convertValidationsToObject = function convertValidationsToObject(validations) {
	
	  if (typeof validations === 'string') {
	
	    return validations.split(/\,(?![^{\[]*[}\]])/g).reduce(function (validations, validation) {
	      var args = validation.split(':');
	      var validateMethod = args.shift();
	
	      args = args.map(function (arg) {
	        try {
	          return JSON.parse(arg);
	        } catch (e) {
	          return arg; // It is a string if it can not parse it
	        }
	      });
	
	      if (args.length > 1) {
	        throw new Error('Formsy does not support multiple args on string validations. Use object format of validations instead.');
	      }
	
	      validations[validateMethod] = args.length ? args[0] : true;
	      return validations;
	    }, {});
	  }
	
	  return validations || {};
	};
	
	module.exports = {
	  getInitialState: function getInitialState() {
	    return {
	      _value: this.props.value,
	      _isRequired: false,
	      _isValid: true,
	      _isPristine: true,
	      _pristineValue: this.props.value,
	      _validationError: [],
	      _externalError: null,
	      _formSubmitted: false
	    };
	  },
	  contextTypes: {
	    formsy: React.PropTypes.object // What about required?
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      validationError: '',
	      validationErrors: {}
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    var configure = function () {
	      this.setValidations(this.props.validations, this.props.required);
	
	      // Pass a function instead?
	      this.context.formsy.attachToForm(this);
	      //this.props._attachToForm(this);
	    }.bind(this);
	
	    if (!this.props.name) {
	      throw new Error('Form Input requires a name property when used');
	    }
	
	    /*
	    if (!this.props._attachToForm) {
	      return setTimeout(function () {
	        if (!this.isMounted()) return;
	        if (!this.props._attachToForm) {
	          throw new Error('Form Mixin requires component to be nested in a Form');
	        }
	        configure();
	      }.bind(this), 0);
	    }
	    */
	    configure();
	  },
	
	  // We have to make the validate method is kept when new props are added
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setValidations(nextProps.validations, nextProps.required);
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	
	    // If the value passed has changed, set it. If value is not passed it will
	    // internally update, and this will never run
	    if (!utils.isSame(this.props.value, prevProps.value)) {
	      this.setValue(this.props.value);
	    }
	
	    // If validations or required is changed, run a new validation
	    if (!utils.isSame(this.props.validations, prevProps.validations) || !utils.isSame(this.props.required, prevProps.required)) {
	      this.context.formsy.validate(this);
	    }
	  },
	
	  // Detach it when component unmounts
	  componentWillUnmount: function componentWillUnmount() {
	    this.context.formsy.detachFromForm(this);
	    //this.props._detachFromForm(this);
	  },
	
	  setValidations: function setValidations(validations, required) {
	
	    // Add validations to the store itself as the props object can not be modified
	    this._validations = convertValidationsToObject(validations) || {};
	    this._requiredValidations = required === true ? { isDefaultRequiredValue: true } : convertValidationsToObject(required);
	  },
	
	  // We validate after the value has been set
	  setValue: function setValue(value) {
	    this.setState({
	      _value: value,
	      _isPristine: false
	    }, function () {
	      this.context.formsy.validate(this);
	      //this.props._validate(this);
	    }.bind(this));
	  },
	  resetValue: function resetValue() {
	    this.setState({
	      _value: this.state._pristineValue,
	      _isPristine: true
	    }, function () {
	      this.context.formsy.validate(this);
	      //this.props._validate(this);
	    });
	  },
	  getValue: function getValue() {
	    return this.state._value;
	  },
	  hasValue: function hasValue() {
	    return this.state._value !== '';
	  },
	  getErrorMessage: function getErrorMessage() {
	    var messages = this.getErrorMessages();
	    return messages.length ? messages[0] : null;
	  },
	  getErrorMessages: function getErrorMessages() {
	    return !this.isValid() || this.showRequired() ? this.state._externalError || this.state._validationError || [] : [];
	  },
	  isFormDisabled: function isFormDisabled() {
	    return this.context.formsy.isFormDisabled();
	    //return this.props._isFormDisabled();
	  },
	  isValid: function isValid() {
	    return this.state._isValid;
	  },
	  isPristine: function isPristine() {
	    return this.state._isPristine;
	  },
	  isFormSubmitted: function isFormSubmitted() {
	    return this.state._formSubmitted;
	  },
	  isRequired: function isRequired() {
	    return !!this.props.required;
	  },
	  showRequired: function showRequired() {
	    return this.state._isRequired;
	  },
	  showError: function showError() {
	    return !this.showRequired() && !this.isValid();
	  },
	  isValidValue: function isValidValue(value) {
	    return this.context.formsy.isValidValue.call(null, this, value);
	    //return this.props._isValidValue.call(null, this, value);
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = global.React || __webpack_require__(299);
	var Mixin = __webpack_require__(1350);
	module.exports = function (Component) {
	  return React.createClass({
	    displayName: 'Formsy(' + getDisplayName(Component) + ')',
	    mixins: [Mixin],
	    render: function render() {
	      return React.createElement(Component, _extends({
	        setValidations: this.setValidations,
	        setValue: this.setValue,
	        resetValue: this.resetValue,
	        getValue: this.getValue,
	        hasValue: this.hasValue,
	        getErrorMessage: this.getErrorMessage,
	        getErrorMessages: this.getErrorMessages,
	        isFormDisabled: this.isFormDisabled,
	        isValid: this.isValid,
	        isPristine: this.isPristine,
	        isFormSubmitted: this.isFormSubmitted,
	        isRequired: this.isRequired,
	        showRequired: this.showRequired,
	        showError: this.showError,
	        isValidValue: this.isValidValue
	      }, this.props));
	    }
	  });
	};
	
	function getDisplayName(Component) {
	  return Component.displayName || Component.name || (typeof Component === 'string' ? Component : 'Component');
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = global.React || __webpack_require__(299);
	var Mixin = __webpack_require__(1350);
	module.exports = function () {
	  return function (Component) {
	    return React.createClass({
	      mixins: [Mixin],
	      render: function render() {
	        return React.createElement(Component, _extends({
	          setValidations: this.setValidations,
	          setValue: this.setValue,
	          resetValue: this.resetValue,
	          getValue: this.getValue,
	          hasValue: this.hasValue,
	          getErrorMessage: this.getErrorMessage,
	          getErrorMessages: this.getErrorMessages,
	          isFormDisabled: this.isFormDisabled,
	          isValid: this.isValid,
	          isPristine: this.isPristine,
	          isFormSubmitted: this.isFormSubmitted,
	          isRequired: this.isRequired,
	          showRequired: this.showRequired,
	          showError: this.showError,
	          isValidValue: this.isValidValue
	        }, this.props));
	      }
	    });
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(555);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _doWhileMounted = __webpack_require__(1354);
	
	var _doWhileMounted2 = _interopRequireDefault(_doWhileMounted);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Formsy = __webpack_require__(1345);
	
	var _Formsy2 = _interopRequireDefault(_Formsy);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormInput = _react2.default.createClass({
	  displayName: 'FormInput',
	
	
	  mixins: [_Formsy2.default.Mixin],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      showErrorAfterBlur: false,
	      showErrorOnPristine: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    // Unless type is 'password', trim input value before validation
	    return {
	      wasBlur: false,
	      value: this.props.value,
	      formatters: this.props.type === 'password' ? [] : [function (value) {
	        return value && value.trim ? value.trim() : value;
	      }]
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.id = (0, _lodash.uniqueId)('id-');
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.value && this.props.value !== nextProps.value) {
	      this.changeValue(nextProps.value);
	    }
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !((0, _lodash.isEqual)(this.props, nextProps) && (0, _lodash.isEqual)(this.state, nextState));
	  },
	  handleBlur: function handleBlur() {
	    if (this.state.wasBlur === false) {
	      this.setState({ wasBlur: true });
	    }
	  },
	  handleChange: function handleChange(event) {
	    // Some of our custom components that will be passed in through component
	    // call onChange on the value, rather than the event.
	    if (event.currentTarget) {
	      this.changeValue(event.currentTarget.value);
	    } else {
	      this.changeValue(event);
	    }
	
	    if (this.props.onChange) {
	      this.props.onChange(event);
	    }
	  },
	  changeValue: function changeValue(value) {
	    var formattedValue = value;
	    this.state.formatters.forEach(function (formatter) {
	      formattedValue = formatter(formattedValue);
	    });
	
	    this.setValue(formattedValue);
	    this.setState({
	      // the state always hold the real value.
	      value: value,
	      wasBlur: false
	    });
	  },
	
	
	  /* This is for autofill purposes.
	   * Some browsers does not emit change event when
	   * they fill out the forms, so formzy is not aware
	   * the value change and the validation does not run.
	   * This pulls the value from the DOM at
	   * regular interval and if what is found is different
	   * than what formzy currently have then we tell formzy
	   * about this new value via the formzy mixin.
	   */
	  lookForChanges: function lookForChanges() {
	    if (!this.refs.input) {
	      return;
	    }
	
	    var _refs$input$getInputN = this.refs.input.getInputNode(),
	        value = _refs$input$getInputN.value;
	
	    if (value && this.getValue() !== value) {
	      var event = {
	        currentTarget: { value: value },
	        target: { value: value }
	      };
	      this.handleChange(event);
	    }
	  },
	  focus: function focus() {
	    if (this.refs.input.focus) {
	      this.refs.input.focus();
	    }
	  },
	  renderLabel: function renderLabel() {
	    var label = this.props.label;
	
	
	    if (label) {
	      return _react2.default.createElement(
	        _Label2.default,
	        { htmlFor: this.id, hidden: this.props.labelHidden },
	        label
	      );
	    } else {
	      return null;
	    }
	  },
	  render: function render() {
	    var errorMessage = this.getErrorMessage();
	
	    if (this.props.showErrorAfterBlur && !this.state.wasBlur) {
	      errorMessage = null;
	    }
	
	    if (!this.props.showErrorOnPristine && this.isPristine()) {
	      errorMessage = null;
	    }
	
	    errorMessage = this.props.errorMessage || errorMessage;
	
	    var Component = this.props.component || _Input2.default;
	
	    return _react2.default.createElement(
	      _Field2.default,
	      { error: errorMessage, warning: this.props.warning, loading: this.props.loading },
	      this.renderLabel(),
	      _react2.default.createElement(Component, _extends({}, this.props, {
	        ref: 'input',
	        id: this.id,
	        value: this.state.value || '',
	        onBlur: (0, _createChainedFunction2.default)(this.props.onBlur, this.handleBlur),
	        onChange: this.handleChange
	      }))
	    );
	  }
	});
	
	exports.default = (0, _doWhileMounted2.default)(FormInput, 'lookForChanges', 1000);

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	/* This component can wrap another component add create
	 * a setInterval on a specified method name of the wrapped
	 * components:
	 *
	 * import doWhileMounted from 'utils/doWhileMounted';
	 *
	 * class SimpleClass extends React.Component {
	 *   hello() {
	 *     console.log('hello world!');
	 *   }
	 *
	 *   render() {
	 *     return null;
	 *   }
	 * }
	 *
	 * export default doWhileMounted(SimpleClass, 'hello', 1000);
	 *
	 */
	function doWhileMounted(Component, functionName, msDelay) {
	  var executer = function (_React$Component) {
	    _inherits(executer, _React$Component);
	
	    function executer() {
	      _classCallCheck(this, executer);
	
	      return _possibleConstructorReturn(this, (executer.__proto__ || Object.getPrototypeOf(executer)).apply(this, arguments));
	    }
	
	    _createClass(executer, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        this.interval = setInterval(this.refs.children[functionName], msDelay);
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        if (this.interval) {
	          clearInterval(this.interval);
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return _react2.default.createElement(Component, _extends({}, this.props, this.state, {
	          ref: "children"
	        }));
	      }
	    }]);
	
	    return executer;
	  }(_react2.default.Component);
	
	  executer.displayName = "executer";
	
	
	  return executer;
	}
	
	exports.default = doWhileMounted;

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1356);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	  * Component used in forms in order to show error messages.
	  */
	
	var Field = function (_React$Component) {
	  _inherits(Field, _React$Component);
	
	  function Field() {
	    _classCallCheck(this, Field);
	
	    return _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).apply(this, arguments));
	  }
	
	  _createClass(Field, [{
	    key: 'render',
	    value: function render() {
	      var error = void 0;
	      if (typeof this.props.error === 'string') {
	        error = _react2.default.createElement(
	          'div',
	          { className: 'Field-error' },
	          this.props.error
	        );
	      } else if (this.props.warning) {
	        error = _react2.default.createElement(
	          'div',
	          { className: 'Field-warning' },
	          this.props.warning
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)({
	            Field: true,
	            'Field-hasError': !!this.props.error,
	            'Field-hasWarning': !this.props.error && !!this.props.warning,
	            'Field-inline': this.props.inline
	          }, this.props.className) },
	        this.props.children,
	        error,
	        this.props.loading && _react2.default.createElement(_LoadingIndicator2.default, { className: 'Field-loading' })
	      );
	    }
	  }]);
	
	  return Field;
	}(_react2.default.Component);
	
	Field.defaultProps = {
	  inline: false,
	  // $FlowIssue
	  error: false,
	  loading: false
	};
	Field.displayName = 'Field';
	exports.default = Field;

/***/ },
/* 1356 */
1136,
/* 1357 */,
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _focusNode = __webpack_require__(1210);
	
	var _focusNode2 = _interopRequireDefault(_focusNode);
	
	var _pickInputElementProps = __webpack_require__(1106);
	
	var _pickInputElementProps2 = _interopRequireDefault(_pickInputElementProps);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	__webpack_require__(1359);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var Input = function (_React$Component) {
	  _inherits(Input, _React$Component);
	
	  function Input() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Input);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.getInputNode = function () {
	      return _this.refs.input;
	    }, _this.focus = function () {
	      _this.getInputNode().focus();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Input, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autofocus) {
	        // Prevents the cursor from being placed at the start of the text
	        var value = this.getInputNode().value;
	        this.getInputNode().value = '';
	        (0, _focusNode2.default)(this.getInputNode());
	        this.getInputNode().value = value;
	      }
	    }
	  }, {
	    key: 'renderPendedInput',
	    value: function renderPendedInput(inputProps) {
	      var _props = this.props,
	          append = _props.append,
	          glyph = _props.glyph;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          // $FlowIssue
	          className: (0, _classnames2.default)('Input--hasPend', {
	            'Input--hasGlyph': glyph,
	            'Input--hasAppend': append
	          }) },
	        glyph && _react2.default.createElement(
	          'div',
	          { className: 'Input-pend Input-glyph' },
	          _react2.default.createElement(_Glyph2.default, { name: glyph, color: 'eclipse', size: 'large' })
	        ),
	        _react2.default.createElement('input', _extends({}, inputProps, {
	          ref: 'input'
	          // $FlowIssue
	          , className: (0, _classnames2.default)('Input', {
	            'Input--hasGlyph-input': glyph,
	            'Input--hasAppend-input': append
	          }, (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className)
	        })),
	        append && _react2.default.createElement(
	          'div',
	          { className: 'Input-pend Input-append' },
	          append
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          append = _props2.append,
	          glyph = _props2.glyph,
	          className = _props2.className;
	
	      var inputProps = (0, _pickInputElementProps2.default)(this.props);
	
	      if (append || glyph) {
	        return this.renderPendedInput(inputProps);
	      }
	
	      return _react2.default.createElement('input', _extends({}, inputProps, {
	        ref: 'input',
	        className: (0, _classnames2.default)('Input', (0, _getPropClasses.getPropClassesFromInstance)(this), className)
	      }));
	    }
	  }]);
	
	  return Input;
	}(_react2.default.Component);
	
	Input.propClasses = {
	  size: {
	    large: 'Input--large',
	    xlarge: 'Input-xlarge'
	  },
	  width: {
	    auto: 'Input--auto',
	    full: 'Input--full'
	  }
	};
	Input.defaultProps = {
	  size: 'medium',
	  autofocus: false,
	  width: 'full'
	};
	Input.displayName = 'Input';
	exports.default = Input;

/***/ },
/* 1359 */
1136,
/* 1360 */,
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1362);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Label = function (_React$Component) {
	  _inherits(Label, _React$Component);
	
	  function Label() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Label);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Label.__proto__ || Object.getPrototypeOf(Label)).call.apply(_ref, [this].concat(args))), _this), _this.renderNote = function () {
	      var note = _this.props.note;
	
	      if (!note) {
	        return null;
	      }
	      return _react2.default.createElement(
	        'small',
	        { className: 'Label-note' },
	        note
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Label, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          hidden = _props.hidden,
	          htmlFor = _props.htmlFor,
	          text = _props.text,
	          className = _props.className,
	          rest = _objectWithoutProperties(_props, ['children', 'hidden', 'htmlFor', 'text', 'className']);
	
	      return _react2.default.createElement(
	        'label',
	        _extends({
	          htmlFor: htmlFor
	        }, rest, {
	          className: (0, _classnames2.default)({
	            Label: true,
	            'Label-hidden': hidden
	          }, className) }),
	        text,
	        children,
	        this.renderNote()
	      );
	    }
	  }]);
	
	  return Label;
	}(_react2.default.Component);
	
	Label.defaultProps = {
	  hidden: false
	};
	Label.displayName = 'Label';
	exports.default = Label;

/***/ },
/* 1362 */
1136,
/* 1363 */,
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AffiliationStore = __webpack_require__(1038);
	
	var _AffiliationStore2 = _interopRequireDefault(_AffiliationStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FormSelect = __webpack_require__(1365);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GroupSchoolSelect = __webpack_require__(1381);
	
	var _GroupSchoolSelect2 = _interopRequireDefault(_GroupSchoolSelect);
	
	var _utils = __webpack_require__(956);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNAFFILIATED_CLASS_ID = -1;
	
	var GroupSchoolSelect = function (_React$Component) {
	  _inherits(GroupSchoolSelect, _React$Component);
	
	  function GroupSchoolSelect() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupSchoolSelect);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupSchoolSelect.__proto__ || Object.getPrototypeOf(GroupSchoolSelect)).call.apply(_ref, [this].concat(args))), _this), _this.defaultProps = {
	      input: 'select',
	      hideUnaffiliated: false
	    }, _this.onSchoolChange = function (orgId) {
	      _this.setState({ organization: _this.state.memberOrganizations.find(function (o) {
	          return o.id.toString() === orgId;
	        }) });
	      var onSchoolChange = _this.props.onSchoolChange;
	
	      if (onSchoolChange) {
	        onSchoolChange(orgId === UNAFFILIATED_CLASS_ID.toString() ? null : orgId);
	      }
	    }, _this.onSelect = function (orgId) {
	      _this.onSchoolChange(orgId);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupSchoolSelect, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.refs.school) {
	        this.refs.school.setValue(this.getSelectedSchoolId());
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var hideChanged = this.props.hideUnaffiliated !== nextProps.hideUnaffiliated;
	      if (hideChanged && this.refs.school) {
	        this.refs.school.setValue(this.getSelectedSchoolId());
	      }
	    }
	  }, {
	    key: 'unaffiliatedIsInvalid',
	    value: function unaffiliatedIsInvalid() {
	      return this.props.hideUnaffiliated || !!this.props.group && this.props.group.hasChildren();
	    }
	  }, {
	    key: 'getSchoolSelectOptions',
	    value: function getSchoolSelectOptions() {
	      var organizationOptions = this.state.memberOrganizations.map(function (org) {
	        return { value: org.id, label: org.getName() };
	      });
	
	      if (!this.unaffiliatedIsInvalid() || this.preExistingUnaffiliatedU13()) {
	        organizationOptions.push({ value: UNAFFILIATED_CLASS_ID, label: 'Not affiliated with a school' });
	      }
	      return organizationOptions;
	    }
	  }, {
	    key: 'getSelectedSchoolName',
	    value: function getSelectedSchoolName() {
	      var name = this.state.organization ? this.state.organization.getName() : 'Not affiliated with a school';
	      return name;
	    }
	  }, {
	    key: 'getSelectedSchoolId',
	    value: function getSelectedSchoolId() {
	      return this.state.organization ? this.state.organization.id : UNAFFILIATED_CLASS_ID;
	    }
	  }, {
	    key: 'getOrganizationForSubmit',
	    value: function getOrganizationForSubmit() {
	      return this.state.organization;
	    }
	
	    // typecheck: ignore statement
	
	  }, {
	    key: 'shouldShowSchool',
	    value: function shouldShowSchool() {
	      return _CurrentUser2.default.getUser().isOrganizationPickerEligible();
	    }
	  }, {
	    key: 'preExistingUnaffiliatedU13',
	    value: function preExistingUnaffiliatedU13() {
	      return !this.state.organization && this.unaffiliatedIsInvalid();
	    }
	  }, {
	    key: 'validation',
	    value: function validation() {
	      return this.unaffiliatedIsInvalid() && 'isGreaterThan: -1';
	    }
	  }, {
	    key: 'renderMenu',
	    value: function renderMenu() {
	      var _cx,
	          _this2 = this;
	
	      var menu = _react2.default.createElement(
	        _Menu2.default,
	        {
	          className: (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _GroupSchoolSelect2.default.schoolMenu, true), _defineProperty(_cx, 'GroupForm-schoolMenu', true), _defineProperty(_cx, _GroupSchoolSelect2.default.hasUnaffiliated, !this.unaffiliatedIsInvalid()), _defineProperty(_cx, 'GroupForm-hasUnaffiliated', !this.unaffiliatedIsInvalid()), _cx)),
	          selectedKey: this.getSelectedSchoolId().toString() },
	        this.getSchoolSelectOptions().map(function (option) {
	          return _react2.default.createElement(
	            _MenuItem2.default,
	            {
	              key: option.value,
	              onSelect: _this2.onSelect },
	            option.label
	          );
	        })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.organization && this.props.prefix,
	        _react2.default.createElement(
	          _LayerTrigger2.default,
	          {
	            layer: menu,
	            trigger: 'click',
	            placement: 'bottom',
	            alignment: 'middle' },
	          _react2.default.createElement(
	            _Link2.default,
	            { href: '#' },
	            _react2.default.createElement(
	              'span',
	              null,
	              this.getSelectedSchoolName(),
	              _react2.default.createElement(_Glyph2.default, { name: 'chevron-down', size: 'xsmall' })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderSelect',
	    value: function renderSelect() {
	      var _cx2;
	
	      return _react2.default.createElement(_FormSelect2.default, {
	        label: 'School',
	        name: 'school',
	        ref: 'school',
	        id: 'schoolSelect',
	        searchable: false,
	        options: this.getSchoolSelectOptions(),
	        value: this.getSelectedSchoolId(),
	        onChange: this.onSchoolChange,
	        validations: this.validation(),
	        validationError: 'The class must be connected to a school if it contains students under 13.',
	        className: (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, _GroupSchoolSelect2.default.schoolSelect, true), _defineProperty(_cx2, 'GroupForm-schoolSelect', true), _defineProperty(_cx2, _GroupSchoolSelect2.default.hasUnaffiliated, !this.unaffiliatedIsInvalid()), _defineProperty(_cx2, 'GroupForm-hasUnaffiliated', !this.unaffiliatedIsInvalid()), _cx2))
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.shouldShowSchool()) {
	        return null;
	      }
	
	      return this.props.input === 'menu' ? this.renderMenu() : this.renderSelect();
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_AffiliationStore2.default, _OrganizationStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState, instanceProps) {
	      var memberOrganizations = _AffiliationStore2.default.getMemberOrganizations();
	      var props = instanceProps; // So Flow is ok with the lambda in `find`
	      var existingOrganization = prevState && prevState.organization;
	      return {
	        memberOrganizations: memberOrganizations,
	        organization: existingOrganization || (props ? memberOrganizations.find(function (o) {
	          return o.id === props.initialOrganizationId;
	        }) : null)
	      };
	    }
	  }]);
	
	  return GroupSchoolSelect;
	}(_react2.default.Component);
	
	GroupSchoolSelect.displayName = 'GroupSchoolSelect';
	exports.default = _utils.Container.create(GroupSchoolSelect, { withProps: true });

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(555);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(1366);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Formsy = __webpack_require__(1345);
	
	var _Formsy2 = _interopRequireDefault(_Formsy);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormSelect = _react2.default.createClass({
	  displayName: 'FormSelect',
	
	
	  mixins: [_Formsy2.default.Mixin],
	
	  getInitialState: function getInitialState() {
	    return {
	      value: this.props.value
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.id = (0, _lodash.uniqueId)('id-');
	  },
	  onChange: function onChange(value) {
	    this.setValue(value);
	    this.setState({ value: value });
	    if (this.props.onChange) {
	      this.props.onChange(value);
	    }
	  },
	  renderLabel: function renderLabel() {
	    var label = this.props.label;
	
	
	    if (label) {
	      return _react2.default.createElement(
	        _Label2.default,
	        { htmlFor: this.id, hidden: this.props.labelHidden },
	        label
	      );
	    } else {
	      return null;
	    }
	  },
	  render: function render() {
	    var errorMessage = this.getErrorMessage();
	
	    if (!this.props.showErrorOnPristine && this.isPristine()) {
	      errorMessage = null;
	    }
	
	    return _react2.default.createElement(
	      _Field2.default,
	      { error: errorMessage },
	      this.renderLabel(),
	      _react2.default.createElement(_Select2.default, _extends({}, this.props, {
	        id: this.id,
	        value: this.state.value,
	        onChange: this.onChange
	      }))
	    );
	  }
	});
	
	exports.default = FormSelect;

/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(1367);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(1378);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var Select = function (_React$Component) {
	  _inherits(Select, _React$Component);
	
	  function Select() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Select);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this._select = null, _this.focus = function () {
	      if (_this._select) {
	        _this._select.focus();
	      }
	    }, _this.onInputKeyUp = function () {
	      if (!_this._select) {
	        return;
	      }
	
	      var inputText = _this._select.getInputValue();
	      var selected = _this.props.options.find(function (option) {
	        var optionLabel = void 0;
	        var inputLabel = void 0;
	        if (option.label) {
	          optionLabel = String(option.label).toLowerCase();
	        }
	        if (inputText) {
	          inputLabel = String(inputText).toLowerCase();
	        }
	        return inputLabel === optionLabel;
	      });
	      if (_this.props.onInputKeyUp) {
	        _this.props.onInputKeyUp(selected);
	      }
	    }, _this.onChange = function (option) {
	      if (_this.props.onChange) {
	        _this.props.onChange(option.value);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // $FlowIssue
	
	
	  _createClass(Select, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          clearable = _props.clearable,
	          options = _props.options,
	          placeholder = _props.placeholder,
	          value = _props.value,
	          required = _props.required,
	          name = _props.name,
	          autoComplete = _props.autoComplete,
	          searchable = _props.searchable;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	
	        for (var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var option = _step.value;
	
	          option.value = String(option.value);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var inputProps = Object.assign({}, this.props.inputProps, { onKeyUp: this.onInputKeyUp });
	
	      return _react2.default.createElement(_reactSelect2.default, {
	        ref: function ref(c) {
	          return _this2._select = c;
	        },
	        className: className,
	        clearable: clearable,
	        onChange: this.onChange,
	        options: options,
	        placeholder: placeholder,
	        value: value && String(value),
	        required: required,
	        name: name,
	        autoComplete: autoComplete,
	        inputProps: inputProps,
	        searchable: searchable
	      });
	    }
	  }]);
	
	  return Select;
	}(_react2.default.Component);
	
	Select.defaultProps = {
	  clearable: false,
	  options: []
	};
	Select.displayName = 'Select';
	exports.default = Select;

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/react-select
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactInputAutosize = __webpack_require__(1368);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsDefaultArrowRenderer = __webpack_require__(1369);
	
	var _utilsDefaultArrowRenderer2 = _interopRequireDefault(_utilsDefaultArrowRenderer);
	
	var _utilsDefaultFilterOptions = __webpack_require__(1370);
	
	var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);
	
	var _utilsDefaultMenuRenderer = __webpack_require__(1372);
	
	var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);
	
	var _Async = __webpack_require__(1373);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(1374);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(1375);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Option = __webpack_require__(1376);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(1377);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function stringifyValue(value) {
		var valueType = typeof value;
		if (valueType === 'string') {
			return value;
		} else if (valueType === 'object') {
			return JSON.stringify(value);
		} else if (valueType === 'number' || valueType === 'boolean') {
			return String(value);
		} else {
			return '';
		}
	}
	
	var stringOrNode = _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]);
	
	var instanceId = 1;
	
	var Select = _react2['default'].createClass({
	
		displayName: 'Select',
	
		propTypes: {
			addLabelText: _react2['default'].PropTypes.string, // placeholder displayed when you want to add a label on a multi-value input
			'aria-label': _react2['default'].PropTypes.string, // Aria label (for assistive tech)
			'aria-labelledby': _react2['default'].PropTypes.string, // HTML ID of an element that should be used as the label (for assistive tech)
			arrowRenderer: _react2['default'].PropTypes.func, // Create drop-down caret element
			autoBlur: _react2['default'].PropTypes.bool, // automatically blur the component when an option is selected
			autofocus: _react2['default'].PropTypes.bool, // autofocus the component on mount
			autosize: _react2['default'].PropTypes.bool, // whether to enable autosizing or not
			backspaceRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
			backspaceToRemoveMessage: _react2['default'].PropTypes.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
			className: _react2['default'].PropTypes.string, // className for the outer element
			clearAllText: stringOrNode, // title for the "clear" control when multi: true
			clearValueText: stringOrNode, // title for the "clear" control
			clearable: _react2['default'].PropTypes.bool, // should it be possible to reset value
			delimiter: _react2['default'].PropTypes.string, // delimiter to use to join multiple values for the hidden field value
			disabled: _react2['default'].PropTypes.bool, // whether the Select is disabled or not
			escapeClearsValue: _react2['default'].PropTypes.bool, // whether escape clears the value when the menu is closed
			filterOption: _react2['default'].PropTypes.func, // method to filter a single option (option, filterString)
			filterOptions: _react2['default'].PropTypes.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
			ignoreAccents: _react2['default'].PropTypes.bool, // whether to strip diacritics when filtering
			ignoreCase: _react2['default'].PropTypes.bool, // whether to perform case-insensitive filtering
			inputProps: _react2['default'].PropTypes.object, // custom attributes for the Input
			inputRenderer: _react2['default'].PropTypes.func, // returns a custom input component
			instanceId: _react2['default'].PropTypes.string, // set the components instanceId
			isLoading: _react2['default'].PropTypes.bool, // whether the Select is loading externally or not (such as options being loaded)
			joinValues: _react2['default'].PropTypes.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
			labelKey: _react2['default'].PropTypes.string, // path of the label value in option objects
			matchPos: _react2['default'].PropTypes.string, // (any|start) match the start or entire string when filtering
			matchProp: _react2['default'].PropTypes.string, // (any|label|value) which option property to filter on
			menuBuffer: _react2['default'].PropTypes.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
			menuContainerStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu container
			menuRenderer: _react2['default'].PropTypes.func, // renders a custom menu with options
			menuStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu
			multi: _react2['default'].PropTypes.bool, // multi-value input
			name: _react2['default'].PropTypes.string, // generates a hidden <input /> tag with this field name for html forms
			noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
			onBlur: _react2['default'].PropTypes.func, // onBlur handler: function (event) {}
			onBlurResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared on blur
			onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
			onClose: _react2['default'].PropTypes.func, // fires when the menu is closed
			onCloseResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared when menu is closed through the arrow
			onFocus: _react2['default'].PropTypes.func, // onFocus handler: function (event) {}
			onInputChange: _react2['default'].PropTypes.func, // onInputChange handler: function (inputValue) {}
			onInputKeyDown: _react2['default'].PropTypes.func, // input keyDown handler: function (event) {}
			onMenuScrollToBottom: _react2['default'].PropTypes.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
			onOpen: _react2['default'].PropTypes.func, // fires when the menu is opened
			onValueClick: _react2['default'].PropTypes.func, // onClick handler for value labels: function (value, event) {}
			openAfterFocus: _react2['default'].PropTypes.bool, // boolean to enable opening dropdown when focused
			openOnFocus: _react2['default'].PropTypes.bool, // always open options menu on focus
			optionClassName: _react2['default'].PropTypes.string, // additional class(es) to apply to the <Option /> elements
			optionComponent: _react2['default'].PropTypes.func, // option component to render in dropdown
			optionRenderer: _react2['default'].PropTypes.func, // optionRenderer: function (option) {}
			options: _react2['default'].PropTypes.array, // array of options
			pageSize: _react2['default'].PropTypes.number, // number of entries to page when using page up/down keys
			placeholder: stringOrNode, // field placeholder, displayed when there's no value
			required: _react2['default'].PropTypes.bool, // applies HTML5 required attribute when needed
			resetValue: _react2['default'].PropTypes.any, // value to use when you clear the control
			scrollMenuIntoView: _react2['default'].PropTypes.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
			searchable: _react2['default'].PropTypes.bool, // whether to enable searching feature or not
			simpleValue: _react2['default'].PropTypes.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
			style: _react2['default'].PropTypes.object, // optional style to apply to the control
			tabIndex: _react2['default'].PropTypes.string, // optional tab index of the control
			tabSelectsValue: _react2['default'].PropTypes.bool, // whether to treat tabbing out while focused to be value selection
			value: _react2['default'].PropTypes.any, // initial field value
			valueComponent: _react2['default'].PropTypes.func, // value component to render
			valueKey: _react2['default'].PropTypes.string, // path of the label value in option objects
			valueRenderer: _react2['default'].PropTypes.func, // valueRenderer: function (option) {}
			wrapperStyle: _react2['default'].PropTypes.object },
	
		// optional style to apply to the component wrapper
		statics: { Async: _Async2['default'], AsyncCreatable: _AsyncCreatable2['default'], Creatable: _Creatable2['default'] },
	
		getDefaultProps: function getDefaultProps() {
			return {
				addLabelText: 'Add "{label}"?',
				arrowRenderer: _utilsDefaultArrowRenderer2['default'],
				autosize: true,
				backspaceRemoves: true,
				backspaceToRemoveMessage: 'Press backspace to remove {label}',
				clearable: true,
				clearAllText: 'Clear all',
				clearValueText: 'Clear value',
				delimiter: ',',
				disabled: false,
				escapeClearsValue: true,
				filterOptions: _utilsDefaultFilterOptions2['default'],
				ignoreAccents: true,
				ignoreCase: true,
				inputProps: {},
				isLoading: false,
				joinValues: false,
				labelKey: 'label',
				matchPos: 'any',
				matchProp: 'any',
				menuBuffer: 0,
				menuRenderer: _utilsDefaultMenuRenderer2['default'],
				multi: false,
				noResultsText: 'No results found',
				onBlurResetsInput: true,
				onCloseResetsInput: true,
				openAfterFocus: false,
				optionComponent: _Option2['default'],
				pageSize: 5,
				placeholder: 'Select...',
				required: false,
				scrollMenuIntoView: true,
				searchable: true,
				simpleValue: false,
				tabSelectsValue: true,
				valueComponent: _Value2['default'],
				valueKey: 'value'
			};
		},
	
		getInitialState: function getInitialState() {
			return {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
		},
	
		componentWillMount: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);
	
			if (this.props.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], this.props.multi)
				});
			}
		},
	
		componentDidMount: function componentDidMount() {
			if (this.props.autofocus) {
				this.focus();
			}
		},
	
		componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);
	
			if (nextProps.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], nextProps.multi)
				});
			}
		},
	
		componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
			if (nextState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(nextState.isOpen);
				var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
				handler && handler();
			}
		},
	
		componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = _reactDom2['default'].findDOMNode(this.focused);
				var menuNode = _reactDom2['default'].findDOMNode(this.menu);
				menuNode.scrollTop = focusedOptionNode.offsetTop;
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}
	
			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = _reactDom2['default'].findDOMNode(this.focused);
				var menuDOM = _reactDom2['default'].findDOMNode(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
		},
	
		componentWillUnmount: function componentWillUnmount() {
			document.removeEventListener('touchstart', this.handleTouchOutside);
		},
	
		toggleTouchOutsideEvent: function toggleTouchOutsideEvent(enabled) {
			if (enabled) {
				document.addEventListener('touchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		},
	
		handleTouchOutside: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		},
	
		focus: function focus() {
			if (!this.input) return;
			this.input.focus();
	
			if (this.props.openAfterFocus) {
				this.setState({
					isOpen: true
				});
			}
		},
	
		blurInput: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		handleTouchEnd: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Fire the mouse events
			this.handleMouseDown(event);
		},
	
		handleTouchEndClearValue: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Clear the value
			this.clearValue(event);
		},
	
		handleMouseDown: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
	
			if (event.target.tagName === 'INPUT') {
				return;
			}
	
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
	
			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}
	
			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();
	
				var input = this.input;
				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}
	
				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';
	
				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: true,
					isPseudoFocused: false
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = true;
				this.focus();
			}
		},
	
		handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			// If the menu isn't open, let the event bubble to the main handleMouseDown
			if (!this.state.isOpen) {
				return;
			}
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
			// close the menu
			this.closeMenu();
		},
	
		handleMouseDownOnMenu: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
	
			this._openAfterFocus = true;
			this.focus();
		},
	
		closeMenu: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi,
					inputValue: ''
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi,
					inputValue: this.state.inputValue
				});
			}
			this.hasScrolledToOption = false;
		},
	
		handleInputFocus: function handleInputFocus(event) {
			if (this.props.disabled) return;
			var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			if (this.props.onFocus) {
				this.props.onFocus(event);
			}
			this.setState({
				isFocused: true,
				isOpen: isOpen
			});
			this._openAfterFocus = false;
		},
	
		handleInputBlur: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}
	
			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = '';
			}
			this.setState(onBlurredState);
		},
	
		handleInputChange: function handleInputChange(event) {
			var newInputValue = event.target.value;
	
			if (this.state.inputValue !== event.target.value && this.props.onInputChange) {
				var nextState = this.props.onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && typeof nextState !== 'object') {
					newInputValue = '' + nextState;
				}
			}
	
			this.setState({
				isOpen: true,
				isPseudoFocused: false,
				inputValue: newInputValue
			});
		},
	
		handleKeyDown: function handleKeyDown(event) {
			if (this.props.disabled) return;
	
			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}
	
			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						return;
					}
					this.selectFocusedOption();
					return;
				case 13:
					// enter
					if (!this.state.isOpen) return;
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 27:
					// escape
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 38:
					// up
					this.focusPreviousOption();
					break;
				case 40:
					// down
					this.focusNextOption();
					break;
				case 33:
					// page up
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						return;
					}
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						return;
					}
					this.focusStartOption();
					break;
				default:
					return;
			}
			event.preventDefault();
		},
	
		handleValueClick: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		},
	
		handleMenuScroll: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;
	
			if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
				this.props.onMenuScrollToBottom();
			}
		},
	
		handleRequired: function handleRequired(value, multi) {
			if (!value) return true;
			return multi ? value.length === 0 : Object.keys(value).length === 0;
		},
	
		getOptionLabel: function getOptionLabel(op) {
			return op[this.props.labelKey];
		},
	
		/**
	  * Turns a value into an array from the given options
	  * @param	{String|Number|Array}	value		- the value of the select input
	  * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	  * @returns	{Array}	the value of the select represented in an array
	  */
		getValueArray: function getValueArray(value, nextProps) {
			var _this = this;
	
			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = typeof nextProps === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') value = value.split(props.delimiter);
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return _this.expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = this.expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		},
	
		/**
	  * Retrieve a value from the given options and valueKey
	  * @param	{String|Number|Array}	value	- the selected value(s)
	  * @param	{Object}		props	- the Select component's props (or nextProps)
	  */
		expandValue: function expandValue(value, props) {
			var valueType = typeof value;
			if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
			var options = props.options;
			var valueKey = props.valueKey;
	
			if (!options) return;
			for (var i = 0; i < options.length; i++) {
				if (options[i][valueKey] === value) return options[i];
			}
		},
	
		setValue: function setValue(value) {
			var _this2 = this;
	
			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (!this.props.onChange) return;
			if (this.props.required) {
				var required = this.handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			this.props.onChange(value);
		},
	
		selectValue: function selectValue(value) {
			var _this3 = this;
	
			//NOTE: update value in the callback to make sure the input value is empty so that there are no styling issues (Chrome had issue otherwise)
			this.hasScrolledToOption = false;
			if (this.props.multi) {
				this.setState({
					inputValue: '',
					focusedIndex: null
				}, function () {
					_this3.addValue(value);
				});
			} else {
				this.setState({
					isOpen: false,
					inputValue: '',
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		},
	
		addValue: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.concat(value));
		},
	
		popValue: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(valueArray.slice(0, valueArray.length - 1));
		},
	
		removeValue: function removeValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i !== value;
			}));
			this.focus();
		},
	
		clearValue: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
			this.setValue(this.getResetValue());
			this.setState({
				isOpen: false,
				inputValue: ''
			}, this.focus);
		},
	
		getResetValue: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		},
	
		focusOption: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		},
	
		focusNextOption: function focusNextOption() {
			this.focusAdjacentOption('next');
		},
	
		focusPreviousOption: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		},
	
		focusPageUpOption: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		},
	
		focusPageDownOption: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		},
	
		focusStartOption: function focusStartOption() {
			this.focusAdjacentOption('start');
		},
	
		focusEndOption: function focusEndOption() {
			this.focusAdjacentOption('end');
		},
	
		focusAdjacentOption: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				this.setState({
					isOpen: true,
					inputValue: '',
					focusedOption: this._focusedOption || options[dir === 'next' ? 0 : options.length - 1].option
				});
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var potentialIndex = focusedIndex + this.props.pageSize;
				if (potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = potentialIndex;
				}
			}
	
			if (focusedIndex === -1) {
				focusedIndex = 0;
			}
	
			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		},
	
		getFocusedOption: function getFocusedOption() {
			return this._focusedOption;
		},
	
		getInputValue: function getInputValue() {
			return this.state.inputValue;
		},
	
		selectFocusedOption: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		},
	
		renderLoading: function renderLoading() {
			if (!this.props.isLoading) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				_react2['default'].createElement('span', { className: 'Select-loading' })
			);
		},
	
		renderValue: function renderValue(valueArray, isOpen) {
			var _this4 = this;
	
			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				return !this.state.inputValue ? _react2['default'].createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return _react2['default'].createElement(
						ValueComponent,
						{
							id: _this4._instancePrefix + '-value-' + i,
							instancePrefix: _this4._instancePrefix,
							disabled: _this4.props.disabled || value.clearableValue === false,
							key: 'value-' + i + '-' + value[_this4.props.valueKey],
							onClick: onClick,
							onRemove: _this4.removeValue,
							value: value
						},
						renderLabel(value, i),
						_react2['default'].createElement(
							'span',
							{ className: 'Select-aria-only' },
							' '
						)
					);
				});
			} else if (!this.state.inputValue) {
				if (isOpen) onClick = null;
				return _react2['default'].createElement(
					ValueComponent,
					{
						id: this._instancePrefix + '-value-item',
						disabled: this.props.disabled,
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		},
	
		renderInput: function renderInput(valueArray, focusedOptionIndex) {
			var _this5 = this;
	
			if (this.props.inputRenderer) {
				return this.props.inputRenderer();
			} else {
				var _classNames;
	
				var className = (0, _classnames2['default'])('Select-input', this.props.inputProps.className);
				var isOpen = !!this.state.isOpen;
	
				var ariaOwns = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				// TODO: Check how this project includes Object.assign()
				var inputProps = _extends({}, this.props.inputProps, {
					role: 'combobox',
					'aria-expanded': '' + isOpen,
					'aria-owns': ariaOwns,
					'aria-haspopup': '' + isOpen,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-label': this.props['aria-label'],
					className: className,
					tabIndex: this.props.tabIndex,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this5.input = _ref;
					},
					required: this.state.required,
					value: this.state.inputValue
				});
	
				if (this.props.disabled || !this.props.searchable) {
					var _props$inputProps = this.props.inputProps;
					var inputClassName = _props$inputProps.inputClassName;
	
					var divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);
	
					return _react2['default'].createElement('div', _extends({}, divProps, {
						role: 'combobox',
						'aria-expanded': isOpen,
						'aria-owns': isOpen ? this._instancePrefix + '-list' : this._instancePrefix + '-value',
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						className: className,
						tabIndex: this.props.tabIndex || 0,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function (ref) {
							return _this5.input = ref;
						},
						'aria-readonly': '' + !!this.props.disabled,
						style: { border: 0, width: 1, display: 'inline-block' } }));
				}
	
				if (this.props.autosize) {
					return _react2['default'].createElement(_reactInputAutosize2['default'], _extends({}, inputProps, { minWidth: '5px' }));
				}
				return _react2['default'].createElement(
					'div',
					{ className: className },
					_react2['default'].createElement('input', inputProps)
				);
			}
		},
	
		renderClear: function renderClear() {
			if (!this.props.clearable || !this.props.value || this.props.value === 0 || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					onMouseDown: this.clearValue,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEndClearValue
				},
				_react2['default'].createElement('span', { className: 'Select-clear', dangerouslySetInnerHTML: { __html: '&times;' } })
			);
		},
	
		renderArrow: function renderArrow() {
			var onMouseDown = this.handleMouseDownOnArrow;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown });
	
			return _react2['default'].createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		},
	
		filterOptions: function filterOptions(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _utilsDefaultFilterOptions2['default'];
	
				return filterOptions(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		},
	
		onOptionRef: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		},
	
		renderMenu: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey,
					onOptionRef: this.onOptionRef
				});
			} else if (this.props.noResultsText) {
				return _react2['default'].createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		},
	
		renderHiddenField: function renderHiddenField(valueArray) {
			var _this6 = this;
	
			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this6.props.valueKey]);
				}).join(this.props.delimiter);
				return _react2['default'].createElement('input', {
					type: 'hidden',
					ref: function (ref) {
						return _this6.value = ref;
					},
					name: this.props.name,
					value: value,
					disabled: this.props.disabled });
			}
			return valueArray.map(function (item, index) {
				return _react2['default'].createElement('input', { key: 'hidden.' + index,
					type: 'hidden',
					ref: 'value' + index,
					name: _this6.props.name,
					value: stringifyValue(item[_this6.props.valueKey]),
					disabled: _this6.props.disabled });
			});
		},
	
		getFocusableOptionIndex: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;
	
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = options.indexOf(focusedOption);
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}
	
			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		},
	
		renderOuter: function renderOuter(options, valueArray, focusedOption) {
			var _this7 = this;
	
			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}
	
			return _react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this7.menuContainer = ref;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				_react2['default'].createElement(
					'div',
					{ ref: function (ref) {
							return _this7.menu = ref;
						}, role: 'listbox', className: 'Select-menu', id: this._instancePrefix + '-list',
						style: this.props.menuStyle,
						onScroll: this.handleMenuScroll,
						onMouseDown: this.handleMouseDownOnMenu },
					menu
				)
			);
		},
	
		render: function render() {
			var _this8 = this;
	
			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = (0, _classnames2['default'])('Select', this.props.className, {
				'Select--multi': this.props.multi,
				'Select--single': !this.props.multi,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'has-value': valueArray.length
			});
	
			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = _react2['default'].createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}
	
			return _react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this8.wrapper = ref;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				_react2['default'].createElement(
					'div',
					{ ref: function (ref) {
							return _this8.control = ref;
						},
						className: 'Select-control',
						style: this.props.style,
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove
					},
					_react2['default'].createElement(
						'span',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
			);
		}
	
	});
	
	exports['default'] = Select;
	module.exports = exports['default'];

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(299);
	
	var sizerStyle = { position: 'absolute', top: 0, left: 0, visibility: 'hidden', height: 0, overflow: 'scroll', whiteSpace: 'pre' };
	
	var AutosizeInput = React.createClass({
		displayName: 'AutosizeInput',
	
		propTypes: {
			className: React.PropTypes.string, // className for the outer element
			defaultValue: React.PropTypes.any, // default field value
			inputClassName: React.PropTypes.string, // className for the input element
			inputStyle: React.PropTypes.object, // css styles for the input element
			minWidth: React.PropTypes.oneOfType([// minimum width for input element
			React.PropTypes.number, React.PropTypes.string]),
			onChange: React.PropTypes.func, // onChange handler: function(newValue) {}
			placeholder: React.PropTypes.string, // placeholder text
			placeholderIsMinWidth: React.PropTypes.bool, // don't collapse size to less than the placeholder
			style: React.PropTypes.object, // css styles for the outer element
			value: React.PropTypes.any },
		// field value
		getDefaultProps: function getDefaultProps() {
			return {
				minWidth: 1
			};
		},
		getInitialState: function getInitialState() {
			return {
				inputWidth: this.props.minWidth
			};
		},
		componentDidMount: function componentDidMount() {
			this.copyInputStyles();
			this.updateInputWidth();
		},
		componentDidUpdate: function componentDidUpdate() {
			this.updateInputWidth();
		},
		copyInputStyles: function copyInputStyles() {
			if (!this.isMounted() || !window.getComputedStyle) {
				return;
			}
			var inputStyle = window.getComputedStyle(this.refs.input);
			if (!inputStyle) {
				return;
			}
			var widthNode = this.refs.sizer;
			widthNode.style.fontSize = inputStyle.fontSize;
			widthNode.style.fontFamily = inputStyle.fontFamily;
			widthNode.style.fontWeight = inputStyle.fontWeight;
			widthNode.style.fontStyle = inputStyle.fontStyle;
			widthNode.style.letterSpacing = inputStyle.letterSpacing;
			if (this.props.placeholder) {
				var placeholderNode = this.refs.placeholderSizer;
				placeholderNode.style.fontSize = inputStyle.fontSize;
				placeholderNode.style.fontFamily = inputStyle.fontFamily;
				placeholderNode.style.fontWeight = inputStyle.fontWeight;
				placeholderNode.style.fontStyle = inputStyle.fontStyle;
				placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
			}
		},
		updateInputWidth: function updateInputWidth() {
			if (!this.isMounted() || typeof this.refs.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = undefined;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.refs.sizer.scrollWidth, this.refs.placeholderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.refs.sizer.scrollWidth + 2;
			}
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		},
		getInput: function getInput() {
			return this.refs.input;
		},
		focus: function focus() {
			this.refs.input.focus();
		},
		blur: function blur() {
			this.refs.input.blur();
		},
		select: function select() {
			this.refs.input.select();
		},
		render: function render() {
			var sizerValue = this.props.defaultValue || this.props.value || '';
			var wrapperStyle = this.props.style || {};
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
			var inputStyle = _extends({}, this.props.inputStyle);
			inputStyle.width = this.state.inputWidth + 'px';
			inputStyle.boxSizing = 'content-box';
			var inputProps = _extends({}, this.props);
			inputProps.className = this.props.inputClassName;
			inputProps.style = inputStyle;
			// ensure props meant for `AutosizeInput` don't end up on the `input`
			delete inputProps.inputClassName;
			delete inputProps.inputStyle;
			delete inputProps.minWidth;
			delete inputProps.placeholderIsMinWidth;
			return React.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				React.createElement('input', _extends({}, inputProps, { ref: 'input' })),
				React.createElement(
					'div',
					{ ref: 'sizer', style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? React.createElement(
					'div',
					{ ref: 'placeholderSizer', style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	});
	
	module.exports = AutosizeInput;

/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports["default"] = arrowRenderer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2["default"].createElement("span", {
			className: "Select-arrow",
			onMouseDown: onMouseDown
		});
	}
	
	;
	module.exports = exports["default"];

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stripDiacritics = __webpack_require__(1371);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function filterOptions(options, filterValue, excludeOptions, props) {
		var _this = this;
	
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2['default'])(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
			if (!filterValue) return true;
			var valueTest = String(option[props.valueKey]);
			var labelTest = String(option[props.labelKey]);
			if (props.ignoreAccents) {
				if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2['default'])(valueTest);
				if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2['default'])(labelTest);
			}
			if (props.ignoreCase) {
				if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
			return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	}
	
	module.exports = filterOptions;

/***/ },
/* 1371 */
/***/ function(module, exports) {

	'use strict';
	
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	module.exports = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption;
		var instancePrefix = _ref.instancePrefix;
		var labelKey = _ref.labelKey;
		var onFocus = _ref.onFocus;
		var onSelect = _ref.onSelect;
		var optionClassName = _ref.optionClassName;
		var optionComponent = _ref.optionComponent;
		var optionRenderer = _ref.optionRenderer;
		var options = _ref.options;
		var valueArray = _ref.valueArray;
		var valueKey = _ref.valueKey;
		var onOptionRef = _ref.onOptionRef;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.indexOf(option) > -1;
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2['default'])(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2['default'].createElement(
				Option,
				{
					className: optionClass,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function (ref) {
						onOptionRef(ref, isFocused);
					}
				},
				optionRenderer(option, i)
			);
		});
	}
	
	module.exports = menuRenderer;

/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(1367);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _utilsStripDiacritics = __webpack_require__(1371);
	
	var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);
	
	var propTypes = {
		autoload: _react2['default'].PropTypes.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _react2['default'].PropTypes.any, // object to use to cache results; set to null/false to disable caching
		children: _react2['default'].PropTypes.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _react2['default'].PropTypes.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _react2['default'].PropTypes.bool, // perform case-insensitive filtering; defaults to true
		loadingPlaceholder: _react.PropTypes.string.isRequired, // replaces the placeholder while options are loading
		loadOptions: _react2['default'].PropTypes.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		options: _react.PropTypes.array.isRequired, // array of options
		placeholder: _react2['default'].PropTypes.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
		searchPromptText: _react2['default'].PropTypes.oneOfType([// label to prompt for search input
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node])
	};
	
	var defaultProps = {
		autoload: true,
		cache: {},
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = (function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			_get(Object.getPrototypeOf(Async.prototype), 'constructor', this).call(this, props, context);
	
			this.state = {
				isLoading: false,
				options: props.options
			};
	
			this._onInputChange = this._onInputChange.bind(this);
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps, nextState) {
				var _this = this;
	
				var propertiesToSync = ['options'];
				propertiesToSync.forEach(function (prop) {
					if (_this.props[prop] !== nextProps[prop]) {
						_this.setState(_defineProperty({}, prop, nextProps[prop]));
					}
				});
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var _props = this.props;
				var cache = _props.cache;
				var loadOptions = _props.loadOptions;
	
				if (cache && cache.hasOwnProperty(inputValue)) {
					this.setState({
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						var options = data && data.options || [];
	
						if (cache) {
							cache[inputValue] = options;
						}
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
	
				return inputValue;
			}
		}, {
			key: '_onInputChange',
			value: function _onInputChange(inputValue) {
				var _props2 = this.props;
				var ignoreAccents = _props2.ignoreAccents;
				var ignoreCase = _props2.ignoreCase;
	
				if (ignoreAccents) {
					inputValue = (0, _utilsStripDiacritics2['default'])(inputValue);
				}
	
				if (ignoreCase) {
					inputValue = inputValue.toLowerCase();
				}
	
				return this.loadOptions(inputValue);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props3 = this.props;
				var children = _props3.children;
				var loadingPlaceholder = _props3.loadingPlaceholder;
				var placeholder = _props3.placeholder;
				var searchPromptText = _props3.searchPromptText;
				var _state = this.state;
				var isLoading = _state.isLoading;
				var options = _state.options;
	
				var props = {
					noResultsText: isLoading ? loadingPlaceholder : searchPromptText,
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading ? [] : options
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this._onInputChange
				}));
			}
		}]);
	
		return Async;
	})(_react.Component);
	
	exports['default'] = Async;
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;
	
	function defaultChildren(props) {
		return _react2['default'].createElement(_Select2['default'], props);
	};
	module.exports = exports['default'];

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(1367);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var AsyncCreatable = _react2['default'].createClass({
		displayName: 'AsyncCreatableSelect',
	
		render: function render() {
			var _this = this;
	
			return _react2['default'].createElement(
				_Select2['default'].Async,
				this.props,
				function (asyncProps) {
					return _react2['default'].createElement(
						_Select2['default'].Creatable,
						_this.props,
						function (creatableProps) {
							return _react2['default'].createElement(_Select2['default'], _extends({}, asyncProps, creatableProps, {
								onInputChange: function (input) {
									creatableProps.onInputChange(input);
									return asyncProps.onInputChange(input);
								}
							}));
						}
					);
				}
			);
		}
	});
	
	module.exports = AsyncCreatable;

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(1367);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _utilsDefaultFilterOptions = __webpack_require__(1370);
	
	var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);
	
	var _utilsDefaultMenuRenderer = __webpack_require__(1372);
	
	var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);
	
	var Creatable = _react2['default'].createClass({
		displayName: 'CreatableSelect',
	
		propTypes: {
			// Child function responsible for creating the inner Select component
			// This component can be used to compose HOCs (eg Creatable and Async)
			// (props: Object): PropTypes.element
			children: _react2['default'].PropTypes.func,
	
			// See Select.propTypes.filterOptions
			filterOptions: _react2['default'].PropTypes.any,
	
			// Searches for any matching option within the set of options.
			// This function prevents duplicate options from being created.
			// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
			isOptionUnique: _react2['default'].PropTypes.func,
	
			// Determines if the current input text represents a valid option.
			// ({ label: string }): boolean
			isValidNewOption: _react2['default'].PropTypes.func,
	
			// See Select.propTypes.menuRenderer
			menuRenderer: _react2['default'].PropTypes.any,
	
			// Factory to create new option.
			// ({ label: string, labelKey: string, valueKey: string }): Object
			newOptionCreator: _react2['default'].PropTypes.func,
	
			// See Select.propTypes.options
			options: _react2['default'].PropTypes.array,
	
			// Creates prompt/placeholder option text.
			// (filterText: string): string
			promptTextCreator: _react2['default'].PropTypes.func,
	
			// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
			shouldKeyDownEventCreateNewOption: _react2['default'].PropTypes.func
		},
	
		// Default prop methods
		statics: {
			isOptionUnique: isOptionUnique,
			isValidNewOption: isValidNewOption,
			newOptionCreator: newOptionCreator,
			promptTextCreator: promptTextCreator,
			shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
		},
	
		getDefaultProps: function getDefaultProps() {
			return {
				filterOptions: _utilsDefaultFilterOptions2['default'],
				isOptionUnique: isOptionUnique,
				isValidNewOption: isValidNewOption,
				menuRenderer: _utilsDefaultMenuRenderer2['default'],
				newOptionCreator: newOptionCreator,
				promptTextCreator: promptTextCreator,
				shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
			};
		},
	
		createNewOption: function createNewOption() {
			var _props = this.props;
			var isValidNewOption = _props.isValidNewOption;
			var newOptionCreator = _props.newOptionCreator;
			var _props$options = _props.options;
			var options = _props$options === undefined ? [] : _props$options;
			var shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;
	
			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option });
	
				// Don't add the same option twice.
				if (_isOptionUnique) {
					options.unshift(option);
	
					this.select.selectValue(option);
				}
			}
		},
	
		filterOptions: function filterOptions() {
			var _props2 = this.props;
			var filterOptions = _props2.filterOptions;
			var isValidNewOption = _props2.isValidNewOption;
			var options = _props2.options;
			var promptTextCreator = _props2.promptTextCreator;
	
			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
			var excludeOptions = arguments[2] || [];
	
			var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;
	
				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});
	
				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});
	
				if (_isOptionUnique2) {
					var _prompt = promptTextCreator(this.inputValue);
	
					this._createPlaceholderOption = _newOptionCreator({
						label: _prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					filteredOptions.unshift(this._createPlaceholderOption);
				}
			}
	
			return filteredOptions;
		},
	
		isOptionUnique: function isOptionUnique(_ref2) {
			var option = _ref2.option;
			var options = _ref2.options;
			var isOptionUnique = this.props.isOptionUnique;
	
			options = options || this.select.filterOptions();
	
			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		},
	
		menuRenderer: function menuRenderer(params) {
			var menuRenderer = this.props.menuRenderer;
	
			return menuRenderer(_extends({}, params, {
				onSelect: this.onOptionSelect
			}));
		},
	
		onInputChange: function onInputChange(input) {
			// This value may be needed in between Select mounts (when this.select is null)
			this.inputValue = input;
		},
	
		onInputKeyDown: function onInputKeyDown(event) {
			var shouldKeyDownEventCreateNewOption = this.props.shouldKeyDownEventCreateNewOption;
	
			var focusedOption = this.select.getFocusedOption();
	
			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
				this.createNewOption();
	
				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			}
		},
	
		onOptionSelect: function onOptionSelect(option, event) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		},
	
		render: function render() {
			var _this = this;
	
			var _props3 = this.props;
			var _props3$children = _props3.children;
			var children = _props3$children === undefined ? defaultChildren : _props3$children;
			var newOptionCreator = _props3.newOptionCreator;
			var shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption;
	
			var restProps = _objectWithoutProperties(_props3, ['children', 'newOptionCreator', 'shouldKeyDownEventCreateNewOption']);
	
			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref) {
					_this.select = _ref;
	
					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref) {
						_this.labelKey = _ref.props.labelKey;
						_this.valueKey = _ref.props.valueKey;
					}
				}
			});
	
			return children(props);
		}
	});
	
	function defaultChildren(props) {
		return _react2['default'].createElement(_Select2['default'], props);
	};
	
	function isOptionUnique(_ref3) {
		var option = _ref3.option;
		var options = _ref3.options;
		var labelKey = _ref3.labelKey;
		var valueKey = _ref3.valueKey;
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	function isValidNewOption(_ref4) {
		var label = _ref4.label;
	
		return !!label;
	};
	
	function newOptionCreator(_ref5) {
		var label = _ref5.label;
		var labelKey = _ref5.labelKey;
		var valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
		return option;
	};
	
	function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	}
	
	function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
		}
	
		return false;
	};
	
	module.exports = Creatable;

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Option = _react2['default'].createClass({
		displayName: 'Option',
	
		propTypes: {
			children: _react2['default'].PropTypes.node,
			className: _react2['default'].PropTypes.string, // className (based on mouse position)
			instancePrefix: _react2['default'].PropTypes.string.isRequired, // unique prefix for the ids (used for aria)
			isDisabled: _react2['default'].PropTypes.bool, // the option is disabled
			isFocused: _react2['default'].PropTypes.bool, // the option is focused
			isSelected: _react2['default'].PropTypes.bool, // the option is selected
			onFocus: _react2['default'].PropTypes.func, // method to handle mouseEnter on option element
			onSelect: _react2['default'].PropTypes.func, // method to handle click on option element
			onUnfocus: _react2['default'].PropTypes.func, // method to handle mouseLeave on option element
			option: _react2['default'].PropTypes.object.isRequired, // object that is base for that option
			optionIndex: _react2['default'].PropTypes.number },
		// index of the option, used to generate unique ids for aria
		blockEvent: function blockEvent(event) {
			event.preventDefault();
			event.stopPropagation();
			if (event.target.tagName !== 'A' || !('href' in event.target)) {
				return;
			}
			if (event.target.target) {
				window.open(event.target.href, event.target.target);
			} else {
				window.location.href = event.target.href;
			}
		},
	
		handleMouseDown: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		},
	
		handleMouseEnter: function handleMouseEnter(event) {
			this.onFocus(event);
		},
	
		handleMouseMove: function handleMouseMove(event) {
			this.onFocus(event);
		},
	
		handleTouchEnd: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			this.handleMouseDown(event);
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		onFocus: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		},
		render: function render() {
			var _props = this.props;
			var option = _props.option;
			var instancePrefix = _props.instancePrefix;
			var optionIndex = _props.optionIndex;
	
			var className = (0, _classnames2['default'])(this.props.className, option.className);
	
			return option.disabled ? _react2['default'].createElement(
				'div',
				{ className: className,
					onMouseDown: this.blockEvent,
					onClick: this.blockEvent },
				this.props.children
			) : _react2['default'].createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	});
	
	module.exports = Option;

/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Value = _react2['default'].createClass({
	
		displayName: 'Value',
	
		propTypes: {
			children: _react2['default'].PropTypes.node,
			disabled: _react2['default'].PropTypes.bool, // disabled prop passed to ReactSelect
			id: _react2['default'].PropTypes.string, // Unique id for the value - used for aria
			onClick: _react2['default'].PropTypes.func, // method to handle click on value label
			onRemove: _react2['default'].PropTypes.func, // method to handle removal of the value
			value: _react2['default'].PropTypes.object.isRequired },
	
		// the option object for this value
		handleMouseDown: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		},
	
		onRemove: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		},
	
		handleTouchEndRemove: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Fire the mouse events
			this.onRemove(event);
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		renderRemoveIcon: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'×'
			);
		},
	
		renderLabel: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? _react2['default'].createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : _react2['default'].createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		},
	
		render: function render() {
			return _react2['default'].createElement(
				'div',
				{ className: (0, _classnames2['default'])('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	
	});
	
	module.exports = Value;

/***/ },
/* 1378 */
1136,
/* 1379 */,
/* 1380 */,
/* 1381 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"brand":"#2f75c1","wolf":"#dcdee2","hasUnaffiliated":"GroupSchoolSelect__hasUnaffiliated___PWm4d","schoolSelect":"GroupSchoolSelect__schoolSelect___3QKb3","schoolMenu":"GroupSchoolSelect__schoolMenu___3tp-m"};

/***/ },
/* 1382 */,
/* 1383 */,
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _focusNode = __webpack_require__(1210);
	
	var _focusNode2 = _interopRequireDefault(_focusNode);
	
	__webpack_require__(1385);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrependedTextInput = function (_React$Component) {
	  _inherits(PrependedTextInput, _React$Component);
	
	  function PrependedTextInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PrependedTextInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PrependedTextInput.__proto__ || Object.getPrototypeOf(PrependedTextInput)).call.apply(_ref, [this].concat(args))), _this), _this.getInputNode = function () {
	      return _reactDom2.default.findDOMNode(_this.refs.input);
	    }, _this.getValue = function () {
	      return _this.getInputNode().value;
	    }, _this.handleFocus = function () {
	      (0, _focusNode2.default)(_reactDom2.default.findDOMNode(_this.refs.input));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PrependedTextInput, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'PrependedTextInput', onFocus: this.handleFocus },
	        _react2.default.createElement(
	          'span',
	          { className: 'PrependedTextInput-prepend' },
	          this.props.prepend
	        ),
	        _react2.default.createElement(_Input2.default, _extends({}, this.props, {
	          ref: 'input',
	          className: (0, _classnames2.default)('PrependedTextInput-input', this.props.className),
	          type: 'text'
	        }))
	      );
	    }
	  }]);
	
	  return PrependedTextInput;
	}(_react2.default.Component);
	
	PrependedTextInput.displayName = 'PrependedTextInput';
	exports.default = PrependedTextInput;

/***/ },
/* 1385 */
1136,
/* 1386 */,
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Checkbox = __webpack_require__(1388);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _CheckboxCopy = __webpack_require__(1391);
	
	var _CheckboxCopy2 = _interopRequireDefault(_CheckboxCopy);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1394);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var GroupOptionsForm = function (_React$Component) {
	  _inherits(GroupOptionsForm, _React$Component);
	
	  function GroupOptionsForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupOptionsForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupOptionsForm.__proto__ || Object.getPrototypeOf(GroupOptionsForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      subscriberInitiatedChats: _this.props.subscriberInitiatedChats,
	      hasChildren: _this.props.hasChildren,
	      searchable: _this.props.searchable
	    }, _this.getValues = function () {
	      return {
	        has_children: _this.props.userIsTeacher && _this.state.hasChildren,
	        searchable: _this.state.searchable,
	        subscriber_initiated_chats: _this.state.subscriberInitiatedChats
	      };
	    }, _this.toggle = function (name) {
	      _this.setState(_defineProperty({}, name, !_this.state[name]));
	
	      if (_this.props.onChange) {
	        _this.props.onChange(name, !_this.state[name]);
	      }
	    }, _this.renderUnder13Checkbox = function () {
	      var labelNote = 'It\u2019s okay if students are under 13. We\u2019ll ask for a parent\u2019s email address to\n      keep everyone in the loop.';
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Checkbox2.default,
	          {
	            checked: !_this.state.hasChildren,
	            labelNote: labelNote,
	            onChange: function onChange() {
	              return _this.toggle('hasChildren');
	            } },
	          'I will only message people 13 or older'
	        ),
	        _this.state.hasChildren && _react2.default.createElement(
	          'p',
	          null,
	          'Students under 13 can\u2019t reply.'
	        )
	      );
	    }, _this.renderSearchableCheckbox = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'GroupOptionsForm-searchableToggle' },
	        _react2.default.createElement(
	          _Checkbox2.default,
	          {
	            checked: _this.state.searchable,
	            onChange: function onChange() {
	              return _this.toggle('searchable');
	            } },
	          'People in this class can see and message each other'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'If you select this option, people at your school can also find your class.'
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupOptionsForm, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        subscriberInitiatedChats: nextProps.subscriberInitiatedChats,
	        hasChildren: nextProps.hasChildren,
	        searchable: nextProps.searchable
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _CheckboxCopy2.default,
	        { className: 'GroupOptionsForm' },
	        this.props.showSearchable && this.renderSearchableCheckbox(),
	        this.props.userIsTeacher && !this.props.hideUnderageNote ? this.renderUnder13Checkbox() : _react2.default.createElement(
	          'p',
	          null,
	          'This class can only include people who are 13 or older.'
	        )
	      );
	    }
	  }]);
	
	  return GroupOptionsForm;
	}(_react2.default.Component);
	
	GroupOptionsForm.defaultProps = {
	  subscriberInitiatedChats: true,
	  hasChildren: true,
	  searchable: true,
	  showSearchable: false
	};
	GroupOptionsForm.displayName = 'GroupOptionsForm';
	exports.default = GroupOptionsForm;

/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _ClickEventTrigger = __webpack_require__(1181);
	
	var _ClickEventTrigger2 = _interopRequireDefault(_ClickEventTrigger);
	
	__webpack_require__(1389);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	  * A React component for Checkbox. Leverages react-select
	  * https://github.com/JedWatson/react-select
	  */
	var Checkbox = function (_React$Component) {
	  _inherits(Checkbox, _React$Component);
	
	  function Checkbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Checkbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.isChecked = function () {
	      return _this.refs.input.getInputNode().checked;
	    }, _this.renderInput = function (properties) {
	      var input = _react2.default.createElement(_Input2.default, _extends({}, properties, {
	        ref: 'input',
	        type: 'checkbox',
	        className: 'Checkbox-input'
	      }));
	      if (_this.props.name && !_this.props.disabled && _this.props.checked) {
	        var eventScreenName = _this.props.eventScreenName;
	
	        var eventElementName = _this.props.eventElementName || 'Checkbox';
	        var eventProperties = {};
	        eventProperties[_this.props.name] = _this.props.value;
	        eventProperties = {
	          toggle: _this.props.checked ? 'no' : 'yes'
	        };
	        return _react2.default.createElement(
	          _ClickEventTrigger2.default,
	          {
	            eventElementName: eventElementName,
	            eventProperties: eventProperties,
	            eventScreenName: eventScreenName },
	          input
	        );
	      } else {
	        return input;
	      }
	    }, _this.renderLabelNote = function () {
	      if (_this.props.labelNote) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'Checkbox-labelNote' },
	          _this.props.labelNote
	        );
	      } else {
	        return null;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Checkbox, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          label = _props.label,
	          children = _props.children,
	          others = _objectWithoutProperties(_props, ['className', 'label', 'children']);
	
	      return _react2.default.createElement(
	        _Label2.default,
	        {
	          className: (0, _classnames2.default)('Checkbox', {
	            'Checkbox--divided': this.props.divided,
	            'Checkbox--noLabel': !this.props.label && !children
	          }, className) },
	        this.renderInput(others),
	        _react2.default.createElement('span', { className: 'Checkbox-indicator' }),
	        label,
	        children,
	        this.renderLabelNote()
	      );
	    }
	  }]);
	
	  return Checkbox;
	}(_react2.default.Component);
	
	Checkbox.defaultProps = {
	  disabled: false,
	  divided: false
	};
	Checkbox.displayName = 'Checkbox';
	exports.default = Checkbox;

/***/ },
/* 1389 */
1136,
/* 1390 */,
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1392);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * CheckboxCopy is a component for lining up paragraphs & lists with Checkbox labels, and styling
	 * them to match a Checkbox label note
	 *
	 * ```example
	 *  <CheckboxCopy>
	 *    <Checkbox label="A checkbox label">
	 *    <p>
	 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean eget rhoncus nunc, eget
	 *     commodo felis. Vestibulum mattis mi tortor, id imperdiet ex imperdiet in.
	 *    </p>
	 *    <ol>
	 *      <li>Lorem ipsum dolor sit amet</li>
	 *      <li>Lorem ipsum dolor sit amet</li>
	 *      <li>Lorem ipsum dolor sit amet</li>
	 *    </ol>
	 *    <ul>
	 *      <li>Lorem ipsum dolor sit amet</li>
	 *      <li>Lorem ipsum dolor sit amet</li>
	 *      <li>Lorem ipsum dolor sit amet</li>
	 *    </ul>
	 *  </CheckboxCopy>
	 * ```
	 */
	
	var CheckboxCopy = function (_React$Component) {
	  _inherits(CheckboxCopy, _React$Component);
	
	  function CheckboxCopy() {
	    _classCallCheck(this, CheckboxCopy);
	
	    return _possibleConstructorReturn(this, (CheckboxCopy.__proto__ || Object.getPrototypeOf(CheckboxCopy)).apply(this, arguments));
	  }
	
	  _createClass(CheckboxCopy, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'CheckboxCopy' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return CheckboxCopy;
	}(_react2.default.Component);
	
	CheckboxCopy.displayName = 'CheckboxCopy';
	exports.default = CheckboxCopy;

/***/ },
/* 1392 */
1136,
/* 1393 */,
/* 1394 */
1136,
/* 1395 */,
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1397);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var MediaObject = function (_React$Component) {
	  _inherits(MediaObject, _React$Component);
	
	  function MediaObject() {
	    _classCallCheck(this, MediaObject);
	
	    return _possibleConstructorReturn(this, (MediaObject.__proto__ || Object.getPrototypeOf(MediaObject)).apply(this, arguments));
	  }
	
	  _createClass(MediaObject, [{
	    key: 'render',
	    value: function render() {
	      var _props$children = _slicedToArray(this.props.children, 2),
	          left = _props$children[0],
	          right = _props$children[1];
	
	      if (this.props.figure === 'left') {
	        left = MediaObject.wrap(left);
	        left = _react2.default.cloneElement(left, {
	          className: (0, _classnames2.default)('MediaObject-figure', left.props.className)
	        });
	
	        right = MediaObject.wrap(right);
	        right = _react2.default.cloneElement(right, {
	          className: (0, _classnames2.default)('MediaObject-body', right.props.className)
	        });
	      } else {
	        right = MediaObject.wrap(right);
	        right = _react2.default.cloneElement(right, {
	          className: (0, _classnames2.default)('MediaObject-figure', right.props.className)
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('MediaObject', {
	            'MediaObject--center': this.props.center,
	            'MediaObject--small': this.props.gutter === 'small'
	          }, this.props.className) },
	        left,
	        right
	      );
	    }
	  }], [{
	    key: 'wrap',
	    value: function wrap(node) {
	      if (_react2.default.isValidElement(node)) {
	        return node;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        node
	      );
	    }
	  }]);
	
	  return MediaObject;
	}(_react2.default.Component);
	
	MediaObject.defaultProps = {
	  center: false,
	  figure: 'left',
	  gutter: 'medium',
	  allowOverflow: false
	};
	MediaObject.displayName = 'MediaObject';
	exports.default = MediaObject;

/***/ },
/* 1397 */
1136,
/* 1398 */,
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageHistoryDialog = function (_React$Component) {
	  _inherits(MessageHistoryDialog, _React$Component);
	
	  function MessageHistoryDialog() {
	    _classCallCheck(this, MessageHistoryDialog);
	
	    return _possibleConstructorReturn(this, (MessageHistoryDialog.__proto__ || Object.getPrototypeOf(MessageHistoryDialog)).apply(this, arguments));
	  }
	
	  _createClass(MessageHistoryDialog, [{
	    key: 'render',
	    value: function render() {
	      var titleText = 'Participants in this class can see all announcements 🎉';
	
	      var title = _react2.default.createElement(_TextWithEntities2.default, {
	        text: titleText,
	        entities: _TextEntities2.default.parseEmoji(titleText)
	      });
	
	      return _react2.default.createElement(_ConfirmDialog2.default, _extends({
	        eventScreenName: 'MessageHistoryDialog'
	      }, this.props, {
	        title: title,
	        subtext: 'People in your new class will be able to read every\n          announcement you send\u2014no matter when they join. Allow this for\n          all of your classes?',
	        actionButtonText: 'Allow',
	        cancelButtonText: 'Cancel'
	      }));
	    }
	  }]);
	
	  return MessageHistoryDialog;
	}(_react2.default.Component);
	
	MessageHistoryDialog.displayName = 'MessageHistoryDialog';
	exports.default = MessageHistoryDialog;

/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _Prompt = __webpack_require__(1049);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PromptActions = {
	  recordDismissal: function recordDismissal(name) {
	    var prompt = new _Prompt2.default({ action: name, response: 'dismissed' });
	    _Dispatcher.dispatcher.dispatch({
	      prompt: prompt,
	      type: _PromptConstants.ActionTypes.PROMPT_DISMISSED
	    });
	    return _Prompt2.default.savePrompt(prompt);
	  },
	  recordDismissExistingPrompt: function recordDismissExistingPrompt(prompt) {
	    if (!prompt) {
	      return;
	    }
	    prompt.set('response', 'dismissed');
	    _Prompt2.default.markDismissed(prompt);
	
	    _Dispatcher.dispatcher.dispatch({
	      prompt: prompt,
	      type: _PromptConstants.ActionTypes.EXISTING_PROMPT_DISMISSED
	    });
	  },
	  recordDismissPromptsInventoryPrompt: function recordDismissPromptsInventoryPrompt(prompt) {
	    if (!prompt) {
	      return;
	    }
	    prompt.set('response', 'dismissed');
	    _Prompt2.default.markDismissed(prompt);
	    _CurrentUser2.default.getUser().getPromptsInventory().remove(prompt);
	    _Dispatcher.dispatcher.dispatch({
	      type: _PromptConstants.ActionTypes.USER_PROMPT_DISMISSED
	    });
	  }
	};
	
	exports.default = PromptActions;

/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _Collection = __webpack_require__(599);
	
	var _Collection2 = _interopRequireDefault(_Collection);
	
	var _AuthConstants = __webpack_require__(1034);
	
	var _UserConstants = __webpack_require__(1015);
	
	var _PromptConstants = __webpack_require__(1045);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PromptStore = function (_Store) {
	  _inherits(PromptStore, _Store);
	
	  function PromptStore() {
	    _classCallCheck(this, PromptStore);
	
	    return _possibleConstructorReturn(this, (PromptStore.__proto__ || Object.getPrototypeOf(PromptStore)).apply(this, arguments));
	  }
	
	  _createClass(PromptStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        prompts: new _Collection2.default()
	      };
	    }
	  }, {
	    key: 'hasDismissed',
	    value: function hasDismissed(name) {
	      return !!this.state.prompts.find(function (prompt) {
	        return prompt.getAction() === name && prompt.getResponse() === 'dismissed';
	      });
	    }
	  }, {
	    key: 'hasDismissedWithin',
	    value: function hasDismissedWithin(name) {
	      var daysAgo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      return !!this.state.prompts.find(function (prompt) {
	        if (prompt.getAction() !== name || prompt.getResponse() !== 'dismissed') {
	          return false;
	        }
	
	        if (daysAgo > 0) {
	          return prompt.getRespondedAt() > Date.now() - daysAgo * 24 * 60 * 60 * 1000;
	        }
	
	        return true;
	      });
	    }
	  }, {
	    key: 'getAvailable',
	    value: function getAvailable(name) {
	      return this.state.prompts.find(function (prompt) {
	        return prompt.getAction() === name && prompt.getResponse() !== 'dismissed';
	      });
	    }
	  }, {
	    key: 'getPrompt',
	    value: function getPrompt(name) {
	      return this.state.prompts.find(function (prompt) {
	        return prompt.getAction() === name;
	      });
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      switch (action.type) {
	        case _AuthConstants.ActionTypes.AUTH_SUCCESS:
	        case _UserConstants.ActionTypes.LOAD_USER:
	          this.handleAuth(action.user);
	          break;
	        case _PromptConstants.ActionTypes.PROMPT_DISMISSED:
	          this.handleDismissed(action.prompt);
	          break;
	        case _PromptConstants.ActionTypes.EXISTING_PROMPT_DISMISSED:
	          // Just emit a change because the model is already in the store,
	          // and has been mutated.
	          this.emitChange();
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'handleAuth',
	    value: function handleAuth(user) {
	      this.state.prompts = user.getRecentPrompts() || new _Collection2.default();
	      this.emitChange();
	    }
	  }, {
	    key: 'handleDismissed',
	    value: function handleDismissed(prompt) {
	      this.state.prompts.add(prompt);
	      this.emitChange();
	    }
	  }]);
	
	  return PromptStore;
	}(_Store3.default);
	
	PromptStore.displayName = 'PromptStore';
	exports.default = new PromptStore();

/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _EmailForm = __webpack_require__(1403);
	
	var _EmailForm2 = _interopRequireDefault(_EmailForm);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SetUserEmailModal = function SetUserEmailModal(props) {
	  return _react2.default.createElement(
	    _Dialog2.default,
	    _extends({}, props, {
	      title: 'What is your email address?',
	      subtext: (props.message || 'We’ll email your message history to the address you enter.') + '\n      This will be your primary email address for Remind.',
	      size: 'small' }),
	    _react2.default.createElement(
	      _BoxBody2.default,
	      { divided: true },
	      _react2.default.createElement(_EmailForm2.default, {
	        onSave: props.closeOnSave ? (0, _createChainedFunction2.default)(props.onRequestHide, props.onSave) : props.onSave
	      })
	    )
	  );
	};
	
	SetUserEmailModal.defaultProps = {
	  onSave: function onSave() {},
	  closeOnSave: true
	};
	
	exports.default = SetUserEmailModal;

/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _modal = __webpack_require__(1188);
	
	var _EmailMergeConfirmation = __webpack_require__(1404);
	
	var _EmailMergeConfirmation2 = _interopRequireDefault(_EmailMergeConfirmation);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EVENT_SCREEN_NAME = 'sign_up_flow';
	
	var EmailForm = function (_React$Component) {
	  _inherits(EmailForm, _React$Component);
	
	  function EmailForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EmailForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmailForm.__proto__ || Object.getPrototypeOf(EmailForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      enabled: false,
	      enteredEmail: '',
	      errorMessage: ''
	    }, _this.submit = function (attrs) {
	      var onSuccess = function onSuccess() {
	        _ToastActions2.default.showSuccessToast('Saved!');
	        _this.props.onSave();
	      };
	
	      var onFailure = function onFailure(error) {
	        var errorMessage = void 0;
	        if (error.field_errors) {
	          errorMessage = error.field_errors.map(function (fieldError) {
	            return fieldError.messages.join(', ');
	          }).join(', ');
	        } else {
	          errorMessage = error.message;
	        }
	        _this.setState({ errorMessage: errorMessage, enteredEmail: attrs.email });
	        (0, _modal.mountModal)(_this.renderEmailMergeConfirmation(), _this);
	      };
	
	      _UserActions2.default.update(attrs).then(onSuccess, onFailure);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EmailForm, [{
	    key: 'logout',
	    value: function logout() {
	      _AuthActions2.default.signOut('/log_in');
	    }
	  }, {
	    key: 'renderEmailMergeConfirmation',
	    value: function renderEmailMergeConfirmation() {
	      return _react2.default.createElement(_EmailMergeConfirmation2.default, {
	        oldUserEmail: this.state.enteredEmail,
	        errorMessage: this.state.errorMessage,
	        onDone: this.logout,
	        eventScreenName: EVENT_SCREEN_NAME
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'EmailForm' },
	        _react2.default.createElement(
	          _Form2.default,
	          {
	            onValidSubmit: this.submit,
	            onValid: function onValid() {
	              return _this2.setState({ enabled: true });
	            },
	            onInvalid: function onInvalid() {
	              return _this2.setState({ enabled: false });
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'EmailForm-email' },
	            _react2.default.createElement(_FormInput2.default, {
	              label: 'Email address',
	              className: 'EmailForm-emailInput',
	              placeholder: 'name@email.com',
	              name: 'email',
	              validations: 'isEmail',
	              validationErrors: {
	                isEmail: 'Invalid email address.'
	              },
	              showErrorAfterBlur: true,
	              value: _CurrentUser2.default.getUser().getEmail() || ''
	            })
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              disabled: !this.state.enabled,
	              className: 'EmailForm-submit',
	              type: 'submit',
	              eventElementName: 'EmailForm-submit' },
	            'Done'
	          )
	        )
	      );
	    }
	  }]);
	
	  return EmailForm;
	}(_react2.default.Component);
	
	EmailForm.displayName = 'EmailForm';
	exports.default = EmailForm;

/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EmailMergeConfirmDialog = __webpack_require__(1405);
	
	var _EmailMergeConfirmDialog2 = _interopRequireDefault(_EmailMergeConfirmDialog);
	
	var _EmailMergeConfirmationCode = __webpack_require__(1406);
	
	var _EmailMergeConfirmationCode2 = _interopRequireDefault(_EmailMergeConfirmationCode);
	
	var _AlertDialog = __webpack_require__(1190);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var EmailMergeConfirmation = function (_React$Component) {
	  _inherits(EmailMergeConfirmation, _React$Component);
	
	  function EmailMergeConfirmation() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EmailMergeConfirmation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmailMergeConfirmation.__proto__ || Object.getPrototypeOf(EmailMergeConfirmation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      page: 'exists'
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EmailMergeConfirmation, [{
	    key: 'renderEmailMergeConfirmDialog',
	    value: function renderEmailMergeConfirmDialog(onNext) {
	      return _react2.default.createElement(_EmailMergeConfirmDialog2.default, {
	        message: this.props.errorMessage,
	        oldUserEmail: this.props.oldUserEmail,
	        onDone: onNext,
	        onRequestHide: this.props.onRequestHide,
	        eventScreenName: this.props.eventScreenName
	      });
	    }
	  }, {
	    key: 'renderEmailMergeConfirmationCode',
	    value: function renderEmailMergeConfirmationCode(onNext) {
	      return _react2.default.createElement(_EmailMergeConfirmationCode2.default, {
	        onDone: onNext,
	        eventScreenName: this.props.eventScreenName,
	        oldUserEmail: this.props.oldUserEmail,
	        onRequestHide: this.props.onRequestHide
	      });
	    }
	  }, {
	    key: 'renderSuccessfulMergeConfirmation',
	    value: function renderSuccessfulMergeConfirmation() {
	      return _react2.default.createElement(_AlertDialog2.default, {
	        eventScreenName: 'EmailMergeConfirmation',
	        title: 'Your accounts have been merged!',
	        onRequestHide: this.props.onRequestHide,
	        onOkay: this.props.onDone
	      });
	    }
	  }, {
	    key: 'getPage',
	    value: function getPage() {
	      var _this2 = this;
	
	      switch (this.state.page) {
	        case 'exists':
	          _EventTracking2.default.view(this.props.eventScreenName, { ui_element_name: 'EmailMergeConfirmDialog' });
	          return this.renderEmailMergeConfirmDialog(function () {
	            return _this2.setState({ page: 'confirmation_code' });
	          });
	
	        case 'confirmation_code':
	          return this.renderEmailMergeConfirmationCode(function () {
	            return _this2.setState({ page: 'success' });
	          });
	
	        case 'success':
	          _EventTracking2.default.view(this.props.eventScreenName, { ui_element_name: 'SuccessfulMerge' });
	          return this.renderSuccessfulMergeConfirmation();
	
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.getPage();
	    }
	  }]);
	
	  return EmailMergeConfirmation;
	}(_react2.default.Component);
	
	EmailMergeConfirmation.displayName = 'EmailMergeConfirmation';
	exports.default = EmailMergeConfirmation;

/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var EmailMergeConfirmDialog = function (_React$Component) {
	  _inherits(EmailMergeConfirmDialog, _React$Component);
	
	  function EmailMergeConfirmDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EmailMergeConfirmDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmailMergeConfirmDialog.__proto__ || Object.getPrototypeOf(EmailMergeConfirmDialog)).call.apply(_ref, [this].concat(args))), _this), _this.sendRequest = function () {
	      _EventTracking2.default.tap(_this.props.eventScreenName, 'EmailMergeConfirmDialogYesButton');
	      _DeviceActions2.default.createEmailMergeRequest(_this.props.oldUserEmail).then(function () {
	        _this.props.onDone();
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EmailMergeConfirmDialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'EmailMergeConfirmDialog',
	        title: this.props.message,
	        subtext: 'Would you like to merge these accounts?',
	        actionButtonText: 'Yes',
	        cancelButtonText: 'No',
	        onRequestHide: this.props.onRequestHide,
	        onConfirm: this.sendRequest,
	        staticModal: false
	      });
	    }
	  }]);
	
	  return EmailMergeConfirmDialog;
	}(_react2.default.Component);
	
	EmailMergeConfirmDialog.displayName = 'EmailMergeConfirmDialog';
	exports.default = EmailMergeConfirmDialog;

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var CODE_LENGTH = 4;
	
	var EmailMergeConfirmationCode = function (_React$Component) {
	  _inherits(EmailMergeConfirmationCode, _React$Component);
	
	  function EmailMergeConfirmationCode() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EmailMergeConfirmationCode);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmailMergeConfirmationCode.__proto__ || Object.getPrototypeOf(EmailMergeConfirmationCode)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      code: ''
	    }, _this.onCodeChange = function (event) {
	      // $FlowFixMe
	      if (event.currentTarget.value.length === CODE_LENGTH) {
	        _this.setState({ code: event.currentTarget.value });
	      }
	    }, _this.confirm = function () {
	      var onFailure = function onFailure(error) {
	        _ToastActions2.default.showAPIError(error);
	        _this.props.onRequestHide();
	      };
	
	      _EventTracking2.default.tap(_this.props.eventScreenName, 'EmailMergeConfirmationCodeSubmit');
	      _DeviceActions2.default.emailMergeRequest(_this.state.code, _this.props.oldUserEmail).then(_this.props.onDone, onFailure);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EmailMergeConfirmationCode, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ConfirmDialog2.default,
	        {
	          eventScreenName: 'EmailMergeConfirmationCode',
	          onConfirm: this.confirm,
	          staticModal: false,
	          onRequestHide: this.props.onRequestHide,
	          size: 'medium',
	          actionButtonText: 'Submit',
	          cancelButtonText: 'Cancel',
	          title: 'Enter your ' + CODE_LENGTH + '-digit confirmation code',
	          subtext: 'Check your email for the code \u2014 it was sent to ' + this.props.oldUserEmail },
	        _react2.default.createElement(_Input2.default, {
	          red: 'code',
	          autofocus: true,
	          placeholder: '0000',
	          maxLength: CODE_LENGTH,
	          size: 'small',
	          onChange: this.onCodeChange
	        })
	      );
	    }
	  }]);
	
	  return EmailMergeConfirmationCode;
	}(_react2.default.Component);
	
	EmailMergeConfirmationCode.displayName = 'EmailMergeConfirmationCode';
	exports.default = EmailMergeConfirmationCode;

/***/ },
/* 1407 */
1136,
/* 1408 */,
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _InlineBlock = __webpack_require__(1410);
	
	var _InlineBlock2 = _interopRequireDefault(_InlineBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InlineBlock = function (_React$Component) {
	  _inherits(InlineBlock, _React$Component);
	
	  function InlineBlock() {
	    _classCallCheck(this, InlineBlock);
	
	    return _possibleConstructorReturn(this, (InlineBlock.__proto__ || Object.getPrototypeOf(InlineBlock)).apply(this, arguments));
	  }
	
	  _createClass(InlineBlock, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          height = _props.height,
	          children = _props.children;
	
	      if (height !== null) {
	        return _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)(_InlineBlock2.default.this, (0, _getPropClasses.getPropClassesFromInstance)(this, ['fullWidth']), className) },
	          _react2.default.createElement('div', {
	            className: (0, _classnames2.default)(_InlineBlock2.default.this, (0, _getPropClasses.getPropClassesFromInstance)(this, ['alignv'])),
	            style: { height: height }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_InlineBlock2.default.this, (0, _getPropClasses.getPropClassesFromInstance)(this)) },
	            children
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_InlineBlock2.default.this, (0, _getPropClasses.getPropClassesFromInstance)(this), className) },
	          children
	        );
	      }
	    }
	  }]);
	
	  return InlineBlock;
	}(_react2.default.Component);
	
	InlineBlock.propClasses = {
	  alignv: {
	    top: _InlineBlock2.default.alignTop,
	    middle: _InlineBlock2.default.alignMiddle,
	    bottom: _InlineBlock2.default.alignBottom
	  },
	  fullWidth: _InlineBlock2.default.fullWidth
	};
	InlineBlock.defaultProps = {
	  alignv: 'baseline',
	  fullWidth: false,
	  height: null
	};
	InlineBlock.displayName = 'InlineBlock';
	exports.default = InlineBlock;

/***/ },
/* 1410 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"this":"InlineBlock__this___3VR2L","fullWidth":"InlineBlock__fullWidth___1EPX6","fullHeight":"InlineBlock__fullHeight___2i0Ft","alignTop":"InlineBlock__alignTop___3SxI4","alignMiddle":"InlineBlock__alignMiddle___3YqpH","alignBottom":"InlineBlock__alignBottom___29Hr3"};

/***/ },
/* 1411 */,
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(1241);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _lodash = __webpack_require__(555);
	
	var _DOM = __webpack_require__(1109);
	
	var _DOM2 = _interopRequireDefault(_DOM);
	
	__webpack_require__(1413);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// typecheck: ignore file
	var ScrollableArea = _react2.default.createClass({
	  displayName: 'ScrollableArea',
	
	
	  childContextTypes: {
	    scrollableArea: _react2.default.PropTypes.object
	  }
	  // $FlowIssue
	  , getDefaultProps: function getDefaultProps() {
	    return {
	      scrollToBottom: false,
	      showShadows: false,
	      useBodyChildrenHeight: false,
	      alignBottom: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      scrollHeight: 0,
	      scrollBottom: 0,
	      scrollTop: 0,
	      scrolledToBottom: this.props.scrollToBottom,
	      scrolledToTop: !this.props.scrollToBottom
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      scrollableArea: this
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.handleScroll = (0, _lodash.throttle)(this.handleScroll, 100);
	    if (this.props.scrollToBottom) {
	      this.scrollToBottom();
	    }
	    this.updateHeight();
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	  },
	  componentWillUpdate: function componentWillUpdate() {
	    var body = this.refs.body;
	
	    this.prevScrolledHeight = body.scrollHeight;
	    this.prevScrollTop = body.scrollTop;
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (this.props.scrollToBottom) {
	      if (this.state.scrolledToBottom) {
	        this.scrollToBottom();
	      } else if (this.props.children !== prevProps.children) {
	        var body = this.refs.body;
	
	        body.scrollTop = this.prevScrollTop + (body.scrollHeight - this.prevScrolledHeight);
	      }
	    }
	
	    if (this.props.children !== prevProps.children || this.props.style && prevProps.style && this.props.style.height !== prevProps.style.height) {
	      this.updateHeight();
	    }
	  },
	
	
	  prevScrollTop: 0,
	  prevScrolledHeight: 0,
	
	  // TODO: Look into why body is using absolute positioning to replace this workaround
	  getScrollHeight: function getScrollHeight() {
	    var body = this.refs.body;
	
	
	    var scrollHeight = void 0;
	    if (this.props.useBodyChildrenHeight) {
	      var children = Array.prototype.slice.call(body.children);
	      scrollHeight = children.map(function (child) {
	        return child.scrollHeight;
	      }).reduce(function (prev, curr) {
	        return prev + curr;
	      }, 0);
	    } else {
	      scrollHeight = body.scrollHeight;
	    }
	
	    // Account for the parents border (assumes equal border width on all sides)
	    var parentBorderWidth = _DOM2.default.getStyle(body.parentNode, 'border-width');
	    if (parentBorderWidth) {
	      scrollHeight += 2 * parseInt(parentBorderWidth, 10);
	    }
	
	    return scrollHeight;
	  },
	  handleScroll: function handleScroll() {
	    if (this.refs.body) {
	      this.updateScrollPositions(this.props.onScroll);
	    }
	  },
	  handleWheel: function handleWheel(event) {
	    if (!this.isMounted()) {
	      return;
	    }
	
	    if (event.deltaX && !event.deltaY) {
	      return;
	    }
	
	    // This prevents mousewheel events on ScrollableArea instances from transferring to mousewheel
	    // on the document's main scroll area.
	    var delta = -event.deltaY;
	    var node = this.refs.body;
	    if (!node) {
	      return;
	    }
	    var scrollHeight = node.scrollHeight;
	    var clientHeight = node.clientHeight;
	    if (scrollHeight > clientHeight) {
	      var scrollTop = node.scrollTop;
	      if (delta > 0 && scrollTop === 0 || delta < 0 && scrollTop >= scrollHeight - clientHeight - 1) {
	        event.preventDefault();
	      }
	    }
	  },
	  isScrolledToBottom: function isScrolledToBottom() {
	    var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    return this.state.scrollBottom + offset >= 0;
	  },
	  isScrolledToTop: function isScrolledToTop() {
	    var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    return this.state.scrollTop - offset <= 0;
	  },
	  scrollIntoView: function scrollIntoView(node) {
	    var body = this.refs.body;
	
	    var position = _DOM2.default.getPosition(node, body);
	    if (position.top < 0) {
	      body.scrollTop += position.top;
	    } else if (position.top + node.offsetHeight > body.offsetHeight) {
	      body.scrollTop += position.top + node.offsetHeight - body.offsetHeight;
	    }
	  },
	  scrollIntoViewCenter: function scrollIntoViewCenter(node) {
	    var body = this.refs.body;
	
	    var position = _DOM2.default.getPosition(node, body);
	    body.scrollTop += position.top - (body.offsetHeight - node.offsetHeight) / 2;
	  },
	  scrollToBottom: function scrollToBottom() {
	    var body = this.refs.body;
	
	    body.scrollTop = body.scrollHeight;
	  },
	  scrollToTop: function scrollToTop() {
	    var body = this.refs.body;
	
	    body.scrollTop = 0;
	  },
	  updateHeight: function updateHeight() {
	    var _this = this;
	
	    this.setState({
	      scrollHeight: this.getScrollHeight()
	    }, function () {
	      // If the component is re-rendered before this is called, the refs become undefined.
	      if (_this.refs.body) {
	        _this.updateScrollPositions();
	      }
	    });
	  },
	  updateScrollPositions: function updateScrollPositions(callback) {
	    var body = this.refs.body;
	
	    var scrollTop = body.scrollTop;
	    var scrollBottom = scrollTop + body.offsetHeight - body.scrollHeight;
	    this.setState({
	      scrollTop: scrollTop,
	      scrollBottom: scrollBottom,
	      scrolledToBottom: scrollBottom === 0,
	      scrolledToTop: scrollTop === 0
	    }, callback || undefined);
	  },
	  render: function render() {
	    var _props = this.props,
	        alignBottom = _props.alignBottom,
	        className = _props.className,
	        style = _props.style,
	        showShadows = _props.showShadows,
	        children = _props.children;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)({
	          ScrollableArea: true,
	          'ScrollableArea-hasContentAbove': showShadows && !this.state.scrolledToTop,
	          'ScrollableArea-hasContentBelow': showShadows && !this.state.scrolledToBottom
	        }, className),
	        style: Object.assign({ height: this.state.scrollHeight }, style) },
	      _react2.default.createElement(
	        'div',
	        {
	          ref: 'body',
	          className: (0, _classnames2.default)({
	            'ScrollableArea-body': true,
	            'ScrollableArea-body-bottom': alignBottom
	          }),
	          onScroll: this.handleScroll,
	          onWheel: this.handleWheel },
	        children
	      )
	    );
	  }
	});
	
	exports.default = ScrollableArea;

/***/ },
/* 1413 */
1136,
/* 1414 */,
/* 1415 */
1136,
/* 1416 */,
/* 1417 */
1136,
/* 1418 */,
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	__webpack_require__(1423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Fieldset = function (_React$Component) {
	  _inherits(Fieldset, _React$Component);
	
	  function Fieldset() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Fieldset);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Fieldset.__proto__ || Object.getPrototypeOf(Fieldset)).call.apply(_ref, [this].concat(args))), _this), _this.renderLegend = function () {
	      var legend = _this.props.legend;
	
	      if (!legend) {
	        return null;
	      }
	      return _react2.default.createElement(_Legend2.default, { text: legend });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Fieldset, [{
	    key: 'render',
	    value: function render() {
	      var legend = this.renderLegend();
	
	      // renders `div` instead of `fieldset` to not require `form` wrapper
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=570095#c22
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('Fieldset', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className) },
	        legend,
	        this.props.children
	      );
	    }
	  }]);
	
	  return Fieldset;
	}(_react2.default.Component);
	
	Fieldset.propClasses = {
	  size: {
	    small: 'Fieldset-small'
	  }
	};
	Fieldset.displayName = 'Fieldset';
	exports.default = Fieldset;

/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1421);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Legend = function (_React$Component) {
	  _inherits(Legend, _React$Component);
	
	  function Legend() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Legend);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Legend.__proto__ || Object.getPrototypeOf(Legend)).call.apply(_ref, [this].concat(args))), _this), _this.renderText = function () {
	      var text = _this.props.text;
	
	      if (!text) {
	        return null;
	      }
	      return text;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Legend, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'legend',
	        {
	          className: (0, _classnames2.default)('Legend', this.props.className) },
	        this.renderText(),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Legend;
	}(_react2.default.Component);
	
	Legend.displayName = 'Legend';
	exports.default = Legend;

/***/ },
/* 1421 */
1136,
/* 1422 */,
/* 1423 */
1136,
/* 1424 */,
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RelationshipViewGroupListItem = __webpack_require__(1426);
	
	var _RelationshipViewGroupListItem2 = _interopRequireDefault(_RelationshipViewGroupListItem);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _Subscription = __webpack_require__(1008);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RelationshipViewGroupList = function (_React$Component) {
	  _inherits(RelationshipViewGroupList, _React$Component);
	
	  function RelationshipViewGroupList() {
	    _classCallCheck(this, RelationshipViewGroupList);
	
	    return _possibleConstructorReturn(this, (RelationshipViewGroupList.__proto__ || Object.getPrototypeOf(RelationshipViewGroupList)).apply(this, arguments));
	  }
	
	  _createClass(RelationshipViewGroupList, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _Fieldset2.default,
	        { legend: this.props.legend, size: 'small' },
	        this.props.groupSubscriptions.map(function (_ref) {
	          var group = _ref.group,
	              subscription = _ref.subscription;
	          return _react2.default.createElement(_RelationshipViewGroupListItem2.default, {
	            key: group.id,
	            group: group,
	            subscriber: _this2.context.subscriber,
	            subscription: subscription
	          });
	        }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return RelationshipViewGroupList;
	}(_react2.default.Component);
	
	RelationshipViewGroupList.contextTypes = {
	  subscriber: _react2.default.PropTypes.instanceOf(_Subscriber2.default).isRequired
	};
	RelationshipViewGroupList.displayName = 'RelationshipViewGroupList';
	exports.default = RelationshipViewGroupList;

/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _ErrorActions = __webpack_require__(1427);
	
	var _ErrorActions2 = _interopRequireDefault(_ErrorActions);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _GroupLink = __webpack_require__(1430);
	
	var _GroupLink2 = _interopRequireDefault(_GroupLink);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _Subscription = __webpack_require__(1008);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Time = __webpack_require__(1563);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _modal = __webpack_require__(1188);
	
	__webpack_require__(1564);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var RelationshipViewGroupItem = function (_React$Component) {
	  _inherits(RelationshipViewGroupItem, _React$Component);
	
	  function RelationshipViewGroupItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RelationshipViewGroupItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelationshipViewGroupItem.__proto__ || Object.getPrototypeOf(RelationshipViewGroupItem)).call.apply(_ref, [this].concat(args))), _this), _this.actionButtonText = function () {
	      if (_this.isActionRemove()) {
	        return 'Remove';
	      } else if (_this.isActionLeave()) {
	        return 'Leave';
	      } else {
	        return null;
	      }
	    }, _this.confirmRemoveFromGroup = function (action) {
	      var _this$props = _this.props,
	          group = _this$props.group,
	          subscriber = _this$props.subscriber;
	
	      var groupName = group.getName();
	      var isActionRemove = action === 'Remove';
	
	      var confirmAction = isActionRemove ? function () {
	        return _GroupActions2.default.removeMember(group, subscriber).then(function () {
	          _ToastActions2.default.showSuccessToast(subscriber.getName() + ' has been removed from ' + groupName);
	        }, _ToastActions2.default.showDefaultErrorToast);
	      } : function () {
	        return _GroupActions2.default.unsubscribeFromGroup(group).then(function () {
	          _ToastActions2.default.showSuccessToast('You have left ' + groupName);
	        }, _ToastActions2.default.showDefaultErrorToast);
	      };
	
	      var confirmTitle = isActionRemove ? 'Are you sure you want to remove ' + subscriber.getName() + ' from ' + groupName + '?' : 'Leave this class?';
	
	      var conditionalProps = {};
	      if (!isActionRemove) {
	        conditionalProps.cancelButtonText = 'Cancel';
	        conditionalProps.subtext = 'Once you leave, you will no longer receive messages from ' + groupName;
	      }
	
	      var dialog = _react2.default.createElement(_ConfirmDialog2.default, _extends({
	        eventScreenName: 'RelationshipViewGroupItem'
	      }, conditionalProps, {
	        title: confirmTitle,
	        actionButtonText: action,
	        onConfirm: confirmAction
	      }));
	
	      (0, _modal.mountModal)(dialog, _this);
	    }, _this.isActionLeave = function () {
	      return !_this.isActionRemove() && _this.props.group.canLeave();
	    }, _this.isActionRemove = function () {
	      var _this$props2 = _this.props,
	          group = _this$props2.group,
	          subscriber = _this$props2.subscriber;
	
	
	      if (group.isStaffClass()) {
	        return false;
	      }
	
	      var user = _CurrentUser2.default.getUser();
	      var isOwnedBySubscriber = group.isOwnedByUser(subscriber.id);
	      var isOwnedByCurrentUser = group.isOwnedByUser(user.id);
	
	      return isOwnedByCurrentUser && !isOwnedBySubscriber;
	    }, _this.joinGroup = function () {
	      var onSuccess = function onSuccess() {
	        return _ToastActions2.default.showSuccessToast('Class joined');
	      };
	      var onError = function onError(error) {
	        return _ErrorActions2.default.serverError(error);
	      };
	      _GroupActions2.default.subscribeToGroup(_this.props.group).then(onSuccess, onError);
	    }, _this.renderActionButton = function () {
	      var subscription = _this.props.subscription;
	
	
	      var sharedProps = { level: 'secondary', size: 'xsmall' };
	
	      if (subscription) {
	        var _ret2 = function () {
	          var actionText = _this.actionButtonText();
	          return {
	            v: actionText && _react2.default.createElement(
	              _Button2.default,
	              _extends({}, sharedProps, {
	                color: 'lava',
	                onClick: function onClick() {
	                  return _this.confirmRemoveFromGroup(actionText);
	                } }),
	              actionText
	            )
	          };
	        }();
	
	        if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	      } else {
	        return _react2.default.createElement(
	          _Button2.default,
	          _extends({}, sharedProps, {
	            color: 'brand',
	            onClick: _this.joinGroup }),
	          'Join'
	        );
	      }
	    }, _this.renderAvatar = function () {
	      return _react2.default.createElement(_GroupAvatar2.default, {
	        className: 'RelationshipViewGroupListItem-avatar',
	        group: _this.props.group
	      });
	    }, _this.renderGroupName = function () {
	      var group = _this.props.group;
	
	
	      var text = _react2.default.createElement(
	        _Text2.default,
	        { size: 'xsmall', weight: 'bold', truncate: true },
	        _react2.default.createElement(_GroupName2.default, { group: group })
	      );
	
	      if (_this.props.subscription) {
	        return _react2.default.createElement(
	          _GroupLink2.default,
	          { className: 'RelationshipViewGroupListItem-name', group: group },
	          text
	        );
	      } else {
	        // can't nav to a group you aren't a member of
	        return text;
	      }
	    }, _this.renderSubText = function () {
	      var _this$props3 = _this.props,
	          subscription = _this$props3.subscription,
	          subscriber = _this$props3.subscriber,
	          group = _this$props3.group;
	
	      var user = _CurrentUser2.default.getUser();
	
	      var coOwned = group.isOwnedByUser(user.id) && group.isOwnedByUser(subscriber.id);
	
	      var subText = void 0;
	      if (coOwned) {
	        subText = 'Also owned by you';
	      } else if (subscription) {
	        subText = _react2.default.createElement(
	          'span',
	          null,
	          'Joined\xA0',
	          _react2.default.createElement(_Time2.default, {
	            date: subscription.getSubscribedAt(),
	            month: 'numeric',
	            day: 'numeric',
	            year: 'numeric'
	          })
	        );
	      } else {
	        subText = '@' + group.getCode();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'RelationshipViewGroupListItem-subText' },
	        subText
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RelationshipViewGroupItem, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _FlexibleBlock2.default,
	        { className: 'RelationshipViewGroupListItem', flex: 'left' },
	        _react2.default.createElement(
	          _FlexibleBlock2.default,
	          { flex: 'right' },
	          this.renderAvatar(),
	          _react2.default.createElement(
	            'div',
	            { className: 'RelationshipViewGroupListItem-info' },
	            this.renderGroupName(),
	            this.renderSubText()
	          )
	        ),
	        this.renderActionButton()
	      );
	    }
	  }]);
	
	  return RelationshipViewGroupItem;
	}(_react2.default.Component);
	
	RelationshipViewGroupItem.displayName = 'RelationshipViewGroupItem';
	exports.default = RelationshipViewGroupItem;

/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dispatcher = __webpack_require__(590);
	
	var _ErrorConstants = __webpack_require__(1428);
	
	var ErrorActions = {
	  expiredToken: function expiredToken(context) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _ErrorConstants.ErrorTypes.EXPIRED_TOKEN,
	      context: context
	    });
	  },
	  unknownToken: function unknownToken(context) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _ErrorConstants.ErrorTypes.UNKNOWN_TOKEN,
	      context: context
	    });
	  },
	  serverError: function serverError(error) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _ErrorConstants.ErrorTypes.SERVER_ERROR,
	      error: error
	    });
	  }
	};
	
	exports.default = ErrorActions;

/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ErrorMessages = exports.ErrorTypes = undefined;
	
	var _ErrorMessages;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MailTo = __webpack_require__(1429);
	
	var _MailTo2 = _interopRequireDefault(_MailTo);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*  weak */
	
	
	var ErrorTypes = exports.ErrorTypes = (0, _enumerate2.default)(['EXPIRED_TOKEN', 'UNKNOWN_TOKEN', 'FORM_ERROR', 'SERVER_ERROR']);
	
	var ErrorMessages = exports.ErrorMessages = (_ErrorMessages = {}, _defineProperty(_ErrorMessages, ErrorTypes.EXPIRED_TOKEN, {
	  DEFAULT: {
	    title: _react2.default.createElement(
	      'span',
	      null,
	      'This link has expired.'
	    ),
	    body: _react2.default.createElement(
	      'span',
	      null,
	      'Sorry! Try using a link from a more recent email.'
	    )
	  },
	
	  REPORT_CHAT: {
	    title: _react2.default.createElement(
	      'span',
	      null,
	      'Oops, the link to report this Chat has expired.'
	    ),
	    body: _react2.default.createElement(
	      'span',
	      null,
	      'Please use the report link on a Chat received less than 24 hours ago or email ',
	      _react2.default.createElement(_MailTo2.default, { to: _LinkConstants2.default.REPORT_EMAIL }),
	      '.'
	    )
	  },
	
	  EMAIL_UNSUBSCRIBE: {
	    title: _react2.default.createElement(
	      'span',
	      null,
	      'This link has expired.'
	    ),
	    body: _react2.default.createElement(
	      'span',
	      null,
	      'Sorry! Try unsubscribing from a more recent email.'
	    )
	  }
	}), _defineProperty(_ErrorMessages, ErrorTypes.UNKNOWN_TOKEN, {
	  DEFAULT: {
	    title: _react2.default.createElement(
	      'span',
	      null,
	      'Oops, something went wrong!'
	    ),
	    body: _react2.default.createElement(
	      'span',
	      null,
	      'We don’t recognize this link.'
	    )
	  },
	
	  REPORT_CHAT: {
	    title: _react2.default.createElement(
	      'span',
	      null,
	      'Oops, something went wrong!'
	    ),
	    body: _react2.default.createElement(
	      'span',
	      null,
	      'We don’t recognize this link, please email ',
	      _react2.default.createElement(_MailTo2.default, { to: _LinkConstants2.default.REPORT_EMAIL }),
	      ' if you’d like to report a Chat.'
	    )
	  }
	}), _ErrorMessages);

/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var MailTo = function (_React$Component) {
	  _inherits(MailTo, _React$Component);
	
	  function MailTo() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MailTo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MailTo.__proto__ || Object.getPrototypeOf(MailTo)).call.apply(_ref, [this].concat(args))), _this), _this.getMailProps = function () {
	      var props = [];
	      var otherProps = ['subject', 'body', 'cc', 'bcc'];
	
	      for (var p in _this.props) {
	        if (otherProps.indexOf(p) > -1 && _this.props[p]) {
	          props.push(p + '=' + _this.getProp(p));
	        }
	      }
	
	      props = props.join('&');
	      return props;
	    }, _this.getMailToLink = function () {
	      return 'mailto:' + _this.getTo() + '?' + _this.getMailProps();
	    }, _this.getProp = function (prop) {
	      return encodeURIComponent(_this.props[prop]);
	    }, _this.getTo = function () {
	      return _this.props.to || '';
	    }, _this.renderBody = function () {
	      var body = void 0;
	
	      if (_this.props.children) {
	        body = _this.props.children;
	      } else {
	        body = _this.getTo();
	      }
	
	      return body;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MailTo, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          to = _props.to,
	          other = _objectWithoutProperties(_props, ['to']); // eslint-disable-line no-unused-vars
	
	      var mailto = _react2.default.createElement(
	        _Link2.default,
	        _extends({}, other, {
	          className: (0, _classnames2.default)('MailTo', this.props.className),
	          href: this.getMailToLink(),
	          target: '_blank' }),
	        this.renderBody()
	      );
	
	      return mailto;
	    }
	  }]);
	
	  return MailTo;
	}(_react2.default.Component);
	
	MailTo.defaultProps = {
	  to: '',
	  subject: '',
	  body: '',
	  cc: '',
	  bcc: ''
	};
	MailTo.displayName = 'MailTo';
	exports.default = MailTo;

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupHovercard = __webpack_require__(1431);
	
	var _GroupHovercard2 = _interopRequireDefault(_GroupHovercard);
	
	var _HoverLayerTrigger = __webpack_require__(1562);
	
	var _HoverLayerTrigger2 = _interopRequireDefault(_HoverLayerTrigger);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupLink = function (_React$Component) {
	  _inherits(GroupLink, _React$Component);
	
	  function GroupLink() {
	    _classCallCheck(this, GroupLink);
	
	    return _possibleConstructorReturn(this, (GroupLink.__proto__ || Object.getPrototypeOf(GroupLink)).apply(this, arguments));
	  }
	
	  _createClass(GroupLink, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          group = _props.group,
	          children = _props.children,
	          placement = _props.placement,
	          alignment = _props.alignment,
	          other = _objectWithoutProperties(_props, ['group', 'children', 'placement', 'alignment']);
	
	      return _react2.default.createElement(
	        _HoverLayerTrigger2.default,
	        {
	          layer: _react2.default.createElement(_GroupHovercard2.default, { group: group }),
	          placement: placement,
	          alignment: alignment,
	          delayShow: 200 },
	        _react2.default.createElement(
	          _Link2.default,
	          _extends({
	            to: group.webUrl(),
	            activeClassName: 'active'
	          }, other),
	          children || group.getName()
	        )
	      );
	    }
	  }]);
	
	  return GroupLink;
	}(_react2.default.Component);
	
	GroupLink.defaultProps = {
	  placement: 'right',
	  alignment: 'middle'
	};
	GroupLink.displayName = 'GroupLink';
	exports.default = GroupLink;

/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _groupDisplay = __webpack_require__(1322);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ButtonGroup = __webpack_require__(1432);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _utils = __webpack_require__(956);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _GroupInviteModal = __webpack_require__(1435);
	
	var _GroupInviteModal2 = _interopRequireDefault(_GroupInviteModal);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _Hovercard = __webpack_require__(1548);
	
	var _Hovercard2 = _interopRequireDefault(_Hovercard);
	
	var _HovercardBody = __webpack_require__(1554);
	
	var _HovercardBody2 = _interopRequireDefault(_HovercardBody);
	
	var _HovercardFooter = __webpack_require__(1557);
	
	var _HovercardFooter2 = _interopRequireDefault(_HovercardFooter);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Messages = __webpack_require__(1229);
	
	var _Messages2 = _interopRequireDefault(_Messages);
	
	var _MessageActions = __webpack_require__(1228);
	
	var _MessageActions2 = _interopRequireDefault(_MessageActions);
	
	var _MessageStore = __webpack_require__(1232);
	
	var _MessageStore2 = _interopRequireDefault(_MessageStore);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _PDFDownload = __webpack_require__(1487);
	
	var _PDFDownload2 = _interopRequireDefault(_PDFDownload);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(1560);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupHovercard = function (_React$Component) {
	  _inherits(GroupHovercard, _React$Component);
	
	  function GroupHovercard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupHovercard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupHovercard.__proto__ || Object.getPrototypeOf(GroupHovercard)).call.apply(_ref, [this].concat(args))), _this), _this.getGroupLink = function (group) {
	      return '/classes/' + group.getCode();
	    }, _this.goToPeopleTab = function () {
	      var group = _this.props.group;
	
	      _this.context.router.push('/classes/' + group.getCode() + '/people/');
	    }, _this.renderInviteButton = function () {
	      var group = _this.props.group;
	
	      if (!group.canAddPeople()) {
	        return null;
	      }
	
	      var addPeopleButton = _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: _react2.default.createElement(_GroupInviteModal2.default, { group: group }) },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'GroupHovercard-addButton',
	            eventElementName: 'GroupHovercard-addButton' },
	          'Add people'
	        )
	      );
	
	      return _react2.default.createElement(
	        _ButtonGroup2.default,
	        {
	          className: 'GroupHovercard-inviteButton',
	          level: 'primary',
	          color: 'brand',
	          size: 'small' },
	        addPeopleButton,
	        _react2.default.createElement(
	          _PDFDownload2.default,
	          {
	            type: 'button',
	            group: group,
	            tooltip: 'Download PDF instructions',
	            tooltipPlacement: 'bottom',
	            tooltipAlignment: 'right' },
	          _react2.default.createElement(_Glyph2.default, { name: 'download', solo: true })
	        )
	      );
	    }, _this.renderScheduledAnnouncements = function () {
	      var group = _this.props.group;
	
	
	      var count = _this.state.messagesScheduled.length;
	      if (count === 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _HovercardFooter2.default,
	        null,
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            to: _this.getGroupLink(group),
	            query: { openScheduledMessages: true } },
	          _react2.default.createElement(_Glyph2.default, { name: 'schedule' }),
	          _react2.default.createElement(
	            _Text2.default,
	            { weight: 'semibold' },
	            count === 1 ? count + ' scheduled announcement' : count + ' scheduled announcements'
	          )
	        )
	      );
	    }, _this.renderSubscriberCount = function () {
	      var group = _this.props.group;
	
	      var count = group.getMembershipsCount();
	      var subscribersCount = (0, _groupDisplay.membershipDescriptionFor)(group);
	
	      if (count > 0) {
	        return _react2.default.createElement(
	          _Link2.default,
	          {
	            to: '/classes/' + group.getCode() + '/people',
	            color: 'thunder' },
	          subscribersCount
	        );
	      }
	      return subscribersCount;
	    }, _this.renderSubtext = function () {
	      var group = _this.props.group;
	
	      var groupCodeOpt = '@' + group.getCode() + ' \u2022 ';
	      return _react2.default.createElement(
	        _Text2.default,
	        { className: 'GroupHovercard-subtext', color: 'thunder' },
	        groupCodeOpt,
	        group.isOwnedByUser(_CurrentUser2.default.getUserId()) && _this.renderSubscriberCount()
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupHovercard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var group = this.props.group;
	
	
	      if (group.isOwnedByUser(_CurrentUser2.default.getUserId())) {
	        var _messagesScheduled = _MessageStore2.default.getMessagesScheduled(group.id);
	        if (_messagesScheduled.isEmpty()) {
	          _MessageActions2.default.loadScheduledMessages(group.id);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var group = this.props.group;
	
	
	      return _react2.default.createElement(
	        _Hovercard2.default,
	        _extends({}, this.props, {
	          className: 'GroupHovercard' }),
	        _react2.default.createElement(
	          _HovercardBody2.default,
	          null,
	          _react2.default.createElement(
	            _Link2.default,
	            { to: this.getGroupLink(group), color: 'pitch' },
	            _react2.default.createElement(_GroupAvatar2.default, { className: 'GroupHovercard-avatar', group: group }),
	            _react2.default.createElement(
	              'h6',
	              { className: 'GroupHovercard-name' },
	              _react2.default.createElement(
	                _Text2.default,
	                { truncate: true },
	                _react2.default.createElement(_GroupName2.default, { group: group })
	              )
	            )
	          ),
	          group.isRoot() || this.renderSubtext(),
	          this.renderInviteButton()
	        ),
	        this.renderScheduledAnnouncements()
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_MessageStore2.default];
	    }
	  }]);
	
	  return GroupHovercard;
	}(_react2.default.Component);
	
	GroupHovercard.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	GroupHovercard.calculateState = function (prevState, props) {
	  var group = props.group;
	
	  return {
	    messagesScheduled: _MessageStore2.default.getMessagesScheduled(group.id)
	  };
	};
	
	GroupHovercard.displayName = 'GroupHovercard';
	exports.default = _utils.Container.create(GroupHovercard, { withProps: true });

/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1433);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A component to display a group a buttons side-by-side.
	 *
	 * ```example
	 *  <ButtonGroup level="primary">
	 *    <Button>Fee</Button>
	 *    <Button>Fi</Button>
	 *    <Button>Fo</Button>
	 *    <Button color="lava">Fum</Button>
	 *  </ButtonGroup>
	 * ```
	 */
	var ButtonGroup = function (_React$Component) {
	  _inherits(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    _classCallCheck(this, ButtonGroup);
	
	    return _possibleConstructorReturn(this, (ButtonGroup.__proto__ || Object.getPrototypeOf(ButtonGroup)).apply(this, arguments));
	  }
	
	  _createClass(ButtonGroup, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          level = _props.level,
	          color = _props.color,
	          size = _props.size,
	          others = _objectWithoutProperties(_props, ['level', 'color', 'size']);
	
	      var children = _react2.default.Children.map(this.props.children, function (button) {
	        return _react2.default.cloneElement(button, {
	          level: button.props.level || level,
	          color: button.props.color || color,
	          size: button.props.size || size
	        });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, others, { className: (0, _classnames2.default)('ButtonGroup', this.props.className) }),
	        children
	      );
	    }
	  }]);
	
	  return ButtonGroup;
	}(_react2.default.Component);
	
	ButtonGroup.displayName = 'ButtonGroup';
	exports.default = ButtonGroup;

/***/ },
/* 1433 */
1136,
/* 1434 */,
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _Heading = __webpack_require__(1436);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _InviteInClassInstructionsTab = __webpack_require__(1439);
	
	var _InviteInClassInstructionsTab2 = _interopRequireDefault(_InviteInClassInstructionsTab);
	
	var _InviteManualAddTab = __webpack_require__(1450);
	
	var _InviteManualAddTab2 = _interopRequireDefault(_InviteManualAddTab);
	
	var _InvitePDFTab = __webpack_require__(1485);
	
	var _InvitePDFTab2 = _interopRequireDefault(_InvitePDFTab);
	
	var _InviteShareLinkTab = __webpack_require__(1491);
	
	var _InviteShareLinkTab2 = _interopRequireDefault(_InviteShareLinkTab);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TeacherAddUploadTab = __webpack_require__(1500);
	
	var _TeacherAddUploadTab2 = _interopRequireDefault(_TeacherAddUploadTab);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _LeftTabModal = __webpack_require__(1531);
	
	var _LeftTabModal2 = _interopRequireDefault(_LeftTabModal);
	
	var _LeftTabModalTitle = __webpack_require__(1544);
	
	var _LeftTabModalTitle2 = _interopRequireDefault(_LeftTabModalTitle);
	
	var _modal = __webpack_require__(1188);
	
	var _shouldEnableCsvUploadForGroup = __webpack_require__(1545);
	
	var _shouldEnableCsvUploadForGroup2 = _interopRequireDefault(_shouldEnableCsvUploadForGroup);
	
	__webpack_require__(1546);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var EVENT_SCREEN_NAME = 'GroupInviteModal';
	
	var GroupInviteModal = function (_React$Component) {
	  _inherits(GroupInviteModal, _React$Component);
	
	  function GroupInviteModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupInviteModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupInviteModal.__proto__ || Object.getPrototypeOf(GroupInviteModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      activeTab: _this.props.initialTab ? _this.getEnabledTabs()[_this.props.initialTab] : _this.getDefaultTab()
	    }, _this.handleHideRequest = function () {
	      var showConfirm = _this.props.group.getMembershipsCount() <= 1 && !_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.INVITE_DIALOG_CONFIRM_HIDE);
	      if (showConfirm) {
	        (0, _modal.mountModal)(_react2.default.createElement(_ConfirmDialog2.default, {
	          eventScreenName: 'GroupInviteModal',
	          title: 'Would you like to add students and parents to your class?',
	          onCancel: _this.props.onRequestHide,
	          actionButtonText: 'Add',
	          cancelButtonText: 'Cancel',
	          hideCloseButton: true,
	          hideOnBlur: false
	        }), _this);
	        _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.INVITE_DIALOG_CONFIRM_HIDE);
	      } else if (_this.props.onRequestHide) {
	        _this.props.onRequestHide();
	      }
	    }, _this.setActiveTab = function (index) {
	      _this.setState({ activeTab: index });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupInviteModal, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        eventScreenName: EVENT_SCREEN_NAME
	      };
	    }
	  }, {
	    key: 'getDefaultTab',
	    value: function getDefaultTab() {
	      var tabs = this.getEnabledTabs();
	      if (GroupInviteModal.TABS.CSV_UPLOAD in tabs) {
	        return tabs.CSV_UPLOAD;
	      } else if (GroupInviteModal.TABS.INVITE in tabs) {
	        return tabs.INVITE;
	      } else {
	        return tabs.INSTRUCTIONS;
	      }
	    }
	  }, {
	    key: 'getEnabledTabs',
	    value: function getEnabledTabs() {
	      var tabs = {};
	      var tabIndex = 0;
	      if (this.shouldEnableCSVUpload()) {
	        tabs.CSV_UPLOAD = tabIndex++;
	      }
	      if (_CurrentUser2.default.getUser().hasManualInviteSupported()) {
	        tabs.INVITE = tabIndex++;
	        tabs.PDF = tabIndex++;
	        tabs.INSTRUCTIONS = tabIndex++;
	        tabs.LINK = tabIndex++;
	      } else {
	        tabs.INSTRUCTIONS = tabIndex++;
	      }
	      return tabs;
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      if (!_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.INVITE_DIALOG_CONFIRM_HIDE)) {
	        _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.INVITE_DIALOG_CONFIRM_HIDE);
	      }
	    }
	  }, {
	    key: 'shouldEnableCSVUpload',
	    value: function shouldEnableCSVUpload() {
	      var group = this.props.group;
	
	      return (0, _shouldEnableCsvUploadForGroup2.default)(group);
	    }
	  }, {
	    key: 'smsEnabled',
	    value: function smsEnabled() {
	      return this.props.group.smsEnabledForUser(_CurrentUser2.default.getUser());
	    }
	  }, {
	    key: 'renderSidebarHeader',
	    value: function renderSidebarHeader() {
	      var group = this.props.group;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _FlexibleBlock2.default,
	          { className: 'GroupInviteModal-group', flex: 'right' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_GroupAvatar2.default, { group: group, className: 'GroupInviteModal-group-avatar' })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h2',
	              { className: 'GroupInviteModal-group-name' },
	              _react2.default.createElement(
	                _Text2.default,
	                { truncate: true },
	                _react2.default.createElement(_GroupName2.default, { group: group })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'GroupInviteModal-group-code' },
	              '@',
	              group.getCode()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Heading2.default,
	          { flush: true, level: '3' },
	          'Ways to add people'
	        )
	      );
	    }
	  }, {
	    key: 'renderInClassInstructionsTab',
	    value: function renderInClassInstructionsTab() {
	      var group = this.props.group;
	
	      var smsEnabled = this.smsEnabled();
	
	      var title = _react2.default.createElement(_LeftTabModalTitle2.default, {
	        glyphName: smsEnabled ? 'display-board' : 'mobile',
	        glyphColor: 'violet',
	        title: smsEnabled ? 'In-person instructions' : 'QR code',
	        titleShort: smsEnabled ? 'Instruct' : 'QR code'
	      });
	
	      return _react2.default.createElement(_InviteInClassInstructionsTab2.default, {
	        group: group,
	        title: title,
	        key: 'inClassInstructionsTab'
	      });
	    }
	  }, {
	    key: 'renderShareLinkTab',
	    value: function renderShareLinkTab() {
	      var group = this.props.group;
	
	      var title = _react2.default.createElement(_LeftTabModalTitle2.default, {
	        glyphName: 'link',
	        glyphColor: 'flame',
	        title: 'Share a link',
	        titleShort: 'Link'
	      });
	      return _react2.default.createElement(_InviteShareLinkTab2.default, {
	        group: group,
	        title: title,
	        key: 'shareLinkTab'
	      });
	    }
	  }, {
	    key: 'renderPDFTab',
	    value: function renderPDFTab() {
	      var group = this.props.group;
	
	      var title = _react2.default.createElement(_LeftTabModalTitle2.default, {
	        glyphName: 'printer',
	        glyphColor: 'lava',
	        title: 'Printable PDFs',
	        titleShort: 'PDF'
	      });
	      return _react2.default.createElement(_InvitePDFTab2.default, {
	        group: group,
	        title: title,
	        key: 'pdfTab'
	      });
	    }
	  }, {
	    key: 'renderManualInviteTab',
	    value: function renderManualInviteTab() {
	      var smsEnabled = this.smsEnabled();
	      var title = _react2.default.createElement(_LeftTabModalTitle2.default, {
	        glyphName: 'avatar-add',
	        glyphColor: 'shamrock',
	        title: smsEnabled ? 'Phone or email contacts' : 'Email invitation',
	        titleShort: 'Invite'
	      });
	      return _react2.default.createElement(_InviteManualAddTab2.default, { group: this.props.group, smsEnabled: smsEnabled, title: title, key: 'manualAddTab' });
	    }
	  }, {
	    key: 'renderCSVUploadTab',
	    value: function renderCSVUploadTab() {
	      if (!this.shouldEnableCSVUpload()) {
	        return null;
	      }
	
	      var group = this.props.group;
	
	      var org = _OrganizationStore2.default.getOrganization(group.getStaffClassOrgId());
	      var title = _react2.default.createElement(_LeftTabModalTitle2.default, {
	        glyphName: 'spreadsheet',
	        glyphColor: 'midnight',
	        title: 'Upload a spreadsheet',
	        titleShort: 'Upload'
	      });
	
	      return _react2.default.createElement(_TeacherAddUploadTab2.default, {
	        key: 'addUploadTab',
	        group: group,
	        organization: org,
	        ref: 'uploadTab',
	        title: title
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var body = void 0;
	
	      if (_CurrentUser2.default.getUser().hasManualInviteSupported()) {
	        body = [this.renderCSVUploadTab(), this.renderManualInviteTab(), this.renderPDFTab(), this.renderInClassInstructionsTab(), this.renderShareLinkTab()];
	      } else {
	        body = [this.renderCSVUploadTab(), this.renderInClassInstructionsTab()];
	      }
	
	      return _react2.default.createElement(
	        _LeftTabModal2.default,
	        {
	          eventScreenName: 'GroupInviteModal',
	          onRequestHide: this.props.onRequestHide,
	          sidebarHeader: this.renderSidebarHeader(),
	          onTabChange: this.setActiveTab,
	          onMaskHide: this.handleHideRequest,
	          onDialogClick: this.handleClick,
	          hideOnBlur: this.props.hideOnBlur,
	          tabActive: this.state.activeTab },
	        body
	      );
	    }
	  }]);
	
	  return GroupInviteModal;
	}(_react2.default.Component);
	
	GroupInviteModal.TABS = ['CSV_UPLOAD', 'INVITE', 'PDF', 'INSTRUCTIONS', 'LINK'].reduce(function (obj, elem) {
	  obj[elem] = elem;
	  return obj;
	}, {});
	GroupInviteModal.defaultProps = {
	  onRequestHide: function onRequestHide() {},
	  hideOnBlur: false
	};
	GroupInviteModal.childContextTypes = {
	  eventScreenName: _react2.default.PropTypes.string
	};
	GroupInviteModal.displayName = 'GroupInviteModal';
	exports.default = GroupInviteModal;

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1437);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Heading = function (_React$Component) {
	  _inherits(Heading, _React$Component);
	
	  function Heading() {
	    _classCallCheck(this, Heading);
	
	    return _possibleConstructorReturn(this, (Heading.__proto__ || Object.getPrototypeOf(Heading)).apply(this, arguments));
	  }
	
	  _createClass(Heading, [{
	    key: 'render',
	    value: function render() {
	      var Component = 'h2';
	
	      if (this.props.level === '1') {
	        Component = 'h1';
	      } else if (this.props.level === '3') {
	        Component = 'h3';
	      } else if (this.props.level === '4') {
	        Component = 'h4';
	      }
	
	      return _react2.default.createElement(
	        Component,
	        { className: (0, _classnames2.default)('Heading', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className) },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Heading;
	}(_react2.default.Component);
	
	Heading.propClasses = {
	  align: {
	    left: 'Heading--left',
	    center: 'Heading--center',
	    right: 'Heading--right'
	  },
	  flush: 'Heading--flush',
	  level: {
	    /* eslint-disable quote-props */
	    '1': 'Heading--1',
	    '2': 'Heading--2',
	    '3': 'Heading--3',
	    '4': 'Heading--4'
	  }
	};
	Heading.defaultProps = {
	  level: '2'
	};
	Heading.displayName = 'Heading';
	exports.default = Heading;

/***/ },
/* 1437 */
1136,
/* 1438 */,
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxHeader = __webpack_require__(1440);
	
	var _BoxHeader2 = _interopRequireDefault(_BoxHeader);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _SmsInstruction = __webpack_require__(1443);
	
	var _SmsInstruction2 = _interopRequireDefault(_SmsInstruction);
	
	var _TabPanel = __webpack_require__(1447);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	__webpack_require__(1448);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InviteInClassInstructionsTab = function (_React$Component) {
	  _inherits(InviteInClassInstructionsTab, _React$Component);
	
	  function InviteInClassInstructionsTab() {
	    _classCallCheck(this, InviteInClassInstructionsTab);
	
	    return _possibleConstructorReturn(this, (InviteInClassInstructionsTab.__proto__ || Object.getPrototypeOf(InviteInClassInstructionsTab)).apply(this, arguments));
	  }
	
	  _createClass(InviteInClassInstructionsTab, [{
	    key: 'isSmsEnabled',
	    value: function isSmsEnabled() {
	      return this.props.group.smsEnabledForUser(_CurrentUser2.default.getUser());
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var group = this.props.group;
	
	      if (this.isSmsEnabled()) {
	        return _react2.default.createElement(_SmsInstruction2.default, { group: group });
	      } else {
	        var qrLink = _LinkConstants2.default.QR + '/?s=' + group.getJoinUrl();
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_BoxHeader2.default, { title: 'Ask your class to scan this QR code with their smartphones' }),
	          _react2.default.createElement(
	            _BoxBody2.default,
	            null,
	            _react2.default.createElement(_Image2.default, { className: 'InviteInClassInstructionsTab-qrCode', src: qrLink })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var eventElementName = this.isSmsEnabled ? 'tab-in-class-instructions' : 'tab-in-class-instructions-no-sms';
	      return _react2.default.createElement(
	        _TabPanel2.default,
	        {
	          key: 'inclassPanel',
	          selectedBorderColor: 'shamrock',
	          className: 'InviteInClassInstructionsTab',
	          eventElementName: eventElementName,
	          title: this.props.title },
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return InviteInClassInstructionsTab;
	}(_react2.default.Component);
	
	InviteInClassInstructionsTab.displayName = 'InviteInClassInstructionsTab';
	exports.default = InviteInClassInstructionsTab;

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1441);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxHeader = function (_React$Component) {
	  _inherits(BoxHeader, _React$Component);
	
	  function BoxHeader() {
	    _classCallCheck(this, BoxHeader);
	
	    return _possibleConstructorReturn(this, (BoxHeader.__proto__ || Object.getPrototypeOf(BoxHeader)).apply(this, arguments));
	  }
	
	  _createClass(BoxHeader, [{
	    key: 'renderTitle',
	    value: function renderTitle() {
	      var title = this.props.title;
	
	      if (!title) {
	        return null;
	      }
	
	      // TODO: shouldn't reference `.Box-*` styles
	      if (this.props.aux) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'BoxHeader-inner' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'Box-title' },
	            title
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.props.aux
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'h2',
	        { className: 'BoxHeader-title' },
	        title
	      );
	    }
	  }, {
	    key: 'renderSubtext',
	    value: function renderSubtext() {
	      if (this.props.subtext) {
	        return _react2.default.createElement(
	          'h3',
	          { className: 'BoxHeader-subtext' },
	          this.props.subtext
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'header',
	        { className: (0, _classnames2.default)('BoxHeader', this.props.className) },
	        this.renderTitle(),
	        this.renderSubtext(),
	        this.props.children
	      );
	    }
	  }]);
	
	  return BoxHeader;
	}(_react2.default.Component);
	
	BoxHeader.displayName = 'BoxHeader';
	exports.default = BoxHeader;

/***/ },
/* 1441 */
1136,
/* 1442 */,
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxHeader = __webpack_require__(1440);
	
	var _BoxHeader2 = _interopRequireDefault(_BoxHeader);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	__webpack_require__(1444);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SmsInstruction = function (_React$Component) {
	  _inherits(SmsInstruction, _React$Component);
	
	  function SmsInstruction() {
	    _classCallCheck(this, SmsInstruction);
	
	    return _possibleConstructorReturn(this, (SmsInstruction.__proto__ || Object.getPrototypeOf(SmsInstruction)).apply(this, arguments));
	  }
	
	  _createClass(SmsInstruction, [{
	    key: 'render',
	    value: function render() {
	      var group = this.props.group;
	
	      var inputId = 'SmsInstruction-phone-input';
	
	      var number = void 0;
	      if (_CurrentUser2.default.isSignedIn()) {
	        number = !group.useShortCodeForUser(_CurrentUser2.default.getUser()) && group.getSMSAlternateNumber() ? group.getSMSAlternateNumber() : group.getSMSNumber();
	      } else {
	        number = !(group.getSubscriptionInfo().sms && group.hasShortCode()) && group.getSMSAlternateNumber() ? group.getSMSAlternateNumber() : group.getSMSNumber();
	      }
	      var code = group.getCode();
	
	      var title = _react2.default.createElement(
	        'span',
	        null,
	        'Tell people to text @',
	        code,
	        ' to the number ',
	        number
	      );
	
	      var alternateNumber = group.getSMSAlternateNumber();
	
	      var subtext = _react2.default.createElement(
	        'span',
	        null,
	        'They\u2019ll receive a welcome text from Remind.',
	        alternateNumber && _react2.default.createElement(
	          _Text2.default,
	          null,
	          _react2.default.createElement('br', null),
	          'If anyone has trouble with ',
	          number,
	          ',',
	          ' ',
	          'they can try texting @',
	          code,
	          ' to ',
	          alternateNumber,
	          '.'
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'SmsInstruction' },
	        _react2.default.createElement(_BoxHeader2.default, { title: title, subtext: subtext }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'SmsInstruction-phone' },
	            _react2.default.createElement(_Image2.default, {
	              className: 'SmsInstruction-phone-image',
	              src: __webpack_require__(1446)
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'SmsInstruction-phone-to' },
	              _react2.default.createElement(
	                'div',
	                { className: 'SmsInstruction-phone-to-inner' },
	                _react2.default.createElement(
	                  'label',
	                  {
	                    htmlFor: inputId,
	                    className: 'SmsInstruction-phone-to-label SmsInstruction-phone-label' },
	                  'To:'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'SmsInstruction-phone-to-number' },
	                  _react2.default.createElement(_Input2.default, {
	                    id: inputId,
	                    value: number,
	                    readOnly: true,
	                    className: 'SmsInstruction-phone-input'
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'SmsInstruction-phone-message' },
	              '@',
	              code,
	              _react2.default.createElement('div', { className: 'SmsInstruction-phone-message-bubble-arrow' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'SmsInstruction-phone-send' },
	              'Send'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SmsInstruction;
	}(_react2.default.Component);
	
	SmsInstruction.displayName = 'SmsInstruction';
	exports.default = SmsInstruction;

/***/ },
/* 1444 */
1136,
/* 1445 */,
/* 1446 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ClickEventTrigger = __webpack_require__(1181);
	
	var _ClickEventTrigger2 = _interopRequireDefault(_ClickEventTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabPanel = _react2.default.createClass({
	  displayName: 'TabPanel',
	  getDefaultProps: function getDefaultProps() {
	    return {
	      inline: false,
	      disabled: false,
	      hidden: false
	    };
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _ClickEventTrigger2.default,
	      { eventElementName: this.props.eventElementName },
	      _react2.default.createElement(
	        'div',
	        { className: this.props.className },
	        this.props.children
	      )
	    );
	  }
	});
	
	exports.default = TabPanel;

/***/ },
/* 1448 */
1136,
/* 1449 */,
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupInviteBulkAddTab = __webpack_require__(1451);
	
	var _GroupInviteBulkAddTab2 = _interopRequireDefault(_GroupInviteBulkAddTab);
	
	var _TabPanel = __webpack_require__(1447);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InviteManualAddTab = function (_React$Component) {
	  _inherits(InviteManualAddTab, _React$Component);
	
	  function InviteManualAddTab() {
	    _classCallCheck(this, InviteManualAddTab);
	
	    return _possibleConstructorReturn(this, (InviteManualAddTab.__proto__ || Object.getPrototypeOf(InviteManualAddTab)).apply(this, arguments));
	  }
	
	  _createClass(InviteManualAddTab, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          group = _props.group,
	          smsEnabled = _props.smsEnabled,
	          title = _props.title;
	
	
	      return _react2.default.createElement(
	        _TabPanel2.default,
	        {
	          key: 'manualAddPanel',
	          selectedBorderColor: 'brand',
	          className: 'InviteManualAddTab',
	          eventElementName: 'tab-text-email-invitation',
	          title: title },
	        _react2.default.createElement(_GroupInviteBulkAddTab2.default, { group: group, supportSms: smsEnabled })
	      );
	    }
	  }]);
	
	  return InviteManualAddTab;
	}(_react2.default.Component);
	
	InviteManualAddTab.displayName = 'InviteManualAddTab';
	exports.default = InviteManualAddTab;

/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxHeader = __webpack_require__(1440);
	
	var _BoxHeader2 = _interopRequireDefault(_BoxHeader);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _directAddHelper = __webpack_require__(1452);
	
	var _DirectAddLegalDialog = __webpack_require__(1460);
	
	var _DirectAddLegalDialog2 = _interopRequireDefault(_DirectAddLegalDialog);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _mountTymkPrompt = __webpack_require__(1464);
	
	var _mountTymkPrompt2 = _interopRequireDefault(_mountTymkPrompt);
	
	var _ParticipantsTableInput = __webpack_require__(1474);
	
	var _ParticipantsTableInput2 = _interopRequireDefault(_ParticipantsTableInput);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Row = __webpack_require__(1482);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var GroupInviteBulkAddTab = function (_React$Component) {
	  _inherits(GroupInviteBulkAddTab, _React$Component);
	
	  function GroupInviteBulkAddTab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupInviteBulkAddTab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupInviteBulkAddTab.__proto__ || Object.getPrototypeOf(GroupInviteBulkAddTab)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      participants: [],
	      loading: false
	    }, _this.onUpdate = function (participants) {
	      _this.setState({ participants: participants });
	    }, _this.submitDirectAddParticipants = function () {
	      _this.setState({ loading: true });
	      (0, _directAddHelper.directAddSubmit)(_this.props.group, _this.state.participants, function (remainingParticpants) {
	        _this.setState({ participants: remainingParticpants, loading: false });
	      }, function () {
	        _this.setState({ loading: false });
	      });
	      (0, _mountTymkPrompt2.default)(_this, 'send_invite');
	    }, _this.submitDisabled = function () {
	      var participants = _this.state.participants;
	
	      return !participants || participants.filter(function (p) {
	        return p.uid && p.valid;
	      }).length === 0;
	    }, _this.toggle = function (name) {
	      _this.setState(_defineProperty({}, name, !_this.state[name]));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupInviteBulkAddTab, [{
	    key: 'render',
	    value: function render() {
	      var supportSms = this.props.supportSms;
	
	
	      var subtext = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Text2.default,
	          { element: 'p' },
	          'Enter contact information in the space provided. You can also copy and paste from a spreadsheet.',
	          ' ',
	          _react2.default.createElement(
	            _Link2.default,
	            { href: 'https://youtu.be/ulfHinOT1Ws', target: '_blank' },
	            'Want to watch how?'
	          )
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          { element: 'p' },
	          'Getting an error?',
	          ' ',
	          _react2.default.createElement(
	            _Link2.default,
	            { href: _LinkConstants2.default.ZENDESK + '/articles/201816825', target: '_blank' },
	            'Here are the reasons why'
	          ),
	          ' ',
	          'you might not be able to add a participant.'
	        )
	      );
	
	      var title = supportSms ? 'Enter phone numbers or email addresses' : 'Enter email addresses';
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_BoxHeader2.default, { title: title, subtext: subtext }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(
	            _Row2.default,
	            { size: 'small' },
	            _react2.default.createElement(_ParticipantsTableInput2.default, {
	              groupId: this.props.group.id,
	              onChangeRow: this.onUpdate,
	              initialRows: this.state.participants,
	              supportSms: supportSms
	            })
	          ),
	          _react2.default.createElement(
	            _Field2.default,
	            null,
	            _react2.default.createElement(
	              _Text2.default,
	              { color: 'thunder', size: 'xxsmall' },
	              'By clicking "Add people," I confirm that these people gave me' + ' permission to send them text messages and emails. ',
	              _react2.default.createElement(
	                _ModalTrigger2.default,
	                {
	                  modal: _react2.default.createElement(_DirectAddLegalDialog2.default, { hasChildren: this.props.group.hasChildren() }) },
	                _react2.default.createElement(
	                  _Link2.default,
	                  null,
	                  'Learn more'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              loading: this.state.loading,
	              onClick: this.submitDirectAddParticipants,
	              disabled: this.state.loading || this.submitDisabled() },
	            'Add people'
	          )
	        )
	      );
	    }
	  }]);
	
	  return GroupInviteBulkAddTab;
	}(_react2.default.Component);
	
	GroupInviteBulkAddTab.displayName = 'GroupInviteBulkAddTab';
	exports.default = GroupInviteBulkAddTab;

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	
	exports.getParticipantsSnapshot = getParticipantsSnapshot;
	exports.getValidParticipants = getValidParticipants;
	exports.directAddSubmit = directAddSubmit;
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _InvitationActions = __webpack_require__(1453);
	
	var _InvitationActions2 = _interopRequireDefault(_InvitationActions);
	
	var _RecipientParser = __webpack_require__(1457);
	
	var _RecipientParser2 = _interopRequireDefault(_RecipientParser);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function onSuccess(participantsSnapshot, response, successCallback) {
	  var nonEmptyParticipants = participantsSnapshot.filter(function (participant) {
	    return participant.uid || participant.name;
	  });
	
	  // The participant rows that were sent to the server
	  var submittedParticipants = nonEmptyParticipants.filter(function (participant) {
	    return participant.valid;
	  });
	
	  // The participant rows that are invalid, but not empty
	  var invalidParticipants = nonEmptyParticipants.filter(function (participant) {
	    return !participant.valid;
	  });
	
	  // Errors returned from the server
	  var serverErrors = Object.keys(response).filter(function (key) {
	    return key.startsWith('sms://') || key.startsWith('email://');
	  });
	
	  // Map server errors to submitted participants by matching on uid
	  var erroredParticipants = [];
	  serverErrors.forEach(function (error) {
	    var matchingParticipant = submittedParticipants.find(function (p) {
	      return error.indexOf(p.uid.trim()) > -1;
	    });
	    if (matchingParticipant) {
	      erroredParticipants.push(_extends({}, matchingParticipant, {
	        serverErrors: { uid: response[error].error.recipient[0] }
	      }));
	    }
	  });
	
	  // The number of participants for whom the invite was sent successfully
	  var numberSuccessful = nonEmptyParticipants.length - (serverErrors.length + invalidParticipants.length);
	
	  if (!Object.keys(response).length && !invalidParticipants.length) {
	    _ToastActions2.default.showSuccessToast('Participants successfully added');
	    successCallback([]);
	  } else {
	    if (numberSuccessful > 0) {
	      _ToastActions2.default.showSuccessToast(numberSuccessful + ' of ' + nonEmptyParticipants.length + ' participants successfully added');
	    } else {
	      _ToastActions2.default.showErrorToast('0 of ' + nonEmptyParticipants.length + ' participants could be added :(');
	    }
	    // Set state to leave only invalid rows or rows for which a server error occurred
	    invalidParticipants.forEach(function (p) {
	      p.pasted = true;
	    }); // in order to re-validate
	    erroredParticipants.forEach(function (p) {
	      p.valid = false;
	    }); // rows with server errs aren't valid
	    var remainingParticipants = invalidParticipants.concat(erroredParticipants);
	    successCallback(remainingParticipants);
	  }
	}
	
	function onFailure(participantsSnapshot, response, successCallback, failCallback) {
	  if (response.statusCode === 422) {
	    // There was an error, but one or more invites may have been successful.
	    onSuccess(participantsSnapshot, response, successCallback);
	  } else {
	    _ToastActions2.default.showDefaultErrorToast();
	    failCallback();
	  }
	}
	
	function getParticipantsSnapshot(participants) {
	  var uniqueParticipants = _lodash2.default.uniqBy(participants.filter(function (p) {
	    return p;
	  }), 'uid');
	  return _lodash2.default.cloneDeep(uniqueParticipants);
	}
	
	function getValidParticipants(participants) {
	  var validParticipants = [];
	
	  participants.forEach(function (participant) {
	    if (participant.uid && participant.valid) {
	      validParticipants.push(participant);
	    }
	  });
	
	  return validParticipants;
	}
	
	function directAddSubmit(group, participants, successCallback, failCallback) {
	  var participantsSnapshot = getParticipantsSnapshot(participants);
	  var validParticipants = getValidParticipants(participantsSnapshot);
	  var submitParticipants = validParticipants.map(function (participant) {
	    return {
	      name: participant.name || '',
	      address: _RecipientParser2.default.newToken(participant.uid).address
	    };
	  });
	  var onSubmissionSuccess = function onSubmissionSuccess(response) {
	    return onSuccess(participantsSnapshot, response, successCallback);
	  };
	  var onSubmissionError = function onSubmissionError(response) {
	    return onFailure(participantsSnapshot, response, successCallback, failCallback);
	  };
	  var groupId = group.id;
	
	  _InvitationActions2.default.invite(groupId, submitParticipants).then(onSubmissionSuccess, onSubmissionError);
	}

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InvitationConstants = __webpack_require__(1454);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _Invitations = __webpack_require__(1455);
	
	var _Invitations2 = _interopRequireDefault(_Invitations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvitationActions = {
	  invite: function invite(groupId, recipients) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _InvitationConstants.ActionTypes.CREATE_INVITATION,
	      recipients: recipients
	    });
	
	    return _Invitations2.default.invite(groupId, recipients);
	  }
	};
	exports.default = InvitationActions;

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['CREATE_INVITATION']); /*  weak */

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _Invitation = __webpack_require__(1456);
	
	var _Invitation2 = _interopRequireDefault(_Invitation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Invitations = function (_Collection) {
	  _inherits(Invitations, _Collection);
	
	  function Invitations() {
	    _classCallCheck(this, Invitations);
	
	    return _possibleConstructorReturn(this, (Invitations.__proto__ || Object.getPrototypeOf(Invitations)).apply(this, arguments));
	  }
	
	  _createClass(Invitations, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _Invitation2.default;
	    }
	  }], [{
	    key: 'invite',
	    value: function invite(groupId, recipients) {
	      return (0, _apiRequest2.default)('/classes/' + groupId + '/invitations', 'POST', {
	        invitations: recipients.map(function (recipient) {
	          return {
	            address: recipient.address,
	            name: recipient.name
	          };
	        })
	      });
	    }
	  }]);
	
	  return Invitations;
	}(_Collection3.default);
	
	Invitations.displayName = 'Invitations';
	exports.default = Invitations;

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Invitation = function (_Entity) {
	  _inherits(Invitation, _Entity);
	
	  function Invitation() {
	    _classCallCheck(this, Invitation);
	
	    return _possibleConstructorReturn(this, (Invitation.__proto__ || Object.getPrototypeOf(Invitation)).apply(this, arguments));
	  }
	
	  _createClass(Invitation, null, [{
	    key: 'isValidGroupInvite',
	    value: function isValidGroupInvite(groupId, address) {
	      return (0, _apiRequest2.default)('/classes/' + groupId + '/invitations/validate', 'GET', {
	        invitations: [{
	          address: address
	        }]
	      });
	    }
	  }, {
	    key: 'isValidOrgInvite',
	    value: function isValidOrgInvite(orgId, address) {
	      return (0, _apiRequest2.default)('/managed_orgs/' + orgId + '/invitations/validate', 'GET', {
	        invitations: [{
	          address: address
	        }]
	      });
	    }
	  }]);
	
	  return Invitation;
	}(_Entity3.default);
	
	Invitation.displayName = 'Invitation';
	exports.default = Invitation;

/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _isEmail = __webpack_require__(1458);
	
	var _isEmail2 = _interopRequireDefault(_isEmail);
	
	var _isPhone = __webpack_require__(1459);
	
	var _isPhone2 = _interopRequireDefault(_isPhone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VALID = 'VALID'; /*  weak */
	
	var INVALID = 'INVALID';
	var UNKNOWN = 'UNKNOWN';
	
	var newToken = function newToken(recipient) {
	  if ((0, _isEmail2.default)(recipient)) {
	    return { value: recipient, address: 'email://' + recipient, status: UNKNOWN };
	  } else if ((0, _isPhone2.default)(recipient)) {
	    return { value: recipient, address: 'sms://' + recipient, status: UNKNOWN };
	  } else {
	    return { value: recipient, address: null, status: INVALID };
	  }
	};
	
	var parse = function parse(input, ignoreTrailing) {
	  var shouldIgnoreTrailing = ignoreTrailing !== false;
	
	  var recipients = input.split(/[;,\n]+/);
	  var results = [];
	
	  if (shouldIgnoreTrailing && recipients.length <= 1) {
	    return results;
	  }
	
	  _lodash2.default.each(recipients, function (recipient) {
	    var trimmedRecipient = recipient.trim();
	    if (trimmedRecipient.length > 1) {
	      results.push(newToken(trimmedRecipient.trim()));
	    }
	  });
	
	  return results;
	};
	
	exports.default = {
	  VALID: VALID,
	  INVALID: INVALID,
	  UNKNOWN: UNKNOWN,
	  parse: parse,
	  newToken: newToken
	};

/***/ },
/* 1458 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (email) {
	  return (/\S+@\S+\.\S+/.test(email)
	  );
	};

/***/ },
/* 1459 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (phone) {
	  if (/[a-zA-Z]/.test(phone)) {
	    return false;
	  }
	
	  var stripped = phone.replace(/[^0-9]/g, '');
	  return stripped.length === 10 || stripped.length === 11 && stripped.charAt(0) === '1';
	};

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Copy = __webpack_require__(1461);
	
	var _Copy2 = _interopRequireDefault(_Copy);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _DialogButton = __webpack_require__(1327);
	
	var _DialogButton2 = _interopRequireDefault(_DialogButton);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var DirectAddLegalDialog = function (_React$Component) {
	  _inherits(DirectAddLegalDialog, _React$Component);
	
	  function DirectAddLegalDialog() {
	    _classCallCheck(this, DirectAddLegalDialog);
	
	    return _possibleConstructorReturn(this, (DirectAddLegalDialog.__proto__ || Object.getPrototypeOf(DirectAddLegalDialog)).apply(this, arguments));
	  }
	
	  _createClass(DirectAddLegalDialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'DirectAddLegalDialog'
	        }, this.props, {
	          title: 'Adding participants on Remind',
	          size: 'small' }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(
	            _Copy2.default,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Here are a few guidelines to help you comply with the',
	              ' ',
	              _react2.default.createElement(
	                _Link2.default,
	                { target: '_blank', href: _LinkConstants2.default.TERMS_OF_SERVICE },
	                'Terms of Service'
	              ),
	              ' ',
	              'of the Remind platform.'
	            ),
	            _react2.default.createElement(
	              'ol',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Before adding anyone to a class, make sure you have their permission to send them SMS messages and emails.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Use Remind only for non-commercial purposes.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Let participants know that normal text messaging rates may apply to messages they receive.'
	                )
	              ),
	              this.props.hasChildren && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Remember to get parental consent for students under 13.',
	                  ' ',
	                  _react2.default.createElement(
	                    _Link2.default,
	                    { target: '_blank', href: _LinkConstants2.default.PARENTAL_CONSENT },
	                    'Learn more'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _DialogButton2.default,
	            { onClick: this.props.onRequestHide },
	            'Got it'
	          )
	        )
	      );
	    }
	  }]);
	
	  return DirectAddLegalDialog;
	}(_react2.default.Component);
	
	DirectAddLegalDialog.displayName = 'DirectAddLegalDialog';
	exports.default = DirectAddLegalDialog;

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getPropClasses = __webpack_require__(1135);
	
	__webpack_require__(1462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Copy is a component for applying base typography styles to elements containing text, such as
	 * headings, paragraphs & lists
	 *
	 * ```example
	 *  <Copy>
	 *    <p>
	 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean eget rhoncus nunc, eget
	 *     commodo felis. Vestibulum mattis mi tortor, id imperdiet ex imperdiet in.
	 *    </p>
	 *    <p>
	 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean eget rhoncus nunc, eget
	 *     commodo felis. Vestibulum mattis mi tortor, id imperdiet ex imperdiet in.
	 *    </p>
	 *    <ol>
	 *      <li>Lorem ipsum dolor sit amet</li>
	 *      <li>Lorem ipsum dolor sit amet</li>
	 *      <li>Lorem ipsum dolor sit amet</li>
	 *    </ol>
	 *    <ul>
	 *      <li>Lorem ipsum dolor sit amet</li>
	 *      <li>Lorem ipsum dolor sit amet</li>
	 *      <li>Lorem ipsum dolor sit amet</li>
	 *    </ul>
	 *  </Copy>
	 * ```
	 */
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class() {
	    _classCallCheck(this, _class);
	
	    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	  }
	
	  _createClass(_class, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('Copy', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className) },
	        this.props.children
	      );
	    }
	  }]);
	
	  return _class;
	}(_react2.default.Component);
	
	_class.propClasses = {
	  center: 'Copy--center',
	  color: {
	    pitch: 'Copy--pitch',
	    thunder: 'Copy--thunder'
	  },
	  size: {
	    medium: 'Copy--medium'
	  }
	};
	_class.defaultProps = {
	  center: false,
	  color: 'pitch',
	  size: 'medium'
	};
	_class.displayName = '_class';
	exports.default = _class;

/***/ },
/* 1462 */
1136,
/* 1463 */,
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mountTymkPrompt;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _LeadStore = __webpack_require__(1024);
	
	var _LeadStore2 = _interopRequireDefault(_LeadStore);
	
	var _modal = __webpack_require__(1188);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _TymkModal = __webpack_require__(1465);
	
	var _TymkModal2 = _interopRequireDefault(_TymkModal);
	
	var _SetupActions = __webpack_require__(1473);
	
	var _SetupActions2 = _interopRequireDefault(_SetupActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isTymkPromptEnabled() {
	  return _CurrentUser2.default.isSignedIn() && _CurrentUser2.default.getUser().hasItemInPromptsInventory(_PromptConstants.PromptNames.TYMK_MODAL) && !_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.TYMK_MODAL);
	}
	
	
	// typecheck: ignore statement
	function mountTymkPrompt(parent, context) {
	  var hideOnBlur = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var leads = _LeadStore2.default.getLeads();
	  if (!isTymkPromptEnabled() || leads.length === 0) {
	    return;
	  }
	
	  _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.TYMK_MODAL);
	  _SetupActions2.default.removeFlagsForSetupSession();
	
	  var modal = _react2.default.createElement(_TymkModal2.default, {
	    leads: leads,
	    triggeredContext: context,
	    onRequestHide: function onRequestHide() {},
	    hideOnBlur: hideOnBlur
	  });
	  // Delay showing the tymk modal by half a second
	  setTimeout(function () {
	    (0, _modal.mountModal)(modal, parent);
	  }, 500);
	}

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AffiliationStore = __webpack_require__(1038);
	
	var _AffiliationStore2 = _interopRequireDefault(_AffiliationStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Tymk = __webpack_require__(1466);
	
	var _Tymk2 = _interopRequireDefault(_Tymk);
	
	var _Leads = __webpack_require__(1023);
	
	var _Leads2 = _interopRequireDefault(_Leads);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TymkModal = function (_React$Component) {
	  _inherits(TymkModal, _React$Component);
	
	  function TymkModal() {
	    _classCallCheck(this, TymkModal);
	
	    return _possibleConstructorReturn(this, (TymkModal.__proto__ || Object.getPrototypeOf(TymkModal)).apply(this, arguments));
	  }
	
	  _createClass(TymkModal, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        eventScreenName: 'invite_teacher_leads_screen',
	        eventProperties: {
	          total: this.props.leads.length,
	          previous_screen_name: this.props.triggeredContext
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var user = _CurrentUser2.default.getUser();
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({ eventScreenName: 'TymkModal' }, this.props, { size: 'small' }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(_Tymk2.default, _extends({}, this.props, {
	            afterSendInvitations: this.props.onRequestHide,
	            organizations: _AffiliationStore2.default.getMemberOrganizations(),
	            user: user
	          }))
	        )
	      );
	    }
	  }]);
	
	  return TymkModal;
	}(_react2.default.Component);
	
	TymkModal.childContextTypes = {
	  eventScreenName: _react2.default.PropTypes.string,
	  eventProperties: _react2.default.PropTypes.object
	};
	TymkModal.displayName = 'TymkModal';
	exports.default = TymkModal;

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CheckboxList = __webpack_require__(1467);
	
	var _CheckboxList2 = _interopRequireDefault(_CheckboxList);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupInviteModal = __webpack_require__(1435);
	
	var _GroupInviteModal2 = _interopRequireDefault(_GroupInviteModal);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _LeadActions = __webpack_require__(1021);
	
	var _LeadActions2 = _interopRequireDefault(_LeadActions);
	
	var _Leads = __webpack_require__(1023);
	
	var _Leads2 = _interopRequireDefault(_Leads);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _modal = __webpack_require__(1188);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _Organizations = __webpack_require__(1002);
	
	var _Organizations2 = _interopRequireDefault(_Organizations);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Tooltip = __webpack_require__(1157);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	__webpack_require__(1470);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var helpText = 'We work with third party companies that aggregate publicly available information\nabout schools (i.e. name, location) and school staff (i.e. names, email addresses) to generate these\nlists. When you click Invite, Remind sends an email on your behalf to invite teachers based on your\nspecific selections. We will never send invitations without your permission. If you have any questions\nabout this list, please email ' + _LinkConstants2.default.CONTACT_EMAIL + '.';
	
	var Tymk = function (_React$Component) {
	  _inherits(Tymk, _React$Component);
	
	  function Tymk() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tymk);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tymk.__proto__ || Object.getPrototypeOf(Tymk)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      leadIds: _this.getAllIds(),
	      checkedAll: true,
	      staffClassToDirectAdd: _this.getStaffClassToDirectAdd()
	    }, _this.goToDirectAdd = function () {
	      if (_this.props.afterSendInvitations) {
	        _this.props.afterSendInvitations();
	      }
	      (0, _modal.mountModal)(_react2.default.createElement(_GroupInviteModal2.default, { group: _this.state.staffClassToDirectAdd, initialTab: _GroupInviteModal2.default.TABS.INVITE }), _this);
	    }, _this.handleLeadChange = function (leadIds) {
	      _this.setState({ leadIds: leadIds });
	    }, _this.sendInvitation = function () {
	      var onSuccess = function onSuccess() {
	        _ToastActions2.default.showSuccessToast('Thank you! All invitations have been sent.');
	      };
	
	      _LeadActions2.default.sendInvitations(_this.state.leadIds, _this.props.triggeredContext).then(onSuccess, _ToastActions2.default.showDefaultErrorToast).then(function () {
	        if (_this.props.afterSendInvitations) {
	          _this.props.afterSendInvitations();
	        }
	      });
	    }, _this.toggleAllCheckbox = function () {
	      if (_this.state.checkedAll) {
	        _this.setState({ leadIds: [], checkedAll: false });
	      } else {
	        _this.setState({ leadIds: _this.getAllIds(), checkedAll: true });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tymk, [{
	    key: 'getAllIds',
	    value: function getAllIds() {
	      return this.props.leads.getNamed().map(function (lead) {
	        return lead.id;
	      });
	    }
	  }, {
	    key: 'getLeadOptions',
	    value: function getLeadOptions() {
	      return this.props.leads.getNamed().reduce(function (result, lead) {
	        // eslint-disable-line
	        var leadLabel = _react2.default.createElement(
	          'div',
	          { className: 'Tymk-lead' },
	          _react2.default.createElement(_Avatar2.default, { text: lead.getInitials(), colorHex: lead.getColor(), size: 'medium', className: 'Tymk-initials' }),
	          lead.getDisplayName()
	        );
	        return result.set(lead.id, leadLabel);
	      }, new Map());
	    }
	  }, {
	    key: 'getStaffClassToDirectAdd',
	    value: function getStaffClassToDirectAdd() {
	      var staffClass = null;
	      this.props.organizations.forEach(function (organization) {
	        if (!staffClass) {
	          staffClass = _GroupStore2.default.getStaffClassForOrg(organization.id);
	        }
	      });
	      return staffClass;
	    }
	  }, {
	    key: 'canSubmit',
	    value: function canSubmit() {
	      return this.state.leadIds.length > 0;
	    }
	  }, {
	    key: 'renderFooter',
	    value: function renderFooter() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Tymk-footer' },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'Tymk-submitButton',
	            disabled: !this.canSubmit(),
	            onClick: this.sendInvitation,
	            eventProperties: {
	              selected: this.state.leadIds.length
	            },
	            eventElementName: 'Tymk-submitButton' },
	          'Send invitations'
	        ),
	        this.renderHelpIcon()
	      );
	    }
	  }, {
	    key: 'renderLeadsList',
	    value: function renderLeadsList() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Tymk-leadsBox' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Tymk-leads' },
	          _react2.default.createElement(_CheckboxList2.default, {
	            options: this.getLeadOptions(),
	            checked: this.state.leadIds,
	            onChange: this.handleLeadChange,
	            checkboxAlignment: 'right',
	            showRowDividers: true
	          })
	        ),
	        this.renderLeadsListButtons()
	      );
	    }
	  }, {
	    key: 'renderLeadsListButtons',
	    value: function renderLeadsListButtons() {
	      var staffClassToDirectAdd = this.state.staffClassToDirectAdd;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Tymk-leadsButtons' },
	        staffClassToDirectAdd && this.renderInviteButton(),
	        this.renderSelectAllButton()
	      );
	    }
	  }, {
	    key: 'renderInviteButton',
	    value: function renderInviteButton() {
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'inviteButton',
	          level: 'text',
	          onClick: this.goToDirectAdd,
	          eventElementName: 'inviteButton' },
	        _react2.default.createElement(_Glyph2.default, { name: 'avatar-add', color: 'brand', size: 'large' }),
	        'Add teachers directly'
	      );
	    }
	  }, {
	    key: 'renderSelectAllButton',
	    value: function renderSelectAllButton() {
	      var buttonText = this.state.checkedAll ? 'Deselect all (' + this.state.leadIds.length + ')' : 'Select all (' + this.props.leads.getNamed().length + ')';
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'toggleButton',
	          level: 'text',
	          onClick: this.toggleAllCheckbox,
	          eventElementName: 'toggleButton' },
	        buttonText
	      );
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle() {
	      var organizations = this.props.organizations;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Tymk-header' },
	        _react2.default.createElement(_Image2.default, { src: __webpack_require__(1472) }),
	        'Share Remind with teachers at ',
	        organizations.length === 1 ? organizations[0].getName() : 'your schools',
	        '!'
	      );
	    }
	  }, {
	    key: 'renderHelpIcon',
	    value: function renderHelpIcon() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Tymk-help-container' },
	        _react2.default.createElement(
	          _LayerTrigger2.default,
	          {
	            placement: 'bottom',
	            layer: _react2.default.createElement(
	              _Tooltip2.default,
	              {
	                className: 'Tymk-help-tooltip' },
	              helpText
	            ) },
	          _react2.default.createElement(_Glyph2.default, { size: 'large', name: 'help', color: 'eclipse', className: 'Tymk-help-glyph' })
	        )
	      );
	    }
	  }, {
	    key: 'renderBody',
	    value: function renderBody() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Tymk-body' },
	        this.renderLeadsList()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Tymk' },
	        this.renderTitle(),
	        this.renderBody(),
	        this.renderFooter()
	      );
	    }
	  }]);
	
	  return Tymk;
	}(_react2.default.Component);
	
	Tymk.displayName = 'Tymk';
	exports.default = Tymk;

/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Checkbox = __webpack_require__(1388);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Divider = __webpack_require__(1330);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _List = __webpack_require__(1281);
	
	var _List2 = _interopRequireDefault(_List);
	
	__webpack_require__(1468);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Renders a list of checkboxes.
	 *
	 * ## CheckboxList can be used as a uncontrolled element
	 *
	 * ```example
	 *  <CheckboxList
	 *    options={{
	 *      'apples': 'Apples',
	 *      'bananas': 'Bananas',
	 *      'oranges': 'Oranges',
	 *      'strawberries': 'Strawberries',
	 *    }}
	 *    defaultChecked={['bananas']}
	 *    onChange={checked => window.alert(checked)}
	 *  />
	 * ```
	 */
	
	var CheckboxList = function (_React$Component) {
	  _inherits(CheckboxList, _React$Component);
	
	  function CheckboxList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CheckboxList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CheckboxList.__proto__ || Object.getPrototypeOf(CheckboxList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      initialChecked: _this.props.defaultChecked || [],
	      checked: Array.from(_this.props.checked || _this.props.defaultChecked || [])
	    }, _this.getValue = function () {
	      return _this.state.checked;
	    }, _this.handleChange = function (value) {
	      var checked = _this.state.checked;
	
	      var index = checked.indexOf(value);
	      if (index >= 0) {
	        checked.splice(index, 1);
	      } else {
	        checked.push(value);
	      }
	      _this.setState({ checked: checked });
	
	      if (_this.props.onChange) {
	        _this.props.onChange(checked);
	      }
	    }, _this.renderCheckbox = function (value, label, lastItem) {
	      var _this$props = _this.props,
	          checked = _this$props.checked,
	          disabled = _this$props.disabled,
	          checkboxAlignment = _this$props.checkboxAlignment,
	          showRowDividers = _this$props.showRowDividers;
	      // By default, the label is given as a child of the Checkbox
	      // which renders it to the right of the checkbox input
	      // If we want to float the checkbox input, we have to move the
	      // label outside of the Checkbox component
	
	      var labelAsChildOfCheckbox = checkboxAlignment === 'default';
	      return _react2.default.createElement(
	        'li',
	        {
	          className: (0, _classnames2.default)({
	            'CheckboxList-item-left': checkboxAlignment === 'left',
	            'CheckboxList-item-right': checkboxAlignment === 'right',
	            'CheckboxList-item-horizontal': _this.props.direction === 'horizontal'
	          }, 'CheckboxList-item'), key: value },
	        _react2.default.createElement(
	          _Checkbox2.default,
	          {
	            name: _this.props.name,
	            value: value,
	            disabled: disabled && disabled.includes(value),
	            checked: checked && checked.includes(value),
	            defaultChecked: checked ? null : _this.state.initialChecked.includes(value),
	            eventElementName: _this.props.eventElementName,
	            onChange: function onChange() {
	              return _this.handleChange(value);
	            },
	            checkboxAlignment: _this.props.checkboxAlignment },
	          labelAsChildOfCheckbox && label
	        ),
	        !labelAsChildOfCheckbox && label,
	        showRowDividers && !lastItem && _react2.default.createElement(_Divider2.default, { size: 'small' })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CheckboxList, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.checked !== nextProps.checked) {
	        this.setState({ checked: Array.from(nextProps.checked) });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var items = [];
	      var options = this.props.options;
	
	      if (options instanceof Map) {
	        (function () {
	          var elementsRemaining = options.size;
	          options.forEach(function (label, value) {
	            items.push(_this2.renderCheckbox(value, label, --elementsRemaining === 0));
	          });
	        })();
	      } else if (Array.isArray(options)) {
	        items = options.map(function (label, index) {
	          return _this2.renderCheckbox(index, label, index === options.length - 1);
	        });
	      } else {
	        (function () {
	          var keys = Object.keys(options);
	          items = options.map(function (value, index) {
	            return _this2.renderCheckbox(value, options[value], index === keys.length - 1);
	          });
	        })();
	      }
	
	      var _props = this.props,
	          onChange = _props.onChange,
	          listProps = _objectWithoutProperties(_props, ['onChange']); // eslint-disable-line
	
	      return _react2.default.createElement(
	        _List2.default,
	        _extends({}, listProps, {
	          className: (0, _classnames2.default)('CheckboxList', this.props.className) }),
	        items
	      );
	    }
	  }]);
	
	  return CheckboxList;
	}(_react2.default.Component);
	
	CheckboxList.defaultProps = {
	  checkboxAlignment: 'default',
	  showRowDividers: false,
	  direction: 'vertical'
	};
	CheckboxList.displayName = 'CheckboxList';
	exports.default = CheckboxList;

/***/ },
/* 1468 */
1136,
/* 1469 */,
/* 1470 */
1136,
/* 1471 */,
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d35468e70047afb9bd86ac00dba2a561.svg";

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SetupConstants = __webpack_require__(1046);
	
	var _Dispatcher = __webpack_require__(590);
	
	var SetupActions = {
	  joinGroupDuringSetup: function joinGroupDuringSetup() {
	    _Dispatcher.dispatcher.dispatch({
	      type: _SetupConstants.ActionTypes.JOIN_CLASS_FOR_SETUP_SESSION
	    });
	  },
	  removeFlagsForSetupSession: function removeFlagsForSetupSession() {
	    _Dispatcher.dispatcher.dispatch({
	      type: _SetupConstants.ActionTypes.REMOVE_FLAGS_FOR_SETUP_SESSION
	    });
	  }
	};
	
	exports.default = SetupActions;

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _papaparse = __webpack_require__(1475);
	
	var _papaparse2 = _interopRequireDefault(_papaparse);
	
	var _ParticipantsTableInputRow = __webpack_require__(1476);
	
	var _ParticipantsTableInputRow2 = _interopRequireDefault(_ParticipantsTableInputRow);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1480);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// TODO: referencing non-component stylesheet
	
	
	var padRows = function padRows(rows, minimumRows) {
	  var filledRows = rows.filter(function (row) {
	    return row;
	  });
	  var emptyRowCount = minimumRows - filledRows.length;
	  _lodash2.default.times(emptyRowCount, function () {
	    return rows.push({ name: '', uid: '' });
	  });
	  return rows;
	};
	
	var ParticipantsTableInput = function (_Component) {
	  _inherits(ParticipantsTableInput, _Component);
	
	  function ParticipantsTableInput(props) {
	    _classCallCheck(this, ParticipantsTableInput);
	
	    var _this = _possibleConstructorReturn(this, (ParticipantsTableInput.__proto__ || Object.getPrototypeOf(ParticipantsTableInput)).call(this, props));
	
	    _this.onPaste = function (e) {
	      var rows = [];
	      var pastedText = void 0;
	
	      try {
	        pastedText = e.clipboardData.getData('text/plain');
	      } catch (ex) {
	        // IE 11 (but not Edge) requires 'Text' data type
	        pastedText = e.clipboardData.getData('Text');
	      }
	      if (!pastedText) {
	        return false;
	      }
	
	      _papaparse2.default.parse(pastedText).data.forEach(function (row) {
	        var isSingleColumn = row.length === 1 && row[0].trim().length > 0;
	        if (isSingleColumn) {
	          // treat the values as uids
	          rows.push({
	            name: '',
	            uid: row[0].trim(),
	            valid: false,
	            pasted: true
	          });
	        } else if (row[0] || row[1]) {
	          rows.push({
	            name: row[0] ? row[0].trim() : '',
	            uid: row[1] ? row[1].trim() : '',
	            valid: false,
	            pasted: true
	          });
	        }
	      });
	
	      // If there are no rows or only a single value in a single row, use default paste behavior
	      if (rows.length === 0 || rows.length === 1 && (!rows[0].name || !rows[0].uid)) {
	        return false;
	      }
	
	      rows = _this.state.rows.filter(function (row) {
	        return row.name || row.uid;
	      }).concat(rows.filter(function (row) {
	        return row.name !== 'full name';
	      }));
	
	      rows = _lodash2.default.uniqBy(rows, 'uid');
	
	      // If the total is gte 5 we can display without scrolling
	      // append an empty row
	      if (rows.length >= _this.props.minimumRows) {
	        rows.push({
	          name: '',
	          uid: ''
	        });
	      }
	
	      var paddedRows = padRows(rows, _this.props.minimumRows);
	      _this.setState({ rows: paddedRows });
	      if (_this.props.onChangeRow) {
	        _this.props.onChangeRow(paddedRows);
	      }
	      return true;
	    };
	
	    _this.onValidityChange = function (rowIndex, valid) {
	      var rows = _this.state.rows.slice(0);
	      var row = rows[rowIndex];
	
	      if (!row || !!row.valid === valid) {
	        return;
	      }
	
	      if (row) {
	        row.valid = valid;
	        row.pasted = false;
	      }
	
	      _this.setState({ rows: rows });
	      if (_this.props.onChangeRow) {
	        _this.props.onChangeRow(rows);
	      }
	    };
	
	    _this.onChange = function (rowIndex, name, event) {
	      var rows = _this.state.rows;
	
	      var row = rows[rowIndex];
	
	      row[name] = event.target.value;
	      row.pasted = false;
	      if (row.serverErrors) {
	        delete row.serverErrors[name];
	      }
	
	      var shouldScroll = false;
	
	      // remove empty row if over minimumRows
	      var rowCount = _this.state.rows.length;
	      var _this$props = _this.props,
	          minimumRows = _this$props.minimumRows,
	          maximumRows = _this$props.maximumRows;
	
	
	      if (rows.filter(function (r) {
	        return r;
	      }).length > minimumRows && !row.uid && !row.name) {
	        delete rows[rowIndex];
	      } else {
	        if (rowIndex === rowCount - 1) {
	          // If an edit is being made in the last row
	          if (!maximumRows || maximumRows && rowCount < maximumRows) {
	            rows.push({
	              name: '',
	              uid: '',
	              valid: false
	            }); // Push another blank row
	            shouldScroll = true;
	          }
	        }
	      }
	
	      var paddedRows = padRows(rows, _this.props.minimumRows);
	
	      _this.setState({ paddedRows: paddedRows, shouldScroll: shouldScroll });
	      if (_this.props.onChangeRow) {
	        _this.props.onChangeRow(paddedRows);
	      }
	    };
	
	    _this.state = {
	      rows: padRows(_this.props.initialRows, _this.props.minimumRows),
	      shouldScroll: false
	    };
	    return _this;
	  }
	
	  _createClass(ParticipantsTableInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // So that setting initialRows in the parent of this component will
	      // overwrite the rows stored in this component's state
	      // in order to show server errors and remove rows
	      if (JSON.stringify(this.state.rows) !== JSON.stringify(nextProps.initialRows)) {
	        this.setState({ rows: padRows(nextProps.initialRows, this.props.minimumRows) });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.shouldScroll) {
	        var tableContainer = this.refs.tableContainer;
	
	        tableContainer.scrollTop = tableContainer.scrollHeight;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          supportSms = _props.supportSms,
	          uidColumnHeader = _props.uidColumnHeader,
	          showColumnHeaders = _props.showColumnHeaders,
	          placeholders = _props.placeholders;
	
	
	      var namePlaceholders = this.props.namePlaceholders || ['Jane Doe', 'Alice Smith', 'John Doe', 'Bob Johnson', 'Art Vandelay'];
	
	      var title = void 0;
	      if (uidColumnHeader) {
	        title = uidColumnHeader;
	      } else {
	        title = supportSms ? 'Email address or phone number' : 'Email address';
	      }
	
	      var uidPlaceholders = void 0;
	      if (placeholders) {
	        uidPlaceholders = placeholders;
	      } else {
	        uidPlaceholders = ['name@email.com'];
	        if (supportSms) {
	          uidPlaceholders.push('(555) 555-5555');
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('TableInput', this.props.className), onPaste: this.onPaste },
	        showColumnHeaders && _react2.default.createElement(
	          'header',
	          { className: 'TableInput-headerRow' },
	          _react2.default.createElement('span', { className: 'TableInput-cell--validation TableInput-cell' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'TableInput-headerRow-cell TableInput-cell' },
	            'Full name'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'TableInput-headerRow-cell TableInput-cell' },
	            title
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)({ 'TableInput-container': this.props.scroll }), ref: 'tableContainer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'TableInput-body' },
	            this.state.rows.map(function (row, rowIndex) {
	              return _react2.default.createElement(_ParticipantsTableInputRow2.default, {
	                key: 'row-' + rowIndex,
	                groupId: _this2.props.groupId,
	                name: row.name.trim(),
	                namePlaceholder: namePlaceholders[rowIndex % namePlaceholders.length],
	                uid: row.uid.trim(),
	                uidPlaceholder: uidPlaceholders[rowIndex % uidPlaceholders.length],
	                validateInitialValues: row.pasted,
	                onValidityChange: _this2.onValidityChange.bind(_this2, rowIndex),
	                onChange: _this2.onChange.bind(_this2, rowIndex),
	                serverErrors: row.serverErrors,
	                parsePasteWith: _this2.onPaste,
	                autofocus: rowIndex === 0
	              });
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ParticipantsTableInput;
	}(_react.Component);
	
	ParticipantsTableInput.defaultProps = {
	  initialRows: [],
	  minimumRows: 5,
	  scroll: true,
	  showColumnHeaders: true
	};
	ParticipantsTableInput.displayName = 'ParticipantsTableInput';
	exports.default = ParticipantsTableInput;

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Papa Parse
		v4.1.2
		https://github.com/mholt/PapaParse
	*/
	(function(global)
	{
		"use strict";
	
		var IS_WORKER = !global.document && !!global.postMessage,
			IS_PAPA_WORKER = IS_WORKER && /(\?|&)papaworker(=|&|$)/.test(global.location.search),
			LOADED_SYNC = false, AUTO_SCRIPT_PATH;
		var workers = {}, workerIdCounter = 0;
	
		var Papa = {};
	
		Papa.parse = CsvToJson;
		Papa.unparse = JsonToCsv;
	
		Papa.RECORD_SEP = String.fromCharCode(30);
		Papa.UNIT_SEP = String.fromCharCode(31);
		Papa.BYTE_ORDER_MARK = "\ufeff";
		Papa.BAD_DELIMITERS = ["\r", "\n", "\"", Papa.BYTE_ORDER_MARK];
		Papa.WORKERS_SUPPORTED = !IS_WORKER && !!global.Worker;
		Papa.SCRIPT_PATH = null;	// Must be set by your code if you use workers and this lib is loaded asynchronously
	
		// Configurable chunk sizes for local and remote files, respectively
		Papa.LocalChunkSize = 1024 * 1024 * 10;	// 10 MB
		Papa.RemoteChunkSize = 1024 * 1024 * 5;	// 5 MB
		Papa.DefaultDelimiter = ",";			// Used if not specified and detection fails
	
		// Exposed for testing and development only
		Papa.Parser = Parser;
		Papa.ParserHandle = ParserHandle;
		Papa.NetworkStreamer = NetworkStreamer;
		Papa.FileStreamer = FileStreamer;
		Papa.StringStreamer = StringStreamer;
	
		if (typeof module !== 'undefined' && module.exports)
		{
			// Export to Node...
			module.exports = Papa;
		}
		else if (isFunction(global.define) && global.define.amd)
		{
			// Wireup with RequireJS
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return Papa; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else
		{
			// ...or as browser global
			global.Papa = Papa;
		}
	
		if (global.jQuery)
		{
			var $ = global.jQuery;
			$.fn.parse = function(options)
			{
				var config = options.config || {};
				var queue = [];
	
				this.each(function(idx)
				{
					var supported = $(this).prop('tagName').toUpperCase() == "INPUT"
									&& $(this).attr('type').toLowerCase() == "file"
									&& global.FileReader;
	
					if (!supported || !this.files || this.files.length == 0)
						return true;	// continue to next input element
	
					for (var i = 0; i < this.files.length; i++)
					{
						queue.push({
							file: this.files[i],
							inputElem: this,
							instanceConfig: $.extend({}, config)
						});
					}
				});
	
				parseNextFile();	// begin parsing
				return this;		// maintains chainability
	
	
				function parseNextFile()
				{
					if (queue.length == 0)
					{
						if (isFunction(options.complete))
							options.complete();
						return;
					}
	
					var f = queue[0];
	
					if (isFunction(options.before))
					{
						var returned = options.before(f.file, f.inputElem);
	
						if (typeof returned === 'object')
						{
							if (returned.action == "abort")
							{
								error("AbortError", f.file, f.inputElem, returned.reason);
								return;	// Aborts all queued files immediately
							}
							else if (returned.action == "skip")
							{
								fileComplete();	// parse the next file in the queue, if any
								return;
							}
							else if (typeof returned.config === 'object')
								f.instanceConfig = $.extend(f.instanceConfig, returned.config);
						}
						else if (returned == "skip")
						{
							fileComplete();	// parse the next file in the queue, if any
							return;
						}
					}
	
					// Wrap up the user's complete callback, if any, so that ours also gets executed
					var userCompleteFunc = f.instanceConfig.complete;
					f.instanceConfig.complete = function(results)
					{
						if (isFunction(userCompleteFunc))
							userCompleteFunc(results, f.file, f.inputElem);
						fileComplete();
					};
	
					Papa.parse(f.file, f.instanceConfig);
				}
	
				function error(name, file, elem, reason)
				{
					if (isFunction(options.error))
						options.error({name: name}, file, elem, reason);
				}
	
				function fileComplete()
				{
					queue.splice(0, 1);
					parseNextFile();
				}
			}
		}
	
	
		if (IS_PAPA_WORKER)
		{
			global.onmessage = workerThreadReceivedMessage;
		}
		else if (Papa.WORKERS_SUPPORTED)
		{
			AUTO_SCRIPT_PATH = getScriptPath();
	
			// Check if the script was loaded synchronously
			if (!document.body)
			{
				// Body doesn't exist yet, must be synchronous
				LOADED_SYNC = true;
			}
			else
			{
				document.addEventListener('DOMContentLoaded', function () {
					LOADED_SYNC = true;
				}, true);
			}
		}
	
	
	
	
		function CsvToJson(_input, _config)
		{
			_config = _config || {};
	
			if (_config.worker && Papa.WORKERS_SUPPORTED)
			{
				var w = newWorker();
	
				w.userStep = _config.step;
				w.userChunk = _config.chunk;
				w.userComplete = _config.complete;
				w.userError = _config.error;
	
				_config.step = isFunction(_config.step);
				_config.chunk = isFunction(_config.chunk);
				_config.complete = isFunction(_config.complete);
				_config.error = isFunction(_config.error);
				delete _config.worker;	// prevent infinite loop
	
				w.postMessage({
					input: _input,
					config: _config,
					workerId: w.id
				});
	
				return;
			}
	
			var streamer = null;
			if (typeof _input === 'string')
			{
				if (_config.download)
					streamer = new NetworkStreamer(_config);
				else
					streamer = new StringStreamer(_config);
			}
			else if ((global.File && _input instanceof File) || _input instanceof Object)	// ...Safari. (see issue #106)
				streamer = new FileStreamer(_config);
	
			return streamer.stream(_input);
		}
	
	
	
	
	
	
		function JsonToCsv(_input, _config)
		{
			var _output = "";
			var _fields = [];
	
			// Default configuration
	
			/** whether to surround every datum with quotes */
			var _quotes = false;
	
			/** delimiting character */
			var _delimiter = ",";
	
			/** newline character(s) */
			var _newline = "\r\n";
	
			unpackConfig();
	
			if (typeof _input === 'string')
				_input = JSON.parse(_input);
	
			if (_input instanceof Array)
			{
				if (!_input.length || _input[0] instanceof Array)
					return serialize(null, _input);
				else if (typeof _input[0] === 'object')
					return serialize(objectKeys(_input[0]), _input);
			}
			else if (typeof _input === 'object')
			{
				if (typeof _input.data === 'string')
					_input.data = JSON.parse(_input.data);
	
				if (_input.data instanceof Array)
				{
					if (!_input.fields)
						_input.fields = _input.data[0] instanceof Array
										? _input.fields
										: objectKeys(_input.data[0]);
	
					if (!(_input.data[0] instanceof Array) && typeof _input.data[0] !== 'object')
						_input.data = [_input.data];	// handles input like [1,2,3] or ["asdf"]
				}
	
				return serialize(_input.fields || [], _input.data || []);
			}
	
			// Default (any valid paths should return before this)
			throw "exception: Unable to serialize unrecognized input";
	
	
			function unpackConfig()
			{
				if (typeof _config !== 'object')
					return;
	
				if (typeof _config.delimiter === 'string'
					&& _config.delimiter.length == 1
					&& Papa.BAD_DELIMITERS.indexOf(_config.delimiter) == -1)
				{
					_delimiter = _config.delimiter;
				}
	
				if (typeof _config.quotes === 'boolean'
					|| _config.quotes instanceof Array)
					_quotes = _config.quotes;
	
				if (typeof _config.newline === 'string')
					_newline = _config.newline;
			}
	
	
			/** Turns an object's keys into an array */
			function objectKeys(obj)
			{
				if (typeof obj !== 'object')
					return [];
				var keys = [];
				for (var key in obj)
					keys.push(key);
				return keys;
			}
	
			/** The double for loop that iterates the data and writes out a CSV string including header row */
			function serialize(fields, data)
			{
				var csv = "";
	
				if (typeof fields === 'string')
					fields = JSON.parse(fields);
				if (typeof data === 'string')
					data = JSON.parse(data);
	
				var hasHeader = fields instanceof Array && fields.length > 0;
				var dataKeyedByField = !(data[0] instanceof Array);
	
				// If there a header row, write it first
				if (hasHeader)
				{
					for (var i = 0; i < fields.length; i++)
					{
						if (i > 0)
							csv += _delimiter;
						csv += safe(fields[i], i);
					}
					if (data.length > 0)
						csv += _newline;
				}
	
				// Then write out the data
				for (var row = 0; row < data.length; row++)
				{
					var maxCol = hasHeader ? fields.length : data[row].length;
	
					for (var col = 0; col < maxCol; col++)
					{
						if (col > 0)
							csv += _delimiter;
						var colIdx = hasHeader && dataKeyedByField ? fields[col] : col;
						csv += safe(data[row][colIdx], col);
					}
	
					if (row < data.length - 1)
						csv += _newline;
				}
	
				return csv;
			}
	
			/** Encloses a value around quotes if needed (makes a value safe for CSV insertion) */
			function safe(str, col)
			{
				if (typeof str === "undefined" || str === null)
					return "";
	
				str = str.toString().replace(/"/g, '""');
	
				var needsQuotes = (typeof _quotes === 'boolean' && _quotes)
								|| (_quotes instanceof Array && _quotes[col])
								|| hasAny(str, Papa.BAD_DELIMITERS)
								|| str.indexOf(_delimiter) > -1
								|| str.charAt(0) == ' '
								|| str.charAt(str.length - 1) == ' ';
	
				return needsQuotes ? '"' + str + '"' : str;
			}
	
			function hasAny(str, substrings)
			{
				for (var i = 0; i < substrings.length; i++)
					if (str.indexOf(substrings[i]) > -1)
						return true;
				return false;
			}
		}
	
		/** ChunkStreamer is the base prototype for various streamer implementations. */
		function ChunkStreamer(config)
		{
			this._handle = null;
			this._paused = false;
			this._finished = false;
			this._input = null;
			this._baseIndex = 0;
			this._partialLine = "";
			this._rowCount = 0;
			this._start = 0;
			this._nextChunk = null;
			this.isFirstChunk = true;
			this._completeResults = {
				data: [],
				errors: [],
				meta: {}
			};
			replaceConfig.call(this, config);
	
			this.parseChunk = function(chunk)
			{
				// First chunk pre-processing
				if (this.isFirstChunk && isFunction(this._config.beforeFirstChunk))
				{
					var modifiedChunk = this._config.beforeFirstChunk(chunk);
					if (modifiedChunk !== undefined)
						chunk = modifiedChunk;
				}
				this.isFirstChunk = false;
	
				// Rejoin the line we likely just split in two by chunking the file
				var aggregate = this._partialLine + chunk;
				this._partialLine = "";
	
				var results = this._handle.parse(aggregate, this._baseIndex, !this._finished);
				
				if (this._handle.paused() || this._handle.aborted())
					return;
				
				var lastIndex = results.meta.cursor;
				
				if (!this._finished)
				{
					this._partialLine = aggregate.substring(lastIndex - this._baseIndex);
					this._baseIndex = lastIndex;
				}
	
				if (results && results.data)
					this._rowCount += results.data.length;
	
				var finishedIncludingPreview = this._finished || (this._config.preview && this._rowCount >= this._config.preview);
	
				if (IS_PAPA_WORKER)
				{
					global.postMessage({
						results: results,
						workerId: Papa.WORKER_ID,
						finished: finishedIncludingPreview
					});
				}
				else if (isFunction(this._config.chunk))
				{
					this._config.chunk(results, this._handle);
					if (this._paused)
						return;
					results = undefined;
					this._completeResults = undefined;
				}
	
				if (!this._config.step && !this._config.chunk) {
					this._completeResults.data = this._completeResults.data.concat(results.data);
					this._completeResults.errors = this._completeResults.errors.concat(results.errors);
					this._completeResults.meta = results.meta;
				}
	
				if (finishedIncludingPreview && isFunction(this._config.complete) && (!results || !results.meta.aborted))
					this._config.complete(this._completeResults);
	
				if (!finishedIncludingPreview && (!results || !results.meta.paused))
					this._nextChunk();
	
				return results;
			};
	
			this._sendError = function(error)
			{
				if (isFunction(this._config.error))
					this._config.error(error);
				else if (IS_PAPA_WORKER && this._config.error)
				{
					global.postMessage({
						workerId: Papa.WORKER_ID,
						error: error,
						finished: false
					});
				}
			};
	
			function replaceConfig(config)
			{
				// Deep-copy the config so we can edit it
				var configCopy = copy(config);
				configCopy.chunkSize = parseInt(configCopy.chunkSize);	// parseInt VERY important so we don't concatenate strings!
				if (!config.step && !config.chunk)
					configCopy.chunkSize = null;  // disable Range header if not streaming; bad values break IIS - see issue #196
				this._handle = new ParserHandle(configCopy);
				this._handle.streamer = this;
				this._config = configCopy;	// persist the copy to the caller
			}
		}
	
	
		function NetworkStreamer(config)
		{
			config = config || {};
			if (!config.chunkSize)
				config.chunkSize = Papa.RemoteChunkSize;
			ChunkStreamer.call(this, config);
	
			var xhr;
	
			if (IS_WORKER)
			{
				this._nextChunk = function()
				{
					this._readChunk();
					this._chunkLoaded();
				};
			}
			else
			{
				this._nextChunk = function()
				{
					this._readChunk();
				};
			}
	
			this.stream = function(url)
			{
				this._input = url;
				this._nextChunk();	// Starts streaming
			};
	
			this._readChunk = function()
			{
				if (this._finished)
				{
					this._chunkLoaded();
					return;
				}
	
				xhr = new XMLHttpRequest();
				
				if (!IS_WORKER)
				{
					xhr.onload = bindFunction(this._chunkLoaded, this);
					xhr.onerror = bindFunction(this._chunkError, this);
				}
	
				xhr.open("GET", this._input, !IS_WORKER);
				
				if (this._config.chunkSize)
				{
					var end = this._start + this._config.chunkSize - 1;	// minus one because byte range is inclusive
					xhr.setRequestHeader("Range", "bytes="+this._start+"-"+end);
					xhr.setRequestHeader("If-None-Match", "webkit-no-cache"); // https://bugs.webkit.org/show_bug.cgi?id=82672
				}
	
				try {
					xhr.send();
				}
				catch (err) {
					this._chunkError(err.message);
				}
	
				if (IS_WORKER && xhr.status == 0)
					this._chunkError();
				else
					this._start += this._config.chunkSize;
			}
	
			this._chunkLoaded = function()
			{
				if (xhr.readyState != 4)
					return;
	
				if (xhr.status < 200 || xhr.status >= 400)
				{
					this._chunkError();
					return;
				}
	
				this._finished = !this._config.chunkSize || this._start > getFileSize(xhr);
				this.parseChunk(xhr.responseText);
			}
	
			this._chunkError = function(errorMessage)
			{
				var errorText = xhr.statusText || errorMessage;
				this._sendError(errorText);
			}
	
			function getFileSize(xhr)
			{
				var contentRange = xhr.getResponseHeader("Content-Range");
				return parseInt(contentRange.substr(contentRange.lastIndexOf("/") + 1));
			}
		}
		NetworkStreamer.prototype = Object.create(ChunkStreamer.prototype);
		NetworkStreamer.prototype.constructor = NetworkStreamer;
	
	
		function FileStreamer(config)
		{
			config = config || {};
			if (!config.chunkSize)
				config.chunkSize = Papa.LocalChunkSize;
			ChunkStreamer.call(this, config);
	
			var reader, slice;
	
			// FileReader is better than FileReaderSync (even in worker) - see http://stackoverflow.com/q/24708649/1048862
			// But Firefox is a pill, too - see issue #76: https://github.com/mholt/PapaParse/issues/76
			var usingAsyncReader = typeof FileReader !== 'undefined';	// Safari doesn't consider it a function - see issue #105
	
			this.stream = function(file)
			{
				this._input = file;
				slice = file.slice || file.webkitSlice || file.mozSlice;
	
				if (usingAsyncReader)
				{
					reader = new FileReader();		// Preferred method of reading files, even in workers
					reader.onload = bindFunction(this._chunkLoaded, this);
					reader.onerror = bindFunction(this._chunkError, this);
				}
				else
					reader = new FileReaderSync();	// Hack for running in a web worker in Firefox
	
				this._nextChunk();	// Starts streaming
			};
	
			this._nextChunk = function()
			{
				if (!this._finished && (!this._config.preview || this._rowCount < this._config.preview))
					this._readChunk();
			}
	
			this._readChunk = function()
			{
				var input = this._input;
				if (this._config.chunkSize)
				{
					var end = Math.min(this._start + this._config.chunkSize, this._input.size);
					input = slice.call(input, this._start, end);
				}
				var txt = reader.readAsText(input, this._config.encoding);
				if (!usingAsyncReader)
					this._chunkLoaded({ target: { result: txt } });	// mimic the async signature
			}
	
			this._chunkLoaded = function(event)
			{
				// Very important to increment start each time before handling results
				this._start += this._config.chunkSize;
				this._finished = !this._config.chunkSize || this._start >= this._input.size;
				this.parseChunk(event.target.result);
			}
	
			this._chunkError = function()
			{
				this._sendError(reader.error);
			}
	
		}
		FileStreamer.prototype = Object.create(ChunkStreamer.prototype);
		FileStreamer.prototype.constructor = FileStreamer;
	
	
		function StringStreamer(config)
		{
			config = config || {};
			ChunkStreamer.call(this, config);
	
			var string;
			var remaining;
			this.stream = function(s)
			{
				string = s;
				remaining = s;
				return this._nextChunk();
			}
			this._nextChunk = function()
			{
				if (this._finished) return;
				var size = this._config.chunkSize;
				var chunk = size ? remaining.substr(0, size) : remaining;
				remaining = size ? remaining.substr(size) : '';
				this._finished = !remaining;
				return this.parseChunk(chunk);
			}
		}
		StringStreamer.prototype = Object.create(StringStreamer.prototype);
		StringStreamer.prototype.constructor = StringStreamer;
	
	
	
		// Use one ParserHandle per entire CSV file or string
		function ParserHandle(_config)
		{
			// One goal is to minimize the use of regular expressions...
			var FLOAT = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i;
	
			var self = this;
			var _stepCounter = 0;	// Number of times step was called (number of rows parsed)
			var _input;				// The input being parsed
			var _parser;			// The core parser being used
			var _paused = false;	// Whether we are paused or not
			var _aborted = false;   // Whether the parser has aborted or not
			var _delimiterError;	// Temporary state between delimiter detection and processing results
			var _fields = [];		// Fields are from the header row of the input, if there is one
			var _results = {		// The last results returned from the parser
				data: [],
				errors: [],
				meta: {}
			};
	
			if (isFunction(_config.step))
			{
				var userStep = _config.step;
				_config.step = function(results)
				{
					_results = results;
	
					if (needsHeaderRow())
						processResults();
					else	// only call user's step function after header row
					{
						processResults();
	
						// It's possbile that this line was empty and there's no row here after all
						if (_results.data.length == 0)
							return;
	
						_stepCounter += results.data.length;
						if (_config.preview && _stepCounter > _config.preview)
							_parser.abort();
						else
							userStep(_results, self);
					}
				};
			}
	
			/**
			 * Parses input. Most users won't need, and shouldn't mess with, the baseIndex
			 * and ignoreLastRow parameters. They are used by streamers (wrapper functions)
			 * when an input comes in multiple chunks, like from a file.
			 */
			this.parse = function(input, baseIndex, ignoreLastRow)
			{
				if (!_config.newline)
					_config.newline = guessLineEndings(input);
	
				_delimiterError = false;
				if (!_config.delimiter)
				{
					var delimGuess = guessDelimiter(input);
					if (delimGuess.successful)
						_config.delimiter = delimGuess.bestDelimiter;
					else
					{
						_delimiterError = true;	// add error after parsing (otherwise it would be overwritten)
						_config.delimiter = Papa.DefaultDelimiter;
					}
					_results.meta.delimiter = _config.delimiter;
				}
	
				var parserConfig = copy(_config);
				if (_config.preview && _config.header)
					parserConfig.preview++;	// to compensate for header row
	
				_input = input;
				_parser = new Parser(parserConfig);
				_results = _parser.parse(_input, baseIndex, ignoreLastRow);
				processResults();
				return _paused ? { meta: { paused: true } } : (_results || { meta: { paused: false } });
			};
	
			this.paused = function()
			{
				return _paused;
			};
	
			this.pause = function()
			{
				_paused = true;
				_parser.abort();
				_input = _input.substr(_parser.getCharIndex());
			};
	
			this.resume = function()
			{
				_paused = false;
				self.streamer.parseChunk(_input);
			};
	
			this.aborted = function () {
				return _aborted;
			}
	
			this.abort = function()
			{
				_aborted = true;
				_parser.abort();
				_results.meta.aborted = true;
				if (isFunction(_config.complete))
					_config.complete(_results);
				_input = "";
			};
	
			function processResults()
			{
				if (_results && _delimiterError)
				{
					addError("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '"+Papa.DefaultDelimiter+"'");
					_delimiterError = false;
				}
	
				if (_config.skipEmptyLines)
				{
					for (var i = 0; i < _results.data.length; i++)
						if (_results.data[i].length == 1 && _results.data[i][0] == "")
							_results.data.splice(i--, 1);
				}
	
				if (needsHeaderRow())
					fillHeaderFields();
	
				return applyHeaderAndDynamicTyping();
			}
	
			function needsHeaderRow()
			{
				return _config.header && _fields.length == 0;
			}
	
			function fillHeaderFields()
			{
				if (!_results)
					return;
				for (var i = 0; needsHeaderRow() && i < _results.data.length; i++)
					for (var j = 0; j < _results.data[i].length; j++)
						_fields.push(_results.data[i][j]);
				_results.data.splice(0, 1);
			}
	
			function applyHeaderAndDynamicTyping()
			{
				if (!_results || (!_config.header && !_config.dynamicTyping))
					return _results;
	
				for (var i = 0; i < _results.data.length; i++)
				{
					var row = {};
	
					for (var j = 0; j < _results.data[i].length; j++)
					{
						if (_config.dynamicTyping)
						{
							var value = _results.data[i][j];
							if (value == "true" || value == "TRUE")
								_results.data[i][j] = true;
							else if (value == "false" || value == "FALSE")
								_results.data[i][j] = false;
							else
								_results.data[i][j] = tryParseFloat(value);
						}
	
						if (_config.header)
						{
							if (j >= _fields.length)
							{
								if (!row["__parsed_extra"])
									row["__parsed_extra"] = [];
								row["__parsed_extra"].push(_results.data[i][j]);
							}
							else
								row[_fields[j]] = _results.data[i][j];
						}
					}
	
					if (_config.header)
					{
						_results.data[i] = row;
						if (j > _fields.length)
							addError("FieldMismatch", "TooManyFields", "Too many fields: expected " + _fields.length + " fields but parsed " + j, i);
						else if (j < _fields.length)
							addError("FieldMismatch", "TooFewFields", "Too few fields: expected " + _fields.length + " fields but parsed " + j, i);
					}
				}
	
				if (_config.header && _results.meta)
					_results.meta.fields = _fields;
				return _results;
			}
	
			function guessDelimiter(input)
			{
				var delimChoices = [",", "\t", "|", ";", Papa.RECORD_SEP, Papa.UNIT_SEP];
				var bestDelim, bestDelta, fieldCountPrevRow;
	
				for (var i = 0; i < delimChoices.length; i++)
				{
					var delim = delimChoices[i];
					var delta = 0, avgFieldCount = 0;
					fieldCountPrevRow = undefined;
	
					var preview = new Parser({
						delimiter: delim,
						preview: 10
					}).parse(input);
	
					for (var j = 0; j < preview.data.length; j++)
					{
						var fieldCount = preview.data[j].length;
						avgFieldCount += fieldCount;
	
						if (typeof fieldCountPrevRow === 'undefined')
						{
							fieldCountPrevRow = fieldCount;
							continue;
						}
						else if (fieldCount > 1)
						{
							delta += Math.abs(fieldCount - fieldCountPrevRow);
							fieldCountPrevRow = fieldCount;
						}
					}
	
					if (preview.data.length > 0)
						avgFieldCount /= preview.data.length;
	
					if ((typeof bestDelta === 'undefined' || delta < bestDelta)
						&& avgFieldCount > 1.99)
					{
						bestDelta = delta;
						bestDelim = delim;
					}
				}
	
				_config.delimiter = bestDelim;
	
				return {
					successful: !!bestDelim,
					bestDelimiter: bestDelim
				}
			}
	
			function guessLineEndings(input)
			{
				input = input.substr(0, 1024*1024);	// max length 1 MB
	
				var r = input.split('\r');
	
				if (r.length == 1)
					return '\n';
	
				var numWithN = 0;
				for (var i = 0; i < r.length; i++)
				{
					if (r[i][0] == '\n')
						numWithN++;
				}
	
				return numWithN >= r.length / 2 ? '\r\n' : '\r';
			}
	
			function tryParseFloat(val)
			{
				var isNumber = FLOAT.test(val);
				return isNumber ? parseFloat(val) : val;
			}
	
			function addError(type, code, msg, row)
			{
				_results.errors.push({
					type: type,
					code: code,
					message: msg,
					row: row
				});
			}
		}
	
	
	
	
	
		/** The core parser implements speedy and correct CSV parsing */
		function Parser(config)
		{
			// Unpack the config object
			config = config || {};
			var delim = config.delimiter;
			var newline = config.newline;
			var comments = config.comments;
			var step = config.step;
			var preview = config.preview;
			var fastMode = config.fastMode;
	
			// Delimiter must be valid
			if (typeof delim !== 'string'
				|| Papa.BAD_DELIMITERS.indexOf(delim) > -1)
				delim = ",";
	
			// Comment character must be valid
			if (comments === delim)
				throw "Comment character same as delimiter";
			else if (comments === true)
				comments = "#";
			else if (typeof comments !== 'string'
				|| Papa.BAD_DELIMITERS.indexOf(comments) > -1)
				comments = false;
	
			// Newline must be valid: \r, \n, or \r\n
			if (newline != '\n' && newline != '\r' && newline != '\r\n')
				newline = '\n';
	
			// We're gonna need these at the Parser scope
			var cursor = 0;
			var aborted = false;
	
			this.parse = function(input, baseIndex, ignoreLastRow)
			{
				// For some reason, in Chrome, this speeds things up (!?)
				if (typeof input !== 'string')
					throw "Input must be a string";
	
				// We don't need to compute some of these every time parse() is called,
				// but having them in a more local scope seems to perform better
				var inputLen = input.length,
					delimLen = delim.length,
					newlineLen = newline.length,
					commentsLen = comments.length;
				var stepIsFunction = typeof step === 'function';
	
				// Establish starting state
				cursor = 0;
				var data = [], errors = [], row = [], lastCursor = 0;
	
				if (!input)
					return returnable();
	
				if (fastMode || (fastMode !== false && input.indexOf('"') === -1))
				{
					var rows = input.split(newline);
					for (var i = 0; i < rows.length; i++)
					{
						var row = rows[i];
						cursor += row.length;
						if (i !== rows.length - 1)
							cursor += newline.length;
						else if (ignoreLastRow)
							return returnable();
						if (comments && row.substr(0, commentsLen) == comments)
							continue;
						if (stepIsFunction)
						{
							data = [];
							pushRow(row.split(delim));
							doStep();
							if (aborted)
								return returnable();
						}
						else
							pushRow(row.split(delim));
						if (preview && i >= preview)
						{
							data = data.slice(0, preview);
							return returnable(true);
						}
					}
					return returnable();
				}
	
				var nextDelim = input.indexOf(delim, cursor);
				var nextNewline = input.indexOf(newline, cursor);
	
				// Parser loop
				for (;;)
				{
					// Field has opening quote
					if (input[cursor] == '"')
					{
						// Start our search for the closing quote where the cursor is
						var quoteSearch = cursor;
	
						// Skip the opening quote
						cursor++;
	
						for (;;)
						{
							// Find closing quote
							var quoteSearch = input.indexOf('"', quoteSearch+1);
	
							if (quoteSearch === -1)
							{
								if (!ignoreLastRow) {
									// No closing quote... what a pity
									errors.push({
										type: "Quotes",
										code: "MissingQuotes",
										message: "Quoted field unterminated",
										row: data.length,	// row has yet to be inserted
										index: cursor
									});
								}
								return finish();
							}
	
							if (quoteSearch === inputLen-1)
							{
								// Closing quote at EOF
								var value = input.substring(cursor, quoteSearch).replace(/""/g, '"');
								return finish(value);
							}
	
							// If this quote is escaped, it's part of the data; skip it
							if (input[quoteSearch+1] == '"')
							{
								quoteSearch++;
								continue;
							}
	
							if (input[quoteSearch+1] == delim)
							{
								// Closing quote followed by delimiter
								row.push(input.substring(cursor, quoteSearch).replace(/""/g, '"'));
								cursor = quoteSearch + 1 + delimLen;
								nextDelim = input.indexOf(delim, cursor);
								nextNewline = input.indexOf(newline, cursor);
								break;
							}
	
							if (input.substr(quoteSearch+1, newlineLen) === newline)
							{
								// Closing quote followed by newline
								row.push(input.substring(cursor, quoteSearch).replace(/""/g, '"'));
								saveRow(quoteSearch + 1 + newlineLen);
								nextDelim = input.indexOf(delim, cursor);	// because we may have skipped the nextDelim in the quoted field
	
								if (stepIsFunction)
								{
									doStep();
									if (aborted)
										return returnable();
								}
								
								if (preview && data.length >= preview)
									return returnable(true);
	
								break;
							}
						}
	
						continue;
					}
	
					// Comment found at start of new line
					if (comments && row.length === 0 && input.substr(cursor, commentsLen) === comments)
					{
						if (nextNewline == -1)	// Comment ends at EOF
							return returnable();
						cursor = nextNewline + newlineLen;
						nextNewline = input.indexOf(newline, cursor);
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// Next delimiter comes before next newline, so we've reached end of field
					if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1))
					{
						row.push(input.substring(cursor, nextDelim));
						cursor = nextDelim + delimLen;
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// End of row
					if (nextNewline !== -1)
					{
						row.push(input.substring(cursor, nextNewline));
						saveRow(nextNewline + newlineLen);
	
						if (stepIsFunction)
						{
							doStep();
							if (aborted)
								return returnable();
						}
	
						if (preview && data.length >= preview)
							return returnable(true);
	
						continue;
					}
	
					break;
				}
	
	
				return finish();
	
	
				function pushRow(row)
				{
					data.push(row);
					lastCursor = cursor;
				}
	
				/**
				 * Appends the remaining input from cursor to the end into
				 * row, saves the row, calls step, and returns the results.
				 */
				function finish(value)
				{
					if (ignoreLastRow)
						return returnable();
					if (typeof value === 'undefined')
						value = input.substr(cursor);
					row.push(value);
					cursor = inputLen;	// important in case parsing is paused
					pushRow(row);
					if (stepIsFunction)
						doStep();
					return returnable();
				}
	
				/**
				 * Appends the current row to the results. It sets the cursor
				 * to newCursor and finds the nextNewline. The caller should
				 * take care to execute user's step function and check for
				 * preview and end parsing if necessary.
				 */
				function saveRow(newCursor)
				{
					cursor = newCursor;
					pushRow(row);
					row = [];
					nextNewline = input.indexOf(newline, cursor);
				}
	
				/** Returns an object with the results, errors, and meta. */
				function returnable(stopped)
				{
					return {
						data: data,
						errors: errors,
						meta: {
							delimiter: delim,
							linebreak: newline,
							aborted: aborted,
							truncated: !!stopped,
							cursor: lastCursor + (baseIndex || 0)
						}
					};
				}
	
				/** Executes the user's step function and resets data & errors. */
				function doStep()
				{
					step(returnable());
					data = [], errors = [];
				}
			};
	
			/** Sets the abort flag */
			this.abort = function()
			{
				aborted = true;
			};
	
			/** Gets the cursor position */
			this.getCharIndex = function()
			{
				return cursor;
			};
		}
	
	
		// If you need to load Papa Parse asynchronously and you also need worker threads, hard-code
		// the script path here. See: https://github.com/mholt/PapaParse/issues/87#issuecomment-57885358
		function getScriptPath()
		{
			var scripts = document.getElementsByTagName('script');
			return scripts.length ? scripts[scripts.length - 1].src : '';
		}
	
		function newWorker()
		{
			if (!Papa.WORKERS_SUPPORTED)
				return false;
			if (!LOADED_SYNC && Papa.SCRIPT_PATH === null)
				throw new Error(
					'Script path cannot be determined automatically when Papa Parse is loaded asynchronously. ' +
					'You need to set Papa.SCRIPT_PATH manually.'
				);
			var workerUrl = Papa.SCRIPT_PATH || AUTO_SCRIPT_PATH;
			// Append "papaworker" to the search string to tell papaparse that this is our worker.
			workerUrl += (workerUrl.indexOf('?') !== -1 ? '&' : '?') + 'papaworker';
			var w = new global.Worker(workerUrl);
			w.onmessage = mainThreadReceivedMessage;
			w.id = workerIdCounter++;
			workers[w.id] = w;
			return w;
		}
	
		/** Callback when main thread receives a message */
		function mainThreadReceivedMessage(e)
		{
			var msg = e.data;
			var worker = workers[msg.workerId];
			var aborted = false;
	
			if (msg.error)
				worker.userError(msg.error, msg.file);
			else if (msg.results && msg.results.data)
			{
				var abort = function() {
					aborted = true;
					completeWorker(msg.workerId, { data: [], errors: [], meta: { aborted: true } });
				};
	
				var handle = {
					abort: abort,
					pause: notImplemented,
					resume: notImplemented
				};
	
				if (isFunction(worker.userStep))
				{
					for (var i = 0; i < msg.results.data.length; i++)
					{
						worker.userStep({
							data: [msg.results.data[i]],
							errors: msg.results.errors,
							meta: msg.results.meta
						}, handle);
						if (aborted)
							break;
					}
					delete msg.results;	// free memory ASAP
				}
				else if (isFunction(worker.userChunk))
				{
					worker.userChunk(msg.results, handle, msg.file);
					delete msg.results;
				}
			}
	
			if (msg.finished && !aborted)
				completeWorker(msg.workerId, msg.results);
		}
	
		function completeWorker(workerId, results) {
			var worker = workers[workerId];
			if (isFunction(worker.userComplete))
				worker.userComplete(results);
			worker.terminate();
			delete workers[workerId];
		}
	
		function notImplemented() {
			throw "Not implemented.";
		}
	
		/** Callback when worker thread receives a message */
		function workerThreadReceivedMessage(e)
		{
			var msg = e.data;
	
			if (typeof Papa.WORKER_ID === 'undefined' && msg)
				Papa.WORKER_ID = msg.workerId;
	
			if (typeof msg.input === 'string')
			{
				global.postMessage({
					workerId: Papa.WORKER_ID,
					results: Papa.parse(msg.input, msg.config),
					finished: true
				});
			}
			else if ((global.File && msg.input instanceof File) || msg.input instanceof Object)	// thank you, Safari (see issue #106)
			{
				var results = Papa.parse(msg.input, msg.config);
				if (results)
					global.postMessage({
						workerId: Papa.WORKER_ID,
						results: results,
						finished: true
					});
			}
		}
	
		/** Makes a deep copy of an array or object (mostly) */
		function copy(obj)
		{
			if (typeof obj !== 'object')
				return obj;
			var cpy = obj instanceof Array ? [] : {};
			for (var key in obj)
				cpy[key] = copy(obj[key]);
			return cpy;
		}
	
		function bindFunction(f, self)
		{
			return function() { f.apply(self, arguments); };
		}
	
		function isFunction(func)
		{
			return typeof func === 'function';
		}
	})(typeof window !== 'undefined' ? window : this);


/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FormCellInput = __webpack_require__(1477);
	
	var _FormCellInput2 = _interopRequireDefault(_FormCellInput);
	
	var _Formsy = __webpack_require__(1345);
	
	var _Formsy2 = _interopRequireDefault(_Formsy);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Invitation = __webpack_require__(1456);
	
	var _Invitation2 = _interopRequireDefault(_Invitation);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RecipientParser = __webpack_require__(1457);
	
	var _RecipientParser2 = _interopRequireDefault(_RecipientParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ParticipantsTableInputRow = function (_Component) {
	  _inherits(ParticipantsTableInputRow, _Component);
	
	  function ParticipantsTableInputRow(props) {
	    _classCallCheck(this, ParticipantsTableInputRow);
	
	    var _this = _possibleConstructorReturn(this, (ParticipantsTableInputRow.__proto__ || Object.getPrototypeOf(ParticipantsTableInputRow)).call(this, props));
	
	    _this.onNameChange = function (event) {
	      // When changing the name, if the uid and name are both empty, clear errors and warning
	      var name = event.target.value;
	      if (!name && !_this.props.uid) {
	        _this.setState({ warning: null, uidError: null });
	      }
	
	      _this.setState({ warning: null });
	      _this.props.onChange('name', event);
	
	      var rowValid = _this.uidValid(name, _this.props.uid) === true && !_this.state.uidError;
	      _this.props.onValidityChange(rowValid);
	    };
	
	    _this.onNameBlur = function (uid) {
	      uid = uid || _this.props.uid;
	
	      if (!_this.props.name && !uid) {
	        _this.setState({ warning: null, uidError: null });
	      } else {
	        if (!_this.nameValid(_this.props.name, uid)) {
	          _this.setState({
	            warning: 'If no name is entered, participants will be asked for ' + 'their names before they’re added to your class.'
	          });
	        } else {
	          _this.setState({ warning: null });
	        }
	      }
	    };
	
	    _this.onUidChange = function (event) {
	      var uid = event.target.value;
	      if (!uid && !_this.props.name) {
	        _this.setState({ warning: null });
	      } else if (uid) {
	        _this.onNameBlur(uid);
	      }
	
	      _this.setState({ uidError: null });
	      _this.props.onChange('uid', event);
	
	      var valid = _this.uidValid(_this.props.name, uid) === true;
	      if (valid) {
	        _this.serverValidateUid(uid);
	      }
	
	      _this.props.onValidityChange(valid);
	    };
	
	    _this.onUidBlur = function () {
	      _this.onNameBlur();
	      if (!_this.props.name && !_this.props.uid) {
	        _this.setState({ warning: null, uidError: null });
	      } else {
	        var error = _this.uidValid(_this.props.name, _this.props.uid);
	        if (error !== true) {
	          _this.setState({ uidError: error });
	        } else {
	          _this.serverValidateUid(_this.props.uid);
	        }
	      }
	    };
	
	    _this.state = {
	      warning: null
	    };
	    return _this;
	  }
	
	  _createClass(ParticipantsTableInputRow, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.validateInitialValues) {
	        this.validateBothInputs(this.props.name, this.props.uid);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.validateInitialValues) {
	        this.validateBothInputs(nextProps.name, nextProps.uid);
	      }
	      if (!nextProps.name && !nextProps.uid) {
	        this.setState({ warning: null, uidError: null });
	      }
	    }
	  }, {
	    key: 'serverValidateUid',
	    value: function serverValidateUid(uid) {
	      var _this2 = this;
	
	      if (!uid) {
	        return;
	      }
	
	      var parsedUid = _RecipientParser2.default.newToken(uid).address;
	      this.validateUid(parsedUid).catch(function (response) {
	        var serverError = '';
	        for (var recipient in response) {
	          recipient = response[recipient];
	          if (recipient.error) {
	            serverError = recipient.error.recipient[0];
	            break;
	          }
	        }
	        _this2.setState({ uidError: serverError });
	        _this2.props.onValidityChange(false);
	      });
	    }
	  }, {
	    key: 'validateUid',
	    value: function validateUid(uid) {
	      return _Invitation2.default.isValidGroupInvite(this.props.groupId, uid);
	    }
	  }, {
	    key: 'nameValid',
	    value: function nameValid(name, uid) {
	      return _Formsy2.default.customValidators.isPresentIfUidIsPresent({ name: name, uid: uid }, name);
	    }
	  }, {
	    key: 'uidValid',
	    value: function uidValid(name, uid) {
	      return _Formsy2.default.customValidators.isEmailOrPhoneOrFormIsEmpty({ name: name, uid: uid }, uid);
	    }
	  }, {
	    key: 'validateBothInputs',
	    value: function validateBothInputs(name, uid) {
	      if (!this.nameValid(name, uid)) {
	        this.setState({
	          warning: 'Participants without names will be asked for ' + 'their name before being added to your class.'
	        });
	      }
	
	      var uidError = this.uidValid(name, uid);
	      if (uidError !== true) {
	        this.setState({ uidError: uidError });
	      }
	
	      this.props.onValidityChange(this.uidValid(name, uid) === true);
	    }
	  }, {
	    key: 'renderTableRowValidationGlyph',
	    value: function renderTableRowValidationGlyph() {
	      return _react2.default.createElement(
	        'button',
	        { tabIndex: '-1', type: 'button' },
	        _react2.default.createElement(_Glyph2.default, { color: 'flame', name: 'caution', solo: true })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Formsy2.default.Form,
	        {
	          className: 'TableInput-body-row' },
	        _react2.default.createElement(
	          'span',
	          { className: 'TableInput-cell--validation TableInput-cell' },
	          this.state.warning && this.renderTableRowValidationGlyph()
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'TableInput-body-cell TableInput-cell' },
	          _react2.default.createElement(_FormCellInput2.default, {
	            parsePasteWith: this.props.parsePasteWith,
	            name: 'name',
	            autofocus: this.props.autofocus,
	            value: this.props.name,
	            onBlur: this.onNameBlur,
	            onChange: this.onNameChange,
	            placeholder: this.props.namePlaceholder,
	            errorMessage: this.props.serverErrors.name,
	            warningMessage: this.state.warning
	          })
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'TableInput-body-cell TableInput-cell' },
	          _react2.default.createElement(_FormCellInput2.default, {
	            parsePasteWith: this.props.parsePasteWith,
	            name: 'uid',
	            value: this.props.uid,
	            onBlur: this.onUidBlur,
	            onChange: this.onUidChange,
	            placeholder: this.props.uidPlaceholder,
	            errorMessage: this.props.serverErrors.uid || this.state.uidError
	          })
	        )
	      );
	    }
	  }]);
	
	  return ParticipantsTableInputRow;
	}(_react.Component);
	
	ParticipantsTableInputRow.defaultProps = {
	  name: '',
	  uid: '',
	  serverErrors: {}
	};
	ParticipantsTableInputRow.displayName = 'ParticipantsTableInputRow';
	exports.default = ParticipantsTableInputRow;

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Layer = __webpack_require__(1158);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(1157);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Formsy = __webpack_require__(1345);
	
	var _Formsy2 = _interopRequireDefault(_Formsy);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _doWhileMounted = __webpack_require__(1354);
	
	var _doWhileMounted2 = _interopRequireDefault(_doWhileMounted);
	
	var _lodash = __webpack_require__(555);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pickInputElementProps = __webpack_require__(1106);
	
	var _pickInputElementProps2 = _interopRequireDefault(_pickInputElementProps);
	
	var _focusNode = __webpack_require__(1210);
	
	var _focusNode2 = _interopRequireDefault(_focusNode);
	
	__webpack_require__(1478);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FormCellInput = _react2.default.createClass({
	  displayName: 'FormCellInput',
	
	
	  mixins: [_Formsy2.default.Mixin],
	
	  getInitialState: function getInitialState() {
	    return {
	      focus: false,
	      wasBlurred: false,
	      value: this.props.value,
	      wasJustMounted: true
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.value) {
	      this.setValue(this.props.value); // To make the input not pristine
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.autofocus) {
	      // Prevents the cursor from being placed at the start of the text
	      var node = this.refs.input;
	      var value = node.value;
	      node.value = '';
	      (0, _focusNode2.default)(node);
	      node.value = value;
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.value !== nextProps.value) {
	      this.changeValue(nextProps.value);
	    }
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !((0, _lodash.isEqual)(this.props, nextProps) && (0, _lodash.isEqual)(this.state, nextState));
	  },
	  onFocus: function onFocus() {
	    this.setState({ focus: true });
	  },
	  onBlur: function onBlur() {
	    this.setState({ focus: false });
	    if (this.state.wasBlurred === false) {
	      this.setState({ wasBlurred: true });
	    }
	    if (this.props.onBlur) {
	      this.props.onBlur();
	    }
	  },
	  onChange: function onChange(event) {
	    this.changeValue(event.currentTarget.value);
	  },
	  onPaste: function onPaste(e) {
	    if (this.props.parsePasteWith) {
	      e.stopPropagation();
	      if (this.props.parsePasteWith(e)) {
	        e.preventDefault();
	      }
	    }
	  },
	  changeValue: function changeValue(value) {
	    this.setState({
	      value: value,
	      wasBlurred: false,
	      wasJustMounted: false
	    });
	  },
	
	
	  /* This is for autofill purposes.
	   * Some browsers does not emit change event when
	   * they fill out the forms, so Formsy is not aware
	   * the value change and the validation does not run.
	   * This pulls the value from the DOM at
	   * regular interval and if what is found is different
	   * than what Formsy currently have then we tell Formsy
	   * about this new value via the Formsy mixin.
	   */
	  lookForChanges: function lookForChanges() {
	    if (!this.refs.input) {
	      return;
	    }
	
	    var fieldVal = this.refs.input.value;
	    if (fieldVal && this.getValue() !== fieldVal) {
	      this.onChange({ currentTarget: { value: fieldVal } });
	    }
	  },
	  render: function render() {
	    var errorMessage = this.getErrorMessage();
	
	    var _props = this.props,
	        value = _props.value,
	        onChange = _props.onChange,
	        warningMessage = _props.warningMessage,
	        others = _objectWithoutProperties(_props, ['value', 'onChange', 'warningMessage']);
	
	    if (!value || !this.state.wasBlurred && !this.state.wasJustMounted || this.isPristine()) {
	      errorMessage = null;
	    }
	
	    errorMessage = this.props.errorMessage || errorMessage;
	
	    var tooltip = _react2.default.createElement(_Layer2.default, null);
	    if (errorMessage) {
	      tooltip = _react2.default.createElement(
	        _Tooltip2.default,
	        { color: 'lava' },
	        errorMessage
	      );
	    } else if (warningMessage) {
	      tooltip = _react2.default.createElement(
	        _Tooltip2.default,
	        { color: 'flame' },
	        warningMessage
	      );
	    }
	
	    var inputProps = (0, _pickInputElementProps2.default)(others);
	    return _react2.default.createElement(
	      _LayerTrigger2.default,
	      {
	        layer: tooltip,
	        placement: 'bottom',
	        alignment: 'left',
	        trigger: ['hover'] },
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('FormCellInput', {
	            'FormCellInput--focus': this.state.focus,
	            'FormCellInput--error': errorMessage,
	            'FormCellInput--warning': warningMessage
	          }) },
	        _react2.default.createElement('input', _extends({
	          // MDN claims that onpaste is "non-standard and is not on a standards track" here:
	          // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste
	          // But the w3 working draft describing this behavior can be found here:
	          // https://www.w3.org/TR/clipboard-apis/#the-paste-action
	          // It appears to function as intended in Chrome, Firefox, Safari, and IE latest.
	          onPaste: this.onPaste
	        }, inputProps, {
	          ref: 'input',
	          value: this.state.value,
	          onFocus: this.onFocus,
	          onBlur: this.onBlur,
	          onChange: (0, _createChainedFunction2.default)(onChange, this.onChange)
	        }))
	      )
	    );
	  }
	});
	
	exports.default = (0, _doWhileMounted2.default)(FormCellInput, 'lookForChanges', 1000);

/***/ },
/* 1478 */
1136,
/* 1479 */,
/* 1480 */
1136,
/* 1481 */,
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getPropClasses = __webpack_require__(1135);
	
	__webpack_require__(1483);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class() {
	    _classCallCheck(this, _class);
	
	    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	  }
	
	  _createClass(_class, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('Row', (0, _getPropClasses.getPropClassesFromInstance)(this)) },
	        this.props.children
	      );
	    }
	  }]);
	
	  return _class;
	}(_react2.default.Component);
	
	_class.propClasses = {
	  size: {
	    large: 'Row--large',
	    medium: 'Row--medium',
	    small: 'Row--small'
	  }
	};
	_class.defaultProps = {
	  size: 'medium'
	};
	_class.displayName = '_class';
	exports.default = _class;

/***/ },
/* 1483 */
1136,
/* 1484 */,
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxHeader = __webpack_require__(1440);
	
	var _BoxHeader2 = _interopRequireDefault(_BoxHeader);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Languages = __webpack_require__(1486);
	
	var _Languages2 = _interopRequireDefault(_Languages);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _PDFDownload = __webpack_require__(1487);
	
	var _PDFDownload2 = _interopRequireDefault(_PDFDownload);
	
	var _TabPanel = __webpack_require__(1447);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	__webpack_require__(1488);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PDF_LOCALES = ['en', 'es-419', 'es-ES', 'fr-FR', 'fr-CA', 'pt-BR'];
	
	var DEFAULT_PDF_LOCALE = 'en';
	
	var InvitePDFTab = function (_React$Component) {
	  _inherits(InvitePDFTab, _React$Component);
	
	  function InvitePDFTab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InvitePDFTab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InvitePDFTab.__proto__ || Object.getPrototypeOf(InvitePDFTab)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      locale: DEFAULT_PDF_LOCALE
	    }, _this.setLocale = function (locale) {
	      _this.setState({ locale: locale });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InvitePDFTab, [{
	    key: 'renderDownloadButton',
	    value: function renderDownloadButton() {
	      return _react2.default.createElement(
	        _PDFDownload2.default,
	        {
	          type: 'button',
	          group: this.props.group,
	          locale: this.state.locale,
	          level: 'primary' },
	        'Download PDF'
	      );
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      var title = _react2.default.createElement(
	        'span',
	        null,
	        'PDF instructions on how to join ',
	        _react2.default.createElement(
	          'span',
	          { className: 'InvitePDFTab-groupName' },
	          this.props.group.getName()
	        )
	      );
	      return _react2.default.createElement(_BoxHeader2.default, { title: title });
	    }
	  }, {
	    key: 'renderLocaleDropdown',
	    value: function renderLocaleDropdown() {
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          layer: this.renderLocaleOptionsMenu(),
	          trigger: 'click',
	          placement: 'top',
	          alignment: 'middle' },
	        _react2.default.createElement(
	          _Link2.default,
	          { href: '#', color: 'inherit' },
	          _react2.default.createElement(
	            'span',
	            { className: 'InvitePDFTab-locale-label' },
	            _Languages2.default[this.state.locale].name
	          ),
	          _react2.default.createElement(_Glyph2.default, { name: 'chevron-down', size: 'xxsmall' })
	        )
	      );
	    }
	  }, {
	    key: 'renderLocaleOptionsMenu',
	    value: function renderLocaleOptionsMenu() {
	      var _this2 = this;
	
	      var menuItems = PDF_LOCALES.map(function (locale) {
	        return _react2.default.createElement(
	          _MenuItem2.default,
	          {
	            eventElementName: 'Pdf-download-link',
	            eventProperties: {
	              screen_name: 'InvitePDFTab',
	              foreign_table: 'groups',
	              foreign_id: _this2.props.group.id,
	              locale: locale
	            },
	            key: locale,
	            onSelect: _this2.setLocale },
	          _Languages2.default[locale].name
	        );
	      });
	
	      return _react2.default.createElement(
	        _Menu2.default,
	        { selectedKey: this.state.locale },
	        menuItems
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _TabPanel2.default,
	        {
	          className: 'InvitePDFTab',
	          key: 'smsPanel',
	          selectedBorderColor: 'lava',
	          eventElementName: 'tab-printable-pdf',
	          title: this.props.title },
	        this.renderHeader(),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Image2.default, {
	              src: __webpack_require__(1490),
	              className: 'InvitePDFTab-img'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'InvitePDFTab-language' },
	            'Language: ',
	            this.renderLocaleDropdown()
	          ),
	          this.renderDownloadButton()
	        )
	      );
	    }
	  }]);
	
	  return InvitePDFTab;
	}(_react2.default.Component);
	
	InvitePDFTab.displayName = 'InvitePDFTab';
	exports.default = InvitePDFTab;

/***/ },
/* 1486 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	exports.default = {
	  ab: {
	    name: 'Abkhaz',
	    nativeName: 'аҧсуа'
	  },
	  aa: {
	    name: 'Afar',
	    nativeName: 'Afaraf'
	  },
	  af: {
	    name: 'Afrikaans',
	    nativeName: 'Afrikaans'
	  },
	  ak: {
	    name: 'Akan',
	    nativeName: 'Akan'
	  },
	  sq: {
	    name: 'Albanian',
	    nativeName: 'Shqip'
	  },
	  am: {
	    name: 'Amharic',
	    nativeName: 'አማርኛ'
	  },
	  ar: {
	    name: 'Arabic',
	    nativeName: 'العربية'
	  },
	  an: {
	    name: 'Aragonese',
	    nativeName: 'Aragonés'
	  },
	  hy: {
	    name: 'Armenian',
	    nativeName: 'Հայերեն'
	  },
	  as: {
	    name: 'Assamese',
	    nativeName: 'অসমীয়া'
	  },
	  av: {
	    name: 'Avaric',
	    nativeName: 'авар мацӀ, магӀарул мацӀ'
	  },
	  ae: {
	    name: 'Avestan',
	    nativeName: 'avesta'
	  },
	  ay: {
	    name: 'Aymara',
	    nativeName: 'aymar aru'
	  },
	  az: {
	    name: 'Azerbaijani',
	    nativeName: 'azərbaycan dili'
	  },
	  bm: {
	    name: 'Bambara',
	    nativeName: 'bamanankan'
	  },
	  ba: {
	    name: 'Bashkir',
	    nativeName: 'башҡорт теле'
	  },
	  eu: {
	    name: 'Basque',
	    nativeName: 'euskara, euskera'
	  },
	  be: {
	    name: 'Belarusian',
	    nativeName: 'Беларуская'
	  },
	  bn: {
	    name: 'Bengali',
	    nativeName: 'বাংলা'
	  },
	  bh: {
	    name: 'Bihari',
	    nativeName: 'भोजपुरी'
	  },
	  bi: {
	    name: 'Bislama',
	    nativeName: 'Bislama'
	  },
	  bs: {
	    name: 'Bosnian',
	    nativeName: 'bosanski jezik'
	  },
	  br: {
	    name: 'Breton',
	    nativeName: 'brezhoneg'
	  },
	  bg: {
	    name: 'Bulgarian',
	    nativeName: 'български език'
	  },
	  my: {
	    name: 'Burmese',
	    nativeName: 'ဗမာစာ'
	  },
	  ca: {
	    name: 'Catalan; Valencian',
	    nativeName: 'Català'
	  },
	  ch: {
	    name: 'Chamorro',
	    nativeName: 'Chamoru'
	  },
	  ce: {
	    name: 'Chechen',
	    nativeName: 'нохчийн мотт'
	  },
	  ny: {
	    name: 'Chichewa; Chewa; Nyanja',
	    nativeName: 'chiCheŵa, chinyanja'
	  },
	  zh: {
	    name: 'Chinese',
	    nativeName: '中文 (Zhōngwén), 汉语, 漢語'
	  },
	  cv: {
	    name: 'Chuvash',
	    nativeName: 'чӑваш чӗлхи'
	  },
	  kw: {
	    name: 'Cornish',
	    nativeName: 'Kernewek'
	  },
	  co: {
	    name: 'Corsican',
	    nativeName: 'corsu, lingua corsa'
	  },
	  cr: {
	    name: 'Cree',
	    nativeName: 'ᓀᐦᐃᔭᐍᐏᐣ'
	  },
	  hr: {
	    name: 'Croatian',
	    nativeName: 'hrvatski'
	  },
	  cs: {
	    name: 'Czech',
	    nativeName: 'česky, čeština'
	  },
	  da: {
	    name: 'Danish',
	    nativeName: 'dansk'
	  },
	  dv: {
	    name: 'Divehi; Dhivehi; Maldivian;',
	    nativeName: 'ދިވެހި'
	  },
	  nl: {
	    name: 'Dutch',
	    nativeName: 'Nederlands, Vlaams'
	  },
	  en: {
	    name: 'English',
	    nativeName: 'English'
	  },
	  eo: {
	    name: 'Esperanto',
	    nativeName: 'Esperanto'
	  },
	  et: {
	    name: 'Estonian',
	    nativeName: 'eesti, eesti keel'
	  },
	  ee: {
	    name: 'Ewe',
	    nativeName: 'Eʋegbe'
	  },
	  fo: {
	    name: 'Faroese',
	    nativeName: 'føroyskt'
	  },
	  fj: {
	    name: 'Fijian',
	    nativeName: 'vosa Vakaviti'
	  },
	  fi: {
	    name: 'Finnish',
	    nativeName: 'suomi, suomen kieli'
	  },
	  fr: {
	    name: 'French',
	    nativeName: 'français, langue française'
	  },
	  'fr-FR': {
	    name: 'French (France)',
	    nativeName: 'Français (France)'
	  },
	  'fr-CA': {
	    name: 'French (Canada)',
	    nativeName: 'Français (Canada)'
	  },
	  ff: {
	    name: 'Fula; Fulah; Pulaar; Pular',
	    nativeName: 'Fulfulde, Pulaar, Pular'
	  },
	  gl: {
	    name: 'Galician',
	    nativeName: 'Galego'
	  },
	  ka: {
	    name: 'Georgian',
	    nativeName: 'ქართული'
	  },
	  de: {
	    name: 'German',
	    nativeName: 'Deutsch'
	  },
	  el: {
	    name: 'Greek, Modern',
	    nativeName: 'Ελληνικά'
	  },
	  gn: {
	    name: 'Guaraní',
	    nativeName: 'Avañeẽ'
	  },
	  gu: {
	    name: 'Gujarati',
	    nativeName: 'ગુજરાતી'
	  },
	  ht: {
	    name: 'Haitian; Haitian Creole',
	    nativeName: 'Kreyòl ayisyen'
	  },
	  ha: {
	    name: 'Hausa',
	    nativeName: 'Hausa, هَوُسَ'
	  },
	  he: {
	    name: 'Hebrew (modern)',
	    nativeName: 'עברית'
	  },
	  hz: {
	    name: 'Herero',
	    nativeName: 'Otjiherero'
	  },
	  hi: {
	    name: 'Hindi',
	    nativeName: 'हिन्दी, हिंदी'
	  },
	  ho: {
	    name: 'Hiri Motu',
	    nativeName: 'Hiri Motu'
	  },
	  hu: {
	    name: 'Hungarian',
	    nativeName: 'Magyar'
	  },
	  ia: {
	    name: 'Interlingua',
	    nativeName: 'Interlingua'
	  },
	  id: {
	    name: 'Indonesian',
	    nativeName: 'Bahasa Indonesia'
	  },
	  ie: {
	    name: 'Interlingue',
	    nativeName: 'Originally called Occidental; then Interlingue after WWII'
	  },
	  ga: {
	    name: 'Irish',
	    nativeName: 'Gaeilge'
	  },
	  ig: {
	    name: 'Igbo',
	    nativeName: 'Asụsụ Igbo'
	  },
	  ik: {
	    name: 'Inupiaq',
	    nativeName: 'Iñupiaq, Iñupiatun'
	  },
	  io: {
	    name: 'Ido',
	    nativeName: 'Ido'
	  },
	  is: {
	    name: 'Icelandic',
	    nativeName: 'Íslenska'
	  },
	  it: {
	    name: 'Italian',
	    nativeName: 'Italiano'
	  },
	  iu: {
	    name: 'Inuktitut',
	    nativeName: 'ᐃᓄᒃᑎᑐᑦ'
	  },
	  ja: {
	    name: 'Japanese',
	    nativeName: '日本語 (にほんご／にっぽんご)'
	  },
	  jv: {
	    name: 'Javanese',
	    nativeName: 'basa Jawa'
	  },
	  kl: {
	    name: 'Kalaallisut, Greenlandic',
	    nativeName: 'kalaallisut, kalaallit oqaasii'
	  },
	  kn: {
	    name: 'Kannada',
	    nativeName: 'ಕನ್ನಡ'
	  },
	  kr: {
	    name: 'Kanuri',
	    nativeName: 'Kanuri'
	  },
	  ks: {
	    name: 'Kashmiri',
	    nativeName: 'कश्मीरी, كشميري‎'
	  },
	  kk: {
	    name: 'Kazakh',
	    nativeName: 'Қазақ тілі'
	  },
	  km: {
	    name: 'Khmer',
	    nativeName: 'ភាសាខ្មែរ'
	  },
	  ki: {
	    name: 'Kikuyu, Gikuyu',
	    nativeName: 'Gĩkũyũ'
	  },
	  rw: {
	    name: 'Kinyarwanda',
	    nativeName: 'Ikinyarwanda'
	  },
	  ky: {
	    name: 'Kirghiz, Kyrgyz',
	    nativeName: 'кыргыз тили'
	  },
	  kv: {
	    name: 'Komi',
	    nativeName: 'коми кыв'
	  },
	  kg: {
	    name: 'Kongo',
	    nativeName: 'KiKongo'
	  },
	  ko: {
	    name: 'Korean',
	    nativeName: '한국어 (韓國語), 조선말 (朝鮮語)'
	  },
	  ku: {
	    name: 'Kurdish',
	    nativeName: 'Kurdî, كوردی‎'
	  },
	  kj: {
	    name: 'Kwanyama, Kuanyama',
	    nativeName: 'Kuanyama'
	  },
	  la: {
	    name: 'Latin',
	    nativeName: 'latine, lingua latina'
	  },
	  lb: {
	    name: 'Luxembourgish, Letzeburgesch',
	    nativeName: 'Lëtzebuergesch'
	  },
	  lg: {
	    name: 'Luganda',
	    nativeName: 'Luganda'
	  },
	  li: {
	    name: 'Limburgish, Limburgan, Limburger',
	    nativeName: 'Limburgs'
	  },
	  ln: {
	    name: 'Lingala',
	    nativeName: 'Lingála'
	  },
	  lo: {
	    name: 'Lao',
	    nativeName: 'ພາສາລາວ'
	  },
	  lt: {
	    name: 'Lithuanian',
	    nativeName: 'lietuvių kalba'
	  },
	  lu: {
	    name: 'Luba-Katanga',
	    nativeName: ''
	  },
	  lv: {
	    name: 'Latvian',
	    nativeName: 'latviešu valoda'
	  },
	  gv: {
	    name: 'Manx',
	    nativeName: 'Gaelg, Gailck'
	  },
	  mk: {
	    name: 'Macedonian',
	    nativeName: 'македонски јазик'
	  },
	  mg: {
	    name: 'Malagasy',
	    nativeName: 'Malagasy fiteny'
	  },
	  ms: {
	    name: 'Malay',
	    nativeName: 'bahasa Melayu, بهاس ملايو‎'
	  },
	  ml: {
	    name: 'Malayalam',
	    nativeName: 'മലയാളം'
	  },
	  mt: {
	    name: 'Maltese',
	    nativeName: 'Malti'
	  },
	  mi: {
	    name: 'Māori',
	    nativeName: 'te reo Māori'
	  },
	  mr: {
	    name: 'Marathi (Marāṭhī)',
	    nativeName: 'मराठी'
	  },
	  mh: {
	    name: 'Marshallese',
	    nativeName: 'Kajin M̧ajeļ'
	  },
	  mn: {
	    name: 'Mongolian',
	    nativeName: 'монгол'
	  },
	  na: {
	    name: 'Nauru',
	    nativeName: 'Ekakairũ Naoero'
	  },
	  nv: {
	    name: 'Navajo, Navaho',
	    nativeName: 'Diné bizaad, Dinékʼehǰí'
	  },
	  nb: {
	    name: 'Norwegian Bokmål',
	    nativeName: 'Norsk bokmål'
	  },
	  nd: {
	    name: 'North Ndebele',
	    nativeName: 'isiNdebele'
	  },
	  ne: {
	    name: 'Nepali',
	    nativeName: 'नेपाली'
	  },
	  ng: {
	    name: 'Ndonga',
	    nativeName: 'Owambo'
	  },
	  nn: {
	    name: 'Norwegian Nynorsk',
	    nativeName: 'Norsk nynorsk'
	  },
	  no: {
	    name: 'Norwegian',
	    nativeName: 'Norsk'
	  },
	  ii: {
	    name: 'Nuosu',
	    nativeName: 'ꆈꌠ꒿ Nuosuhxop'
	  },
	  nr: {
	    name: 'South Ndebele',
	    nativeName: 'isiNdebele'
	  },
	  oc: {
	    name: 'Occitan',
	    nativeName: 'Occitan'
	  },
	  oj: {
	    name: 'Ojibwe, Ojibwa',
	    nativeName: 'ᐊᓂᔑᓈᐯᒧᐎᓐ'
	  },
	  cu: {
	    name: 'Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic',
	    nativeName: 'ѩзыкъ словѣньскъ'
	  },
	  om: {
	    name: 'Oromo',
	    nativeName: 'Afaan Oromoo'
	  },
	  or: {
	    name: 'Oriya',
	    nativeName: 'ଓଡ଼ିଆ'
	  },
	  os: {
	    name: 'Ossetian, Ossetic',
	    nativeName: 'ирон æвзаг'
	  },
	  pa: {
	    name: 'Panjabi, Punjabi',
	    nativeName: 'ਪੰਜਾਬੀ, پنجابی‎'
	  },
	  pi: {
	    name: 'Pāli',
	    nativeName: 'पाऴि'
	  },
	  fa: {
	    name: 'Persian',
	    nativeName: 'فارسی'
	  },
	  pl: {
	    name: 'Polish',
	    nativeName: 'polski'
	  },
	  ps: {
	    name: 'Pashto, Pushto',
	    nativeName: 'پښتو'
	  },
	  pt: {
	    name: 'Portuguese',
	    nativeName: 'Português'
	  },
	  'pt-BR': {
	    name: 'Portuguese (Brazil)',
	    nativeName: 'Português (Brasil)'
	  },
	  qu: {
	    name: 'Quechua',
	    nativeName: 'Runa Simi, Kichwa'
	  },
	  rm: {
	    name: 'Romansh',
	    nativeName: 'rumantsch grischun'
	  },
	  rn: {
	    name: 'Kirundi',
	    nativeName: 'kiRundi'
	  },
	  ro: {
	    name: 'Romanian, Moldavian, Moldovan',
	    nativeName: 'română'
	  },
	  ru: {
	    name: 'Russian',
	    nativeName: 'русский язык'
	  },
	  sa: {
	    name: 'Sanskrit (Saṁskṛta)',
	    nativeName: 'संस्कृतम्'
	  },
	  sc: {
	    name: 'Sardinian',
	    nativeName: 'sardu'
	  },
	  sd: {
	    name: 'Sindhi',
	    nativeName: 'सिन्धी, سنڌي، سندھی‎'
	  },
	  se: {
	    name: 'Northern Sami',
	    nativeName: 'Davvisámegiella'
	  },
	  sm: {
	    name: 'Samoan',
	    nativeName: 'gagana faa Samoa'
	  },
	  sg: {
	    name: 'Sango',
	    nativeName: 'yângâ tî sängö'
	  },
	  sr: {
	    name: 'Serbian',
	    nativeName: 'српски језик'
	  },
	  gd: {
	    name: 'Scottish Gaelic; Gaelic',
	    nativeName: 'Gàidhlig'
	  },
	  sn: {
	    name: 'Shona',
	    nativeName: 'chiShona'
	  },
	  si: {
	    name: 'Sinhala, Sinhalese',
	    nativeName: 'සිංහල'
	  },
	  sk: {
	    name: 'Slovak',
	    nativeName: 'slovenčina'
	  },
	  sl: {
	    name: 'Slovene',
	    nativeName: 'slovenščina'
	  },
	  so: {
	    name: 'Somali',
	    nativeName: 'Soomaaliga, af Soomaali'
	  },
	  st: {
	    name: 'Southern Sotho',
	    nativeName: 'Sesotho'
	  },
	  es: {
	    name: 'Spanish, Castilian',
	    nativeName: 'español, castellano'
	  },
	  'es-419': {
	    name: 'Spanish (Latin America)',
	    nativeName: 'Español (Lat. Am.)'
	  },
	  'es-ES': {
	    name: 'Spanish (Spain)',
	    nativeName: 'Español (España)'
	  },
	  su: {
	    name: 'Sundanese',
	    nativeName: 'Basa Sunda'
	  },
	  sw: {
	    name: 'Swahili',
	    nativeName: 'Kiswahili'
	  },
	  ss: {
	    name: 'Swati',
	    nativeName: 'SiSwati'
	  },
	  sv: {
	    name: 'Swedish',
	    nativeName: 'svenska'
	  },
	  ta: {
	    name: 'Tamil',
	    nativeName: 'தமிழ்'
	  },
	  te: {
	    name: 'Telugu',
	    nativeName: 'తెలుగు'
	  },
	  tg: {
	    name: 'Tajik',
	    nativeName: 'тоҷикӣ, toğikī, تاجیکی‎'
	  },
	  th: {
	    name: 'Thai',
	    nativeName: 'ไทย'
	  },
	  ti: {
	    name: 'Tigrinya',
	    nativeName: 'ትግርኛ'
	  },
	  bo: {
	    name: 'Tibetan Standard, Tibetan, Central',
	    nativeName: 'བོད་ཡིག'
	  },
	  tk: {
	    name: 'Turkmen',
	    nativeName: 'Türkmen, Түркмен'
	  },
	  tl: {
	    name: 'Tagalog',
	    nativeName: 'Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔'
	  },
	  tn: {
	    name: 'Tswana',
	    nativeName: 'Setswana'
	  },
	  to: {
	    name: 'Tonga (Tonga Islands)',
	    nativeName: 'faka Tonga'
	  },
	  tr: {
	    name: 'Turkish',
	    nativeName: 'Türkçe'
	  },
	  ts: {
	    name: 'Tsonga',
	    nativeName: 'Xitsonga'
	  },
	  tt: {
	    name: 'Tatar',
	    nativeName: 'татарча, tatarça, تاتارچا‎'
	  },
	  tw: {
	    name: 'Twi',
	    nativeName: 'Twi'
	  },
	  ty: {
	    name: 'Tahitian',
	    nativeName: 'Reo Tahiti'
	  },
	  ug: {
	    name: 'Uighur, Uyghur',
	    nativeName: 'Uyƣurqə, ئۇيغۇرچە‎'
	  },
	  uk: {
	    name: 'Ukrainian',
	    nativeName: 'українська'
	  },
	  ur: {
	    name: 'Urdu',
	    nativeName: 'اردو'
	  },
	  uz: {
	    name: 'Uzbek',
	    nativeName: 'zbek, Ўзбек, أۇزبېك‎'
	  },
	  ve: {
	    name: 'Venda',
	    nativeName: 'Tshivenḓa'
	  },
	  vi: {
	    name: 'Vietnamese',
	    nativeName: 'Tiếng Việt'
	  },
	  vo: {
	    name: 'Volapük',
	    nativeName: 'Volapük'
	  },
	  wa: {
	    name: 'Walloon',
	    nativeName: 'Walon'
	  },
	  cy: {
	    name: 'Welsh',
	    nativeName: 'Cymraeg'
	  },
	  wo: {
	    name: 'Wolof',
	    nativeName: 'Wollof'
	  },
	  fy: {
	    name: 'Western Frisian',
	    nativeName: 'Frysk'
	  },
	  xh: {
	    name: 'Xhosa',
	    nativeName: 'isiXhosa'
	  },
	  yi: {
	    name: 'Yiddish',
	    nativeName: 'ייִדיש'
	  },
	  yo: {
	    name: 'Yoruba',
	    nativeName: 'Yorùbá'
	  },
	  za: {
	    name: 'Zhuang, Chuang',
	    nativeName: 'Saɯ cueŋƅ, Saw cuengh'
	  }
	};

/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mountTymkPrompt = __webpack_require__(1464);
	
	var _mountTymkPrompt2 = _interopRequireDefault(_mountTymkPrompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PDFDownload = function (_React$Component) {
	  _inherits(PDFDownload, _React$Component);
	
	  function PDFDownload() {
	    _classCallCheck(this, PDFDownload);
	
	    return _possibleConstructorReturn(this, (PDFDownload.__proto__ || Object.getPrototypeOf(PDFDownload)).apply(this, arguments));
	  }
	
	  _createClass(PDFDownload, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var Component = this.props.type === 'link' ? _Link2.default : _Button2.default;
	
	      return _react2.default.createElement(Component, _extends({}, this.props, {
	        eventElementName: 'Pdf-download-link',
	        eventProperties: {
	          foreign_table: 'groups',
	          foreign_id: this.props.group.id,
	          locale: this.props.locale
	        },
	        href: this.props.group.getPdfUrl(this.props.locale),
	        target: '_blank',
	        onClick: function onClick() {
	          (0, _mountTymkPrompt2.default)(_this2, 'download_pdf');
	        }
	      }));
	    }
	  }]);
	
	  return PDFDownload;
	}(_react2.default.Component);
	
	PDFDownload.defaultProps = {
	  locale: 'en'
	};
	PDFDownload.displayName = 'PDFDownload';
	exports.default = PDFDownload;

/***/ },
/* 1488 */
1136,
/* 1489 */,
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9c036caf74082eb3addb5d45801f3b8f.png";

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxHeader = __webpack_require__(1440);
	
	var _BoxHeader2 = _interopRequireDefault(_BoxHeader);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ClipboardTrigger = __webpack_require__(1492);
	
	var _ClipboardTrigger2 = _interopRequireDefault(_ClipboardTrigger);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _TabPanel = __webpack_require__(1447);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _getPrettyUrl = __webpack_require__(1496);
	
	var _getPrettyUrl2 = _interopRequireDefault(_getPrettyUrl);
	
	__webpack_require__(1497);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InviteShareLinkTab = function (_React$Component) {
	  _inherits(InviteShareLinkTab, _React$Component);
	
	  function InviteShareLinkTab() {
	    _classCallCheck(this, InviteShareLinkTab);
	
	    return _possibleConstructorReturn(this, (InviteShareLinkTab.__proto__ || Object.getPrototypeOf(InviteShareLinkTab)).apply(this, arguments));
	  }
	
	  _createClass(InviteShareLinkTab, [{
	    key: 'getEmailBody',
	    value: function getEmailBody() {
	      var group = this.props.group;
	
	      return encodeURIComponent('I’m using Remind to send important updates, assignments, and information for ' + (group.getName() + '. ') + 'Please click on the link below to join our class. (For reference, our class code is ' + ('@' + group.getCode() + '.)\n\r' + group.getJoinUrl() + '\n\r') + ('Thanks for joining!\n\r' + _CurrentUser2.default.getUser().getSignature() + '\n\r') + 'P.S. Remind is a free, safe, and easy way for me to reach you with important information. ' + 'You can choose to receive notifications by text, email, or the app. Having trouble? ' + 'Go here: https://help.remind.com/hc/en-us/articles/203541849');
	    }
	  }, {
	    key: 'getEmailSubject',
	    value: function getEmailSubject() {
	      return encodeURIComponent('Accept request to join ' + this.props.group.getName() + ' with ' + ('' + _CurrentUser2.default.getUser().getSignature()));
	    }
	  }, {
	    key: 'showCopyToast',
	    value: function showCopyToast() {
	      _ToastActions2.default.showSuccessToast('URL has been copied to your clipboard');
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      return _react2.default.createElement(
	        _BoxBody2.default,
	        null,
	        _react2.default.createElement(
	          _Container2.default,
	          { size: 'xsmall' },
	          this.renderImage(),
	          this.renderCopyLinkForm(),
	          this.renderEmailButton()
	        )
	      );
	    }
	  }, {
	    key: 'renderCopyLinkForm',
	    value: function renderCopyLinkForm() {
	      var group = this.props.group;
	
	      var referralUrl = group.getJoinUrl();
	      var referralUrlPretty = (0, _getPrettyUrl2.default)(referralUrl);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'InviteShareLinkTab-form' },
	        _react2.default.createElement(
	          'div',
	          { className: 'InviteShareLinkTab-form-input' },
	          _react2.default.createElement(_Label2.default, { text: 'URL', hidden: true }),
	          _react2.default.createElement(_Input2.default, { value: referralUrlPretty, readOnly: true })
	        ),
	        _react2.default.createElement(
	          _ClipboardTrigger2.default,
	          { text: referralUrl, onCopy: this.showCopyToast },
	          _react2.default.createElement(
	            _Button2.default,
	            { level: 'secondary', size: 'small' },
	            'Copy link'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderEmailButton',
	    value: function renderEmailButton() {
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          href: 'mailto:?subject=' + this.getEmailSubject() + '&body=' + this.getEmailBody(),
	          target: '_blank',
	          full: true,
	          size: 'small',
	          className: 'InviteShareLinkTab-emailBtn',
	          eventElementName: 'email-link-button' },
	        _react2.default.createElement(_Glyph2.default, { name: 'email', size: 'medium' }),
	        'Email link'
	      );
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      return _react2.default.createElement(_BoxHeader2.default, {
	        title: 'Share this link any way you like!',
	        subtext: 'This link includes your class code, ' + 'so anyone who has it can join your class instantly.'
	      });
	    }
	  }, {
	    key: 'renderImage',
	    value: function renderImage() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'InviteShareLinkTab-img' },
	        _react2.default.createElement(_GroupAvatar2.default, { group: this.props.group, className: 'InviteShareLinkTab-img-avatar' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _TabPanel2.default,
	        {
	          key: 'webPanel',
	          selectedBorderColor: 'flame',
	          className: 'InviteShareLinkTab',
	          eventElementName: 'tab-website-link',
	          title: this.props.title },
	        this.renderHeader(),
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return InviteShareLinkTab;
	}(_react2.default.Component);
	
	InviteShareLinkTab.displayName = 'InviteShareLinkTab';
	exports.default = InviteShareLinkTab;

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _currentUserAgent = __webpack_require__(1160);
	
	var _currentUserAgent2 = _interopRequireDefault(_currentUserAgent);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	/**
	 * Copy text to the user's clipboard
	 *
	 * ```example
	 *  <ClipboardTrigger
	 *    text="http://www.google.com/"
	 *    onCopy={() => window.alert('Link copied!')}>
	 *    <Link>
	 *      Click here to copy the link to your clipboard.
	 *    </Link>
	 *  </ClipboardTrigger>
	 * ```
	 */
	
	var ClipboardTrigger = function (_React$Component) {
	  _inherits(ClipboardTrigger, _React$Component);
	
	  function ClipboardTrigger() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClipboardTrigger);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClipboardTrigger.__proto__ || Object.getPrototypeOf(ClipboardTrigger)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
	      event.preventDefault();
	
	      var input = document.createElement('input');
	      input.readOnly = true;
	      input.style.cssText = '\n      position: absolute;\n      top: -9999px;\n    ';
	      input.value = _this.props.text;
	      document.body.appendChild(input);
	      input.select();
	
	      try {
	        var success = document.execCommand('copy');
	        document.body.removeChild(input);
	        (0, _invariant2.default)(success, 'unable to copy');
	        _this.props.onCopy();
	      } catch (e) {
	        var message = _currentUserAgent2.default.mac() ? 'Press Cmd-C to copy to clipboard' : 'Press Control-C to copy to clipboard';
	
	        if (window.prompt(message, _this.props.text)) {
	          // eslint-disable-line no-alert
	          _this.props.onCopy();
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ClipboardTrigger, [{
	    key: 'render',
	    value: function render() {
	      var trigger = _react2.default.Children.only(this.props.children);
	      return _react2.default.cloneElement(trigger, {
	        onClick: (0, _createChainedFunction2.default)(this.handleClick, this.props.onClick)
	      });
	    }
	  }]);
	
	  return ClipboardTrigger;
	}(_react2.default.Component);
	
	ClipboardTrigger.defaultProps = {
	  onCopy: function onCopy() {}
	};
	ClipboardTrigger.displayName = 'ClipboardTrigger';
	exports.default = ClipboardTrigger;

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _getPropClasses2 = _interopRequireDefault(_getPropClasses);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1494);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToClasses = {
	  size: {
	    large: 'Container-large',
	    medium: 'Container-medium',
	    small: 'Container-small',
	    xsmall: 'Container-xsmall',
	    xxsmall: 'Container-xxsmall'
	  },
	  full: 'Container-full'
	};
	
	var Container = function (_React$Component) {
	  _inherits(Container, _React$Component);
	
	  function Container() {
	    _classCallCheck(this, Container);
	
	    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
	  }
	
	  _createClass(Container, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('Container', (0, _getPropClasses2.default)(this.props, propsToClasses), this.props.className) },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Container;
	}(_react2.default.Component);
	
	Container.displayName = 'Container';
	exports.default = Container;

/***/ },
/* 1494 */
1136,
/* 1495 */,
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrettyUrl;
	
	var _urijs = __webpack_require__(607);
	
	var _urijs2 = _interopRequireDefault(_urijs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPrettyUrl(url) {
	  var uri = new _urijs2.default(url);
	  return uri.hostname().replace(/^www\./, '') + uri.resource();
	} /*  weak */

/***/ },
/* 1497 */
1136,
/* 1498 */,
/* 1499 */,
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _DropZoneModal = __webpack_require__(1501);
	
	var _DropZoneModal2 = _interopRequireDefault(_DropZoneModal);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _FileSenderMixin = __webpack_require__(1504);
	
	var _FileSenderMixin2 = _interopRequireDefault(_FileSenderMixin);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabPanel = __webpack_require__(1447);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	var _apiRequest = __webpack_require__(556);
	
	var _TeacherAddUploadTabInitial = __webpack_require__(1507);
	
	var _TeacherAddUploadTabInitial2 = _interopRequireDefault(_TeacherAddUploadTabInitial);
	
	var _TeacherAddUploadTabSuccess = __webpack_require__(1517);
	
	var _TeacherAddUploadTabSuccess2 = _interopRequireDefault(_TeacherAddUploadTabSuccess);
	
	var _TeacherAddUploadTabUploading = __webpack_require__(1519);
	
	var _TeacherAddUploadTabUploading2 = _interopRequireDefault(_TeacherAddUploadTabUploading);
	
	var _TeacherAddUploadTabFixErrors = __webpack_require__(1523);
	
	var _TeacherAddUploadTabFixErrors2 = _interopRequireDefault(_TeacherAddUploadTabFixErrors);
	
	var _directAdd = __webpack_require__(1525);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	__webpack_require__(1529);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EVENT_SCREEN_NAME = 'TeacherAddUploadTab';
	
	var TeacherAddUploadTab = _react2.default.createClass({
	  displayName: 'TeacherAddUploadTab',
	
	
	  childContextTypes: {
	    eventScreenName: _react2.default.PropTypes.string
	  },
	
	  mixins: [_FileSenderMixin2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      composerExpanded: false,
	      fileUploaded: false,
	      error: null,
	      fixingErrors: false
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      eventScreenName: EVENT_SCREEN_NAME
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    _EventTracking2.default.view(EVENT_SCREEN_NAME);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.getFiles().map(this.removeFile);
	  },
	  onDragEnter: function onDragEnter() {
	    if (!this.state.composerExpanded) {
	      this.onDragOverDropzone();
	    }
	  },
	  onDragOverDropzone: function onDragOverDropzone() {
	    if (!this.state.composerExpanded) {
	      this.setState({ composerExpanded: true, isDraggingFileInner: true });
	    }
	  },
	  onDragOverWindow: function onDragOverWindow() {
	    if (!this.state.composerExpanded) {
	      this.setState({ composerExpanded: true });
	    }
	  },
	  onUploadFailed: function onUploadFailed(file, error) {
	    this.removeAllFiles();
	    this.setState({ error: error });
	  },
	  onUploadSuccess: function onUploadSuccess(file) {
	    var _this = this;
	
	    this.removeAllFiles();
	    var response = JSON.parse(file.xhr.response);
	    this.setState({
	      fileUploaded: true,
	      error: null,
	      uploadProcessing: true,
	      uploadPercentage: 0
	    });
	
	    (0, _directAdd.queryDirectAddJob)(this.props.organization.id, response.id, function (pollResponse) {
	      _this.setState({
	        uploadPercentage: Math.floor(100 * (pollResponse.completed / pollResponse.total))
	      });
	    }).then(function (results) {
	      return setTimeout(function () {
	        return _this.setState({ uploadProcessing: false, successResponse: results });
	      }, 500);
	    });
	  },
	  onAddedFile: function onAddedFile() {
	    this.setState({ fileUploaded: false });
	  },
	  getUploadURL: function getUploadURL() {
	    return (0, _apiRequest.getAPIURL)('/organizations/' + this.props.organization.id + '/' + this._role + '/spreadsheet');
	  },
	  getDropzoneId: function getDropzoneId() {
	    return this.props.organization.id;
	  },
	  isFileUploaded: function isFileUploaded() {
	    return this.getFiles().length > 0 && this.getFiles()[0].status === 'success';
	  },
	  resetTab: function resetTab() {
	    if (this.state.fileUploaded || this.state.fixingErrors) {
	      this.destroyDropzoneIfEmpty();
	      this.setState(this.getInitialState());
	    }
	  },
	  renderDropzoneModal: function renderDropzoneModal() {
	    if (this.state.isDraggingFile) {
	      return _react2.default.createElement(_DropZoneModal2.default, {
	        isFileUploaded: this.getFiles().length > 0,
	        isHovering: this.state.isDraggingFileInner,
	        title: 'Drag and drop spreadsheet to upload',
	        titleDrop: 'Drop spreadsheet!'
	      });
	    }
	    return null;
	  },
	  renderContent: function renderContent() {
	    var _this2 = this;
	
	    if (this.state.uploadProcessing) {
	      return _react2.default.createElement(_TeacherAddUploadTabUploading2.default, { uploadPercentage: this.state.uploadPercentage });
	    }
	    if (this.state.fixingErrors) {
	      var users = this.state.successResponse.errorUsers;
	      return _react2.default.createElement(_TeacherAddUploadTabFixErrors2.default, {
	        organization: this.props.organization,
	        users: users,
	        role: this._role,
	        onSuccess: function onSuccess(response) {
	          return _this2.setState({ fixingErrors: false, successResponse: response });
	        }
	      });
	    }
	    if (this.state.successResponse) {
	      return _react2.default.createElement(
	        'div',
	        { ref: 'dropzone_attach' },
	        _react2.default.createElement(_TeacherAddUploadTabSuccess2.default, {
	          group: this.props.group,
	          role: this._role,
	          response: this.state.successResponse,
	          onFixError: function onFixError() {
	            return _this2.setState({ fixingErrors: true });
	          }
	        })
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      { ref: 'dropzone_attach' },
	      _react2.default.createElement(_TeacherAddUploadTabInitial2.default, {
	        dropzoneid: this.getDropzoneId(),
	        setRole: function setRole(role) {
	          _this2._role = role;
	        },
	        error: this.state.error
	      })
	    );
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _TabPanel2.default,
	      {
	        selectedBorderColor: 'brand',
	        className: 'TeacherAddUploadTab-panel TeacherAddUploadTab-link',
	        title: this.props.title },
	      _react2.default.createElement(
	        _BoxBody2.default,
	        {
	          ref: 'dropzone',
	          className: 'TeacherAddUploadTab-box',
	          onDragEnter: this.onDragEnter },
	        this.renderDropzoneModal(),
	        this.renderContent()
	      )
	    );
	  }
	});
	
	exports.default = TeacherAddUploadTab;

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1502);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropZoneModal = function (_React$Component) {
	  _inherits(DropZoneModal, _React$Component);
	
	  function DropZoneModal() {
	    _classCallCheck(this, DropZoneModal);
	
	    return _possibleConstructorReturn(this, (DropZoneModal.__proto__ || Object.getPrototypeOf(DropZoneModal)).apply(this, arguments));
	  }
	
	  _createClass(DropZoneModal, [{
	    key: 'render',
	    value: function render() {
	      var content = void 0;
	      if (!this.props.isFileUploaded) {
	        content = {
	          containerClass: 'DropZoneModal-drop',
	          glyphName: 'upload',
	          glyphColor: 'brand'
	        };
	        if (this.props.isHovering) {
	          content.title = this.props.titleDrop || 'Drop attachment!';
	        } else {
	          content.title = this.props.title || 'Drag and drop attachment to upload';
	        }
	      } else {
	        content = {
	          containerClass: 'DropZoneModal-noDrop',
	          glyphName: 'disabled',
	          glyphColor: 'lava',
	          title: 'Sorry, you can only upload 1 attachment.'
	        };
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, this.props, {
	          className: (0, _classnames2.default)('DropZoneModal', {
	            hover: this.props.isHovering && !this.props.isFileUploaded
	          }) }),
	        _react2.default.createElement(
	          'div',
	          { className: 'DropZoneModal-wrap' },
	          _react2.default.createElement(
	            _Container2.default,
	            { className: (0, _classnames2.default)('DropZoneModal-container', content.containerClass) },
	            _react2.default.createElement(
	              'header',
	              { className: 'DropZoneModal-header' },
	              _react2.default.createElement(_Glyph2.default, {
	                className: 'DropZoneModal-glyph',
	                name: content.glyphName,
	                color: content.glyphColor,
	                size: 'xxlarge'
	              }),
	              _react2.default.createElement(
	                'h2',
	                { className: 'DropZoneModal-title' },
	                content.title
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DropZoneModal;
	}(_react2.default.Component);
	
	DropZoneModal.displayName = 'DropZoneModal';
	exports.default = DropZoneModal;

/***/ },
/* 1502 */
1136,
/* 1503 */,
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cookies = __webpack_require__(573);
	
	var _Cookies2 = _interopRequireDefault(_Cookies);
	
	var _FileDropzoneMixinSupport = __webpack_require__(1505);
	
	var _FileDropzoneMixinSupport2 = _interopRequireDefault(_FileDropzoneMixinSupport);
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  handleAddedFile: function handleAddedFile(file) {
	    file.key = _lodash2.default.uniqueId();
	
	    this.state.fileData[file.key] = { type: file.type };
	    this.setState({ files: this.state.files.concat(file) });
	
	    if (this.onAddedFile) {
	      this.onAddedFile(file);
	    }
	  },
	  handleRemovedFile: function handleRemovedFile(file) {
	    var fileIndex = this.state.files.indexOf(file);
	    this.state.files.splice(fileIndex, 1);
	    delete this.state.fileData[file.key];
	    this.setState({
	      files: this.state.files,
	      fileData: this.state.fileData
	    });
	  },
	  handleUploadProgress: function handleUploadProgress(file, progress /* , bytesSent */) {
	    this.state.fileData[file.key].progress = progress;
	    this.setState({ fileData: this.state.fileData });
	  },
	  handleUploadSuccess: function handleUploadSuccess(file) {
	    if (this.onUploadSuccess) {
	      this.onUploadSuccess(file);
	    }
	  },
	  handleSendingFile: function handleSendingFile(file, xhr) {
	    var csrfToken = _Cookies2.default.get('csrf_token');
	    if (csrfToken) {
	      xhr.setRequestHeader('X-CSRF-Token', csrfToken);
	    }
	  },
	  handleUploadError: function handleUploadError(file, error) {
	    // A second file is attempting to be uploaded
	    if (this.state.files.length > 1) {
	      this.removeFile(file);
	      return;
	    }
	
	    console.warn('Upload Error', error);
	    this.state.fileData[file.key].error = error;
	    this.setState({ fileData: this.state.fileData });
	    if (this.onUploadFailed) {
	      this.onUploadFailed(file, error);
	    }
	  }
	};
	
	
	var FileSenderMixin = Object.assign(mixin, _FileDropzoneMixinSupport2.default);
	
	exports.default = FileSenderMixin;

/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _File = __webpack_require__(929);
	
	var _File2 = _interopRequireDefault(_File);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// For the mixin:
	// The dependent mixin should have a getUploadURL function
	// It is the url to post the file to. Any other attributes
	// can be set in the handleSendingFile function
	//
	// Optional:
	// handlers for events
	//
	// For the component:
	// Dependencies: Requires a place for refs.dropzone and
	// the attach button needs to have class .addFileButton.
	// Can implement onUploadFailed to react to any errors
	//
	// Optional:
	//  If you have a getDropzoneId function that returns a
	//  unique string id, you can have multiple dropzones.
	//  This is used for things like having saving the state
	//  of a page and coming back, or showing multiple
	//  dropzones on a single page.
	
	var MAX_FILESIZE = 10 * 1024 * 1024;
	var MAX_FILESIZE_NAME = '10MB';
	
	var dropzones = [];
	
	var stack = [];
	var windowDragEventCount = 0;
	var setUpMouseMoveListener = false;
	
	// This is needed because mouse events still sometimes fire
	//   when you’re dragging a file in chrome.
	var mouseMoveClearTimeout = null;
	
	var handleMouseMove = function handleMouseMove() {
	  if (!mouseMoveClearTimeout) {
	    mouseMoveClearTimeout = setTimeout(function () {
	      windowDragEventCount = 0;
	      stack.forEach(function (s) {
	        return s.handleMouseMoveWindow();
	      });
	
	      if (setUpMouseMoveListener) {
	        setUpMouseMoveListener = false;
	        window.removeEventListener('mousemove', handleMouseMove);
	      }
	    }, 100);
	  }
	};
	
	var handleDragMove = function handleDragMove() {
	  if (mouseMoveClearTimeout) {
	    clearTimeout(mouseMoveClearTimeout);
	    mouseMoveClearTimeout = null;
	  }
	};
	
	var handleDragEnter = function handleDragEnter(event) {
	  windowDragEventCount = Math.min(windowDragEventCount + 1, 2);
	  stack.forEach(function (s) {
	    return s.handleDragEnterWindow(event);
	  });
	
	  if (!setUpMouseMoveListener) {
	    setUpMouseMoveListener = true;
	    window.addEventListener('mousemove', handleMouseMove, false);
	  }
	};
	
	var handleDragLeave = function handleDragLeave(event) {
	  windowDragEventCount--;
	  stack.forEach(function (s) {
	    return s.handleDragLeave(event);
	  });
	};
	
	var handleDropFile = function handleDropFile(event) {
	  event.preventDefault();
	  windowDragEventCount = 0;
	  stack.forEach(function (s) {
	    return s.handleDropFile(event);
	  });
	};
	
	var FileDropzoneMixinSupport = {
	  uploadFields: {},
	  dragEventCount: 0,
	
	  getInitialState: function getInitialState() {
	    return {
	      fileEntities: {},
	      files: [],
	      fileData: {},
	      isDraggingFile: false,
	      isDraggingFileInner: false,
	      dropzoneAttachFailed: false
	    };
	  },
	  _getDropzone: function _getDropzone() {
	    var id = '_default';
	    if (typeof this.getDropzoneId === 'function') {
	      var dropzoneId = this.getDropzoneId();
	      if (dropzoneId) {
	        id = dropzoneId;
	      }
	    }
	    if (!dropzones[id] && !this.state.dropzoneAttachFailed) {
	      dropzones[id] = this._initializeDropzone();
	    }
	    return dropzones[id];
	  },
	  getFileEntities: function getFileEntities() {
	    var _this = this;
	
	    return this.state.files.map(function (file) {
	      return _this.state.fileEntities[file.key];
	    });
	  },
	  getFileData: function getFileData(file) {
	    if (!file) {
	      return null;
	    }
	
	    return this.state.fileData[file.key];
	  },
	  _destroyDropzone: function _destroyDropzone() {
	    var id = '_default';
	    if (typeof this.getDropzoneId === 'function') {
	      id = this.getDropzoneId();
	    }
	    if (dropzones[id]) {
	      dropzones[id].destroy();
	      dropzones[id] = undefined;
	    }
	  },
	  _refreshEventListeners: function _refreshEventListeners(dz) {
	    var _this2 = this;
	
	    var resolvedDz = dz || this._getDropzone();
	    if (resolvedDz) {
	      (function () {
	        if (_this2.handleAcceptFile) {
	          resolvedDz.options.accept = _this2.handleAcceptFile;
	        }
	
	        var refreshFcns = {
	          addedfile: _this2.handleAddedFile,
	          removedfile: _this2.handleRemovedFile,
	          thumbnail: _this2.handleThumbnail,
	          uploadprogress: _this2.handleUploadProgress,
	          sending: _this2.handleSendingFile,
	          success: _this2.handleUploadSuccess,
	          error: _this2.handleUploadError,
	          dragenter: _this2.handleDragEnterInner,
	          dragleave: _this2.handleDragLeaveInner,
	          drop: handleDropFile
	        };
	
	        Object.keys(refreshFcns).forEach(function (key) {
	          resolvedDz.off(key);
	          if (refreshFcns[key]) {
	            resolvedDz.on(key, refreshFcns[key]);
	          }
	        });
	      })();
	    }
	  },
	  _initializeDropzone: function _initializeDropzone() {
	    if (!this.refs.dropzone_attach) {
	      return undefined;
	    }
	
	    try {
	      var Dropzone = __webpack_require__(1506);
	      Dropzone.autoDiscover = false;
	
	      var clickable = 'addFileButton_' + this.getDropzoneId();
	      var dropzone = new Dropzone(_reactDom2.default.findDOMNode(this.refs.dropzone), {
	        url: this.getUploadURL,
	        clickable: document.getElementsByClassName(clickable).length ? '.' + clickable : false,
	        paramName: 'file',
	        maxFiles: 1,
	        uploadMultiple: false,
	        uploadprogress: this.handleUploadProgress,
	        maxFilesize: MAX_FILESIZE / (1024 * 1024)
	      });
	      this._refreshEventListeners(dropzone);
	      return dropzone;
	    } catch (e) {
	      if (e.message === 'Dropzone already attached.') {
	        this.setState({ dropzoneAttachFailed: true });
	        return undefined;
	      } else {
	        throw e;
	      }
	    }
	  },
	  getFiles: function getFiles() {
	    return this.state.files;
	  },
	  getMaxFilesize: function getMaxFilesize() {
	    return MAX_FILESIZE;
	  },
	  getMaxFilesizeName: function getMaxFilesizeName() {
	    return MAX_FILESIZE_NAME;
	  },
	  destroyDropzoneIfEmpty: function destroyDropzoneIfEmpty() {
	    if (this._getDropzone() && this.state.files.length === 0) {
	      this._destroyDropzone();
	    }
	  },
	  _removeWindowDragListeners: function _removeWindowDragListeners() {
	    window.removeEventListener('dragenter', handleDragEnter);
	    window.removeEventListener('dragleave', handleDragLeave);
	    window.removeEventListener('dragover', handleDragMove);
	    window.removeEventListener('drop', handleDropFile);
	
	    if (setUpMouseMoveListener) {
	      setUpMouseMoveListener = false;
	      window.removeEventListener('mousemove', handleMouseMove);
	    }
	  },
	  initWindowDragListeners: function initWindowDragListeners() {
	    this._removeWindowDragListeners();
	
	    // NOTE: The dragenter event must be registered on the window so that the drop
	    // zone appears as soon as a file is dragged into the window. You can't do
	    // 'this.dropzone.on('dragenter', this.handleDragEnter);' because it only
	    // listens to events inside the dropzone element.
	    window.addEventListener('dragenter', handleDragEnter, false);
	    window.addEventListener('dragleave', handleDragLeave, false);
	    window.addEventListener('dragover', handleDragMove, false);
	    window.addEventListener('drop', handleDropFile, false);
	  },
	  componentWillMount: function componentWillMount() {
	    if (stack.length === 0) {
	      this.initWindowDragListeners();
	    }
	
	    stack.push(this);
	  },
	  componentDidMount: function componentDidMount() {
	    this._getDropzone();
	
	    this._refreshEventListeners();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (this._getDropzone()) {
	      // If the component updates we must re-bind the event handlers
	      this._refreshEventListeners();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.destroyDropzoneIfEmpty();
	
	    stack.pop();
	
	    if (stack.length === 0) {
	      this._removeWindowDragListeners();
	    }
	  },
	  handleMouseMoveWindow: function handleMouseMoveWindow() {
	    // reset event counts
	    this.dragEventCount = 0;
	
	    this.setState({
	      isDraggingFile: false,
	      isDraggingFileInner: false
	    });
	  },
	  handleDragEnterWindow: function handleDragEnterWindow(event) {
	    this.handleDragEnter(event);
	
	    if (typeof this.onDragOverWindow === 'function') {
	      this.onDragOverWindow();
	    }
	  },
	  handleDragEnter: function handleDragEnter(event) {
	    event.preventDefault();
	
	    this.setState({ isDraggingFile: true });
	  },
	  handleDragEnterInner: function handleDragEnterInner(event) {
	    windowDragEventCount = Math.min(windowDragEventCount + 1, 2);
	    this.handleDragEnter(event);
	    event.cancelBubble = true;
	
	    this.dragEventCount = Math.min(this.dragEventCount + 1, 2);
	    this.setState({ isDraggingFileInner: true });
	
	    if (typeof this.onDragOverDropzone === 'function') {
	      this.onDragOverDropzone();
	    }
	  },
	  handleDragLeave: function handleDragLeave(event) {
	    event.preventDefault();
	
	    if (windowDragEventCount === 0) {
	      this.setState({ isDraggingFile: false });
	    }
	  },
	  handleDragLeaveInner: function handleDragLeaveInner(event) {
	    windowDragEventCount--;
	    this.handleDragLeave(event);
	    event.cancelBubble = true;
	
	    this.dragEventCount--;
	    // When dragEventCount is 0, this means the drag went out of
	    // all elements and consequently, the window
	    if (this.dragEventCount === 0) {
	      this.setState({ isDraggingFileInner: false });
	    }
	  },
	  handleDropFile: function handleDropFile(event) {
	    event.preventDefault();
	    this.dragEventCount = 0;
	    this.setState({ isDraggingFile: false, isDraggingFileInner: false });
	  },
	  removeFile: function removeFile(file) {
	    this.setState({ uploadedFile: null });
	    this._getDropzone().removeFile(file);
	    this.destroyDropzoneIfEmpty();
	  },
	  removeAllFiles: function removeAllFiles() {
	    if (this._getDropzone().removeAllFiles) {
	      this._getDropzone().removeAllFiles();
	      this.setState({ files: [], fileData: {} });
	    }
	    this.destroyDropzoneIfEmpty();
	  },
	  retryUpload: function retryUpload(file) {
	    this.removeFile(file);
	    this._getDropzone().addFile(file);
	  },
	  resetDropzone: function resetDropzone() {
	    this.removeAllFiles();
	    this._getDropzone();
	  },
	  addFile: function addFile(file) {
	    var mockFile = {
	      id: file.id,
	      type: file.getContentType(),
	      size: file.getSize(),
	      name: file.getName(),
	      urls: file.getUrls()
	    };
	
	    var dz = this._getDropzone();
	    dz.emit('addedfile', mockFile);
	    this.setState({ uploadedFile: _File2.default.fromJSON(mockFile) });
	    dz.emit('uploadprogress', mockFile, 100);
	  }
	};
	
	exports.default = FileDropzoneMixinSupport;

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {
	/*
	 *
	 * More info at [www.dropzonejs.com](http://www.dropzonejs.com)
	 *
	 * Copyright (c) 2012, Matias Meno
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 *
	 */
	
	(function() {
	  var Dropzone, Emitter, camelize, contentLoaded, detectVerticalSquash, drawImageIOSFix, noop, without,
	    __slice = [].slice,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };
	
	  noop = function() {};
	
	  Emitter = (function() {
	    function Emitter() {}
	
	    Emitter.prototype.addEventListener = Emitter.prototype.on;
	
	    Emitter.prototype.on = function(event, fn) {
	      this._callbacks = this._callbacks || {};
	      if (!this._callbacks[event]) {
	        this._callbacks[event] = [];
	      }
	      this._callbacks[event].push(fn);
	      return this;
	    };
	
	    Emitter.prototype.emit = function() {
	      var args, callback, callbacks, event, _i, _len;
	      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	      this._callbacks = this._callbacks || {};
	      callbacks = this._callbacks[event];
	      if (callbacks) {
	        for (_i = 0, _len = callbacks.length; _i < _len; _i++) {
	          callback = callbacks[_i];
	          callback.apply(this, args);
	        }
	      }
	      return this;
	    };
	
	    Emitter.prototype.removeListener = Emitter.prototype.off;
	
	    Emitter.prototype.removeAllListeners = Emitter.prototype.off;
	
	    Emitter.prototype.removeEventListener = Emitter.prototype.off;
	
	    Emitter.prototype.off = function(event, fn) {
	      var callback, callbacks, i, _i, _len;
	      if (!this._callbacks || arguments.length === 0) {
	        this._callbacks = {};
	        return this;
	      }
	      callbacks = this._callbacks[event];
	      if (!callbacks) {
	        return this;
	      }
	      if (arguments.length === 1) {
	        delete this._callbacks[event];
	        return this;
	      }
	      for (i = _i = 0, _len = callbacks.length; _i < _len; i = ++_i) {
	        callback = callbacks[i];
	        if (callback === fn) {
	          callbacks.splice(i, 1);
	          break;
	        }
	      }
	      return this;
	    };
	
	    return Emitter;
	
	  })();
	
	  Dropzone = (function(_super) {
	    var extend, resolveOption;
	
	    __extends(Dropzone, _super);
	
	    Dropzone.prototype.Emitter = Emitter;
	
	
	    /*
	    This is a list of all available events you can register on a dropzone object.
	    
	    You can register an event handler like this:
	    
	        dropzone.on("dragEnter", function() { });
	     */
	
	    Dropzone.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"];
	
	    Dropzone.prototype.defaultOptions = {
	      url: null,
	      method: "post",
	      withCredentials: false,
	      parallelUploads: 2,
	      uploadMultiple: false,
	      maxFilesize: 256,
	      paramName: "file",
	      createImageThumbnails: true,
	      maxThumbnailFilesize: 10,
	      thumbnailWidth: 120,
	      thumbnailHeight: 120,
	      filesizeBase: 1000,
	      maxFiles: null,
	      params: {},
	      clickable: true,
	      ignoreHiddenFiles: true,
	      acceptedFiles: null,
	      acceptedMimeTypes: null,
	      autoProcessQueue: true,
	      autoQueue: true,
	      addRemoveLinks: false,
	      previewsContainer: null,
	      hiddenInputContainer: "body",
	      capture: null,
	      renameFilename: null,
	      dictDefaultMessage: "Drop files here to upload",
	      dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
	      dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
	      dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
	      dictInvalidFileType: "You can't upload files of this type.",
	      dictResponseError: "Server responded with {{statusCode}} code.",
	      dictCancelUpload: "Cancel upload",
	      dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
	      dictRemoveFile: "Remove file",
	      dictRemoveFileConfirmation: null,
	      dictMaxFilesExceeded: "You can not upload any more files.",
	      accept: function(file, done) {
	        return done();
	      },
	      init: function() {
	        return noop;
	      },
	      forceFallback: false,
	      fallback: function() {
	        var child, messageElement, span, _i, _len, _ref;
	        this.element.className = "" + this.element.className + " dz-browser-not-supported";
	        _ref = this.element.getElementsByTagName("div");
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          child = _ref[_i];
	          if (/(^| )dz-message($| )/.test(child.className)) {
	            messageElement = child;
	            child.className = "dz-message";
	            continue;
	          }
	        }
	        if (!messageElement) {
	          messageElement = Dropzone.createElement("<div class=\"dz-message\"><span></span></div>");
	          this.element.appendChild(messageElement);
	        }
	        span = messageElement.getElementsByTagName("span")[0];
	        if (span) {
	          if (span.textContent != null) {
	            span.textContent = this.options.dictFallbackMessage;
	          } else if (span.innerText != null) {
	            span.innerText = this.options.dictFallbackMessage;
	          }
	        }
	        return this.element.appendChild(this.getFallbackForm());
	      },
	      resize: function(file) {
	        var info, srcRatio, trgRatio;
	        info = {
	          srcX: 0,
	          srcY: 0,
	          srcWidth: file.width,
	          srcHeight: file.height
	        };
	        srcRatio = file.width / file.height;
	        info.optWidth = this.options.thumbnailWidth;
	        info.optHeight = this.options.thumbnailHeight;
	        if ((info.optWidth == null) && (info.optHeight == null)) {
	          info.optWidth = info.srcWidth;
	          info.optHeight = info.srcHeight;
	        } else if (info.optWidth == null) {
	          info.optWidth = srcRatio * info.optHeight;
	        } else if (info.optHeight == null) {
	          info.optHeight = (1 / srcRatio) * info.optWidth;
	        }
	        trgRatio = info.optWidth / info.optHeight;
	        if (file.height < info.optHeight || file.width < info.optWidth) {
	          info.trgHeight = info.srcHeight;
	          info.trgWidth = info.srcWidth;
	        } else {
	          if (srcRatio > trgRatio) {
	            info.srcHeight = file.height;
	            info.srcWidth = info.srcHeight * trgRatio;
	          } else {
	            info.srcWidth = file.width;
	            info.srcHeight = info.srcWidth / trgRatio;
	          }
	        }
	        info.srcX = (file.width - info.srcWidth) / 2;
	        info.srcY = (file.height - info.srcHeight) / 2;
	        return info;
	      },
	
	      /*
	      Those functions register themselves to the events on init and handle all
	      the user interface specific stuff. Overwriting them won't break the upload
	      but can break the way it's displayed.
	      You can overwrite them if you don't like the default behavior. If you just
	      want to add an additional event handler, register it on the dropzone object
	      and don't overwrite those options.
	       */
	      drop: function(e) {
	        return this.element.classList.remove("dz-drag-hover");
	      },
	      dragstart: noop,
	      dragend: function(e) {
	        return this.element.classList.remove("dz-drag-hover");
	      },
	      dragenter: function(e) {
	        return this.element.classList.add("dz-drag-hover");
	      },
	      dragover: function(e) {
	        return this.element.classList.add("dz-drag-hover");
	      },
	      dragleave: function(e) {
	        return this.element.classList.remove("dz-drag-hover");
	      },
	      paste: noop,
	      reset: function() {
	        return this.element.classList.remove("dz-started");
	      },
	      addedfile: function(file) {
	        var node, removeFileEvent, removeLink, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2, _results;
	        if (this.element === this.previewsContainer) {
	          this.element.classList.add("dz-started");
	        }
	        if (this.previewsContainer) {
	          file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim());
	          file.previewTemplate = file.previewElement;
	          this.previewsContainer.appendChild(file.previewElement);
	          _ref = file.previewElement.querySelectorAll("[data-dz-name]");
	          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	            node = _ref[_i];
	            node.textContent = this._renameFilename(file.name);
	          }
	          _ref1 = file.previewElement.querySelectorAll("[data-dz-size]");
	          for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
	            node = _ref1[_j];
	            node.innerHTML = this.filesize(file.size);
	          }
	          if (this.options.addRemoveLinks) {
	            file._removeLink = Dropzone.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>" + this.options.dictRemoveFile + "</a>");
	            file.previewElement.appendChild(file._removeLink);
	          }
	          removeFileEvent = (function(_this) {
	            return function(e) {
	              e.preventDefault();
	              e.stopPropagation();
	              if (file.status === Dropzone.UPLOADING) {
	                return Dropzone.confirm(_this.options.dictCancelUploadConfirmation, function() {
	                  return _this.removeFile(file);
	                });
	              } else {
	                if (_this.options.dictRemoveFileConfirmation) {
	                  return Dropzone.confirm(_this.options.dictRemoveFileConfirmation, function() {
	                    return _this.removeFile(file);
	                  });
	                } else {
	                  return _this.removeFile(file);
	                }
	              }
	            };
	          })(this);
	          _ref2 = file.previewElement.querySelectorAll("[data-dz-remove]");
	          _results = [];
	          for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
	            removeLink = _ref2[_k];
	            _results.push(removeLink.addEventListener("click", removeFileEvent));
	          }
	          return _results;
	        }
	      },
	      removedfile: function(file) {
	        var _ref;
	        if (file.previewElement) {
	          if ((_ref = file.previewElement) != null) {
	            _ref.parentNode.removeChild(file.previewElement);
	          }
	        }
	        return this._updateMaxFilesReachedClass();
	      },
	      thumbnail: function(file, dataUrl) {
	        var thumbnailElement, _i, _len, _ref;
	        if (file.previewElement) {
	          file.previewElement.classList.remove("dz-file-preview");
	          _ref = file.previewElement.querySelectorAll("[data-dz-thumbnail]");
	          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	            thumbnailElement = _ref[_i];
	            thumbnailElement.alt = file.name;
	            thumbnailElement.src = dataUrl;
	          }
	          return setTimeout(((function(_this) {
	            return function() {
	              return file.previewElement.classList.add("dz-image-preview");
	            };
	          })(this)), 1);
	        }
	      },
	      error: function(file, message) {
	        var node, _i, _len, _ref, _results;
	        if (file.previewElement) {
	          file.previewElement.classList.add("dz-error");
	          if (typeof message !== "String" && message.error) {
	            message = message.error;
	          }
	          _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
	          _results = [];
	          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	            node = _ref[_i];
	            _results.push(node.textContent = message);
	          }
	          return _results;
	        }
	      },
	      errormultiple: noop,
	      processing: function(file) {
	        if (file.previewElement) {
	          file.previewElement.classList.add("dz-processing");
	          if (file._removeLink) {
	            return file._removeLink.textContent = this.options.dictCancelUpload;
	          }
	        }
	      },
	      processingmultiple: noop,
	      uploadprogress: function(file, progress, bytesSent) {
	        var node, _i, _len, _ref, _results;
	        if (file.previewElement) {
	          _ref = file.previewElement.querySelectorAll("[data-dz-uploadprogress]");
	          _results = [];
	          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	            node = _ref[_i];
	            if (node.nodeName === 'PROGRESS') {
	              _results.push(node.value = progress);
	            } else {
	              _results.push(node.style.width = "" + progress + "%");
	            }
	          }
	          return _results;
	        }
	      },
	      totaluploadprogress: noop,
	      sending: noop,
	      sendingmultiple: noop,
	      success: function(file) {
	        if (file.previewElement) {
	          return file.previewElement.classList.add("dz-success");
	        }
	      },
	      successmultiple: noop,
	      canceled: function(file) {
	        return this.emit("error", file, "Upload canceled.");
	      },
	      canceledmultiple: noop,
	      complete: function(file) {
	        if (file._removeLink) {
	          file._removeLink.textContent = this.options.dictRemoveFile;
	        }
	        if (file.previewElement) {
	          return file.previewElement.classList.add("dz-complete");
	        }
	      },
	      completemultiple: noop,
	      maxfilesexceeded: noop,
	      maxfilesreached: noop,
	      queuecomplete: noop,
	      addedfiles: noop,
	      previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size></span></div>\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n  </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>"
	    };
	
	    extend = function() {
	      var key, object, objects, target, val, _i, _len;
	      target = arguments[0], objects = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	      for (_i = 0, _len = objects.length; _i < _len; _i++) {
	        object = objects[_i];
	        for (key in object) {
	          val = object[key];
	          target[key] = val;
	        }
	      }
	      return target;
	    };
	
	    function Dropzone(element, options) {
	      var elementOptions, fallback, _ref;
	      this.element = element;
	      this.version = Dropzone.version;
	      this.defaultOptions.previewTemplate = this.defaultOptions.previewTemplate.replace(/\n*/g, "");
	      this.clickableElements = [];
	      this.listeners = [];
	      this.files = [];
	      if (typeof this.element === "string") {
	        this.element = document.querySelector(this.element);
	      }
	      if (!(this.element && (this.element.nodeType != null))) {
	        throw new Error("Invalid dropzone element.");
	      }
	      if (this.element.dropzone) {
	        throw new Error("Dropzone already attached.");
	      }
	      Dropzone.instances.push(this);
	      this.element.dropzone = this;
	      elementOptions = (_ref = Dropzone.optionsForElement(this.element)) != null ? _ref : {};
	      this.options = extend({}, this.defaultOptions, elementOptions, options != null ? options : {});
	      if (this.options.forceFallback || !Dropzone.isBrowserSupported()) {
	        return this.options.fallback.call(this);
	      }
	      if (this.options.url == null) {
	        this.options.url = this.element.getAttribute("action");
	      }
	      if (!this.options.url) {
	        throw new Error("No URL provided.");
	      }
	      if (this.options.acceptedFiles && this.options.acceptedMimeTypes) {
	        throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
	      }
	      if (this.options.acceptedMimeTypes) {
	        this.options.acceptedFiles = this.options.acceptedMimeTypes;
	        delete this.options.acceptedMimeTypes;
	      }
	      this.options.method = this.options.method.toUpperCase();
	      if ((fallback = this.getExistingFallback()) && fallback.parentNode) {
	        fallback.parentNode.removeChild(fallback);
	      }
	      if (this.options.previewsContainer !== false) {
	        if (this.options.previewsContainer) {
	          this.previewsContainer = Dropzone.getElement(this.options.previewsContainer, "previewsContainer");
	        } else {
	          this.previewsContainer = this.element;
	        }
	      }
	      if (this.options.clickable) {
	        if (this.options.clickable === true) {
	          this.clickableElements = [this.element];
	        } else {
	          this.clickableElements = Dropzone.getElements(this.options.clickable, "clickable");
	        }
	      }
	      this.init();
	    }
	
	    Dropzone.prototype.getAcceptedFiles = function() {
	      var file, _i, _len, _ref, _results;
	      _ref = this.files;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        if (file.accepted) {
	          _results.push(file);
	        }
	      }
	      return _results;
	    };
	
	    Dropzone.prototype.getRejectedFiles = function() {
	      var file, _i, _len, _ref, _results;
	      _ref = this.files;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        if (!file.accepted) {
	          _results.push(file);
	        }
	      }
	      return _results;
	    };
	
	    Dropzone.prototype.getFilesWithStatus = function(status) {
	      var file, _i, _len, _ref, _results;
	      _ref = this.files;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        if (file.status === status) {
	          _results.push(file);
	        }
	      }
	      return _results;
	    };
	
	    Dropzone.prototype.getQueuedFiles = function() {
	      return this.getFilesWithStatus(Dropzone.QUEUED);
	    };
	
	    Dropzone.prototype.getUploadingFiles = function() {
	      return this.getFilesWithStatus(Dropzone.UPLOADING);
	    };
	
	    Dropzone.prototype.getAddedFiles = function() {
	      return this.getFilesWithStatus(Dropzone.ADDED);
	    };
	
	    Dropzone.prototype.getActiveFiles = function() {
	      var file, _i, _len, _ref, _results;
	      _ref = this.files;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        if (file.status === Dropzone.UPLOADING || file.status === Dropzone.QUEUED) {
	          _results.push(file);
	        }
	      }
	      return _results;
	    };
	
	    Dropzone.prototype.init = function() {
	      var eventName, noPropagation, setupHiddenFileInput, _i, _len, _ref, _ref1;
	      if (this.element.tagName === "form") {
	        this.element.setAttribute("enctype", "multipart/form-data");
	      }
	      if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) {
	        this.element.appendChild(Dropzone.createElement("<div class=\"dz-default dz-message\"><span>" + this.options.dictDefaultMessage + "</span></div>"));
	      }
	      if (this.clickableElements.length) {
	        setupHiddenFileInput = (function(_this) {
	          return function() {
	            if (_this.hiddenFileInput) {
	              _this.hiddenFileInput.parentNode.removeChild(_this.hiddenFileInput);
	            }
	            _this.hiddenFileInput = document.createElement("input");
	            _this.hiddenFileInput.setAttribute("type", "file");
	            if ((_this.options.maxFiles == null) || _this.options.maxFiles > 1) {
	              _this.hiddenFileInput.setAttribute("multiple", "multiple");
	            }
	            _this.hiddenFileInput.className = "dz-hidden-input";
	            if (_this.options.acceptedFiles != null) {
	              _this.hiddenFileInput.setAttribute("accept", _this.options.acceptedFiles);
	            }
	            if (_this.options.capture != null) {
	              _this.hiddenFileInput.setAttribute("capture", _this.options.capture);
	            }
	            _this.hiddenFileInput.style.visibility = "hidden";
	            _this.hiddenFileInput.style.position = "absolute";
	            _this.hiddenFileInput.style.top = "0";
	            _this.hiddenFileInput.style.left = "0";
	            _this.hiddenFileInput.style.height = "0";
	            _this.hiddenFileInput.style.width = "0";
	            document.querySelector(_this.options.hiddenInputContainer).appendChild(_this.hiddenFileInput);
	            return _this.hiddenFileInput.addEventListener("change", function() {
	              var file, files, _i, _len;
	              files = _this.hiddenFileInput.files;
	              if (files.length) {
	                for (_i = 0, _len = files.length; _i < _len; _i++) {
	                  file = files[_i];
	                  _this.addFile(file);
	                }
	              }
	              _this.emit("addedfiles", files);
	              return setupHiddenFileInput();
	            });
	          };
	        })(this);
	        setupHiddenFileInput();
	      }
	      this.URL = (_ref = window.URL) != null ? _ref : window.webkitURL;
	      _ref1 = this.events;
	      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
	        eventName = _ref1[_i];
	        this.on(eventName, this.options[eventName]);
	      }
	      this.on("uploadprogress", (function(_this) {
	        return function() {
	          return _this.updateTotalUploadProgress();
	        };
	      })(this));
	      this.on("removedfile", (function(_this) {
	        return function() {
	          return _this.updateTotalUploadProgress();
	        };
	      })(this));
	      this.on("canceled", (function(_this) {
	        return function(file) {
	          return _this.emit("complete", file);
	        };
	      })(this));
	      this.on("complete", (function(_this) {
	        return function(file) {
	          if (_this.getAddedFiles().length === 0 && _this.getUploadingFiles().length === 0 && _this.getQueuedFiles().length === 0) {
	            return setTimeout((function() {
	              return _this.emit("queuecomplete");
	            }), 0);
	          }
	        };
	      })(this));
	      noPropagation = function(e) {
	        e.stopPropagation();
	        if (e.preventDefault) {
	          return e.preventDefault();
	        } else {
	          return e.returnValue = false;
	        }
	      };
	      this.listeners = [
	        {
	          element: this.element,
	          events: {
	            "dragstart": (function(_this) {
	              return function(e) {
	                return _this.emit("dragstart", e);
	              };
	            })(this),
	            "dragenter": (function(_this) {
	              return function(e) {
	                noPropagation(e);
	                return _this.emit("dragenter", e);
	              };
	            })(this),
	            "dragover": (function(_this) {
	              return function(e) {
	                var efct;
	                try {
	                  efct = e.dataTransfer.effectAllowed;
	                } catch (_error) {}
	                e.dataTransfer.dropEffect = 'move' === efct || 'linkMove' === efct ? 'move' : 'copy';
	                noPropagation(e);
	                return _this.emit("dragover", e);
	              };
	            })(this),
	            "dragleave": (function(_this) {
	              return function(e) {
	                return _this.emit("dragleave", e);
	              };
	            })(this),
	            "drop": (function(_this) {
	              return function(e) {
	                noPropagation(e);
	                return _this.drop(e);
	              };
	            })(this),
	            "dragend": (function(_this) {
	              return function(e) {
	                return _this.emit("dragend", e);
	              };
	            })(this)
	          }
	        }
	      ];
	      this.clickableElements.forEach((function(_this) {
	        return function(clickableElement) {
	          return _this.listeners.push({
	            element: clickableElement,
	            events: {
	              "click": function(evt) {
	                if ((clickableElement !== _this.element) || (evt.target === _this.element || Dropzone.elementInside(evt.target, _this.element.querySelector(".dz-message")))) {
	                  _this.hiddenFileInput.click();
	                }
	                return true;
	              }
	            }
	          });
	        };
	      })(this));
	      this.enable();
	      return this.options.init.call(this);
	    };
	
	    Dropzone.prototype.destroy = function() {
	      var _ref;
	      this.disable();
	      this.removeAllFiles(true);
	      if ((_ref = this.hiddenFileInput) != null ? _ref.parentNode : void 0) {
	        this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
	        this.hiddenFileInput = null;
	      }
	      delete this.element.dropzone;
	      return Dropzone.instances.splice(Dropzone.instances.indexOf(this), 1);
	    };
	
	    Dropzone.prototype.updateTotalUploadProgress = function() {
	      var activeFiles, file, totalBytes, totalBytesSent, totalUploadProgress, _i, _len, _ref;
	      totalBytesSent = 0;
	      totalBytes = 0;
	      activeFiles = this.getActiveFiles();
	      if (activeFiles.length) {
	        _ref = this.getActiveFiles();
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          file = _ref[_i];
	          totalBytesSent += file.upload.bytesSent;
	          totalBytes += file.upload.total;
	        }
	        totalUploadProgress = 100 * totalBytesSent / totalBytes;
	      } else {
	        totalUploadProgress = 100;
	      }
	      return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
	    };
	
	    Dropzone.prototype._getParamName = function(n) {
	      if (typeof this.options.paramName === "function") {
	        return this.options.paramName(n);
	      } else {
	        return "" + this.options.paramName + (this.options.uploadMultiple ? "[" + n + "]" : "");
	      }
	    };
	
	    Dropzone.prototype._renameFilename = function(name) {
	      if (typeof this.options.renameFilename !== "function") {
	        return name;
	      }
	      return this.options.renameFilename(name);
	    };
	
	    Dropzone.prototype.getFallbackForm = function() {
	      var existingFallback, fields, fieldsString, form;
	      if (existingFallback = this.getExistingFallback()) {
	        return existingFallback;
	      }
	      fieldsString = "<div class=\"dz-fallback\">";
	      if (this.options.dictFallbackText) {
	        fieldsString += "<p>" + this.options.dictFallbackText + "</p>";
	      }
	      fieldsString += "<input type=\"file\" name=\"" + (this._getParamName(0)) + "\" " + (this.options.uploadMultiple ? 'multiple="multiple"' : void 0) + " /><input type=\"submit\" value=\"Upload!\"></div>";
	      fields = Dropzone.createElement(fieldsString);
	      if (this.element.tagName !== "FORM") {
	        form = Dropzone.createElement("<form action=\"" + this.options.url + "\" enctype=\"multipart/form-data\" method=\"" + this.options.method + "\"></form>");
	        form.appendChild(fields);
	      } else {
	        this.element.setAttribute("enctype", "multipart/form-data");
	        this.element.setAttribute("method", this.options.method);
	      }
	      return form != null ? form : fields;
	    };
	
	    Dropzone.prototype.getExistingFallback = function() {
	      var fallback, getFallback, tagName, _i, _len, _ref;
	      getFallback = function(elements) {
	        var el, _i, _len;
	        for (_i = 0, _len = elements.length; _i < _len; _i++) {
	          el = elements[_i];
	          if (/(^| )fallback($| )/.test(el.className)) {
	            return el;
	          }
	        }
	      };
	      _ref = ["div", "form"];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        tagName = _ref[_i];
	        if (fallback = getFallback(this.element.getElementsByTagName(tagName))) {
	          return fallback;
	        }
	      }
	    };
	
	    Dropzone.prototype.setupEventListeners = function() {
	      var elementListeners, event, listener, _i, _len, _ref, _results;
	      _ref = this.listeners;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        elementListeners = _ref[_i];
	        _results.push((function() {
	          var _ref1, _results1;
	          _ref1 = elementListeners.events;
	          _results1 = [];
	          for (event in _ref1) {
	            listener = _ref1[event];
	            _results1.push(elementListeners.element.addEventListener(event, listener, false));
	          }
	          return _results1;
	        })());
	      }
	      return _results;
	    };
	
	    Dropzone.prototype.removeEventListeners = function() {
	      var elementListeners, event, listener, _i, _len, _ref, _results;
	      _ref = this.listeners;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        elementListeners = _ref[_i];
	        _results.push((function() {
	          var _ref1, _results1;
	          _ref1 = elementListeners.events;
	          _results1 = [];
	          for (event in _ref1) {
	            listener = _ref1[event];
	            _results1.push(elementListeners.element.removeEventListener(event, listener, false));
	          }
	          return _results1;
	        })());
	      }
	      return _results;
	    };
	
	    Dropzone.prototype.disable = function() {
	      var file, _i, _len, _ref, _results;
	      this.clickableElements.forEach(function(element) {
	        return element.classList.remove("dz-clickable");
	      });
	      this.removeEventListeners();
	      _ref = this.files;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        _results.push(this.cancelUpload(file));
	      }
	      return _results;
	    };
	
	    Dropzone.prototype.enable = function() {
	      this.clickableElements.forEach(function(element) {
	        return element.classList.add("dz-clickable");
	      });
	      return this.setupEventListeners();
	    };
	
	    Dropzone.prototype.filesize = function(size) {
	      var cutoff, i, selectedSize, selectedUnit, unit, units, _i, _len;
	      selectedSize = 0;
	      selectedUnit = "b";
	      if (size > 0) {
	        units = ['TB', 'GB', 'MB', 'KB', 'b'];
	        for (i = _i = 0, _len = units.length; _i < _len; i = ++_i) {
	          unit = units[i];
	          cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
	          if (size >= cutoff) {
	            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
	            selectedUnit = unit;
	            break;
	          }
	        }
	        selectedSize = Math.round(10 * selectedSize) / 10;
	      }
	      return "<strong>" + selectedSize + "</strong> " + selectedUnit;
	    };
	
	    Dropzone.prototype._updateMaxFilesReachedClass = function() {
	      if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
	        if (this.getAcceptedFiles().length === this.options.maxFiles) {
	          this.emit('maxfilesreached', this.files);
	        }
	        return this.element.classList.add("dz-max-files-reached");
	      } else {
	        return this.element.classList.remove("dz-max-files-reached");
	      }
	    };
	
	    Dropzone.prototype.drop = function(e) {
	      var files, items;
	      if (!e.dataTransfer) {
	        return;
	      }
	      this.emit("drop", e);
	      files = e.dataTransfer.files;
	      this.emit("addedfiles", files);
	      if (files.length) {
	        items = e.dataTransfer.items;
	        if (items && items.length && (items[0].webkitGetAsEntry != null)) {
	          this._addFilesFromItems(items);
	        } else {
	          this.handleFiles(files);
	        }
	      }
	    };
	
	    Dropzone.prototype.paste = function(e) {
	      var items, _ref;
	      if ((e != null ? (_ref = e.clipboardData) != null ? _ref.items : void 0 : void 0) == null) {
	        return;
	      }
	      this.emit("paste", e);
	      items = e.clipboardData.items;
	      if (items.length) {
	        return this._addFilesFromItems(items);
	      }
	    };
	
	    Dropzone.prototype.handleFiles = function(files) {
	      var file, _i, _len, _results;
	      _results = [];
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        _results.push(this.addFile(file));
	      }
	      return _results;
	    };
	
	    Dropzone.prototype._addFilesFromItems = function(items) {
	      var entry, item, _i, _len, _results;
	      _results = [];
	      for (_i = 0, _len = items.length; _i < _len; _i++) {
	        item = items[_i];
	        if ((item.webkitGetAsEntry != null) && (entry = item.webkitGetAsEntry())) {
	          if (entry.isFile) {
	            _results.push(this.addFile(item.getAsFile()));
	          } else if (entry.isDirectory) {
	            _results.push(this._addFilesFromDirectory(entry, entry.name));
	          } else {
	            _results.push(void 0);
	          }
	        } else if (item.getAsFile != null) {
	          if ((item.kind == null) || item.kind === "file") {
	            _results.push(this.addFile(item.getAsFile()));
	          } else {
	            _results.push(void 0);
	          }
	        } else {
	          _results.push(void 0);
	        }
	      }
	      return _results;
	    };
	
	    Dropzone.prototype._addFilesFromDirectory = function(directory, path) {
	      var dirReader, errorHandler, readEntries;
	      dirReader = directory.createReader();
	      errorHandler = function(error) {
	        return typeof console !== "undefined" && console !== null ? typeof console.log === "function" ? console.log(error) : void 0 : void 0;
	      };
	      readEntries = (function(_this) {
	        return function() {
	          return dirReader.readEntries(function(entries) {
	            var entry, _i, _len;
	            if (entries.length > 0) {
	              for (_i = 0, _len = entries.length; _i < _len; _i++) {
	                entry = entries[_i];
	                if (entry.isFile) {
	                  entry.file(function(file) {
	                    if (_this.options.ignoreHiddenFiles && file.name.substring(0, 1) === '.') {
	                      return;
	                    }
	                    file.fullPath = "" + path + "/" + file.name;
	                    return _this.addFile(file);
	                  });
	                } else if (entry.isDirectory) {
	                  _this._addFilesFromDirectory(entry, "" + path + "/" + entry.name);
	                }
	              }
	              readEntries();
	            }
	            return null;
	          }, errorHandler);
	        };
	      })(this);
	      return readEntries();
	    };
	
	    Dropzone.prototype.accept = function(file, done) {
	      if (file.size > this.options.maxFilesize * 1024 * 1024) {
	        return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
	      } else if (!Dropzone.isValidFile(file, this.options.acceptedFiles)) {
	        return done(this.options.dictInvalidFileType);
	      } else if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
	        done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
	        return this.emit("maxfilesexceeded", file);
	      } else {
	        return this.options.accept.call(this, file, done);
	      }
	    };
	
	    Dropzone.prototype.addFile = function(file) {
	      file.upload = {
	        progress: 0,
	        total: file.size,
	        bytesSent: 0
	      };
	      this.files.push(file);
	      file.status = Dropzone.ADDED;
	      this.emit("addedfile", file);
	      this._enqueueThumbnail(file);
	      return this.accept(file, (function(_this) {
	        return function(error) {
	          if (error) {
	            file.accepted = false;
	            _this._errorProcessing([file], error);
	          } else {
	            file.accepted = true;
	            if (_this.options.autoQueue) {
	              _this.enqueueFile(file);
	            }
	          }
	          return _this._updateMaxFilesReachedClass();
	        };
	      })(this));
	    };
	
	    Dropzone.prototype.enqueueFiles = function(files) {
	      var file, _i, _len;
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        this.enqueueFile(file);
	      }
	      return null;
	    };
	
	    Dropzone.prototype.enqueueFile = function(file) {
	      if (file.status === Dropzone.ADDED && file.accepted === true) {
	        file.status = Dropzone.QUEUED;
	        if (this.options.autoProcessQueue) {
	          return setTimeout(((function(_this) {
	            return function() {
	              return _this.processQueue();
	            };
	          })(this)), 0);
	        }
	      } else {
	        throw new Error("This file can't be queued because it has already been processed or was rejected.");
	      }
	    };
	
	    Dropzone.prototype._thumbnailQueue = [];
	
	    Dropzone.prototype._processingThumbnail = false;
	
	    Dropzone.prototype._enqueueThumbnail = function(file) {
	      if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1024 * 1024) {
	        this._thumbnailQueue.push(file);
	        return setTimeout(((function(_this) {
	          return function() {
	            return _this._processThumbnailQueue();
	          };
	        })(this)), 0);
	      }
	    };
	
	    Dropzone.prototype._processThumbnailQueue = function() {
	      if (this._processingThumbnail || this._thumbnailQueue.length === 0) {
	        return;
	      }
	      this._processingThumbnail = true;
	      return this.createThumbnail(this._thumbnailQueue.shift(), (function(_this) {
	        return function() {
	          _this._processingThumbnail = false;
	          return _this._processThumbnailQueue();
	        };
	      })(this));
	    };
	
	    Dropzone.prototype.removeFile = function(file) {
	      if (file.status === Dropzone.UPLOADING) {
	        this.cancelUpload(file);
	      }
	      this.files = without(this.files, file);
	      this.emit("removedfile", file);
	      if (this.files.length === 0) {
	        return this.emit("reset");
	      }
	    };
	
	    Dropzone.prototype.removeAllFiles = function(cancelIfNecessary) {
	      var file, _i, _len, _ref;
	      if (cancelIfNecessary == null) {
	        cancelIfNecessary = false;
	      }
	      _ref = this.files.slice();
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        if (file.status !== Dropzone.UPLOADING || cancelIfNecessary) {
	          this.removeFile(file);
	        }
	      }
	      return null;
	    };
	
	    Dropzone.prototype.createThumbnail = function(file, callback) {
	      var fileReader;
	      fileReader = new FileReader;
	      fileReader.onload = (function(_this) {
	        return function() {
	          if (file.type === "image/svg+xml") {
	            _this.emit("thumbnail", file, fileReader.result);
	            if (callback != null) {
	              callback();
	            }
	            return;
	          }
	          return _this.createThumbnailFromUrl(file, fileReader.result, callback);
	        };
	      })(this);
	      return fileReader.readAsDataURL(file);
	    };
	
	    Dropzone.prototype.createThumbnailFromUrl = function(file, imageUrl, callback, crossOrigin) {
	      var img;
	      img = document.createElement("img");
	      if (crossOrigin) {
	        img.crossOrigin = crossOrigin;
	      }
	      img.onload = (function(_this) {
	        return function() {
	          var canvas, ctx, resizeInfo, thumbnail, _ref, _ref1, _ref2, _ref3;
	          file.width = img.width;
	          file.height = img.height;
	          resizeInfo = _this.options.resize.call(_this, file);
	          if (resizeInfo.trgWidth == null) {
	            resizeInfo.trgWidth = resizeInfo.optWidth;
	          }
	          if (resizeInfo.trgHeight == null) {
	            resizeInfo.trgHeight = resizeInfo.optHeight;
	          }
	          canvas = document.createElement("canvas");
	          ctx = canvas.getContext("2d");
	          canvas.width = resizeInfo.trgWidth;
	          canvas.height = resizeInfo.trgHeight;
	          drawImageIOSFix(ctx, img, (_ref = resizeInfo.srcX) != null ? _ref : 0, (_ref1 = resizeInfo.srcY) != null ? _ref1 : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, (_ref2 = resizeInfo.trgX) != null ? _ref2 : 0, (_ref3 = resizeInfo.trgY) != null ? _ref3 : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
	          thumbnail = canvas.toDataURL("image/png");
	          _this.emit("thumbnail", file, thumbnail);
	          if (callback != null) {
	            return callback();
	          }
	        };
	      })(this);
	      if (callback != null) {
	        img.onerror = callback;
	      }
	      return img.src = imageUrl;
	    };
	
	    Dropzone.prototype.processQueue = function() {
	      var i, parallelUploads, processingLength, queuedFiles;
	      parallelUploads = this.options.parallelUploads;
	      processingLength = this.getUploadingFiles().length;
	      i = processingLength;
	      if (processingLength >= parallelUploads) {
	        return;
	      }
	      queuedFiles = this.getQueuedFiles();
	      if (!(queuedFiles.length > 0)) {
	        return;
	      }
	      if (this.options.uploadMultiple) {
	        return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
	      } else {
	        while (i < parallelUploads) {
	          if (!queuedFiles.length) {
	            return;
	          }
	          this.processFile(queuedFiles.shift());
	          i++;
	        }
	      }
	    };
	
	    Dropzone.prototype.processFile = function(file) {
	      return this.processFiles([file]);
	    };
	
	    Dropzone.prototype.processFiles = function(files) {
	      var file, _i, _len;
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        file.processing = true;
	        file.status = Dropzone.UPLOADING;
	        this.emit("processing", file);
	      }
	      if (this.options.uploadMultiple) {
	        this.emit("processingmultiple", files);
	      }
	      return this.uploadFiles(files);
	    };
	
	    Dropzone.prototype._getFilesWithXhr = function(xhr) {
	      var file, files;
	      return files = (function() {
	        var _i, _len, _ref, _results;
	        _ref = this.files;
	        _results = [];
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          file = _ref[_i];
	          if (file.xhr === xhr) {
	            _results.push(file);
	          }
	        }
	        return _results;
	      }).call(this);
	    };
	
	    Dropzone.prototype.cancelUpload = function(file) {
	      var groupedFile, groupedFiles, _i, _j, _len, _len1, _ref;
	      if (file.status === Dropzone.UPLOADING) {
	        groupedFiles = this._getFilesWithXhr(file.xhr);
	        for (_i = 0, _len = groupedFiles.length; _i < _len; _i++) {
	          groupedFile = groupedFiles[_i];
	          groupedFile.status = Dropzone.CANCELED;
	        }
	        file.xhr.abort();
	        for (_j = 0, _len1 = groupedFiles.length; _j < _len1; _j++) {
	          groupedFile = groupedFiles[_j];
	          this.emit("canceled", groupedFile);
	        }
	        if (this.options.uploadMultiple) {
	          this.emit("canceledmultiple", groupedFiles);
	        }
	      } else if ((_ref = file.status) === Dropzone.ADDED || _ref === Dropzone.QUEUED) {
	        file.status = Dropzone.CANCELED;
	        this.emit("canceled", file);
	        if (this.options.uploadMultiple) {
	          this.emit("canceledmultiple", [file]);
	        }
	      }
	      if (this.options.autoProcessQueue) {
	        return this.processQueue();
	      }
	    };
	
	    resolveOption = function() {
	      var args, option;
	      option = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	      if (typeof option === 'function') {
	        return option.apply(this, args);
	      }
	      return option;
	    };
	
	    Dropzone.prototype.uploadFile = function(file) {
	      return this.uploadFiles([file]);
	    };
	
	    Dropzone.prototype.uploadFiles = function(files) {
	      var file, formData, handleError, headerName, headerValue, headers, i, input, inputName, inputType, key, method, option, progressObj, response, updateProgress, url, value, xhr, _i, _j, _k, _l, _len, _len1, _len2, _len3, _m, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
	      xhr = new XMLHttpRequest();
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        file.xhr = xhr;
	      }
	      method = resolveOption(this.options.method, files);
	      url = resolveOption(this.options.url, files);
	      xhr.open(method, url, true);
	      xhr.withCredentials = !!this.options.withCredentials;
	      response = null;
	      handleError = (function(_this) {
	        return function() {
	          var _j, _len1, _results;
	          _results = [];
	          for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
	            file = files[_j];
	            _results.push(_this._errorProcessing(files, response || _this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr));
	          }
	          return _results;
	        };
	      })(this);
	      updateProgress = (function(_this) {
	        return function(e) {
	          var allFilesFinished, progress, _j, _k, _l, _len1, _len2, _len3, _results;
	          if (e != null) {
	            progress = 100 * e.loaded / e.total;
	            for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
	              file = files[_j];
	              file.upload = {
	                progress: progress,
	                total: e.total,
	                bytesSent: e.loaded
	              };
	            }
	          } else {
	            allFilesFinished = true;
	            progress = 100;
	            for (_k = 0, _len2 = files.length; _k < _len2; _k++) {
	              file = files[_k];
	              if (!(file.upload.progress === 100 && file.upload.bytesSent === file.upload.total)) {
	                allFilesFinished = false;
	              }
	              file.upload.progress = progress;
	              file.upload.bytesSent = file.upload.total;
	            }
	            if (allFilesFinished) {
	              return;
	            }
	          }
	          _results = [];
	          for (_l = 0, _len3 = files.length; _l < _len3; _l++) {
	            file = files[_l];
	            _results.push(_this.emit("uploadprogress", file, progress, file.upload.bytesSent));
	          }
	          return _results;
	        };
	      })(this);
	      xhr.onload = (function(_this) {
	        return function(e) {
	          var _ref;
	          if (files[0].status === Dropzone.CANCELED) {
	            return;
	          }
	          if (xhr.readyState !== 4) {
	            return;
	          }
	          response = xhr.responseText;
	          if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) {
	            try {
	              response = JSON.parse(response);
	            } catch (_error) {
	              e = _error;
	              response = "Invalid JSON response from server.";
	            }
	          }
	          updateProgress();
	          if (!((200 <= (_ref = xhr.status) && _ref < 300))) {
	            return handleError();
	          } else {
	            return _this._finished(files, response, e);
	          }
	        };
	      })(this);
	      xhr.onerror = (function(_this) {
	        return function() {
	          if (files[0].status === Dropzone.CANCELED) {
	            return;
	          }
	          return handleError();
	        };
	      })(this);
	      progressObj = (_ref = xhr.upload) != null ? _ref : xhr;
	      progressObj.onprogress = updateProgress;
	      headers = {
	        "Accept": "application/json",
	        "Cache-Control": "no-cache",
	        "X-Requested-With": "XMLHttpRequest"
	      };
	      if (this.options.headers) {
	        extend(headers, this.options.headers);
	      }
	      for (headerName in headers) {
	        headerValue = headers[headerName];
	        if (headerValue) {
	          xhr.setRequestHeader(headerName, headerValue);
	        }
	      }
	      formData = new FormData();
	      if (this.options.params) {
	        _ref1 = this.options.params;
	        for (key in _ref1) {
	          value = _ref1[key];
	          formData.append(key, value);
	        }
	      }
	      for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
	        file = files[_j];
	        this.emit("sending", file, xhr, formData);
	      }
	      if (this.options.uploadMultiple) {
	        this.emit("sendingmultiple", files, xhr, formData);
	      }
	      if (this.element.tagName === "FORM") {
	        _ref2 = this.element.querySelectorAll("input, textarea, select, button");
	        for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
	          input = _ref2[_k];
	          inputName = input.getAttribute("name");
	          inputType = input.getAttribute("type");
	          if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
	            _ref3 = input.options;
	            for (_l = 0, _len3 = _ref3.length; _l < _len3; _l++) {
	              option = _ref3[_l];
	              if (option.selected) {
	                formData.append(inputName, option.value);
	              }
	            }
	          } else if (!inputType || ((_ref4 = inputType.toLowerCase()) !== "checkbox" && _ref4 !== "radio") || input.checked) {
	            formData.append(inputName, input.value);
	          }
	        }
	      }
	      for (i = _m = 0, _ref5 = files.length - 1; 0 <= _ref5 ? _m <= _ref5 : _m >= _ref5; i = 0 <= _ref5 ? ++_m : --_m) {
	        formData.append(this._getParamName(i), files[i], this._renameFilename(files[i].name));
	      }
	      return this.submitRequest(xhr, formData, files);
	    };
	
	    Dropzone.prototype.submitRequest = function(xhr, formData, files) {
	      return xhr.send(formData);
	    };
	
	    Dropzone.prototype._finished = function(files, responseText, e) {
	      var file, _i, _len;
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        file.status = Dropzone.SUCCESS;
	        this.emit("success", file, responseText, e);
	        this.emit("complete", file);
	      }
	      if (this.options.uploadMultiple) {
	        this.emit("successmultiple", files, responseText, e);
	        this.emit("completemultiple", files);
	      }
	      if (this.options.autoProcessQueue) {
	        return this.processQueue();
	      }
	    };
	
	    Dropzone.prototype._errorProcessing = function(files, message, xhr) {
	      var file, _i, _len;
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        file.status = Dropzone.ERROR;
	        this.emit("error", file, message, xhr);
	        this.emit("complete", file);
	      }
	      if (this.options.uploadMultiple) {
	        this.emit("errormultiple", files, message, xhr);
	        this.emit("completemultiple", files);
	      }
	      if (this.options.autoProcessQueue) {
	        return this.processQueue();
	      }
	    };
	
	    return Dropzone;
	
	  })(Emitter);
	
	  Dropzone.version = "4.3.0";
	
	  Dropzone.options = {};
	
	  Dropzone.optionsForElement = function(element) {
	    if (element.getAttribute("id")) {
	      return Dropzone.options[camelize(element.getAttribute("id"))];
	    } else {
	      return void 0;
	    }
	  };
	
	  Dropzone.instances = [];
	
	  Dropzone.forElement = function(element) {
	    if (typeof element === "string") {
	      element = document.querySelector(element);
	    }
	    if ((element != null ? element.dropzone : void 0) == null) {
	      throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
	    }
	    return element.dropzone;
	  };
	
	  Dropzone.autoDiscover = true;
	
	  Dropzone.discover = function() {
	    var checkElements, dropzone, dropzones, _i, _len, _results;
	    if (document.querySelectorAll) {
	      dropzones = document.querySelectorAll(".dropzone");
	    } else {
	      dropzones = [];
	      checkElements = function(elements) {
	        var el, _i, _len, _results;
	        _results = [];
	        for (_i = 0, _len = elements.length; _i < _len; _i++) {
	          el = elements[_i];
	          if (/(^| )dropzone($| )/.test(el.className)) {
	            _results.push(dropzones.push(el));
	          } else {
	            _results.push(void 0);
	          }
	        }
	        return _results;
	      };
	      checkElements(document.getElementsByTagName("div"));
	      checkElements(document.getElementsByTagName("form"));
	    }
	    _results = [];
	    for (_i = 0, _len = dropzones.length; _i < _len; _i++) {
	      dropzone = dropzones[_i];
	      if (Dropzone.optionsForElement(dropzone) !== false) {
	        _results.push(new Dropzone(dropzone));
	      } else {
	        _results.push(void 0);
	      }
	    }
	    return _results;
	  };
	
	  Dropzone.blacklistedBrowsers = [/opera.*Macintosh.*version\/12/i];
	
	  Dropzone.isBrowserSupported = function() {
	    var capableBrowser, regex, _i, _len, _ref;
	    capableBrowser = true;
	    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
	      if (!("classList" in document.createElement("a"))) {
	        capableBrowser = false;
	      } else {
	        _ref = Dropzone.blacklistedBrowsers;
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          regex = _ref[_i];
	          if (regex.test(navigator.userAgent)) {
	            capableBrowser = false;
	            continue;
	          }
	        }
	      }
	    } else {
	      capableBrowser = false;
	    }
	    return capableBrowser;
	  };
	
	  without = function(list, rejectedItem) {
	    var item, _i, _len, _results;
	    _results = [];
	    for (_i = 0, _len = list.length; _i < _len; _i++) {
	      item = list[_i];
	      if (item !== rejectedItem) {
	        _results.push(item);
	      }
	    }
	    return _results;
	  };
	
	  camelize = function(str) {
	    return str.replace(/[\-_](\w)/g, function(match) {
	      return match.charAt(1).toUpperCase();
	    });
	  };
	
	  Dropzone.createElement = function(string) {
	    var div;
	    div = document.createElement("div");
	    div.innerHTML = string;
	    return div.childNodes[0];
	  };
	
	  Dropzone.elementInside = function(element, container) {
	    if (element === container) {
	      return true;
	    }
	    while (element = element.parentNode) {
	      if (element === container) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  Dropzone.getElement = function(el, name) {
	    var element;
	    if (typeof el === "string") {
	      element = document.querySelector(el);
	    } else if (el.nodeType != null) {
	      element = el;
	    }
	    if (element == null) {
	      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector or a plain HTML element.");
	    }
	    return element;
	  };
	
	  Dropzone.getElements = function(els, name) {
	    var e, el, elements, _i, _j, _len, _len1, _ref;
	    if (els instanceof Array) {
	      elements = [];
	      try {
	        for (_i = 0, _len = els.length; _i < _len; _i++) {
	          el = els[_i];
	          elements.push(this.getElement(el, name));
	        }
	      } catch (_error) {
	        e = _error;
	        elements = null;
	      }
	    } else if (typeof els === "string") {
	      elements = [];
	      _ref = document.querySelectorAll(els);
	      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
	        el = _ref[_j];
	        elements.push(el);
	      }
	    } else if (els.nodeType != null) {
	      elements = [els];
	    }
	    if (!((elements != null) && elements.length)) {
	      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
	    }
	    return elements;
	  };
	
	  Dropzone.confirm = function(question, accepted, rejected) {
	    if (window.confirm(question)) {
	      return accepted();
	    } else if (rejected != null) {
	      return rejected();
	    }
	  };
	
	  Dropzone.isValidFile = function(file, acceptedFiles) {
	    var baseMimeType, mimeType, validType, _i, _len;
	    if (!acceptedFiles) {
	      return true;
	    }
	    acceptedFiles = acceptedFiles.split(",");
	    mimeType = file.type;
	    baseMimeType = mimeType.replace(/\/.*$/, "");
	    for (_i = 0, _len = acceptedFiles.length; _i < _len; _i++) {
	      validType = acceptedFiles[_i];
	      validType = validType.trim();
	      if (validType.charAt(0) === ".") {
	        if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
	          return true;
	        }
	      } else if (/\/\*$/.test(validType)) {
	        if (baseMimeType === validType.replace(/\/.*$/, "")) {
	          return true;
	        }
	      } else {
	        if (mimeType === validType) {
	          return true;
	        }
	      }
	    }
	    return false;
	  };
	
	  if (typeof jQuery !== "undefined" && jQuery !== null) {
	    jQuery.fn.dropzone = function(options) {
	      return this.each(function() {
	        return new Dropzone(this, options);
	      });
	    };
	  }
	
	  if (typeof module !== "undefined" && module !== null) {
	    module.exports = Dropzone;
	  } else {
	    window.Dropzone = Dropzone;
	  }
	
	  Dropzone.ADDED = "added";
	
	  Dropzone.QUEUED = "queued";
	
	  Dropzone.ACCEPTED = Dropzone.QUEUED;
	
	  Dropzone.UPLOADING = "uploading";
	
	  Dropzone.PROCESSING = Dropzone.UPLOADING;
	
	  Dropzone.CANCELED = "canceled";
	
	  Dropzone.ERROR = "error";
	
	  Dropzone.SUCCESS = "success";
	
	
	  /*
	  
	  Bugfix for iOS 6 and 7
	  Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
	  based on the work of https://github.com/stomita/ios-imagefile-megapixel
	   */
	
	  detectVerticalSquash = function(img) {
	    var alpha, canvas, ctx, data, ey, ih, iw, py, ratio, sy;
	    iw = img.naturalWidth;
	    ih = img.naturalHeight;
	    canvas = document.createElement("canvas");
	    canvas.width = 1;
	    canvas.height = ih;
	    ctx = canvas.getContext("2d");
	    ctx.drawImage(img, 0, 0);
	    data = ctx.getImageData(0, 0, 1, ih).data;
	    sy = 0;
	    ey = ih;
	    py = ih;
	    while (py > sy) {
	      alpha = data[(py - 1) * 4 + 3];
	      if (alpha === 0) {
	        ey = py;
	      } else {
	        sy = py;
	      }
	      py = (ey + sy) >> 1;
	    }
	    ratio = py / ih;
	    if (ratio === 0) {
	      return 1;
	    } else {
	      return ratio;
	    }
	  };
	
	  drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
	    var vertSquashRatio;
	    vertSquashRatio = detectVerticalSquash(img);
	    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
	  };
	
	
	  /*
	   * contentloaded.js
	   *
	   * Author: Diego Perini (diego.perini at gmail.com)
	   * Summary: cross-browser wrapper for DOMContentLoaded
	   * Updated: 20101020
	   * License: MIT
	   * Version: 1.2
	   *
	   * URL:
	   * http://javascript.nwbox.com/ContentLoaded/
	   * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
	   */
	
	  contentLoaded = function(win, fn) {
	    var add, doc, done, init, poll, pre, rem, root, top;
	    done = false;
	    top = true;
	    doc = win.document;
	    root = doc.documentElement;
	    add = (doc.addEventListener ? "addEventListener" : "attachEvent");
	    rem = (doc.addEventListener ? "removeEventListener" : "detachEvent");
	    pre = (doc.addEventListener ? "" : "on");
	    init = function(e) {
	      if (e.type === "readystatechange" && doc.readyState !== "complete") {
	        return;
	      }
	      (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
	      if (!done && (done = true)) {
	        return fn.call(win, e.type || e);
	      }
	    };
	    poll = function() {
	      var e;
	      try {
	        root.doScroll("left");
	      } catch (_error) {
	        e = _error;
	        setTimeout(poll, 50);
	        return;
	      }
	      return init("poll");
	    };
	    if (doc.readyState !== "complete") {
	      if (doc.createEventObject && root.doScroll) {
	        try {
	          top = !win.frameElement;
	        } catch (_error) {}
	        if (top) {
	          poll();
	        }
	      }
	      doc[add](pre + "DOMContentLoaded", init, false);
	      doc[add](pre + "readystatechange", init, false);
	      return win[add](pre + "load", init, false);
	    }
	  };
	
	  Dropzone._autoDiscoverFunction = function() {
	    if (Dropzone.autoDiscover) {
	      return Dropzone.discover();
	    }
	  };
	
	  contentLoaded(window, Dropzone._autoDiscoverFunction);
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(490)(module)))

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BoxTitle = __webpack_require__(1508);
	
	var _BoxTitle2 = _interopRequireDefault(_BoxTitle);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Buttons = __webpack_require__(1315);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _ZopimOrSubmitTicketLink = __webpack_require__(1514);
	
	var _ZopimOrSubmitTicketLink2 = _interopRequireDefault(_ZopimOrSubmitTicketLink);
	
	var _UserConstants = __webpack_require__(1015);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var initialUploadView = _react2.default.createElement(
	  'div',
	  null,
	  _react2.default.createElement(_BoxTitle2.default, { title: 'Upload a spreadsheet' }),
	  _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'Create a spreadsheet (.csv only) for teachers, students or parents at your school. Each spreadsheet should include three columns: first name, last name, and email or mobile number.',
	      ' ',
	      _react2.default.createElement(
	        _Link2.default,
	        {
	          href: 'http://assets.remind.com/schools/remind-upload-sample.csv',
	          target: '_blank',
	          download: true },
	        'Download a sample template'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'TeacherAddUploadTab-image' },
	      _react2.default.createElement(_Image2.default, {
	        className: 'TeacherAddUploadTab-spreadsheet-example',
	        src: __webpack_require__(1515)
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'TeacherAddUploadTab-overlay' },
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                'First name'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Last name'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Email or mobile number'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                'Natalie'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Koga'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'nkoga@example.k12.us'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                'Max'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Rodriguez'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                '(555) 555-5555'
	              )
	            ),
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                'Farah'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'Siddiqi'
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                'fsiddiqi@example.k12.us'
	              )
	            )
	          )
	        )
	      )
	    )
	  )
	);
	
	var errorUploadViewSubtext = _react2.default.createElement(
	  'div',
	  null,
	  'Please make sure your spreadsheet is a CSV file (.csv) formatted to match',
	  ' ',
	  _react2.default.createElement(
	    _Link2.default,
	    {
	      href: 'http://assets.remind.com/schools/remind-upload-sample.csv',
	      target: '_blank',
	      download: true },
	    'our sample template'
	  ),
	  '.',
	  _react2.default.createElement('br', null),
	  'If the problem continues, check out our',
	  ' ',
	  _react2.default.createElement(
	    _Link2.default,
	    { href: _LinkConstants2.default.ZENDESK + '/articles/208218366', target: '_blank' },
	    'FAQ'
	  ),
	  ' ',
	  'or',
	  ' ',
	  _react2.default.createElement(
	    _ZopimOrSubmitTicketLink2.default,
	    null,
	    'contact us'
	  ),
	  '.'
	);
	
	var errorUploadView = _react2.default.createElement(_TitleHeader2.default, {
	  image: __webpack_require__(1516),
	  imageClassName: 'TeacherAddUploadTab-titleHeader-image',
	  title: 'Couldn\u2019t upload spreadsheet',
	  subtext: errorUploadViewSubtext,
	  bottomMargin: 'none'
	});
	
	var TeacherAddUploadTabInitial = function TeacherAddUploadTabInitial(_ref) {
	  var dropzoneid = _ref.dropzoneid,
	      setRole = _ref.setRole,
	      error = _ref.error;
	
	  var getUploadButton = function getUploadButton(role) {
	    return _react2.default.createElement(
	      _Button2.default,
	      {
	        className: (0, _classnames2.default)('upload_csv', 'addFileButton_' + dropzoneid),
	        ref: function ref(button) {
	          // The reason for adding an event listener instead of the onclick property
	          // is that setting onclick overrides the dropzone functionality breaking
	          // file uploads. By adding an event listener, it doesn't affect other handlers
	          var node = _reactDom2.default.findDOMNode(button);
	          if (node) {
	            node.addEventListener('click', function () {
	              setRole(role);
	            });
	          }
	        },
	        level: 'secondary',
	        size: 'medium' },
	      'Upload ',
	      role,
	      's'
	    );
	  };
	
	  var View = error ? errorUploadView : initialUploadView;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'TeacherAddUploadTab-container' },
	      View
	    ),
	    _react2.default.createElement(
	      _Buttons2.default,
	      { className: 'TeacherAddUploadTab-attach' },
	      getUploadButton(_UserConstants.Roles.teacher),
	      getUploadButton(_UserConstants.Roles.parent),
	      getUploadButton(_UserConstants.Roles.student)
	    )
	  );
	};
	
	exports.default = TeacherAddUploadTabInitial;

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1509);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxTitle = function (_React$Component) {
	  _inherits(BoxTitle, _React$Component);
	
	  function BoxTitle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BoxTitle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BoxTitle.__proto__ || Object.getPrototypeOf(BoxTitle)).call.apply(_ref, [this].concat(args))), _this), _this.renderTitle = function () {
	      var title = _this.props.title;
	
	      if (!title) {
	        return null;
	      }
	
	      return title;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BoxTitle, [{
	    key: 'render',
	    value: function render() {
	      var title = this.renderTitle();
	
	      return _react2.default.createElement(
	        'h2',
	        { className: (0, _classnames2.default)('BoxTitle', this.props.className) },
	        title,
	        this.props.children
	      );
	    }
	  }]);
	
	  return BoxTitle;
	}(_react2.default.Component);
	
	BoxTitle.displayName = 'BoxTitle';
	exports.default = BoxTitle;

/***/ },
/* 1509 */
1136,
/* 1510 */,
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	__webpack_require__(1512);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TitleHeader = function (_React$Component) {
	  _inherits(TitleHeader, _React$Component);
	
	  function TitleHeader() {
	    _classCallCheck(this, TitleHeader);
	
	    return _possibleConstructorReturn(this, (TitleHeader.__proto__ || Object.getPrototypeOf(TitleHeader)).apply(this, arguments));
	  }
	
	  _createClass(TitleHeader, [{
	    key: 'renderImage',
	    value: function renderImage() {
	      var image = this.props.image;
	
	      if (image) {
	        return _react2.default.createElement(_Image2.default, { src: image, className: (0, _classnames2.default)('TitleHeader-img', this.props.imageClassName) });
	      }
	      return null;
	    }
	  }, {
	    key: 'renderGlyph',
	    value: function renderGlyph() {
	      var glyph = this.props.glyph;
	
	      if (glyph) {
	        return _react2.default.createElement(_Glyph2.default, { name: glyph, color: 'brand', className: 'TitleHeader-glyph', solo: true });
	      }
	      return null;
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle() {
	      var title = this.props.title;
	
	      if (title) {
	        return _react2.default.createElement(
	          'h2',
	          { className: (0, _classnames2.default)('TitleHeader-title', (0, _getPropClasses.getPropClassesFromInstance)(this, ['titleColor'])) },
	          title
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderSubtext',
	    value: function renderSubtext() {
	      var subtext = this.props.subtext;
	
	      if (subtext) {
	        return _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('TitleHeader-subtext', { 'TitleHeader-subtext--subtle': this.props.subtle }) },
	          subtext
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderAction',
	    value: function renderAction() {
	      var action = this.props.action;
	
	      if (action) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'TitleHeader-action' },
	          action
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'header',
	        { className: (0, _classnames2.default)('TitleHeader', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className) },
	        this.renderImage(),
	        this.renderGlyph(),
	        this.renderTitle(),
	        this.renderSubtext(),
	        this.props.children,
	        this.renderAction()
	      );
	    }
	  }]);
	
	  return TitleHeader;
	}(_react2.default.Component);
	
	TitleHeader.propClasses = {
	  bottomMargin: {
	    xxlarge: 'TitleHeader--bottomMargin--xxlarge',
	    xlarge: 'TitleHeader--bottomMargin--xlarge',
	    large: 'TitleHeader--bottomMargin--large',
	    medium: 'TitleHeader--bottomMargin--medium',
	    small: 'TitleHeader--bottomMargin--small',
	    none: 'TitleHeader-bottomMargin-none'
	  },
	  size: {
	    xxlarge: 'TitleHeader--xxlarge',
	    xlarge: 'TitleHeader--xlarge',
	    large: 'TitleHeader--large',
	    medium: 'TitleHeader--medium',
	    small: 'TitleHeader--small'
	  },
	  textAlign: {
	    left: 'TitleHeader-left',
	    center: 'TitleHeader-center',
	    right: 'TitleHeader-right'
	  },
	  titleColor: {
	    pitch: 'TitleHeader-pitch',
	    brand: 'TitleHeader-brand'
	  }
	};
	TitleHeader.defaultProps = {
	  bottomMargin: 'xxlarge',
	  size: 'medium',
	  textAlign: 'center',
	  titleColor: 'pitch',
	  subtle: false
	};
	TitleHeader.displayName = 'TitleHeader';
	exports.default = TitleHeader;

/***/ },
/* 1512 */
1136,
/* 1513 */,
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Zopim = __webpack_require__(1081);
	
	var _Zopim2 = _interopRequireDefault(_Zopim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ZopimOrSubmitTicketLink = _react2.default.createClass({
	  displayName: 'ZopimOrSubmitTicketLink',
	  getInitialState: function getInitialState() {
	    return {
	      isZopimOnline: _Zopim2.default.getCurrentStatus()
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    _Zopim2.default.addStatusListener(function (status) {
	      // XXX a bit of a hack because Zopim doesn't allow you to clear a status listener
	      if (_this.isMounted()) {
	        _this.setState({
	          isZopimOnline: status === 'online'
	        });
	      }
	    });
	  },
	  render: function render() {
	    // We can't let underage children use live chat.
	    if (this.state.isZopimOnline && !(_CurrentUser2.default.isSignedIn() && _CurrentUser2.default.getUser().isUnderage())) {
	      var showZopim = function showZopim(event) {
	        event.preventDefault();
	        event.stopPropagation();
	        _Zopim2.default.show();
	      };
	      return _react2.default.createElement(
	        _Link2.default,
	        {
	          onClick: showZopim,
	          className: (0, _classnames2.default)('ZopimOrSubmitTicketLink', this.props.className) },
	        this.props.children
	      );
	    } else {
	      return _react2.default.createElement(
	        _Link2.default,
	        {
	          className: (0, _classnames2.default)('ZopimOrSubmitTicketLink', this.props.className),
	          href: 'https://help.remind.com/hc/en-us/requests/new',
	          target: '_blank' },
	        this.props.children
	      );
	    }
	  }
	});
	exports.default = ZopimOrSubmitTicketLink;

/***/ },
/* 1515 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 1516 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MDAgNTAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MDAgNTAwIj48cGF0aCBmaWxsPSIjZWZmOGZmIiBkPSJtNjMuNSA0MzQuMWMtMy42IDAtNi41LTIuOS02LjUtNi41di00MTAuM2MwLTMuNiAyLjktNi41IDYuNS02LjVoMjUxLjdsODIuMiA4NC41djMzMi4zYzAgMy42LTIuOSA2LjUtNi41IDYuNWgtMzI3LjQiLz48cGF0aCBmaWxsPSIjYzlkY2YwIiBkPSJtMzEyLjUgMTcuM2w3OC40IDgwLjZ2MzI5LjdoLTMyNy40di00MTAuM2gyNDltNS41LTEzLjFoLTI1NC41Yy03LjIgMC0xMy4xIDUuOS0xMy4xIDEzLjF2NDEwLjNjMCA3LjIgNS45IDEzLjEgMTMuMSAxMy4xaDMyNy40YzcuMiAwIDEzLjEtNS45IDEzLjEtMTMuMXYtMzM1bC04Ni04OC40eiIvPjxlbGxpcHNlIGZpbGw9IiNhYTJkM2YiIGN4PSIzNTcuNCIgY3k9IjM5OS40IiByeD0iODkuNiIgcnk9IjkzLjQiLz48Y2lyY2xlIGZpbGw9IiNjNjM0NDIiIGN4PSIzNTcuNCIgY3k9IjM5NS42IiByPSI4OS42Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTM3OS40IDM1OC40bC0yMS4yIDI0LjYtMTkuMS0yMi4xYy02LTctMTUuOC03LTIxLjggMGwzMCAzNC43LTMyLjEgMzcuMmM2IDcgMTUuOCA3IDIxLjggMGwyMS4yLTI0LjYgMTkuMSAyMi4xYzYgNyAxNS44IDcgMjEuOCAwbC0zMC0zNC43IDMyLjEtMzcuMmMtNi03LTE1LjgtNy0yMS44IDAiLz48ZyBmaWxsPSIjYzlkY2YwIj48cGF0aCBkPSJNMzEyLjYsNC43djgwLjNjMCw3LjIsNS45LDEzLjEsMTMuMSwxMy4xSDQwNEwzMTIuNiw0Ljd6Ii8+PGNpcmNsZSBjeD0iMjY2LjMiIGN5PSIxNDUuNyIgcj0iMTkuMiIvPjxjaXJjbGUgY3g9IjE3OS45IiBjeT0iMTQ1LjciIHI9IjE5LjIiLz48cGF0aCBkPSJtMjk4LjMgMjcxLjhoLTE0Ny43Yy05LjMgMC0xNi44LTcuNi0xNi44LTE2LjggMC05LjMgNy42LTE2LjggMTYuOC0xNi44aDE0Ny44YzkuMyAwIDE2LjggNy42IDE2LjggMTYuOCAwIDkuMy03LjYgMTYuOC0xNi45IDE2LjgiLz48L2c+PC9zdmc+"

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function userText(users, role) {
	  return users.length === 1 ? role : role + 's';
	}
	
	function AddedUsers(props) {
	  var users = props.users,
	      role = props.role;
	
	  if (users.length) {
	    return _react2.default.createElement(
	      'li',
	      { className: 'TeacherAddUploadTab-success-listitem' },
	      _react2.default.createElement(_Glyph2.default, { name: 'check', color: 'shamrock' }),
	      _react2.default.createElement(
	        'strong',
	        null,
	        users.length
	      ),
	      ' ',
	      userText(users, role),
	      ' added to your school'
	    );
	  }
	  return _react2.default.createElement('noscript', null);
	}
	
	
	function ExistingUsers(props) {
	  var users = props.users,
	      role = props.role;
	
	  if (users.length) {
	    return _react2.default.createElement(
	      'li',
	      { className: 'TeacherAddUploadTab-success-listitem' },
	      _react2.default.createElement(_Glyph2.default, { name: 'check', color: 'shamrock' }),
	      _react2.default.createElement(
	        'strong',
	        null,
	        users.length
	      ),
	      ' ',
	      userText(users, role),
	      ' already in your school'
	    );
	  }
	  return _react2.default.createElement('noscript', null);
	}
	
	
	function ErrorUsers(props) {
	  var users = props.users,
	      role = props.role,
	      onClick = props.onClick;
	
	  if (users.length) {
	    return _react2.default.createElement(
	      'li',
	      { className: 'TeacherAddUploadTab-success-listitem' },
	      _react2.default.createElement(_Glyph2.default, { name: 'close', color: 'lava' }),
	      _react2.default.createElement(
	        'strong',
	        null,
	        users.length
	      ),
	      ' ',
	      userText(users, role),
	      ' not added.',
	      ' ',
	      _react2.default.createElement(
	        _Link2.default,
	        { onClick: onClick },
	        'Fix errors.'
	      )
	    );
	  }
	  return _react2.default.createElement('noscript', null);
	}
	
	var TeacherAddUploadTabSuccess = function (_React$Component) {
	  _inherits(TeacherAddUploadTabSuccess, _React$Component);
	
	  function TeacherAddUploadTabSuccess() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TeacherAddUploadTabSuccess);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TeacherAddUploadTabSuccess.__proto__ || Object.getPrototypeOf(TeacherAddUploadTabSuccess)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
	      var groupCode = _this.props.group.getCode();
	      _this.context.router.push('/classes/' + groupCode + '/people');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TeacherAddUploadTabSuccess, [{
	    key: 'render',
	    value: function render() {
	      var _props$response = this.props.response,
	          addedUsers = _props$response.addedUsers,
	          existingUsers = _props$response.existingUsers,
	          errorUsers = _props$response.errorUsers;
	
	      _EventTracking2.default.view(this.context.eventScreenName, {
	        num_added: addedUsers.length,
	        num_already_in_org: existingUsers.length,
	        num_not_added: errorUsers.length
	      });
	      var dialogTitle = errorUsers.length ? 'Spreadsheet uploaded' : 'Upload successful';
	      var CTAAction = errorUsers.length ? this.props.onFixError : this.handleClick;
	      var CTAText = errorUsers.length ? 'Fix spreadsheet errors' : 'View added ' + this.props.role + 's';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'TeacherAddUploadTab-success' },
	        _react2.default.createElement(
	          'div',
	          { className: 'TeacherAddUploadTab-container' },
	          _react2.default.createElement(_TitleHeader2.default, {
	            image: __webpack_require__(1518),
	            imageClassName: 'TeacherAddUploadTab-titleHeader-image',
	            title: dialogTitle
	          }),
	          _react2.default.createElement(
	            'ul',
	            { className: 'TeacherAddUploadTab-success-list' },
	            _react2.default.createElement(AddedUsers, { users: addedUsers, role: this.props.role }),
	            _react2.default.createElement(ExistingUsers, { users: existingUsers, role: this.props.role }),
	            _react2.default.createElement(ErrorUsers, {
	              users: errorUsers,
	              role: this.props.role,
	              onClick: this.props.onFixError
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            onClick: CTAAction,
	            className: 'TeacherAddUploadTab-success-button',
	            eventElementName: 'TeacherAddUploadTab-success-button' },
	          CTAText
	        )
	      );
	    }
	  }]);
	
	  return TeacherAddUploadTabSuccess;
	}(_react2.default.Component);
	
	TeacherAddUploadTabSuccess.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired,
	  eventScreenName: _react2.default.PropTypes.string
	};
	TeacherAddUploadTabSuccess.displayName = 'TeacherAddUploadTabSuccess';
	exports.default = TeacherAddUploadTabSuccess;

/***/ },
/* 1518 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MDAgNTAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MDAgNTAwIj48cGF0aCBmaWxsPSIjZWZmOGZmIiBkPSJtNjMuNSA0MzQuMWMtMy42IDAtNi41LTIuOS02LjUtNi41di00MTAuM2MwLTMuNiAyLjktNi41IDYuNS02LjVoMjUxLjdsODIuMiA4NC41djMzMi4zYzAgMy42LTIuOSA2LjUtNi41IDYuNWgtMzI3LjQiLz48cGF0aCBmaWxsPSIjYzlkY2YwIiBkPSJtMzEyLjUgMTcuM2w3OC40IDgwLjZ2MzI5LjdoLTMyNy40di00MTAuM2gyNDltNS41LTEzLjFoLTI1NC41Yy03LjIgMC0xMy4xIDUuOS0xMy4xIDEzLjF2NDEwLjNjMCA3LjIgNS45IDEzLjEgMTMuMSAxMy4xaDMyNy40YzcuMiAwIDEzLjEtNS45IDEzLjEtMTMuMXYtMzM1bC04Ni04OC40eiIvPjxlbGxpcHNlIGZpbGw9IiMzMmEwNzgiIGN4PSIzNTcuNCIgY3k9IjM5OS40IiByeD0iODkuNiIgcnk9IjkzLjQiLz48Y2lyY2xlIGZpbGw9IiMzOGI4OGQiIGN4PSIzNTcuNCIgY3k9IjM5NS42IiByPSI4OS42Ii8+PGcgZmlsbD0iI2ZmZiI+PHBhdGggZD0ibTM0NS43IDQzNy43bC0zNi45LTM2LjljNi4zLTYuMyAxNi42LTYuMyAyMi45IDBsMTIuNCAxMi40IDM5LjEtNTAuN2M1LjUtNy4xIDE1LjYtOC40IDIyLjctMi45bC02MC4yIDc4LjEiLz48cGF0aCBkPSJtMzQ1LjkgNDQwLjJsLTM5LjMtMzkuMyAxLjItMS4yYzMuNC0zLjQgNy44LTUuMiAxMi42LTUuMnM5LjIgMS45IDEyLjYgNS4ybDExLjEgMTEuMSAzOC00OS4yYzMuNC00LjQgOC41LTYuOSAxNC4xLTYuOSA0IDAgNy43IDEuMyAxMC45IDMuN2wxLjMgMS0xIDEuMy02MS41IDc5LjVtLTM0LjctMzkuM2wzNC4zIDM0LjMgNTguMS03NS4zYy0yLjMtMS40LTQuOC0yLjEtNy41LTIuMS00LjYgMC04LjggMi4xLTExLjUgNS43bC00MC4zIDUyLjItMTMuNy0xMy43Yy01LjEtNS4xLTEzLjgtNS41LTE5LjQtMS4xIi8+PC9nPjxnIGZpbGw9IiNjOWRjZjAiPjxwYXRoIGQ9Ik0zMTIuNiw0Ljd2ODAuM2MwLDcuMiw1LjksMTMuMSwxMy4xLDEzLjFINDA0TDMxMi42LDQuN3oiLz48cGF0aCBkPSJtMjIzLjEgMjMyLjdjLTMxLjkgMC02MC42LTUuMS03OS45LTEzLjMtNC4yLTEuOC04LjcgMS45LTcuOSA2LjQgNy4zIDQxLjkgNDMuOCA3My44IDg3LjggNzMuOCA0NCAwIDgwLjUtMzEuOSA4Ny44LTczLjguOC00LjUtMy43LTguMi03LjktNi40LTE5LjMgOC4xLTQ3LjkgMTMuMy03OS45IDEzLjMiLz48Y2lyY2xlIGN4PSIyNjYuMyIgY3k9IjE0NS43IiByPSIxOS4yIi8+PGNpcmNsZSBjeD0iMTc5LjkiIGN5PSIxNDUuNyIgcj0iMTkuMiIvPjwvZz48L3N2Zz4="

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Progress = __webpack_require__(1520);
	
	var _Progress2 = _interopRequireDefault(_Progress);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeacherAddUploadTabUploading = function TeacherAddUploadTabUploading(_ref) {
	  var uploadPercentage = _ref.uploadPercentage;
	  return _react2.default.createElement(
	    'div',
	    { className: 'TeacherAddUploadTab-loading' },
	    _react2.default.createElement(
	      _Container2.default,
	      { size: 'xxsmall' },
	      _react2.default.createElement(_Progress2.default, { label: 'Uploading\u2026', percent: uploadPercentage })
	    )
	  );
	}; /*  weak */
	exports.default = TeacherAddUploadTabUploading;

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(1521);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Progress = function (_React$Component) {
	  _inherits(Progress, _React$Component);
	
	  function Progress() {
	    _classCallCheck(this, Progress);
	
	    return _possibleConstructorReturn(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).apply(this, arguments));
	  }
	
	  _createClass(Progress, [{
	    key: 'renderGlyph',
	    value: function renderGlyph() {
	      var glyph = this.props.glyph;
	
	
	      if (glyph) {
	        // $FlowFixMe
	        return _react2.default.createElement(_Glyph2.default, { name: glyph, color: 'eclipse', size: 'xxxlarge', className: 'Progress-glyph' });
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel() {
	      var label = this.props.label;
	
	
	      if (label) {
	        return _react2.default.createElement(
	          _Text2.default,
	          { color: 'thunder', element: 'div', className: 'Progress-label' },
	          label,
	          '\u2026'
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var percent = this.props.percent;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Progress' },
	        this.renderGlyph(),
	        _react2.default.createElement(
	          'div',
	          { className: 'Progress-bar' },
	          _react2.default.createElement('div', { className: 'Progress-bar-value', style: { width: percent + '%' } })
	        ),
	        this.renderLabel()
	      );
	    }
	  }]);
	
	  return Progress;
	}(_react2.default.Component);
	
	Progress.displayName = 'Progress';
	exports.default = Progress;

/***/ },
/* 1521 */
1136,
/* 1522 */,
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxTitle = __webpack_require__(1508);
	
	var _BoxTitle2 = _interopRequireDefault(_BoxTitle);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _TeacherAddManualTabView = __webpack_require__(1524);
	
	var _TeacherAddManualTabView2 = _interopRequireDefault(_TeacherAddManualTabView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EVENT_SCREEN_NAME = 'TeacherAddUploadTabFixErrors';
	
	var TeacherAddUploadTabFixErrors = function (_React$Component) {
	  _inherits(TeacherAddUploadTabFixErrors, _React$Component);
	
	  function TeacherAddUploadTabFixErrors() {
	    _classCallCheck(this, TeacherAddUploadTabFixErrors);
	
	    return _possibleConstructorReturn(this, (TeacherAddUploadTabFixErrors.__proto__ || Object.getPrototypeOf(TeacherAddUploadTabFixErrors)).apply(this, arguments));
	  }
	
	  _createClass(TeacherAddUploadTabFixErrors, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        eventScreenName: EVENT_SCREEN_NAME
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var name = 'We found the following errors';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_BoxTitle2.default, { title: name }),
	        _react2.default.createElement(_TeacherAddManualTabView2.default, {
	          users: this.props.users,
	          role: this.props.role,
	          organization: this.props.organization,
	          onSuccess: this.props.onSuccess
	        })
	      );
	    }
	  }]);
	
	  return TeacherAddUploadTabFixErrors;
	}(_react2.default.Component);
	
	TeacherAddUploadTabFixErrors.childContextTypes = {
	  eventScreenName: _react2.default.PropTypes.string
	};
	TeacherAddUploadTabFixErrors.displayName = 'TeacherAddUploadTabFixErrors';
	exports.default = TeacherAddUploadTabFixErrors;

/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _directAdd = __webpack_require__(1525);
	
	var _TableInput = __webpack_require__(1526);
	
	var _TableInput2 = _interopRequireDefault(_TableInput);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	__webpack_require__(1527);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var TeacherAddManualTabView = function (_React$Component) {
	  _inherits(TeacherAddManualTabView, _React$Component);
	
	  function TeacherAddManualTabView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TeacherAddManualTabView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TeacherAddManualTabView.__proto__ || Object.getPrototypeOf(TeacherAddManualTabView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      users: _this.props.users
	    }, _this.onUpdate = function (users) {
	      _this.setState({ users: users });
	      if (_this.props.onUpdate) {
	        _this.props.onUpdate(users);
	      }
	    }, _this.onSuccess = function (response) {
	      var role = _this.props.role;
	
	      (0, _directAdd.queryDirectAddJob)(_this.props.organization.id, response.id).then(function (results) {
	        var numSuccessful = results.addedUsers.length + results.existingUsers.length;
	        if (numSuccessful > 0) {
	          var userText = numSuccessful === 1 ? role : role + 's';
	          _ToastActions2.default.showSuccessToast(numSuccessful + ' ' + userText + ' successfully added');
	          _EventTracking2.default.view('user_add_manual_success', { role: role, num_users_added: numSuccessful });
	        }
	
	        var previousUsers = _this.state.users.filter(function (e) {
	          return !_lodash2.default.isEmpty(e.fields);
	        });
	        _this.setState({ users: previousUsers.concat(results.errorUsers) });
	        if (results.errorUsers.length === 0 && _this.props.onSuccess) {
	          _this.props.onSuccess(results);
	        }
	      }, _this.onFailure);
	    }, _this.onFailure = function () {
	      _ToastActions2.default.showDefaultErrorToast();
	    }, _this.submitAddUsers = function () {
	      var validUsers = [];
	      var errorUsers = [];
	      _this.state.users.forEach(function (t) {
	        if (t.isValid) {
	          validUsers.push(t);
	        } else if (!_lodash2.default.isEmpty(t.fields)) {
	          errorUsers.push(t);
	        }
	      });
	
	      var submitUsers = validUsers.map(function (t) {
	        var name = t.fields.name || '';
	        return {
	          first_name: name.split(' ')[0],
	          last_name: name.slice(name.indexOf(' ') + 1),
	          address: t.fields.address.trim()
	        };
	      });
	      var _this$props = _this.props,
	          role = _this$props.role,
	          organization = _this$props.organization;
	
	      _OrganizationActions2.default.addUsers(submitUsers, role, organization.id).then(_this.onSuccess, _this.onFailure);
	
	      _EventTracking2.default.tap(_this.context.eventScreenName, 'add_users', { role: _this.props.role, num_valid_users: validUsers.length, num_error_users: errorUsers.length });
	
	      _this.setState({ users: errorUsers });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TeacherAddManualTabView, [{
	    key: 'render',
	    value: function render() {
	      var users = this.state.users;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'TeacherAddManualTabView' },
	        _react2.default.createElement(
	          'div',
	          { className: 'TeacherAddManualTabView-container' },
	          _react2.default.createElement(_TableInput2.default, {
	            initialRows: this.state.users,
	            onChangeRow: this.onUpdate,
	            autofocusFirstRow: true,
	            columns: [{
	              name: 'name',
	              label: 'Full name',
	              placeholder: 'First and last name',
	              validations: {
	                matchRegexp: /\w+ +\w+/
	              },
	              validationErrors: {
	                matchRegexp: _directAdd.firstLastRequired
	              }
	            }, {
	              name: 'address',
	              label: 'Email address or phone number',
	              placeholders: ['name@example.k12.us', '(555) 555-5555'],
	              validations: 'isEmailOrPhone',
	              validationError: 'Invalid phone or email'
	            }]
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'TeacherAddManualTabView-button',
	              disabled: !users || users.filter(function (e) {
	                return e.isValid;
	              }).length === 0,
	              onClick: this.submitAddUsers,
	              level: 'primary',
	              eventElementName: 'TeacherAddManualTabView-button' },
	            'Add ',
	            this.props.role,
	            's'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TeacherAddManualTabView;
	}(_react2.default.Component);
	
	TeacherAddManualTabView.contextTypes = {
	  eventScreenName: _react2.default.PropTypes.string
	};
	TeacherAddManualTabView.displayName = 'TeacherAddManualTabView';
	exports.default = TeacherAddManualTabView;

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.firstLastRequired = undefined;
	exports.handleDirectAddResponse = handleDirectAddResponse;
	exports.queryDirectAddJob = queryDirectAddJob;
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var POLL_INTERVAL = 1000; // ms
	
	/*  weak */
	var firstLastRequired = exports.firstLastRequired = 'First and last name are both required';
	function handleDirectAddResponse(response) {
	  var addedUsers = [];
	  var existingUsers = [];
	  var errorUsers = [];
	  response.forEach(function (row) {
	    var user = {
	      fields: {
	        name: [row.first_name, row.last_name].join(' '),
	        address: row.address
	      },
	      validation_errors: {}
	    };
	
	    if (row.was_added_to_org) {
	      addedUsers.push(user);
	    } else if (row.was_successful) {
	      existingUsers.push(user);
	    } else {
	      row.validation_errors.forEach(function (error) {
	        var key = null;
	        var message = null;
	        if (error.field_name === 'first_name' || error.field_name === 'last_name') {
	          key = 'name';
	          if (error.code === 'blank') {
	            message = firstLastRequired;
	          }
	        } else {
	          key = error.field_name;
	        }
	        user.validation_errors[key] = message || error.messages[0];
	      });
	
	      errorUsers.push(user);
	    }
	  });
	
	  return {
	    existingUsers: existingUsers,
	    addedUsers: addedUsers,
	    errorUsers: errorUsers
	  };
	}
	
	function queryDirectAddJob(orgId, jobId, onUpdate) {
	  return new Promise(function (resolve, reject) {
	    var poll = function poll() {
	      (0, _apiRequest2.default)('/organizations/' + orgId + '/teachers/job/' + jobId).then(function (response) {
	        if (onUpdate) {
	          onUpdate(response);
	        }
	        if (response.status === 'complete') {
	          resolve(handleDirectAddResponse(response.results));
	        } else if (response.status === 'error') {
	          reject(response.results);
	        } else {
	          setTimeout(poll, POLL_INTERVAL);
	        }
	      });
	    };
	
	    poll();
	  });
	}

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormCellInput = __webpack_require__(1477);
	
	var _FormCellInput2 = _interopRequireDefault(_FormCellInput);
	
	var _Formsy = __webpack_require__(1345);
	
	var _Formsy2 = _interopRequireDefault(_Formsy);
	
	__webpack_require__(1480);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var MIN_ROWS = 5;
	
	function padRows(rows) {
	  var rowLength = rows.length;
	  for (var i = 0; i < MIN_ROWS - rowLength; i++) {
	    rows.push({});
	  }
	  return rows;
	}
	
	var TableInput = function (_React$Component) {
	  _inherits(TableInput, _React$Component);
	
	  function TableInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TableInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableInput.__proto__ || Object.getPrototypeOf(TableInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      rows: padRows(_this.props.initialRows),
	      shouldScroll: false
	    }, _this.setRowValid = function (rowIndex, isValid) {
	      var rows = _this.state.rows.slice(0);
	      rows[rowIndex].isValid = isValid;
	      _this.setState({ rows: rows });
	      if (_this.props.onChangeRow) {
	        _this.props.onChangeRow(rows);
	      }
	    }, _this.changeInputState = function (rowIndex, name, event) {
	      var rows = _this.state.rows.slice(0);
	      if (!rows[rowIndex].fields) {
	        rows[rowIndex].fields = {};
	      }
	      rows[rowIndex].fields[name] = event.target.value;
	      if (rows[rowIndex].validation_errors) {
	        delete rows[rowIndex].validation_errors[name];
	      }
	
	      var shouldScroll = false;
	      if (rowIndex === _this.state.rows.length - 1) {
	        rows.push({});
	        shouldScroll = true;
	      }
	
	      _this.setState({ rows: rows, shouldScroll: shouldScroll });
	      if (_this.props.onChangeRow) {
	        _this.props.onChangeRow(rows);
	      }
	    }, _this.renderTableBody = function () {
	      var rowItems = _this.state.rows.map(function (row, rowIndex) {
	        var fieldErrors = row.validation_errors || [];
	        var tableCells = _this.props.columns.map(function (column, columnIndex) {
	          var name = column.name,
	              label = column.label,
	              placeholder = column.placeholder,
	              placeholders = column.placeholders,
	              validations = column.validations,
	              validationError = column.validationError,
	              validationErrors = column.validationErrors;
	
	          var key = name + '-' + rowIndex;
	          var value = row.fields && row.fields[name];
	          var placeholderText = placeholders ? placeholders[rowIndex % placeholders.length] : placeholder || label;
	          return _react2.default.createElement(
	            'span',
	            { key: key, className: 'TableInput-body-cell TableInput-cell' },
	            _react2.default.createElement(_FormCellInput2.default, {
	              onChange: _this.changeInputState.bind(_this, rowIndex, name),
	              value: value || '',
	              placeholder: placeholderText,
	              validations: validations,
	              validationError: validationError,
	              validationErrors: validationErrors,
	              name: key,
	              errorMessage: fieldErrors[name] || null,
	              autofocus: rowIndex === 0 && columnIndex === 0 && _this.props.autofocusFirstRow
	            })
	          );
	        });
	        return _react2.default.createElement(
	          _Formsy2.default.Form,
	          {
	            key: rowIndex,
	            ref: 'form-' + rowIndex,
	            className: 'TableInput-body-row',
	            onValid: function onValid() {
	              return _this.setRowValid(rowIndex, true);
	            },
	            onInvalid: function onInvalid() {
	              return _this.setRowValid(rowIndex, false);
	            } },
	          _react2.default.createElement('span', { className: 'TableInput-cell--validation TableInput-cell' }),
	          tableCells
	        );
	      });
	
	      return rowItems;
	    }, _this.renderColumnNames = function () {
	      var headerItems = _this.props.columns.map(function (col) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'TableInput-headerRow-cell TableInput-cell', key: col.name },
	          col.label
	        );
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'TableInput-headerRow' },
	        _react2.default.createElement('span', { className: 'TableInput-cell--validation TableInput-cell' }),
	        headerItems
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TableInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.initialRows.length !== this.state.rows.length) {
	        this.setState({ rows: padRows(nextProps.initialRows) });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (nextState.rows.length !== this.state.rows.length) {
	        this.setState({ rows: padRows(nextState.rows) });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      if (this.state.shouldScroll) {
	        var tableContainer = this.refs.tableContainer;
	        tableContainer.scrollTop = tableContainer.scrollHeight;
	      }
	
	      if (JSON.stringify(prevState) === JSON.stringify(this.state)) {
	        return;
	      }
	
	      prevState.rows.forEach(function (row, i) {
	        if (!_this2.state.rows[i]) {
	          return;
	        }
	        if (!_lodash2.default.isEmpty(row.fields) && _lodash2.default.isEmpty(_this2.state.rows[i].fields)) {
	          _this2.refs['form-' + i].reset();
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('TableInput', this.props.className) },
	        this.renderColumnNames(),
	        _react2.default.createElement(
	          'div',
	          { className: 'TableInput-container', ref: 'tableContainer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'TableInput-body' },
	            this.renderTableBody()
	          )
	        )
	      );
	    }
	  }]);
	
	  return TableInput;
	}(_react2.default.Component);
	
	TableInput.defaultProps = {
	  initialRows: []
	};
	TableInput.displayName = 'TableInput';
	exports.default = TableInput;

/***/ },
/* 1527 */
1136,
/* 1528 */,
/* 1529 */
1136,
/* 1530 */,
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Columns = __webpack_require__(1532);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DialogWithSidebar = __webpack_require__(1535);
	
	var _DialogWithSidebar2 = _interopRequireDefault(_DialogWithSidebar);
	
	var _DialogSidebar = __webpack_require__(1536);
	
	var _DialogSidebar2 = _interopRequireDefault(_DialogSidebar);
	
	var _Tabs = __webpack_require__(1539);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	__webpack_require__(1542);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var LeftTabModal = function (_React$Component) {
	  _inherits(LeftTabModal, _React$Component);
	
	  function LeftTabModal() {
	    _classCallCheck(this, LeftTabModal);
	
	    return _possibleConstructorReturn(this, (LeftTabModal.__proto__ || Object.getPrototypeOf(LeftTabModal)).apply(this, arguments));
	  }
	
	  _createClass(LeftTabModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _DialogWithSidebar2.default,
	        _extends({}, this.props, {
	          className: (0, _classnames2.default)('LeftTabModal', this.props.className),
	          hideOnBlur: this.props.hideOnBlur,
	          onMaskHide: this.props.onMaskHide,
	          onClick: this.props.onDialogClick,
	          size: 'large' }),
	        _react2.default.createElement(
	          _Columns2.default,
	          null,
	          _react2.default.createElement(
	            _DialogSidebar2.default,
	            { color: 'grey' },
	            this.props.sidebarHeader,
	            this.props.sidebarFooter && _react2.default.createElement(
	              'div',
	              { className: 'LeftTabModal-footer' },
	              this.props.sidebarFooter
	            )
	          ),
	          _react2.default.createElement(
	            _Tabs2.default,
	            {
	              center: true,
	              tabActive: this.props.tabActive,
	              className: 'LeftTabModal-body',
	              onTabChange: this.props.onTabChange },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	
	  return LeftTabModal;
	}(_react2.default.Component);
	
	LeftTabModal.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	LeftTabModal.defaultProps = {
	  tabActive: 0,
	  onTabChange: function onTabChange() {},
	  hideOnBlur: false
	};
	LeftTabModal.displayName = 'LeftTabModal';
	exports.default = LeftTabModal;

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1533);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Columns = function (_React$Component) {
	  _inherits(Columns, _React$Component);
	
	  function Columns() {
	    _classCallCheck(this, Columns);
	
	    return _possibleConstructorReturn(this, (Columns.__proto__ || Object.getPrototypeOf(Columns)).apply(this, arguments));
	  }
	
	  _createClass(Columns, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var children = _react2.default.Children.map(this.props.children, function (child, index) {
	        return _react2.default.cloneElement(child, {
	          key: index,
	          className: (0, _classnames2.default)('Columns-column', child.props.className, {
	            'Columns-column-divided': _this2.props.divided
	          })
	        });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('Columns', this.props.className) },
	        children
	      );
	    }
	  }]);
	
	  return Columns;
	}(_react2.default.Component);
	
	Columns.defaultProps = {
	  divided: false
	};
	Columns.displayName = 'Columns';
	exports.default = Columns;

/***/ },
/* 1533 */
1136,
/* 1534 */,
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogWithSidebar = function (_React$Component) {
	  _inherits(DialogWithSidebar, _React$Component);
	
	  function DialogWithSidebar() {
	    _classCallCheck(this, DialogWithSidebar);
	
	    return _possibleConstructorReturn(this, (DialogWithSidebar.__proto__ || Object.getPrototypeOf(DialogWithSidebar)).apply(this, arguments));
	  }
	
	  _createClass(DialogWithSidebar, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({}, this.props, {
	          size: 'xlarge' }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return DialogWithSidebar;
	}(_react2.default.Component);
	
	DialogWithSidebar.displayName = 'DialogWithSidebar';
	exports.default = DialogWithSidebar;

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Heading = __webpack_require__(1436);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getPropClasses = __webpack_require__(1135);
	
	__webpack_require__(1537);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogSidebar = function (_React$Component) {
	  _inherits(DialogSidebar, _React$Component);
	
	  function DialogSidebar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DialogSidebar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DialogSidebar.__proto__ || Object.getPrototypeOf(DialogSidebar)).call.apply(_ref, [this].concat(args))), _this), _this.renderTitle = function () {
	      var title = _this.props.title;
	
	      if (!title) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _Heading2.default,
	        { flush: true, level: '3' },
	        title
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DialogSidebar, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)({
	            DialogSidebar: true
	          }, (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className) },
	        this.renderTitle(),
	        this.props.children
	      );
	    }
	  }]);
	
	  return DialogSidebar;
	}(_react2.default.Component);
	
	DialogSidebar.propClasses = {
	  color: {
	    grey: 'DialogSidebar-grey'
	  }
	};
	DialogSidebar.displayName = 'DialogSidebar';
	exports.default = DialogSidebar;

/***/ },
/* 1537 */
1136,
/* 1538 */,
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1540);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var Tabs = function (_React$Component) {
	  _inherits(Tabs, _React$Component);
	
	  function Tabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      tabActive: _this.props.tabActive || 0
	    }, _this.setActive = function (index, e) {
	      _this.setState({ tabActive: index });
	      e.preventDefault();
	
	      if (_this.props.onTabChange) {
	        _this.props.onTabChange(index);
	      }
	    }, _this.getChildren = function () {
	      return (0, _lodash.compact)(_this.props.children);
	    }, _this.renderBar = function (title) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Tabs-bar' },
	        title
	      );
	    }, _this.renderMenuItems = function () {
	      var _this$props = _this.props,
	          tabType = _this$props.type,
	          buttonSize = _this$props.buttonSize;
	
	      var menuItems = _this.getChildren().map(function (panel, index) {
	        if (!panel) {
	          return null;
	        }
	
	        if (tabType === 'button') {
	          return _react2.default.createElement(
	            _Button2.default,
	            {
	              level: _this.state.tabActive === index ? 'primary' : 'secondary',
	              size: buttonSize,
	              className: 'Tabs--buttons-button',
	              key: index,
	              onClick: (0, _createChainedFunction2.default)(panel.props.onClick, _this.setActive.bind(_this, index)),
	              eventElementName: panel.props.eventElementName },
	            panel.props.title
	          );
	        } else if (tabType === 'bar') {
	          return _react2.default.createElement(
	            _Button2.default,
	            {
	              color: _this.state.tabActive === index ? 'brand' : 'thunder',
	              level: _this.state.tabActive === index ? 'primary' : 'secondary',
	              size: buttonSize,
	              className: 'Tabs--bar-button',
	              key: index,
	              full: true,
	              onClick: (0, _createChainedFunction2.default)(panel.props.onClick, _this.setActive.bind(_this, index)),
	              eventElementName: panel.props.eventElementName },
	            panel.props.title
	          );
	        } else {
	          var borderColor = panel.props.selectedBorderColor;
	
	
	          return _react2.default.createElement(
	            'li',
	            {
	              className: (0, _classnames2.default)('Tabs--border-item', {
	                'Tabs--border-item--hidden': panel.props.hidden,
	                'Tabs--border-item-vertical': _this.props.orientation === 'vertical'
	              }),
	              key: index },
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                href: '#',
	                className: (0, _classnames2.default)('Tabs--border-item-link', _this.state.tabActive === index && 'active', borderColor && 'Tabs--border-item-link--' + borderColor, panel.props.className),
	                onClick: (0, _createChainedFunction2.default)(panel.props.onClick, _this.setActive.bind(_this, index)),
	                eventElementName: panel.props.eventElementName },
	              panel.props.title
	            )
	          );
	        }
	      });
	
	      if (_this.props.type === 'button') {
	        return _react2.default.createElement(
	          'nav',
	          {
	            className: (0, _classnames2.default)('Tabs Tabs--buttons', {
	              'Tabs--buttons-vertical': _this.props.orientation === 'vertical'
	            }) },
	          menuItems
	        );
	      } else if (_this.props.type === 'bar') {
	        return _react2.default.createElement(
	          'nav',
	          { className: (0, _classnames2.default)('Tabs', 'Tabs--bar', _this.props.tabHeaderClass) },
	          menuItems
	        );
	      } else {
	        return _react2.default.createElement(
	          'nav',
	          {
	            className: (0, _classnames2.default)('Tabs', 'Tabs--border', _this.props.tabHeaderClass),
	            style: { textAlign: _this.props.tabAlign } },
	          _react2.default.createElement(
	            'ul',
	            { className: 'Tabs-list Tabs--border-list' },
	            menuItems
	          )
	        );
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tabs, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref2) {
	      var tabActive = _ref2.tabActive;
	
	      if (typeof tabActive === 'number') {
	        this.setState({ tabActive: tabActive });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className },
	        this.renderMenuItems(),
	        this.getChildren()[this.state.tabActive]
	      );
	    }
	  }]);
	
	  return Tabs;
	}(_react2.default.Component);
	
	Tabs.defaultProps = {
	  tabAlign: 'left',
	  tabHeaderClass: '',
	  type: 'border',
	  buttonSize: 'medium',
	  orientation: 'horizontal'
	};
	Tabs.displayName = 'Tabs';
	exports.default = Tabs;

/***/ },
/* 1540 */
1136,
/* 1541 */,
/* 1542 */
1136,
/* 1543 */,
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeftTabModalTitle = function (_React$Component) {
	  _inherits(LeftTabModalTitle, _React$Component);
	
	  function LeftTabModalTitle() {
	    _classCallCheck(this, LeftTabModalTitle);
	
	    return _possibleConstructorReturn(this, (LeftTabModalTitle.__proto__ || Object.getPrototypeOf(LeftTabModalTitle)).apply(this, arguments));
	  }
	
	  _createClass(LeftTabModalTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          glyphName = _props.glyphName,
	          glyphColor = _props.glyphColor,
	          title = _props.title,
	          titleShort = _props.titleShort;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Glyph2.default, { name: glyphName, color: glyphColor, size: 'medium' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'LeftTabModal-tab-text' },
	          _react2.default.createElement(
	            'span',
	            { className: 'hide--mobile' },
	            title
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'hide show--mobile' },
	            titleShort
	          )
	        )
	      );
	    }
	  }]);
	
	  return LeftTabModalTitle;
	}(_react2.default.Component);
	
	LeftTabModalTitle.displayName = 'LeftTabModalTitle';
	exports.default = LeftTabModalTitle;

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = shouldEnableCsvUploadForGroup;
	
	var _AffiliationStore = __webpack_require__(1038);
	
	var _AffiliationStore2 = _interopRequireDefault(_AffiliationStore);
	
	var _FeatureStore = __webpack_require__(588);
	
	var _FeatureStore2 = _interopRequireDefault(_FeatureStore);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shouldEnableCsvUploadForGroup(group) {
	  if (_FeatureStore2.default.hasFeature('disable_csv_upload')) {
	    return false;
	  }
	
	  if (!group.isStaffClass()) {
	    return false;
	  }
	
	  var org = _OrganizationStore2.default.getOrganization(group.getStaffClassOrgId());
	  var affiliation = _AffiliationStore2.default.getAffiliation(org.id);
	  return affiliation.roles.includes('teacher') || affiliation.roles.includes('admin');
	} /*  weak */

/***/ },
/* 1546 */
1136,
/* 1547 */,
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _LayerWithArrow = __webpack_require__(1549);
	
	var _LayerWithArrow2 = _interopRequireDefault(_LayerWithArrow);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1550);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Hovercard is a simple LayerWithArrow component
	 *
	 * Hovercard can be used with [HoverLayerTrigger](/components/HoverLayerTrigger) or
	 * [LayerTrigger](/components/LayerTrigger).
	 *
	 * ```example
	 *  <div>
	 *    <HoverLayerTrigger
	 *      layer={
	 *        <Hovercard>
	 *          <HovercardBody>
	 *            Hello
	 *          </HovercardBody>
	 *        </Hovercard>
	 *      }
	 *      placement="top">
	 *      <Link>Hover this link</Link>
	 *    </HoverLayerTrigger>
	 *    {' or '}
	 *    <LayerTrigger
	 *      layer={
	 *        <Hovercard>
	 *          <HovercardBody>
	 *            Hello
	 *          </HovercardBody>
	 *        </Hovercard>
	 *      }
	 *      placement="top"
	 *      trigger="click">
	 *      <Link>Click this link</Link>
	 *    </LayerTrigger>
	 *  </div>
	 * ```
	 */
	
	var Hovercard = function (_React$Component) {
	  _inherits(Hovercard, _React$Component);
	
	  function Hovercard() {
	    _classCallCheck(this, Hovercard);
	
	    return _possibleConstructorReturn(this, (Hovercard.__proto__ || Object.getPrototypeOf(Hovercard)).apply(this, arguments));
	  }
	
	  _createClass(Hovercard, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _LayerWithArrow2.default,
	        _extends({}, this.props, {
	          className: (0, _classnames2.default)('Hovercard', this.props.className),
	          arrowClassName: 'Hovercard-arrow' }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Hovercard;
	}(_react2.default.Component);
	
	Hovercard.displayName = 'Hovercard';
	exports.default = Hovercard;

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _DOM = __webpack_require__(1109);
	
	var _DOM2 = _interopRequireDefault(_DOM);
	
	var _Layer = __webpack_require__(1158);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _LayerPropTypes = __webpack_require__(1166);
	
	var _LayerPropTypes2 = _interopRequireDefault(_LayerPropTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A layer that adds an arrow element to point at its trigger.
	 *
	 * LayerWithArrow adds an arrow element that can be styled to point at the layer's trigger
	 * element. This behavior is demonstrated by Hovercard.
	 *
	 * ```example
	 *  <LayerTrigger
	 *    layer={
	 *      <Hovercard hideOnBlur={false} hideOnEscape={false}>
	 *        <HovercardBody>
	 *          This layer has an arrow.
	 *        </HovercardBody>
	 *      </Hovercard>
	 *    }
	 *    trigger="manual"
	 *    defaultLayerShown={true}>
	 *    <Link>This is the layer's trigger</Link>
	 *  </LayerTrigger>
	 * ```
	 */
	
	var LayerWithArrow = function (_React$Component) {
	  _inherits(LayerWithArrow, _React$Component);
	
	  function LayerWithArrow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LayerWithArrow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LayerWithArrow.__proto__ || Object.getPrototypeOf(LayerWithArrow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      arrowPosition: {}
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LayerWithArrow, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.arrowClassName !== null) {
	        this.updateArrowPosition();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      if (this.props.arrowClassName !== null) {
	        this.updateArrowPosition();
	      }
	    }
	  }, {
	    key: 'updateArrowPosition',
	    value: function updateArrowPosition() {
	      var position = {};
	
	      var node = _reactDom2.default.findDOMNode(this);
	      var nodePosition = _DOM2.default.getOffset(node);
	      var context = this.props.context;
	
	      var contextPosition = _DOM2.default.getOffset(context);
	
	      if (this.props.placement === 'bottom' || this.props.placement === 'top') {
	        position.left = contextPosition.left + context.offsetWidth / 2 - nodePosition.left;
	      } else if (this.props.placement === 'left' || this.props.placement === 'right') {
	        position.top = contextPosition.top + context.offsetHeight / 2 - nodePosition.top;
	      }
	
	      this.setState({ arrowPosition: position });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          arrowClassName = _props.arrowClassName,
	          others = _objectWithoutProperties(_props, ['arrowClassName']);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        others,
	        this.props.children,
	        _react2.default.createElement('div', { className: arrowClassName, style: this.state.arrowPosition })
	      );
	    }
	  }]);
	
	  return LayerWithArrow;
	}(_react2.default.Component);
	
	LayerWithArrow.defaultProps = {
	  arrowClassName: null
	};
	LayerWithArrow.displayName = 'LayerWithArrow';
	exports.default = LayerWithArrow;

/***/ },
/* 1550 */
1136,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HovercardBody = function (_React$Component) {
	  _inherits(HovercardBody, _React$Component);
	
	  function HovercardBody() {
	    _classCallCheck(this, HovercardBody);
	
	    return _possibleConstructorReturn(this, (HovercardBody.__proto__ || Object.getPrototypeOf(HovercardBody)).apply(this, arguments));
	  }
	
	  _createClass(HovercardBody, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        _extends({}, this.props, { className: (0, _classnames2.default)('HovercardBody', this.props.className) }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return HovercardBody;
	}(_react2.default.Component);
	
	HovercardBody.displayName = 'HovercardBody';
	exports.default = HovercardBody;

/***/ },
/* 1555 */
1136,
/* 1556 */,
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1558);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HovercardFooter = function (_React$Component) {
	  _inherits(HovercardFooter, _React$Component);
	
	  function HovercardFooter() {
	    _classCallCheck(this, HovercardFooter);
	
	    return _possibleConstructorReturn(this, (HovercardFooter.__proto__ || Object.getPrototypeOf(HovercardFooter)).apply(this, arguments));
	  }
	
	  _createClass(HovercardFooter, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        _extends({}, this.props, { className: (0, _classnames2.default)('HovercardFooter', this.props.className) }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return HovercardFooter;
	}(_react2.default.Component);
	
	HovercardFooter.displayName = 'HovercardFooter';
	exports.default = HovercardFooter;

/***/ },
/* 1558 */
1136,
/* 1559 */,
/* 1560 */
1136,
/* 1561 */,
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _findScrollParent = __webpack_require__(1176);
	
	var _findScrollParent2 = _interopRequireDefault(_findScrollParent);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Keyboard accessibility. Should focus the layer and use tab isolation.
	
	var _currentInstanceShown = null;
	var _showTimeout = null;
	
	/**
	 * LayerTrigger with a specific hover behavior for use with Hovercard.
	 *
	 * HoverLayerTrigger was built to be used with [Hovercard](/components/Hovercard). It is a
	 * [LayerTrigger](/components/LayerTrigger) with a special customizable delayed-hover behavior.
	 *
	 * Unlike a normal LayerTrigger, the user is able to move their mouse from the HoverLayerTrigger
	 * element to the layer. The layer is hidden when the user moves their mouse away from the layer
	 * or performs an action in the layer.
	 *
	 * If the user hovers over another HoverLayerTrigger while moving their mouse towards a visible
	 * layer, that HoverLayerTrigger will NOT be triggered.
	 *
	 * ```example
	 *  <div>
	 *    <HoverLayerTrigger
	 *      layer={
	 *        <Hovercard>
	 *          <HovercardBody>
	 *            You can move your mouse here!
	 *          </HovercardBody>
	 *        </Hovercard>
	 *      }
	 *      placement="top">
	 *      <Link block="inline" style={{border: '1px solid #eee', padding: 20}}>
	 *        Hover me
	 *      </Link>
	 *    </HoverLayerTrigger>
	 *    <HoverLayerTrigger
	 *      layer={
	 *        <Hovercard>
	 *          <HovercardBody>
	 *            You can move your mouse here!
	 *          </HovercardBody>
	 *        </Hovercard>
	 *      }
	 *      placement="top">
	 *      <Link block="inline" style={{border: '1px solid #eee', padding: 20}}>
	 *        Hover me
	 *      </Link>
	 *    </HoverLayerTrigger>
	 *    <HoverLayerTrigger
	 *      layer={
	 *        <Hovercard>
	 *          <HovercardBody>
	 *            You can move your mouse here!
	 *          </HovercardBody>
	 *        </Hovercard>
	 *      }
	 *      placement="top">
	 *      <Link block="inline" style={{border: '1px solid #eee', padding: 20}}>
	 *        Hover me
	 *      </Link>
	 *    </HoverLayerTrigger>
	 *    <HoverLayerTrigger
	 *      layer={
	 *        <Hovercard>
	 *          <HovercardBody>
	 *            You can move your mouse here!
	 *          </HovercardBody>
	 *        </Hovercard>
	 *      }
	 *      placement="top">
	 *      <Link block="inline" style={{border: '#eee', padding: 20}}>
	 *        Hover me
	 *      </Link>
	 *    </HoverLayerTrigger>
	 *  </div>
	 * ```
	 */
	
	var HoverLayerTrigger = _react2.default.createClass({
	  displayName: 'HoverLayerTrigger',
	  componentDidMount: function componentDidMount() {
	    this._scrollParent = (0, _findScrollParent2.default)(_reactDom2.default.findDOMNode(this));
	  },
	
	
	  _mouseOrigin: null,
	
	  _scrollParent: null,
	
	  addDocumentListeners: function addDocumentListeners() {
	    document.addEventListener('mousemove', this.handleDocumentMouseMove, false);
	  },
	  handleClick: function handleClick() {
	    if (_showTimeout !== null) {
	      clearTimeout(_showTimeout);
	      _showTimeout = null;
	    }
	
	    var trigger = this.refs.trigger;
	
	    if (trigger.isLayerShown()) {
	      trigger.hideLayer();
	      _currentInstanceShown = null;
	    }
	  },
	  handleDelayedHide: function handleDelayedHide() {
	    var _this = this;
	
	    if (this._hideTimeout !== null) {
	      clearTimeout(this._hideTimeout);
	      this._hideTimeout = null;
	    }
	
	    var delay = this.props.delayHide !== null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hideLayer();
	      return;
	    }
	
	    this._hideTimeout = setTimeout(function () {
	      _this._hideTimeout = null;
	      _this.hideLayer();
	    }, delay);
	  },
	  handleDelayedShow: function handleDelayedShow() {
	    var _this2 = this;
	
	    if (_showTimeout !== null) {
	      clearTimeout(_showTimeout);
	      _showTimeout = null;
	    }
	
	    var delay = this.props.delayShow !== null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.showLayer();
	      return;
	    }
	
	    _showTimeout = setTimeout(function () {
	      _showTimeout = null;
	      _this2.showLayer();
	    }, delay);
	  },
	  handleDocumentMouseMove: function handleDocumentMouseMove(event) {
	    if (this.shouldHideLayer({ x: event.clientX, y: event.clientY })) {
	      this.handleDelayedHide();
	      this.removeDocumentListeners();
	    }
	  },
	  handleDocumentScroll: function handleDocumentScroll() {
	    this.handleDelayedHide();
	    this.removeDocumentListeners();
	  },
	  handleLayerHide: function handleLayerHide() {
	    this.removeDocumentListeners();
	    _currentInstanceShown = null;
	  },
	  handleLayerMouseEnter: function handleLayerMouseEnter() {
	    this.removeDocumentListeners();
	  },
	  handleLayerMouseLeave: function handleLayerMouseLeave() {
	    this.handleDelayedHide();
	  },
	  handleMouseEnter: function handleMouseEnter() {
	    this.handleDelayedShow();
	  },
	  handleMouseLeave: function handleMouseLeave(event) {
	    if (_showTimeout !== null) {
	      clearTimeout(_showTimeout);
	      _showTimeout = null;
	    }
	
	    if (_currentInstanceShown !== this) {
	      return;
	    }
	
	    this._mouseOrigin = {
	      x: event.clientX,
	      y: event.clientY
	    };
	
	    this.addDocumentListeners();
	  },
	  handleMouseMove: function handleMouseMove() {
	    this.handleDelayedShow();
	  },
	  hideLayer: function hideLayer() {
	    if (this._scrollParent) {
	      this._scrollParent.removeEventListener('scroll', this.handleDocumentScroll, false);
	    }
	
	    if (this.isMounted()) {
	      this.refs.trigger.hideLayer();
	    }
	    _currentInstanceShown = null;
	  },
	  isPointInTriangle: function isPointInTriangle(point, p1, p2, p3) {
	    // This checks to see if the mouse is moving within a triangle formed by our three points.
	    // See: http://www.blackpawn.com/texts/pointinpoly/default.html
	    // This would be better if the sides of the triangle weren't straight and had a parabolic-like
	    // shape, but that just seemed really hard.
	    // I might just adjust the origin by some amount to provide some leeway.
	
	    var v0 = [p3.x - p1.x, p3.y - p1.y];
	    var v1 = [p2.x - p1.x, p2.y - p1.y];
	    var v2 = [point.x - p1.x, point.y - p1.y];
	
	    var dot00 = v0[0] * v0[0] + v0[1] * v0[1];
	    var dot01 = v0[0] * v1[0] + v0[1] * v1[1];
	    var dot02 = v0[0] * v2[0] + v0[1] * v2[1];
	    var dot11 = v1[0] * v1[0] + v1[1] * v1[1];
	    var dot12 = v1[0] * v2[0] + v1[1] * v2[1];
	
	    var invDenom = 1 / (dot00 * dot11 - dot01 * dot01);
	
	    var u = (dot11 * dot02 - dot01 * dot12) * invDenom;
	    var v = (dot00 * dot12 - dot01 * dot02) * invDenom;
	
	    return u >= 0 && v >= 0 && u + v <= 1;
	  },
	  removeDocumentListeners: function removeDocumentListeners() {
	    document.removeEventListener('mousemove', this.handleDocumentMouseMove, false);
	  },
	  shouldHideLayer: function shouldHideLayer(point) {
	    if (!this.isMounted()) {
	      return true;
	    }
	
	    var trigger = this.refs.trigger;
	    // If the layer is already hidden for some reason, ensure we clean up.
	
	    if (!trigger.isLayerShown()) {
	      return true;
	    }
	    var rect = trigger.getLayerRect();
	
	    // Determine the points on the layer's rect in which the mouse can move towards.
	    var p1 = void 0;
	    var p2 = void 0;
	    var origin = this._mouseOrigin;
	    if (origin.x > rect.right) {
	      // Left
	      p1 = {
	        x: origin.y < rect.top ? rect.left : rect.right,
	        y: rect.top
	      };
	      p2 = {
	        x: origin.y > rect.bottom ? rect.left : rect.right,
	        y: rect.bottom
	      };
	    } else if (origin.x < rect.left) {
	      // Right
	      p1 = {
	        x: origin.y < rect.top ? rect.right : rect.left,
	        y: rect.top
	      };
	      p2 = {
	        x: origin.y > rect.bottom ? rect.right : rect.left,
	        y: rect.bottom
	      };
	    } else if (origin.y > rect.bottom) {
	      // Top
	      p1 = {
	        x: rect.left,
	        y: origin.x < rect.left ? rect.top : rect.bottom
	      };
	      p2 = {
	        x: rect.right,
	        y: origin.x > rect.right ? rect.top : rect.bottom
	      };
	    } else if (origin.y < rect.top) {
	      // Bottom
	      p1 = {
	        x: rect.left,
	        y: origin.x < rect.left ? rect.bottom : rect.top
	      };
	      p2 = {
	        x: rect.right,
	        y: origin.x > rect.right ? rect.bottom : rect.top
	      };
	    } else {
	      // Is the origin inside of the layer? Not sure how that happened.
	      console.warn('origin in layer rect', origin, rect);
	      // FIXME https://app.asana.com/0/42965143452863/193556816395307
	      console.warn('HoverLayerTrigger non-fatal error');
	      return false;
	    }
	
	    return !this.isPointInTriangle(point, origin, p1, p2);
	  },
	  showLayer: function showLayer() {
	    // Only allow one layer to be triggered by `HoverLayerTrigger` at a time
	    if (_currentInstanceShown !== null) {
	      return;
	    }
	
	    if (this.isMounted()) {
	      if (this._scrollParent) {
	        this._scrollParent.addEventListener('scroll', this.handleDocumentScroll, false);
	      }
	
	      this.refs.trigger.showLayer();
	      _currentInstanceShown = this;
	    }
	  },
	  render: function render() {
	    var child = _react2.default.Children.only(this.props.children);
	
	    child = _react2.default.cloneElement(child, {
	      onMouseEnter: (0, _createChainedFunction2.default)(this.handleMouseEnter, child.props.onMouseEnter),
	      onMouseMove: (0, _createChainedFunction2.default)(this.handleMouseMove, child.props.onMouseMove),
	      onMouseLeave: (0, _createChainedFunction2.default)(this.handleMouseLeave, child.props.onMouseLeave),
	      onClick: (0, _createChainedFunction2.default)(this.handleClick, child.props.onClick)
	    });
	
	    var layer = this.props.layer;
	
	
	    layer = _react2.default.cloneElement(layer, {
	      onMouseEnter: (0, _createChainedFunction2.default)(this.handleLayerMouseEnter, layer.props.onMouseEnter),
	      onMouseLeave: (0, _createChainedFunction2.default)(this.handleLayerMouseLeave, layer.props.onMouseLeave),
	      onRequestHide: (0, _createChainedFunction2.default)(this.handleLayerHide, layer.props.onRequestHide)
	    });
	
	    return _react2.default.createElement(
	      _LayerTrigger2.default,
	      _extends({}, this.props, { ref: 'trigger', layer: layer, trigger: 'manual' }),
	      child
	    );
	  }
	});
	
	exports.default = HoverLayerTrigger;

/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18n = __webpack_require__(1018);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Time = function (_React$Component) {
	  _inherits(Time, _React$Component);
	
	  function Time() {
	    _classCallCheck(this, Time);
	
	    return _possibleConstructorReturn(this, (Time.__proto__ || Object.getPrototypeOf(Time)).apply(this, arguments));
	  }
	
	  _createClass(Time, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          date = _props.date,
	          rest = _objectWithoutProperties(_props, ['className', 'date']);
	
	      return _react2.default.createElement(
	        'span',
	        { className: className },
	        _i18n2.default.getDate(date, rest)
	      );
	    }
	  }]);
	
	  return Time;
	}(_react2.default.Component);
	
	Time.displayName = 'Time';
	exports.default = Time;

/***/ },
/* 1564 */
1136,
/* 1565 */,
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BoxHeader = __webpack_require__(1440);
	
	var _BoxHeader2 = _interopRequireDefault(_BoxHeader);
	
	var _Buttons = __webpack_require__(1315);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Relationship = __webpack_require__(1007);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _StartChatButton = __webpack_require__(1567);
	
	var _StartChatButton2 = _interopRequireDefault(_StartChatButton);
	
	var _StatusLabel = __webpack_require__(1571);
	
	var _StatusLabel2 = _interopRequireDefault(_StatusLabel);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _GroupMembersTabUserActions = __webpack_require__(1574);
	
	var _GroupMembersTabUserActions2 = _interopRequireDefault(_GroupMembersTabUserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RelationshipViewHeader = function (_React$Component) {
	  _inherits(RelationshipViewHeader, _React$Component);
	
	  function RelationshipViewHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RelationshipViewHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelationshipViewHeader.__proto__ || Object.getPrototypeOf(RelationshipViewHeader)).call.apply(_ref, [this].concat(args))), _this), _this.renderHeaderAux = function () {
	      var _this$props = _this.props,
	          relationship = _this$props.relationship,
	          subscriber = _this$props.subscriber,
	          groupToAdmin = _this$props.groupToAdmin,
	          groupMember = _this$props.groupMember;
	
	      return _react2.default.createElement(
	        _Buttons2.default,
	        null,
	        relationship.isEligibleForChat() && _react2.default.createElement(_StartChatButton2.default, {
	          subscriber: subscriber,
	          onRequestHide: _this.props.onRequestHide
	        }),
	        _react2.default.createElement(_GroupMembersTabUserActions2.default, {
	          groupToAdmin: groupToAdmin,
	          groupMembership: groupMember,
	          subscriber: subscriber,
	          buttonSize: 'small'
	        })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RelationshipViewHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          relationship = _props.relationship,
	          subscriber = _props.subscriber;
	
	
	      var name = _react2.default.createElement(
	        _Text2.default,
	        { truncate: true },
	        subscriber.getName()
	      );
	
	      var status = void 0;
	      if (relationship.isPendingForChat()) {
	        status = 'Pending';
	      } else if (relationship.isUnder13()) {
	        status = 'Under 13';
	      }
	
	      if (status) {
	        name = _react2.default.createElement(
	          'div',
	          null,
	          name,
	          _react2.default.createElement(
	            _StatusLabel2.default,
	            null,
	            status
	          )
	        );
	      }
	
	      return _react2.default.createElement(_BoxHeader2.default, {
	        className: 'RelationshipViewHeader',
	        title: name,
	        aux: this.renderHeaderAux()
	      });
	    }
	  }]);
	
	  return RelationshipViewHeader;
	}(_react2.default.Component);
	
	RelationshipViewHeader.displayName = 'RelationshipViewHeader';
	exports.default = RelationshipViewHeader;

/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StartChatButton = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _ChatRouteHelper = __webpack_require__(1568);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _recentMessagesModal = __webpack_require__(1570);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StartChatButton = exports.StartChatButton = function (_Component) {
	  _inherits(StartChatButton, _Component);
	
	  function StartChatButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StartChatButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StartChatButton.__proto__ || Object.getPrototypeOf(StartChatButton)).call.apply(_ref, [this].concat(args))), _this), _this.startChat = function () {
	      var _this$context = _this.context,
	          group = _this$context.group,
	          router = _this$context.router;
	
	
	      var subscriber = _this.props.subscriber;
	
	      (0, _ChatRouteHelper.pushRouterToChatWithMember)(router, _this.props.showRecent, _this.props.hideRecent, subscriber, group);
	      if (_this.props.onRequestHide) {
	        _this.props.onRequestHide();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(StartChatButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          useGlyph = _props.useGlyph,
	          children = _props.children,
	          other = _objectWithoutProperties(_props, ['useGlyph', 'children']);
	
	      if (children) {
	        return _react2.default.createElement(
	          'div',
	          { onClick: this.startChat },
	          children
	        );
	      }
	      if (useGlyph) {
	        return _react2.default.createElement(
	          _Button2.default,
	          _extends({}, other, {
	            size: 'xsmall',
	            level: 'icon',
	            tooltip: 'Send a message',
	            tooltipPlacement: 'bottom',
	            onClick: this.startChat }),
	          _react2.default.createElement(_Glyph2.default, { name: 'chat-add-bubble', size: 'xlarge', solo: true })
	        );
	      } else {
	        return _react2.default.createElement(
	          _Button2.default,
	          _extends({}, other, { size: 'xsmall', onClick: this.startChat }),
	          'Send a message'
	        );
	      }
	    }
	  }]);
	
	  return StartChatButton;
	}(_react.Component);
	
	StartChatButton.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired,
	  group: _react2.default.PropTypes.instanceOf(_Group2.default)
	};
	StartChatButton.displayName = 'StartChatButton';
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch
	// $FlowIssue
	) {
	  return (0, _redux.bindActionCreators)({
	    showRecent: _recentMessagesModal.showRecent,
	    hideRecent: _recentMessagesModal.hideRecent
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(StartChatButton);

/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getGroupForMember = getGroupForMember;
	exports.pushRouterToChatWithMember = pushRouterToChatWithMember;
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatMember = __webpack_require__(921);
	
	var _ChatMember2 = _interopRequireDefault(_ChatMember);
	
	var _ChatMembers = __webpack_require__(987);
	
	var _ChatMembers2 = _interopRequireDefault(_ChatMembers);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _PotentialChatMember = __webpack_require__(945);
	
	var _PotentialChatMember2 = _interopRequireDefault(_PotentialChatMember);
	
	var _Relationship = __webpack_require__(1007);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _RootGroup = __webpack_require__(943);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _ChatPromises = __webpack_require__(1569);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// basically an entity that has .id and .getName()\
	// NOTE: The id MUST be the id of a User!
	function getGroupForRelationship(relationship) {
	  var myGroups = _GroupStore2.default.getGroups().toArray();
	  var toMe = relationship.getSubscriptionsToMe().map(function (s) {
	    return s.getGroup();
	  });
	  var toUser = relationship.getSubscriptionsToUser().map(function (s) {
	    return s.getGroup();
	  });
	  var otherGroups = _lodash2.default.union(toMe, toUser);
	  var sharedGroups = _lodash2.default.intersection(myGroups, otherGroups);
	  return sharedGroups.length > 0 ? sharedGroups[0] : _RootGroup.rootGroup;
	}
	function getGroupForMember(otherMember, group) {
	  var isPotentialChatMember = otherMember instanceof _PotentialChatMember2.default;
	  var canJoinGivenGroup = group && (isPotentialChatMember && otherMember.isMemberOfGroup(group.id) || otherMember instanceof _Subscriber2.default);
	
	  if (canJoinGivenGroup && group && group.getCode()) {
	    return group;
	  } else if (isPotentialChatMember) {
	    var myGroups = _GroupStore2.default.getGroups();
	    var sharedGroups = myGroups.filter(function (g) {
	      return otherMember.isMemberOfGroup(g.id);
	    });
	    return sharedGroups.length > 0 ? sharedGroups[0] : _RootGroup.rootGroup;
	  }
	  return _RootGroup.rootGroup;
	}
	
	// TODO maybe make this a promise for the pathname and let the component do
	// the router pusher so we're not passing the router around
	function pushRouterToChatWithMember(router, showRootContext, hideRootContext, otherMember, group, catchHandler) {
	  var commonGroup = getGroupForMember(otherMember, group);
	
	  if (commonGroup === _RootGroup.rootGroup) {
	    (0, _ChatPromises.promiseRelationship)(otherMember).then(function (relationship) {
	      // TODO fall back to schools, organizations
	      var relatedGroup = getGroupForRelationship(relationship);
	
	      if (relatedGroup === _RootGroup.rootGroup) {
	        getChatAndShowRootContext(showRootContext, relationship);
	      } else {
	        routeWithSharedGroup(router, relatedGroup, otherMember, hideRootContext, relationship);
	      }
	    }).catch(function () {
	      var currentMember = _ChatMembers2.default.buildChatMember(_CurrentUser2.default.getUser());
	      _ChatActions2.default.loadLocal([currentMember, otherMember], otherMember.getName());
	      _ChatActions2.default.resetSelection(); // deselect current chat to focus on local
	      showRootContext();
	      if (catchHandler) {
	        catchHandler();
	      }
	    });
	  } else {
	    (0, _ChatPromises.promiseRelationship)(otherMember).then(function (relationship) {
	      routeWithSharedGroup(router, commonGroup, otherMember, hideRootContext, relationship);
	    }).catch(function () {
	      var pathname = '/classes/' + commonGroup.getCode() + '/messages/new/' + otherMember.id;
	      router.push({ pathname: pathname });
	      hideRootContext();
	      if (catchHandler) {
	        catchHandler();
	      }
	    });
	  }
	}
	
	function getChatAndShowRootContext(showRootContext, relationship) {
	  var chat = relationship.getChat();
	  if (chat) {
	    _ChatActions2.default.selectChat(chat.id);
	  } else {
	    var currentMember = _ChatMembers2.default.buildChatMember(_CurrentUser2.default.getUser());
	    var relatedMember = _ChatMembers2.default.buildChatMember(relationship.getRelatedUser());
	    _ChatActions2.default.loadLocal([currentMember, relatedMember], relatedMember.getName());
	    _ChatActions2.default.resetSelection(); // deselect current chat to focus on local
	  }
	  showRootContext();
	}
	
	function routeWithSharedGroup(router, commonGroup, otherMember, hideRootContext, relationship) {
	  var chat = relationship.getChat();
	  var pathname = chat ? '/classes/' + commonGroup.getCode() + '/messages/' + chat.id : '/classes/' + commonGroup.getCode() + '/messages/new/' + relationship.id;
	  router.push({ pathname: pathname });
	  hideRootContext();
	}

/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.promiseGroupOrRootChats = promiseGroupOrRootChats;
	exports.promiseRelationship = promiseRelationship;
	
	var _RootGroup = __webpack_require__(943);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _Chats = __webpack_require__(942);
	
	var _Chats2 = _interopRequireDefault(_Chats);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _PotentialChatMember = __webpack_require__(945);
	
	var _PotentialChatMember2 = _interopRequireDefault(_PotentialChatMember);
	
	var _ChatMember = __webpack_require__(921);
	
	var _ChatMember2 = _interopRequireDefault(_ChatMember);
	
	var _RelationshipActions = __webpack_require__(1006);
	
	var _RelationshipActions2 = _interopRequireDefault(_RelationshipActions);
	
	var _RelationshipStore = __webpack_require__(1310);
	
	var _RelationshipStore2 = _interopRequireDefault(_RelationshipStore);
	
	var _RelatedUserSummary = __webpack_require__(909);
	
	var _RelatedUserSummary2 = _interopRequireDefault(_RelatedUserSummary);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function promiseGroupChats(group) {
	  // If all chats are loaded for all groups, resolve immediately
	  if (_ChatStore2.default.areAllChatsLoaded()) {
	    return Promise.resolve(_ChatStore2.default.getChats(group));
	  }
	
	  // If the first page of chats have been loaded for the requested group
	  // resolve with all the chats we have for this group
	  if (_ChatStore2.default.haveChatsBeenLoadedForGroup(group)) {
	    return Promise.resolve(_ChatStore2.default.getChats(group));
	  } else {
	    var existingChats = _ChatStore2.default.getChats(group);
	    if (existingChats.length) {
	      // refresh
	      _ChatActions2.default.loadChats(group);
	      // but return what we've already got
	      return Promise.resolve(existingChats);
	    }
	    // Otherwise fetch chats for this group
	    return _ChatActions2.default.promiseLoadChats(group);
	  }
	}
	// XXX until we can express route dependencies through Flux instead of promises
	function promiseGroupOrRootChats() {
	  var groupCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	  var group = groupCode ? _GroupStore2.default.getGroupForCode(groupCode) : _RootGroup.rootGroup;
	
	  if (!group) {
	    return Promise.resolve();
	  }
	
	  return promiseGroupChats(group);
	}
	
	function promiseRelationship(withUser) {
	  var id = withUser instanceof Object ? withUser.id : withUser;
	  return Promise.resolve(_RelationshipStore2.default.getRelationship(id) || _RelationshipActions2.default.loadRelationship(id));
	}

/***/ },
/* 1570 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.showRecent = showRecent;
	exports.hideRecent = hideRecent;
	var initialState = exports.initialState = {
	  showingRecent: false
	};
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'recentMessagesModal/SHOW_RECENT_MESSAGES':
	      return _extends({}, state, { showingRecent: true });
	    case 'recentMessagesModal/HIDE_RECENT_MESSAGES':
	      return _extends({}, state, { showingRecent: false });
	    default:
	      return state;
	  }
	}
	
	function showRecent() {
	  return {
	    type: 'recentMessagesModal/SHOW_RECENT_MESSAGES'
	  };
	}
	
	function hideRecent() {
	  return {
	    type: 'recentMessagesModal/HIDE_RECENT_MESSAGES'
	  };
	}

/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1572);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatusLabel = function (_React$Component) {
	  _inherits(StatusLabel, _React$Component);
	
	  function StatusLabel() {
	    _classCallCheck(this, StatusLabel);
	
	    return _possibleConstructorReturn(this, (StatusLabel.__proto__ || Object.getPrototypeOf(StatusLabel)).apply(this, arguments));
	  }
	
	  _createClass(StatusLabel, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Text2.default,
	        _extends({}, this.props, {
	          className: (0, _classnames2.default)('StatusLabel', this.props.className),
	          color: 'thunder' }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return StatusLabel;
	}(_react2.default.Component);
	
	StatusLabel.displayName = 'StatusLabel';
	exports.default = StatusLabel;

/***/ },
/* 1572 */
1136,
/* 1573 */,
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _UserActionsMenuButton = __webpack_require__(1575);
	
	var _UserActionsMenuButton2 = _interopRequireDefault(_UserActionsMenuButton);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var GroupMembersTabUserActions = function (_React$Component) {
	  _inherits(GroupMembersTabUserActions, _React$Component);
	
	  function GroupMembersTabUserActions() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupMembersTabUserActions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupMembersTabUserActions.__proto__ || Object.getPrototypeOf(GroupMembersTabUserActions)).call.apply(_ref, [this].concat(args))), _this), _this.showCopyToClass = function () {
	      var _this$props = _this.props,
	          groupMembership = _this$props.groupMembership,
	          subscriber = _this$props.subscriber;
	
	      var sub = subscriber || groupMembership && groupMembership.getSubscriber();
	
	      return sub && sub.getCanBeCopiedToClass();
	    }, _this.showMakeOwner = function () {
	      var groupMembership = _this.props.groupMembership;
	
	      return groupMembership && groupMembership.getCanBecomeOwner();
	    }, _this.showBlockMember = function () {
	      var groupMembership = _this.props.groupMembership;
	
	      return !!groupMembership;
	    }, _this.showRemoveFromSchool = function () {
	      var groupMembership = _this.props.groupMembership;
	
	      var hasAdminConsole = _CurrentUser2.default.getUser().hasFeature('web_admin_console');
	      if (_this.isRootGroup()) {
	        return false;
	      } else if (hasAdminConsole) {
	        return false;
	      } else if (groupMembership && groupMembership.hasPermission('can_remove_from_org')) {
	        return true;
	      }
	      return false;
	    }, _this.isRootGroup = function () {
	      var groupToAdmin = _this.props.groupToAdmin;
	
	      return groupToAdmin && groupToAdmin.isRoot();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupMembersTabUserActions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          groupMembership = _props.groupMembership,
	          subscriber = _props.subscriber,
	          groupToAdmin = _props.groupToAdmin;
	
	      var sub = subscriber || groupMembership && groupMembership.getSubscriber();
	      var isRootGroup = this.isRootGroup();
	
	      return _react2.default.createElement(_UserActionsMenuButton2.default, {
	        className: this.props.className,
	        buttonSize: 'small',
	        onClick: this.props.onClick,
	        level: this.props.level,
	        tooltip: this.props.tooltip,
	        tooltipPlacement: this.props.tooltipPlacement,
	        subscriber: sub,
	        groupMembership: groupMembership,
	        groupToAdmin: groupToAdmin,
	        showViewProfile: this.props.showViewProfile,
	        showChangeRole: false,
	        showCopyToClass: this.showCopyToClass(),
	        showMakeOwner: !isRootGroup && this.showMakeOwner(),
	        showRemoveMember: !isRootGroup && groupMembership && groupMembership.hasPermission('can_remove_from_group'),
	        showBlockMember: this.showBlockMember(),
	        showGetTranscript: groupMembership && groupMembership.hasPermission('can_admin'),
	        showRemoveFromSchool: this.showRemoveFromSchool(),
	        showReportAsUser: isRootGroup || !groupMembership || !groupMembership.hasPermission('can_admin'),
	        showReportAsAdmin: !isRootGroup && groupMembership && groupMembership.hasPermission('can_admin')
	      });
	    }
	  }]);
	
	  return GroupMembersTabUserActions;
	}(_react2.default.Component);
	
	GroupMembersTabUserActions.displayName = 'GroupMembersTabUserActions';
	exports.default = GroupMembersTabUserActions;

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _AddGroupOwnerModalConfirm = __webpack_require__(1576);
	
	var _AddGroupOwnerModalConfirm2 = _interopRequireDefault(_AddGroupOwnerModalConfirm);
	
	var _BatchRoleCorrectionModal = __webpack_require__(1577);
	
	var _BatchRoleCorrectionModal2 = _interopRequireDefault(_BatchRoleCorrectionModal);
	
	var _BlockMemberMenuItem = __webpack_require__(1594);
	
	var _BlockMemberMenuItem2 = _interopRequireDefault(_BlockMemberMenuItem);
	
	var _GetTranscriptMenuItem = __webpack_require__(1596);
	
	var _GetTranscriptMenuItem2 = _interopRequireDefault(_GetTranscriptMenuItem);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuButton = __webpack_require__(1604);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	var _ModalMenuItem = __webpack_require__(1595);
	
	var _ModalMenuItem2 = _interopRequireDefault(_ModalMenuItem);
	
	var _RelationshipModal = __webpack_require__(1309);
	
	var _RelationshipModal2 = _interopRequireDefault(_RelationshipModal);
	
	var _RemoveFromOrgModal = __webpack_require__(1605);
	
	var _RemoveFromOrgModal2 = _interopRequireDefault(_RemoveFromOrgModal);
	
	var _RemoveMemberMenuItem = __webpack_require__(1606);
	
	var _RemoveMemberMenuItem2 = _interopRequireDefault(_RemoveMemberMenuItem);
	
	var _ReportOrgUserModal = __webpack_require__(1607);
	
	var _ReportOrgUserModal2 = _interopRequireDefault(_ReportOrgUserModal);
	
	var _ReportUserMenuItem = __webpack_require__(1614);
	
	var _ReportUserMenuItem2 = _interopRequireDefault(_ReportUserMenuItem);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _SubscribeUserMenuItem = __webpack_require__(1615);
	
	var _SubscribeUserMenuItem2 = _interopRequireDefault(_SubscribeUserMenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var UserActionsMenuButton = function (_React$Component) {
	  _inherits(UserActionsMenuButton, _React$Component);
	
	  function UserActionsMenuButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserActionsMenuButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserActionsMenuButton.__proto__ || Object.getPrototypeOf(UserActionsMenuButton)).call.apply(_ref, [this].concat(args))), _this), _this.renderMakeOwnerDialog = function () {
	      var _this$props = _this.props,
	          groupMembership = _this$props.groupMembership,
	          groupToAdmin = _this$props.groupToAdmin;
	
	      (0, _invariant2.default)(groupMembership, 'renderMakeOwnerDialog called without a group membership');
	      return _react2.default.createElement(_AddGroupOwnerModalConfirm2.default, {
	        group: groupToAdmin,
	        checkedIds: [groupMembership.getUser().id],
	        userName: groupMembership.getUser().getName()
	      });
	    }, _this.renderChangeRoleModal = function () {
	      var _this$props2 = _this.props,
	          groupMembership = _this$props2.groupMembership,
	          groupToAdmin = _this$props2.groupToAdmin;
	
	      (0, _invariant2.default)(groupMembership, 'renderChangeRoleModal called without a group membership');
	      return _react2.default.createElement(_BatchRoleCorrectionModal2.default, {
	        group: groupToAdmin,
	        groupMemberships: [groupMembership],
	        onClose: function onClose() {/* TODO */}
	      });
	    }, _this.renderMenu = function () {
	      var _this$props3 = _this.props,
	          groupMembership = _this$props3.groupMembership,
	          groupToAdmin = _this$props3.groupToAdmin,
	          subscriber = _this$props3.subscriber,
	          isAdminView = _this$props3.isAdminView;
	
	
	      return _react2.default.createElement(
	        _Menu2.default,
	        null,
	        _this.props.showChangeRole && _react2.default.createElement(
	          _ModalMenuItem2.default,
	          { modal: _this.renderChangeRoleModal() },
	          _react2.default.createElement(_Glyph2.default, { name: 'spreadsheet' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Change role'
	          )
	        ),
	        _this.props.showViewProfile && _react2.default.createElement(
	          _ModalMenuItem2.default,
	          { modal: _this.renderRelationshipDialog() },
	          _react2.default.createElement(_Glyph2.default, { name: 'avatar' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'View profile'
	          )
	        ),
	        _this.props.showCopyToClass && _react2.default.createElement(_SubscribeUserMenuItem2.default, { subscriber: subscriber }),
	        _this.props.showMakeOwner && _react2.default.createElement(
	          _ModalMenuItem2.default,
	          { modal: _this.renderMakeOwnerDialog() },
	          _react2.default.createElement(_Glyph2.default, { name: 'crown-stroke' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Make owner of class'
	          )
	        ),
	        _this.props.showRemoveMember && _react2.default.createElement(_RemoveMemberMenuItem2.default, {
	          group: groupToAdmin,
	          member: groupMembership
	        }),
	        _this.props.showBlockMember && groupMembership && _react2.default.createElement(_BlockMemberMenuItem2.default, {
	          blocked: groupMembership.isBlocked(),
	          memberId: groupMembership.getUserId(),
	          memberName: groupMembership.getName()
	        }),
	        _this.props.showGetTranscript && groupMembership && _react2.default.createElement(_GetTranscriptMenuItem2.default, {
	          groupMembership: groupMembership,
	          groupToAdmin: groupToAdmin,
	          isAdminView: isAdminView
	        }),
	        _this.props.showRemoveFromSchool && _react2.default.createElement(
	          _ModalMenuItem2.default,
	          { modal: _this.renderRemoveFromOrgModal() },
	          _react2.default.createElement(_Glyph2.default, { name: 'close' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Remove from school'
	          )
	        ),
	        _this.props.showReportAsUser && _react2.default.createElement(_ReportUserMenuItem2.default, { reportee: subscriber }),
	        _this.props.showReportAsAdmin && _react2.default.createElement(
	          _ModalMenuItem2.default,
	          { modal: _this.renderReportOrgUserModal() },
	          _react2.default.createElement(_Glyph2.default, { name: 'flag' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Report to Remind'
	          )
	        )
	      );
	    }, _this.renderRelationshipDialog = function () {
	      var _this$props4 = _this.props,
	          groupToAdmin = _this$props4.groupToAdmin,
	          groupMembership = _this$props4.groupMembership;
	
	      (0, _invariant2.default)(groupMembership, 'renderMakeOwnerDialog called without a group membership');
	      return _react2.default.createElement(_RelationshipModal2.default, {
	        groupToAdmin: groupToAdmin,
	        groupMember: groupMembership,
	        userId: groupMembership.getUserId()
	      });
	    }, _this.renderRemoveFromOrgModal = function () {
	      var _this$props5 = _this.props,
	          groupToAdmin = _this$props5.groupToAdmin,
	          groupMembership = _this$props5.groupMembership,
	          isAdminView = _this$props5.isAdminView;
	
	      (0, _invariant2.default)(groupToAdmin, 'renderRemoveFromOrgModal when no group');
	      (0, _invariant2.default)(groupMembership, 'renderRemoveFromOrgModal called without a group membership');
	      var org = groupToAdmin.getOrganization();
	      (0, _invariant2.default)(org, 'renderRemoveFromOrgModal failed to get org');
	      return _react2.default.createElement(_RemoveFromOrgModal2.default, {
	        isAdminView: isAdminView,
	        userName: groupMembership.getSubscriber().getName(),
	        userIds: [groupMembership.getUserId()],
	        orgName: org.getName(),
	        orgId: org.id,
	        reportModal: _this.renderReportOrgUserModal
	      });
	    }, _this.renderReportOrgUserModal = function () {
	      var _this$props6 = _this.props,
	          groupToAdmin = _this$props6.groupToAdmin,
	          groupMembership = _this$props6.groupMembership;
	
	      (0, _invariant2.default)(groupToAdmin, 'renderReportOrgUserModal when no group');
	      (0, _invariant2.default)(groupMembership, 'renderReportOrgUserModal called without a group membership');
	      var org = groupToAdmin.getOrganization();
	      (0, _invariant2.default)(org, 'renderReportOrgUserModal failed to get org');
	
	      return _react2.default.createElement(_ReportOrgUserModal2.default, {
	        userName: groupMembership.getSubscriber().getName(),
	        userId: groupMembership.getUserId(),
	        orgName: org.getName(),
	        orgId: org.id,
	        removeModal: _this.renderRemoveFromOrgModal
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UserActionsMenuButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _MenuButton2.default,
	        {
	          alignment: 'right',
	          disabled: this.props.disabled,
	          className: this.props.className,
	          menu: this.renderMenu(),
	          size: 'xsmall',
	          onClick: this.props.handleClick,
	          level: this.props.level,
	          tooltip: this.props.tooltip,
	          tooltipPlacement: this.props.tooltipPlacement },
	        _react2.default.createElement(_Glyph2.default, { name: 'ellipses', solo: true, size: this.props.buttonSize || 'xlarge' })
	      );
	    }
	  }]);
	
	  return UserActionsMenuButton;
	}(_react2.default.Component);
	
	UserActionsMenuButton.defaultProps = {
	  level: 'secondary'
	};
	UserActionsMenuButton.displayName = 'UserActionsMenuButton';
	exports.default = UserActionsMenuButton;

/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddGroupOwnerModalConfirm = function (_React$Component) {
	  _inherits(AddGroupOwnerModalConfirm, _React$Component);
	
	  function AddGroupOwnerModalConfirm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddGroupOwnerModalConfirm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddGroupOwnerModalConfirm.__proto__ || Object.getPrototypeOf(AddGroupOwnerModalConfirm)).call.apply(_ref, [this].concat(args))), _this), _this.addOwners = function () {
	      var successMessage = 'Class ' + (_this.props.checkedIds.length > 1 ? 'owners' : 'owner') + ' added';
	
	      if (_this.props.onFinish) {
	        _this.props.onFinish();
	      }
	
	      _GroupActions2.default.promoteGroupMemberships(_this.props.group, _this.props.checkedIds).then(function () {
	        return _ToastActions2.default.showSuccessToast(successMessage);
	      }, function () {
	        return _ToastActions2.default.showDefaultErrorToast();
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddGroupOwnerModalConfirm, [{
	    key: 'render',
	    value: function render() {
	      var ownersCount = this.props.checkedIds.length;
	      var confirmTitle = void 0;
	      if (ownersCount > 1) {
	        confirmTitle = 'Are you sure you want to add ' + ownersCount + ' class owners?';
	      } else if (this.props.userName) {
	        confirmTitle = 'Are you sure you want to add ' + this.props.userName + ' as class owner?';
	      } else {
	        confirmTitle = 'Are you sure you want to add a class owner?';
	      }
	
	      return _react2.default.createElement(_ConfirmDialog2.default, _extends({
	        eventScreenName: 'AddGroupOwnerModalConfirm'
	      }, this.props, {
	        title: confirmTitle,
	        subtext: 'All class owners have the same controls. Once added, an owner can’t be removed.',
	        actionButtonText: 'Add',
	        cancelButtonText: 'Cancel',
	        onConfirm: this.addOwners
	      }));
	    }
	  }]);
	
	  return AddGroupOwnerModalConfirm;
	}(_react2.default.Component);
	
	AddGroupOwnerModalConfirm.displayName = 'AddGroupOwnerModalConfirm';
	exports.default = AddGroupOwnerModalConfirm;

/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _OrgRoleDropdown = __webpack_require__(1578);
	
	var _OrgRoleDropdown2 = _interopRequireDefault(_OrgRoleDropdown);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	__webpack_require__(1592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var BatchRoleCorrectionModal = function (_React$Component) {
	  _inherits(BatchRoleCorrectionModal, _React$Component);
	
	  function BatchRoleCorrectionModal() {
	    _classCallCheck(this, BatchRoleCorrectionModal);
	
	    return _possibleConstructorReturn(this, (BatchRoleCorrectionModal.__proto__ || Object.getPrototypeOf(BatchRoleCorrectionModal)).apply(this, arguments));
	  }
	
	  _createClass(BatchRoleCorrectionModal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.onClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'renderMemberRow',
	    value: function renderMemberRow(member) {
	      var user = member.getUser();
	      var orgAffView = member.getOrgAffiliationView();
	      (0, _invariant2.default)(orgAffView, 'member missing org_affiliation_view');
	
	      return _react2.default.createElement(
	        'tr',
	        { key: member.id },
	        _react2.default.createElement(
	          'td',
	          { className: 'BatchRoleCorrectionModal-table-nameRow' },
	          _react2.default.createElement(_Avatar2.default, {
	            size: 'medium',
	            text: user.getInitials(),
	            colorHex: user.getColor()
	          }),
	          _react2.default.createElement(
	            _Text2.default,
	            { truncate: true, className: 'BatchRoleCorrectionModal-table-nameRow-name' },
	            user.getFullName()
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'BatchRoleCorrectionModal-table-organizationDropdown' },
	            _react2.default.createElement(_OrgRoleDropdown2.default, {
	              userId: user.id,
	              name: user.getFullName(),
	              group: this.props.group,
	              roles: orgAffView.roles,
	              potentialRoles: orgAffView.potential_roles,
	              onSave: this.props.onUserRoleSave,
	              canHaveRoleChanged: orgAffView.can_have_role_changed
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onRequestHide = _props.onRequestHide,
	          groupMemberships = _props.groupMemberships,
	          loading = _props.loading;
	
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        { onRequestHide: onRequestHide, eventScreenName: 'BatchRoleCorrectionModal', className: 'BatchRoleCorrectionModal' },
	        _react2.default.createElement(
	          'div',
	          { className: 'BatchRoleCorrectionModal-body' },
	          _react2.default.createElement(_TitleHeader2.default, { title: 'Modify Roles' }),
	          _react2.default.createElement(
	            'table',
	            { className: 'BatchRoleCorrectionModal-table' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Name'
	                ),
	                _react2.default.createElement(
	                  'th',
	                  null,
	                  'Role'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              groupMemberships.map(function (m) {
	                return _this2.renderMemberRow(m);
	              })
	            )
	          ),
	          loading && _react2.default.createElement(
	            'div',
	            { className: 'BatchRoleCorrectionModal-loadingIndicator' },
	            _react2.default.createElement(_LoadingIndicator2.default, { size: 'small' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return BatchRoleCorrectionModal;
	}(_react2.default.Component);
	
	BatchRoleCorrectionModal.displayName = 'BatchRoleCorrectionModal';
	exports.default = BatchRoleCorrectionModal;

/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CircleSpinner = __webpack_require__(1579);
	
	var _CircleSpinner2 = _interopRequireDefault(_CircleSpinner);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _OrgRoleDropdownMenu = __webpack_require__(1582);
	
	var _OrgRoleDropdownMenu2 = _interopRequireDefault(_OrgRoleDropdownMenu);
	
	__webpack_require__(1590);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var NO_ROLE = 'No role';
	
	var OrgRoleDropdown = function (_React$Component) {
	  _inherits(OrgRoleDropdown, _React$Component);
	
	  function OrgRoleDropdown(props) {
	    _classCallCheck(this, OrgRoleDropdown);
	
	    var _this = _possibleConstructorReturn(this, (OrgRoleDropdown.__proto__ || Object.getPrototypeOf(OrgRoleDropdown)).call(this, props));
	
	    _this.state = {
	      open: false,
	      saving: false
	    };
	
	    _this.handleClose = function () {
	      _this.setState({ open: false });
	    };
	
	    _this.onDropdownHide = function (roles) {
	      _this.setState({ open: false, saving: !_lodash2.default.isEqual(_this.roles, roles) });
	      _this.roles = roles;
	    };
	
	    _this.onSave = function () {
	      _this.setState({ saving: false });
	
	      if (_this.props.onSave) {
	        _this.props.onSave(_this.props.userId);
	      }
	    };
	
	    _this.roles = props.roles;
	    return _this;
	  }
	
	  _createClass(OrgRoleDropdown, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!_lodash2.default.isEqual(this.props.roles, nextProps.roles)) {
	        this.roles = nextProps.roles;
	      }
	    }
	  }, {
	    key: 'getFormattedRoles',
	    value: function getFormattedRoles() {
	      return this.roles.join(', ');
	    }
	  }, {
	    key: 'renderRoleMenu',
	    value: function renderRoleMenu() {
	      var _this2 = this;
	
	      var rolesString = this.getFormattedRoles();
	      var roleDropdown = _react2.default.createElement(_OrgRoleDropdownMenu2.default, {
	        organization: this.props.group.getOrganization(),
	        roles: this.roles,
	        potentialRoles: this.props.potentialRoles,
	        userId: this.props.userId,
	        onClose: this.onDropdownHide,
	        onSave: this.onSave
	      });
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          layer: roleDropdown,
	          trigger: 'click',
	          placement: 'bottom',
	          alignment: 'left' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'OrgRoleDropdown-select',
	            onClick: function onClick() {
	              return _this2.setState({ open: !_this2.state.open });
	            } },
	          _react2.default.createElement(
	            _Text2.default,
	            { color: this.state.saving ? 'eclipse' : 'inherit' },
	            rolesString.length ? _react2.default.createElement(
	              _Text2.default,
	              { truncate: true, capitalize: true },
	              rolesString
	            ) : _react2.default.createElement(
	              _Text2.default,
	              { truncate: true, className: 'OrgRoleDropdown-unassigned' },
	              NO_ROLE
	            )
	          ),
	          this.state.saving ? _react2.default.createElement(_CircleSpinner2.default, { color: 'shamrock', size: 'small' }) : _react2.default.createElement(_Glyph2.default, {
	            name: 'chevron-down',
	            color: this.state.open ? 'brand' : 'thunder',
	            size: 'xxsmall',
	            className: 'OrgRoleDropdown-select-arrow'
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderStaticRoles',
	    value: function renderStaticRoles() {
	      var rolesString = this.getFormattedRoles();
	      return _react2.default.createElement(
	        'span',
	        null,
	        rolesString ? _react2.default.createElement(
	          _Text2.default,
	          { capitalize: true, truncate: true },
	          rolesString
	        ) : _react2.default.createElement(
	          _Text2.default,
	          { truncate: true },
	          NO_ROLE
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var canChange = this.props.canHaveRoleChanged || this.props.canHaveRoleInitialized;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('OrgRoleDropdown', { 'OrgRoleDropdown--open': this.state.open }) },
	        canChange ? this.renderRoleMenu() : this.renderStaticRoles()
	      );
	    }
	  }]);
	
	  return OrgRoleDropdown;
	}(_react2.default.Component);
	
	OrgRoleDropdown.displayName = 'OrgRoleDropdown';
	exports.default = OrgRoleDropdown;

/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1580);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CircleSpinner = function (_React$Component) {
	  _inherits(CircleSpinner, _React$Component);
	
	  function CircleSpinner() {
	    _classCallCheck(this, CircleSpinner);
	
	    return _possibleConstructorReturn(this, (CircleSpinner.__proto__ || Object.getPrototypeOf(CircleSpinner)).apply(this, arguments));
	  }
	
	  _createClass(CircleSpinner, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', {
	        className: (0, _classnames2.default)('CircleSpinner', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className)
	      });
	    }
	  }]);
	
	  return CircleSpinner;
	}(_react2.default.Component);
	
	CircleSpinner.propClasses = {
	  size: {
	    medium: 'CircleSpinner-medium',
	    small: 'CircleSpinner-small'
	  },
	  color: {
	    shamrock: 'CircleSpinner-shamrock',
	    jungle: 'CircleSpinner-jungle'
	  }
	};
	CircleSpinner.defaultProps = {
	  color: 'brand',
	  size: 'medium'
	};
	CircleSpinner.displayName = 'CircleSpinner';
	exports.default = CircleSpinner;

/***/ },
/* 1580 */
1136,
/* 1581 */,
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _MediaObject = __webpack_require__(1396);
	
	var _MediaObject2 = _interopRequireDefault(_MediaObject);
	
	var _modal = __webpack_require__(1188);
	
	var _OrgRoleActions = __webpack_require__(1583);
	
	__webpack_require__(1585);
	
	var _apple = __webpack_require__(1587);
	
	var _apple2 = _interopRequireDefault(_apple);
	
	var _heart = __webpack_require__(1588);
	
	var _heart2 = _interopRequireDefault(_heart);
	
	var _pencil = __webpack_require__(1589);
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _bell = __webpack_require__(1098);
	
	var _bell2 = _interopRequireDefault(_bell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var OrgRoleDropdownMenu = function (_React$Component) {
	  _inherits(OrgRoleDropdownMenu, _React$Component);
	
	  function OrgRoleDropdownMenu(props) {
	    _classCallCheck(this, OrgRoleDropdownMenu);
	
	    var _this = _possibleConstructorReturn(this, (OrgRoleDropdownMenu.__proto__ || Object.getPrototypeOf(OrgRoleDropdownMenu)).call(this, props));
	
	    _this.handleClose = function () {
	      var _this$props = _this.props,
	          organization = _this$props.organization,
	          userId = _this$props.userId,
	          roles = _this$props.roles,
	          onClose = _this$props.onClose;
	
	      if (_lodash2.default.xor(roles, _this.getRoles()).length) {
	        var commitPatchRole = function commitPatchRole() {
	          var patchFn = _this.props.isCurrentUser ? _OrgRoleActions.patchCurrentUserRoles : _OrgRoleActions.patchRoles;
	
	          patchFn(organization.id, userId, _this.getRoles()).then(_this.props.onSave);
	
	          if (onClose) {
	            onClose(_this.getRoles());
	          }
	        };
	
	        var revertPatchRole = function revertPatchRole() {
	          _this.roles = _this.getRolesObject(_this.props.roles);
	        };
	
	        if (_CurrentUser2.default.getUserId() === userId) {
	          (0, _modal.mountModal)(_react2.default.createElement(_ConfirmDialog2.default, {
	            eventScreenName: 'OrgRoleDropdownMenu',
	            title: 'Are you sure you want to change your role?',
	            actionButtonText: 'Yes',
	            cancelButtonText: 'No',
	            onConfirm: commitPatchRole,
	            onCancel: revertPatchRole
	          }), _this);
	        } else {
	          commitPatchRole();
	        }
	      }
	      if (_this.props.onRequestHide) {
	        _this.props.onRequestHide();
	      }
	    };
	
	    _this.roles = _this.getRolesObject(props.roles);
	    return _this;
	  }
	
	  _createClass(OrgRoleDropdownMenu, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!_lodash2.default.isEqual(this.props.roles, nextProps.roles)) {
	        this.roles = this.getRolesObject(nextProps.roles);
	      }
	    }
	  }, {
	    key: 'getRolesObject',
	    value: function getRolesObject(roles) {
	      return {
	        student: roles.includes('student'),
	        parent: roles.includes('parent'),
	        teacher: roles.includes('teacher'),
	        admin: roles.includes('admin'),
	        rce: roles.includes('rce')
	      };
	    }
	  }, {
	    key: 'getRoles',
	    value: function getRoles() {
	      var _this2 = this;
	
	      return _lodash2.default.keys(this.roles).filter(function (r) {
	        return _this2.roles[r];
	      });
	    }
	  }, {
	    key: 'getFormattedRoles',
	    value: function getFormattedRoles() {
	      return this.getRoles().join(', ');
	    }
	  }, {
	    key: 'renderMenuItem',
	    value: function renderMenuItem(role, roleName, icon) {
	      var _this3 = this;
	
	      var checked = this.roles[role];
	      var disabled = role === 'admin' && this.roles.admin;
	
	      var handleClick = function handleClick() {
	        var nextRoles = _extends({}, _this3.roles);
	        nextRoles[role] = !_this3.roles[role];
	        if (role === 'student' && nextRoles.student) {
	          nextRoles.parent = false;
	          nextRoles.teacher = false;
	        } else if (nextRoles.teacher || nextRoles.parent || nextRoles.admin) {
	          nextRoles.student = false;
	        }
	
	        if (role === 'admin' && !_this3.roles.parent) {
	          nextRoles.parent = true;
	        }
	
	        _this3.roles = nextRoles;
	      };
	
	      return _react2.default.createElement(
	        _MenuItem2.default,
	        {
	          key: role,
	          className: (0, _classnames2.default)('OrgRoleDropdownMenu-item', { 'OrgRoleDropdownMenu-item-hover': !disabled }),
	          onClick: disabled ? function () {} : handleClick },
	        _react2.default.createElement(
	          'div',
	          { className: 'OrgRoleDropdownMenu-item-inner' },
	          _react2.default.createElement(
	            _MediaObject2.default,
	            { gutter: 'small', center: true },
	            _react2.default.createElement(_Image2.default, {
	              className: 'OrgRoleDropdownMenu-item-image',
	              src: icon
	            }),
	            _react2.default.createElement(
	              _Text2.default,
	              { className: 'OrgRoleDropdownMenu-item-label', color: checked ? 'pitch' : 'inherit' },
	              roleName
	            )
	          ),
	          checked && _react2.default.createElement(_Glyph2.default, { name: 'check', size: 'medium', color: 'brand' }),
	          disabled && _react2.default.createElement('div', { className: 'OrgRoleDropdownMenu-item-disabled' })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var roleToIcon = {
	        student: _pencil2.default,
	        parent: _heart2.default,
	        teacher: _apple2.default,
	        admin: _bell2.default
	      };
	
	      return _react2.default.createElement(
	        _Menu2.default,
	        _extends({}, this.props, {
	          className: 'OrgRoleDropdownMenu',
	          onRequestHide: this.handleClose }),
	        this.props.potentialRoles.map(function (_ref) {
	          var role = _ref.role,
	              display_role = _ref.display_role;
	
	          return _this4.renderMenuItem(role, display_role, roleToIcon[role]);
	        })
	      );
	    }
	  }]);
	
	  return OrgRoleDropdownMenu;
	}(_react2.default.Component);
	
	OrgRoleDropdownMenu.displayName = 'OrgRoleDropdownMenu';
	exports.default = OrgRoleDropdownMenu;

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.patchRoles = exports.patchCurrentUserRoles = undefined;
	
	var patchOrganizationMemberRoles = function () {
	  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(organizationId, userId, roles) {
	    var url, response;
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            url = '/organizations/' + organizationId + '/roles/batch';
	            _context.next = 3;
	            return (0, _apiRequest2.default)(url, 'PATCH', { user_ids: [userId], roles: roles });
	
	          case 3:
	            response = _context.sent;
	            return _context.abrupt('return', response.members[0]);
	
	          case 5:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function patchOrganizationMemberRoles(_x, _x2, _x3) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var patchCurrentUserRoles = exports.patchCurrentUserRoles = function () {
	  var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(organizationId, currentUserId, roles) {
	    var _ref3, affiliation;
	
	    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.prev = 0;
	            _context2.next = 3;
	            return patchOrganizationMemberRoles(organizationId, currentUserId, roles);
	
	          case 3:
	            _ref3 = _context2.sent;
	            affiliation = _ref3.affiliation;
	
	
	            _Dispatcher.dispatcher.dispatch({
	              type: _OrganizationConstants.ActionTypes.UPDATE_CURRENT_USER_ORGANIZATION_AFFILIATION,
	              affiliation: affiliation,
	              organizationId: organizationId
	            });
	            _context2.next = 12;
	            break;
	
	          case 8:
	            _context2.prev = 8;
	            _context2.t0 = _context2['catch'](0);
	
	            if (!(0, _isAPIError2.default)(_context2.t0)) {
	              console.error(_context2.t0);
	            }
	            _ToastActions2.default.showDefaultErrorToast();
	
	          case 12:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this, [[0, 8]]);
	  }));
	
	  return function patchCurrentUserRoles(_x4, _x5, _x6) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var patchRoles = exports.patchRoles = function () {
	  var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(organizationId, userId, roles) {
	    var _ref5, affiliation;
	
	    return regeneratorRuntime.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.prev = 0;
	            _context3.next = 3;
	            return patchOrganizationMemberRoles(organizationId, userId, roles);
	
	          case 3:
	            _ref5 = _context3.sent;
	            affiliation = _ref5.affiliation;
	
	
	            _Dispatcher.dispatcher.dispatch({
	              type: _OrganizationConstants.ActionTypes.UPDATE_ORG_AFF_VIEW,
	              orgAffView: affiliation,
	              orgId: organizationId,
	              userId: userId
	            });
	
	            _ToastActions2.default.showSuccessToast('Saved');
	            _context3.next = 13;
	            break;
	
	          case 9:
	            _context3.prev = 9;
	            _context3.t0 = _context3['catch'](0);
	
	            if (!(0, _isAPIError2.default)(_context3.t0)) {
	              console.error(_context3.t0);
	            }
	            _ToastActions2.default.showDefaultErrorToast();
	
	          case 13:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this, [[0, 9]]);
	  }));
	
	  return function patchRoles(_x7, _x8, _x9) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	exports.adminOptIn = adminOptIn;
	exports.adminOptOut = adminOptOut;
	exports.resignAdminship = resignAdminship;
	
	var _OrganizationConstants = __webpack_require__(1004);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _Affiliation = __webpack_require__(1039);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _isAPIError = __webpack_require__(1584);
	
	var _isAPIError2 = _interopRequireDefault(_isAPIError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function adminOptIn(orgId, orgName, affiliation) {
	  var userId = _CurrentUser2.default.getUserId();
	
	  var url = '/organizations/' + orgId + '/users/' + userId + '/roles/admin';
	  (0, _apiRequest2.default)(url, 'PATCH', { opted_in: true }).then(function () {
	    _OrganizationActions2.default.loadUserOrganizations();
	    // Fetch the staff class that the user has access to now they they joined the org
	    _GroupActions2.default.loadGroups();
	    if (affiliation && (0, _Affiliation.needsEmailConf)(affiliation)) {
	      _ToastActions2.default.showSuccessToast('Please confirm your email address');
	    } else {
	      _ToastActions2.default.showSuccessToast('You are now a verified administrator for ' + orgName + ' on Remind');
	    }
	  }).catch(function (e) {
	    _ToastActions2.default.showDefaultErrorToast();
	    console.warn(e);
	  });
	}
	
	function adminOptOut(orgId, orgName, affiliation) {
	  var userId = _CurrentUser2.default.getUserId();
	
	  var url = '/organizations/' + orgId + '/users/' + userId + '/roles/admin';
	  (0, _apiRequest2.default)(url, 'PATCH', { opted_in: false }).then(function () {
	    // Stop showing the organization if they weren't a member before
	    if (affiliation && !(0, _Affiliation.isMember)(affiliation)) {
	      _OrganizationActions2.default.removeOrganization(orgId);
	    } else if (affiliation) {
	      // update the affiliation to remove the pending role
	      _OrganizationActions2.default.loadUserOrganizations();
	    }
	    _ToastActions2.default.showSuccessToast('You chose not to be an administrator for ' + orgName + ' on Remind');
	  }).catch(function (e) {
	    _ToastActions2.default.showDefaultErrorToast();
	    console.warn(e);
	  });
	}
	
	function resignAdminship(orgId, userId) {
	  var url = '/organizations/' + orgId + '/users/' + userId + '/roles/admin';
	  return (0, _apiRequest2.default)(url, 'DELETE').then(function () {
	    _Dispatcher.dispatcher.dispatch({
	      type: _OrganizationConstants.ActionTypes.REMOVE_ADMIN_ROLE,
	      orgId: orgId
	    });
	  });
	}

/***/ },
/* 1584 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAPIError;
	
	// typecheck: ignore file
	
	function isAPIError(error) {
	  return !(error instanceof Error);
	}

/***/ },
/* 1585 */
1136,
/* 1586 */,
/* 1587 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4xLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAzMDAgMzAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMDAgMzAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4LjA4IDEwLjk2NikiPg0KCTxwYXRoIGZpbGw9IiMzNTM2MzUiIGQ9Ik0xMzUuMiwyOS42YzQuOCwwLDguOCwxMi42LDguOCwyNy45djEwLjZjMCwxNS40LTQsMjcuOS04LjgsMjcuOWMtNC44LDAtOC44LTEyLjYtOC44LTI3LjlWNTcuNQ0KCQlDMTI2LjUsNDIsMTMwLjQsMjkuNiwxMzUuMiwyOS42Ii8+DQoJPGcgdHJhbnNmb3JtPSJtYXRyaXgoLjk4NzY5LS4xNTY0My4xNTY0My45ODc2OSA0Ljc1OSAyLjE0MikiPg0KCQk8cGF0aCBmaWxsPSIjM0RCNjZCIiBkPSJNMTExLjQsNzYuOWMtMTMuMiwxMy4xLTM5LjUsOC42LTU4LjUtMTAuMUMyMC43LDM0LjksMjkuNS00LjEsMjkuNS00LjFzMzguNS05LjQsNzEuNywyMy4zDQoJCQlDMTIwLDM3LjksMTI0LjYsNjMuNiwxMTEuNCw3Ni45Ii8+DQoJCTxwYXRoIGZpbGw9IiMzOEE0NjIiIGQ9Ik0xMTEuNCw3Ni45Yy0xMy4yLDEzLjEtMzkuNSw4LjYtNTguNS0xMC4xQzIwLjcsMzQuOSwyOS41LTQuMSwyOS41LTQuMSIvPg0KCTwvZz4NCgk8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDE3LjMxMSkiPg0KCQk8cGF0aCBmaWxsPSIjN0ZCODUwIiBkPSJNMTAxLDY4Yy0zLjgtMC41LTcuNi0wLjctMTEuNC0wLjdjLTQwLjIsMC44LTczLjIsMzMuNC03NC43LDczLjdjLTEuNyw0My42LDQyLjEsMTI1LjEsODUuMywxMjUuMWwzMS43LTMNCgkJCVY3MEMxMjEuNSw3MCwxMTEuMyw2OS4zLDEwMSw2OCIvPg0KCQk8Zz4NCgkJCTxwYXRoIGZpbGw9IiM5MEM5NUIiIGQ9Ik0xNjIuOCw2OGMzLjgtMC41LDcuNi0wLjcsMTEuNC0wLjdjNDAuMiwwLjgsNzMuMiwzMy40LDc0LjcsNzMuN2MxLjcsNDMuNi00Mi4xLDEyNS4xLTg1LjMsMTI1LjENCgkJCQljMCwwLTMxLjctMy0zMS43LTMuMVY3MEMxNDIuMiw3MCwxNTIuNiw2OS4zLDE2Mi44LDY4Ii8+DQoJCQk8cGF0aCBmaWxsPSIjOTBDOTVCIiBkPSJNMTMxLjksNzBjMCwwLTM2LjIsMjYuMS0zNi4yLDk0LjdzMzYuMiw5OC4zLDM2LjIsOTguM2w0NS44LTEyNi42bC0zNi44LTU2LjciLz4NCgkJPC9nPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ },
/* 1588 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4xLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAzMDAgMzAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMDAgMzAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxwYXRoIGZpbGw9IiNEQzUwMzAiIGQ9Ik0yMjUuNCwxOS40YzI2LjcsMi43LDY0LjgsMjcuMyw2OC41LDc0Ljh2MTUuOGMtMy41LDQ1LjQtNDQuNCwxMDEuMy0xNDMuOCwxNzEuMw0KCQlDNTAuNiwyMTEuMSw5LjgsMTU1LjEsNi4yLDEwOS45Vjk0LjJDMTAsNDYuOSw0Ny45LDIyLjEsNzQuNiwxOS40YzQuNC0wLjQsOC41LTAuNiwxMi41LTAuNmMzMSwwLDQ2LDEzLjUsNjIuOSwzMy44DQoJCWMxNi45LTIwLjQsMzEuOS0zMy44LDYyLjktMzMuOEMyMTYuNywxOC42LDIyMSwxOC44LDIyNS40LDE5LjQiLz4NCgk8cGF0aCBmaWxsPSIjQkI0MzI4IiBkPSJNMTUwLDI4MS4zQzUwLjYsMjExLjEsOS44LDE1NS4xLDYuMiwxMDkuOVY5NC4yQzEwLDQ2LjksNDcuOSwyMi4xLDc0LjYsMTkuNGM0LjQtMC40LDguNS0wLjYsMTIuNS0wLjYNCgkJYzMxLDAsNDYsMTMuNSw2Mi45LDMzLjhWMjgxLjMiLz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ },
/* 1589 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4xLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAzMDAgMzAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMDAgMzAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxwYXRoIGZpbGw9IiNENjgwN0QiIGQ9Ik0yMTMuMiwyNS42bDYxLjIsNjEuMmMxMi4xLDEyLjEsMTIuMSwzMS44LDAsNDMuOUwyMzksMTY2LjNjLTEyLjEsMTIuMS0zMS44LDEyLjEtNDMuOSwwbC02MS4yLTYxLjINCgkJYy0xMi4xLTEyLjEtMTIuMS0zMS44LDAtNDMuOWwzNS41LTM1LjVDMTgxLjUsMTMuNCwyMDEuMiwxMy42LDIxMy4yLDI1LjYiLz4NCgk8cGF0aCBmaWxsPSIjQzk3NTcyIiBkPSJNMjEzLjIsMjUuNmw4LjcsOC43YzEyLjEsMTIuMSwxMi4xLDMxLjgsMCw0My45bC0zNS41LDM1LjVjLTEyLjEsMTIuMS0zMS44LDEyLjEtNDMuOSwwbC04LjctOC43DQoJCWMtMTIuMS0xMi4xLTEyLjEtMzEuOCwwLTQzLjlsMzUuNS0zNS41QzE4MS41LDEzLjQsMjAxLjIsMTMuNiwyMTMuMiwyNS42Ii8+DQoJPHBhdGggZmlsbD0iI0U2QzYxRiIgZD0iTTE0Mi41LDUyLjRsMTA1LDEwNUwxMjcuNSwyNzcuNWwtMTA1LTEwNUwxNDIuNSw1Mi40eiIvPg0KCTxwYXRoIGZpbGw9IiNFRkVDRTYiIGQ9Ik0xNjIuOCwzMi4xbDEwNSwxMDVsLTIwLjQsMjAuNGwtMTA1LTEwNUwxNjIuOCwzMi4xeiIvPg0KCTxwYXRoIGZpbGw9IiNEQUQ2Q0UiIGQ9Ik0xNjIuOCwzMi4xbDUyLjUsNTIuNWwtMjAuNCwyMC40bC01Mi41LTUyLjVMMTYyLjgsMzIuMXoiLz4NCgk8cGF0aCBmaWxsPSIjREJCQzI2IiBkPSJNMTQyLjUsNTIuNGw1Mi41LDUyLjVMNzUsMjI1bC01Mi41LTUyLjVMMTQyLjUsNTIuNHoiLz4NCgk8cGF0aCBmaWxsPSIjRUZFQ0U2IiBkPSJNMTEuNCwyNzZMMjcsMjg4LjRsMTAwLjQtMTAuOWwtMTA1LTEwNUwxMS40LDI3NnoiLz4NCgk8cGF0aCBmaWxsPSIjREFENkNFIiBkPSJNMTEuMSwyNzguN2MtMC42LDYuNCwyLjMsNy44LDYuOSwzLjJsNTYuOC01Ni44bC01Mi41LTUyLjVMMTEuMSwyNzguNyIvPg0KCTxwYXRoIG9wYWNpdHk9IjAuOTgiIGZpbGw9IiMzMTMzM0EiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgICAgIiBkPSJNMTUuNiwyMzcuMWwtNC40LDQxLjZjLTAuNiw2LjQsMy45LDEwLjksMTAuMywxMC4zDQoJCWMwLDAsMjMuOC0yLjUsNDEuNi00LjRMMTUuNiwyMzcuMSIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ },
/* 1590 */
1136,
/* 1591 */,
/* 1592 */
1136,
/* 1593 */,
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _RelationshipActions = __webpack_require__(1006);
	
	var _RelationshipActions2 = _interopRequireDefault(_RelationshipActions);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _ModalMenuItem = __webpack_require__(1595);
	
	var _ModalMenuItem2 = _interopRequireDefault(_ModalMenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockMemberMenuItem = function (_Component) {
	  _inherits(BlockMemberMenuItem, _Component);
	
	  function BlockMemberMenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BlockMemberMenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BlockMemberMenuItem.__proto__ || Object.getPrototypeOf(BlockMemberMenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.blockMember = function () {
	      var _this$props = _this.props,
	          memberId = _this$props.memberId,
	          memberName = _this$props.memberName;
	
	      _RelationshipActions2.default.block(memberId, memberName);
	    }, _this.unblockMember = function () {
	      var _this$props2 = _this.props,
	          memberId = _this$props2.memberId,
	          memberName = _this$props2.memberName;
	
	      _RelationshipActions2.default.unblock(memberId, memberName);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BlockMemberMenuItem, [{
	    key: 'renderConfirmDialog',
	    value: function renderConfirmDialog() {
	      var memberName = this.props.memberName;
	
	      return _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'BlockMemberMenuItem',
	        actionButtonText: 'Block',
	        cancelButtonText: 'Cancel',
	        size: 'xsmall',
	        onConfirm: this.blockMember,
	        title: 'Block ' + memberName + '?',
	        subtext: 'You will no longer be able to direct message or add them to your classes.'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.blocked) {
	        return _react2.default.createElement(
	          _MenuItem2.default,
	          { onClick: this.unblockMember },
	          _react2.default.createElement(_Glyph2.default, { name: 'disabled' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Unblock user'
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          _ModalMenuItem2.default,
	          { modal: this.renderConfirmDialog() },
	          _react2.default.createElement(_Glyph2.default, { name: 'disabled' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Block user'
	          )
	        );
	      }
	    }
	  }]);
	
	  return BlockMemberMenuItem;
	}(_react.Component);
	
	BlockMemberMenuItem.displayName = 'BlockMemberMenuItem';
	exports.default = BlockMemberMenuItem;

/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalMenuItem = function (_React$Component) {
	  _inherits(ModalMenuItem, _React$Component);
	
	  function ModalMenuItem() {
	    _classCallCheck(this, ModalMenuItem);
	
	    return _possibleConstructorReturn(this, (ModalMenuItem.__proto__ || Object.getPrototypeOf(ModalMenuItem)).apply(this, arguments));
	  }
	
	  _createClass(ModalMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var menuItem = _react2.default.createElement(
	        _MenuItem2.default,
	        this.props,
	        this.props.children
	      );
	
	      if (!this.props.disabled) {
	        menuItem = _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: this.props.modal },
	          menuItem
	        );
	      }
	
	      return menuItem;
	    }
	  }]);
	
	  return ModalMenuItem;
	}(_react2.default.Component);
	
	ModalMenuItem.defaultProps = {
	  disabled: false
	};
	ModalMenuItem.displayName = 'ModalMenuItem';
	exports.default = ModalMenuItem;

/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _ModalMenuItem = __webpack_require__(1595);
	
	var _ModalMenuItem2 = _interopRequireDefault(_ModalMenuItem);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RequestTranscriptModal = __webpack_require__(1597);
	
	var _RequestTranscriptModal2 = _interopRequireDefault(_RequestTranscriptModal);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var GetTranscriptMenuItem = function (_React$Component) {
	  _inherits(GetTranscriptMenuItem, _React$Component);
	
	  function GetTranscriptMenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GetTranscriptMenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GetTranscriptMenuItem.__proto__ || Object.getPrototypeOf(GetTranscriptMenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.requestTranscriptModal = function () {
	      var _this$props = _this.props,
	          groupMembership = _this$props.groupMembership,
	          groupToAdmin = _this$props.groupToAdmin,
	          isAdminView = _this$props.isAdminView;
	
	      var org = groupToAdmin.getOrganization();
	
	      var users = [{
	        id: groupMembership.getUserId(),
	        fullName: groupMembership.getUser().getFullName(),
	        firstName: groupMembership.getUser().getFirstName(),
	        canGetMessageHistory: groupMembership.hasPermission('can_get_message_history'),
	        canRequestMessageHistory: groupMembership.hasPermission('can_request_message_history')
	      }];
	
	      return _react2.default.createElement(_RequestTranscriptModal2.default, {
	        users: users,
	        organizationId: org.id,
	        organizationName: org.getName(),
	        forceRequestMessageHistory: !isAdminView
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GetTranscriptMenuItem, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ModalMenuItem2.default,
	        { modal: this.requestTranscriptModal() },
	        _react2.default.createElement(_Glyph2.default, { name: 'email-transcript' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          this.props.isAdminView ? 'Get message history' : 'Request message history'
	        )
	      );
	    }
	  }]);
	
	  return GetTranscriptMenuItem;
	}(_react2.default.Component);
	
	GetTranscriptMenuItem.displayName = 'GetTranscriptMenuItem';
	exports.default = GetTranscriptMenuItem;

/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Buttons = __webpack_require__(1315);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _Checkbox = __webpack_require__(1388);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Copy = __webpack_require__(1461);
	
	var _Copy2 = _interopRequireDefault(_Copy);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _Row = __webpack_require__(1482);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Textarea = __webpack_require__(1598);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(1602);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var RequestTranscriptModal = function (_React$Component) {
	  _inherits(RequestTranscriptModal, _React$Component);
	
	  function RequestTranscriptModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RequestTranscriptModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RequestTranscriptModal.__proto__ || Object.getPrototypeOf(RequestTranscriptModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      note: '',
	      inclChat: true,
	      inclAnnouncements: true
	    }, _this.onAnnouncementCheckChange = function () {
	      _this.setState({ inclAnnouncements: !_this.state.inclAnnouncements });
	    }, _this.onChatCheckChange = function () {
	      _this.setState({ inclChat: !_this.state.inclChat });
	    }, _this.onNoteChange = function (event) {
	      _this.setState({ note: event.target.value });
	    }, _this.getNoteText = function (name) {
	      return 'Hi' + (name ? ' ' + name : '') + ', I\u2019d like to take a quick look at how you\u2019re using Remind. Feel free to reach out to me if you have any questions.';
	    }, _this.canGetAllMessageHistory = function () {
	      return !_this.props.forceRequestMessageHistory && _this.props.users.every(function (u) {
	        return u.canGetMessageHistory;
	      });
	    }, _this.getEmailLink = function () {
	      var users = _this.props.users;
	
	
	      var email = 'schooladmin@remindhq.com';
	      var subject = 'Urgent request for message history';
	
	      var body = ['I’d like to request the message history of a person at my school as part of an active investigation.\n', 'User Ids: ' + users.map(function (u) {
	        return u.id;
	      }).join(', ') + '\n', 'School: ' + _this.props.organizationName, 'Description of investigation:\n', 'Please contact me as soon as possible,', _CurrentUser2.default.getUser().getSignature()].join('\n');
	
	      return 'mailto:' + email + '?subject=' + subject + '&body=' + encodeURIComponent(body);
	    }, _this.getUsersDescription = function () {
	      var users = _this.props.users;
	
	
	      if (users.length === 1) {
	        return users[0].fullName || '1 person';
	      }
	
	      return _this.props.users.length + ' people';
	    }, _this.invalid = function () {
	      return !(_this.state.inclChat || _this.state.inclAnnouncements);
	    }, _this.requestTranscript = function () {
	      var _this$props = _this.props,
	          onRequestHide = _this$props.onRequestHide,
	          organizationId = _this$props.organizationId,
	          users = _this$props.users;
	
	      (0, _invariant2.default)(onRequestHide, 'onRequestHide required in a modal');
	
	      var onSuccess = function onSuccess() {
	        _ToastActions2.default.showSuccessToast('Message history for ' + _this.getUsersDescription() + ' requested');
	        onRequestHide();
	      };
	
	      var onError = function onError() {
	        _ToastActions2.default.showErrorToast('Something went wrong. Please try again.');
	      };
	
	      var transcripts = users.map(function (user) {
	        return { user_id: user.id, request_from_affected_user: _this.props.forceRequestMessageHistory || !user.canGetMessageHistory };
	      });
	
	      _OrganizationActions2.default.batchRequestTranscript(organizationId, transcripts, _this.state.note, _this.state.inclChat, _this.state.inclAnnouncements).then(onSuccess, onError);
	    }, _this.renderBody = function () {
	      var onRequestHide = _this.props.onRequestHide;
	
	      var canGetAllMessageHistory = _this.canGetAllMessageHistory();
	      (0, _invariant2.default)(onRequestHide, 'onRequestHide required in a modal');
	
	      return _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: true },
	        _react2.default.createElement(
	          _Row2.default,
	          null,
	          _react2.default.createElement(
	            _Copy2.default,
	            { color: 'thunder' },
	            _react2.default.createElement(
	              'p',
	              null,
	              canGetAllMessageHistory ? 'You’ll receive an email once you have access to the selected message history. You can also join their classes to view announcements.' : 'This request will be sent to this person, and you’ll receive an email once you have access to the selected message history. You can also join the person’s class to view announcements.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'If this request is part of an active investigation, please',
	              ' ',
	              _react2.default.createElement(
	                _Link2.default,
	                { href: _this.getEmailLink() },
	                'contact our Support team'
	              ),
	              '. We\u2019ll respond within one business day.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Field2.default,
	          null,
	          _react2.default.createElement(
	            _Label2.default,
	            null,
	            'What would you like to view?'
	          ),
	          _react2.default.createElement(_Checkbox2.default, {
	            onChange: _this.onAnnouncementCheckChange,
	            checked: _this.state.inclAnnouncements,
	            label: 'All class announcements'
	          }),
	          _react2.default.createElement(_Checkbox2.default, {
	            onChange: _this.onChatCheckChange,
	            checked: _this.state.inclChat,
	            label: 'All individual and group messages'
	          })
	        ),
	        !canGetAllMessageHistory && _react2.default.createElement(
	          _Field2.default,
	          null,
	          _react2.default.createElement(
	            _Label2.default,
	            null,
	            'Your message'
	          ),
	          _react2.default.createElement(_Textarea2.default, { value: _this.state.note, onChange: _this.onNoteChange })
	        ),
	        _react2.default.createElement(
	          _Buttons2.default,
	          { axis: 'y' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'RequestTranscriptModal-confirm',
	              eventElementName: 'RequestTranscriptModal-confirm',
	              'data-test': 'confirm-button',
	              full: true,
	              onClick: _this.requestTranscript,
	              disabled: _this.invalid() },
	            (canGetAllMessageHistory ? 'Get' : 'Request') + ' message history'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              color: 'brand',
	              level: 'text',
	              onClick: onRequestHide },
	            'Cancel'
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RequestTranscriptModal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var note = this.props.users.length === 1 ? this.getNoteText(this.props.users[0].firstName) : this.getNoteText();
	
	      this.setState({ note: note });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var onRequestHide = this.props.onRequestHide;
	
	      var canGetAllMessageHistory = this.canGetAllMessageHistory();
	      (0, _invariant2.default)(onRequestHide, 'onRequestHide required in a modal');
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        {
	          eventScreenName: 'RequestTranscriptModal',
	          size: 'small',
	          onRequestHide: onRequestHide,
	          title: (canGetAllMessageHistory ? 'Get' : 'Request') + ' message history from ' + this.getUsersDescription() },
	        this.renderBody()
	      );
	    }
	  }]);
	
	  return RequestTranscriptModal;
	}(_react2.default.Component);
	
	RequestTranscriptModal.displayName = 'RequestTranscriptModal';
	exports.default = RequestTranscriptModal;

/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _focusNode = __webpack_require__(1210);
	
	var _focusNode2 = _interopRequireDefault(_focusNode);
	
	var _KeyConstants = __webpack_require__(1164);
	
	var _KeyConstants2 = _interopRequireDefault(_KeyConstants);
	
	var _pickTextareaElementProps = __webpack_require__(1599);
	
	var _pickTextareaElementProps2 = _interopRequireDefault(_pickTextareaElementProps);
	
	__webpack_require__(1600);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var BORDER_HEIGHT = 2;
	
	var Textarea = function (_React$Component) {
	  _inherits(Textarea, _React$Component);
	
	  function Textarea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Textarea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call.apply(_ref, [this].concat(args))), _this), _this.getInputNode = function () {
	      return _reactDom2.default.findDOMNode(_this.refs.textarea);
	    }, _this.select = function () {
	      _this.getInputNode().select();
	    }, _this.focus = function () {
	      _this.getInputNode().focus();
	    }, _this.clear = function () {
	      _this.getInputNode().value = '';
	    }, _this.handleChange = function () {
	      if (_this.props.autogrow) {
	        _this.recalculateSize();
	      }
	    }, _this.handleKeyDown = function (event) {
	      if (_this.props.onReturnKeyPress && event.keyCode === _KeyConstants2.default.ENTER) {
	        if (_this.props.onReturnKeyPress(event)) {
	          event.stopPropagation();
	        }
	      }
	    }, _this.height = null, _this.recalculateSize = function () {
	      var node = _reactDom2.default.findDOMNode(_this);
	      node.style.height = 'auto';
	
	      var height = node.scrollHeight + BORDER_HEIGHT;
	      node.style.height = height + 'px';
	      if (_this.height !== height) {
	        _this.height = height;
	        if (_this.props.onHeightChange) {
	          _this.props.onHeightChange();
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Textarea, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autogrow) {
	        this.recalculateSize();
	        window.addEventListener('resize', this.recalculateSize, false);
	      }
	
	      if (this.props.autofocus) {
	        // Prevents the cursor from being placed at the start of the text
	        var value = this.getInputNode().value;
	        this.getInputNode().value = '';
	        (0, _focusNode2.default)(this.getInputNode());
	        this.getInputNode().value = value;
	      }
	
	      if (this.props.autoselect) {
	        this.select();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.autogrow) {
	        this.recalculateSize();
	      }
	      if (this.props.onUpdate) {
	        this.props.onUpdate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.autogrow) {
	        window.removeEventListener('resize', this.recalculateSize, false);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          placeholder = _props.placeholder,
	          onChange = _props.onChange,
	          className = _props.className,
	          value = _props.value,
	          others = _objectWithoutProperties(_props, ['children', 'placeholder', 'onChange', 'className', 'value']);
	
	      var initialValue = '';
	      if (value) {
	        initialValue = value;
	      } else if (children) {
	        initialValue = children;
	      }
	
	      var props = (0, _pickTextareaElementProps2.default)(others);
	
	      return _react2.default.createElement('textarea', _extends({}, props, {
	        value: initialValue,
	        ref: 'textarea',
	        onKeyDown: this.handleKeyDown,
	        placeholder: placeholder,
	        className: (0, _classnames2.default)('Textarea', className),
	        onChange: (0, _createChainedFunction2.default)(onChange, this.handleChange)
	      }));
	    }
	  }]);
	
	  return Textarea;
	}(_react2.default.Component);
	
	Textarea.defaultProps = {
	  autogrow: false,
	  autofocus: false,
	  autoselect: false,
	  rows: 3
	};
	Textarea.displayName = 'Textarea';
	exports.default = Textarea;

/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _GlobalAttributes = __webpack_require__(1107);
	
	var _GlobalAttributes2 = _interopRequireDefault(_GlobalAttributes);
	
	var _SupportedEventNames = __webpack_require__(1108);
	
	var _SupportedEventNames2 = _interopRequireDefault(_SupportedEventNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TEXTAREA_ATTRIBUTES = ['autoComplete', 'autoFocus', 'cols', 'disabled', 'maxLength', 'minLength', 'name', 'placeholder', 'readOnly', 'required', 'rows', 'spellCheck', 'wrap']; /*  weak */
	
	
	var ALLOWED_PROPS = _lodash2.default.union(_GlobalAttributes2.default, _SupportedEventNames2.default, TEXTAREA_ATTRIBUTES);
	
	exports.default = function (props) {
	  return _lodash2.default.pick(props, ALLOWED_PROPS);
	};

/***/ },
/* 1600 */
1136,
/* 1601 */,
/* 1602 */
1136,
/* 1603 */,
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuButton = function (_React$Component) {
	  _inherits(MenuButton, _React$Component);
	
	  function MenuButton() {
	    _classCallCheck(this, MenuButton);
	
	    return _possibleConstructorReturn(this, (MenuButton.__proto__ || Object.getPrototypeOf(MenuButton)).apply(this, arguments));
	  }
	
	  _createClass(MenuButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          menu = _props.menu,
	          alignment = _props.alignment,
	          placement = _props.placement,
	          activeClassName = _props.activeClassName,
	          tooltip = _props.tooltip,
	          tooltipPlacement = _props.tooltipPlacement,
	          tooltipAlignment = _props.tooltipAlignment,
	          other = _objectWithoutProperties(_props, ['menu', 'alignment', 'placement', 'activeClassName', 'tooltip', 'tooltipPlacement', 'tooltipAlignment']);
	
	      var button = _react2.default.createElement(
	        _Button2.default,
	        _extends({}, other, {
	          tooltip: tooltip,
	          disabled: this.props.disabled,
	          tooltipPlacement: tooltipPlacement,
	          tooltipAlignment: tooltipAlignment }),
	        this.props.children
	      );
	
	      if (this.props.disabled) {
	        return button;
	      }
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          layer: menu,
	          trigger: 'click',
	          placement: placement || 'bottom',
	          alignment: alignment || 'left',
	          activeClassName: activeClassName },
	        button
	      );
	    }
	  }]);
	
	  return MenuButton;
	}(_react2.default.Component);
	
	MenuButton.displayName = 'MenuButton';
	exports.default = MenuButton;

/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Buttons = __webpack_require__(1315);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _Checkbox = __webpack_require__(1388);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Copy = __webpack_require__(1461);
	
	var _Copy2 = _interopRequireDefault(_Copy);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _Textarea = __webpack_require__(1598);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var RemoveFromOrgModal = function (_React$Component) {
	  _inherits(RemoveFromOrgModal, _React$Component);
	
	  function RemoveFromOrgModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RemoveFromOrgModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RemoveFromOrgModal.__proto__ || Object.getPrototypeOf(RemoveFromOrgModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isSubmitting: false,
	      selectedBan: false,
	      reason: ''
	    }, _this.closeModal = function () {
	      var onRequestHide = _this.props.onRequestHide;
	
	      (0, _invariant2.default)(onRequestHide, 'modal must have onRequestHide');
	      onRequestHide();
	    }, _this.onNoteChange = function (event) {
	      _this.setState({ reason: event.target.value });
	    }, _this.removeUser = function () {
	      var _this$props = _this.props,
	          orgName = _this$props.orgName,
	          orgId = _this$props.orgId,
	          userName = _this$props.userName,
	          userIds = _this$props.userIds,
	          onRemoved = _this$props.onRemoved;
	
	
	      var isBan = _this.state.selectedBan;
	      var finishedWord = isBan ? 'banned' : 'removed';
	
	      var onSuccess = function onSuccess() {
	        var peopleText = void 0;
	        if (userName) {
	          peopleText = userName + ' has';
	        } else {
	          peopleText = userIds.length === 1 ? '1 person has' : userIds.length + ' people have';
	        }
	        _this.setState({ isSubmitting: false });
	        _ToastActions2.default.showSuccessToast(peopleText + ' been ' + finishedWord + ' from ' + orgName);
	        if (onRemoved) {
	          onRemoved();
	        }
	        _this.closeModal();
	      };
	
	      var onError = function onError() {
	        _this.setState({ isSubmitting: false });
	        _ToastActions2.default.showErrorToast('Something went wrong! No one was ' + finishedWord + ' from ' + orgName + '.');
	      };
	
	      _this.setState({ isSubmitting: true });
	
	      var removeAction = isBan ? _OrganizationActions2.default.batchBanFromOrg : _OrganizationActions2.default.batchRemoveFromOrg;
	      removeAction(orgId, userIds, _this.state.reason).then(onSuccess, onError);
	    }, _this.renderBody = function () {
	      var _this$props2 = _this.props,
	          userName = _this$props2.userName,
	          isAdminView = _this$props2.isAdminView,
	          group = _this$props2.group,
	          reportModal = _this$props2.reportModal,
	          userIds = _this$props2.userIds;
	      var _this$state = _this.state,
	          reason = _this$state.reason,
	          isSubmitting = _this$state.isSubmitting;
	
	
	      var reportLink = void 0;
	      if ((isAdminView || userIds.length > 1) && group) {
	        reportLink = _react2.default.createElement(
	          _Link2.default,
	          { href: 'https://www.remind.com/classes/' + group.getCode() + '/people', target: '_blank' },
	          'report that person to Remind'
	        );
	      } else if (reportModal) {
	        reportLink = _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: reportModal(userName, userIds[0]) },
	          _react2.default.createElement(
	            _Link2.default,
	            { onClick: _this.closeModal },
	            'report that person to Remind'
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: true },
	        _react2.default.createElement(
	          _Copy2.default,
	          { color: 'thunder' },
	          _react2.default.createElement(
	            'div',
	            null,
	            !isAdminView && _react2.default.createElement(
	              'p',
	              null,
	              'People you remove from ',
	              _this.props.orgName,
	              ' will not be able to rejoin the school.  However, they keep all account privileges, including access to their classes and participant lists.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'If ',
	              userName ? userName + ' is' : 'they are',
	              ' violating our',
	              ' ',
	              _react2.default.createElement(
	                _Link2.default,
	                {
	                  href: _LinkConstants2.default.COMMUNITY_GUIDELINES,
	                  target: '_blank' },
	                'Community Guidelines'
	              ),
	              ', please',
	              ' ',
	              reportLink,
	              '.'
	            ),
	            'When you remove ',
	            userName || 'them',
	            ',',
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'They will no longer appear in the school roster.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'They will be removed from classes linked to the school.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Classes they own will be unlinked from the school.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              userName || 'They',
	              ' will be notified by email, and you can add a custom message below.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Field2.default,
	          null,
	          _react2.default.createElement(
	            _Label2.default,
	            null,
	            'Type your message'
	          ),
	          _react2.default.createElement(_Textarea2.default, {
	            value: reason,
	            placeholder: 'Type your message here',
	            onChange: _this.onNoteChange
	          })
	        ),
	        _react2.default.createElement(
	          _Field2.default,
	          null,
	          _react2.default.createElement(
	            _Checkbox2.default,
	            {
	              'data-test': 'ban-checkbox',
	              onChange: function onChange() {
	                return _this.setState({ selectedBan: !_this.state.selectedBan });
	              } },
	            _react2.default.createElement(
	              _Copy2.default,
	              { color: 'thunder' },
	              'Ban ',
	              userName || 'these people',
	              ' from joining ',
	              _this.props.orgName,
	              ' again'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Buttons2.default,
	          { axis: 'y' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              'data-test': 'confirm-button',
	              color: 'brand',
	              level: 'primary',
	              full: true,
	              disabled: isSubmitting,
	              onClick: _this.removeUser },
	            'Remove from school'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { color: 'brand', level: 'text', onClick: _this.closeModal },
	            'Cancel'
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RemoveFromOrgModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          userIds = _props.userIds,
	          orgName = _props.orgName,
	          userName = _props.userName;
	
	      var title = void 0;
	      if (userName) {
	        title = _react2.default.createElement(
	          'span',
	          null,
	          'Remove ',
	          userName,
	          ' from ',
	          orgName,
	          '?'
	        );
	      } else {
	        title = _react2.default.createElement(
	          'span',
	          null,
	          'Remove ',
	          userIds.length === 1 ? '1 person' : userIds.length + ' people',
	          ' from ',
	          orgName
	        );
	      }
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        {
	          eventScreenName: 'RemoveFromOrgModal',
	          size: 'small',
	          onRequestHide: this.props.onRequestHide,
	          title: title },
	        this.renderBody()
	      );
	    }
	  }]);
	
	  return RemoveFromOrgModal;
	}(_react2.default.Component);
	
	RemoveFromOrgModal.displayName = 'RemoveFromOrgModal';
	exports.default = RemoveFromOrgModal;

/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _ModalMenuItem = __webpack_require__(1595);
	
	var _ModalMenuItem2 = _interopRequireDefault(_ModalMenuItem);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RemoveMemberMenuItem = function (_React$Component) {
	  _inherits(RemoveMemberMenuItem, _React$Component);
	
	  function RemoveMemberMenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RemoveMemberMenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RemoveMemberMenuItem.__proto__ || Object.getPrototypeOf(RemoveMemberMenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.removeMember = function () {
	      var subscriber = _this.props.member.getUser();
	      var message = subscriber.getName() + ' was removed from ' + _this.props.group.getName();
	      _GroupActions2.default.removeMember(_this.props.group, subscriber).then(function () {
	        return _ToastActions2.default.showSuccessToast(message);
	      });
	    }, _this.renderConfirmDialog = function () {
	      return _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'RemoveMemberMenuItem',
	        actionButtonText: 'Remove',
	        cancelButtonText: 'Cancel',
	        size: 'xsmall',
	        onConfirm: _this.removeMember,
	        title: 'Remove participant?',
	        subtext: 'This person won’t receive announcements or be available ' + 'for direct messaging. You can always change this later.'
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RemoveMemberMenuItem, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ModalMenuItem2.default,
	        { modal: this.renderConfirmDialog() },
	        _react2.default.createElement(_Glyph2.default, { name: 'close' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          'Remove from class'
	        )
	      );
	    }
	  }]);
	
	  return RemoveMemberMenuItem;
	}(_react2.default.Component);
	
	RemoveMemberMenuItem.displayName = 'RemoveMemberMenuItem';
	exports.default = RemoveMemberMenuItem;

/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReportToRemindSelectModal = __webpack_require__(1608);
	
	var _ReportToRemindSelectModal2 = _interopRequireDefault(_ReportToRemindSelectModal);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(1612);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportOrgUserModal = _react2.default.createClass({
	  displayName: 'ReportOrgUserModal',
	  onCancel: function onCancel() {
	    this.props.onRequestHide();
	  },
	  onReport: function onReport(reason, notes) {
	    var _this = this;
	
	    var onSuccess = function onSuccess() {
	      _ToastActions2.default.showSuccessToast('Report submitted');
	      _this.props.onRequestHide();
	    };
	
	    var onError = function onError() {
	      _ToastActions2.default.showErrorToast('Something went wrong. Please try again.');
	    };
	
	    _OrganizationActions2.default.reportUserAsAdmin(this.props.orgId, this.props.userId, reason, notes).then(onSuccess, onError);
	  },
	  render: function render() {
	    var placeholder = 'Please explain why you are reporting this person to Remind.';
	    var options = _ReportToRemindSelectModal.DEFAULT_OPTIONS.concat(['No longer at this school']);
	    var title = 'Report to Remind';
	
	    return _react2.default.createElement(
	      _ReportToRemindSelectModal2.default,
	      _extends({}, this.props, {
	        title: title,
	        buttonText: 'Report',
	        notesRequired: true,
	        options: options,
	        reportee: this.props.userName,
	        notesPlaceholder: placeholder,
	        onReport: this.onReport }),
	      _react2.default.createElement(
	        'p',
	        { className: 'ReportOrgUserModal-info' },
	        'If ',
	        this.props.userName,
	        ' is erroneously linked to',
	        ' ',
	        this.props.orgName,
	        ', please',
	        ' ',
	        _react2.default.createElement(
	          _ModalTrigger2.default,
	          {
	            modal: this.props.removeModal(this.props.userName, this.props.userId) },
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              className: 'ReportOrgUserModal-remove',
	              onClick: this.onCancel,
	              eventElementName: 'ReportOrgUserModal-remove' },
	            'remove this person from your school.'
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = ReportOrgUserModal;

/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_OPTIONS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Buttons = __webpack_require__(1315);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Radio = __webpack_require__(1609);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _Textarea = __webpack_require__(1598);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // typecheck: ignore file
	
	
	var DEFAULT_OPTIONS = exports.DEFAULT_OPTIONS = ['Inappropriate content', 'Harassment/bullying', 'Threatening harm to me or others', 'Pretending to be someone else', 'At risk of harming him or herself', 'Using hate speech or encouraging extreme acts'];
	var OTHER = 'other';
	
	var ReportToRemindSelectModal = function (_React$Component) {
	  _inherits(ReportToRemindSelectModal, _React$Component);
	
	  function ReportToRemindSelectModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReportToRemindSelectModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReportToRemindSelectModal.__proto__ || Object.getPrototypeOf(ReportToRemindSelectModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selected: 0,
	      notes: ''
	    }, _this.cancelConfirmDialog = function () {
	      if (_this.props.onCancel) {
	        _this.props.onCancel();
	      }
	      _this.props.onRequestHide();
	    }, _this.missingNotes = function () {
	      return (_this.props.notesRequired || _this.state.selected === OTHER) && _this.state.notes === '';
	    }, _this.reportClicked = function () {
	      _this.props.onRequestHide();
	
	      var reason = _this.state.selected === OTHER ? 'Other' : _this.props.options[_this.state.selected];
	
	      return _this.props.onReport(reason, _this.state.notes);
	    }, _this.renderConfirmDialog = function () {
	      return _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'ReportToRemindSelectModal',
	        title: 'Are you sure you want to report ' + _this.props.reportee + ' to Remind?',
	        subtext: 'We review all reports and handle them based on our guidelines. Thank you for helping to keep our community safe.',
	        actionButtonText: 'Report',
	        cancelButtonText: 'Cancel',
	        onConfirm: _this.reportClicked
	      });
	    }, _this.renderOption = function (option, index) {
	      return _react2.default.createElement(
	        _Radio2.default,
	        {
	          name: 'report-message',
	          checked: _this.state.selected === index,
	          onChange: function onChange() {
	            return _this.setState({ selected: index });
	          },
	          key: index },
	        option
	      );
	    }, _this.handleTextChange = function (event) {
	      _this.setState({ notes: event.target.value });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReportToRemindSelectModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var subtext = 'Why are you reporting ' + this.props.reportee + '?';
	      var confirmDialog = this.renderConfirmDialog();
	      var notesPlaceholder = this.props.notesPlaceholder;
	
	      if (this.props.notesRequired) {
	        notesPlaceholder = this.props.notesPlaceholder + ' (Required)';
	      } else if (subtext === this.props.notesPlaceholder) {
	        notesPlaceholder = '';
	      }
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({}, this.props, {
	          size: 'small',
	          className: 'ReportToRemindSelectModal',
	          title: this.props.title,
	          subtext: subtext }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          this.props.children,
	          _react2.default.createElement(
	            'form',
	            null,
	            _react2.default.createElement(
	              _Field2.default,
	              null,
	              _react2.default.createElement(_Label2.default, { text: 'Reason' }),
	              this.props.options.map(this.renderOption),
	              _react2.default.createElement(
	                _Radio2.default,
	                {
	                  name: 'report-message',
	                  checked: this.state.selected === OTHER,
	                  onChange: function onChange() {
	                    return _this2.setState({ selected: OTHER });
	                  } },
	                'Other'
	              )
	            ),
	            _react2.default.createElement(
	              _Field2.default,
	              null,
	              _react2.default.createElement(_Label2.default, { text: 'Notes' }),
	              _react2.default.createElement(_Textarea2.default, {
	                name: 'notes',
	                value: this.state.notes,
	                placeholder: notesPlaceholder,
	                required: this.props.notesRequired,
	                rows: 2,
	                onChange: this.handleTextChange
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Container2.default,
	            { size: 'xxsmall' },
	            _react2.default.createElement(
	              _Buttons2.default,
	              { full: true },
	              _react2.default.createElement(
	                _Button2.default,
	                { level: 'secondary', onClick: this.cancelConfirmDialog },
	                'Cancel'
	              ),
	              _react2.default.createElement(
	                _ModalTrigger2.default,
	                { modal: confirmDialog },
	                _react2.default.createElement(
	                  _Button2.default,
	                  { disabled: this.missingNotes() },
	                  this.props.buttonText
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReportToRemindSelectModal;
	}(_react2.default.Component);
	
	ReportToRemindSelectModal.defaultProps = {
	  title: 'Report to Remind',
	  options: DEFAULT_OPTIONS,
	  notesPlaceholder: 'Why are you reporting this person?',
	  notesRequired: false,
	  buttonText: 'Report'
	};
	ReportToRemindSelectModal.displayName = 'ReportToRemindSelectModal';
	exports.default = ReportToRemindSelectModal;

/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1610);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Radio = function (_React$Component) {
	  _inherits(Radio, _React$Component);
	
	  function Radio() {
	    _classCallCheck(this, Radio);
	
	    return _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
	  }
	
	  _createClass(Radio, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          label = _props.label,
	          children = _props.children,
	          others = _objectWithoutProperties(_props, ['className', 'label', 'children']);
	
	      return _react2.default.createElement(
	        _Label2.default,
	        {
	          className: (0, _classnames2.default)('Radio', {
	            'Radio--inline': this.props.inline
	          }, className) },
	        _react2.default.createElement(_Input2.default, _extends({}, others, {
	          type: 'radio',
	          className: 'Radio-input'
	        })),
	        _react2.default.createElement('span', { className: 'Radio-indicator' }),
	        label,
	        children
	      );
	    }
	  }]);
	
	  return Radio;
	}(_react2.default.Component);
	
	Radio.defaultProps = {
	  disabled: false
	};
	Radio.displayName = 'Radio';
	exports.default = Radio;

/***/ },
/* 1610 */
1136,
/* 1611 */,
/* 1612 */
1136,
/* 1613 */,
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _ModalMenuItem = __webpack_require__(1595);
	
	var _ModalMenuItem2 = _interopRequireDefault(_ModalMenuItem);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReportToRemindSelectModal = __webpack_require__(1608);
	
	var _ReportToRemindSelectModal2 = _interopRequireDefault(_ReportToRemindSelectModal);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var ReportUserMenuItem = function (_React$Component) {
	  _inherits(ReportUserMenuItem, _React$Component);
	
	  function ReportUserMenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReportUserMenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReportUserMenuItem.__proto__ || Object.getPrototypeOf(ReportUserMenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.reportParticipant = function (reason, notes) {
	      _UserActions2.default.reportUser(_this.props.reportee.id, reason, notes);
	    }, _this.renderReportDialog = function () {
	      return _react2.default.createElement(_ReportToRemindSelectModal2.default, {
	        reportee: _this.props.reportee.getName(),
	        notesPlaceholder: 'Why are you reporting this participant?',
	        onReport: _this.reportParticipant
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReportUserMenuItem, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ModalMenuItem2.default,
	        { modal: this.renderReportDialog() },
	        _react2.default.createElement(_Glyph2.default, { name: 'flag' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          'Report to Remind'
	        )
	      );
	    }
	  }]);
	
	  return ReportUserMenuItem;
	}(_react2.default.Component);
	
	ReportUserMenuItem.displayName = 'ReportUserMenuItem';
	exports.default = ReportUserMenuItem;

/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CopySubscriberDialog = __webpack_require__(1313);
	
	var _CopySubscriberDialog2 = _interopRequireDefault(_CopySubscriberDialog);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Relationship = __webpack_require__(1007);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _modal = __webpack_require__(1188);
	
	var _ChatPromises = __webpack_require__(1569);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubscribeUserMenuItem = function (_React$Component) {
	  _inherits(SubscribeUserMenuItem, _React$Component);
	
	  function SubscribeUserMenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SubscribeUserMenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubscribeUserMenuItem.__proto__ || Object.getPrototypeOf(SubscribeUserMenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.clickCopyDialog = function () {
	      (0, _ChatPromises.promiseRelationship)(_this.props.subscriber).then(function (relationship) {
	        _this.renderCopyDialog(relationship);
	      });
	    }, _this.renderCopyDialog = function (relationship) {
	      var groups = _GroupStore2.default.getOwnedGroups();
	      (0, _modal.mountModal)(_react2.default.createElement(_CopySubscriberDialog2.default, {
	        relationship: relationship,
	        groups: groups
	      }), _this);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SubscribeUserMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _MenuItem2.default,
	        { onClick: function onClick() {
	            return _this2.clickCopyDialog();
	          } },
	        _react2.default.createElement(_Glyph2.default, { name: 'arrow-right' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          'Copy to another class'
	        )
	      );
	    }
	  }]);
	
	  return SubscribeUserMenuItem;
	}(_react2.default.Component);
	
	SubscribeUserMenuItem.displayName = 'SubscribeUserMenuItem';
	exports.default = SubscribeUserMenuItem;

/***/ },
/* 1616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _capitalize = __webpack_require__(1617);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _ProfilePicture = __webpack_require__(1618);
	
	var _ProfilePicture2 = _interopRequireDefault(_ProfilePicture);
	
	var _Relationship = __webpack_require__(1007);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(1621);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RelationshipViewProfileHeader = function (_React$Component) {
	  _inherits(RelationshipViewProfileHeader, _React$Component);
	
	  function RelationshipViewProfileHeader() {
	    _classCallCheck(this, RelationshipViewProfileHeader);
	
	    return _possibleConstructorReturn(this, (RelationshipViewProfileHeader.__proto__ || Object.getPrototypeOf(RelationshipViewProfileHeader)).apply(this, arguments));
	  }
	
	  _createClass(RelationshipViewProfileHeader, [{
	    key: 'renderOrgAffiliations',
	    value: function renderOrgAffiliations() {
	      var orgAffiliations = this.props.relationship.getOrgAffiliationViews();
	      return _react2.default.createElement(
	        'div',
	        null,
	        orgAffiliations.map(function (orgAff) {
	          var org = _OrganizationStore2.default.getOrganization(orgAff.organization_id);
	          (0, _invariant2.default)(org, 'missing organization');
	          return _react2.default.createElement(
	            _Text2.default,
	            { element: 'div' },
	            (0, _capitalize2.default)(orgAff.roles.join(', ')),
	            ' at ',
	            org.getName()
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderOfficeHours',
	    value: function renderOfficeHours() {
	      var officeHours = this.props.subscriber.getOfficeHours();
	      if (!officeHours || !officeHours.hasAvailability()) {
	        return null;
	      }
	      return this.renderSecondaryByline('Office hours: ' + officeHours.getLabel());
	    }
	  }, {
	    key: 'renderMediums',
	    value: function renderMediums() {
	      var subscriber = this.props.subscriber;
	
	      var enabledDevices = subscriber.getDevices().filter(function (device) {
	        return device.isEnabled();
	      });
	      if (enabledDevices.length === 0) {
	        return null;
	      }
	
	      var text = 'Receiving messages via ' + enabledDevices.map(function (d) {
	        return d.getFriendlyName();
	      }).join(', ').toLowerCase();
	      return this.renderSecondaryByline(text);
	    }
	  }, {
	    key: 'renderSecondaryByline',
	    value: function renderSecondaryByline(text) {
	      return _react2.default.createElement(
	        _Text2.default,
	        { element: 'div', size: 'xsmall', color: 'thunder' },
	        text
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var subscriber = this.props.subscriber;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'RelationshipViewProfileHeader' },
	        _react2.default.createElement(_ProfilePicture2.default, { user: subscriber }),
	        _react2.default.createElement(
	          _Text2.default,
	          { element: 'div', size: 'xxxlarge' },
	          subscriber.getName()
	        ),
	        this.renderOrgAffiliations(),
	        _react2.default.createElement(
	          'div',
	          { className: 'RelationshipViewProfileHeader-subtext' },
	          this.renderOfficeHours(),
	          this.renderMediums()
	        )
	      );
	    }
	  }]);
	
	  return RelationshipViewProfileHeader;
	}(_react2.default.Component);
	
	RelationshipViewProfileHeader.displayName = 'RelationshipViewProfileHeader';
	exports.default = RelationshipViewProfileHeader;

/***/ },
/* 1617 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	function capitalize(word) {
	  return word ? word.charAt(0).toUpperCase() + word.slice(1) : '';
	}
	
	exports.default = capitalize;

/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	__webpack_require__(1619);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfilePicture = function ProfilePicture(_ref) {
	  var user = _ref.user,
	      size = _ref.size;
	
	  // Because we are migrating off of entities
	  // $FlowFixMe
	  var initials = user.getInitials ? user.getInitials() : user.initials;
	
	  return _react2.default.createElement(_Avatar2.default, { className: 'ProfilePicture', text: initials, size: size });
	};
	exports.default = ProfilePicture;

/***/ },
/* 1619 */
1136,
/* 1620 */,
/* 1621 */
1136,
/* 1622 */,
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _MediumConstants = __webpack_require__(1017);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Heading = __webpack_require__(1436);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1624);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RelationshipViewNotes = function (_React$Component) {
	  _inherits(RelationshipViewNotes, _React$Component);
	
	  function RelationshipViewNotes() {
	    _classCallCheck(this, RelationshipViewNotes);
	
	    return _possibleConstructorReturn(this, (RelationshipViewNotes.__proto__ || Object.getPrototypeOf(RelationshipViewNotes)).apply(this, arguments));
	  }
	
	  _createClass(RelationshipViewNotes, [{
	    key: 'render',
	    value: function render() {
	      var subscriber = this.props.subscriber;
	
	
	      var enabledDevices = subscriber.getDevices().filter(function (device) {
	        return device.isEnabled();
	      });
	
	      var mediums = void 0;
	      if (enabledDevices.length > 0) {
	        mediums = enabledDevices.map(function (device) {
	          var medium = device.getMedium();
	          var verified = device.isVerified();
	
	          return _react2.default.createElement(
	            'div',
	            {
	              key: device.cid,
	              className: (0, _classnames2.default)('RelationshipViewMediums-list-item', {
	                'RelationshipViewMediums-list-item--disabled': !verified
	              }) },
	            _react2.default.createElement(_Glyph2.default, {
	              className: 'RelationshipViewMediums-list-item-glyph',
	              name: _MediumConstants.GLYPHS[medium]
	            }),
	            device.getFriendlyName()
	          );
	        });
	      } else {
	        mediums = _react2.default.createElement(
	          _Text2.default,
	          { color: 'thunder' },
	          'Oops, messages may not be received. This person doesn\u2019t have any notifications enabled.',
	          ' ',
	          _react2.default.createElement(
	            _Link2.default,
	            { href: _LinkConstants2.default.NO_DEVICES, target: '_blank' },
	            'View FAQ.'
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'RelationshipViewMediums' },
	        _react2.default.createElement(
	          _Heading2.default,
	          { align: 'left', level: '4' },
	          'Notifications'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'RelationshipViewMediums-list' },
	          mediums
	        )
	      );
	    }
	  }]);
	
	  return RelationshipViewNotes;
	}(_react2.default.Component);
	
	RelationshipViewNotes.displayName = 'RelationshipViewNotes';
	exports.default = RelationshipViewNotes;

/***/ },
/* 1624 */
1136,
/* 1625 */,
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RelationshipActions = __webpack_require__(1006);
	
	var _RelationshipActions2 = _interopRequireDefault(_RelationshipActions);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	var _Textarea = __webpack_require__(1598);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var RelationshipViewNotes = function (_React$Component) {
	  _inherits(RelationshipViewNotes, _React$Component);
	
	  function RelationshipViewNotes() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RelationshipViewNotes);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelationshipViewNotes.__proto__ || Object.getPrototypeOf(RelationshipViewNotes)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      note: _this.props.subscriber.getNote()
	    }, _this.handleNoteChange = function (event) {
	      // $FlowIssue
	      _this.setState({ note: event.target.value });
	    }, _this.handleUpdateNote = function () {
	      _RelationshipActions2.default.updateNote(_this.props.subscriber.id, _this.state.note).then(function () {
	        _ToastActions2.default.showSuccessToast('Notes saved');
	      }).catch(function () {
	        _ToastActions2.default.showErrorToast('An error has occurred');
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RelationshipViewNotes, [{
	    key: 'render',
	    value: function render() {
	      var subscriber = this.props.subscriber;
	
	      var placeholder = 'Add a note about ' + subscriber.getName() + ' (only you can see this)';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'RelationshipViewNotes' },
	        _react2.default.createElement(
	          _Field2.default,
	          null,
	          _react2.default.createElement(
	            _Label2.default,
	            { htmlFor: '' },
	            'Notes'
	          ),
	          _react2.default.createElement(_Textarea2.default, {
	            value: this.state.note,
	            placeholder: placeholder,
	            ref: 'note',
	            autogrow: true,
	            rows: 2,
	            onChange: this.handleNoteChange
	          })
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            size: 'xsmall',
	            className: 'pull-right',
	            disabled: this.state.note === subscriber.getNote(),
	            onClick: this.handleUpdateNote,
	            eventElementName: 'pull-right' },
	          'Save'
	        )
	      );
	    }
	  }]);
	
	  return RelationshipViewNotes;
	}(_react2.default.Component);
	
	RelationshipViewNotes.displayName = 'RelationshipViewNotes';
	exports.default = RelationshipViewNotes;

/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Buttons = __webpack_require__(1315);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _ChangeUntrustedNameModal = __webpack_require__(1628);
	
	var _ChangeUntrustedNameModal2 = _interopRequireDefault(_ChangeUntrustedNameModal);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RelationshipActions = __webpack_require__(1006);
	
	var _RelationshipActions2 = _interopRequireDefault(_RelationshipActions);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var RelationshipViewUntrustedName = function (_React$Component) {
	  _inherits(RelationshipViewUntrustedName, _React$Component);
	
	  function RelationshipViewUntrustedName() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RelationshipViewUntrustedName);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelationshipViewUntrustedName.__proto__ || Object.getPrototypeOf(RelationshipViewUntrustedName)).call.apply(_ref, [this].concat(args))), _this), _this.handleConfirmSubscriberName = function (event) {
	      event.preventDefault();
	      _RelationshipActions2.default.confirmUntrustedName(_this.props.subscriber.id);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RelationshipViewUntrustedName, [{
	    key: 'render',
	    value: function render() {
	      var subscriber = this.props.subscriber;
	
	
	      if (!subscriber.getUntrustedName()) {
	        return null;
	      }
	
	      var changeUntrustedNameModal = _react2.default.createElement(_ChangeUntrustedNameModal2.default, { subscriber: subscriber });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'RelationshipView-untrustedName' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'RelationshipView-untrustedName-title' },
	          'Is this person\u2019s name correct?'
	        ),
	        _react2.default.createElement(
	          _Container2.default,
	          { size: 'xxsmall' },
	          _react2.default.createElement(
	            _Buttons2.default,
	            { full: true },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                level: 'primary',
	                size: 'xsmall',
	                color: 'brand',
	                onClick: this.handleConfirmSubscriberName },
	              'Yes'
	            ),
	            _react2.default.createElement(
	              _ModalTrigger2.default,
	              { modal: changeUntrustedNameModal },
	              _react2.default.createElement(
	                _Button2.default,
	                {
	                  level: 'primary',
	                  size: 'xsmall',
	                  color: 'brand' },
	                'No'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RelationshipViewUntrustedName;
	}(_react2.default.Component);
	
	RelationshipViewUntrustedName.displayName = 'RelationshipViewUntrustedName';
	exports.default = RelationshipViewUntrustedName;

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _DialogButton = __webpack_require__(1327);
	
	var _DialogButton2 = _interopRequireDefault(_DialogButton);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _FormNote = __webpack_require__(1629);
	
	var _FormNote2 = _interopRequireDefault(_FormNote);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RelationshipActions = __webpack_require__(1006);
	
	var _RelationshipActions2 = _interopRequireDefault(_RelationshipActions);
	
	var _Subscriber = __webpack_require__(605);
	
	var _Subscriber2 = _interopRequireDefault(_Subscriber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChangeUntrustedNameModal = _react2.default.createClass({
	  displayName: 'ChangeUntrustedNameModal',
	  getInitialState: function getInitialState() {
	    return {
	      subscriber: this.props.subscriber,
	      firstName: this.props.subscriber.getFirstName(),
	      lastName: this.props.subscriber.getLastName()
	    };
	  },
	  cancelConfirmDialog: function cancelConfirmDialog(event) {
	    event.preventDefault();
	    if (this.props.onCancel) {
	      this.props.onCancel();
	    }
	    this.props.onRequestHide();
	  },
	
	
	  // change
	  changeName: function changeName() {
	    var subscriberId = this.props.subscriber.id;
	    var _state = this.state,
	        firstName = _state.firstName,
	        lastName = _state.lastName;
	
	    _RelationshipActions2.default.updateName(subscriberId, firstName, lastName);
	    this.props.onRequestHide();
	  },
	  closeUntrustedNameModal: function closeUntrustedNameModal() {
	    this.props.onRequestHide();
	  },
	  renderConfirmDialog: function renderConfirmDialog() {
	    var confirmString = 'Are you sure you want to change this participant’s name to ' + this.state.firstName + ' ' + this.state.lastName + '?';
	    return _react2.default.createElement(
	      _ConfirmDialog2.default,
	      {
	        eventScreenName: 'ChangeUntrustedNameModal',
	        title: confirmString,
	        onConfirm: this.changeName },
	      'A participant\u2019s name can only be changed once.'
	    );
	  },
	  handleFirstNameChange: function handleFirstNameChange(event) {
	    this.setState({ firstName: event.target.value });
	  },
	  handleLastNameChange: function handleLastNameChange(event) {
	    this.setState({ lastName: event.target.value });
	  },
	  render: function render() {
	    var confirmDialog = this.renderConfirmDialog();
	
	    return _react2.default.createElement(
	      _Dialog2.default,
	      _extends({}, this.props, {
	        className: 'ChangeUntrustedNameModal',
	        title: 'Change name',
	        size: 'xsmall',
	        onRequestHide: this.closeUntrustedNameModal }),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        null,
	        _react2.default.createElement(
	          'form',
	          null,
	          _react2.default.createElement(
	            _Field2.default,
	            null,
	            _react2.default.createElement(
	              _Label2.default,
	              null,
	              'First name'
	            ),
	            _react2.default.createElement(_Input2.default, {
	              value: this.state.firstName,
	              onChange: this.handleFirstNameChange
	            })
	          ),
	          _react2.default.createElement(
	            _Field2.default,
	            null,
	            _react2.default.createElement(
	              _Label2.default,
	              null,
	              'Last name'
	            ),
	            _react2.default.createElement(_Input2.default, {
	              value: this.state.lastName,
	              onChange: this.handleLastNameChange
	            })
	          ),
	          _react2.default.createElement(
	            _FormNote2.default,
	            { glyph: 'caution', glyphColor: 'lava' },
	            'You can only change this once.'
	          ),
	          _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: confirmDialog },
	            _react2.default.createElement(
	              _DialogButton2.default,
	              null,
	              'Change'
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = ChangeUntrustedNameModal;

/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _MediaObject = __webpack_require__(1396);
	
	var _MediaObject2 = _interopRequireDefault(_MediaObject);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(1630);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var FormNote = function (_React$Component) {
	  _inherits(FormNote, _React$Component);
	
	  function FormNote() {
	    _classCallCheck(this, FormNote);
	
	    return _possibleConstructorReturn(this, (FormNote.__proto__ || Object.getPrototypeOf(FormNote)).apply(this, arguments));
	  }
	
	  _createClass(FormNote, [{
	    key: 'render',
	    value: function render() {
	      var glyph = void 0;
	
	      if (this.props.glyph) {
	        glyph = _react2.default.createElement(_Glyph2.default, {
	          name: this.props.glyph,
	          color: this.props.glyphColor || 'inherit',
	          size: 'medium',
	          className: 'FormNote-glyph'
	        });
	      }
	
	      return _react2.default.createElement(
	        _MediaObject2.default,
	        { gutter: 'small', className: 'FormNote' },
	        glyph,
	        _react2.default.createElement(
	          _Text2.default,
	          { size: 'xxsmall', weight: 'semibold' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return FormNote;
	}(_react2.default.Component);
	
	FormNote.displayName = 'FormNote';
	exports.default = FormNote;

/***/ },
/* 1630 */
1136,
/* 1631 */,
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _lodash = __webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var TeacherDetail = function (_Entity) {
	  _inherits(TeacherDetail, _Entity);
	
	  function TeacherDetail() {
	    _classCallCheck(this, TeacherDetail);
	
	    return _possibleConstructorReturn(this, (TeacherDetail.__proto__ || Object.getPrototypeOf(TeacherDetail)).apply(this, arguments));
	  }
	
	  _createClass(TeacherDetail, [{
	    key: 'getCreatedAt',
	    value: function getCreatedAt() {
	      return this.get('created_at');
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }, {
	    key: 'getFirstName',
	    value: function getFirstName() {
	      return this.get('first_name');
	    }
	  }, {
	    key: 'getGroups',
	    value: function getGroups() {
	      return this.get('groups');
	    }
	  }, {
	    key: 'getLast30DaysAnnouncementsCount',
	    value: function getLast30DaysAnnouncementsCount() {
	      return this.get('last_30_days_announcements_count');
	    }
	  }, {
	    key: 'getLast30DaysParticipantChatCount',
	    value: function getLast30DaysParticipantChatCount() {
	      return this.get('last_30_days_participant_chats_count');
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var teacherDetail = (0, _lodash.cloneDeep)(response);
	      if (teacherDetail['groups']) {
	        teacherDetail['groups'] = _Groups2.default.fromJSON(teacherDetail['groups']);
	        // HACK for loading nested entities instead of the GroupView entity
	        teacherDetail['groups'].forEach(function (group) {
	          group.set('permissions', {
	            can_delete: false,
	            can_edit: false,
	            can_post: false,
	            // Allow admins to always join and leave
	            can_join: true,
	            can_leave: true
	          });
	        });
	      }
	      if (teacherDetail['created_at']) {
	        teacherDetail['created_at'] = new Date(teacherDetail['created_at']);
	      }
	      return teacherDetail;
	    }
	  }], [{
	    key: 'getTeacherByOrgAndUserId',
	    value: function getTeacherByOrgAndUserId(orgId, userId) {
	      return (0, _apiRequest2.default)('/managed_orgs/' + orgId + '/teachers/' + userId, 'GET').then(function (teacherDetail) {
	        return TeacherDetail.fromJSON(teacherDetail);
	      });
	    }
	  }]);
	
	  return TeacherDetail;
	}(_Entity3.default);
	
	TeacherDetail.displayName = 'TeacherDetail';
	exports.default = TeacherDetail;

/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TeacherDetail = __webpack_require__(1632);
	
	var _TeacherDetail2 = _interopRequireDefault(_TeacherDetail);
	
	__webpack_require__(1634);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TeacherDetailActivitySection(props) {
	  return _react2.default.createElement(
	    _Fieldset2.default,
	    { legend: 'Activity in the last 30 days', size: 'small' },
	    _react2.default.createElement(
	      'div',
	      { className: 'TeacherDetailView-usageStats' },
	      _react2.default.createElement(
	        'div',
	        { className: 'TeacherDetailView-usageStat' },
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            className: 'TeacherDetailView-usageStat-header',
	            color: 'pitch',
	            size: 'xxxxlarge',
	            weight: 'light' },
	          props.teacherDetail.getLast30DaysAnnouncementsCount()
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          { color: 'thunder', size: 'xxsmall' },
	          'Announcements sent'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'TeacherDetailView-usageStat' },
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            className: 'TeacherDetailView-usageStat-header',
	            color: 'pitch',
	            size: 'xxxxlarge',
	            weight: 'light' },
	          props.teacherDetail.getLast30DaysParticipantChatCount()
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          { color: 'thunder', size: 'xxsmall' },
	          'Chats with participants'
	        )
	      )
	    )
	  );
	}
	// typecheck: ignore file
	exports.default = TeacherDetailActivitySection;

/***/ },
/* 1634 */
1136,
/* 1635 */,
/* 1636 */
1136,
/* 1637 */,
/* 1638 */
1136,
/* 1639 */,
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _HoverLayerTrigger = __webpack_require__(1562);
	
	var _HoverLayerTrigger2 = _interopRequireDefault(_HoverLayerTrigger);
	
	var _RelationshipActions = __webpack_require__(1006);
	
	var _RelationshipActions2 = _interopRequireDefault(_RelationshipActions);
	
	var _RelationshipStore = __webpack_require__(1310);
	
	var _RelationshipStore2 = _interopRequireDefault(_RelationshipStore);
	
	var _UserHovercard = __webpack_require__(1641);
	
	var _UserHovercard2 = _interopRequireDefault(_UserHovercard);
	
	var _Relationship = __webpack_require__(1007);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var UserLink = function (_React$Component) {
	  _inherits(UserLink, _React$Component);
	
	  function UserLink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserLink.__proto__ || Object.getPrototypeOf(UserLink)).call.apply(_ref, [this].concat(args))), _this), _this.loadRelationship = function () {
	      if (!_this.state.relationship) {
	        _RelationshipActions2.default.loadRelationship(_this.props.userId);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UserLink, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          neverShowStartChat = _props.neverShowStartChat,
	          showSubscriptions = _props.showSubscriptions,
	          children = _props.children,
	          placement = _props.placement,
	          alignment = _props.alignment,
	          props = _objectWithoutProperties(_props, ['neverShowStartChat', 'showSubscriptions', 'children', 'placement', 'alignment']);
	
	      if (this.props.userId === _CurrentUser2.default.getUserId()) {
	        return _react2.default.createElement(
	          _Link2.default,
	          props,
	          children
	        );
	      }
	
	      var hovercard = _react2.default.createElement(_UserHovercard2.default, {
	        relationship: this.state.relationship,
	        neverShowStartChat: neverShowStartChat,
	        showSubscriptions: showSubscriptions
	      });
	
	      return _react2.default.createElement(
	        _HoverLayerTrigger2.default,
	        {
	          layer: hovercard,
	          placement: placement,
	          alignment: alignment,
	          delayShow: 400 },
	        _react2.default.createElement(
	          _Link2.default,
	          _extends({}, props, { onMouseEnter: this.loadRelationship }),
	          children
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_RelationshipStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(_prevState, props) {
	      return {
	        relationship: _RelationshipStore2.default.getRelationship(props.userId)
	      };
	    }
	  }]);
	
	  return UserLink;
	}(_react2.default.Component);
	
	UserLink.defaultProps = {
	  neverShowStartChat: false
	};
	UserLink.displayName = 'UserLink';
	exports.default = _utils.Container.create(UserLink, { withProps: true });

/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _CopySubscriberButton = __webpack_require__(1312);
	
	var _CopySubscriberButton2 = _interopRequireDefault(_CopySubscriberButton);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _GroupLink = __webpack_require__(1430);
	
	var _GroupLink2 = _interopRequireDefault(_GroupLink);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Hovercard = __webpack_require__(1548);
	
	var _Hovercard2 = _interopRequireDefault(_Hovercard);
	
	var _HovercardBody = __webpack_require__(1554);
	
	var _HovercardBody2 = _interopRequireDefault(_HovercardBody);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Relationship = __webpack_require__(1007);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _RelationshipModal = __webpack_require__(1309);
	
	var _RelationshipModal2 = _interopRequireDefault(_RelationshipModal);
	
	var _ScrollableArea = __webpack_require__(1412);
	
	var _ScrollableArea2 = _interopRequireDefault(_ScrollableArea);
	
	var _StartChatButton = __webpack_require__(1567);
	
	var _StartChatButton2 = _interopRequireDefault(_StartChatButton);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(1642);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserHovercard = _react2.default.createClass({
	  displayName: 'UserHovercard',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [(0, _linkStateWithStores2.default)([_GroupStore2.default])],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      showSubscriptions: true
	    };
	  },
	  getInitialState: function getInitialState() {
	    return this.getStateFromStores();
	  },
	  componentDidMount: function componentDidMount() {
	    if (!_GroupStore2.default.isLoaded()) {
	      _GroupActions2.default.loadGroups();
	    }
	  },
	  getStateFromStores: function getStateFromStores() {
	    return {
	      groups: _GroupStore2.default.getOwnedGroups()
	    };
	  },
	  handleScrollAreaScroll: function handleScrollAreaScroll() {
	    var scrollArea = this.refs.scrollArea;
	
	    this.setState({ scrollAreaScrolled: !scrollArea.isScrolledToTop() });
	  },
	  subText: function subText() {
	    var relationship = this.props.relationship;
	
	    var subscriber = relationship.getRelatedUser();
	
	    var note = subscriber.getNote();
	
	    if (note) {
	      return _react2.default.createElement(
	        _Text2.default,
	        { className: 'UserHovercard-note', color: 'thunder', truncate: true },
	        note
	      );
	    }
	
	    var organizations = relationship.getCommonOrganizationsWithUser();
	    return organizations.length > 0 ? _react2.default.createElement(
	      _Text2.default,
	      { className: 'UserHovercard-note', color: 'thunder', truncate: true },
	      organizations.first().getName()
	    ) : null;
	  },
	  renderCopySubscriberButton: function renderCopySubscriberButton() {
	    return _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(_CopySubscriberButton2.default, {
	        className: 'UserHovercard-groups-copyButton',
	        relationship: this.props.relationship,
	        groups: this.state.groups,
	        size: 'small'
	      })
	    );
	  },
	  renderOwnedGroups: function renderOwnedGroups() {
	    var relationship = this.props.relationship;
	
	    var subscriptions = [];
	
	    if (relationship && this.props.showSubscriptions) {
	      var subscriber = relationship.getRelatedUser();
	      subscriptions = subscriber.getSubscriptions();
	    }
	
	    if (subscriptions.length === 0) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)('UserHovercard-groups', {
	          'UserHovercard-groups-scrolled': this.state.scrollAreaScrolled
	        }) },
	      _react2.default.createElement(
	        _Text2.default,
	        {
	          className: 'UserHovercard-groups-title',
	          color: 'thunder',
	          size: 'xxxsmall',
	          weight: 'semibold',
	          uppercase: true },
	        'Classes joined'
	      ),
	      _react2.default.createElement(
	        _ScrollableArea2.default,
	        {
	          ref: 'scrollArea',
	          className: 'UserHovercard-groups-scrollArea',
	          onScroll: this.handleScrollAreaScroll,
	          showShadows: true },
	        _react2.default.createElement(
	          'ul',
	          { className: 'UserHovercard-groups-list' },
	          subscriptions.map(function (subscription) {
	            var group = subscription.getGroup();
	
	            return _react2.default.createElement(
	              'li',
	              { key: subscription.getGroupId() },
	              _react2.default.createElement(
	                _GroupLink2.default,
	                {
	                  className: 'UserHovercard-groups-list-item',
	                  group: group,
	                  color: 'pitch' },
	                _react2.default.createElement(
	                  _FlexibleBlock2.default,
	                  { flex: 'right' },
	                  _react2.default.createElement(_GroupAvatar2.default, {
	                    className: 'UserHovercard-groups-list-item-avatar',
	                    group: group
	                  }),
	                  _react2.default.createElement(
	                    _Text2.default,
	                    { truncate: true },
	                    _react2.default.createElement(_GroupName2.default, { group: group })
	                  )
	                )
	              )
	            );
	          }),
	          this.renderCopySubscriberButton()
	        )
	      )
	    );
	  },
	  renderStartChat: function renderStartChat() {
	    if (this.props.neverShowStartChat) {
	      return null;
	    }
	
	    var relationship = this.props.relationship;
	
	    if (!relationship.isEligibleForChat()) {
	      return null;
	    }
	
	    return _react2.default.createElement(_StartChatButton2.default, {
	      className: 'UserHovercard-startChatButton',
	      subscriber: relationship.getRelatedUser(),
	      full: true
	    });
	  },
	  renderBody: function renderBody() {
	    var relationship = this.props.relationship;
	
	    var subscriber = relationship.getRelatedUser();
	
	    var name = _react2.default.createElement(
	      'h6',
	      { className: 'UserHovercard-name' },
	      _react2.default.createElement(
	        _Text2.default,
	        { truncate: true },
	        subscriber.getName()
	      )
	    );
	
	    // Only link to RelationshipModal if they have a relationship
	    if (relationship.isEligibleForChat() || relationship.getSubscriptionsToMe().length > 0) {
	      name = _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: _react2.default.createElement(_RelationshipModal2.default, { userId: subscriber.id }) },
	        _react2.default.createElement(
	          _Link2.default,
	          { color: 'pitch' },
	          name
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      name,
	      this.subText(),
	      this.renderOwnedGroups(),
	      this.renderStartChat()
	    );
	  },
	  render: function render() {
	    var body = this.props.relationship ? this.renderBody() : _react2.default.createElement(_LoadingIndicator2.default, null);
	
	    return _react2.default.createElement(
	      _Hovercard2.default,
	      _extends({}, this.props, {
	        className: (0, _classnames2.default)('UserHovercard', this.props.className) }),
	      _react2.default.createElement(
	        _HovercardBody2.default,
	        null,
	        body
	      )
	    );
	  }
	});
	
	exports.default = UserHovercard;

/***/ },
/* 1642 */
1136,
/* 1643 */,
/* 1644 */
1136,
/* 1645 */,
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DeliveryModal = __webpack_require__(1647);
	
	var _DeliveryModal2 = _interopRequireDefault(_DeliveryModal);
	
	var _DeliveryStore = __webpack_require__(1678);
	
	var _DeliveryStore2 = _interopRequireDefault(_DeliveryStore);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _ReadReceipt = __webpack_require__(1670);
	
	var _ReadReceipt2 = _interopRequireDefault(_ReadReceipt);
	
	var _RelationshipModal = __webpack_require__(1309);
	
	var _RelationshipModal2 = _interopRequireDefault(_RelationshipModal);
	
	var _StatusLabel = __webpack_require__(1571);
	
	var _StatusLabel2 = _interopRequireDefault(_StatusLabel);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Time = __webpack_require__(1563);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	var _Timestamp = __webpack_require__(1683);
	
	var _Timestamp2 = _interopRequireDefault(_Timestamp);
	
	var _modal = __webpack_require__(1188);
	
	__webpack_require__(1684);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupMessageInformation = _react2.default.createClass({
	  displayName: 'GroupMessageInformation',
	
	
	  contextTypes: {
	    group: _react2.default.PropTypes.instanceOf(_Group2.default),
	    message: _react2.default.PropTypes.instanceOf(_Message2.default).isRequired
	  },
	
	  mixins: [(0, _linkStateWithStores2.default)([_DeliveryStore2.default])],
	
	  getInitialState: function getInitialState() {
	    return this.getStateFromStores();
	  },
	  getStateFromStores: function getStateFromStores() {
	    return {
	      readReceipt: _DeliveryStore2.default.getDeliveryByMessageId(this.context.message.getUuid())
	    };
	  },
	  renderReadReceipt: function renderReadReceipt() {
	    var _this = this;
	
	    var summary = this.state.readReceipt.getReadSummary();
	    var openReadReceiptModal = function openReadReceiptModal() {
	      (0, _modal.mountModal)(_react2.default.createElement(_DeliveryModal2.default, { message: _this.context.message }), _this);
	    };
	
	    return summary.getState() && _react2.default.createElement(
	      'div',
	      { className: 'GroupMessageInformation-readreceipt' },
	      _react2.default.createElement(_ReadReceipt2.default, {
	        labelDisplay: true,
	        glyphDisplay: true,
	        onClick: openReadReceiptModal,
	        status: summary.getState(),
	        errorCount: summary.getFailedCount()
	      })
	    );
	  },
	  renderRecipients: function renderRecipients() {
	    var group = this.context.group;
	
	    if (!group || !group.isOwnedByUser(_CurrentUser2.default.getUserId())) {
	      return null;
	    }
	
	    var message = this.context.message;
	
	    var recipients = message.getRecipients();
	    if (recipients.length <= 1) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'GroupMessageInformation-recipients' },
	      _react2.default.createElement(
	        'span',
	        { className: 'GroupMessageInformation-bullet' },
	        '\u2022'
	      ),
	      _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          layer: this.renderRecipientsDropdown(),
	          trigger: 'click',
	          placement: 'bottom',
	          alignment: 'middle' },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'GroupMessageInformation-recipients-button',
	            level: 'text',
	            size: 'small',
	            eventElementName: 'GroupMessageInformation-recipients-button' },
	          this.renderRecipientsLabel()
	        )
	      )
	    );
	  },
	  renderRecipientsDropdown: function renderRecipientsDropdown() {
	    var message = this.context.message;
	
	    var recipients = message.getRecipients();
	
	    return _react2.default.createElement(
	      _Menu2.default,
	      null,
	      recipients.map(function (recipient) {
	        var id = recipient.id;
	        if (recipient.isGroup()) {
	          var group = _GroupStore2.default.getGroup(id);
	          if (group) {
	            return _react2.default.createElement(
	              _MenuItem2.default,
	              {
	                key: id,
	                className: 'GroupMessageInformation-recipient',
	                to: '/classes/' + group.getCode() },
	              _react2.default.createElement(_GroupAvatar2.default, {
	                className: 'GroupMessageInformation-recipient-avatar',
	                group: group
	              }),
	              _react2.default.createElement(
	                _Text2.default,
	                { className: 'GroupMessageInformation-recipient-name', truncate: true },
	                _react2.default.createElement(_GroupName2.default, { group: group })
	              )
	            );
	          }
	        }
	
	        if (recipient.isSubscriber()) {
	          return _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: _react2.default.createElement(_RelationshipModal2.default, { userId: id }) },
	            _react2.default.createElement(
	              _MenuItem2.default,
	              { key: id, className: 'GroupMessageInformation-recipient' },
	              _react2.default.createElement(
	                _Text2.default,
	                { className: 'GroupMessageInformation-recipient-name', truncate: true },
	                recipient.getName()
	              )
	            )
	          );
	        }
	
	        var status = void 0;
	        if (recipient.isDeleted()) {
	          status = _react2.default.createElement(
	            _StatusLabel2.default,
	            { className: 'GroupMessageInformation-recipient-status' },
	            'Deleted'
	          );
	        }
	
	        return _react2.default.createElement(
	          _MenuItem2.default,
	          {
	            key: id,
	            className: 'GroupMessageInformation-recipient',
	            disabled: true },
	          _react2.default.createElement(
	            _Text2.default,
	            { className: 'GroupMessageInformation-recipient-name', truncate: true },
	            recipient.getName()
	          ),
	          status
	        );
	      })
	    );
	  },
	  renderRecipientsLabel: function renderRecipientsLabel() {
	    var message = this.context.message;
	
	    var recipients = message.getRecipients();
	
	    var _recipients$getCounts = recipients.getCounts(),
	        group = _recipients$getCounts.group,
	        subscriber = _recipients$getCounts.subscriber;
	
	    var label = void 0;
	    // FIXME: Sigh. This alone makes me want to do the work involved to get Intl.MessageFormat's
	    // pluralization working with our i18n tool.
	    if (message.getStatus() === 'scheduled') {
	      label = group === 1 ? 'Sending to 1 class' : 'Sending to ' + group + ' classes';
	    } else {
	      if (group === 1) {
	        if (subscriber === 1) {
	          label = 'Sent to 1 class and 1 person';
	        } else if (subscriber > 1) {
	          label = 'Sent to 1 class and ' + subscriber + ' people';
	        } else {
	          label = 'Sent to 1 class';
	        }
	      } else if (group > 1) {
	        if (subscriber === 1) {
	          label = 'Sent to ' + group + ' classes and 1 person';
	        } else if (subscriber > 1) {
	          label = 'Sent to ' + group + ' classes and ' + subscriber + ' people';
	        } else {
	          label = 'Sent to ' + group + ' classes';
	        }
	      } else {
	        if (subscriber === 1) {
	          label = 'Sent to ' + subscriber + ' person';
	        } else if (subscriber > 1) {
	          label = 'Sent to ' + subscriber + ' people';
	        }
	      }
	    }
	    return label;
	  },
	  renderTimestamp: function renderTimestamp() {
	    var message = this.context.message;
	
	
	    if (message.getStatus() === 'failed') {
	      return _react2.default.createElement(
	        'div',
	        { className: 'GroupMessageInformation-timestamp' },
	        _react2.default.createElement(
	          'span',
	          { className: 'GroupMessageInformation-failed' },
	          'An error has occurred. Please edit your message and send again.'
	        )
	      );
	    }
	
	    var time = void 0;
	    var date = void 0;
	    var glyph = void 0;
	    if (message.getStatus() === 'scheduled') {
	      time = _react2.default.createElement(_Time2.default, { date: message.getSendAt(), hour: 'numeric', minute: '2-digit' });
	      date = _react2.default.createElement(_Time2.default, { date: message.getSendAt(), day: 'numeric', month: 'long', year: 'numeric' });
	      glyph = _react2.default.createElement(_Glyph2.default, { className: 'GroupMessageInformation-clock', name: 'schedule', size: 'small' });
	    } else {
	      time = _react2.default.createElement(_Time2.default, { date: message.getSentAt(), hour: 'numeric', minute: '2-digit' });
	      date = _react2.default.createElement(_Timestamp2.default, { date: message.getSentAt() });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'GroupMessageInformation-timestamp' },
	      glyph,
	      date,
	      ' at ',
	      time
	    );
	  },
	  render: function render() {
	    var shouldRenderReadReceipt = this.props.showReadReceipt && this.state.readReceipt;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'GroupMessageInformation' },
	      this.renderTimestamp(),
	      _CurrentUser2.default.isSignedIn() && shouldRenderReadReceipt && this.renderReadReceipt(),
	      _CurrentUser2.default.isSignedIn() && this.renderRecipients()
	    );
	  }
	});
	
	exports.default = GroupMessageInformation;

/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _DeliveryConstants = __webpack_require__(1648);
	
	var _DeliveryModalCounters = __webpack_require__(1649);
	
	var _DeliveryModalCounters2 = _interopRequireDefault(_DeliveryModalCounters);
	
	var _DeliveryModalFocusedErrorView = __webpack_require__(1661);
	
	var _DeliveryModalFocusedErrorView2 = _interopRequireDefault(_DeliveryModalFocusedErrorView);
	
	var _DeliveryModalList = __webpack_require__(1665);
	
	var _DeliveryModalList2 = _interopRequireDefault(_DeliveryModalList);
	
	var _DeliveryModalListItem = __webpack_require__(1666);
	
	var _DeliveryModalListItem2 = _interopRequireDefault(_DeliveryModalListItem);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _DialogBody = __webpack_require__(1669);
	
	var _DialogBody2 = _interopRequireDefault(_DialogBody);
	
	var _Row = __webpack_require__(1482);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _MessageDeliverySummary = __webpack_require__(1658);
	
	var _MessageDeliverySummary2 = _interopRequireDefault(_MessageDeliverySummary);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReadReceipt = __webpack_require__(1670);
	
	var _ReadReceipt2 = _interopRequireDefault(_ReadReceipt);
	
	var _ScrollableArea = __webpack_require__(1412);
	
	var _ScrollableArea2 = _interopRequireDefault(_ScrollableArea);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	__webpack_require__(1676);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line
	// eslint-disable-line
	
	
	var DeliveryModal = function (_React$Component) {
	  _inherits(DeliveryModal, _React$Component);
	
	  function DeliveryModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DeliveryModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeliveryModal.__proto__ || Object.getPrototypeOf(DeliveryModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      focusedUser: null
	    }, _this.setFocusedUser = function (focusedUser) {
	      _this.setState({ focusedUser: focusedUser });
	    }, _this.clearFocusedUser = function () {
	      _this.setState({ focusedUser: null });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DeliveryModal, [{
	    key: 'getAvatar',
	    value: function getAvatar(text, colorHex) {
	      return _react2.default.createElement(_Avatar2.default, { size: 'small', text: text, colorHex: colorHex || undefined });
	    }
	  }, {
	    key: 'getReadReceiptIcon',
	    value: function getReadReceiptIcon(status) {
	      return _react2.default.createElement(_ReadReceipt2.default, { iconSize: 'xxxsmall', labelDisplay: true, glyphDisplay: true, status: status });
	    }
	  }, {
	    key: 'renderDeliverySuccess',
	    value: function renderDeliverySuccess() {
	      var _this2 = this;
	
	      var summary = this.props.summary;
	
	
	      if (!summary) {
	        return null;
	      }
	
	      if (summary.getSuccessUsers().length === 0) {
	        var success = summary.getSuccessCount();
	
	        return _react2.default.createElement(
	          _DeliveryModalList2.default,
	          { title: 'Delivered' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _Text2.default,
	              { color: 'thunder', size: 'xxsmall' },
	              'This data isn\u2019t currently available.',
	              _react2.default.createElement('br', null),
	              success === 1 && 'The message was delivered to ' + success + ' participant.',
	              success > 1 && 'The message was delivered to ' + success + ' participants.'
	            )
	          )
	        );
	      }
	
	      var renderedSuccessDeliveries = summary.getSuccessUsers().map(function (user) {
	        return _react2.default.createElement(_DeliveryModalListItem2.default, {
	          avatar: user.initials && _this2.getAvatar(user.initials, user.color),
	          key: user.uuid,
	          text: user.name,
	          info: _this2.getReadReceiptIcon(_DeliveryConstants.DeliveryStatus.DELIVERED)
	        });
	      });
	
	      return _react2.default.createElement(
	        _DeliveryModalList2.default,
	        { title: 'Delivered' },
	        renderedSuccessDeliveries
	      );
	    }
	  }, {
	    key: 'renderRead',
	    value: function renderRead() {
	      var _this3 = this;
	
	      var summary = this.props.summary;
	
	
	      if (!summary) {
	        return null;
	      }
	
	      var renderedRead = summary.getReadUsers().map(function (user) {
	        return _react2.default.createElement(_DeliveryModalListItem2.default, {
	          avatar: user.initials && _this3.getAvatar(user.initials, user.color),
	          key: user.uuid,
	          text: user.name,
	          info: _this3.getReadReceiptIcon(_DeliveryConstants.DeliveryStatus.READ)
	        });
	      });
	
	      return _react2.default.createElement(
	        _DeliveryModalList2.default,
	        {
	          title: 'Read',
	          subtext: 'Read receipts are available for messages viewed on the app and attachments viewed via\n          text or email.' },
	        renderedRead
	      );
	    }
	  }, {
	    key: 'renderDeliveryError',
	    value: function renderDeliveryError() {
	      var _this4 = this;
	
	      var summary = this.props.summary;
	
	
	      if (!summary) {
	        return null;
	      }
	
	      var renderedErroredDeliveries = summary.getFailedUsers().map(function (user) {
	        return _react2.default.createElement(
	          _Link2.default,
	          {
	            key: user.uuid,
	            color: 'inherit',
	            onClick: function onClick() {
	              return _this4.setFocusedUser(user);
	            } },
	          _react2.default.createElement(_DeliveryModalListItem2.default, {
	            avatar: user.initials && _this4.getAvatar(user.initials, user.color),
	            info: _this4.getReadReceiptIcon(_DeliveryConstants.DeliveryStatus.DELIVERY_ERROR),
	            text: user.name
	          })
	        );
	      });
	
	      return _react2.default.createElement(
	        _DeliveryModalList2.default,
	        { title: 'Delivery errors' },
	        _react2.default.createElement(
	          _Row2.default,
	          null,
	          renderedErroredDeliveries
	        )
	      );
	    }
	  }, {
	    key: 'renderNotAvailable',
	    value: function renderNotAvailable() {
	      var title = 'Delivery summary not available';
	      var subtext = void 0;
	
	      if (this.props.tooSoon) {
	        title = 'Check back later';
	        subtext = 'Your delivery summary might take a few seconds to load. It should be ready soon!';
	      }
	
	      return _react2.default.createElement(_TitleHeader2.default, {
	        image: __webpack_require__(1664),
	        imageClassName: 'DeliveryModal-unavailableImage',
	        title: title,
	        subtext: subtext,
	        bottomMargin: 'none',
	        size: 'small'
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var summary = this.props.summary;
	
	
	      if (!summary) {
	        if (this.props.loaded) {
	          return this.renderNotAvailable();
	        } else {
	          return _react2.default.createElement(_LoadingIndicator2.default, { height: 400 });
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Row2.default,
	          null,
	          _react2.default.createElement(_DeliveryModalCounters2.default, { summary: summary })
	        ),
	        _react2.default.createElement(
	          _ScrollableArea2.default,
	          { className: 'DeliveryModal-details' },
	          summary.getFailedCount() > 0 && this.renderDeliveryError(),
	          summary.getMessageType() === 'broadcast' && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Row2.default,
	              null,
	              this.renderRead()
	            ),
	            this.renderDeliverySuccess()
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.focusedUser) {
	        return _react2.default.createElement(_DeliveryModalFocusedErrorView2.default, _extends({}, this.props, {
	          name: this.state.focusedUser.name,
	          onClose: this.clearFocusedUser
	        }));
	      }
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'DeliveryModal'
	        }, this.props, {
	          className: 'DeliveryModal',
	          size: 'small',
	          title: 'Delivery summary' }),
	        _react2.default.createElement(
	          _DialogBody2.default,
	          null,
	          this.renderContent()
	        )
	      );
	    }
	  }]);
	
	  return DeliveryModal;
	}(_react2.default.Component);
	
	DeliveryModal.displayName = 'DeliveryModal';
	exports.default = DeliveryModal;

/***/ },
/* 1648 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DeliveryStatus = exports.DeliveryStatus = {
	  SENT: 'sent',
	  READ: 'read',
	  DELIVERED: 'delivered',
	  DELIVERY_ERROR: 'delivery_error',
	  PENDING_INITIAL_ACK: 'pending_initial_ack'
	};

/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Counter = __webpack_require__(1650);
	
	var _Counter2 = _interopRequireDefault(_Counter);
	
	var _MessageDeliverySummary = __webpack_require__(1658);
	
	var _MessageDeliverySummary2 = _interopRequireDefault(_MessageDeliverySummary);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1659);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeliveryModalCounters = function (_React$Component) {
	  _inherits(DeliveryModalCounters, _React$Component);
	
	  function DeliveryModalCounters() {
	    _classCallCheck(this, DeliveryModalCounters);
	
	    return _possibleConstructorReturn(this, (DeliveryModalCounters.__proto__ || Object.getPrototypeOf(DeliveryModalCounters)).apply(this, arguments));
	  }
	
	  _createClass(DeliveryModalCounters, [{
	    key: 'render',
	    value: function render() {
	      var summary = this.props.summary;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('DeliveryModalCounters', this.props.className) },
	        _react2.default.createElement(_Counter2.default, {
	          className: 'DeliveryModalCounters-counter',
	          value: summary.getFailedCount(),
	          label: summary.getFailedCount() === 1 ? 'Error' : 'Errors'
	        }),
	        _react2.default.createElement(_Counter2.default, {
	          className: 'DeliveryModalCounters-counter',
	          value: summary.getReadCount(),
	          label: 'Read'
	        }),
	        _react2.default.createElement(_Counter2.default, {
	          className: 'DeliveryModalCounters-counter',
	          value: summary.getSuccessCount(),
	          label: 'Delivered'
	        })
	      );
	    }
	  }]);
	
	  return DeliveryModalCounters;
	}(_react2.default.Component);
	
	DeliveryModalCounters.displayName = 'DeliveryModalCounters';
	exports.default = DeliveryModalCounters;

/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MoneyCounter = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Money = __webpack_require__(1651);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(1656);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var Counter = function (_React$Component) {
	  _inherits(Counter, _React$Component);
	
	  function Counter() {
	    _classCallCheck(this, Counter);
	
	    return _possibleConstructorReturn(this, (Counter.__proto__ || Object.getPrototypeOf(Counter)).apply(this, arguments));
	  }
	
	  _createClass(Counter, [{
	    key: 'render',
	    value: function render() {
	      var label = this.props.label;
	
	      var value = this.props.value || 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('Counter', this.props.className) },
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            className: 'Counter-text',
	            size: this.props.valueSize,
	            weight: this.props.valueWeight },
	          value
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            className: 'Counter-text',
	            size: this.props.labelSize,
	            weight: this.props.labelWeight },
	          label
	        )
	      );
	    }
	  }]);
	
	  return Counter;
	}(_react2.default.Component);
	
	Counter.defaultProps = {
	  labelSize: 'xsmall',
	  labelWeight: 'normal',
	  valueSize: 'xxxxlarge',
	  valueWeight: 'normal'
	};
	Counter.displayName = 'Counter';
	var MoneyCounter = function MoneyCounter(_ref) {
	  var cents = _ref.cents,
	      rest = _objectWithoutProperties(_ref, ['cents']);
	
	  return _react2.default.createElement(Counter, _extends({ value: _react2.default.createElement(_Money2.default, { cents: cents }) }, rest));
	};
	
	exports.MoneyCounter = MoneyCounter;
	exports.default = Counter;

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Currencies = __webpack_require__(1652);
	
	var _Currencies2 = _interopRequireDefault(_Currencies);
	
	var _MoneyFormatter = __webpack_require__(1653);
	
	var _MoneyFormatter2 = _interopRequireDefault(_MoneyFormatter);
	
	__webpack_require__(1654);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Payment is US only right now but
	// this component idea is to be (or wrap) our currency formatter.
	//
	// <Money cents="1000" currency="EUR" /> == 10€
	// <Money cents="1000" currency="USD" /> == $10
	//
	var Money = function Money(_ref) {
	  var cents = _ref.cents,
	      _ref$currency = _ref.currency,
	      currency = _ref$currency === undefined ? _Currencies2.default.USD : _ref$currency,
	      _ref$displaySeparator = _ref.displaySeparator,
	      displaySeparator = _ref$displaySeparator === undefined ? true : _ref$displaySeparator,
	      className = _ref.className;
	
	  var money = new _MoneyFormatter2.default(cents, currency);
	
	  return _react2.default.createElement(
	    'span',
	    { className: (0, _classnames2.default)('Money', className) },
	    _react2.default.createElement(
	      'div',
	      { className: 'Money-container' },
	      money.getPrefix() && _react2.default.createElement(
	        'span',
	        { className: 'Money-currency Money-currency-prefix' },
	        money.getPrefix()
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        money.getWhole() && _react2.default.createElement(
	          'span',
	          { className: 'Money-amount Money-whole' },
	          money.getWhole()
	        ),
	        money.getCents() && displaySeparator && _react2.default.createElement(
	          'span',
	          { className: 'Money-amount Money-separator' },
	          money.getSeparator()
	        ),
	        money.getCents() && _react2.default.createElement(
	          'span',
	          { className: 'Money-amount Money-cents' },
	          money.getCents()
	        )
	      ),
	      money.getSuffix() && _react2.default.createElement(
	        'span',
	        { className: 'Money-currency Money-currency-suffix' },
	        money.getSuffix()
	      )
	    )
	  );
	}; /*  weak */
	exports.default = Money;

/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CURRENCIES = (0, _enumerate2.default)(['USD', 'EUR']); /*  weak */
	exports.default = CURRENCIES;

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Currencies = __webpack_require__(1652);
	
	var _Currencies2 = _interopRequireDefault(_Currencies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MoneyFormatter = function () {
	  function MoneyFormatter() {
	    var cents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Currencies2.default.USD;
	
	    _classCallCheck(this, MoneyFormatter);
	
	    this.cents = cents;
	    this.currency = currency;
	  }
	
	  /* Return this appropriate number formatter
	   * @param minimumFractionDigits integer
	   */
	
	
	  _createClass(MoneyFormatter, [{
	    key: 'getNumberFormatter',
	    value: function getNumberFormatter() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var locale = null;
	
	      switch (this.currency) {
	        case _Currencies2.default.USD:
	        default:
	          locale = 'en-US';
	      }
	
	      return new window.Intl.NumberFormat(locale, options);
	    }
	  }, {
	    key: 'format',
	    value: function format(number) {
	      if (number % 1) {
	        return this.getNumberFormatter({ minimumFractionDigits: 2 }).format(number);
	      }
	
	      return this.getNumberFormatter().format(number);
	    }
	  }, {
	    key: 'getPrefix',
	    value: function getPrefix() {
	      switch (this.currency) {
	        case _Currencies2.default.USD:
	          return '$';
	        default:
	          return null;
	      }
	    }
	
	    // Return the whole part of the amount (12.50 -> 12)
	
	  }, {
	    key: 'getWhole',
	    value: function getWhole() {
	      return this.format(Math.floor(this._getNumericAmount()));
	    }
	
	    // Return the cent part of the amount (12.50 -> 50)
	    // always prepend 0 when between 1 and 9 (12.05 -> 05)
	
	  }, {
	    key: 'getCents',
	    value: function getCents() {
	      var cents = this.cents % 100;
	
	      if (cents === 0) {
	        return null;
	      }
	
	      if (cents > 0 && cents < 10) {
	        cents = '0' + cents;
	      }
	
	      return cents.toString();
	    }
	  }, {
	    key: 'getSeparator',
	    value: function getSeparator() {
	      switch (this.currency) {
	        default:
	          return '.';
	      }
	    }
	
	    // Returns the amount without formatting (1250 -> 12.50,
	    // rather than 1250 -> '12.50')
	
	  }, {
	    key: '_getNumericAmount',
	    value: function _getNumericAmount() {
	      return this.cents / 100;
	    }
	
	    // Return the amount (1250 -> '12.50')
	
	  }, {
	    key: 'getAmount',
	    value: function getAmount() {
	      return this.format(this._getNumericAmount());
	    }
	  }, {
	    key: 'getSuffix',
	    value: function getSuffix() {
	      switch (this.currency) {
	        case _Currencies2.default.EUR:
	          return '€';
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return (this.getPrefix() || '') + String(this.getAmount()) + (this.getSuffix() || '');
	    }
	  }]);
	
	  return MoneyFormatter;
	}();
	
	MoneyFormatter.displayName = 'MoneyFormatter';
	exports.default = MoneyFormatter;

/***/ },
/* 1654 */
1136,
/* 1655 */,
/* 1656 */
1136,
/* 1657 */,
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageDeliverySummary = function (_Entity) {
	  _inherits(MessageDeliverySummary, _Entity);
	
	  function MessageDeliverySummary() {
	    _classCallCheck(this, MessageDeliverySummary);
	
	    return _possibleConstructorReturn(this, (MessageDeliverySummary.__proto__ || Object.getPrototypeOf(MessageDeliverySummary)).apply(this, arguments));
	  }
	
	  _createClass(MessageDeliverySummary, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.idAttribute = 'message_uuid';
	    }
	  }, {
	    key: 'getMessageType',
	    value: function getMessageType() {
	      return this.get('message_type');
	    }
	  }, {
	    key: 'getState',
	    value: function getState() {
	      return this.get('state');
	    }
	  }, {
	    key: 'setState',
	    value: function setState(state) {
	      this.set('state', state);
	    }
	  }, {
	    key: 'getSuccessCount',
	    value: function getSuccessCount() {
	      return this.get('success_count') || 0;
	    }
	  }, {
	    key: 'getReadCount',
	    value: function getReadCount() {
	      return this.get('read_count') || 0;
	    }
	  }, {
	    key: 'getFailedCount',
	    value: function getFailedCount() {
	      return this.get('failed_count') || 0;
	    }
	  }, {
	    key: 'getTotalSent',
	    value: function getTotalSent() {
	      return this.getSuccessCount() + this.getReadCount() + this.getFailedCount();
	    }
	  }, {
	    key: 'getSteamUUID',
	    value: function getSteamUUID() {
	      return this.get('stream_uuid');
	    }
	  }, {
	    key: 'getSuccessUsers',
	    value: function getSuccessUsers() {
	      return this.get('success_users') || [];
	    }
	  }, {
	    key: 'getReadUsers',
	    value: function getReadUsers() {
	      return this.get('read_users') || [];
	    }
	  }, {
	    key: 'getFailedUsers',
	    value: function getFailedUsers() {
	      return this.get('failed_users') || [];
	    }
	  }]);
	
	  return MessageDeliverySummary;
	}(_Entity3.default);
	
	MessageDeliverySummary.displayName = 'MessageDeliverySummary';
	exports.default = MessageDeliverySummary;

/***/ },
/* 1659 */
1136,
/* 1660 */,
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(1662);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeliveryModalFocusedErrorView = function (_React$Component) {
	  _inherits(DeliveryModalFocusedErrorView, _React$Component);
	
	  function DeliveryModalFocusedErrorView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DeliveryModalFocusedErrorView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeliveryModalFocusedErrorView.__proto__ || Object.getPrototypeOf(DeliveryModalFocusedErrorView)).call.apply(_ref, [this].concat(args))), _this), _this.getTitle = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        'We\u2019re having trouble sending messages to ',
	        _this.props.name
	      );
	    }, _this.getSubText = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _this.props.name,
	        ' may not have a device or phone number that can receive your messages. Please contact ',
	        _this.props.name,
	        ' directly.'
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DeliveryModalFocusedErrorView, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'DeliveryModalFocusedErrorView'
	        }, this.props, {
	          title: this.getTitle(),
	          subtext: this.getSubText(),
	          image: __webpack_require__(1664),
	          className: 'DeliveryModalFocusedErrorView-dialog',
	          size: 'medium' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'DeliveryModalFocusedErrorView-body' },
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: this.props.onClose },
	            'OK, got it!'
	          )
	        )
	      );
	    }
	  }]);
	
	  return DeliveryModalFocusedErrorView;
	}(_react2.default.Component);
	
	DeliveryModalFocusedErrorView.displayName = 'DeliveryModalFocusedErrorView';
	exports.default = DeliveryModalFocusedErrorView;

/***/ },
/* 1662 */
1136,
/* 1663 */,
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b7f44f79b0a5e81ff93663e4358e872c.png";

/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Heading = __webpack_require__(1436);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeliveryModalList = function (_React$Component) {
	  _inherits(DeliveryModalList, _React$Component);
	
	  function DeliveryModalList() {
	    _classCallCheck(this, DeliveryModalList);
	
	    return _possibleConstructorReturn(this, (DeliveryModalList.__proto__ || Object.getPrototypeOf(DeliveryModalList)).apply(this, arguments));
	  }
	
	  _createClass(DeliveryModalList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          subtext = _props.subtext,
	          children = _props.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'DeliveryModalList' },
	        _react2.default.createElement(
	          _Heading2.default,
	          { align: 'left', level: '3' },
	          title
	        ),
	        subtext && _react2.default.createElement(
	          _Text2.default,
	          { color: 'thunder', element: 'p', size: 'xxsmall' },
	          subtext
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          children
	        )
	      );
	    }
	  }]);
	
	  return DeliveryModalList;
	}(_react2.default.Component);
	
	DeliveryModalList.displayName = 'DeliveryModalList';
	exports.default = DeliveryModalList;

/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _MediaObject = __webpack_require__(1396);
	
	var _MediaObject2 = _interopRequireDefault(_MediaObject);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1667);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeliveryModalListItem = function (_React$Component) {
	  _inherits(DeliveryModalListItem, _React$Component);
	
	  function DeliveryModalListItem() {
	    _classCallCheck(this, DeliveryModalListItem);
	
	    return _possibleConstructorReturn(this, (DeliveryModalListItem.__proto__ || Object.getPrototypeOf(DeliveryModalListItem)).apply(this, arguments));
	  }
	
	  _createClass(DeliveryModalListItem, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'li',
	        { className: (0, _classnames2.default)('DeliveryModalListItem', this.props.className) },
	        _react2.default.createElement(
	          _FlexibleBlock2.default,
	          { flex: 'left' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _MediaObject2.default,
	              { center: true, gutter: 'small' },
	              _react2.default.createElement(
	                'div',
	                null,
	                this.props.image && _react2.default.createElement(_Image2.default, { className: 'DeliveryModalListItem-image', src: this.props.image }),
	                this.props.avatar
	              ),
	              this.props.text
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'DeliveryModalListItem-info' },
	            this.props.info
	          )
	        )
	      );
	    }
	  }]);
	
	  return DeliveryModalListItem;
	}(_react2.default.Component);
	
	DeliveryModalListItem.displayName = 'DeliveryModalListItem';
	exports.default = DeliveryModalListItem;

/***/ },
/* 1667 */
1136,
/* 1668 */,
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogBody = function (_React$Component) {
	  _inherits(DialogBody, _React$Component);
	
	  function DialogBody() {
	    _classCallCheck(this, DialogBody);
	
	    return _possibleConstructorReturn(this, (DialogBody.__proto__ || Object.getPrototypeOf(DialogBody)).apply(this, arguments));
	  }
	
	  _createClass(DialogBody, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _BoxBody2.default,
	        { full: this.props.full },
	        this.props.children
	      );
	    }
	  }]);
	
	  return DialogBody;
	}(_react2.default.Component);
	
	DialogBody.displayName = 'DialogBody';
	exports.default = DialogBody;

/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CircleSpinner = __webpack_require__(1579);
	
	var _CircleSpinner2 = _interopRequireDefault(_CircleSpinner);
	
	var _Coin = __webpack_require__(1671);
	
	var _Coin2 = _interopRequireDefault(_Coin);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DeliveryConstants = __webpack_require__(1648);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(555);
	
	__webpack_require__(1674);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var ReadReceipt = function (_React$Component) {
	  _inherits(ReadReceipt, _React$Component);
	
	  function ReadReceipt() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReadReceipt);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReadReceipt.__proto__ || Object.getPrototypeOf(ReadReceipt)).call.apply(_ref, [this].concat(args))), _this), _this.renderDelivered = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _this.props.labelDisplay && _react2.default.createElement(
	          'span',
	          null,
	          'Delivered'
	        ),
	        _this.props.glyphDisplay && _react2.default.createElement(
	          _Coin2.default,
	          { className: 'ReadReceipt-icon', color: 'shamrock', size: _this.props.iconSize },
	          _react2.default.createElement(_Glyph2.default, { color: 'white', name: 'check', solo: true })
	        )
	      );
	    }, _this.renderDeliveryError = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _this.props.labelDisplay && _react2.default.createElement(
	          'span',
	          null,
	          _this.props.errorCount && _this.props.errorCount + ' ',
	          _this.props.errorCount && _this.props.errorCount > 1 ? 'Delivery errors' : 'Delivery error'
	        ),
	        _this.props.glyphDisplay && _react2.default.createElement(
	          _Coin2.default,
	          {
	            className: 'ReadReceipt-icon',
	            border: 'sunrise',
	            size: _this.props.iconSize },
	          _react2.default.createElement(_Glyph2.default, { color: 'sunrise', name: 'explanation', solo: true })
	        )
	      );
	    }, _this.renderPendingInitialAck = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _this.props.labelDisplay && _react2.default.createElement(
	          'span',
	          null,
	          'Sending'
	        ),
	        _this.props.glyphDisplay && _react2.default.createElement(_CircleSpinner2.default, {
	          className: 'ReadReceipt-icon',
	          color: 'shamrock',
	          size: 'small'
	        })
	      );
	    }, _this.renderRead = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _this.props.labelDisplay && _react2.default.createElement(
	          'span',
	          null,
	          'Read'
	        ),
	        _this.props.glyphDisplay && _react2.default.createElement(
	          _Coin2.default,
	          { className: 'ReadReceipt-icon', color: 'brand', size: _this.props.iconSize },
	          _react2.default.createElement(_Glyph2.default, { color: 'white', name: 'check', solo: true })
	        )
	      );
	    }, _this.renderSent = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _this.props.labelDisplay && _react2.default.createElement(
	          'span',
	          null,
	          'Sent'
	        ),
	        _this.props.glyphDisplay && _react2.default.createElement(
	          _Coin2.default,
	          { className: 'ReadReceipt-icon', border: 'shamrock', size: _this.props.iconSize },
	          _react2.default.createElement(_Glyph2.default, { color: 'shamrock', name: 'check', solo: true })
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReadReceipt, [{
	    key: 'render',
	    value: function render() {
	      var _DeliveryStatus$SENT$;
	
	      var presenter = (_DeliveryStatus$SENT$ = {}, _defineProperty(_DeliveryStatus$SENT$, _DeliveryConstants.DeliveryStatus.SENT, this.renderSent), _defineProperty(_DeliveryStatus$SENT$, _DeliveryConstants.DeliveryStatus.READ, this.renderRead), _defineProperty(_DeliveryStatus$SENT$, _DeliveryConstants.DeliveryStatus.DELIVERED, this.renderDelivered), _defineProperty(_DeliveryStatus$SENT$, _DeliveryConstants.DeliveryStatus.DELIVERY_ERROR, this.renderDeliveryError), _defineProperty(_DeliveryStatus$SENT$, _DeliveryConstants.DeliveryStatus.PENDING_INITIAL_ACK, this.renderPendingInitialAck), _DeliveryStatus$SENT$)[this.props.status];
	
	      return presenter && _react2.default.createElement(
	        'span',
	        {
	          className: (0, _classnames2.default)('ReadReceipt', {
	            'ReadReceipt-link': !!this.props.onClick
	          }),
	          onClick: this.props.onClick },
	        presenter()
	      );
	    }
	  }]);
	
	  return ReadReceipt;
	}(_react2.default.Component);
	
	ReadReceipt.defaultProps = {
	  iconSize: 'xxxsmall',
	  onClick: function onClick() {}
	};
	ReadReceipt.displayName = 'ReadReceipt';
	exports.default = ReadReceipt;

/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1672);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var COLORS = ['lava', 'flame', 'sunrise', 'shamrock', 'jungle', 'brand', 'violet', 'thunder', 'midnight', 'eclipse', 'koala', 'pitch', 'white', 'facebook', 'pinterest', 'twitter'];
	
	/**
	 * A component that renders a circle containing centered content.
	 *
	 *
	 * ```example
	 *  <div>
	 *    <Coin color="brand" size="xxxlarge">
	 *      <Text color="white">
	 *        <Glyph name="check" />
	 *      </Text>
	 *    </Coin>
	 *    <Coin color="lava" size="xlarge">
	 *      <Text color="white">
	 *        <Glyph name="check" />
	 *      </Text>
	 *    </Coin>
	 *    <Coin border="jungle" size="medium">
	 *      <Text color="jungle">
	 *        <Glyph name="check" />
	 *      </Text>
	 *    </Coin>
	 *    <Coin border="lava" size="xxxsmall">
	 *      <Text color="lava">
	 *        <Glyph name="check" />
	 *      </Text>
	 *    </Coin>
	 *  </div>
	 * ```
	 */
	
	var Coin = function (_React$Component) {
	  _inherits(Coin, _React$Component);
	
	  function Coin() {
	    _classCallCheck(this, Coin);
	
	    return _possibleConstructorReturn(this, (Coin.__proto__ || Object.getPrototypeOf(Coin)).apply(this, arguments));
	  }
	
	  _createClass(Coin, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)('Coin', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className) },
	        _react2.default.createElement(
	          'span',
	          { className: 'Coin-content' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Coin;
	}(_react2.default.Component);
	
	Coin.propClasses = {
	  color: _lodash2.default.zipObject(COLORS, _lodash2.default.map(COLORS, function (color) {
	    return 'Coin-color-' + color;
	  })),
	  border: _lodash2.default.zipObject(COLORS, _lodash2.default.map(COLORS, function (color) {
	    return 'Coin-border-' + color;
	  })),
	  size: {
	    xxxsmall: 'Coin-sizeXxxSmall',
	    xxsmall: 'Coin-sizeXxSmall',
	    xsmall: 'Coin-sizeXSmall',
	    small: 'Coin-sizeSmall',
	    medium: 'Coin-sizeMedium',
	    large: 'Coin-sizeLarge',
	    xlarge: 'Coin-sizeXLarge',
	    xxlarge: 'Coin-sizeXxLarge',
	    xxxlarge: 'Coin-sizeXxxLarge'
	  }
	};
	Coin.displayName = 'Coin';
	exports.default = Coin;

/***/ },
/* 1672 */
1136,
/* 1673 */,
/* 1674 */
1136,
/* 1675 */,
/* 1676 */
1136,
/* 1677 */,
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _ChatConstants = __webpack_require__(941);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _ChatMessageDelivery = __webpack_require__(1679);
	
	var _ChatMessageDelivery2 = _interopRequireDefault(_ChatMessageDelivery);
	
	var _DeliveryConstants = __webpack_require__(1648);
	
	var _GroupConstants = __webpack_require__(991);
	
	var _GroupMessageDelivery = __webpack_require__(1681);
	
	var _GroupMessageDelivery2 = _interopRequireDefault(_GroupMessageDelivery);
	
	var _MessageDeliveries = __webpack_require__(1682);
	
	var _MessageDeliveries2 = _interopRequireDefault(_MessageDeliveries);
	
	var _PusherConstants = __webpack_require__(954);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Marker = function Marker(attr) {
	  _classCallCheck(this, Marker);
	
	  this.readSeq = attr['read_seq'];
	  this.updatedAt = attr['updated_at'];
	};
	
	Marker.displayName = 'Marker';
	
	var DeliveryStore = function (_Store) {
	  _inherits(DeliveryStore, _Store);
	
	  function DeliveryStore() {
	    _classCallCheck(this, DeliveryStore);
	
	    return _possibleConstructorReturn(this, (DeliveryStore.__proto__ || Object.getPrototypeOf(DeliveryStore)).apply(this, arguments));
	  }
	
	  _createClass(DeliveryStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        deliveries: new _MessageDeliveries2.default(),
	        markers: {}
	      };
	    }
	  }, {
	    key: 'getDeliveryByMessageId',
	    value: function getDeliveryByMessageId(id) {
	      /* We need to clone the deliveries so that containers
	       * know to rerender when performing a shallow comparison
	       * of the otherwise unchanged backbone collection.
	      */
	      var delivery = this.state.deliveries.findWhereMessageId(id);
	      return delivery && delivery.clone();
	    }
	  }, {
	    key: 'storeDeliveries',
	    value: function storeDeliveries(deliveries) {
	      this.state.deliveries.add(deliveries);
	    }
	  }, {
	    key: 'getMarkerForStream',
	    value: function getMarkerForStream(streamId) {
	      return this.state.markers[streamId];
	    }
	  }, {
	    key: 'storeMarkersForSteam',
	    value: function storeMarkersForSteam(streamId, markers) {
	      this.state.markers[streamId] = Object.assign(this.state.markers[streamId] || {}, markers);
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      var delivery = void 0;
	      var chatMessages = void 0;
	
	      switch (action.type) {
	        case _GroupConstants.ActionTypes.LIST_GROUP_MESSAGES:
	          {
	            var deliveries = action.messages.map(function (groupMessage) {
	              return _GroupMessageDelivery2.default.createFromGroupMessage(groupMessage);
	            });
	
	            this.storeDeliveries(deliveries);
	            this.emitChange();
	            break;
	          }
	        case _GroupConstants.ActionTypes.SEND_GROUP_MESSAGE:
	          delivery = _GroupMessageDelivery2.default.createFromGroupMessage(action.message);
	          this.storeDeliveries([delivery]);
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.SENT_MESSAGE:
	          delivery = _ChatMessageDelivery2.default.createFromChatMessage(action.message);
	          this.storeDeliveries([delivery]);
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.SEND_MESSAGE:
	          delivery = _ChatMessageDelivery2.default.createFromChatMessage(action.message);
	          delivery.setReadSummaryState(_DeliveryConstants.DeliveryStatus.PENDING_INITIAL_ACK);
	          this.storeDeliveries([delivery]);
	          this.emitChange();
	          break;
	        case _ChatConstants.ActionTypes.LOAD_CHAT_MESSAGES:
	          {
	            // filter only the ChatMessage, no GapChatMessage ect.
	            chatMessages = action.messages.filter(function (message) {
	              return message instanceof _ChatMessage2.default;
	            });
	
	            // Create the deliveries from ChatMessages.
	            var _deliveries = chatMessages.map(function (chatMessage) {
	              return _ChatMessageDelivery2.default.createFromChatMessage(chatMessage);
	            });
	
	            this.storeDeliveries(_deliveries);
	            this.emitChange();
	            break;
	          }
	        case _PusherConstants.PushEvents.CHANGESET_CREATE_CHAT_MESSAGE:
	          {
	            var _deliveries2 = action.changes.map(function (change) {
	              return (0, _ChatMessage.chatMessageFactory)(change.content);
	            }).map(function (message) {
	              return _ChatMessageDelivery2.default.createFromChatMessage(message);
	            });
	
	            if (_deliveries2.length > 0) {
	              this.storeDeliveries(_deliveries2);
	              this.emitChange();
	            }
	            break;
	          }
	        case _PusherConstants.PushEvents.CHANGESET_UPDATE_DELIVERY_UPDATES:
	          {
	            var _deliveries3 = action.changes.map(function (change) {
	              return _ChatMessageDelivery2.default.fromJSON(change.content);
	            });
	            this.storeDeliveries(_deliveries3);
	            this.emitChange();
	            break;
	          }
	        case _PusherConstants.PushEvents.MARKER_UPDATE:
	          {
	            var data = action.eventData.data.v2;
	            var marker = new Marker(data.markers);
	            this.storeMarkersForSteam(data['stream_uuid'], marker);
	            this.emitChange();
	            break;
	          }
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return DeliveryStore;
	}(_Store3.default);
	
	DeliveryStore.displayName = 'DeliveryStore';
	exports.default = new DeliveryStore();

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _MessageDelivery2 = __webpack_require__(1680);
	
	var _MessageDelivery3 = _interopRequireDefault(_MessageDelivery2);
	
	var _MessageDeliverySummary = __webpack_require__(1658);
	
	var _MessageDeliverySummary2 = _interopRequireDefault(_MessageDeliverySummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatMessageDelivery = function (_MessageDelivery) {
	  _inherits(ChatMessageDelivery, _MessageDelivery);
	
	  function ChatMessageDelivery() {
	    _classCallCheck(this, ChatMessageDelivery);
	
	    return _possibleConstructorReturn(this, (ChatMessageDelivery.__proto__ || Object.getPrototypeOf(ChatMessageDelivery)).apply(this, arguments));
	  }
	
	  _createClass(ChatMessageDelivery, null, [{
	    key: 'createFromChatMessage',
	    value: function createFromChatMessage(chatMessage) {
	      return new ChatMessageDelivery({
	        message_type: 'chat',
	        message_uuid: chatMessage.id,
	        read_summary: new _MessageDeliverySummary2.default(chatMessage.getReadSummary()),
	        stream_uuid: chatMessage.getChatId()
	      });
	    }
	  }]);
	
	  return ChatMessageDelivery;
	}(_MessageDelivery3.default);
	
	ChatMessageDelivery.displayName = 'ChatMessageDelivery';
	exports.default = ChatMessageDelivery;

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _MessageDeliverySummary = __webpack_require__(1658);
	
	var _MessageDeliverySummary2 = _interopRequireDefault(_MessageDeliverySummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var MessageDelivery = function (_Entity) {
	  _inherits(MessageDelivery, _Entity);
	
	  function MessageDelivery() {
	    _classCallCheck(this, MessageDelivery);
	
	    return _possibleConstructorReturn(this, (MessageDelivery.__proto__ || Object.getPrototypeOf(MessageDelivery)).apply(this, arguments));
	  }
	
	  _createClass(MessageDelivery, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.idAttribute = 'message_uuid';
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      if (response['read_summary']) {
	        response['read_summary'] = new _MessageDeliverySummary2.default(response['read_summary']);
	      }
	
	      return response;
	    }
	  }, {
	    key: 'setReadSummaryState',
	    value: function setReadSummaryState(state) {
	      this.getReadSummary().setState(state);
	    }
	  }, {
	    key: 'getReadSummary',
	    value: function getReadSummary() {
	      return this.get('read_summary');
	    }
	  }]);
	
	  return MessageDelivery;
	}(_Entity3.default);
	
	MessageDelivery.displayName = 'MessageDelivery';
	exports.default = MessageDelivery;

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _MessageDelivery2 = __webpack_require__(1680);
	
	var _MessageDelivery3 = _interopRequireDefault(_MessageDelivery2);
	
	var _MessageDeliverySummary = __webpack_require__(1658);
	
	var _MessageDeliverySummary2 = _interopRequireDefault(_MessageDeliverySummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupMessageDelivery = function (_MessageDelivery) {
	  _inherits(GroupMessageDelivery, _MessageDelivery);
	
	  function GroupMessageDelivery() {
	    _classCallCheck(this, GroupMessageDelivery);
	
	    return _possibleConstructorReturn(this, (GroupMessageDelivery.__proto__ || Object.getPrototypeOf(GroupMessageDelivery)).apply(this, arguments));
	  }
	
	  _createClass(GroupMessageDelivery, null, [{
	    key: 'createFromGroupMessage',
	    value: function createFromGroupMessage(groupMessage) {
	      return new GroupMessageDelivery({
	        message_type: 'broadcast',
	        message_uuid: groupMessage.getUuid(),
	        read_summary: new _MessageDeliverySummary2.default(groupMessage.getReadSummary()),
	        stream_uuid: null
	      });
	    }
	  }]);
	
	  return GroupMessageDelivery;
	}(_MessageDelivery3.default);
	
	GroupMessageDelivery.displayName = 'GroupMessageDelivery';
	exports.default = GroupMessageDelivery;

/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _MessageDelivery = __webpack_require__(1680);
	
	var _MessageDelivery2 = _interopRequireDefault(_MessageDelivery);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageDeliveries = function (_Collection) {
	  _inherits(MessageDeliveries, _Collection);
	
	  function MessageDeliveries() {
	    _classCallCheck(this, MessageDeliveries);
	
	    return _possibleConstructorReturn(this, (MessageDeliveries.__proto__ || Object.getPrototypeOf(MessageDeliveries)).apply(this, arguments));
	  }
	
	  _createClass(MessageDeliveries, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _MessageDelivery2.default;
	    }
	  }, {
	    key: 'findWhereMessageId',
	    value: function findWhereMessageId(messageId) {
	      return this.findWhere({ message_uuid: messageId });
	    }
	  }]);
	
	  return MessageDeliveries;
	}(_Collection3.default);
	
	MessageDeliveries.displayName = 'MessageDeliveries';
	exports.default = MessageDeliveries;

/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Time = __webpack_require__(1563);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var Timestamp = function (_React$Component) {
	  _inherits(Timestamp, _React$Component);
	
	  function Timestamp() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Timestamp);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Timestamp.__proto__ || Object.getPrototypeOf(Timestamp)).call.apply(_ref, [this].concat(args))), _this), _this.getDayInterval = function (date) {
	      return Math.floor((date.getTime() - date.getTimezoneOffset() * 60 * 1000) / (1000 * 60 * 60 * 24));
	    }, _this.getDayIntervalDifference = function (a, b) {
	      return _this.getDayInterval(a) - _this.getDayInterval(b);
	    }, _this.renderTimestamp = function () {
	      var _this$props = _this.props,
	          format = _this$props.format,
	          date = _this$props.date;
	
	      if (format !== 'time') {
	        var diff = _this.getDayIntervalDifference(date, new Date());
	
	        if (format === 'long') {
	          if (Math.abs(diff) >= 7) {
	            // Show full date (e.g., March 26, 2015)
	            return _react2.default.createElement(_Time2.default, { date: date, month: 'long', day: 'numeric', year: 'numeric' });
	          } else if (Math.abs(diff) >= 2) {
	            // Show full weekday (e.g., Sunday)
	            return _react2.default.createElement(_Time2.default, { date: date, weekday: 'long' });
	          } else if (Math.abs(diff) === 1) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              diff > 0 ? 'Tomorrow' : 'Yesterday'
	            );
	          } else {
	            return _react2.default.createElement(
	              'span',
	              null,
	              'Today'
	            );
	          }
	        } else {
	          if (diff >= 365) {
	            // Show full numeric date (e.g., 3/28/15)
	            return _react2.default.createElement(_Time2.default, { date: date, month: 'numeric', day: 'numeric', year: '2-digit' });
	          } else if (diff >= 7) {
	            // Show abbreviated date (e.g., Jun 12)
	            return _react2.default.createElement(_Time2.default, { date: date, month: 'short', day: 'numeric' });
	          } else if (diff >= 1) {
	            // Show abbreviated weekday (e.g., Sun)
	            return _react2.default.createElement(_Time2.default, { date: date, weekday: 'short' });
	          }
	        }
	      }
	
	      // Just the time (e.g., 11:32 AM)
	      return _react2.default.createElement(_Time2.default, { date: date, hour: 'numeric', minute: '2-digit' });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Timestamp, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var same = this.props.date.getTime() === nextProps.date.getTime() && this.props.format === nextProps.format;
	      return !same;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.cloneElement(this.renderTimestamp(), {
	        className: this.props.className,
	        title: this.props.date.toString()
	      });
	    }
	  }]);
	
	  return Timestamp;
	}(_react2.default.Component);
	
	Timestamp.defaultProps = {
	  format: 'long'
	};
	Timestamp.displayName = 'Timestamp';
	exports.default = Timestamp;

/***/ },
/* 1684 */
1136,
/* 1685 */,
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _InviteModal = __webpack_require__(1687);
	
	var _InviteModal2 = _interopRequireDefault(_InviteModal);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UniversalComposeButtonContainer = __webpack_require__(1723);
	
	var _UniversalComposeButtonContainer2 = _interopRequireDefault(_UniversalComposeButtonContainer);
	
	var _groupLaunch = __webpack_require__(2115);
	
	var _groupLaunch2 = _interopRequireDefault(_groupLaunch);
	
	var _GroupMessagesNull = __webpack_require__(2116);
	
	var _GroupMessagesNull2 = _interopRequireDefault(_GroupMessagesNull);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Used to display a null state in a group message list before any messages are available.
	 *
	 * It has many possible states.
	
	  # With standard inline composer
	
	  ## User can post
	  ```example
	    <GroupMessagesNull
	      canPost
	    />
	  ```
	
	  ## User can post and has history
	  ```example
	    <GroupMessagesNull
	      canPost
	      messageHistoryEnabled
	    />
	  ```
	
	  ## User can't post, but can chat
	  e.g. student/parent in 2-way
	
	  ```example
	    <GroupMessagesNull
	      canChat
	    />
	  ```
	
	  ## User can't post or chat
	  e.g. student/parent in 2-way
	
	  ```example
	    <GroupMessagesNull
	    />
	  ```
	 *
	 */
	var GroupMessagesNull = function (_Component) {
	  _inherits(GroupMessagesNull, _Component);
	
	  function GroupMessagesNull() {
	    _classCallCheck(this, GroupMessagesNull);
	
	    return _possibleConstructorReturn(this, (GroupMessagesNull.__proto__ || Object.getPrototypeOf(GroupMessagesNull)).apply(this, arguments));
	  }
	
	  _createClass(GroupMessagesNull, [{
	    key: 'getPosterUI',
	    value: function getPosterUI() {
	      var title = 'Send a welcome message!';
	      var subtitle = 'Let your class know how you’ll be using Remind.';
	      var subtext = _react2.default.createElement(_UniversalComposeButtonContainer2.default, { label: 'Send an announcement' });
	
	      return { title: title, subtitle: subtitle, subtext: subtext };
	    }
	  }, {
	    key: 'getReceiverUI',
	    value: function getReceiverUI() {
	      var title = 'No announcements yet';
	
	      var subtitle = '';
	      if (this.props.canInviteTeachers) {
	        subtitle = _react2.default.createElement(
	          'div',
	          null,
	          'While you\u2019re waiting,',
	          ' ',
	          _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: _react2.default.createElement(_InviteModal2.default, null) },
	            _react2.default.createElement(
	              _Link2.default,
	              { className: _GroupMessagesNull2.default.link },
	              'share Remind'
	            )
	          ),
	          ' ',
	          'with other teachers!'
	        );
	      } else if (this.props.canChat) {
	        subtitle = _react2.default.createElement(
	          'span',
	          null,
	          'In the meantime, click on the New Message button to send your teacher questions, updates, and more.'
	        );
	      } else {
	        subtitle = _react2.default.createElement(
	          'span',
	          null,
	          'We\u2019ll let you know as soon as your',
	          _react2.default.createElement('br', null),
	          'teacher sends an announcement.'
	        );
	      }
	
	      var subtext = '';
	      if (this.props.canChat) {
	        subtext = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_UniversalComposeButtonContainer2.default, { label: 'Send a message' })
	        );
	      }
	
	      return { title: title, subtitle: subtitle, subtext: subtext };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var image = _react2.default.createElement(_Image2.default, { src: _groupLaunch2.default });
	
	      var _ref = this.props.canPost ? this.getPosterUI() : this.getReceiverUI(),
	          title = _ref.title,
	          subtitle = _ref.subtitle,
	          subtext = _ref.subtext;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _GroupMessagesNull2.default.this },
	        _react2.default.createElement(
	          'div',
	          { className: _GroupMessagesNull2.default.image },
	          image
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _GroupMessagesNull2.default.title },
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _GroupMessagesNull2.default.subtitle },
	          subtitle
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _GroupMessagesNull2.default.subtext },
	          subtext
	        )
	      );
	    }
	  }]);
	
	  return GroupMessagesNull;
	}(_react.Component);
	
	GroupMessagesNull.defaultProps = {
	  canChat: false,
	  canPost: false,
	  canInviteTeachers: false,
	  messageHistoryEnabled: false
	};
	GroupMessagesNull.displayName = 'GroupMessagesNull';
	exports.default = GroupMessagesNull;

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LeadStore = __webpack_require__(1024);
	
	var _LeadStore2 = _interopRequireDefault(_LeadStore);
	
	var _LeadActions = __webpack_require__(1021);
	
	var _LeadActions2 = _interopRequireDefault(_LeadActions);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _RequireUser = __webpack_require__(1688);
	
	var _RequireUser2 = _interopRequireDefault(_RequireUser);
	
	var _TymkModal = __webpack_require__(1465);
	
	var _TymkModal2 = _interopRequireDefault(_TymkModal);
	
	var _ShareRemindModal = __webpack_require__(1714);
	
	var _ShareRemindModal2 = _interopRequireDefault(_ShareRemindModal);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _userBootData = __webpack_require__(975);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InviteModal = _react2.default.createClass({
	  displayName: 'InviteModal',
	
	  mixins: [_RequireUser2.default],
	
	  statics: {
	    prefetch: [function () {
	      var leads = _LeadStore2.default.getLeads();
	      if (leads.length === 0) {
	        return _LeadActions2.default.loadLeads();
	      }
	      return leads;
	    }, _userBootData.promiseSettings]
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      leads: _LeadStore2.default.getLeads(),
	      settings: _SettingsStore2.default.getSettings()
	    };
	  },
	  closeModal: function closeModal() {
	    this.props.onRequestHide();
	  },
	  render: function render() {
	    if (this.state.leads.length > 0) {
	      return _react2.default.createElement(_TymkModal2.default, _extends({}, this.props, {
	        leads: this.state.leads,
	        triggeredContext: 'love_remind'
	      }));
	    } else {
	      return _react2.default.createElement(_ShareRemindModal2.default, _extends({}, this.props, {
	        user: _CurrentUser2.default.getUser(),
	        settings: this.state.settings
	      }));
	    }
	  }
	});
	
	exports.default = InviteModal;

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _SignInPage = __webpack_require__(1689);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequireUser = {
	  statics: {
	    onEnter: function onEnter(nextState, replaceWith, callback) {
	      var query = nextState.location.query;
	
	      if (_CurrentUser2.default.isSignedIn()) {
	        callback();
	      } else {
	        var _ret = function () {
	          var redirectToSignIn = function redirectToSignIn() {
	            _SignInPage.redirector.attemptedTransition = nextState.location;
	            replaceWith('/log_in');
	            callback();
	          };
	
	          if (query['auth_token']) {
	            _AuthActions2.default.accessTokenSignIn(query['auth_token']).then(function () {
	              return callback();
	            }).catch(redirectToSignIn);
	            return {
	              v: void 0
	            };
	          }
	
	          _AuthActions2.default.checkLoggedIn().then(function (user) {
	            if (user) {
	              callback();
	            } else {
	              redirectToSignIn();
	            }
	          }).catch(function (err) {
	            console.error(err);
	            redirectToSignIn();
	          });
	        }();
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	      }
	    }
	  }
	};
	
	exports.default = RequireUser;

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SignInPage = exports.redirector = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthenticationView = __webpack_require__(1690);
	
	var _AuthenticationView2 = _interopRequireDefault(_AuthenticationView);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _SignInForm = __webpack_require__(1702);
	
	var _SignInForm2 = _interopRequireDefault(_SignInForm);
	
	var _documentTitle = __webpack_require__(1713);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO: Not sure why we have two of those.
	// they are consumed the same way (router.push).
	var redirector = exports.redirector = {
	  onSignInRedirectTo: null,
	  attemptedTransition: null,
	  reset: function reset() {
	    this.onSignInRedirectTo = null;
	    this.attemptedTransition = null;
	  }
	};
	
	var SignInPage = function (_React$Component) {
	  _inherits(SignInPage, _React$Component);
	
	  function SignInPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SignInPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignInPage.__proto__ || Object.getPrototypeOf(SignInPage)).call.apply(_ref, [this].concat(args))), _this), _this.onSignIn = function () {
	      var query = _this.props.location.query;
	      var attemptedTransition = redirector.attemptedTransition,
	          onSignInRedirectTo = redirector.onSignInRedirectTo;
	
	
	      if (attemptedTransition) {
	        redirector.reset();
	        _this.context.router.push(attemptedTransition);
	        return;
	      }
	
	      if (onSignInRedirectTo) {
	        redirector.reset();
	        _this.context.router.push(onSignInRedirectTo);
	        return;
	      }
	
	      if (query.locationOnAuth) {
	        var locationOnAuth = query.locationOnAuth,
	            rest = _objectWithoutProperties(query, ['locationOnAuth']);
	
	        _this.context.router.push({
	          pathname: locationOnAuth,
	          query: rest
	        });
	      } else if (query.join) {
	        _this.context.router.push('/join/' + query.join);
	      } else {
	        _this.context.router.push('/');
	      }
	    }, _this.onUserNoRoleSignin = function () {
	      _this.context.router.push('/join/role_picker');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SignInPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _CurrentUser2.default.addSignInListener(this.onSignIn);
	      _CurrentUser2.default.addSignInNoRoleListener(this.onUserNoRoleSignin);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _CurrentUser2.default.removeSignInListener(this.onSignIn);
	      _CurrentUser2.default.removeSignInNoRoleListener(this.onUserNoRoleSignin);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var query = this.props.location.query;
	
	
	      return _react2.default.createElement(
	        _AuthenticationView2.default,
	        _extends({}, this.props, { title: 'Log in' }),
	        _react2.default.createElement(_SignInForm2.default, { initialUid: query.email || query.uid || '' })
	      );
	    }
	  }]);
	
	  return SignInPage;
	}(_react2.default.Component);
	
	SignInPage.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	SignInPage.displayName = 'SignInPage';
	exports.SignInPage = SignInPage;
	exports.default = (0, _documentTitle.withDocumentTitle)('Sign in', SignInPage);

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AuthenticationView = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Box = __webpack_require__(1202);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _UnauthenticatedView = __webpack_require__(1691);
	
	var _UnauthenticatedView2 = _interopRequireDefault(_UnauthenticatedView);
	
	__webpack_require__(1700);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AuthenticationView = exports.AuthenticationView = function (_Component) {
	  _inherits(AuthenticationView, _Component);
	
	  function AuthenticationView() {
	    _classCallCheck(this, AuthenticationView);
	
	    return _possibleConstructorReturn(this, (AuthenticationView.__proto__ || Object.getPrototypeOf(AuthenticationView)).apply(this, arguments));
	  }
	
	  _createClass(AuthenticationView, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          size = _props.size,
	          props = _objectWithoutProperties(_props, ['size']);
	
	      return _react2.default.createElement(
	        _UnauthenticatedView2.default,
	        props,
	        _react2.default.createElement(
	          _Container2.default,
	          { size: size },
	          _react2.default.createElement(
	            _Box2.default,
	            { className: 'AuthenticationView-box' },
	            _react2.default.createElement(
	              _BoxBody2.default,
	              null,
	              this.props.children
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AuthenticationView;
	}(_react.Component);
	
	AuthenticationView.defaultProps = {
	  size: 'xsmall'
	};
	AuthenticationView.displayName = 'AuthenticationView';
	exports.default = AuthenticationView;

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Footer = __webpack_require__(1692);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1698);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnauthenticatedView = function (_React$Component) {
	  _inherits(UnauthenticatedView, _React$Component);
	
	  function UnauthenticatedView() {
	    _classCallCheck(this, UnauthenticatedView);
	
	    return _possibleConstructorReturn(this, (UnauthenticatedView.__proto__ || Object.getPrototypeOf(UnauthenticatedView)).apply(this, arguments));
	  }
	
	  _createClass(UnauthenticatedView, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          className = _props.className,
	          children = _props.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'main',
	          { className: (0, _classnames2.default)('UnauthenticatedView', className) },
	          _react2.default.createElement(
	            _Container2.default,
	            null,
	            title && _react2.default.createElement(
	              'h1',
	              { className: 'UnauthenticatedView-title' },
	              title
	            ),
	            children
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return UnauthenticatedView;
	}(_react2.default.Component);
	
	UnauthenticatedView.displayName = 'UnauthenticatedView';
	exports.default = UnauthenticatedView;

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FooterNavItem = __webpack_require__(1693);
	
	var _FooterNavItem2 = _interopRequireDefault(_FooterNavItem);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1696);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
	  }
	
	  _createClass(Footer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'footer',
	        { className: 'Footer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Footer-container' },
	          _react2.default.createElement(
	            'nav',
	            { className: 'Footer-nav' },
	            _react2.default.createElement(
	              _FooterNavItem2.default,
	              { href: _LinkConstants2.default.TERMS_OF_SERVICE, color: 'violet', divided: true },
	              _react2.default.createElement(_Glyph2.default, { name: 'lock-stroke' }),
	              'Terms & Privacy'
	            ),
	            _react2.default.createElement(
	              _FooterNavItem2.default,
	              { href: _LinkConstants2.default.HOW_IT_WORKS_TEACHERS },
	              'Learn More'
	            ),
	            _react2.default.createElement(
	              _FooterNavItem2.default,
	              { href: _LinkConstants2.default.RESOURCES },
	              'Resources'
	            ),
	            _react2.default.createElement(
	              _FooterNavItem2.default,
	              { href: _LinkConstants2.default.BLOG },
	              'Blog'
	            ),
	            _react2.default.createElement(
	              _FooterNavItem2.default,
	              { href: _LinkConstants2.default.COMMUNITY },
	              'Community'
	            ),
	            _react2.default.createElement(
	              _FooterNavItem2.default,
	              { href: _LinkConstants2.default.ABOUT },
	              'About Us'
	            ),
	            _react2.default.createElement(
	              _FooterNavItem2.default,
	              { href: _LinkConstants2.default.PRESS },
	              'Press'
	            ),
	            _react2.default.createElement(
	              _FooterNavItem2.default,
	              { href: _LinkConstants2.default.CAREERS },
	              'Careers'
	            ),
	            _react2.default.createElement(
	              _FooterNavItem2.default,
	              { href: _LinkConstants2.default.HELP },
	              'Support'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react2.default.Component);
	
	Footer.displayName = 'Footer';
	exports.default = Footer;

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1694);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FooterNavItem = function (_React$Component) {
	  _inherits(FooterNavItem, _React$Component);
	
	  function FooterNavItem() {
	    _classCallCheck(this, FooterNavItem);
	
	    return _possibleConstructorReturn(this, (FooterNavItem.__proto__ || Object.getPrototypeOf(FooterNavItem)).apply(this, arguments));
	  }
	
	  _createClass(FooterNavItem, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Link2.default,
	        _extends({}, this.props, {
	          target: '_blank',
	          weight: 'semibold',
	          className: (0, _classnames2.default)('FooterNavItem', {
	            'FooterNavItem--divided': this.props.divided
	          }) }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return FooterNavItem;
	}(_react2.default.Component);
	
	FooterNavItem.defaultProps = {
	  divided: false
	};
	FooterNavItem.displayName = 'FooterNavItem';
	exports.default = FooterNavItem;

/***/ },
/* 1694 */
1136,
/* 1695 */,
/* 1696 */
1136,
/* 1697 */,
/* 1698 */
1136,
/* 1699 */,
/* 1700 */
1136,
/* 1701 */,
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ConfirmEmail = __webpack_require__(1703);
	
	var _ConfirmEmail2 = _interopRequireDefault(_ConfirmEmail);
	
	var _ConfirmPhone = __webpack_require__(1704);
	
	var _ConfirmPhone2 = _interopRequireDefault(_ConfirmPhone);
	
	var _Cookies = __webpack_require__(573);
	
	var _Cookies2 = _interopRequireDefault(_Cookies);
	
	var _DividerText = __webpack_require__(1234);
	
	var _DividerText2 = _interopRequireDefault(_DividerText);
	
	var _Electron = __webpack_require__(1104);
	
	var _Electron2 = _interopRequireDefault(_Electron);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormCheckBox = __webpack_require__(1705);
	
	var _FormCheckBox2 = _interopRequireDefault(_FormCheckBox);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _GoogleSignIn = __webpack_require__(1706);
	
	var _GoogleSignIn2 = _interopRequireDefault(_GoogleSignIn);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _Notice = __webpack_require__(1132);
	
	var _Notice2 = _interopRequireDefault(_Notice);
	
	var _Row = __webpack_require__(1482);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Profile = __webpack_require__(1710);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	__webpack_require__(1711);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mediumOfUid = function mediumOfUid(uid) {
	  return uid.includes('@') ? 'email' : 'sms';
	};
	
	
	var SignInForm = _react2.default.createClass({
	  displayName: 'SignInForm',
	  getInitialState: function getInitialState() {
	    // Flow seems to have trouble with getInitialState()
	    var uid = this.props.initialUid || '';
	    return {
	      error: false,
	      signingIn: false,
	      needsConfirmation: '',
	      uid: uid,
	      medium: mediumOfUid(uid)
	    };
	  },
	
	
	  // typecheck: ignore statement
	  onPersistChange: function onPersistChange(event) {
	    var target = event.target;
	
	    if (target instanceof window.HTMLInputElement) {
	      _Cookies2.default.set('persist', target.checked);
	    }
	  },
	
	
	  // typecheck: ignore statement
	  onUidChange: function onUidChange(event) {
	    var target = event.target;
	
	    if (target instanceof window.HTMLInputElement) {
	      var uid = target.value;
	      this.setState({
	        uid: uid,
	        medium: mediumOfUid(uid)
	      });
	    }
	  },
	  onProfileSuccess: function onProfileSuccess(profile) {
	    if (profile.needsPassword()) {
	      // send to partial account completion page
	      this.setState(function (_ref) {
	        var medium = _ref.medium;
	        return { signingIn: false, needsConfirmation: medium };
	      });
	    } else {
	      this.handleInvalidCredentials();
	    }
	  },
	  onGoBack: function onGoBack() {
	    this.setState({ needsConfirmation: '' });
	  },
	  getPersistFromCookie: function getPersistFromCookie() {
	    if (typeof _Cookies2.default.get('persist') === 'undefined') {
	      var defaultValue = _Electron2.default.isAvailable() ? 'true' : 'false';
	      _Cookies2.default.set('persist', defaultValue);
	    }
	
	    return _Cookies2.default.get('persist') === 'true';
	  },
	
	
	  // if an account exists and it needs a password
	  // send them the confirmation email and redirect them to an instruction page
	  checkForAccountExistence: function checkForAccountExistence() {
	    _Profile2.default.fetchByIdentifier(this.state.uid).then(this.onProfileSuccess).catch(this.handleInvalidCredentials);
	  },
	  handleInvalidCredentials: function handleInvalidCredentials(err) {
	    var uidErr = 'Invalid email address or phone number';
	    var unregistered = err && err.statusCode === 404;
	    var errorMessage = unregistered ? uidErr : uidErr + ' or password';
	
	    _ToastActions2.default.showErrorToast(errorMessage);
	    this.setState({ signingIn: false, error: true });
	  },
	  handleSubmit: function handleSubmit(data) {
	    var _this = this;
	
	    var uid = data.uid,
	        password = data.password,
	        persist = data.persist;
	
	
	    _AuthActions2.default.signIn(uid, password, persist).then(function () {
	      return _this.setState({ error: false });
	    }).catch(function (err) {
	      if (err && err.statusCode === 401) {
	        _this.checkForAccountExistence();
	      } else {
	        _ToastActions2.default.showErrorToast('There was an error logging in. Please try again later.');
	        _this.setState({ signingIn: false, error: true });
	      }
	    });
	
	    this.setState({ signingIn: true });
	  },
	  renderCookieWarningIfNeeded: function renderCookieWarningIfNeeded() {
	    if (_Cookies2.default.isEnabled()) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      _Row2.default,
	      null,
	      _react2.default.createElement(
	        _Notice2.default,
	        { color: 'lava' },
	        'Cookies are not enabled on your browser. Please enable cookies in your browser preferences to continue.'
	      )
	    );
	  },
	  renderDefault: function renderDefault() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _Form2.default,
	        { onSubmit: this.handleSubmit },
	        this.renderCookieWarningIfNeeded(),
	        _react2.default.createElement(_FormInput2.default, {
	          label: 'Email address or phone number',
	          name: 'uid',
	          autoComplete: 'username',
	          placeholder: 'Email address or phone number',
	          onChange: this.onUidChange,
	          size: 'large',
	          value: this.state.uid,
	          showErrorAfterBlur: true,
	          required: true,
	          validations: this.state.medium === 'email' ? { isEmail: true } : { couldPlausiblyBeANorthAmericanPhoneNumber: true },
	          validationErrors: {
	            isEmail: 'Invalid email. Please try again.',
	            couldPlausiblyBeANorthAmericanPhoneNumber: 'Invalid phone number or email address. Please try again.'
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'SignInForm-password' },
	          _react2.default.createElement(_FormInput2.default, {
	            label: 'Password',
	            type: 'password',
	            name: 'password',
	            autoComplete: 'current-password',
	            autofocus: !!this.state.uid,
	            placeholder: 'Password',
	            required: true,
	            size: 'large',
	            validations: 'minLength:1'
	          }),
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              to: '/forgot_password',
	              query: this.state.uid ? { email: this.state.uid } : null,
	              tabIndex: '-1',
	              className: 'SignInForm-forgotPassword',
	              eventElementName: 'SignInForm-forgotPassword' },
	            'Forgot?'
	          )
	        ),
	        _react2.default.createElement(_FormCheckBox2.default, {
	          name: 'persist',
	          defaultChecked: this.getPersistFromCookie(),
	          onChange: this.onPersistChange,
	          label: 'Stay logged in'
	        }),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            type: 'submit',
	            level: 'primary',
	            full: true,
	            disabled: this.state.signingIn },
	          'Log in'
	        )
	      ),
	      _react2.default.createElement(_DividerText2.default, { text: 'or', uppercase: true }),
	      _react2.default.createElement(_GoogleSignIn2.default, null),
	      _react2.default.createElement(
	        _Link2.default,
	        {
	          href: _LinkConstants2.default.SIGN_UP,
	          target: _Electron2.default.isAvailable() ? '_blank' : null,
	          color: 'thunder',
	          className: 'SignInForm-signUpLink',
	          eventElementName: 'SignInForm-signUpLink' },
	        'Don\u2019t have an account? Sign up!'
	      )
	    );
	  },
	  render: function render() {
	    if (this.state.needsConfirmation === 'sms') {
	      return _react2.default.createElement(_ConfirmPhone2.default, {
	        uid: this.state.uid,
	        onGoBack: this.onGoBack
	      });
	    } else if (this.state.needsConfirmation === 'email') {
	      return _react2.default.createElement(_ConfirmEmail2.default, {
	        uid: this.state.uid,
	        onGoBack: this.onGoBack
	      });
	    } else {
	      return this.renderDefault();
	    }
	  }
	});
	
	exports.default = SignInForm;

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxTitle = __webpack_require__(1508);
	
	var _BoxTitle2 = _interopRequireDefault(_BoxTitle);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	__webpack_require__(1638);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmEmail = _react2.default.createClass({
	  displayName: 'ConfirmEmail',
	  componentDidMount: function componentDidMount() {
	    _DeviceActions2.default.resendConfirmationEmail(this.props.uid);
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'ConfirmEmail' },
	      _react2.default.createElement(
	        _BoxTitle2.default,
	        null,
	        'Check your email to continue'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'block' },
	        'It looks like you\u2019ve already used Remind, so we sent you a confirmation email. Click on the link in the email to finish signing up for Remind!'
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          level: 'text',
	          onClick: this.props.onGoBack },
	        'Go back'
	      )
	    );
	  }
	});
	exports.default = ConfirmEmail;

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _BoxTitle = __webpack_require__(1508);
	
	var _BoxTitle2 = _interopRequireDefault(_BoxTitle);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Buttons = __webpack_require__(1315);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _Device = __webpack_require__(1016);
	
	var _Device2 = _interopRequireDefault(_Device);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(1638);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmPhone = _react2.default.createClass({
	  displayName: 'ConfirmPhone',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isValidCode: false,
	      verifying: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.sendSMSConf();
	  },
	
	
	  _outboundToken: null,
	
	  // typecheck: ignore statement
	  onCodeChange: function onCodeChange(event) {
	    // $FlowFixMe
	    var isValidCode = event.target.value.match(/^\d{4}$/);
	    this.setState({ isValidCode: isValidCode });
	  },
	  onContinue: function onContinue() {
	    var _this = this;
	
	    this.setState({ verifying: true });
	    var onError = function onError() {
	      _this.setState({ verifying: false });
	      _ToastActions2.default.showErrorToast('Error verifying your phone.');
	    };
	    var onSuccess = function onSuccess(_ref) {
	      var token = _ref.token;
	
	      _AuthActions2.default.accessTokenSignIn(token).then(function () {
	        return _this.context.router.push('/join/role_picker');
	      });
	    };
	
	    var code = _reactDom2.default.findDOMNode(this.refs.code).value;
	    // $FlowFixMe
	    return _Device2.default.createOutboundDevice(this._outboundToken, code).then(onSuccess, onError);
	  },
	  sendSMSConf: function sendSMSConf(onSuccess, onError) {
	    var _this2 = this;
	
	    return _Device2.default.outboundVerify(this.props.uid).then(function (_ref2) {
	      var token = _ref2.token;
	
	      _this2._outboundToken = token;
	      if (onSuccess) {
	        onSuccess();
	      }
	    }, onError);
	  },
	  resendSMSConf: function resendSMSConf() {
	    var onError = function onError() {
	      return _ToastActions2.default.showErrorToast('Error sending the code');
	    };
	    var onSuccess = function onSuccess() {
	      return _ToastActions2.default.showSuccessToast('Code successfully resent');
	    };
	    return this.sendSMSConf(onSuccess, onError);
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'ConfirmPhone' },
	      _react2.default.createElement(
	        _BoxTitle2.default,
	        null,
	        'Enter your code'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'block' },
	        'Please enter the 4-digit code sent to you.',
	        _react2.default.createElement('br', null),
	        'Didn\u2019t receive the code?',
	        ' ',
	        _react2.default.createElement(
	          _Link2.default,
	          { onClick: this.resendSMSConf },
	          'Resend'
	        )
	      ),
	      _react2.default.createElement(
	        _Field2.default,
	        null,
	        _react2.default.createElement(_Input2.default, {
	          ref: 'code',
	          autofocus: true,
	          placeholder: '0000',
	          maxLength: '4',
	          onChange: this.onCodeChange,
	          size: 'large'
	        })
	      ),
	      _react2.default.createElement(
	        _Buttons2.default,
	        { axis: 'y' },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            disabled: !this.state.isValidCode || this.state.verifying,
	            onClick: this.onContinue,
	            full: true },
	          'Continue'
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            level: 'text',
	            onClick: this.props.onGoBack },
	          'Go back'
	        )
	      )
	    );
	  }
	});
	
	exports.default = ConfirmPhone;

/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Checkbox = __webpack_require__(1388);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _doWhileMounted = __webpack_require__(1354);
	
	var _doWhileMounted2 = _interopRequireDefault(_doWhileMounted);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Formsy = __webpack_require__(1345);
	
	var _Formsy2 = _interopRequireDefault(_Formsy);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormCheckBox = _react2.default.createClass({
	  displayName: 'FormCheckBox',
	
	  mixins: [_Formsy2.default.Mixin],
	
	  onChange: function onChange(event) {
	    this.setValue(event.target.checked);
	  },
	
	
	  /* This is for autofill purposes.
	   * Some browsers does not emit change event when
	   * they fill out the forms, so formzy is not aware
	   * the value change and the validation does not run.
	   * This pulls the value from the DOM at
	   * regular interval and if what is found is different
	   * than what formzy currently have then we tell formzy
	   * about this new value via the formzy mixin.
	   */
	  lookForChanges: function lookForChanges() {
	    if (!this.refs.input) {
	      return;
	    }
	
	    var checked = this.refs.input.isChecked();
	    if (checked !== this.getValue()) {
	      this.setValue(checked);
	    }
	  },
	  render: function render() {
	    var errorMessage = this.getErrorMessage();
	
	    return _react2.default.createElement(
	      _Field2.default,
	      { error: errorMessage },
	      _react2.default.createElement(_Checkbox2.default, _extends({}, this.props, {
	        ref: 'input',
	        onChange: (0, _createChainedFunction2.default)(this.props.onChange, this.onChange)
	      }))
	    );
	  }
	});
	
	exports.default = (0, _doWhileMounted2.default)(FormCheckBox, 'lookForChanges', 1000);

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _GoogleAPI = __webpack_require__(950);
	
	var _GoogleAPI2 = _interopRequireDefault(_GoogleAPI);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(1707);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GoogleSignIn = function (_React$Component) {
	  _inherits(GoogleSignIn, _React$Component);
	
	  function GoogleSignIn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GoogleSignIn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GoogleSignIn.__proto__ || Object.getPrototypeOf(GoogleSignIn)).call.apply(_ref, [this].concat(args))), _this), _this.handleAuthorizationCode = function (code) {
	      _AuthActions2.default.googleSignIn(code).then(_this.props.onSuccess || function () {}).catch(_this.handleAuthorizationError);
	    }, _this.handleAuthorizationError = function () {
	      _ToastActions2.default.showErrorToast('There was an error logging in with Google. Please try again later.');
	    }, _this.handleClick = function () {
	      _GoogleAPI2.default.fetchAuthorizationCode().then(_this.handleAuthorizationCode).catch(_this.handleAuthorizationError);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GoogleSignIn, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Loads the Google API and initializes an auth instance so that the sign in flow becomes
	      // synchronous. If the sign in button is clicked before the API is loaded, the Google sign
	      // in popup will likely get blocked by a popup blocker.
	      _GoogleAPI2.default.initWithAuthInstance();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'GoogleSignIn',
	          type: 'button',
	          level: 'secondary',
	          color: 'thunder',
	          full: true,
	          onClick: this.handleClick,
	          eventElementName: 'GoogleSignIn' },
	        _react2.default.createElement(_Image2.default, { src: __webpack_require__(1709) }),
	        this.props.body
	      );
	    }
	  }]);
	
	  return GoogleSignIn;
	}(_react2.default.Component);
	
	GoogleSignIn.defaultProps = {
	  body: 'Log in with Google'
	};
	GoogleSignIn.displayName = 'GoogleSignIn';
	exports.default = GoogleSignIn;

/***/ },
/* 1707 */
1136,
/* 1708 */,
/* 1709 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMDAgMzAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMDAgMzAwIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNiAxNikiPjxwYXRoIGZpbGw9IiNlYTQzMzUiIGQ9Im0xMzcgNDNjMjcuOSAwIDQ2LjcgMTIgNTcuNCAyMi4xbDQxLjktNDAuOWMtMjUuOC0yMy45LTU5LjMtMzguNi05OS4zLTM4LjYtNTggMC0xMDguMiAzMy4zLTEzMi42IDgxLjhsNDggMzcuM2MxMi0zNS44IDQ1LjMtNjEuNyA4NC42LTYxLjciLz48cGF0aCBmaWxsPSIjNDI4NWY0IiBkPSJtMjc5LjQgMTM3LjNjMC0xMi4yLTEtMjEuMS0zLjEtMzAuM2gtMTM5LjN2NTVoODEuOGMtMS42IDEzLjctMTAuNiAzNC4zLTMwLjMgNDguMWw0Ni44IDM2LjNjMjgtMjUuOCA0NC4xLTYzLjkgNDQuMS0xMDkuMSIvPjxwYXRoIGZpbGw9IiNmYmJjMDUiIGQ9Im01Mi41IDE2My4zYy0zLjEtOS4yLTQuOS0xOS4xLTQuOS0yOS4zczEuOC0yMC4xIDQuOC0yOS4zbC00OC0zNy4zYy0xMC4xIDIwLjEtMTUuOCA0Mi43LTE1LjggNjYuNnM1LjggNDYuNSAxNS44IDY2LjZsNDguMS0zNy4zIi8+PHBhdGggZmlsbD0iIzM0YTg1MyIgZD0ibTEzNyAyODIuNGM0MC4xIDAgNzMuNy0xMy4yIDk4LjMtMzUuOWwtNDYuOC0zNi4zYy0xMi41IDguNy0yOS4zIDE0LjgtNTEuNCAxNC44LTM5LjIgMC03Mi41LTI1LjktODQuNC02MS43bC00OCAzNy4zYzI0LjMgNDguNSA3NC4yIDgxLjggMTMyLjMgODEuOCIvPjwvZz48L3N2Zz4="

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Profile = function (_Entity) {
	  _inherits(Profile, _Entity);
	
	  function Profile() {
	    _classCallCheck(this, Profile);
	
	    return _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).apply(this, arguments));
	  }
	
	  _createClass(Profile, [{
	    key: 'urlRoot',
	    value: function urlRoot() {
	      return '/profiles';
	    }
	  }, {
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        needs: {}
	      };
	    }
	  }, {
	    key: 'getNeeds',
	    value: function getNeeds() {
	      return this.get('needs');
	    }
	  }, {
	    key: 'needsPassword',
	    value: function needsPassword() {
	      return !!this.getNeeds().password;
	    }
	  }, {
	    key: 'needsFullName',
	    value: function needsFullName() {
	      return !!this.getNeeds().full_name;
	    }
	  }], [{
	    key: 'fetchByIdentifier',
	    value: function fetchByIdentifier(identifier) {
	      return (0, _apiRequest2.default)('/profiles', 'GET', { user_identifier: identifier }).then(function (profile) {
	        return Profile.fromJSON(profile);
	      });
	    }
	  }]);
	
	  return Profile;
	}(_Entity3.default);
	
	Profile.displayName = 'Profile';
	exports.default = Profile;

/***/ },
/* 1711 */
1136,
/* 1712 */,
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.unset = unset;
	exports.set = set;
	exports.withDocumentTitle = withDocumentTitle;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uuid = __webpack_require__(583);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _hoistNonReactStatics = __webpack_require__(474);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var document = typeof window === 'undefined' ? {} : window.document;
	
	var titles = [];
	
	function unset(id) {
	  titles = titles.filter(function (title) {
	    return title.id !== id;
	  });
	  refreshTitle();
	}
	
	function set(body) {
	  var title = { id: _uuid2.default.v4(), body: body };
	  titles.push(title);
	  refreshTitle();
	  return title.id;
	}
	
	function refreshTitle() {
	  if (titles.length > 0) {
	    document.title = titles[titles.length - 1].body;
	  } else {
	    document.title = 'Remind';
	  }
	}
	
	function withDocumentTitle(body, ComposedComponent) {
	  var HOC = function (_React$Component) {
	    _inherits(HOC, _React$Component);
	
	    function HOC() {
	      _classCallCheck(this, HOC);
	
	      return _possibleConstructorReturn(this, (HOC.__proto__ || Object.getPrototypeOf(HOC)).apply(this, arguments));
	    }
	
	    _createClass(HOC, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.id = set(body);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        unset(this.id);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(ComposedComponent, this.props);
	      }
	    }]);
	
	    return HOC;
	  }(_react2.default.Component);
	
	  HOC.displayName = 'HOC';
	
	
	  return (0, _hoistNonReactStatics2.default)(HOC, ComposedComponent);
	}

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _ShareRemind = __webpack_require__(1715);
	
	var _ShareRemind2 = _interopRequireDefault(_ShareRemind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShareRemindModal = function (_React$Component) {
	  _inherits(ShareRemindModal, _React$Component);
	
	  function ShareRemindModal() {
	    _classCallCheck(this, ShareRemindModal);
	
	    return _possibleConstructorReturn(this, (ShareRemindModal.__proto__ || Object.getPrototypeOf(ShareRemindModal)).apply(this, arguments));
	  }
	
	  _createClass(ShareRemindModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'ShareRemindModal',
	          className: 'ShareRemindModal'
	        }, this.props, {
	          size: 'small' }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(_ShareRemind2.default, this.props)
	        )
	      );
	    }
	  }]);
	
	  return ShareRemindModal;
	}(_react2.default.Component);
	
	ShareRemindModal.displayName = 'ShareRemindModal';
	exports.default = ShareRemindModal;

/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ClipboardTrigger = __webpack_require__(1492);
	
	var _ClipboardTrigger2 = _interopRequireDefault(_ClipboardTrigger);
	
	var _FormSingle = __webpack_require__(1716);
	
	var _FormSingle2 = _interopRequireDefault(_FormSingle);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ShareRemindSocial = __webpack_require__(1719);
	
	var _ShareRemindSocial2 = _interopRequireDefault(_ShareRemindSocial);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _UserConstants = __webpack_require__(1015);
	
	__webpack_require__(1720);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShareRemind = function (_React$Component) {
	  _inherits(ShareRemind, _React$Component);
	
	  function ShareRemind() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ShareRemind);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShareRemind.__proto__ || Object.getPrototypeOf(ShareRemind)).call.apply(_ref, [this].concat(args))), _this), _this.showCopyToast = function () {
	      _ToastActions2.default.showSuccessToast('URL has been copied to your clipboard');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ShareRemind, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var shareByEmailButton = void 0;
	      var socials = void 0;
	
	      if (this.props.user) {
	        shareByEmailButton = _react2.default.createElement(
	          _ShareRemindSocial2.default,
	          { medium: 'email', user: this.props.user },
	          _react2.default.createElement(
	            _Button2.default,
	            { full: true, size: 'small' },
	            _react2.default.createElement(_Glyph2.default, { name: 'email', size: 'medium' }),
	            'Share by email'
	          )
	        );
	        socials = ['facebook', 'twitter', 'pinterest'].map(function (name, index) {
	          return _react2.default.createElement(
	            _ShareRemindSocial2.default,
	            {
	              key: index,
	              medium: name,
	              className: 'ShareRemind-socialLink',
	              user: _this2.props.user },
	            _react2.default.createElement(_Glyph2.default, { className: 'ShareRemind-socialIcon', name: name, color: name, size: 'xlarge', solo: true })
	          );
	        });
	      }
	
	      var url = this.props.user ? this.props.user.getReferralUrl() : _LinkConstants2.default.MARKETING;
	
	      var shareText = this.props.user ? _react2.default.createElement(
	        'p',
	        null,
	        'Or share us on'
	      ) : '';
	
	      var subtext = void 0;
	      if (this.props.user && this.props.user.getRole() !== _UserConstants.Roles.teacher) {
	        subtext = 'Spread the word and share us with teachers at your school.';
	      } else {
	        subtext = 'Spread the word and share us with colleagues at your school.';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ShareRemind' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ShareRemind-header' },
	          _react2.default.createElement(_Image2.default, { src: __webpack_require__(1722) }),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Love Remind?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            subtext
	          )
	        ),
	        _react2.default.createElement(
	          _FormSingle2.default,
	          { className: 'ShareRemind-referralUrl', reset: 'mobile' },
	          _react2.default.createElement(_Input2.default, { className: 'ShareRemind-input', value: url, readOnly: true }),
	          _react2.default.createElement(
	            _ClipboardTrigger2.default,
	            { text: url, onCopy: this.showCopyToast },
	            _react2.default.createElement(
	              _Button2.default,
	              { level: 'secondary', size: 'small' },
	              'Copy link'
	            )
	          )
	        ),
	        shareByEmailButton,
	        _react2.default.createElement(
	          'div',
	          { className: 'ShareRemind-social' },
	          shareText,
	          socials
	        )
	      );
	    }
	  }]);
	
	  return ShareRemind;
	}(_react2.default.Component);
	
	ShareRemind.displayName = 'ShareRemind';
	exports.default = ShareRemind;

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1717);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormSingle = function (_React$Component) {
	  _inherits(FormSingle, _React$Component);
	
	  function FormSingle() {
	    _classCallCheck(this, FormSingle);
	
	    return _possibleConstructorReturn(this, (FormSingle.__proto__ || Object.getPrototypeOf(FormSingle)).apply(this, arguments));
	  }
	
	  _createClass(FormSingle, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('FormSingle', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className) },
	        this.props.children
	      );
	    }
	  }]);
	
	  return FormSingle;
	}(_react2.default.Component);
	
	FormSingle.propClasses = {
	  reset: {
	    mobile: 'FormSingle--reset--mobile'
	  }
	};
	FormSingle.displayName = 'FormSingle';
	exports.default = FormSingle;

/***/ },
/* 1717 */
1136,
/* 1718 */,
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _MailTo = __webpack_require__(1429);
	
	var _MailTo2 = _interopRequireDefault(_MailTo);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _userBootData = __webpack_require__(975);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShareRemindSocial = function (_React$Component) {
	  _inherits(ShareRemindSocial, _React$Component);
	
	  function ShareRemindSocial() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ShareRemindSocial);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShareRemindSocial.__proto__ || Object.getPrototypeOf(ShareRemindSocial)).call.apply(_ref, [this].concat(args))), _this), _this.getEncodedBody = function (base) {
	      _lodash2.default.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	      var compiled = _lodash2.default.template(base);
	      var body = compiled({ user_id: _this.props.user.id, platform: 'web' });
	      return body;
	    }, _this.getLink = function () {
	      var medium = _this.props.medium;
	
	      var setting = _this.getSetting();
	
	      var url = setting[_this.getRole() + '_url'];
	      var body = setting[_this.getRole()];
	      var base = void 0;
	
	      if (medium === 'facebook') {
	        body = _this.getEncodedBody(url);
	        base = 'https://www.facebook.com/sharer/sharer.php';
	        return base + '?u=' + body;
	      }
	
	      if (medium === 'twitter') {
	        body = _this.getEncodedBody(body);
	        base = 'https://www.twitter.com/home';
	        return base + '?status=' + body;
	      }
	
	      if (medium === 'pinterest') {
	        url = _this.getEncodedBody(url);
	        var media = _this.getEncodedBody(setting.image);
	
	        body = _this.getEncodedBody(body);
	        base = 'https://www.pinterest.com/pin/create/button/';
	
	        return base + '?url=' + url + '&media=' + media + '&description=' + body;
	      }
	      return null;
	    }, _this.getRole = function () {
	      return _this.props.user.getRole();
	    }, _this.getSetting = function () {
	      var medium = _this.props.medium;
	
	      return _SettingsStore2.default.getSettings().sharing[medium];
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ShareRemindSocial, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // TODO this should not be a concern of components
	      (0, _userBootData.promiseSettings)();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!_SettingsStore2.default.getSettings()) {
	        return null;
	      }
	
	      if (this.props.medium === 'email') {
	        var setting = this.getSetting()[this.getRole()];
	        var body = this.getEncodedBody(setting.body.text);
	        var subject = setting.subject;
	        var bcc = setting.bcc;
	
	        return _react2.default.createElement(
	          _MailTo2.default,
	          _extends({}, this.props, {
	            className: (0, _classnames2.default)('ShareRemindSocial', this.props.className),
	            subject: subject,
	            body: body,
	            bcc: bcc }),
	          this.props.children
	        );
	      }
	
	      return _react2.default.createElement(
	        _Link2.default,
	        _extends({}, this.props, {
	          className: (0, _classnames2.default)('ShareRemindSocial', this.props.className),
	          href: this.getLink(),
	          target: '_blank' }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return ShareRemindSocial;
	}(_react2.default.Component);
	
	ShareRemindSocial.displayName = 'ShareRemindSocial';
	exports.default = ShareRemindSocial;

/***/ },
/* 1720 */
1136,
/* 1721 */,
/* 1722 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMDAgMzAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMDAgMzAwIj48cGF0aCBmaWxsPSIjMzZjY2I2IiBkPSJtMjkyLjkgMjA4LjFjLTEyLjQtMy4xLTEzLjEtMjAuMi0xMi0zMi40IDIuOS04IDQuNC0xNi43IDQuNC0yNS43IDAtNDIuMi0zNC4yLTc2LjMtNzYuMy03Ni4zcy03Ni4zIDM0LjItNzYuMyA3Ni4zIDM0LjIgNzYuMyA3Ni4zIDc2LjNjMTcuOSAwIDM0LjMtNi4xIDQ3LjMtMTYuNCAxOC40IDEyLjIgNTQgMi41IDM2LjYtMS44bS01OC4xLTQ5LjJsLTIxLjIgMjAuOGMtLjMuMi0uNi4zLS45LjMtLjQgMC0uNy0uMS0uOS0uM2wtMjEuMi0yMC44Yy0xMC4xLTkuOS0xMC44LTIwLjItNC4zLTI2LjUgNi40LTYuMyAxNi45LTYuMyAyMy40IDAgMS4yIDEuMiAyLjIgMi41IDMgMy45LjgtMS40IDEuOC0yLjcgMy0zLjkgNi41LTYuNCAxNi45LTYuNCAyMy41IDAgNi40IDYuMyA1LjggMTYuNS00LjQgMjYuNSIvPjxwYXRoIGZpbGw9IiM0YTg5ZGMiIGQ9Im05MSA3My43Yy00Mi4yIDAtNzYuMyAzNC4yLTc2LjMgNzYuMyAwIDkgMS42IDE3LjYgNC40IDI1LjcgMS4xIDEyLjIuNCAyOS4zLTEyIDMyLjQtMTcuMyA0LjMgMTguMiAxNCAzNi42IDEuOCAxMyAxMC4zIDI5LjQgMTYuNCA0Ny4zIDE2LjQgNDIuMiAwIDc2LjMtMzQuMiA3Ni4zLTc2LjNzLTM0LjItNzYuMy03Ni4zLTc2LjNtMTguNyA4Ni4zYy0xLjggNC40LTYuMSA3LjYtMTEuMyA3LjYtLjcgMC0xLjMtLjEtMS45LS4ybC04LjIgMTAuN2MtMS4xIDEuNS0zLjYuOC0zLjgtMWwtLjktOC4xYy0yLjkgMS44LTYuMyAyLjgtMTAgMi44LTEwLjQgMC0xOC44LTguMy0xOC44LTE4LjUgMC04IDUuMi0xNC45IDEyLjUtMTcuNCAyLjktNy40IDEyLjYtMTIuOSAyNC0xMi45IDkuMyAwIDE3LjUgMy42IDIxLjcgOSA3LjIgMS43IDEyLjQgNy4yIDEyLjQgMTMuOC4yIDcuNS02LjggMTMuNy0xNS43IDE0LjIiLz48cGF0aCBmaWxsPSIjMGY2ZDlkIiBkPSJtMTMyLjcgMTUwYzAgMTguNCA2LjUgMzUuMiAxNy4zIDQ4LjQgMTAuOC0xMy4yIDE3LjMtMzAgMTcuMy00OC40cy02LjUtMzUuMi0xNy4zLTQ4LjRjLTEwLjggMTMuMi0xNy4zIDMwLTE3LjMgNDguNCIvPjwvc3ZnPg=="

/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _UniversalComposeButton = __webpack_require__(1724);
	
	var _UniversalComposeButton2 = _interopRequireDefault(_UniversalComposeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UniversalComposeButtonContainer = function (_React$Component) {
	  _inherits(UniversalComposeButtonContainer, _React$Component);
	
	  function UniversalComposeButtonContainer() {
	    _classCallCheck(this, UniversalComposeButtonContainer);
	
	    return _possibleConstructorReturn(this, (UniversalComposeButtonContainer.__proto__ || Object.getPrototypeOf(UniversalComposeButtonContainer)).apply(this, arguments));
	  }
	
	  _createClass(UniversalComposeButtonContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_UniversalComposeButton2.default, _extends({}, this.props, this.state));
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        currentUser: _CurrentUser2.default.getUser()
	      };
	    }
	  }]);
	
	  return UniversalComposeButtonContainer;
	}(_react2.default.Component);
	
	UniversalComposeButtonContainer.displayName = 'UniversalComposeButtonContainer';
	exports.default = _utils.Container.create(UniversalComposeButtonContainer, { withProps: true });

/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _mountTymkPrompt = __webpack_require__(1464);
	
	var _mountTymkPrompt2 = _interopRequireDefault(_mountTymkPrompt);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Timestamp = __webpack_require__(1683);
	
	var _Timestamp2 = _interopRequireDefault(_Timestamp);
	
	var _Tooltip = __webpack_require__(1157);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _UniversalComposeHovercard = __webpack_require__(1725);
	
	var _UniversalComposeHovercard2 = _interopRequireDefault(_UniversalComposeHovercard);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UniversalComposeButton = function (_React$Component) {
	  _inherits(UniversalComposeButton, _React$Component);
	
	  function UniversalComposeButton() {
	    _classCallCheck(this, UniversalComposeButton);
	
	    return _possibleConstructorReturn(this, (UniversalComposeButton.__proto__ || Object.getPrototypeOf(UniversalComposeButton)).apply(this, arguments));
	  }
	
	  _createClass(UniversalComposeButton, [{
	    key: 'renderButton',
	    value: function renderButton() {
	      var _props = this.props,
	          currentUser = _props.currentUser,
	          label = _props.label,
	          props = _objectWithoutProperties(_props, ['currentUser', 'label']);
	
	      return _react2.default.createElement(
	        _Button2.default,
	        _extends({
	          disabled: currentUser.isMuted(),
	          'data-test-selector': 'universial_compose_button',
	          className: 'UniversalComposeButton'
	        }, props, {
	          eventElementName: 'UniversalComposeButton' }),
	        label
	      );
	    }
	  }, {
	    key: 'renderEnabledButton',
	    value: function renderEnabledButton() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          currentUser = _props2.currentUser,
	          hideActivities = _props2.hideActivities,
	          hideAnnouncements = _props2.hideAnnouncements,
	          onComposeSelection = _props2.onComposeSelection;
	
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          ref: 'activityLayer',
	          trigger: 'click',
	          layer: _react2.default.createElement(_UniversalComposeHovercard2.default, {
	            currentUser: currentUser,
	            hideActivities: hideActivities,
	            hideAnnouncements: hideAnnouncements,
	            onMessageSent: function onMessageSent() {
	              (0, _mountTymkPrompt2.default)(_this2, 'send_announcement');
	            },
	            onComposeSelection: onComposeSelection
	          }),
	          placement: 'bottom',
	          delayShow: 400 },
	        this.renderButton()
	      );
	    }
	  }, {
	    key: 'renderDisabledButton',
	    value: function renderDisabledButton() {
	      var currentUser = this.props.currentUser;
	
	      var timestamp = _react2.default.createElement(_Timestamp2.default, { date: currentUser.getMutedUntil(), format: 'long' });
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          layer: _react2.default.createElement(
	            _Tooltip2.default,
	            null,
	            _react2.default.createElement(
	              _Text2.default,
	              { align: 'center', element: 'div' },
	              'Your messaging privileges have been temporarily suspended until ',
	              timestamp,
	              '.'
	            )
	          ),
	          placement: 'bottom' },
	        this.renderButton()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var currentUser = this.props.currentUser;
	
	
	      return currentUser.isMuted() ? this.renderDisabledButton() : this.renderEnabledButton();
	    }
	  }]);
	
	  return UniversalComposeButton;
	}(_react2.default.Component);
	
	UniversalComposeButton.defaultProps = {
	  label: 'New message'
	};
	UniversalComposeButton.displayName = 'UniversalComposeButton';
	exports.default = UniversalComposeButton;

/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ActivityCreateDialogContainer = __webpack_require__(1726);
	
	var _ActivityCreateDialogContainer2 = _interopRequireDefault(_ActivityCreateDialogContainer);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Hovercard = __webpack_require__(1548);
	
	var _Hovercard2 = _interopRequireDefault(_Hovercard);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _UniversalComposer = __webpack_require__(2032);
	
	var _UniversalComposer2 = _interopRequireDefault(_UniversalComposer);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	__webpack_require__(2113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UniversalComposeHovercard = function (_Component) {
	  _inherits(UniversalComposeHovercard, _Component);
	
	  function UniversalComposeHovercard() {
	    _classCallCheck(this, UniversalComposeHovercard);
	
	    return _possibleConstructorReturn(this, (UniversalComposeHovercard.__proto__ || Object.getPrototypeOf(UniversalComposeHovercard)).apply(this, arguments));
	  }
	
	  _createClass(UniversalComposeHovercard, [{
	    key: 'getUniversalComposerForPanel',
	    value: function getUniversalComposerForPanel(panel) {
	      var canAnnounce = this.props.currentUser.canCreateGroups();
	      return _react2.default.createElement(_UniversalComposer2.default, { canAnnounce: canAnnounce, panel: panel, onMessageSent: this.props.onMessageSent });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          currentUser = _props.currentUser,
	          hideAnnouncements = _props.hideAnnouncements,
	          hideActivities = _props.hideActivities,
	          onComposeSelection = _props.onComposeSelection;
	
	
	      var canComposeAnnouncements = !hideAnnouncements && currentUser.canComposeAnnouncements();
	      var canComposeGroupChat = currentUser.canComposeGroupChat();
	      var canComposeActivity = !hideActivities && currentUser.canCreateActivity();
	      var canComposeIndividualChat = currentUser.canComposeIndividualChat();
	      var eventScreenName = 'universal_composer_hovercard';
	
	      return _react2.default.createElement(
	        _Hovercard2.default,
	        _extends({}, this.props, { className: 'UniversalComposeHovercard' }),
	        canComposeAnnouncements && _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: this.getUniversalComposerForPanel(_UniversalComposer.PANELS.CLASS_ANNOUCEMENT) },
	          _react2.default.createElement(
	            'div',
	            { className: 'UniversalComposeHovercard-item', onClick: onComposeSelection },
	            _react2.default.createElement(_Avatar2.default, { glyphName: 'megaphone', color: 'brand', size: 'small' }),
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                className: 'UniversalComposeHovercard-item-link',
	                eventElementName: 'class_announcement',
	                eventScreenName: eventScreenName,
	                color: 'inherit' },
	              'Class announcement'
	            )
	          )
	        ),
	        canComposeGroupChat && _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: this.getUniversalComposerForPanel(_UniversalComposer.PANELS.GROUP_CONVERSATION) },
	          _react2.default.createElement(
	            'div',
	            { className: 'UniversalComposeHovercard-item', onClick: onComposeSelection },
	            _react2.default.createElement(_Avatar2.default, { glyphName: 'avatar-group-stroke', color: 'brand', size: 'small' }),
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                'data-test-selector': 'group_conversation_menu_item',
	                className: 'UniversalComposeHovercard-item-link',
	                eventElementName: 'group_conversation',
	                eventScreenName: eventScreenName,
	                color: 'inherit' },
	              'Group conversation'
	            )
	          )
	        ),
	        canComposeIndividualChat && _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: this.getUniversalComposerForPanel(_UniversalComposer.PANELS.INDIVIDUAL_MESSAGE) },
	          _react2.default.createElement(
	            'div',
	            { className: 'UniversalComposeHovercard-item', onClick: onComposeSelection },
	            _react2.default.createElement(_Avatar2.default, { glyphName: 'message-individual', color: 'brand', size: 'small' }),
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                className: 'UniversalComposeHovercard-item-link',
	                eventElementName: 'individual_message',
	                eventScreenName: eventScreenName,
	                color: 'inherit' },
	              'Individual message'
	            )
	          )
	        ),
	        canComposeActivity && _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: _react2.default.createElement(_ActivityCreateDialogContainer2.default, null) },
	          _react2.default.createElement(
	            'div',
	            { className: 'UniversalComposeHovercard-item', onClick: onComposeSelection },
	            _react2.default.createElement(_Avatar2.default, { glyphName: 'calendar-stroke', color: 'brand', size: 'small' }),
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                className: 'UniversalComposeHovercard-item-link',
	                eventElementName: 'new_activity',
	                eventScreenName: eventScreenName,
	                color: 'inherit' },
	              'Activity'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UniversalComposeHovercard;
	}(_react.Component);
	
	UniversalComposeHovercard.displayName = 'UniversalComposeHovercard';
	exports.default = UniversalComposeHovercard;

/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _ActivityCreateDialog = __webpack_require__(1727);
	
	var _ActivityCreateDialog2 = _interopRequireDefault(_ActivityCreateDialog);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getDefaultGroups(groupCode) {
	  var postableGroups = _GroupStore2.default.getPostableGroups().models;
	
	  // If there is only one postable class, always use it
	  if (postableGroups.length === 1) {
	    return postableGroups;
	  }
	
	  if (!groupCode) {
	    return [];
	  }
	
	  var group = _GroupStore2.default.getGroupForCode(groupCode);
	  if (postableGroups.includes(group)) {
	    return [group];
	  }
	
	  return [];
	}
	
	var ActivityCreateDialogContainer = function (_React$Component) {
	  _inherits(ActivityCreateDialogContainer, _React$Component);
	
	  function ActivityCreateDialogContainer() {
	    _classCallCheck(this, ActivityCreateDialogContainer);
	
	    return _possibleConstructorReturn(this, (ActivityCreateDialogContainer.__proto__ || Object.getPrototypeOf(ActivityCreateDialogContainer)).apply(this, arguments));
	  }
	
	  _createClass(ActivityCreateDialogContainer, [{
	    key: 'render',
	    value: function render() {
	      var defaultGroupCodes = getDefaultGroups(this.context.params.groupCode).map(
	      // $FlowFixMe https://github.com/remind101/r101-frontend/pull/4065
	      function (group) {
	        return group.getCode();
	      });
	
	      return _react2.default.createElement(_ActivityCreateDialog2.default, _extends({
	        defaultGroupCodes: defaultGroupCodes
	      }, this.props, this.state));
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        currentUser: _CurrentUser2.default.getUser()
	      };
	    }
	  }]);
	
	  return ActivityCreateDialogContainer;
	}(_react2.default.Component);
	
	ActivityCreateDialogContainer.contextTypes = {
	  params: _react2.default.PropTypes.object.isRequired
	};
	ActivityCreateDialogContainer.displayName = 'ActivityCreateDialogContainer';
	exports.default = _utils.Container.create(ActivityCreateDialogContainer, { withProps: true });

/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// typecheck: ignore file
	// eslint-disable-line
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ActivityAnnouncementTeacherComposer = __webpack_require__(1728);
	
	var _ActivityAnnouncementTeacherComposer2 = _interopRequireDefault(_ActivityAnnouncementTeacherComposer);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _SetUserEmailModal = __webpack_require__(1402);
	
	var _SetUserEmailModal2 = _interopRequireDefault(_SetUserEmailModal);
	
	var _modal = __webpack_require__(1188);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	__webpack_require__(2030);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function CloseDialogConfirmationDialog(props) {
	  return _react2.default.createElement(_ConfirmDialog2.default, _extends({
	    eventScreenName: 'ActivityCreateDialog',
	    hideCloseButton: true,
	    title: 'Would you like to close out of creating an activity',
	    subtext: 'Your progress will not be saved',
	    actionButtonText: 'Yes',
	    cancelButtonText: 'Cancel'
	  }, props));
	}
	
	var ActivityCreateDialog = function (_React$Component) {
	  _inherits(ActivityCreateDialog, _React$Component);
	
	  function ActivityCreateDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityCreateDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityCreateDialog.__proto__ || Object.getPrototypeOf(ActivityCreateDialog)).call.apply(_ref, [this].concat(args))), _this), _this.onActivitySent = function () {
	      if (_this.props.onRequestHide) {
	        _this.props.onRequestHide();
	      }
	
	      if (_this.props.onActivitySent) {
	        _this.props.onActivitySent();
	      }
	    }, _this.onDialogRequestHide = function () {
	      var close = _this.props.onRequestHide || function () {};
	      var state = _this.getComposerState();
	
	      // if user selected a type (which is the first screen)
	      // we prompt a confirm dialog before closing the activity dialog
	      if (state.type) {
	        (0, _modal.mountModal)(_react2.default.createElement(CloseDialogConfirmationDialog, { onConfirm: close }), _this);
	      } else {
	        close();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityCreateDialog, [{
	    key: 'componentDidMount',
	
	
	    /* This is kinda weird, this is to make
	     * sure all groups are loaded for the recipient picker
	     * further down in ActivityAnnouncementTeacherComposer
	     * It needs to be move in the recipient picker component.
	     */
	    value: function componentDidMount() {
	      _GroupActions2.default.loadGroups();
	    }
	  }, {
	    key: 'getComposerState',
	
	
	    /* Return the public state of the composer
	     * This is a function because I just wanted an
	     * easy way to stub the ref for shallow render.
	     */
	    value: function getComposerState() {
	      return this.refs.activity_composer.getWrappedInstance().getPublicState();
	    }
	
	    /* Render the user email form.
	     * There's no callback here, SetUserEmailModal will
	     * update the CurrentUser store and ActivityCreateDialogContainer
	     * will update and re-render ActivityCreateDialog.
	     */
	
	  }, {
	    key: 'renderRequireEmailView',
	    value: function renderRequireEmailView() {
	      return _react2.default.createElement(_SetUserEmailModal2.default, _extends({}, this.props, {
	        closeOnSave: false,
	        message: 'An email address is required to create an activity. This will be your primary email address for Remind.'
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.currentUser.hasEmail()) {
	        return this.renderRequireEmailView();
	      }
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({}, this.props, {
	          onRequestHide: this.onDialogRequestHide,
	          className: 'ActivityCreateDialog',
	          size: 'medium' }),
	        _react2.default.createElement(_ActivityAnnouncementTeacherComposer2.default, {
	          ref: 'activity_composer',
	          onActivitySent: this.onActivitySent,
	          defaultGroupCodes: this.props.defaultGroupCodes,
	          initialState: this.props.createParams || undefined
	        })
	      );
	    }
	  }]);
	
	  return ActivityCreateDialog;
	}(_react2.default.Component);
	
	ActivityCreateDialog.displayName = 'ActivityCreateDialog';
	exports.default = ActivityCreateDialog;

/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActivityAnnouncementTeacherComposer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(555);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _redux = __webpack_require__(476);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityAnnouncementAdditionalDetailForm = __webpack_require__(1729);
	
	var _ActivityAnnouncementAdditionalDetailForm2 = _interopRequireDefault(_ActivityAnnouncementAdditionalDetailForm);
	
	var _ActivityAnnouncementAmountForm = __webpack_require__(1866);
	
	var _ActivityAnnouncementAmountForm2 = _interopRequireDefault(_ActivityAnnouncementAmountForm);
	
	var _ActivityAnnouncementChatMessageFormView = __webpack_require__(1875);
	
	var _ActivityAnnouncementChatMessageFormView2 = _interopRequireDefault(_ActivityAnnouncementChatMessageFormView);
	
	var _ActivityAnnouncementTitleForm = __webpack_require__(1920);
	
	var _ActivityAnnouncementTitleForm2 = _interopRequireDefault(_ActivityAnnouncementTitleForm);
	
	var _ActivityAnnouncementTypePicker = __webpack_require__(1923);
	
	var _ActivityAnnouncementTypePicker2 = _interopRequireDefault(_ActivityAnnouncementTypePicker);
	
	var _ActivityActions = __webpack_require__(976);
	
	var _ActivityActions2 = _interopRequireDefault(_ActivityActions);
	
	var _ActivityRSVPPreview = __webpack_require__(1930);
	
	var _ActivityRSVPPreview2 = _interopRequireDefault(_ActivityRSVPPreview);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _CreateEventCostEducation = __webpack_require__(1732);
	
	var _CreateEventCostEducation2 = _interopRequireDefault(_CreateEventCostEducation);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Hovercard = __webpack_require__(1548);
	
	var _Hovercard2 = _interopRequireDefault(_Hovercard);
	
	var _OverlayLoading = __webpack_require__(2022);
	
	var _OverlayLoading2 = _interopRequireDefault(_OverlayLoading);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _modal = __webpack_require__(1188);
	
	var _RelatedUserSummary = __webpack_require__(909);
	
	var _RelatedUserSummary2 = _interopRequireDefault(_RelatedUserSummary);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _roleHelpers = __webpack_require__(1230);
	
	var _Message = __webpack_require__(930);
	
	var _roleBasedMessagingSearch = __webpack_require__(1901);
	
	__webpack_require__(2028);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	// InitialValues is State without page or groupCodes
	// Any fields may be excluded
	var TITLE_PLACEHOLDER_MAPPING = {
	  field_trip: 'E.g. Day at the Aquarium',
	  event: 'E.g. Spring Choir Concert',
	  fundraiser: 'E.g. PTO Car Wash',
	  order: 'E.g. Spring Training T-Shirts'
	};
	
	var ActivityAnnouncementTeacherComposer = function (_React$Component) {
	  _inherits(ActivityAnnouncementTeacherComposer, _React$Component);
	
	  function ActivityAnnouncementTeacherComposer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityAnnouncementTeacherComposer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityAnnouncementTeacherComposer.__proto__ || Object.getPrototypeOf(ActivityAnnouncementTeacherComposer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      page: _this.props.initialState.type ? 'title' : 'type',
	      title: _this.props.initialState.title || null,
	      groupCodes: _this.props.defaultGroupCodes || [],
	      location: _this.props.initialState.location || null,
	      date: _this.props.initialState.date || null,
	      endDate: _this.props.initialState.endDate || null,
	      amount: _this.props.initialState.amount || null,
	      type: _this.props.initialState.type || null,
	      hasChildren: _this.props.initialState.hasChildren || false,
	      disableReplies: _this.props.initialState.disableReplies || false,
	      message: _this.props.initialState.message || null,
	      targets: [],
	      inComposer: false,
	      loading: false
	    }, _this.mountRSVPPreview = function () {
	      var requester = new _RelatedUserSummary2.default({
	        display_name: _CurrentUser2.default.getUser().getDisplayName()
	      });
	
	      var previewActivity = new _Activity2.default({
	        title: _this.state.title,
	        amount_per_person: _this.state.amount,
	        location: _this.state.location,
	        has_children: _this.state.hasChildren,
	        start_at: _this.state.date,
	        end_at: _this.state.endDate,
	        group_ids: null,
	        collect_online: !!_this.state.collectOnline,
	        recipient_ids: null,
	        disable_replies: _this.state.disableReplies,
	        welcome_msg_body: _this.state.message,
	        event_type: _this.state.type,
	        targets: null,
	        requester: requester
	      });
	      (0, _modal.mountModal)(_react2.default.createElement(_ActivityRSVPPreview2.default, { isUnderage: false, activity: previewActivity }), _this);
	    }, _this.handlePreviewClick = function (values) {
	      _this.setState(_extends({}, values), _this.mountRSVPPreview);
	    }, _this.handleInComposer = function (inComposer) {
	      _this.setState({ inComposer: inComposer });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityAnnouncementTeacherComposer, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.deselect) {
	        this.props.deselect();
	      }
	    }
	
	    // public
	
	  }, {
	    key: 'getPublicState',
	    value: function getPublicState() {
	      return {
	        type: this.state.type
	      };
	    }
	  }, {
	    key: 'createActivityFromCurrentState',
	    value: function createActivityFromCurrentState() {
	      var _this2 = this;
	
	      var groupIds = [];
	      var individualIds = [];
	      var roleTargets = []; // group targets with roles other than EVERYONE
	
	      // FIXME: Once the backend handles group roles on activity creation
	      // all targets can be passed directly through to the backend.
	      if (this.state.targets) {
	        this.state.targets.forEach(function (t) {
	          if (t.type === _Message.TARGET_TYPES.GROUP_TARGET) {
	            if (t.role === _roleHelpers.EVERYONE) {
	              groupIds.push(t.group_id);
	            } else {
	              roleTargets.push(t);
	            }
	          } else {
	            individualIds.push(t.member_id);
	          }
	        });
	      }
	
	      var onSuccess = function onSuccess(activity) {
	        var chatUuid = activity.getChatUuid();
	        _ChatActions2.default.loadChat(chatUuid).then(function () {
	          _this2.context.router.push({
	            pathname: '/chat/' + chatUuid
	          });
	        });
	      };
	
	      var onError = function onError(error) {
	        _ToastActions2.default.showAPIError(error);
	        _this2.setState({ page: 'chat_message_and_recipient' });
	      };
	
	      // typecheck: ignore statement
	      var params = {
	        title: this.state.title || '',
	        amountPerPerson: this.state.amount,
	        location: this.state.location,
	        date: this.state.date,
	        endDate: this.state.endDate,
	        hasChildren: this.state.hasChildren,
	        groupIds: (0, _lodash.uniq)(groupIds),
	        collectOnline: !!this.state.collectOnline,
	        disableReplies: this.state.disableReplies,
	        welcomeMsgBody: this.state.message,
	        type: this.state.type,
	        targets: roleTargets,
	        individualIds: individualIds
	      };
	
	      this.setState({ loading: true });
	
	      _ActivityActions2.default.create(params).then(onSuccess).then(this.props.onActivitySent, onError).then(function () {
	        return _this2.setState({ loading: false });
	      });
	    }
	  }, {
	    key: 'getActivityImageType',
	    value: function getActivityImageType() {
	      if (this.state.type) {
	        return _ActivityAnnouncementTypePicker.TYPE_TO_IMG[this.state.type];
	      } else {
	        return undefined;
	      }
	    }
	  }, {
	    key: 'getPlaceholder',
	    value: function getPlaceholder() {
	      return TITLE_PLACEHOLDER_MAPPING[this.state.type || 'field_trip'];
	    }
	  }, {
	    key: 'renderTypeView',
	    value: function renderTypeView(onBack, onNext) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityAnnouncementTeacherComposer-view' },
	        _react2.default.createElement(_TitleHeader2.default, {
	          title: 'What type of activity would you like to organize?',
	          bottomMargin: 'small'
	        }),
	        _react2.default.createElement(_ActivityAnnouncementTypePicker2.default, {
	          type: this.state.type,
	          onSelect: onNext
	        })
	      );
	    }
	  }, {
	    key: 'renderTitleView',
	    value: function renderTitleView(onBack, onNext) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityAnnouncementTeacherComposer-view' },
	        _react2.default.createElement(_TitleHeader2.default, {
	          image: this.getActivityImageType(),
	          imageClassName: 'ActivityAnnouncementTeacherComposer-img',
	          title: 'Great! Let\'s get this show on the road.',
	          bottomMargin: 'xlarge'
	        }),
	        _react2.default.createElement(_ActivityAnnouncementTitleForm2.default, {
	          title: this.state.title,
	          onBack: onBack,
	          onNext: onNext,
	          placeholder: this.getPlaceholder()
	        })
	      );
	    }
	  }, {
	    key: 'renderAmountView',
	    value: function renderAmountView(onBack, onNext) {
	      var subText = _react2.default.createElement(
	        'span',
	        null,
	        'You can collect money on Remind or through a different method. Funds on Remind can be deposited directly into your school\u2019s bank account.',
	        _react2.default.createElement(
	          _LayerTrigger2.default,
	          {
	            trigger: 'click',
	            layer: _react2.default.createElement(
	              _Hovercard2.default,
	              { className: 'ActivityAnnouncementTeacherComposer-amountHovercard' },
	              _react2.default.createElement(_CreateEventCostEducation2.default, null)
	            ) },
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              className: 'ActivityAnnouncementTeacherComposer-link',
	              eventElementName: 'ActivityAnnouncementTeacherComposer-link' },
	            ' ',
	            'Learn More'
	          )
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityAnnouncementTeacherComposer-view' },
	        _react2.default.createElement(_TitleHeader2.default, {
	          image: this.getActivityImageType(),
	          imageClassName: 'ActivityAnnouncementTeacherComposer-img',
	          title: 'How much does ' + (this.state.title || 'this activity') + ' cost per person? ',
	          subtext: subText,
	          bottomMargin: 'xlarge'
	        }),
	        _react2.default.createElement(_ActivityAnnouncementAmountForm2.default, {
	          initialCollectedOnline: this.state.collectOnline,
	          initialAmount: this.state.amount,
	          onBack: onBack,
	          onNext: onNext
	        })
	      );
	    }
	  }, {
	    key: 'renderLocationAndDateView',
	    value: function renderLocationAndDateView(onBack, onNext) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityAnnouncementTeacherComposer-view' },
	        _react2.default.createElement(_TitleHeader2.default, {
	          image: this.getActivityImageType(),
	          imageClassName: 'ActivityAnnouncementTeacherComposer-img',
	          title: 'Now, the basics.',
	          bottomMargin: 'xlarge'
	        }),
	        _react2.default.createElement(_ActivityAnnouncementAdditionalDetailForm2.default, {
	          withoutAmountInput: true,
	          location: this.state.location,
	          date: this.state.date,
	          endDate: this.state.endDate,
	          onBack: onBack,
	          onNext: onNext
	        })
	      );
	    }
	  }, {
	    key: 'renderChatMessageAndRecipientFormView',
	    value: function renderChatMessageAndRecipientFormView(onBack, onNext) {
	      var inComposerExperimentVariation = _CurrentUser2.default.inExpVariant('ACTIVITY_CREATION_INDIVIDUAL_COMPOSER', 'enabled');
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)({ 'ActivityAnnouncementTeacherComposer-view': this.state.inComposer }) },
	        _react2.default.createElement(_TitleHeader2.default, {
	          image: this.getActivityImageType(),
	          imageClassName: 'ActivityAnnouncementTeacherComposer-img',
	          title: 'Almost there! Add a message to your invitation.',
	          bottomMargin: 'xlarge'
	        }),
	        _react2.default.createElement(_ActivityAnnouncementChatMessageFormView2.default, {
	          withRecipientInput: true,
	          message: this.state.message,
	          groupCodes: this.state.groupCodes,
	          hasChildren: this.state.hasChildren,
	          disableReplies: this.state.disableReplies,
	          onBack: onBack,
	          onNext: onNext,
	          onPreviewClick: this.handlePreviewClick,
	          onInComposerChange: this.handleInComposer,
	          title: this.state.title || '',
	          showIndividualRecipients: inComposerExperimentVariation
	        })
	      );
	    }
	  }, {
	    key: 'getPage',
	    value: function getPage() {
	      var _this3 = this;
	
	      var canCollectMoney = _CurrentUser2.default.isSignedIn() && _CurrentUser2.default.getUser().canCollectMoney();
	
	      switch (this.state.page) {
	        case 'type':
	          return this.renderTypeView(undefined, function (values) {
	            return _this3.setState(_extends({}, values, { page: 'title' }));
	          });
	
	        case 'title':
	          return this.renderTitleView(function (values) {
	            return _this3.setState(_extends({}, values, { page: 'type' }));
	          }, function (values) {
	            return _this3.setState(_extends({}, values, { page: 'location_and_date' }));
	          });
	
	        case 'location_and_date':
	          return this.renderLocationAndDateView(function (values) {
	            return _this3.setState(_extends({}, values, { page: 'title' }));
	          }, function (values) {
	            return _this3.setState(_extends({}, values, { page: canCollectMoney ? 'amount' : 'chat_message_and_recipient' }));
	          });
	
	        case 'amount':
	          return this.renderAmountView(function (values) {
	            return _this3.setState(_extends({}, values, { page: 'location_and_date' }));
	          }, function (values) {
	            return _this3.setState(_extends({}, values, { page: 'chat_message_and_recipient' }));
	          });
	
	        case 'chat_message_and_recipient':
	          return this.renderChatMessageAndRecipientFormView(function (values) {
	            return _this3.setState(_extends({}, values, { page: canCollectMoney ? 'amount' : 'location_and_date' }));
	          }, function (values) {
	            return _this3.setState(_extends({}, values), _this3.createActivityFromCurrentState);
	          });
	
	        default:
	          return _react2.default.createElement('span', null);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityAnnouncementTeacherComposer', 'data-test-selector': 'activity-announcement-composer-modal' },
	        this.state.loading && _react2.default.createElement(_OverlayLoading2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityAnnouncementTeacherComposer-content' },
	          this.getPage()
	        )
	      );
	    }
	  }]);
	
	  return ActivityAnnouncementTeacherComposer;
	}(_react2.default.Component);
	
	ActivityAnnouncementTeacherComposer.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired,
	  params: _react2.default.PropTypes.object.isRequired
	};
	ActivityAnnouncementTeacherComposer.defaultProps = {
	  initialState: {}
	};
	ActivityAnnouncementTeacherComposer.displayName = 'ActivityAnnouncementTeacherComposer';
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    deselect: _roleBasedMessagingSearch.reset
	  }, dispatch);
	};
	
	exports.ActivityAnnouncementTeacherComposer = ActivityAnnouncementTeacherComposer;
	exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps, undefined, { withRef: true })(ActivityAnnouncementTeacherComposer);

/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ActivityForm = __webpack_require__(1730);
	
	var _ActivityForm2 = _interopRequireDefault(_ActivityForm);
	
	var _PageControls = __webpack_require__(1861);
	
	var _PageControls2 = _interopRequireDefault(_PageControls);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	__webpack_require__(1864);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CENTS_IN_DOLLAR = 100;
	
	var ActivityAnnouncementAdditionalDetailForm = function (_React$Component) {
	  _inherits(ActivityAnnouncementAdditionalDetailForm, _React$Component);
	
	  function ActivityAnnouncementAdditionalDetailForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityAnnouncementAdditionalDetailForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityAnnouncementAdditionalDetailForm.__proto__ || Object.getPrototypeOf(ActivityAnnouncementAdditionalDetailForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      amount: _this.props.amount,
	      location: _this.props.location,
	      date: _this.props.date,
	      endDate: _this.props.endDate
	    }, _this.setStateFromValues = function (values, onSetState) {
	      _this.setState({
	        location: values.location,
	        date: values.date,
	        endDate: values.end_date,
	        amount: values.amount * CENTS_IN_DOLLAR
	      }, onSetState);
	    }, _this.onChange = function (values) {
	      _this.setStateFromValues(values);
	    }, _this.onBack = function () {
	      var amount = _this.props.withoutAmountInput ? {} : { amount: _this.state.amount };
	      _this.props.onBack(_extends({
	        location: _this.state.location,
	        date: _this.state.date,
	        endDate: _this.state.endDate
	      }, amount));
	    }, _this.onValidSubmit = function (values) {
	      _this.setStateFromValues(values, function () {
	        var amount = _this.props.withoutAmountInput ? {} : { amount: _this.state.amount };
	        _this.props.onNext(_extends({
	          location: _this.state.location,
	          date: _this.state.date,
	          endDate: _this.state.endDate
	        }, amount));
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityAnnouncementAdditionalDetailForm, [{
	    key: 'render',
	    value: function render() {
	      var initialActivity = void 0;
	      if (this.state.location || this.state.date || this.state.endDate || this.state.amount) {
	        initialActivity = _Activity2.default.fromJSON({
	          location: this.state.location,
	          start_at: this.state.date,
	          amount_per_person: this.state.amount,
	          end_at: this.state.endDate
	        });
	      }
	
	      var canCollectMoney = _CurrentUser2.default.isSignedIn() && _CurrentUser2.default.getUser().canCollectMoney();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityAnnouncementAdditionalDetailForm' },
	        _react2.default.createElement(_ActivityForm2.default, {
	          showLabels: true,
	          canCollectMoney: canCollectMoney && !this.props.withoutAmountInput,
	          showTitleField: false,
	          showWelcomeMsgBodyField: false,
	          showCheckboxFields: false,
	          submitText: 'Next',
	          initialActivity: initialActivity,
	          onValidSubmit: this.onValidSubmit,
	          onChange: this.onChange
	        }),
	        _react2.default.createElement(_PageControls2.default, {
	          className: 'ActivityAnnouncementAdditionalDetailForm-controls',
	          onBack: this.onBack
	        })
	      );
	    }
	  }]);
	
	  return ActivityAnnouncementAdditionalDetailForm;
	}(_react2.default.Component);
	
	ActivityAnnouncementAdditionalDetailForm.displayName = 'ActivityAnnouncementAdditionalDetailForm';
	exports.default = ActivityAnnouncementAdditionalDetailForm;

/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _AmountInput = __webpack_require__(1731);
	
	var _AmountInput2 = _interopRequireDefault(_AmountInput);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ClickEventTrigger = __webpack_require__(1181);
	
	var _ClickEventTrigger2 = _interopRequireDefault(_ClickEventTrigger);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _EventTrackingConstants = __webpack_require__(1745);
	
	var _EventTrackingConstants2 = _interopRequireDefault(_EventTrackingConstants);
	
	var _FocusEventTrigger = __webpack_require__(1746);
	
	var _FocusEventTrigger2 = _interopRequireDefault(_FocusEventTrigger);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormCheckBox = __webpack_require__(1705);
	
	var _FormCheckBox2 = _interopRequireDefault(_FormCheckBox);
	
	var _FormDatePickerInput = __webpack_require__(1748);
	
	var _FormDatePickerInput2 = _interopRequireDefault(_FormDatePickerInput);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormTimePickerInput = __webpack_require__(1853);
	
	var _FormTimePickerInput2 = _interopRequireDefault(_FormTimePickerInput);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Textarea = __webpack_require__(1598);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	__webpack_require__(1859);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	// typecheck: ignore file
	
	
	var ActivityForm = function (_Component) {
	  _inherits(ActivityForm, _Component);
	
	  function ActivityForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityForm.__proto__ || Object.getPrototypeOf(ActivityForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      submitDisabled: true,
	      amount: _this.props.initialActivity ? (_this.props.initialActivity.getAmountPerPerson() || 0) / 100 : null,
	      hasChildren: _this.props.initialActivity ? _this.props.initialActivity.hasChildren() : false,
	      collectOnline: _this.props.initialActivity ? _this.props.initialActivity.isCollectingMoneyOnline() : true,
	      timeInputIsPristine: !_this.props.initialActivity, // not pristine when editing
	      tomorrow: new Date(new Date().getTime() + 24 * 60 * 60 * 1000) }, _this.onValid = function () {
	      if (_this.state.submitDisabled && !_this.props.disabled) {
	        _this.setState({ submitDisabled: false });
	      }
	    }, _this.onInvalid = function () {
	      if (!_this.state.submitDisabled) {
	        _this.setState({ submitDisabled: true });
	      }
	    }, _this.treatTimeValues = function (values) {
	      if (values.time && values.date) {
	        values.date = new Date(values.date.getFullYear(), values.date.getMonth(), values.date.getDate(), values.time.getHours(), values.time.getMinutes(), values.time.getSeconds(), values.time.getMilliseconds());
	        delete values.time;
	      }
	
	      if (values.end_time && values.date) {
	        values.end_date = new Date(values.date.getFullYear(), values.date.getMonth(), values.date.getDate(), values.end_time.getHours(), values.end_time.getMinutes(), values.end_time.getSeconds(), values.end_time.getMilliseconds());
	        delete values.end_time;
	      }
	      return values;
	    }, _this.onValidSubmit = function (values, resetForm, invalidateForm) {
	      if (!values.has_no_children) {
	        values.enable_replies = false;
	      }
	
	      // The ui checkbox are inverted from the values
	      // since it easier to have checked == true.
	      // Here we revert them to they normal names & values.
	      values.disable_replies = !values.enable_replies;
	      delete values.enable_replies;
	
	      values.has_children = !values.has_no_children;
	      delete values.has_no_children;
	
	      var treatedValues = _this.treatTimeValues(values);
	
	      if (_this.props.onValidSubmit) {
	        _this.props.onValidSubmit(treatedValues, resetForm, invalidateForm);
	      }
	    }, _this.onDateChange = function (date) {
	      if (_this.state.timeInputIsPristine) {
	        var time = new Date(date);
	        time.setHours(12, 0, 0); // default to noon
	        var endTime = new Date(time.getTime());
	        endTime.setHours(time.getHours() + 1);
	        _this.setState({ timeInputIsPristine: false, time: time, endTime: endTime });
	      }
	    }, _this.onChange = function (values) {
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(_this.treatTimeValues(values));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityForm, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          tomorrow = _state.tomorrow,
	          hasChildren = _state.hasChildren;
	      var _props = this.props,
	          initialActivity = _props.initialActivity,
	          disabled = _props.disabled;
	
	
	      var title = null;
	      var welcomeMsgBody = null;
	      var location = null;
	      var dateTime = null;
	      var endDateTime = null;
	      var enableReplies = true;
	
	      if (initialActivity) {
	        title = initialActivity.getTitle();
	        welcomeMsgBody = initialActivity.getWelcomeMsgBody();
	        location = initialActivity.getLocation();
	        dateTime = initialActivity.getStartAt();
	        endDateTime = initialActivity.getEndAt();
	        enableReplies = !initialActivity.hasDisableReplies();
	      }
	
	      var time = this.state.time ? this.state.time : dateTime;
	      var endTime = this.state.endTime ? this.state.endTime : endDateTime;
	      var minDate = void 0;
	
	      // when editing an activity, we want the minimun date to be
	      // the current activity start at date even if it's in the past.
	      if (dateTime && dateTime < tomorrow) {
	        minDate = dateTime;
	      } else {
	        minDate = tomorrow;
	      }
	
	      return _react2.default.createElement(
	        _Form2.default,
	        _extends({}, this.props, {
	          onChange: this.onChange,
	          onValid: (0, _createChainedFunction2.default)(this.onValid, this.props.onValid),
	          onInvalid: (0, _createChainedFunction2.default)(this.onInvalid, this.props.onInvalid),
	          onValidSubmit: this.onValidSubmit }),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityForm-row' },
	          this.props.showTitleField && _react2.default.createElement(
	            'div',
	            { className: 'ActivityForm-row-title' },
	            _react2.default.createElement(
	              _FocusEventTrigger2.default,
	              {
	                eventElementName: 'activity_title',
	                eventScreenName: _EventTrackingConstants2.default.CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG,
	                trackChildComponents: true },
	              _react2.default.createElement(_FormInput2.default, {
	                label: 'Title',
	                labelHidden: !this.props.showLabels,
	                name: 'title',
	                autoFocus: true,
	                autoComplete: 'off',
	                required: 'isRequired',
	                placeholder: 'Title of activity',
	                validations: { maxLength: 50 },
	                showErrorAfterBlur: true,
	                validationErrors: {
	                  isRequired: 'An activity name is required.',
	                  maxLength: 'The activity name can’t be longer than 50 characters.'
	                },
	                value: title,
	                disabled: disabled
	              })
	            )
	          ),
	          this.props.canCollectMoney && _react2.default.createElement(
	            'div',
	            { className: 'ActivityForm-row-amount' },
	            _react2.default.createElement(
	              _ClickEventTrigger2.default,
	              {
	                eventScreenName: _EventTrackingConstants2.default.CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG,
	                eventElementName: 'activity_amount' },
	              _react2.default.createElement(_FormInput2.default, {
	                label: 'Cost per person',
	                labelHidden: !this.props.showLabels,
	                name: 'amount',
	                component: _AmountInput2.default,
	                placeholder: 'Cost',
	                value: this.state.amount,
	                onChange: function onChange(value) {
	                  return _this2.setState({ amount: value });
	                },
	                validations: {
	                  isValidEventAmount: 0.99,
	                  isLessThan: 2001
	                },
	                validationErrors: {
	                  isValidEventAmount: 'The minimum amount is $1.',
	                  isLessThan: 'The maximum amount is $2000.'
	                },
	                disabled: disabled
	              })
	            )
	          )
	        ),
	        this.props.showWelcomeMsgBodyField && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _ClickEventTrigger2.default,
	            {
	              eventElementName: 'activity_welcome_msg_body',
	              eventScreenName: _EventTrackingConstants2.default.CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG },
	            _react2.default.createElement(_FormInput2.default, {
	              label: 'Welcome message',
	              labelHidden: !this.props.showLabels,
	              rows: 6,
	              name: 'welcome_msg_body',
	              component: _Textarea2.default,
	              placeholder: 'Welcome message',
	              value: welcomeMsgBody,
	              disabled: disabled
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityForm-row' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _ClickEventTrigger2.default,
	              {
	                eventElementName: 'activity_date',
	                eventScreenName: _EventTrackingConstants2.default.CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG },
	              _react2.default.createElement(_FormDatePickerInput2.default, {
	                label: 'Day',
	                labelHidden: !this.props.showLabels,
	                'data-test': 'activity-form-date',
	                name: 'date',
	                autoComplete: 'off',
	                required: 'isRequired',
	                min: minDate,
	                showErrorAfterBlur: true,
	                onChange: this.onDateChange,
	                validations: { isGreaterOrEqualToDate: minDate },
	                placeholder: 'Date',
	                validationErrors: {
	                  isRequired: 'An activity date is required.',
	                  isGreaterOrEqualToDate: 'The activity date can’t be in the past.'
	                },
	                value: dateTime,
	                disabled: disabled
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _ClickEventTrigger2.default,
	              {
	                eventScreenName: _EventTrackingConstants2.default.CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG,
	                eventElementName: 'activity_time' },
	              _react2.default.createElement(_FormTimePickerInput2.default, {
	                label: 'Start time',
	                labelHidden: !this.props.showLabels,
	                'data-test': 'activity-form-time',
	                required: 'isRequired',
	                autoComplete: 'off',
	                className: 'ActivityForm-row-time-input',
	                name: 'time',
	                placeholder: 'Start time',
	                showErrorAfterBlur: true,
	                value: time,
	                disabled: disabled
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _ClickEventTrigger2.default,
	              {
	                eventScreenName: _EventTrackingConstants2.default.CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG,
	                eventElementName: 'activity_end_time' },
	              _react2.default.createElement(_FormTimePickerInput2.default, {
	                label: 'End time',
	                labelHidden: !this.props.showLabels,
	                'data-test': 'activity-form-end-time',
	                autoComplete: 'off',
	                className: 'ActivityForm-row-end-time-input',
	                name: 'end_time',
	                placeholder: 'End time',
	                showErrorAfterBlur: true,
	                value: endTime,
	                disabled: disabled
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _ClickEventTrigger2.default,
	          {
	            eventElementName: 'activity_location',
	            eventScreenName: _EventTrackingConstants2.default.CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG },
	          _react2.default.createElement(_FormInput2.default, {
	            label: 'Location',
	            labelHidden: !this.props.showLabels,
	            'data-test': 'activity-form-location',
	            glyph: 'location-pin',
	            name: 'location',
	            placeholder: 'Location',
	            inputClassName: 'ActivityForm-location-input',
	            value: location,
	            disabled: disabled
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityForm-footer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ActivityForm-footer-checkboxes' },
	            this.props.showCheckboxFields && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_FormCheckBox2.default, {
	                  defaultChecked: !hasChildren,
	                  name: 'has_no_children',
	                  label: 'All participants are 13 or older',
	                  onChange: function onChange(value) {
	                    return _this2.setState({ hasChildren: !value.currentTarget.checked });
	                  },
	                  eventScreenName: _EventTrackingConstants2.default.CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG,
	                  eventElementName: 'activity_has_no_children'
	                })
	              ),
	              this.state.amount > 0 && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_FormCheckBox2.default, {
	                  name: 'collect_online',
	                  label: 'Use Remind to collect funds for this activity',
	                  checked: this.state.collectOnline,
	                  onChange: function onChange() {
	                    return _this2.setState({ collectOnline: !_this2.state.collectOnline });
	                  },
	                  eventScreenName: _EventTrackingConstants2.default.CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG,
	                  eventElementName: 'activity_collect_online'
	                })
	              ),
	              this.props.showEnableReplies && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_FormCheckBox2.default, {
	                  className: 'ActivityForm-footer-replies',
	                  disabled: hasChildren,
	                  defaultChecked: enableReplies,
	                  name: 'enable_replies',
	                  label: 'Allow participants to reply to the group conversation',
	                  eventScreenName: _EventTrackingConstants2.default.CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG,
	                  eventElementName: 'activity_enable_replies'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                'data-test': 'activity-form-submit',
	                size: 'small',
	                className: 'ActivityForm-submit',
	                eventScreenName: _EventTrackingConstants2.default.CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG,
	                eventElementName: 'create_activity',
	                loading: this.props.loading,
	                disabled: this.state.submitDisabled || this.props.disabled },
	              this.props.submitText
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ActivityForm;
	}(_react.Component);
	
	ActivityForm.defaultProps = {
	  loading: false,
	  canCollectMoney: true,
	  showEnableReplies: false,
	  submitText: 'Create',
	  showLabels: false,
	  showTitleField: true,
	  showWelcomeMsgBodyField: true,
	  showCheckboxFields: true,
	  disabled: false
	};
	ActivityForm.displayName = 'ActivityForm';
	exports.default = ActivityForm;

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CreateEventCostEducation = __webpack_require__(1732);
	
	var _CreateEventCostEducation2 = _interopRequireDefault(_CreateEventCostEducation);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Hovercard = __webpack_require__(1548);
	
	var _Hovercard2 = _interopRequireDefault(_Hovercard);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _NumberInput = __webpack_require__(1742);
	
	var _NumberInput2 = _interopRequireDefault(_NumberInput);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1743);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HelpHovercard = function (_Component) {
	  _inherits(HelpHovercard, _Component);
	
	  function HelpHovercard() {
	    _classCallCheck(this, HelpHovercard);
	
	    return _possibleConstructorReturn(this, (HelpHovercard.__proto__ || Object.getPrototypeOf(HelpHovercard)).apply(this, arguments));
	  }
	
	  _createClass(HelpHovercard, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Hovercard2.default,
	        _extends({}, this.props, { className: 'AmountInput-hovercard' }),
	        _react2.default.createElement(_CreateEventCostEducation2.default, null)
	      );
	    }
	  }]);
	
	  return HelpHovercard;
	}(_react.Component);
	
	HelpHovercard.displayName = 'HelpHovercard';
	
	var AmountInput = function (_Component2) {
	  _inherits(AmountInput, _Component2);
	
	  function AmountInput() {
	    var _ref;
	
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, AmountInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = AmountInput.__proto__ || Object.getPrototypeOf(AmountInput)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
	      focused: false
	    }, _this2.handleOnFocus = function () {
	      _this2.setState({ focused: true });
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  _createClass(AmountInput, [{
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.refs.input.getInputNode();
	    }
	  }, {
	    key: 'renderHelp',
	    value: function renderHelp() {
	      var button = _react2.default.createElement(
	        _Button2.default,
	        {
	          color: 'eclipse',
	          level: 'text',
	          className: 'AmountInput-help',
	          eventElementName: 'AmountInput-help' },
	        _react2.default.createElement(_Glyph2.default, { name: 'help', size: 'small', solo: true })
	      );
	
	      if (this.props.customHelpClickHandler) {
	        return button;
	      }
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        { trigger: 'click', placement: 'top', layer: _react2.default.createElement(HelpHovercard, null), delayShow: 400 },
	        button
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_NumberInput2.default, _extends({}, this.props, {
	          className: (0, _classnames2.default)('AmountInput', this.props.className),
	          inputClassName: (0, _classnames2.default)('AmountInput-input', this.props.inputClassName),
	          ref: 'input',
	          glyph: 'dollar-circle',
	          append: this.state.focused && this.renderHelp(),
	          onFocus: this.handleOnFocus
	        }))
	      );
	    }
	  }]);
	
	  return AmountInput;
	}(_react.Component);
	
	AmountInput.displayName = 'AmountInput';
	exports.default = AmountInput;

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CopyConstants = __webpack_require__(1733);
	
	var _EducationMediaObject = __webpack_require__(1734);
	
	var _EducationMediaObject2 = _interopRequireDefault(_EducationMediaObject);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1737);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateEventCostEducation = function (_React$Component) {
	  _inherits(CreateEventCostEducation, _React$Component);
	
	  function CreateEventCostEducation() {
	    _classCallCheck(this, CreateEventCostEducation);
	
	    return _possibleConstructorReturn(this, (CreateEventCostEducation.__proto__ || Object.getPrototypeOf(CreateEventCostEducation)).apply(this, arguments));
	  }
	
	  _createClass(CreateEventCostEducation, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        _extends({ className: 'CreateEventCostEducation' }, this.props),
	        _react2.default.createElement(_EducationMediaObject2.default, {
	          image: __webpack_require__(1739),
	          className: 'CreateEventCostEducation-education',
	          title: _CopyConstants.CreateEventCostEducation.title1,
	          text: _CopyConstants.CreateEventCostEducation.subheader1
	        }),
	        _react2.default.createElement(_EducationMediaObject2.default, {
	          image: __webpack_require__(1740),
	          className: 'CreateEventCostEducation-education',
	          title: _CopyConstants.CreateEventCostEducation.title2,
	          text: _CopyConstants.CreateEventCostEducation.subheader2
	        }),
	        _react2.default.createElement(_EducationMediaObject2.default, {
	          className: 'CreateEventCostEducation-education',
	          image: __webpack_require__(1741),
	          title: _CopyConstants.CreateEventCostEducation.title3,
	          text: _CopyConstants.CreateEventCostEducation.subheader3
	        })
	      );
	    }
	  }]);
	
	  return CreateEventCostEducation;
	}(_react2.default.Component);
	
	CreateEventCostEducation.displayName = 'CreateEventCostEducation';
	exports.default = CreateEventCostEducation;

/***/ },
/* 1733 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	var IdentityVerification = exports.IdentityVerification = {
	  title: 'Verify your information to keep your funds safe',
	  subtext: 'Verification helps us make sure that we\'re moving money to the right person and account.\n    This information will only be used to protect your funds.'
	};
	
	var BankAccount = exports.BankAccount = {
	  title: 'Add a bank account',
	  subtext: 'Request approval to send activity funds to an official school bank account. If you do\n    not have a school account, you can always deposit funds into an individual bank account.'
	};
	
	var TreasurerSignUp = exports.TreasurerSignUp = {
	  title: 'Money collection built for schools',
	  h1: 'Hassle-free. Never deal with bounced checks or envelopes of cash again.',
	  h2: 'Approve staff requests to deposit funds directly to your school bank account.',
	  h3: 'Keep information secure and protected with bank-level payment solutions.'
	};
	
	var TreasurerAddBankAccount = exports.TreasurerAddBankAccount = {
	  title: 'Approve request to deposit funds to your school bank account'
	};
	
	var RequestBankAccountConfirmation = exports.RequestBankAccountConfirmation = {
	  title: 'Request sent',
	  subtext: 'You\u2019ll be notified when your account administrator approves your request.\n    Once that\'s done, you\u2019ll be able to deposit funds directly to your school bank account.'
	};
	
	var AddSchoolAccount = exports.AddSchoolAccount = {
	  defaultNote1: 'I’m using Remind to organize a class activity, and I’d like to share our activity',
	  defaultNote2: 'and transaction details with you. You can set up our school bank account on',
	  defaultNote3: 'Remind, and if you approve, I can transfer activity funds directly into that',
	  defaultNote4: 'account without seeing any confidential information.',
	  defaultNote5: 'Please let me know if you have any questions. Thanks!'
	};
	
	var CreateEventCostEducation = exports.CreateEventCostEducation = {
	  title1: 'Collect money effortlessly',
	  subheader1: 'Activity participants can send money online. All major credit and debit cards are\n    accepted.',
	  title2: 'Automatically track who’s paid',
	  subheader2: 'Access this list from anywhere and share reminders when you need to.',
	  title3: 'Deposit to any bank account',
	  subheader3: 'Transfer activity funds to your school’s bank account or an individual account.'
	};
	
	var CreateEventEducation = exports.CreateEventEducation = {
	  header: 'It’s easier than ever to coordinate activities at your school.',
	  subheader1: 'Let people know about upcoming events and track who’s coming.',
	  subheader2: 'Collect funds online so you don’t have to worry about cash and checks.',
	  subheader3: 'Request admin approval to deposit money safely to your school’s bank account.'
	};
	
	var ActivityAgeConfirmation = exports.ActivityAgeConfirmation = {
	  title: 'The organizer would love to know more about you',
	  subtext: 'The below information will help your organizer better plan and manage this activity.\n    Thanks!'
	};

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MediaObject = __webpack_require__(1396);
	
	var _MediaObject2 = _interopRequireDefault(_MediaObject);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1735);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EducationMediaObject = function (_React$Component) {
	  _inherits(EducationMediaObject, _React$Component);
	
	  function EducationMediaObject() {
	    _classCallCheck(this, EducationMediaObject);
	
	    return _possibleConstructorReturn(this, (EducationMediaObject.__proto__ || Object.getPrototypeOf(EducationMediaObject)).apply(this, arguments));
	  }
	
	  _createClass(EducationMediaObject, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          image = _props.image,
	          title = _props.title,
	          text = _props.text;
	
	      return _react2.default.createElement(
	        _MediaObject2.default,
	        { className: (0, _classnames2.default)('EducationMediaObject', this.props.className) },
	        _react2.default.createElement(
	          'div',
	          { className: 'EducationMediaObject-imagecol' },
	          _react2.default.createElement(_Image2.default, { src: image })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Text2.default,
	            { element: 'h3', weight: 'semibold', className: 'EducationMediaObject-title' },
	            title
	          ),
	          _react2.default.createElement(
	            _Text2.default,
	            { element: 'p', color: 'thunder', size: 'xsmall' },
	            text
	          )
	        )
	      );
	    }
	  }]);
	
	  return EducationMediaObject;
	}(_react2.default.Component);
	
	EducationMediaObject.displayName = 'EducationMediaObject';
	exports.default = EducationMediaObject;

/***/ },
/* 1735 */
1136,
/* 1736 */,
/* 1737 */
1136,
/* 1738 */,
/* 1739 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNCAzNCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMzQgMzQiPjxwYXRoIGZpbGw9IiMzOGI4OGQiIGQ9Ik0xNywxLjNDOC40LDEuMywxLjMsOC4zLDEuMywxN2MwLDguNiw3LDE1LjcsMTUuNywxNS43YzguNiwwLDE1LjctNywxNS43LTE1LjdDMzIuNyw4LjMsMjUuNiwxLjMsMTcsMS4zeiBNMTcsMzEuNgoJCUM4LjksMzEuNiwyLjMsMjUsMi4zLDE3UzguOSwyLjMsMTcsMi4zYzguMSwwLDE0LjcsNi42LDE0LjcsMTQuN1MyNS4xLDMxLjYsMTcsMzEuNnoiLz48cGF0aCBmaWxsPSIjMzhiODhkIiBkPSJtMTcuMSAxNi4yaC0uM2MtMS44IDAtMi43LS43LTIuNy0yIDAtMS4xIDEuMi0yIDIuNy0yczIuNy45IDIuNyAyaDFjMC0xLjUtMS4zLTIuNy0zLjEtMyAwIDAgMC0uMSAwLS4xdi0uOWMwLS4zLS4yLS41LS41LS41cy0uNS4yLS41LjV2LjljMCAwIDAgMCAwIC4xLTEuOS4xLTMuNCAxLjQtMy40IDMgMCAxLjEuNSAzIDMuNyAzaC4zYzIgMCAzIC43IDMgMi4zIDAgMS4zLTEuMyAyLjMtMyAyLjMtMS43IDAtMy0xLTMtMi4zaC0xYzAgMS42IDEuNSAzIDMuNCAzLjJ2LjljMCAuMy4yLjUuNS41cy41LS4yLjUtLjV2LS45YzItLjIgMy42LTEuNSAzLjYtMy4yLjItMS4yLS40LTMuMy0zLjktMy4zIi8+PC9zdmc+"

/***/ },
/* 1740 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNCAzNCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMzQgMzQiPjxwYXRoIGZpbGw9IiMzOGI4OGQiIGQ9Im0xMS43IDE2LjdoNy45Yy4zIDAgLjUtLjIuNS0uNSAwLS4zLS4yLS41LS41LS41aC03LjljLS4zIDAtLjUuMi0uNS41IDAgLjIuMi41LjUuNSIvPjxwYXRoIGZpbGw9IiMzOGI4OGQiIGQ9Im0xMS43IDEwLjNoMTIuN2MuMyAwIC41LS4yLjUtLjVzLS4yLS41LS41LS41aC0xMi43Yy0uMyAwLS41LjItLjUuNXMuMi41LjUuNSIvPjxwYXRoIGZpbGw9IiMzOGI4OGQiIGQ9Im02LjMgMS4xdjIyYy0yLjIuNC0zLjkgMi40LTMuOSA0LjggMCAyLjcgMi4yIDQuOCA0LjggNC44aDE3LjFjMy4zLS4zIDUuOC0zIDUuOC02LjN2LTI1LjNoLTIzLjhtMTYuOCAzMC42aC0xNmMtMi4xIDAtMy44LTEuNy0zLjgtMy44IDAtMS44IDEuMy0zLjQgMy4xLTMuN2wuMy0uMWgxNi4zdi41Yy0xLjQuNC0yLjQgMS43LTIuNCAzLjMgMCAxLjcuOSAyLjggMi40IDMuM3YuNXptNi01LjJjMCAyLjgtMi4xIDUuMS00LjkgNS4zaC0uMXYtMS40Yy0xLjItLjEtMi40LS43LTIuNC0yLjQgMC0xLjMgMS4xLTIuNCAyLjQtMi40di0yLjRoLTE2Ljh2LTIxaDIxLjh2MjQuMyIvPjwvc3ZnPg=="

/***/ },
/* 1741 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNiAzMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMzYgMzAiIGZpbGw9IiMzOGI4OGQiPjxwYXRoIGQ9Im0zNC4zIDE3LjZoLTYuNnYtMmMwLS41LS4yLS45LS42LTEuMmwtMi43LTJ2LTUuN2wxLjkgMS40LjYtLjgtOC45LTYuNS04LjkgNi42LjYuOCAxLjktMS40djUuN2wtMi43IDJjLS40LjMtLjYuNy0uNiAxLjJ2MmgtNi42Yy0uOCAwLTEuNC43LTEuNCAxLjV2MTAuMWgxNy43IDEuNCAxNi4zdi0xMC4yYy4xLS44LS42LTEuNS0xLjQtMS41bS0yNC44LTIuNGwzLjEtMi4zdi02LjlsNS40LTQgNS40IDR2Ni45bDMuMSAyLjNjLjEuMS4yLjIuMi40djEyLjZoLTQuOHYtOS4xYzAtLjgtLjYtMS41LTEuNC0xLjVoLTEuOC0uNy0yLjVjLS44IDAtMS40LjctMS40IDEuNXY5LjFoLTQuOHYtMTIuNmMwLS4yLjEtLjMuMi0uNG0tOC4zIDMuOWMwLS4zLjItLjUuNC0uNWg2LjZ2OS42aC03di05LjFtMTYuOCA5LjFoLTIuOXYtOS4xYzAtLjMuMi0uNS40LS41aDIuNS43IDEuOGMuMiAwIC40LjIuNC41djkuMWgtMS41LTEuNG0xNi44IDBoLTcuMXYtOS42aDYuNmMuMiAwIC40LjIuNC41djkuMXoiLz48ZWxsaXBzZSBjeD0iMTgiIGN5PSI5LjkiIHJ4PSIyIiByeT0iMiIvPjwvc3ZnPgo="

/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var NumberInput = function (_React$Component) {
	  _inherits(NumberInput, _React$Component);
	
	  function NumberInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NumberInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NumberInput.__proto__ || Object.getPrototypeOf(NumberInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      value: _this.props.value || ''
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(NumberInput, [{
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return _reactDom2.default.findDOMNode(this.refs.input);
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var value = event.target.value.replace(/^(?!\d+\.?\d)$/, '');
	      var values = value.split('.');
	
	      if (values[1] && values[1].length > 2) {
	        value = values[0] + '.' + values[1].substr(0, 2);
	      }
	
	      if (!isNaN(value)) {
	        this.setState({ value: value });
	        if (this.props.onChange) {
	          this.props.onChange(value);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_Input2.default, _extends({}, this.props, {
	        ref: 'input',
	        type: 'text',
	        onChange: this.handleChange.bind(this),
	        value: this.state.value
	      }));
	    }
	  }]);
	
	  return NumberInput;
	}(_react2.default.Component);
	
	NumberInput.displayName = 'NumberInput';
	exports.default = NumberInput;

/***/ },
/* 1743 */
1136,
/* 1744 */,
/* 1745 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	// Event Tracking Screen Names
	
	// Payment Request Flow
	var GET_STARTED_SCREEN = 'collect_get_started';
	var SET_AMOUNT_SCREEN = 'collect_set_amount';
	var LINK_SCREEN = 'collect_link';
	
	// Activity Creation Flow
	var ACTIVITY_GET_STARTED = 'activity_get_started';
	var CREATE_ACTIVITY_FORM = 'create_activity_form';
	var CURRENT_ACTIVITIES = 'current_activities';
	var CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG = 'create_activity_form_universal_dialog';
	var CREATE_ACTIVITY_COMPOSER_UNIVERSAL_DIALOG = 'create_activity_composer_universal_dialog';
	
	// Activity Component
	var ACTIVITY_COMPONENT = 'activity_component';
	var REMOVE_ACTIVITY_MODAL = 'remove_activity_modal';
	
	// Class Feed
	var MESSAGE_PAYMENT = 'pay';
	var MESSAGE_PAYMENT_LINK = 'payment_link';
	
	// Event Participation View
	var RSVP = 'rsvp';
	
	// Payment Flow
	var SELECT_PAYMENT = 'select_payment';
	var CONFIRM_PAYMENT = 'confirm_payment';
	var PAYMENT_RECEIPT = 'payment_receipt';
	var PAYMENT_LOGIN = 'payment_login';
	
	// Campaigns Page
	var YOUR_CAMPAIGN_PAYMENTS = 'your_campaign_payments';
	
	// Link School Bank Account Flow
	var TREASURER_INTERSTITIAL = 'treasurer_interstitial';
	var TREASURER_ADD_BANK_ACCOUNT = 'treasurer_add_bank_account';
	
	// Cash Out Flow
	var CREATE_DEPOSIT_ADDRESS = 'create_deposit_address';
	var CREATE_DEPOSIT_ACCOUNT = 'create_deposit_account';
	var CONFIRM_DEPOSIT = 'confirm_deposit';
	var DEPOSIT_RECEIPT = 'deposit_receipt';
	var DEPOSIT_SELECT = 'deposit_select';
	
	exports.default = {
	  ACTIVITY_COMPONENT: ACTIVITY_COMPONENT,
	  ACTIVITY_GET_STARTED: ACTIVITY_GET_STARTED,
	  CONFIRM_DEPOSIT: CONFIRM_DEPOSIT,
	  CONFIRM_PAYMENT: CONFIRM_PAYMENT,
	  CREATE_ACTIVITY_FORM: CREATE_ACTIVITY_FORM,
	  CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG: CREATE_ACTIVITY_FORM_UNIVERSAL_DIALOG,
	  CREATE_ACTIVITY_COMPOSER_UNIVERSAL_DIALOG: CREATE_ACTIVITY_COMPOSER_UNIVERSAL_DIALOG,
	  CREATE_DEPOSIT_ACCOUNT: CREATE_DEPOSIT_ACCOUNT,
	  CREATE_DEPOSIT_ADDRESS: CREATE_DEPOSIT_ADDRESS,
	  CURRENT_ACTIVITIES: CURRENT_ACTIVITIES,
	  DEPOSIT_RECEIPT: DEPOSIT_RECEIPT,
	  DEPOSIT_SELECT: DEPOSIT_SELECT,
	  GET_STARTED_SCREEN: GET_STARTED_SCREEN,
	  LINK_SCREEN: LINK_SCREEN,
	  MESSAGE_PAYMENT_LINK: MESSAGE_PAYMENT_LINK,
	  MESSAGE_PAYMENT: MESSAGE_PAYMENT,
	  PAYMENT_LOGIN: PAYMENT_LOGIN,
	  PAYMENT_RECEIPT: PAYMENT_RECEIPT,
	  REMOVE_ACTIVITY_MODAL: REMOVE_ACTIVITY_MODAL,
	  RSVP: RSVP,
	  SELECT_PAYMENT: SELECT_PAYMENT,
	  SET_AMOUNT_SCREEN: SET_AMOUNT_SCREEN,
	  TREASURER_ADD_BANK_ACCOUNT: TREASURER_ADD_BANK_ACCOUNT,
	  TREASURER_INTERSTITIAL: TREASURER_INTERSTITIAL,
	  YOUR_CAMPAIGN_PAYMENTS: YOUR_CAMPAIGN_PAYMENTS
	};

/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _EventTrackingMixin = __webpack_require__(1747);
	
	var _EventTrackingMixin2 = _interopRequireDefault(_EventTrackingMixin);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This component wraps another component and adds click tracking
	 * events that occur when the component is focused.
	 */
	var FocusEventTrigger = _react2.default.createClass({
	  displayName: 'FocusEventTrigger',
	
	
	  mixins: [_EventTrackingMixin2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      trackChildComponents: false
	    };
	  },
	  propagateOnFocus: function propagateOnFocus(event) {
	    var node = _reactDom2.default.findDOMNode(this);
	    if (event.target === node || this.props.trackChildComponents) {
	      this.trackClick();
	    }
	  },
	  render: function render() {
	    var child = _react2.default.Children.only(this.props.children);
	    var onFocus = (0, _createChainedFunction2.default)(this.propagateOnFocus, child.props.onFocus);
	    return _react2.default.cloneElement(child, Object.assign({}, this.props, child.props, {
	      children: child.props.children,
	      className: (0, _classnames2.default)(child.props.className, this.props.className),
	      onFocus: (0, _createChainedFunction2.default)(onFocus, this.props.onFocus)
	    }));
	  }
	}); /*  weak */
	exports.default = FocusEventTrigger;

/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventTrackingMixin = {
	  propTypes: {
	    eventElementName: _react2.default.PropTypes.string,
	    eventContextName: _react2.default.PropTypes.string,
	    eventProperties: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    eventScreenName: _react2.default.PropTypes.string,
	    eventProperties: _react2.default.PropTypes.object,
	    eventContextName: _react2.default.PropTypes.string,
	    router: _react2.default.PropTypes.object
	  },
	
	  trackClick: function trackClick() {
	    var elementName = (0, _EventTracking.getEventElementName)(this.props);
	    var screenName = (0, _EventTracking.getEventScreenName)(this.props, this.context.router);
	    if (elementName && screenName) {
	      _EventTracking2.default.tap(screenName, elementName, (0, _EventTracking.getEventContextName)(this.props, this.context), (0, _EventTracking.getEventProperties)(this.props.eventProperties, this.context));
	    }
	  }
	};
	
	exports.default = EventTrackingMixin;

/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(555);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DatePickerInput = __webpack_require__(1749);
	
	var _DatePickerInput2 = _interopRequireDefault(_DatePickerInput);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Formsy = __webpack_require__(1345);
	
	var _Formsy2 = _interopRequireDefault(_Formsy);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1851);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'FormDatePickerInput',
	
	
	  mixins: [_Formsy2.default.Mixin],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      showErrorAfterBlur: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      wasBlur: false,
	      value: this.props.value
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.id = (0, _lodash.uniqueId)('id-');
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.value) {
	      this.onChange(this.props.value);
	    }
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !(0, _lodash.isEqual)(this.props, nextProps) || !(0, _lodash.isEqual)(this.state, nextState);
	  },
	  onChange: function onChange(value) {
	    this.setState({ value: value });
	    this.setValue(value);
	  },
	  onBlur: function onBlur() {
	    if (this.state.wasBlur === false) {
	      this.setState({ wasBlur: true });
	    }
	  },
	  renderLabel: function renderLabel() {
	    var label = this.props.label;
	
	
	    if (label) {
	      return _react2.default.createElement(
	        _Label2.default,
	        { htmlFor: this.id, hidden: this.props.labelHidden },
	        label
	      );
	    } else {
	      return null;
	    }
	  },
	  render: function render() {
	    var error = this.getErrorMessage();
	
	    if (this.props.showErrorAfterBlur && !this.state.wasBlur) {
	      error = null;
	    }
	
	    return _react2.default.createElement(
	      _Field2.default,
	      { className: 'FormDatePickerInput', error: error },
	      this.renderLabel(),
	      _react2.default.createElement(_DatePickerInput2.default, _extends({}, this.props, {
	        value: this.state.value,
	        className: (0, _classnames2.default)(this.props.className, 'FormDatePickerInput-input', {
	          'FormDatePickerInput-input-error': !!error
	        }),
	        onBlur: (0, _createChainedFunction2.default)(this.props.onBlur, this.onBlur),
	        onChange: (0, _createChainedFunction2.default)(this.props.onChange, this.onChange)
	      }))
	    );
	  }
	});

/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactWidgets = __webpack_require__(1750);
	
	var _DateTimePickerMixin = __webpack_require__(1838);
	
	var _DateTimePickerMixin2 = _interopRequireDefault(_DateTimePickerMixin);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _constants = __webpack_require__(1821);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1841);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePickerInput = _react2.default.createClass({
	  displayName: 'DatePickerInput',
	
	
	  mixins: [_DateTimePickerMixin2.default],
	
	  statics: {
	    propClasses: {
	      placement: {
	        top: 'DateTimePicker-top',
	        bottom: 'DateTimePicker-bottom'
	      }
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      placement: 'bottom',
	      disabled: false
	    };
	  },
	  onClick: function onClick(event) {
	    if (!this.props.disabled) {
	      this.handleClick(event);
	    }
	  },
	  render: function render() {
	    var open = this.isOpen() ? _constants.datePopups.CALENDAR : false;
	    var _props = this.props,
	        value = _props.value,
	        min = _props.min,
	        max = _props.max,
	        placeholder = _props.placeholder,
	        className = _props.className,
	        disabled = _props.disabled,
	        onBlur = _props.onBlur,
	        onChange = _props.onChange;
	
	    var datePickerClass = (0, _classnames2.default)('DatePickerInput DateTimePicker', className, {
	      'is-focused': this.isFocused()
	    });
	
	    var parse = function parse(val) {
	      var date = new Date(val);
	      return date instanceof Date && !isNaN(date.valueOf()) ? date : null;
	    };
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(datePickerClass, (0, _getPropClasses.getPropClassesFromInstance)(this), {
	          'DatePickerInput-disabled': disabled
	        }),
	        onClick: this.onClick },
	      _react2.default.createElement(_Glyph2.default, {
	        name: 'schedule',
	        color: 'eclipse'
	      }),
	      _react2.default.createElement(_ReactWidgets.DateTimePicker, {
	        'data-test': this.props['data-test'],
	        ref: 'picker',
	        value: value,
	        min: min,
	        max: max,
	        placeholder: placeholder,
	        open: open,
	        duration: 0,
	        format: 'M/d/yyyy',
	        finalView: 'month',
	        parse: parse,
	        dayFormat: function dayFormat(date) {
	          return ['S', 'M', 'T', 'W', 'T', 'F', 'S'][date.getDay()];
	        },
	        onFocus: this.handleFocus,
	        onKeyDown: this.closePopup,
	        onBlur: (0, _createChainedFunction2.default)(this.handleBlur, onBlur),
	        onChange: (0, _createChainedFunction2.default)(this.handleChange, onChange),
	        onToggle: function onToggle() {},
	        className: (0, _classnames2.default)({
	          'DatePickerInput-disabled': disabled
	        })
	      })
	    );
	  }
	}); /*  weak */
	exports.default = DatePickerInput;

/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DateTimePicker = undefined;
	
	var _DateConstants = __webpack_require__(1751);
	
	var _DateConstants2 = _interopRequireDefault(_DateConstants);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactWidgets = __webpack_require__(1752);
	
	var _reactWidgets2 = _interopRequireDefault(_reactWidgets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function pad(n, width) {
	  var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
	
	  var stringN = String(n);
	  return stringN.length >= width ? stringN : new Array(width - stringN.length + 1).join(padding) + stringN;
	}
	
	function getDateTokenValues(date) {
	  var m = date.getMonth();
	  var d = date.getDate();
	  var w = date.getDay();
	  var y = date.getFullYear();
	  var hours = date.getHours();
	  var mins = date.getMinutes();
	  var secs = date.getSeconds();
	  return {
	    MMMM: _DateConstants2.default.MONTHS[m],
	    M: String(m + 1),
	    d: String(d),
	    dd: pad(d, 2),
	    dddd: _DateConstants2.default.WEEKDAYS[w],
	    yyyy: String(y),
	    h: String(hours % 12 || 12),
	    mm: pad(mins, 2),
	    ss: pad(secs, 2),
	    tt: hours >= 12 ? 'PM' : 'AM'
	  };
	}
	
	function endOfDecade(time) {
	  var date = new Date(time);
	  date.setFullYear(date.getFullYear() + 10);
	  date.setMilliseconds(date.getMilliseconds() - 1);
	  return date;
	}
	
	function endOfCentury(time) {
	  var date = new Date(time);
	  date.setFullYear(date.getFullYear() + 100);
	  date.setMilliseconds(date.getMilliseconds() - 1);
	  return date;
	}
	
	_reactWidgets2.default.setDateLocalizer({
	  // FIXME: This needs to actually use localization data
	  formats: {
	    default: 'M/d/yyyy h:mm tt',
	    date: 'M/d/yyyy',
	    time: 'h:mm tt',
	    header: 'MMMM yyyy',
	    footer: 'dddd, MMMM d yyyy',
	    dayOfMonth: 'dd',
	    month: 'MMM',
	    weekday: 'dddd',
	    year: 'yyyy',
	    decade: function decade(date, culture, localizer) {
	      return localizer.format(date, localizer.formats.year, culture) + ' - ' + localizer.format(endOfDecade(date), localizer.formats.year, culture);
	    },
	    century: function century(date, culture, localizer) {
	      return localizer.format(date, localizer.formats.year, culture) + ' - ' + localizer.format(endOfCentury(date), localizer.formats.year, culture);
	    }
	  },
	
	  propType: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object, _react2.default.PropTypes.func]),
	
	  firstOfWeek: function firstOfWeek() /* culture */{
	    // FIXME: This needs to actually use localization data
	    return 0;
	  },
	  parse: function parse(value /* , format, culture */) {
	    var date = new Date();
	    var time = value.match(/(\d+)(?::(\d\d))?\s*(p?)/i);
	    if (time !== null) {
	      var hours = parseInt(time[1], 10);
	      if (hours === 12 && !time[3]) {
	        hours = 0;
	      } else if (hours < 12 && time[3]) {
	        hours += 12;
	      }
	      date.setHours(hours);
	      date.setMinutes(parseInt(time[2], 10) || 0);
	    }
	    return date;
	  },
	  format: function format(value, _format /* , culture */) {
	    var tokens = getDateTokenValues(value);
	    if (typeof _format === 'function') {
	      return _format(value);
	    }
	    return _format.replace(/(.)\1*/g, function (token) {
	      return tokens[token] || token;
	    });
	  }
	});
	
	var DateTimePicker = exports.DateTimePicker = _reactWidgets2.default.DateTimePicker;
	
	exports.default = _reactWidgets2.default;

/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WEEKDAYS_COMPACT = exports.WEEKDAYS = exports.MONTHS = undefined;
	
	var _i18n = __webpack_require__(1018);
	
	var MONTHS = exports.MONTHS = [(0, _i18n.getText)('January'), (0, _i18n.getText)('February'), (0, _i18n.getText)('March'), (0, _i18n.getText)('April'), (0, _i18n.getText)('May'), (0, _i18n.getText)('June'), (0, _i18n.getText)('July'), (0, _i18n.getText)('August'), (0, _i18n.getText)('September'), (0, _i18n.getText)('October'), (0, _i18n.getText)('November'), (0, _i18n.getText)('December')]; /*  weak */
	var WEEKDAYS = exports.WEEKDAYS = [(0, _i18n.getText)('Sunday'), (0, _i18n.getText)('Monday'), (0, _i18n.getText)('Tuesday'), (0, _i18n.getText)('Wednesday'), (0, _i18n.getText)('Thursday'), (0, _i18n.getText)('Friday'), (0, _i18n.getText)('Saturday')];
	
	var WEEKDAYS_COMPACT = exports.WEEKDAYS_COMPACT = [(0, _i18n.getText)('Su'), (0, _i18n.getText)('M'), (0, _i18n.getText)('T'), (0, _i18n.getText)('W'), (0, _i18n.getText)('Th'), (0, _i18n.getText)('F'), (0, _i18n.getText)('S')];
	
	exports.default = {
	  MONTHS: MONTHS,
	  WEEKDAYS: WEEKDAYS,
	  WEEKDAYS_COMPACT: WEEKDAYS_COMPACT
	};

/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var configure = __webpack_require__(1753);
	
	if (false) {
	  [Array.prototype.some, Array.prototype.filter, Array.prototype.reduce].forEach(function (method) {
	    if (!method) throw new Error('One or more ES5 features is not available to ReactWidgets: http://jquense.github.io/react-widgets/docs/#/getting-started/browser');
	  });
	}
	
	module.exports = _extends({}, configure, {
	  DropdownList: __webpack_require__(1770),
	  Combobox: __webpack_require__(1810),
	  Calendar: __webpack_require__(1813),
	  DateTimePicker: __webpack_require__(1828),
	  NumberPicker: __webpack_require__(1831),
	  Multiselect: __webpack_require__(1834),
	  SelectList: __webpack_require__(1837),
	
	  utils: {
	    ReplaceTransitionGroup: __webpack_require__(1826),
	    SlideTransition: __webpack_require__(1825)
	  }
	});

/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _configuration = __webpack_require__(1754);
	
	var _configuration2 = _interopRequireDefault(_configuration);
	
	var _localizers = __webpack_require__(1768);
	
	var localizers = _interopRequireWildcard(_localizers);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  setAnimate: function setAnimate(animatefn) {
	    _configuration2.default.animate = animatefn;
	  },
	  setLocalizers: function setLocalizers(_ref) {
	    var date = _ref.date;
	    var number = _ref.number;
	
	    date && this.setDateLocalizer(date);
	    number && this.setNumberLocalizer(number);
	  },
	
	
	  setDateLocalizer: localizers.setDate,
	
	  setNumberLocalizer: localizers.setNumber
	};
	module.exports = exports['default'];

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _animate = __webpack_require__(1755);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { animate: _animate2.default };
	module.exports = exports['default'];

/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = animate;
	
	var _hyphenate = __webpack_require__(1756);
	
	var _hyphenate2 = _interopRequireDefault(_hyphenate);
	
	var _style = __webpack_require__(1757);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _on = __webpack_require__(1764);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(1766);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _properties = __webpack_require__(1767);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var has = Object.prototype.hasOwnProperty,
	    reset = {},
	    TRANSLATION_MAP = {
	  left: 'translateX',
	  right: 'translateX',
	  top: 'translateY',
	  bottom: 'translateY'
	};
	
	reset[_properties2.default.property] = reset[_properties2.default.duration] = reset[_properties2.default.delay] = reset[_properties2.default.timing] = '';
	
	animate.endEvent = _properties2.default.end;
	animate.transform = _properties2.default.transform;
	animate.TRANSLATION_MAP = TRANSLATION_MAP;
	
	// super lean animate function for transitions
	// doesn't support all translations to keep it matching the jquery API
	/**
	 * code in part from: Zepto 1.1.4 | zeptojs.com/license
	 */
	function animate(node, properties, duration, easing, callback) {
	  var cssProperties = [],
	      fakeEvent = { target: node, currentTarget: node },
	      cssValues = {},
	      transforms = '',
	      fired;
	
	  if (typeof easing === 'function') callback = easing, easing = null;
	
	  if (!_properties2.default.end) duration = 0;
	  if (duration === undefined) duration = 200;
	
	  for (var key in properties) {
	    if (has.call(properties, key)) {
	      if (/(top|bottom)/.test(key)) transforms += TRANSLATION_MAP[key] + '(' + properties[key] + ') ';else {
	        cssValues[key] = properties[key];
	        cssProperties.push((0, _hyphenate2.default)(key));
	      }
	    }
	  }if (transforms) {
	    cssValues[_properties2.default.transform] = transforms;
	    cssProperties.push(_properties2.default.transform);
	  }
	
	  if (duration > 0) {
	    cssValues[_properties2.default.property] = cssProperties.join(', ');
	    cssValues[_properties2.default.duration] = duration / 1000 + 's';
	    cssValues[_properties2.default.delay] = 0 + 's';
	    cssValues[_properties2.default.timing] = easing || 'linear';
	
	    (0, _on2.default)(node, _properties2.default.end, done);
	
	    setTimeout(function () {
	      if (!fired) done(fakeEvent);
	    }, duration + 500);
	  }
	
	  node.clientLeft; // trigger page reflow
	  (0, _style2.default)(node, cssValues);
	
	  if (duration <= 0) setTimeout(done.bind(null, fakeEvent), 0);
	
	  return {
	    cancel: function cancel() {
	      if (fired) return;
	      fired = true;
	      (0, _off2.default)(node, _properties2.default.end, done);
	      (0, _style2.default)(node, reset);
	    }
	  };
	
	  function done(event) {
	    if (event.target !== event.currentTarget) return;
	
	    fired = true;
	    (0, _off2.default)(event.target, _properties2.default.end, done);
	    (0, _style2.default)(node, reset);
	    callback && callback.call(this);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1756 */
/***/ function(module, exports) {

	'use strict';
	
	var rUpper = /([A-Z])/g;
	
	module.exports = function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	};

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var camelize = __webpack_require__(1758),
	    hyphenate = __webpack_require__(1760),
	    _getComputedStyle = __webpack_require__(1761),
	    removeStyle = __webpack_require__(1763);
	
	var has = Object.prototype.hasOwnProperty;
	
	module.exports = function style(node, property, value) {
	  var css = '',
	      props = property;
	
	  if (typeof property === 'string') {
	
	    if (value === undefined) return node.style[camelize(property)] || _getComputedStyle(node).getPropertyValue(hyphenate(property));else (props = {})[property] = value;
	  }
	
	  for (var key in props) if (has.call(props, key)) {
	    !props[key] && props[key] !== 0 ? removeStyle(node, hyphenate(key)) : css += hyphenate(key) + ':' + props[key] + ';';
	  }
	
	  node.style.cssText += ';' + css;
	};

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	
	'use strict';
	var camelize = __webpack_require__(1759);
	var msPattern = /^-ms-/;
	
	module.exports = function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	};

/***/ },
/* 1759 */
/***/ function(module, exports) {

	"use strict";
	
	var rHyphen = /-(.)/g;
	
	module.exports = function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	};

/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	
	"use strict";
	
	var hyphenate = __webpack_require__(1756);
	var msPattern = /^ms-/;
	
	module.exports = function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, "-ms-");
	};

/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(1762);
	
	var _utilCamelizeStyle = __webpack_require__(1758);
	
	var _utilCamelizeStyle2 = babelHelpers.interopRequireDefault(_utilCamelizeStyle);
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	module.exports = function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : { //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _utilCamelizeStyle2['default'])(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	};

/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === "object") {
	    factory(exports);
	  } else {
	    factory(root.babelHelpers = {});
	  }
	})(this, function (global) {
	  var babelHelpers = global;
	
	  babelHelpers.interopRequireDefault = function (obj) {
	    return obj && obj.__esModule ? obj : {
	      "default": obj
	    };
	  };
	
	  babelHelpers._extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	})

/***/ },
/* 1763 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	};

/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(1765);
	var on = function on() {};
	
	if (canUseDOM) {
	  on = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = on;

/***/ },
/* 1765 */
/***/ function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(1765);
	var off = function off() {};
	
	if (canUseDOM) {
	
	  off = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = off;

/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(1765);
	
	var has = Object.prototype.hasOwnProperty,
	    transform = 'transform',
	    transition = {},
	    transitionTiming,
	    transitionDuration,
	    transitionProperty,
	    transitionDelay;
	
	if (canUseDOM) {
	  transition = getTransitionProperties();
	
	  transform = transition.prefix + transform;
	
	  transitionProperty = transition.prefix + 'transition-property';
	  transitionDuration = transition.prefix + 'transition-duration';
	  transitionDelay = transition.prefix + 'transition-delay';
	  transitionTiming = transition.prefix + 'transition-timing-function';
	}
	
	module.exports = {
	  transform: transform,
	  end: transition.end,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	function getTransitionProperties() {
	  var endEvent,
	      prefix = '',
	      transitions = {
	    O: 'otransitionend',
	    Moz: 'transitionend',
	    Webkit: 'webkitTransitionEnd',
	    ms: 'MSTransitionEnd'
	  };
	
	  var element = document.createElement('div');
	
	  for (var vendor in transitions) if (has.call(transitions, vendor)) {
	    if (element.style[vendor + 'TransitionProperty'] !== undefined) {
	      prefix = '-' + vendor.toLowerCase() + '-';
	      endEvent = transitions[vendor];
	      break;
	    }
	  }
	
	  if (!endEvent && element.style.transitionProperty !== undefined) endEvent = 'transitionend';
	
	  return { end: endEvent, prefix: prefix };
	}

/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.date = exports.number = exports.setNumber = undefined;
	exports.setDate = setDate;
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ = __webpack_require__(1769);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var localePropType = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.func]);
	
	var REQUIRED_NUMBER_FORMATS = ['default'];
	
	var REQUIRED_DATE_FORMATS = ['default', 'date', 'time', 'header', 'footer', 'dayOfMonth', 'month', 'year', 'decade', 'century'];
	
	function _format(localizer, formatter, value, format, culture) {
	  var result = typeof format === 'function' ? format(value, culture, localizer) : formatter.call(localizer, value, format, culture);
	
	  (0, _invariant2.default)(result == null || typeof result === 'string', '`localizer format(..)` must return a string, null, or undefined');
	
	  return result;
	}
	
	function checkFormats(requiredFormats, formats) {
	  if (false) requiredFormats.forEach(function (f) {
	    return (0, _invariant2.default)((0, _.has)(formats, f), 'localizer missing required format: `%s`', f);
	  });
	}
	
	var _numberLocalizer = createWrapper('NumberPicker');
	
	function setNumber(_ref) {
	  var _format2 = _ref.format;
	  var _parse = _ref.parse;
	  var _ref$decimalChar = _ref.decimalChar;
	  var decimalChar = _ref$decimalChar === undefined ? function () {
	    return '.';
	  } : _ref$decimalChar;
	  var _ref$precision = _ref.precision;
	  var precision = _ref$precision === undefined ? function () {
	    return null;
	  } : _ref$precision;
	  var formats = _ref.formats;
	  var propType = _ref.propType;
	
	  (0, _invariant2.default)(typeof _format2 === 'function', 'number localizer `format(..)` must be a function');
	  (0, _invariant2.default)(typeof _parse === 'function', 'number localizer `parse(..)` must be a function');
	
	  checkFormats(REQUIRED_NUMBER_FORMATS, formats);
	
	  formats.editFormat = formats.editFormat || function (str) {
	    return parseFloat(str);
	  };
	
	  _numberLocalizer = {
	    formats: formats,
	    precision: precision,
	    decimalChar: decimalChar,
	    propType: propType || localePropType,
	
	    format: function format(value, str, culture) {
	      return _format(this, _format2, value, str, culture);
	    },
	    parse: function parse(value, culture, format) {
	      var result = _parse.call(this, value, culture, format);
	      (0, _invariant2.default)(result == null || typeof result === 'number', 'number localizer `parse(..)` must return a number, null, or undefined');
	      return result;
	    }
	  };
	}
	
	exports.setNumber = setNumber;
	var _dateLocalizer = createWrapper('DateTimePicker');
	
	function setDate(spec) {
	  (0, _invariant2.default)(typeof spec.format === 'function', 'date localizer `format(..)` must be a function');
	  (0, _invariant2.default)(typeof spec.parse === 'function', 'date localizer `parse(..)` must be a function');
	  (0, _invariant2.default)(typeof spec.firstOfWeek === 'function', 'date localizer `firstOfWeek(..)` must be a function');
	  checkFormats(REQUIRED_DATE_FORMATS, spec.formats);
	
	  _dateLocalizer = {
	    formats: spec.formats,
	    propType: spec.propType || localePropType,
	    startOfWeek: spec.firstOfWeek,
	    format: function format(value, str, culture) {
	      return _format(this, spec.format, value, str, culture);
	    },
	    parse: function parse(value, culture) {
	      var result = spec.parse.call(this, value, culture);
	      (0, _invariant2.default)(result == null || result instanceof Date && !isNaN(result.getTime()), 'date localizer `parse(..)` must return a valid Date, null, or undefined');
	      return result;
	    }
	  };
	}
	
	var number = exports.number = {
	  propType: function propType() {
	    var _numberLocalizer2;
	
	    return (_numberLocalizer2 = _numberLocalizer).propType.apply(_numberLocalizer2, arguments);
	  },
	  getFormat: function getFormat(key, format) {
	    return format || _numberLocalizer.formats[key];
	  },
	  parse: function parse() {
	    var _numberLocalizer3;
	
	    return (_numberLocalizer3 = _numberLocalizer).parse.apply(_numberLocalizer3, arguments);
	  },
	  format: function format() {
	    var _numberLocalizer4;
	
	    return (_numberLocalizer4 = _numberLocalizer).format.apply(_numberLocalizer4, arguments);
	  },
	  decimalChar: function decimalChar() {
	    var _numberLocalizer5;
	
	    return (_numberLocalizer5 = _numberLocalizer).decimalChar.apply(_numberLocalizer5, arguments);
	  },
	  precision: function precision() {
	    var _numberLocalizer6;
	
	    return (_numberLocalizer6 = _numberLocalizer).precision.apply(_numberLocalizer6, arguments);
	  }
	};
	
	var date = exports.date = {
	  propType: function propType() {
	    var _dateLocalizer2;
	
	    return (_dateLocalizer2 = _dateLocalizer).propType.apply(_dateLocalizer2, arguments);
	  },
	  getFormat: function getFormat(key, format) {
	    return format || _dateLocalizer.formats[key];
	  },
	  parse: function parse() {
	    var _dateLocalizer3;
	
	    return (_dateLocalizer3 = _dateLocalizer).parse.apply(_dateLocalizer3, arguments);
	  },
	  format: function format() {
	    var _dateLocalizer4;
	
	    return (_dateLocalizer4 = _dateLocalizer).format.apply(_dateLocalizer4, arguments);
	  },
	  startOfWeek: function startOfWeek() {
	    var _dateLocalizer5;
	
	    return (_dateLocalizer5 = _dateLocalizer).startOfWeek.apply(_dateLocalizer5, arguments);
	  }
	};
	
	exports.default = { number: number, date: date };
	
	
	function createWrapper() {
	  var dummy = {};
	
	  if (false) {
	    ['formats', 'parse', 'format', 'firstOfWeek', 'precision', 'propType'].forEach(function (name) {
	      return Object.defineProperty(dummy, name, {
	        enumerable: true,
	        get: function get() {
	          throw new Error('[React Widgets] You are attempting to use a widget that requires localization ' + '(Calendar, DateTimePicker, NumberPicker). ' + 'However there is no localizer set. Please configure a localizer. \n\n' + 'see http://jquense.github.io/react-widgets/docs/#/i18n for more info.');
	        }
	      });
	    });
	  }
	  return dummy;
	}

/***/ },
/* 1769 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var idCount = 0;
	
	var _ = module.exports = {
	
	  has: has,
	
	  result: function result(value) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return typeof value === 'function' ? value.apply(undefined, args) : value;
	  },
	
	  isShallowEqual: function isShallowEqual(a, b) {
	    if (a === b) return true;
	    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
	
	    if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object' && (typeof b === 'undefined' ? 'undefined' : _typeof(b)) !== 'object') return a === b;
	
	    if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== (typeof b === 'undefined' ? 'undefined' : _typeof(b))) return false;
	
	    return shallowEqual(a, b);
	  },
	  transform: function transform(obj, cb, seed) {
	    _.each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	    return seed;
	  },
	  each: function each(obj, cb, thisArg) {
	    if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	    for (var key in obj) {
	      if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	    }
	  },
	  pick: function pick(obj, keys) {
	    keys = [].concat(keys);
	    return _.transform(obj, function (mapped, val, key) {
	      if (keys.indexOf(key) !== -1) mapped[key] = val;
	    }, {});
	  },
	  pickProps: function pickProps(props, componentClass) {
	    return _.pick(props, Object.keys(componentClass.propTypes));
	  },
	  omit: function omit(obj, keys) {
	    keys = [].concat(keys);
	    return _.transform(obj, function (mapped, val, key) {
	      if (keys.indexOf(key) === -1) mapped[key] = val;
	    }, {});
	  },
	  omitOwnProps: function omitOwnProps(component) {
	    for (var _len2 = arguments.length, others = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      others[_key2 - 1] = arguments[_key2];
	    }
	
	    var keys = others.reduce(function (arr, compClass) {
	      return arr.concat(Object.keys(compClass.propTypes));
	    }, Object.keys(component.constructor.propTypes));
	
	    return _.omit(component.props, keys);
	  },
	  find: function find(arr, cb, thisArg) {
	    var result;
	    if (Array.isArray(arr)) {
	      arr.every(function (val, idx) {
	        if (cb.call(thisArg, val, idx, arr)) return result = val, false;
	        return true;
	      });
	      return result;
	    } else for (var key in arr) {
	      if (has(arr, key)) if (cb.call(thisArg, arr[key], key, arr)) return arr[key];
	    }
	  },
	  chunk: function chunk(array, chunkSize) {
	    var index = 0,
	        length = array ? array.length : 0,
	        result = [];
	
	    chunkSize = Math.max(+chunkSize || 1, 1);
	
	    while (index < length) {
	      result.push(array.slice(index, index += chunkSize));
	    }return result;
	  },
	  splat: function splat(obj) {
	    return obj == null ? [] : [].concat(obj);
	  },
	  noop: function noop() {},
	  uniqueId: function uniqueId(prefix) {
	    return '' + ((prefix == null ? '' : prefix) + ++idCount);
	  }
	};
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	function eql(a, b) {
	  return a === b;
	}
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 */
	function shallowEqual(objA, objB) {
	
	  if (objA == null || objB == null) return false;
	
	  var keysA = Object.keys(objA),
	      keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!has(objB, keysA[i]) || !eql(objA[keysA[i]], objB[keysA[i]])) return false;
	  }return true;
	}

/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _desc, _value, _obj;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _activeElement = __webpack_require__(1771);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(1773);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _Widget = __webpack_require__(1774);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _Input = __webpack_require__(1775);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Select = __webpack_require__(1776);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _DropdownListInput = __webpack_require__(1778);
	
	var _DropdownListInput2 = _interopRequireDefault(_DropdownListInput);
	
	var _Popup = __webpack_require__(1782);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(1787);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListGroupable = __webpack_require__(1793);
	
	var _ListGroupable2 = _interopRequireDefault(_ListGroupable);
	
	var _validateListInterface = __webpack_require__(1795);
	
	var _validateListInterface2 = _interopRequireDefault(_validateListInterface);
	
	var _uncontrollable = __webpack_require__(1796);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _dataHelpers = __webpack_require__(1781);
	
	var _interaction = __webpack_require__(1790);
	
	var _widgetHelpers = __webpack_require__(1789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var result = _3.default.result;
	
	
	var propTypes = _extends({}, _Popup2.default.propTypes, {
	
	  //-- controlled props -----------
	  value: _react2.default.PropTypes.any,
	  onChange: _react2.default.PropTypes.func,
	  open: _react2.default.PropTypes.bool,
	  onToggle: _react2.default.PropTypes.func,
	  //------------------------------------
	
	  data: _react2.default.PropTypes.array,
	  valueField: _react2.default.PropTypes.string,
	  textField: _propTypes2.default.accessor,
	
	  valueComponent: _propTypes2.default.elementType,
	  itemComponent: _propTypes2.default.elementType,
	  listComponent: _propTypes2.default.elementType,
	
	  groupComponent: _propTypes2.default.elementType,
	  groupBy: _propTypes2.default.accessor,
	
	  onSelect: _react2.default.PropTypes.func,
	  searchTerm: _react2.default.PropTypes.string,
	  onSearch: _react2.default.PropTypes.func,
	  busy: _react2.default.PropTypes.bool,
	  delay: _react2.default.PropTypes.number,
	  dropUp: _react2.default.PropTypes.bool,
	  duration: _react2.default.PropTypes.number, //popup
	
	  disabled: _propTypes2.default.disabled.acceptsArray,
	  readOnly: _propTypes2.default.readOnly.acceptsArray,
	
	  messages: _react2.default.PropTypes.shape({
	    open: _propTypes2.default.message,
	    emptyList: _propTypes2.default.message,
	    emptyFilter: _propTypes2.default.message,
	    filterPlaceholder: _propTypes2.default.message
	  })
	});
	
	var DropdownList = _react2.default.createClass((_obj = {
	
	  displayName: 'DropdownList',
	
	  mixins: [__webpack_require__(1799), __webpack_require__(1800), __webpack_require__(1801), __webpack_require__(1802), __webpack_require__(1803), __webpack_require__(1808), __webpack_require__(1792)(), __webpack_require__(1809)({
	    didHandle: function didHandle(focused) {
	      if (!focused) this.close();
	    }
	  })],
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      delay: 500,
	      value: '',
	      open: false,
	      data: [],
	      searchTerm: '',
	      messages: msgs(),
	      ariaActiveDescendantKey: 'dropdownlist'
	    };
	  },
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var open = _props.open;
	    var filter = _props.filter;
	    var value = _props.value;
	    var data = _props.data;
	    var searchTerm = _props.searchTerm;
	    var valueField = _props.valueField;
	
	
	    var processed = filter ? this.filter(data, searchTerm) : data,
	        initialIdx = (0, _dataHelpers.dataIndexOf)(data, value, valueField);
	
	    return {
	      filteredData: open && filter ? processed : null,
	      selectedItem: processed[initialIdx],
	      focusedItem: processed[initialIdx] || data[0]
	    };
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.refs.list && (0, _validateListInterface2.default)(this.refs.list);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    var open = props.open;
	    var filter = props.filter;
	    var value = props.value;
	    var data = props.data;
	    var searchTerm = props.searchTerm;
	    var valueField = props.valueField;
	
	
	    var processed = filter ? this.filter(data, searchTerm) : data,
	        idx = (0, _dataHelpers.dataIndexOf)(data, value, valueField);
	
	    this.setState({
	      filteredData: open && filter ? processed : null,
	      selectedItem: processed[idx],
	      focusedItem: processed[!~idx ? 0 : idx]
	    });
	  },
	  renderFilter: function renderFilter(messages) {
	    var _this = this;
	
	    return _react2.default.createElement(
	      'div',
	      { ref: 'filterWrapper', className: 'rw-filter-input' },
	      _react2.default.createElement(_Select2.default, { component: 'span', icon: 'search' }),
	      _react2.default.createElement(_Input2.default, {
	        ref: 'filter',
	        value: this.props.searchTerm,
	        placeholder: _3.default.result(messages.filterPlaceholder, this.props),
	        onChange: function onChange(e) {
	          return (0, _widgetHelpers.notify)(_this.props.onSearch, e.target.value);
	        }
	      })
	    );
	  },
	  renderList: function renderList(List, id, messages) {
	    var _props2 = this.props;
	    var open = _props2.open;
	    var filter = _props2.filter;
	    var data = _props2.data;
	    var _state = this.state;
	    var selectedItem = _state.selectedItem;
	    var focusedItem = _state.focusedItem;
	
	
	    var listProps = _3.default.pickProps(this.props, List);
	    var items = this._data();
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      filter && this.renderFilter(messages),
	      _react2.default.createElement(List, _extends({}, listProps, {
	        ref: 'list',
	        id: id,
	        data: items,
	        'aria-live': open && 'polite',
	        'aria-labelledby': (0, _widgetHelpers.instanceId)(this),
	        'aria-hidden': !this.props.open,
	        selected: selectedItem,
	        focused: open ? focusedItem : null,
	        onSelect: this.handleSelect,
	        onMove: this._scrollTo,
	        messages: {
	          emptyList: data.length ? messages.emptyFilter : messages.emptyList
	        } }))
	    );
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var _props3 = this.props;
	    var className = _props3.className;
	    var tabIndex = _props3.tabIndex;
	    var duration = _props3.duration;
	    var valueField = _props3.valueField;
	    var textField = _props3.textField;
	    var groupBy = _props3.groupBy;
	    var messages = _props3.messages;
	    var data = _props3.data;
	    var busy = _props3.busy;
	    var dropUp = _props3.dropUp;
	    var placeholder = _props3.placeholder;
	    var value = _props3.value;
	    var open = _props3.open;
	    var valueComponent = _props3.valueComponent;
	    var List = _props3.listComponent;
	
	
	    List = List || groupBy && _ListGroupable2.default || _List2.default;
	
	    var focused = this.state.focused;
	
	
	    var disabled = (0, _interaction.isDisabled)(this.props),
	        readOnly = (0, _interaction.isReadOnly)(this.props),
	        valueItem = (0, _dataHelpers.dataItem)(data, value, valueField) // take value from the raw data
	    ,
	        listID = (0, _widgetHelpers.instanceId)(this, '__listbox');
	
	    var elementProps = _extends(_3.default.omitOwnProps(this, List), {
	      role: 'combobox',
	      tabIndex: tabIndex || 0,
	      'aria-owns': listID,
	      'aria-expanded': !!open,
	      'aria-haspopup': true,
	      'aria-busy': !!busy,
	      'aria-live': !open && 'polite',
	      'aria-autocomplete': 'list',
	      'aria-disabled': disabled,
	      'aria-readonly': readOnly
	    });
	
	    var shouldRenderPopup = open || (0, _widgetHelpers.isFirstFocusedRender)(this);
	
	    messages = msgs(messages);
	
	    return _react2.default.createElement(
	      _Widget2.default,
	      _extends({}, elementProps, {
	        ref: 'input',
	        className: (0, _classnames2.default)(className, 'rw-dropdownlist'),
	        open: open,
	        dropUp: dropUp,
	        focused: focused,
	        disabled: disabled,
	        readOnly: readOnly,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onClick: this.handleClick,
	        onKeyDown: this.handleKeyDown,
	        onKeyPress: this.handleKeyPress
	      }),
	      _react2.default.createElement(_Select2.default, {
	        busy: busy,
	        icon: 'caret-down',
	        component: 'span',
	        className: 'rw-dropdownlist-picker',
	        label: result(messages.open, this.props)
	      }),
	      _react2.default.createElement(_DropdownListInput2.default, {
	        value: valueItem,
	        textField: textField,
	        placeholder: placeholder,
	        valueComponent: valueComponent
	      }),
	      shouldRenderPopup && _react2.default.createElement(
	        _Popup2.default,
	        {
	          open: open,
	          dropUp: dropUp,
	          duration: duration,
	          onOpen: function onOpen() {
	            return _this2.focus();
	          },
	          onOpening: function onOpening() {
	            return _this2.refs.list.forceUpdate();
	          }
	        },
	        this.renderList(List, listID, messages)
	      )
	    );
	  },
	  handleSelect: function handleSelect(data) {
	    this.close();
	    (0, _widgetHelpers.notify)(this.props.onSelect, data);
	    this.change(data);
	    this.focus(this);
	  },
	  handleClick: function handleClick(e) {
	    var wrapper = this.refs.filterWrapper;
	
	    if (!this.props.filter || !this.props.open) this.toggle();else if (!(0, _contains2.default)(_compat2.default.findDOMNode(wrapper), e.target)) this.close();
	
	    (0, _widgetHelpers.notify)(this.props.onClick, e);
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var _this3 = this;
	
	    var key = e.key,
	        alt = e.altKey,
	        list = this.refs.list,
	        filtering = this.props.filter,
	        focusedItem = this.state.focusedItem,
	        selectedItem = this.state.selectedItem,
	        isOpen = this.props.open,
	        closeWithFocus = function closeWithFocus() {
	      _this3.close(), _compat2.default.findDOMNode(_this3).focus();
	    };
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	
	    var change = function change(item, fromList) {
	      if (item == null) return;
	      fromList ? _this3.handleSelect(item) : _this3.change(item);
	    };
	
	    if (e.defaultPrevented) return;
	
	    if (key === 'End') {
	      e.preventDefault();
	
	      if (isOpen) this.setState({ focusedItem: list.last() });else change(list.last());
	    } else if (key === 'Home') {
	      e.preventDefault();
	
	      if (isOpen) this.setState({ focusedItem: list.first() });else change(list.first());
	    } else if (key === 'Escape' && isOpen) {
	      e.preventDefault();
	      closeWithFocus();
	    } else if ((key === 'Enter' || key === ' ' && !filtering) && isOpen) {
	      e.preventDefault();
	      change(this.state.focusedItem, true);
	    } else if (key === ' ' && !filtering && !isOpen) {
	      e.preventDefault();
	      this.open();
	    } else if (key === 'ArrowDown') {
	      if (alt) this.open();else if (isOpen) this.setState({ focusedItem: list.next(focusedItem) });else change(list.next(selectedItem));
	      e.preventDefault();
	    } else if (key === 'ArrowUp') {
	      if (alt) closeWithFocus();else if (isOpen) this.setState({ focusedItem: list.prev(focusedItem) });else change(list.prev(selectedItem));
	      e.preventDefault();
	    }
	  },
	  handleKeyPress: function handleKeyPress(e) {
	    var _this4 = this;
	
	    (0, _widgetHelpers.notify)(this.props.onKeyPress, [e]);
	
	    if (e.defaultPrevented) return;
	
	    if (!(this.props.filter && this.props.open)) this.search(String.fromCharCode(e.which), function (item) {
	      _this4.isMounted() && _this4.props.open ? _this4.setState({ focusedItem: item }) : item && _this4.change(item);
	    });
	  },
	  change: function change(data) {
	    if (!(0, _dataHelpers.valueMatcher)(data, this.props.value, this.props.valueField)) {
	      (0, _widgetHelpers.notify)(this.props.onChange, data);
	      (0, _widgetHelpers.notify)(this.props.onSearch, '');
	      this.close();
	    }
	  },
	  focus: function focus(target) {
	    var _props4 = this.props;
	    var filter = _props4.filter;
	    var open = _props4.open;
	
	    var inst = target || (filter && open ? this.refs.filter : this.refs.input);
	
	    inst = _compat2.default.findDOMNode(inst);
	
	    if ((0, _activeElement2.default)() !== inst) inst.focus();
	  },
	  _data: function _data() {
	    return this.state.filteredData || this.props.data.concat();
	  },
	  search: function search(character, cb) {
	    var _this5 = this;
	
	    var word = ((this._searchTerm || '') + character).toLowerCase();
	
	    if (!character) return;
	
	    this._searchTerm = word;
	
	    this.setTimeout('search', function () {
	      var list = _this5.refs.list,
	          key = _this5.props.open ? 'focusedItem' : 'selectedItem',
	          item = list.next(_this5.state[key], word);
	
	      _this5._searchTerm = '';
	      if (item) cb(item);
	    }, this.props.delay);
	  },
	  open: function open() {
	    (0, _widgetHelpers.notify)(this.props.onToggle, true);
	  },
	  close: function close() {
	    (0, _widgetHelpers.notify)(this.props.onToggle, false);
	  },
	  toggle: function toggle() {
	    this.props.open ? this.close() : this.open();
	  }
	}, (_applyDecoratedDescriptor(_obj, 'handleSelect', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleSelect'), _obj), _applyDecoratedDescriptor(_obj, 'handleClick', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleClick'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyDown'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyPress', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyPress'), _obj)), _obj));
	
	function msgs(msgs) {
	  return _extends({
	    open: 'open dropdown',
	    filterPlaceholder: '',
	    emptyList: 'There are no items in this list',
	    emptyFilter: 'The filter returned no results'
	  }, msgs);
	}
	
	exports.default = (0, _uncontrollable2.default)(DropdownList, { open: 'onToggle', value: 'onChange', searchTerm: 'onSearch' }, ['focus']);
	module.exports = exports['default'];

/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(1762);
	
	exports.__esModule = true;
	
	/**
	 * document.activeElement
	 */
	exports['default'] = activeElement;
	
	var _ownerDocument = __webpack_require__(1772);
	
	var _ownerDocument2 = babelHelpers.interopRequireDefault(_ownerDocument);
	
	function activeElement() {
	  var doc = arguments[0] === undefined ? document : arguments[0];
	
	  try {
	    return doc.activeElement;
	  } catch (e) {}
	}
	
	module.exports = exports['default'];

/***/ },
/* 1772 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(1765);
	
	var contains = (function () {
	  var root = canUseDOM && document.documentElement;
	
	  return root && root.contains ? function (context, node) {
	    return context.contains(node);
	  } : root && root.compareDocumentPosition ? function (context, node) {
	    return context === node || !!(context.compareDocumentPosition(node) & 16);
	  } : function (context, node) {
	    if (node) do {
	      if (node === context) return true;
	    } while (node = node.parentNode);
	
	    return false;
	  };
	})();
	
	module.exports = contains;

/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Widget = (_temp = _class = function (_React$Component) {
	  _inherits(Widget, _React$Component);
	
	  function Widget() {
	    _classCallCheck(this, Widget);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Widget.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var tabIndex = _props.tabIndex;
	    var open = _props.open;
	    var dropUp = _props.dropUp;
	    var disabled = _props.disabled;
	    var readOnly = _props.readOnly;
	    var focused = _props.focused;
	
	    var props = _objectWithoutProperties(_props, ['className', 'tabIndex', 'open', 'dropUp', 'disabled', 'readOnly', 'focused']);
	
	    var isRtl = !!this.context.isRtl;
	    var openClass = 'rw-open' + (dropUp ? '-up' : '');
	
	    tabIndex = tabIndex != null ? tabIndex : '-1';
	
	    return _react2.default.createElement('div', _extends({}, props, {
	      tabIndex: tabIndex,
	      className: (0, _classnames2.default)(className, 'rw-widget', isRtl && 'rw-rtl', open && openClass, focused && 'rw-state-focus', disabled && 'rw-state-disabled', readOnly && 'rw-state-readonly')
	    }));
	  };
	
	  return Widget;
	}(_react2.default.Component), _class.propTypes = {
	  tabIndex: _react.PropTypes.node,
	  focused: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  readOnly: _react.PropTypes.bool,
	  open: _react.PropTypes.bool,
	  dropUp: _react.PropTypes.bool
	}, _class.contextTypes = {
	  isRtl: _react.PropTypes.bool
	}, _temp);
	exports.default = Widget;
	module.exports = exports['default'];

/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = function (_React$Component) {
	  _inherits(Input, _React$Component);
	
	  function Input() {
	    _classCallCheck(this, Input);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Input.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var disabled = _props.disabled;
	    var readOnly = _props.readOnly;
	    var value = _props.value;
	    var tabIndex = _props.tabIndex;
	    var _props$component = _props.component;
	    var Component = _props$component === undefined ? 'input' : _props$component;
	
	    var props = _objectWithoutProperties(_props, ['className', 'disabled', 'readOnly', 'value', 'tabIndex', 'component']);
	
	    return _react2.default.createElement(Component, _extends({}, props, {
	      type: 'text',
	      tabIndex: tabIndex || 0,
	      autoComplete: 'off',
	      disabled: disabled,
	      readOnly: readOnly,
	      'aria-disabled': disabled,
	      'aria-readonly': readOnly,
	      value: value == null ? '' : value,
	      className: (0, _classnames2.default)(className, 'rw-input')
	    }));
	  };
	
	  return Input;
	}(_react2.default.Component);
	
	exports.default = Input;
	module.exports = exports['default'];

/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(1777);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Select = function (_React$Component) {
	  _inherits(Select, _React$Component);
	
	  function Select() {
	    _classCallCheck(this, Select);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Select.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    return _react2.default.createElement(_Button2.default, _extends({}, props, {
	      className: (0, _classnames2.default)(className, 'rw-select')
	    }));
	  };
	
	  return Select;
	}(_react2.default.Component);
	
	exports.default = Select;
	module.exports = exports['default'];

/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Button = function (_React$Component) {
	  _inherits(Button, _React$Component);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var disabled = _props.disabled;
	    var label = _props.label;
	    var icon = _props.icon;
	    var busy = _props.busy;
	    var active = _props.active;
	    var children = _props.children;
	    var _props$component = _props.component;
	    var Tag = _props$component === undefined ? 'button' : _props$component;
	
	    var props = _objectWithoutProperties(_props, ['className', 'disabled', 'label', 'icon', 'busy', 'active', 'children', 'component']);
	
	    var type = props.type;
	
	    if (Tag === 'button') type = type || 'button';
	
	    return _react2.default.createElement(
	      Tag,
	      _extends({}, props, {
	        tabIndex: '-1',
	        title: label,
	        type: type,
	        disabled: disabled,
	        'aria-disabled': disabled,
	        'aria-label': label,
	        className: (0, _classnames2.default)(className, 'rw-btn', active && !disabled && 'rw-state-active')
	      }),
	      icon && _react2.default.createElement('i', {
	        'aria-hidden': true,
	        className: (0, _classnames2.default)('rw-i', 'rw-i-' + icon, busy && 'rw-loading')
	      }),
	      children
	    );
	  };
	
	  return Button;
	}(_react2.default.Component);
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dataHelpers = __webpack_require__(1781);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropdownListInput = (_temp = _class = function (_React$Component) {
	  _inherits(DropdownListInput, _React$Component);
	
	  function DropdownListInput() {
	    _classCallCheck(this, DropdownListInput);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownListInput.prototype.render = function render() {
	    var _props = this.props;
	    var placeholder = _props.placeholder;
	    var value = _props.value;
	    var textField = _props.textField;
	    var Component = _props.valueComponent;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'rw-input' },
	      !value && placeholder ? _react2.default.createElement(
	        'span',
	        { className: 'rw-placeholder' },
	        placeholder
	      ) : Component ? _react2.default.createElement(Component, { item: value }) : (0, _dataHelpers.dataText)(value, textField)
	    );
	  };
	
	  return DropdownListInput;
	}(_react2.default.Component), _class.propTypes = {
	  value: _react.PropTypes.any,
	  placeholder: _react.PropTypes.string,
	  textField: _propTypes2.default.accessor,
	  valueComponent: _propTypes2.default.elementType
	}, _temp);
	exports.default = DropdownListInput;
	module.exports = exports['default'];

/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _localizers = __webpack_require__(1768);
	
	var _localizers2 = _interopRequireDefault(_localizers);
	
	var _filter = __webpack_require__(1780);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filterTypes = Object.keys(_filter2.default).filter(function (i) {
	  return i !== 'filter';
	});
	
	function getInteractionPropType(key) {
	  var types = [_react.PropTypes.bool, _react.PropTypes.oneOf([key])],
	      propType = _react.PropTypes.oneOfType(types);
	
	  propType.acceptsArray = _react.PropTypes.oneOfType(types.concat(_react.PropTypes.array));
	
	  return propType;
	}
	
	module.exports = {
	
	  elementType: createChainableTypeChecker(function (props, propName, componentName) {
	
	    if (typeof props[propName] !== 'function') {
	      if (_react2.default.isValidElement(props[propName])) return new Error('Invalid prop `' + propName + '` specified in  `' + componentName + '`.' + ' Expected an Element `type`, not an actual Element');
	
	      if (typeof props[propName] !== 'string') return new Error('Invalid prop `' + propName + '` specified in  `' + componentName + '`.' + ' Expected an Element `type` such as a tag name or return value of React.createClass(...)');
	    }
	    return null;
	  }),
	
	  numberFormat: createChainableTypeChecker(function () {
	    var _localizers$number;
	
	    return (_localizers$number = _localizers2.default.number).propType.apply(_localizers$number, arguments);
	  }),
	
	  dateFormat: createChainableTypeChecker(function () {
	    var _localizers$date;
	
	    return (_localizers$date = _localizers2.default.date).propType.apply(_localizers$date, arguments);
	  }),
	
	  disabled: getInteractionPropType('disabled'),
	  readOnly: getInteractionPropType('readOnly'),
	
	  accessor: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.func]),
	
	  message: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.node, _react2.default.PropTypes.string]),
	
	  filter: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.func, _react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(filterTypes)])
	};
	
	function createChainableTypeChecker(validate) {
	
	  function checkType(isRequired, props, propName, componentName) {
	    componentName = componentName || '<<anonymous>>';
	
	    for (var _len = arguments.length, args = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
	      args[_key - 4] = arguments[_key];
	    }
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required prop `' + propName + '` was not specified in  `' + componentName + '`.');
	      }
	    } else return validate.apply(undefined, [props, propName, componentName].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ },
/* 1780 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var common = {
	  eq: function eq(a, b) {
	    return a === b;
	  },
	  neq: function neq(a, b) {
	    return a !== b;
	  },
	  gt: function gt(a, b) {
	    return a > b;
	  },
	  gte: function gte(a, b) {
	    return a >= b;
	  },
	  lt: function lt(a, b) {
	    return a < b;
	  },
	  lte: function lte(a, b) {
	    return a <= b;
	  },
	  contains: function contains(a, b) {
	    return a.indexOf(b) !== -1;
	  },
	  startsWith: function startsWith(a, b) {
	    return a.lastIndexOf(b, 0) === 0;
	  },
	  endsWith: function endsWith(a, b) {
	    var pos = a.length - b.length,
	        lastIndex = a.indexOf(b, pos);
	
	    return lastIndex !== -1 && lastIndex === pos;
	  }
	};
	
	exports.default = common;
	module.exports = exports['default'];

/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.dataValue = dataValue;
	exports.dataText = dataText;
	exports.dataIndexOf = dataIndexOf;
	exports.valueMatcher = valueMatcher;
	exports.dataItem = dataItem;
	
	var _ = __webpack_require__(1769);
	
	function accessor(data, field) {
	  var value = data;
	
	  if (typeof field === 'function') value = field(data);else if (data == null) value = data;else if (typeof field === 'string' && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && field in data) value = data[field];
	
	  return value;
	}
	
	function dataValue(item, valueField) {
	  return valueField && item && (0, _.has)(item, valueField) ? item[valueField] : item;
	}
	
	function dataText(item, textField) {
	  var value = accessor(item, textField);
	  return value == null ? '' : value + '';
	}
	
	function dataIndexOf(data, item, valueField) {
	  var idx = -1,
	      len = data.length,
	      isValueEqual = function isValueEqual(datum) {
	    return valueMatcher(item, datum, valueField);
	  };
	
	  while (++idx < len) {
	    var datum = data[idx];
	    if (datum === item || isValueEqual(datum)) return idx;
	  }
	
	  return -1;
	}
	
	/**
	 * I don't know that the shallow equal makes sense here but am too afraid to
	 * remove it.
	 */
	function valueMatcher(a, b, valueField) {
	  return (0, _.isShallowEqual)(dataValue(a, valueField), dataValue(b, valueField));
	}
	
	function dataItem(data, item, valueField) {
	  var idx = dataIndexOf(data, dataValue(item, valueField), valueField);
	
	  if (idx !== -1) return data[idx];
	
	  return item;
	}

/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _OVERFLOW;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _style = __webpack_require__(1757);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _height = __webpack_require__(1783);
	
	var _height2 = _interopRequireDefault(_height);
	
	var _camelizeStyle = __webpack_require__(1758);
	
	var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
	var _configuration = __webpack_require__(1754);
	
	var _configuration2 = _interopRequireDefault(_configuration);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = (0, _camelizeStyle2.default)(_configuration2.default.animate.transform);
	
	var CLOSING = 0,
	    CLOSED = 1,
	    OPENING = 2,
	    OPEN = 3;
	
	function properties(prop, value) {
	  var _ref, _ref2;
	
	  var TRANSLATION_MAP = _configuration2.default.animate.TRANSLATION_MAP;
	
	  if (TRANSLATION_MAP && TRANSLATION_MAP[prop]) return _ref = {}, _ref[transform] = TRANSLATION_MAP[prop] + '(' + value + ')', _ref;
	
	  return _ref2 = {}, _ref2[prop] = value, _ref2;
	}
	
	var OVERFLOW = (_OVERFLOW = {}, _OVERFLOW[CLOSED] = 'hidden', _OVERFLOW[CLOSING] = 'hidden', _OVERFLOW[OPENING] = 'hidden', _OVERFLOW);
	
	var propTypes = {
	  open: _react2.default.PropTypes.bool,
	  dropUp: _react2.default.PropTypes.bool,
	  duration: _react2.default.PropTypes.number,
	
	  onClosing: _react2.default.PropTypes.func,
	  onOpening: _react2.default.PropTypes.func,
	  onClose: _react2.default.PropTypes.func,
	  onOpen: _react2.default.PropTypes.func
	};
	
	exports.default = _react2.default.createClass({
	
	  displayName: 'Popup',
	
	  propTypes: propTypes,
	
	  getInitialState: function getInitialState() {
	    return {
	      initialRender: true,
	      status: this.props.open ? OPENING : CLOSED
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      duration: 200,
	      open: false,
	      onClosing: function onClosing() {},
	      onOpening: function onOpening() {},
	      onClose: function onClose() {},
	      onOpen: function onOpen() {}
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState({
	      contentChanged: childKey(nextProps.children) !== childKey(this.props.children)
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var isOpen = this.state.status === OPENING;
	
	    _compat2.default.batchedUpdates(function () {
	      _this.setState({ initialRender: false });
	      if (isOpen) {
	        _this.open();
	      }
	    });
	  },
	  componentDidUpdate: function componentDidUpdate(pvProps) {
	    var closing = pvProps.open && !this.props.open,
	        opening = !pvProps.open && this.props.open,
	        open = this.props.open,
	        status = this.state.status;
	
	    if (!!pvProps.dropUp !== !!this.props.dropUp) {
	      this.cancelNextCallback();
	      if (status === OPENING) this.open();
	      if (status === CLOSING) this.close();
	      return;
	    }
	
	    if (opening) this.open();else if (closing) this.close();else if (open) {
	      var height = this.height();
	      if (height !== this.state.height) this.setState({ height: height });
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var dropUp = _props.dropUp;
	    var style = _props.style;
	    var _state = this.state;
	    var status = _state.status;
	    var height = _state.height;
	
	
	    var overflow = OVERFLOW[status] || 'visible',
	        display = status === CLOSED ? 'none' : 'block';
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: _extends({
	          display: display,
	          overflow: overflow,
	          height: height
	        }, style),
	        className: (0, _classnames2.default)(className, 'rw-popup-container', dropUp && 'rw-dropup', this.isTransitioning() && 'rw-popup-animating')
	      },
	      this.renderChildren()
	    );
	  },
	  renderChildren: function renderChildren() {
	    if (!this.props.children) return _react2.default.createElement('span', { className: 'rw-popup rw-widget' });
	
	    var offset = this.getOffsetForStatus(this.state.status),
	        child = _react2.default.Children.only(this.props.children);
	
	    return (0, _react.cloneElement)(child, {
	      style: _extends({}, child.props.style, offset, {
	        position: this.isTransitioning() ? 'absolute' : undefined
	      }),
	      className: (0, _classnames2.default)(child.props.className, 'rw-popup rw-widget')
	    });
	  },
	  open: function open() {
	    var _this2 = this;
	
	    this.cancelNextCallback();
	    var el = _compat2.default.findDOMNode(this).firstChild,
	        height = this.height();
	
	    this.props.onOpening();
	
	    this.safeSetState({ status: OPENING, height: height }, function () {
	      var offset = _this2.getOffsetForStatus(OPEN),
	          duration = _this2.props.duration;
	
	      _this2.animate(el, offset, duration, 'ease', function () {
	        _this2.safeSetState({ status: OPEN }, function () {
	          _this2.props.onOpen();
	        });
	      });
	    });
	  },
	  close: function close() {
	    var _this3 = this;
	
	    this.cancelNextCallback();
	    var el = _compat2.default.findDOMNode(this).firstChild,
	        height = this.height();
	
	    this.props.onClosing();
	
	    this.safeSetState({ status: CLOSING, height: height }, function () {
	      var offset = _this3.getOffsetForStatus(CLOSED),
	          duration = _this3.props.duration;
	
	      _this3.animate(el, offset, duration, 'ease', function () {
	        return _this3.safeSetState({ status: CLOSED }, function () {
	          _this3.props.onClose();
	        });
	      });
	    });
	  },
	  getOffsetForStatus: function getOffsetForStatus(status) {
	    var _CLOSED$CLOSING$OPENI;
	
	    if (this.state.initialRender) return {};
	
	    var _in = properties('top', this.props.dropUp ? '100%' : '-100%'),
	        out = properties('top', 0);
	    return (_CLOSED$CLOSING$OPENI = {}, _CLOSED$CLOSING$OPENI[CLOSED] = _in, _CLOSED$CLOSING$OPENI[CLOSING] = out, _CLOSED$CLOSING$OPENI[OPENING] = _in, _CLOSED$CLOSING$OPENI[OPEN] = out, _CLOSED$CLOSING$OPENI)[status] || {};
	  },
	  height: function height() {
	    var container = _compat2.default.findDOMNode(this),
	        content = container.firstChild,
	        margin = parseInt((0, _style2.default)(content, 'margin-top'), 10) + parseInt((0, _style2.default)(content, 'margin-bottom'), 10);
	
	    var old = container.style.display,
	        height = void 0;
	
	    container.style.display = 'block';
	    height = ((0, _height2.default)(content) || 0) + (isNaN(margin) ? 0 : margin);
	    container.style.display = old;
	    return height;
	  },
	  isTransitioning: function isTransitioning() {
	    return this.state.status === OPENING || this.state.status === CLOSED;
	  },
	  animate: function animate(el, props, dur, easing, cb) {
	    this._transition = _configuration2.default.animate(el, props, dur, easing, this.setNextCallback(cb));
	  },
	  cancelNextCallback: function cancelNextCallback() {
	    if (this._transition && this._transition.cancel) {
	      this._transition.cancel();
	      this._transition = null;
	    }
	    if (this.nextCallback) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  },
	  safeSetState: function safeSetState(nextState, callback) {
	    this.setState(nextState, this.setNextCallback(callback));
	  },
	  setNextCallback: function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      return active = false;
	    };
	    return this.nextCallback;
	  }
	});
	
	
	function childKey(children) {
	  var nextChildMapping = _react2.default.Children.map(children, function (c) {
	    return c;
	  });
	  for (var key in nextChildMapping) {
	    return key;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var offset = __webpack_require__(1784),
	    getWindow = __webpack_require__(1785);
	
	module.exports = function height(node, client) {
	  var win = getWindow(node);
	  return win ? win.innerHeight : client ? node.clientHeight : offset(node).height;
	};

/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var contains = __webpack_require__(1773),
	    getWindow = __webpack_require__(1785),
	    ownerDocument = __webpack_require__(1772);
	
	module.exports = function offset(node) {
	  var doc = ownerDocument(node),
	      win = getWindow(doc),
	      docElem = doc && doc.documentElement,
	      box = { top: 0, left: 0, height: 0, width: 0 };
	
	  if (!doc) return;
	
	  // Make sure it's not a disconnected DOM node
	  if (!contains(docElem, node)) return box;
	
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
	
	  if (box.width || box.height) {
	
	    box = {
	      top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	      left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	      width: (box.width == null ? node.offsetWidth : box.width) || 0,
	      height: (box.height == null ? node.offsetHeight : box.height) || 0
	    };
	  }
	
	  return box;
	};

/***/ },
/* 1785 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	};

/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _version = _react2.default.version.split('.').map(parseFloat);
	
	module.exports = {
	  version: function version() {
	    return _version;
	  },
	  findDOMNode: function findDOMNode(component) {
	    return _reactDom2.default.findDOMNode(component);
	  },
	  batchedUpdates: function batchedUpdates(cb) {
	    _reactDom2.default.unstable_batchedUpdates(cb);
	  }
	};

/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ListOption = __webpack_require__(1788);
	
	var _ListOption2 = _interopRequireDefault(_ListOption);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _dataHelpers = __webpack_require__(1781);
	
	var _widgetHelpers = __webpack_require__(1789);
	
	var _interaction = __webpack_require__(1790);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var optionId = function optionId(id, idx) {
	  return id + '__option__' + idx;
	};
	
	exports.default = _react2.default.createClass({
	
	  displayName: 'List',
	
	  mixins: [__webpack_require__(1791), __webpack_require__(1792)()],
	
	  propTypes: {
	    data: _react2.default.PropTypes.array,
	    onSelect: _react2.default.PropTypes.func,
	    onMove: _react2.default.PropTypes.func,
	
	    optionComponent: _propTypes2.default.elementType,
	    itemComponent: _propTypes2.default.elementType,
	
	    selected: _react2.default.PropTypes.any,
	    focused: _react2.default.PropTypes.any,
	    valueField: _propTypes2.default.accessor,
	    textField: _propTypes2.default.accessor,
	
	    disabled: _propTypes2.default.disabled.acceptsArray,
	    readOnly: _propTypes2.default.readOnly.acceptsArray,
	
	    messages: _react2.default.PropTypes.shape({
	      emptyList: _propTypes2.default.message
	    })
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onSelect: function onSelect() {},
	      optionComponent: _ListOption2.default,
	      ariaActiveDescendantKey: 'list',
	      data: [],
	      messages: {
	        emptyList: 'There are no items in this list'
	      }
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.move();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var _props = this.props;
	    var data = _props.data;
	    var focused = _props.focused;
	    var idx = data.indexOf(focused);
	    var activeId = optionId((0, _widgetHelpers.instanceId)(this), idx);
	
	    this.ariaActiveDescendant(idx !== -1 ? activeId : null);
	
	    this.move();
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var className = _props2.className;
	    var role = _props2.role;
	    var data = _props2.data;
	    var textField = _props2.textField;
	    var valueField = _props2.valueField;
	    var focused = _props2.focused;
	    var selected = _props2.selected;
	    var messages = _props2.messages;
	    var onSelect = _props2.onSelect;
	    var ItemComponent = _props2.itemComponent;
	    var Option = _props2.optionComponent;
	
	
	    var id = (0, _widgetHelpers.instanceId)(this),
	        items = void 0;
	
	    var elementProps = _3.default.omitOwnProps(this);
	
	    items = !data.length ? _react2.default.createElement(
	      'li',
	      { className: 'rw-list-empty' },
	      _3.default.result(messages.emptyList, this.props)
	    ) : data.map(function (item, idx) {
	      var currentId = optionId(id, idx),
	          isDisabled = (0, _interaction.isDisabledItem)(item, _this.props),
	          isReadOnly = (0, _interaction.isReadOnlyItem)(item, _this.props);
	
	      return _react2.default.createElement(
	        Option,
	        {
	          key: 'item_' + idx,
	          id: currentId,
	          dataItem: item,
	          disabled: isDisabled,
	          readOnly: isReadOnly,
	          focused: focused === item,
	          selected: selected === item,
	          onClick: isDisabled || isReadOnly ? undefined : onSelect.bind(null, item)
	        },
	        ItemComponent ? _react2.default.createElement(ItemComponent, {
	          item: item,
	          value: (0, _dataHelpers.dataValue)(item, valueField),
	          text: (0, _dataHelpers.dataText)(item, textField),
	          disabled: isDisabled,
	          readOnly: isReadOnly
	        }) : (0, _dataHelpers.dataText)(item, textField)
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      _extends({
	        id: id,
	        tabIndex: '-1',
	        className: (0, _classnames2.default)(className, 'rw-list'),
	        role: role === undefined ? 'listbox' : role
	      }, elementProps),
	      items
	    );
	  },
	  _data: function _data() {
	    return this.props.data;
	  },
	  move: function move() {
	    var list = _compat2.default.findDOMNode(this),
	        idx = this._data().indexOf(this.props.focused),
	        selected = list.children[idx];
	
	    if (!selected) return;
	
	    (0, _widgetHelpers.notify)(this.props.onMove, [selected, list, this.props.focused]);
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListOption = _react2.default.createClass({
	  displayName: 'ListOption',
	
	  propTypes: {
	    dataItem: _react2.default.PropTypes.any,
	    focused: _react2.default.PropTypes.bool,
	    selected: _react2.default.PropTypes.bool,
	    disabled: _react2.default.PropTypes.bool,
	    readOnly: _react2.default.PropTypes.bool
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var children = _props.children;
	    var focused = _props.focused;
	    var selected = _props.selected;
	    var disabled = _props.disabled;
	    var readOnly = _props.readOnly;
	
	
	    var props = _3.default.omitOwnProps(this);
	
	    var classes = {
	      'rw-state-focus': focused,
	      'rw-state-selected': selected,
	      'rw-state-disabled': disabled,
	      'rw-state-readonly': readOnly
	    };
	
	    return _react2.default.createElement(
	      'li',
	      _extends({
	        role: 'option',
	        tabIndex: !(disabled || readOnly) ? '-1' : undefined,
	        'aria-selected': !!selected,
	        className: (0, _classnames2.default)('rw-list-option', className, classes)
	      }, props),
	      children
	    );
	  }
	});
	
	exports.default = ListOption;
	module.exports = exports['default'];

/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.notify = notify;
	exports.instanceId = instanceId;
	exports.isFirstFocusedRender = isFirstFocusedRender;
	
	var _ = __webpack_require__(1769);
	
	function notify(handler, args) {
	  handler && handler.apply(null, [].concat(args));
	}
	
	function instanceId(component) {
	  var suffix = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	
	  component.__id || (component.__id = (0, _.uniqueId)('rw_'));
	  return (component.props.id || component.__id) + suffix;
	}
	
	function isFirstFocusedRender(component) {
	  return component._firstFocus || component.state.focused && (component._firstFocus = true);
	}

/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.widgetEditable = exports.widgetEnabled = undefined;
	exports.isDisabled = isDisabled;
	exports.isReadOnly = isReadOnly;
	exports.isDisabledItem = isDisabledItem;
	exports.isReadOnlyItem = isReadOnlyItem;
	exports.contains = contains;
	exports.move = move;
	
	var _dataHelpers = __webpack_require__(1781);
	
	function isDisabled(props) {
	  return props.disabled === true || props.disabled === 'disabled';
	}
	
	function isReadOnly(props) {
	  return props.readOnly === true || props.readOnly === 'readOnly';
	}
	
	function isDisabledItem(item, props) {
	  return isDisabled(props) || contains(item, props.disabled, props.valueField);
	}
	
	function isReadOnlyItem(item, props) {
	  return isReadOnly(props) || contains(item, props.readOnly, props.valueField);
	}
	
	function contains(item, values, valueField) {
	  return Array.isArray(values) ? values.some(function (value) {
	    return (0, _dataHelpers.valueMatcher)(item, value, valueField);
	  }) : (0, _dataHelpers.valueMatcher)(item, values, valueField);
	}
	
	function move(dir, item, props, list) {
	  var isDisabledOrReadonly = function isDisabledOrReadonly(item) {
	    return isDisabledItem(item, props) || isReadOnlyItem(item, props);
	  },
	      stop = dir === 'next' ? list.last() : list.first(),
	      next = list[dir](item);
	
	  while (next !== stop && isDisabledOrReadonly(next)) {
	    next = list[dir](next);
	  }return isDisabledOrReadonly(next) ? item : next;
	}
	
	var widgetEnabled = exports.widgetEnabled = interactionDecorator(true);
	
	var widgetEditable = exports.widgetEditable = interactionDecorator(false);
	
	function interactionDecorator(disabledOnly) {
	  function wrap(method) {
	    return function decoratedMethod() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      if (!(isDisabled(this.props) || !disabledOnly && isReadOnly(this.props))) return method.apply(this, args);
	    };
	  }
	
	  return function decorate(target, key, desc) {
	    if (desc.initializer) {
	      (function () {
	        var init = desc.initializer;
	        desc.initializer = function () {
	          return wrap(init());
	        };
	      })();
	    } else desc.value = wrap(desc.value);
	    return desc;
	  };
	}

/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _filter = __webpack_require__(1780);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _dataHelpers = __webpack_require__(1781);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _interaction = __webpack_require__(1790);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EMPTY_VALUE = {};
	
	var isDisabledOrReadonly = function isDisabledOrReadonly(item, props) {
	  return (0, _interaction.isDisabledItem)(item, props) || (0, _interaction.isReadOnlyItem)(item, props);
	};
	
	exports.default = {
	
	  propTypes: {
	    textField: _propTypes2.default.accessor,
	    valueField: _propTypes2.default.accessor,
	    disabled: _propTypes2.default.disabled.acceptsArray,
	    readOnly: _propTypes2.default.readOnly.acceptsArray
	  },
	
	  first: function first() {
	    return this.next(EMPTY_VALUE);
	  },
	  last: function last() {
	    var data = this._data(),
	        item = data[data.length - 1];
	
	    return isDisabledOrReadonly(item, this.props) ? this.prev(item) : item;
	  },
	  prev: function prev(item, word) {
	    var data = this._data(),
	        nextIdx = data.indexOf(item),
	        matches = matcher(word, item, this.props.textField);
	
	    if (nextIdx < 0 || nextIdx == null) nextIdx = 0;
	
	    nextIdx--;
	
	    while (nextIdx > -1 && (isDisabledOrReadonly(data[nextIdx], this.props) || !matches(data[nextIdx]))) {
	      nextIdx--;
	    }return nextIdx >= 0 ? data[nextIdx] : item;
	  },
	  next: function next(item, word) {
	    var data = this._data(),
	        nextIdx = data.indexOf(item) + 1,
	        len = data.length,
	        matches = matcher(word, item, this.props.textField);
	
	    while (nextIdx < len && (isDisabledOrReadonly(data[nextIdx], this.props) || !matches(data[nextIdx]))) {
	      nextIdx++;
	    }return nextIdx < len ? data[nextIdx] : item;
	  }
	};
	
	
	function matcher(word, item, textField) {
	  if (!word) return function () {
	    return true;
	  };
	
	  word = word.toLowerCase();
	  return function (item) {
	    return _filter2.default.startsWith((0, _dataHelpers.dataText)(item, textField).toLowerCase(), word);
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (nodeOrComponent) {
	  var reconcileChildren = arguments.length <= 1 || arguments[1] === undefined ? defaultReconcile : arguments[1];
	
	
	  return {
	    propTypes: {
	      ariaActiveDescendantKey: _react2.default.PropTypes.string.isRequired
	    },
	
	    contextTypes: {
	      activeDescendants: shape
	    },
	
	    childContextTypes: {
	      activeDescendants: shape
	    },
	
	    ariaActiveDescendant: function ariaActiveDescendant(id) {
	      var key = arguments.length <= 1 || arguments[1] === undefined ? this.props.ariaActiveDescendantKey : arguments[1];
	      var activeDescendants = this.context.activeDescendants;
	
	      var current = this.__ariaActiveDescendantId;
	
	      if (id === undefined) return current;
	
	      id = reconcileChildren.call(this, key, id);
	
	      if (id === undefined) id = current;else {
	        this.__ariaActiveDescendantId = id;
	        flushAriaToNode(id, nodeOrComponent, this);
	      }
	
	      activeDescendants && activeDescendants.reconcile(key, id);
	    },
	    getChildContext: function getChildContext() {
	      var _this = this;
	
	      return this._context || (this._context = {
	        activeDescendants: {
	          reconcile: function reconcile(key, id) {
	            return _this.ariaActiveDescendant(id, key);
	          }
	        }
	      });
	    }
	  };
	};
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shape = _react2.default.PropTypes.shape({
	  //setActive: React.PropTypes.func,
	  reconcile: _react2.default.PropTypes.func
	});
	
	function defaultReconcile(key, id) {
	  return id;
	}
	
	function flushAriaToNode(id, nodeOrComponent, ctx) {
	  var node = typeof nodeOrComponent === 'function' ? nodeOrComponent(ctx) : typeof nodeOrComponent === 'string' ? ctx.refs[nodeOrComponent] : ctx;
	
	  if (node) {
	    if (id) _compat2.default.findDOMNode(node).setAttribute('aria-activedescendant', id);else _compat2.default.findDOMNode(node).removeAttribute('aria-activedescendant');
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ListOption = __webpack_require__(1788);
	
	var _ListOption2 = _interopRequireDefault(_ListOption);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _warning = __webpack_require__(1794);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _dataHelpers = __webpack_require__(1781);
	
	var _widgetHelpers = __webpack_require__(1789);
	
	var _interaction = __webpack_require__(1790);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var optionId = function optionId(id, idx) {
	  return id + '__option__' + idx;
	};
	
	exports.default = _react2.default.createClass({
	
	  displayName: 'List',
	
	  mixins: [__webpack_require__(1791), __webpack_require__(1792)()],
	
	  propTypes: {
	    data: _react2.default.PropTypes.array,
	    onSelect: _react2.default.PropTypes.func,
	    onMove: _react2.default.PropTypes.func,
	
	    optionComponent: _propTypes2.default.elementType,
	    itemComponent: _propTypes2.default.elementType,
	    groupComponent: _propTypes2.default.elementType,
	
	    selected: _react2.default.PropTypes.any,
	    focused: _react2.default.PropTypes.any,
	
	    valueField: _propTypes2.default.accessor,
	    textField: _propTypes2.default.accessor,
	
	    disabled: _propTypes2.default.disabled.acceptsArray,
	    readOnly: _propTypes2.default.readOnly.acceptsArray,
	
	    groupBy: _propTypes2.default.accessor,
	
	    messages: _react2.default.PropTypes.shape({
	      emptyList: _propTypes2.default.message
	    })
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onSelect: function onSelect() {},
	      data: [],
	      optionComponent: _ListOption2.default,
	      ariaActiveDescendantKey: 'groupedList',
	      messages: {
	        emptyList: 'There are no items in this list'
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    var keys = [];
	
	    return {
	      groups: this._group(this.props.groupBy, this.props.data, keys),
	
	      sortedKeys: keys
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var keys = [];
	
	    if (nextProps.data !== this.props.data || nextProps.groupBy !== this.props.groupBy) this.setState({
	      groups: this._group(nextProps.groupBy, nextProps.data, keys),
	      sortedKeys: keys
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    this.move();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.ariaActiveDescendant(this._currentActiveID);
	    this.move();
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var className = _props.className;
	    var role = _props.role;
	    var data = _props.data;
	    var messages = _props.messages;
	    var _state = this.state;
	    var sortedKeys = _state.sortedKeys;
	    var groups = _state.groups;
	
	
	    var elementProps = _3.default.omitOwnProps(this);
	
	    var items = [],
	        idx = -1,
	        group = void 0;
	
	    var id = (0, _widgetHelpers.instanceId)(this);
	
	    this._currentActiveID = null;
	
	    if (data.length) {
	      items = sortedKeys.reduce(function (items, key) {
	        group = groups[key];
	        items.push(_this._renderGroupHeader(key));
	
	        for (var itemIdx = 0; itemIdx < group.length; itemIdx++) {
	          items.push(_this._renderItem(key, group[itemIdx], ++idx));
	        }return items;
	      }, []);
	    } else items = _react2.default.createElement(
	      'li',
	      { className: 'rw-list-empty' },
	      _3.default.result(messages.emptyList, this.props)
	    );
	
	    return _react2.default.createElement(
	      'ul',
	      _extends({
	        ref: 'scrollable',
	        id: id,
	        tabIndex: '-1',
	        className: (0, _classnames2.default)(className, 'rw-list', 'rw-list-grouped'),
	        role: role === undefined ? 'listbox' : role
	      }, elementProps),
	      items
	    );
	  },
	  _renderGroupHeader: function _renderGroupHeader(group) {
	    var GroupComponent = this.props.groupComponent,
	        id = (0, _widgetHelpers.instanceId)(this);
	
	    return _react2.default.createElement(
	      'li',
	      {
	        key: 'item_' + group,
	        tabIndex: '-1',
	        role: 'separator',
	        id: id + '_group_' + group,
	        className: 'rw-list-optgroup'
	      },
	      GroupComponent ? _react2.default.createElement(GroupComponent, { item: group }) : group
	    );
	  },
	  _renderItem: function _renderItem(group, item, idx) {
	    var _props2 = this.props;
	    var focused = _props2.focused;
	    var selected = _props2.selected;
	    var onSelect = _props2.onSelect;
	    var textField = _props2.textField;
	    var valueField = _props2.valueField;
	    var ItemComponent = _props2.itemComponent;
	    var Option = _props2.optionComponent;
	
	
	    var currentID = optionId((0, _widgetHelpers.instanceId)(this), idx),
	        isDisabled = (0, _interaction.isDisabledItem)(item, this.props),
	        isReadOnly = (0, _interaction.isReadOnlyItem)(item, this.props);
	
	    if (focused === item) this._currentActiveID = currentID;
	
	    return _react2.default.createElement(
	      Option,
	      {
	        key: 'item_' + group + '_' + idx,
	        id: currentID,
	        dataItem: item,
	        focused: focused === item,
	        selected: selected === item,
	        disabled: isDisabled,
	        readOnly: isReadOnly,
	        onClick: isDisabled || isReadOnly ? undefined : onSelect.bind(null, item)
	      },
	      ItemComponent ? _react2.default.createElement(ItemComponent, {
	        item: item,
	        value: (0, _dataHelpers.dataValue)(item, valueField),
	        text: (0, _dataHelpers.dataText)(item, textField),
	        disabled: isDisabled,
	        readOnly: isReadOnly
	      }) : (0, _dataHelpers.dataText)(item, textField)
	    );
	  },
	  _isIndexOf: function _isIndexOf(idx, item) {
	    return this.props.data[idx] === item;
	  },
	  _group: function _group(groupBy, data, keys) {
	    var iter = typeof groupBy === 'function' ? groupBy : function (item) {
	      return item[groupBy];
	    };
	
	    // the keys array ensures that groups are rendered in the order they came in
	    // which means that if you sort the data array it will render sorted,
	    // so long as you also sorted by group
	    keys = keys || [];
	
	    (0, _warning2.default)(typeof groupBy !== 'string' || !data.length || _3.default.has(data[0], groupBy), '[React Widgets] You are seem to be trying to group this list by a ' + ('property `' + groupBy + '` that doesn\'t exist in the dataset items, this may be a typo'));
	
	    return data.reduce(function (grps, item) {
	      var group = iter(item);
	
	      _3.default.has(grps, group) ? grps[group].push(item) : (keys.push(group), grps[group] = [item]);
	
	      return grps;
	    }, {});
	  },
	  _data: function _data() {
	    var groups = this.state.groups;
	
	    return this.state.sortedKeys.reduce(function (flat, grp) {
	      return flat.concat(groups[grp]);
	    }, []);
	  },
	  move: function move() {
	    var selected = this.getItemDOMNode(this.props.focused);
	
	    if (!selected) return;
	
	    (0, _widgetHelpers.notify)(this.props.onMove, [selected, _compat2.default.findDOMNode(this), this.props.focused]);
	  },
	  getItemDOMNode: function getItemDOMNode(item) {
	    var list = _compat2.default.findDOMNode(this),
	        groups = this.state.groups,
	        idx = -1,
	        itemIdx,
	        child;
	
	    this.state.sortedKeys.some(function (group) {
	      itemIdx = groups[group].indexOf(item);
	      idx++;
	
	      if (itemIdx !== -1) return !!(child = list.children[idx + itemIdx + 1]);
	
	      idx += groups[group].length;
	    });
	
	    return child;
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 1794 */
504,
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = validateListComponent;
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS = ['next', 'prev', 'first', 'last'];
	
	function validateListComponent(list) {
	  if (false) {
	    METHODS.forEach(function (method) {
	      return (0, _invariant2.default)(typeof list[method] === 'function', 'List components must implement a `' + method + '()` method');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(1797);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (component.isMounted()) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)([mixin], set);
	module.exports = exports['default'];

/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(1798);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createUncontrollable(mixins, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var methods = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = _react2.default.createClass(_extends({
	
	      displayName: 'Uncontrolled(' + displayName + ')',
	
	      mixins: mixins,
	
	      propTypes: propTypes
	
	    }, methods, {
	      componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this._values[key] = props[utils.defaultKey(key)];
	        });
	      },
	
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var props = this.props;
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this2._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      },
	      getControlledInstance: function getControlledInstance() {
	        return this.refs.inner;
	      },
	      render: function render() {
	        var _this3 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this3.props[propName];
	
	          if (linkPropName && !isProp(_this3.props, propName) && isProp(_this3.props, linkPropName)) {
	            prop = _this3.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this3._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this3, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      }
	    }));
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	        args[_key - 2] = arguments[_key];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(1769);
	
	var has = _require.has;
	
	
	module.exports = {
	  componentWillUnmount: function componentWillUnmount() {
	    var timers = this._timers || {};
	
	    this._unmounted = true;
	
	    for (var k in timers) {
	      if (has(timers, k)) this.clearTimeout(k);
	    }
	  },
	  clearTimeout: function clearTimeout(key) {
	    var timers = this._timers || {};
	    window.clearTimeout(timers[key]);
	  },
	  setTimeout: function setTimeout(key, cb, duration) {
	    var _this = this;
	
	    var timers = this._timers || (this._timers = Object.create(null));
	
	    if (this._unmounted) return;
	
	    this.clearTimeout(key);
	    timers[key] = window.setTimeout(function () {
	      if (!_this._unmounted) cb();
	    }, duration);
	  }
	};

/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  propTypes: {
	    autoFocus: _react2.default.PropTypes.bool
	  },
	
	  componentDidMount: function componentDidMount() {
	    var autoFocus = this.props.autoFocus;
	
	
	    if (autoFocus) this.focus ? this.focus() : (0, _reactDom.findDOMNode)(this).focus();
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1769);
	
	//backport PureRenderEqual
	module.exports = {
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !_.isShallowEqual(this.props, nextProps) || !_.isShallowEqual(this.state, nextState);
	  }
	};

/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _filter = __webpack_require__(1780);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dataHelpers = __webpack_require__(1781);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dflt = function dflt(f) {
	  return f === true ? 'startsWith' : f ? f : 'eq';
	};
	
	module.exports = {
	
	  propTypes: {
	    data: _react2.default.PropTypes.array,
	    value: _react2.default.PropTypes.any,
	    filter: _propTypes2.default.filter,
	    caseSensitive: _react2.default.PropTypes.bool,
	    minLength: _react2.default.PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      caseSensitive: false,
	      minLength: 1
	    };
	  },
	  filterIndexOf: function filterIndexOf(items, searchTerm) {
	    var idx = -1,
	        matches = typeof this.props.filter === 'function' ? this.props.filter : getFilter(_filter2.default[dflt(this.props.filter)], searchTerm, this);
	
	    if (!searchTerm || !searchTerm.trim() || this.props.filter && searchTerm.length < (this.props.minLength || 1)) return -1;
	
	    items.every(function (item, i) {
	      if (matches(item, searchTerm, i)) return idx = i, false;
	
	      return true;
	    });
	
	    return idx;
	  },
	  filter: function filter(items, searchTerm) {
	    var matches = typeof this.props.filter === 'string' ? getFilter(_filter2.default[this.props.filter], searchTerm, this) : this.props.filter;
	
	    if (!matches || !searchTerm || !searchTerm.trim() || searchTerm.length < (this.props.minLength || 1)) return items;
	
	    return items.filter(function (item, idx) {
	      return matches(item, searchTerm, idx);
	    });
	  }
	};
	
	function getFilter(matcher, searchTerm, ctx) {
	  searchTerm = !ctx.props.caseSensitive ? searchTerm.toLowerCase() : searchTerm;
	
	  return function (item) {
	    var val = (0, _dataHelpers.dataText)(item, ctx.props.textField);
	
	    if (!ctx.props.caseSensitive) val = val.toLowerCase();
	
	    return matcher(val, searchTerm);
	  };
	}

/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _scrollTo2 = __webpack_require__(1804);
	
	var _scrollTo3 = _interopRequireDefault(_scrollTo2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  _scrollTo: function _scrollTo(selected, list, focused) {
	    var state = this._scrollState || (this._scrollState = {}),
	        handler = this.props.onMove,
	        lastVisible = state.visible,
	        lastItem = state.focused,
	        shown,
	        changed;
	
	    state.visible = !(!list.offsetWidth || !list.offsetHeight);
	    state.focused = focused;
	
	    changed = lastItem !== focused;
	    shown = state.visible && !lastVisible;
	
	    if (shown || state.visible && changed) {
	      if (handler) handler(selected, list, focused);else {
	        state.scrollCancel && state.scrollCancel();
	        state.scrollCancel = (0, _scrollTo3.default)(selected, list);
	      }
	    }
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getOffset = __webpack_require__(1784),
	    height = __webpack_require__(1783),
	    getScrollParent = __webpack_require__(1805),
	    scrollTop = __webpack_require__(1806),
	    raf = __webpack_require__(1807),
	    getWindow = __webpack_require__(1785);
	
	module.exports = function scrollTo(selected, scrollParent) {
	    var offset = getOffset(selected),
	        poff = { top: 0, left: 0 },
	        list,
	        listScrollTop,
	        selectedTop,
	        isWin,
	        selectedHeight,
	        listHeight,
	        bottom;
	
	    if (!selected) return;
	
	    list = scrollParent || getScrollParent(selected);
	    isWin = getWindow(list);
	    listScrollTop = scrollTop(list);
	
	    listHeight = height(list, true);
	    isWin = getWindow(list);
	
	    if (!isWin) poff = getOffset(list);
	
	    offset = {
	        top: offset.top - poff.top,
	        left: offset.left - poff.left,
	        height: offset.height,
	        width: offset.width
	    };
	
	    selectedHeight = offset.height;
	    selectedTop = offset.top + (isWin ? 0 : listScrollTop);
	    bottom = selectedTop + selectedHeight;
	
	    listScrollTop = listScrollTop > selectedTop ? selectedTop : bottom > listScrollTop + listHeight ? bottom - listHeight : listScrollTop;
	
	    var id = raf(function () {
	        return scrollTop(list, listScrollTop);
	    });
	
	    return function () {
	        return raf.cancel(id);
	    };
	};

/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var css = __webpack_require__(1757),
	    height = __webpack_require__(1783);
	
	module.exports = function scrollPrarent(node) {
	  var position = css(node, 'position'),
	      excludeStatic = position === 'absolute',
	      ownerDoc = node.ownerDocument;
	
	  if (position === 'fixed') return ownerDoc || document;
	
	  while ((node = node.parentNode) && node.nodeType !== 9) {
	
	    var isStatic = excludeStatic && css(node, 'position') === 'static',
	        style = css(node, 'overflow') + css(node, 'overflow-y') + css(node, 'overflow-x');
	
	    if (isStatic) continue;
	
	    if (/(auto|scroll)/.test(style) && height(node) < node.scrollHeight) return node;
	  }
	
	  return document;
	};

/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(1785);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	};

/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(1765);
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'],
	    cancel = 'clearTimeout',
	    raf = fallback,
	    compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (canUseDOM) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function (cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function (cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  return window[cancel](id);
	};
	
	module.exports = compatRaf;

/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(299);
	
	module.exports = {
	
	  propTypes: {
	    isRtl: React.PropTypes.bool
	  },
	
	  contextTypes: {
	    isRtl: React.PropTypes.bool
	  },
	
	  childContextTypes: {
	    isRtl: React.PropTypes.bool
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      isRtl: !!(this.props.isRtl || this.context && this.context.isRtl)
	    };
	  },
	  isRtl: function isRtl() {
	    return !!(this.props.isRtl || this.context && this.context.isRtl);
	  }
	};

/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = FocusMixin;
	
	var _widgetHelpers = __webpack_require__(1789);
	
	var _interaction = __webpack_require__(1790);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function FocusMixin(_ref) {
	  var _desc, _value, _obj;
	
	  var willHandle = _ref.willHandle;
	  var didHandle = _ref.didHandle;
	
	  function _handleFocus(inst, focused, event) {
	    var handler = inst.props[focused ? 'onFocus' : 'onBlur'];
	
	    if (handler && event) event.persist();
	
	    if (willHandle && willHandle.call(inst, focused, event) === false) return;
	
	    inst.setTimeout('focus', function () {
	      _compat2.default.batchedUpdates(function () {
	        if (didHandle) didHandle.call(inst, focused, event);
	
	        if (focused !== inst.state.focused) {
	          (0, _widgetHelpers.notify)(handler, event);
	          if (inst.isMounted()) inst.setState({ focused: focused });
	        }
	      });
	    });
	  }
	
	  return _obj = {
	    handleBlur: function handleBlur(event) {
	      _handleFocus(this, false, event);
	    },
	    handleFocus: function handleFocus(event) {
	      _handleFocus(this, true, event);
	    }
	  }, (_applyDecoratedDescriptor(_obj, 'handleBlur', [_interaction.widgetEnabled], Object.getOwnPropertyDescriptor(_obj, 'handleBlur'), _obj), _applyDecoratedDescriptor(_obj, 'handleFocus', [_interaction.widgetEnabled], Object.getOwnPropertyDescriptor(_obj, 'handleFocus'), _obj)), _obj;
	}
	module.exports = exports['default'];

/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _desc, _value, _obj;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _filter = __webpack_require__(1780);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _Widget = __webpack_require__(1774);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _Popup = __webpack_require__(1782);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Select = __webpack_require__(1776);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _ComboboxInput = __webpack_require__(1811);
	
	var _ComboboxInput2 = _interopRequireDefault(_ComboboxInput);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(1787);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListGroupable = __webpack_require__(1793);
	
	var _ListGroupable2 = _interopRequireDefault(_ListGroupable);
	
	var _validateListInterface = __webpack_require__(1795);
	
	var _validateListInterface2 = _interopRequireDefault(_validateListInterface);
	
	var _uncontrollable = __webpack_require__(1796);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _dataHelpers = __webpack_require__(1781);
	
	var _interaction = __webpack_require__(1790);
	
	var _widgetHelpers = __webpack_require__(1789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var defaultSuggest = function defaultSuggest(f) {
	  return f === true ? 'startsWith' : f ? f : 'eq';
	};
	
	var propTypes = _extends({}, _Popup2.default.propTypes, {
	
	  //-- controlled props -----------
	  value: _react2.default.PropTypes.any,
	  onChange: _react2.default.PropTypes.func,
	  open: _react2.default.PropTypes.bool,
	  onToggle: _react2.default.PropTypes.func,
	  //------------------------------------
	
	  itemComponent: _propTypes2.default.elementType,
	  listComponent: _propTypes2.default.elementType,
	
	  groupComponent: _propTypes2.default.elementType,
	  groupBy: _propTypes2.default.accessor,
	
	  data: _react2.default.PropTypes.array,
	  valueField: _react2.default.PropTypes.string,
	  textField: _propTypes2.default.accessor,
	  name: _react2.default.PropTypes.string,
	
	  onSelect: _react2.default.PropTypes.func,
	
	  autoFocus: _react2.default.PropTypes.bool,
	  disabled: _propTypes2.default.disabled.acceptsArray,
	  readOnly: _propTypes2.default.readOnly.acceptsArray,
	
	  suggest: _propTypes2.default.filter,
	  filter: _propTypes2.default.filter,
	
	  busy: _react2.default.PropTypes.bool,
	
	  dropUp: _react2.default.PropTypes.bool,
	  duration: _react2.default.PropTypes.number,
	  delay: _react2.default.PropTypes.number,
	
	  placeholder: _react2.default.PropTypes.string,
	
	  messages: _react2.default.PropTypes.shape({
	    open: _propTypes2.default.message,
	    emptyList: _propTypes2.default.message,
	    emptyFilter: _propTypes2.default.message
	  })
	});
	
	var ComboBox = _react2.default.createClass((_obj = {
	
	  displayName: 'ComboBox',
	
	  mixins: [__webpack_require__(1799), __webpack_require__(1802), __webpack_require__(1803), __webpack_require__(1808), __webpack_require__(1792)('input'), __webpack_require__(1809)({
	    willHandle: function willHandle(focused) {
	      // not suggesting anymore
	      !focused && this.refs.input.accept();
	    },
	    didHandle: function didHandle(focused) {
	      if (!focused) this.close();
	    }
	  })],
	
	  propTypes: propTypes,
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var value = _props.value;
	    var data = _props.data;
	    var valueField = _props.valueField;
	    var items = this.process(data, value);
	    var idx = (0, _dataHelpers.dataIndexOf)(items, value, valueField);
	
	    return {
	      selectedItem: items[idx],
	      focusedItem: items[!~idx ? 0 : idx],
	      processedData: items,
	      open: false
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      data: [],
	      value: '',
	      open: false,
	      suggest: false,
	      filter: false,
	      delay: 500,
	
	      messages: msgs(),
	      ariaActiveDescendantKey: 'combobox'
	    };
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.refs.list && (0, _validateListInterface2.default)(this.refs.list);
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    var isSuggesting = this.refs.input && this.refs.input.isSuggesting(),
	        stateChanged = !_3.default.isShallowEqual(nextState, this.state),
	        valueChanged = !_3.default.isShallowEqual(nextProps, this.props);
	
	    return isSuggesting || stateChanged || valueChanged;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var value = nextProps.value;
	    var data = nextProps.data;
	    var valueField = nextProps.valueField;
	    var textField = nextProps.textField;
	
	
	    var rawIdx = (0, _dataHelpers.dataIndexOf)(data, value, valueField),
	        valueItem = rawIdx === -1 ? nextProps.value : nextProps.data[rawIdx],
	        isSuggesting = this.refs.input && this.refs.input.isSuggesting();
	
	    var items = this.process(nextProps.data, nextProps.value, (rawIdx === -1 || isSuggesting) && (0, _dataHelpers.dataText)(valueItem, textField));
	
	    var idx = (0, _dataHelpers.dataIndexOf)(items, value, valueField),
	        focused = this.filterIndexOf(items, (0, _dataHelpers.dataText)(valueItem, textField));
	
	    this._searchTerm = '';
	
	    this.setState({
	      processedData: items,
	      selectedItem: items[idx],
	      focusedItem: items[idx === -1 ? focused !== -1 ? focused : 0 // focus the closest match
	      : idx]
	    });
	  },
	  renderInput: function renderInput(listID) {
	    var _props2 = this.props;
	    var suggest = _props2.suggest;
	    var filter = _props2.filter;
	    var textField = _props2.textField;
	    var busy = _props2.busy;
	    var name = _props2.name;
	    var data = _props2.data;
	    var value = _props2.value;
	    var valueField = _props2.valueField;
	    var autoFocus = _props2.autoFocus;
	    var tabIndex = _props2.tabIndex;
	    var disabled = _props2.disabled;
	    var readOnly = _props2.readOnly;
	    var placeholder = _props2.placeholder;
	    var open = _props2.open;
	
	
	    var valueItem = (0, _dataHelpers.dataItem)(data, value, valueField); // take value from the raw data
	
	    var completeType = suggest ? filter ? 'both' : 'inline' : filter ? 'list' : '';
	
	    return _react2.default.createElement(_ComboboxInput2.default, {
	      ref: 'input',
	      id: (0, _widgetHelpers.instanceId)(this, '_input'),
	      autoFocus: autoFocus,
	      tabIndex: tabIndex,
	      suggest: suggest,
	      name: name,
	      role: 'combobox',
	      disabled: disabled,
	      readOnly: readOnly,
	      'aria-owns': listID,
	      'aria-busy': !!busy,
	      'aria-autocomplete': completeType,
	      'aria-expanded': open,
	      'aria-haspopup': true,
	      placeholder: placeholder,
	      value: (0, _dataHelpers.dataText)(valueItem, textField),
	      onChange: this.handleInputChange,
	      onKeyDown: this.handleInputKeyDown
	    });
	  },
	  renderList: function renderList(List, id, messages) {
	    var _props3 = this.props;
	    var open = _props3.open;
	    var data = _props3.data;
	    var _state = this.state;
	    var selectedItem = _state.selectedItem;
	    var focusedItem = _state.focusedItem;
	
	
	    var listProps = _3.default.pickProps(this.props, List);
	    var items = this._data();
	
	    return _react2.default.createElement(List, _extends({ ref: 'list'
	    }, listProps, {
	      id: id,
	      data: items,
	      selected: selectedItem,
	      focused: focusedItem,
	      'aria-hidden': !open,
	      'aria-labelledby': (0, _widgetHelpers.instanceId)(this),
	      'aria-live': open && 'polite',
	      onSelect: this.handleSelect,
	      onMove: this._scrollTo,
	      messages: {
	        emptyList: data.length ? messages.emptyFilter : messages.emptyList
	      }
	    }));
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props4 = this.props;
	    var className = _props4.className;
	    var duration = _props4.duration;
	    var groupBy = _props4.groupBy;
	    var messages = _props4.messages;
	    var busy = _props4.busy;
	    var dropUp = _props4.dropUp;
	    var open = _props4.open;
	    var List = _props4.listComponent;
	    var focused = this.state.focused;
	
	
	    var disabled = (0, _interaction.isDisabled)(this.props),
	        readOnly = (0, _interaction.isReadOnly)(this.props),
	        listID = (0, _widgetHelpers.instanceId)(this, '_listbox');
	
	    List = List || groupBy && _ListGroupable2.default || _List2.default;
	
	    var elementProps = _3.default.omitOwnProps(this, List);
	    var shouldRenderPopup = open || (0, _widgetHelpers.isFirstFocusedRender)(this);
	
	    messages = msgs(messages);
	
	    return _react2.default.createElement(
	      _Widget2.default,
	      _extends({}, elementProps, {
	        open: open,
	        dropUp: dropUp,
	        focused: focused,
	        disabled: disabled,
	        readOnly: readOnly,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        className: (0, _classnames2.default)(className, 'rw-combobox')
	      }),
	      _react2.default.createElement(_Select2.default, {
	        onClick: this.toggle,
	        disabled: !!(disabled || readOnly),
	        busy: busy,
	        icon: 'caret-down',
	        label: _3.default.result(messages.open, this.props)
	      }),
	      this.renderInput(listID),
	      shouldRenderPopup && _react2.default.createElement(
	        _Popup2.default,
	        {
	          open: open,
	          dropUp: dropUp,
	          duration: duration,
	          onOpening: function onOpening() {
	            return _this.refs.list.forceUpdate();
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.renderList(List, listID, messages)
	        )
	      )
	    );
	  },
	  handleSelect: function handleSelect(data) {
	    this.close();
	    (0, _widgetHelpers.notify)(this.props.onSelect, data);
	    this.change(data);
	    this.focus();
	  },
	  handleInputKeyDown: function handleInputKeyDown(e) {
	    this._deleting = e.key === 'Backspace' || e.key === 'Delete';
	    this._isTyping = true;
	  },
	  handleInputChange: function handleInputChange(e) {
	    var _props5 = this.props;
	    var data = _props5.data;
	    var textField = _props5.textField;
	
	
	    var shouldSuggest = !!this.props.suggest,
	        strVal = e.target.value,
	        suggestion;
	
	    suggestion = this._deleting || !shouldSuggest ? strVal : this.suggest(this._data(), strVal);
	
	    suggestion = suggestion || strVal;
	
	    data = _3.default.find(data, function (item) {
	      return (0, _dataHelpers.dataText)(item, textField).toLowerCase() === suggestion.toLowerCase();
	    });
	
	    this.change(!this._deleting && data ? data : strVal, true);
	
	    this.open();
	  },
	  focus: function focus() {
	    this.refs.input && this.refs.input.focus();
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var self = this,
	        key = e.key,
	        alt = e.altKey,
	        list = this.refs.list,
	        focusedItem = this.state.focusedItem,
	        selectedItem = this.state.selectedItem,
	        isOpen = this.props.open;
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	    if (e.defaultPrevented) return;
	
	    if (key === 'End') {
	      if (isOpen) this.setState({ focusedItem: list.last() });else select(list.last(), true);
	    } else if (key === 'Home') {
	      if (isOpen) this.setState({ focusedItem: list.first() });else select(list.first(), true);
	    } else if (key === 'Escape' && isOpen) this.close();else if (key === 'Enter' && isOpen) {
	      e.preventDefault();
	      select(this.state.focusedItem, true);
	    } else if (key === 'ArrowDown') {
	      if (alt) this.open();else {
	        if (isOpen) this.setState({ focusedItem: list.next(focusedItem) });else select(list.next(selectedItem), true);
	      }
	    } else if (key === 'ArrowUp') {
	      if (alt) this.close();else {
	        if (isOpen) this.setState({ focusedItem: list.prev(focusedItem) });else select(list.prev(selectedItem), true);
	      }
	    }
	
	    function select(item, fromList) {
	      if (!item) return self.change(_compat2.default.findDOMNode(self.refs.input).value, false);
	
	      self.refs.input.accept(true); //removes caret
	
	      if (fromList) return self.handleSelect(item);
	
	      self.change(item, false);
	    }
	  },
	  change: function change(data, typing) {
	    this._typedChange = !!typing;
	    (0, _widgetHelpers.notify)(this.props.onChange, data);
	  },
	  open: function open() {
	    if (!this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, true);
	  },
	  close: function close() {
	    if (this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, false);
	  },
	  toggle: function toggle() {
	    this.focus();
	
	    this.props.open ? this.close() : this.open();
	  },
	  suggest: function suggest(data, value) {
	    var _props6 = this.props;
	    var textField = _props6.textField;
	    var suggest = _props6.suggest;
	    var minLength = _props6.minLength;
	
	
	    var word = (0, _dataHelpers.dataText)(value, textField),
	        suggestion;
	
	    suggest = defaultSuggest(suggest);
	
	    if (!(word || '').trim() || word.length < (minLength || 1)) return '';
	
	    suggestion = typeof value === 'string' ? _3.default.find(data, getFilter(suggest, word, textField)) : value;
	
	    if (suggestion && (!this.state || !this.state.deleting)) return (0, _dataHelpers.dataText)(suggestion, textField);
	
	    return '';
	  },
	  _data: function _data() {
	    return this.state.processedData;
	  },
	  process: function process(data, values, searchTerm) {
	    if (this.props.filter && searchTerm) data = this.filter(data, searchTerm);
	
	    return data;
	  }
	}, (_applyDecoratedDescriptor(_obj, 'handleSelect', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleSelect'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyDown'), _obj), _applyDecoratedDescriptor(_obj, 'toggle', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'toggle'), _obj)), _obj));
	
	exports.default = (0, _uncontrollable2.default)(ComboBox, { open: 'onToggle', value: 'onChange' }, ['focus']);
	
	
	function msgs(msgs) {
	  return _extends({
	    open: 'open combobox',
	    emptyList: 'There are no items in this list',
	    emptyFilter: 'The filter returned no results'
	  }, msgs);
	}
	
	function getFilter(suggest, word, textField) {
	  return typeof suggest === 'string' ? function (item) {
	    return _filter2.default[suggest]((0, _dataHelpers.dataText)(item, textField).toLowerCase(), word.toLowerCase());
	  } : function (item) {
	    return suggest(item, word);
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _caret = __webpack_require__(1812);
	
	var _caret2 = _interopRequireDefault(_caret);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _Input = __webpack_require__(1775);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = _react2.default.createClass({
	
	  displayName: 'ComboboxInput',
	
	  propTypes: {
	    value: _react2.default.PropTypes.string,
	    suggest: _react2.default.PropTypes.bool,
	    onChange: _react2.default.PropTypes.func.isRequired
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    var input = _compat2.default.findDOMNode(this),
	        val = this.props.value;
	
	    if (this.isSuggesting()) {
	      var start = val.toLowerCase().indexOf(this._last.toLowerCase()) + this._last.length,
	          end = val.length - start;
	
	      if (start >= 0) {
	        (0, _caret2.default)(input, start, start + end);
	      }
	    }
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      value: ''
	    };
	  },
	  render: function render() {
	    var _props = this.props;
	    var onKeyDown = _props.onKeyDown;
	
	    var props = _objectWithoutProperties(_props, ['onKeyDown']);
	
	    delete props.suggest;
	
	    return _react2.default.createElement(_Input2.default, _extends({}, props, {
	      onKeyDown: onKeyDown,
	      onChange: this.handleChange
	    }));
	  },
	  isSuggesting: function isSuggesting() {
	    var val = this.props.value,
	        isSuggestion = this._last != null && val.toLowerCase().indexOf(this._last.toLowerCase()) !== -1;
	
	    return this.props.suggest && isSuggestion;
	  },
	  accept: function accept(removeCaret) {
	    var val = _compat2.default.findDOMNode(this).value || '',
	        end = val.length;
	
	    this._last = null;
	    removeCaret && (0, _caret2.default)(_compat2.default.findDOMNode(this), end, end);
	  },
	  handleChange: function handleChange(e) {
	    var val = e.target.value,
	        pl = !!this.props.placeholder;
	
	    // IE fires input events when setting/unsetting placeholders.
	    // issue #112
	    if (pl && !val && val === (this.props.value || '')) return;
	
	    this._last = val;
	    this.props.onChange(e, val);
	  },
	  focus: function focus() {
	    _compat2.default.findDOMNode(this).focus();
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 1812 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = caret;
	/*eslint-disable no-empty */
	function caret(el, start, end) {
	  if (start === undefined) return get(el);
	
	  set(el, start, end);
	}
	
	function get(el) {
	  var start, end, rangeEl, clone;
	
	  if (el.selectionStart !== undefined) {
	    start = el.selectionStart;
	    end = el.selectionEnd;
	  } else {
	    try {
	      el.focus();
	      rangeEl = el.createTextRange();
	      clone = rangeEl.duplicate();
	
	      rangeEl.moveToBookmark(document.selection.createRange().getBookmark());
	      clone.setEndPoint('EndToStart', rangeEl);
	
	      start = clone.text.length;
	      end = start + rangeEl.text.length;
	    } catch (e) {/* not focused or not visible */}
	  }
	
	  return { start: start, end: end };
	}
	
	function set(el, start, end) {
	  var rangeEl;
	
	  try {
	    if (el.selectionStart !== undefined) {
	      el.focus();
	      el.setSelectionRange(start, end);
	    } else {
	      el.focus();
	      rangeEl = el.createTextRange();
	      rangeEl.collapse(true);
	      rangeEl.moveStart('character', start);
	      rangeEl.moveEnd('character', end - start);
	      rangeEl.select();
	    }
	  } catch (e) {/* not focused or not visible */}
	}
	module.exports = exports['default'];

/***/ },
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _VIEW, _OPPOSITE_DIRECTION, _MULTIPLIER, _desc, _value2, _obj; //values, omit
	
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _Widget = __webpack_require__(1774);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _Header = __webpack_require__(1814);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(1816);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Month = __webpack_require__(1817);
	
	var _Month2 = _interopRequireDefault(_Month);
	
	var _Year = __webpack_require__(1822);
	
	var _Year2 = _interopRequireDefault(_Year);
	
	var _Decade = __webpack_require__(1823);
	
	var _Decade2 = _interopRequireDefault(_Decade);
	
	var _Century = __webpack_require__(1824);
	
	var _Century2 = _interopRequireDefault(_Century);
	
	var _localizers = __webpack_require__(1768);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__(1796);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _SlideTransition = __webpack_require__(1825);
	
	var _SlideTransition2 = _interopRequireDefault(_SlideTransition);
	
	var _dates = __webpack_require__(1819);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _constants = __webpack_require__(1821);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _widgetHelpers = __webpack_require__(1789);
	
	var _interaction = __webpack_require__(1790);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var dir = constants.directions,
	    values = function values(obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	},
	    invert = function invert(obj) {
	  return _3.default.transform(obj, function (o, val, key) {
	    o[val] = key;
	  }, {});
	};
	
	var views = constants.calendarViews,
	    VIEW_OPTIONS = values(views),
	    ALT_VIEW = invert(constants.calendarViewHierarchy),
	    NEXT_VIEW = constants.calendarViewHierarchy,
	    VIEW_UNIT = constants.calendarViewUnits,
	    VIEW = (_VIEW = {}, _VIEW[views.MONTH] = _Month2.default, _VIEW[views.YEAR] = _Year2.default, _VIEW[views.DECADE] = _Decade2.default, _VIEW[views.CENTURY] = _Century2.default, _VIEW);
	
	var ARROWS_TO_DIRECTION = {
	  ArrowDown: dir.DOWN,
	  ArrowUp: dir.UP,
	  ArrowRight: dir.RIGHT,
	  ArrowLeft: dir.LEFT
	};
	
	var OPPOSITE_DIRECTION = (_OPPOSITE_DIRECTION = {}, _OPPOSITE_DIRECTION[dir.LEFT] = dir.RIGHT, _OPPOSITE_DIRECTION[dir.RIGHT] = dir.LEFT, _OPPOSITE_DIRECTION);
	
	var MULTIPLIER = (_MULTIPLIER = {}, _MULTIPLIER[views.YEAR] = 1, _MULTIPLIER[views.DECADE] = 10, _MULTIPLIER[views.CENTURY] = 100, _MULTIPLIER);
	
	var format = function format(props, f) {
	  return _localizers.date.getFormat(f, props[f + 'Format']);
	};
	
	var propTypes = {
	
	  disabled: _propTypes2.default.disabled,
	  readOnly: _propTypes2.default.readOnly,
	
	  onChange: _react2.default.PropTypes.func,
	  value: _react2.default.PropTypes.instanceOf(Date),
	
	  min: _react2.default.PropTypes.instanceOf(Date),
	  max: _react2.default.PropTypes.instanceOf(Date),
	
	  currentDate: _react2.default.PropTypes.instanceOf(Date),
	  onCurrentDateChange: _react2.default.PropTypes.func,
	
	  view: _react2.default.PropTypes.oneOf(VIEW_OPTIONS),
	  initialView: _react2.default.PropTypes.oneOf(VIEW_OPTIONS),
	
	  finalView: function finalView(props, propName, componentName) {
	    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      args[_key - 3] = arguments[_key];
	    }
	
	    var err = _react2.default.PropTypes.oneOf(VIEW_OPTIONS).apply(undefined, [props, propName, componentName].concat(args));
	
	    if (err) return err;
	    if (VIEW_OPTIONS.indexOf(props[propName]) < VIEW_OPTIONS.indexOf(props.initialView)) return new Error(('The `' + propName + '` prop: `' + props[propName] + '` cannot be \'lower\' than the `initialView`\n        prop. This creates a range that cannot be rendered.').replace(/\n\t/g, ''));
	  },
	
	
	  onViewChange: _react2.default.PropTypes.func,
	  onNavigate: _react2.default.PropTypes.func,
	  culture: _react2.default.PropTypes.string,
	  footer: _react2.default.PropTypes.bool,
	
	  dayComponent: _propTypes2.default.elementType,
	  headerFormat: _propTypes2.default.dateFormat,
	  footerFormat: _propTypes2.default.dateFormat,
	
	  dayFormat: _propTypes2.default.dateFormat,
	  dateFormat: _propTypes2.default.dateFormat,
	  monthFormat: _propTypes2.default.dateFormat,
	  yearFormat: _propTypes2.default.dateFormat,
	  decadeFormat: _propTypes2.default.dateFormat,
	  centuryFormat: _propTypes2.default.dateFormat,
	
	  messages: _react2.default.PropTypes.shape({
	    moveBack: _react2.default.PropTypes.string,
	    moveForward: _react2.default.PropTypes.string
	  })
	};
	
	var Calendar = _react2.default.createClass((_obj = {
	
	  displayName: 'Calendar',
	
	  mixins: [__webpack_require__(1799), __webpack_require__(1800), __webpack_require__(1801), __webpack_require__(1808), __webpack_require__(1792)(), __webpack_require__(1809)({
	    willHandle: function willHandle() {
	      if (+this.props.tabIndex === -1) return false;
	    }
	  })],
	
	  propTypes: propTypes,
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: 0,
	      view: this.props.initialView || 'month'
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	
	      value: null,
	      min: new Date(1900, 0, 1),
	      max: new Date(2099, 11, 31),
	      currentDate: new Date(),
	
	      initialView: 'month',
	      finalView: 'century',
	
	      tabIndex: '0',
	      footer: false,
	
	      ariaActiveDescendantKey: 'calendar',
	      messages: msgs({})
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.changeCurrentDate(this.props.value);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var bottom = VIEW_OPTIONS.indexOf(nextProps.initialView),
	        top = VIEW_OPTIONS.indexOf(nextProps.finalView),
	        current = VIEW_OPTIONS.indexOf(this.state.view),
	        view = this.state.view,
	        val = this.inRangeValue(nextProps.value);
	
	    if (current < bottom) this.setState({ view: view = nextProps.initialView });else if (current > top) this.setState({ view: view = nextProps.finalView });
	
	    //if the value changes reset views to the new one
	    if (!_dates2.default.eq(val, dateOrNull(this.props.value), VIEW_UNIT[view])) {
	      this.changeCurrentDate(val, nextProps.currentDate);
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var className = _props.className;
	    var value = _props.value;
	    var footerFormat = _props.footerFormat;
	    var disabled = _props.disabled;
	    var readOnly = _props.readOnly;
	    var finalView = _props.finalView;
	    var footer = _props.footer;
	    var messages = _props.messages;
	    var min = _props.min;
	    var max = _props.max;
	    var culture = _props.culture;
	    var duration = _props.duration;
	    var tabIndex = _props.tabIndex;
	    var currentDate = _props.currentDate;
	    var _state = this.state;
	    var view = _state.view;
	    var slideDirection = _state.slideDirection;
	    var focused = _state.focused;
	
	
	    var View = VIEW[view],
	        unit = VIEW_UNIT[view],
	        todaysDate = new Date(),
	        todayNotInRange = !_dates2.default.inRange(todaysDate, min, max, view);
	
	    unit = unit === 'day' ? 'date' : unit;
	
	    var viewID = (0, _widgetHelpers.instanceId)(this, '_calendar'),
	        labelID = (0, _widgetHelpers.instanceId)(this, '_calendar_label'),
	        key = view + '_' + _dates2.default[view](currentDate);
	
	    var elementProps = _3.default.omitOwnProps(this),
	        viewProps = _3.default.pickProps(this.props, View);
	
	    var isDisabled = disabled || readOnly;
	
	    messages = msgs(this.props.messages);
	
	    return _react2.default.createElement(
	      _Widget2.default,
	      _extends({}, elementProps, {
	        role: 'group',
	        focused: focused,
	        disabled: disabled,
	        readOnly: readOnly,
	        tabIndex: tabIndex || 0,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        className: (0, _classnames2.default)(className, 'rw-calendar')
	      }),
	      _react2.default.createElement(_Header2.default, {
	        label: this._label(),
	        labelId: labelID,
	        messages: messages,
	        upDisabled: isDisabled || view === finalView,
	        prevDisabled: isDisabled || !_dates2.default.inRange(this.nextDate(dir.LEFT), min, max, view),
	        nextDisabled: isDisabled || !_dates2.default.inRange(this.nextDate(dir.RIGHT), min, max, view),
	        onViewChange: this.navigate.bind(null, dir.UP, null),
	        onMoveLeft: this.navigate.bind(null, dir.LEFT, null),
	        onMoveRight: this.navigate.bind(null, dir.RIGHT, null)
	      }),
	      _react2.default.createElement(
	        _SlideTransition2.default,
	        {
	          ref: 'animation',
	          duration: duration,
	          direction: slideDirection,
	          onAnimate: function onAnimate() {
	            return focused && _this.focus();
	          }
	        },
	        _react2.default.createElement(View, _extends({}, viewProps, {
	          key: key,
	          id: viewID,
	          value: value,
	          today: todaysDate,
	          focused: currentDate,
	          onChange: this.change,
	          onKeyDown: this.handleKeyDown,
	          'aria-labelledby': labelID,
	          ariaActiveDescendantKey: 'calendarView'
	        }))
	      ),
	      footer && _react2.default.createElement(_Footer2.default, {
	        value: todaysDate,
	        format: footerFormat,
	        culture: culture,
	        disabled: disabled || todayNotInRange,
	        readOnly: readOnly,
	        onClick: this.select
	      })
	    );
	  },
	  navigate: function navigate(direction, date) {
	    var view = this.state.view,
	        slideDir = direction === dir.LEFT || direction === dir.UP ? 'right' : 'left';
	
	    if (!date) date = [dir.LEFT, dir.RIGHT].indexOf(direction) !== -1 ? this.nextDate(direction) : this.props.currentDate;
	
	    if (direction === dir.DOWN) view = ALT_VIEW[view] || view;
	
	    if (direction === dir.UP) view = NEXT_VIEW[view] || view;
	
	    if (this.isValidView(view) && _dates2.default.inRange(date, this.props.min, this.props.max, view)) {
	      (0, _widgetHelpers.notify)(this.props.onNavigate, [date, slideDir, view]);
	      this.focus(true);
	
	      this.changeCurrentDate(date);
	
	      this.setState({
	        slideDirection: slideDir,
	        view: view
	      });
	    }
	  },
	  focus: function focus() {
	    if (+this.props.tabIndex > -1) _compat2.default.findDOMNode(this).focus();
	  },
	  change: function change(date) {
	    if (this.state.view === this.props.initialView) {
	      this.changeCurrentDate(date);
	      (0, _widgetHelpers.notify)(this.props.onChange, date);
	      this.focus();
	      return;
	    }
	
	    this.navigate(dir.DOWN, date);
	  },
	  changeCurrentDate: function changeCurrentDate(date) {
	    var currentDate = arguments.length <= 1 || arguments[1] === undefined ? this.props.currentDate : arguments[1];
	
	    var inRangeDate = this.inRangeValue(date ? new Date(date) : currentDate);
	    if (_dates2.default.eq(inRangeDate, dateOrNull(currentDate), VIEW_UNIT[this.state.view])) return;
	    (0, _widgetHelpers.notify)(this.props.onCurrentDateChange, inRangeDate);
	  },
	  select: function select(date) {
	    var view = this.props.initialView,
	        slideDir = view !== this.state.view || _dates2.default.gt(date, this.state.currentDate) ? 'left' // move down to a the view
	    : 'right';
	
	    (0, _widgetHelpers.notify)(this.props.onChange, date);
	
	    if (this.isValidView(view) && _dates2.default.inRange(date, this.props.min, this.props.max, view)) {
	      this.focus();
	
	      this.changeCurrentDate(date);
	
	      this.setState({
	        slideDirection: slideDir,
	        view: view
	      });
	    }
	  },
	  nextDate: function nextDate(direction) {
	    var method = direction === dir.LEFT ? 'subtract' : 'add',
	        view = this.state.view,
	        unit = view === views.MONTH ? view : views.YEAR,
	        multi = MULTIPLIER[view] || 1;
	
	    return _dates2.default[method](this.props.currentDate, 1 * multi, unit);
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var ctrl = e.ctrlKey,
	        key = e.key,
	        direction = ARROWS_TO_DIRECTION[key],
	        current = this.props.currentDate,
	        view = this.state.view,
	        unit = VIEW_UNIT[view],
	        currentDate = current;
	
	    if (key === 'Enter') {
	      e.preventDefault();
	      return this.change(current);
	    }
	
	    if (direction) {
	      if (ctrl) {
	        e.preventDefault();
	        this.navigate(direction);
	      } else {
	        if (this.isRtl() && OPPOSITE_DIRECTION[direction]) direction = OPPOSITE_DIRECTION[direction];
	
	        currentDate = _dates2.default.move(currentDate, this.props.min, this.props.max, view, direction);
	
	        if (!_dates2.default.eq(current, currentDate, unit)) {
	          e.preventDefault();
	
	          if (_dates2.default.gt(currentDate, current, view)) this.navigate(dir.RIGHT, currentDate);else if (_dates2.default.lt(currentDate, current, view)) this.navigate(dir.LEFT, currentDate);else this.changeCurrentDate(currentDate);
	        }
	      }
	    }
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	  },
	  _label: function _label() {
	    var _props2 = this.props;
	    var culture = _props2.culture;
	    var props = _objectWithoutProperties(_props2, ['culture']);
	    var view = this.state.view;
	    var dt = this.props.currentDate;
	
	    if (view === 'month') return _localizers.date.format(dt, format(props, 'header'), culture);else if (view === 'year') return _localizers.date.format(dt, format(props, 'year'), culture);else if (view === 'decade') return _localizers.date.format(_dates2.default.startOf(dt, 'decade'), format(props, 'decade'), culture);else if (view === 'century') return _localizers.date.format(_dates2.default.startOf(dt, 'century'), format(props, 'century'), culture);
	  },
	  inRangeValue: function inRangeValue(_value) {
	    var value = dateOrNull(_value);
	
	    if (value === null) return value;
	
	    return _dates2.default.max(_dates2.default.min(value, this.props.max), this.props.min);
	  },
	  isValidView: function isValidView(next) {
	    var bottom = VIEW_OPTIONS.indexOf(this.props.initialView),
	        top = VIEW_OPTIONS.indexOf(this.props.finalView),
	        current = VIEW_OPTIONS.indexOf(next);
	
	    return current >= bottom && current <= top;
	  }
	}, (_applyDecoratedDescriptor(_obj, 'navigate', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'navigate'), _obj), _applyDecoratedDescriptor(_obj, 'change', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'change'), _obj), _applyDecoratedDescriptor(_obj, 'select', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'select'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyDown'), _obj)), _obj));
	
	function dateOrNull(dt) {
	  if (dt && !isNaN(dt.getTime())) return dt;
	  return null;
	}
	
	function msgs(msgs) {
	  return _extends({
	    moveBack: 'navigate back',
	    moveForward: 'navigate forward'
	  }, msgs);
	}
	
	exports.default = (0, _uncontrollable2.default)(Calendar, {
	  value: 'onChange',
	  currentDate: 'onCurrentDateChange',
	  view: 'onViewChange'
	}, ['focus']);
	module.exports = exports['default'];

/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1777);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'Header',
	  propTypes: {
	    label: _react2.default.PropTypes.string.isRequired,
	    labelId: _react2.default.PropTypes.string,
	
	    upDisabled: _react2.default.PropTypes.bool.isRequired,
	    prevDisabled: _react2.default.PropTypes.bool.isRequired,
	    nextDisabled: _react2.default.PropTypes.bool.isRequired,
	    onViewChange: _react2.default.PropTypes.func.isRequired,
	    onMoveLeft: _react2.default.PropTypes.func.isRequired,
	    onMoveRight: _react2.default.PropTypes.func.isRequired,
	
	    messages: _react2.default.PropTypes.shape({
	      moveBack: _react2.default.PropTypes.string,
	      moveForward: _react2.default.PropTypes.string
	    })
	  },
	
	  mixins: [__webpack_require__(1801), __webpack_require__(1815)],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      messages: {
	        moveBack: 'navigate back',
	        moveForward: 'navigate forward'
	      }
	    };
	  },
	  render: function render() {
	    var _props = this.props;
	    var messages = _props.messages;
	    var label = _props.label;
	    var labelId = _props.labelId;
	    var onMoveRight = _props.onMoveRight;
	    var onMoveLeft = _props.onMoveLeft;
	    var onViewChange = _props.onViewChange;
	    var prevDisabled = _props.prevDisabled;
	    var upDisabled = _props.upDisabled;
	    var nextDisabled = _props.nextDisabled;
	
	
	    var rtl = this.isRtl();
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'rw-header' },
	      _react2.default.createElement(_Button2.default, {
	        className: 'rw-btn-left',
	        onClick: onMoveLeft,
	        disabled: prevDisabled,
	        label: messages.moveBack,
	        icon: 'caret-' + (rtl ? 'right' : 'left')
	      }),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          id: labelId,
	          onClick: onViewChange,
	          className: 'rw-btn-view',
	          disabled: upDisabled,
	          'aria-live': 'polite',
	          'aria-atomic': 'true'
	        },
	        label
	      ),
	      _react2.default.createElement(_Button2.default, {
	        className: 'rw-btn-right',
	        onClick: onMoveRight,
	        disabled: nextDisabled,
	        label: messages.moveForward,
	        icon: 'caret-' + (rtl ? 'left' : 'right')
	      })
	    );
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 1815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  contextTypes: {
	    isRtl: _react2.default.PropTypes.bool
	  },
	
	  isRtl: function isRtl() {
	    return !!this.context.isRtl;
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 1816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1777);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _localizers = __webpack_require__(1768);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = function format(props) {
	  return _localizers.date.getFormat('footer', props.format);
	};
	
	module.exports = _react2.default.createClass({
	
	  displayName: 'Footer',
	
	  render: function render() {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var readOnly = _props.readOnly;
	    var value = _props.value;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'rw-footer' },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          disabled: !!(disabled || readOnly),
	          onClick: this.props.onClick.bind(null, value)
	        },
	        _localizers.date.format(value, format(this.props), this.props.culture)
	      )
	    );
	  }
	});

/***/ },
/* 1817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CalendarView = __webpack_require__(1818);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _dates = __webpack_require__(1819);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizers = __webpack_require__(1768);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _widgetHelpers = __webpack_require__(1789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayFormat = function dayFormat(props) {
	  return _localizers.date.getFormat('weekday', props.dayFormat);
	},
	    dateFormat = function dateFormat(props) {
	  return _localizers.date.getFormat('dayOfMonth', props.dateFormat);
	};
	
	var optionId = function optionId(id, date) {
	  return id + '__month_' + _dates2.default.month(date) + '-' + _dates2.default.date(date);
	};
	
	var propTypes = {
	  culture: _react2.default.PropTypes.string,
	  today: _react2.default.PropTypes.instanceOf(Date),
	  value: _react2.default.PropTypes.instanceOf(Date),
	  focused: _react2.default.PropTypes.instanceOf(Date),
	  min: _react2.default.PropTypes.instanceOf(Date),
	  max: _react2.default.PropTypes.instanceOf(Date),
	  onChange: _react2.default.PropTypes.func.isRequired,
	
	  dayComponent: _propTypes2.default.elementType,
	  dayFormat: _propTypes2.default.dateFormat,
	  dateFormat: _propTypes2.default.dateFormat
	};
	
	var isEqual = function isEqual(dateA, dateB) {
	  return _dates2.default.eq(dateA, dateB, 'day');
	};
	
	var MonthView = _react2.default.createClass({
	
	  displayName: 'MonthView',
	
	  statics: {
	    isEqual: isEqual
	  },
	
	  mixins: [__webpack_require__(1815), __webpack_require__(1792)()],
	
	  propTypes: propTypes,
	
	  componentDidUpdate: function componentDidUpdate() {
	    var activeId = optionId((0, _widgetHelpers.instanceId)(this), this.props.focused);
	    this.ariaActiveDescendant(activeId, null);
	  },
	  render: function render() {
	    var _props = this.props;
	    var focused = _props.focused;
	    var culture = _props.culture;
	    var month = _dates2.default.visibleDays(focused, culture);
	    var rows = _3.default.chunk(month, 7);
	
	    return _react2.default.createElement(
	      _CalendarView2.default,
	      _3.default.omitOwnProps(this),
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          this.renderHeaders(rows[0], dayFormat(this.props), culture)
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        rows.map(this.renderRow)
	      )
	    );
	  },
	  renderRow: function renderRow(row, rowIdx) {
	    var _this = this;
	
	    var _props2 = this.props;
	    var focused = _props2.focused;
	    var today = _props2.today;
	    var disabled = _props2.disabled;
	    var onChange = _props2.onChange;
	    var value = _props2.value;
	    var culture = _props2.culture;
	    var min = _props2.min;
	    var max = _props2.max;
	    var Day = _props2.dayComponent;
	    var id = (0, _widgetHelpers.instanceId)(this);
	    var labelFormat = _localizers.date.getFormat('footer');
	
	    return _react2.default.createElement(
	      _CalendarView2.default.Row,
	      { key: rowIdx },
	      row.map(function (date, colIdx) {
	        var formattedDate = _localizers.date.format(date, dateFormat(_this.props), culture),
	            label = _localizers.date.format(date, labelFormat, culture);
	
	        return _react2.default.createElement(
	          _CalendarView2.default.Cell,
	          {
	            key: colIdx,
	            id: optionId(id, date),
	            label: label,
	            date: date,
	            now: today,
	            min: min,
	            max: max,
	            unit: 'day',
	            viewUnit: 'month',
	            onChange: onChange,
	            focused: focused,
	            selected: value,
	            disabled: disabled
	          },
	          Day ? _react2.default.createElement(Day, { date: date, label: formattedDate }) : formattedDate
	        );
	      })
	    );
	  },
	  renderHeaders: function renderHeaders(week, format, culture) {
	    return week.map(function (date) {
	      return _react2.default.createElement(
	        'th',
	        { key: 'header_' + _dates2.default.weekday(date, undefined, _localizers.date.startOfWeek(culture)) },
	        _localizers.date.format(date, format, culture)
	      );
	    });
	  }
	});
	
	exports.default = MonthView;
	module.exports = exports['default'];

/***/ },
/* 1818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dates = __webpack_require__(1819);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VIEW_UNITS = ['month', 'year', 'decade', 'century'];
	
	function clamp(date, min, max) {
	  return _dates2.default.max(_dates2.default.min(date, max), min);
	}
	
	var CalendarView = function (_React$Component) {
	  _inherits(CalendarView, _React$Component);
	
	  function CalendarView() {
	    _classCallCheck(this, CalendarView);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CalendarView.prototype.render = function render() {
	    var className = this.props.className;
	
	
	    return _react2.default.createElement('table', _extends({}, this.props, {
	      role: 'grid',
	      tabIndex: '-1',
	      className: (0, _classnames2.default)(className, 'rw-nav-view', 'rw-calendar-grid')
	    }));
	  };
	
	  return CalendarView;
	}(_react2.default.Component);
	
	var CalendarViewCell = (_temp2 = _class = function (_React$Component2) {
	  _inherits(CalendarViewCell, _React$Component2);
	
	  function CalendarViewCell() {
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, CalendarViewCell);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this2), _this2.handleChange = function () {
	      var _this2$props = _this2.props;
	      var onChange = _this2$props.onChange;
	      var min = _this2$props.min;
	      var max = _this2$props.max;
	      var date = _this2$props.date;
	
	      onChange(clamp(date, min, max));
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  CalendarViewCell.prototype.isEqual = function isEqual(date) {
	    return _dates2.default.eq(this.props.date, date, this.props.unit);
	  };
	
	  CalendarViewCell.prototype.isEmpty = function isEmpty() {
	    var _props = this.props;
	    var unit = _props.unit;
	    var min = _props.min;
	    var max = _props.max;
	    var date = _props.date;
	
	    return !_dates2.default.inRange(date, min, max, unit);
	  };
	
	  CalendarViewCell.prototype.isNow = function isNow() {
	    return this.isEqual(this.props.now);
	  };
	
	  CalendarViewCell.prototype.isFocused = function isFocused() {
	    return this.isEqual(this.props.focused);
	  };
	
	  CalendarViewCell.prototype.isSelected = function isSelected() {
	    return this.isEqual(this.props.selected);
	  };
	
	  CalendarViewCell.prototype.isOffView = function isOffView() {
	    var _props2 = this.props;
	    var viewUnit = _props2.viewUnit;
	    var focused = _props2.focused;
	    var date = _props2.date;
	
	    return viewUnit && _dates2.default[viewUnit](date) !== _dates2.default[viewUnit](focused);
	  };
	
	  CalendarViewCell.prototype.render = function render() {
	    var _props3 = this.props;
	    var children = _props3.children;
	    var id = _props3.id;
	    var label = _props3.label;
	    var disabled = _props3.disabled;
	
	
	    if (this.isEmpty()) {
	      return _react2.default.createElement(
	        'td',
	        { className: 'rw-empty-cell', role: 'presentation' },
	        ' '
	      );
	    }
	
	    return _react2.default.createElement(
	      'td',
	      {
	        role: 'gridcell',
	        id: id,
	        title: label,
	        'aria-label': label,
	        'aria-readonly': disabled,
	        'aria-selected': this.isSelected()
	      },
	      _react2.default.createElement(
	        'span',
	        {
	          'aria-labelledby': id,
	          onClick: this.handleChange,
	          className: (0, _classnames2.default)('rw-btn', this.isNow() && 'rw-now', this.isOffView() && 'rw-off-range', this.isFocused() && 'rw-state-focus', this.isSelected() && 'rw-state-selected')
	        },
	        children
	      )
	    );
	  };
	
	  return CalendarViewCell;
	}(_react2.default.Component), _class.propTypes = {
	  id: _react2.default.PropTypes.string,
	  label: _react2.default.PropTypes.string,
	  today: _react2.default.PropTypes.instanceOf(Date),
	  selected: _react2.default.PropTypes.instanceOf(Date),
	  focused: _react2.default.PropTypes.instanceOf(Date),
	  min: _react2.default.PropTypes.instanceOf(Date),
	  max: _react2.default.PropTypes.instanceOf(Date),
	  unit: _react2.default.PropTypes.oneOf(['day'].concat(VIEW_UNITS)),
	  viewUnit: _react2.default.PropTypes.oneOf(VIEW_UNITS),
	  onChange: _react2.default.PropTypes.func.isRequired
	}, _temp2);
	
	
	CalendarView.Row = function (props) {
	  return _react2.default.createElement('tr', _extends({ role: 'row' }, props));
	};
	CalendarView.Cell = CalendarViewCell;
	
	exports.default = CalendarView;
	module.exports = exports['default'];

/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _dateArithmetic = __webpack_require__(1820);
	
	var _dateArithmetic2 = _interopRequireDefault(_dateArithmetic);
	
	var _constants = __webpack_require__(1821);
	
	var _localizers = __webpack_require__(1768);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dates = _extends(_dateArithmetic2.default, {
	  parse: function parse(date, format, culture) {
	    return _localizers.date.parse(date, format, culture);
	  },
	  format: function format(date, _format, culture) {
	    return _localizers.date.format(date, _format, culture);
	  },
	  monthsInYear: function monthsInYear(year) {
	    var months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
	        date = new Date(year, 0, 1);
	
	    return months.map(function (i) {
	      return dates.month(date, i);
	    });
	  },
	  firstVisibleDay: function firstVisibleDay(date, culture) {
	    var firstOfMonth = dates.startOf(date, 'month');
	    return dates.startOf(firstOfMonth, 'week', _localizers.date.startOfWeek(culture));
	  },
	  lastVisibleDay: function lastVisibleDay(date, culture) {
	    var endOfMonth = dates.endOf(date, 'month');
	
	    return dates.endOf(endOfMonth, 'week', _localizers.date.startOfWeek(culture));
	  },
	  visibleDays: function visibleDays(date, culture) {
	    var current = dates.firstVisibleDay(date, culture),
	        last = dates.lastVisibleDay(date, culture),
	        days = [];
	
	    while (dates.lte(current, last, 'day')) {
	      days.push(current);
	      current = dates.add(current, 1, 'day');
	    }
	
	    return days;
	  },
	  move: function move(date, min, max, unit, direction) {
	    var isMonth = unit === 'month',
	        isUpOrDown = direction === _constants.directions.UP || direction === _constants.directions.DOWN,
	        rangeUnit = _constants.calendarViewUnits[unit],
	        addUnit = isMonth && isUpOrDown ? 'week' : _constants.calendarViewUnits[unit],
	        amount = isMonth || !isUpOrDown ? 1 : 4,
	        newDate;
	
	    if (direction === _constants.directions.UP || direction === _constants.directions.LEFT) amount *= -1;
	
	    newDate = dates.add(date, amount, addUnit);
	
	    return dates.inRange(newDate, min, max, rangeUnit) ? newDate : date;
	  },
	  merge: function merge(date, time, defaultDate) {
	    if (time == null && date == null) return null;
	
	    if (time == null) time = defaultDate || new Date();
	    if (date == null) date = defaultDate || new Date();
	
	    date = dates.startOf(date, 'day');
	    date = dates.hours(date, dates.hours(time));
	    date = dates.minutes(date, dates.minutes(time));
	    date = dates.seconds(date, dates.seconds(time));
	    return dates.milliseconds(date, dates.milliseconds(time));
	  },
	  sameMonth: function sameMonth(dateA, dateB) {
	    return dates.eq(dateA, dateB, 'month');
	  },
	  today: function today() {
	    return this.startOf(new Date(), 'day');
	  },
	  yesterday: function yesterday() {
	    return this.add(this.startOf(new Date(), 'day'), -1, 'day');
	  },
	  tomorrow: function tomorrow() {
	    return this.add(this.startOf(new Date(), 'day'), 1, 'day');
	  }
	});
	
	exports.default = dates;
	module.exports = exports['default'];

/***/ },
/* 1820 */
/***/ function(module, exports) {

	var MILI    = 'milliseconds'
	  , SECONDS = 'seconds'
	  , MINUTES = 'minutes'
	  , HOURS   = 'hours'
	  , DAY     = 'day'
	  , WEEK    = 'week'
	  , MONTH   = 'month'
	  , YEAR    = 'year'
	  , DECADE  = 'decade'
	  , CENTURY = 'century';
	
	var dates = module.exports = {
	
	  add: function(date, num, unit) {
	    date = new Date(date)
	
	    switch (unit){
	      case MILI:
	      case SECONDS:
	      case MINUTES:
	      case HOURS:
	      case YEAR:
	        return dates[unit](date, dates[unit](date) + num)
	      case DAY:
	        return dates.date(date, dates.date(date) + num)
	      case WEEK:
	        return dates.date(date, dates.date(date) + (7 * num)) 
	      case MONTH:
	        return monthMath(date, num)
	      case DECADE:
	        return dates.year(date, dates.year(date) + (num * 10))
	      case CENTURY:
	        return dates.year(date, dates.year(date) + (num * 100))
	    }
	
	    throw new TypeError('Invalid units: "' + unit + '"')
	  },
	
	  subtract: function(date, num, unit) {
	    return dates.add(date, -num, unit)
	  },
	
	  startOf: function(date, unit, firstOfWeek) {
	    date = new Date(date)
	
	    switch (unit) {
	      case 'century':
	      case 'decade':
	      case 'year':
	          date = dates.month(date, 0);
	      case 'month':
	          date = dates.date(date, 1);
	      case 'week':
	      case 'day':
	          date = dates.hours(date, 0);
	      case 'hours':
	          date = dates.minutes(date, 0);
	      case 'minutes':
	          date = dates.seconds(date, 0);
	      case 'seconds':
	          date = dates.milliseconds(date, 0);
	    }
	
	    if (unit === DECADE) 
	      date = dates.subtract(date, dates.year(date) % 10, 'year')
	    
	    if (unit === CENTURY) 
	      date = dates.subtract(date, dates.year(date) % 100, 'year')
	
	    if (unit === WEEK) 
	      date = dates.weekday(date, 0, firstOfWeek);
	
	    return date
	  },
	
	
	  endOf: function(date, unit, firstOfWeek){
	    date = new Date(date)
	    date = dates.startOf(date, unit, firstOfWeek)
	    date = dates.add(date, 1, unit)
	    date = dates.subtract(date, 1, MILI)
	    return date
	  },
	
	  eq:  createComparer(function(a, b){ return a === b }),
	  neq: createComparer(function(a, b){ return a !== b }),
	  gt:  createComparer(function(a, b){ return a > b }),
	  gte: createComparer(function(a, b){ return a >= b }),
	  lt:  createComparer(function(a, b){ return a < b }),
	  lte: createComparer(function(a, b){ return a <= b }),
	
	  min: function(){
	    return new Date(Math.min.apply(Math, arguments))
	  },
	
	  max: function(){
	    return new Date(Math.max.apply(Math, arguments))
	  },
	  
	  inRange: function(day, min, max, unit){
	    unit = unit || 'day'
	
	    return (!min || dates.gte(day, min, unit))
	        && (!max || dates.lte(day, max, unit))
	  },
	
	  milliseconds:   createAccessor('Milliseconds'),
	  seconds:        createAccessor('Seconds'),
	  minutes:        createAccessor('Minutes'),
	  hours:          createAccessor('Hours'),
	  day:            createAccessor('Day'),
	  date:           createAccessor('Date'),
	  month:          createAccessor('Month'),
	  year:           createAccessor('FullYear'),
	
	  decade: function (date, val) {
	    return val === undefined 
	      ? dates.year(dates.startOf(date, DECADE))
	      : dates.add(date, val + 10, YEAR);
	  },
	
	  century: function (date, val) {
	    return val === undefined 
	      ? dates.year(dates.startOf(date, CENTURY))
	      : dates.add(date, val + 100, YEAR);
	  },
	
	  weekday: function (date, val, firstDay) {
	      var weekday = (dates.day(date) + 7 - (firstDay || 0) ) % 7;
	
	      return val === undefined 
	        ? weekday 
	        : dates.add(date, val - weekday, DAY);
	  },
	
	  diff: function (date1, date2, unit, asFloat) {
	    var dividend, divisor, result;
	
	    switch (unit) {
	      case MILI:
	      case SECONDS:
	      case MINUTES:
	      case HOURS:
	      case DAY:
	      case WEEK:
	        dividend = date2.getTime() - date1.getTime(); break;
	      case MONTH:
	      case YEAR:
	      case DECADE:
	      case CENTURY:
	        dividend = (dates.year(date2) - dates.year(date1)) * 12 + dates.month(date2) - dates.month(date1); break;
	      default:
	        throw new TypeError('Invalid units: "' + unit + '"');
	    }
	
	    switch (unit) {
	      case MILI:
	          divisor = 1; break;
	      case SECONDS:
	          divisor = 1000; break;
	      case MINUTES:
	          divisor = 1000 * 60; break;
	      case HOURS:
	          divisor = 1000 * 60 * 60; break;
	      case DAY:
	          divisor = 1000 * 60 * 60 * 24; break;
	      case WEEK:
	          divisor = 1000 * 60 * 60 * 24 * 7; break;
	      case MONTH:
	          divisor = 1; break;
	      case YEAR:
	          divisor = 12; break;
	      case DECADE:
	          divisor = 120; break;
	      case CENTURY:
	          divisor = 1200; break;
	      default:
	        throw new TypeError('Invalid units: "' + unit + '"');
	    }
	
	    result = dividend / divisor;
	
	    return asFloat ? result : absoluteFloor(result);
	  }
	};
	
	function absoluteFloor(number) {
	  return number < 0 ? Math.ceil(number) : Math.floor(number);
	}
	
	function monthMath(date, val){
	  var current = dates.month(date)
	    , newMonth  = (current + val);
	
	    date = dates.month(date, newMonth)
	
	    while (newMonth < 0 ) newMonth = 12 + newMonth
	      
	    //month rollover
	    if ( dates.month(date) !== ( newMonth % 12))
	      date = dates.date(date, 0) //move to last of month
	
	    return date
	}
	
	function createAccessor(method){
	  return function(date, val){
	    if (val === undefined)
	      return date['get' + method]()
	
	    date = new Date(date)
	    date['set' + method](val)
	    return date
	  }
	}
	
	function createComparer(operator) {
	  return function (a, b, unit) {
	    return operator(+dates.startOf(a, unit), +dates.startOf(b, unit))
	  };
	}


/***/ },
/* 1821 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _calendarViewHierarch, _calendarViewUnits;
	
	var views = {
	  MONTH: 'month',
	  YEAR: 'year',
	  DECADE: 'decade',
	  CENTURY: 'century'
	};
	
	var directions = exports.directions = {
	  LEFT: 'LEFT',
	  RIGHT: 'RIGHT',
	  UP: 'UP',
	  DOWN: 'DOWN'
	};
	
	var datePopups = exports.datePopups = {
	  TIME: 'time',
	  CALENDAR: 'calendar'
	};
	
	var calendarViews = exports.calendarViews = views;
	
	var calendarViewHierarchy = exports.calendarViewHierarchy = (_calendarViewHierarch = {}, _calendarViewHierarch[views.MONTH] = views.YEAR, _calendarViewHierarch[views.YEAR] = views.DECADE, _calendarViewHierarch[views.DECADE] = views.CENTURY, _calendarViewHierarch);
	
	var calendarViewUnits = exports.calendarViewUnits = (_calendarViewUnits = {}, _calendarViewUnits[views.MONTH] = 'day', _calendarViewUnits[views.YEAR] = views.MONTH, _calendarViewUnits[views.DECADE] = views.YEAR, _calendarViewUnits[views.CENTURY] = views.DECADE, _calendarViewUnits);

/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CalendarView = __webpack_require__(1818);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _dates = __webpack_require__(1819);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizers = __webpack_require__(1768);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _widgetHelpers = __webpack_require__(1789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = function format(props) {
	  return _localizers.date.getFormat('month', props.monthFormat);
	};
	
	var propTypes = {
	  culture: _react2.default.PropTypes.string,
	  today: _react2.default.PropTypes.instanceOf(Date),
	  value: _react2.default.PropTypes.instanceOf(Date),
	  focused: _react2.default.PropTypes.instanceOf(Date),
	  min: _react2.default.PropTypes.instanceOf(Date),
	  max: _react2.default.PropTypes.instanceOf(Date),
	  onChange: _react2.default.PropTypes.func.isRequired,
	
	  monthFormat: _propTypes2.default.dateFormat
	};
	
	var optionId = function optionId(id, date) {
	  return id + '__year_' + _dates2.default.year(date) + '-' + _dates2.default.month(date);
	};
	
	var YearView = _react2.default.createClass({
	
	  displayName: 'YearView',
	
	  mixins: [__webpack_require__(1815), __webpack_require__(1792)()],
	
	  propTypes: propTypes,
	
	  componentDidUpdate: function componentDidUpdate() {
	    var activeId = optionId((0, _widgetHelpers.instanceId)(this), this.props.focused);
	    this.ariaActiveDescendant(activeId);
	  },
	  render: function render() {
	    var focused = this.props.focused;
	    var months = _dates2.default.monthsInYear(_dates2.default.year(focused));
	
	    return _react2.default.createElement(
	      _CalendarView2.default,
	      _3.default.omitOwnProps(this),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _3.default.chunk(months, 4).map(this.renderRow)
	      )
	    );
	  },
	  renderRow: function renderRow(row, rowIdx) {
	    var _this = this;
	
	    var _props = this.props;
	    var focused = _props.focused;
	    var disabled = _props.disabled;
	    var onChange = _props.onChange;
	    var value = _props.value;
	    var today = _props.today;
	    var culture = _props.culture;
	    var min = _props.min;
	    var max = _props.max;
	
	
	    var id = (0, _widgetHelpers.instanceId)(this),
	        labelFormat = _localizers.date.getFormat('header');
	
	    return _react2.default.createElement(
	      _CalendarView2.default.Row,
	      { key: rowIdx },
	      row.map(function (date, colIdx) {
	        var label = _localizers.date.format(date, labelFormat, culture);
	
	        return _react2.default.createElement(
	          _CalendarView2.default.Cell,
	          {
	            key: colIdx,
	            id: optionId(id, date),
	            label: label,
	            date: date,
	            now: today,
	            min: min,
	            max: max,
	            unit: 'month',
	            onChange: onChange,
	            focused: focused,
	            selected: value,
	            disabled: disabled
	          },
	          _localizers.date.format(date, format(_this.props), culture)
	        );
	      })
	    );
	  }
	});
	
	exports.default = YearView;
	module.exports = exports['default'];

/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CalendarView = __webpack_require__(1818);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _dates = __webpack_require__(1819);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizers = __webpack_require__(1768);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _widgetHelpers = __webpack_require__(1789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  culture: _react2.default.PropTypes.string,
	  today: _react2.default.PropTypes.instanceOf(Date),
	  value: _react2.default.PropTypes.instanceOf(Date),
	  focused: _react2.default.PropTypes.instanceOf(Date),
	  min: _react2.default.PropTypes.instanceOf(Date),
	  max: _react2.default.PropTypes.instanceOf(Date),
	  onChange: _react2.default.PropTypes.func.isRequired,
	
	  yearFormat: _propTypes2.default.dateFormat
	};
	
	var optionId = function optionId(id, date) {
	  return id + '__decade_' + _dates2.default.year(date);
	};
	
	exports.default = _react2.default.createClass({
	
	  displayName: 'DecadeView',
	
	  mixins: [__webpack_require__(1801), __webpack_require__(1815), __webpack_require__(1792)()],
	
	  propTypes: propTypes,
	
	  componentDidUpdate: function componentDidUpdate() {
	    var activeId = optionId((0, _widgetHelpers.instanceId)(this), this.props.focused);
	    this.ariaActiveDescendant(activeId);
	  },
	  render: function render() {
	    var focused = this.props.focused;
	
	
	    return _react2.default.createElement(
	      _CalendarView2.default,
	      _3.default.omitOwnProps(this),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _3.default.chunk(getDecadeYears(focused), 4).map(this.renderRow)
	      )
	    );
	  },
	  renderRow: function renderRow(row, rowIdx) {
	    var _props = this.props;
	    var focused = _props.focused;
	    var disabled = _props.disabled;
	    var onChange = _props.onChange;
	    var yearFormat = _props.yearFormat;
	    var value = _props.value;
	    var today = _props.today;
	    var culture = _props.culture;
	    var min = _props.min;
	    var max = _props.max;
	
	
	    var id = (0, _widgetHelpers.instanceId)(this);
	
	    return _react2.default.createElement(
	      _CalendarView2.default.Row,
	      { key: rowIdx },
	      row.map(function (date, colIdx) {
	        var label = _localizers.date.format(date, _localizers.date.getFormat('year', yearFormat), culture);
	
	        return _react2.default.createElement(
	          _CalendarView2.default.Cell,
	          {
	            key: colIdx,
	            unit: 'year',
	            id: optionId(id, date),
	            label: label,
	            date: date,
	            now: today,
	            min: min,
	            max: max,
	            onChange: onChange,
	            focused: focused,
	            selected: value,
	            disabled: disabled
	          },
	          label
	        );
	      })
	    );
	  }
	});
	
	
	function getDecadeYears(_date) {
	  var days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
	      date = _dates2.default.add(_dates2.default.startOf(_date, 'decade'), -2, 'year');
	
	  return days.map(function () {
	    return date = _dates2.default.add(date, 1, 'year');
	  });
	}
	module.exports = exports['default'];

/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CalendarView = __webpack_require__(1818);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _dates = __webpack_require__(1819);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizers = __webpack_require__(1768);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _widgetHelpers = __webpack_require__(1789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = function format(props) {
	  return _localizers.date.getFormat('decade', props.decadeFormat);
	};
	
	var optionId = function optionId(id, date) {
	  return id + '__century_' + _dates2.default.year(date);
	};
	
	var propTypes = {
	  culture: _react2.default.PropTypes.string,
	  today: _react2.default.PropTypes.instanceOf(Date),
	  value: _react2.default.PropTypes.instanceOf(Date),
	  focused: _react2.default.PropTypes.instanceOf(Date),
	  min: _react2.default.PropTypes.instanceOf(Date),
	  max: _react2.default.PropTypes.instanceOf(Date),
	  onChange: _react2.default.PropTypes.func.isRequired,
	  decadeFormat: _propTypes2.default.dateFormat
	};
	
	exports.default = _react2.default.createClass({
	
	  displayName: 'CenturyView',
	
	  mixins: [__webpack_require__(1801), __webpack_require__(1815), __webpack_require__(1792)()],
	
	  propTypes: propTypes,
	
	  componentDidUpdate: function componentDidUpdate() {
	    var activeId = optionId((0, _widgetHelpers.instanceId)(this), this.props.focused);
	    this.ariaActiveDescendant(activeId);
	  },
	  render: function render() {
	    var focused = this.props.focused;
	
	
	    return _react2.default.createElement(
	      _CalendarView2.default,
	      _3.default.omitOwnProps(this),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _3.default.chunk(getCenturyDecades(focused), 4).map(this.renderRow)
	      )
	    );
	  },
	  renderRow: function renderRow(row, rowIdx) {
	    var _this = this;
	
	    var _props = this.props;
	    var focused = _props.focused;
	    var disabled = _props.disabled;
	    var onChange = _props.onChange;
	    var value = _props.value;
	    var today = _props.today;
	    var culture = _props.culture;
	    var min = _props.min;
	    var max = _props.max;
	
	
	    var id = (0, _widgetHelpers.instanceId)(this, '_century');
	
	    return _react2.default.createElement(
	      _CalendarView2.default.Row,
	      { key: rowIdx },
	      row.map(function (date, colIdx) {
	        var label = _localizers.date.format(_dates2.default.startOf(date, 'decade'), format(_this.props), culture);
	
	        return _react2.default.createElement(
	          _CalendarView2.default.Cell,
	          {
	            key: colIdx,
	            unit: 'decade',
	            id: optionId(id, date),
	            label: label,
	            date: date,
	            now: today,
	            min: min,
	            max: max,
	            onChange: onChange,
	            focused: focused,
	            selected: value,
	            disabled: disabled
	          },
	          label
	        );
	      })
	    );
	  }
	});
	
	
	function getCenturyDecades(_date) {
	  var days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
	      date = _dates2.default.add(_dates2.default.startOf(_date, 'century'), -20, 'year');
	
	  return days.map(function () {
	    return date = _dates2.default.add(date, 10, 'year');
	  });
	}
	module.exports = exports['default'];

/***/ },
/* 1825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReplaceTransitionGroup = __webpack_require__(1826);
	
	var _ReplaceTransitionGroup2 = _interopRequireDefault(_ReplaceTransitionGroup);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _style = __webpack_require__(1757);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _width = __webpack_require__(1827);
	
	var _width2 = _interopRequireDefault(_width);
	
	var _configuration = __webpack_require__(1754);
	
	var _configuration2 = _interopRequireDefault(_configuration);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideChildGroup = _react2.default.createClass({
	  displayName: 'SlideChildGroup',
	
	
	  propTypes: {
	    direction: _react2.default.PropTypes.oneOf(['left', 'right']),
	    duration: _react2.default.PropTypes.number
	  },
	
	  componentWillEnter: function componentWillEnter(done) {
	    var _this = this;
	
	    var node = _compat2.default.findDOMNode(this),
	        width = (0, _width2.default)(node),
	        direction = this.props.direction;
	
	    width = direction === 'left' ? width : -width;
	
	    this.ORGINAL_POSITION = node.style.position;
	
	    (0, _style2.default)(node, { position: 'absolute', left: width + 'px', top: 0 });
	
	    _configuration2.default.animate(node, { left: 0 }, this.props.duration, function () {
	
	      (0, _style2.default)(node, {
	        position: _this.ORGINAL_POSITION,
	        overflow: 'hidden'
	      });
	
	      _this.ORGINAL_POSITION = null;
	      done && done();
	    });
	  },
	  componentWillLeave: function componentWillLeave(done) {
	    var _this2 = this;
	
	    var node = _compat2.default.findDOMNode(this),
	        width = (0, _width2.default)(node),
	        direction = this.props.direction;
	
	    width = direction === 'left' ? -width : width;
	
	    this.ORGINAL_POSITION = node.style.position;
	
	    (0, _style2.default)(node, { position: 'absolute', top: 0, left: 0 });
	
	    _configuration2.default.animate(node, { left: width + 'px' }, this.props.duration, function () {
	      (0, _style2.default)(node, {
	        position: _this2.ORGINAL_POSITION,
	        overflow: 'hidden'
	      });
	
	      _this2.ORGINAL_POSITION = null;
	      done && done();
	    });
	  },
	  render: function render() {
	    return _react2.default.Children.only(this.props.children);
	  }
	});
	
	module.exports = _react2.default.createClass({
	  displayName: 'exports',
	
	
	  propTypes: {
	    direction: _react2.default.PropTypes.oneOf(['left', 'right']),
	    duration: _react2.default.PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      direction: 'left',
	      duration: 250
	    };
	  },
	  _wrapChild: function _wrapChild(child, ref) {
	    return _react2.default.createElement(
	      SlideChildGroup,
	      { key: child.key, ref: ref,
	        direction: this.props.direction,
	        duration: this.props.duration },
	      child
	    );
	  },
	  render: function render() {
	    var _props = this.props;
	    var style = _props.style;
	    var children = _props.children;
	
	
	    style = _extends({}, style, {
	      position: 'relative',
	      overflow: 'hidden'
	    });
	
	    return _react2.default.createElement(
	      _ReplaceTransitionGroup2.default,
	      _extends({}, _3.default.omitOwnProps(this), {
	        ref: 'container',
	        component: 'div',
	        childFactory: this._wrapChild,
	        style: style
	      }),
	      children
	    );
	  }
	});

/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(1757);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _height = __webpack_require__(1783);
	
	var _height2 = _interopRequireDefault(_height);
	
	var _width = __webpack_require__(1827);
	
	var _width2 = _interopRequireDefault(_width);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A streamlined version of TransitionGroup built for managing at most two active children
	 * also provides additional hooks for animation start/end
	 * https://github.com/facebook/react/blob/master/src/addons/transitions/ReactTransitionGroup.js
	 * relevent code is licensed accordingly
	 */
	
	
	function getChild(children) {
	  return _react2.default.Children.only(children);
	}
	
	function key(child) {
	  return child && child.key;
	}
	
	exports.default = _react2.default.createClass({
	
	  displayName: 'ReplaceTransitionGroup',
	
	  propTypes: {
	    component: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.element, _react2.default.PropTypes.string]),
	    childFactory: _react2.default.PropTypes.func,
	    onAnimating: _react2.default.PropTypes.func,
	    onAnimate: _react2.default.PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      component: 'span',
	      childFactory: function childFactory(a) {
	        return a;
	      },
	      onAnimating: _3.default.noop,
	      onAnimate: _3.default.noop
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      children: _3.default.splat(this.props.children)
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var nextChild = getChild(nextProps.children),
	        stack = this.state.children.slice(),
	        next = stack[1],
	        last = stack[0];
	
	    var isLastChild = last && key(last) === key(nextChild),
	        isNextChild = next && key(next) === key(nextChild);
	
	    //no children
	    if (!last) {
	      stack.push(nextChild);
	      this.entering = nextChild;
	    } else if (last && !next && !isLastChild) {
	      //new child
	      stack.push(nextChild);
	      this.leaving = last;
	      this.entering = nextChild;
	    } else if (last && next && !isLastChild && !isNextChild) {
	      // the child is not the current one, exit the current one, add the new one
	      //  - shift the stack down
	      stack.shift();
	      stack.push(nextChild);
	      this.leaving = next;
	      this.entering = nextChild;
	    }
	    //new child that just needs to be re-rendered
	    else if (isLastChild) stack.splice(0, 1, nextChild);else if (isNextChild) stack.splice(1, 1, nextChild);
	
	    if (this.state.children[0] !== stack[0] || this.state.children[1] !== stack[1]) this.setState({ children: stack });
	  },
	  componentWillMount: function componentWillMount() {
	    this.animatingKeys = {};
	    this.leaving = null;
	    this.entering = null;
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var entering = this.entering,
	        leaving = this.leaving,
	        first = this.refs[key(entering) || key(leaving)],
	        node = _compat2.default.findDOMNode(this),
	        el = first && _compat2.default.findDOMNode(first);
	
	    if (el) (0, _style2.default)(node, {
	      overflow: 'hidden',
	      height: (0, _height2.default)(el) + 'px',
	      width: (0, _width2.default)(el) + 'px'
	    });
	
	    this.props.onAnimating();
	
	    this.entering = null;
	    this.leaving = null;
	
	    if (entering) this.performEnter(key(entering));
	    if (leaving) this.performLeave(key(leaving));
	  },
	  performEnter: function performEnter(key) {
	    var component = this.refs[key];
	
	    if (!component) return;
	
	    this.animatingKeys[key] = true;
	
	    if (component.componentWillEnter) component.componentWillEnter(this._handleDoneEntering.bind(this, key));else this._handleDoneEntering(key);
	  },
	  _tryFinish: function _tryFinish() {
	
	    if (this.isTransitioning()) return;
	
	    if (this.isMounted()) (0, _style2.default)(_compat2.default.findDOMNode(this), { overflow: 'visible', height: '', width: '' });
	
	    this.props.onAnimate();
	  },
	  _handleDoneEntering: function _handleDoneEntering(enterkey) {
	    var component = this.refs[enterkey];
	
	    if (component && component.componentDidEnter) component.componentDidEnter();
	
	    delete this.animatingKeys[enterkey];
	
	    if (key(this.props.children) !== enterkey) this.performLeave(enterkey); // This was removed before it had fully entered. Remove it.
	
	    this._tryFinish();
	  },
	  performLeave: function performLeave(key) {
	    var component = this.refs[key];
	
	    if (!component) return;
	
	    this.animatingKeys[key] = true;
	
	    if (component.componentWillLeave) component.componentWillLeave(this._handleDoneLeaving.bind(this, key));else this._handleDoneLeaving(key);
	  },
	  _handleDoneLeaving: function _handleDoneLeaving(leavekey) {
	    var component = this.refs[leavekey];
	
	    if (component && component.componentDidLeave) component.componentDidLeave();
	
	    delete this.animatingKeys[leavekey];
	
	    if (key(this.props.children) === leavekey) this.performEnter(leavekey); // This entered again before it fully left. Add it again.
	
	    else if (this.isMounted()) this.setState({
	        children: this.state.children.filter(function (c) {
	          return key(c) !== leavekey;
	        })
	      });
	
	    this._tryFinish();
	  },
	  isTransitioning: function isTransitioning() {
	    return !!Object.keys(this.animatingKeys).length;
	  },
	  render: function render() {
	    var _this = this;
	
	    var Component = this.props.component;
	
	    return _react2.default.createElement(
	      Component,
	      _3.default.omitOwnProps(this),
	      this.state.children.map(function (c) {
	        return _this.props.childFactory(c, key(c));
	      })
	    );
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 1827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var offset = __webpack_require__(1784),
	    getWindow = __webpack_require__(1785);
	
	module.exports = function width(node, client) {
	  var win = getWindow(node);
	  return win ? win.innerWidth : client ? node.clientWidth : offset(node).width;
	};

/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _desc, _value, _obj;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //pick, omit, has
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _activeElement = __webpack_require__(1771);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _dates = __webpack_require__(1819);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _localizers = __webpack_require__(1768);
	
	var _constants = __webpack_require__(1821);
	
	var _Widget = __webpack_require__(1774);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _Popup = __webpack_require__(1782);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Calendar = __webpack_require__(1813);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _TimeList = __webpack_require__(1829);
	
	var _TimeList2 = _interopRequireDefault(_TimeList);
	
	var _DateTimePickerInput = __webpack_require__(1830);
	
	var _DateTimePickerInput2 = _interopRequireDefault(_DateTimePickerInput);
	
	var _Button = __webpack_require__(1777);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__(1796);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _interaction = __webpack_require__(1790);
	
	var _widgetHelpers = __webpack_require__(1789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var Calendar = _Calendar2.default.ControlledComponent;
	
	var viewEnum = Object.keys(_constants.calendarViews).map(function (k) {
	  return _constants.calendarViews[k];
	});
	
	var propTypes = _extends({}, Calendar.propTypes, {
	
	  //-- controlled props -----------
	  value: _react2.default.PropTypes.instanceOf(Date),
	  onChange: _react2.default.PropTypes.func,
	  open: _react2.default.PropTypes.oneOf([false, _constants.datePopups.TIME, _constants.datePopups.CALENDAR]),
	  onToggle: _react2.default.PropTypes.func,
	  currentDate: _react2.default.PropTypes.instanceOf(Date),
	  onCurrentDateChange: _react2.default.PropTypes.func,
	  //------------------------------------
	
	  onSelect: _react2.default.PropTypes.func,
	
	  min: _react2.default.PropTypes.instanceOf(Date),
	  max: _react2.default.PropTypes.instanceOf(Date),
	
	  culture: _react2.default.PropTypes.string,
	
	  format: _propTypes2.default.dateFormat,
	  timeFormat: _propTypes2.default.dateFormat,
	  editFormat: _propTypes2.default.dateFormat,
	
	  calendar: _react2.default.PropTypes.bool,
	  time: _react2.default.PropTypes.bool,
	
	  timeComponent: _propTypes2.default.elementType,
	
	  //popup
	  dropUp: _react2.default.PropTypes.bool,
	  duration: _react2.default.PropTypes.number,
	
	  placeholder: _react2.default.PropTypes.string,
	  name: _react2.default.PropTypes.string,
	
	  initialView: _react2.default.PropTypes.oneOf(viewEnum),
	  finalView: _react2.default.PropTypes.oneOf(viewEnum),
	
	  autoFocus: _react2.default.PropTypes.bool,
	  disabled: _propTypes2.default.disabled,
	  readOnly: _propTypes2.default.readOnly,
	
	  parse: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string), _react2.default.PropTypes.string, _react2.default.PropTypes.func]),
	
	  'aria-labelledby': _react2.default.PropTypes.string,
	
	  messages: _react2.default.PropTypes.shape({
	    calendarButton: _react2.default.PropTypes.string,
	    timeButton: _react2.default.PropTypes.string
	  })
	});
	
	var DateTimePicker = _react2.default.createClass((_obj = {
	
	  displayName: 'DateTimePicker',
	
	  mixins: [__webpack_require__(1799), __webpack_require__(1801), __webpack_require__(1803), __webpack_require__(1808), __webpack_require__(1809)({
	    didHandle: function didHandle(focused) {
	      if (!focused) this.close();
	    }
	  }), __webpack_require__(1792)('valueInput', function (key, id) {
	    var open = this.props.open;
	    var current = this.ariaActiveDescendant();
	    var calIsActive = open === _constants.datePopups.CALENDAR && key === 'calendar';
	    var timeIsActive = open === _constants.datePopups.TIME && key === 'timelist';
	
	    if (!current || timeIsActive || calIsActive) return id;
	  })],
	
	  propTypes: propTypes,
	
	  getInitialState: function getInitialState() {
	    return {
	      focused: false
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	
	    return {
	      value: null,
	      currentDate: new Date(),
	      min: new Date(1900, 0, 1),
	      max: new Date(2099, 11, 31),
	      calendar: true,
	      time: true,
	      open: false,
	
	      //calendar override
	      footer: true,
	
	      messages: {
	        calendarButton: 'Select Date',
	        timeButton: 'Select Time'
	      },
	
	      ariaActiveDescendantKey: 'dropdownlist'
	    };
	  },
	  renderInput: function renderInput(id, owns) {
	    var _props = this.props;
	    var open = _props.open;
	    var value = _props.value;
	    var editFormat = _props.editFormat;
	    var culture = _props.culture;
	    var busy = _props.busy;
	    var placeholder = _props.placeholder;
	    var disabled = _props.disabled;
	    var readOnly = _props.readOnly;
	    var name = _props.name;
	    var tabIndex = _props.tabIndex;
	    var autoFocus = _props.autoFocus;
	    var ariaLabelledby = _props['aria-labelledby'];
	    var ariaDescribedby = _props['aria-describedby'];
	    var focused = this.state.focused;
	
	
	    return _react2.default.createElement(_DateTimePickerInput2.default, {
	      id: id,
	      ref: 'valueInput',
	      role: 'combobox',
	      name: name,
	      tabIndex: tabIndex,
	      autoFocus: autoFocus,
	      placeholder: placeholder,
	      disabled: disabled,
	      readOnly: readOnly,
	      value: value,
	      format: getFormat(this.props),
	      editFormat: editFormat,
	      editing: focused,
	      culture: culture,
	      parse: this._parse,
	      onChange: this.handleChange,
	      'aria-haspopup': true,
	      'aria-labelledby': ariaLabelledby,
	      'aria-describedby': ariaDescribedby,
	      'aria-expanded': !!open,
	      'aria-busy': !!busy,
	      'aria-owns': owns
	    });
	  },
	  renderButtons: function renderButtons(messages) {
	    var _props2 = this.props;
	    var calendar = _props2.calendar;
	    var time = _props2.time;
	    var disabled = _props2.disabled;
	    var readOnly = _props2.readOnly;
	
	
	    if (!calendar && !time) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'span',
	      { className: 'rw-select' },
	      calendar && _react2.default.createElement(_Button2.default, {
	        icon: 'calendar',
	        className: 'rw-btn-calendar',
	        label: messages.calendarButton,
	        disabled: !!(disabled || readOnly),
	        onClick: this._click.bind(null, _constants.datePopups.CALENDAR)
	      }),
	      time && _react2.default.createElement(_Button2.default, {
	        icon: 'clock-o',
	        className: 'rw-btn-time',
	        label: messages.timeButton,
	        disabled: !!(disabled || readOnly),
	        onClick: this._click.bind(null, _constants.datePopups.TIME)
	      })
	    );
	  },
	  renderCalendar: function renderCalendar(id, inputID) {
	    var _this = this;
	
	    var _props3 = this.props;
	    var open = _props3.open;
	    var value = _props3.value;
	    var duration = _props3.duration;
	    var dropUp = _props3.dropUp;
	
	
	    var calendarProps = _3.default.pickProps(this.props, Calendar);
	
	    return _react2.default.createElement(
	      _Popup2.default,
	      {
	        dropUp: dropUp,
	        duration: duration,
	        open: open === _constants.datePopups.CALENDAR,
	        className: 'rw-calendar-popup'
	      },
	      _react2.default.createElement(Calendar, _extends({}, calendarProps, {
	        ref: 'calPopup',
	        id: id,
	        tabIndex: '-1',
	        value: value,
	        autoFocus: false,
	        onChange: this.handleDateSelect
	        // #75: need to aggressively reclaim focus from the calendar otherwise
	        // disabled header/footer buttons will drop focus completely from the widget
	        , onNavigate: function onNavigate() {
	          return _this.focus();
	        },
	        currentDate: this.props.currentDate,
	        onCurrentDateChange: this.props.onCurrentDateChange,
	        'aria-hidden': !open,
	        'aria-live': 'polite',
	        'aria-labelledby': inputID,
	        ariaActiveDescendantKey: 'calendar'
	      }))
	    );
	  },
	  renderTimeList: function renderTimeList(id, inputID) {
	    var _this2 = this;
	
	    var _props4 = this.props;
	    var open = _props4.open;
	    var value = _props4.value;
	    var duration = _props4.duration;
	    var dropUp = _props4.dropUp;
	    var calendar = _props4.calendar;
	    var timeFormat = _props4.timeFormat;
	    var timeComponent = _props4.timeComponent;
	
	
	    var timeListProps = _3.default.pickProps(this.props, _TimeList2.default);
	
	    return _react2.default.createElement(
	      _Popup2.default,
	      {
	        dropUp: dropUp,
	        duration: duration,
	        open: open === _constants.datePopups.TIME,
	        onOpening: function onOpening() {
	          return _this2.refs.timePopup.forceUpdate();
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TimeList2.default, _extends({}, timeListProps, {
	          ref: 'timePopup',
	          id: id,
	          format: timeFormat,
	          value: dateOrNull(value),
	          onMove: this._scrollTo,
	          onSelect: this.handleTimeSelect,
	          preserveDate: !!calendar,
	          itemComponent: timeComponent,
	          'aria-labelledby': inputID,
	          'aria-live': open && 'polite',
	          'aria-hidden': !open,
	          ariaActiveDescendantKey: 'timelist'
	        }))
	      )
	    );
	  },
	  render: function render() {
	    var _props5 = this.props;
	    var className = _props5.className;
	    var calendar = _props5.calendar;
	    var time = _props5.time;
	    var open = _props5.open;
	    var messages = _props5.messages;
	    var disabled = _props5.disabled;
	    var readOnly = _props5.readOnly;
	    var dropUp = _props5.dropUp;
	    var focused = this.state.focused;
	
	
	    var inputID = (0, _widgetHelpers.instanceId)(this, '_input'),
	        timeListID = (0, _widgetHelpers.instanceId)(this, '_time_listbox'),
	        dateListID = (0, _widgetHelpers.instanceId)(this, '_cal'),
	        owns = '';
	
	    var elementProps = _3.default.omitOwnProps(this, Calendar, _TimeList2.default);
	
	    var shouldRenderList = open || (0, _widgetHelpers.isFirstFocusedRender)(this);
	
	    if (calendar) owns += dateListID;
	    if (time) owns += ' ' + timeListID;
	
	    return _react2.default.createElement(
	      _Widget2.default,
	      _extends({}, elementProps, {
	        open: !!open,
	        dropUp: dropUp,
	        focused: focused,
	        disabled: disabled,
	        readOnly: readOnly,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onKeyPress: this.handleKeyPress,
	        className: (0, _classnames2.default)(className, 'rw-datetimepicker', calendar && time && 'rw-has-both', !calendar && !time && 'rw-has-neither')
	      }),
	      this.renderInput(inputID, owns.trim()),
	      this.renderButtons(messages),
	      shouldRenderList && this.renderTimeList(timeListID, inputID),
	      shouldRenderList && this.renderCalendar(dateListID, inputID)
	    );
	  },
	  handleChange: function handleChange(date, str, constrain) {
	    var _props6 = this.props;
	    var onChange = _props6.onChange;
	    var value = _props6.value;
	
	
	    if (constrain) date = this.inRangeValue(date);
	
	    if (onChange) {
	      if (date == null || value == null) {
	        if (date != value) //eslint-disable-line eqeqeq
	          onChange(date, str);
	      } else if (!_dates2.default.eq(date, value)) {
	        onChange(date, str);
	      }
	    }
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var _props7 = this.props;
	    var open = _props7.open;
	    var calendar = _props7.calendar;
	    var time = _props7.time;
	
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	
	    if (e.defaultPrevented) return;
	
	    if (e.key === 'Escape' && open) this.close();else if (e.altKey) {
	      e.preventDefault();
	
	      if (e.key === 'ArrowDown') {
	        if (calendar && time) this.open(open === _constants.datePopups.CALENDAR ? _constants.datePopups.TIME : _constants.datePopups.CALENDAR);else if (time) this.open(_constants.datePopups.TIME);else if (calendar) this.open(_constants.datePopups.CALENDAR);
	      } else if (e.key === 'ArrowUp') this.close();
	    } else if (open) {
	      if (open === _constants.datePopups.CALENDAR) this.refs.calPopup.handleKeyDown(e);
	      if (open === _constants.datePopups.TIME) this.refs.timePopup.handleKeyDown(e);
	    }
	  },
	  handleKeyPress: function handleKeyPress(e) {
	    (0, _widgetHelpers.notify)(this.props.onKeyPress, [e]);
	
	    if (e.defaultPrevented) return;
	
	    if (this.props.open === _constants.datePopups.TIME) this.refs.timePopup.handleKeyPress(e);
	  },
	  focus: function focus() {
	    var valueInput = this.refs.valueInput;
	
	
	    if (valueInput && (0, _activeElement2.default)() !== _compat2.default.findDOMNode(valueInput)) valueInput.focus();
	  },
	  handleDateSelect: function handleDateSelect(date) {
	    var format = getFormat(this.props),
	        dateTime = _dates2.default.merge(date, this.props.value, this.props.currentDate),
	        dateStr = formatDate(date, format, this.props.culture);
	
	    this.close();
	    (0, _widgetHelpers.notify)(this.props.onSelect, [dateTime, dateStr]);
	    this.handleChange(dateTime, dateStr, true);
	    this.focus();
	  },
	  handleTimeSelect: function handleTimeSelect(datum) {
	    var format = getFormat(this.props),
	        dateTime = _dates2.default.merge(this.props.value, datum.date, this.props.currentDate),
	        dateStr = formatDate(datum.date, format, this.props.culture);
	
	    this.close();
	    (0, _widgetHelpers.notify)(this.props.onSelect, [dateTime, dateStr]);
	    this.handleChange(dateTime, dateStr, true);
	    this.focus();
	  },
	  _click: function _click(view, e) {
	    this.focus();
	    this.toggle(view, e);
	  },
	  _parse: function _parse(string) {
	    var format = getFormat(this.props, true),
	        editFormat = this.props.editFormat,
	        parse = this.props.parse,
	        formats = [];
	
	    if (typeof parse === 'function') return parse(string, this.props.culture);
	
	    if (typeof format === 'string') formats.push(format);
	
	    if (typeof editFormat === 'string') formats.push(editFormat);
	
	    if (parse) formats = formats.concat(this.props.parse);
	
	    (0, _invariant2.default)(formats.length, 'React Widgets: there are no specified `parse` formats provided and the `format` prop is a function. ' + 'the DateTimePicker is unable to parse `%s` into a dateTime, ' + 'please provide either a parse function or Globalize.js compatible string for `format`', string);
	
	    return formatsParser(formats, this.props.culture, string);
	  },
	  toggle: function toggle(view) {
	    this.props.open ? this.props.open !== view ? this.open(view) : this.close(view) : this.open(view);
	  },
	  open: function open(view) {
	    if (this.props.open !== view && this.props[view] === true) (0, _widgetHelpers.notify)(this.props.onToggle, view);
	  },
	  close: function close() {
	    if (this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, false);
	  },
	  inRangeValue: function inRangeValue(value) {
	    if (value == null) return value;
	
	    return _dates2.default.max(_dates2.default.min(value, this.props.max), this.props.min);
	  }
	}, (_applyDecoratedDescriptor(_obj, 'handleChange', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleChange'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyDown'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyPress', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyPress'), _obj), _applyDecoratedDescriptor(_obj, 'handleDateSelect', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleDateSelect'), _obj), _applyDecoratedDescriptor(_obj, 'handleTimeSelect', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleTimeSelect'), _obj), _applyDecoratedDescriptor(_obj, '_click', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, '_click'), _obj)), _obj));
	
	exports.default = (0, _uncontrollable2.default)(DateTimePicker, {
	  open: 'onToggle',
	  value: 'onChange',
	  currentDate: 'onCurrentDateChange'
	}, ['focus']);
	
	
	function getFormat(props) {
	  var cal = props[_constants.datePopups.CALENDAR] != null ? props.calendar : true,
	      time = props[_constants.datePopups.TIME] != null ? props.time : true;
	
	  return props.format ? props.format : cal && time || !cal && !time ? _localizers.date.getFormat('default') : _localizers.date.getFormat(cal ? 'date' : 'time');
	}
	
	function formatDate(date, format, culture) {
	  var val = '';
	
	  if (date instanceof Date && !isNaN(date.getTime())) val = _localizers.date.format(date, format, culture);
	
	  return val;
	}
	
	function formatsParser(formats, culture, str) {
	  var date;
	
	  for (var i = 0; i < formats.length; i++) {
	    date = _localizers.date.parse(str, formats[i], culture);
	    if (date) return date;
	  }
	  return null;
	}
	
	function dateOrNull(dt) {
	  if (dt && !isNaN(dt.getTime())) return dt;
	  return null;
	}
	module.exports = exports['default'];

/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dates2 = __webpack_require__(1819);
	
	var _dates3 = _interopRequireDefault(_dates2);
	
	var _List = __webpack_require__(1787);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _localizers = __webpack_require__(1768);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = function format(props) {
	  return _localizers.date.getFormat('time', props.format);
	};
	
	exports.default = _react2.default.createClass({
	
	  displayName: 'TimeList',
	
	  propTypes: {
	    value: _react2.default.PropTypes.instanceOf(Date),
	    step: _react2.default.PropTypes.number,
	    min: _react2.default.PropTypes.instanceOf(Date),
	    max: _react2.default.PropTypes.instanceOf(Date),
	    currentDate: _react2.default.PropTypes.instanceOf(Date),
	
	    itemComponent: _propTypes2.default.elementType,
	    format: _propTypes2.default.dateFormat,
	    onSelect: _react2.default.PropTypes.func,
	    preserveDate: _react2.default.PropTypes.bool,
	    culture: _react2.default.PropTypes.string,
	    delay: _react2.default.PropTypes.number
	  },
	
	  mixins: [__webpack_require__(1799)],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      step: 30,
	      onSelect: function onSelect() {},
	      min: new Date(1900, 0, 1),
	      max: new Date(2099, 11, 31),
	      preserveDate: true,
	      delay: 300,
	      ariaActiveDescendantKey: 'timelist'
	    };
	  },
	  getInitialState: function getInitialState() {
	    var data = this._dates(this.props),
	        focusedItem = this._closestDate(data, this.props.value);
	
	    return {
	      focusedItem: focusedItem || data[0],
	      dates: data
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var data = this._dates(nextProps),
	        focusedItem = this._closestDate(data, nextProps.value),
	        valChanged = !_dates3.default.eq(nextProps.value, this.props.value, 'minutes'),
	        minChanged = !_dates3.default.eq(nextProps.min, this.props.min, 'minutes'),
	        maxChanged = !_dates3.default.eq(nextProps.max, this.props.max, 'minutes'),
	        localeChanged = this.props.format !== nextProps.format || this.props.culture !== nextProps.culture;
	
	    if (valChanged || minChanged || maxChanged || localeChanged) {
	      this.setState({
	        focusedItem: focusedItem || data[0],
	        dates: data
	      });
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var value = _props.value;
	    var onSelect = _props.onSelect;
	
	
	    var times = this.state.dates,
	        date = this._closestDate(times, value);
	
	    return _react2.default.createElement(_List2.default, _extends({}, _3.default.omitOwnProps(this), {
	      ref: 'list',
	      data: times,
	      textField: 'label',
	      valueField: 'date',
	      selected: date,
	      onSelect: onSelect,
	      focused: this.state.focusedItem
	    }));
	  },
	  _closestDate: function _closestDate(times, date) {
	    var roundTo = 1000 * 60 * this.props.step,
	        inst = null,
	        label;
	
	    if (!date) return null;
	
	    date = new Date(Math.floor(date.getTime() / roundTo) * roundTo);
	    label = _localizers.date.format(date, format(this.props), this.props.culture);
	
	    times.some(function (time) {
	      if (time.label === label) return inst = time;
	    });
	
	    return inst;
	  },
	  _data: function _data() {
	    return this.state.dates;
	  },
	  _dates: function _dates(props) {
	    var times = [],
	        i = 0,
	        values = this._dateValues(props),
	        start = values.min,
	        startDay = _dates3.default.date(start);
	
	    while (_dates3.default.date(start) === startDay && _dates3.default.lte(start, values.max)) {
	      i++;
	      times.push({ date: start, label: _localizers.date.format(start, format(props), props.culture) });
	      start = _dates3.default.add(start, props.step || 30, 'minutes');
	    }
	    return times;
	  },
	  _dateValues: function _dateValues(props) {
	    var value = props.value || props.currentDate || _dates3.default.today(),
	        useDate = props.preserveDate,
	        min = props.min,
	        max = props.max,
	        start,
	        end;
	
	    //compare just the time regradless of whether they fall on the same day
	    if (!useDate) {
	      start = _dates3.default.startOf(_dates3.default.merge(new Date(), min, props.currentDate), 'minutes');
	      end = _dates3.default.startOf(_dates3.default.merge(new Date(), max, props.currentDate), 'minutes');
	
	      if (_dates3.default.lte(end, start) && _dates3.default.gt(max, min, 'day')) end = _dates3.default.tomorrow();
	
	      return {
	        min: start,
	        max: end
	      };
	    }
	
	    start = _dates3.default.today();
	    end = _dates3.default.tomorrow();
	    //date parts are equal
	    return {
	      min: _dates3.default.eq(value, min, 'day') ? _dates3.default.merge(start, min, props.currentDate) : start,
	      max: _dates3.default.eq(value, max, 'day') ? _dates3.default.merge(start, max, props.currentDate) : end
	    };
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var key = e.key,
	        focusedItem = this.state.focusedItem,
	        list = this.refs.list;
	
	    if (key === 'End') {
	      e.preventDefault();
	      this.setState({ focusedItem: list.last() });
	    } else if (key === 'Home') {
	      e.preventDefault();
	      this.setState({ focusedItem: list.first() });
	    } else if (key === 'Enter') this.props.onSelect(focusedItem);else if (key === 'ArrowDown') {
	      e.preventDefault();
	      this.setState({ focusedItem: list.next(focusedItem) });
	    } else if (key === 'ArrowUp') {
	      e.preventDefault();
	      this.setState({ focusedItem: list.prev(focusedItem) });
	    }
	  },
	  handleKeyPress: function handleKeyPress(e) {
	    var _this = this;
	
	    e.preventDefault();
	
	    this.search(String.fromCharCode(e.which), function (item) {
	      _this.isMounted() && _this.setState({ focusedItem: item });
	    });
	  },
	  scrollTo: function scrollTo() {
	    this.refs.list.move && this.refs.list.move();
	  },
	  search: function search(character, cb) {
	    var _this2 = this;
	
	    var word = ((this._searchTerm || '') + character).toLowerCase();
	
	    this._searchTerm = word;
	
	    this.setTimeout('search', function () {
	      var list = _this2.refs.list,
	          item = list.next(_this2.state.focusedItem, word);
	
	      _this2._searchTerm = '';
	      if (item) cb(item);
	    }, this.props.delay);
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 1830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _Input = __webpack_require__(1775);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _localizers = __webpack_require__(1768);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	
	  displayName: 'DateTimePickerInput',
	
	  propTypes: {
	    format: _propTypes2.default.dateFormat.isRequired,
	    editing: _react2.default.PropTypes.bool,
	    editFormat: _propTypes2.default.dateFormat,
	    parse: _react2.default.PropTypes.func.isRequired,
	
	    value: _react2.default.PropTypes.instanceOf(Date),
	    onChange: _react2.default.PropTypes.func.isRequired,
	    culture: _react2.default.PropTypes.string
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var value = nextProps.value;
	    var editing = nextProps.editing;
	    var editFormat = nextProps.editFormat;
	    var format = nextProps.format;
	    var culture = nextProps.culture;
	
	
	    this.setState({
	      textValue: formatDate(value, editing && editFormat ? editFormat : format, culture)
	    });
	  },
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var value = _props.value;
	    var editing = _props.editing;
	    var editFormat = _props.editFormat;
	    var format = _props.format;
	    var culture = _props.culture;
	
	
	    return {
	      textValue: formatDate(value, editing && editFormat ? editFormat : format, culture)
	    };
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var disabled = _props2.disabled;
	    var readOnly = _props2.readOnly;
	    var textValue = this.state.textValue;
	
	
	    var props = _3.default.omitOwnProps(this);
	
	    return _react2.default.createElement(_Input2.default, _extends({}, props, {
	      type: 'text',
	      value: textValue,
	      disabled: disabled,
	      readOnly: readOnly,
	      onChange: this.handleChange,
	      onBlur: this.handleBlur
	    }));
	  },
	  handleChange: function handleChange(_ref) {
	    var value = _ref.target.value;
	
	    this._needsFlush = true;
	    this.setState({ textValue: value });
	  },
	  handleBlur: function handleBlur(event) {
	    var _props3 = this.props;
	    var format = _props3.format;
	    var culture = _props3.culture;
	    var parse = _props3.parse;
	    var onChange = _props3.onChange;
	    var onBlur = _props3.onBlur;
	
	
	    onBlur && onBlur(event);
	
	    if (this._needsFlush) {
	      var date = parse(event.target.value);
	
	      this._needsFlush = false;
	      onChange(date, formatDate(date, format, culture));
	    }
	  },
	  focus: function focus() {
	    _compat2.default.findDOMNode(this).focus();
	  }
	});
	
	
	function isValid(d) {
	  return !isNaN(d.getTime());
	}
	
	function formatDate(date, format, culture) {
	  var val = '';
	
	  if (date instanceof Date && isValid(date)) val = _localizers.date.format(date, format, culture);
	
	  return val;
	}
	module.exports = exports['default'];

/***/ },
/* 1831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _desc, _value, _obj;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__(1796);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _constants = __webpack_require__(1821);
	
	var _repeater = __webpack_require__(1832);
	
	var _repeater2 = _interopRequireDefault(_repeater);
	
	var _localizers = __webpack_require__(1768);
	
	var _NumberInput = __webpack_require__(1833);
	
	var _NumberInput2 = _interopRequireDefault(_NumberInput);
	
	var _Button = __webpack_require__(1777);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _interaction = __webpack_require__(1790);
	
	var _widgetHelpers = __webpack_require__(1789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var format = function format(props) {
	  return _localizers.number.getFormat('default', props.format);
	};
	
	var propTypes = {
	
	  // -- controlled props -----------
	  value: _react2.default.PropTypes.number,
	  onChange: _react2.default.PropTypes.func,
	  //------------------------------------
	
	  min: _react2.default.PropTypes.number,
	  max: _react2.default.PropTypes.number,
	  step: _react2.default.PropTypes.number,
	
	  precision: _react2.default.PropTypes.number,
	
	  culture: _react2.default.PropTypes.string,
	
	  format: _propTypes2.default.numberFormat,
	
	  name: _react2.default.PropTypes.string,
	
	  parse: _react2.default.PropTypes.func,
	
	  autoFocus: _react2.default.PropTypes.bool,
	  disabled: _propTypes2.default.disabled,
	  readOnly: _propTypes2.default.readOnly,
	
	  messages: _react2.default.PropTypes.shape({
	    increment: _react2.default.PropTypes.string,
	    decrement: _react2.default.PropTypes.string
	  }),
	
	  placeholder: _react2.default.PropTypes.string
	};
	
	var NumberPicker = _react2.default.createClass((_obj = {
	
	  displayName: 'NumberPicker',
	
	  mixins: [__webpack_require__(1799), __webpack_require__(1801), __webpack_require__(1808), __webpack_require__(1809)({
	    willHandle: function willHandle(focused) {
	      if (focused) this.focus();
	    }
	  })],
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      value: null,
	      open: false,
	
	      min: -Infinity,
	      max: Infinity,
	      step: 1,
	
	      messages: {
	        increment: 'increment value',
	        decrement: 'decrement value'
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      focused: false,
	      active: false
	    };
	  },
	  render: function render() {
	    var _this = this;
	
	    var _$omitOwnProps = _3.default.omitOwnProps(this);
	
	    var className = _$omitOwnProps.className;
	    var onKeyPress = _$omitOwnProps.onKeyPress;
	    var onKeyUp = _$omitOwnProps.onKeyUp;
	
	    var props = _objectWithoutProperties(_$omitOwnProps, ['className', 'onKeyPress', 'onKeyUp']);
	
	    var val = this.constrainValue(this.props.value);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, props, {
	        ref: 'element',
	        onKeyDown: this._keyDown,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        tabIndex: '-1',
	        className: (0, _classnames2.default)(className, 'rw-numberpicker', 'rw-widget', {
	          'rw-state-focus': this.state.focused,
	          'rw-state-disabled': this.props.disabled,
	          'rw-state-readonly': this.props.readOnly,
	          'rw-rtl': this.isRtl()
	        }) }),
	      _react2.default.createElement(
	        'span',
	        { className: 'rw-select' },
	        _react2.default.createElement(_Button2.default, {
	          icon: 'caret-up',
	          onClick: this.handleFocus,
	          label: this.props.messages.increment,
	          active: this.state.active === _constants.directions.UP,
	          disabled: val === this.props.max || this.props.disabled,
	          onMouseUp: function onMouseUp() {
	            return _this.handleMouseUp(_constants.directions.UP);
	          },
	          onMouseDown: function onMouseDown() {
	            return _this.handleMouseDown(_constants.directions.UP);
	          },
	          onMouseLeave: function onMouseLeave() {
	            return _this.handleMouseUp(_constants.directions.UP);
	          }
	        }),
	        _react2.default.createElement(_Button2.default, {
	          icon: 'caret-down',
	          onClick: this.handleFocus,
	          label: this.props.messages.decrement,
	          active: this.state.active === _constants.directions.UP,
	          disabled: val === this.props.min || this.props.disabled,
	          onMouseUp: function onMouseUp() {
	            return _this.handleMouseUp(_constants.directions.DOWN);
	          },
	          onMouseDown: function onMouseDown() {
	            return _this.handleMouseDown(_constants.directions.DOWN);
	          },
	          onMouseLeave: function onMouseLeave() {
	            return _this.handleMouseUp(_constants.directions.DOWN);
	          }
	        })
	      ),
	      _react2.default.createElement(_NumberInput2.default, {
	        ref: 'input',
	        tabIndex: props.tabIndex,
	        placeholder: this.props.placeholder,
	        value: val,
	        autoFocus: this.props.autoFocus,
	        editing: this.state.focused,
	        format: this.props.format,
	        parse: this.props.parse,
	        name: this.props.name,
	        role: 'spinbutton',
	        min: this.props.min,
	        'aria-valuenow': val,
	        'aria-valuemin': isFinite(this.props.min) ? this.props.min : null,
	        'aria-valuemax': isFinite(this.props.max) ? this.props.max : null,
	        'aria-disabled': this.props.disabled,
	        'aria-readonly': this.props.readonly,
	        disabled: this.props.disabled,
	        readOnly: this.props.readOnly,
	        onChange: this.change,
	        onKeyPress: onKeyPress,
	        onKeyUp: onKeyUp })
	    );
	  },
	  handleMouseDown: function handleMouseDown(dir) {
	    var method = dir === _constants.directions.UP ? this.increment : this.decrement;
	
	    this.setState({ active: dir });
	
	    var val = method.call(this);
	
	    if (!(dir === _constants.directions.UP && val === this.props.max || dir === _constants.directions.DOWN && val === this.props.min)) {
	      if (!this._cancelRepeater) this._cancelRepeater = (0, _repeater2.default)(this.handleMouseDown.bind(null, dir));
	    } else this.handleMouseUp();
	  },
	  handleMouseUp: function handleMouseUp() {
	    this.setState({ active: false });
	    this._cancelRepeater && this._cancelRepeater();
	    this._cancelRepeater = null;
	  },
	  _keyDown: function _keyDown(e) {
	    var key = e.key;
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	
	    if (e.defaultPrevented) return;
	
	    if (key === 'End' && isFinite(this.props.max)) this.change(this.props.max);else if (key === 'Home' && isFinite(this.props.min)) this.change(this.props.min);else if (key === 'ArrowDown') {
	      e.preventDefault();
	      this.decrement();
	    } else if (key === 'ArrowUp') {
	      e.preventDefault();
	      this.increment();
	    }
	  },
	  focus: function focus() {
	    _compat2.default.findDOMNode(this.refs.input).focus();
	  },
	  increment: function increment() {
	    return this.step(this.props.step);
	  },
	  decrement: function decrement() {
	    return this.step(-this.props.step);
	  },
	  step: function step(amount) {
	    var value = (this.props.value || 0) + amount;
	
	    var decimals = this.props.precision != null ? this.props.precision : _localizers.number.precision(format(this.props));
	
	    this.change(decimals != null ? round(value, decimals) : value);
	
	    return value;
	  },
	  change: function change(val) {
	    val = this.constrainValue(val);
	
	    if (this.props.value !== val) (0, _widgetHelpers.notify)(this.props.onChange, val);
	  },
	  constrainValue: function constrainValue(value) {
	    var max = this.props.max == null ? Infinity : this.props.max,
	        min = this.props.min == null ? -Infinity : this.props.min;
	
	    if (value == null || value === '') return null;
	
	    return Math.max(Math.min(value, max), min);
	  }
	}, (_applyDecoratedDescriptor(_obj, 'handleMouseDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleMouseDown'), _obj), _applyDecoratedDescriptor(_obj, 'handleMouseUp', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleMouseUp'), _obj), _applyDecoratedDescriptor(_obj, '_keyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, '_keyDown'), _obj)), _obj));
	
	exports.default = (0, _uncontrollable2.default)(NumberPicker, { value: 'onChange' }, ['focus']);
	
	// thank you kendo ui core
	// https://github.com/telerik/kendo-ui-core/blob/master/src/kendo.core.js#L1036
	
	function round(value, precision) {
	  precision = precision || 0;
	
	  value = ('' + value).split('e');
	  value = Math.round(+(value[0] + 'e' + (value[1] ? +value[1] + precision : precision)));
	
	  value = ('' + value).split('e');
	  value = +(value[0] + 'e' + (value[1] ? +value[1] - precision : -precision));
	
	  return value.toFixed(precision);
	}
	module.exports = exports['default'];

/***/ },
/* 1832 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Repeater;
	// my tests in ie11/chrome/FF indicate that keyDown repeats
	// at about 35ms+/- 5ms after an initial 500ms delay. callback fires on the leading edge
	function Repeater(callback) {
	  var id,
	      cancel = function cancel() {
	    return clearInterval(id);
	  };
	
	  id = setInterval(function () {
	    cancel();
	    id = setInterval(callback, 35);
	    callback(); //fire after everything in case the user cancels on the first call
	  }, 500);
	
	  return cancel;
	}
	module.exports = exports['default'];

/***/ },
/* 1833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _localizers = __webpack_require__(1768);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getFormat = function getFormat(props) {
	  return _localizers.number.getFormat('default', props.format);
	};
	
	var propTypes = {
	  value: _react2.default.PropTypes.number,
	  editing: _react2.default.PropTypes.bool,
	  placeholder: _react2.default.PropTypes.string,
	
	  format: _propTypes2.default.numberFormat,
	
	  parse: _react2.default.PropTypes.func,
	  culture: _react2.default.PropTypes.string,
	
	  min: _react2.default.PropTypes.number,
	
	  onChange: _react2.default.PropTypes.func.isRequired,
	  onKeyDown: _react2.default.PropTypes.func
	};
	
	exports.default = _react2.default.createClass({
	
	  displayName: 'NumberPickerInput',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      value: null,
	      editing: false
	    };
	  },
	  getDefaultState: function getDefaultState() {
	    var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	
	    var value = props.value,
	        decimal = _localizers.number.decimalChar(null, props.culture),
	        format = getFormat(props);
	
	    if (value == null || isNaN(props.value)) value = '';else value = props.editing ? ('' + value).replace('.', decimal) : _localizers.number.format(value, format, props.culture);
	
	    return {
	      stringValue: '' + value
	    };
	  },
	  getInitialState: function getInitialState() {
	    return this.getDefaultState();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState(this.getDefaultState(nextProps));
	  },
	  render: function render() {
	    var value = this.state.stringValue;
	    var props = _3.default.omitOwnProps(this);
	
	    return _react2.default.createElement('input', _extends({}, props, {
	      type: 'text',
	      className: 'rw-input',
	      onChange: this._change,
	      onBlur: this._finish,
	      'aria-disabled': this.props.disabled,
	      'aria-readonly': this.props.readOnly,
	      disabled: this.props.disabled,
	      readOnly: this.props.readOnly,
	      placeholder: this.props.placeholder,
	      value: value
	    }));
	  },
	  _change: function _change(e) {
	    var val = e.target.value,
	        number = this._parse(e.target.value);
	
	    var isIntermediate = this.isIntermediateValue(number, val);
	
	    if (val == null || val.trim() === '') {
	      this.current('');
	      return this.props.onChange(null);
	    }
	
	    if (!isIntermediate) {
	      if (number !== this.props.value) {
	        return this.props.onChange(number);
	      }
	    } else {
	      this.current(e.target.value);
	    }
	  },
	  _finish: function _finish() {
	    var str = this.state.stringValue,
	        number = this._parse(str);
	
	    // if number is below the min
	    // we need to flush low values and decimal stops, onBlur means i'm done inputing
	    if (this.isIntermediateValue(number, str)) {
	      if (isNaN(number)) {
	        number = null;
	      }
	      this.props.onChange(number);
	    }
	  },
	  _parse: function _parse(strVal) {
	    var culture = this.props.culture,
	        delimChar = _localizers.number.decimalChar(null, culture),
	        userParse = this.props.parse;
	
	    if (userParse) return userParse(strVal, culture);
	
	    strVal = strVal.replace(delimChar, '.');
	    strVal = parseFloat(strVal);
	
	    return strVal;
	  },
	  isIntermediateValue: function isIntermediateValue(num, str) {
	    return !!(num < this.props.min || this.isSign(str) || this.isAtDelimiter(num, str) || this.isPaddedZeros(str));
	  },
	  isSign: function isSign(val) {
	    return (val || '').trim() === '-';
	  },
	  isPaddedZeros: function isPaddedZeros(str) {
	    var localeChar = _localizers.number.decimalChar(null, this.props.culture);
	
	    var _str$split = str.split(localeChar);
	
	    var _ = _str$split[0];
	    var decimals = _str$split[1];
	
	
	    return !!(decimals && decimals.match(/0+$/));
	  },
	  isAtDelimiter: function isAtDelimiter(num, str) {
	    var props = arguments.length <= 2 || arguments[2] === undefined ? this.props : arguments[2];
	
	    var localeChar = _localizers.number.decimalChar(null, props.culture),
	        lastIndex = str.length - 1,
	        char;
	
	    if (str.length < 1) return false;
	
	    char = str[lastIndex];
	
	    return !!(char === localeChar && str.indexOf(char) === lastIndex);
	  },
	  isValid: function isValid(num) {
	    if (typeof num !== 'number' || isNaN(num)) return false;
	    return num >= this.props.min;
	  },
	
	
	  //this intermediate state is for when one runs into the decimal or are typing the number
	  current: function current(stringValue) {
	    this.setState({ stringValue: stringValue });
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _desc, _value, _obj;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _uncontrollable = __webpack_require__(1796);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Widget = __webpack_require__(1774);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _Popup = __webpack_require__(1782);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _MultiselectInput = __webpack_require__(1835);
	
	var _MultiselectInput2 = _interopRequireDefault(_MultiselectInput);
	
	var _MultiselectTagList = __webpack_require__(1836);
	
	var _MultiselectTagList2 = _interopRequireDefault(_MultiselectTagList);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(1787);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListGroupable = __webpack_require__(1793);
	
	var _ListGroupable2 = _interopRequireDefault(_ListGroupable);
	
	var _validateListInterface = __webpack_require__(1795);
	
	var _validateListInterface2 = _interopRequireDefault(_validateListInterface);
	
	var _dataHelpers = __webpack_require__(1781);
	
	var _interaction = __webpack_require__(1790);
	
	var _widgetHelpers = __webpack_require__(1789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var compatCreate = function compatCreate(props, msgs) {
	  return typeof msgs.createNew === 'function' ? msgs.createNew(props) : [_react2.default.createElement(
	    'strong',
	    { key: 'dumb' },
	    '"' + props.searchTerm + '"'
	  ), ' ' + msgs.createNew];
	};
	
	var splat = _3.default.splat;
	
	
	var propTypes = _extends({}, _Popup2.default.propTypes, {
	
	  data: _react2.default.PropTypes.array,
	  //-- controlled props --
	  value: _react2.default.PropTypes.array,
	  onChange: _react2.default.PropTypes.func,
	
	  searchTerm: _react2.default.PropTypes.string,
	  onSearch: _react2.default.PropTypes.func,
	
	  open: _react2.default.PropTypes.bool,
	  onToggle: _react2.default.PropTypes.func,
	  //-------------------------------------------
	
	  valueField: _react2.default.PropTypes.string,
	  textField: _propTypes2.default.accessor,
	
	  tagComponent: _propTypes2.default.elementType,
	  itemComponent: _propTypes2.default.elementType,
	  listComponent: _propTypes2.default.elementType,
	
	  groupComponent: _propTypes2.default.elementType,
	  groupBy: _propTypes2.default.accessor,
	
	  createComponent: _propTypes2.default.elementType,
	
	  onSelect: _react2.default.PropTypes.func,
	  onCreate: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.oneOf([false]), _react2.default.PropTypes.func]),
	
	  busy: _react2.default.PropTypes.bool,
	  dropUp: _react2.default.PropTypes.bool,
	
	  placeholder: _react2.default.PropTypes.string,
	
	  autoFocus: _react2.default.PropTypes.bool,
	  disabled: _propTypes2.default.disabled.acceptsArray,
	  readOnly: _propTypes2.default.readOnly.acceptsArray,
	
	  messages: _react2.default.PropTypes.shape({
	    open: _propTypes2.default.message,
	    emptyList: _propTypes2.default.message,
	    emptyFilter: _propTypes2.default.message,
	    createNew: _propTypes2.default.message
	  })
	});
	
	var Multiselect = _react2.default.createClass((_obj = {
	
	  displayName: 'Multiselect',
	
	  mixins: [__webpack_require__(1799), __webpack_require__(1802), __webpack_require__(1803), __webpack_require__(1808), __webpack_require__(1809)({
	    willHandle: function willHandle(focused) {
	      focused && this.focus();
	    },
	    didHandle: function didHandle(focused) {
	      if (!focused) this.close();
	
	      if (!focused && this.refs.tagList) this.setState({ focusedTag: null });
	
	      if (focused && !this.props.open) this.open();
	    }
	  }), __webpack_require__(1792)('input', function (key, id) {
	    var myKey = this.props.ariaActiveDescendantKey;
	
	
	    var createIsActive = (!this._data().length || this.state.focusedItem === null) && key === myKey;
	
	    var tagIsActive = this.state.focusedTag != null && key === 'taglist';
	    var listIsActive = this.state.focusedTag == null && key === 'list';
	
	    if (createIsActive || tagIsActive || listIsActive) return id;
	  })],
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      data: [],
	      filter: 'startsWith',
	      value: [],
	      open: false,
	      searchTerm: '',
	      ariaActiveDescendantKey: 'multiselect',
	      messages: {
	        createNew: '(create new tag)',
	        emptyList: 'There are no items in this list',
	        emptyFilter: 'The filter returned no results',
	        tagsLabel: 'selected items',
	        selectedItems: 'selected items',
	        noneSelected: 'no selected items',
	        removeLabel: 'remove selected item'
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var data = _props.data;
	    var value = _props.value;
	    var valueField = _props.valueField;
	    var searchTerm = _props.searchTerm;
	    var dataItems = splat(value).map(function (item) {
	      return (0, _dataHelpers.dataItem)(data, item, valueField);
	    });
	    var processedData = this.process(data, dataItems, searchTerm);
	
	    return {
	      focusedTag: null,
	      focusedItem: processedData[0],
	      processedData: processedData,
	      dataItems: dataItems
	    };
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.ariaActiveDescendant((0, _widgetHelpers.instanceId)(this, '__createlist_option'));
	
	    this.refs.list && (0, _validateListInterface2.default)(this.refs.list);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var data = nextProps.data;
	    var value = nextProps.value;
	    var valueField = nextProps.valueField;
	    var searchTerm = nextProps.searchTerm;
	    var values = _3.default.splat(value);
	    var current = this.state.focusedItem;
	    var items = this.process(data, values, searchTerm);
	
	    this.setState({
	      processedData: items,
	      focusedItem: items.indexOf(current) === -1 ? items[0] : current,
	      dataItems: values.map(function (item) {
	        return (0, _dataHelpers.dataItem)(data, item, valueField);
	      })
	    });
	  },
	  renderCreateItem: function renderCreateItem(id, messages) {
	    var _this = this;
	
	    var searchTerm = this.props.searchTerm;
	    var focusedItem = this.state.focusedItem;
	
	
	    var createIsFocused = !this._data().length || focusedItem === null;
	    var optionID = (0, _widgetHelpers.instanceId)(this, '__createlist_option');
	
	    return _react2.default.createElement(
	      'ul',
	      {
	        id: id,
	        role: 'listbox',
	        className: 'rw-list rw-multiselect-create-tag'
	      },
	      _react2.default.createElement(
	        'li',
	        {
	          id: optionID,
	          role: 'option',
	          onClick: function onClick() {
	            return _this.handleCreate(searchTerm);
	          },
	          className: (0, _classnames2.default)('rw-list-option', 'rw-create-list-option', createIsFocused && 'rw-state-focus')
	        },
	        compatCreate(this.props, messages)
	      )
	    );
	  },
	  renderInput: function renderInput(owns) {
	    var _props2 = this.props;
	    var searchTerm = _props2.searchTerm;
	    var maxLength = _props2.maxLength;
	    var tabIndex = _props2.tabIndex;
	    var busy = _props2.busy;
	    var open = _props2.open;
	    var disabled = _props2.disabled;
	    var readOnly = _props2.readOnly;
	
	
	    return _react2.default.createElement(_MultiselectInput2.default, {
	      ref: 'input',
	      tabIndex: tabIndex || 0,
	      role: 'listbox',
	      'aria-expanded': !!open,
	      'aria-busy': !!busy,
	      autoFocus: this.props.autoFocus,
	      'aria-owns': owns,
	      'aria-haspopup': true,
	      value: searchTerm,
	      maxLength: maxLength,
	      disabled: disabled === true,
	      readOnly: readOnly === true,
	      placeholder: this.getPlaceholder(),
	      onKeyDown: this.handleSearchKeyDown,
	      onKeyUp: this.handleSearchKeyUp,
	      onChange: this.handleInputChange,
	      onClick: this.handleInputInteraction,
	      onTouchEnd: this.handleInputInteraction
	    });
	  },
	  renderList: function renderList(List, id, messages) {
	    var _props3 = this.props;
	    var open = _props3.open;
	    var disabled = _props3.disabled;
	    var readOnly = _props3.readOnly;
	    var focusedItem = this.state.focusedItem;
	
	
	    var listProps = _3.default.pickProps(this.props, List);
	    var items = this._data();
	
	    return _react2.default.createElement(List, _extends({ ref: 'list',
	      key: 0
	    }, listProps, {
	      readOnly: readOnly,
	      disabled: disabled,
	      id: id,
	      'aria-live': 'polite',
	      'aria-labelledby': (0, _widgetHelpers.instanceId)(this),
	      'aria-hidden': !open,
	      ariaActiveDescendantKey: 'list',
	      data: items,
	      focused: focusedItem,
	      onSelect: this.handleSelect,
	      onMove: this._scrollTo,
	      messages: {
	        emptyList: this._lengthWithoutValues ? messages.emptyFilter : messages.emptyList
	      }
	    }));
	  },
	  renderNotificationArea: function renderNotificationArea(id, messages) {
	    var textField = this.props.textField;
	    var _state = this.state;
	    var focused = _state.focused;
	    var dataItems = _state.dataItems;
	
	
	    return _react2.default.createElement(
	      'span',
	      {
	        id: id,
	        role: 'status',
	        className: 'rw-sr',
	        'aria-live': 'assertive',
	        'aria-atomic': 'true',
	        'aria-relevant': 'additions removals text'
	      },
	      focused && (dataItems.length ? messages.selectedItems + ': ' + dataItems.map(function (item) {
	        return (0, _dataHelpers.dataText)(item, textField);
	      }).join(', ') : messages.noneSelected)
	    );
	  },
	  renderTags: function renderTags(id, messages) {
	    var _props4 = this.props;
	    var disabled = _props4.disabled;
	    var readOnly = _props4.readOnly;
	    var valueField = _props4.valueField;
	    var textField = _props4.textField;
	    var _state2 = this.state;
	    var focusedTag = _state2.focusedTag;
	    var dataItems = _state2.dataItems;
	
	
	    var Component = this.props.tagComponent;
	
	    return _react2.default.createElement(_MultiselectTagList2.default, {
	      ref: 'tagList',
	      id: id,
	      valueField: valueField,
	      textField: textField,
	      'aria-label': messages.tagsLabel,
	      value: dataItems,
	      focused: focusedTag,
	      disabled: disabled,
	      readOnly: readOnly,
	      onDelete: this.handleDelete,
	      valueComponent: Component,
	      ariaActiveDescendantKey: 'taglist'
	    });
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var _props5 = this.props;
	    var className = _props5.className;
	    var groupBy = _props5.groupBy;
	    var messages = _props5.messages;
	    var busy = _props5.busy;
	    var dropUp = _props5.dropUp;
	    var open = _props5.open;
	    var duration = _props5.duration;
	    var disabled = _props5.disabled;
	    var readOnly = _props5.readOnly;
	    var List = _props5.listComponent;
	    var _state3 = this.state;
	    var focused = _state3.focused;
	    var dataItems = _state3.dataItems;
	
	
	    List = List || groupBy && _ListGroupable2.default || _List2.default;
	
	    var elementProps = _3.default.omitOwnProps(this, List);
	
	    var shouldRenderTags = !!dataItems.length,
	        shouldRenderPopup = (0, _widgetHelpers.isFirstFocusedRender)(this) || open,
	        shouldShowCreate = this.shouldShowCreate();
	
	    var tagsID = (0, _widgetHelpers.instanceId)(this, '_taglist'),
	        listID = (0, _widgetHelpers.instanceId)(this, '__listbox'),
	        createID = (0, _widgetHelpers.instanceId)(this, '__createlist'),
	        notifyID = (0, _widgetHelpers.instanceId)(this, '__notify');
	
	    var inputOwns = listID + ' ' + notifyID + ' ' + (shouldRenderTags ? tagsID : '') + (shouldShowCreate ? createID : '');
	
	    messages = msgs(messages);
	
	    return _react2.default.createElement(
	      _Widget2.default,
	      _extends({}, elementProps, {
	        id: (0, _widgetHelpers.instanceId)(this),
	        open: open,
	        dropUp: dropUp,
	        focused: focused,
	        disabled: disabled === true,
	        readOnly: readOnly === true,
	        onKeyDown: this.handleKeyDown,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onTouchEnd: this.handleFocus,
	        className: (0, _classnames2.default)(className, 'rw-multiselect')
	      }),
	      this.renderNotificationArea(notifyID, messages),
	      _react2.default.createElement(
	        'div',
	        { className: 'rw-multiselect-wrapper' },
	        busy && _react2.default.createElement('i', { className: 'rw-i rw-loading' }),
	        shouldRenderTags && this.renderTags(tagsID, messages),
	        this.renderInput(inputOwns)
	      ),
	      shouldRenderPopup && _react2.default.createElement(
	        _Popup2.default,
	        {
	          dropUp: dropUp,
	          open: open,
	          duration: duration,
	          onOpening: function onOpening() {
	            return _this2.refs.list.forceUpdate();
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.renderList(List, listID, messages),
	          shouldShowCreate && this.renderCreateItem(createID, messages)
	        )
	      )
	    );
	  },
	  _data: function _data() {
	    return this.state.processedData;
	  },
	  handleDelete: function handleDelete(value) {
	    this.focus();
	    this.change(this.state.dataItems.filter(function (d) {
	      return d !== value;
	    }));
	  },
	  handleSearchKeyDown: function handleSearchKeyDown(e) {
	    if (e.key === 'Backspace' && e.target.value && !this._deletingText) this._deletingText = true;
	  },
	  handleSearchKeyUp: function handleSearchKeyUp(e) {
	    if (e.key === 'Backspace' && this._deletingText) this._deletingText = false;
	  },
	  handleInputChange: function handleInputChange(e) {
	    (0, _widgetHelpers.notify)(this.props.onSearch, [e.target.value]);
	    this.open();
	  },
	  handleInputInteraction: function handleInputInteraction() {
	    this.open();
	  },
	  handleSelect: function handleSelect(data) {
	    if (data === undefined) {
	      if (this.props.onCreate) this.handleCreate(this.props.searchTerm);
	
	      return;
	    }
	    (0, _widgetHelpers.notify)(this.props.onSelect, data);
	    this.change(this.state.dataItems.concat(data));
	
	    this.close();
	    this.focus();
	  },
	  handleCreate: function handleCreate(tag) {
	    if (tag.trim() === '') return;
	
	    (0, _widgetHelpers.notify)(this.props.onCreate, tag);
	    this.props.searchTerm && (0, _widgetHelpers.notify)(this.props.onSearch, ['']);
	
	    this.close();
	    this.focus();
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var key = e.key;
	    var altKey = e.altKey;
	    var ctrlKey = e.ctrlKey;
	    var noSearch = !this.props.searchTerm && !this._deletingText;
	    var isOpen = this.props.open;var _state4 = this.state;
	    var focusedTag = _state4.focusedTag;
	    var focusedItem = _state4.focusedItem;
	    var _refs = this.refs;
	    var list = _refs.list;
	    var tagList = _refs.tagList;
	
	    var nullTag = { focusedTag: null };
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	
	    if (e.defaultPrevented) return;
	
	    if (key === 'ArrowDown') {
	      var next = list.next(focusedItem),
	          creating = this.shouldShowCreate() && focusedItem === next || focusedItem === null;
	
	      next = creating ? null : next;
	
	      e.preventDefault();
	      if (isOpen) this.setState(_extends({ focusedItem: next }, nullTag));else this.open();
	    } else if (key === 'ArrowUp') {
	      var prev = focusedItem === null ? list.last() : list.prev(focusedItem);
	
	      e.preventDefault();
	
	      if (altKey) this.close();else if (isOpen) this.setState(_extends({ focusedItem: prev }, nullTag));
	    } else if (key === 'End') {
	      e.preventDefault();
	      if (isOpen) this.setState(_extends({ focusedItem: list.last() }, nullTag));else tagList && this.setState({ focusedTag: tagList.last() });
	    } else if (key === 'Home') {
	      e.preventDefault();
	      if (isOpen) this.setState(_extends({ focusedItem: list.first() }, nullTag));else tagList && this.setState({ focusedTag: tagList.first() });
	    } else if (isOpen && key === 'Enter') {
	      e.preventDefault();
	      ctrlKey && this.props.onCreate || focusedItem === null ? this.handleCreate(this.props.searchTerm) : this.handleSelect(this.state.focusedItem);
	    } else if (key === 'Escape') isOpen ? this.close() : tagList && this.setState(nullTag);else if (noSearch && key === 'ArrowLeft') tagList && this.setState({ focusedTag: tagList.prev(focusedTag) });else if (noSearch && key === 'ArrowRight') tagList && this.setState({ focusedTag: tagList.next(focusedTag) });else if (noSearch && key === 'Delete') tagList && tagList.remove(focusedTag);else if (noSearch && key === 'Backspace') tagList && tagList.removeNext();
	  },
	  change: function change(data) {
	    (0, _widgetHelpers.notify)(this.props.onChange, [data]);
	    (0, _widgetHelpers.notify)(this.props.onSearch, ['']);
	  },
	  focus: function focus() {
	    this.refs.input && this.refs.input.focus();
	  },
	  open: function open() {
	    if (!this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, true);
	  },
	  close: function close() {
	    (0, _widgetHelpers.notify)(this.props.onToggle, false);
	  },
	  toggle: function toggle() {
	    this.props.open ? this.close() : this.open();
	  },
	  process: function process(data, values, searchTerm) {
	    var valueField = this.props.valueField;
	
	    var items = data.filter(function (i) {
	      return !values.some(function (v) {
	        return (0, _dataHelpers.valueMatcher)(i, v, valueField);
	      });
	    });
	
	    this._lengthWithoutValues = items.length;
	
	    if (searchTerm) items = this.filter(items, searchTerm);
	
	    return items;
	  },
	  shouldShowCreate: function shouldShowCreate() {
	    var _props6 = this.props;
	    var textField = _props6.textField;
	    var searchTerm = _props6.searchTerm;
	    var onCreate = _props6.onCreate;
	    var caseSensitive = _props6.caseSensitive;
	
	
	    if (!onCreate || !searchTerm) return false;
	
	    var lower = function lower(text) {
	      return caseSensitive ? text : text.toLowerCase();
	    };
	    var eq = function eq(v) {
	      return lower((0, _dataHelpers.dataText)(v, textField)) === lower(searchTerm);
	    };
	
	    // if there is an exact match on textFields: "john" => { name: "john" }, don't show
	    return !this._data().some(eq) && !this.state.dataItems.some(eq);
	  },
	  getPlaceholder: function getPlaceholder() {
	    return (this.props.value || []).length ? '' : this.props.placeholder || '';
	  }
	}, (_applyDecoratedDescriptor(_obj, 'handleInputInteraction', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleInputInteraction'), _obj), _applyDecoratedDescriptor(_obj, 'handleSelect', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleSelect'), _obj), _applyDecoratedDescriptor(_obj, 'handleCreate', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleCreate'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyDown'), _obj), _applyDecoratedDescriptor(_obj, 'change', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'change'), _obj)), _obj));
	
	function msgs(msgs) {
	  return _extends({
	    createNew: '(create new tag)',
	    emptyList: 'There are no items in this list',
	    emptyFilter: 'The filter returned no results',
	    tagsLabel: 'selected items',
	    selectedItems: 'selected items',
	    removeLabel: 'remove selected item'
	  }, msgs);
	}
	
	exports.default = (0, _uncontrollable2.default)(Multiselect, { open: 'onToggle', value: 'onChange', searchTerm: 'onSearch' }, ['focus']);
	module.exports = exports['default'];

/***/ },
/* 1835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultiselectInput = (_temp = _class = function (_React$Component) {
	  _inherits(MultiselectInput, _React$Component);
	
	  function MultiselectInput() {
	    _classCallCheck(this, MultiselectInput);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MultiselectInput.prototype.render = function render() {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var readOnly = _props.readOnly;
	
	    var props = _objectWithoutProperties(_props, ['disabled', 'readOnly']);
	
	    var size = Math.max((props.value || props.placeholder).length, 1) + 1;
	
	    return _react2.default.createElement('input', _extends({}, props, {
	      size: size,
	      className: 'rw-input',
	      autoComplete: 'off',
	      'aria-disabled': disabled,
	      'aria-readonly': readOnly,
	      disabled: disabled,
	      readOnly: readOnly
	    }));
	  };
	
	  MultiselectInput.prototype.focus = function focus() {
	    _compat2.default.findDOMNode(this).focus();
	  };
	
	  return MultiselectInput;
	}(_react2.default.Component), _class.propTypes = {
	  value: _react2.default.PropTypes.string,
	  placeholder: _react2.default.PropTypes.string,
	  maxLength: _react2.default.PropTypes.number,
	  onChange: _react2.default.PropTypes.func.isRequired,
	
	  disabled: _propTypes2.default.disabled,
	  readOnly: _propTypes2.default.readOnly
	}, _temp);
	exports.default = MultiselectInput;
	module.exports = exports['default'];

/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _widgetHelpers = __webpack_require__(1789);
	
	var _dataHelpers = __webpack_require__(1781);
	
	var _interaction = __webpack_require__(1790);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var optionId = function optionId(id, idx) {
	  return id + '__option__' + idx;
	};
	
	exports.default = _react2.default.createClass({
	  displayName: 'MultiselectTagList',
	
	
	  mixins: [__webpack_require__(1801), __webpack_require__(1792)()],
	
	  propTypes: {
	    value: _react2.default.PropTypes.array,
	    focused: _react2.default.PropTypes.number,
	
	    valueField: _react2.default.PropTypes.string,
	    textField: _propTypes2.default.accessor,
	
	    onDelete: _react2.default.PropTypes.func.isRequired,
	    valueComponent: _react2.default.PropTypes.func,
	
	    disabled: _propTypes2.default.disabled.acceptsArray,
	    readOnly: _propTypes2.default.readOnly.acceptsArray
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      ariaActiveDescendantKey: 'taglist'
	    };
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var focused = this.props.focused;
	    var activeId = optionId((0, _widgetHelpers.instanceId)(this), focused);
	
	    this.ariaActiveDescendant(focused == null || (0, _interaction.isDisabledItem)(focused, this.props) ? null : activeId);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var focused = _props.focused;
	    var value = _props.value;
	    var textField = _props.textField;
	    var ValueComponent = _props.valueComponent;
	
	
	    var id = (0, _widgetHelpers.instanceId)(this);
	    var props = _3.default.omitOwnProps(this);
	
	    return _react2.default.createElement(
	      'ul',
	      _extends({}, props, {
	        role: 'listbox',
	        tabIndex: '-1',
	        className: 'rw-multiselect-taglist'
	      }),
	      value.map(function (item, i) {
	        var isDisabled = (0, _interaction.isDisabledItem)(item, _this.props),
	            isReadonly = (0, _interaction.isReadOnlyItem)(item, _this.props),
	            isFocused = !isDisabled && focused === i,
	            currentID = optionId(id, i);
	
	        return _react2.default.createElement(
	          'li',
	          {
	            key: i,
	            id: currentID,
	            tabIndex: '-1',
	            role: 'option',
	            className: (0, _classnames2.default)({
	              'rw-state-focus': isFocused,
	              'rw-state-disabled': isDisabled,
	              'rw-state-readonly': isReadonly
	            })
	          },
	          ValueComponent ? _react2.default.createElement(ValueComponent, { item: item }) : (0, _dataHelpers.dataText)(item, textField),
	          _react2.default.createElement(
	            'span',
	            {
	              tabIndex: '-1',
	              onClick: !(isDisabled || isReadonly) ? _this._delete.bind(null, item) : undefined,
	              'aria-disabled': isDisabled,
	              'aria-label': 'Unselect',
	              disabled: isDisabled
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'rw-tag-btn', 'aria-hidden': 'true' },
	              '×'
	            )
	          )
	        );
	      })
	    );
	  },
	  _delete: function _delete(val) {
	    this.props.onDelete(val);
	  },
	  remove: function remove(idx) {
	    var val = this.props.value[idx];
	
	    if (val && !((0, _interaction.isDisabledItem)(val, this.props) || (0, _interaction.isReadOnlyItem)(val, this.props))) this.props.onDelete(val);
	  },
	  removeNext: function removeNext() {
	    var val = this.props.value[this.props.value.length - 1];
	
	    if (val && !((0, _interaction.isDisabledItem)(val, this.props) || (0, _interaction.isReadOnlyItem)(val, this.props))) this.props.onDelete(val);
	  },
	  clear: function clear() {
	    this.setState({ focused: null });
	  },
	  first: function first() {
	    var idx = 0,
	        value = this.props.value,
	        l = value.length;
	
	    while (idx < l && (0, _interaction.isDisabledItem)(value[idx], this.props)) {
	      idx++;
	    }return idx !== l ? idx : null;
	  },
	  last: function last() {
	    var value = this.props.value,
	        idx = value.length - 1;
	
	    while (idx > -1 && (0, _interaction.isDisabledItem)(value[idx], this.props)) {
	      idx--;
	    }return idx >= 0 ? idx : null;
	  },
	  next: function next(current) {
	    var nextIdx = current + 1,
	        value = this.props.value,
	        l = value.length;
	
	    while (nextIdx < l && (0, _interaction.isDisabledItem)(nextIdx, this.props)) {
	      nextIdx++;
	    }if (current === null || nextIdx >= l) return null;
	
	    return nextIdx;
	  },
	  prev: function prev(current) {
	    var nextIdx = current,
	        value = this.props.value;
	
	    if (nextIdx === null || nextIdx === 0) nextIdx = value.length;
	
	    nextIdx--;
	
	    while (nextIdx > -1 && (0, _interaction.isDisabledItem)(value[nextIdx], this.props)) {
	      nextIdx--;
	    }return nextIdx >= 0 ? nextIdx : null;
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _desc, _value, _obj;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _2 = __webpack_require__(1769);
	
	var _3 = _interopRequireDefault(_2);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _uncontrollable = __webpack_require__(1796);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _compat = __webpack_require__(1786);
	
	var _compat2 = _interopRequireDefault(_compat);
	
	var _propTypes = __webpack_require__(1779);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(1787);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListGroupable = __webpack_require__(1793);
	
	var _ListGroupable2 = _interopRequireDefault(_ListGroupable);
	
	var _ListOption = __webpack_require__(1788);
	
	var _ListOption2 = _interopRequireDefault(_ListOption);
	
	var _Widget = __webpack_require__(1774);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _validateListInterface = __webpack_require__(1795);
	
	var _validateListInterface2 = _interopRequireDefault(_validateListInterface);
	
	var _scrollTo2 = __webpack_require__(1804);
	
	var _scrollTo3 = _interopRequireDefault(_scrollTo2);
	
	var _dataHelpers = __webpack_require__(1781);
	
	var _interaction = __webpack_require__(1790);
	
	var _widgetHelpers = __webpack_require__(1789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var find = _3.default.find;
	
	
	var propTypes = {
	
	  data: _react2.default.PropTypes.array,
	  value: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.any, _react2.default.PropTypes.array]),
	  onChange: _react2.default.PropTypes.func,
	  onMove: _react2.default.PropTypes.func,
	
	  multiple: _react2.default.PropTypes.bool,
	
	  itemComponent: _propTypes2.default.elementType,
	  listComponent: _propTypes2.default.elementType,
	
	  valueField: _react2.default.PropTypes.string,
	  textField: _propTypes2.default.accessor,
	
	  busy: _react2.default.PropTypes.bool,
	
	  filter: _react2.default.PropTypes.string,
	  delay: _react2.default.PropTypes.number,
	
	  disabled: _propTypes2.default.disabled.acceptsArray,
	  readOnly: _propTypes2.default.readOnly.acceptsArray,
	
	  messages: _react2.default.PropTypes.shape({
	    emptyList: _react2.default.PropTypes.string
	  })
	};
	
	function getFirstValue(props) {
	  var data = props.data;
	  var value = props.value;
	  var valueField = props.valueField;
	
	  value = _3.default.splat(value);
	
	  if (value.length) return find(data, function (d) {
	    return (0, _dataHelpers.dataIndexOf)(value, d, valueField) !== -1;
	  }) || null;
	
	  return null;
	}
	
	var SelectList = _react2.default.createClass((_obj = {
	  displayName: 'SelectList',
	
	
	  propTypes: propTypes,
	
	  mixins: [__webpack_require__(1799), __webpack_require__(1800), __webpack_require__(1808), __webpack_require__(1792)(), __webpack_require__(1809)({
	    didHandle: function didHandle(focused) {
	      // the rigamarole here is to avoid flicker went clicking an item and
	      // gaining focus at the same time.
	      if (focused !== this.state.focused) {
	        if (!focused) this.setState({ focusedItem: null });else if (focused && !this._clicking) this.setState({
	          focusedItem: getFirstValue(this.props)
	        });
	        this._clicking = false;
	      }
	    }
	  })],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      delay: 250,
	      value: [],
	      data: [],
	      ariaActiveDescendantKey: 'selectlist',
	      messages: {
	        emptyList: 'There are no items in this list'
	      }
	    };
	  },
	  getDefaultState: function getDefaultState(props) {
	    var data = props.data;
	    var value = props.value;
	    var valueField = props.valueField;
	    var multiple = props.multiple;
	
	
	    return {
	      dataItems: multiple && _3.default.splat(value).map(function (item) {
	        return (0, _dataHelpers.dataItem)(data, item, valueField);
	      })
	    };
	  },
	  getInitialState: function getInitialState() {
	    var state = this.getDefaultState(this.props);
	
	    state.ListItem = getListItem(this);
	
	    return state;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    return this.setState(this.getDefaultState(nextProps));
	  },
	  componentDidMount: function componentDidMount() {
	    (0, _validateListInterface2.default)(this.refs.list);
	  },
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var tabIndex = _props.tabIndex;
	    var busy = _props.busy;
	    var groupBy = _props.groupBy;
	    var List = _props.listComponent;
	
	
	    List = List || groupBy && _ListGroupable2.default || _List2.default;
	
	    var elementProps = _3.default.omitOwnProps(this, List);
	    var listProps = _3.default.pickProps(this.props, List);
	
	    var _state = this.state;
	    var ListItem = _state.ListItem;
	    var focusedItem = _state.focusedItem;
	    var focused = _state.focused;
	
	
	    var items = this._data();
	
	    focusedItem = focused && !(0, _interaction.isDisabled)(this.props) && !(0, _interaction.isReadOnly)(this.props) && focusedItem;
	
	    return _react2.default.createElement(
	      _Widget2.default,
	      _extends({}, elementProps, {
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onKeyPress: this.handleKeyPress,
	        disabled: (0, _interaction.isDisabled)(this.props),
	        readOnly: (0, _interaction.isReadOnly)(this.props),
	        role: 'radiogroup',
	        'aria-busy': !!busy,
	        className: (0, _classnames2.default)(className, 'rw-selectlist', busy && 'rw-loading-mask')
	      }),
	      _react2.default.createElement(List, _extends({}, listProps, {
	        ref: 'list',
	        role: 'radiogroup',
	        tabIndex: tabIndex || '0',
	        id: (0, _widgetHelpers.instanceId)(this, '_listbox'),
	        data: items,
	        focused: focusedItem,
	        optionComponent: ListItem,
	        itemComponent: this.props.itemComponent,
	        onMove: this._scrollTo
	      }))
	    );
	  },
	  _scrollTo: function _scrollTo(selected, list) {
	    var handler = this.props.onMove;
	
	    if (handler) handler(selected, list);else {
	      this._scrollCancel && this._scrollCancel();
	      // default behavior is to scroll the whole page not just the widget
	      this._scrollCancel = (0, _scrollTo3.default)(selected);
	    }
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    var _this = this;
	
	    var key = e.key;
	    var _props2 = this.props;
	    var valueField = _props2.valueField;
	    var multiple = _props2.multiple;
	    var list = this.refs.list;
	    var focusedItem = this.state.focusedItem;
	
	    var change = function change(item) {
	      if (item) _this.handleChange(item, multiple ? !(0, _interaction.contains)(item, _this._values(), valueField) // toggle value
	      : true);
	    };
	
	    (0, _widgetHelpers.notify)(this.props.onKeyDown, [e]);
	
	    if (e.defaultPrevented) return;
	
	    if (key === 'End') {
	      e.preventDefault();
	      focusedItem = list.last();
	
	      this.setState({ focusedItem: focusedItem });
	      if (!multiple) change(focusedItem);
	    } else if (key === 'Home') {
	      e.preventDefault();
	      focusedItem = list.first();
	
	      this.setState({ focusedItem: focusedItem });
	      if (!multiple) change(focusedItem);
	    } else if (key === 'Enter' || key === ' ') {
	      e.preventDefault();
	      change(focusedItem);
	    } else if (key === 'ArrowDown' || key === 'ArrowRight') {
	      e.preventDefault();
	      focusedItem = list.next(focusedItem);
	
	      this.setState({ focusedItem: focusedItem });
	      if (!multiple) change(focusedItem);
	    } else if (key === 'ArrowUp' || key === 'ArrowLeft') {
	      e.preventDefault();
	      focusedItem = list.prev(focusedItem);
	
	      this.setState({ focusedItem: focusedItem });
	      if (!multiple) change(focusedItem);
	    } else if (multiple && e.keyCode === 65 && e.ctrlKey) {
	      e.preventDefault();
	      this.selectAll();
	    }
	  },
	  handleKeyPress: function handleKeyPress(e) {
	    (0, _widgetHelpers.notify)(this.props.onKeyPress, [e]);
	
	    if (e.defaultPrevented) return;
	
	    this.search(String.fromCharCode(e.which));
	  },
	  focus: function focus() {
	    _compat2.default.findDOMNode(this.refs.list).focus();
	  },
	  selectAll: function selectAll() {
	    var _this2 = this;
	
	    var _props3 = this.props;
	    var disabled = _props3.disabled;
	    var readOnly = _props3.readOnly;
	    var valueField = _props3.valueField;
	    var values = this.state.dataItems;
	    var data = this._data();
	    var blacklist;
	
	    disabled = disabled || readOnly;
	    disabled = Array.isArray(disabled) ? disabled : [];
	    //disabled values that are not selected
	    blacklist = disabled.filter(function (v) {
	      return !(0, _interaction.contains)(v, values, valueField);
	    });
	    data = data.filter(function (v) {
	      return !(0, _interaction.contains)(v, blacklist, valueField);
	    });
	
	    if (data.length === values.length) {
	      data = disabled.filter(function (item) {
	        return (0, _interaction.contains)(item, values, valueField);
	      });
	      data = data.map(function (item) {
	        return (0, _dataHelpers.dataItem)(_this2._data(), item, valueField);
	      });
	    }
	
	    (0, _widgetHelpers.notify)(this.props.onChange, [data]);
	  },
	  handleChange: function handleChange(item, checked) {
	    var multiple = this.props.multiple;
	    var values = this.state.dataItems;
	
	    multiple = !!multiple;
	
	    this.clearTimeout('focusedItem');
	    this.setState({ focusedItem: item });
	
	    if (!multiple) return (0, _widgetHelpers.notify)(this.props.onChange, checked ? item : null);
	
	    values = checked ? values.concat(item) : values.filter(function (v) {
	      return v !== item;
	    });
	
	    (0, _widgetHelpers.notify)(this.props.onChange, [values || []]);
	  },
	  search: function search(character) {
	    var _this3 = this;
	
	    var word = ((this._searchTerm || '') + character).toLowerCase(),
	        list = this.refs.list,
	        multiple = this.props.multiple;
	
	    if (!character) return;
	
	    this._searchTerm = word;
	
	    this.setTimeout('search', function () {
	      var focusedItem = list.next(_this3.state.focusedItem, word);
	
	      _this3._searchTerm = '';
	
	      if (focusedItem) {
	        !multiple ? _this3.handleChange(focusedItem, true) : _this3.setState({ focusedItem: focusedItem });
	      }
	    }, this.props.delay);
	  },
	  _data: function _data() {
	    return this.props.data;
	  },
	  _values: function _values() {
	    return this.props.multiple ? this.state.dataItems : this.props.value;
	  }
	}, (_applyDecoratedDescriptor(_obj, 'handleKeyDown', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyDown'), _obj), _applyDecoratedDescriptor(_obj, 'handleKeyPress', [_interaction.widgetEditable], Object.getOwnPropertyDescriptor(_obj, 'handleKeyPress'), _obj)), _obj));
	
	function getListItem(parent) {
	
	  return _react2.default.createClass({
	
	    displayName: 'SelectItem',
	
	    handleChange: function handleChange(e) {
	      var _props4 = this.props;
	      var disabled = _props4.disabled;
	      var readonly = _props4.readonly;
	      var dataItem = _props4.dataItem;
	
	
	      if (!disabled && !readonly) parent.handleChange(dataItem, e.target.checked);
	    },
	    handleMouseDown: function handleMouseDown() {
	      parent._clicking = true;
	    },
	    render: function render() {
	      var _props5 = this.props;
	      var children = _props5.children;
	      var disabled = _props5.disabled;
	      var readonly = _props5.readonly;
	      var item = _props5.dataItem;
	      var _parent$props = parent.props;
	      var multiple = _parent$props.multiple;
	      var _parent$props$name = _parent$props.name;
	      var name = _parent$props$name === undefined ? (0, _widgetHelpers.instanceId)(parent, '_name') : _parent$props$name;
	
	
	      var checked = (0, _interaction.contains)(item, parent._values(), parent.props.valueField),
	          type = multiple ? 'checkbox' : 'radio';
	
	      return _react2.default.createElement(
	        _ListOption2.default,
	        _extends({}, this.props, {
	          role: type,
	          'aria-checked': !!checked
	        }),
	        _react2.default.createElement(
	          'label',
	          { onMouseDown: this.handleMouseDown },
	          _react2.default.createElement('input', {
	            name: name,
	            type: type,
	            tabIndex: '-1',
	            role: 'presentation',
	            checked: checked,
	            disabled: disabled || readonly,
	            onChange: this.handleChange
	          }),
	          children
	        )
	      );
	    }
	  });
	}
	
	exports.default = (0, _uncontrollable2.default)(SelectList, { value: 'onChange' }, ['selectAll', 'focus']);
	module.exports = exports['default'];

/***/ },
/* 1838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(1839);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// XXX kill this mixin. Complicates DatePickerInput
	/*  weak */
	var DateTimePickerMixin = {
	  getInitialState: function getInitialState() {
	    return {
	      opened: this.props.autofocus,
	      focused: false
	    };
	  },
	  updatePositionForTopPlacement: function updatePositionForTopPlacement() {
	    var nodes = this.getPopupNodes();
	    for (var i = 0; i < nodes.length; i++) {
	      var node = nodes[i];
	      var popup = node.getElementsByClassName('rw-popup')[0];
	      if (popup) {
	        popup.style.top = -parseInt(popup.offsetHeight, 10) - 36 + 'px';
	      }
	    }
	  },
	  getPopupNodes: function getPopupNodes() {
	    if (this.refs.picker) {
	      var root = _reactDom2.default.findDOMNode(this.refs.picker);
	      return root.getElementsByClassName('rw-popup-container');
	    }
	    return [];
	  },
	  handleClick: function handleClick(e) {
	    var _this = this;
	
	    var clickedPopup = false;
	    [].forEach.call(this.getPopupNodes(), function (n) {
	      if (n.contains(e.target)) {
	        clickedPopup = true;
	      }
	    });
	
	    if (!clickedPopup) {
	      // if we didn't click the popup, toggle the popup
	      this.setState({ opened: !this.state.opened });
	    }
	
	    // Hack to update positioning based on the new height
	    if (this.props.placement === 'top') {
	      setTimeout(function () {
	        return _this.updatePositionForTopPlacement();
	      }, 1);
	    }
	  },
	  isOpen: function isOpen() {
	    return this.state.opened;
	  },
	  isFocused: function isFocused() {
	    return this.state.focused;
	  },
	  closePopup: function closePopup() {
	    if (this.state.opened) {
	      this.setState({ opened: false });
	    }
	  },
	  handleFocus: function handleFocus() {
	    this.setState({ focused: true });
	  },
	  handleBlur: function handleBlur() {
	    this.setState({ focused: false });
	    this.closePopup();
	  },
	  handleChange: function handleChange() {
	    this.setState({ opened: false });
	  }
	};
	
	exports.default = DateTimePickerMixin;

/***/ },
/* 1839 */
1136,
/* 1840 */,
/* 1841 */
1136,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */
1136,
/* 1852 */,
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(555);
	
	var _TimePickerInput = __webpack_require__(1854);
	
	var _TimePickerInput2 = _interopRequireDefault(_TimePickerInput);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Formsy = __webpack_require__(1345);
	
	var _Formsy2 = _interopRequireDefault(_Formsy);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'FormTimePickerInput',
	
	
	  mixins: [_Formsy2.default.Mixin],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      showErrorAfterBlur: false,
	      showErrorOnPristine: true
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      wasBlur: false,
	      value: this.props.value
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.id = (0, _lodash.uniqueId)('id-');
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.value) {
	      this.onChange(this.props.value);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.value !== nextProps.value) {
	      this.setState({ value: nextProps.value });
	    }
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !(0, _lodash.isEqual)(this.props, nextProps) || !(0, _lodash.isEqual)(this.state, nextState);
	  },
	  onChange: function onChange(value) {
	    this.setState({ value: value });
	    this.setValue(value);
	  },
	  onBlur: function onBlur() {
	    if (this.state.wasBlur === false) {
	      this.setState({ wasBlur: true });
	    }
	  },
	  renderLabel: function renderLabel() {
	    var label = this.props.label;
	
	
	    if (label) {
	      return _react2.default.createElement(
	        _Label2.default,
	        { htmlFor: this.id, hidden: this.props.labelHidden },
	        label
	      );
	    } else {
	      return null;
	    }
	  },
	  render: function render() {
	    var error = this.getErrorMessage();
	
	    if (this.props.showErrorAfterBlur && !this.state.wasBlur) {
	      error = null;
	    }
	
	    return _react2.default.createElement(
	      _Field2.default,
	      { className: 'FormTimePickerInput', error: error },
	      this.renderLabel(),
	      _react2.default.createElement(_TimePickerInput2.default, _extends({}, this.props, {
	        value: this.state.value,
	        className: (0, _classnames2.default)(this.props.className, 'FormTimePickerInput-input', {
	          'FormTimePickerInput-input-error': !!error
	        }),
	        onBlur: (0, _createChainedFunction2.default)(this.props.onBlur, this.onBlur),
	        onChange: (0, _createChainedFunction2.default)(this.props.onChange, this.onChange)
	      }))
	    );
	  }
	});

/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactWidgets = __webpack_require__(1750);
	
	var _DateTimePickerMixin = __webpack_require__(1838);
	
	var _DateTimePickerMixin2 = _interopRequireDefault(_DateTimePickerMixin);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _constants = __webpack_require__(1821);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1855);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimePickerInput = _react2.default.createClass({
	  displayName: 'TimePickerInput',
	
	
	  mixins: [_DateTimePickerMixin2.default],
	
	  statics: {
	    propClasses: {
	      placement: {
	        top: 'DateTimePicker-top',
	        bottom: 'DateTimePicker-bottom'
	      }
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      placement: 'bottom'
	    };
	  },
	  onClick: function onClick(event) {
	    if (!this.props.disabled) {
	      this.handleClick(event);
	    }
	  },
	  render: function render() {
	    var open = this.isOpen() ? _constants.datePopups.TIME : false;
	    var _props = this.props,
	        value = _props.value,
	        min = _props.min,
	        max = _props.max,
	        placeholder = _props.placeholder,
	        className = _props.className,
	        disabled = _props.disabled,
	        onFocus = _props.onFocus,
	        onChange = _props.onChange;
	
	    var timePickerClass = (0, _classnames2.default)('TimePickerInput', 'DateTimePicker', className, {
	      'is-focused': this.isFocused()
	    });
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(timePickerClass, (0, _getPropClasses.getPropClassesFromInstance)(this), {
	          'TimePickerInput-disabled': disabled
	        }),
	        onClick: this.onClick },
	      _react2.default.createElement(_Glyph2.default, { name: 'clock', size: 'medium', color: 'eclipse' }),
	      _react2.default.createElement(_ReactWidgets.DateTimePicker, {
	        'data-test': this.props['data-test'],
	        ref: 'picker',
	        value: value,
	        min: min,
	        max: max,
	        placeholder: placeholder,
	        open: open,
	        format: 'h:mm tt',
	        parse: ['h:mm tt', 'h:mmtt', 'HH:mm'],
	        step: 5,
	        duration: 0,
	        onFocus: (0, _createChainedFunction2.default)(this.handleFocus, onFocus),
	        onBlur: this.handleBlur,
	        onKeyDown: this.closePopup,
	        onChange: (0, _createChainedFunction2.default)(this.handleChange, onChange),
	        onToggle: function onToggle() {},
	        className: (0, _classnames2.default)({
	          'TimePickerInput-disabled': disabled
	        })
	      })
	    );
	  }
	}); /*  weak */
	exports.default = TimePickerInput;

/***/ },
/* 1855 */
1136,
/* 1856 */,
/* 1857 */
1136,
/* 1858 */,
/* 1859 */
1136,
/* 1860 */,
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1862);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageControls = function (_Component) {
	  _inherits(PageControls, _Component);
	
	  function PageControls() {
	    _classCallCheck(this, PageControls);
	
	    return _possibleConstructorReturn(this, (PageControls.__proto__ || Object.getPrototypeOf(PageControls)).apply(this, arguments));
	  }
	
	  _createClass(PageControls, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('PageControls', this.props.className) },
	        this.props.onBack && _react2.default.createElement(
	          _Button2.default,
	          {
	            'data-test': 'page-controls-back',
	            size: 'small',
	            level: 'secondary',
	            onClick: this.props.onBack },
	          'Back'
	        ),
	        this.props.onPreview && _react2.default.createElement(
	          _Button2.default,
	          {
	            size: 'small',
	            level: 'secondary',
	            className: 'PageControls-preview',
	            onClick: this.props.onPreview,
	            eventElementName: 'PageControls-preview' },
	          'Preview'
	        ),
	        this.props.onNext && _react2.default.createElement(
	          _Button2.default,
	          {
	            'data-test': 'page-controls-next',
	            size: 'small',
	            disabled: !!this.props.disabledNext,
	            onClick: this.props.onNext },
	          this.props.nextText || 'Next'
	        )
	      );
	    }
	  }]);
	
	  return PageControls;
	}(_react.Component);
	
	PageControls.displayName = 'PageControls';
	exports.default = PageControls;

/***/ },
/* 1862 */
1136,
/* 1863 */,
/* 1864 */
1136,
/* 1865 */,
/* 1866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _PageControls = __webpack_require__(1861);
	
	var _PageControls2 = _interopRequireDefault(_PageControls);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormMoneyInput = __webpack_require__(1867);
	
	var _FormMoneyInput2 = _interopRequireDefault(_FormMoneyInput);
	
	var _Checkbox = __webpack_require__(1388);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	__webpack_require__(1873);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityAnnouncementAmountForm = function (_React$Component) {
	  _inherits(ActivityAnnouncementAmountForm, _React$Component);
	
	  function ActivityAnnouncementAmountForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityAnnouncementAmountForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityAnnouncementAmountForm.__proto__ || Object.getPrototypeOf(ActivityAnnouncementAmountForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      amount: _this.props.initialAmount || 0,
	      collectOnline: _this.props.initialCollectedOnline === undefined ? true : _this.props.initialCollectedOnline,
	      isAmountValid: true
	    }, _this.onAmountValid = function (amount) {
	      _this.setState({ amount: amount, isAmountValid: true });
	    }, _this.onAmountInvalid = function () {
	      if (_this.state.isAmountValid) {
	        _this.setState({ isAmountValid: false });
	      }
	    }, _this.onBack = function () {
	      _this.props.onBack({
	        amount: _this.state.amount,
	        collectOnline: _this.state.collectOnline
	      });
	    }, _this.onNext = function () {
	      _this.props.onNext({
	        amount: _this.state.amount,
	        collectOnline: _this.state.collectOnline
	      });
	    }, _this.toggleCollectOnline = function () {
	      _this.setState(function (_ref2) {
	        var collectOnline = _ref2.collectOnline;
	        return { collectOnline: !collectOnline };
	      });
	    }, _this.isValid = function () {
	      return _this.state.isAmountValid;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityAnnouncementAmountForm, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityAnnouncementAmountForm-amountInput' },
	          _react2.default.createElement(_FormMoneyInput2.default, {
	            allowZeroValue: true,
	            onValidChange: this.onAmountValid,
	            onInvalidChange: this.onAmountInvalid,
	            initialCentValue: this.props.initialAmount,
	            currency: 'USD'
	          }),
	          this.state.amount > 0 && _react2.default.createElement(_Checkbox2.default, {
	            name: 'collect_online',
	            label: 'Use Remind to collect funds for this activity',
	            checked: this.state.collectOnline,
	            onChange: this.toggleCollectOnline
	          })
	        ),
	        _react2.default.createElement(_PageControls2.default, {
	          className: 'ActivityAnnouncementAmountForm-controls',
	          disabledNext: !this.isValid(),
	          nextText: this.state.amount === 0 ? 'Skip' : 'Next',
	          onBack: this.onBack,
	          onNext: this.onNext
	        })
	      );
	    }
	  }]);
	
	  return ActivityAnnouncementAmountForm;
	}(_react2.default.Component);
	
	ActivityAnnouncementAmountForm.displayName = 'ActivityAnnouncementAmountForm';
	exports.default = ActivityAnnouncementAmountForm;

/***/ },
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _MoneyFormatter = __webpack_require__(1653);
	
	var _MoneyFormatter2 = _interopRequireDefault(_MoneyFormatter);
	
	var _MoneyInput = __webpack_require__(1868);
	
	var _MoneyInput2 = _interopRequireDefault(_MoneyInput);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	__webpack_require__(1871);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_MAX = 200000;
	var DEFAULT_MIN = 0;
	
	var FormMoneyInput = function (_React$Component) {
	  _inherits(FormMoneyInput, _React$Component);
	
	  function FormMoneyInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FormMoneyInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormMoneyInput.__proto__ || Object.getPrototypeOf(FormMoneyInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      error: null,
	      wasBlur: false
	    }, _this.onChange = function (_ref2) {
	      var value = _ref2.value;
	
	      var error = _this.getError(value);
	
	      if (error) {
	        _this.setState({ error: error }, function () {
	          return _this.props.onInvalidChange();
	        });
	      } else {
	        _this.setState({ error: null }, function () {
	          return _this.props.onValidChange(value);
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // $FlowFixMe destructuring
	
	
	  _createClass(FormMoneyInput, [{
	    key: 'getError',
	    value: function getError(value) {
	      var max = _SettingsStore2.default.getMaxPaymentPerPerson() || DEFAULT_MAX;
	      var min = this.props.minimum || _SettingsStore2.default.getMinPaymentPerPerson() || DEFAULT_MIN;
	
	      if (value === 0 && this.props.allowZeroValue) {
	        return null;
	      }
	
	      if (value < min) {
	        return 'Minimum amount is  ' + new _MoneyFormatter2.default(min);
	      }
	
	      if (value > max) {
	        return 'Maximum amount is ' + new _MoneyFormatter2.default(max);
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var error = this.state.wasBlur && this.state.error;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('FormMoneyInput', {
	            'FormMoneyInput-error': error
	          }),
	          onClick: function onClick() {
	            return _this2.refs.input.focus();
	          } },
	        _react2.default.createElement(
	          _Field2.default,
	          { error: error },
	          _react2.default.createElement(
	            _Label2.default,
	            { hidden: true },
	            'Amount'
	          ),
	          _react2.default.createElement(_MoneyInput2.default, _extends({}, this.props, {
	            ref: 'input',
	            onChange: this.onChange,
	            onBlur: function onBlur() {
	              return _this2.setState({ wasBlur: true });
	            }
	          }))
	        )
	      );
	    }
	  }]);
	
	  return FormMoneyInput;
	}(_react2.default.Component);
	
	FormMoneyInput.displayName = 'FormMoneyInput';
	exports.default = FormMoneyInput;

/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactInputAutosize = __webpack_require__(1368);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _focusNode = __webpack_require__(1210);
	
	var _focusNode2 = _interopRequireDefault(_focusNode);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1869);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHARACTERISTIC_EMPTY_CHAR = '0';
	var CHARACTERISTIC_MAX_DIGIT = 4;
	var MANTISSA_MAX_DIGITS = 2;
	var CENTS_PER_DOLLAR = 100;
	
	// For the following number: 8.22, characteristic = 8 ; mantissa = 0.22.
	// inside this component the mentissa is considered a natural number (22).
	// http://www.math-for-all-grades.com/CharacteristicandMantissa.html
	
	var MoneyInput = function (_React$Component) {
	  _inherits(MoneyInput, _React$Component);
	
	  function MoneyInput(props) {
	    _classCallCheck(this, MoneyInput);
	
	    var _this = _possibleConstructorReturn(this, (MoneyInput.__proto__ || Object.getPrototypeOf(MoneyInput)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var initialCentValue = props.initialCentValue;
	
	
	    if (!initialCentValue) {
	      _this.state = {
	        characteristic: CHARACTERISTIC_EMPTY_CHAR,
	        showMantissa: false,
	        mantissa: null,
	        focus: false
	      };
	
	      return _possibleConstructorReturn(_this);
	    }
	
	    var dollar = initialCentValue / CENTS_PER_DOLLAR;
	
	    if (dollar % 1) {
	      dollar = dollar.toFixed(2);
	    }
	
	    var characteristic = dollar.toString().split('.')[0];
	    var mantissa = dollar.toString().split('.')[1];
	
	    _this.state = {
	      characteristic: characteristic,
	      showMantissa: !!mantissa,
	      mantissa: mantissa,
	      focus: false
	    };
	    return _this;
	  }
	
	  _createClass(MoneyInput, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autofocus) {
	        this.focusCharacteristic();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onBlur: this.props.onBlur,
	          className: (0, _classnames2.default)(this.props.className, 'MoneyInput', {
	            'MoneyInput-empty': this.state.characteristic[0] === CHARACTERISTIC_EMPTY_CHAR,
	            'MoneyInput-animation': this.state.animation,
	            'MoneyInput-border': this.props.border,
	            'MoneyInput-focus': this.state.focus
	          }) },
	        _react2.default.createElement(
	          'span',
	          { className: 'MoneyInput-currencySymbol' },
	          this.renderCurrencySymbol()
	        ),
	        _react2.default.createElement(_reactInputAutosize2.default, {
	          className: 'MoneyInput-characteristic',
	          disabled: this.props.disabled,
	          onChange: this.onCharacteristicChange,
	          onClick: this.onCharacteristicClick,
	          onFocus: function onFocus() {
	            return _this2.setState({ focus: true });
	          },
	          value: this.state.characteristic.toString(),
	          placeholder: '0',
	          onBlur: function onBlur(event) {
	            var switchedToMantissa = _this2.state.showMantissa && (!_this2.state.mantissa || _this2.state.mantissa.length === 0);
	
	            if (switchedToMantissa) {
	              event.stopPropagation();
	              event.preventDefault();
	            } else {
	              _this2.setState({ focus: false });
	            }
	          },
	          ref: 'characteristic'
	        }),
	        this.state.showMantissa && _react2.default.createElement(_Input2.default, {
	          className: 'MoneyInput-mantissa',
	          disabled: this.props.disabled,
	          onChange: this.onMantissaChange,
	          onClick: function onClick(event) {
	            return event.stopPropagation();
	          },
	          value: this.state.mantissa && this.state.mantissa.toString(),
	          placeholder: '00',
	          ref: 'mantissa',
	          onFocus: function onFocus() {
	            return _this2.setState({ focus: true });
	          },
	          onBlur: function onBlur() {
	            return _this2.setState({ focus: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return MoneyInput;
	}(_react2.default.Component);
	
	MoneyInput.defaultProps = {
	  border: false,
	  disabled: false,
	  onBlur: function onBlur() {}
	};
	MoneyInput.displayName = 'MoneyInput';
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onMantissaChange = function (event) {
	    var mantissa = event.target.value.split('').filter(function (char) {
	      return !isNaN(parseInt(char, 10));
	    });
	
	    // when backspace is press
	    if (event.target.value.length === 0) {
	      _this3.setState({ showMantissa: false }, function () {
	        _this3.refs.characteristic.focus();
	      });
	    }
	
	    mantissa = mantissa.join('');
	    mantissa = mantissa.substring(0, MANTISSA_MAX_DIGITS);
	
	    _this3.setState({ mantissa: mantissa }, _this3.propagateOnChange);
	  };
	
	  this.onCharacteristicChange = function (event) {
	    var characteristic = event.target.value.split('').filter(function (char) {
	      return !isNaN(parseInt(char, 10));
	    });
	
	    if (event.target.value.includes('.')) {
	      _this3.setState({ showMantissa: true }, function () {
	        _this3.refs.mantissa.focus();
	      });
	    }
	
	    // when backspace is press
	    if (event.target.value.length === 0) {
	      characteristic.push(CHARACTERISTIC_EMPTY_CHAR);
	    }
	
	    // when first keystroke, remove default default.
	    if (characteristic.length === 2 && characteristic[0] === CHARACTERISTIC_EMPTY_CHAR) {
	      characteristic.shift();
	    }
	
	    characteristic = characteristic.join('');
	    characteristic = characteristic.substring(0, CHARACTERISTIC_MAX_DIGIT);
	
	    _this3.setState({ characteristic: characteristic }, _this3.propagateOnChange);
	  };
	
	  this.onCharacteristicClick = function (event) {
	    _this3.focusCharacteristic();
	    event.stopPropagation();
	  };
	
	  this.focus = function () {
	    (0, _focusNode2.default)(_this3.refs.characteristic);
	  };
	
	  this.propagateOnChange = function () {
	    if (_this3.props.onChange) {
	      _this3.props.onChange({
	        value: Number(_this3.state.characteristic) * CENTS_PER_DOLLAR + Number(_this3.state.mantissa || 0)
	      });
	    }
	  };
	
	  this.focusCharacteristic = function () {
	    var input = _this3.refs.characteristic.getInput();
	    _this3.refs.characteristic.focus();
	
	    if (input.value && input.value.length === 1) {
	      if (input.setSelectionRange) {
	        input.setSelectionRange(1, 1);
	      }
	    }
	  };
	
	  this.renderCurrencySymbol = function () {
	    switch (_this3.props.currency) {
	      case 'USD':
	        return _react2.default.createElement(_Glyph2.default, { name: 'dollar', size: 'xxlarge', solo: true });
	      case 'EUR':
	        return '€';
	      default:
	    }
	  };
	};
	
	exports.default = MoneyInput;

/***/ },
/* 1869 */
1136,
/* 1870 */,
/* 1871 */
1136,
/* 1872 */,
/* 1873 */
1136,
/* 1874 */,
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActivityAnnouncementChatMessageFormView = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _AnnouncementComposerRecipientsInput = __webpack_require__(1876);
	
	var _AnnouncementComposerRecipientsInput2 = _interopRequireDefault(_AnnouncementComposerRecipientsInput);
	
	var _Checkbox = __webpack_require__(1388);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _PageControls = __webpack_require__(1861);
	
	var _PageControls2 = _interopRequireDefault(_PageControls);
	
	var _RoleBasedMessagingRecipientsInput = __webpack_require__(1893);
	
	var _RoleBasedMessagingRecipientsInput2 = _interopRequireDefault(_RoleBasedMessagingRecipientsInput);
	
	var _Textarea = __webpack_require__(1598);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _getTargetsFromGroupCodes = __webpack_require__(1917);
	
	var _Chat = __webpack_require__(906);
	
	var _Message = __webpack_require__(930);
	
	__webpack_require__(1918);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ActivityAnnouncementChatMessageFormView = exports.ActivityAnnouncementChatMessageFormView = function (_React$Component) {
	  _inherits(ActivityAnnouncementChatMessageFormView, _React$Component);
	
	  function ActivityAnnouncementChatMessageFormView() {
	    _classCallCheck(this, ActivityAnnouncementChatMessageFormView);
	
	    var _this = _possibleConstructorReturn(this, (ActivityAnnouncementChatMessageFormView.__proto__ || Object.getPrototypeOf(ActivityAnnouncementChatMessageFormView)).apply(this, arguments));
	
	    _this.onNext = function () {
	      _this.props.onNext(_this.getPublicState());
	    };
	
	    _this.handlePreviewClick = function () {
	      _this.props.onPreviewClick(_this.getPublicState());
	    };
	
	    _this.onBack = function () {
	      _this.props.onBack(_this.getPublicState());
	    };
	
	    _this.isValid = function () {
	      var selectedTargets = _this.props.showIndividualRecipients ? _this.props.selection : _this.state.groupCodes;
	
	      return !!_this.state.message && !(_this.props.withRecipientInput && selectedTargets.length === 0 && _this.props.targets.length === 0);
	    };
	
	    _this.handleInputFocus = function () {
	      if (_this.state.inComposer) {
	        _this.setState({ inComposer: false }, function () {
	          if (_this.props.onInComposerChange) {
	            _this.props.onInComposerChange(_this.state.inComposer);
	          }
	        });
	      }
	    };
	
	    _this.handleRecipientsChange = function (groupCodes) {
	      _this.setState({ groupCodes: groupCodes });
	    };
	
	    _this.goToComposer = function () {
	      if (!_this.state.inComposer) {
	        _this.setState({ inComposer: true }, function () {
	          if (_this.props.onInComposerChange) {
	            _this.props.onInComposerChange(_this.state.inComposer);
	          }
	        });
	      }
	    };
	
	    var title = _this.props.title || '';
	    var message = _this.props.message || 'Hi everyone! I\'m using Remind to coordinate the ' + title + '. Please make sure to RSVP through this message.';
	
	    _this.state = {
	      message: message,
	      hasChildren: _this.props.hasChildren || false,
	      disableReplies: _this.props.disableReplies || false,
	      groupCodes: _this.props.groupCodes || [],
	      inComposer: false
	    };
	    return _this;
	  }
	
	  _createClass(ActivityAnnouncementChatMessageFormView, [{
	    key: 'getTotalMembershipCount',
	    value: function getTotalMembershipCount() {
	      if (this.props.showIndividualRecipients) {
	        var _targets = this.props.targets;
	
	        return _targets.reduce(function (total, target) {
	          var count = 0;
	          if (target.group_id) {
	            // $FlowFixMe https://github.com/remind101/r101-frontend/pull/4065
	            count = _GroupStore2.default.getGroup(target.group_id).getMembershipsCount();
	          }
	          return total + count;
	        }, 0);
	      } else {
	        var _groupCodes = this.state.groupCodes;
	
	        return _groupCodes.reduce(function (total, code) {
	          // $FlowFixMe https://github.com/remind101/r101-frontend/pull/4065
	          var memberships = _GroupStore2.default.getGroupForCode(code).getMembershipsCount();
	          return total + memberships;
	        }, 0);
	      }
	    }
	  }, {
	    key: 'getPublicState',
	    value: function getPublicState() {
	      var publicState = {
	        message: this.state.message,
	        hasChildren: this.state.hasChildren,
	        disableReplies: this.state.disableReplies,
	        targets: this.props.targets
	      };
	
	      if (!this.props.showIndividualRecipients) {
	        var _groupCodes2 = this.props.withRecipientInput ? this.state.groupCodes : [];
	        var _targets2 = (0, _getTargetsFromGroupCodes.getTargetsFromGroupCodes)(_groupCodes2);
	
	        publicState.targets.push(_targets2);
	        publicState.targets = (0, _lodash.uniqBy)(_targets2, function (t) {
	          return t.group_id;
	        });
	      }
	
	      return publicState;
	    }
	  }, {
	    key: 'getRepliesCheckboxLabel',
	    value: function getRepliesCheckboxLabel() {
	      var label = 'Allow participants to reply to the group conversation';
	      if (this.getTotalMembershipCount() > _Chat.MAX_PARTICIPANTS_REPLIES_ENABLE) {
	        label = 'Replies are automatically turned off for groups with more than ' + _Chat.MAX_PARTICIPANTS_REPLIES_ENABLE + ' members';
	      }
	      return label;
	    }
	  }, {
	    key: 'renderRecipientsInput',
	    value: function renderRecipientsInput() {
	      var input = void 0;
	
	      if (this.props.showIndividualRecipients) {
	        var _groupCodes3 = this.props.groupCodes;
	
	        // TODO: FIX: The initial message passed in is just a string, so message
	        // targets who are individuals can't be detected and passed along to the
	        // composer input.
	
	        var initialTargets = [];
	        if (_groupCodes3) {
	          initialTargets = (0, _getTargetsFromGroupCodes.getTargetsFromGroupCodes)(_groupCodes3);
	        }
	        var _inComposer = this.state.inComposer;
	
	
	        input = _react2.default.createElement(_RoleBasedMessagingRecipientsInput2.default, {
	          autoFocus: !_inComposer,
	          onInputFocus: this.handleInputFocus,
	          initialTargets: initialTargets,
	          onEnter: this.goToComposer,
	          onActionButtonClick: this.goToComposer,
	          hideResults: _inComposer,
	          showIndividuals: this.props.showIndividualRecipients
	        });
	      } else {
	        input = _react2.default.createElement(_AnnouncementComposerRecipientsInput2.default, {
	          selectedGroupCodes: this.state.groupCodes,
	          onChange: this.handleRecipientsChange
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityAnnouncementChatMessageFormView-recipientInput' },
	        input
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        this.props.withRecipientInput && this.renderRecipientsInput(),
	        (this.state.inComposer || !this.props.showIndividualRecipients) && _react2.default.createElement(
	          'div',
	          { className: 'ActivityAnnouncementChatMessageFormView-composer' },
	          _react2.default.createElement(_Textarea2.default, {
	            rows: 4,
	            'data-test': 'activity-announcement-chat-message-form-view-body',
	            className: 'ActivityAnnouncementChatMessageFormView-textarea',
	            value: this.state.message,
	            onChange: function onChange(event) {
	              return _this2.setState({ message: event.target.value });
	            },
	            placeholder: 'Add a note and any details. (An RSVP link will be included in your message.)'
	          }),
	          _react2.default.createElement(_Checkbox2.default, {
	            defaultChecked: !this.state.hasChildren,
	            label: 'The people responding to this activity are 13 years or older',
	            onChange: function onChange(value) {
	              return _this2.setState({ hasChildren: !value.currentTarget.checked });
	            }
	          }),
	          _react2.default.createElement(_Checkbox2.default, {
	            disabled: this.state.hasChildren || this.getTotalMembershipCount() > _Chat.MAX_PARTICIPANTS_REPLIES_ENABLE,
	            defaultChecked: !this.state.disableReplies,
	            label: this.getRepliesCheckboxLabel(),
	            onChange: function onChange(value) {
	              return _this2.setState({ disableReplies: !value.currentTarget.checked });
	            }
	          }),
	          _react2.default.createElement(_PageControls2.default, {
	            className: 'ActivityAnnouncementChatMessageFormView-controls',
	            disabledNext: !this.isValid(),
	            onBack: this.onBack,
	            onNext: this.onNext,
	            onPreview: this.handlePreviewClick,
	            nextText: 'Submit'
	          })
	        )
	      );
	    }
	  }]);
	
	  return ActivityAnnouncementChatMessageFormView;
	}(_react2.default.Component);
	
	ActivityAnnouncementChatMessageFormView.defaultProps = {
	  title: '',
	  withRecipientInput: false,
	  showIndividualRecipients: false
	};
	ActivityAnnouncementChatMessageFormView.displayName = 'ActivityAnnouncementChatMessageFormView';
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    selection: state.roleBasedMessagingSearch.selection,
	    targets: state.roleBasedMessagingSearch.targets
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ActivityAnnouncementChatMessageFormView);

/***/ },
/* 1876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _List = __webpack_require__(1281);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(1282);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollableArea = __webpack_require__(1412);
	
	var _ScrollableArea2 = _interopRequireDefault(_ScrollableArea);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _UniversalComposerRecipientToken = __webpack_require__(1877);
	
	var _UniversalComposerRecipientToken2 = _interopRequireDefault(_UniversalComposerRecipientToken);
	
	var _DeprecatedTokenizerTypeahead = __webpack_require__(1884);
	
	var _DeprecatedTokenizerTypeahead2 = _interopRequireDefault(_DeprecatedTokenizerTypeahead);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getMatcher = __webpack_require__(1890);
	
	var _getMatcher2 = _interopRequireDefault(_getMatcher);
	
	var _groupDisplay = __webpack_require__(1322);
	
	var _AnnouncementComposerRecipientsInput = __webpack_require__(1891);
	
	var _AnnouncementComposerRecipientsInput2 = _interopRequireDefault(_AnnouncementComposerRecipientsInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnnouncementComposerRecipientsInput = function (_React$Component) {
	  _inherits(AnnouncementComposerRecipientsInput, _React$Component);
	
	  function AnnouncementComposerRecipientsInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AnnouncementComposerRecipientsInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnnouncementComposerRecipientsInput.__proto__ || Object.getPrototypeOf(AnnouncementComposerRecipientsInput)).call.apply(_ref, [this].concat(args))), _this), _this.getFilter = function (query) {
	      var matcher = (0, _getMatcher2.default)(query);
	      return function (groupCode) {
	        if (_this.props.selectedGroupCodes.includes(groupCode)) {
	          return false;
	        }
	        var group = _GroupStore2.default.getGroupForCode(groupCode);
	        return matcher([group.getName(), group.getCode()]);
	      };
	    }, _this.loadData = function () {
	      var groups = _GroupStore2.default.getPostableGroups();
	      var groupCodes = groups.models.map(function (g) {
	        return g.getCode();
	      });
	      return Promise.resolve(groupCodes);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AnnouncementComposerRecipientsInput, [{
	    key: 'renderTypeaheadList',
	    value: function renderTypeaheadList(items) {
	      return _react2.default.createElement(
	        _ScrollableArea2.default,
	        {
	          useBodyChildrenHeight: true,
	          className: _AnnouncementComposerRecipientsInput2.default.typeaheadScrollArea },
	        _react2.default.createElement(
	          _List2.default,
	          { className: _AnnouncementComposerRecipientsInput2.default.typeaheadList },
	          items
	        )
	      );
	    }
	  }, {
	    key: 'renderTypeaheadItem',
	    value: function renderTypeaheadItem(groupCode, highlighted, query, onSelect) {
	      var _cx;
	
	      var group = _GroupStore2.default.getGroupForCode(groupCode);
	      return _react2.default.createElement(
	        _ListItem2.default,
	        {
	          onClick: function onClick() {
	            return onSelect();
	          },
	          key: group.id,
	          className: (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _AnnouncementComposerRecipientsInput2.default.typeaheadItem, true), _defineProperty(_cx, _AnnouncementComposerRecipientsInput2.default.highlightedTypeaheadItem, highlighted), _cx)) },
	        _react2.default.createElement(
	          _FlexibleBlock2.default,
	          { flex: 'right' },
	          _react2.default.createElement(_GroupAvatar2.default, { className: _AnnouncementComposerRecipientsInput2.default.itemAvatar, group: group, size: 'small' }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Text2.default,
	              {
	                className: _AnnouncementComposerRecipientsInput2.default.itemName,
	                color: 'pitch',
	                size: 'xsmall',
	                weight: 'semibold',
	                truncate: true },
	              _react2.default.createElement(_GroupName2.default, { group: group })
	            ),
	            _react2.default.createElement(
	              _Text2.default,
	              { className: _AnnouncementComposerRecipientsInput2.default.itemDescription, color: 'koala', size: 'xxsmall', truncate: true },
	              (0, _groupDisplay.membershipDescriptionFor)(group)
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderTypeaheadSelectAllItem',
	    value: function renderTypeaheadSelectAllItem(highlighted, onSelect) {
	      var _cx2;
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        {
	          onClick: onSelect,
	          className: (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, _AnnouncementComposerRecipientsInput2.default.typeaheadItem, true), _defineProperty(_cx2, _AnnouncementComposerRecipientsInput2.default.selectAllTypeaheadItem, true), _defineProperty(_cx2, _AnnouncementComposerRecipientsInput2.default.highlightedTypeaheadItem, highlighted), _cx2)) },
	        _react2.default.createElement(
	          _Text2.default,
	          { color: 'pitch', size: 'xsmall', weight: 'semibold', truncate: true },
	          _react2.default.createElement(_Glyph2.default, { className: _AnnouncementComposerRecipientsInput2.default.sendallGlyph, name: 'plus' }),
	          'Send to all classes'
	        )
	      );
	    }
	  }, {
	    key: 'renderNoMoreItems',
	    value: function renderNoMoreItems() {
	      return _react2.default.createElement(
	        _ListItem2.default,
	        { className: _AnnouncementComposerRecipientsInput2.default.noMoreItems, key: 'noMoreItems' },
	        _react2.default.createElement(
	          _Text2.default,
	          { color: 'pitch', size: 'xsmall', weight: 'semibold' },
	          'No more classes'
	        )
	      );
	    }
	  }, {
	    key: 'renderNoResults',
	    value: function renderNoResults(query) {
	      return _react2.default.createElement(
	        _ListItem2.default,
	        { className: _AnnouncementComposerRecipientsInput2.default.noResults, key: 'noResults' },
	        _react2.default.createElement(
	          _Text2.default,
	          { color: 'pitch', size: 'xsmall', weight: 'semibold' },
	          'No classes found for "',
	          query,
	          '"'
	        )
	      );
	    }
	  }, {
	    key: 'renderToken',
	    value: function renderToken(groupCode) {
	      var group = _GroupStore2.default.getGroupForCode(groupCode);
	      return _react2.default.createElement(
	        _UniversalComposerRecipientToken2.default,
	        null,
	        _react2.default.createElement(_GroupAvatar2.default, { group: group, size: 'xsmall' }),
	        _react2.default.createElement(_GroupName2.default, { group: group })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_DeprecatedTokenizerTypeahead2.default, _extends({}, this.props, {
	        className: this.props.className,
	        prompt: 'To:',
	        placeholder: 'Select one or more classes',
	        value: this.props.selectedGroupCodes,
	        onChange: this.props.onChange,
	        dataSource: this.loadData,
	        dataFilterFactory: this.getFilter,
	        listRenderer: this.renderTypeaheadList,
	        itemRenderer: this.renderTypeaheadItem,
	        selectAllItemRenderer: this.renderTypeaheadSelectAllItem,
	        noMoreItemsRenderer: this.renderNoMoreItems,
	        noResultsRenderer: this.renderNoResults,
	        tokenRenderer: this.renderToken
	      }));
	    }
	  }]);
	
	  return AnnouncementComposerRecipientsInput;
	}(_react2.default.Component);
	
	AnnouncementComposerRecipientsInput.defaultProps = {
	  selectedGroupCodes: [],
	  onChange: function onChange() {}
	};
	AnnouncementComposerRecipientsInput.displayName = 'AnnouncementComposerRecipientsInput';
	exports.default = AnnouncementComposerRecipientsInput;

/***/ },
/* 1877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Token = __webpack_require__(1878);
	
	var _Token2 = _interopRequireDefault(_Token);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UniversalComposerRecipientToken = __webpack_require__(1881);
	
	var _UniversalComposerRecipientToken2 = _interopRequireDefault(_UniversalComposerRecipientToken);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UniversalComposerRecipientToken = function (_React$Component) {
	  _inherits(UniversalComposerRecipientToken, _React$Component);
	
	  function UniversalComposerRecipientToken() {
	    _classCallCheck(this, UniversalComposerRecipientToken);
	
	    return _possibleConstructorReturn(this, (UniversalComposerRecipientToken.__proto__ || Object.getPrototypeOf(UniversalComposerRecipientToken)).apply(this, arguments));
	  }
	
	  _createClass(UniversalComposerRecipientToken, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          tokenProps = _objectWithoutProperties(_props, ['children']);
	
	      var _children = _slicedToArray(children, 2),
	          avatar = _children[0],
	          text = _children[1];
	
	      var styledAvatar = _react2.default.cloneElement(avatar, {
	        className: (0, _classnames2.default)(avatar.props.className, _UniversalComposerRecipientToken2.default.avatar)
	      });
	
	      return _react2.default.createElement(
	        _Token2.default,
	        _extends({ className: _UniversalComposerRecipientToken2.default.this }, tokenProps),
	        _react2.default.createElement(
	          'div',
	          { className: _UniversalComposerRecipientToken2.default.container },
	          styledAvatar,
	          _react2.default.createElement(
	            _Text2.default,
	            { className: _UniversalComposerRecipientToken2.default.name },
	            text
	          )
	        )
	      );
	    }
	  }]);
	
	  return UniversalComposerRecipientToken;
	}(_react2.default.Component);
	
	UniversalComposerRecipientToken.displayName = 'UniversalComposerRecipientToken';
	exports.default = UniversalComposerRecipientToken;

/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _tooltipable = __webpack_require__(1156);
	
	var _tooltipable2 = _interopRequireDefault(_tooltipable);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pickInputElementProps = __webpack_require__(1106);
	
	var _pickInputElementProps2 = _interopRequireDefault(_pickInputElementProps);
	
	__webpack_require__(1879);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Token = function (_React$Component) {
	  _inherits(Token, _React$Component);
	
	  function Token() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Token);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Token.__proto__ || Object.getPrototypeOf(Token)).call.apply(_ref, [this].concat(args))), _this), _this.renderRemove = function () {
	      if (!_this.props.removable || _this.props.disabled) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Link2.default,
	        {
	          className: 'Token-remove',
	          onClick: _this.props.onRemove,
	          eventElementName: 'Token-remove' },
	        _react2.default.createElement(_Glyph2.default, { name: 'close', size: 'xxsmall', solo: true })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Token, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          className = _props.className,
	          truncate = _props.truncate,
	          children = _props.children,
	          others = _objectWithoutProperties(_props, ['disabled', 'className', 'truncate', 'children']);
	
	      var otherProps = (0, _pickInputElementProps2.default)(others);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, otherProps, {
	          className: (0, _classnames2.default)({
	            Token: true,
	            'Token-disabled': disabled
	          }, (0, _getPropClasses.getPropClassesFromInstance)(this), className) }),
	        _react2.default.createElement(
	          _Text2.default,
	          { className: 'Token-value', truncate: truncate },
	          children
	        ),
	        this.renderRemove()
	      );
	    }
	  }]);
	
	  return Token;
	}(_react2.default.Component);
	
	Token.propClasses = {
	  color: {
	    lava: 'Token-lava',
	    grey: 'Token-grey',
	    white: 'Token-white'
	  }
	};
	Token.defaultProps = {
	  color: 'default',
	  disabled: false,
	  removable: true,
	  truncate: true
	};
	Token.displayName = 'Token';
	exports.default = (0, _tooltipable2.default)(Token);

/***/ },
/* 1879 */
1136,
/* 1880 */,
/* 1881 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"spacing-small":"4px","spacing-medium":"8px","this":"UniversalComposerRecipientToken__this___1t7Tj","container":"UniversalComposerRecipientToken__container___Ror6o","avatar":"UniversalComposerRecipientToken__avatar___12O7e Spacing__marginRightMedium___bhiZC","name":"UniversalComposerRecipientToken__name___1LxQM"};

/***/ },
/* 1882 */,
/* 1883 */,
/* 1884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Token = __webpack_require__(1878);
	
	var _Token2 = _interopRequireDefault(_Token);
	
	var _Tokenizer = __webpack_require__(1885);
	
	var _Tokenizer2 = _interopRequireDefault(_Tokenizer);
	
	var _DeprecatedTypeahead = __webpack_require__(1888);
	
	var _DeprecatedTypeahead2 = _interopRequireDefault(_DeprecatedTypeahead);
	
	var _lodash = __webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var DeprecatedTokenizerTypeahead = function (_React$Component) {
	  _inherits(DeprecatedTokenizerTypeahead, _React$Component);
	
	  function DeprecatedTokenizerTypeahead() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DeprecatedTokenizerTypeahead);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeprecatedTokenizerTypeahead.__proto__ || Object.getPrototypeOf(DeprecatedTokenizerTypeahead)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelect = function (datum) {
	      var tokenizer = _this.refs.tokenizer;
	      var value = _this.props.value;
	
	      var index = value.indexOf(datum);
	      if (index >= 0) {
	        tokenizer.remove(datum);
	      } else {
	        tokenizer.add(datum);
	      }
	      tokenizer.clearInputValue();
	      tokenizer.focusInput();
	    }, _this.handleSelectAll = function (data) {
	      var tokenizer = _this.refs.tokenizer;
	
	      tokenizer.add(data);
	      tokenizer.focusInput();
	    }, _this.handleInputChange = (0, _lodash.debounce)(function (query) {
	      if (_this.refs.typeahead) {
	        _this.refs.typeahead.setQuery(query);
	      }
	    }, 200), _this.handleInputKeyDown = function (event) {
	      if (_this.refs.typeahead) {
	        _this.refs.typeahead.handleKeyDown(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DeprecatedTokenizerTypeahead, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.value !== this.props.value) {
	        this.refs.typeahead.updateResults();
	      }
	    }
	
	    // HACK around using refs within render
	
	
	    // HACK around using refs within render
	    // typecheck: ignore statement
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          value = _props.value,
	          prompt = _props.prompt,
	          placeholder = _props.placeholder,
	          tokenRenderer = _props.tokenRenderer,
	          autoFocus = _props.autoFocus,
	          onChange = _props.onChange,
	          actionButton = _props.actionButton,
	          props = _objectWithoutProperties(_props, ['value', 'prompt', 'placeholder', 'tokenRenderer', 'autoFocus', 'onChange', 'actionButton']);
	
	      var tokenizer = _react2.default.createElement(_Tokenizer2.default, {
	        ref: 'tokenizer',
	        value: value,
	        prompt: prompt,
	        placeholder: placeholder,
	        tokenRenderer: tokenRenderer,
	        autoFocus: autoFocus,
	        onChange: onChange,
	        onInputChange: this.handleInputChange,
	        onInputKeyDown: this.handleInputKeyDown
	      });
	
	      var controlRow = actionButton ? _react2.default.createElement(
	        _FlexibleBlock2.default,
	        { flex: 'left' },
	        tokenizer,
	        actionButton
	      ) : tokenizer;
	
	      return _react2.default.createElement(
	        _DeprecatedTypeahead2.default,
	        _extends({}, props, {
	          ref: 'typeahead',
	          className: props.className,
	          onSelect: this.handleSelect,
	          onSelectAll: this.handleSelectAll }),
	        controlRow
	      );
	    }
	  }]);
	
	  return DeprecatedTokenizerTypeahead;
	}(_react2.default.Component);
	
	DeprecatedTokenizerTypeahead.defaultProps = {
	  value: [],
	  tokenRenderer: function tokenRenderer(datum) {
	    return _react2.default.createElement(
	      _Token2.default,
	      null,
	      datum
	    );
	  },
	  onChange: function onChange(data) {} };
	DeprecatedTokenizerTypeahead.displayName = 'DeprecatedTokenizerTypeahead';
	exports.default = DeprecatedTokenizerTypeahead;

/***/ },
/* 1885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(1241);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _focusNode = __webpack_require__(1210);
	
	var _focusNode2 = _interopRequireDefault(_focusNode);
	
	var _KeyConstants = __webpack_require__(1164);
	
	var _KeyConstants2 = _interopRequireDefault(_KeyConstants);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Token = __webpack_require__(1878);
	
	var _Token2 = _interopRequireDefault(_Token);
	
	var _Tokenizer = __webpack_require__(1886);
	
	var _Tokenizer2 = _interopRequireDefault(_Tokenizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tokenizer = function (_React$Component) {
	  _inherits(Tokenizer, _React$Component);
	
	  function Tokenizer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tokenizer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tokenizer.__proto__ || Object.getPrototypeOf(Tokenizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      inputValue: '',
	      focused: false
	    }, _this.handleBlur = function () {
	      _this.setState({ focused: false });
	      if (_this.props.onBlur) {
	        _this.props.onBlur();
	      }
	    }, _this.handleFocus = function () {
	      _this.setState({ focused: true });
	      if (_this.props.onFocus) {
	        _this.props.onFocus();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tokenizer, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: 'getInput',
	    value: function getInput() {
	      return this.refs.input;
	    }
	  }, {
	    key: 'getInputValue',
	    value: function getInputValue() {
	      return this.state.inputValue;
	    }
	  }, {
	    key: 'clearInputValue',
	    value: function clearInputValue() {
	      var _this2 = this;
	
	      this.setState({ inputValue: '' }, function () {
	        return _this2.props.onInputChange('');
	      });
	    }
	  }, {
	    key: 'focusInput',
	    value: function focusInput() {
	      (0, _focusNode2.default)(this.getInput());
	    }
	
	    // typecheck: ignore statement
	
	  }, {
	    key: 'add',
	    value: function add(data) {
	      var value = this.props.value;
	
	      var newValue = Array.from(value);
	
	      (Array.isArray(data) ? data : [data]).forEach(function (datum) {
	        var index = value.indexOf(datum);
	        if (index < 0) {
	          newValue.push(datum);
	        }
	      });
	
	      if (newValue.length !== value.length) {
	        this.props.onChange(newValue);
	      }
	    }
	
	    // typecheck: ignore statement
	
	  }, {
	    key: 'remove',
	    value: function remove(datum) {
	      var value = this.props.value;
	
	      var index = value.indexOf(datum);
	      if (index >= 0) {
	        var newValue = value.slice(0, index).concat(value.slice(index + 1));
	        this.props.onChange(newValue);
	        this.props.onDeselect(datum);
	      }
	    }
	  }, {
	    key: 'handleInputChange',
	
	
	    // typecheck: ignore statement
	    value: function handleInputChange(event) {
	      var target = event.target;
	
	      if (target instanceof window.HTMLInputElement) {
	        var inputValue = target.value;
	        this.setState({ inputValue: inputValue });
	        this.props.onInputChange(inputValue);
	      }
	    }
	
	    // typecheck: ignore statement
	
	  }, {
	    key: 'handleInputKeyDown',
	    value: function handleInputKeyDown(event) {
	      var keyCode = event.keyCode;
	
	      switch (keyCode) {
	        case _KeyConstants2.default.BACKSPACE:
	          if (this.state.inputValue === '') {
	            if (this.props.value.length > 0) {
	              this.remove(this.props.value[this.props.value.length - 1]);
	            }
	          }
	          break;
	        default:
	          break;
	      }
	      this.props.onInputKeyDown(event);
	    }
	  }, {
	    key: 'renderPrompt',
	    value: function renderPrompt() {
	      var prompt = this.props.prompt;
	
	      if (!prompt) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _Text2.default,
	        {
	          className: _Tokenizer2.default.prompt,
	          color: 'pitch',
	          weight: 'semibold' },
	        prompt
	      );
	    }
	  }, {
	    key: 'renderTokens',
	    value: function renderTokens() {
	      return this.props.value.map(this.renderToken.bind(this));
	    }
	  }, {
	    key: 'renderToken',
	    value: function renderToken(datum, index, data) {
	      var _this3 = this;
	
	      var token = this.props.tokenRenderer(datum, index, data);
	      return _react2.default.cloneElement(token, {
	        key: index,
	        onRemove: function onRemove() {
	          return _this3.remove(datum);
	        }
	      });
	    }
	  }, {
	    key: 'renderInput',
	    value: function renderInput() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Tokenizer2.default.inputContainer },
	        !this.state.inputValue && this.renderPlaceholder(),
	        _react2.default.createElement('input', {
	          ref: 'input',
	          className: (0, _classnames2.default)(_defineProperty({}, _Tokenizer2.default.inputHasValue, !!this.state.inputValue || this.props.value.length > 0), this.props.inputClassName),
	          type: 'text',
	          value: this.state.inputValue,
	          size: this.state.inputValue.length || 1,
	          autoFocus: this.props.autoFocus,
	          onChange: function onChange(event) {
	            return _this4.handleInputChange(event);
	          },
	          onKeyDown: function onKeyDown(event) {
	            return _this4.handleInputKeyDown(event);
	          },
	          onFocus: this.handleFocus,
	          onBlur: this.handleBlur
	        })
	      );
	    }
	  }, {
	    key: 'renderPlaceholder',
	    value: function renderPlaceholder() {
	      var placeholder = this.props.placeholder;
	
	      if (!placeholder || this.props.value.length > 0) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _Text2.default,
	        { className: _Tokenizer2.default.placeholder, color: 'koala' },
	        placeholder
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_Tokenizer2.default.this, _defineProperty({}, _Tokenizer2.default.focused, this.state.focused), this.props.className),
	          onClick: function onClick() {
	            return _this5.focusInput();
	          } },
	        this.renderPrompt(),
	        this.renderTokens(),
	        this.renderInput()
	      );
	    }
	  }]);
	
	  return Tokenizer;
	}(_react2.default.Component);
	
	Tokenizer.defaultProps = {
	  value: [],
	  tokenRenderer: function tokenRenderer(data) {
	    return _react2.default.createElement(
	      _Token2.default,
	      null,
	      data
	    );
	  },
	  onChange: function onChange(value) {}, // eslint-disable-line
	  onDeselect: function onDeselect() {},
	  onInputChange: function onInputChange() {},
	  // typecheck: ignore statement
	  onInputKeyDown: function onInputKeyDown(e) {} };
	Tokenizer.displayName = 'Tokenizer';
	exports.default = Tokenizer;

/***/ },
/* 1886 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"brand":"#2f75c1","koala":"#c5c7cb","thunder":"#6b6e72","spacing-medium":"8px","this":"Tokenizer__this___1k-Bf","focused":"Tokenizer__focused___3YVfo","prompt":"Tokenizer__prompt___2YHno","inputContainer":"Tokenizer__inputContainer___CnKpt","inputHasValue":"Tokenizer__inputHasValue___1U8GT"};

/***/ },
/* 1887 */,
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Typeahead = __webpack_require__(1889);
	
	var _Typeahead2 = _interopRequireDefault(_Typeahead);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeprecatedTypeahead = function (_React$Component) {
	  _inherits(DeprecatedTypeahead, _React$Component);
	
	  function DeprecatedTypeahead() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DeprecatedTypeahead);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeprecatedTypeahead.__proto__ || Object.getPrototypeOf(DeprecatedTypeahead)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      query: '',
	      data: [],
	      results: [],
	      loading: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DeprecatedTypeahead, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.inline) {
	        this.loadData();
	      }
	    }
	  }, {
	    key: 'setQuery',
	    value: function setQuery() {
	      var _this2 = this;
	
	      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      var trimmedQuery = query.trim();
	      this.setState({
	        query: trimmedQuery,
	        results: this.filterDataWithQuery(trimmedQuery)
	      }, function () {
	        return _this2.loadData(trimmedQuery);
	      });
	    }
	  }, {
	    key: 'handleInputFocus',
	    value: function handleInputFocus() {
	      if (!this.state.loading && this.state.data.length === 0) {
	        this.loadData(this.state.query);
	      }
	    }
	
	    // typecheck: ignore statement
	
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      this.refs.typeahead.handleKeyDown(event);
	    }
	  }, {
	    key: 'updateResults',
	    value: function updateResults() {
	      var results = this.filterDataWithQuery(this.state.query);
	      this.setState({
	        loading: false,
	        results: results
	      });
	    }
	  }, {
	    key: 'filterDataWithQuery',
	    value: function filterDataWithQuery(query) {
	      var data = this.state.data.filter(this.props.dataFilterFactory(query));
	
	      if (!query) {
	        if (this.props.selectAllItemRenderer && data.length > 1) {
	          data.unshift('_all');
	        }
	      }
	
	      return data;
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this3 = this;
	
	      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      if (query === '' && this.state.data.length > 0) {
	        // the query is empty, but we're not waiting on data
	        // This can be further improved by not loading whenever the query truncated by delete key
	        this.updateResults();
	        return;
	      }
	
	      this.setState({ loading: true });
	      this.props.dataSource(query).then(function (data) {
	        _this3.setState({ data: data }, _this3.updateResults);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        _Typeahead2.default,
	        {
	          ref: 'typeahead',
	          className: this.props.className,
	          inline: this.props.inline,
	          query: this.state.query,
	          results: this.state.results,
	          itemRenderer: this.props.itemRenderer,
	          listRenderer: this.props.listRenderer,
	          selectAllItemRenderer: this.props.selectAllItemRenderer,
	          noMoreItemsRenderer: this.props.noMoreItemsRenderer,
	          noResultsRenderer: this.props.noResultsRenderer,
	          onSelect: this.props.onSelect,
	          onSelectAll: function onSelectAll() {
	            return _this4.props.onSelectAll(_this4.state.data);
	          } },
	        _react2.default.cloneElement(this.props.children, { onFocus: function onFocus() {
	            return _this4.handleInputFocus();
	          } })
	      );
	    }
	  }]);
	
	  return DeprecatedTypeahead;
	}(_react2.default.Component);
	
	DeprecatedTypeahead.defaultProps = {
	  dataSource: function dataSource() {
	    return Promise.resolve([]);
	  },
	  dataFilterFactory: function dataFilterFactory(query) {
	    return function (datum) {
	      return datum === query;
	    };
	  },
	  inline: false,
	  onSelect: function onSelect() {},
	  onSelectAll: function onSelectAll() {}
	};
	DeprecatedTypeahead.displayName = 'DeprecatedTypeahead';
	exports.default = DeprecatedTypeahead;

/***/ },
/* 1889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _KeyConstants = __webpack_require__(1164);
	
	var _KeyConstants2 = _interopRequireDefault(_KeyConstants);
	
	var _Layer = __webpack_require__(1158);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _List = __webpack_require__(1281);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Typeahead = function (_React$Component) {
	  _inherits(Typeahead, _React$Component);
	
	  function Typeahead() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Typeahead);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Typeahead.__proto__ || Object.getPrototypeOf(Typeahead)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      highlightIndex: -1,
	      loading: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Typeahead, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.inline) {
	        // Hide the layer on window resize
	        window.addEventListener('resize', this.hideLayer.bind(this), false);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.query !== nextProps.query) {
	        if (nextProps.query === '') {
	          this.setState({ highlightIndex: -1 });
	        } else {
	          this.setState({ highlightIndex: 0 });
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var propsChanged = this.props.query !== nextProps.query || this.props.results.length !== nextProps.results.length || this.props.children !== nextProps.children;
	      var stateChanged = this.state.highlightIndex !== nextState.highlightIndex;
	      return propsChanged || stateChanged;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.refs.trigger) {
	        this.refs.trigger.updateLayerPosition();
	      }
	      if (this.state.highlightIndex !== prevState.highlightIndex) {
	        this.props.onHighlightIndexChange(this.state.highlightIndex);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.hideLayer.bind(this), false);
	    }
	
	    // typecheck: ignore statement
	
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      var keyCode = event.keyCode;
	
	      switch (keyCode) {
	        case _KeyConstants2.default.DOWN:
	        case _KeyConstants2.default.UP:
	          {
	            var highlightIndex = this.state.highlightIndex;
	
	            if (keyCode === _KeyConstants2.default.UP) {
	              this.setState({
	                highlightIndex: highlightIndex > 0 ? highlightIndex - 1 : this.props.results.length - 1
	              });
	            } else {
	              this.setState({
	                highlightIndex: highlightIndex + 1 < this.props.results.length ? highlightIndex + 1 : 0
	              });
	            }
	            this.showLayer();
	            break;
	          }
	        case _KeyConstants2.default.ENTER:
	          if (this.state.highlightIndex >= 0) {
	            this.selectItem(this.props.results[this.state.highlightIndex]);
	          } else {
	            this.props.onEnter();
	          }
	          break;
	        default:
	          this.showLayer();
	          break;
	      }
	    }
	  }, {
	    key: 'handleInputFocus',
	    value: function handleInputFocus() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        return _this2.showLayer();
	      }, 0);
	    }
	  }, {
	    key: 'showLayer',
	    value: function showLayer() {
	      if (!this.refs.trigger || this.refs.trigger.isLayerShown()) {
	        return;
	      }
	      this.refs.trigger.showLayer();
	    }
	  }, {
	    key: 'hideLayer',
	    value: function hideLayer() {
	      if (!this.refs.trigger || !this.refs.trigger.isLayerShown()) {
	        return;
	      }
	      this.refs.trigger.hideLayer();
	      this.resetHighlight();
	    }
	  }, {
	    key: 'resetHighlight',
	    value: function resetHighlight() {
	      if (this.state.highlightIndex >= 0) {
	        this.setState({ highlightIndex: -1 });
	      }
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(datum) {
	      this.resetHighlight();
	      if (datum === '_all') {
	        this.props.onSelectAll();
	      } else {
	        this.props.onSelect(datum);
	      }
	    }
	  }, {
	    key: 'renderInput',
	    value: function renderInput() {
	      var _this3 = this;
	
	      var input = _react2.default.Children.only(this.props.children);
	
	      return _react2.default.cloneElement(input, {
	        onFocus: (0, _createChainedFunction2.default)(function () {
	          return _this3.handleInputFocus();
	        }, input.props.onFocus)
	      });
	    }
	  }, {
	    key: 'renderList',
	    value: function renderList() {
	      var _this4 = this;
	
	      var _props = this.props,
	          query = _props.query,
	          hideResults = _props.hideResults;
	
	      if (hideResults) {
	        return null;
	      }
	
	      var items = this.props.results.map(function (datum, index) {
	        var item = _this4.renderListItem(datum, index === _this4.state.highlightIndex, query);
	        return _react2.default.cloneElement(item, {
	          key: index,
	          onMouseEnter: (0, _createChainedFunction2.default)(function () {
	            if (index !== _this4.state.highlightIndex) {
	              _this4.setState({ highlightIndex: index });
	            }
	          }, item.props.onMouseEnter),
	          onMouseLeave: (0, _createChainedFunction2.default)(function () {
	            if (index === _this4.state.highlightIndex) {
	              _this4.setState({ highlightIndex: -1 });
	            }
	          }, item.props.onMouseLeave)
	        });
	      });
	
	      if (items.length === 0) {
	        items.push(query ? this.props.noResultsRenderer(query) : this.props.noMoreItemsRenderer());
	      }
	      return this.props.listRenderer(items, this.state.loading);
	    }
	  }, {
	    key: 'renderListItem',
	    value: function renderListItem(item, highlighted, query) {
	      var _this5 = this;
	
	      switch (item) {
	        case '_all':
	          if (!this.props.selectAllItemRenderer) {
	            return _react2.default.createElement(
	              'b',
	              null,
	              'error'
	            );
	          }
	          return this.props.selectAllItemRenderer(highlighted, function () {
	            return _this5.selectItem('_all');
	          });
	        default:
	          return this.props.itemRenderer(item, highlighted, query, function () {
	            var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : item;
	            return _this5.selectItem(i);
	          });
	      }
	    }
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          style: { margin: '0 44px' },
	          onMouseLeave: function onMouseLeave() {
	            return _this6.resetHighlight();
	          },
	          onRequestHide: function onRequestHide() {
	            return _this6.resetHighlight();
	          } },
	        this.renderList()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = _extends({}, this.props, { onSelect: null });
	
	      if (this.props.inline) {
	        return _react2.default.createElement(
	          'div',
	          { className: this.props.className },
	          this.renderInput(),
	          this.renderList()
	        );
	      }
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          ref: 'trigger',
	          className: props.className,
	          layer: this.renderLayer(),
	          trigger: 'manual',
	          placement: 'bottom',
	          useContextWidth: true },
	        this.renderInput()
	      );
	    }
	  }]);
	
	  return Typeahead;
	}(_react2.default.Component);
	
	Typeahead.defaultProps = {
	  listRenderer: function listRenderer(items, loading) {
	    return _react2.default.createElement(
	      _List2.default,
	      null,
	      items,
	      loading && _react2.default.createElement(_LoadingIndicator2.default, null)
	    );
	  },
	  itemRenderer: function itemRenderer(item, highlightIndex, query, onSelect) {
	    return _react2.default.createElement(
	      _Text2.default,
	      { onClick: onSelect, weight: highlightIndex ? 'bold' : null },
	      item
	    );
	  },
	  noMoreItemsRenderer: function noMoreItemsRenderer() {
	    return undefined;
	  },
	  noResultsRenderer: function noResultsRenderer() {
	    return undefined;
	  },
	  hideResults: false,
	  onHighlightIndexChange: function onHighlightIndexChange(index) {
	    return undefined;
	  }, // eslint-disable-line
	  onEnter: function onEnter() {
	    return undefined;
	  }
	};
	Typeahead.displayName = 'Typeahead';
	exports.default = Typeahead;

/***/ },
/* 1890 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function getMatcher(query) {
	  var words = query.toLowerCase().split(/\W+/);
	  var match = function match(item) {
	    return item && words.every(function (word) {
	      return item.toLowerCase().includes(word);
	    });
	  };
	  return function (terms) {
	    return terms.some(function (item) {
	      return item && (Array.isArray(item) ? item.some(match) : match(item));
	    });
	  };
	}
	exports.default = getMatcher;

/***/ },
/* 1891 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"eclipse":"#9e9fa5","koala":"#c5c7cb","pitch":"#282c31","polarBear":"#f2f3f5","thunder":"#6b6e72","wolf":"#dcdee2","spacing-small":"4px","spacing-medium":"8px","spacing-large":"16px","sendallGlyph":"AnnouncementComposerRecipientsInput__sendallGlyph___1TSxv Spacing__marginRightMedium___bhiZC","itemAvatar":"AnnouncementComposerRecipientsInput__itemAvatar___3T1Os Spacing__marginRightMedium___bhiZC","noResults":"AnnouncementComposerRecipientsInput__noResults___2cqkl","typeaheadScrollArea":"AnnouncementComposerRecipientsInput__typeaheadScrollArea___1207S","typeaheadList":"AnnouncementComposerRecipientsInput__typeaheadList___1oyOi","typeaheadItem":"AnnouncementComposerRecipientsInput__typeaheadItem___JhDHQ","selectAllTypeaheadItem":"AnnouncementComposerRecipientsInput__selectAllTypeaheadItem___yHSd3","highlightedTypeaheadItem":"AnnouncementComposerRecipientsInput__highlightedTypeaheadItem___1PRFE","noMoreItems":"AnnouncementComposerRecipientsInput__noMoreItems___3lnlw","dropdownScrollArea":"AnnouncementComposerRecipientsInput__dropdownScrollArea___3r8jk"};

/***/ },
/* 1892 */,
/* 1893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RoleBasedMessagingRecipientsInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _lodash = __webpack_require__(555);
	
	var _AddButton = __webpack_require__(1894);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _KeyConstants = __webpack_require__(1164);
	
	var _KeyConstants2 = _interopRequireDefault(_KeyConstants);
	
	var _PotentialChatMember = __webpack_require__(945);
	
	var _PotentialChatMember2 = _interopRequireDefault(_PotentialChatMember);
	
	var _PotentialChatMembers = __webpack_require__(946);
	
	var _PotentialChatMembers2 = _interopRequireDefault(_PotentialChatMembers);
	
	var _RoleBasedMessagingResultItem = __webpack_require__(1897);
	
	var _RoleBasedMessagingResultItem2 = _interopRequireDefault(_RoleBasedMessagingResultItem);
	
	var _ScrollableArea = __webpack_require__(1412);
	
	var _ScrollableArea2 = _interopRequireDefault(_ScrollableArea);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TokenizerTypeahead = __webpack_require__(1914);
	
	var _TokenizerTypeahead2 = _interopRequireDefault(_TokenizerTypeahead);
	
	var _UniversalComposerRecipientToken = __webpack_require__(1877);
	
	var _UniversalComposerRecipientToken2 = _interopRequireDefault(_UniversalComposerRecipientToken);
	
	var _roleHelpers = __webpack_require__(1230);
	
	var _ChatConstants = __webpack_require__(941);
	
	var _roleBasedMessagingSearch = __webpack_require__(1901);
	
	__webpack_require__(1915);
	
	__webpack_require__(1912);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var RoleBasedMessagingRecipientsInput = exports.RoleBasedMessagingRecipientsInput = function (_React$Component) {
	  _inherits(RoleBasedMessagingRecipientsInput, _React$Component);
	
	  function RoleBasedMessagingRecipientsInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RoleBasedMessagingRecipientsInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RoleBasedMessagingRecipientsInput.__proto__ || Object.getPrototypeOf(RoleBasedMessagingRecipientsInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      focus: false
	    }, _this.debouncedLoadPotentialChatMembers = (0, _lodash.debounce)(function (query) {
	      this.props.onLoadPotentialChatMembers(query);
	    }, _ChatConstants.SEARCH_NETWORK_LIMIT_MS), _this.handleActionButtonClick = function () {
	      if (_this.state.focus) {
	        _this.setState({ focus: false });
	      }
	      _this.props.onActionButtonClick();
	    }, _this.handleInputChange = function (query) {
	      // Calls onChangeQuery first so that the current page of individuals
	      // can be searched while additional results from the backend are still
	      // being fetched
	      _this.props.onChangeQuery(query);
	      if (_this.props.showIndividuals) {
	        _this.debouncedLoadPotentialChatMembers(query);
	      }
	    }, _this.handleInputFocus = function () {
	      if (!_this.state.focus) {
	        _this.setState({ focus: true });
	      }
	      _this.props.onInputFocus();
	    }, _this.handleInputKeyDown = function (e) {
	      var _this$props = _this.props,
	          results = _this$props.results,
	          highlightIndex = _this$props.highlightIndex,
	          resultSelectionIndex = _this$props.resultSelectionIndex,
	          query = _this$props.query;
	      var keyCode = e.keyCode;
	
	      switch (keyCode) {
	        case _KeyConstants2.default.DOWN:
	          {
	            var highlightedResults = results[highlightIndex];
	            if (highlightedResults && query) {
	              if (resultSelectionIndex === highlightedResults.length - 1) {
	                // If we are at the end, set selection to 0 and allow typeahead to handle the keypress
	                _this.props.onChangeResultSelection(0);
	              } else {
	                _this.props.onChangeResultSelection(_this.props.resultSelectionIndex + 1);
	                e.stopPropagation();
	              }
	            }
	            break;
	          }
	        case _KeyConstants2.default.UP:
	          {
	            if (query) {
	              if (resultSelectionIndex === 0) {
	                var previousResults = results[highlightIndex - 1];
	                if (previousResults) {
	                  _this.props.onChangeResultSelection(previousResults.length - 1);
	                }
	              } else {
	                _this.props.onChangeResultSelection(_this.props.resultSelectionIndex - 1);
	                e.stopPropagation();
	              }
	            }
	            break;
	          }
	        default:
	          break;
	      }
	    }, _this.renderActionButton = function () {
	      if (_this.state.focus) {
	        return _react2.default.createElement(
	          _Button2.default,
	          {
	            disabled: !_this.props.selection.length,
	            className: 'RoleBasedMessagingRecipientsInput-control-row-action-nextButton',
	            'data-test': 'role-based-messaging-recipients-input-next',
	            onClick: _this.handleActionButtonClick,
	            eventElementName: 'RoleBasedMessagingRecipientsInput-control-row-action-nextButton' },
	          'Next'
	        );
	      } else {
	        return _react2.default.createElement(
	          _Button2.default,
	          {
	            color: 'brand',
	            level: 'text',
	            className: 'RoleBasedMessagingRecipientsInput-control-row-action-addButton',
	            onClick: _this.handleInputFocus,
	            eventElementName: 'RoleBasedMessagingRecipientsInput-control-row-action-addButton' },
	          _react2.default.createElement(_Glyph2.default, { name: 'plus', solo: true })
	        );
	      }
	    }, _this.renderResultsList = function (items) {
	      return (
	        // $FlowIssue
	        _react2.default.createElement(
	          _ScrollableArea2.default,
	          { className: 'RoleBasedMessagingRecipientsInput-list' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            items
	          )
	        )
	      );
	    }, _this.renderResultItem = function (recipients, highlighted, query, onSelect) {
	      var selectedRecipients = _this.props.selection.filter(function (s) {
	        var sId = s.type === _roleBasedMessagingSearch.RECIPIENT_TYPES.GROUP_RECIPIENT ? s.group.id : s.id;
	        var r = recipients[0];
	        var rId = r.type === _roleBasedMessagingSearch.RECIPIENT_TYPES.GROUP_RECIPIENT ? r.group.id : r.id;
	
	        return sId === rId;
	      });
	      return _react2.default.createElement(_RoleBasedMessagingResultItem2.default, {
	        recipients: recipients,
	        highlighted: highlighted,
	        query: query,
	        onSelect: onSelect,
	        selectedRecipients: selectedRecipients,
	        resultSelectionIndex: _this.props.resultSelectionIndex
	      });
	    }, _this.renderSelectAllItem = function (highlighted, onSelect) {
	      return _react2.default.createElement(
	        'li',
	        {
	          'data-test-selector': 'send-to-all-classes',
	          onClick: onSelect,
	          className: (0, _classnames2.default)('RoleBasedMessagingResultItem', {
	            'RoleBasedMessagingResultItem-highlighted': highlighted
	          }) },
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            className: 'RoleBasedMessagingResultItem-select-all',
	            color: 'pitch',
	            size: 'xsmall',
	            weight: 'semibold' },
	          _react2.default.createElement(
	            _AddButton2.default,
	            { size: 'large' },
	            'Add all the classes you own'
	          )
	        )
	      );
	    }, _this.renderGroupTokenAvatar = function (_ref2) {
	      var group = _ref2.group;
	
	      return _react2.default.createElement(_GroupAvatar2.default, { group: group, size: 'xsmall' });
	    }, _this.renderGroupTokenContent = function (_ref3) {
	      var group = _ref3.group,
	          role = _ref3.role;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'RoleBasedMessagingRecipientsInput-token-name' },
	          _react2.default.createElement(_GroupName2.default, { group: group })
	        ),
	        _react2.default.createElement(_Glyph2.default, {
	          name: 'chevron-right',
	          size: 'xxsmall',
	          className: 'RoleBasedMessagingRecipientsInput-token-carat'
	        }),
	        _react2.default.createElement(
	          'span',
	          { className: 'RoleBasedMessagingRecipientsInput-token-role' },
	          _roleHelpers.subgroupName[role.role || _roleHelpers.EVERYONE]
	        )
	      );
	    }, _this.renderIndividualTokenAvatar = function (_ref4) {
	      var member = _ref4.member;
	
	      return _react2.default.createElement(_Avatar2.default, {
	        colorHex: member.getUser().getColor(),
	        text: member.getUser().getInitials(),
	        size: 'small'
	      });
	    }, _this.renderIndividualTokenContent = function (_ref5) {
	      var member = _ref5.member;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'RoleBasedMessagingRecipientsInput-token-name' },
	          member.getName()
	        )
	      );
	    }, _this.renderToken = function (recipient) {
	      var avatar = recipient.type === _roleBasedMessagingSearch.RECIPIENT_TYPES.GROUP_RECIPIENT ? _this.renderGroupTokenAvatar(recipient) : _this.renderIndividualTokenAvatar(recipient);
	      var content = recipient.type === _roleBasedMessagingSearch.RECIPIENT_TYPES.GROUP_RECIPIENT ? _this.renderGroupTokenContent(recipient) : _this.renderIndividualTokenContent(recipient);
	
	      return _react2.default.createElement(
	        _UniversalComposerRecipientToken2.default,
	        null,
	        avatar,
	        _react2.default.createElement(
	          'span',
	          { className: 'RoleBasedMessagingRecipientsInput-token-container' },
	          content
	        )
	      );
	    }, _this.renderControlRow = function (tokenizer, actionButton) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'RoleBasedMessagingRecipientsInput-control-row' },
	        tokenizer,
	        _react2.default.createElement(
	          'div',
	          { className: 'RoleBasedMessagingRecipientsInput-control-row-action' },
	          actionButton
	        )
	      );
	    }, _this.noResultsRenderer = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'RoleBasedMessagingRecipientsInput-noResult' },
	        'No results for \u201C',
	        _this.props.query,
	        '\u201D'
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RoleBasedMessagingRecipientsInput, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          onLoadGroups = _props.onLoadGroups,
	          onLoadIndividuals = _props.onLoadIndividuals,
	          initialTargets = _props.initialTargets,
	          onSelectInitialTargets = _props.onSelectInitialTargets,
	          showIndividuals = _props.showIndividuals;
	      // $FlowFixMe https://github.com/remind101/r101-frontend/pull/4065
	
	      onLoadGroups(_GroupStore2.default.getGroups());
	      if (showIndividuals) {
	        onLoadIndividuals(new _PotentialChatMembers2.default(_ChatStore2.default.getEligibleMemberModels()));
	      }
	      if (initialTargets && initialTargets.length) {
	        onSelectInitialTargets(initialTargets);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onFlush();
	    }
	
	    // typecheck: ignore statement
	
	
	    // $FlowFixMe destructuring
	
	
	    // $FlowFixMe destructuring
	
	
	    // $FlowFixMe destructuring
	
	
	    // $FlowFixMe destructuring
	
	
	    // $FlowIssue adding the annotation destroys the prop types on this component 💩💩💩
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var fullResults = void 0;
	      if (this.props.query) {
	        fullResults = this.props.results;
	      } else {
	        fullResults = this.props.results.length ? ['_all'].concat(_toConsumableArray(this.props.results)) : this.props.results;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'RoleBasedMessagingRecipientsInput' },
	        _react2.default.createElement(_TokenizerTypeahead2.default, {
	          inline: true,
	          className: this.props.className,
	          autoFocus: this.props.autoFocus,
	          placeholder: 'Select one or more classes',
	          prompt: 'To:',
	          tokenizerClassName: 'RoleBasedMessagingRecipientsInput-tokenizer',
	          controlRowClassName: 'RoleBasedMessagingRecipientsInput-control-row',
	          query: this.props.query,
	          results: fullResults,
	          selection: this.props.selection,
	          onDeselect: function onDeselect(recipient) {
	            return _this2.props.onSelect([recipient]);
	          },
	          onSelect: this.props.onSelect,
	          onSelectAll: this.props.onSelectAllGroups,
	          onInputFocus: this.handleInputFocus,
	          onInputChange: this.handleInputChange,
	          onInputKeyDown: this.handleInputKeyDown,
	          noResultsRenderer: this.noResultsRenderer,
	          onEnter: this.props.onEnter,
	          itemRenderer: function itemRenderer() {
	            return _this2.renderResultItem.apply(_this2, arguments);
	          },
	          listRenderer: this.renderResultsList,
	          selectAllItemRenderer: this.renderSelectAllItem,
	          tokenRenderer: this.renderToken,
	          controlRowRenderer: this.renderControlRow,
	          actionButton: this.renderActionButton(),
	          hideResults: this.props.hideResults,
	          onHighlightIndexChange: this.props.onHighlightIndexChange
	        })
	      );
	    }
	  }]);
	
	  return RoleBasedMessagingRecipientsInput;
	}(_react2.default.Component);
	
	RoleBasedMessagingRecipientsInput.defaultProps = {
	  autoFocus: false,
	  hideResults: true,
	  showIndividuals: false,
	  query: ''
	};
	RoleBasedMessagingRecipientsInput.displayName = 'RoleBasedMessagingRecipientsInput';
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    results: state.roleBasedMessagingSearch.results,
	    resultSelectionIndex: state.roleBasedMessagingSearch.resultSelectionIndex,
	    query: state.roleBasedMessagingSearch.query,
	    selection: state.roleBasedMessagingSearch.selection,
	    highlightIndex: state.roleBasedMessagingSearch.highlightIndex
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    onChangeQuery: _roleBasedMessagingSearch.changeQuery,
	    onLoadGroups: _roleBasedMessagingSearch.loadGroups,
	    onLoadIndividuals: _roleBasedMessagingSearch.loadIndividuals,
	    onLoadPotentialChatMembers: _roleBasedMessagingSearch.loadPotentialChatMembers,
	    onSelect: _roleBasedMessagingSearch.select,
	    onSelectInitialTargets: _roleBasedMessagingSearch.selectInitialTargets,
	    onSelectAllGroups: _roleBasedMessagingSearch.selectAllGroups,
	    onChangeResultSelection: _roleBasedMessagingSearch.changeResultSelection,
	    onHighlightIndexChange: _roleBasedMessagingSearch.changeHighlightIndex,
	    onFlush: _roleBasedMessagingSearch.flush
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RoleBasedMessagingRecipientsInput);

/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1895);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddButton = function (_React$Component) {
	  _inherits(AddButton, _React$Component);
	
	  function AddButton() {
	    _classCallCheck(this, AddButton);
	
	    return _possibleConstructorReturn(this, (AddButton.__proto__ || Object.getPrototypeOf(AddButton)).apply(this, arguments));
	  }
	
	  _createClass(AddButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          highlight = _props.highlight,
	          className = _props.className,
	          disabled = _props.disabled,
	          linkId = _props.linkId,
	          onClick = _props.onClick,
	          size = _props.size,
	          children = _props.children,
	          others = _objectWithoutProperties(_props, ['highlight', 'className', 'disabled', 'linkId', 'onClick', 'size', 'children']);
	
	      return _react2.default.createElement(
	        _Link2.default,
	        _extends({}, others, {
	          className: (0, _classnames2.default)({
	            AddButton: true,
	            'AddButton-highlight': highlight
	          }, className),
	          disabled: disabled,
	          eventElementName: linkId,
	          onClick: onClick }),
	        _react2.default.createElement(
	          _Button2.default,
	          _extends({}, others, {
	            id: linkId,
	            className: 'AddButton-action AddButton-' + size,
	            level: 'secondary',
	            shape: 'circle',
	            disabled: disabled }),
	          '+'
	        ),
	        children
	      );
	    }
	  }]);
	
	  return AddButton;
	}(_react2.default.Component);
	
	AddButton.defaultProps = {
	  size: 'normal'
	};
	AddButton.displayName = 'AddButton';
	exports.default = AddButton;

/***/ },
/* 1895 */
1136,
/* 1896 */,
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsShallowCompare = __webpack_require__(1241);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _RoleBasedMessagingGroupResultItem = __webpack_require__(1898);
	
	var _RoleBasedMessagingGroupResultItem2 = _interopRequireDefault(_RoleBasedMessagingGroupResultItem);
	
	var _RoleBasedMessagingIndividualResultItem = __webpack_require__(1909);
	
	var _RoleBasedMessagingIndividualResultItem2 = _interopRequireDefault(_RoleBasedMessagingIndividualResultItem);
	
	var _roleBasedMessagingSearch = __webpack_require__(1901);
	
	__webpack_require__(1912);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var RoleBasedMessagingResultItem = function (_React$Component) {
	  _inherits(RoleBasedMessagingResultItem, _React$Component);
	
	  function RoleBasedMessagingResultItem() {
	    _classCallCheck(this, RoleBasedMessagingResultItem);
	
	    return _possibleConstructorReturn(this, (RoleBasedMessagingResultItem.__proto__ || Object.getPrototypeOf(RoleBasedMessagingResultItem)).apply(this, arguments));
	  }
	
	  _createClass(RoleBasedMessagingResultItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.scrollIntoView) {
	        setTimeout(function () {
	          // Because parent ScrollableArea is async
	          var node = _reactDom2.default.findDOMNode(_this2);
	          var nodeBottom = node.offsetTop + node.offsetHeight;
	          var scrollAreaBottom = node.offsetParent.scrollTop + node.offsetParent.offsetHeight;
	          if (nodeBottom > scrollAreaBottom) {
	            node.scrollIntoView();
	          }
	        }, 0);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.highlighted && !prevProps.highlighted) {
	        // Only scroll into view if the entire element is not visible, otherwise mouse hover would trigger scroll.
	        var node = _reactDom2.default.findDOMNode(this);
	        var nodeTop = node.offsetTop;
	        var nodeBottom = nodeTop + node.offsetHeight;
	        var scrollAreaTop = node.offsetParent.scrollTop;
	        var scrollAreaBottom = scrollAreaTop + node.offsetParent.offsetHeight;
	        if (nodeTop > scrollAreaBottom || nodeBottom < scrollAreaTop) {
	          node.scrollIntoView();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          recipients = _props.recipients,
	          rest = _objectWithoutProperties(_props, ['recipients']);
	
	      var groupRecipients = recipients.filter(function (r) {
	        return r.type === _roleBasedMessagingSearch.RECIPIENT_TYPES.GROUP_RECIPIENT;
	      });
	      var individualRecipients = recipients.filter(function (r) {
	        return r.type === _roleBasedMessagingSearch.RECIPIENT_TYPES.INDIVIDUAL_RECIPIENT;
	      });
	      var content = void 0;
	
	      if (groupRecipients.length) {
	        content = _react2.default.createElement(_RoleBasedMessagingGroupResultItem2.default, _extends({}, rest, {
	          recipients: groupRecipients
	        }));
	      } else {
	        var recipient = individualRecipients[0];
	        if (recipient.type === _roleBasedMessagingSearch.RECIPIENT_TYPES.INDIVIDUAL_RECIPIENT) {
	          content = _react2.default.createElement(_RoleBasedMessagingIndividualResultItem2.default, _extends({}, rest, {
	            recipient: recipient
	          }));
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'RoleBasedMessagingResultItem-container' },
	        content
	      );
	    }
	  }]);
	
	  return RoleBasedMessagingResultItem;
	}(_react2.default.Component);
	
	RoleBasedMessagingResultItem.defaultProps = {
	  scrollIntoView: false,
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {}
	};
	RoleBasedMessagingResultItem.displayName = 'RoleBasedMessagingResultItem';
	exports.default = RoleBasedMessagingResultItem;

/***/ },
/* 1898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _redux = __webpack_require__(476);
	
	var _Coin = __webpack_require__(1671);
	
	var _Coin2 = _interopRequireDefault(_Coin);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _modal = __webpack_require__(1188);
	
	var _UnknownRolesModalContainer = __webpack_require__(1899);
	
	var _UnknownRolesModalContainer2 = _interopRequireDefault(_UnknownRolesModalContainer);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _roleHelpers = __webpack_require__(1230);
	
	var _roleBasedMessagingSearch = __webpack_require__(1901);
	
	__webpack_require__(1907);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var RolesToken = function (_React$Component) {
	  _inherits(RolesToken, _React$Component);
	
	  function RolesToken() {
	    _classCallCheck(this, RolesToken);
	
	    return _possibleConstructorReturn(this, (RolesToken.__proto__ || Object.getPrototypeOf(RolesToken)).apply(this, arguments));
	  }
	
	  _createClass(RolesToken, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          role = _props.role,
	          selected = _props.selected,
	          highlighted = _props.highlighted,
	          isUnknown = _props.isUnknown;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onClick: this.props.onSelect,
	          onMouseEnter: this.props.onMouseEnter,
	          className: (0, _classnames2.default)('RolesToken', {
	            'RolesToken-selected': selected,
	            'RolesToken-highlighted': highlighted,
	            'RolesToken-unknown': isUnknown
	          }) },
	        _roleHelpers.roleName[role.role || _roleHelpers.EVERYONE],
	        _react2.default.createElement(
	          'div',
	          { className: 'RolesToken-count' },
	          _react2.default.createElement(
	            'span',
	            { className: 'RolesToken-count-divider' },
	            '|'
	          ),
	          '\xA0\xA0\xA0',
	          role.count
	        )
	      );
	    }
	  }]);
	
	  return RolesToken;
	}(_react2.default.Component);
	
	RolesToken.displayName = 'RolesToken';
	
	var RoleBasedMessagingGroupResultItem = function (_React$Component2) {
	  _inherits(RoleBasedMessagingGroupResultItem, _React$Component2);
	
	  function RoleBasedMessagingGroupResultItem() {
	    var _ref;
	
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, RoleBasedMessagingGroupResultItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = RoleBasedMessagingGroupResultItem.__proto__ || Object.getPrototypeOf(RoleBasedMessagingGroupResultItem)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
	      open: false
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  _createClass(RoleBasedMessagingGroupResultItem, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.selectedRecipients.length && nextProps.selectedRecipients.length) {
	        this.setState({ open: true });
	      }
	
	      if (this.props.selectedRecipients.length && !nextProps.selectedRecipients.length) {
	        this.setState({ open: false });
	      }
	    }
	  }, {
	    key: 'handleSelectPrimary',
	    value: function handleSelectPrimary() {
	      var recipients = this.props.recipients;
	      // With Teacher to Teacher announcements there may not be a group
	
	      var recipientWithGroup = recipients.find(function (r) {
	        return r.role.role === undefined;
	      });
	      var primaryRecipient = recipientWithGroup || recipients[0];
	
	      this.props.onSelect([primaryRecipient]);
	    }
	
	    // typecheck: ignore statement
	
	  }, {
	    key: 'handleDeselectGroup',
	    value: function handleDeselectGroup(e) {
	      e.stopPropagation();
	      var recipient = this.props.recipients[0];
	      this.props.onDeselectGroup(recipient.group);
	      this.setState({ open: false });
	    }
	  }, {
	    key: 'renderCheck',
	    value: function renderCheck() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        _Coin2.default,
	        {
	          onClick: function onClick(e) {
	            return _this3.handleDeselectGroup(e);
	          },
	          color: 'brand',
	          size: 'xxxlarge' },
	        _react2.default.createElement(_Glyph2.default, { name: 'check', color: 'white', size: 'large', solo: true })
	      );
	    }
	  }, {
	    key: 'renderRoleToken',
	    value: function renderRoleToken(recipient, i) {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          highlighted = _props2.highlighted,
	          onSelect = _props2.onSelect,
	          selectedRecipients = _props2.selectedRecipients,
	          resultSelectionIndex = _props2.resultSelectionIndex;
	
	
	      var handleSelect = function handleSelect(e) {
	        e.stopPropagation();
	        if (recipient.role.role === _roleHelpers.UNKNOWN) {
	          _this4.renderUnknownRolesModal();
	        } else {
	          onSelect([recipient]);
	        }
	      };
	
	      var handleMouseEnter = function handleMouseEnter() {
	        _this4.props.onChangeResultSelection(i);
	      };
	
	      var selected = selectedRecipients.some(function (s) {
	        return s.role.role === recipient.role.role;
	      });
	
	      return _react2.default.createElement(RolesToken, {
	        key: i,
	        role: recipient.role,
	        onSelect: handleSelect,
	        selected: selected,
	        highlighted: highlighted && i === resultSelectionIndex,
	        isUnknown: recipient.role.role === _roleHelpers.UNKNOWN,
	        onMouseEnter: handleMouseEnter
	      });
	    }
	  }, {
	    key: 'renderUnknownRolesModal',
	    value: function renderUnknownRolesModal() {
	      var _this5 = this;
	
	      var modal = _react2.default.createElement(_UnknownRolesModalContainer2.default, {
	        group: this.props.recipients[0].group,
	        onClose: function onClose() {
	          return _this5.props.onLoadGroups(_GroupStore2.default.getGroups());
	        }
	      });
	      (0, _modal.mountModal)(modal, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var open = this.state.open;
	      var _props3 = this.props,
	          recipients = _props3.recipients,
	          highlighted = _props3.highlighted,
	          selectedRecipients = _props3.selectedRecipients,
	          query = _props3.query;
	
	      var recipient = recipients[0];
	      var group = recipient.group;
	      var selected = !!selectedRecipients.length;
	
	      var handleSelect = function handleSelect(e) {
	        e.stopPropagation();
	        if (!selected) {
	          _this6.handleSelectPrimary();
	        }
	      };
	
	      return _react2.default.createElement(
	        'li',
	        {
	          onMouseEnter: this.props.onMouseEnter,
	          onMouseLeave: this.props.onMouseLeave,
	          onClick: handleSelect,
	          className: (0, _classnames2.default)('RoleBasedMessagingGroupResultItem', {
	            'RoleBasedMessagingGroupResultItem-highlighted': highlighted,
	            'RoleBasedMessagingGroupResultItem-selected': selected
	          }),
	          key: group.id },
	        _react2.default.createElement(
	          'div',
	          { className: 'RoleBasedMessagingGroupResultItem-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'RoleBasedMessagingGroupResultItem-info' },
	            _react2.default.createElement(
	              'div',
	              { className: 'RoleBasedMessagingGroupResultItem-circle' },
	              selected ? this.renderCheck() : _react2.default.createElement(_GroupAvatar2.default, { group: group, size: 'small' })
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                onClick: selected ? function (e) {
	                  return _this6.handleDeselectGroup(e);
	                } : handleSelect,
	                className: 'RoleBasedMessagingGroupResultItem-name' },
	              _react2.default.createElement(
	                _Text2.default,
	                {
	                  truncate: true,
	                  color: 'pitch',
	                  size: 'small' },
	                _react2.default.createElement(_GroupName2.default, { group: group })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'RoleBasedMessagingGroupResultItem-roles-container' },
	            (selected || query || open) && recipients.map(function (r, i) {
	              return _this6.renderRoleToken(r, i);
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return RoleBasedMessagingGroupResultItem;
	}(_react2.default.Component);
	
	RoleBasedMessagingGroupResultItem.displayName = 'RoleBasedMessagingGroupResultItem';
	
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    onLoadGroups: _roleBasedMessagingSearch.loadGroups,
	    onDeselectGroup: _roleBasedMessagingSearch.deselectGroup,
	    onChangeResultSelection: _roleBasedMessagingSearch.changeResultSelection
	  }, dispatch);
	}
	
	// $FlowIssue
	exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(RoleBasedMessagingGroupResultItem);

/***/ },
/* 1899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _GroupMembershipStore = __webpack_require__(1900);
	
	var _GroupMembershipStore2 = _interopRequireDefault(_GroupMembershipStore);
	
	var _BatchRoleCorrectionModal = __webpack_require__(1577);
	
	var _BatchRoleCorrectionModal2 = _interopRequireDefault(_BatchRoleCorrectionModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var zeroRolesFilter = function zeroRolesFilter(m) {
	  var orgView = m.getOrgAffiliationView();
	  return !!orgView && orgView.roles.length === 0;
	};
	
	var UnknownRolesModalContainer = function (_React$Component) {
	  _inherits(UnknownRolesModalContainer, _React$Component);
	
	  function UnknownRolesModalContainer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UnknownRolesModalContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UnknownRolesModalContainer.__proto__ || Object.getPrototypeOf(UnknownRolesModalContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      unknownRoles: [],
	      loading: true
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UnknownRolesModalContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      _GroupActions2.default.loadGroupMemberships(this.props.group, {
	        perPage: 500,
	        role: 'unknown'
	      }).then(function () {
	        return _this2.setState({ loading: false });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          group = _props.group,
	          onRequestHide = _props.onRequestHide,
	          onClose = _props.onClose;
	      var _state = this.state,
	          unknownRoles = _state.unknownRoles,
	          loading = _state.loading;
	
	      return _react2.default.createElement(_BatchRoleCorrectionModal2.default, {
	        group: group,
	        onRequestHide: onRequestHide,
	        onClose: onClose,
	        groupMemberships: unknownRoles,
	        loading: loading
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_GroupMembershipStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState, props) {
	      var all = _GroupMembershipStore2.default.getGroupMembershipsForGroup(props.group.id);
	
	      return {
	        unknownRoles: all.filter(zeroRolesFilter)
	      };
	    }
	  }]);
	
	  return UnknownRolesModalContainer;
	}(_react2.default.Component);
	
	UnknownRolesModalContainer.displayName = 'UnknownRolesModalContainer';
	exports.default = _utils.Container.create(UnknownRolesModalContainer, { withProps: true });

/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _GroupConstants = __webpack_require__(991);
	
	var _GroupMembershipConstants = __webpack_require__(1011);
	
	var _OrganizationConstants = __webpack_require__(1004);
	
	var _GroupMemberships = __webpack_require__(996);
	
	var _GroupMemberships2 = _interopRequireDefault(_GroupMemberships);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _PusherConstants = __webpack_require__(954);
	
	var _RelationshipConstants = __webpack_require__(986);
	
	var _RootGroup = __webpack_require__(943);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupMembershipStore = function (_Store) {
	  _inherits(GroupMembershipStore, _Store);
	
	  function GroupMembershipStore() {
	    _classCallCheck(this, GroupMembershipStore);
	
	    return _possibleConstructorReturn(this, (GroupMembershipStore.__proto__ || Object.getPrototypeOf(GroupMembershipStore)).apply(this, arguments));
	  }
	
	  _createClass(GroupMembershipStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        members: new _GroupMemberships2.default(),
	        isQueryComplete: {},
	        hasBeenLoaded: {}
	      };
	    }
	  }, {
	    key: 'isLoadedForGroup',
	    value: function isLoadedForGroup(groupUuid) {
	      return !!this.state.hasBeenLoaded[groupUuid];
	    }
	  }, {
	    key: 'getGroupMembership',
	    value: function getGroupMembership(membershipId) {
	      return this.state.members.get(membershipId);
	    }
	  }, {
	    key: 'getGroupMembershipsForGroup',
	    value: function getGroupMembershipsForGroup(groupId) {
	      if (groupId === _RootGroup.rootGroup.id) {
	        return new _GroupMemberships2.default((0, _lodash.uniqBy)(this.state.members.toArray(), function (m) {
	          return m.getUser().id;
	        }));
	      }
	      return new _GroupMemberships2.default(this.state.members.filter(function (member) {
	        return member.getGroupId() === groupId;
	      }));
	    }
	  }, {
	    key: 'removeGroupMembershipsForGroup',
	    value: function removeGroupMembershipsForGroup(groupId) {
	      var membersToDelete = this.getGroupMembershipsForGroup(groupId);
	      this.state.members.remove(membersToDelete);
	    }
	  }, {
	    key: 'allMembersLoadedForGroup',
	    value: function allMembersLoadedForGroup(groupUuid) {
	      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      var loaded = this.state.isQueryComplete;
	      if (groupUuid in loaded) {
	        return !!loaded[groupUuid][query];
	      } else {
	        return false;
	      }
	    }
	
	    /* Copy over the related user of a relationship into
	     * the group membership user object. This is useful when
	     * the relation is updated (the name is confirmed, or the note updated)
	     */
	
	  }, {
	    key: 'handleRelationshipUpdate',
	    value: function handleRelationshipUpdate(relationship) {
	      if (!relationship.getSubscriptionsToMe().isEmpty()) {
	        var userId = relationship.getSubscriptionsToMe().first().id;
	        var member = this.getGroupMembership(userId);
	
	        if (member) {
	          /* We need to clone the membership list so that containers
	           * know to rerender when performing a shallow comparison
	           * of the otherwise unchanged backbone collection.
	           */
	          member.getUser().set(relationship.getRelatedUser().toJSON());
	          this.state.members = this.state.members.clone();
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      var _this2 = this;
	
	      switch (action.type) {
	        case _PusherConstants.PushEvents.CHANGESET_CREATE_CLASSMEMBERSHIP:
	          {
	            // this assumes all classmembership update are for the same group.
	            // which is the case currently with this push event
	            var ids = action.changes.map(function (change) {
	              return change.content.related_user_id;
	            });
	            var group = _Group2.default.fromJSON({
	              uuid: action.changes[0].content.group_uuid
	            });
	
	            _GroupActions2.default.loadGroupMemberships(group, {
	              perPage: ids.length,
	              userIds: ids
	            });
	
	            break;
	          }
	        case _PusherConstants.PushEvents.CHANGESET_DESTROY_CLASSMEMBERSHIP:
	          {
	            action.changes.forEach(function (change) {
	              return _this2.state.members.remove(change.content.membership_id);
	            });
	            this.emitChange();
	            break;
	          }
	        case _GroupMembershipConstants.ActionTypes.LOAD_CLASS_MEMBERS:
	          {
	            this.handleLoadMembers(action.members);
	            var uuid = action.group.getUuid() || 'r';
	            this.state.hasBeenLoaded[uuid] = true;
	
	            if (action.members.length < action.membersRequested) {
	              if (!(uuid in this.state.isQueryComplete)) {
	                this.state.isQueryComplete[uuid] = {};
	              }
	              this.state.isQueryComplete[uuid][action.query] = true;
	            }
	
	            this.emitChange();
	            break;
	          }
	        case _RelationshipConstants.ActionTypes.UPDATE_RELATIONSHIP:
	          if (this.handleRelationshipUpdate(action.relationship)) {
	            this.emitChange();
	          }
	          break;
	        case _GroupMembershipConstants.ActionTypes.PROMOTED_CLASS_MEMBERS:
	          this.handleLoadMembers(action.members);
	          this.emitChange();
	          break;
	        case _GroupMembershipConstants.ActionTypes.REMOVE_SUBSCRIBER:
	          {
	            var membership = this.state.members.find(function (m) {
	              return m.getUser() === action.subscriber;
	            });
	            this.state.members.remove(membership);
	            this.emitChange();
	            break;
	          }
	        case _GroupConstants.ActionTypes.LIST_GROUPS:
	          action.groups.forEach(function (group) {
	            return _this2.handleLoadMembers(group.getOwners());
	          });
	          this.emitChange();
	          break;
	        case _GroupConstants.ActionTypes.LOAD_GROUP:
	        case _GroupConstants.ActionTypes.UPDATE_GROUP:
	          this.handleLoadMembers(action.group.getOwners());
	          this.emitChange();
	          break;
	        case _GroupConstants.ActionTypes.CREATE_GROUP:
	        case _GroupConstants.ActionTypes.GROUPS_UPDATED:
	          action.groups.forEach(function (group) {
	            return _this2.handleLoadMembers(group.getOwners());
	          });
	          this.emitChange();
	          break;
	        case _OrganizationConstants.ActionTypes.UPDATE_ORG_AFF_VIEW:
	          this.state.members.forEach(function (m) {
	            if (m.getUser().id === action.userId) {
	              m.set('org_affiliation_view', action.orgAffView);
	            }
	          });
	          this.emitChange();
	          break;
	        case _GroupConstants.ActionTypes.CHANGE_ORG:
	          {
	            var groupUuid = action.groupUuid;
	
	            this.state.isQueryComplete[groupUuid] = {};
	            this.state.hasBeenLoaded[groupUuid] = false;
	            this.state.members = new _GroupMemberships2.default(this.state.members.filter(function (m) {
	              return m.getGroupId() !== action.groupId;
	            }));
	            this.emitChange();
	            break;
	          }
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'handleLoadMembers',
	    value: function handleLoadMembers(members) {
	      var _this3 = this;
	
	      members.forEach(function (member) {
	        return _this3.state.members.add(member);
	      });
	    }
	  }]);
	
	  return GroupMembershipStore;
	}(_Store3.default);
	
	GroupMembershipStore.displayName = 'GroupMembershipStore';
	exports.default = new GroupMembershipStore();

/***/ },
/* 1901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadPotentialChatMembers = exports.loadPotentialChatMembersSuccess = exports.reset = exports.flush = exports.changeHighlightIndex = exports.changeResultSelection = exports.deselectIndividual = exports.deselectGroup = exports.selectAllGroups = exports.selectGroup = exports.selectInitialTargets = exports.select = exports.changeQuery = exports.loadIndividuals = exports.loadGroups = exports.createTargets = exports.RECIPIENT_TYPES = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rolesOrder;
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _fuzzaldrin = __webpack_require__(1902);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _PotentialChatMember = __webpack_require__(945);
	
	var _PotentialChatMember2 = _interopRequireDefault(_PotentialChatMember);
	
	var _PotentialChatMembers = __webpack_require__(946);
	
	var _PotentialChatMembers2 = _interopRequireDefault(_PotentialChatMembers);
	
	var _Message = __webpack_require__(930);
	
	var _roleHelpers = __webpack_require__(1230);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	// typecheck: ignore file
	
	
	var fuzzaldrinOptions = {
	  key: 'searchString'
	};
	
	var RECIPIENT_TYPES = exports.RECIPIENT_TYPES = {
	  GROUP_RECIPIENT: 'group_recipient',
	  INDIVIDUAL_RECIPIENT: 'individual_recipient'
	};
	
	var initialState = {
	  recipients: [],
	  results: [],
	  resultSelectionIndex: 0,
	  selection: [],
	  targets: [],
	  query: '',
	  highlightIndex: -1
	};
	
	var createTargets = exports.createTargets = function createTargets(recipients) {
	  return recipients.map(function (r) {
	    var t = void 0;
	    if (r.type === RECIPIENT_TYPES.GROUP_RECIPIENT) {
	      t = { type: _Message.TARGET_TYPES.GROUP_TARGET, group_id: r.group.id, role: r.role.role || _roleHelpers.EVERYONE };
	    } else {
	      t = { type: _Message.TARGET_TYPES.INDIVIDUAL_TARGET, member_id: r.member.id };
	    }
	    return t;
	  });
	};
	
	var rolesOrder = (_rolesOrder = {}, _defineProperty(_rolesOrder, _roleHelpers.EVERYONE, 0), _defineProperty(_rolesOrder, _roleHelpers.STUDENT, 1), _defineProperty(_rolesOrder, _roleHelpers.PARENT, 2), _defineProperty(_rolesOrder, _roleHelpers.TEACHER, 3), _defineProperty(_rolesOrder, _roleHelpers.ADMIN, 4), _defineProperty(_rolesOrder, _roleHelpers.UNKNOWN, 5), _rolesOrder);
	
	var getRoleOrder = function getRoleOrder(r) {
	  var role = _roleHelpers.EVERYONE;
	  if (r.type === RECIPIENT_TYPES.GROUP_RECIPIENT) {
	    role = r.role.role || _roleHelpers.EVERYONE;
	  }
	  return rolesOrder[role];
	};
	
	var groupRecipients = function groupRecipients(recipients) {
	  var resIndex = {};
	  recipients.forEach(function (r, i) {
	    if (r.type === RECIPIENT_TYPES.GROUP_RECIPIENT) {
	      if (!resIndex[r.group.id]) {
	        resIndex[r.group.id] = i;
	      }
	    }
	  });
	
	  var unsortedRecipients = (0, _lodash2.default)(recipients).groupBy(function (r) {
	    return r.group.id;
	  }).values().value();
	
	  return unsortedRecipients.sort(function (a, b) {
	    return resIndex[a[0].group.id] - resIndex[b[0].group.id];
	  }).map(function (r) {
	    return r.sort(function (a, b) {
	      return getRoleOrder(a) - getRoleOrder(b);
	    });
	  });
	};
	
	var generateResults = function generateResults(recipients) {
	  var group = recipients.filter(function (r) {
	    return r.type === RECIPIENT_TYPES.GROUP_RECIPIENT;
	  });
	  var individual = recipients.filter(function (r) {
	    return r.type === RECIPIENT_TYPES.INDIVIDUAL_RECIPIENT;
	  });
	  var groupResults = groupRecipients(group);
	  var individualResults = _lodash2.default.values(_lodash2.default.groupBy([].concat(_toConsumableArray(individual)), function (r) {
	    return r.id;
	  }));
	  return [].concat(_toConsumableArray(groupResults), _toConsumableArray(individualResults));
	};
	
	var calcResults = function calcResults(recipients, query) {
	  if (query) {
	    return (0, _fuzzaldrin.filter)(recipients, query, fuzzaldrinOptions);
	  } else {
	    return recipients;
	  }
	};
	
	var createIndividualRecipient = function createIndividualRecipient(member) {
	  return {
	    type: 'individual_recipient',
	    member: member,
	    id: member.id,
	    searchString: member.getName() + ' ' + member.getFirstName() + ' ' + member.getLastName() + ' ' + member.getNote() + ' ' + member.getGroupNames()
	  };
	};
	
	var createGroupRecipient = function createGroupRecipient(group) {
	  var role = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { count: group.getMembershipsCount() };
	  // eslint-disable-line
	  return {
	    type: RECIPIENT_TYPES.GROUP_RECIPIENT,
	    role: role,
	    group: group,
	    // $FlowIssue
	    id: (0, _roleHelpers.getGroupKey)(group.id, role.role),
	    searchString: group.getName() + ' ' + (role.role || _roleHelpers.EVERYONE)
	  };
	};
	
	var loadGroups = exports.loadGroups = function loadGroups(groups) {
	  return {
	    type: 'rbms/LOAD_GROUPS',
	    groups: groups
	  };
	};
	
	var loadIndividuals = exports.loadIndividuals = function loadIndividuals(members) {
	  return {
	    type: 'rbms/LOAD_INDIVIDUALS',
	    members: members
	  };
	};
	
	var changeQuery = exports.changeQuery = function changeQuery(query) {
	  return {
	    type: 'rbms/CHANGE_QUERY',
	    query: query
	  };
	};
	
	var select = exports.select = function select(recipients) {
	  return {
	    type: 'rbms/SELECT',
	    recipients: recipients
	  };
	};
	
	var selectInitialTargets = exports.selectInitialTargets = function selectInitialTargets(targets) {
	  return {
	    type: 'rbms/SELECT_INITIAL_TARGETS',
	    targets: targets
	  };
	};
	
	var selectGroup = exports.selectGroup = function selectGroup(group) {
	  return {
	    type: 'rbms/SELECT',
	    recipients: [{
	      group: group,
	      role: { role: undefined },
	      id: group.id + '~',
	      type: RECIPIENT_TYPES.GROUP_RECIPIENT
	    }]
	  };
	};
	
	var selectAllGroups = exports.selectAllGroups = function selectAllGroups() {
	  return {
	    type: 'rbms/SELECT_ALL_GROUPS'
	  };
	};
	
	var deselectGroup = exports.deselectGroup = function deselectGroup(group) {
	  return {
	    type: 'rbms/DESELECT_GROUP',
	    group: group
	  };
	};
	
	var deselectIndividual = exports.deselectIndividual = function deselectIndividual(member) {
	  return {
	    type: 'rbms/DESELECT_INDIVIDUAL',
	    member: member
	  };
	};
	
	var changeResultSelection = exports.changeResultSelection = function changeResultSelection(selectedIndex) {
	  return {
	    type: 'rbms/CHANGE_RESULT_SELECTION',
	    selectedIndex: selectedIndex
	  };
	};
	
	var changeHighlightIndex = exports.changeHighlightIndex = function changeHighlightIndex(index) {
	  return {
	    type: 'rbms/CHANGE_HIGHLIGHT_INDEX',
	    index: index
	  };
	};
	
	var flush = exports.flush = function flush() {
	  return {
	    type: 'rbms/FLUSH'
	  };
	};
	
	var reset = exports.reset = function reset() {
	  return {
	    type: 'rbms/RESET'
	  };
	};
	
	var loadPotentialChatMembersSuccess = exports.loadPotentialChatMembersSuccess = function loadPotentialChatMembersSuccess(members) {
	  return {
	    type: 'rbms/LOAD_POTENTIAL_CHAT_MEMBERS_REQUEST_SUCCESS',
	    members: members
	  };
	};
	
	var loadPotentialChatMembers = exports.loadPotentialChatMembers = function loadPotentialChatMembers(query) {
	  return {
	    type: 'rbms/LOAD_POTENTIAL_CHAT_MEMBERS_REQUEST',
	    query: query
	  };
	};
	
	// typecheck: ignore statement
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'rbms/LOAD_GROUPS':
	      {
	        var _groups = action.groups;
	
	        var _recipients = _groups.reduce(function (acc, group) {
	          var postableRoles = group.getPostableRoles();
	          var recipientsToInclude = group.getRoles().filter(function (role) {
	            return postableRoles.includes(role.role) || role.role === _roleHelpers.UNKNOWN;
	          }).map(function (role) {
	            return createGroupRecipient(group, role);
	          });
	          if (postableRoles.includes(_roleHelpers.EVERYONE)) {
	            recipientsToInclude.push(createGroupRecipient(group));
	          }
	          return [].concat(_toConsumableArray(acc), _toConsumableArray(recipientsToInclude));
	        }, []);
	
	        var currentRecipients = state.recipients,
	            rest = _objectWithoutProperties(state, ['recipients']);
	
	        var allRecipients = _lodash2.default.uniqBy([].concat(_toConsumableArray(currentRecipients), _toConsumableArray(_recipients)), function (r) {
	          return r.id;
	        });
	
	        return _extends({}, rest, {
	          results: generateResults(calcResults(allRecipients, state.query)),
	          recipients: allRecipients
	        });
	      }
	    case 'rbms/LOAD_INDIVIDUALS':
	      {
	        var _members = action.members;
	
	        var _recipients2 = _members.map(function (m) {
	          return createIndividualRecipient(m);
	        });
	
	        var _currentRecipients = state.recipients,
	            _rest = _objectWithoutProperties(state, ['recipients']);
	
	        var _allRecipients = _lodash2.default.uniqBy([].concat(_toConsumableArray(_currentRecipients), _toConsumableArray(_recipients2)), function (r) {
	          return r.id;
	        });
	
	        return _extends({}, _rest, {
	          results: generateResults(calcResults(_allRecipients, state.query)),
	          recipients: _allRecipients
	        });
	      }
	
	    case 'rbms/LOAD_POTENTIAL_CHAT_MEMBERS_REQUEST_SUCCESS':
	      {
	        var _members2 = action.members;
	        var _currentRecipients2 = state.recipients,
	            _query = state.query;
	
	        var _allRecipients2 = [].concat(_toConsumableArray(_currentRecipients2));
	        if (_members2) {
	          var _recipients3 = _members2.map(function (m) {
	            return createIndividualRecipient(m);
	          });
	          _allRecipients2 = [].concat(_toConsumableArray(_allRecipients2), _toConsumableArray(_recipients3));
	        }
	        _allRecipients2 = _lodash2.default.uniqBy(_allRecipients2, function (r) {
	          return r.id;
	        });
	
	        return _extends({}, state, {
	          results: generateResults(calcResults(_allRecipients2, _query)),
	          recipients: _allRecipients2,
	          loadingIndividualRecipients: false,
	          query: _query
	        });
	      }
	
	    case 'rbms/CHANGE_QUERY':
	      {
	        var _query2 = action.query;
	
	        return _extends({}, state, {
	          results: generateResults(calcResults(state.recipients, _query2)),
	          resultSelectionIndex: 0,
	          query: _query2
	        });
	      }
	    case 'rbms/SELECT':
	      {
	        var _ret = function () {
	          var recipient = action.recipients.length === 1 ? action.recipients[0] : action.recipients[state.resultSelectionIndex];
	
	          var selection = state.selection;
	
	          var newSelection = void 0;
	          if (state.selection.some(function (s) {
	            return s.id === recipient.id;
	          })) {
	            // selecting something already selected removes it
	            newSelection = selection.filter(function (s) {
	              return s.id !== recipient.id;
	            });
	          } else {
	            if (recipient.type === RECIPIENT_TYPES.GROUP_RECIPIENT) {
	              if (recipient.role.role === undefined) {
	                // when adding everyone, remove all the others from that group
	                var filteredSelection = selection.filter(function (s) {
	                  return !s.group || s.group.id !== recipient.group.id;
	                });
	                newSelection = [].concat(_toConsumableArray(filteredSelection), [recipient]);
	              } else {
	                // when adding !everyone, remove everyone
	                var selectionWithoutEveryone = selection.filter(function (s) {
	                  if (s.type === RECIPIENT_TYPES.INDIVIDUAL_RECIPIENT) {
	                    return true;
	                  } else {
	                    return !(s.group.id === recipient.group.id && s.role.role === undefined);
	                  }
	                });
	                newSelection = [].concat(_toConsumableArray(selectionWithoutEveryone), [recipient]);
	              }
	            } else {
	              newSelection = [].concat(_toConsumableArray(selection), [recipient]);
	            }
	          }
	          return {
	            v: _extends({}, state, {
	              selection: newSelection,
	              targets: createTargets(newSelection)
	            })
	          };
	        }();
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	      }
	    case 'rbms/DESELECT_GROUP':
	      {
	        var _ret2 = function () {
	          var group = action.group;
	
	          var filteredSelection = state.selection.filter(function (s) {
	            if (s.type === RECIPIENT_TYPES.INDIVIDUAL_RECIPIENT) {
	              return true;
	            }
	            return s.group.id !== group.id;
	          });
	          return {
	            v: _extends({}, state, {
	              selection: filteredSelection,
	              targets: createTargets(filteredSelection)
	            })
	          };
	        }();
	
	        if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	      }
	    case 'rbms/DESELECT_INDIVIDUAL':
	      {
	        var _ret3 = function () {
	          var member = action.member;
	
	          var filteredSelection = state.selection.filter(function (s) {
	            if (s.type === RECIPIENT_TYPES.GROUP_RECIPIENT) {
	              return true;
	            }
	            return s.id !== member.id;
	          });
	          return {
	            v: _extends({}, state, {
	              selection: filteredSelection,
	              targets: createTargets(filteredSelection)
	            })
	          };
	        }();
	
	        if ((typeof _ret3 === 'undefined' ? 'undefined' : _typeof(_ret3)) === "object") return _ret3.v;
	      }
	    case 'rbms/SELECT_INITIAL_TARGETS':
	      {
	        var _targets = action.targets;
	
	        var _selection = _targets.map(function (t) {
	          return state.recipients.find(function (r) {
	            return r.id === (0, _roleHelpers.getGroupKey)(t.group_id, t.role);
	          });
	        });
	        return _extends({}, state, {
	          selection: _selection,
	          targets: createTargets(_selection)
	        });
	      }
	    case 'rbms/SELECT_ALL_GROUPS':
	      {
	        var newSelection = state.recipients.filter(function (r) {
	          if (r.type === RECIPIENT_TYPES.INDIVIDUAL_RECIPIENT) {
	            return true;
	          }
	          return r.role.role === undefined;
	        });
	
	        var _allRecipients3 = _lodash2.default.uniqBy(newSelection, function (r) {
	          return r.id;
	        });
	
	        return _extends({}, state, {
	          selection: _allRecipients3,
	          targets: createTargets(_allRecipients3)
	        });
	      }
	    case 'rbms/CHANGE_RESULT_SELECTION':
	      {
	        return _extends({}, state, {
	          resultSelectionIndex: action.selectedIndex
	        });
	      }
	    case 'rbms/CHANGE_HIGHLIGHT_INDEX':
	      {
	        return _extends({}, state, {
	          highlightIndex: action.index
	        });
	      }
	    case 'rbms/RESET':
	      {
	        return _extends({}, initialState, {
	          results: generateResults(calcResults(state.recipients, '')),
	          recipients: state.recipients
	        });
	      }
	    case 'rbms/FLUSH':
	      {
	        return initialState;
	      }
	
	    case 'rbms/LOAD_POTENTIAL_CHAT_MEMBERS_REQUEST':
	      {
	        return _extends({}, state, {
	          query: action.query,
	          loadingIndividualRecipients: true
	        });
	      }
	    default:
	      return state;
	  }
	};

/***/ },
/* 1902 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var PathSeparator, SpaceRegex, filter, matcher, scorer;
	
	  scorer = __webpack_require__(1903);
	
	  filter = __webpack_require__(1905);
	
	  matcher = __webpack_require__(1906);
	
	  PathSeparator = __webpack_require__(1904).sep;
	
	  SpaceRegex = /\ /g;
	
	  module.exports = {
	    filter: function(candidates, query, options) {
	      var queryHasSlashes;
	      if (query) {
	        queryHasSlashes = query.indexOf(PathSeparator) !== -1;
	        query = query.replace(SpaceRegex, '');
	      }
	      return filter(candidates, query, queryHasSlashes, options);
	    },
	    score: function(string, query) {
	      var queryHasSlashes, score;
	      if (!string) {
	        return 0;
	      }
	      if (!query) {
	        return 0;
	      }
	      if (string === query) {
	        return 2;
	      }
	      queryHasSlashes = query.indexOf(PathSeparator) !== -1;
	      query = query.replace(SpaceRegex, '');
	      score = scorer.score(string, query);
	      if (!queryHasSlashes) {
	        score = scorer.basenameScore(string, query, score);
	      }
	      return score;
	    },
	    match: function(string, query) {
	      var baseMatches, index, matches, queryHasSlashes, seen, _i, _ref, _results;
	      if (!string) {
	        return [];
	      }
	      if (!query) {
	        return [];
	      }
	      if (string === query) {
	        return (function() {
	          _results = [];
	          for (var _i = 0, _ref = string.length; 0 <= _ref ? _i < _ref : _i > _ref; 0 <= _ref ? _i++ : _i--){ _results.push(_i); }
	          return _results;
	        }).apply(this);
	      }
	      queryHasSlashes = query.indexOf(PathSeparator) !== -1;
	      query = query.replace(SpaceRegex, '');
	      matches = matcher.match(string, query);
	      if (!queryHasSlashes) {
	        baseMatches = matcher.basenameMatch(string, query);
	        matches = matches.concat(baseMatches).sort(function(a, b) {
	          return a - b;
	        });
	        seen = null;
	        index = 0;
	        while (index < matches.length) {
	          if (index && seen === matches[index]) {
	            matches.splice(index, 1);
	          } else {
	            seen = matches[index];
	            index++;
	          }
	        }
	      }
	      return matches;
	    }
	  };
	
	}).call(this);


/***/ },
/* 1903 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var PathSeparator, queryIsLastPathSegment;
	
	  PathSeparator = __webpack_require__(1904).sep;
	
	  exports.basenameScore = function(string, query, score) {
	    var base, depth, index, lastCharacter, segmentCount, slashCount;
	    index = string.length - 1;
	    while (string[index] === PathSeparator) {
	      index--;
	    }
	    slashCount = 0;
	    lastCharacter = index;
	    base = null;
	    while (index >= 0) {
	      if (string[index] === PathSeparator) {
	        slashCount++;
	        if (base == null) {
	          base = string.substring(index + 1, lastCharacter + 1);
	        }
	      } else if (index === 0) {
	        if (lastCharacter < string.length - 1) {
	          if (base == null) {
	            base = string.substring(0, lastCharacter + 1);
	          }
	        } else {
	          if (base == null) {
	            base = string;
	          }
	        }
	      }
	      index--;
	    }
	    if (base === string) {
	      score *= 2;
	    } else if (base) {
	      score += exports.score(base, query);
	    }
	    segmentCount = slashCount + 1;
	    depth = Math.max(1, 10 - segmentCount);
	    score *= depth * 0.01;
	    return score;
	  };
	
	  exports.score = function(string, query) {
	    var character, characterScore, indexInQuery, indexInString, lowerCaseIndex, minIndex, queryLength, queryScore, stringLength, totalCharacterScore, upperCaseIndex, _ref;
	    if (string === query) {
	      return 1;
	    }
	    if (queryIsLastPathSegment(string, query)) {
	      return 1;
	    }
	    totalCharacterScore = 0;
	    queryLength = query.length;
	    stringLength = string.length;
	    indexInQuery = 0;
	    indexInString = 0;
	    while (indexInQuery < queryLength) {
	      character = query[indexInQuery++];
	      lowerCaseIndex = string.indexOf(character.toLowerCase());
	      upperCaseIndex = string.indexOf(character.toUpperCase());
	      minIndex = Math.min(lowerCaseIndex, upperCaseIndex);
	      if (minIndex === -1) {
	        minIndex = Math.max(lowerCaseIndex, upperCaseIndex);
	      }
	      indexInString = minIndex;
	      if (indexInString === -1) {
	        return 0;
	      }
	      characterScore = 0.1;
	      if (string[indexInString] === character) {
	        characterScore += 0.1;
	      }
	      if (indexInString === 0 || string[indexInString - 1] === PathSeparator) {
	        characterScore += 0.8;
	      } else if ((_ref = string[indexInString - 1]) === '-' || _ref === '_' || _ref === ' ') {
	        characterScore += 0.7;
	      }
	      string = string.substring(indexInString + 1, stringLength);
	      totalCharacterScore += characterScore;
	    }
	    queryScore = totalCharacterScore / queryLength;
	    return ((queryScore * (queryLength / stringLength)) + queryScore) / 2;
	  };
	
	  queryIsLastPathSegment = function(string, query) {
	    if (string[string.length - query.length - 1] === PathSeparator) {
	      return string.lastIndexOf(query) === string.length - query.length;
	    }
	  };
	
	}).call(this);


/***/ },
/* 1904 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ },
/* 1905 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var pluckCandidates, scorer, sortCandidates;
	
	  scorer = __webpack_require__(1903);
	
	  pluckCandidates = function(a) {
	    return a.candidate;
	  };
	
	  sortCandidates = function(a, b) {
	    return b.score - a.score;
	  };
	
	  module.exports = function(candidates, query, queryHasSlashes, _arg) {
	    var candidate, key, maxResults, score, scoredCandidates, string, _i, _len, _ref;
	    _ref = _arg != null ? _arg : {}, key = _ref.key, maxResults = _ref.maxResults;
	    if (query) {
	      scoredCandidates = [];
	      for (_i = 0, _len = candidates.length; _i < _len; _i++) {
	        candidate = candidates[_i];
	        string = key != null ? candidate[key] : candidate;
	        if (!string) {
	          continue;
	        }
	        score = scorer.score(string, query, queryHasSlashes);
	        if (!queryHasSlashes) {
	          score = scorer.basenameScore(string, query, score);
	        }
	        if (score > 0) {
	          scoredCandidates.push({
	            candidate: candidate,
	            score: score
	          });
	        }
	      }
	      scoredCandidates.sort(sortCandidates);
	      candidates = scoredCandidates.map(pluckCandidates);
	    }
	    if (maxResults != null) {
	      candidates = candidates.slice(0, maxResults);
	    }
	    return candidates;
	  };
	
	}).call(this);


/***/ },
/* 1906 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var PathSeparator;
	
	  PathSeparator = __webpack_require__(1904).sep;
	
	  exports.basenameMatch = function(string, query) {
	    var base, index, lastCharacter, slashCount;
	    index = string.length - 1;
	    while (string[index] === PathSeparator) {
	      index--;
	    }
	    slashCount = 0;
	    lastCharacter = index;
	    base = null;
	    while (index >= 0) {
	      if (string[index] === PathSeparator) {
	        slashCount++;
	        if (base == null) {
	          base = string.substring(index + 1, lastCharacter + 1);
	        }
	      } else if (index === 0) {
	        if (lastCharacter < string.length - 1) {
	          if (base == null) {
	            base = string.substring(0, lastCharacter + 1);
	          }
	        } else {
	          if (base == null) {
	            base = string;
	          }
	        }
	      }
	      index--;
	    }
	    return exports.match(base, query, string.length - base.length);
	  };
	
	  exports.match = function(string, query, stringOffset) {
	    var character, indexInQuery, indexInString, lowerCaseIndex, matches, minIndex, queryLength, stringLength, upperCaseIndex, _i, _ref, _results;
	    if (stringOffset == null) {
	      stringOffset = 0;
	    }
	    if (string === query) {
	      return (function() {
	        _results = [];
	        for (var _i = stringOffset, _ref = stringOffset + string.length; stringOffset <= _ref ? _i < _ref : _i > _ref; stringOffset <= _ref ? _i++ : _i--){ _results.push(_i); }
	        return _results;
	      }).apply(this);
	    }
	    queryLength = query.length;
	    stringLength = string.length;
	    indexInQuery = 0;
	    indexInString = 0;
	    matches = [];
	    while (indexInQuery < queryLength) {
	      character = query[indexInQuery++];
	      lowerCaseIndex = string.indexOf(character.toLowerCase());
	      upperCaseIndex = string.indexOf(character.toUpperCase());
	      minIndex = Math.min(lowerCaseIndex, upperCaseIndex);
	      if (minIndex === -1) {
	        minIndex = Math.max(lowerCaseIndex, upperCaseIndex);
	      }
	      indexInString = minIndex;
	      if (indexInString === -1) {
	        return [];
	      }
	      matches.push(stringOffset + indexInString);
	      stringOffset += indexInString + 1;
	      string = string.substring(indexInString + 1, stringLength);
	    }
	    return matches;
	  };
	
	}).call(this);


/***/ },
/* 1907 */
1136,
/* 1908 */,
/* 1909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _redux = __webpack_require__(476);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Coin = __webpack_require__(1671);
	
	var _Coin2 = _interopRequireDefault(_Coin);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _PotentialChatMember = __webpack_require__(945);
	
	var _PotentialChatMember2 = _interopRequireDefault(_PotentialChatMember);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	var _roleBasedMessagingSearch = __webpack_require__(1901);
	
	__webpack_require__(1910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var RoleBasedMessagingIndividualResultItem = function (_React$Component) {
	  _inherits(RoleBasedMessagingIndividualResultItem, _React$Component);
	
	  function RoleBasedMessagingIndividualResultItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RoleBasedMessagingIndividualResultItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RoleBasedMessagingIndividualResultItem.__proto__ || Object.getPrototypeOf(RoleBasedMessagingIndividualResultItem)).call.apply(_ref, [this].concat(args))), _this), _this.renderIndividual = function (recipient) {
	      var member = recipient.member;
	      var _this$props = _this.props,
	          selectedRecipients = _this$props.selectedRecipients,
	          query = _this$props.query;
	
	      var selected = !!selectedRecipients.length;
	      var parser = _TextEntities2.default.createTextMatchingParser(query);
	
	      var handleSelect = function handleSelect(e) {
	        e.stopPropagation();
	        if (!selected) {
	          _this.handleSelectIndividual(recipient);
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { key: member.id, className: 'RoleBasedMessagingIndividualResultItem-individual' },
	        _react2.default.createElement(
	          'div',
	          { className: 'RoleBasedMessagingIndividualResultItem-info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'RoleBasedMessagingIndividualResultItem-circle' },
	            selected ? _this.renderCheck() : _react2.default.createElement(_Avatar2.default, {
	              colorHex: member.getUser().getColor(),
	              text: member.getUser().getInitials(),
	              size: 'medium'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              onClick: selected ? function (e) {
	                return _this.handleDeselectIndividual(e);
	              } : handleSelect,
	              className: 'RoleBasedMessagingIndividualResultItem-name' },
	            _react2.default.createElement(
	              _Text2.default,
	              {
	                truncate: true,
	                color: 'pitch',
	                size: 'small' },
	              member.getName()
	            ),
	            _react2.default.createElement(
	              _Text2.default,
	              { color: 'koala', size: 'xsmall', truncate: true },
	              _react2.default.createElement(_TextWithEntities2.default, {
	                text: member.getConnectionDescription(),
	                entities: parser(member.getConnectionDescription())
	              })
	            )
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RoleBasedMessagingIndividualResultItem, [{
	    key: 'handleSelectIndividual',
	    value: function handleSelectIndividual(recipient) {
	      this.props.onSelect([recipient]);
	    }
	
	    // typecheck: ignore statement
	
	  }, {
	    key: 'handleDeselectIndividual',
	    value: function handleDeselectIndividual(e) {
	      e.stopPropagation();
	      var recipient = this.props.recipient;
	      this.props.onDeselectIndividual(recipient.member);
	    }
	  }, {
	    key: 'renderCheck',
	    value: function renderCheck() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _Coin2.default,
	        {
	          onClick: function onClick(e) {
	            return _this2.handleDeselectIndividual(e);
	          },
	          color: 'brand',
	          size: 'xxxlarge' },
	        _react2.default.createElement(_Glyph2.default, { name: 'check', color: 'white', size: 'large', solo: true })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          recipient = _props.recipient,
	          highlighted = _props.highlighted,
	          selectedRecipients = _props.selectedRecipients;
	
	      var selected = !!selectedRecipients.length;
	
	      var handleSelect = function handleSelect(e) {
	        e.stopPropagation();
	        if (!selected) {
	          _this3.handleSelectIndividual(recipient);
	        }
	      };
	
	      return _react2.default.createElement(
	        'li',
	        {
	          onMouseEnter: this.props.onMouseEnter,
	          onMouseLeave: this.props.onMouseLeave,
	          onClick: handleSelect,
	          className: (0, _classnames2.default)('RoleBasedMessagingIndividualResultItem', {
	            'RoleBasedMessagingIndividualResultItem-highlighted': highlighted,
	            'RoleBasedMessagingIndividualResultItem-selected': selected
	          }),
	          key: recipient.id },
	        _react2.default.createElement(
	          'div',
	          { className: 'RoleBasedMessagingIndividualResultItem-content' },
	          this.renderIndividual(recipient)
	        )
	      );
	    }
	  }]);
	
	  return RoleBasedMessagingIndividualResultItem;
	}(_react2.default.Component);
	
	RoleBasedMessagingIndividualResultItem.displayName = 'RoleBasedMessagingIndividualResultItem';
	
	
	var mapStateToDispatch = function mapStateToDispatch(_state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    onDeselectIndividual: _roleBasedMessagingSearch.deselectIndividual,
	    onChangeResultSelection: _roleBasedMessagingSearch.changeResultSelection
	  }, dispatch);
	};
	
	// $FlowIssue
	exports.default = (0, _reactRedux.connect)(mapStateToDispatch, mapDispatchToProps)(RoleBasedMessagingIndividualResultItem);

/***/ },
/* 1910 */
1136,
/* 1911 */,
/* 1912 */
1136,
/* 1913 */,
/* 1914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Tokenizer = __webpack_require__(1885);
	
	var _Tokenizer2 = _interopRequireDefault(_Tokenizer);
	
	var _Typeahead = __webpack_require__(1889);
	
	var _Typeahead2 = _interopRequireDefault(_Typeahead);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var TokenizerTypeahead = function (_React$Component) {
	  _inherits(TokenizerTypeahead, _React$Component);
	
	  function TokenizerTypeahead() {
	    _classCallCheck(this, TokenizerTypeahead);
	
	    return _possibleConstructorReturn(this, (TokenizerTypeahead.__proto__ || Object.getPrototypeOf(TokenizerTypeahead)).apply(this, arguments));
	  }
	
	  _createClass(TokenizerTypeahead, [{
	    key: 'handleSelect',
	    value: function handleSelect(datum) {
	      var tokenizer = this.refs.tokenizer;
	
	      tokenizer.clearInputValue();
	      tokenizer.focusInput();
	      this.props.onSelect(datum);
	    }
	  }, {
	    key: 'handleSelectAll',
	    value: function handleSelectAll() {
	      var tokenizer = this.refs.tokenizer;
	
	      tokenizer.clearInputValue();
	      tokenizer.focusInput();
	      this.props.onSelectAll();
	    }
	
	    // typecheck: ignore statement
	
	  }, {
	    key: 'handleInputKeyDown',
	    value: function handleInputKeyDown(event) {
	      if (this.props.onInputKeyDown) {
	        this.props.onInputKeyDown(event);
	        if (event.isPropagationStopped()) {
	          return;
	        }
	      }
	
	      if (this.refs.typeahead) {
	        this.refs.typeahead.handleKeyDown(event);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var inputClassName = this.props.tokenizerClassName || 'TokenizerTypeahead';
	      inputClassName = inputClassName + '-input';
	      var tokenizer = _react2.default.createElement(_Tokenizer2.default, {
	        ref: 'tokenizer',
	        className: this.props.tokenizerClassName,
	        inputClassName: inputClassName,
	        value: this.props.selection,
	        prompt: this.props.prompt,
	        placeholder: this.props.placeholder,
	        tokenRenderer: this.props.tokenRenderer,
	        autoFocus: this.props.autoFocus,
	        onDeselect: this.props.onDeselect
	        // $FlowIssue
	        , onInputChange: this.props.onInputChange,
	        onInputKeyDown: function onInputKeyDown() {
	          return _this2.handleInputKeyDown.apply(_this2, arguments);
	        },
	        onFocus: this.props.onInputFocus
	      });
	
	      return _react2.default.createElement(
	        _Typeahead2.default,
	        {
	          ref: 'typeahead',
	          className: this.props.className,
	          inline: this.props.inline,
	          query: this.props.query,
	          results: this.props.results,
	          listRenderer: this.props.listRenderer,
	          itemRenderer: this.props.itemRenderer,
	          noResultsRenderer: this.props.noResultsRenderer,
	          selectAllItemRenderer: this.props.selectAllItemRenderer,
	          hideResults: this.props.hideResults,
	          onSelect: function onSelect() {
	            return _this2.handleSelect.apply(_this2, arguments);
	          },
	          onSelectAll: function onSelectAll() {
	            return _this2.handleSelectAll();
	          },
	          onEnter: this.props.onEnter,
	          onHighlightIndexChange: this.props.onHighlightIndexChange },
	        this.props.controlRowRenderer(tokenizer, this.props.actionButton)
	      );
	    }
	  }]);
	
	  return TokenizerTypeahead;
	}(_react2.default.Component);
	
	TokenizerTypeahead.defaultProps = {
	  controlRowRenderer: function controlRowRenderer(tokenizer, actionButton) {
	    return actionButton ? _react2.default.createElement(
	      _FlexibleBlock2.default,
	      { flex: 'left' },
	      tokenizer,
	      actionButton
	    ) : tokenizer;
	  },
	  onInputFocus: function onInputFocus() {},
	  tokenizerClassName: 'TokenizerTypeahead'
	};
	TokenizerTypeahead.displayName = 'TokenizerTypeahead';
	exports.default = TokenizerTypeahead;

/***/ },
/* 1915 */
1136,
/* 1916 */,
/* 1917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTargetsFromGroupCodes = getTargetsFromGroupCodes;
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _roleHelpers = __webpack_require__(1230);
	
	var _Message = __webpack_require__(930);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTargetsFromGroupCodes(groupCodes) {
	  var targets = [];
	  groupCodes.forEach(function (gc) {
	    var group = _GroupStore2.default.getGroupForCode(gc);
	    if (group) {
	      var roles = group.getPostableRoles();
	      if (roles.length) {
	        var target = roles.includes(_roleHelpers.EVERYONE) ? { type: _Message.TARGET_TYPES.GROUP_TARGET, role: _roleHelpers.EVERYONE, group_id: group.id } : { type: _Message.TARGET_TYPES.GROUP_TARGET, role: roles[0], group_id: group.id };
	        targets.push(target);
	      }
	    }
	  });
	  return targets;
	}

/***/ },
/* 1918 */
1136,
/* 1919 */,
/* 1920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _PageControls = __webpack_require__(1861);
	
	var _PageControls2 = _interopRequireDefault(_PageControls);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1921);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityAnnouncementTitleForm = function (_React$Component) {
	  _inherits(ActivityAnnouncementTitleForm, _React$Component);
	
	  function ActivityAnnouncementTitleForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityAnnouncementTitleForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityAnnouncementTitleForm.__proto__ || Object.getPrototypeOf(ActivityAnnouncementTitleForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      title: _this.props.title || '',
	      isTitleValid: false
	    }, _this.onTitleValid = function () {
	      if (!_this.state.isTitleValid) {
	        _this.setState({ isTitleValid: true });
	      }
	    }, _this.onTitleInvalid = function () {
	      if (_this.state.isTitleValid) {
	        _this.setState({ isTitleValid: false });
	      }
	    }, _this.onBack = function () {
	      _this.props.onBack({
	        title: _this.state.title
	      });
	    }, _this.onNext = function () {
	      _this.props.onNext({
	        title: _this.state.title
	      });
	    }, _this.onTitleChange = function (event) {
	      _this.setState({ title: event.target.value });
	    }, _this.isValid = function () {
	      return _this.state.isTitleValid;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityAnnouncementTitleForm, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Form2.default,
	          { onValid: this.onTitleValid, onInvalid: this.onTitleInvalid },
	          _react2.default.createElement(_FormInput2.default, {
	            label: 'Name of activity',
	            'data-test': 'activity-announcement-title-and-participant-form-title',
	            name: 'title',
	            autoFocus: true,
	            autoComplete: 'off',
	            required: 'isRequired',
	            onChange: this.onTitleChange,
	            placeholder: this.props.placeholder,
	            validations: { maxLength: 50 },
	            showErrorAfterBlur: true,
	            validationErrors: {
	              isRequired: 'An activity name is required.',
	              maxLength: 'The activity name can’t be longer than 50 characters.'
	            },
	            value: this.props.title
	          })
	        ),
	        _react2.default.createElement(_PageControls2.default, {
	          className: 'ActivityAnnouncementTitleForm-controls',
	          disabledNext: !this.isValid(),
	          onBack: this.onBack,
	          onNext: this.onNext
	        })
	      );
	    }
	  }]);
	
	  return ActivityAnnouncementTitleForm;
	}(_react2.default.Component);
	
	ActivityAnnouncementTitleForm.displayName = 'ActivityAnnouncementTitleForm';
	exports.default = ActivityAnnouncementTitleForm;

/***/ },
/* 1921 */
1136,
/* 1922 */,
/* 1923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TYPE_TO_IMG = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _TYPE_TO_IMG;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Activity = __webpack_require__(907);
	
	__webpack_require__(1924);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	// typecheck: ignore file
	// eslint-disable-line
	
	// eslint-disable-line
	
	
	var TYPE_TO_IMG = exports.TYPE_TO_IMG = (_TYPE_TO_IMG = {}, _defineProperty(_TYPE_TO_IMG, _Activity.TYPES.FIELD_TRIP, __webpack_require__(1926)), _defineProperty(_TYPE_TO_IMG, _Activity.TYPES.FUNDRAISER, __webpack_require__(1927)), _defineProperty(_TYPE_TO_IMG, _Activity.TYPES.EVENT, __webpack_require__(1928)), _defineProperty(_TYPE_TO_IMG, _Activity.TYPES.ORDER, __webpack_require__(1929)), _TYPE_TO_IMG);
	
	var SELECTED_CX = 'ActivityAnnouncementTypePicker-selected';
	
	var ActivityAnnouncementTypePicker = function (_React$Component) {
	  _inherits(ActivityAnnouncementTypePicker, _React$Component);
	
	  function ActivityAnnouncementTypePicker() {
	    _classCallCheck(this, ActivityAnnouncementTypePicker);
	
	    return _possibleConstructorReturn(this, (ActivityAnnouncementTypePicker.__proto__ || Object.getPrototypeOf(ActivityAnnouncementTypePicker)).apply(this, arguments));
	  }
	
	  _createClass(ActivityAnnouncementTypePicker, [{
	    key: 'renderType',
	    value: function renderType(type, text) {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          'data-test': 'activity-announcement-type-picker-' + type,
	          className: (0, _classnames2.default)(_defineProperty({}, SELECTED_CX, this.props.type === type)),
	          onClick: function onClick() {
	            return _this2.props.onSelect({ type: type });
	          } },
	        _react2.default.createElement(_Image2.default, {
	          className: 'ActivityAnnouncementTypePicker-img',
	          src: TYPE_TO_IMG[type]
	        }),
	        _react2.default.createElement(
	          'div',
	          null,
	          text
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityAnnouncementTypePicker' },
	        this.renderType(_Activity.TYPES.FIELD_TRIP, 'Field trip'),
	        this.renderType(_Activity.TYPES.FUNDRAISER, 'Fundraiser'),
	        this.renderType(_Activity.TYPES.EVENT, 'Event'),
	        this.renderType(_Activity.TYPES.ORDER, 'Item sales')
	      );
	    }
	  }]);
	
	  return ActivityAnnouncementTypePicker;
	}(_react2.default.Component);
	
	ActivityAnnouncementTypePicker.displayName = 'ActivityAnnouncementTypePicker';
	exports.default = ActivityAnnouncementTypePicker;

/***/ },
/* 1924 */
1136,
/* 1925 */,
/* 1926 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 1927 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 1928 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 1929 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8a71e5eb17831eaa267ed75bbffd8de5.svg";

/***/ },
/* 1930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WindowDialog = __webpack_require__(1931);
	
	var _WindowDialog2 = _interopRequireDefault(_WindowDialog);
	
	var _PaymentView = __webpack_require__(1934);
	
	var _PaymentView2 = _interopRequireDefault(_PaymentView);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(2019);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityRSVPPreview = function (_React$Component) {
	  _inherits(ActivityRSVPPreview, _React$Component);
	
	  function ActivityRSVPPreview() {
	    _classCallCheck(this, ActivityRSVPPreview);
	
	    return _possibleConstructorReturn(this, (ActivityRSVPPreview.__proto__ || Object.getPrototypeOf(ActivityRSVPPreview)).apply(this, arguments));
	  }
	
	  _createClass(ActivityRSVPPreview, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        isPreview: true
	      };
	    }
	  }, {
	    key: 'renderBanner',
	    value: function renderBanner() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityRSVPPreview-banner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityRSVPPreview-banner-contentContainer' },
	          _react2.default.createElement(_Image2.default, {
	            className: 'ActivityRSVPPreview-banner-image',
	            src: __webpack_require__(2021)
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'ActivityRSVPPreview-banner-content' },
	            _react2.default.createElement(
	              _Text2.default,
	              { size: 'small', element: 'span' },
	              'This is a web preview of your invitation!'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _Text2.default,
	              { size: 'xsmall', element: 'span', color: 'thunder' },
	              'Sms participants will receive a link to this invitation, and you can reply to RSVP.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'ActivityRSVPPreview-banner-button',
	            level: 'secondary',
	            size: 'small',
	            onClick: this.props.onRequestHide,
	            eventElementName: 'ActivityRSVPPreview-banner-button' },
	          'Close'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _WindowDialog2.default,
	        { className: 'ActivityRSVPPreview', onRequestHide: this.props.onRequestHide, hideCloseButton: true },
	        this.renderBanner(),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityRSVPPreview-background' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ActivityRSVPPreview-content' },
	            _react2.default.createElement('div', { className: 'ActivityRSVPPreview-hero' }),
	            _react2.default.createElement(_PaymentView2.default, this.props)
	          )
	        )
	      );
	    }
	  }]);
	
	  return ActivityRSVPPreview;
	}(_react2.default.Component);
	
	ActivityRSVPPreview.childContextTypes = {
	  isPreview: _react2.default.PropTypes.bool
	};
	ActivityRSVPPreview.displayName = 'ActivityRSVPPreview';
	exports.default = ActivityRSVPPreview;

/***/ },
/* 1931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Modal = __webpack_require__(1207);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(1932);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WindowDialog = function (_React$Component) {
	  _inherits(WindowDialog, _React$Component);
	
	  function WindowDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, WindowDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WindowDialog.__proto__ || Object.getPrototypeOf(WindowDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      closing: false
	    }, _this.onClose = function () {
	      _this.setState({ closing: true }, function () {
	        return setTimeout(_this.props.onRequestHide, 300);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(WindowDialog, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // push a fake history state to enable back button
	      // to only close the modal (and not change navigation).
	      window.history.pushState(null, null, null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          rest = _objectWithoutProperties(_props, ['className', 'children']);
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        _extends({}, rest, {
	          onRequestHide: this.onClose,
	          className: (0, _classnames2.default)('WindowDialog', className, {
	            'WindowDialog-closing': this.state.closing
	          }) }),
	        !this.props.hideCloseButton && _react2.default.createElement(
	          _Link2.default,
	          {
	            className: 'WindowDialog-closeButton',
	            onClick: this.onClose,
	            eventElementName: 'WindowDialog-closeButton' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Glyph2.default, { color: 'eclipse', name: 'close-btn', size: 'xlarge', solo: true })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'WindowDialog-closeButton-subtitle' },
	            _react2.default.createElement(
	              _Text2.default,
	              {
	                className: 'WindowDialog-closeButton-text',
	                color: 'eclipse',
	                size: 'xxxxxsmall',
	                uppercase: true },
	              'Close'
	            )
	          )
	        ),
	        children
	      );
	    }
	  }]);
	
	  return WindowDialog;
	}(_react2.default.Component);
	
	WindowDialog.displayName = 'WindowDialog';
	
	
	WindowDialog.Content = function (_ref2) {
	  var className = _ref2.className,
	      children = _ref2.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('WindowDialog-content', className) },
	    children
	  );
	};
	
	/* eslint-disable react/prop-types */
	WindowDialog.Header = function (_ref3) {
	  var className = _ref3.className,
	      children = _ref3.children,
	      border = _ref3.border;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)('WindowDialog-header', className, { 'WindowDialog-header-border': border }) },
	    children
	  );
	};
	
	WindowDialog.Header.propTypes = {
	  border: _react2.default.PropTypes.bool
	};
	
	WindowDialog.Header.defaultProps = {
	  border: true
	};
	
	WindowDialog.SubHeader = function (_ref4) {
	  var className = _ref4.className,
	      children = _ref4.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('WindowDialog-subheader', className) },
	    children
	  );
	};
	
	exports.default = WindowDialog;

/***/ },
/* 1932 */
1136,
/* 1933 */,
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _PaymentViewSideInformation = __webpack_require__(1935);
	
	var _PaymentViewSideInformation2 = _interopRequireDefault(_PaymentViewSideInformation);
	
	var _RSVPFlow = __webpack_require__(1940);
	
	var _RSVPFlow2 = _interopRequireDefault(_RSVPFlow);
	
	var _withWidth = __webpack_require__(1951);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	__webpack_require__(2017);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line
	
	var PaymentView = function (_React$Component) {
	  _inherits(PaymentView, _React$Component);
	
	  function PaymentView() {
	    _classCallCheck(this, PaymentView);
	
	    return _possibleConstructorReturn(this, (PaymentView.__proto__ || Object.getPrototypeOf(PaymentView)).apply(this, arguments));
	  }
	
	  _createClass(PaymentView, [{
	    key: 'render',
	    value: function render() {
	      var activity = this.props.activity;
	
	
	      if (!activity) {
	        return null;
	      }
	
	      var isVertical = this.props.width < 900;
	      var isVerticalSlim = this.props.width < 500;
	
	      var vertical = { 'PaymentView-vertical': isVertical };
	      var horizontal = { 'PaymentView-horizontal': !isVertical };
	      var verticalSlim = { 'PaymentView-vertical-slim': isVerticalSlim };
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('PaymentView', horizontal, vertical, verticalSlim) },
	        _react2.default.createElement(
	          'div',
	          { className: 'PaymentView-panel PaymentView-panel-rsvp' },
	          _react2.default.createElement(_RSVPFlow2.default, {
	            activity: this.props.activity,
	            isUnderage: this.props.isUnderage,
	            initialRSVP: this.props.initialRSVP,
	            headerAlign: isVerticalSlim ? 'left' : 'center',
	            initialActivityRecipient: this.props.initialActivityRecipient
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'PaymentView-panel PaymentView-panel-info' },
	          _react2.default.createElement(_PaymentViewSideInformation2.default, { activity: this.props.activity })
	        )
	      );
	    }
	  }]);
	
	  return PaymentView;
	}(_react2.default.Component);
	
	PaymentView.displayName = 'PaymentView';
	exports.default = (0, _withWidth2.default)(PaymentView);

/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _createGoogleCalLink = __webpack_require__(1936);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Money = __webpack_require__(1651);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TimeRange = __webpack_require__(1937);
	
	var _TimeRange2 = _interopRequireDefault(_TimeRange);
	
	__webpack_require__(1938);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentViewSideInformation = function (_React$Component) {
	  _inherits(PaymentViewSideInformation, _React$Component);
	
	  function PaymentViewSideInformation() {
	    _classCallCheck(this, PaymentViewSideInformation);
	
	    return _possibleConstructorReturn(this, (PaymentViewSideInformation.__proto__ || Object.getPrototypeOf(PaymentViewSideInformation)).apply(this, arguments));
	  }
	
	  _createClass(PaymentViewSideInformation, [{
	    key: 'renderGoogleCalUrl',
	    value: function renderGoogleCalUrl() {
	      var activity = this.props.activity;
	
	      var date = activity.getStartAt();
	      var title = activity.getTitle();
	      var welcomeMsgBody = activity.getWelcomeMsgBody();
	      var location = activity.getLocation();
	      var googleCalendarUrl = date ? (0, _createGoogleCalLink.buildGoogleCalendarUrl)(title, date, welcomeMsgBody, location) : null;
	
	      return googleCalendarUrl ? _react2.default.createElement(
	        'div',
	        { className: 'PaymentViewSideInformation-item-content' },
	        _react2.default.createElement(
	          _Link2.default,
	          { target: '_blank', href: googleCalendarUrl },
	          _react2.default.createElement(
	            _Text2.default,
	            { size: 'xsmall', weight: 'semibold' },
	            'Add to Google Calendar'
	          )
	        )
	      ) : _react2.default.createElement('span', null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var startAt = this.props.activity.getStartAt();
	      var endAt = this.props.activity.getEndAt();
	      var amountPerPerson = this.props.activity.getAmountPerPerson();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'PaymentViewSideInformation' },
	        _react2.default.createElement(
	          'div',
	          { className: 'PaymentViewSideInformation-title' },
	          'Activity details'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Text2.default,
	            { color: 'thunder' },
	            this.props.activity.getWelcomeMsgBody()
	          )
	        ),
	        this.props.activity.getLocation() && _react2.default.createElement(
	          'div',
	          { className: 'PaymentViewSideInformation-item' },
	          _react2.default.createElement(
	            'div',
	            { className: 'PaymentViewSideInformation-item-header' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Where:'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'PaymentViewSideInformation-item-content' },
	            this.props.activity.getLocation()
	          )
	        ),
	        this.props.activity.getStartAt() && _react2.default.createElement(
	          'div',
	          { className: 'PaymentViewSideInformation-item' },
	          _react2.default.createElement(
	            'div',
	            { className: 'PaymentViewSideInformation-item-header' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'When:'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'PaymentViewSideInformation-item-content' },
	            startAt && _react2.default.createElement(_TimeRange2.default, {
	              start: startAt,
	              end: endAt,
	              month: 'long',
	              year: 'numeric',
	              day: '2-digit',
	              hour: '2-digit',
	              minute: '2-digit'
	            })
	          ),
	          this.renderGoogleCalUrl()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'PaymentViewSideInformation-item' },
	          _react2.default.createElement(
	            'div',
	            { className: 'PaymentViewSideInformation-item-header' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Cost:'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'PaymentViewSideInformation-item-content' },
	            amountPerPerson && amountPerPerson > 0 ? _react2.default.createElement(_Money2.default, { cents: this.props.activity.getAmountPerPerson() }) : _react2.default.createElement(
	              'span',
	              null,
	              'Free'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PaymentViewSideInformation;
	}(_react2.default.Component);
	
	PaymentViewSideInformation.displayName = 'PaymentViewSideInformation';
	exports.default = PaymentViewSideInformation;

/***/ },
/* 1936 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildGoogleCalendarUrl = buildGoogleCalendarUrl;
	exports.createGoogleCalLink = createGoogleCalLink;
	var BASE_URL = 'https://www.google.com/calendar/render?action=TEMPLATE&';
	
	var HOUR_MS = 60 * 60 * 1000;
	
	function formatTime(date) {
	  return date.toISOString().replace(/-|:|\.\d\d\d/g, '');
	}
	
	function buildGoogleCalendarUrl(title, start, description, location) {
	  var end = new Date(start.getTime() + 1 * HOUR_MS);
	  try {
	    return createGoogleCalLink(title, start, end, description, location);
	  } catch (e) {
	    return null;
	  }
	}
	
	function createGoogleCalLink(title, startTime, endTime, details, location) {
	  if (new Date(startTime) > new Date(endTime)) {
	    throw new Error('Start time is after end time');
	  }
	
	  if (!startTime) {
	    throw new Error('Start time not supplied');
	  }
	
	  if (!endTime) {
	    throw new Error('End time not supplied');
	  }
	
	  var formattedStartTime = formatTime(startTime);
	  var formattedEndTime = formatTime(endTime);
	  var dates = 'dates=' + formattedStartTime + '/' + formattedEndTime + '&';
	
	  title = title ? 'text=' + encodeURI(title) + '&' : '';
	  details = details ? 'details=' + encodeURI(details) + '&' : '';
	  location = location ? 'location=' + encodeURI(location) + '&' : '';
	
	  return '' + BASE_URL + title + dates + details + location + 'sf=true&output=xml';
	}

/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TimeRange;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Time = __webpack_require__(1563);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function TimeRange(props) {
	  var start = props.start,
	      end = props.end,
	      timeProps = _objectWithoutProperties(props, ['start', 'end']);
	
	  // Copy props for start and end
	
	
	  var startProps = Object.assign({}, timeProps);
	  var endProps = Object.assign({}, timeProps);
	
	  startProps.date = start;
	
	  // If end is null, just proxy to Time
	  if (!end) {
	    return _react2.default.createElement(_Time2.default, startProps);
	  }
	
	  endProps.date = end;
	
	  // Check if start and end have same calendar day
	  if (start.getDate() === end.getDate() && start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
	    // Date is the same, so don't show date in end Time component
	    delete endProps.year;
	    delete endProps.month;
	    delete endProps.day;
	  }
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'TimeRange' },
	    _react2.default.createElement(_Time2.default, startProps),
	    ' - ',
	    _react2.default.createElement(_Time2.default, endProps)
	  );
	}

/***/ },
/* 1938 */
1136,
/* 1939 */,
/* 1940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _EventParticipationView = __webpack_require__(1941);
	
	var _EventParticipationView2 = _interopRequireDefault(_EventParticipationView);
	
	var _PaymentCreator = __webpack_require__(1959);
	
	var _PaymentCreator2 = _interopRequireDefault(_PaymentCreator);
	
	var _PaymentViewConfirmation = __webpack_require__(2001);
	
	var _PaymentViewConfirmation2 = _interopRequireDefault(_PaymentViewConfirmation);
	
	var _ActivityBlockedViewContainer = __webpack_require__(2011);
	
	var _ActivityBlockedViewContainer2 = _interopRequireDefault(_ActivityBlockedViewContainer);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _Transaction = __webpack_require__(982);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	__webpack_require__(2015);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line
	
	var RSVPFlow = function (_React$Component) {
	  _inherits(RSVPFlow, _React$Component);
	
	  function RSVPFlow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RSVPFlow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RSVPFlow.__proto__ || Object.getPrototypeOf(RSVPFlow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      contribute: null,
	      recipient: null,
	      transaction: null
	    }, _this.onRecipientCreated = function (recipient, contribute) {
	      _this.setState({ recipient: recipient, contribute: contribute });
	      if (_this.props.onActivityRecipientUpdated) {
	        _this.props.onActivityRecipientUpdated(recipient);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RSVPFlow, [{
	    key: 'renderParticipationForm',
	    value: function renderParticipationForm() {
	      return _react2.default.createElement(_EventParticipationView2.default, {
	        initialRSVP: this.props.initialRSVP,
	        activity: this.props.activity,
	        editableEventRecipient: this.props.initialActivityRecipient || undefined,
	        onRecipientCreated: this.onRecipientCreated
	      });
	    }
	  }, {
	    key: 'renderClosedEvent',
	    value: function renderClosedEvent() {
	      var teacherName = this.props.activity.getRequester().getDisplayName();
	      var activityTitle = this.props.activity.getTitle();
	
	      var title = activityTitle + ' is closed';
	      var subtext = 'To participate in this activity, please contact ' + teacherName + '.';
	
	      return _react2.default.createElement(_ActivityBlockedViewContainer2.default, { title: title, subtext: subtext });
	    }
	  }, {
	    key: 'renderBlockedEvent',
	    value: function renderBlockedEvent() {
	      var teacherName = this.props.activity.getRequester().getDisplayName();
	      var activityTitle = this.props.activity.getTitle();
	
	      var title = 'Please contact ' + teacherName;
	      var subtext = activityTitle + ' is currently closed to participants.';
	
	      return _react2.default.createElement(_ActivityBlockedViewContainer2.default, { title: title, subtext: subtext });
	    }
	  }, {
	    key: 'renderConfirmation',
	    value: function renderConfirmation() {
	      return _react2.default.createElement(_PaymentViewConfirmation2.default, {
	        transaction: this.state.transaction,
	        activity: this.props.activity,
	        recipient: this.state.recipient
	      });
	    }
	  }, {
	    key: 'renderTransactionForm',
	    value: function renderTransactionForm() {
	      var _this2 = this;
	
	      return _react2.default.createElement(_PaymentCreator2.default, {
	        request: this.props.activity,
	        recipient: this.state.recipient,
	        onComplete: function onComplete(transaction) {
	          return _this2.setState({ transaction: transaction });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          transaction = _state.transaction,
	          recipient = _state.recipient;
	      var activity = this.props.activity;
	
	
	      if (!activity) {
	        return null;
	      }
	
	      var body = void 0;
	      var title = void 0;
	      var subtitle = void 0;
	
	      if (activity.isBlocked()) {
	        body = this.renderBlockedEvent();
	      } else if (activity.isClosed()) {
	        body = this.renderClosedEvent();
	      } else if (!recipient) {
	        title = this.props.activity.getTitle();
	        subtitle = 'Organized by ' + this.props.activity.getRequester().getDisplayName();
	        body = this.renderParticipationForm();
	      } else if (activity.isCollectingMoneyOnline() && this.state.contribute && !transaction) {
	        title = 'How would you like to pay for this activity?';
	        subtitle = this.props.isUnderage ? 'Please ask your parents to complete the below and pay for your activity' : '';
	        body = this.renderTransactionForm();
	      } else {
	        body = this.renderConfirmation();
	      }
	
	      var headerStyles = {
	        textAlign: this.props.headerAlign || 'center'
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'RSVPFlow' },
	        _react2.default.createElement(
	          'div',
	          { className: 'RSVPFlow-header', style: headerStyles },
	          title && _react2.default.createElement(
	            'div',
	            { className: 'RSVPFlow-header-title' },
	            title
	          ),
	          subtitle && _react2.default.createElement(
	            'div',
	            { className: 'RSVPFlow-header-subtitle' },
	            subtitle
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          body
	        )
	      );
	    }
	  }]);
	
	  return RSVPFlow;
	}(_react2.default.Component);
	
	RSVPFlow.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	RSVPFlow.displayName = 'RSVPFlow';
	exports.default = RSVPFlow;

/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _RemindAPI = __webpack_require__(612);
	
	var _modal = __webpack_require__(1188);
	
	var _ActivityAgeConfirmationModal = __webpack_require__(1942);
	
	var _ActivityAgeConfirmationModal2 = _interopRequireDefault(_ActivityAgeConfirmationModal);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _EventParticipationForm = __webpack_require__(1949);
	
	var _EventParticipationForm2 = _interopRequireDefault(_EventParticipationForm);
	
	var _EventTrackingConstants = __webpack_require__(1745);
	
	var _EventTrackingConstants2 = _interopRequireDefault(_EventTrackingConstants);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _EventParticipationView = __webpack_require__(1957);
	
	var _EventParticipationView2 = _interopRequireDefault(_EventParticipationView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function leaveChatConfirmationDialog(onConfirm, onCancel) {
	  return _react2.default.createElement(_ConfirmDialog2.default, {
	    eventScreenName: 'EventParticipationView',
	    title: 'Would you like to leave the conversation related to this Activity?',
	    actionButtonText: 'Yes',
	    cancelButtonText: 'No',
	    onConfirm: onConfirm,
	    onCancel: onCancel
	  });
	}
	
	var EventParticipationView = _react2.default.createClass({
	  displayName: 'EventParticipationView',
	
	
	  childContextTypes: {
	    eventScreenName: _react.PropTypes.string
	  },
	
	  mixins: [(0, _linkStateWithStores2.default)([_CurrentUser2.default])],
	
	  getInitialState: function getInitialState() {
	    return _extends({
	      processingSubmit: false
	    }, this.getStateFromStores());
	  },
	  getChildContext: function getChildContext() {
	    return {
	      eventScreenName: _EventTrackingConstants2.default.RSVP
	    };
	  },
	  onDone: function onDone() {
	    if (this.isMounted()) {
	      this.setState({ processingSubmit: false });
	    }
	  },
	  onRSVPCreated: function onRSVPCreated(recipient, contribute, attendance) {
	    var _this = this;
	
	    var chatUuid = this.props.activity.getChatUuid();
	    var isSender = this.props.activity.isSender();
	
	    var onDone = function onDone() {
	      _this.props.onRecipientCreated(recipient, contribute);
	      _this.onDone();
	    };
	
	    if (!isSender && this.state.user && chatUuid && attendance === _Activity.ATTENDANCE.NO) {
	      // if the activity has a group chat and the current logged in user RSVP no,
	      // then we check if the user is part of the group chat. If he is then we ask
	      // him if he wants to leave, otherwise resume normal flow.
	      _Chat2.default.fetch({ uuid: chatUuid }).then(function (chat) {
	        // if user already left, we can abort!
	        if (!chat.isPresent()) {
	          onDone();
	          return;
	        }
	
	        // otherwise ask for confirmation
	        var confirmationModal = leaveChatConfirmationDialog(function () {
	          chat.leave().then(onDone, onDone);
	        }, onDone);
	
	        (0, _modal.mountModal)(confirmationModal, _this);
	      }, onDone);
	    } else {
	      onDone();
	    }
	  },
	  onValidSubmit: function onValidSubmit(values) {
	    var _this2 = this;
	
	    var onRSVPCreated = function onRSVPCreated(recipient) {
	      return _this2.onRSVPCreated(recipient, values.contribute, values.response);
	    };
	
	    var onAgeConfirmed = function onAgeConfirmed(confirmedIsChild, confirmedBirthdate) {
	      return _this2.submitForm(values, confirmedIsChild, confirmedBirthdate).then(onRSVPCreated);
	    };
	
	    this.setState({ processingSubmit: true });
	    this.submitForm(values).then(onRSVPCreated, function (error) {
	      if (error) {
	        switch (error.code) {
	          case _RemindAPI.ERRORS.birthdate_required:
	            (0, _modal.mountModal)(_react2.default.createElement(_ActivityAgeConfirmationModal2.default, { onAgeConfirmed: onAgeConfirmed }), _this2);
	            break;
	          default:
	            _this2.setState({ processingSubmit: false });
	            _ToastActions2.default.showAPIError(error);
	            break;
	        }
	      }
	    });
	  },
	  getStateFromStores: function getStateFromStores() {
	    return {
	      user: _CurrentUser2.default.isSignedIn() ? _CurrentUser2.default.getUser() : null
	    };
	  },
	  submitForm: function submitForm(values, isChild, birthdate) {
	    var activity = this.props.activity;
	    var note = values.note,
	        response = values.response,
	        name = values.name,
	        address = values.address;
	
	    var opts = { note: note, attendance: response };
	    var user = this.state.user;
	
	
	    if (!user) {
	      opts = _extends({}, opts, { name: name, address: address });
	    }
	
	    if (activity.hasChildren()) {
	      var child = user ? user.getIsChild() : isChild;
	
	      opts = _extends({}, opts, { is_child: child });
	
	      if (!user && isChild) {
	        opts = _extends({}, opts, { birthdate: birthdate });
	      }
	    } else {
	      opts = _extends({}, opts, { is_child: false });
	    }
	
	    return this.props.activity.createRSVP(opts);
	  },
	  render: function render() {
	    var activity = this.props.activity;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_EventParticipationView2.default.this, this.props.className) },
	      _react2.default.createElement(_EventParticipationForm2.default, {
	        initialRSVP: this.props.initialRSVP,
	        isCollectingMoney: activity.isCollectingMoneyOnline(),
	        onValidSubmit: this.onValidSubmit,
	        editableEventRecipient: this.props.editableEventRecipient,
	        processingSubmit: this.state.processingSubmit,
	        showParticipantIdentityFields: !this.state.user,
	        eventScreenName: _EventTrackingConstants2.default.RSVP
	      })
	    );
	  }
	});
	
	exports.default = EventParticipationView;

/***/ },
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CopyConstants = __webpack_require__(1733);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BirthdateSelector = __webpack_require__(1943);
	
	var _BirthdateSelector2 = _interopRequireDefault(_BirthdateSelector);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _DialogButton = __webpack_require__(1327);
	
	var _DialogButton2 = _interopRequireDefault(_DialogButton);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabPanel = __webpack_require__(1447);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	var _Tabs = __webpack_require__(1539);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	__webpack_require__(1946);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityAgeConfirmationModal = function (_Component) {
	  _inherits(ActivityAgeConfirmationModal, _Component);
	
	  function ActivityAgeConfirmationModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityAgeConfirmationModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityAgeConfirmationModal.__proto__ || Object.getPrototypeOf(ActivityAgeConfirmationModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      birthdate: null,
	      isChild: true
	    }, _this.handleClick = function () {
	      var _this$state = _this.state,
	          isChild = _this$state.isChild,
	          birthdate = _this$state.birthdate;
	
	      _this.props.onRequestHide();
	      _this.props.onAgeConfirmed(isChild, birthdate);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityAgeConfirmationModal, [{
	    key: 'renderStudentAgeConfirmation',
	    value: function renderStudentAgeConfirmation() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityAgeConfirmationModal-birthdate' },
	        _react2.default.createElement(_BirthdateSelector2.default, { onChange: function onChange(birthdate) {
	            return _this2.setState({ birthdate: birthdate });
	          } })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        {
	          eventScreenName: 'ActivityAgeConfirmationModal',
	          className: (0, _classnames2.default)('ActivityAgeConfirmationModal', className) },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(
	            _Container2.default,
	            { size: 'medium' },
	            _react2.default.createElement(_TitleHeader2.default, {
	              image: __webpack_require__(1948),
	              title: _CopyConstants.ActivityAgeConfirmation.title,
	              subtext: _CopyConstants.ActivityAgeConfirmation.subtext
	            }),
	            _react2.default.createElement(
	              _Tabs2.default,
	              {
	                type: 'button',
	                buttonSize: 'small' },
	              _react2.default.createElement(
	                _TabPanel2.default,
	                {
	                  title: _react2.default.createElement(
	                    'span',
	                    null,
	                    'I am a student'
	                  ),
	                  onClick: function onClick() {
	                    return _this3.setState({ isChild: true });
	                  } },
	                this.renderStudentAgeConfirmation()
	              ),
	              _react2.default.createElement(_TabPanel2.default, {
	                title: _react2.default.createElement(
	                  'span',
	                  null,
	                  'I am a parent'
	                ),
	                onClick: function onClick() {
	                  return _this3.setState({ isChild: false });
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _DialogButton2.default,
	              {
	                disabled: this.state.isChild && !this.state.birthdate,
	                onClick: this.handleClick },
	              'Done'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ActivityAgeConfirmationModal;
	}(_react.Component);
	
	ActivityAgeConfirmationModal.displayName = 'ActivityAgeConfirmationModal';
	exports.default = ActivityAgeConfirmationModal;

/***/ },
/* 1943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(555);
	
	var _DateConstants = __webpack_require__(1751);
	
	var _DateConstants2 = _interopRequireDefault(_DateConstants);
	
	var _Select = __webpack_require__(1366);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	__webpack_require__(1944);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BirthdateSelector = function (_React$Component) {
	  _inherits(BirthdateSelector, _React$Component);
	
	  function BirthdateSelector() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BirthdateSelector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BirthdateSelector.__proto__ || Object.getPrototypeOf(BirthdateSelector)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      year: _this.props.initialDate ? _this.props.initialDate.getFullYear() : null,
	      month: _this.props.initialDate ? _this.props.initialDate.getMonth() + 1 : null,
	      day: _this.props.initialDate ? _this.props.initialDate.getDate() : null
	    }, _this.calculateBirthdate = function () {
	      // Setting default values to 0 to satisfy flow typing
	      var year = _this.state.year || 0;
	      var month = _this.state.month || 0;
	      var day = _this.state.day || 0;
	      var isValid = year !== 0 && month !== 0 && day !== 0;
	
	      if (isValid) {
	        _this.props.onChange(new Date(year, month - 1, day));
	      }
	    }, _this.dayChanged = function (value) {
	      _this.setState({ day: parseInt(value, 10) }, _this.calculateBirthdate);
	    }, _this.monthChanged = function (value) {
	      var month = parseInt(value, 10);
	      _this.setState({ month: month }, function () {
	        // return number of days in a month
	        var days = new Date(_this.state.year || 0, month, 0).getDate();
	
	        if (_this.state.day && _this.state.day > days) {
	          _this.setState({ day: days }, _this.calculateBirthdate);
	        } else {
	          _this.calculateBirthdate();
	        }
	      });
	    }, _this.yearChanged = function (value) {
	      _this.setState({ year: parseInt(value, 10) }, _this.calculateBirthdate);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BirthdateSelector, [{
	    key: 'render',
	    value: function render() {
	      var monthOptions = (0, _lodash.range)(0, 12).map(function (n) {
	        return {
	          label: _DateConstants2.default.MONTHS[n],
	          value: n + 1
	        };
	      });
	
	      // return number of days in a month
	      var days = new Date(this.state.year || 0, this.state.month || 0, 0).getDate();
	      var dayOptions = (0, _lodash.range)(1, days + 1).map(function (n) {
	        return {
	          label: n,
	          value: n
	        };
	      });
	
	      var currentYear = new Date().getFullYear();
	      var yearOptions = (0, _lodash.range)(currentYear - 120, currentYear + 1).reverse().map(function (n) {
	        return {
	          label: n,
	          value: n
	        };
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'BirthdateSelector' },
	        _react2.default.createElement(
	          'div',
	          { className: 'BirthdateSelector-Select' },
	          _react2.default.createElement(_Select2.default, {
	            className: 'BirthdateSelector-Select-Month bday-month',
	            options: monthOptions,
	            autoComplete: 'bday-month',
	            placeholder: 'Month',
	            value: this.state.month,
	            onChange: this.monthChanged
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'BirthdateSelector-Select' },
	          _react2.default.createElement(_Select2.default, {
	            options: dayOptions,
	            key: this.state.day,
	            className: 'BirthdateSelector-Select-Day bday-day',
	            autoComplete: 'bday-day',
	            placeholder: 'Day',
	            value: this.state.day,
	            onChange: this.dayChanged
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'BirthdateSelector-Select' },
	          _react2.default.createElement(_Select2.default, {
	            options: yearOptions,
	            className: 'BirthdateSelector-Select-Year bday-year',
	            autoComplete: 'bday-year',
	            placeholder: 'Year',
	            value: this.state.year,
	            onChange: this.yearChanged
	          })
	        )
	      );
	    }
	  }]);
	
	  return BirthdateSelector;
	}(_react2.default.Component);
	
	BirthdateSelector.displayName = 'BirthdateSelector';
	exports.default = BirthdateSelector;

/***/ },
/* 1944 */
1136,
/* 1945 */,
/* 1946 */
1136,
/* 1947 */,
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e9b13cfe3ac708b810c680a30c2ab089.svg";

/***/ },
/* 1949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EventParticipationForm = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Activity = __webpack_require__(907);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	var _trackView = __webpack_require__(1950);
	
	var _trackView2 = _interopRequireDefault(_trackView);
	
	var _FocusEventTrigger = __webpack_require__(1746);
	
	var _FocusEventTrigger2 = _interopRequireDefault(_FocusEventTrigger);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormCheckBox = __webpack_require__(1705);
	
	var _FormCheckBox2 = _interopRequireDefault(_FormCheckBox);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _isEmail = __webpack_require__(1458);
	
	var _isEmail2 = _interopRequireDefault(_isEmail);
	
	var _isPhone = __webpack_require__(1459);
	
	var _isPhone2 = _interopRequireDefault(_isPhone);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _withWidth = __webpack_require__(1951);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	var _Textarea = __webpack_require__(1598);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _EventRSVPForm = __webpack_require__(1952);
	
	var _EventRSVPForm2 = _interopRequireDefault(_EventRSVPForm);
	
	var _EventParticipationForm = __webpack_require__(1955);
	
	var _EventParticipationForm2 = _interopRequireDefault(_EventParticipationForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_INITIAL_RESPONSE = _Activity.ATTENDANCE.YES;
	var UI_CONTEXT = null;
	
	var EventParticipationForm = exports.EventParticipationForm = _react2.default.createClass({
	  displayName: 'EventParticipationForm',
	
	
	  contextTypes: {
	    isPreview: _react.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      showParticipantIdentityFields: true,
	      processingSubmit: false,
	      isCollectingMoney: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    var response = DEFAULT_INITIAL_RESPONSE;
	
	    if (this.props.initialRSVP) {
	      response = this.props.initialRSVP;
	    } else if (this.props.editableEventRecipient) {
	      response = this.props.editableEventRecipient.getAttendance();
	    }
	
	    return {
	      response: response,
	      contribute: false,
	      disabled: true
	    };
	  },
	  onResponseChange: function onResponseChange(response) {
	    this.setState({ response: response });
	  },
	  onValidSubmit: function onValidSubmit(values, reset, errors) {
	    var _props = this.props,
	        eventScreenName = _props.eventScreenName,
	        onValidSubmit = _props.onValidSubmit,
	        showParticipantIdentityFields = _props.showParticipantIdentityFields;
	
	
	    if (showParticipantIdentityFields) {
	      if (!(0, _isEmail2.default)(values.address) && !(0, _isPhone2.default)(values.address)) {
	        errors({ address: 'Email or phone incorrect' });
	        return;
	      }
	    }
	
	    _EventTracking2.default.tap(eventScreenName, 'respond', UI_CONTEXT);
	
	    var hasPaid = this.props.editableEventRecipient && this.props.editableEventRecipient.hasPaid();
	
	    // If RSVP yes and user has not paid already
	    // then user has no choice but to pay. Otherwise
	    // pass whatever the checkbox value is.
	    var isContributing = !hasPaid && this.state.response === _Activity.ATTENDANCE.YES || this.state.contribute;
	
	    onValidSubmit(_extends({}, values, {
	      response: this.state.response,
	      contribute: isContributing
	    }));
	  },
	  onValid: function onValid() {
	    if (this.state.disabled) {
	      this.setState({ disabled: false });
	    }
	  },
	  onInvalid: function onInvalid() {
	    if (!this.state.disabled) {
	      this.setState({ disabled: true });
	    }
	  },
	  onContributeChange: function onContributeChange() {
	    this.setState({ contribute: !this.state.contribute });
	  },
	  shouldDisplayContribute: function shouldDisplayContribute() {
	    return this.props.isCollectingMoney && (this.state.response === _Activity.ATTENDANCE.MAYBE || this.state.response === _Activity.ATTENDANCE.NO || this.props.editableEventRecipient && this.props.editableEventRecipient.hasPaid());
	  },
	  renderContributionCheckbox: function renderContributionCheckbox() {
	    var label = this.props.editableEventRecipient && this.props.editableEventRecipient.hasPaid() ? 'I would like to send money again for this activity' : 'I would like to send money for this activity';
	
	    return _react2.default.createElement(_FormCheckBox2.default, {
	      name: 'contribute',
	      checked: this.state.contribute,
	      onChange: this.onContributeChange,
	      label: label,
	      eventElementName: 'participant_contribute'
	    });
	  },
	  renderNoteField: function renderNoteField() {
	    var _props2 = this.props,
	        eventScreenName = _props2.eventScreenName,
	        editableEventRecipient = _props2.editableEventRecipient;
	
	
	    return _react2.default.createElement(
	      _FocusEventTrigger2.default,
	      {
	        eventScreenName: eventScreenName,
	        eventElementName: 'add_note',
	        trackChildComponents: true },
	      _react2.default.createElement(_FormInput2.default, {
	        'data-test-selector': 'note_input',
	        name: 'note',
	        component: _Textarea2.default,
	        value: editableEventRecipient && editableEventRecipient.getNote(),
	        className: (0, _classnames2.default)(_EventParticipationForm2.default.textareaInput),
	        placeholder: 'Add a private message for the teacher (e.g., student\'s name or t-shirt size)'
	      })
	    );
	  },
	  shouldFormBeDisabled: function shouldFormBeDisabled() {
	    return !!(this.context.isPreview || this.state.disabled || /* formzy form validation */
	    this.state.response === _Activity.ATTENDANCE.PENDING || !this.state.response);
	  },
	  renderParticipantIdentityFields: function renderParticipantIdentityFields() {
	    var eventScreenName = this.props.eventScreenName;
	
	
	    var verticalPositioning = this.props.width < 521;
	
	    var name = _react2.default.createElement(
	      _FocusEventTrigger2.default,
	      {
	        eventScreenName: eventScreenName,
	        eventElementName: 'add_name',
	        trackChildComponents: true },
	      _react2.default.createElement(_FormInput2.default, {
	        'data-test-selector': 'name_input',
	        name: 'name',
	        required: 'isRequired',
	        className: (0, _classnames2.default)(!verticalPositioning && _EventParticipationForm2.default.nameInput),
	        placeholder: 'Your name',
	        validationErrors: {
	          isRequired: 'A name is required.'
	        }
	      })
	    );
	
	    var address = _react2.default.createElement(
	      _FocusEventTrigger2.default,
	      {
	        eventScreenName: eventScreenName,
	        eventElementName: 'add_email_address',
	        trackChildComponents: true },
	      _react2.default.createElement(_FormInput2.default, {
	        'data-test-selector': 'address_input',
	        name: 'address',
	        required: 'isRequired',
	        className: (0, _classnames2.default)(!verticalPositioning && _EventParticipationForm2.default.emailInput),
	        showErrorAfterBlur: true,
	        placeholder: 'Email or phone number',
	        validationErrors: {
	          isRequired: 'An email address or phone number is required.'
	        }
	      })
	    );
	
	    if (verticalPositioning) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          name
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          address
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_EventParticipationForm2.default.row) },
	      name,
	      address
	    );
	  },
	  render: function render() {
	    var _props3 = this.props,
	        className = _props3.className,
	        processingSubmit = _props3.processingSubmit,
	        showParticipantIdentityFields = _props3.showParticipantIdentityFields;
	
	
	    var hasRSVP = this.props.editableEventRecipient && this.props.editableEventRecipient.getAttendance() !== 'pending';
	
	    var submitText = hasRSVP ? 'Change response' : 'Respond';
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_EventParticipationForm2.default.this, className) },
	      _react2.default.createElement(_EventRSVPForm2.default, {
	        buttonSize: 'medium',
	        onChange: this.onResponseChange,
	        initialResponse: this.state.response
	      }),
	      _react2.default.createElement(
	        _Form2.default,
	        {
	          className: (0, _classnames2.default)(_EventParticipationForm2.default.form),
	          onValid: this.onValid,
	          onInvalid: this.onInvalid,
	          onValidSubmit: this.onValidSubmit },
	        showParticipantIdentityFields && this.renderParticipantIdentityFields(),
	        this.renderNoteField(),
	        this.shouldDisplayContribute() && this.renderContributionCheckbox(),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            size: 'small',
	            'data-test-selector': 'rsvp_submit_button',
	            loading: processingSubmit,
	            className: (0, _classnames2.default)(_EventParticipationForm2.default.submitButton),
	            disabled: this.shouldFormBeDisabled() },
	          submitText
	        ),
	        _react2.default.createElement('hr', { className: _EventParticipationForm2.default.divider }),
	        _react2.default.createElement(
	          'div',
	          { className: _EventParticipationForm2.default.tos },
	          _react2.default.createElement(
	            'span',
	            null,
	            'By responding to this invitation, you agree to our ',
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                weight: 'semibold',
	                href: _LinkConstants2.default.TERMS_OF_SERVICE,
	                target: '_blank' },
	              'Terms of Service'
	            ),
	            ' and ',
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                weight: 'semibold',
	                href: _LinkConstants2.default.PRIVACY_POLICY,
	                target: '_blank' },
	              'Privacy Policy'
	            ),
	            '.',
	            ' ',
	            'The activity organizer may contact you with updates ' + 'about time, location, or other details.'
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = (0, _trackView2.default)((0, _withWidth2.default)(EventParticipationForm));

/***/ },
/* 1950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _hoistNonReactStatics = __webpack_require__(474);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var trackView = function trackView(Component, eventScreenName, getEventPropertiesFromProps) {
	  var WrappedComponent = function (_React$Component) {
	    _inherits(WrappedComponent, _React$Component);
	
	    function WrappedComponent() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, WrappedComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedComponent.__proto__ || Object.getPrototypeOf(WrappedComponent)).call.apply(_ref, [this].concat(args))), _this), _this.displayName = 'TrackView(' + Component.displayName + ')', _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(WrappedComponent, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var screenName = eventScreenName || Component.displayName;
	        (0, _invariant2.default)(screenName, 'TriggerViewEvent requires an eventScreenName, otherwise it would be the same as the automatically generated view event.');
	
	        var eventPropertiesFromProps = getEventPropertiesFromProps ? getEventPropertiesFromProps(this.props) : {};
	        var viewProperties = (0, _EventTracking.getEventProperties)(eventPropertiesFromProps, this.context);
	        _EventTracking2.default.view(screenName, viewProperties);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(Component, this.props);
	      }
	    }]);
	
	    return WrappedComponent;
	  }(_react2.default.Component);
	
	  WrappedComponent.contextTypes = {
	    eventProperties: _react2.default.PropTypes.object
	  };
	  WrappedComponent.displayName = 'WrappedComponent';
	
	
	  return (0, _hoistNonReactStatics2.default)(WrappedComponent, Component);
	};
	
	exports.default = trackView;

/***/ },
/* 1951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = responsive;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var THROTTLE_TIME = 200;
	
	/** Higher order component (HOC) that pass the component width as prop.
	 *
	 * class SomeComponent {
	 *   static propTypes = {
	 *     width: PropTypes.number.isRequired <- isRequired, can be use in the first render!
	 *   }
	 *
	 *   render() {
	 *     return <div>my width is {this.props.width} pixels</div>;
	 *   }
	 * }
	 *
	 * export default withWidth(SomeComponent);
	 */
	
	/* Placeholder is a component that we use to compute
	 * the initial size of the children when mounted. We can't
	 * just mount the child directly otherwise the width props
	 * will be null at first and the child will have to re-render
	 * when we'll set the width prop.
	 */
	
	var Placeholder = function (_Component) {
	  _inherits(Placeholder, _Component);
	
	  function Placeholder() {
	    _classCallCheck(this, Placeholder);
	
	    return _possibleConstructorReturn(this, (Placeholder.__proto__ || Object.getPrototypeOf(Placeholder)).apply(this, arguments));
	  }
	
	  _createClass(Placeholder, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	      var style = this.props.style;
	
	
	      if (!className && !style) {
	        style = { width: '100%', height: '100%', position: 'relative' };
	      }
	
	      var props = { className: className, style: style };
	      return _react2.default.createElement('div', props);
	    }
	  }]);
	
	  return Placeholder;
	}(_react.Component);
	
	Placeholder.displayName = 'Placeholder';
	function responsive(Child) {
	  var Wrapper = function (_Component2) {
	    _inherits(Wrapper, _Component2);
	
	    function Wrapper() {
	      var _ref;
	
	      var _temp, _this2, _ret;
	
	      _classCallCheck(this, Wrapper);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
	        width: null
	      }, _this2.computeState = (0, _lodash.throttle)(function () {
	        this.node = _reactDom2.default.findDOMNode(this);
	        if (!this.node) {
	          return;
	        }
	
	        if (this.node.offsetWidth !== this.state.width) {
	          this.setState({ width: this.node.offsetWidth });
	        }
	      }.bind(_this2), THROTTLE_TIME), _temp), _possibleConstructorReturn(_this2, _ret);
	    }
	
	    _createClass(Wrapper, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        window.addEventListener('resize', this.computeState);
	        this.computeState();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this.computeState);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        if (this.state.width) {
	          return _react2.default.createElement(Child, _extends({}, this.state, this.props));
	        } else {
	          return _react2.default.createElement(Placeholder, null);
	        }
	      }
	    }]);
	
	    return Wrapper;
	  }(_react.Component);
	
	  Wrapper.displayName = 'Wrapper';
	
	
	  return Wrapper;
	}

/***/ },
/* 1952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EventRSVPForm = __webpack_require__(1953);
	
	var _EventRSVPForm2 = _interopRequireDefault(_EventRSVPForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventRSVPForm = function (_React$Component) {
	  _inherits(EventRSVPForm, _React$Component);
	
	  function EventRSVPForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EventRSVPForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EventRSVPForm.__proto__ || Object.getPrototypeOf(EventRSVPForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedResponse: _this.props.initialResponse
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EventRSVPForm, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (nextProps.initialResponse && this.props.initialResponse !== nextProps.initialResponse) {
	        this.setState({ selectedResponse: nextProps.initialResponse });
	      }
	    }
	  }, {
	    key: 'getClassNames',
	    value: function getClassNames(response) {
	      var isSelected = this.state.selectedResponse === response;
	
	      var buttonStyle = _EventRSVPForm2.default.mediumButton;
	      if (this.props.buttonSize === 'small') {
	        buttonStyle = _EventRSVPForm2.default.smallButton;
	      }
	
	      return (0, _classnames2.default)(_EventRSVPForm2.default.button, buttonStyle, _defineProperty({}, _EventRSVPForm2.default.selected, isSelected));
	    }
	  }, {
	    key: 'changeResponse',
	    value: function changeResponse(selectedResponse) {
	      var _this2 = this;
	
	      if (this.props.disableSelectionChange) {
	        if (this.props.onChange) {
	          this.props.onChange(selectedResponse);
	        }
	        return;
	      }
	
	      this.setState({ selectedResponse: selectedResponse }, function () {
	        if (_this2.props.onChange) {
	          _this2.props.onChange(selectedResponse);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_EventRSVPForm2.default.this, this.props.className) },
	        _react2.default.createElement(
	          'div',
	          { className: _EventRSVPForm2.default.buttonGroup },
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.getClassNames('yes'),
	              onClick: function onClick() {
	                return _this3.changeResponse('yes');
	              } },
	            'Yes'
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.getClassNames('maybe'),
	              onClick: function onClick() {
	                return _this3.changeResponse('maybe');
	              } },
	            'Maybe'
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.getClassNames('no'),
	              onClick: function onClick() {
	                return _this3.changeResponse('no');
	              } },
	            'No'
	          )
	        )
	      );
	    }
	  }]);
	
	  return EventRSVPForm;
	}(_react2.default.Component);
	
	EventRSVPForm.defaultProps = {
	  disableSelectionChange: false,
	  buttonSize: 'small'
	};
	EventRSVPForm.displayName = 'EventRSVPForm';
	exports.default = EventRSVPForm;

/***/ },
/* 1953 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"koala":"#c5c7cb","brand":"#2f75c1","polarBear":"#f2f3f5","this":"EventRSVPForm__this___3B7W6","buttonGroup":"EventRSVPForm__buttonGroup___sm0iy","button":"EventRSVPForm__button___2RWki","smallButton":"EventRSVPForm__smallButton___2uCI6","mediumButton":"EventRSVPForm__mediumButton___3D4F-","selected":"EventRSVPForm__selected___2Wyuf"};

/***/ },
/* 1954 */,
/* 1955 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"spacing-large":"16px","spacing-huge":"32px","thunder":"#6b6e72","wolf":"#dcdee2","this":"EventParticipationForm__this___EIPvY","row":"EventParticipationForm__row___2TfAe","form":"EventParticipationForm__form___2rbrh","textareaInput":"EventParticipationForm__textareaInput___3d4kB","submitButton":"EventParticipationForm__submitButton___DZdGc","divider":"EventParticipationForm__divider___jDB_I","tos":"EventParticipationForm__tos___I9yje","nameInput":"EventParticipationForm__nameInput___3inxH","emailInput":"EventParticipationForm__emailInput___1aIKF"};

/***/ },
/* 1956 */,
/* 1957 */
1136,
/* 1958 */,
/* 1959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _EventTrackingConstants = __webpack_require__(1745);
	
	var _EventTrackingConstants2 = _interopRequireDefault(_EventTrackingConstants);
	
	var _PaymentCardCreator = __webpack_require__(1960);
	
	var _PaymentCardCreator2 = _interopRequireDefault(_PaymentCardCreator);
	
	var _PaymentChargeCreator = __webpack_require__(1985);
	
	var _PaymentChargeCreator2 = _interopRequireDefault(_PaymentChargeCreator);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var PAGE = (0, _enumerate2.default)(['cardCreator', 'chargeCreator']);
	
	var PaymentCreator = _react2.default.createClass({
	  displayName: 'PaymentCreator',
	  getInitialState: function getInitialState() {
	    return {
	      amount: this.props.request.getAmountPerPerson(),
	      page: PAGE.cardCreator,
	      cardErrors: [],
	      token: ''
	    };
	  },
	  onCardErrored: function onCardErrored(cardErrors) {
	    this.setState({ cardErrors: cardErrors, page: PAGE.cardCreator });
	  },
	  handleContinue: function handleContinue(amount, token) {
	    this.setState({ amount: amount, token: token, page: PAGE.chargeCreator });
	  },
	  renderPaymentCardCreator: function renderPaymentCardCreator() {
	    return _react2.default.createElement(_PaymentCardCreator2.default, {
	      errors: this.state.cardErrors,
	      request: this.props.request,
	      onContinue: this.handleContinue,
	      eventScreenName: _EventTrackingConstants2.default.SELECT_PAYMENT
	    });
	  },
	  renderPaymentChargeCreator: function renderPaymentChargeCreator() {
	    var _this = this;
	
	    return _react2.default.createElement(_PaymentChargeCreator2.default, {
	      token: this.state.token,
	      amount: this.state.amount,
	      request: this.props.request,
	      recipient: this.props.recipient,
	      onCardErrored: this.onCardErrored,
	      onTransactionCreated: function onTransactionCreated(transaction) {
	        return _this.props.onComplete(transaction);
	      },
	      eventScreenName: _EventTrackingConstants2.default.CONFIRM_PAYMENT
	    });
	  },
	  render: function render() {
	    var _pages;
	
	    var pages = (_pages = {}, _defineProperty(_pages, PAGE.cardCreator, this.renderPaymentCardCreator), _defineProperty(_pages, PAGE.chargeCreator, this.renderPaymentChargeCreator), _pages);
	    return pages[this.state.page]();
	  }
	});
	
	exports.default = PaymentCreator;

/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DecoratedInput = __webpack_require__(1961);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Select = __webpack_require__(1366);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _CardInput = __webpack_require__(1964);
	
	var _CardInput2 = _interopRequireDefault(_CardInput);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _EncryptionNotice = __webpack_require__(1970);
	
	var _EncryptionNotice2 = _interopRequireDefault(_EncryptionNotice);
	
	var _EventTrackingConstants = __webpack_require__(1745);
	
	var _EventTrackingConstants2 = _interopRequireDefault(_EventTrackingConstants);
	
	var _trackView = __webpack_require__(1950);
	
	var _trackView2 = _interopRequireDefault(_trackView);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _FormMoneyInput = __webpack_require__(1867);
	
	var _FormMoneyInput2 = _interopRequireDefault(_FormMoneyInput);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _List = __webpack_require__(1281);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(1282);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _PaymentSourceActions = __webpack_require__(1973);
	
	var _PaymentSourceActions2 = _interopRequireDefault(_PaymentSourceActions);
	
	var _PaymentSourceStore = __webpack_require__(1977);
	
	var _PaymentSourceStore2 = _interopRequireDefault(_PaymentSourceStore);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _StripeAPI = __webpack_require__(1979);
	
	var _StripeAPI2 = _interopRequireDefault(_StripeAPI);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _connectPaymentHeaderEventScreenName = __webpack_require__(1980);
	
	var _connectPaymentHeaderEventScreenName2 = _interopRequireDefault(_connectPaymentHeaderEventScreenName);
	
	__webpack_require__(1983);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var savedState = null;
	
	var PaymentCardCreator = _react2.default.createClass({
	  displayName: 'PaymentCardCreator',
	
	
	  childContextTypes: {
	    eventScreenName: _react2.default.PropTypes.string
	  },
	
	  mixins: [(0, _linkStateWithStores2.default)([_PaymentSourceStore2.default])],
	
	  getInitialState: function getInitialState() {
	    var _this = this;
	
	    var errorsContains = function errorsContains(field) {
	      return !!_this.props.errors.some(function (error) {
	        return error.code === field;
	      });
	    };
	
	    // if there's errors than we need to show
	    // the previous state of this component
	    if (this.props.errors && savedState && savedState.card) {
	      // those are stripe errors https://stripe.com/docs/testing
	      savedState.card.cvc.isValid = !errorsContains('incorrect_cvc');
	      savedState.card.expiry.isValid = !errorsContains('expired_card');
	      return savedState;
	    }
	
	    return Object.assign(this.getStateFromStores(), {
	      amountPerPerson: this.props.request.getAmountPerPerson(),
	      card: null
	    });
	  },
	  getChildContext: function getChildContext() {
	    return {
	      eventScreenName: _EventTrackingConstants2.default.SELECT_PAYMENT
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    _StripeAPI2.default.setPublishableKey(_SettingsStore2.default.getStripeKey()).then(this.handleScriptLoaded, this.handleScriptError);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    _CurrentUser2.default.removeSignInListener(this.onUserSignIn);
	  },
	  getStateFromStores: function getStateFromStores() {
	    return {
	      paymentSourceIndex: 0,
	      paymentSources: _PaymentSourceStore2.default.getPaymentSources()
	    };
	  },
	  onUserSignIn: function onUserSignIn() {
	    this.loadPaymentSources();
	  },
	  isUsingSaved: function isUsingSaved() {
	    return this.state.paymentSources && this.state.paymentSources.size() > this.state.paymentSourceIndex;
	  },
	  onSubmit: function onSubmit() {
	    var _this2 = this;
	
	    savedState = this.state;
	
	    // if we have a payment source selected than use it!
	    if (this.isUsingSaved()) {
	      this.props.onContinue(this.state.amountPerPerson, this.state.paymentSources.at(this.state.paymentSourceIndex).id);
	
	      return;
	    }
	
	    // otherwise create a new card!
	    var handleStripeResponse = function handleStripeResponse(status, response) {
	      if (response.error) {
	        _ToastActions2.default.showErrorToast(response.error.message);
	      } else {
	        _this2.props.onContinue(_this2.state.amountPerPerson, response.id);
	      }
	    };
	
	    _StripeAPI2.default.createCardToken({
	      number: this.state.card.number.value,
	      cvc: this.state.card.cvc.value,
	      exp: this.state.card.expiry.value,
	      address_zip: this.state.card.zip.value
	    }, handleStripeResponse.bind(this));
	  },
	  handleScriptError: function handleScriptError() {
	    _ToastActions2.default.showErrorToast('Looks like there was an error loading the page. Please reload to continue.');
	  },
	  handleScriptLoaded: function handleScriptLoaded() {
	    _CurrentUser2.default.addSignInListener(this.onUserSignIn);
	
	    if (_CurrentUser2.default.isSignedIn() && _PaymentSourceStore2.default.getPaymentSources().length <= 0) {
	      this.loadPaymentSources();
	    }
	  },
	  loadPaymentSources: function loadPaymentSources() {
	    var _this3 = this;
	
	    var loaded = function loaded() {
	      return _this3.setState({ isLoadingPaymentSources: false });
	    };
	
	    this.setState({ isLoadingPaymentSources: true }, function () {
	      _PaymentSourceActions2.default.load().then(loaded, loaded);
	    });
	  },
	  handleAmountChange: function handleAmountChange(_ref) {
	    var value = _ref.value;
	
	    this.setState({ amountPerPerson: value });
	  },
	  isSubmitEnabled: function isSubmitEnabled() {
	    return (this.isUsingSaved() || this.state.card) && this.state.amountPerPerson > 0;
	  },
	  paymentSourceOptions: function paymentSourceOptions() {
	    return (this.state.paymentSources || []).map(function (source, index) {
	      return {
	        label: source.getBrand() + ' ending in ' + source.getLastFourDigit(),
	        value: '' + index
	      };
	    }).concat({ label: 'Add a new card', value: '' + this.state.paymentSources.size() });
	  },
	  renderCardInput: function renderCardInput() {
	    var _this4 = this;
	
	    var _state = this.state,
	        paymentSources = _state.paymentSources,
	        paymentSourceIndex = _state.paymentSourceIndex;
	
	
	    if (this.state.isLoadingPaymentSources) {
	      return _react2.default.createElement(_DecoratedInput.LoadingInput, null);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      paymentSources && paymentSources.size() > 0 && _react2.default.createElement(_Select2.default, {
	        options: this.paymentSourceOptions(),
	        value: '' + paymentSourceIndex,
	        onChange: function onChange(index) {
	          return _this4.setState({ paymentSourceIndex: index });
	        }
	      }),
	      !this.isUsingSaved() && _react2.default.createElement(_CardInput2.default, {
	        className: 'PaymentCardCreator-cardInput',
	        values: this.state.card,
	        onValid: function onValid(card) {
	          return _this4.setState({ card: card });
	        },
	        onInvalid: function onInvalid() {
	          return _this4.setState({ card: null });
	        },
	        eventScreenName: _EventTrackingConstants2.default.SELECT_PAYMENT
	      })
	    );
	  },
	  renderErrors: function renderErrors() {
	    var errors = this.props.errors.map(function (error) {
	      return error.messages.map(function (message, index) {
	        return _react2.default.createElement(
	          _ListItem2.default,
	          { key: index },
	          message
	        );
	      });
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'PaymentCardCreator-errorList' },
	      _react2.default.createElement(
	        'div',
	        null,
	        'An error occured during the payment process:'
	      ),
	      _react2.default.createElement(
	        _List2.default,
	        { className: 'PaymentCardCreator-error' },
	        errors
	      )
	    );
	  },
	  render: function render() {
	    var _this5 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'PaymentCardCreator-content' },
	      _react2.default.createElement(_FormMoneyInput2.default, {
	        border: false,
	        currency: 'USD',
	        minimum: this.props.request.getFee(),
	        initialCentValue: this.state.amountPerPerson || this.props.request.getAmountPerPerson(),
	        className: 'PaymentCardCreator-moneyInput',
	        onValidChange: function onValidChange(amountPerPerson) {
	          return _this5.setState({ amountPerPerson: amountPerPerson });
	        },
	        onInvalidChange: function onInvalidChange() {
	          return _this5.setState({ amountPerPerson: null });
	        }
	      }),
	      _react2.default.createElement(
	        _Field2.default,
	        null,
	        this.renderCardInput()
	      ),
	      this.props.errors && this.props.errors.length > 0 && this.renderErrors(),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          onClick: this.onSubmit,
	          'data-test-selector': 'payment_card_creator_submit',
	          className: 'PaymentCardCreator-cardEntryButton',
	          disabled: !this.isSubmitEnabled(),
	          eventScreenName: _EventTrackingConstants2.default.SELECT_PAYMENT,
	          eventElementName: 'continue' },
	        'Continue'
	      ),
	      _react2.default.createElement(_EncryptionNotice2.default, null)
	    );
	  }
	});
	
	exports.default = (0, _trackView2.default)((0, _connectPaymentHeaderEventScreenName2.default)(PaymentCardCreator));

/***/ },
/* 1961 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ClosableInput = exports.LoadingInput = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1962);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /*  weak */
	
	
	var LoadingInput = function LoadingInput(_ref) {
	  var className = _ref.className,
	      rest = _objectWithoutProperties(_ref, ['className']);
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('DecoratedInput DecoratedInput--loading', className) },
	    _react2.default.createElement(_LoadingIndicator2.default, { size: 'small', className: 'DecoratedInput-loader' }),
	    _react2.default.createElement(_Input2.default, _extends({}, rest, { disabled: true }))
	  );
	};
	
	exports.LoadingInput = LoadingInput;
	var ClosableInput = function ClosableInput(_ref2) {
	  var className = _ref2.className,
	      onClose = _ref2.onClose,
	      eventScreenName = _ref2.eventScreenName,
	      eventElementName = _ref2.eventElementName,
	      rest = _objectWithoutProperties(_ref2, ['className', 'onClose', 'eventScreenName', 'eventElementName']);
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('DecoratedInput DecoratedInput--closable', className) },
	    _react2.default.createElement(_Input2.default, _extends({}, rest, { disabled: true })),
	    _react2.default.createElement(
	      _Link2.default,
	      {
	        color: 'thunder',
	        eventScreenName: eventScreenName,
	        eventElementName: eventElementName,
	        onClick: onClose },
	      _react2.default.createElement(_Glyph2.default, {
	        name: 'close-circle',
	        size: 'large',
	        className: 'DecoratedInput-glyph',
	        solo: true
	      })
	    )
	  );
	};
	
	exports.ClosableInput = ClosableInput;

/***/ },
/* 1962 */
1136,
/* 1963 */,
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _INPUT_VALIDATIONS;
	
	var _lodash = __webpack_require__(555);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _MMYYInput = __webpack_require__(1965);
	
	var _MMYYInput2 = _interopRequireDefault(_MMYYInput);
	
	var _CardNumberInput = __webpack_require__(1967);
	
	var _CardNumberInput2 = _interopRequireDefault(_CardNumberInput);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TrackedInput = __webpack_require__(1966);
	
	var _TrackedInput2 = _interopRequireDefault(_TrackedInput);
	
	__webpack_require__(1968);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*  weak */
	
	
	var INPUTS = (0, _enumerate2.default)(['CARD_CVC', 'CARD_EXPIRY', 'CARD_NUMBER', 'CARD_ZIP']);
	
	var INPUT_VALIDATIONS = (_INPUT_VALIDATIONS = {}, _defineProperty(_INPUT_VALIDATIONS, INPUTS.CARD_CVC, {
	  getValidator: function getValidator() {
	    return window.Stripe.card.validateCVC;
	  },
	  key: 'cvc'
	}), _defineProperty(_INPUT_VALIDATIONS, INPUTS.CARD_EXPIRY, {
	  getValidator: function getValidator() {
	    return window.Stripe.card.validateExpiry;
	  },
	  key: 'expiry'
	}), _defineProperty(_INPUT_VALIDATIONS, INPUTS.CARD_NUMBER, {
	  getValidator: function getValidator() {
	    return window.Stripe.card.validateCardNumber;
	  },
	  key: 'number'
	}), _defineProperty(_INPUT_VALIDATIONS, INPUTS.CARD_ZIP, {
	  getValidator: function getValidator() {
	    return function (value) {
	      return value.length > 0;
	    };
	  },
	  key: 'zip'
	}), _INPUT_VALIDATIONS);
	
	var CardInput = _react2.default.createClass({
	  displayName: 'CardInput',
	
	
	  contextTypes: {
	    eventScreenName: _react2.default.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      placeholder: 'Enter your debit or credit card number to pay'
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      showCardInfo: !!this.props.values,
	      card: Object.assign({
	        cvc: {},
	        expiry: {},
	        number: {},
	        zip: {}
	      }, this.props.values)
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.setState({ id: (0, _lodash.uniqueId)('id-') });
	  },
	  onInputChange: function onInputChange(input, value) {
	    var validation = INPUT_VALIDATIONS[input];
	    var validator = validation.getValidator();
	
	    var card = this.state.card;
	
	    card[validation.key] = { value: value, isValid: validator(value) };
	
	    this.setState({ card: card }, this.informParentsOfFormStatus);
	  },
	  handleInputFocus: function handleInputFocus() {
	    this.setState({ showCardInfo: true });
	  },
	  informParentsOfFormStatus: function informParentsOfFormStatus() {
	    var _this = this;
	
	    var cardKeys = (0, _lodash.keys)(this.state.card);
	    var isValid = cardKeys.every(function (key) {
	      return _this.state.card[key].isValid;
	    });
	
	    if (isValid) {
	      this.props.onValid(this.state.card);
	    } else {
	      this.props.onInvalid(this.state.card);
	    }
	  },
	  renderLabel: function renderLabel() {
	    var label = this.props.label;
	
	
	    if (label) {
	      return _react2.default.createElement(
	        _Label2.default,
	        {
	          htmlFor: this.state.id,
	          hidden: this.props.labelHidden,
	          onClick: this.handleInputFocus },
	        label
	      );
	    } else {
	      return null;
	    }
	  },
	  renderCardInputs: function renderCardInputs() {
	    var _this2 = this;
	
	    if (!this.state.showCardInfo) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'CardInput-inputs' },
	        _react2.default.createElement(_Input2.default, {
	          'data-test-selector': 'card_input_placeholder',
	          placeholder: this.props.placeholder,
	          className: 'CardInput-cardPlaceholder CardInput-input',
	          onFocus: this.handleInputFocus
	        })
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'CardInput-inputs' },
	      _react2.default.createElement(_CardNumberInput2.default, {
	        'data-test-selector': 'card_number_input',
	        autoFocus: true,
	        id: this.state.id,
	        value: this.state.card.number.value || '',
	        className: (0, _classnames2.default)('CardInput-cardNumber CardInput-input', {
	          error: this.state.card.number.isValid === false
	        }),
	        onChange: function onChange(value) {
	          return _this2.onInputChange(INPUTS.CARD_NUMBER, value);
	        },
	        onFocus: function onFocus() {
	          return _this2.setState({ focus: true });
	        },
	        onBlur: function onBlur() {
	          return _this2.setState({ focus: false });
	        }
	      }),
	      _react2.default.createElement(_MMYYInput2.default, {
	        'data-test-selector': 'card_expiration_input',
	        maxLength: '7',
	        placeholder: 'MM/YY',
	        value: this.state.card.expiry.value || '',
	        className: (0, _classnames2.default)('CardInput-expiry CardInput-input', {
	          error: this.state.card.expiry.isValid === false
	        }),
	        onChange: function onChange(value) {
	          return _this2.onInputChange(INPUTS.CARD_EXPIRY, value);
	        },
	        onFocus: function onFocus() {
	          return _this2.setState({ focus: true });
	        },
	        onBlur: function onBlur() {
	          return _this2.setState({ focus: false });
	        }
	      }),
	      _react2.default.createElement(_TrackedInput2.default, {
	        'data-test-selector': 'card_cvc_input',
	        type: 'tel',
	        autoComplete: 'cc-csc',
	        maxLength: '4',
	        pattern: '[\\d]{3,4}',
	        placeholder: 'CVC',
	        value: this.state.card.cvc.value || '',
	        className: (0, _classnames2.default)('CardInput-verificationCode CardInput-input cc-cvc cc-csc', {
	          error: this.state.card.cvc.isValid === false
	        }),
	        onChange: function onChange(_ref) {
	          var target = _ref.target;
	          return _this2.onInputChange(INPUTS.CARD_CVC, target.value);
	        },
	        onFocus: function onFocus() {
	          return _this2.setState({ focus: true });
	        },
	        onBlur: function onBlur() {
	          return _this2.setState({ focus: false });
	        },
	        eventScreenName: this.context.eventScreenName,
	        eventElementName: 'add_cvv'
	      }),
	      _react2.default.createElement(_TrackedInput2.default, {
	        'data-test-selector': 'card_zip_input',
	        type: 'tel',
	        autoComplete: 'postal-code',
	        maxLength: '5',
	        pattern: '[\\d]{5}',
	        placeholder: 'ZIP',
	        value: this.state.card.zip.value || '',
	        className: (0, _classnames2.default)('CardInput-zip CardInput-input postal-code', {
	          error: this.state.card.zip.isValid === false
	        }),
	        onChange: function onChange(_ref2) {
	          var target = _ref2.target;
	          return _this2.onInputChange(INPUTS.CARD_ZIP, target.value);
	        },
	        onFocus: function onFocus() {
	          return _this2.setState({ focus: true });
	        },
	        onBlur: function onBlur() {
	          return _this2.setState({ focus: false });
	        },
	        eventScreenName: this.context.eventScreenName,
	        eventElementName: 'add_zip'
	      })
	    );
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.renderLabel(),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('CardInput', this.props.className, {
	            'CardInput-focus': this.state.focus
	          }) },
	        this.renderCardInputs(),
	        _react2.default.createElement(_Glyph2.default, { name: 'lock-stroke', className: 'CardInput-icon', size: 'small', color: 'koala' })
	      )
	    );
	  }
	});
	
	exports.default = CardInput;

/***/ },
/* 1965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TrackedInput = __webpack_require__(1966);
	
	var _TrackedInput2 = _interopRequireDefault(_TrackedInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var MMYYInput = function (_React$Component) {
	  _inherits(MMYYInput, _React$Component);
	
	  function MMYYInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MMYYInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MMYYInput.__proto__ || Object.getPrototypeOf(MMYYInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      value: _this.props.value || ''
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MMYYInput, [{
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var inputs = event.target.value.split('').filter(function (char, index) {
	        return !isNaN(parseInt(char, 10)) || index === 2 && char === '/';
	      });
	
	      if (inputs.length === 1) {
	        var num = parseInt(inputs[0], 10);
	        if (num > 1) {
	          inputs.unshift('0');
	          inputs.push('/');
	        }
	      } else if (inputs.length === 2 && this.state.value.length === 1 || inputs.length > 2 && inputs[2] !== '/') {
	        inputs.splice(2, 0, '/');
	      }
	
	      var newValue = inputs.join('');
	
	      this.setState({ value: newValue });
	
	      if (this.props.onChange) {
	        this.props.onChange(newValue);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_TrackedInput2.default, _extends({}, this.props, {
	        type: 'text',
	        autoComplete: 'cc-exp',
	        maxLength: 5,
	        placeholder: 'MM/YY',
	        value: this.state.value,
	        className: (0, _classnames2.default)('cc-exp', this.props.className),
	        onChange: this.handleChange.bind(this),
	        eventScreenName: this.context.eventScreenName,
	        eventElementName: 'add_date'
	      }));
	    }
	  }]);
	
	  return MMYYInput;
	}(_react2.default.Component);
	
	MMYYInput.contextTypes = {
	  eventScreenName: _react2.default.PropTypes.string
	};
	MMYYInput.displayName = 'MMYYInput';
	exports.default = MMYYInput;

/***/ },
/* 1966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _EventTrackingMixin = __webpack_require__(1747);
	
	var _EventTrackingMixin2 = _interopRequireDefault(_EventTrackingMixin);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrackedInput = _react2.default.createClass({
	  displayName: 'TrackedInput',
	
	  mixins: [_EventTrackingMixin2.default],
	
	  handleFocus: function handleFocus() {
	    this.trackClick();
	  },
	  render: function render() {
	    return _react2.default.createElement(_Input2.default, _extends({}, this.props, {
	      onFocus: (0, _createChainedFunction2.default)(this.props.onFocus, this.handleFocus)
	    }));
	  }
	});
	
	exports.default = TrackedInput;

/***/ },
/* 1967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TrackedInput = __webpack_require__(1966);
	
	var _TrackedInput2 = _interopRequireDefault(_TrackedInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var CardNumberInput = function (_React$Component) {
	  _inherits(CardNumberInput, _React$Component);
	
	  function CardNumberInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CardNumberInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CardNumberInput.__proto__ || Object.getPrototypeOf(CardNumberInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      value: _this.props.value || ''
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CardNumberInput, [{
	    key: 'getFormattedValue',
	    value: function getFormattedValue(value) {
	      var type = window.Stripe ? window.Stripe.card.cardType(value) : null;
	
	      switch (type) {
	        case 'American Express':
	          var values = value.split('');
	
	          values.splice(4, 0, ' ');
	          values.splice(11, 0, ' ');
	
	          return values.join('').trim();
	        default:
	          return value.replace(/(.{4})/g, '$1 ').trim();
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var value = event.target.value.split('').filter(function (char) {
	        return !isNaN(parseInt(char, 10));
	      }).join('');
	
	      this.setState({ value: value });
	
	      if (this.props.onChange) {
	        this.props.onChange(value);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_TrackedInput2.default, _extends({}, this.props, {
	        type: 'tel',
	        autoComplete: 'cc-number',
	        className: (0, _classnames2.default)('cc-number', this.props.className),
	        maxLength: '19',
	        placeholder: '0000 0000 0000 0000',
	        value: this.getFormattedValue(this.state.value),
	        onChange: this.handleChange.bind(this),
	        eventScreenName: this.context.eventScreenName,
	        eventElementName: 'add_credit_card_number'
	      }));
	    }
	  }]);
	
	  return CardNumberInput;
	}(_react2.default.Component);
	
	CardNumberInput.contextTypes = {
	  eventScreenName: _react2.default.PropTypes.string
	};
	CardNumberInput.displayName = 'CardNumberInput';
	exports.default = CardNumberInput;

/***/ },
/* 1968 */
1136,
/* 1969 */,
/* 1970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(1971);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    _Text2.default,
	    { color: 'thunder', className: (0, _classnames2.default)('EncryptionNotice', className) },
	    _react2.default.createElement(_Glyph2.default, { name: 'lock-stroke', className: 'EncryptionNotice-icon' }),
	    'All data is encrypted and protected with bank-level security.'
	  );
	}; /*  weak */

/***/ },
/* 1971 */
1136,
/* 1972 */,
/* 1973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PaymentSourceConstants = __webpack_require__(1974);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _PaymentSources = __webpack_require__(1975);
	
	var _PaymentSources2 = _interopRequireDefault(_PaymentSources);
	
	var _PaymentSource = __webpack_require__(1976);
	
	var _PaymentSource2 = _interopRequireDefault(_PaymentSource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentSourceActions = {
	  create: function create(token) {
	    return _PaymentSource2.default.create(token).then(function (paymentSource) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _PaymentSourceConstants.ActionTypes.CREATE_PAYMENT_SOURCE,
	        paymentSource: paymentSource
	      });
	    });
	  },
	  delete: function _delete(paymentSource) {
	    return paymentSource.delete().then(function () {
	      _Dispatcher.dispatcher.dispatch({
	        type: _PaymentSourceConstants.ActionTypes.DELETE_PAYMENT_SOURCE,
	        paymentSource: paymentSource
	      });
	    });
	  },
	  load: function load() {
	    return _PaymentSources2.default.load().then(function (paymentSources) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _PaymentSourceConstants.ActionTypes.LOAD_PAYMENT_SOURCES,
	        paymentSources: paymentSources
	      });
	
	      return paymentSources;
	    });
	  }
	};
	
	exports.default = PaymentSourceActions;

/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['CREATE_PAYMENT_SOURCE', 'DELETE_PAYMENT_SOURCE', 'LOAD_PAYMENT_SOURCES']); /*  weak */

/***/ },
/* 1975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _PaymentSource = __webpack_require__(1976);
	
	var _PaymentSource2 = _interopRequireDefault(_PaymentSource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentSources = function (_Collection) {
	  _inherits(PaymentSources, _Collection);
	
	  function PaymentSources() {
	    _classCallCheck(this, PaymentSources);
	
	    return _possibleConstructorReturn(this, (PaymentSources.__proto__ || Object.getPrototypeOf(PaymentSources)).apply(this, arguments));
	  }
	
	  _createClass(PaymentSources, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _PaymentSource2.default;
	    }
	  }], [{
	    key: 'load',
	    value: function load() {
	      return (0, _apiRequest2.default)('/payments/payment_sources', 'GET').then(function (paymentSources) {
	        return PaymentSources.fromJSON(paymentSources);
	      });
	    }
	  }]);
	
	  return PaymentSources;
	}(_Collection3.default);
	
	PaymentSources.displayName = 'PaymentSources';
	exports.default = PaymentSources;

/***/ },
/* 1976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentSource = function (_Entity) {
	  _inherits(PaymentSource, _Entity);
	
	  function PaymentSource() {
	    _classCallCheck(this, PaymentSource);
	
	    return _possibleConstructorReturn(this, (PaymentSource.__proto__ || Object.getPrototypeOf(PaymentSource)).apply(this, arguments));
	  }
	
	  _createClass(PaymentSource, [{
	    key: 'getBrand',
	    value: function getBrand() {
	      return this.get('brand');
	    }
	  }, {
	    key: 'getLastFourDigit',
	    value: function getLastFourDigit() {
	      return this.get('last4');
	    }
	  }, {
	    key: 'getExpMonth',
	    value: function getExpMonth() {
	      return this.get('exp_month');
	    }
	  }, {
	    key: 'getExpYear',
	    value: function getExpYear() {
	      return this.get('exp_year');
	    }
	  }, {
	    key: 'getExpirationDate',
	    value: function getExpirationDate() {
	      return this.getExpMonth() + '/' + String(this.getExpYear()).slice(-2);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      return (0, _apiRequest2.default)('/payments/payment_sources/' + this.id, 'DELETE');
	    }
	  }], [{
	    key: 'create',
	    value: function create(token) {
	      return (0, _apiRequest2.default)('/payments/payment_sources', 'POST', { token: token }).then(function (paymentSource) {
	        return PaymentSource.fromJSON(paymentSource);
	      });
	    }
	  }]);
	
	  return PaymentSource;
	}(_Entity3.default);
	
	PaymentSource.displayName = 'PaymentSource';
	exports.default = PaymentSource;

/***/ },
/* 1977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _PaymentSources = __webpack_require__(1978);
	
	var _utils = __webpack_require__(956);
	
	var _Dispatcher = __webpack_require__(590);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentSourceStore = function (_ReduceStore) {
	  _inherits(PaymentSourceStore, _ReduceStore);
	
	  function PaymentSourceStore() {
	    _classCallCheck(this, PaymentSourceStore);
	
	    return _possibleConstructorReturn(this, (PaymentSourceStore.__proto__ || Object.getPrototypeOf(PaymentSourceStore)).apply(this, arguments));
	  }
	
	  _createClass(PaymentSourceStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return _PaymentSources.initialState;
	    }
	  }, {
	    key: 'getPaymentSources',
	    value: function getPaymentSources() {
	      return this.getState().paymentSources;
	    }
	  }, {
	    key: 'reduce',
	    value: function reduce(state, action) {
	      return (0, _PaymentSources.reducer)(state, action);
	    }
	  }]);
	
	  return PaymentSourceStore;
	}(_utils.ReduceStore);
	
	PaymentSourceStore.displayName = 'PaymentSourceStore';
	exports.default = new PaymentSourceStore(_Dispatcher.dispatcher);

/***/ },
/* 1978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	
	exports.reducer = reducer;
	
	var _PaymentSourceConstants = __webpack_require__(1974);
	
	var _PaymentSources = __webpack_require__(1975);
	
	var _PaymentSources2 = _interopRequireDefault(_PaymentSources);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  paymentSources: new _PaymentSources2.default()
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var paymentSources = void 0;
	
	  switch (action.type) {
	    case _PaymentSourceConstants.ActionTypes.DELETE_PAYMENT_SOURCE:
	      paymentSources = state.paymentSources.clone();
	      paymentSources.remove(action.paymentSource);
	      return _extends({}, state, { paymentSources: paymentSources });
	
	    case _PaymentSourceConstants.ActionTypes.CREATE_PAYMENT_SOURCE:
	      paymentSources = state.paymentSources.clone();
	      paymentSources.add(action.paymentSource);
	      return _extends({}, state, { paymentSources: paymentSources });
	
	    case _PaymentSourceConstants.ActionTypes.LOAD_PAYMENT_SOURCES:
	      paymentSources = state.paymentSources.clone();
	      paymentSources.add(action.paymentSources.models);
	      return _extends({}, state, { paymentSources: paymentSources });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 1979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*  weak */
	
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var STRIPE_JS = 'https://js.stripe.com/v2/';
	
	var loadId = null;
	
	var StripeAPI = function () {
	  function StripeAPI() {
	    _classCallCheck(this, StripeAPI);
	  }
	
	  _createClass(StripeAPI, null, [{
	    key: 'load',
	    value: function load() {
	      if (window.Stripe) {
	        return Promise.resolve(window.Stripe);
	      }
	
	      var $script = __webpack_require__(951);
	
	      if (!loadId) {
	        $script(STRIPE_JS, loadId = _lodash2.default.uniqueId('stripe'));
	      }
	
	      return new Promise(function (resolve) {
	        $script.ready(loadId, function () {
	          resolve(window.Stripe);
	        });
	      });
	    }
	  }, {
	    key: 'setPublishableKey',
	    value: function setPublishableKey(publishableKey) {
	      return StripeAPI.load().then(function (stripe) {
	        stripe.setPublishableKey(publishableKey);
	        return Promise.resolve();
	      });
	    }
	  }, {
	    key: 'createCardToken',
	    value: function createCardToken(card, callback) {
	      StripeAPI.load().then(function (stripe) {
	        stripe.card.createToken(card, callback);
	      }).catch(function (e) {
	        return console.error('StripeAPI createCardToken failed', e);
	      });
	    }
	  }, {
	    key: 'createPIIToken',
	    value: function createPIIToken(pii, callback) {
	      StripeAPI.load().then(function (stripe) {
	        stripe.piiData.createToken(pii, callback);
	      }).catch(function (e) {
	        return console.error('StripeAPI createPIIToken failed', e);
	      });
	    }
	  }, {
	    key: 'createBankAccountToken',
	    value: function createBankAccountToken(account, callback) {
	      StripeAPI.load().then(function (stripe) {
	        stripe.bankAccount.createToken(account, callback);
	      }).catch(function (e) {
	        return console.error('StripeAPI createBankAccountToken failed', e);
	      });
	    }
	  }]);
	
	  return StripeAPI;
	}();
	
	StripeAPI.displayName = 'StripeAPI';
	exports.default = StripeAPI;

/***/ },
/* 1980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	
	exports.default = connectPaymentHeaderEventScreenName;
	
	var _PaymentHeaderActions = __webpack_require__(1981);
	
	var _PaymentHeaderActions2 = _interopRequireDefault(_PaymentHeaderActions);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This component allows the component it wraps to pass an event screen
	 * name through to the PaymentHeader so that clicking the 'Sign In' or
	 * 'Log Out' button on a particular screen in a flow can be logged.
	 */
	function connectPaymentHeaderEventScreenName(Component) {
	  var wrapper = _react2.default.createClass({
	    displayName: 'wrapper',
	    componentDidMount: function componentDidMount() {
	      var screenName = this.props.eventScreenName;
	      if (screenName) {
	        _PaymentHeaderActions2.default.setEventScreenName(screenName);
	      }
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      _PaymentHeaderActions2.default.setEventScreenName(null);
	    },
	    render: function render() {
	      return _react2.default.createElement(Component, _extends({}, this.props, this.state));
	    }
	  });
	
	  return wrapper;
	}

/***/ },
/* 1981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dispatcher = __webpack_require__(590);
	
	var _PaymentHeaderConstants = __webpack_require__(1982);
	
	var PaymentHeaderActions = {
	  hideNavigation: function hideNavigation() {
	    _Dispatcher.dispatcher.dispatch({
	      type: _PaymentHeaderConstants.ActionTypes.HIDE_NAVIGATION
	    });
	  },
	  showNavigation: function showNavigation() {
	    _Dispatcher.dispatcher.dispatch({
	      type: _PaymentHeaderConstants.ActionTypes.SHOW_NAVIGATION
	    });
	  },
	
	
	  // this is unset by setting to null
	  setEventScreenName: function setEventScreenName(screenName) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _PaymentHeaderConstants.ActionTypes.SET_EVENT_SCREEN_NAME,
	      eventScreenName: screenName
	    });
	  }
	};
	
	exports.default = PaymentHeaderActions;

/***/ },
/* 1982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['SHOW_NAVIGATION', 'HIDE_NAVIGATION', 'SET_EVENT_SCREEN_NAME']); /*  weak */

/***/ },
/* 1983 */
1136,
/* 1984 */,
/* 1985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fee = __webpack_require__(1986);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _EncryptionNotice = __webpack_require__(1970);
	
	var _EncryptionNotice2 = _interopRequireDefault(_EncryptionNotice);
	
	var _EventTrackingConstants = __webpack_require__(1745);
	
	var _EventTrackingConstants2 = _interopRequireDefault(_EventTrackingConstants);
	
	var _trackView = __webpack_require__(1950);
	
	var _trackView2 = _interopRequireDefault(_trackView);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _Money = __webpack_require__(1651);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Receipt = __webpack_require__(1987);
	
	var _Receipt2 = _interopRequireDefault(_Receipt);
	
	var _ReceiptBody = __webpack_require__(1990);
	
	var _ReceiptBody2 = _interopRequireDefault(_ReceiptBody);
	
	var _ReceiptFooter = __webpack_require__(1993);
	
	var _ReceiptFooter2 = _interopRequireDefault(_ReceiptFooter);
	
	var _ReceiptRow = __webpack_require__(1996);
	
	var _ReceiptRow2 = _interopRequireDefault(_ReceiptRow);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _TransactionActions = __webpack_require__(1997);
	
	var _TransactionActions2 = _interopRequireDefault(_TransactionActions);
	
	var _withoutPaymentHeader = __webpack_require__(1998);
	
	var _withoutPaymentHeader2 = _interopRequireDefault(_withoutPaymentHeader);
	
	__webpack_require__(1999);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CARD_ERRORS = ['card_declined', 'incorrect_cvc', 'expired_card'];
	
	var PaymentChargeCreator = _react2.default.createClass({
	  displayName: 'PaymentChargeCreator',
	  getInitialState: function getInitialState() {
	    return {
	      processingSubmit: false,
	      fee: null,
	      feeError: null
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.fetchFee();
	  },
	  onTransactionCreateError: function onTransactionCreateError(response) {
	    var cardErrors = response['field_errors'].reduce(function (acc, error) {
	      if (CARD_ERRORS.includes(error.code)) {
	        acc.push(error);
	      }
	
	      return acc;
	    }, []);
	
	    if (cardErrors.length > 0) {
	      // this will trigger the parent comp to show the
	      // card form again with the appropriate error message.
	      this.props.onCardErrored(cardErrors);
	    }
	
	    _ToastActions2.default.showErrorToast('An error occured during the payment process');
	  },
	  fetchFee: function fetchFee() {
	    var _this = this;
	
	    (0, _fee.fetchFeeForAmount)(this.props.amount).then(function (fee) {
	      _this.setState({ fee: fee, feeError: null });
	    }).catch(function (feeError) {
	      _ToastActions2.default.showAPIError(feeError);
	      _this.setState({ feeError: feeError });
	      throw feeError;
	    });
	  },
	  createTransaction: function createTransaction() {
	    var _this2 = this;
	
	    this.setState({ processingSubmit: true });
	    var onDone = function onDone() {
	      if (_this2.isMounted()) {
	        _this2.setState({ processingSubmit: false });
	      }
	    };
	
	    _TransactionActions2.default.pay(this.props.request.id, this.props.recipient.getNote(), this.props.amount, this.props.token, this.props.recipient.getAddress(), this.props.recipient.getName(), this.props.recipient.id).then(this.props.onTransactionCreated, this.onTransactionCreateError).then(onDone, onDone);
	  },
	  render: function render() {
	    var _state = this.state,
	        fee = _state.fee,
	        feeError = _state.feeError;
	
	
	    if (feeError) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'PaymentChargeCreator' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'An error occurred and your payment wasn\u2019t processed.'
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            size: 'xsmall',
	            className: 'PaymentChargeCreator-retry',
	            onClick: this.fetchFee,
	            eventElementName: 'PaymentChargeCreator-retry' },
	          'Try again'
	        )
	      );
	    }
	
	    if (!fee) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'PaymentChargeCreator' },
	        _react2.default.createElement(_LoadingIndicator2.default, null)
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'PaymentChargeCreator', 'data-test-selector': 'payment_charge_creator' },
	      _react2.default.createElement(
	        _Container2.default,
	        { size: 'small' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'PaymentChargeCreator-title' },
	          'Review and confirm your payment!'
	        ),
	        _react2.default.createElement(
	          _Receipt2.default,
	          { className: 'PaymentChargeCreator-confirmation' },
	          _react2.default.createElement(
	            _ReceiptBody2.default,
	            null,
	            _react2.default.createElement(
	              _ReceiptRow2.default,
	              null,
	              this.props.request.getTitle(),
	              _react2.default.createElement(_Money2.default, { cents: this.props.amount })
	            ),
	            _react2.default.createElement(
	              _ReceiptRow2.default,
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Service fee'
	              ),
	              _react2.default.createElement(_Money2.default, { cents: fee })
	            )
	          ),
	          _react2.default.createElement(
	            _ReceiptFooter2.default,
	            null,
	            _react2.default.createElement(
	              _ReceiptRow2.default,
	              { className: 'PaymentChargeCreator-total' },
	              _react2.default.createElement(
	                'span',
	                null,
	                'Total payment'
	              ),
	              _react2.default.createElement(_Money2.default, { cents: this.props.amount + fee })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            'data-test-selector': 'payment_charget_creator_submit',
	            loading: this.state.processingSubmit,
	            onClick: this.createTransaction,
	            eventScreenName: _EventTrackingConstants2.default.CONFIRM_PAYMENT,
	            eventElementName: 'pay' },
	          'Pay'
	        ),
	        _react2.default.createElement(_EncryptionNotice2.default, null)
	      )
	    );
	  }
	});
	
	exports.default = (0, _trackView2.default)((0, _withoutPaymentHeader2.default)(PaymentChargeCreator));

/***/ },
/* 1986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchFeeForAmount = fetchFeeForAmount;
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Retrieve the computed fee from the API
	 * @param amount integer - value in cents.
	 */
	// $FlowFixMe
	function fetchFeeForAmount(amount) {
	  return _RemindAPI2.default.request('/payments/fees', 'GET', { amount: amount }).then(function (response) {
	    return response.fee;
	  });
	}

/***/ },
/* 1987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1988);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Receipt = _react2.default.createClass({
	  displayName: 'Receipt',
	  render: function render() {
	    return _react2.default.createElement(
	      'table',
	      { className: (0, _classnames2.default)('Receipt', this.props.className) },
	      this.props.children
	    );
	  }
	});
	exports.default = Receipt;

/***/ },
/* 1988 */
1136,
/* 1989 */,
/* 1990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1991);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReceiptBody = _react2.default.createClass({
	  displayName: 'ReceiptBody',
	  render: function render() {
	    return _react2.default.createElement(
	      'tbody',
	      { className: 'ReceiptBody' },
	      this.props.children
	    );
	  }
	});
	
	exports.default = ReceiptBody;

/***/ },
/* 1991 */
1136,
/* 1992 */,
/* 1993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1994);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReceiptFooter = _react2.default.createClass({
	  displayName: 'ReceiptFooter',
	  render: function render() {
	    return _react2.default.createElement(
	      'tfoot',
	      { className: 'ReceiptFooter' },
	      this.props.children
	    );
	  }
	});
	
	exports.default = ReceiptFooter;

/***/ },
/* 1994 */
1136,
/* 1995 */,
/* 1996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReceiptRow = _react2.default.createClass({
	  displayName: 'ReceiptRow',
	  render: function render() {
	    var children = _react2.default.Children.map(this.props.children, function (child, index) {
	      return _react2.default.createElement(
	        'td',
	        { key: index },
	        child
	      );
	    });
	
	    return _react2.default.createElement(
	      'tr',
	      { className: this.props.className },
	      children
	    );
	  }
	});
	exports.default = ReceiptRow;

/***/ },
/* 1997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TransactionConstants = __webpack_require__(979);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _Transactions = __webpack_require__(981);
	
	var _Transactions2 = _interopRequireDefault(_Transactions);
	
	var _ActivityActions = __webpack_require__(976);
	
	var _ActivityActions2 = _interopRequireDefault(_ActivityActions);
	
	var _Transaction = __webpack_require__(982);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransactionActions = {
	  // $FlowFixMe
	  claim: function claim(transactionToClaim, args) {
	    return transactionToClaim.claim(args).then(function (transaction) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _TransactionConstants.ActionTypes.CLAIM_TRANSACTION,
	        transaction: transaction
	      });
	
	      return transaction;
	    });
	  },
	  refund: function refund(activityId, transactionId) {
	    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'requested_by_customer';
	
	    return _RemindAPI2.default.request('/payments/transactions/' + transactionId + '/refund', 'POST', { reason: reason }).then(function () {
	      return _ActivityActions2.default.getTransactions(activityId);
	    });
	  },
	  loadTransactions: function loadTransactions() {
	    return _Transactions2.default.load().then(function (transactions) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _TransactionConstants.ActionTypes.LOAD_TRANSACTIONS,
	        transactions: transactions
	      });
	
	      return transactions;
	    });
	  },
	  createWithdrawTransaction: function createWithdrawTransaction(activityId, accountId, amount) {
	    return _Transaction2.default.createWithdrawTransaction(activityId, accountId, amount).then(function (transaction) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _TransactionConstants.ActionTypes.CREATE_ACTIVITY_WITHDRAW_TRANSACTION,
	        activityId: activityId,
	        transaction: transaction
	      });
	
	      return transaction;
	    });
	  },
	  pay: function pay() {
	    return _Transaction2.default.createPayment.apply(_Transaction2.default, arguments).then(function (transaction) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _TransactionConstants.ActionTypes.CREATE_TRANSACTION,
	        transaction: transaction
	      });
	
	      return transaction;
	    });
	  }
	};
	
	exports.default = TransactionActions;

/***/ },
/* 1998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	
	exports.default = withoutPaymentHeader;
	
	var _PaymentHeaderActions = __webpack_require__(1981);
	
	var _PaymentHeaderActions2 = _interopRequireDefault(_PaymentHeaderActions);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This component wraps a component within one of the payments routes to
	 * allow the navigation components in the upper right of the PaymentHeader
	 * to be hidden while the component is mounted.
	 *
	 * e.g.
	 *
	 * var CardView = React.createClass({
	 *   render() {
	 *     return <CardInput />;
	 *   }
	 * });
	 *
	 * export default withoutPaymentHeader(CardView);
	 */
	function withoutPaymentHeader(Component) {
	  var wrapper = _react2.default.createClass({
	    displayName: 'wrapper',
	    componentDidMount: function componentDidMount() {
	      _PaymentHeaderActions2.default.hideNavigation();
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      _PaymentHeaderActions2.default.showNavigation();
	    },
	    render: function render() {
	      return _react2.default.createElement(Component, _extends({}, this.props, this.state));
	    }
	  });
	
	  return wrapper;
	}

/***/ },
/* 1999 */
1136,
/* 2000 */,
/* 2001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _EventTrackingConstants = __webpack_require__(1745);
	
	var _EventTrackingConstants2 = _interopRequireDefault(_EventTrackingConstants);
	
	var _trackView = __webpack_require__(1950);
	
	var _trackView2 = _interopRequireDefault(_trackView);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _Transaction = __webpack_require__(982);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _TransactionActions = __webpack_require__(1997);
	
	var _TransactionActions2 = _interopRequireDefault(_TransactionActions);
	
	var _withoutPaymentHeader = __webpack_require__(1998);
	
	var _withoutPaymentHeader2 = _interopRequireDefault(_withoutPaymentHeader);
	
	var _isEmail = __webpack_require__(1458);
	
	var _isEmail2 = _interopRequireDefault(_isEmail);
	
	var _isPhone = __webpack_require__(1459);
	
	var _isPhone2 = _interopRequireDefault(_isPhone);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _createGoogleCalLink = __webpack_require__(1936);
	
	var _PaymentViewConfirmationEmailAuthentificator = __webpack_require__(2002);
	
	var _PaymentViewConfirmationEmailAuthentificator2 = _interopRequireDefault(_PaymentViewConfirmationEmailAuthentificator);
	
	var _PaymentViewConfirmationPhoneAuthentificator = __webpack_require__(2006);
	
	var _PaymentViewConfirmationPhoneAuthentificator2 = _interopRequireDefault(_PaymentViewConfirmationPhoneAuthentificator);
	
	var _GoogleSignIn = __webpack_require__(1706);
	
	var _GoogleSignIn2 = _interopRequireDefault(_GoogleSignIn);
	
	var _DividerText = __webpack_require__(1234);
	
	var _DividerText2 = _interopRequireDefault(_DividerText);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(2009);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentViewConfirmation = _react2.default.createClass({
	  displayName: 'PaymentViewConfirmation',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired,
	    isModal: _react2.default.PropTypes.bool.isRequired,
	    onRequestHide: _react2.default.PropTypes.func
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      submittedPassword: false,
	      loading: false
	    };
	  },
	  onAuthSuccess: function onAuthSuccess() {
	    var _this = this;
	
	    var promise = void 0;
	
	    // If there's a transaction (paid activity) then claim the
	    // transaction and the recipient thought it, otherwise just
	    // claim the recipient.
	    if (this.props.transaction) {
	      promise = _TransactionActions2.default.claim(this.props.transaction, {
	        recipient_uuid: this.props.recipient.id
	      });
	    } else {
	      promise = this.props.recipient.claim(this.props.activity);
	    }
	
	    promise.then(function () {
	      return _this.setState({ submittedPassword: true });
	    }).catch(function (err) {
	      _ToastActions2.default.showAPIError(err);
	      console.log(err); // track in trackjs
	    });
	  },
	  getEventAuthStatus: function getEventAuthStatus() {
	    var authStatus = void 0;
	
	    if (_CurrentUser2.default.isSignedIn()) {
	      authStatus = 'logged_in_user';
	    } else {
	      authStatus = this.props.recipient.getUserUuid() ? 'unauthed_user' : 'new_user';
	    }
	
	    return authStatus;
	  },
	  renderAuthenticationForm: function renderAuthenticationForm() {
	    var authentificator = void 0;
	
	    if ((0, _isPhone2.default)(this.props.recipient.getAddress())) {
	      authentificator = _react2.default.createElement(_PaymentViewConfirmationPhoneAuthentificator2.default, {
	        recipient: this.props.recipient,
	        onAuthSuccess: this.onAuthSuccess
	      });
	    }
	
	    if ((0, _isEmail2.default)(this.props.recipient.getAddress())) {
	      authentificator = _react2.default.createElement(_PaymentViewConfirmationEmailAuthentificator2.default, {
	        recipient: this.props.recipient,
	        onAuthSuccess: this.onAuthSuccess,
	        authStatus: this.getEventAuthStatus()
	      });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      authentificator,
	      _react2.default.createElement(_DividerText2.default, { text: 'or', uppercase: true, className: 'PaymentViewConfirmation-divider' }),
	      _react2.default.createElement(_GoogleSignIn2.default, { onSuccess: this.onAuthSuccess })
	    );
	  },
	  renderConfirmationButtons: function renderConfirmationButtons() {
	    var chatUuid = this.props.activity.getChatUuid();
	
	    var href = chatUuid ? '/chat/' + chatUuid : '/classes';
	
	    var props = {};
	
	    if (this.context.isModal && this.context.onRequestHide) {
	      props = {
	        onClick: this.context.onRequestHide,
	        children: 'Close'
	      };
	    } else {
	      /* href, full page reload
	       * to have mobile clients able
	       * to respond to the url change.
	       */
	      props = {
	        href: href,
	        children: chatUuid ? 'Join conversation' : 'Go to Remind'
	      };
	    }
	
	    return _react2.default.createElement(_Button2.default, _extends({
	      level: 'primary'
	    }, props, {
	      className: 'PaymentViewConfirmation-button',
	      eventScreenName: _EventTrackingConstants2.default.PAYMENT_RECEIPT,
	      eventElementName: 'back_to_remind'
	    }));
	  },
	  renderGoogleCalUrl: function renderGoogleCalUrl() {
	    var activity = this.props.activity;
	
	    var date = activity.getStartAt();
	    var title = activity.getTitle();
	    var welcomeMsgBody = activity.getWelcomeMsgBody();
	    var location = activity.getLocation();
	    var googleCalendarUrl = date ? (0, _createGoogleCalLink.buildGoogleCalendarUrl)(title, date, welcomeMsgBody, location) : null;
	
	    return googleCalendarUrl ? _react2.default.createElement(
	      'div',
	      { className: 'PaymentViewConfirmation-link' },
	      _react2.default.createElement(
	        _Link2.default,
	        { target: '_blank', href: googleCalendarUrl },
	        _react2.default.createElement(
	          _Text2.default,
	          { size: 'xsmall' },
	          'Add to Google Calendar'
	        )
	      )
	    ) : _react2.default.createElement('span', null);
	  },
	  render: function render() {
	    var content = _CurrentUser2.default.isSignedIn() || this.state.submittedPassword ? this.renderConfirmationButtons() : this.renderAuthenticationForm();
	
	    var attendanceText = void 0;
	
	    if (this.props.recipient.getAttendance() === _ActivityRecipient.RECIPIENT_ATTENDING) {
	      attendanceText = 'You’ve responded Yes!';
	    } else if (this.props.recipient.getAttendance() === _ActivityRecipient.RECIPIENT_MAYBE) {
	      attendanceText = 'You’ve responded Maybe';
	    } else if (this.props.recipient.getAttendance() === _ActivityRecipient.RECIPIENT_DECLINED) {
	      attendanceText = 'You’ve responded No';
	    }
	
	    var name = this.props.activity.getRequester().getDisplayName();
	    var subtext = _react2.default.createElement(
	      _Text2.default,
	      { size: 'xsmall' },
	      'Your response has been sent to ',
	      name,
	      '. If you need to change your response, you can always update this page.'
	    );
	    return _react2.default.createElement(
	      'div',
	      { className: 'PaymentViewConfirmation', 'data-test-selector': 'payment_view_confirmation' },
	      _react2.default.createElement(_TitleHeader2.default, {
	        title: attendanceText,
	        subtext: subtext,
	        bottomMargin: 'none',
	        textAlign: 'center',
	        size: 'xlarge'
	      }),
	      this.renderGoogleCalUrl(),
	      _react2.default.createElement('div', { className: 'PaymentViewConfirmation-separator' }),
	      content
	    );
	  }
	});
	
	exports.default = (0, _trackView2.default)((0, _withoutPaymentHeader2.default)(PaymentViewConfirmation), _EventTrackingConstants2.default.PAYMENT_RECEIPT);

/***/ },
/* 2002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _EventTrackingConstants = __webpack_require__(1745);
	
	var _EventTrackingConstants2 = _interopRequireDefault(_EventTrackingConstants);
	
	var _FocusEventTrigger = __webpack_require__(1746);
	
	var _FocusEventTrigger2 = _interopRequireDefault(_FocusEventTrigger);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _humanparser = __webpack_require__(2003);
	
	var _humanparser2 = _interopRequireDefault(_humanparser);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	__webpack_require__(2004);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var PaymentViewConfirmationEmailAuthentificator = function (_Component) {
	  _inherits(PaymentViewConfirmationEmailAuthentificator, _Component);
	
	  function PaymentViewConfirmationEmailAuthentificator() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PaymentViewConfirmationEmailAuthentificator);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentViewConfirmationEmailAuthentificator.__proto__ || Object.getPrototypeOf(PaymentViewConfirmationEmailAuthentificator)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loadingUserProfile: true,
	      loading: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PaymentViewConfirmationEmailAuthentificator, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var onSuccess = function onSuccess(userProfile) {
	        _this2.setState({ userProfile: userProfile, loadingUserProfile: false });
	      };
	
	      var onFail = function onFail() {
	        _this2.setState({ loadingUserProfile: false });
	      };
	
	      _User2.default.loadProfile({ user_identifier: this.props.recipient.getAddress() }).then(onSuccess, onFail);
	    }
	  }, {
	    key: 'canSignInWithPassword',
	    value: function canSignInWithPassword(profile) {
	      return profile && !profile.needs.password;
	    }
	  }, {
	    key: 'handleCreateAccount',
	    value: function handleCreateAccount(data) {
	      var email = this.props.recipient.getAddress();
	      var human = _humanparser2.default.parseName(this.props.recipient.getName());
	      var userData = {
	        email: email,
	        password: data.password,
	        first_name: human.firstName,
	        last_name: human.lastName,
	        role: '' };
	
	      var onFailure = function onFailure(err) {
	        return _ToastActions2.default.showAPIError(err);
	      };
	
	      return _UserActions2.default.create(userData).then(this.props.onAuthSuccess, onFailure);
	    }
	  }, {
	    key: 'handleSignIn',
	    value: function handleSignIn(data) {
	      return _AuthActions2.default.signIn(this.props.recipient.getAddress(), data.password).then(this.props.onAuthSuccess, function () {
	        _ToastActions2.default.showErrorToast('Invalid email address or password.');
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (this.state.loadingUserProfile) {
	        return _react2.default.createElement(_LoadingIndicator2.default, null);
	      }
	
	      var field = 'Create a password to complete your account';
	      var placeholder = 'New password';
	      var buttonText = 'Sign up';
	      var buttonElementName = 'sign_up';
	      var inputElementName = 'add_password';
	      var handleSubmit = this.handleCreateAccount.bind(this);
	
	      if (this.canSignInWithPassword(this.state.userProfile)) {
	        field = 'Enter your Remind password to sign in';
	        placeholder = 'Enter your Remind password';
	        buttonText = 'Log in';
	        buttonElementName = 'log_in';
	        inputElementName = 'enter_password';
	        handleSubmit = this.handleSignIn.bind(this);
	      }
	
	      var submitWrapper = function submitWrapper(data) {
	        _this3.setState({ loading: true });
	
	        handleSubmit(data).then(function () {
	          return _this3.setState({ loading: false });
	        }, function () {
	          return _this3.setState({ loading: false });
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('PaymentViewConfirmationEmailAuthentificator', this.props.className) },
	        _react2.default.createElement(
	          _Form2.default,
	          { onSubmit: submitWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: 'PaymentViewConfirmationEmailAuthentificator-form-field' },
	            _react2.default.createElement(
	              _Text2.default,
	              { weight: 'bold' },
	              field
	            )
	          ),
	          _react2.default.createElement(
	            _FocusEventTrigger2.default,
	            {
	              eventScreenName: _EventTrackingConstants2.default.PAYMENT_RECEIPT,
	              eventElementName: inputElementName,
	              trackChildComponents: true },
	            _react2.default.createElement(_FormInput2.default, {
	              type: 'password',
	              autoComplete: 'current-password',
	              name: 'password',
	              autofocus: true,
	              placeholder: placeholder,
	              required: true,
	              size: 'large',
	              validations: 'minLength:1'
	            })
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              type: 'submit',
	              level: 'primary',
	              loading: this.state.loading,
	              eventScreenName: _EventTrackingConstants2.default.PAYMENT_RECEIPT,
	              className: 'PaymentViewConfirmationEmailAuthentificator-button',
	              eventElementName: buttonElementName },
	            buttonText
	          )
	        )
	      );
	    }
	  }]);
	
	  return PaymentViewConfirmationEmailAuthentificator;
	}(_react.Component);
	
	PaymentViewConfirmationEmailAuthentificator.displayName = 'PaymentViewConfirmationEmailAuthentificator';
	exports.default = PaymentViewConfirmationEmailAuthentificator;

/***/ },
/* 2003 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(555);
	
	var parser = module.exports = {};
	
	parser.parseName = function (name) {
	    var salutations = ['mr', 'master', 'mister', 'mrs', 'miss', 'ms', 'dr', 'prof', 'rev', 'fr', 'judge', 'honorable', 'hon']
	        , suffixes = ['i', 'ii', 'iii', 'iv', 'v', 'senior', 'junior', 'jr', 'sr', 'phd', 'apr', 'rph', 'pe', 'md', 'ma', 'dmd', 'cme']
	        , compound = ['vere', 'von', 'van', 'de', 'del', 'della', 'der', 'di', 'da', 'pietro', 'vanden', 'du', 'st.', 'st', 'la', 'lo', 'ter', 'bin', 'ibn'];
	
	    var parts = name.trim().split(/\s+/)
	        , attrs = {};
	
	    if (!parts.length) {
	        return attrs;
	    }
	
	    if ( parts.length === 1 ) {
	        attrs.firstName = parts[0];
	    }
	
	    if ( parts.length > 1 && _.indexOf(salutations, _.first(parts).toLowerCase().replace(/\./g, '')) > -1) {
	        attrs.salutation = parts.shift();
	        attrs.firstName = parts.shift();
	    } else {
	        attrs.firstName = parts.shift();
	    }
	
	    if ( parts.length > 1 && _.indexOf(suffixes, _.last(parts).toLowerCase().replace(/\./g, '')) > -1) {
	        attrs.suffix = parts.pop();
	        attrs.lastName = parts.pop();
	    } else {
	        attrs.lastName = parts.pop();
	    }
	
	    // test for compound last name, we reverse because middle name is last bit to be defined.
	    // We already know lastname, so check next word if its part of a compound last name.
	    var revParts = parts.reverse()
	        , compoundParts = [];
	
	    _.every(revParts, function(part, i, all){
	        var test = part.toLowerCase().replace(/\./g, '');
	
	        if (_.indexOf(compound, test) > -1 ) {
	            compoundParts.push(part);
	
	            return true;
	        }
	
	        //break on first non compound word
	        return false;
	    });
	
	    //join compound parts with known last name
	    if ( compoundParts.length ) {
	        attrs.lastName = compoundParts.reverse().join(' ') + ' ' + attrs.lastName;
	
	        parts = _.difference(parts, compoundParts);
	    }
	
	    if ( parts.length ) {
	        attrs.middleName = parts.join(' ');
	    }
	
	    //remove comma like "<lastName>, Jr."
	    if ( attrs.lastName ) {
	        attrs.lastName = attrs.lastName.replace(',', '');
	    }
	
	    //save a copy of original
	    attrs.fullName = name;
	
	    //console.log('attrs:', JSON.stringify(attrs));
	    return attrs;
	};
	
	parser.getFullestName = function(str){
	    var name = str
	        , names = [];
	
	    //find fullname from strings like 'Jon and Sue Doyle'
	    if ( name.indexOf('&') > -1 || name.toLowerCase().indexOf(' and ') > -1 ) {
	        names = name.split(/\s+(?:and|&)\s+/gi);
	
	        //pluck the name with the most parts (first, middle, last) from the array.
	        //will grab 'Sue Doyle' in 'Jon & Sue Anne Doyle'
	        if ( names.length ) {
	            name = names.sort(function(a, b) {
	                return b.split(/\s+/).length - a.split(/\s+/).length;
	            })[0];
	        }
	    }
	
	    return name;
	};
	
	parser.parseAddress = function(str){
	    //416 W. Manchester Blvd., Inglewood, CA  90301
	    var parts = str.split(/,\s+/).reverse()
	        , stateZip
	        , city
	        , address = {};
	
	    stateZip = parts[0].split(/\s+/);
	    parts.shift();
	
	    city = parts.shift();
	
	    address.address = parts.reverse().join(', ');
	    address.city = city;
	    address.state = stateZip[0];
	    address.zip = stateZip[1];
	    address.fullAddress = str;
	
	    return address;
	};


/***/ },
/* 2004 */
1136,
/* 2005 */,
/* 2006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Device = __webpack_require__(1016);
	
	var _Device2 = _interopRequireDefault(_Device);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _humanparser = __webpack_require__(2003);
	
	var _humanparser2 = _interopRequireDefault(_humanparser);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__(2007);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentViewConfirmationPhoneAuthentificator = function (_React$Component) {
	  _inherits(PaymentViewConfirmationPhoneAuthentificator, _React$Component);
	
	  function PaymentViewConfirmationPhoneAuthentificator() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PaymentViewConfirmationPhoneAuthentificator);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentViewConfirmationPhoneAuthentificator.__proto__ || Object.getPrototypeOf(PaymentViewConfirmationPhoneAuthentificator)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loadingUserProfile: true,
	      startCodeSignin: false,
	      codeFormValid: false,
	      userProfile: null,
	      loading: false
	    }, _this.componentDidMount = function () {
	      _User2.default.loadProfile({ user_identifier: _this.props.recipient.getAddress() }).then(function (userProfile) {
	        return _this.setState({ userProfile: userProfile, loadingUserProfile: false });
	      }).catch(function () {
	        return _this.setState({ loadingUserProfile: false });
	      });
	    }, _this.onCodeSigninStart = function () {
	      _this.setState({ startCodeSignin: true });
	      _this.refreshDeviceOutboundVerificationToken();
	    }, _this.refreshDeviceOutboundVerificationToken = function () {
	      // $FlowFixMe
	      _Device2.default.outboundVerify(_this.props.recipient.getAddress()).then(function (response) {
	        return _this.setState({ token: response.token });
	      }).then(function () {
	        return _ToastActions2.default.showSuccessToast('A verification code was send to the mobile phone');
	      });
	    }, _this.canSignInWithPassword = function (profile) {
	      return profile && !profile.needs.password;
	    }, _this.handleSignIn = function (data) {
	      _this.setState({ loading: true });
	
	      var address = _this.props.recipient.getAddress();
	
	      (0, _invariant2.default)(address, 'recipient has no address, can‘t sign in');
	
	      return _AuthActions2.default.signIn(address, data.password).then(_this.props.onAuthSuccess).catch(_ToastActions2.default.showAPIError).then(function () {
	        return _this.setState({ loading: false });
	      });
	    }, _this.handleCodeSubmit = function (values) {
	      var updateUser = function updateUser() {
	        var human = _humanparser2.default.parseName(_this.props.recipient.getName());
	
	        return _User2.default.update({
	          first_name: human.firstName,
	          last_name: human.lastName,
	          password: values.password,
	          role: ''
	        });
	      };
	
	      _this.setState({ loading: true });
	      // $FlowFixMe
	      _Device2.default.createOutboundDevice(_this.state.token, values.code).then(function (_ref2) {
	        var token = _ref2.token;
	        return _AuthActions2.default.accessTokenSignIn(token).then(updateUser).then(function () {
	          return _AuthActions2.default.accessTokenSignIn(token);
	        });
	      }).then(_this.props.onAuthSuccess).catch(_ToastActions2.default.showAPIError).then(function () {
	        return _this.setState({ loading: false });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /* Load the user profile
	   * This user profile is what help us determine
	   * is the user already has a password or if the user
	   * need to create a brand new account using sms verification code.
	   */
	
	
	  /* refreshed the verification token, this is the code send the the API
	   * with the user code that he inputed in the form. This function is call
	   * when the user start the verification process or when he clicks the
	   * "send again" button in the form.
	   */
	
	
	  /* Handle the form submit for when the user profile
	   * told us that the user already had a password.
	   */
	
	
	  /* Handle the form submit for when the user profile
	   * told us that the user already did not have a password
	   * and needed to undergo the device verification signup.
	   */
	
	
	  _createClass(PaymentViewConfirmationPhoneAuthentificator, [{
	    key: 'renderPasswordSignIn',
	    value: function renderPasswordSignIn() {
	      return _react2.default.createElement(
	        _Form2.default,
	        { onSubmit: this.handleSignIn },
	        _react2.default.createElement(
	          'div',
	          { className: 'PaymentViewConfirmationEmailAuthentificator-form-field' },
	          _react2.default.createElement(
	            _Text2.default,
	            { weight: 'bold' },
	            'Enter your Remind password to sign in'
	          )
	        ),
	        _react2.default.createElement(_FormInput2.default, {
	          type: 'password',
	          name: 'password',
	          autoComplete: 'current-password',
	          autofocus: true,
	          placeholder: 'Enter your Remind password',
	          required: true,
	          size: 'large',
	          validations: 'minLength:1'
	        }),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            type: 'submit',
	            level: 'primary',
	            loading: this.state.loading,
	            className: 'PaymentViewConfirmationEmailAuthentificator-button',
	            eventElementName: 'PaymentViewConfirmationEmailAuthentificator-button' },
	          'Log in'
	        )
	      );
	    }
	  }, {
	    key: 'renderCodeSignIn',
	    value: function renderCodeSignIn() {
	      var _this2 = this;
	
	      if (!this.state.startCodeSignin) {
	        return _react2.default.createElement(
	          _Button2.default,
	          {
	            full: true,
	            type: 'submit',
	            level: 'secondary',
	            loading: this.state.loading,
	            onClick: this.onCodeSigninStart,
	            className: 'PaymentViewConfirmationPhoneAuthentificator-button',
	            eventElementName: 'PaymentViewConfirmationPhoneAuthentificator-button' },
	          'Signup on remind using your phone'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Form2.default,
	        {
	          onSubmit: this.handleCodeSubmit,
	          onValid: function onValid() {
	            return _this2.setState({ codeFormValid: true });
	          },
	          onInvalid: function onInvalid() {
	            return _this2.setState({ codeFormValid: false });
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'PaymentViewConfirmationPhoneAuthentificator-form-field' },
	          _react2.default.createElement(
	            _Text2.default,
	            { weight: 'bold' },
	            'Enter the code received on your phone.'
	          ),
	          ' ',
	          _react2.default.createElement(
	            _Link2.default,
	            { onClick: this.refreshDeviceOutboundVerificationToken },
	            'Resend Code'
	          )
	        ),
	        _react2.default.createElement(_FormInput2.default, {
	          required: true,
	          type: 'text',
	          name: 'code',
	          size: 'large',
	          placeholder: 'Enter the 4 digit code',
	          validations: 'minLength:1'
	        }),
	        _react2.default.createElement(_FormInput2.default, {
	          required: true,
	          size: 'large',
	          type: 'password',
	          name: 'password',
	          autoComplete: 'new-password',
	          validations: 'minLength:6',
	          validOnPristine: false,
	          placeholder: 'New password for your account',
	          validationError: 'Password must be at least 6 characters long.'
	        }),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            type: 'submit',
	            level: 'primary',
	            disabled: !this.state.codeFormValid,
	            loading: this.state.loading,
	            className: 'PaymentViewConfirmationPhoneAuthentificator-button',
	            eventElementName: 'PaymentViewConfirmationPhoneAuthentificator-button' },
	          'continue'
	        )
	      );
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      if (this.state.loadingUserProfile) {
	        return _react2.default.createElement(_LoadingIndicator2.default, null);
	      }
	
	      if (!this.state.userProfile || this.canSignInWithPassword(this.state.userProfile)) {
	        return this.renderPasswordSignIn();
	      }
	
	      return this.renderCodeSignIn();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('PaymentViewConfirmationPhoneAuthentificator', this.props.className) },
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return PaymentViewConfirmationPhoneAuthentificator;
	}(_react2.default.Component);
	
	PaymentViewConfirmationPhoneAuthentificator.displayName = 'PaymentViewConfirmationPhoneAuthentificator';
	exports.default = PaymentViewConfirmationPhoneAuthentificator;

/***/ },
/* 2007 */
1136,
/* 2008 */,
/* 2009 */
1136,
/* 2010 */,
/* 2011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _ActivityBlockedView = __webpack_require__(2012);
	
	var _ActivityBlockedView2 = _interopRequireDefault(_ActivityBlockedView);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityBlockedViewContainer = function (_React$Component) {
	  _inherits(ActivityBlockedViewContainer, _React$Component);
	
	  function ActivityBlockedViewContainer() {
	    _classCallCheck(this, ActivityBlockedViewContainer);
	
	    return _possibleConstructorReturn(this, (ActivityBlockedViewContainer.__proto__ || Object.getPrototypeOf(ActivityBlockedViewContainer)).apply(this, arguments));
	  }
	
	  _createClass(ActivityBlockedViewContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ActivityBlockedView2.default, {
	        title: this.props.title,
	        subtext: this.props.subtext,
	        isSignedIn: this.state.isSignedIn
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        isSignedIn: _CurrentUser2.default.isSignedIn()
	      };
	    }
	  }]);
	
	  return ActivityBlockedViewContainer;
	}(_react2.default.Component);
	
	ActivityBlockedViewContainer.displayName = 'ActivityBlockedViewContainer';
	exports.default = _utils.Container.create(ActivityBlockedViewContainer, { withProps: true });

/***/ },
/* 2012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	__webpack_require__(2013);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ActivityBlockedView(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'ActivityBlockedView' },
	    _react2.default.createElement(_TitleHeader2.default, {
	      subtle: true,
	      size: 'xlarge',
	      title: props.title,
	      subtext: props.subtext
	    }),
	    props.isSignedIn ? _react2.default.createElement(
	      _Button2.default,
	      { href: '/classes' },
	      'Continue to Remind'
	    ) : _react2.default.createElement(
	      _Button2.default,
	      { href: '/log_in' },
	      'Log in'
	    )
	  );
	}
	
	exports.default = ActivityBlockedView;

/***/ },
/* 2013 */
1136,
/* 2014 */,
/* 2015 */
1136,
/* 2016 */,
/* 2017 */
1136,
/* 2018 */,
/* 2019 */
1136,
/* 2020 */,
/* 2021 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Overlay = __webpack_require__(2023);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	__webpack_require__(2026);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// typecheck: ignore file
	function OverlayLoading() {
	  return _react2.default.createElement(
	    _Overlay2.default,
	    { className: 'OverlayLoading' },
	    _react2.default.createElement(_Glyph2.default, { name: 'gear', size: 'xxxlarge' })
	  );
	}
	
	exports.default = OverlayLoading;

/***/ },
/* 2023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2024);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Overlay(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('Overlay', props.className) },
	    props.children
	  );
	}
	// typecheck: ignore file
	exports.default = Overlay;

/***/ },
/* 2024 */
1136,
/* 2025 */,
/* 2026 */
1136,
/* 2027 */,
/* 2028 */
1136,
/* 2029 */,
/* 2030 */
1136,
/* 2031 */,
/* 2032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PANELS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(956);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _GroupMessageStarter = __webpack_require__(2033);
	
	var _GroupMessageStarter2 = _interopRequireDefault(_GroupMessageStarter);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _IndividualMessageStarter = __webpack_require__(2042);
	
	var _IndividualMessageStarter2 = _interopRequireDefault(_IndividualMessageStarter);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _MessageStore = __webpack_require__(1232);
	
	var _MessageStore2 = _interopRequireDefault(_MessageStore);
	
	var _RoleBasedMessagingComposer = __webpack_require__(2043);
	
	var _RoleBasedMessagingComposer2 = _interopRequireDefault(_RoleBasedMessagingComposer);
	
	var _Spacing = __webpack_require__(2037);
	
	var _Spacing2 = _interopRequireDefault(_Spacing);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _getDefaultGroups = __webpack_require__(2104);
	
	var _prefillMessageWithGroupName = __webpack_require__(935);
	
	var _roleHelpers = __webpack_require__(1230);
	
	var _UniversalComposerTabView = __webpack_require__(2105);
	
	var _UniversalComposerTabView2 = _interopRequireDefault(_UniversalComposerTabView);
	
	var _UniversalComposer = __webpack_require__(2111);
	
	var _UniversalComposer2 = _interopRequireDefault(_UniversalComposer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var PANELS = exports.PANELS = (0, _enumerate2.default)(['CLASS_ANNOUCEMENT', 'GROUP_CONVERSATION', 'INDIVIDUAL_MESSAGE']);
	
	var UniversalComposer = function (_React$Component) {
	  _inherits(UniversalComposer, _React$Component);
	
	  function UniversalComposer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UniversalComposer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UniversalComposer.__proto__ || Object.getPrototypeOf(UniversalComposer)).call.apply(_ref, [this].concat(args))), _this), _this.handleMessageSent = function (targets) {
	      _this.props.onRequestHide();
	      if (_this.props.onMessageSent) {
	        _this.props.onMessageSent();
	      }
	      _this.handleAnnouncementSent(targets);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UniversalComposer, [{
	    key: 'getGroupCode',
	    value: function getGroupCode() {
	      var activity = this.props.activity;
	
	      if (this.context.router.params.groupCode) {
	        return this.context.router.params.groupCode;
	      }
	
	      if (activity) {
	        var groupSummaries = activity.getGroupSummaries();
	        if (groupSummaries.length > 0) {
	          return groupSummaries[0].name;
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getInitialAnnouncement',
	    value: function getInitialAnnouncement() {
	      var draftAnnouncement = this.state.draftAnnouncement;
	      var activity = this.props.activity;
	
	      // Unfinished message takes precedence
	
	      if (draftAnnouncement) {
	        return draftAnnouncement;
	      }
	
	      var groupCode = this.getGroupCode();
	
	      if (!groupCode) {
	        return null;
	      }
	
	      var groups = (0, _getDefaultGroups.getDefaultGroups)(groupCode);
	
	      var initialText = '';
	      // If we are routed to classes (aka. coming from the classes screen) and
	      // the class we came from has no existing messages, we will provide a prefilled
	      // message
	      // NOTE: Currently, groups will always be an array of size 0-1, where the one element
	      // is the class that we initiated the UniversalComposer from, so we can just check the
	      // message count of groups[0] to see if there are messages in the class.
	      // If this changes (ie. the implementation of getDefaultGroups changes),
	      // then we need to figure out the number of messages in a different way.
	      if (groups.length === 1 && _MessageStore2.default.getMessages(groups[0].id).isEmpty()) {
	        initialText = (0, _prefillMessageWithGroupName.prefillMessageWithGroupName)(groups[0].getName());
	      }
	
	      if (activity) {
	        initialText = 'Hey! I\u2019m using Remind to organize ' + activity.getTitle() + '. Please respond here --> ' + activity.getPayUrl();
	      }
	      var message = _Message2.default.createMessage(groups, initialText);
	
	      var group = _GroupStore2.default.getGroupForCode(groupCode);
	      (0, _invariant2.default)(group, 'missing group in getInitialAnnouncement');
	      var hasRecipients = message.getGroupIds().length || message.getTargets().length || message.getThreads().length;
	      if (!hasRecipients && group.getPostableRoles().includes(_roleHelpers.TEACHER)) {
	        message.set('targets', [{
	          role: _roleHelpers.TEACHER,
	          group_id: group.id
	        }]);
	      }
	
	      return message;
	    }
	  }, {
	    key: 'handleAnnouncementSent',
	    value: function handleAnnouncementSent(targets) {
	      var firstTarget = targets[0];
	      var group = _GroupStore2.default.getGroup(firstTarget.group_id);
	      (0, _invariant2.default)(group, 'missing group in handleAnnouncementSent');
	      var groupCode = group.getCode();
	      this.context.router.push('/classes/' + groupCode + '/messages/announcements/' + firstTarget.role);
	    }
	  }, {
	    key: 'getChatMembersLimit',
	    value: function getChatMembersLimit() {
	      var limit = _SettingsStore2.default.getChatMembersLimit();
	      try {
	        // WHY do we need this try?
	        limit = _CurrentUser2.default.getUser().getGroupChatMemberLimit();
	      } catch (e) {
	        console.warn('Could not fetch settings.chats.members.limit for user');
	      }
	
	      return limit - 1; // subtract one for yourself
	    }
	  }, {
	    key: 'renderAllPanels',
	    value: function renderAllPanels() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({}, this.props, {
	          className: (0, _classnames2.default)(_UniversalComposer2.default.this, this.props.className),
	          eventScreenName: 'UniversalComposer',
	          size: 'large' }),
	        _react2.default.createElement(
	          _UniversalComposerTabView2.default,
	          {
	            title: 'New message',
	            subtext: 'Choose the type of message you want to send.' },
	          this.props.canAnnounce && _react2.default.createElement(
	            _UniversalComposerTabView2.default.Panel,
	            {
	              className: _Spacing2.default.paddingHuge,
	              name: 'Class announcement',
	              glyphName: 'announcement',
	              glyphSize: 'xxlarge',
	              defaultSelected: true },
	            this.renderAnnouncementComposer()
	          ),
	          _react2.default.createElement(
	            _UniversalComposerTabView2.default.Panel,
	            {
	              className: _Spacing2.default.paddingHuge,
	              name: 'Group conversation',
	              glyphName: 'message-group',
	              glyphSize: 'xxlarge' },
	            this.renderGroupMessageStarter()
	          ),
	          _react2.default.createElement(
	            _UniversalComposerTabView2.default.Panel,
	            {
	              className: _Spacing2.default.paddingHuge,
	              name: 'Individual message',
	              glyphName: 'message-individual',
	              glyphSize: 'xxlarge',
	              defaultSelected: !this.props.canAnnounce },
	            this.renderIndividualMessageStarter()
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderGroupMessageStarter',
	    value: function renderGroupMessageStarter() {
	      return _react2.default.createElement(_GroupMessageStarter2.default, {
	        groupCode: this.getGroupCode() || undefined,
	        chatMembersLimit: this.getChatMembersLimit(),
	        onRequestHide: this.props.onRequestHide
	      });
	    }
	  }, {
	    key: 'renderIndividualMessageStarter',
	    value: function renderIndividualMessageStarter() {
	      return _react2.default.createElement(_IndividualMessageStarter2.default, {
	        groupCode: this.getGroupCode() || undefined,
	        onRequestHide: this.props.onRequestHide
	      });
	    }
	  }, {
	    key: 'renderAnnouncementComposer',
	    value: function renderAnnouncementComposer() {
	      return _react2.default.createElement(_RoleBasedMessagingComposer2.default, {
	        onRequestHide: this.props.onRequestHide,
	        initialMessage: this.getInitialAnnouncement(),
	        onMessageSent: this.handleMessageSent,
	        charLimit: _CurrentUser2.default.getUser().getAnnouncementCharactersLimit(),
	        charLimitWithFiles: _CurrentUser2.default.getUser().getAnnouncementCharactersLimitWithFiles()
	      });
	    }
	  }, {
	    key: 'renderPanel',
	    value: function renderPanel(panel) {
	      var content = void 0;
	      var title = void 0;
	      var subtext = void 0;
	
	      switch (panel) {
	        case PANELS.CLASS_ANNOUCEMENT:
	          title = 'Send a Class Announcement';
	          subtext = 'Keep everyone in the loop with class announcements. Schedule them ahead to save time.';
	          content = this.renderAnnouncementComposer();
	          break;
	        case PANELS.GROUP_CONVERSATION:
	          title = 'Create a Group Conversation';
	          subtext = 'Start the dialogue with up to ' + this.getChatMembersLimit() + ' other people\u2014everyone can participate in the conversation.';
	          content = this.renderGroupMessageStarter();
	          break;
	        case PANELS.INDIVIDUAL_MESSAGE:
	          title = 'Create an Individual Message';
	          subtext = 'Reach out to someone with questions or feedback.';
	          content = this.renderIndividualMessageStarter();
	          break;
	        default:
	          console.warn('unknow universal composer panel: ', panel);
	      }
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({}, this.props, { size: 'large', className: (0, _classnames2.default)(_UniversalComposer2.default.this, this.props.className), eventScreenName: 'UniversalComposer' }),
	        _react2.default.createElement(
	          'div',
	          { className: _UniversalComposer2.default.uniquePanelContent },
	          _react2.default.createElement(_TitleHeader2.default, { textAlign: 'left', title: title, subtext: subtext }),
	          content
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.panel ? this.renderPanel(this.props.panel) : this.renderAllPanels();
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_GroupStore2.default, _ChatStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        draftAnnouncement: _GroupStore2.default.getDraftAnnouncement()
	      };
	    }
	  }]);
	
	  return UniversalComposer;
	}(_react2.default.Component);
	
	UniversalComposer.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	UniversalComposer.displayName = 'UniversalComposer';
	exports.default = _utils.Container.create(UniversalComposer);

/***/ },
/* 2033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GroupMessageStarter = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatMembers = __webpack_require__(987);
	
	var _ChatMembers2 = _interopRequireDefault(_ChatMembers);
	
	var _ChatParticipantSearchMixin = __webpack_require__(2034);
	
	var _ChatParticipantSearchMixin2 = _interopRequireDefault(_ChatParticipantSearchMixin);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DeprecatedTokenizerTypeahead = __webpack_require__(1884);
	
	var _DeprecatedTokenizerTypeahead2 = _interopRequireDefault(_DeprecatedTokenizerTypeahead);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _getMatcher = __webpack_require__(1890);
	
	var _getMatcher2 = _interopRequireDefault(_getMatcher);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _PotentialChatMember = __webpack_require__(945);
	
	var _PotentialChatMember2 = _interopRequireDefault(_PotentialChatMember);
	
	var _ScrollableArea = __webpack_require__(1412);
	
	var _ScrollableArea2 = _interopRequireDefault(_ScrollableArea);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _UniversalComposerRecipientToken = __webpack_require__(1877);
	
	var _UniversalComposerRecipientToken2 = _interopRequireDefault(_UniversalComposerRecipientToken);
	
	var _ChatRouteHelper = __webpack_require__(1568);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _recentMessagesModal = __webpack_require__(1570);
	
	var _MessageStarterItem = __webpack_require__(2035);
	
	var _MessageStarterItem2 = _interopRequireDefault(_MessageStarterItem);
	
	var _MessageStarter = __webpack_require__(2040);
	
	var _MessageStarter2 = _interopRequireDefault(_MessageStarter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var GroupMessageStarter = exports.GroupMessageStarter = _react2.default.createClass({
	  displayName: 'GroupMessageStarter',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [
	  // TODO remove this mixin and convert to ES6 class
	  // Only blocker is scrollToBottom load handling
	  _ChatParticipantSearchMixin2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedMembers: []
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.fetchData('');
	  },
	
	
	  // required by ChatParticipantSearchMixin
	  _scrollableArea: null,
	
	  getFilter: function getFilter(query) {
	    var matcher = (0, _getMatcher2.default)(query);
	    return function (member) {
	      return matcher([member.getName(), member.getFirstName(), member.getLastName(), member.getNote(), member.getGroupNames()]);
	    };
	  },
	  fetchData: function fetchData(query) {
	    return _ChatActions2.default.promisePotentialChatMembers(query).then(function () {
	      return _ChatStore2.default.getEligibleMemberModels();
	    });
	  },
	  handleSelectionChange: function handleSelectionChange(selectedMembers) {
	    this.setState({ selectedMembers: selectedMembers });
	  },
	  createLocalChat: function createLocalChat(originIds) {
	    var currentMember = _ChatMembers2.default.buildChatMember(_CurrentUser2.default.getUser());
	    var members = [currentMember].concat(this.state.selectedMembers);
	    var title = '';
	
	    _ChatActions2.default.loadLocal(members, title, originIds);
	    _ChatActions2.default.resetSelection(); // deselect current chat to focus on local
	  },
	  startConversation: function startConversation() {
	    var _this = this;
	
	    var selectedMembers = this.state.selectedMembers;
	
	    var group = this.props.groupCode ? _GroupStore2.default.getGroupForCode(this.props.groupCode) : null;
	
	    // if we are starting a 1 to 1 chat:
	    if (selectedMembers.length === 1) {
	      (0, _ChatRouteHelper.pushRouterToChatWithMember)(this.context.router, this.props.showRecent, this.props.hideRecent, selectedMembers[0], group);
	      if (this.props.onRequestHide) {
	        this.props.onRequestHide();
	      }
	      return;
	    }
	
	    // if we are starting a group chat:
	    // Timeout to prevent multiple dispatches at the same time
	    setTimeout(function () {
	      // Create chat in whatever group is open at the time
	      var _ref = group ? [group.getCode(), [group.id]] : ['r', []],
	          _ref2 = _slicedToArray(_ref, 2),
	          groupCode = _ref2[0],
	          originIds = _ref2[1];
	
	      var conversationPath = '/classes/' + groupCode + '/messages/new';
	      _this.createLocalChat(originIds);
	      _this.context.router.replace(conversationPath);
	    }, 0);
	  },
	  isAtChatMembersLimit: function isAtChatMembersLimit() {
	    var selectedMembers = this.state.selectedMembers;
	
	    return selectedMembers.length === this.props.chatMembersLimit;
	  },
	  isOverChatMembersLimit: function isOverChatMembersLimit() {
	    var selectedMembers = this.state.selectedMembers;
	
	    return selectedMembers.length > this.props.chatMembersLimit;
	  },
	  renderActionButton: function renderActionButton() {
	    return _react2.default.createElement(
	      _Button2.default,
	      {
	        disabled: this.state.selectedMembers.length === 0,
	        className: _MessageStarter2.default.actionButton,
	        onClick: this.startConversation },
	      'Go'
	    );
	  },
	  renderInputToken: function renderInputToken(member) {
	    var user = member.getUser();
	    return _react2.default.createElement(
	      _UniversalComposerRecipientToken2.default,
	      null,
	      _react2.default.createElement(_Avatar2.default, {
	        text: user.getInitials(),
	        colorHex: user.getColor(),
	        size: 'xsmall'
	      }),
	      member.getName()
	    );
	  },
	  renderParticipantRemainingCount: function renderParticipantRemainingCount() {
	    var selectedMembers = this.state.selectedMembers;
	
	    if (selectedMembers.length === 0) {
	      return null;
	    }
	
	    var chatMembersLimit = this.props.chatMembersLimit;
	    var remainingCount = chatMembersLimit - selectedMembers.length;
	    var text = 'You can add ' + remainingCount + ' more people';
	    if (this.isOverChatMembersLimit()) {
	      text = 'You have exceeded the maximum number of participants';
	    } else if (this.isAtChatMembersLimit()) {
	      text = 'You have reached the maximum number of participants';
	    } else if (remainingCount === 1) {
	      text = 'You can add 1 more person';
	    }
	
	    return _react2.default.createElement(
	      _Text2.default,
	      { color: this.isOverChatMembersLimit() ? 'lava' : 'koala', size: 'xxsmall' },
	      text
	    );
	  },
	  renderMember: function renderMember(member, highlighted, query, onSelect) {
	    return _react2.default.createElement(
	      'li',
	      {
	        onClick: function onClick() {
	          return onSelect();
	        },
	        key: member.id },
	      _react2.default.createElement(_MessageStarterItem2.default, {
	        className: (0, _classnames2.default)(_defineProperty({}, _MessageStarter2.default.highlightedItem, highlighted)),
	        member: member,
	        query: query,
	        selectable: this.state.selectedMembers.length > 0,
	        selected: this.state.selectedMembers.includes(member)
	      })
	    );
	  },
	  renderList: function renderList(items, loading) {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.renderParticipantRemainingCount(),
	      _react2.default.createElement(
	        _ScrollableArea2.default
	        // required by ChatParticipantSearchMixin
	        ,
	        { ref: function ref(c) {
	            return _this2._scrollableArea = c;
	          },
	          className: _MessageStarter2.default.scrollArea,
	          onScroll: function onScroll(event) {
	            return _this2.handleScroll(event);
	          } },
	        _react2.default.createElement(
	          'ul',
	          { className: _MessageStarter2.default.results },
	          items
	        ),
	        loading && _react2.default.createElement(
	          'div',
	          { className: _MessageStarter2.default.loadingIndicatorContainer },
	          _react2.default.createElement(_LoadingIndicator2.default, null)
	        )
	      )
	    );
	  },
	  renderNoResults: function renderNoResults(query) {
	    return _react2.default.createElement(
	      'li',
	      { className: _MessageStarter2.default.noResults, key: 'noResults' },
	      _react2.default.createElement(
	        _Text2.default,
	        { color: 'pitch', size: 'xsmall', weight: 'semibold' },
	        'No people found for "',
	        query,
	        '"'
	      )
	    );
	  },
	  render: function render() {
	    var actionButton = _react2.default.createElement(
	      _Button2.default,
	      {
	        'data-test-selector': 'start_group_chat_button',
	        disabled: this.state.selectedMembers.length === 0 || this.isOverChatMembersLimit(),
	        className: _MessageStarter2.default.actionButton,
	        onClick: this.startConversation },
	      'Go'
	    );
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_MessageStarter2.default.this, this.props.className) },
	      _react2.default.createElement(_DeprecatedTokenizerTypeahead2.default, {
	        prompt: 'To:',
	        placeholder: 'Select or search for people',
	        value: this.state.selectedMembers || '',
	        onChange: this.handleSelectionChange,
	        dataSource: this.fetchData,
	        dataFilterFactory: this.getFilter,
	        listRenderer: this.renderList,
	        itemRenderer: this.renderMember,
	        tokenRenderer: this.renderInputToken,
	        noResultsRenderer: this.renderNoResults,
	        actionButton: actionButton,
	        autoFocus: true,
	        inline: true
	      })
	    );
	  }
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    showRecent: _recentMessagesModal.showRecent,
	    hideRecent: _recentMessagesModal.hideRecent
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(GroupMessageStarter);

/***/ },
/* 2034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(555);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _AlertDialog = __webpack_require__(1190);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _GroupSelectionDialog = __webpack_require__(1321);
	
	var _GroupSelectionDialog2 = _interopRequireDefault(_GroupSelectionDialog);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _modal = __webpack_require__(1188);
	
	var _focusNode = __webpack_require__(1210);
	
	var _focusNode2 = _interopRequireDefault(_focusNode);
	
	var _getMatcher = __webpack_require__(1890);
	
	var _getMatcher2 = _interopRequireDefault(_getMatcher);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Used to decrease duplicate code between NewConversationHeader and AddParticipantModal
	var ChatParticipantSearchMixin = {
	  mixins: [(0, _linkStateWithStores2.default)([_ChatStore2.default])],
	
	  statics: {
	    loadData: function loadData() {
	      // TODO handle this by Flux instead of action promise
	      return _ChatActions2.default.promisePotentialChatMembers().then(function () {
	        return _ChatStore2.default.getMembers();
	      });
	    }
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      members: _ChatStore2.default.getMembers(),
	      allMembersLoaded: _ChatStore2.default.areAllMembersLoaded(),
	      query: '',
	      results: _ChatStore2.default.getMembers(),
	      highlight: 0
	    };
	  },
	  getStateFromStores: function getStateFromStores() {
	    return {
	      members: _ChatStore2.default.getMembers(),
	      results: this.getResults(this.state.query),
	      allMembersLoaded: _ChatStore2.default.areAllMembersLoaded()
	    };
	  },
	  _getInput: function _getInput() {
	    return typeof this.getInput === 'function' ? this.getInput() : _reactDom2.default.findDOMNode(this.refs.memberSearch);
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevState.members.length === 0 && this.state.members.length > 0) {
	      this.performSearch();
	    }
	  },
	  isScrolledToBottom: function isScrolledToBottom() {
	    var scrollable = this.refs.scrollArea || this._scrollableArea;
	    return scrollable.isScrolledToBottom(100);
	  },
	
	
	  _blockResultMouseOverWhileScrolling: false,
	
	  handleScroll: (0, _lodash.throttle)(function () {
	    var _this = this;
	
	    if (!this.state.updating && this.isScrolledToBottom() && !this.state.areAllMembersLoaded) {
	      this.setState({ updating: true });
	      this.loadMoreMembers().then(function () {
	        _this.setState({ updating: false });
	      });
	    }
	  }, 100),
	
	  loadMoreMembers: function loadMoreMembers() {
	    return _ChatActions2.default.promisePotentialChatMembers(this.state.query);
	  },
	
	
	  performSearchOnInputChange: (0, _lodash.debounce)(function () {
	    this.performSearch();
	    this.setState({ highlight: 0 });
	  }, 100),
	
	  performSearch: function performSearch() {
	    var input = this._getInput();
	    var value = input.value;
	
	    this.setState({
	      query: value,
	      results: this.getResults(value),
	      highlight: -1
	    }, this.loadMoreMembers);
	  },
	  getResults: function getResults() {
	    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    // Search the possible members for the query substring
	    var isMatch = (0, _getMatcher2.default)(query);
	
	    return this.state.members.filter(function (member) {
	      return isMatch([member.getName(), member.getFirstName(), member.getLastName(), member.getNote(), member.getGroupNames()]);
	    });
	  },
	  memberNotEligible: function memberNotEligible(member) {
	    var modal = void 0;
	    if (member.isAgeUnknown() || member.isPending()) {
	      if (member.isAgeUnknown()) {
	        _ChatActions2.default.requestMemberAge(member);
	      }
	
	      modal = _react2.default.createElement(_AlertDialog2.default, {
	        title: 'We need to collect more information from the participant',
	        subtext: 'We\'ll notify you as soon as they\'re available for two-way messaging.'
	      });
	    } else if (member.isUnder13()) {
	      modal = _react2.default.createElement(_AlertDialog2.default, {
	        title: 'Two-way messaging is only available for students 13 and older.',
	        subtext: 'Don\'t worry\u2014they can still receive announcements.'
	      });
	    } else if (member.isUnavailable()) {
	      modal = _react2.default.createElement(_AlertDialog2.default, {
	        title: 'Sorry! ' + member.getName() + ' isn\'t accepting messages on Remind.'
	      });
	    }
	
	    if (modal) {
	      this.focusInput();
	      this._preventBlur = true;
	      (0, _modal.mountModal)(modal, this);
	    }
	  },
	  focusInput: function focusInput() {
	    (0, _focusNode2.default)(this._getInput());
	  },
	  handleInputChange: function handleInputChange() {
	    this.performSearchOnInputChange();
	  },
	  handleResultMouseOver: function handleResultMouseOver(index) {
	    if (this._blockResultMouseOverWhileScrolling) {
	      this._blockResultMouseOverWhileScrolling = false;
	      return;
	    }
	    this.setState({ highlight: index });
	  },
	  renderGroupSelectionDialog: function renderGroupSelectionDialog() {
	    var groups = _GroupStore2.default.getInvitableGroups();
	    return _react2.default.createElement(_GroupSelectionDialog2.default, {
	      ref: 'groupSelectionDialog',
	      title: 'Select a class',
	      groups: groups,
	      onSelect: this.handleGroupSelect
	    });
	  },
	  renderLoadingIndicator: function renderLoadingIndicator() {
	    if (!_ChatStore2.default.areAllMembersLoaded()) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ChatList-loading' },
	        _react2.default.createElement(_LoadingIndicator2.default, { size: 'small' })
	      );
	    } else {
	      return null;
	    }
	  }
	}; /*  weak */
	exports.default = ChatParticipantSearchMixin;

/***/ },
/* 2035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(1241);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _Coin = __webpack_require__(1671);
	
	var _Coin2 = _interopRequireDefault(_Coin);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _NameAndSignatureQuery = __webpack_require__(2036);
	
	var _NameAndSignatureQuery2 = _interopRequireDefault(_NameAndSignatureQuery);
	
	var _PotentialChatMember = __webpack_require__(945);
	
	var _PotentialChatMember2 = _interopRequireDefault(_PotentialChatMember);
	
	var _Spacing = __webpack_require__(2037);
	
	var _Spacing2 = _interopRequireDefault(_Spacing);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	var _MessageStarterItem = __webpack_require__(2038);
	
	var _MessageStarterItem2 = _interopRequireDefault(_MessageStarterItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageStarterItem = function (_React$Component) {
	  _inherits(MessageStarterItem, _React$Component);
	
	  function MessageStarterItem() {
	    _classCallCheck(this, MessageStarterItem);
	
	    return _possibleConstructorReturn(this, (MessageStarterItem.__proto__ || Object.getPrototypeOf(MessageStarterItem)).apply(this, arguments));
	  }
	
	  _createClass(MessageStarterItem, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      // HACK assumes `member` doesn't mutate during the life of this component
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, null);
	    }
	  }, {
	    key: 'renderReachability',
	    value: function renderReachability() {
	      var member = this.props.member;
	
	      var user = member.getUser();
	
	      if (user.getReachabilityState() !== 'active') {
	        return null;
	      }
	
	      var reachability = user.getReachability();
	
	      return _react2.default.createElement(
	        _Text2.default,
	        { className: _MessageStarterItem2.default.reachability, size: 'xsmall' },
	        reachability['medium']
	      );
	    }
	  }, {
	    key: 'renderDroplet',
	    value: function renderDroplet() {
	      if (this.props.selectable) {
	        if (this.props.selected) {
	          return _react2.default.createElement(
	            _Coin2.default,
	            {
	              className: _Spacing2.default.marginRightLarge,
	              color: 'brand',
	              size: 'xxxlarge' },
	            _react2.default.createElement(_Glyph2.default, { name: 'check', color: 'white', size: 'large', solo: true })
	          );
	        } else {
	          return _react2.default.createElement(_Coin2.default, {
	            className: _Spacing2.default.marginRightLarge,
	            border: 'koala',
	            size: 'xxxlarge'
	          });
	        }
	      }
	
	      var member = this.props.member;
	
	      var user = member.getUser();
	
	      return _react2.default.createElement(_Avatar2.default, {
	        className: _Spacing2.default.marginRightLarge,
	        text: user.getInitials(),
	        colorHex: user.getColor(),
	        size: 'medium'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          member = _props.member,
	          query = _props.query;
	
	      var parser = _TextEntities2.default.createTextMatchingParser(query);
	
	      return _react2.default.createElement(
	        'a',
	        {
	          className: (0, _classnames2.default)(_MessageStarterItem2.default.this, this.props.className) },
	        _react2.default.createElement(
	          _FlexibleBlock2.default,
	          { flex: 'left' },
	          _react2.default.createElement(
	            _FlexibleBlock2.default,
	            { flex: 'right' },
	            this.renderDroplet(),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_NameAndSignatureQuery2.default, {
	                displayName: member.getName(),
	                fullName: member.getUser().getFullName(),
	                query: query
	              }),
	              _react2.default.createElement(
	                _Text2.default,
	                { color: 'koala', size: 'xsmall', truncate: true },
	                _react2.default.createElement(_TextWithEntities2.default, {
	                  text: member.getConnectionDescription(),
	                  entities: parser(member.getConnectionDescription())
	                })
	              )
	            )
	          ),
	          this.renderReachability()
	        )
	      );
	    }
	  }]);
	
	  return MessageStarterItem;
	}(_react2.default.Component);
	
	MessageStarterItem.defaultProps = {
	  selectable: false,
	  selected: false
	};
	MessageStarterItem.displayName = 'MessageStarterItem';
	exports.default = MessageStarterItem;

/***/ },
/* 2036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NameAndSignatureQuery = function NameAndSignatureQuery(_ref) {
	  var displayName = _ref.displayName,
	      fullName = _ref.fullName,
	      query = _ref.query;
	
	  var parser = _TextEntities2.default.createTextMatchingParser(query);
	  if (query !== '' && fullName && parser(fullName).length > parser(displayName).length) {
	    fullName = _react2.default.createElement(_TextWithEntities2.default, { text: '(' + fullName + ')', entities: parser('(' + fullName + ')') });
	  } else {
	    fullName = '';
	  }
	  displayName = _react2.default.createElement(_TextWithEntities2.default, { text: displayName, entities: parser(displayName) });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    displayName,
	    ' ',
	    fullName
	  );
	};
	
	exports.default = NameAndSignatureQuery;

/***/ },
/* 2037 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"small":"4px","medium":"8px","large":"16px","huge":"32px","giant":"64px","marginSmall":"Spacing__marginSmall___2swfJ","marginMedium":"Spacing__marginMedium___2yw1Z","marginLarge":"Spacing__marginLarge___3JEsJ","marginHuge":"Spacing__marginHuge___cQ7BD","marginBottomSmall":"Spacing__marginBottomSmall___1jHXm","marginBottomMedium":"Spacing__marginBottomMedium___3VRvv","marginBottomLarge":"Spacing__marginBottomLarge___89-lt","marginBottomHuge":"Spacing__marginBottomHuge___17K5U","marginLeftSmall":"Spacing__marginLeftSmall___Jyo69","marginLeftMedium":"Spacing__marginLeftMedium___1bHJc","marginLeftLarge":"Spacing__marginLeftLarge___11Ucb","marginLeftHuge":"Spacing__marginLeftHuge___3Z_Bc","marginRightSmall":"Spacing__marginRightSmall___3T7Sl","marginRightMedium":"Spacing__marginRightMedium___bhiZC","marginRightLarge":"Spacing__marginRightLarge___cfZEM","marginRightHuge":"Spacing__marginRightHuge___2tn5Z","marginTopSmall":"Spacing__marginTopSmall___aOQjA","marginTopMedium":"Spacing__marginTopMedium___3A8eu","marginTopLarge":"Spacing__marginTopLarge___10pJs","marginTopHuge":"Spacing__marginTopHuge___3SnyJ","marginHorizSmall":"Spacing__marginHorizSmall___1gJ2Z Spacing__marginLeftSmall___Jyo69 Spacing__marginRightSmall___3T7Sl","marginHorizMedium":"Spacing__marginHorizMedium___2VGIy Spacing__marginLeftMedium___1bHJc Spacing__marginRightMedium___bhiZC","marginHorizLarge":"Spacing__marginHorizLarge___3djl8 Spacing__marginLeftLarge___11Ucb Spacing__marginRightLarge___cfZEM","marginHorizHuge":"Spacing__marginHorizHuge___HAG1e Spacing__marginLeftHuge___3Z_Bc Spacing__marginRightHuge___2tn5Z","marginVertSmall":"Spacing__marginVertSmall___uQJQG Spacing__marginBottomSmall___1jHXm Spacing__marginTopSmall___aOQjA","marginVertMedium":"Spacing__marginVertMedium___UGSg_ Spacing__marginBottomMedium___3VRvv Spacing__marginTopMedium___3A8eu","marginVertLarge":"Spacing__marginVertLarge___URHFR Spacing__marginBottomLarge___89-lt Spacing__marginTopLarge___10pJs","marginVertHuge":"Spacing__marginVertHuge___AsRGt Spacing__marginBottomHuge___17K5U Spacing__marginTopHuge___3SnyJ","paddingSmall":"Spacing__paddingSmall___2rmt3","paddingMedium":"Spacing__paddingMedium___2n-MO","paddingLarge":"Spacing__paddingLarge___1pHq4","paddingHuge":"Spacing__paddingHuge___23uKM","paddingBottomSmall":"Spacing__paddingBottomSmall___gYuLU","paddingBottomMedium":"Spacing__paddingBottomMedium___2LPVP","paddingBottomLarge":"Spacing__paddingBottomLarge___2Auzs","paddingBottomHuge":"Spacing__paddingBottomHuge___2Pa73","paddingLeftSmall":"Spacing__paddingLeftSmall___edX4D","paddingLeftMedium":"Spacing__paddingLeftMedium___23u8X","paddingLeftLarge":"Spacing__paddingLeftLarge___QvQBP","paddingLeftHuge":"Spacing__paddingLeftHuge___1gykW","paddingRightSmall":"Spacing__paddingRightSmall___pWszI","paddingRightMedium":"Spacing__paddingRightMedium___3Lv5a","paddingRightLarge":"Spacing__paddingRightLarge___1p09V","paddingRightHuge":"Spacing__paddingRightHuge___3fmOJ","paddingTopSmall":"Spacing__paddingTopSmall___3-gdW","paddingTopMedium":"Spacing__paddingTopMedium___qfOik","paddingTopLarge":"Spacing__paddingTopLarge___1qHMl","paddingTopHuge":"Spacing__paddingTopHuge___1KFLE","paddingHorizSmall":"Spacing__paddingHorizSmall___3UCoY Spacing__paddingLeftSmall___edX4D Spacing__paddingRightSmall___pWszI","paddingHorizMedium":"Spacing__paddingHorizMedium___2lbEl Spacing__paddingLeftMedium___23u8X Spacing__paddingRightMedium___3Lv5a","paddingHorizLarge":"Spacing__paddingHorizLarge___1rB6u Spacing__paddingLeftLarge___QvQBP Spacing__paddingRightLarge___1p09V","paddingHorizHuge":"Spacing__paddingHorizHuge___1ss5K Spacing__paddingLeftHuge___1gykW Spacing__paddingRightHuge___3fmOJ","paddingVertSmall":"Spacing__paddingVertSmall___3X8DQ Spacing__paddingBottomSmall___gYuLU Spacing__paddingTopSmall___3-gdW","paddingVertMedium":"Spacing__paddingVertMedium___3s3nZ Spacing__paddingBottomMedium___2LPVP Spacing__paddingTopMedium___qfOik","paddingVertLarge":"Spacing__paddingVertLarge___Fzb8K Spacing__paddingBottomLarge___2Auzs Spacing__paddingTopLarge___1qHMl","paddingVertHuge":"Spacing__paddingVertHuge___R7Gfm Spacing__paddingBottomHuge___2Pa73 Spacing__paddingTopHuge___1KFLE"};

/***/ },
/* 2038 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"brand":"#2f75c1","koala":"#c5c7cb","spacing-medium":"8px","spacing-large":"16px","this":"MessageStarterItem__this___61zXL","reachability":"MessageStarterItem__reachability___1Y0hX"};

/***/ },
/* 2039 */,
/* 2040 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"spacing-large":"16px","this":"MessageStarter__this___6k5ae","body":"MessageStarter__body___2F6sW","scrollArea":"MessageStarter__scrollArea___2oqoG","loadingIndicatorContainer":"MessageStarter__loadingIndicatorContainer___1ljOs","highlightedItem":"MessageStarter__highlightedItem___1L61n","actionButton":"MessageStarter__actionButton___1Cibe Spacing__marginLeftMedium___1bHJc"};

/***/ },
/* 2041 */,
/* 2042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IndividualMessageStarter = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatParticipantSearchMixin = __webpack_require__(2034);
	
	var _ChatParticipantSearchMixin2 = _interopRequireDefault(_ChatParticipantSearchMixin);
	
	var _DeprecatedTokenizerTypeahead = __webpack_require__(1884);
	
	var _DeprecatedTokenizerTypeahead2 = _interopRequireDefault(_DeprecatedTokenizerTypeahead);
	
	var _getMatcher = __webpack_require__(1890);
	
	var _getMatcher2 = _interopRequireDefault(_getMatcher);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _PotentialChatMember = __webpack_require__(945);
	
	var _PotentialChatMember2 = _interopRequireDefault(_PotentialChatMember);
	
	var _ScrollableArea = __webpack_require__(1412);
	
	var _ScrollableArea2 = _interopRequireDefault(_ScrollableArea);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ChatRouteHelper = __webpack_require__(1568);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _recentMessagesModal = __webpack_require__(1570);
	
	var _MessageStarterItem = __webpack_require__(2035);
	
	var _MessageStarterItem2 = _interopRequireDefault(_MessageStarterItem);
	
	var _MessageStarter = __webpack_require__(2040);
	
	var _MessageStarter2 = _interopRequireDefault(_MessageStarter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var IndividualMessageStarter = _react2.default.createClass({
	  displayName: 'IndividualMessageStarter',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [
	  // TODO remove this mixin and convert to ES6 class
	  // Only blocker is scrollToBottom load handling
	  _ChatParticipantSearchMixin2.default],
	
	  componentDidMount: function componentDidMount() {
	    this.fetchData('');
	  },
	
	
	  // required by ChatParticipantSearchMixin
	  _scrollableArea: null,
	
	  getFilter: function getFilter(query) {
	    var matcher = (0, _getMatcher2.default)(query);
	    return function (member) {
	      return matcher([member.getName(), member.getFirstName(), member.getLastName(), member.getNote(), member.getGroupNames()]);
	    };
	  },
	  fetchData: function fetchData(query) {
	    return _ChatActions2.default.promisePotentialChatMembers(query).then(function (coll) {
	      return coll.getAvailableMembers();
	    });
	  },
	
	
	  // $FlowFixMe destructuring. Missing annotation
	  startChatWithMember: function startChatWithMember(_ref) {
	    var _ref2 = _slicedToArray(_ref, 1),
	        member = _ref2[0];
	
	    var _props = this.props,
	        groupCode = _props.groupCode,
	        onRequestHide = _props.onRequestHide;
	
	    var group = _GroupStore2.default.getGroupForCode(groupCode);
	    (0, _ChatRouteHelper.pushRouterToChatWithMember)(this.context.router, this.props.showRecent, this.props.hideRecent, member, group);
	    if (onRequestHide) {
	      onRequestHide();
	    }
	  },
	  renderInputToken: function renderInputToken() {
	    // N/A because we're short-cutting out of tokenizing
	    return _react2.default.createElement(
	      'b',
	      null,
	      'error'
	    );
	  },
	  renderList: function renderList(items, loading) {
	    var _this = this;
	
	    return _react2.default.createElement(
	      _ScrollableArea2.default
	      // required by ChatParticipantSearchMixin
	      ,
	      { ref: function ref(c) {
	          return _this._scrollableArea = c;
	        },
	        className: _MessageStarter2.default.scrollArea,
	        onScroll: function onScroll(event) {
	          return _this.handleScroll(event);
	        } },
	      _react2.default.createElement(
	        'ul',
	        null,
	        items
	      ),
	      loading && _react2.default.createElement(
	        'div',
	        { className: _MessageStarter2.default.loadingIndicatorContainer },
	        _react2.default.createElement(_LoadingIndicator2.default, null)
	      )
	    );
	  },
	  renderNoResults: function renderNoResults(query) {
	    return _react2.default.createElement(
	      'li',
	      { className: _MessageStarter2.default.noResults, key: 'noResults' },
	      _react2.default.createElement(
	        _Text2.default,
	        { color: 'pitch', size: 'xsmall', weight: 'semibold' },
	        'No people found for "',
	        query,
	        '"'
	      )
	    );
	  },
	  renderMember: function renderMember(member, highlighted, query, onSelect) {
	    return _react2.default.createElement(
	      'li',
	      {
	        onClick: function onClick() {
	          return onSelect();
	        },
	        key: member.id },
	      _react2.default.createElement(_MessageStarterItem2.default, {
	        className: (0, _classnames2.default)(_defineProperty({}, _MessageStarter2.default.highlightedItem, highlighted)),
	        member: member,
	        query: query,
	        selectable: false,
	        selected: false
	      })
	    );
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_MessageStarter2.default.this, this.props.className) },
	      _react2.default.createElement(_DeprecatedTokenizerTypeahead2.default, {
	        prompt: 'To:',
	        placeholder: 'Choose or search for an individual',
	        onChange: this.startChatWithMember,
	        dataSource: this.fetchData,
	        dataFilterFactory: this.getFilter,
	        listRenderer: this.renderList,
	        noResultsRenderer: this.renderNoResults,
	        itemRenderer: this.renderMember,
	        tokenRenderer: this.renderInputToken,
	        autoFocus: true,
	        inline: true
	      })
	    );
	  }
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    showRecent: _recentMessagesModal.showRecent,
	    hideRecent: _recentMessagesModal.hideRecent
	  }, dispatch);
	};
	
	exports.IndividualMessageStarter = IndividualMessageStarter;
	exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(IndividualMessageStarter);

/***/ },
/* 2043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RoleBasedMessagingComposer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _AnnouncementComposer = __webpack_require__(2044);
	
	var _AnnouncementComposer2 = _interopRequireDefault(_AnnouncementComposer);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _RoleBasedMessagingRecipientsInput = __webpack_require__(1893);
	
	var _RoleBasedMessagingRecipientsInput2 = _interopRequireDefault(_RoleBasedMessagingRecipientsInput);
	
	var _roleBasedMessagingSearch = __webpack_require__(1901);
	
	__webpack_require__(2102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var RoleBasedMessagingComposer = exports.RoleBasedMessagingComposer = function (_React$Component) {
	  _inherits(RoleBasedMessagingComposer, _React$Component);
	
	  function RoleBasedMessagingComposer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RoleBasedMessagingComposer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RoleBasedMessagingComposer.__proto__ || Object.getPrototypeOf(RoleBasedMessagingComposer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      inComposer: false
	    }, _this.handleInputFocus = function () {
	      if (_this.state.inComposer) {
	        _this.setState({ inComposer: false });
	      }
	    }, _this.goToComposer = function () {
	      if (!_this.state.inComposer) {
	        _this.setState({ inComposer: true });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RoleBasedMessagingComposer, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        eventScreenName: 'role_based_messaging_composer'
	      };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          initialMessage = _props.initialMessage,
	          onSelectGroup = _props.onSelectGroup;
	
	      if (initialMessage && (initialMessage.getThreads().length || initialMessage.getTargets().length)) {
	        this.setState({ inComposer: true });
	      } else if (initialMessage && initialMessage.getGroupIds().length) {
	        initialMessage.getGroupIds().forEach(function (groupId) {
	          return onSelectGroup(_GroupStore2.default.getGroup(groupId));
	        });
	        initialMessage.set('group_ids', []);
	        this.setState({ inComposer: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var initialMessage = this.props.initialMessage;
	
	      var initialTargets = void 0;
	
	      if (initialMessage && initialMessage.getThreads().length) {
	        initialTargets = initialMessage.getThreads();
	      } else if (initialMessage && initialMessage.getTargets().length) {
	        initialTargets = initialMessage.getTargets();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'RoleBasedMessagingComposer' },
	        _react2.default.createElement(_RoleBasedMessagingRecipientsInput2.default, {
	          className: 'RoleBasedMessagingComposer-recipients-input',
	          autoFocus: !this.state.inComposer,
	          onInputFocus: this.handleInputFocus,
	          initialTargets: initialTargets || [],
	          onEnter: this.goToComposer,
	          onActionButtonClick: this.goToComposer,
	          hideResults: this.state.inComposer
	        }),
	        this.state.inComposer && _react2.default.createElement(_AnnouncementComposer2.default, {
	          className: 'RoleBasedMessagingComposer-composer-container',
	          initialMessage: initialMessage,
	          onMessageSent: this.props.onMessageSent,
	          charLimit: this.props.charLimit,
	          charLimitWithFiles: this.props.charLimitWithFiles,
	          targets: this.props.targets,
	          onRequestHide: this.props.onRequestHide,
	          hideOldInput: true,
	          autoFocus: true,
	          isEdit: this.props.isEdit
	        })
	      );
	    }
	  }]);
	
	  return RoleBasedMessagingComposer;
	}(_react2.default.Component);
	
	RoleBasedMessagingComposer.childContextTypes = {
	  eventScreenName: _react2.default.PropTypes.string
	};
	RoleBasedMessagingComposer.displayName = 'RoleBasedMessagingComposer';
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    targets: state.roleBasedMessagingSearch.targets
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    onSelectGroup: _roleBasedMessagingSearch.selectGroup
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RoleBasedMessagingComposer);

/***/ },
/* 2044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(555);
	
	var _AlertDialog = __webpack_require__(1190);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _AnnouncementComposerRecipientsInput = __webpack_require__(1876);
	
	var _AnnouncementComposerRecipientsInput2 = _interopRequireDefault(_AnnouncementComposerRecipientsInput);
	
	var _ActivityComposerTooltipContainer = __webpack_require__(2045);
	
	var _ActivityComposerTooltipContainer2 = _interopRequireDefault(_ActivityComposerTooltipContainer);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ButtonGroup = __webpack_require__(1432);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _CharacterCount = __webpack_require__(2049);
	
	var _CharacterCount2 = _interopRequireDefault(_CharacterCount);
	
	var _Composer = __webpack_require__(2050);
	
	var _Composer2 = _interopRequireDefault(_Composer);
	
	var _ComposerAlert = __webpack_require__(2053);
	
	var _ComposerAlert2 = _interopRequireDefault(_ComposerAlert);
	
	var _ComposerFilePreview = __webpack_require__(2079);
	
	var _ComposerFilePreview2 = _interopRequireDefault(_ComposerFilePreview);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DatePickerInput = __webpack_require__(1749);
	
	var _DatePickerInput2 = _interopRequireDefault(_DatePickerInput);
	
	var _DropZoneModal = __webpack_require__(1501);
	
	var _DropZoneModal2 = _interopRequireDefault(_DropZoneModal);
	
	var _File = __webpack_require__(929);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _FileUploaderMixin = __webpack_require__(2082);
	
	var _FileUploaderMixin2 = _interopRequireDefault(_FileUploaderMixin);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _LanguageHoverCard = __webpack_require__(2083);
	
	var _LanguageHoverCard2 = _interopRequireDefault(_LanguageHoverCard);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _List = __webpack_require__(1281);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _MessageActions = __webpack_require__(1228);
	
	var _MessageActions2 = _interopRequireDefault(_MessageActions);
	
	var _promptDialog = __webpack_require__(2086);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TimePickerInput = __webpack_require__(1854);
	
	var _TimePickerInput2 = _interopRequireDefault(_TimePickerInput);
	
	var _TranslationActions = __webpack_require__(1301);
	
	var _TranslationActions2 = _interopRequireDefault(_TranslationActions);
	
	var _UniversalComposer = __webpack_require__(2032);
	
	var _UniversalComposer2 = _interopRequireDefault(_UniversalComposer);
	
	var _modal = __webpack_require__(1188);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _SafetyDialog = __webpack_require__(2099);
	
	var _SafetyDialog2 = _interopRequireDefault(_SafetyDialog);
	
	var _mountTymkPrompt = __webpack_require__(1464);
	
	var _mountTymkPrompt2 = _interopRequireDefault(_mountTymkPrompt);
	
	var _AnnouncementComposer = __webpack_require__(2100);
	
	var _AnnouncementComposer2 = _interopRequireDefault(_AnnouncementComposer);
	
	var _Leads = __webpack_require__(1023);
	
	var _Leads2 = _interopRequireDefault(_Leads);
	
	var _roleHelpers = __webpack_require__(1230);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	// typecheck: ignore file
	
	
	var ONE_MINUTE_IN_MS = 60 * 1000;
	var FIVE_MINUTES_IN_MS = 5 * ONE_MINUTE_IN_MS;
	var THIRTY_MINUTES_IN_MS = 30 * ONE_MINUTE_IN_MS;
	var ONE_HOUR_IN_MS = 2 * THIRTY_MINUTES_IN_MS;
	
	var getNext30MinInterval = function getNext30MinInterval() {
	  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
	
	  var newDate = new Date(parseInt(date.getTime() / ONE_MINUTE_IN_MS, 10) * ONE_MINUTE_IN_MS);
	
	  if (newDate.getMinutes() >= 30) {
	    newDate.setMinutes(0);
	    return new Date(newDate.getTime() + ONE_HOUR_IN_MS);
	  }
	
	  newDate.setMinutes(30);
	  return newDate;
	};
	
	var getDefaultScheduledTime = function getDefaultScheduledTime() {
	  return new Date(getNext30MinInterval().getTime() + FIVE_MINUTES_IN_MS);
	};
	
	var getStateFromMessage = function getStateFromMessage(message) {
	  var groups = message.getGroupIds().map(function (id) {
	    return _GroupStore2.default.getGroup(id);
	  }).filter(function (o) {
	    return !!o;
	  });
	
	  return {
	    groupCodes: groups.map(function (group) {
	      return group.getCode();
	    }),
	    scheduledTime: message.getSendAt(),
	    text: message.getBody(),
	    attachmentId: message.getAttachmentId()
	  };
	};
	
	var AnnouncementComposer = _react2.default.createClass({
	  displayName: 'AnnouncementComposer',
	
	
	  childContextTypes: {
	    eventContextName: _react2.default.PropTypes.string
	  },
	
	  mixins: [_FileUploaderMixin2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      initialMessage: new _Message2.default(),
	      autoFocus: false,
	      onMessageSent: function onMessageSent() {},
	      shouldShowModals: true,
	      groupCodes: [],
	      hideOldInput: false,
	      isEdit: false,
	      disableToField: false
	    };
	  },
	
	
	  // $FlowIssue property props cannot be accessed on the global object
	  getInitialState: function getInitialState() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	    var initialMessage = props.initialMessage;
	
	    var initialMessageProps = initialMessage ? getStateFromMessage(initialMessage) : {};
	
	    return {
	      remainingCharactersCount: this.getRemainingCharacters(initialMessageProps.text || ''),
	      schedulerOpened: !!initialMessageProps.scheduledTime,
	      translationOpened: false,
	      groupCodes: (0, _lodash.uniq)(this.props.groupCodes.concat(initialMessageProps.groupCodes)),
	      scheduledTime: initialMessageProps.scheduledTime || null,
	      text: initialMessageProps.text || ''
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      eventContextName: 'group_composer'
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    // Called after the state is set so that the dropzone
	    // is initialized (composer must expand)
	    if (this.props.initialMessage) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.props.initialMessage.getFiles()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var file = _step.value;
	
	          this.addFile(file);
	        }
	
	        // Checks for a fileId passed in through query params
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var fileId = this.props.initialMessage.getAttachmentId();
	      if (fileId) {
	        this.getFileFromId(fileId, this.props.initialMessage);
	      }
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    // TODO remove group codes (we use targets now)
	    var groupCodes = nextProps.groupCodes,
	        initialMessage = nextProps.initialMessage;
	
	    if (this.props.groupCodes.length !== groupCodes.length) {
	      this.setState({ groupCodes: groupCodes });
	    }
	
	    if (this.props.initialMessage !== initialMessage && (this.props.initialMessage && initialMessage && this.props.initialMessage.getBody() !== initialMessage.getBody() || !(0, _lodash.isEqual)(this.props.initialMessage.getTargets(), initialMessage.getTargets()))) {
	      this.setState(this.getInitialState(nextProps));
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var message = this.createMessageFromState();
	    var _props = this.props,
	        targets = _props.targets,
	        inAnnouncementsThread = _props.inAnnouncementsThread;
	
	    var group = targets[0] && _GroupStore2.default.getGroup(targets[0].group_id);
	    var groupName = group ? group.getName() : '';
	    if (!inAnnouncementsThread && message.isWorthSaving(groupName)) {
	      _MessageActions2.default.saveDraftAnnouncement(message);
	    } else if (!inAnnouncementsThread) {
	      _MessageActions2.default.clearDraftAnnouncement();
	    }
	  },
	  hasFiles: function hasFiles() {
	    return this.state && this.state.files && this.state.files.length > 0;
	  },
	  getRemainingCharacters: function getRemainingCharacters(text) {
	    var _props2 = this.props,
	        charLimit = _props2.charLimit,
	        charLimitWithFiles = _props2.charLimitWithFiles;
	
	    return _CharacterCount2.default.getRemainingCharactersForText(charLimit, charLimitWithFiles, text, this.hasFiles());
	  },
	  onUploadFailed: function onUploadFailed(file) {
	    if (file.getSize() > this.getMaxFilesize()) {
	      this.resetDropzone();
	      (0, _modal.mountModal)(_react2.default.createElement(_AlertDialog2.default, {
	        eventScreenName: 'AnnouncementComposer',
	        glyph: 'caution',
	        glyphColor: 'lava',
	        title: 'File "' + file.getName() + '" is too large.',
	        subtext: 'Files must be less than ' + this.getMaxFilesizeName()
	      }), this);
	    }
	  },
	  getDropzoneId: function getDropzoneId() {
	    if (this.props.inAnnouncementsThread) {
	      return 'group_composer_thread';
	    }
	    return 'group_composer';
	  },
	
	
	  // Currently just used for prefilled attachments
	  // typecheck: ignore statement
	  getFileFromId: function getFileFromId(fileId, message) {
	    var _this = this;
	
	    var request = _FileUploaderMixin2.default.handleFileFromId(fileId, message);
	    request.then(function (file) {
	      _this.addFile(_File2.default.fromJSON(file));
	    });
	  },
	  resetComposerContent: function resetComposerContent() {
	    var groupCodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    this.setState({
	      remainingCharactersCount: this.getRemainingCharacters(''),
	      schedulerOpened: false,
	      translationOpened: false,
	      groupCodes: groupCodes,
	      scheduledTime: null,
	      text: ''
	    });
	    this.clear();
	  },
	
	
	  offsetHeight: null,
	
	  handleRecipientsChange: function handleRecipientsChange(groupCodes) {
	    this.setState({ groupCodes: groupCodes });
	  },
	  handleTextChange: function handleTextChange(event) {
	    // $FlowIssue
	    var text = event.target.value;
	
	    if (text === this.state.text) {
	      return;
	    }
	
	    this.setState({
	      text: text,
	      remainingCharactersCount: this.getRemainingCharacters(text.trim())
	    });
	  },
	  submitComposer: function submitComposer() {
	    var _this2 = this;
	
	    if (this.isSubmitDisabled()) {
	      return;
	    }
	
	    if (!_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.SAFETY_MODAL) && ['student', 'parent'].includes(_CurrentUser2.default.getUser().getUserSelectedRole())) {
	      var onSafetyDialogOkay = function onSafetyDialogOkay() {
	        _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.SAFETY_MODAL);
	        _this2.sendMessage();
	      };
	      (0, _modal.mountModal)(_react2.default.createElement(_SafetyDialog2.default, { onOkay: onSafetyDialogOkay }), this);
	      return;
	    }
	
	    this.sendMessage();
	  },
	  handleDatePickerChanged: function handleDatePickerChanged(newDate) {
	    var scheduledTime = this.state.scheduledTime;
	
	    if (newDate) {
	      // $FlowIssue not null at this point
	      var oldDate = new Date(scheduledTime.getTime());
	      newDate.setHours(oldDate.getHours());
	      newDate.setMinutes(oldDate.getMinutes());
	      this.setState({ scheduledTime: newDate });
	    } else {
	      this.setState({ scheduledTime: scheduledTime });
	    }
	  },
	  handleTimePickerChanged: function handleTimePickerChanged(inputDate) {
	    var scheduledTime = this.state.scheduledTime;
	    // $FlowIssue not null at this point
	
	    var newDate = new Date(scheduledTime.getTime());
	    newDate.setHours(inputDate.getHours());
	    newDate.setMinutes(inputDate.getMinutes());
	    this.setState({ scheduledTime: newDate });
	  },
	  isAttachEnabled: function isAttachEnabled() {
	    return !this.state.translationOpened && !this.getFiles()[0];
	  },
	  isSubmitDisabled: function isSubmitDisabled() {
	    return this.state.remainingCharactersCount < 0 || !this.isValidMessage();
	  },
	  isValidMessage: function isValidMessage() {
	    var isAddressed = this.state.groupCodes.length || !!this.props.targets && this.props.targets.length;
	
	    var fileData = this.getFileData(this.getFiles()[0]);
	    var allUploadsComplete = fileData ? fileData.progress === 100 : true;
	
	    var hasText = this.state.text.trim().length > 0;
	
	    return isAddressed && allUploadsComplete && (hasText || !!fileData);
	  },
	  createMessageFromState: function createMessageFromState() {
	    var groupCodes = this.state.groupCodes;
	    var targets = this.props.targets;
	
	
	    var args = [targets ? null : groupCodes.map(function (code) {
	      return _GroupStore2.default.getGroupForCode(code);
	    }).filter(function (g) {
	      return !!g;
	    }), this.state.text, this.state.scheduledTime, this.getFileEntities(), // FileUploaderMixin
	    null, null, targets];
	
	    return _Message2.default.createMessage.apply(_Message2.default, args);
	  },
	  focus: function focus() {
	    if (this.refs.composer) {
	      this.refs.composer.focus();
	    }
	  },
	  clear: function clear() {
	    if (this.refs.composer) {
	      this.refs.composer.clear();
	    }
	  },
	  sendMessage: function sendMessage() {
	    var _this3 = this;
	
	    if (this.props.isEdit) {
	      this.editMessage();
	      return;
	    }
	    var message = this.createMessageFromState();
	    var _state = this.state,
	        groupCodes = _state.groupCodes,
	        remainingCharactersCount = _state.remainingCharactersCount;
	
	    // Dismiss the prompt showing the long announcements banner to this user
	
	    var overLengthLimit = remainingCharactersCount < 0;
	    var hasPrompt = _CurrentUser2.default.getUser().hasItemInPromptsInventory(_PromptConstants.PromptNames.LONG_ANNOUNCEMENTS_BANNER);
	    if (overLengthLimit && hasPrompt) {
	      var prompt = _CurrentUser2.default.getUser().findPrompt(_PromptConstants.PromptNames.LONG_ANNOUNCEMENTS_BANNER);
	      _PromptActions2.default.recordDismissPromptsInventoryPrompt(prompt);
	    }
	
	    _MessageActions2.default.sendMessage(message).then(function () {
	      if (_this3.props.shouldShowModals) {
	        _this3.showModals();
	      }
	
	      // TODO: WHY???
	      _GroupStore2.default.invalidate();
	
	      _this3.removeAllFiles();
	
	      if (_this3.props.inAnnouncementsThread) {
	        _this3.resetComposerContent(groupCodes);
	      } else {
	        _this3.setState({ text: '', groupCodes: [] });
	      }
	
	      _this3.props.onMessageSent(_this3.props.targets);
	    });
	  },
	  editMessage: function editMessage() {
	    var _this4 = this;
	
	    var body = this.state.text;
	    var files = this.getFileEntities(); // FileUploaderMixin
	    var sendAt = this.state.scheduledTime;
	    (0, _invariant2.default)(sendAt, 'editMessage requires scheduledTime');
	    _MessageActions2.default.updateScheduledMessage(this.props.initialMessage, body, this.props.targets, files, sendAt).then(function () {
	      return _this4.props.onMessageSent(_this4.props.targets);
	    });
	  },
	  showSendToMoreClassesComposer: function showSendToMoreClassesComposer() {
	    var _this5 = this;
	
	    var draftMessage = this.createMessageFromState();
	    _MessageActions2.default.saveDraftAnnouncement(draftMessage);
	    (0, _modal.mountModal)(_react2.default.createElement(_UniversalComposer2.default, {
	      canAnnounce: true,
	      panel: _UniversalComposer.PANELS.CLASS_ANNOUCEMENT,
	      onMessageSent: function onMessageSent() {
	        (0, _mountTymkPrompt2.default)(_this5, 'send_announcement');
	      }
	    }), this);
	  },
	
	
	  // copied from GroupComposer, which this component has replaced
	  showModals: function showModals() {
	    (0, _promptDialog.showPromptDialog)(_PromptConstants.PromptNames.DESKTOP_NOTIFICATION_MODAL, 'sent_announcement', this);
	  },
	  toggleScheduler: function toggleScheduler() {
	    var scheduledTime = this.state.schedulerOpened ? null : getDefaultScheduledTime();
	
	    this.setState({
	      schedulerOpened: !this.state.schedulerOpened,
	      scheduledTime: scheduledTime
	    });
	  },
	  toggleTranslation: function toggleTranslation() {
	    this.setState(function (_ref) {
	      var translationOpened = _ref.translationOpened;
	      return { translationOpened: !translationOpened };
	    });
	  },
	  translateTo: function translateTo(lang) {
	    var _this6 = this;
	
	    _TranslationActions2.default.translate(this.state.text, lang).then(function (response) {
	      _this6.setState({
	        text: response.translation,
	        translationOpened: false,
	        latestTranslation: lang,
	        remainingCharactersCount: _this6.getRemainingCharacters(response.translation)
	      });
	    });
	  },
	  getPlaceholder: function getPlaceholder() {
	    var targets = this.props.targets;
	
	    var firstTarget = targets[0]; // In this component, there can be only a single target
	    var groupName = firstTarget && firstTarget.name;
	    var role = firstTarget && firstTarget.role;
	
	    if (groupName && role) {
	      return 'Message ' + _roleHelpers.subgroupName[role].toLowerCase() + ' in ' + groupName;
	    } else {
	      return 'Type a message';
	    }
	  },
	  renderComposer: function renderComposer() {
	    var inAnnouncementsThread = this.props.inAnnouncementsThread;
	    var remainingCharactersCount = this.state.remainingCharactersCount;
	
	    var overLengthLimit = remainingCharactersCount < 0;
	
	    var indicator = void 0;
	    if (inAnnouncementsThread) {
	      indicator = this.renderRemainingCharactersCount();
	    }
	
	    var messageOptions = _react2.default.createElement(
	      'div',
	      null,
	      this.renderScheduler(),
	      this.renderTranslation()
	    );
	
	    return _react2.default.createElement(
	      'div',
	      { className: _AnnouncementComposer2.default.composerContainer },
	      _react2.default.createElement(
	        _Composer2.default,
	        {
	          ref: 'composer',
	          className: (0, _classnames2.default)(_AnnouncementComposer2.default.composer, _defineProperty({}, _AnnouncementComposer2.default.announcementThreadComposer, inAnnouncementsThread)),
	          placeholder: this.getPlaceholder(),
	          autogrow: true,
	          value: this.state.text,
	          autoFocus: this.props.autoFocus && this.state.groupCodes.length > 0,
	          error: overLengthLimit,
	          onChange: this.handleTextChange,
	          indicator: indicator },
	        this.renderActivityTooltip(),
	        this.renderFilePreview(),
	        messageOptions,
	        !inAnnouncementsThread && this.renderControls()
	      ),
	      inAnnouncementsThread && this.renderControls()
	    );
	  },
	  renderActivityTooltip: function renderActivityTooltip() {
	    var setting = _SettingsStore2.default.getComposerActivityRegex();
	    var regex = new RegExp(setting, 'i');
	    var user = _CurrentUser2.default.getUser();
	
	    if (user && user.canCollectMoney() && this.state.text.match(regex)) {
	      return _react2.default.createElement(_ActivityComposerTooltipContainer2.default, { onActivitySent: this.props.onRequestHide });
	    } else {
	      return _react2.default.createElement('span', null);
	    }
	  },
	  renderFilePreview: function renderFilePreview() {
	    var _this7 = this;
	
	    var file = this.getFiles()[0];
	    var fileData = this.getFileData(file);
	
	    if (!fileData) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: _AnnouncementComposer2.default.filePreview },
	      _react2.default.createElement(_ComposerFilePreview2.default, {
	        progress: fileData.progress,
	        thumbnail: fileData.thumbnail,
	        type: fileData.type,
	        error: fileData.error,
	        onDelete: function onDelete() {
	          return _this7.removeFile(file);
	        },
	        onRetry: function onRetry() {
	          return _this7.retryUpload(file);
	        },
	        file: this.state.uploadedFile
	      })
	    );
	  },
	  renderControls: function renderControls() {
	    var inUniversalComposer = !this.props.inAnnouncementsThread;
	    var disabled = this.isSubmitDisabled();
	    var hasMultipleGroups = _GroupStore2.default.getOwnedGroups().length > 1;
	    var controlList = _react2.default.createElement(
	      _List2.default,
	      { className: _AnnouncementComposer2.default.controls, horizontal: true },
	      this.renderAttachButton(),
	      this.renderScheduleButton(),
	      this.renderTranslationButton(),
	      !inUniversalComposer && hasMultipleGroups && !disabled && this.renderSendToMoreClassesButton()
	    );
	    return controlList;
	  },
	  renderAttachButton: function renderAttachButton() {
	    var tooltip = this.getFiles()[0] ? 'You can only attach 1 file' : null;
	    var disabled = !this.isAttachEnabled();
	
	    return _react2.default.createElement(
	      'div',
	      { ref: 'dropzone_attach' },
	      _react2.default.createElement(
	        _Button2.default
	        // We need for force this to be a link due to a Chrome bug, because
	        // otherwise onmouseleave events won’t fire properly when this button
	        // is disabled, so the tooltip will appear but won’t disappear when the
	        // cursor leaves the button
	        ,
	        { href: tooltip ? '#' : null,
	          className: 'addFileButton_' + this.getDropzoneId(),
	          onClick: this.focus,
	          disabled: disabled,
	          tooltip: tooltip,
	          tooltipPlacement: 'top',
	          level: 'text' },
	        _react2.default.createElement(_Glyph2.default, { name: 'paperclip', className: _AnnouncementComposer2.default.controlGlyph }),
	        'Attach'
	      )
	    );
	  },
	  renderDropzoneModal: function renderDropzoneModal() {
	    if (this.state.isDraggingFile) {
	      return _react2.default.createElement(_DropZoneModal2.default, {
	        isFileUploaded: this.getFiles().length > 0,
	        isHovering: this.state.isDraggingFileInner
	      });
	    } else {
	      return null;
	    }
	  },
	  renderSendToMoreClassesButton: function renderSendToMoreClassesButton() {
	    return _react2.default.createElement(
	      'li',
	      { className: [_AnnouncementComposer2.default.listItemPullRight, _AnnouncementComposer2.default.moreClassesListItem].join(' ') },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: _AnnouncementComposer2.default.moreClassesButton,
	          level: 'text',
	          onClick: this.showSendToMoreClassesComposer },
	        'Add more classes'
	      )
	    );
	  },
	  renderScheduleButton: function renderScheduleButton() {
	    var disabled = !!this.state.scheduledTime || this.state.translationOpened;
	    return _react2.default.createElement(
	      _Button2.default,
	      {
	        disabled: disabled,
	        level: 'text',
	        onClick: this.toggleScheduler },
	      _react2.default.createElement(_Glyph2.default, { name: 'schedule', className: _AnnouncementComposer2.default.controlGlyph }),
	      'Schedule'
	    );
	  },
	  renderTranslationButton: function renderTranslationButton() {
	    var disabled = this.state.translationOpened || this.state.text.length < 1;
	    return _react2.default.createElement(
	      _Button2.default,
	      {
	        level: 'text',
	        disabled: disabled,
	        eventElementName: 'show_translation_box',
	        onClick: this.toggleTranslation },
	      _react2.default.createElement(_Glyph2.default, { name: 'globe', size: 'medium', className: _AnnouncementComposer2.default.controlGlyph }),
	      'Translate'
	    );
	  },
	  renderRecipientsInput: function renderRecipientsInput() {
	    return _react2.default.createElement(_AnnouncementComposerRecipientsInput2.default, {
	      className: (0, _classnames2.default)(_AnnouncementComposer2.default.recipientsInput, _defineProperty({}, _AnnouncementComposer2.default.recipientsInputDisabled, this.props.disableToField)),
	      selectedGroupCodes: this.state.groupCodes
	      // FIXME initially renders the layer relative to the window
	      // autoFocus={this.props.autoFocus && this.state.groupCodes.length === 0}
	      , onChange: this.handleRecipientsChange
	    });
	  },
	  renderScheduler: function renderScheduler() {
	    if (!this.state.schedulerOpened) {
	      return null;
	    }
	
	    var placement = this.props.inAnnouncementsThread ? 'top' : 'bottom';
	
	    var datePicker = _react2.default.createElement(_DatePickerInput2.default, {
	      value: this.state.scheduledTime,
	      min: getNext30MinInterval(),
	      onChange: this.handleDatePickerChanged,
	      ref: 'timePicker',
	      placement: placement
	    });
	
	    var timePicker = _react2.default.createElement(_TimePickerInput2.default, {
	      className: (0, _classnames2.default)({
	        error: !!this.state.scheduledTime && new Date() > this.state.scheduledTime
	      }),
	      value: this.state.scheduledTime,
	      min: getNext30MinInterval(),
	      onChange: this.handleTimePickerChanged,
	      ref: 'timePicker',
	      placement: placement
	    });
	
	    var closeButton = _react2.default.createElement(
	      _Button2.default,
	      { className: _AnnouncementComposer2.default.schedulerCloseButton, level: 'text', onClick: this.toggleScheduler },
	      _react2.default.createElement(_Glyph2.default, { name: 'close-circle', color: 'eclipse', size: 'large', solo: true })
	    );
	
	    return _react2.default.createElement(
	      'div',
	      { className: _AnnouncementComposer2.default.scheduler },
	      _react2.default.createElement(
	        _Text2.default,
	        { className: _AnnouncementComposer2.default.schedulerLabel, color: 'pitch', weight: 'semibold' },
	        'Scheduled for:'
	      ),
	      datePicker,
	      ' at ',
	      timePicker,
	      closeButton
	    );
	  },
	  renderRemainingCharactersCount: function renderRemainingCharactersCount() {
	    var remainingCharactersCount = this.state.remainingCharactersCount;
	
	
	    var textColor = remainingCharactersCount < 0 ? 'lava' : 'eclipse';
	    return _react2.default.createElement(
	      _Text2.default,
	      {
	        className: _AnnouncementComposer2.default.remainingCharCount,
	        color: textColor,
	        size: 'xxsmall',
	        'data-test-selector': 'character_count' },
	      remainingCharactersCount
	    );
	  },
	  renderSendButton: function renderSendButton() {
	    var _state2 = this.state,
	        remainingCharactersCount = _state2.remainingCharactersCount,
	        latestTranslation = _state2.latestTranslation,
	        scheduledTime = _state2.scheduledTime;
	
	    var disabled = this.isSubmitDisabled();
	
	    var tooltip = null;
	    if (disabled) {
	      if (remainingCharactersCount < 0) {
	        var charactersOverLimit = Math.abs(remainingCharactersCount);
	        tooltip = _react2.default.createElement(
	          'div',
	          null,
	          'This announcement is ' + charactersOverLimit + '\n              character' + (charactersOverLimit === 1 ? '' : 's') + ' over the limit.\n              Shorten your announcement by ' + charactersOverLimit + '\n              character' + (charactersOverLimit === 1 ? '' : 's') + ' before\n              ' + (scheduledTime ? 'scheduling' : 'sending') + '.'
	        );
	      }
	    }
	
	    var eventProperties = {};
	
	    if (latestTranslation) {
	      eventProperties.language_code = latestTranslation;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: _AnnouncementComposer2.default.buttonContainer },
	      !this.props.inAnnouncementsThread && this.renderRemainingCharactersCount(),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          'data-test-selector': 'announcement_composer_send_button',
	          className: _AnnouncementComposer2.default.sendButton,
	          href: tooltip ? '#' : null /* Note: Due to a Chrome bug, we force this to be a link */
	          , level: 'primary',
	          size: 'small',
	          eventElementName: 'send_button',
	          eventProperties: eventProperties,
	          tooltip: tooltip,
	          tooltipPlacement: 'bottom',
	          disabled: disabled,
	          onClick: this.submitComposer },
	        scheduledTime ? 'Save' : this.props.sendButtonText || 'Send'
	      )
	    );
	  },
	  renderTranslation: function renderTranslation() {
	    var _this8 = this;
	
	    if (!this.state.translationOpened) {
	      return null;
	    }
	
	    var languages = _SettingsStore2.default.getPrimaryLanguages();
	    var buttons = [];
	
	    // TODO: Implement two-pass render in ButtonGroup
	    var displayedMax = Object.keys(languages).length - 1;
	    var displayed = 0;
	
	    var _loop = function _loop(lang) {
	      displayed += 1;
	      if (displayed <= displayedMax) {
	        buttons.push(_react2.default.createElement(
	          _Button2.default,
	          {
	            eventElementName: 'translate_button',
	            eventProperties: {
	              language_code: lang
	            },
	            onClick: function onClick() {
	              return _this8.translateTo(lang);
	            } },
	          languages[lang]
	        ));
	      }
	    };
	
	    for (var lang in languages) {
	      _loop(lang);
	    }
	
	    buttons.push(_react2.default.createElement(
	      _LayerTrigger2.default,
	      {
	        layer: _react2.default.createElement(_LanguageHoverCard2.default, { onLanguagePicked: function onLanguagePicked(lang) {
	            return _this8.translateTo(lang);
	          } }),
	        trigger: 'click',
	        placement: 'bottom',
	        alignment: 'middle' },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          level: 'secondary',
	          color: 'thunder',
	          size: 'xsmall',
	          eventElementName: 'show_more_languages_button' },
	        _react2.default.createElement(_Glyph2.default, { name: 'ellipses', solo: true })
	      )
	    ));
	
	    return _react2.default.createElement(
	      _FlexibleBlock2.default,
	      {
	        className: _AnnouncementComposer2.default.translation,
	        flex: 'left' },
	      _react2.default.createElement(
	        _ButtonGroup2.default,
	        {
	          className: _AnnouncementComposer2.default.translationButtons,
	          level: 'secondary',
	          color: 'thunder',
	          size: 'xsmall' },
	        buttons
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          level: 'text',
	          eventElementName: 'close_translation_box',
	          onClick: this.toggleTranslation },
	        _react2.default.createElement(_Glyph2.default, { name: 'close-circle', color: 'eclipse', size: 'large', solo: true })
	      )
	    );
	  },
	  renderComposerAlert: function renderComposerAlert() {
	    if (!this.props.inAnnouncementsThread) {
	      return null;
	    }
	
	    var target = this.props.targets[0]; // always have only one if inAnnouncementsThread
	    return _react2.default.createElement(_ComposerAlert2.default, {
	      group: _GroupStore2.default.getGroup(target.group_id),
	      target: target
	    });
	  },
	  renderComposerArea: function renderComposerArea() {
	    if (!_CurrentUser2.default.getUser().canComposeAnnouncements()) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: _AnnouncementComposer2.default.composerWrapper },
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_AnnouncementComposer2.default.wrap, _defineProperty({}, _AnnouncementComposer2.default.dialogWrap, !this.props.inAnnouncementsThread)),
	          key: 'composerAndButton' },
	        this.renderComposer(),
	        this.renderSendButton()
	      ),
	      this.renderDropzoneModal()
	    );
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      {
	        ref: 'dropzone',
	        className: (0, _classnames2.default)(_AnnouncementComposer2.default.this, this.props.className, _defineProperty({}, _AnnouncementComposer2.default.announcementsThread, this.props.inAnnouncementsThread)) },
	      !this.props.hideOldInput && this.renderRecipientsInput(),
	      this.renderComposerAlert(),
	      this.renderComposerArea()
	    );
	  }
	});
	
	exports.default = AnnouncementComposer;

/***/ },
/* 2045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PROMPT = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ActivityComposerTooltip = __webpack_require__(2046);
	
	var _ActivityComposerTooltip2 = _interopRequireDefault(_ActivityComposerTooltip);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PROMPT = exports.PROMPT = 'web.composer.activity_banner';
	
	var ActivityComposerTooltipContainer = function (_React$Component) {
	  _inherits(ActivityComposerTooltipContainer, _React$Component);
	
	  function ActivityComposerTooltipContainer() {
	    _classCallCheck(this, ActivityComposerTooltipContainer);
	
	    return _possibleConstructorReturn(this, (ActivityComposerTooltipContainer.__proto__ || Object.getPrototypeOf(ActivityComposerTooltipContainer)).apply(this, arguments));
	  }
	
	  _createClass(ActivityComposerTooltipContainer, [{
	    key: 'render',
	    value: function render() {
	      var actions = {
	        dismiss: function dismiss() {
	          return _PromptActions2.default.recordDismissal(PROMPT);
	        }
	      };
	
	      if (this.state.hasDismissed) {
	        return _react2.default.createElement('span', null);
	      }
	
	      return _react2.default.createElement(_ActivityComposerTooltip2.default, _extends({}, this.props, actions));
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_PromptStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        hasDismissed: _PromptStore2.default.hasDismissed(PROMPT)
	      };
	    }
	  }]);
	
	  return ActivityComposerTooltipContainer;
	}(_react2.default.Component);
	
	ActivityComposerTooltipContainer.displayName = 'ActivityComposerTooltipContainer';
	exports.default = _utils.Container.create(ActivityComposerTooltipContainer, { withProps: true });

/***/ },
/* 2046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modal = __webpack_require__(1188);
	
	var _ActivityCreateDialogContainer = __webpack_require__(1726);
	
	var _ActivityCreateDialogContainer2 = _interopRequireDefault(_ActivityCreateDialogContainer);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	__webpack_require__(2047);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ActivityComposerTooltip = function (_Component) {
	  _inherits(ActivityComposerTooltip, _Component);
	
	  function ActivityComposerTooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityComposerTooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityComposerTooltip.__proto__ || Object.getPrototypeOf(ActivityComposerTooltip)).call.apply(_ref, [this].concat(args))), _this), _this.onClose = function (event) {
	      event.stopPropagation();
	      _this.props.dismiss();
	    }, _this.mountActivityModal = function (event) {
	      event.stopPropagation();
	      (0, _modal.mountModal)(_react2.default.createElement(_ActivityCreateDialogContainer2.default, { onActivitySent: _this.props.onActivitySent }), _this);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityComposerTooltip, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'ActivityComposerTooltip',
	          onClick: this.mountActivityModal },
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityComposerTooltip-content' },
	          _react2.default.createElement(_Image2.default, {
	            className: 'ActivityComposerTooltip-content-img',
	            src: __webpack_require__(2021)
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'ActivityComposerTooltip-content-text' },
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                className: 'ActivityComposerTooltip-content-text-header',
	                onClick: this.mountActivityModal,
	                eventElementName: 'ActivityComposerTooltip-content-text-header' },
	              'Click to organize your event or activity on Remind'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'ActivityComposerTooltip-content-text-subtext' },
	              'Use Remind to send invitations, track participants, and collect funds!'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            color: 'koala',
	            level: 'text',
	            className: 'ActivityComposerTooltip-closeButton',
	            onClick: this.onClose,
	            eventElementName: 'ActivityComposerTooltip-closeButton' },
	          _react2.default.createElement(_Glyph2.default, { name: 'close', size: 'small', solo: true })
	        )
	      );
	    }
	  }]);
	
	  return ActivityComposerTooltip;
	}(_react.Component);
	
	ActivityComposerTooltip.displayName = 'ActivityComposerTooltip';
	exports.default = ActivityComposerTooltip;

/***/ },
/* 2047 */
1136,
/* 2048 */,
/* 2049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCount = getCount;
	exports.getRemainingCharacters = getRemainingCharacters;
	exports.getRemainingCharactersForText = getRemainingCharactersForText;
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCount(text) {
	  var charactersSetting = _SettingsStore2.default.getSetting('messages', 'characters');
	  var urlRegexp = charactersSetting ? new RegExp(charactersSetting.urlregexp, 'g') : null;
	
	  var numberOfUrlsInMessage = 0;
	  var textSansUrlsLength = text.replace(urlRegexp, function () {
	    numberOfUrlsInMessage++;
	    return '';
	  }).length;
	
	  var urlWeight = charactersSetting ? charactersSetting.urlweight : 0;
	  var urlsLength = urlWeight * numberOfUrlsInMessage;
	
	  return textSansUrlsLength + urlsLength;
	} /*  weak */
	function getRemainingCharacters(limit, limitWithFiles) {
	  var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var hasFiles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  return (hasFiles ? limitWithFiles : limit) - length;
	}
	
	function getRemainingCharactersForText(limit, limitWithFiles, text) {
	  var hasFiles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  return getRemainingCharacters(limit, limitWithFiles, getCount(text), hasFiles);
	}
	
	// require() compatibility and to support module spying
	exports.default = {
	  getCount: getCount,
	  getRemainingCharacters: getRemainingCharacters,
	  getRemainingCharactersForText: getRemainingCharactersForText
	};

/***/ },
/* 2050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(1241);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _Textarea = __webpack_require__(1598);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	__webpack_require__(2051);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var Composer = function (_React$Component) {
	  _inherits(Composer, _React$Component);
	
	  function Composer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Composer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Composer.__proto__ || Object.getPrototypeOf(Composer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      focused: false
	    }, _this.focus = function () {
	      _this.refs.textarea.focus();
	    }, _this.clear = function () {
	      _this.refs.textarea.clear();
	    }, _this.handleTextareaBlur = function () {
	      _this.setState({ focused: false });
	      if (_this.props.onBlur) {
	        _this.props.onBlur();
	      }
	    }, _this.handleTextareaFocus = function () {
	      _this.setState({ focused: true });
	      if (_this.props.onFocus) {
	        _this.props.onFocus();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Composer, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          error = _props.error,
	          className = _props.className,
	          onChange = _props.onChange,
	          placeholder = _props.placeholder,
	          indicator = _props.indicator,
	          onReturnKeyPress = _props.onReturnKeyPress,
	          rows = _props.rows,
	          value = _props.value;
	
	
	      var content = null;
	      if (children && _react2.default.Children.toArray(children).length) {
	        content = _react2.default.createElement(
	          'div',
	          { className: 'Composer-content' },
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('Composer', {
	            'Composer-focus': this.state.focused,
	            'Composer-error': error
	          }, className) },
	        _react2.default.createElement(
	          'div',
	          { className: 'Composer-input' },
	          _react2.default.createElement(_Textarea2.default, {
	            autogrow: true,
	            rows: rows,
	            ref: 'textarea',
	            className: 'Composer-input-textarea',
	            onFocus: this.handleTextareaFocus,
	            onBlur: this.handleTextareaBlur,
	            onReturnKeyPress: onReturnKeyPress,
	            onChange: onChange,
	            value: value,
	            placeholder: placeholder
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'Composer-input-indicator' },
	            indicator
	          )
	        ),
	        content
	      );
	    }
	  }]);
	
	  return Composer;
	}(_react2.default.Component);
	
	Composer.defaultProps = {
	  rows: 1
	};
	Composer.displayName = 'Composer';
	exports.default = Composer;

/***/ },
/* 2051 */
1136,
/* 2052 */,
/* 2053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _MessageStore = __webpack_require__(1232);
	
	var _MessageStore2 = _interopRequireDefault(_MessageStore);
	
	var _Timestamp = __webpack_require__(1683);
	
	var _Timestamp2 = _interopRequireDefault(_Timestamp);
	
	var _modal = __webpack_require__(1188);
	
	var _roleHelpers = __webpack_require__(1230);
	
	var _ScheduledAnnouncementsDialog = __webpack_require__(2054);
	
	var _ScheduledAnnouncementsDialog2 = _interopRequireDefault(_ScheduledAnnouncementsDialog);
	
	__webpack_require__(2077);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComposerAlert = function (_React$Component) {
	  _inherits(ComposerAlert, _React$Component);
	
	  _createClass(ComposerAlert, null, [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_MessageStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState, props) {
	      var group = props.group,
	          target = props.target;
	
	      var role = '';
	      if (target) {
	        role = target.role;
	      }
	      if (group) {
	        return {
	          messagesScheduled: _MessageStore2.default.getMessagesScheduled((0, _roleHelpers.getGroupKey)(group.id, role))
	        };
	      }
	
	      return {};
	    }
	  }]);
	
	  function ComposerAlert(props) {
	    _classCallCheck(this, ComposerAlert);
	
	    var _this = _possibleConstructorReturn(this, (ComposerAlert.__proto__ || Object.getPrototypeOf(ComposerAlert)).call(this, props));
	
	    _this.state = {
	      messagesScheduled: []
	    };
	    return _this;
	  }
	
	  _createClass(ComposerAlert, [{
	    key: 'openScheduledMessagesDialog',
	    value: function openScheduledMessagesDialog() {
	      var messagesScheduled = this.state.messagesScheduled;
	
	      (0, _modal.mountModal)(_react2.default.createElement(_ScheduledAnnouncementsDialog2.default, {
	        messagesScheduled: messagesScheduled,
	        group: this.props.group,
	        target: this.props.target
	      }), this);
	    }
	  }, {
	    key: 'renderOfficeHoursNotice',
	    value: function renderOfficeHoursNotice() {
	      var chat = this.props.chat;
	
	
	      if (!chat || chat.isUnsubscribed() || !chat.isPresent() || chat.getLeftMemberships()[0]) {
	        return null;
	      }
	
	      var message = void 0;
	      if (chat.isOutsideOfOtherOfficeHours()) {
	        message = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Glyph2.default, { name: 'clock' }),
	          'It\u2019s outside of office hours.'
	        );
	      } else if (!_CurrentUser2.default.getUser().getOfficeHours().isAvailableNow()) {
	        message = _react2.default.createElement(
	          _Link2.default,
	          { color: 'pitch', to: '/settings/chat' },
	          _react2.default.createElement(_Glyph2.default, { name: 'clock' }),
	          'It\u2019s outside of your office hours.'
	        );
	      }
	
	      if (message) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'ComposerAlert ComposerAlert-officeHours' },
	          message
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderRepliesDisabledNotice',
	    value: function renderRepliesDisabledNotice() {
	      var chat = this.props.chat;
	
	      var message = 'Replies are turned off';
	
	      if (chat.getMemberships().length > _Chat.MAX_PARTICIPANTS_REPLIES_ENABLE) {
	        message = 'Replies are turned off for group conversations with more than ' + _Chat.MAX_PARTICIPANTS_REPLIES_ENABLE + ' participants.';
	      }
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'ComposerAlert ComposerAlert-repliesDisabled',
	          onClick: this.props.openSideBar },
	        _react2.default.createElement(_Glyph2.default, { name: 'chat-close-bubble-fill', size: 'large' }),
	        message
	      );
	    }
	  }, {
	    key: 'renderUserMutedNotice',
	    value: function renderUserMutedNotice() {
	      var currentUser = _CurrentUser2.default.getUser();
	      var timestamp = _react2.default.createElement(_Timestamp2.default, { date: currentUser.getMutedUntil(), format: 'long' });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ComposerAlert' },
	        _react2.default.createElement(_Glyph2.default, { name: 'chat-close-bubble-fill', size: 'large' }),
	        'Your messaging privileges have been suspended until ',
	        timestamp,
	        '.',
	        ' ',
	        _react2.default.createElement(
	          _Link2.default,
	          { color: 'blue', href: _LinkConstants2.default.COMMUNITY_GUIDELINES, target: '_blank' },
	          'More Information'
	        ),
	        '.'
	      );
	    }
	  }, {
	    key: 'renderMembersMutedNotice',
	    value: function renderMembersMutedNotice() {
	      var chat = this.props.chat;
	
	
	      var otherMember = chat.getOtherMember();
	      var name = otherMember && otherMember.id !== -1 ? otherMember.name : 'Some participants in this conversation';
	
	      var message = name + ' may not be able to respond to your message right now.';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ComposerAlert' },
	        message
	      );
	    }
	  }, {
	    key: 'renderScheduledMessagesNotice',
	    value: function renderScheduledMessagesNotice() {
	      var _this2 = this;
	
	      var numScheduled = this.state.messagesScheduled.length;
	      var noticeText = numScheduled > 1 ? numScheduled + ' scheduled announcements' : '1 scheduled announcement';
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'ComposerAlert ComposerAlert-scheduledMessages',
	          onClick: function onClick() {
	            _this2.openScheduledMessagesDialog();
	          } },
	        _react2.default.createElement(_Glyph2.default, { name: 'schedule' }),
	        noticeText
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          chat = _props.chat,
	          group = _props.group;
	
	
	      if (_CurrentUser2.default.getUser().isMuted()) {
	        return this.renderUserMutedNotice();
	      }
	
	      if (chat) {
	        // NOTE: Should be repliesDisabled() but there may be a backend bug right now
	        if (chat.isDisabled()) {
	          return this.renderRepliesDisabledNotice();
	        } else if (chat.hasMutedMembers()) {
	          return this.renderMembersMutedNotice();
	        } else {
	          return this.renderOfficeHoursNotice();
	        }
	      }
	
	      if (group && this.state.messagesScheduled.length > 0) {
	        return this.renderScheduledMessagesNotice();
	      }
	
	      return null;
	    }
	  }]);
	
	  return ComposerAlert;
	}(_react2.default.Component);
	
	ComposerAlert.displayName = 'ComposerAlert';
	exports.default = _utils.Container.create(ComposerAlert, {
	  withProps: true,
	  pure: false
	});

/***/ },
/* 2054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Messages = __webpack_require__(1229);
	
	var _Messages2 = _interopRequireDefault(_Messages);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupScheduledMessageList = __webpack_require__(2055);
	
	var _GroupScheduledMessageList2 = _interopRequireDefault(_GroupScheduledMessageList);
	
	var _MessageStore = __webpack_require__(1232);
	
	var _MessageStore2 = _interopRequireDefault(_MessageStore);
	
	var _roleHelpers = __webpack_require__(1230);
	
	var _ScheduledAnnouncementsDialog = __webpack_require__(2075);
	
	var _ScheduledAnnouncementsDialog2 = _interopRequireDefault(_ScheduledAnnouncementsDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScheduledAnnouncementsDialog = function (_React$Component) {
	  _inherits(ScheduledAnnouncementsDialog, _React$Component);
	
	  _createClass(ScheduledAnnouncementsDialog, null, [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_MessageStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState, props) {
	      var group = props.group,
	          target = props.target;
	
	      var role = '';
	      if (target) {
	        role = target.role;
	      }
	      if (group) {
	        return {
	          messagesScheduled: _MessageStore2.default.getMessagesScheduled((0, _roleHelpers.getGroupKey)(group.id, role))
	        };
	      }
	
	      return {};
	    }
	  }]);
	
	  function ScheduledAnnouncementsDialog(props) {
	    _classCallCheck(this, ScheduledAnnouncementsDialog);
	
	    var _this = _possibleConstructorReturn(this, (ScheduledAnnouncementsDialog.__proto__ || Object.getPrototypeOf(ScheduledAnnouncementsDialog)).call(this, props));
	
	    _this.state = {
	      messagesScheduled: props.messagesScheduled
	    };
	    return _this;
	  }
	
	  _createClass(ScheduledAnnouncementsDialog, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!this.state.messagesScheduled || this.state.messagesScheduled.isEmpty()) {
	        this.props.onRequestHide();
	      }
	    }
	  }, {
	    key: 'renderScheduledMessages',
	    value: function renderScheduledMessages() {
	      return _react2.default.createElement(_GroupScheduledMessageList2.default, {
	        group: this.props.group,
	        className: _ScheduledAnnouncementsDialog2.default.messageList,
	        messages: this.state.messagesScheduled
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'ScheduledAnnouncementsDialog'
	        }, this.props, {
	          className: _ScheduledAnnouncementsDialog2.default.this,
	          title: 'Scheduled Announcements',
	          size: 'medium' }),
	        _react2.default.createElement(
	          'div',
	          { className: _ScheduledAnnouncementsDialog2.default.dialogBodyWrapper },
	          this.renderScheduledMessages()
	        )
	      );
	    }
	  }]);
	
	  return ScheduledAnnouncementsDialog;
	}(_react2.default.Component);
	
	ScheduledAnnouncementsDialog.displayName = 'ScheduledAnnouncementsDialog';
	exports.default = _utils.Container.create(ScheduledAnnouncementsDialog, {
	  withProps: true,
	  pure: false
	});

/***/ },
/* 2055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupScheduledMessage = __webpack_require__(2056);
	
	var _GroupScheduledMessage2 = _interopRequireDefault(_GroupScheduledMessage);
	
	var _Messages = __webpack_require__(1229);
	
	var _Messages2 = _interopRequireDefault(_Messages);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2073);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupScheduledMessageList = function (_React$Component) {
	  _inherits(GroupScheduledMessageList, _React$Component);
	
	  function GroupScheduledMessageList() {
	    _classCallCheck(this, GroupScheduledMessageList);
	
	    return _possibleConstructorReturn(this, (GroupScheduledMessageList.__proto__ || Object.getPrototypeOf(GroupScheduledMessageList)).apply(this, arguments));
	  }
	
	  _createClass(GroupScheduledMessageList, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          messages = _props.messages,
	          className = _props.className;
	
	      var messageList = messages.toArray().sort(function (a, b) {
	        return a.getSendAt() - b.getSendAt();
	      }).map(function (message) {
	        return _react2.default.createElement(_GroupScheduledMessage2.default, {
	          className: (0, _classnames2.default)({
	            'GroupScheduledMessageList-item': true,
	            'GroupScheduledMessageList-non-collapsible-item': true
	          }),
	          key: message.get('uuid'),
	          message: message,
	          group: _this2.props.group
	        });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('GroupScheduledMessageList', 'GroupScheduledMessageList-non-collapsible', className) },
	        _react2.default.createElement(
	          'div',
	          { key: 'messageList' },
	          messageList
	        )
	      );
	    }
	  }]);
	
	  return GroupScheduledMessageList;
	}(_react2.default.Component);
	
	GroupScheduledMessageList.displayName = 'GroupScheduledMessageList';
	exports.default = GroupScheduledMessageList;

/***/ },
/* 2056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _MessageActions = __webpack_require__(1228);
	
	var _MessageActions2 = _interopRequireDefault(_MessageActions);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _MessageItemContent = __webpack_require__(2057);
	
	var _MessageItemContent2 = _interopRequireDefault(_MessageItemContent);
	
	var _EditScheduledMessageComposer = __webpack_require__(2067);
	
	var _EditScheduledMessageComposer2 = _interopRequireDefault(_EditScheduledMessageComposer);
	
	var _GroupMessageBase = __webpack_require__(1253);
	
	var _GroupMessageBase2 = _interopRequireDefault(_GroupMessageBase);
	
	var _GroupMessageHeader = __webpack_require__(1305);
	
	var _GroupMessageHeader2 = _interopRequireDefault(_GroupMessageHeader);
	
	var _GroupMessageHeaderAction = __webpack_require__(2068);
	
	var _GroupMessageHeaderAction2 = _interopRequireDefault(_GroupMessageHeaderAction);
	
	var _GroupMessageInformation = __webpack_require__(1646);
	
	var _GroupMessageInformation2 = _interopRequireDefault(_GroupMessageInformation);
	
	__webpack_require__(2071);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupScheduledMessage = function (_React$Component) {
	  _inherits(GroupScheduledMessage, _React$Component);
	
	  function GroupScheduledMessage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupScheduledMessage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupScheduledMessage.__proto__ || Object.getPrototypeOf(GroupScheduledMessage)).call.apply(_ref, [this].concat(args))), _this), _this.remove = function () {
	      _MessageActions2.default.destroyScheduledMessage(_this.props.message);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupScheduledMessage, [{
	    key: 'clickHandler',
	
	
	    // TODO: Figure out a better way to ignore this click
	    // while allowing the event to bubble
	    // typecheck: ignore statement
	    value: function clickHandler(event) {
	      // Prevents the GroupScheduledMessageList from toggling
	      // when clicking inside its child (i.e., this)
	      event.stopPropagation();
	    }
	  }, {
	    key: 'renderMessage',
	    value: function renderMessage() {
	      var message = this.props.message;
	
	      var senderId = message && message.getSender().id;
	      return _react2.default.createElement(
	        _GroupMessageBase2.default,
	        {
	          message: message },
	        _react2.default.createElement(
	          _GroupMessageHeader2.default,
	          {
	            author: message && message.getSender().getName(),
	            initials: message && message.getSender().getInitials(),
	            color: message && message.getSender().getColor(),
	            senderId: senderId },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _ModalTrigger2.default,
	              {
	                modal: _react2.default.createElement(_EditScheduledMessageComposer2.default, { message: message, onRequestHide: function onRequestHide() {
	                    return _MessageActions2.default.clearDraftAnnouncement();
	                  } }) },
	              _react2.default.createElement(
	                _Button2.default,
	                { level: 'secondary', size: 'small' },
	                'Edit'
	              )
	            ),
	            this.renderRemoveAction()
	          )
	        ),
	        _react2.default.createElement(_MessageItemContent2.default, { message: message, failed: false }),
	        _react2.default.createElement(_GroupMessageInformation2.default, null)
	      );
	    }
	  }, {
	    key: 'renderRemoveAction',
	    value: function renderRemoveAction() {
	      var modal = _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'GroupScheduledMessage',
	        title: 'Are you sure you want to delete this announcement?',
	        actionButtonText: 'Delete',
	        cancelButtonText: 'Cancel',
	        onConfirm: this.remove
	      });
	
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: modal, 'data-test-selector': 'delete-modal-trigger' },
	        _react2.default.createElement(
	          _GroupMessageHeaderAction2.default,
	          { color: 'lava' },
	          'Delete'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('GroupScheduledMessage', className), onClick: this.clickHandler },
	        this.renderMessage()
	      );
	    }
	  }]);
	
	  return GroupScheduledMessage;
	}(_react2.default.Component);
	
	GroupScheduledMessage.displayName = 'GroupScheduledMessage';
	exports.default = GroupScheduledMessage;

/***/ },
/* 2057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _MessageInterfacePropType = __webpack_require__(2058);
	
	var _MessageInterfacePropType2 = _interopRequireDefault(_MessageInterfacePropType);
	
	var _MessageItemAttachment = __webpack_require__(2059);
	
	var _MessageItemAttachment2 = _interopRequireDefault(_MessageItemAttachment);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	var _TranslatableText = __webpack_require__(1300);
	
	var _TranslatableText2 = _interopRequireDefault(_TranslatableText);
	
	__webpack_require__(2065);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UI_CONTEXT = 'chat_message';
	
	var MessageItemContent = function (_React$Component) {
	  _inherits(MessageItemContent, _React$Component);
	
	  function MessageItemContent(props) {
	    _classCallCheck(this, MessageItemContent);
	
	    var _this = _possibleConstructorReturn(this, (MessageItemContent.__proto__ || Object.getPrototypeOf(MessageItemContent)).call(this, props));
	
	    _this.translate = function () {
	      var shouldTranslateToMessageLocal = _this.state.language === _this.props.message.getISO639Locale();
	
	      var language = shouldTranslateToMessageLocal ? _CurrentUser2.default.getUser().getISO639Locale() : _this.props.message.getISO639Locale();
	
	      _this.setState({ language: language });
	
	      var elementName = shouldTranslateToMessageLocal ? 'translation_show_translation' : 'translation_show_orignal';
	
	      _EventTracking2.default.tap(_this.context.eventScreenName, elementName, UI_CONTEXT);
	    };
	
	    _this.state = {
	      language: _this.props.message.getISO639Locale()
	    };
	    return _this;
	  }
	
	  /* Translate the message.
	   * Toogles the language between the message locale & the user locale.
	   */
	
	
	  _createClass(MessageItemContent, [{
	    key: 'isMessageTranslatable',
	    value: function isMessageTranslatable() {
	      return !!(
	      // a user is signed in
	      _CurrentUser2.default.isSignedIn() &&
	      // current user was not the sender
	      this.props.message.getSender().id !== _CurrentUser2.default.getUserId() &&
	      // the locales are defined on the user & the message
	      _CurrentUser2.default.getUser().getISO639Locale() && this.props.message.getISO639Locale() &&
	      // the locales differs from one another.
	      this.props.message.getISO639Locale() !== _CurrentUser2.default.getUser().getISO639Locale());
	    }
	  }, {
	    key: 'renderMessageAttachment',
	    value: function renderMessageAttachment() {
	      var message = this.props.message;
	
	      var file = message.getFile();
	      if (!file) {
	        return null;
	      }
	      return _react2.default.createElement(_MessageItemAttachment2.default, { file: file });
	    }
	  }, {
	    key: 'renderMessageBody',
	    value: function renderMessageBody() {
	      var message = this.props.message;
	
	      var body = message.getBody();
	      if (!body) {
	        return null;
	      }
	
	      var messageBody = this.isMessageTranslatable() ? _react2.default.createElement(_TranslatableText2.default, {
	        text: body,
	        language: this.state.language
	      }) : _react2.default.createElement(_TextWithEntities2.default, {
	        text: body,
	        entities: [].concat(_TextEntities2.default.parseEmoji(body), _TextEntities2.default.parseShortcodeEmoji(body), _TextEntities2.default.parseNewlines(body), _TextEntities2.default.parseLeadingWhitespace(body), _TextEntities2.default.parseUrls(body)),
	        shallow: true
	      });
	
	      if (this.isMessageTranslatable()) {
	        // BUG messageBody may have a URL transformed to a Link,
	        // which causes a validateDOMNesting <a> error
	        messageBody = _react2.default.createElement(
	          _Link2.default,
	          {
	            color: 'inherit',
	            onClick: this.translate,
	            className: 'MessageItem-Translatable',
	            eventElementName: 'MessageItem-Translatable' },
	          messageBody
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('MessageItemContent-body', {
	            'MessageItemContent-failedBody': this.props.failed
	          }) },
	        messageBody
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(this.props.className, {
	            'MessageItemContent-self': this.props.sentBySelf
	          }) },
	        this.renderMessageBody(),
	        this.renderMessageAttachment()
	      );
	    }
	  }]);
	
	  return MessageItemContent;
	}(_react2.default.Component);
	
	MessageItemContent.contextTypes = {
	  eventScreenName: _react2.default.PropTypes.string
	};
	MessageItemContent.displayName = 'MessageItemContent';
	exports.default = MessageItemContent;

/***/ },
/* 2058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.shape({
	  getISO639Locale: _react2.default.PropTypes.func.isRequired,
	  getBody: _react2.default.PropTypes.func.isRequired,
	  getSender: _react2.default.PropTypes.func.isRequired,
	  getSentAt: _react2.default.PropTypes.func.isRequired,
	  getActivity: _react2.default.PropTypes.func.isRequired,
	  getUuid: _react2.default.PropTypes.func.isRequired,
	  getType: _react2.default.PropTypes.func.isRequired,
	  getMessage: _react2.default.PropTypes.func,
	  getChatId: _react2.default.PropTypes.func
	}), _react2.default.PropTypes.instanceOf(_Message.GapMessage), _react2.default.PropTypes.instanceOf(_ChatMessage.ChatGapMessage)]);

/***/ },
/* 2059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _File = __webpack_require__(929);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _FileTypes = __webpack_require__(1293);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _MessageItemImageAttachment = __webpack_require__(2060);
	
	var _MessageItemImageAttachment2 = _interopRequireDefault(_MessageItemImageAttachment);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Video = __webpack_require__(1297);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _Audio = __webpack_require__(1258);
	
	var _Audio2 = _interopRequireDefault(_Audio);
	
	var _filesize = __webpack_require__(1294);
	
	var _filesize2 = _interopRequireDefault(_filesize);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2063);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageItemAttachment = function (_React$Component) {
	  _inherits(MessageItemAttachment, _React$Component);
	
	  function MessageItemAttachment() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MessageItemAttachment);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MessageItemAttachment.__proto__ || Object.getPrototypeOf(MessageItemAttachment)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.hoverOn = function () {
	      return _this.setState({ hover: true });
	    }, _this.hoverOff = function () {
	      return _this.setState({ hover: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MessageItemAttachment, [{
	    key: 'renderAudioPreview',
	    value: function renderAudioPreview(file) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'MessageItemAttachment-multimedia' },
	        _react2.default.createElement(_Audio2.default, {
	          src: file.getUrls().cdn,
	          key: file.id
	        })
	      );
	    }
	  }, {
	    key: 'renderImagePreview',
	    value: function renderImagePreview(file) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'MessageItemAttachment-multimedia' },
	        _react2.default.createElement(_MessageItemImageAttachment2.default, { file: file })
	      );
	    }
	  }, {
	    key: 'renderVideoPreview',
	    value: function renderVideoPreview(file) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'MessageItemAttachment-multimedia MessageItemAttachment-video' },
	        _react2.default.createElement(_Video2.default, {
	          src: file.getUrls().cdn,
	          key: file.id
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var file = this.props.file;
	
	      var type = file.getContentType();
	
	      if (_Image2.default.isSupportedType(type)) {
	        return this.renderImagePreview(file);
	      } else if (_Audio2.default.isSupportedType(type)) {
	        return this.renderAudioPreview(file);
	      } else if (_Video2.default.isSupportedType(type)) {
	        return this.renderVideoPreview(file);
	      }
	
	      var size = file.getSize();
	      if (size) {
	        size = (0, _filesize2.default)(size, { round: 0 }).toUpperCase();
	      }
	
	      var urls = file.getUrls();
	      var glyphName = this.state.hover ? 'download' : (0, _FileTypes.getGlyphName)(type);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'MessageItemAttachment' },
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            className: 'MessageItemAttachment-icon',
	            onMouseLeave: this.hoverOff,
	            onMouseEnter: this.hoverOn,
	            href: urls.cdn,
	            target: '_blank',
	            eventElementName: 'MessageItemAttachment-icon' },
	          _react2.default.createElement(_Glyph2.default, { name: glyphName, size: 'xlarge', solo: true })
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)({
	              'MessageItemAttachment-info': true,
	              hovered: this.state.hover }) },
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              className: 'MessageItemAttachment-name',
	              href: urls.cdn,
	              target: '_blank',
	              eventElementName: 'MessageItemAttachment-name' },
	            file.getName()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'MessageItemAttachment-metadata' },
	            _react2.default.createElement(
	              'em',
	              null,
	              size
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MessageItemAttachment;
	}(_react2.default.Component);
	
	MessageItemAttachment.displayName = 'MessageItemAttachment';
	exports.default = MessageItemAttachment;

/***/ },
/* 2060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _File = __webpack_require__(929);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ImageFilePreviewModal = __webpack_require__(1271);
	
	var _ImageFilePreviewModal2 = _interopRequireDefault(_ImageFilePreviewModal);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2061);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageItemImageAttachment = function (_React$Component) {
	  _inherits(MessageItemImageAttachment, _React$Component);
	
	  function MessageItemImageAttachment() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MessageItemImageAttachment);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MessageItemImageAttachment.__proto__ || Object.getPrototypeOf(MessageItemImageAttachment)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loading: true
	    }, _this.handleImageOnLoad = function () {
	      _this.setState({ loading: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // NOTE: This is a hack to prevent images from breaking the scrolled-to-bottom behavior of the
	  // conversation view. This wouldn't be necessary if images were rendered with dimensions (need
	  // dimensions from the backend). This causes a little bit of jank (a bit of a flash when the
	  // image loads).
	
	
	  _createClass(MessageItemImageAttachment, [{
	    key: 'render',
	    value: function render() {
	      var file = this.props.file;
	
	      var urls = file.getUrls();
	
	      var placeholder = null;
	      if (this.state.loading) {
	        var dimensions = file.getPreviewDimensions(_File.MAX_IMAGE_PREVIEW_HEIGHT);
	        var lineHeight = dimensions.height ? { lineHeight: dimensions.height + 'px' } : {};
	        placeholder = _react2.default.createElement(
	          _Link2.default,
	          {
	            style: _extends({}, dimensions, lineHeight),
	            className: 'MessageItemImageAttachment-icon',
	            target: '_blank',
	            eventElementName: 'MessageItemImageAttachment-icon' },
	          _react2.default.createElement(_Glyph2.default, { name: 'image', size: 'xxxlarge', solo: true })
	        );
	      }
	
	      var modal = _react2.default.createElement(_ImageFilePreviewModal2.default, { file: file });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)({
	            MessageItemImageAttachment: true,
	            'MessageItemImageAttachment-loading': this.state.loading
	          }) },
	        placeholder,
	        _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: modal },
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              className: 'MessageItemImageAttachment-link',
	              eventElementName: 'MessageItemImageAttachment-link' },
	            _react2.default.createElement(_Image2.default, {
	              className: 'MessageItemImageAttachment-image',
	              style: { maxHeight: _File.MAX_IMAGE_PREVIEW_HEIGHT },
	              src: urls.cdn,
	              onLoad: this.handleImageOnLoad
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MessageItemImageAttachment;
	}(_react2.default.Component);
	
	MessageItemImageAttachment.displayName = 'MessageItemImageAttachment';
	exports.default = MessageItemImageAttachment;

/***/ },
/* 2061 */
1136,
/* 2062 */,
/* 2063 */
1136,
/* 2064 */,
/* 2065 */
1136,
/* 2066 */,
/* 2067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _RoleBasedMessagingComposer = __webpack_require__(2043);
	
	var _RoleBasedMessagingComposer2 = _interopRequireDefault(_RoleBasedMessagingComposer);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditScheduledMessageComposer = function (_React$Component) {
	  _inherits(EditScheduledMessageComposer, _React$Component);
	
	  function EditScheduledMessageComposer() {
	    _classCallCheck(this, EditScheduledMessageComposer);
	
	    return _possibleConstructorReturn(this, (EditScheduledMessageComposer.__proto__ || Object.getPrototypeOf(EditScheduledMessageComposer)).apply(this, arguments));
	  }
	
	  _createClass(EditScheduledMessageComposer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        {
	          eventScreenName: 'EditScheduledMessageComposer',
	          size: 'large',
	          onRequestHide: this.props.onRequestHide },
	        _react2.default.createElement(
	          'div',
	          { className: 'GroupScheduledMessage-composer-dialog' },
	          _react2.default.createElement(_RoleBasedMessagingComposer2.default, {
	            initialMessage: this.props.message,
	            onRequestHide: this.props.onRequestHide,
	            onMessageSent: this.props.onRequestHide,
	            charLimit: _CurrentUser2.default.getUser().getAnnouncementCharactersLimit(),
	            charLimitWithFiles: _CurrentUser2.default.getUser().getAnnouncementCharactersLimitWithFiles(),
	            isEdit: true
	          })
	        )
	      );
	    }
	  }]);
	
	  return EditScheduledMessageComposer;
	}(_react2.default.Component);
	
	EditScheduledMessageComposer.displayName = 'EditScheduledMessageComposer';
	exports.default = EditScheduledMessageComposer;

/***/ },
/* 2068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2069);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupMessageHeaderAction = function (_React$Component) {
	  _inherits(GroupMessageHeaderAction, _React$Component);
	
	  function GroupMessageHeaderAction() {
	    _classCallCheck(this, GroupMessageHeaderAction);
	
	    return _possibleConstructorReturn(this, (GroupMessageHeaderAction.__proto__ || Object.getPrototypeOf(GroupMessageHeaderAction)).apply(this, arguments));
	  }
	
	  _createClass(GroupMessageHeaderAction, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          className: (0, _classnames2.default)('GroupMessageHeaderAction', (0, _getPropClasses.getPropClassesFromInstance)(this)),
	          level: 'text',
	          size: 'small',
	          onClick: this.props.onClick },
	        this.props.children
	      );
	    }
	  }]);
	
	  return GroupMessageHeaderAction;
	}(_react2.default.Component);
	
	GroupMessageHeaderAction.propClasses = {
	  color: {
	    lava: 'GroupMessageHeaderAction-lava',
	    brand: 'GroupMessageHeaderAction-brand'
	  }
	};
	GroupMessageHeaderAction.defaultProps = {
	  color: 'brand'
	};
	GroupMessageHeaderAction.displayName = 'GroupMessageHeaderAction';
	exports.default = GroupMessageHeaderAction;

/***/ },
/* 2069 */
1136,
/* 2070 */,
/* 2071 */
1136,
/* 2072 */,
/* 2073 */
1136,
/* 2074 */,
/* 2075 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"this":"ScheduledAnnouncementsDialog__this___3LCOi","messageList":"ScheduledAnnouncementsDialog__messageList___1X2wH","dialogBodyWrapper":"ScheduledAnnouncementsDialog__dialogBodyWrapper___3rWVH"};

/***/ },
/* 2076 */,
/* 2077 */
1136,
/* 2078 */,
/* 2079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FileTypes = __webpack_require__(1293);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _File = __webpack_require__(929);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _ImageFilePreviewModal = __webpack_require__(1271);
	
	var _ImageFilePreviewModal2 = _interopRequireDefault(_ImageFilePreviewModal);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2080);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComposerFilePreview = function (_React$Component) {
	  _inherits(ComposerFilePreview, _React$Component);
	
	  function ComposerFilePreview() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ComposerFilePreview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ComposerFilePreview.__proto__ || Object.getPrototypeOf(ComposerFilePreview)).call.apply(_ref, [this].concat(args))), _this), _this.getProgress = function () {
	      if (_this.props.error) {
	        return 0;
	      }
	      var percent = Math.pow(_this.props.progress / 100, 0.7);
	      return Math.floor(percent * 100);
	    }, _this.isFileThumbnail = function () {
	      var file = _this.props.file;
	
	      return file && _Image2.default.isSupportedType(file.getContentType());
	    }, _this.renderPreview = function () {
	      var file = _this.props.file;
	
	
	      var preview = null;
	      if (_this.props.thumbnail) {
	        preview = _react2.default.createElement(_Image2.default, { className: 'ComposerFilePreview-image', src: _this.props.thumbnail });
	      } else if (_this.isFileThumbnail()) {
	        preview = _react2.default.createElement('div', {
	          className: (0, _classnames2.default)('ComposerFilePreview-image', 'ComposerFilePreview-imageBackground'),
	          style: {
	            background: 'url("' + file.getUrls().cdn + '")',
	            backgroundSize: 'cover'
	          }
	        });
	      } else {
	        preview = _react2.default.createElement(_Glyph2.default, {
	          className: 'ComposerFilePreview-glyph',
	          name: (0, _FileTypes.getGlyphName)(_this.props.type),
	          size: 'xlarge',
	          solo: true
	        });
	      }
	
	      if (file) {
	        var url = file.getUrls().cdn;
	        if (_Image2.default.isSupportedType(file.getContentType())) {
	          var modal = _react2.default.createElement(_ImageFilePreviewModal2.default, { file: file });
	          preview = _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: modal },
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                className: 'MessageItemAttachment-image',
	                href: url,
	                target: '_blank',
	                eventElementName: 'MessageItemAttachment-image' },
	              preview
	            )
	          );
	        } else {
	          preview = _react2.default.createElement(
	            _Link2.default,
	            {
	              className: 'MessageItemAttachment-icon',
	              href: url,
	              target: '_blank',
	              eventElementName: 'MessageItemAttachment-icon' },
	            preview
	          );
	        }
	      }
	
	      return preview;
	    }, _this.renderStatus = function () {
	      if (_this.props.error) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Glyph2.default, { name: 'caution', color: 'lava' }),
	          ' ',
	          'Upload error.',
	          ' ',
	          _react2.default.createElement(
	            _Link2.default,
	            { color: 'inherit', weight: 'semibold', onClick: _this.props.onRetry },
	            'Retry'
	          ),
	          ' ',
	          'or',
	          ' ',
	          _react2.default.createElement(
	            _Link2.default,
	            { color: 'inherit', weight: 'semibold', onClick: _this.props.onDelete },
	            'Cancel'
	          ),
	          '?'
	        );
	      }
	      if (_this.props.progress < 100) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'ComposerFilePreview-progress' },
	            'Uploading\u2026 ',
	            _this.getProgress(),
	            '%'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'ComposerFilePreview-cancelUploadButton',
	              level: 'text',
	              color: 'brand',
	              onClick: _this.props.onDelete,
	              eventElementName: 'ComposerFilePreview-cancelUploadButton' },
	            _react2.default.createElement(_Glyph2.default, { name: 'close-circle', size: 'xlarge', solo: true })
	          )
	        );
	      } else if (_this.props.onDelete) {
	        return _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'ComposerFilePreview-cancelAttachButton',
	            level: 'text',
	            color: 'brand',
	            onClick: _this.props.onDelete,
	            eventElementName: 'ComposerFilePreview-cancelAttachButton' },
	          _react2.default.createElement(_Glyph2.default, { name: 'close-circle', size: 'xlarge', solo: true })
	        );
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // If only I could put quotes around "Progress"
	
	
	  // When editing an announcement that has an image attachement,
	  // we don't have the thumbnail that we usually have during uploading,
	  // but we can display the image itself as a pseudo-thumbnail
	
	
	  _createClass(ComposerFilePreview, [{
	    key: 'render',
	    value: function render() {
	      var preview = this.renderPreview();
	      var status = this.renderStatus();
	      return _react2.default.createElement(
	        'div',
	        { className: 'ComposerFilePreview' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)({
	              'ComposerFilePreview-preview': true,
	              'ComposerFilePreview-previewNoThumbnail': !(this.props.thumbnail || this.isFileThumbnail())
	            }) },
	          preview,
	          _react2.default.createElement('div', {
	            className: 'ComposerFilePreview-mask',
	            style: { width: 100 - this.getProgress() + '%' }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ComposerFilePreview-status' },
	          status
	        )
	      );
	    }
	  }]);
	
	  return ComposerFilePreview;
	}(_react2.default.Component);
	
	ComposerFilePreview.defaultProps = { progress: 0, error: false };
	ComposerFilePreview.displayName = 'ComposerFilePreview';
	exports.default = ComposerFilePreview;

/***/ },
/* 2080 */
1136,
/* 2081 */,
/* 2082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _File = __webpack_require__(929);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _FileDropzoneMixinSupport = __webpack_require__(1505);
	
	var _FileDropzoneMixinSupport2 = _interopRequireDefault(_FileDropzoneMixinSupport);
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var mixin = {
	  uploadURL: null,
	
	  getUploadURL: function getUploadURL() {
	    return this.uploadURL;
	  },
	
	
	  // NOTE: file is a File web interface object
	  // Its properties must be parsed individually (can't do new File(file))
	  parseFile: function parseFile(file) {
	    return new _File2.default({
	      id: file.id,
	      content_type: file.type,
	      size: file.size,
	      name: file.name,
	      urls: file.urls
	    });
	  },
	  updateRemainingCharacters: function updateRemainingCharacters() {
	    // Awful coupling to components using this mixin =(
	    if (this.getRemainingCharacters) {
	      var remainingCharactersCount = this.getRemainingCharacters(this.state.text);
	      this.setState({ remainingCharactersCount: remainingCharactersCount });
	    }
	  },
	  handleAddedFile: function handleAddedFile(file) {
	    file.key = _lodash2.default.uniqueId();
	
	    this.state.fileData[file.key] = { type: file.type };
	    this.state.fileEntities[file.key] = this.parseFile(file);
	
	    this.setState({
	      files: this.state.files.concat(file)
	    }, this.updateRemainingCharacters);
	  },
	  handleRemovedFile: function handleRemovedFile(file) {
	    var fileIndex = this.state.files.indexOf(file);
	    this.state.files.splice(fileIndex, 1);
	    delete this.state.fileData[file.key];
	    delete this.state.fileEntities[file.key];
	
	    this.setState({
	      files: this.state.files,
	      fileEntities: this.state.fileEntities,
	      fileData: this.state.fileData
	    }, this.updateRemainingCharacters);
	  },
	  handleThumbnail: function handleThumbnail(file, dataUrl) {
	    this.state.fileData[file.key].thumbnail = dataUrl;
	  },
	  handleUploadProgress: function handleUploadProgress(file, progress /* , bytesSent */) {
	    this.state.fileData[file.key].progress = progress;
	    this.setState({ fileData: this.state.fileData });
	  },
	  handleAcceptFile: function handleAcceptFile(file, done) {
	    var _this = this;
	
	    var send = function send() {
	      var img = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var request = (0, _apiRequest2.default)('/files', 'POST', {
	        file: {
	          name: file.name,
	          height: img.height || 0,
	          width: img.width || 0
	        }
	      });
	      request.then(function (response) {
	        _this.uploadURL = response.upload_url;
	        _this.uploadFields = response.fields;
	        file.id = response.id;
	        _this.state.fileEntities[file.key].set('id', response.id);
	        done();
	        _this._getDropzone().processQueue();
	      }, function () {
	        _this.handleUploadError(file);
	        done('Unable to upload file');
	      });
	    };
	
	    // Detect if the uploaded file is an image by attempting to load it as such.
	    var fileReader = new FileReader(); // eslint-disable-line no-undef
	    fileReader.onload = function () {
	      var imgDataUri = fileReader.result;
	      var img = document.createElement('img');
	      img.onload = function () {
	        send(img);
	      };
	      img.onerror = send;
	      img.src = imgDataUri;
	    };
	    fileReader.readAsDataURL(file);
	  },
	  handleSendingFile: function handleSendingFile(file, xhr, formData) {
	    var _this2 = this;
	
	    Object.keys(this.uploadFields).forEach(function (key) {
	      formData.append(key, _this2.uploadFields[key]);
	    });
	  },
	  handleUploadSuccess: function handleUploadSuccess(file) {
	    var _this3 = this;
	
	    var request = (0, _apiRequest2.default)('/files/' + file.id + '/ack', 'POST', {});
	    request.then(function (response) {
	      _this3.state.fileEntities[file.key] = _File2.default.fromJSON(response);
	      _this3.setState({
	        uploadedFile: _File2.default.fromJSON(response),
	        fileEntities: _this3.state.fileEntities
	      });
	      if (_this3.onUploadSuccess) {
	        _this3.onUploadSuccess(file);
	      }
	    }, function () {
	      return _this3.handleUploadError(file);
	    });
	  },
	  handleUploadError: function handleUploadError(file, error) {
	    // A second file is attempting to be uploaded
	    if (this.state.files.length > 1) {
	      this.removeFile(file);
	      return;
	    }
	
	    console.warn('Upload Error', error);
	    this.state.fileData[file.key].error = error;
	    this.setState({ fileData: this.state.fileData });
	    if (this.onUploadFailed) {
	      this.onUploadFailed(this.state.fileEntities[file.key], error);
	    }
	  },
	  handleFileFromId: function handleFileFromId(fileId, message) {
	    var request = (0, _apiRequest2.default)('/files/' + fileId, 'GET');
	    request.then(function (response) {
	      message.setOnlyFile(response);
	    });
	    return request;
	  }
	};
	
	var FileUploaderMixin = Object.assign(mixin, _FileDropzoneMixinSupport2.default);
	
	exports.default = FileUploaderMixin;

/***/ },
/* 2083 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Hovercard = __webpack_require__(1548);
	
	var _Hovercard2 = _interopRequireDefault(_Hovercard);
	
	var _HovercardBody = __webpack_require__(1554);
	
	var _HovercardBody2 = _interopRequireDefault(_HovercardBody);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	__webpack_require__(2084);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var LanguageHoverCard = function (_React$Component) {
	  _inherits(LanguageHoverCard, _React$Component);
	
	  function LanguageHoverCard() {
	    _classCallCheck(this, LanguageHoverCard);
	
	    return _possibleConstructorReturn(this, (LanguageHoverCard.__proto__ || Object.getPrototypeOf(LanguageHoverCard)).apply(this, arguments));
	  }
	
	  _createClass(LanguageHoverCard, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var languageNames = Object.assign({}, _SettingsStore2.default.getLanguages().secondary, this.props.additionalLanguages);
	
	      var sortedLanguages = Object.entries(languageNames).map(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            code = _ref2[0],
	            name = _ref2[1];
	
	        return { code: code, name: name };
	      }).sort(function (a, b) {
	        return +(a.name > b.name) || +(a.name === b.name) - 1;
	      });
	
	      var items = sortedLanguages.map(function (language) {
	        return _react2.default.createElement(
	          _Button2.default,
	          _extends({}, _this2.props, {
	            key: language.code,
	            level: 'text',
	            className: 'LanguageHoverCard-language',
	            eventScreenName: 'language_dialog',
	            eventElementName: 'translate_button',
	            eventProperties: {
	              language_code: language.code
	            },
	            onClick: function onClick() {
	              _this2.props.onRequestHide();
	              _this2.props.onLanguagePicked(language.code);
	            } }),
	          language.name
	        );
	      });
	
	      return _react2.default.createElement(
	        _Hovercard2.default,
	        _extends({}, this.props, {
	          className: (0, _classnames2.default)('LanguageHoverCard', this.props.className) }),
	        _react2.default.createElement(
	          _HovercardBody2.default,
	          { className: 'LanguageHoverCard-body' },
	          items
	        )
	      );
	    }
	  }]);
	
	  return LanguageHoverCard;
	}(_react2.default.Component);
	
	LanguageHoverCard.defaultProps = {
	  additionalLanguages: {}
	};
	LanguageHoverCard.displayName = 'LanguageHoverCard';
	exports.default = LanguageHoverCard;

/***/ },
/* 2084 */
1136,
/* 2085 */,
/* 2086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.showPromptDialog = undefined;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LocalUserSettings = __webpack_require__(2087);
	
	var _LocalUserSettings2 = _interopRequireDefault(_LocalUserSettings);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _WebNotificationPreAskModal = __webpack_require__(2088);
	
	var _WebNotificationPreAskModal2 = _interopRequireDefault(_WebNotificationPreAskModal);
	
	var _WebNotificationStore = __webpack_require__(2096);
	
	var _WebNotificationStore2 = _interopRequireDefault(_WebNotificationStore);
	
	var _modal = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MILLIS_PER_DAY = 24 * 60 * 60 * 1000;
	
	var promptDefs = _defineProperty({}, _PromptConstants.PromptNames.DESKTOP_NOTIFICATION_MODAL, {
	  /*
	    reAskIntervals is the intervals of time that we show the modal.
	      e.g., we show the modal on the 0th day, the 4rd day after, then the 4th day after that
	    The notification preask modal is shown under the following conditions:
	    - The notifications are compatible
	    - Browser settings is either 'granted' or 'default'
	      - If another user granted browser permission for notifications,
	        we still have to show the modal for enabling it for another user
	    - User permission is false (which is by default)
	    - We have shown the modal less times than we have reAskIntervals
	    - If either (there is no last prompt) or (if the time since the last prompt
	      is longer than the last interval)
	  */
	  meetsCondition: function meetsCondition() {
	    // all the logic below depends on being able to record prompts
	    if (!_LocalUserSettings2.default.isEnabled()) {
	      return false;
	    }
	
	    var prompts = _LocalUserSettings2.default.getUserProperties().prompts.filter(function (prompt) {
	      return prompt.name === _PromptConstants.PromptNames.DESKTOP_NOTIFICATION_MODAL;
	    }).sort(function (p1, p2) {
	      return p1.date - p2.date;
	    });
	    var lastPrompt = prompts.length > 0 ? prompts[prompts.length - 1] : null;
	
	    var reAskIntervals = [0, 4, 4].map(function (days) {
	      return days * MILLIS_PER_DAY;
	    });
	
	    return _WebNotificationStore2.default.areNotificationsCompatible() && _WebNotificationStore2.default.getBrowserPermission() !== 'denied' && !_WebNotificationStore2.default.areNotificationsUserEnabled() && prompts.length < reAskIntervals.length && (!lastPrompt || lastPrompt.date < Date.now() - reAskIntervals[prompts.length]);
	  },
	  display: function display(triggeredContext, thisContext) {
	    (0, _modal.mountModal)(_react2.default.createElement(_WebNotificationPreAskModal2.default, { triggeredContext: triggeredContext }), thisContext);
	    _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.DESKTOP_NOTIFICATION_MODAL);
	    var properties = _LocalUserSettings2.default.getUserProperties();
	    properties.prompts.push({
	      name: _PromptConstants.PromptNames.DESKTOP_NOTIFICATION_MODAL,
	      date: Date.now()
	    });
	    _LocalUserSettings2.default.updateUser(properties);
	  }
	});
	
	var showPromptDialog = exports.showPromptDialog = function showPromptDialog(promptName, triggeredContext, thisContext) {
	  var prompt = promptDefs[promptName];
	  if (prompt && prompt.meetsCondition()) {
	    prompt.display(triggeredContext, thisContext);
	  }
	};

/***/ },
/* 2087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Electron = __webpack_require__(1104);
	
	var _Electron2 = _interopRequireDefault(_Electron);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	  This class is for storing user settings locally using localStorage
	  These settings can be set/get on a per-(Current)user basis
	*/
	var LocalUserSettings = function () {
	  function LocalUserSettings() {
	    _classCallCheck(this, LocalUserSettings);
	  }
	
	  _createClass(LocalUserSettings, [{
	    key: 'isEnabled',
	    value: function isEnabled() {
	      try {
	        window.localStorage.setItem('local_storage_check', 'check');
	        window.localStorage.removeItem('local_storage_check');
	        return true;
	      } catch (e) {
	        // e.g. no window or no storage capability
	        return false;
	      }
	    }
	  }, {
	    key: '_setItem',
	    value: function _setItem(key, value) {
	      if (!this.isEnabled()) {
	        throw new Error('localStorage not available');
	      }
	      var stringifiedValue = typeof value === 'string' ? value : JSON.stringify(value);
	      window.localStorage.setItem(key, stringifiedValue);
	    }
	  }, {
	    key: '_getItem',
	    value: function _getItem(key) {
	      if (!this.isEnabled()) {
	        throw new Error('localStorage not available');
	      }
	      var value = window.localStorage.getItem(key);
	      return JSON.parse(value);
	    }
	  }, {
	    key: '_getUserList',
	    value: function _getUserList() {
	      var result = this._getItem('local_user_properties');
	      if (result) {
	        return result;
	      } else {
	        this._setItem('local_user_properties', {});
	        return {};
	      }
	    }
	  }, {
	    key: '_getDefaultUserProperties',
	    value: function _getDefaultUserProperties() {
	      return {
	        prompts: [],
	        settings: {
	          displayWebNotifications: _Electron2.default.isAvailable()
	        }
	      };
	    }
	  }, {
	    key: 'updateUser',
	    value: function updateUser(properties) {
	      var users = this._getUserList();
	      users[_CurrentUser2.default.getUserId()] = Object.assign(this.getUserProperties(), properties);
	      this._setItem('local_user_properties', users);
	    }
	  }, {
	    key: 'getUserProperties',
	    value: function getUserProperties() {
	      return this._getUserList()[_CurrentUser2.default.getUserId()] || this._getDefaultUserProperties();
	    }
	  }]);
	
	  return LocalUserSettings;
	}();
	
	LocalUserSettings.displayName = 'LocalUserSettings';
	exports.default = new LocalUserSettings();

/***/ },
/* 2088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserConstants = __webpack_require__(1015);
	
	var _WebNotificationTutorialModal = __webpack_require__(2089);
	
	var _WebNotificationTutorialModal2 = _interopRequireDefault(_WebNotificationTutorialModal);
	
	var _modal = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WebNotificationPreAskModal = _react2.default.createClass({
	  displayName: 'WebNotificationPreAskModal',
	
	
	  childContextTypes: {
	    eventScreenName: _react2.default.PropTypes.string,
	    eventProperties: _react2.default.PropTypes.object
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      eventScreenName: 'WebNotificationPreAskModal',
	      eventProperties: { ui_context: this.props.triggeredContext }
	    };
	  },
	  render: function render() {
	    var _this = this;
	
	    var subtext = _CurrentUser2.default.getUser().getRole() === _UserConstants.Roles.teacher ? 'You’ll get notifications for new messages, participants, class owners, and more.' : 'You’ll get notifications for new class announcements and messages from your teacher.';
	    return _react2.default.createElement(_ConfirmDialog2.default, _extends({
	      eventScreenName: 'WebNotificationPreAskModal'
	    }, this.props, {
	      className: 'WebNotificationPreAskModal WebNotificationModal',
	      size: 'xsmall',
	      hideCloseButton: true,
	      hideOnBlur: false,
	      title: 'Turn on desktop notifications',
	      subtext: subtext,
	      image: __webpack_require__(2095),
	      actionButtonText: 'Turn on',
	      cancelButtonText: 'Not now',
	      onConfirm: function onConfirm() {
	        (0, _modal.mountModal)(_react2.default.createElement(_WebNotificationTutorialModal2.default, null), _this);
	      },
	      imageSize: 'large'
	    }));
	  }
	});
	
	exports.default = WebNotificationPreAskModal;

/***/ },
/* 2089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Modal = __webpack_require__(1207);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _currentUserAgent = __webpack_require__(1160);
	
	var _currentUserAgent2 = _interopRequireDefault(_currentUserAgent);
	
	var _WebNotificationActions = __webpack_require__(2090);
	
	var _WebNotificationActions2 = _interopRequireDefault(_WebNotificationActions);
	
	__webpack_require__(2091);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WebNotificationTutorialModal = _react2.default.createClass({
	  displayName: 'WebNotificationTutorialModal',
	  componentDidMount: function componentDidMount() {
	    this.askForPermission();
	  },
	  askForPermission: function askForPermission() {
	    var _this = this;
	
	    _WebNotificationActions2.default.askForPermission().then(function () {
	      return _this.props.onRequestHide();
	    });
	  },
	  renderAskButton: function renderAskButton() {
	    if (_currentUserAgent2.default.firefox()) {
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'WebNotificationTutorialModal-body-button',
	          onClick: this.askForPermission,
	          level: 'secondary',
	          eventElementName: 'WebNotificationTutorialModal-body-button' },
	        'Show dialog again'
	      );
	    }
	  },
	  renderCloseLink: function renderCloseLink() {
	    if (!_currentUserAgent2.default.safari()) {
	      return _react2.default.createElement(
	        _Link2.default,
	        {
	          className: 'WebNotificationTutorialModal-close',
	          onClick: this.props.onRequestHide,
	          eventElementName: 'WebNotificationTutorialModal-close' },
	        _react2.default.createElement(_Glyph2.default, { name: 'close', size: 'large', solo: true })
	      );
	    }
	  },
	  renderImage: function renderImage() {
	    if (_currentUserAgent2.default.safari()) {
	      return _react2.default.createElement(_Image2.default, {
	        className: 'WebNotificationTutorialModal-body-image-up',
	        src: __webpack_require__(2093)
	      });
	    } else {
	      return _react2.default.createElement(_Image2.default, {
	        className: 'WebNotificationTutorialModal-body-image-left',
	        src: __webpack_require__(2094)
	      });
	    }
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _Modal2.default,
	      { className: 'WebNotificationTutorialModal' },
	      this.renderCloseLink(),
	      _react2.default.createElement(
	        _Container2.default,
	        { className: 'WebNotificationTutorialModal-container', size: 'small' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { className: 'WebNotificationTutorialModal-body' },
	          this.renderImage(),
	          _react2.default.createElement(
	            'div',
	            { className: 'WebNotificationTutorialModal-body-title' },
	            'Turn on desktop notifications'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'WebNotificationTutorialModal-body-subtext' },
	            'Click "Allow" in the dialog to get notifications for new messages and updates.'
	          ),
	          this.renderAskButton()
	        )
	      )
	    );
	  }
	});
	exports.default = WebNotificationTutorialModal;

/***/ },
/* 2090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _LocalUserSettings = __webpack_require__(2087);
	
	var _LocalUserSettings2 = _interopRequireDefault(_LocalUserSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WebNotificationActions = {
	  updateLocalUserEnabled: function updateLocalUserEnabled(enabled) {
	    var properties = _LocalUserSettings2.default.getUserProperties();
	    properties.settings.displayWebNotifications = enabled;
	    _LocalUserSettings2.default.updateUser(properties);
	  },
	  askForPermission: function askForPermission() {
	    var _this = this;
	
	    return new Promise(function (resolve) {
	      window.Notification.requestPermission(function (permission) {
	        if (permission === 'granted') {
	          _ToastActions2.default.showSuccessToast('Desktop notifications turned on');
	          _EventTracking2.default.view('desktop_notification_success_toast');
	          _this.updateLocalUserEnabled(true);
	        } else if (permission === 'denied') {
	          _ToastActions2.default.showErrorToast('There was a problem turning on desktop notifications');
	          _EventTracking2.default.view('desktop_notification_error_toast');
	          _this.updateLocalUserEnabled(false);
	        }
	        resolve(permission);
	      });
	    });
	  }
	};
	exports.default = WebNotificationActions;

/***/ },
/* 2091 */
1136,
/* 2092 */,
/* 2093 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2a2170d4591d7b4db9a7799a5bd3734e.svg";

/***/ },
/* 2094 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1ca2f40503cf094624733b6601b9c2bf.svg";

/***/ },
/* 2095 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6245ded7585e1219b8e0d4cd4bc2185a.svg";

/***/ },
/* 2096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Electron = __webpack_require__(1104);
	
	var _Electron2 = _interopRequireDefault(_Electron);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _LocalUserSettings = __webpack_require__(2087);
	
	var _LocalUserSettings2 = _interopRequireDefault(_LocalUserSettings);
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _WebNotification = __webpack_require__(2097);
	
	var _WebNotification2 = _interopRequireDefault(_WebNotification);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _PusherConstants = __webpack_require__(954);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	// https://developer.mozilla.org/en-US/docs/Web/API/Notifications_API/Using_the_Notifications_API#Getting_permission
	var WebNotificationStore = function (_Store) {
	  _inherits(WebNotificationStore, _Store);
	
	  function WebNotificationStore() {
	    _classCallCheck(this, WebNotificationStore);
	
	    return _possibleConstructorReturn(this, (WebNotificationStore.__proto__ || Object.getPrototypeOf(WebNotificationStore)).apply(this, arguments));
	  }
	
	  _createClass(WebNotificationStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        seenChatMessageIds: [],
	        notifications: []
	      };
	    }
	  }, {
	    key: 'getBrowserPermission',
	    value: function getBrowserPermission() {
	      if (!this.areNotificationsCompatible()) {
	        return 'default';
	      }
	      return window.Notification.permission;
	    }
	  }, {
	    key: 'areNotificationsUserEnabled',
	    value: function areNotificationsUserEnabled() {
	      return this.areNotificationsCompatible() && _LocalUserSettings2.default.getUserProperties().settings.displayWebNotifications;
	    }
	  }, {
	    key: 'areNotificationsCompatible',
	    value: function areNotificationsCompatible() {
	      return window.Notification && _LocalUserSettings2.default.isEnabled();
	    }
	  }, {
	    key: 'areNotificationsDispatchable',
	    value: function areNotificationsDispatchable() {
	      return this.areNotificationsCompatible() && _LocalUserSettings2.default.getUserProperties().settings.displayWebNotifications && window.Notification.permission === 'granted';
	    }
	  }, {
	    key: 'getPendingNotifications',
	    value: function getPendingNotifications() {
	      return this.state.notifications.filter(function (n) {
	        return !n.isDismissed() && !n.isDispatched();
	      });
	    }
	  }, {
	    key: 'addNotification',
	    value: function addNotification(options) {
	      if (this.areNotificationsDispatchable()) {
	        this.state.notifications.push(new _WebNotification2.default(options));
	      }
	    }
	  }, {
	    key: 'getOptionsForChangesetChatMessage',
	    value: function getOptionsForChangesetChatMessage(action) {
	      var seenChatMessageIds = this.state.seenChatMessageIds;
	      var messages = action.changes.map(function (change) {
	        return (0, _ChatMessage.chatMessageFactory)(change.content);
	      }).filter(function (message) {
	        var show = message instanceof _ChatMessage.ChatMessage && !seenChatMessageIds.includes(message.getUuid()) && message.getSender().id !== _CurrentUser2.default.getUserId();
	
	        if (show) {
	          seenChatMessageIds.push(message.getUuid());
	          return true;
	        }
	        return false;
	      });
	
	      var notifications = [];
	
	      messages.forEach(function (message) {
	        var body = message.getBody() ? message.getBody() : 'File uploaded';
	        var url = '/classes/r/messages/' + message.getChatId();
	
	        notifications.push({
	          title: 'New message from ' + message.getSender().getName(),
	          body: body,
	          url: url,
	          tracking: {
	            ui_context: 'received_chat',
	            foreign_table: 'chats',
	            foreign_id: message.getChatId()
	          }
	        });
	      });
	
	      return notifications;
	    }
	  }, {
	    key: 'getOptionsForClassMembership',
	    value: function getOptionsForClassMembership(action) {
	      var model = action.model,
	          type = action.type;
	
	      var group = _GroupStore2.default.getGroup(model.getGroupId());
	
	      if (!group) {
	        return [];
	      }
	
	      // Copy the backend logic: Don't show new class membership notifications
	      // for staff classes.
	      //
	      // TODO: Receive desktop notifications from r101-api via Pusher so this
	      // logic can be moved to r101-api where it can be shared with the mobile
	      // apps.
	      //
	      // See https://app.asana.com/0/42793365058492/108770129145700.
	      if (group.isStaffClass()) {
	        return [];
	      }
	
	      if (type === 'update' && model.getRole() === 'owner' && model.getUserId() === _CurrentUser2.default.getUserId()) {
	        return [{
	          title: 'Remind',
	          body: 'You\u2019ve been added as a class owner to ' + group.getName() + '.',
	          url: '/classes/' + group.getCode(),
	          tracking: {
	            ui_context: 'group_owner_promotion',
	            foreign_table: 'groups',
	            foreign_id: group.id
	          }
	        }];
	      }
	
	      return [];
	    }
	  }, {
	    key: 'getOptionsForChangesetDesktopNotification',
	    value: function getOptionsForChangesetDesktopNotification(action) {
	      var lines = action.changes.map(function (change) {
	        return change.content.body;
	      });
	
	      return [{
	        title: 'Remind',
	        body: lines.join('\n')
	      }];
	    }
	  }, {
	    key: 'getOptionsForTestMessage',
	    value: function getOptionsForTestMessage() {
	      return [{
	        title: 'A Notification from Remind',
	        body: 'Education is not the filling of a pail, but the lighting of a fire.'
	      }];
	    }
	  }, {
	    key: 'handlePushEvent',
	    value: function handlePushEvent(action) {
	      var _OPTIONS_FACTORIES,
	          _this2 = this;
	
	      var type = action.type;
	
	      /* Skip notifications when page is focused, except for TEST_MESSAGE
	       * We use this instead of `document.hidden` which would still be true if
	       * app is backgrounded but the browser tab is foremost.
	       */
	
	      if (window.document.hasFocus() && type !== _PusherConstants.PushEvents.TEST_MESSAGE) {
	        return;
	      }
	
	      var OPTIONS_FACTORIES = (_OPTIONS_FACTORIES = {}, _defineProperty(_OPTIONS_FACTORIES, _PusherConstants.PushEvents.TEST_MESSAGE, this.getOptionsForTestMessage), _defineProperty(_OPTIONS_FACTORIES, _PusherConstants.PushEvents.CLASS_MEMBERSHIP, this.getOptionsForClassMembership), _defineProperty(_OPTIONS_FACTORIES, _PusherConstants.PushEvents.CHANGESET_CREATE_CHAT_MESSAGE, this.getOptionsForChangesetChatMessage.bind(this)), _defineProperty(_OPTIONS_FACTORIES, _PusherConstants.PushEvents.CHANGESET_CREATE_DESKTOP_NOTIFICATION, this.getOptionsForChangesetDesktopNotification), _OPTIONS_FACTORIES);
	
	      var factory = OPTIONS_FACTORIES[type];
	      var optionsCollection = factory(action);
	
	      /*
	       * This resolves to the Remind icon shown when a notification is dispatched.
	       * options.icon is not assigned on the desktop app as Electron handles the icon
	       * for its local notifications
	       */
	      optionsCollection.forEach(function (options) {
	        options.icon = !_Electron2.default.isAvailable() && '/assets/images/remind-square-logo-128.png';
	        _this2.addNotification(options);
	        _this2.emitChange();
	      });
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      switch (action.type) {
	        case _PusherConstants.PushEvents.TEST_MESSAGE:
	        case _PusherConstants.PushEvents.CLASS_MEMBERSHIP:
	        case _PusherConstants.PushEvents.CHANGESET_CREATE_CHAT_MESSAGE:
	        case _PusherConstants.PushEvents.CHANGESET_CREATE_DESKTOP_NOTIFICATION:
	          this.handlePushEvent(action);
	          break;
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return WebNotificationStore;
	}(_Store3.default);
	
	WebNotificationStore.displayName = 'WebNotificationStore';
	exports.default = new WebNotificationStore();

/***/ },
/* 2097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TRACKING_SCREEN_NAME = 'desktop_notification';
	
	/*
	  This class is a wrapper around the Notification class.
	  Adds additional functionalities such as storing the Notification without showing it,
	  as well as being able to change its properties before dispatching it
	*/
	var WebNotification = function () {
	  function WebNotification(options) {
	    _classCallCheck(this, WebNotification);
	
	    this._options = options;
	    this._dispatchedNotification = null;
	    this._dismissed = false;
	    this.pingSound = new window.Audio(__webpack_require__(2098));
	  }
	
	  _createClass(WebNotification, [{
	    key: 'setOnClick',
	    value: function setOnClick(onClick) {
	      this._options.onclick = onClick;
	    }
	  }, {
	    key: 'dispatch',
	    value: function dispatch() {
	      var _this = this;
	
	      if (!this.isDismissed()) {
	        this.pingSound.play();
	
	        var _options = this._options,
	            _title = _options.title,
	            _onclick = _options.onclick,
	            _onerror = _options.onerror,
	            others = _objectWithoutProperties(_options, ['title', 'onclick', 'onerror']);
	
	        var notification = new window.Notification(_title, others);
	        var trackClick = function trackClick() {
	          return _EventTracking2.default.tap(TRACKING_SCREEN_NAME, TRACKING_SCREEN_NAME, null, _this._options.tracking);
	        };
	        notification.onerror = _onerror;
	        notification.onclose = function () {
	          return _this._dismissed = true;
	        };
	        notification.onclick = (0, _createChainedFunction2.default)((0, _createChainedFunction2.default)(_onclick, trackClick), notification.close);
	        this._dispatchedNotification = notification;
	        _EventTracking2.default.view(TRACKING_SCREEN_NAME, this._options.tracking);
	      }
	    }
	  }, {
	    key: 'dismissNotification',
	    value: function dismissNotification() {
	      if (this._dispatchedNotification) {
	        this._dispatchedNotification.close();
	      } else {
	        this._dismissed = true;
	      }
	    }
	  }, {
	    key: 'isDispatched',
	    value: function isDispatched() {
	      return !!this._dispatchedNotification;
	    }
	  }, {
	    key: 'isDismissed',
	    value: function isDismissed() {
	      return this._dismissed;
	    }
	
	    // TODO refactor "tag" concern so it doesn't have to be parsed
	
	  }, {
	    key: 'getTag',
	    value: function getTag() {
	      return this._options.tag;
	    }
	  }]);
	
	  return WebNotification;
	}();
	
	WebNotification.displayName = 'WebNotification';
	exports.default = WebNotification;

/***/ },
/* 2098 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d1a353bdc1b31525e96b7a7ce60ce9f8.mp3";

/***/ },
/* 2099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AlertDialog = __webpack_require__(1190);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SafetyModal = function (_React$Component) {
	  _inherits(SafetyModal, _React$Component);
	
	  function SafetyModal() {
	    _classCallCheck(this, SafetyModal);
	
	    return _possibleConstructorReturn(this, (SafetyModal.__proto__ || Object.getPrototypeOf(SafetyModal)).apply(this, arguments));
	  }
	
	  _createClass(SafetyModal, [{
	    key: 'render',
	    value: function render() {
	      var titleText = 'Help keep Remind safe ✨';
	      var title = _react2.default.createElement(_TextWithEntities2.default, { text: titleText, entities: _TextEntities2.default.parseEmoji(titleText) });
	      var subtext = _react2.default.createElement(
	        'span',
	        null,
	        'Remind is built for education, so your school administrator can request the message history for any group. Check out our',
	        ' ',
	        _react2.default.createElement(
	          _Link2.default,
	          { href: _LinkConstants2.default.COMMUNITY_GUIDELINES, target: '_blank' },
	          'Community Guidelines'
	        ),
	        ' ',
	        'for tips on safe communication.'
	      );
	
	      return _react2.default.createElement(_AlertDialog2.default, {
	        eventScreenName: 'SafetyModal',
	        title: title,
	        subtext: subtext,
	        buttonText: 'Got it',
	        onOkay: this.props.onOkay,
	        onRequestHide: this.props.onRequestHide
	      });
	    }
	  }]);
	
	  return SafetyModal;
	}(_react2.default.Component);
	
	SafetyModal.displayName = 'SafetyModal';
	exports.default = SafetyModal;

/***/ },
/* 2100 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"polarBear":"#f2f3f5","wolf":"#dcdee2","snow":"#fafbfc","brand":"#2f75c1","koala":"#c5c7cb","spacing-medium":"8px","this":"AnnouncementComposer__this___R8Ewo","wrap":"AnnouncementComposer__wrap___2c-Gr","dialogWrap":"AnnouncementComposer__dialogWrap___243bz","composerContainer":"AnnouncementComposer__composerContainer___3Fp__","buttonContainer":"AnnouncementComposer__buttonContainer___5KbhT","composer":"AnnouncementComposer__composer___OHHj0 Spacing__marginBottomLarge___89-lt","announcementThreadComposer":"AnnouncementComposer__announcementThreadComposer___2DbZC","announcementsThread":"AnnouncementComposer__announcementsThread___3kqTz","composerWrapper":"AnnouncementComposer__composerWrapper___geAsl","controls":"AnnouncementComposer__controls___xu04A","controlsWrapper":"AnnouncementComposer__controlsWrapper___ULZF8","schedulerLabel":"AnnouncementComposer__schedulerLabel___2uBW5","translationButtons":"AnnouncementComposer__translationButtons___1DdOG Spacing__marginTopSmall___aOQjA","sendButton":"AnnouncementComposer__sendButton___yTDA6","recipientsInput":"AnnouncementComposer__recipientsInput___3zfEt Spacing__marginBottomLarge___89-lt","recipientsInputDisabled":"AnnouncementComposer__recipientsInputDisabled___2pXQE","listItemPullRight":"AnnouncementComposer__listItemPullRight___374Cb","moreClassesListItem":"AnnouncementComposer__moreClassesListItem___Kbqq2","controlGlyph":"AnnouncementComposer__controlGlyph___1SDPX","filePreview":"AnnouncementComposer__filePreview___ND11- Spacing__paddingVertMedium___3s3nZ Spacing__paddingBottomMedium___2LPVP Spacing__paddingTopMedium___qfOik Spacing__paddingHorizLarge___1rB6u Spacing__paddingLeftLarge___QvQBP Spacing__paddingRightLarge___1p09V","scheduler":"AnnouncementComposer__scheduler___1DpVh Spacing__paddingVertMedium___3s3nZ Spacing__paddingBottomMedium___2LPVP Spacing__paddingTopMedium___qfOik Spacing__paddingHorizLarge___1rB6u Spacing__paddingLeftLarge___QvQBP Spacing__paddingRightLarge___1p09V","schedulerCloseButton":"AnnouncementComposer__schedulerCloseButton___2H35s","translation":"AnnouncementComposer__translation___3PS54 Spacing__paddingVertMedium___3s3nZ Spacing__paddingBottomMedium___2LPVP Spacing__paddingTopMedium___qfOik Spacing__paddingHorizLarge___1rB6u Spacing__paddingLeftLarge___QvQBP Spacing__paddingRightLarge___1p09V","activity":"AnnouncementComposer__activity___jBfCc","moreClassesButton":"AnnouncementComposer__moreClassesButton___1PkW2"};

/***/ },
/* 2101 */,
/* 2102 */
1136,
/* 2103 */,
/* 2104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDefaultGroups = getDefaultGroups;
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @deprecated use the group's postable roles instead
	 */
	function getDefaultGroups(groupCode) {
	  var postableGroups = _GroupStore2.default.getPostableGroups().models;
	
	  // If there is only one postable class, always use it
	  if (postableGroups.length === 1) {
	    return postableGroups;
	  } else if (groupCode) {
	    var group = _GroupStore2.default.getGroupForCode(groupCode);
	    if (postableGroups.includes(group)) {
	      return [group];
	    }
	    return [];
	  } else {
	    return [];
	  }
	}

/***/ },
/* 2105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Panel = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _List = __webpack_require__(1281);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabView = __webpack_require__(2106);
	
	var _TabView2 = _interopRequireDefault(_TabView);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UniversalComposerTabView = __webpack_require__(2109);
	
	var _UniversalComposerTabView2 = _interopRequireDefault(_UniversalComposerTabView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UniversalComposerTabView = function (_React$Component) {
	  _inherits(UniversalComposerTabView, _React$Component);
	
	  function UniversalComposerTabView() {
	    _classCallCheck(this, UniversalComposerTabView);
	
	    return _possibleConstructorReturn(this, (UniversalComposerTabView.__proto__ || Object.getPrototypeOf(UniversalComposerTabView)).apply(this, arguments));
	  }
	
	  _createClass(UniversalComposerTabView, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          subtext = _props.subtext,
	          children = _props.children;
	
	      return _react2.default.createElement(
	        _TabView2.default,
	        {
	          viewRenderer: function viewRenderer(_ref) {
	            var tabList = _ref.tabList,
	                panel = _ref.panel,
	                props = _objectWithoutProperties(_ref, ['tabList', 'panel']);
	
	            return _react2.default.createElement(
	              'div',
	              _extends({}, props, {
	                className: (0, _classnames2.default)(_UniversalComposerTabView2.default.this, props.className) }),
	              _react2.default.createElement(
	                'div',
	                { className: _UniversalComposerTabView2.default.header },
	                title && _react2.default.createElement(
	                  'h2',
	                  { className: _UniversalComposerTabView2.default.title },
	                  _react2.default.createElement(
	                    _Text2.default,
	                    { color: 'pitch', size: 'xxlarge' },
	                    title
	                  )
	                ),
	                subtext && _react2.default.createElement(
	                  _Text2.default,
	                  {
	                    className: _UniversalComposerTabView2.default.subtext,
	                    color: 'koala',
	                    size: 'xsmall' },
	                  subtext
	                ),
	                tabList
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _UniversalComposerTabView2.default.content },
	                panel
	              )
	            );
	          },
	          tabListRenderer: function tabListRenderer(_ref2) {
	            var tabs = _ref2.tabs,
	                props = _objectWithoutProperties(_ref2, ['tabs']);
	
	            return _react2.default.createElement(
	              _List2.default,
	              _extends({}, props, { className: _UniversalComposerTabView2.default.tabList }),
	              tabs
	            );
	          },
	          tabRenderer: function tabRenderer(_ref3) {
	            var panel = _ref3.panel,
	                selected = _ref3.selected,
	                props = _objectWithoutProperties(_ref3, ['panel', 'selected']);
	
	            return _react2.default.createElement(
	              'a',
	              _extends({}, props, {
	                className: (0, _classnames2.default)(_UniversalComposerTabView2.default.tab, _defineProperty({}, _UniversalComposerTabView2.default.selectedTab, selected)) }),
	              _react2.default.createElement(
	                _Text2.default,
	                { truncate: true },
	                panel.props.glyphName && _react2.default.createElement(_Glyph2.default, {
	                  className: _UniversalComposerTabView2.default.tabGlyph,
	                  name: panel.props.glyphName,
	                  size: panel.props.glyphSize
	                }),
	                panel.props.name
	              )
	            );
	          } },
	        children
	      );
	    }
	  }]);
	
	  return UniversalComposerTabView;
	}(_react2.default.Component);
	
	UniversalComposerTabView.displayName = 'UniversalComposerTabView';
	exports.default = UniversalComposerTabView;
	var Panel = function Panel(_ref4) {
	  var children = _ref4.children,
	      className = _ref4.className,
	      props = _objectWithoutProperties(_ref4, ['children', 'className']);
	
	  return _react2.default.createElement(
	    _TabView2.default.Panel,
	    _extends({}, props, {
	      className: (0, _classnames2.default)(_UniversalComposerTabView2.default.panel, className) }),
	    children
	  );
	};
	
	exports.Panel = Panel;
	UniversalComposerTabView.Panel = Panel;

/***/ },
/* 2106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Panel = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _List = __webpack_require__(1281);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(1241);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TabView = __webpack_require__(2107);
	
	var _TabView2 = _interopRequireDefault(_TabView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabView = function (_React$Component) {
	  _inherits(TabView, _React$Component);
	
	  function TabView(props, context) {
	    _classCallCheck(this, TabView);
	
	    var _this = _possibleConstructorReturn(this, (TabView.__proto__ || Object.getPrototypeOf(TabView)).call(this, props, context));
	
	    var panels = _react2.default.Children.toArray(props.children);
	    var selectedPanelIndex = panels.findIndex(function (panel) {
	      return panel.props.defaultSelected;
	    });
	
	    _this.state = {
	      selectedPanelIndex: selectedPanelIndex >= 0 ? selectedPanelIndex : 0
	    };
	    return _this;
	  }
	
	  _createClass(TabView, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          viewRenderer = _props.viewRenderer,
	          tabListRenderer = _props.tabListRenderer,
	          tabRenderer = _props.tabRenderer,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['viewRenderer', 'tabListRenderer', 'tabRenderer', 'children']);
	
	      var selectedPanelIndex = this.state.selectedPanelIndex;
	
	      var panels = _react2.default.Children.toArray(children);
	
	      var tabList = tabListRenderer({
	        tabs: panels.map(function (panel, index) {
	          var tab = tabRenderer({
	            panel: panel,
	            selected: index === selectedPanelIndex
	          });
	
	          return _react2.default.cloneElement(tab, {
	            key: index,
	            className: (0, _classnames2.default)(tab.props.className, _TabView2.default.tab),
	            onClick: (0, _createChainedFunction2.default)(function () {
	              if (index !== _this2.state.selectedPanelIndex) {
	                _this2.setState({ selectedPanelIndex: index });
	              }
	            }, tab.props.onClick)
	          });
	        })
	      });
	
	      return viewRenderer(Object.assign(props, {
	        tabList: tabList,
	        panel: panels[selectedPanelIndex]
	      }));
	    }
	  }]);
	
	  return TabView;
	}(_react2.default.Component);
	
	TabView.defaultProps = {
	  viewRenderer: function viewRenderer(_ref) {
	    var tabList = _ref.tabList,
	        panel = _ref.panel,
	        props = _objectWithoutProperties(_ref, ['tabList', 'panel']);
	
	    return _react2.default.createElement(
	      'div',
	      props,
	      tabList,
	      panel
	    );
	  },
	  tabListRenderer: function tabListRenderer(_ref2) {
	    var tabs = _ref2.tabs,
	        props = _objectWithoutProperties(_ref2, ['tabs']);
	
	    return _react2.default.createElement(
	      _List2.default,
	      props,
	      tabs
	    );
	  },
	  tabRenderer: function tabRenderer(_ref3) {
	    var panel = _ref3.panel,
	        selected = _ref3.selected,
	        props = _objectWithoutProperties(_ref3, ['panel', 'selected']);
	
	    return _react2.default.createElement(
	      _Text2.default,
	      _extends({}, props, { weight: selected ? 'bold' : null }),
	      panel.props.name
	    );
	  }
	};
	TabView.displayName = 'TabView';
	exports.default = TabView;
	
	var Panel = exports.Panel = function (_React$Component2) {
	  _inherits(Panel, _React$Component2);
	
	  function Panel() {
	    _classCallCheck(this, Panel);
	
	    return _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).apply(this, arguments));
	  }
	
	  _createClass(Panel, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          name = _props2.name,
	          children = _props2.children,
	          props = _objectWithoutProperties(_props2, ['name', 'children']);
	
	      return _react2.default.createElement(
	        'div',
	        props,
	        children
	      );
	    }
	  }]);
	
	  return Panel;
	}(_react2.default.Component);
	
	Panel.displayName = 'Panel';
	
	
	TabView.Panel = Panel;

/***/ },
/* 2107 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tab":"TabView__tab___3JLtt"};

/***/ },
/* 2108 */,
/* 2109 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"brand":"#2f75c1","eclipse":"#9e9fa5","koala":"#c5c7cb","polarBear":"#f2f3f5","wolf":"#dcdee2","this":"UniversalComposerTabView__this___36BiG","header":"UniversalComposerTabView__header___1sPMn Spacing__paddingTopLarge___1qHMl Spacing__paddingHorizLarge___1rB6u Spacing__paddingLeftLarge___QvQBP Spacing__paddingRightLarge___1p09V Spacing__marginHorizLarge___3djl8 Spacing__marginLeftLarge___11Ucb Spacing__marginRightLarge___cfZEM","title":"UniversalComposerTabView__title___1DLg3 Spacing__marginTopLarge___10pJs","subtext":"UniversalComposerTabView__subtext___2yUyK Spacing__marginBottomLarge___89-lt","tabList":"UniversalComposerTabView__tabList___1W8jx Spacing__marginTopLarge___10pJs","tab":"UniversalComposerTabView__tab___38T8o Spacing__paddingMedium___2n-MO","selectedTab":"UniversalComposerTabView__selectedTab___27_Bk","tabGlyph":"UniversalComposerTabView__tabGlyph___1Ttgg Spacing__marginRightMedium___bhiZC"};

/***/ },
/* 2110 */,
/* 2111 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"spacing-small":"4px","spacing-huge":"32px","thunder":"#6b6e72","this":"UniversalComposer__this___Lp9Ja","uniquePanelContent":"UniversalComposer__uniquePanelContent___2ARSO"};

/***/ },
/* 2112 */,
/* 2113 */
1136,
/* 2114 */,
/* 2115 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2116 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"borderRadiusDefault":"5px","eclipse":"#9e9fa5","pitch":"#282c31","thunder":"#6b6e72","spacing-small":"4px","spacing-medium":"8px","spacing-huge":"32px","spacing-giant":"64px","this":"GroupMessagesNull__this___2C3CP","tooltip":"GroupMessagesNull__tooltip___3cVaz","link":"GroupMessagesNull__link___1dLbt","image":"GroupMessagesNull__image___26Us4","title":"GroupMessagesNull__title___ZmRRz","subtitle":"GroupMessagesNull__subtitle___52alq","subtext":"GroupMessagesNull__subtext___D5ie6"};

/***/ },
/* 2117 */,
/* 2118 */,
/* 2119 */
1136,
/* 2120 */,
/* 2121 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"this":"GroupMessageListModal__this___1pHxY","messages":"GroupMessageListModal__messages___1j7X3"};

/***/ },
/* 2122 */,
/* 2123 */
1136,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */,
/* 2431 */,
/* 2432 */,
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */,
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */,
/* 2446 */,
/* 2447 */,
/* 2448 */,
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */,
/* 2454 */,
/* 2455 */,
/* 2456 */,
/* 2457 */,
/* 2458 */,
/* 2459 */,
/* 2460 */,
/* 2461 */,
/* 2462 */,
/* 2463 */,
/* 2464 */,
/* 2465 */,
/* 2466 */,
/* 2467 */,
/* 2468 */,
/* 2469 */,
/* 2470 */,
/* 2471 */,
/* 2472 */,
/* 2473 */,
/* 2474 */,
/* 2475 */,
/* 2476 */,
/* 2477 */,
/* 2478 */,
/* 2479 */,
/* 2480 */,
/* 2481 */,
/* 2482 */,
/* 2483 */,
/* 2484 */,
/* 2485 */,
/* 2486 */,
/* 2487 */,
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */,
/* 2494 */,
/* 2495 */,
/* 2496 */,
/* 2497 */,
/* 2498 */,
/* 2499 */,
/* 2500 */,
/* 2501 */,
/* 2502 */,
/* 2503 */,
/* 2504 */,
/* 2505 */,
/* 2506 */,
/* 2507 */,
/* 2508 */,
/* 2509 */,
/* 2510 */,
/* 2511 */,
/* 2512 */,
/* 2513 */,
/* 2514 */,
/* 2515 */,
/* 2516 */,
/* 2517 */,
/* 2518 */,
/* 2519 */,
/* 2520 */,
/* 2521 */,
/* 2522 */,
/* 2523 */,
/* 2524 */,
/* 2525 */,
/* 2526 */,
/* 2527 */,
/* 2528 */,
/* 2529 */,
/* 2530 */,
/* 2531 */,
/* 2532 */,
/* 2533 */,
/* 2534 */,
/* 2535 */,
/* 2536 */,
/* 2537 */,
/* 2538 */,
/* 2539 */,
/* 2540 */,
/* 2541 */,
/* 2542 */,
/* 2543 */,
/* 2544 */,
/* 2545 */,
/* 2546 */,
/* 2547 */,
/* 2548 */,
/* 2549 */,
/* 2550 */,
/* 2551 */,
/* 2552 */,
/* 2553 */,
/* 2554 */,
/* 2555 */,
/* 2556 */,
/* 2557 */,
/* 2558 */,
/* 2559 */,
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */,
/* 2564 */,
/* 2565 */,
/* 2566 */,
/* 2567 */,
/* 2568 */,
/* 2569 */,
/* 2570 */,
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */,
/* 2579 */,
/* 2580 */,
/* 2581 */,
/* 2582 */,
/* 2583 */,
/* 2584 */,
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */,
/* 2592 */,
/* 2593 */,
/* 2594 */,
/* 2595 */,
/* 2596 */,
/* 2597 */,
/* 2598 */,
/* 2599 */,
/* 2600 */,
/* 2601 */,
/* 2602 */,
/* 2603 */,
/* 2604 */,
/* 2605 */,
/* 2606 */,
/* 2607 */,
/* 2608 */,
/* 2609 */,
/* 2610 */,
/* 2611 */,
/* 2612 */,
/* 2613 */,
/* 2614 */,
/* 2615 */,
/* 2616 */,
/* 2617 */,
/* 2618 */,
/* 2619 */,
/* 2620 */,
/* 2621 */,
/* 2622 */,
/* 2623 */,
/* 2624 */,
/* 2625 */,
/* 2626 */,
/* 2627 */,
/* 2628 */,
/* 2629 */,
/* 2630 */,
/* 2631 */,
/* 2632 */,
/* 2633 */,
/* 2634 */,
/* 2635 */,
/* 2636 */,
/* 2637 */,
/* 2638 */,
/* 2639 */,
/* 2640 */,
/* 2641 */,
/* 2642 */,
/* 2643 */,
/* 2644 */,
/* 2645 */,
/* 2646 */,
/* 2647 */,
/* 2648 */,
/* 2649 */,
/* 2650 */,
/* 2651 */,
/* 2652 */,
/* 2653 */,
/* 2654 */,
/* 2655 */,
/* 2656 */,
/* 2657 */,
/* 2658 */,
/* 2659 */,
/* 2660 */,
/* 2661 */,
/* 2662 */,
/* 2663 */,
/* 2664 */,
/* 2665 */,
/* 2666 */,
/* 2667 */,
/* 2668 */,
/* 2669 */,
/* 2670 */,
/* 2671 */,
/* 2672 */,
/* 2673 */,
/* 2674 */,
/* 2675 */,
/* 2676 */,
/* 2677 */,
/* 2678 */,
/* 2679 */,
/* 2680 */,
/* 2681 */,
/* 2682 */,
/* 2683 */,
/* 2684 */,
/* 2685 */,
/* 2686 */,
/* 2687 */,
/* 2688 */,
/* 2689 */,
/* 2690 */,
/* 2691 */,
/* 2692 */,
/* 2693 */,
/* 2694 */,
/* 2695 */,
/* 2696 */,
/* 2697 */,
/* 2698 */,
/* 2699 */,
/* 2700 */,
/* 2701 */,
/* 2702 */,
/* 2703 */,
/* 2704 */,
/* 2705 */,
/* 2706 */,
/* 2707 */,
/* 2708 */,
/* 2709 */,
/* 2710 */,
/* 2711 */,
/* 2712 */,
/* 2713 */,
/* 2714 */,
/* 2715 */,
/* 2716 */,
/* 2717 */,
/* 2718 */,
/* 2719 */,
/* 2720 */,
/* 2721 */,
/* 2722 */,
/* 2723 */,
/* 2724 */,
/* 2725 */,
/* 2726 */,
/* 2727 */,
/* 2728 */,
/* 2729 */,
/* 2730 */,
/* 2731 */,
/* 2732 */,
/* 2733 */,
/* 2734 */,
/* 2735 */,
/* 2736 */,
/* 2737 */,
/* 2738 */,
/* 2739 */,
/* 2740 */,
/* 2741 */,
/* 2742 */,
/* 2743 */,
/* 2744 */,
/* 2745 */,
/* 2746 */,
/* 2747 */,
/* 2748 */,
/* 2749 */,
/* 2750 */,
/* 2751 */,
/* 2752 */,
/* 2753 */,
/* 2754 */,
/* 2755 */,
/* 2756 */,
/* 2757 */,
/* 2758 */,
/* 2759 */,
/* 2760 */,
/* 2761 */,
/* 2762 */,
/* 2763 */,
/* 2764 */,
/* 2765 */,
/* 2766 */,
/* 2767 */,
/* 2768 */,
/* 2769 */,
/* 2770 */,
/* 2771 */,
/* 2772 */,
/* 2773 */,
/* 2774 */,
/* 2775 */,
/* 2776 */,
/* 2777 */,
/* 2778 */,
/* 2779 */,
/* 2780 */,
/* 2781 */,
/* 2782 */,
/* 2783 */,
/* 2784 */,
/* 2785 */,
/* 2786 */,
/* 2787 */,
/* 2788 */,
/* 2789 */,
/* 2790 */,
/* 2791 */,
/* 2792 */,
/* 2793 */,
/* 2794 */,
/* 2795 */,
/* 2796 */,
/* 2797 */,
/* 2798 */,
/* 2799 */,
/* 2800 */,
/* 2801 */,
/* 2802 */,
/* 2803 */,
/* 2804 */,
/* 2805 */,
/* 2806 */,
/* 2807 */,
/* 2808 */,
/* 2809 */,
/* 2810 */,
/* 2811 */,
/* 2812 */,
/* 2813 */,
/* 2814 */,
/* 2815 */,
/* 2816 */,
/* 2817 */,
/* 2818 */,
/* 2819 */,
/* 2820 */,
/* 2821 */,
/* 2822 */,
/* 2823 */,
/* 2824 */,
/* 2825 */,
/* 2826 */,
/* 2827 */,
/* 2828 */,
/* 2829 */,
/* 2830 */,
/* 2831 */,
/* 2832 */,
/* 2833 */,
/* 2834 */,
/* 2835 */,
/* 2836 */,
/* 2837 */,
/* 2838 */,
/* 2839 */,
/* 2840 */,
/* 2841 */,
/* 2842 */,
/* 2843 */,
/* 2844 */,
/* 2845 */,
/* 2846 */,
/* 2847 */,
/* 2848 */,
/* 2849 */,
/* 2850 */,
/* 2851 */,
/* 2852 */,
/* 2853 */,
/* 2854 */,
/* 2855 */,
/* 2856 */,
/* 2857 */,
/* 2858 */,
/* 2859 */,
/* 2860 */,
/* 2861 */,
/* 2862 */,
/* 2863 */,
/* 2864 */,
/* 2865 */,
/* 2866 */,
/* 2867 */,
/* 2868 */,
/* 2869 */,
/* 2870 */,
/* 2871 */,
/* 2872 */,
/* 2873 */,
/* 2874 */,
/* 2875 */,
/* 2876 */,
/* 2877 */,
/* 2878 */,
/* 2879 */,
/* 2880 */,
/* 2881 */,
/* 2882 */,
/* 2883 */,
/* 2884 */,
/* 2885 */,
/* 2886 */,
/* 2887 */,
/* 2888 */,
/* 2889 */,
/* 2890 */,
/* 2891 */,
/* 2892 */,
/* 2893 */,
/* 2894 */,
/* 2895 */,
/* 2896 */,
/* 2897 */,
/* 2898 */,
/* 2899 */,
/* 2900 */,
/* 2901 */,
/* 2902 */,
/* 2903 */,
/* 2904 */,
/* 2905 */,
/* 2906 */,
/* 2907 */,
/* 2908 */,
/* 2909 */,
/* 2910 */,
/* 2911 */,
/* 2912 */,
/* 2913 */,
/* 2914 */,
/* 2915 */,
/* 2916 */,
/* 2917 */,
/* 2918 */,
/* 2919 */,
/* 2920 */,
/* 2921 */,
/* 2922 */,
/* 2923 */,
/* 2924 */,
/* 2925 */,
/* 2926 */,
/* 2927 */,
/* 2928 */,
/* 2929 */,
/* 2930 */,
/* 2931 */,
/* 2932 */,
/* 2933 */,
/* 2934 */,
/* 2935 */,
/* 2936 */,
/* 2937 */,
/* 2938 */,
/* 2939 */,
/* 2940 */,
/* 2941 */,
/* 2942 */,
/* 2943 */,
/* 2944 */,
/* 2945 */,
/* 2946 */,
/* 2947 */,
/* 2948 */,
/* 2949 */,
/* 2950 */,
/* 2951 */,
/* 2952 */,
/* 2953 */,
/* 2954 */,
/* 2955 */,
/* 2956 */,
/* 2957 */,
/* 2958 */,
/* 2959 */,
/* 2960 */,
/* 2961 */,
/* 2962 */,
/* 2963 */,
/* 2964 */,
/* 2965 */,
/* 2966 */,
/* 2967 */,
/* 2968 */,
/* 2969 */,
/* 2970 */,
/* 2971 */,
/* 2972 */,
/* 2973 */,
/* 2974 */,
/* 2975 */,
/* 2976 */,
/* 2977 */,
/* 2978 */,
/* 2979 */,
/* 2980 */,
/* 2981 */,
/* 2982 */,
/* 2983 */,
/* 2984 */,
/* 2985 */,
/* 2986 */,
/* 2987 */,
/* 2988 */,
/* 2989 */,
/* 2990 */,
/* 2991 */,
/* 2992 */,
/* 2993 */,
/* 2994 */,
/* 2995 */,
/* 2996 */,
/* 2997 */,
/* 2998 */,
/* 2999 */,
/* 3000 */,
/* 3001 */,
/* 3002 */,
/* 3003 */,
/* 3004 */,
/* 3005 */,
/* 3006 */,
/* 3007 */,
/* 3008 */,
/* 3009 */,
/* 3010 */,
/* 3011 */,
/* 3012 */,
/* 3013 */,
/* 3014 */,
/* 3015 */,
/* 3016 */,
/* 3017 */,
/* 3018 */,
/* 3019 */,
/* 3020 */,
/* 3021 */,
/* 3022 */,
/* 3023 */,
/* 3024 */,
/* 3025 */,
/* 3026 */,
/* 3027 */,
/* 3028 */,
/* 3029 */,
/* 3030 */,
/* 3031 */,
/* 3032 */,
/* 3033 */,
/* 3034 */,
/* 3035 */,
/* 3036 */,
/* 3037 */,
/* 3038 */,
/* 3039 */,
/* 3040 */,
/* 3041 */,
/* 3042 */,
/* 3043 */,
/* 3044 */,
/* 3045 */,
/* 3046 */,
/* 3047 */,
/* 3048 */,
/* 3049 */,
/* 3050 */,
/* 3051 */,
/* 3052 */,
/* 3053 */,
/* 3054 */,
/* 3055 */,
/* 3056 */,
/* 3057 */,
/* 3058 */,
/* 3059 */,
/* 3060 */,
/* 3061 */,
/* 3062 */,
/* 3063 */,
/* 3064 */,
/* 3065 */,
/* 3066 */,
/* 3067 */,
/* 3068 */,
/* 3069 */,
/* 3070 */,
/* 3071 */,
/* 3072 */,
/* 3073 */,
/* 3074 */,
/* 3075 */,
/* 3076 */,
/* 3077 */,
/* 3078 */,
/* 3079 */,
/* 3080 */,
/* 3081 */,
/* 3082 */,
/* 3083 */,
/* 3084 */,
/* 3085 */,
/* 3086 */,
/* 3087 */,
/* 3088 */,
/* 3089 */,
/* 3090 */,
/* 3091 */,
/* 3092 */,
/* 3093 */,
/* 3094 */,
/* 3095 */,
/* 3096 */,
/* 3097 */,
/* 3098 */,
/* 3099 */,
/* 3100 */,
/* 3101 */,
/* 3102 */,
/* 3103 */,
/* 3104 */,
/* 3105 */,
/* 3106 */,
/* 3107 */,
/* 3108 */,
/* 3109 */,
/* 3110 */,
/* 3111 */,
/* 3112 */,
/* 3113 */,
/* 3114 */,
/* 3115 */,
/* 3116 */,
/* 3117 */,
/* 3118 */,
/* 3119 */,
/* 3120 */,
/* 3121 */,
/* 3122 */,
/* 3123 */,
/* 3124 */,
/* 3125 */,
/* 3126 */,
/* 3127 */,
/* 3128 */,
/* 3129 */,
/* 3130 */,
/* 3131 */,
/* 3132 */,
/* 3133 */,
/* 3134 */,
/* 3135 */,
/* 3136 */,
/* 3137 */,
/* 3138 */,
/* 3139 */,
/* 3140 */,
/* 3141 */,
/* 3142 */,
/* 3143 */,
/* 3144 */,
/* 3145 */,
/* 3146 */,
/* 3147 */,
/* 3148 */,
/* 3149 */,
/* 3150 */,
/* 3151 */,
/* 3152 */,
/* 3153 */,
/* 3154 */,
/* 3155 */,
/* 3156 */,
/* 3157 */,
/* 3158 */,
/* 3159 */,
/* 3160 */,
/* 3161 */,
/* 3162 */,
/* 3163 */,
/* 3164 */,
/* 3165 */,
/* 3166 */,
/* 3167 */,
/* 3168 */,
/* 3169 */,
/* 3170 */,
/* 3171 */,
/* 3172 */,
/* 3173 */,
/* 3174 */,
/* 3175 */,
/* 3176 */,
/* 3177 */,
/* 3178 */,
/* 3179 */,
/* 3180 */,
/* 3181 */,
/* 3182 */,
/* 3183 */,
/* 3184 */,
/* 3185 */,
/* 3186 */,
/* 3187 */,
/* 3188 */,
/* 3189 */,
/* 3190 */,
/* 3191 */,
/* 3192 */,
/* 3193 */,
/* 3194 */,
/* 3195 */,
/* 3196 */,
/* 3197 */,
/* 3198 */,
/* 3199 */,
/* 3200 */,
/* 3201 */,
/* 3202 */,
/* 3203 */,
/* 3204 */,
/* 3205 */,
/* 3206 */,
/* 3207 */,
/* 3208 */,
/* 3209 */,
/* 3210 */,
/* 3211 */,
/* 3212 */,
/* 3213 */,
/* 3214 */,
/* 3215 */,
/* 3216 */,
/* 3217 */,
/* 3218 */,
/* 3219 */,
/* 3220 */,
/* 3221 */,
/* 3222 */,
/* 3223 */,
/* 3224 */,
/* 3225 */,
/* 3226 */,
/* 3227 */,
/* 3228 */,
/* 3229 */,
/* 3230 */,
/* 3231 */,
/* 3232 */,
/* 3233 */,
/* 3234 */,
/* 3235 */,
/* 3236 */,
/* 3237 */,
/* 3238 */,
/* 3239 */,
/* 3240 */,
/* 3241 */,
/* 3242 */,
/* 3243 */,
/* 3244 */,
/* 3245 */,
/* 3246 */,
/* 3247 */,
/* 3248 */,
/* 3249 */,
/* 3250 */,
/* 3251 */,
/* 3252 */,
/* 3253 */,
/* 3254 */,
/* 3255 */,
/* 3256 */,
/* 3257 */,
/* 3258 */,
/* 3259 */,
/* 3260 */,
/* 3261 */,
/* 3262 */,
/* 3263 */,
/* 3264 */,
/* 3265 */,
/* 3266 */,
/* 3267 */,
/* 3268 */,
/* 3269 */,
/* 3270 */,
/* 3271 */,
/* 3272 */,
/* 3273 */,
/* 3274 */,
/* 3275 */,
/* 3276 */,
/* 3277 */,
/* 3278 */,
/* 3279 */,
/* 3280 */,
/* 3281 */,
/* 3282 */,
/* 3283 */,
/* 3284 */,
/* 3285 */,
/* 3286 */,
/* 3287 */,
/* 3288 */,
/* 3289 */,
/* 3290 */,
/* 3291 */,
/* 3292 */,
/* 3293 */,
/* 3294 */,
/* 3295 */,
/* 3296 */,
/* 3297 */,
/* 3298 */,
/* 3299 */,
/* 3300 */,
/* 3301 */,
/* 3302 */,
/* 3303 */,
/* 3304 */,
/* 3305 */,
/* 3306 */,
/* 3307 */,
/* 3308 */,
/* 3309 */,
/* 3310 */,
/* 3311 */,
/* 3312 */,
/* 3313 */,
/* 3314 */,
/* 3315 */,
/* 3316 */,
/* 3317 */,
/* 3318 */,
/* 3319 */,
/* 3320 */,
/* 3321 */,
/* 3322 */,
/* 3323 */,
/* 3324 */,
/* 3325 */,
/* 3326 */,
/* 3327 */,
/* 3328 */,
/* 3329 */,
/* 3330 */,
/* 3331 */,
/* 3332 */,
/* 3333 */,
/* 3334 */,
/* 3335 */,
/* 3336 */,
/* 3337 */,
/* 3338 */,
/* 3339 */,
/* 3340 */,
/* 3341 */,
/* 3342 */,
/* 3343 */,
/* 3344 */,
/* 3345 */,
/* 3346 */,
/* 3347 */,
/* 3348 */,
/* 3349 */,
/* 3350 */,
/* 3351 */,
/* 3352 */,
/* 3353 */,
/* 3354 */,
/* 3355 */,
/* 3356 */,
/* 3357 */,
/* 3358 */,
/* 3359 */,
/* 3360 */,
/* 3361 */,
/* 3362 */,
/* 3363 */,
/* 3364 */,
/* 3365 */,
/* 3366 */,
/* 3367 */,
/* 3368 */,
/* 3369 */,
/* 3370 */,
/* 3371 */,
/* 3372 */,
/* 3373 */,
/* 3374 */,
/* 3375 */,
/* 3376 */,
/* 3377 */,
/* 3378 */,
/* 3379 */,
/* 3380 */,
/* 3381 */,
/* 3382 */,
/* 3383 */,
/* 3384 */,
/* 3385 */,
/* 3386 */,
/* 3387 */,
/* 3388 */,
/* 3389 */,
/* 3390 */,
/* 3391 */,
/* 3392 */,
/* 3393 */,
/* 3394 */,
/* 3395 */,
/* 3396 */,
/* 3397 */,
/* 3398 */,
/* 3399 */,
/* 3400 */,
/* 3401 */,
/* 3402 */,
/* 3403 */,
/* 3404 */,
/* 3405 */,
/* 3406 */,
/* 3407 */,
/* 3408 */,
/* 3409 */,
/* 3410 */,
/* 3411 */,
/* 3412 */,
/* 3413 */,
/* 3414 */,
/* 3415 */,
/* 3416 */,
/* 3417 */,
/* 3418 */,
/* 3419 */,
/* 3420 */,
/* 3421 */,
/* 3422 */,
/* 3423 */,
/* 3424 */,
/* 3425 */,
/* 3426 */,
/* 3427 */,
/* 3428 */,
/* 3429 */,
/* 3430 */,
/* 3431 */,
/* 3432 */,
/* 3433 */,
/* 3434 */,
/* 3435 */,
/* 3436 */,
/* 3437 */,
/* 3438 */,
/* 3439 */,
/* 3440 */,
/* 3441 */,
/* 3442 */,
/* 3443 */,
/* 3444 */,
/* 3445 */,
/* 3446 */,
/* 3447 */,
/* 3448 */,
/* 3449 */,
/* 3450 */,
/* 3451 */,
/* 3452 */,
/* 3453 */,
/* 3454 */,
/* 3455 */,
/* 3456 */,
/* 3457 */,
/* 3458 */,
/* 3459 */,
/* 3460 */,
/* 3461 */,
/* 3462 */,
/* 3463 */,
/* 3464 */,
/* 3465 */,
/* 3466 */,
/* 3467 */,
/* 3468 */,
/* 3469 */,
/* 3470 */,
/* 3471 */,
/* 3472 */,
/* 3473 */,
/* 3474 */,
/* 3475 */,
/* 3476 */,
/* 3477 */,
/* 3478 */,
/* 3479 */,
/* 3480 */,
/* 3481 */,
/* 3482 */,
/* 3483 */,
/* 3484 */,
/* 3485 */,
/* 3486 */,
/* 3487 */,
/* 3488 */,
/* 3489 */,
/* 3490 */,
/* 3491 */,
/* 3492 */,
/* 3493 */,
/* 3494 */,
/* 3495 */,
/* 3496 */,
/* 3497 */,
/* 3498 */,
/* 3499 */,
/* 3500 */,
/* 3501 */,
/* 3502 */,
/* 3503 */,
/* 3504 */,
/* 3505 */,
/* 3506 */,
/* 3507 */,
/* 3508 */,
/* 3509 */,
/* 3510 */,
/* 3511 */,
/* 3512 */,
/* 3513 */,
/* 3514 */,
/* 3515 */,
/* 3516 */,
/* 3517 */,
/* 3518 */,
/* 3519 */,
/* 3520 */,
/* 3521 */,
/* 3522 */,
/* 3523 */,
/* 3524 */,
/* 3525 */,
/* 3526 */,
/* 3527 */,
/* 3528 */,
/* 3529 */,
/* 3530 */,
/* 3531 */,
/* 3532 */,
/* 3533 */,
/* 3534 */,
/* 3535 */,
/* 3536 */,
/* 3537 */,
/* 3538 */,
/* 3539 */,
/* 3540 */,
/* 3541 */,
/* 3542 */,
/* 3543 */,
/* 3544 */,
/* 3545 */,
/* 3546 */,
/* 3547 */,
/* 3548 */,
/* 3549 */,
/* 3550 */,
/* 3551 */,
/* 3552 */,
/* 3553 */,
/* 3554 */,
/* 3555 */,
/* 3556 */,
/* 3557 */,
/* 3558 */,
/* 3559 */,
/* 3560 */,
/* 3561 */,
/* 3562 */,
/* 3563 */,
/* 3564 */,
/* 3565 */,
/* 3566 */,
/* 3567 */,
/* 3568 */,
/* 3569 */,
/* 3570 */,
/* 3571 */,
/* 3572 */,
/* 3573 */,
/* 3574 */,
/* 3575 */,
/* 3576 */,
/* 3577 */,
/* 3578 */,
/* 3579 */,
/* 3580 */,
/* 3581 */,
/* 3582 */,
/* 3583 */,
/* 3584 */,
/* 3585 */,
/* 3586 */,
/* 3587 */,
/* 3588 */,
/* 3589 */,
/* 3590 */,
/* 3591 */,
/* 3592 */,
/* 3593 */,
/* 3594 */,
/* 3595 */,
/* 3596 */,
/* 3597 */,
/* 3598 */,
/* 3599 */,
/* 3600 */,
/* 3601 */,
/* 3602 */,
/* 3603 */,
/* 3604 */,
/* 3605 */,
/* 3606 */,
/* 3607 */,
/* 3608 */,
/* 3609 */,
/* 3610 */,
/* 3611 */,
/* 3612 */,
/* 3613 */,
/* 3614 */,
/* 3615 */,
/* 3616 */,
/* 3617 */,
/* 3618 */,
/* 3619 */,
/* 3620 */,
/* 3621 */,
/* 3622 */,
/* 3623 */,
/* 3624 */,
/* 3625 */,
/* 3626 */,
/* 3627 */,
/* 3628 */,
/* 3629 */,
/* 3630 */,
/* 3631 */,
/* 3632 */,
/* 3633 */,
/* 3634 */,
/* 3635 */,
/* 3636 */,
/* 3637 */,
/* 3638 */,
/* 3639 */,
/* 3640 */,
/* 3641 */,
/* 3642 */,
/* 3643 */,
/* 3644 */,
/* 3645 */,
/* 3646 */,
/* 3647 */,
/* 3648 */,
/* 3649 */,
/* 3650 */,
/* 3651 */,
/* 3652 */,
/* 3653 */,
/* 3654 */,
/* 3655 */,
/* 3656 */,
/* 3657 */,
/* 3658 */,
/* 3659 */,
/* 3660 */,
/* 3661 */,
/* 3662 */,
/* 3663 */,
/* 3664 */,
/* 3665 */,
/* 3666 */,
/* 3667 */,
/* 3668 */,
/* 3669 */,
/* 3670 */,
/* 3671 */,
/* 3672 */,
/* 3673 */,
/* 3674 */,
/* 3675 */,
/* 3676 */,
/* 3677 */,
/* 3678 */,
/* 3679 */,
/* 3680 */,
/* 3681 */,
/* 3682 */,
/* 3683 */,
/* 3684 */,
/* 3685 */,
/* 3686 */,
/* 3687 */,
/* 3688 */,
/* 3689 */,
/* 3690 */,
/* 3691 */,
/* 3692 */,
/* 3693 */,
/* 3694 */,
/* 3695 */,
/* 3696 */,
/* 3697 */,
/* 3698 */,
/* 3699 */,
/* 3700 */,
/* 3701 */,
/* 3702 */,
/* 3703 */,
/* 3704 */,
/* 3705 */,
/* 3706 */,
/* 3707 */,
/* 3708 */,
/* 3709 */,
/* 3710 */,
/* 3711 */,
/* 3712 */,
/* 3713 */,
/* 3714 */,
/* 3715 */,
/* 3716 */,
/* 3717 */,
/* 3718 */,
/* 3719 */,
/* 3720 */,
/* 3721 */,
/* 3722 */,
/* 3723 */,
/* 3724 */,
/* 3725 */,
/* 3726 */,
/* 3727 */,
/* 3728 */,
/* 3729 */,
/* 3730 */,
/* 3731 */,
/* 3732 */,
/* 3733 */,
/* 3734 */,
/* 3735 */,
/* 3736 */,
/* 3737 */,
/* 3738 */,
/* 3739 */,
/* 3740 */,
/* 3741 */,
/* 3742 */,
/* 3743 */,
/* 3744 */,
/* 3745 */,
/* 3746 */,
/* 3747 */,
/* 3748 */,
/* 3749 */,
/* 3750 */,
/* 3751 */,
/* 3752 */,
/* 3753 */,
/* 3754 */,
/* 3755 */,
/* 3756 */,
/* 3757 */,
/* 3758 */,
/* 3759 */,
/* 3760 */,
/* 3761 */,
/* 3762 */,
/* 3763 */,
/* 3764 */,
/* 3765 */,
/* 3766 */,
/* 3767 */,
/* 3768 */,
/* 3769 */,
/* 3770 */,
/* 3771 */,
/* 3772 */,
/* 3773 */,
/* 3774 */,
/* 3775 */,
/* 3776 */,
/* 3777 */,
/* 3778 */,
/* 3779 */,
/* 3780 */,
/* 3781 */,
/* 3782 */,
/* 3783 */,
/* 3784 */,
/* 3785 */,
/* 3786 */,
/* 3787 */,
/* 3788 */,
/* 3789 */,
/* 3790 */,
/* 3791 */,
/* 3792 */,
/* 3793 */,
/* 3794 */,
/* 3795 */,
/* 3796 */,
/* 3797 */,
/* 3798 */,
/* 3799 */,
/* 3800 */,
/* 3801 */,
/* 3802 */,
/* 3803 */,
/* 3804 */,
/* 3805 */,
/* 3806 */,
/* 3807 */,
/* 3808 */,
/* 3809 */,
/* 3810 */,
/* 3811 */,
/* 3812 */,
/* 3813 */,
/* 3814 */,
/* 3815 */,
/* 3816 */,
/* 3817 */,
/* 3818 */,
/* 3819 */,
/* 3820 */,
/* 3821 */,
/* 3822 */,
/* 3823 */,
/* 3824 */,
/* 3825 */,
/* 3826 */,
/* 3827 */,
/* 3828 */,
/* 3829 */,
/* 3830 */,
/* 3831 */,
/* 3832 */,
/* 3833 */,
/* 3834 */,
/* 3835 */,
/* 3836 */,
/* 3837 */,
/* 3838 */,
/* 3839 */,
/* 3840 */,
/* 3841 */,
/* 3842 */,
/* 3843 */,
/* 3844 */,
/* 3845 */,
/* 3846 */,
/* 3847 */,
/* 3848 */,
/* 3849 */,
/* 3850 */,
/* 3851 */,
/* 3852 */,
/* 3853 */,
/* 3854 */,
/* 3855 */,
/* 3856 */,
/* 3857 */,
/* 3858 */,
/* 3859 */,
/* 3860 */,
/* 3861 */,
/* 3862 */,
/* 3863 */,
/* 3864 */,
/* 3865 */,
/* 3866 */,
/* 3867 */,
/* 3868 */,
/* 3869 */,
/* 3870 */,
/* 3871 */,
/* 3872 */,
/* 3873 */,
/* 3874 */,
/* 3875 */,
/* 3876 */,
/* 3877 */,
/* 3878 */,
/* 3879 */,
/* 3880 */,
/* 3881 */,
/* 3882 */,
/* 3883 */,
/* 3884 */,
/* 3885 */,
/* 3886 */,
/* 3887 */,
/* 3888 */,
/* 3889 */,
/* 3890 */,
/* 3891 */,
/* 3892 */,
/* 3893 */,
/* 3894 */,
/* 3895 */,
/* 3896 */,
/* 3897 */,
/* 3898 */,
/* 3899 */,
/* 3900 */,
/* 3901 */,
/* 3902 */,
/* 3903 */,
/* 3904 */,
/* 3905 */,
/* 3906 */,
/* 3907 */,
/* 3908 */,
/* 3909 */,
/* 3910 */,
/* 3911 */,
/* 3912 */,
/* 3913 */,
/* 3914 */,
/* 3915 */,
/* 3916 */,
/* 3917 */,
/* 3918 */,
/* 3919 */,
/* 3920 */,
/* 3921 */,
/* 3922 */,
/* 3923 */,
/* 3924 */,
/* 3925 */,
/* 3926 */,
/* 3927 */,
/* 3928 */,
/* 3929 */,
/* 3930 */,
/* 3931 */,
/* 3932 */,
/* 3933 */,
/* 3934 */,
/* 3935 */,
/* 3936 */,
/* 3937 */,
/* 3938 */,
/* 3939 */,
/* 3940 */,
/* 3941 */,
/* 3942 */,
/* 3943 */,
/* 3944 */,
/* 3945 */,
/* 3946 */,
/* 3947 */,
/* 3948 */,
/* 3949 */,
/* 3950 */,
/* 3951 */,
/* 3952 */,
/* 3953 */,
/* 3954 */,
/* 3955 */,
/* 3956 */,
/* 3957 */,
/* 3958 */,
/* 3959 */,
/* 3960 */,
/* 3961 */,
/* 3962 */,
/* 3963 */,
/* 3964 */,
/* 3965 */,
/* 3966 */,
/* 3967 */,
/* 3968 */,
/* 3969 */,
/* 3970 */,
/* 3971 */,
/* 3972 */,
/* 3973 */,
/* 3974 */,
/* 3975 */,
/* 3976 */,
/* 3977 */,
/* 3978 */,
/* 3979 */,
/* 3980 */,
/* 3981 */,
/* 3982 */,
/* 3983 */,
/* 3984 */,
/* 3985 */,
/* 3986 */,
/* 3987 */,
/* 3988 */,
/* 3989 */,
/* 3990 */,
/* 3991 */,
/* 3992 */,
/* 3993 */,
/* 3994 */,
/* 3995 */,
/* 3996 */,
/* 3997 */,
/* 3998 */,
/* 3999 */,
/* 4000 */,
/* 4001 */,
/* 4002 */,
/* 4003 */,
/* 4004 */,
/* 4005 */,
/* 4006 */,
/* 4007 */,
/* 4008 */,
/* 4009 */,
/* 4010 */,
/* 4011 */,
/* 4012 */,
/* 4013 */,
/* 4014 */,
/* 4015 */,
/* 4016 */,
/* 4017 */,
/* 4018 */,
/* 4019 */,
/* 4020 */,
/* 4021 */,
/* 4022 */,
/* 4023 */,
/* 4024 */,
/* 4025 */,
/* 4026 */,
/* 4027 */,
/* 4028 */,
/* 4029 */,
/* 4030 */,
/* 4031 */,
/* 4032 */,
/* 4033 */,
/* 4034 */,
/* 4035 */,
/* 4036 */,
/* 4037 */,
/* 4038 */,
/* 4039 */,
/* 4040 */,
/* 4041 */,
/* 4042 */,
/* 4043 */,
/* 4044 */,
/* 4045 */,
/* 4046 */,
/* 4047 */,
/* 4048 */,
/* 4049 */,
/* 4050 */,
/* 4051 */,
/* 4052 */,
/* 4053 */,
/* 4054 */,
/* 4055 */,
/* 4056 */,
/* 4057 */,
/* 4058 */,
/* 4059 */,
/* 4060 */,
/* 4061 */,
/* 4062 */,
/* 4063 */,
/* 4064 */,
/* 4065 */,
/* 4066 */,
/* 4067 */,
/* 4068 */,
/* 4069 */,
/* 4070 */,
/* 4071 */,
/* 4072 */,
/* 4073 */,
/* 4074 */,
/* 4075 */,
/* 4076 */,
/* 4077 */,
/* 4078 */,
/* 4079 */,
/* 4080 */,
/* 4081 */,
/* 4082 */,
/* 4083 */,
/* 4084 */,
/* 4085 */,
/* 4086 */,
/* 4087 */,
/* 4088 */,
/* 4089 */,
/* 4090 */,
/* 4091 */,
/* 4092 */,
/* 4093 */,
/* 4094 */,
/* 4095 */,
/* 4096 */,
/* 4097 */,
/* 4098 */,
/* 4099 */,
/* 4100 */,
/* 4101 */,
/* 4102 */,
/* 4103 */,
/* 4104 */,
/* 4105 */,
/* 4106 */,
/* 4107 */,
/* 4108 */,
/* 4109 */,
/* 4110 */,
/* 4111 */,
/* 4112 */,
/* 4113 */,
/* 4114 */,
/* 4115 */,
/* 4116 */,
/* 4117 */,
/* 4118 */,
/* 4119 */,
/* 4120 */,
/* 4121 */,
/* 4122 */,
/* 4123 */,
/* 4124 */,
/* 4125 */,
/* 4126 */,
/* 4127 */,
/* 4128 */,
/* 4129 */,
/* 4130 */,
/* 4131 */,
/* 4132 */,
/* 4133 */,
/* 4134 */,
/* 4135 */,
/* 4136 */,
/* 4137 */,
/* 4138 */,
/* 4139 */,
/* 4140 */,
/* 4141 */,
/* 4142 */,
/* 4143 */,
/* 4144 */,
/* 4145 */,
/* 4146 */,
/* 4147 */,
/* 4148 */,
/* 4149 */,
/* 4150 */,
/* 4151 */,
/* 4152 */,
/* 4153 */,
/* 4154 */,
/* 4155 */,
/* 4156 */,
/* 4157 */,
/* 4158 */,
/* 4159 */,
/* 4160 */,
/* 4161 */,
/* 4162 */,
/* 4163 */,
/* 4164 */,
/* 4165 */,
/* 4166 */,
/* 4167 */,
/* 4168 */,
/* 4169 */,
/* 4170 */,
/* 4171 */,
/* 4172 */,
/* 4173 */,
/* 4174 */,
/* 4175 */,
/* 4176 */,
/* 4177 */,
/* 4178 */,
/* 4179 */,
/* 4180 */,
/* 4181 */,
/* 4182 */,
/* 4183 */,
/* 4184 */,
/* 4185 */,
/* 4186 */,
/* 4187 */,
/* 4188 */,
/* 4189 */,
/* 4190 */,
/* 4191 */,
/* 4192 */,
/* 4193 */,
/* 4194 */,
/* 4195 */,
/* 4196 */,
/* 4197 */,
/* 4198 */,
/* 4199 */,
/* 4200 */,
/* 4201 */,
/* 4202 */,
/* 4203 */,
/* 4204 */,
/* 4205 */,
/* 4206 */,
/* 4207 */,
/* 4208 */,
/* 4209 */,
/* 4210 */,
/* 4211 */,
/* 4212 */,
/* 4213 */,
/* 4214 */,
/* 4215 */,
/* 4216 */,
/* 4217 */,
/* 4218 */,
/* 4219 */,
/* 4220 */,
/* 4221 */,
/* 4222 */,
/* 4223 */,
/* 4224 */,
/* 4225 */,
/* 4226 */,
/* 4227 */,
/* 4228 */,
/* 4229 */,
/* 4230 */,
/* 4231 */,
/* 4232 */,
/* 4233 */,
/* 4234 */,
/* 4235 */,
/* 4236 */,
/* 4237 */,
/* 4238 */,
/* 4239 */,
/* 4240 */,
/* 4241 */,
/* 4242 */,
/* 4243 */,
/* 4244 */,
/* 4245 */,
/* 4246 */,
/* 4247 */,
/* 4248 */,
/* 4249 */,
/* 4250 */,
/* 4251 */,
/* 4252 */,
/* 4253 */,
/* 4254 */,
/* 4255 */,
/* 4256 */,
/* 4257 */,
/* 4258 */,
/* 4259 */,
/* 4260 */,
/* 4261 */,
/* 4262 */,
/* 4263 */,
/* 4264 */,
/* 4265 */,
/* 4266 */,
/* 4267 */,
/* 4268 */,
/* 4269 */,
/* 4270 */,
/* 4271 */,
/* 4272 */,
/* 4273 */,
/* 4274 */,
/* 4275 */,
/* 4276 */,
/* 4277 */,
/* 4278 */,
/* 4279 */,
/* 4280 */,
/* 4281 */,
/* 4282 */,
/* 4283 */,
/* 4284 */,
/* 4285 */,
/* 4286 */,
/* 4287 */,
/* 4288 */,
/* 4289 */,
/* 4290 */,
/* 4291 */,
/* 4292 */,
/* 4293 */,
/* 4294 */,
/* 4295 */,
/* 4296 */,
/* 4297 */,
/* 4298 */,
/* 4299 */,
/* 4300 */,
/* 4301 */,
/* 4302 */,
/* 4303 */,
/* 4304 */,
/* 4305 */,
/* 4306 */,
/* 4307 */,
/* 4308 */,
/* 4309 */,
/* 4310 */,
/* 4311 */,
/* 4312 */,
/* 4313 */,
/* 4314 */,
/* 4315 */,
/* 4316 */,
/* 4317 */,
/* 4318 */,
/* 4319 */,
/* 4320 */,
/* 4321 */,
/* 4322 */,
/* 4323 */,
/* 4324 */,
/* 4325 */,
/* 4326 */,
/* 4327 */,
/* 4328 */,
/* 4329 */,
/* 4330 */,
/* 4331 */,
/* 4332 */,
/* 4333 */,
/* 4334 */,
/* 4335 */,
/* 4336 */,
/* 4337 */,
/* 4338 */,
/* 4339 */,
/* 4340 */,
/* 4341 */,
/* 4342 */,
/* 4343 */,
/* 4344 */,
/* 4345 */,
/* 4346 */,
/* 4347 */,
/* 4348 */,
/* 4349 */,
/* 4350 */,
/* 4351 */,
/* 4352 */,
/* 4353 */,
/* 4354 */,
/* 4355 */,
/* 4356 */,
/* 4357 */,
/* 4358 */,
/* 4359 */,
/* 4360 */,
/* 4361 */,
/* 4362 */,
/* 4363 */,
/* 4364 */,
/* 4365 */,
/* 4366 */,
/* 4367 */,
/* 4368 */,
/* 4369 */,
/* 4370 */,
/* 4371 */,
/* 4372 */,
/* 4373 */,
/* 4374 */,
/* 4375 */,
/* 4376 */,
/* 4377 */,
/* 4378 */,
/* 4379 */,
/* 4380 */,
/* 4381 */,
/* 4382 */,
/* 4383 */,
/* 4384 */,
/* 4385 */,
/* 4386 */,
/* 4387 */,
/* 4388 */,
/* 4389 */,
/* 4390 */,
/* 4391 */,
/* 4392 */,
/* 4393 */,
/* 4394 */,
/* 4395 */,
/* 4396 */,
/* 4397 */,
/* 4398 */,
/* 4399 */,
/* 4400 */,
/* 4401 */,
/* 4402 */,
/* 4403 */,
/* 4404 */,
/* 4405 */,
/* 4406 */,
/* 4407 */,
/* 4408 */,
/* 4409 */,
/* 4410 */,
/* 4411 */,
/* 4412 */,
/* 4413 */,
/* 4414 */,
/* 4415 */,
/* 4416 */,
/* 4417 */,
/* 4418 */,
/* 4419 */,
/* 4420 */,
/* 4421 */,
/* 4422 */,
/* 4423 */,
/* 4424 */,
/* 4425 */,
/* 4426 */,
/* 4427 */,
/* 4428 */,
/* 4429 */,
/* 4430 */,
/* 4431 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__, __webpack_module_template_argument_22__, __webpack_module_template_argument_23__, __webpack_module_template_argument_24__, __webpack_module_template_argument_25__, __webpack_module_template_argument_26__, __webpack_module_template_argument_27__, __webpack_module_template_argument_28__, __webpack_module_template_argument_29__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(__webpack_module_template_argument_0__)
	  , has            = __webpack_require__(__webpack_module_template_argument_1__)
	  , DESCRIPTORS    = __webpack_require__(__webpack_module_template_argument_2__)
	  , $export        = __webpack_require__(__webpack_module_template_argument_3__)
	  , redefine       = __webpack_require__(__webpack_module_template_argument_4__)
	  , META           = __webpack_require__(__webpack_module_template_argument_5__).KEY
	  , $fails         = __webpack_require__(__webpack_module_template_argument_6__)
	  , shared         = __webpack_require__(__webpack_module_template_argument_7__)
	  , setToStringTag = __webpack_require__(__webpack_module_template_argument_8__)
	  , uid            = __webpack_require__(__webpack_module_template_argument_9__)
	  , wks            = __webpack_require__(__webpack_module_template_argument_10__)
	  , wksExt         = __webpack_require__(__webpack_module_template_argument_11__)
	  , wksDefine      = __webpack_require__(__webpack_module_template_argument_12__)
	  , keyOf          = __webpack_require__(__webpack_module_template_argument_13__)
	  , enumKeys       = __webpack_require__(__webpack_module_template_argument_14__)
	  , isArray        = __webpack_require__(__webpack_module_template_argument_15__)
	  , anObject       = __webpack_require__(__webpack_module_template_argument_16__)
	  , toIObject      = __webpack_require__(__webpack_module_template_argument_17__)
	  , toPrimitive    = __webpack_require__(__webpack_module_template_argument_18__)
	  , createDesc     = __webpack_require__(__webpack_module_template_argument_19__)
	  , _create        = __webpack_require__(__webpack_module_template_argument_20__)
	  , gOPNExt        = __webpack_require__(__webpack_module_template_argument_21__)
	  , $GOPD          = __webpack_require__(__webpack_module_template_argument_22__)
	  , $DP            = __webpack_require__(__webpack_module_template_argument_23__)
	  , $keys          = __webpack_require__(__webpack_module_template_argument_24__)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(__webpack_module_template_argument_25__).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(__webpack_module_template_argument_26__).f  = $propertyIsEnumerable;
	  __webpack_require__(__webpack_module_template_argument_27__).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(__webpack_module_template_argument_28__)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(__webpack_module_template_argument_29__)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 4432 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 4433 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP         = __webpack_require__(__webpack_module_template_argument_0__)
	  , createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 4434 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject       = __webpack_require__(__webpack_module_template_argument_0__)
	  , IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__)
	  , toPrimitive    = __webpack_require__(__webpack_module_template_argument_2__)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 4435 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 4436 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function(){
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 4437 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__)
	  , document = __webpack_require__(__webpack_module_template_argument_1__).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 4438 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 4439 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 4440 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var META     = __webpack_require__(__webpack_module_template_argument_0__)('meta')
	  , isObject = __webpack_require__(__webpack_module_template_argument_1__)
	  , has      = __webpack_require__(__webpack_module_template_argument_2__)
	  , setDesc  = __webpack_require__(__webpack_module_template_argument_3__).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(__webpack_module_template_argument_4__)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 4441 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 4442 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).f
	  , has = __webpack_require__(__webpack_module_template_argument_1__)
	  , TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 4443 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store      = __webpack_require__(__webpack_module_template_argument_0__)('wks')
	  , uid        = __webpack_require__(__webpack_module_template_argument_1__)
	  , Symbol     = __webpack_require__(__webpack_module_template_argument_2__).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 4444 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	exports.f = __webpack_require__(__webpack_module_template_argument_0__);

/***/ },
/* 4445 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var global         = __webpack_require__(__webpack_module_template_argument_0__)
	  , core           = __webpack_require__(__webpack_module_template_argument_1__)
	  , LIBRARY        = __webpack_require__(__webpack_module_template_argument_2__)
	  , wksExt         = __webpack_require__(__webpack_module_template_argument_3__)
	  , defineProperty = __webpack_require__(__webpack_module_template_argument_4__).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 4446 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getKeys   = __webpack_require__(__webpack_module_template_argument_0__)
	  , toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 4447 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(__webpack_module_template_argument_0__)
	  , enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 4448 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has          = __webpack_require__(__webpack_module_template_argument_0__)
	  , toIObject    = __webpack_require__(__webpack_module_template_argument_1__)
	  , arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false)
	  , IE_PROTO     = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 4449 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__)
	  , defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 4450 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 4451 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__)
	  , toLength  = __webpack_require__(__webpack_module_template_argument_1__)
	  , toIndex   = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 4452 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 4453 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 4454 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys')
	  , uid    = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 4455 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__)
	  , gOPS    = __webpack_require__(__webpack_module_template_argument_1__)
	  , pIE     = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 4456 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 4457 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(__webpack_module_template_argument_0__)
	  , dPs         = __webpack_require__(__webpack_module_template_argument_1__)
	  , enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__)
	  , IE_PROTO    = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 4458 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP       = __webpack_require__(__webpack_module_template_argument_0__)
	  , anObject = __webpack_require__(__webpack_module_template_argument_1__)
	  , getKeys  = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 4459 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = __webpack_require__(__webpack_module_template_argument_0__).document && document.documentElement;

/***/ },
/* 4460 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__)
	  , gOPN      = __webpack_require__(__webpack_module_template_argument_1__).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 4461 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(__webpack_module_template_argument_0__)
	  , hiddenKeys = __webpack_require__(__webpack_module_template_argument_1__).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 4462 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE            = __webpack_require__(__webpack_module_template_argument_0__)
	  , createDesc     = __webpack_require__(__webpack_module_template_argument_1__)
	  , toIObject      = __webpack_require__(__webpack_module_template_argument_2__)
	  , toPrimitive    = __webpack_require__(__webpack_module_template_argument_3__)
	  , has            = __webpack_require__(__webpack_module_template_argument_4__)
	  , IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 4463 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(__webpack_module_template_argument_1__)});

/***/ },
/* 4464 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_1__), 'Object', {defineProperty: __webpack_require__(__webpack_module_template_argument_2__).f});

/***/ },
/* 4465 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 4466 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(__webpack_module_template_argument_0__)
	  , toObject    = __webpack_require__(__webpack_module_template_argument_1__)
	  , IE_PROTO    = __webpack_require__(__webpack_module_template_argument_2__)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 4467 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(__webpack_module_template_argument_1__)});

/***/ },
/* 4468 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(__webpack_module_template_argument_0__)
	  , gOPS     = __webpack_require__(__webpack_module_template_argument_1__)
	  , pIE      = __webpack_require__(__webpack_module_template_argument_2__)
	  , toObject = __webpack_require__(__webpack_module_template_argument_3__)
	  , IObject  = __webpack_require__(__webpack_module_template_argument_4__)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(__webpack_module_template_argument_5__)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 4469 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__)
	  , TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 4470 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $at  = __webpack_require__(__webpack_module_template_argument_0__)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_1__)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 4471 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__)
	  , defined   = __webpack_require__(__webpack_module_template_argument_1__);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 4472 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	'use strict';
	var LIBRARY        = __webpack_require__(__webpack_module_template_argument_0__)
	  , $export        = __webpack_require__(__webpack_module_template_argument_1__)
	  , redefine       = __webpack_require__(__webpack_module_template_argument_2__)
	  , hide           = __webpack_require__(__webpack_module_template_argument_3__)
	  , has            = __webpack_require__(__webpack_module_template_argument_4__)
	  , Iterators      = __webpack_require__(__webpack_module_template_argument_5__)
	  , $iterCreate    = __webpack_require__(__webpack_module_template_argument_6__)
	  , setToStringTag = __webpack_require__(__webpack_module_template_argument_7__)
	  , getPrototypeOf = __webpack_require__(__webpack_module_template_argument_8__)
	  , ITERATOR       = __webpack_require__(__webpack_module_template_argument_9__)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 4473 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var create         = __webpack_require__(__webpack_module_template_argument_0__)
	  , descriptor     = __webpack_require__(__webpack_module_template_argument_1__)
	  , setToStringTag = __webpack_require__(__webpack_module_template_argument_2__)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 4474 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var ctx            = __webpack_require__(__webpack_module_template_argument_0__)
	  , $export        = __webpack_require__(__webpack_module_template_argument_1__)
	  , toObject       = __webpack_require__(__webpack_module_template_argument_2__)
	  , call           = __webpack_require__(__webpack_module_template_argument_3__)
	  , isArrayIter    = __webpack_require__(__webpack_module_template_argument_4__)
	  , toLength       = __webpack_require__(__webpack_module_template_argument_5__)
	  , createProperty = __webpack_require__(__webpack_module_template_argument_6__)
	  , getIterFn      = __webpack_require__(__webpack_module_template_argument_7__);
	
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_8__)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 4475 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 4476 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(__webpack_module_template_argument_0__)
	  , ITERATOR   = __webpack_require__(__webpack_module_template_argument_1__)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 4477 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__)
	  , createDesc      = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },
/* 4478 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof   = __webpack_require__(__webpack_module_template_argument_0__)
	  , ITERATOR  = __webpack_require__(__webpack_module_template_argument_1__)('iterator')
	  , Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 4479 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR     = __webpack_require__(__webpack_module_template_argument_0__)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 4480 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(__webpack_module_template_argument_0__)
	  , IObject  = __webpack_require__(__webpack_module_template_argument_1__)
	  , toObject = __webpack_require__(__webpack_module_template_argument_2__)
	  , toLength = __webpack_require__(__webpack_module_template_argument_3__)
	  , asc      = __webpack_require__(__webpack_module_template_argument_4__);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 4481 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ },
/* 4482 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__)
	  , isArray  = __webpack_require__(__webpack_module_template_argument_1__)
	  , SPECIES  = __webpack_require__(__webpack_module_template_argument_2__)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ },
/* 4483 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__)
	  , step             = __webpack_require__(__webpack_module_template_argument_1__)
	  , Iterators        = __webpack_require__(__webpack_module_template_argument_2__)
	  , toIObject        = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 4484 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ctx         = __webpack_require__(__webpack_module_template_argument_0__)
	  , call        = __webpack_require__(__webpack_module_template_argument_1__)
	  , isArrayIter = __webpack_require__(__webpack_module_template_argument_2__)
	  , anObject    = __webpack_require__(__webpack_module_template_argument_3__)
	  , toLength    = __webpack_require__(__webpack_module_template_argument_4__)
	  , getIterFn   = __webpack_require__(__webpack_module_template_argument_5__)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ },
/* 4485 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var strong = __webpack_require__(__webpack_module_template_argument_0__);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(__webpack_module_template_argument_1__)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 4486 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__) {

	'use strict';
	var dP          = __webpack_require__(__webpack_module_template_argument_0__).f
	  , create      = __webpack_require__(__webpack_module_template_argument_1__)
	  , redefineAll = __webpack_require__(__webpack_module_template_argument_2__)
	  , ctx         = __webpack_require__(__webpack_module_template_argument_3__)
	  , anInstance  = __webpack_require__(__webpack_module_template_argument_4__)
	  , defined     = __webpack_require__(__webpack_module_template_argument_5__)
	  , forOf       = __webpack_require__(__webpack_module_template_argument_6__)
	  , $iterDefine = __webpack_require__(__webpack_module_template_argument_7__)
	  , step        = __webpack_require__(__webpack_module_template_argument_8__)
	  , setSpecies  = __webpack_require__(__webpack_module_template_argument_9__)
	  , DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_10__)
	  , fastKey     = __webpack_require__(__webpack_module_template_argument_11__).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 4487 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var strong = __webpack_require__(__webpack_module_template_argument_0__);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(__webpack_module_template_argument_1__)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 4488 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('asyncIterator');

/***/ },
/* 4489 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('observable');

/***/ },
/* 4490 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(__webpack_module_template_argument_1__)('Map')});

/***/ },
/* 4491 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(__webpack_module_template_argument_0__)
	  , from    = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ },
/* 4492 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var forOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 4493 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(__webpack_module_template_argument_1__)('Set')});

/***/ },
/* 4494 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 4495 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 4496 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(__webpack_module_template_argument_0__), src$en$$ = __webpack_require__(__webpack_module_template_argument_1__);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// common.a06745785d45342c7a63.js